export const judete = {
    "BUCUREȘTI": [
        {
          "name": "BUCURESTI",
          "zip": "010011",
          "lat": "44.436141",
          "long": "26.10272"
        }
      ],
    "ALBA": [
      {
        "name": "ABRUD",
        "zip": "515100",
        "lat": "46.274675",
        "long": "23.065029"
      },
      {
        "name": "ABRUD-SAT",
        "zip": "515101",
        "lat": "46.283967",
        "long": "23.061093"
      },
      {
        "name": "ACHIMETESTI",
        "zip": "517066",
        "lat": "46.384842",
        "long": "22.803892"
      },
      {
        "name": "ACMARIU",
        "zip": "517161",
        "lat": "45.965968",
        "long": "23.362486"
      },
      {
        "name": "AIUD",
        "zip": "515200",
        "lat": "46.310841",
        "long": "23.71885"
      },
      {
        "name": "AIUDUL DE SUS",
        "zip": "515201",
        "lat": "46.321908",
        "long": "23.684365"
      },
      {
        "name": "ALBA IULIA",
        "zip": "510002",
        "lat": "46.068738",
        "long": "23.57044"
      },
      {
        "name": "ALBAC",
        "zip": "517005",
        "lat": "46.447786",
        "long": "22.964985"
      },
      {
        "name": "ALECUS",
        "zip": "517756",
        "lat": "46.290043",
        "long": "23.993177"
      },
      {
        "name": "ALMASU DE MIJLOC",
        "zip": "517031",
        "lat": "46.066934",
        "long": "23.106543"
      },
      {
        "name": "ALMASU MARE",
        "zip": "517030",
        "lat": "46.109273",
        "long": "23.119791"
      },
      {
        "name": "AMPOITA",
        "zip": "517446",
        "lat": "46.117609",
        "long": "23.450111"
      },
      {
        "name": "ANGHELESTI",
        "zip": "517166",
        "lat": "46.245523",
        "long": "23.098053"
      },
      {
        "name": "ARIESENI",
        "zip": "517040",
        "lat": "46.476245",
        "long": "22.757905"
      },
      {
        "name": "ARONESTI",
        "zip": "517116",
        "lat": "46.436545",
        "long": "23.129156"
      },
      {
        "name": "ARTI",
        "zip": "517776",
        "lat": "45.73996",
        "long": "23.598402"
      },
      {
        "name": "ASINIP",
        "zip": "517396",
        "lat": "46.297706",
        "long": "23.888962"
      },
      {
        "name": "AVRAM IANCU",
        "zip": "517065",
        "lat": "46.358277",
        "long": "22.819303"
      },
      {
        "name": "AVRAMESTI",
        "zip": "517041",
        "lat": "46.480143",
        "long": "22.743452"
      },
      {
        "name": "AVRAMESTI",
        "zip": "517067",
        "lat": "46.391428",
        "long": "22.823833"
      },
      {
        "name": "BABA",
        "zip": "517341",
        "lat": "46.50205",
        "long": "22.963223"
      },
      {
        "name": "BACAINTI",
        "zip": "517752",
        "lat": "45.941804",
        "long": "23.28236"
      },
      {
        "name": "BADAI",
        "zip": "517068",
        "lat": "46.408486",
        "long": "22.75576"
      },
      {
        "name": "BAGAU",
        "zip": "517397",
        "lat": "46.310469",
        "long": "23.793987"
      },
      {
        "name": "BAI",
        "zip": "517826",
        "lat": "46.336359",
        "long": "22.915942"
      },
      {
        "name": "BAIA DE ARIES",
        "zip": "515300",
        "lat": "46.380251",
        "long": "23.281206"
      },
      {
        "name": "BALCACIU",
        "zip": "517386",
        "lat": "46.191217",
        "long": "24.061395"
      },
      {
        "name": "BALESTI",
        "zip": "517117",
        "lat": "46.427307",
        "long": "23.092773"
      },
      {
        "name": "BALESTI-CATUN",
        "zip": "517118",
        "lat": "46.434827",
        "long": "23.090169"
      },
      {
        "name": "BALMOSESTI",
        "zip": "517616",
        "lat": "46.309652",
        "long": "23.103783"
      },
      {
        "name": "BALOMIRU DE CAMP",
        "zip": "517751",
        "lat": "45.938784",
        "long": "23.361089"
      },
      {
        "name": "BARABANT",
        "zip": "510001",
        "lat": "46.099304",
        "long": "23.584868"
      },
      {
        "name": "BARASTI",
        "zip": "517006",
        "lat": "46.459994",
        "long": "22.988352"
      },
      {
        "name": "BARBESTI",
        "zip": "517481",
        "lat": "46.275988",
        "long": "23.332085"
      },
      {
        "name": "BARDESTI",
        "zip": "517411",
        "lat": "46.31471",
        "long": "23.192055"
      },
      {
        "name": "BARLESTI",
        "zip": "517119",
        "lat": "46.357493",
        "long": "23.131266"
      },
      {
        "name": "BARLESTI",
        "zip": "517482",
        "lat": "46.26199",
        "long": "23.288484"
      },
      {
        "name": "BARLESTI",
        "zip": "517681",
        "lat": "46.42616",
        "long": "22.888324"
      },
      {
        "name": "BARLESTI-CATUN",
        "zip": "517483",
        "lat": "46.287647",
        "long": "23.381416"
      },
      {
        "name": "BARSANA",
        "zip": "517777",
        "lat": "45.761329",
        "long": "23.570888"
      },
      {
        "name": "BARZAN",
        "zip": "517412",
        "lat": "46.359582",
        "long": "23.233554"
      },
      {
        "name": "BARZOGANI",
        "zip": "517484",
        "lat": "46.302762",
        "long": "23.337995"
      },
      {
        "name": "BAZESTI",
        "zip": "517701",
        "lat": "46.318367",
        "long": "23.012838"
      },
      {
        "name": "BELDIU",
        "zip": "515901",
        "lat": "46.236295",
        "long": "23.715374"
      },
      {
        "name": "BENIC",
        "zip": "517286",
        "lat": "46.213119",
        "long": "23.591427"
      },
      {
        "name": "BERGHIN",
        "zip": "517110",
        "lat": "46.0763",
        "long": "23.739362"
      },
      {
        "name": "BETA",
        "zip": "517398",
        "lat": "46.256731",
        "long": "23.815076"
      },
      {
        "name": "BIDIGESTI",
        "zip": "517251",
        "lat": "46.259982",
        "long": "23.014035"
      },
      {
        "name": "BIHARIA",
        "zip": "517311",
        "lat": "46.428259",
        "long": "22.767724"
      },
      {
        "name": "BIIA",
        "zip": "517757",
        "lat": "46.230818",
        "long": "24.004895"
      },
      {
        "name": "BILANESTI",
        "zip": "517702",
        "lat": "46.336649",
        "long": "23.000571"
      },
      {
        "name": "BISERICANI",
        "zip": "517167",
        "lat": "46.291021",
        "long": "23.159966"
      },
      {
        "name": "BISTRA",
        "zip": "517115",
        "lat": "46.376923",
        "long": "23.103729"
      },
      {
        "name": "BLAJ",
        "zip": "515400",
        "lat": "46.175036",
        "long": "23.922407"
      },
      {
        "name": "BLANDIANA",
        "zip": "517160",
        "lat": "45.976944",
        "long": "23.38589"
      },
      {
        "name": "BLIDESTI",
        "zip": "517617",
        "lat": "46.30101",
        "long": "23.090683"
      },
      {
        "name": "BOBARESTI",
        "zip": "517703",
        "lat": "46.341629",
        "long": "22.986515"
      },
      {
        "name": "BOBARESTI",
        "zip": "517827",
        "lat": "46.370991",
        "long": "22.987474"
      },
      {
        "name": "BOCESTI",
        "zip": "517486",
        "lat": "46.283489",
        "long": "23.344057"
      },
      {
        "name": "BOCSITURA",
        "zip": "515601",
        "lat": "45.766003",
        "long": "23.43293"
      },
      {
        "name": "BODESTI",
        "zip": "517796",
        "lat": "46.411639",
        "long": "22.986761"
      },
      {
        "name": "BODRESTI",
        "zip": "517252",
        "lat": "46.272017",
        "long": "22.973574"
      },
      {
        "name": "BOGDANESTI",
        "zip": "517487",
        "lat": "46.291789",
        "long": "23.34812"
      },
      {
        "name": "BOGDANESTI",
        "zip": "517828",
        "lat": "46.363672",
        "long": "22.987372"
      },
      {
        "name": "BOGLESTI",
        "zip": "517253",
        "lat": "46.253711",
        "long": "22.998386"
      },
      {
        "name": "BOLDESTI",
        "zip": "517069",
        "lat": "46.34358",
        "long": "22.838883"
      },
      {
        "name": "BOLOVANESTI",
        "zip": "517221",
        "lat": "45.9997",
        "long": "23.255063"
      },
      {
        "name": "BONCESTI",
        "zip": "515501",
        "lat": "46.368381",
        "long": "23.081488"
      },
      {
        "name": "BORDESTII POIENI",
        "zip": "517829",
        "lat": "46.352508",
        "long": "22.926983"
      },
      {
        "name": "BORLESTI",
        "zip": "515502",
        "lat": "46.408423",
        "long": "23.00445"
      },
      {
        "name": "BOTANI",
        "zip": "517591",
        "lat": "46.286484",
        "long": "23.443693"
      },
      {
        "name": "BOTESTI",
        "zip": "515503",
        "lat": "46.388161",
        "long": "23.017838"
      },
      {
        "name": "BOTESTI",
        "zip": "516101",
        "lat": "46.180688",
        "long": "23.149355"
      },
      {
        "name": "BOTESTI",
        "zip": "517682",
        "lat": "46.427325",
        "long": "22.896689"
      },
      {
        "name": "BOZ",
        "zip": "517276",
        "lat": "45.948294",
        "long": "23.803947"
      },
      {
        "name": "BRADEANA",
        "zip": "517704",
        "lat": "46.332294",
        "long": "22.977928"
      },
      {
        "name": "BRADESTI",
        "zip": "517592",
        "lat": "46.332297",
        "long": "23.469132"
      },
      {
        "name": "BRADET",
        "zip": "517032",
        "lat": "46.106658",
        "long": "23.093978"
      },
      {
        "name": "BRAZESTI",
        "zip": "515301",
        "lat": "46.398486",
        "long": "23.318512"
      },
      {
        "name": "BUBESTI",
        "zip": "517042",
        "lat": "46.50556",
        "long": "22.70384"
      },
      {
        "name": "BUCERDEA GRANOASA",
        "zip": "517261",
        "lat": "46.192837",
        "long": "23.839552"
      },
      {
        "name": "BUCERDEA VINOASA",
        "zip": "517361",
        "lat": "46.163279",
        "long": "23.529041"
      },
      {
        "name": "BUCIUM",
        "zip": "517165",
        "lat": "46.26402",
        "long": "23.179099"
      },
      {
        "name": "BUCIUM-SAT",
        "zip": "517168",
        "lat": "46.260821",
        "long": "23.119797"
      },
      {
        "name": "BUCURU",
        "zip": "515602",
        "lat": "45.788722",
        "long": "23.394293"
      },
      {
        "name": "BUDAIESTI",
        "zip": "517007",
        "lat": "46.474338",
        "long": "22.969849"
      },
      {
        "name": "BUDENI",
        "zip": "516102",
        "lat": "46.18875",
        "long": "23.125641"
      },
      {
        "name": "BULBUC",
        "zip": "517222",
        "lat": "46.024148",
        "long": "23.290394"
      },
      {
        "name": "BUNINGINEA",
        "zip": "517254",
        "lat": "46.22657",
        "long": "23.03837"
      },
      {
        "name": "BUNTA",
        "zip": "517618",
        "lat": "46.276722",
        "long": "23.120822"
      },
      {
        "name": "BURZESTI",
        "zip": "517797",
        "lat": "46.401736",
        "long": "22.947893"
      },
      {
        "name": "BURZONESTI",
        "zip": "517706",
        "lat": "46.367743",
        "long": "23.008678"
      },
      {
        "name": "BUTESTI",
        "zip": "517342",
        "lat": "46.509491",
        "long": "22.943624"
      },
      {
        "name": "BUTESTI",
        "zip": "517488",
        "lat": "46.297018",
        "long": "23.345868"
      },
      {
        "name": "CALENE",
        "zip": "515603",
        "lat": "45.831944",
        "long": "23.40633"
      },
      {
        "name": "CALNIC",
        "zip": "517205",
        "lat": "45.887344",
        "long": "23.658829"
      },
      {
        "name": "CALUGARESTI",
        "zip": "517071",
        "lat": "46.405105",
        "long": "22.789637"
      },
      {
        "name": "CAMPENI",
        "zip": "515500",
        "lat": "46.364843",
        "long": "23.050877"
      },
      {
        "name": "CAMPU GOBLII",
        "zip": "517876",
        "lat": "45.998699",
        "long": "23.450019"
      },
      {
        "name": "CANDESTI",
        "zip": "517073",
        "lat": "46.41564",
        "long": "22.76727"
      },
      {
        "name": "CAPALNA",
        "zip": "517661",
        "lat": "45.847174",
        "long": "23.604117"
      },
      {
        "name": "CAPALNA DE JOS",
        "zip": "517387",
        "lat": "46.239997",
        "long": "24.113037"
      },
      {
        "name": "CAPTALAN",
        "zip": "517516",
        "lat": "46.409208",
        "long": "23.941717"
      },
      {
        "name": "CAPU DEALULUI",
        "zip": "517211",
        "lat": "46.086637",
        "long": "24.018657"
      },
      {
        "name": "CAPUD",
        "zip": "515902",
        "lat": "46.205648",
        "long": "23.725509"
      },
      {
        "name": "CARASTI",
        "zip": "517074",
        "lat": "46.371221",
        "long": "22.823447"
      },
      {
        "name": "CARPEN",
        "zip": "517766",
        "lat": "45.966309",
        "long": "23.708718"
      },
      {
        "name": "CARPENII DE SUS",
        "zip": "517767",
        "lat": "45.993373",
        "long": "23.710148"
      },
      {
        "name": "CARPINIS",
        "zip": "517306",
        "lat": "45.831964",
        "long": "23.659358"
      },
      {
        "name": "CARPINIS",
        "zip": "517619",
        "lat": "46.317011",
        "long": "23.056843"
      },
      {
        "name": "CARTULESTI",
        "zip": "517076",
        "lat": "46.385788",
        "long": "22.789989"
      },
      {
        "name": "CASA DE PIATRA",
        "zip": "517043",
        "lat": "46.535177",
        "long": "22.783138"
      },
      {
        "name": "CASOAIA",
        "zip": "517072",
        "lat": "46.388178",
        "long": "22.760121"
      },
      {
        "name": "CENADE",
        "zip": "517210",
        "lat": "46.05872",
        "long": "24.008917"
      },
      {
        "name": "CERBU",
        "zip": "517169",
        "lat": "46.245354",
        "long": "23.105902"
      },
      {
        "name": "CERGAU MARE",
        "zip": "517216",
        "lat": "46.098743",
        "long": "23.922817"
      },
      {
        "name": "CERGAU MIC",
        "zip": "517217",
        "lat": "46.083085",
        "long": "23.940682"
      },
      {
        "name": "CERTEGE",
        "zip": "515504",
        "lat": "46.414575",
        "long": "23.021686"
      },
      {
        "name": "CERU-BACAINTI",
        "zip": "517220",
        "lat": "45.973694",
        "long": "23.271899"
      },
      {
        "name": "CETATEA DE BALTA",
        "zip": "517235",
        "lat": "46.247938",
        "long": "24.172445"
      },
      {
        "name": "CETEA",
        "zip": "517287",
        "lat": "46.239763",
        "long": "23.584643"
      },
      {
        "name": "CHEIA",
        "zip": "517593",
        "lat": "46.299791",
        "long": "23.455343"
      },
      {
        "name": "CHEILE CIBULUI",
        "zip": "517033",
        "lat": "46.035645",
        "long": "23.181614"
      },
      {
        "name": "CHELETENI",
        "zip": "517121",
        "lat": "46.447209",
        "long": "23.094579"
      },
      {
        "name": "CIB",
        "zip": "517034",
        "lat": "46.060456",
        "long": "23.188816"
      },
      {
        "name": "CICARD",
        "zip": "517399",
        "lat": "46.274711",
        "long": "23.906504"
      },
      {
        "name": "CICAU",
        "zip": "517471",
        "lat": "46.399967",
        "long": "23.67925"
      },
      {
        "name": "CIOARA DE SUS",
        "zip": "515302",
        "lat": "46.376497",
        "long": "23.315149"
      },
      {
        "name": "CIOCASU",
        "zip": "517877",
        "lat": "46.038788",
        "long": "23.463865"
      },
      {
        "name": "CIONESTI",
        "zip": "517008",
        "lat": "46.471782",
        "long": "22.989536"
      },
      {
        "name": "CISTEI",
        "zip": "517466",
        "lat": "46.186616",
        "long": "23.753637"
      },
      {
        "name": "CISTEIU DE MURES",
        "zip": "515701",
        "lat": "46.377493",
        "long": "23.813071"
      },
      {
        "name": "CIUCULESTI",
        "zip": "517171",
        "lat": "46.261648",
        "long": "23.185574"
      },
      {
        "name": "CIUGUD",
        "zip": "517240",
        "lat": "46.046065",
        "long": "23.612864"
      },
      {
        "name": "CIUGUDU DE JOS",
        "zip": "517786",
        "lat": "46.417774",
        "long": "23.744619"
      },
      {
        "name": "CIUGUDU DE SUS",
        "zip": "517787",
        "lat": "46.425512",
        "long": "23.712313"
      },
      {
        "name": "CIUGUZEL",
        "zip": "517401",
        "lat": "46.283388",
        "long": "23.858736"
      },
      {
        "name": "CIULDESTI",
        "zip": "517122",
        "lat": "46.389283",
        "long": "23.107221"
      },
      {
        "name": "CIUMBRUD",
        "zip": "515202",
        "lat": "46.308097",
        "long": "23.762224"
      },
      {
        "name": "CIURULEASA",
        "zip": "517250",
        "lat": "46.255395",
        "long": "23.034481"
      },
      {
        "name": "COASTA HENTII",
        "zip": "517621",
        "lat": "46.31036",
        "long": "23.057226"
      },
      {
        "name": "COASTA VASCULUI",
        "zip": "515505",
        "lat": "46.416025",
        "long": "23.048394"
      },
      {
        "name": "COBLES",
        "zip": "517044",
        "lat": "46.494217",
        "long": "22.733575"
      },
      {
        "name": "COCESTI",
        "zip": "517077",
        "lat": "46.361329",
        "long": "22.812299"
      },
      {
        "name": "COCOSESTI",
        "zip": "517078",
        "lat": "46.374812",
        "long": "22.814395"
      },
      {
        "name": "COJOCANI",
        "zip": "517489",
        "lat": "46.283049",
        "long": "23.365829"
      },
      {
        "name": "COLESENI",
        "zip": "517172",
        "lat": "46.243004",
        "long": "23.141223"
      },
      {
        "name": "COLIBI",
        "zip": "517531",
        "lat": "46.111885",
        "long": "23.78565"
      },
      {
        "name": "COLTESTI",
        "zip": "517611",
        "lat": "46.421498",
        "long": "23.559792"
      },
      {
        "name": "COPAND",
        "zip": "517517",
        "lat": "46.420133",
        "long": "23.981158"
      },
      {
        "name": "CORNA",
        "zip": "517622",
        "lat": "46.288182",
        "long": "23.122679"
      },
      {
        "name": "CORNU",
        "zip": "517262",
        "lat": "46.221304",
        "long": "23.814246"
      },
      {
        "name": "COROIESTI",
        "zip": "517079",
        "lat": "46.355965",
        "long": "22.820643"
      },
      {
        "name": "CORTESTI",
        "zip": "517576",
        "lat": "46.446646",
        "long": "23.303595"
      },
      {
        "name": "COSLARIU",
        "zip": "517676",
        "lat": "46.157813",
        "long": "23.688278"
      },
      {
        "name": "COSLARIU NOU",
        "zip": "515903",
        "lat": "46.176762",
        "long": "23.681285"
      },
      {
        "name": "COSTESTI",
        "zip": "517009",
        "lat": "46.48683",
        "long": "22.90889"
      },
      {
        "name": "COSTESTI",
        "zip": "517546",
        "lat": "46.410631",
        "long": "22.860099"
      },
      {
        "name": "COTORASTI",
        "zip": "517594",
        "lat": "46.329321",
        "long": "23.543133"
      },
      {
        "name": "CRACIUNELU DE JOS",
        "zip": "517260",
        "lat": "46.171394",
        "long": "23.835488"
      },
      {
        "name": "CRACIUNELU DE SUS",
        "zip": "517236",
        "lat": "46.172233",
        "long": "24.182633"
      },
      {
        "name": "CRAIVA",
        "zip": "517266",
        "lat": "46.170735",
        "long": "23.551909"
      },
      {
        "name": "CRETESTI",
        "zip": "517123",
        "lat": "46.357933",
        "long": "23.10589"
      },
      {
        "name": "CRICAU",
        "zip": "517265",
        "lat": "46.176421",
        "long": "23.568993"
      },
      {
        "name": "CRISENI",
        "zip": "517878",
        "lat": "46.041475",
        "long": "23.488659"
      },
      {
        "name": "CRISTESTI",
        "zip": "517491",
        "lat": "46.275701",
        "long": "23.307835"
      },
      {
        "name": "CUCUTA",
        "zip": "517223",
        "lat": "45.984653",
        "long": "23.264105"
      },
      {
        "name": "CUGIR",
        "zip": "515600",
        "lat": "45.836289",
        "long": "23.374095"
      },
      {
        "name": "CULDESTI",
        "zip": "517831",
        "lat": "46.383941",
        "long": "22.960139"
      },
      {
        "name": "CUNTA",
        "zip": "517768",
        "lat": "45.926136",
        "long": "23.721623"
      },
      {
        "name": "CURATURI",
        "zip": "517623",
        "lat": "46.329475",
        "long": "23.049965"
      },
      {
        "name": "CURMATURA",
        "zip": "517413",
        "lat": "46.341409",
        "long": "23.227503"
      },
      {
        "name": "CURPENI",
        "zip": "517224",
        "lat": "45.985266",
        "long": "23.280881"
      },
      {
        "name": "CUT",
        "zip": "517206",
        "lat": "45.939724",
        "long": "23.667193"
      },
      {
        "name": "DAIA ROMANA",
        "zip": "517270",
        "lat": "46.007088",
        "long": "23.668159"
      },
      {
        "name": "DAMBURENI",
        "zip": "517124",
        "lat": "46.413735",
        "long": "23.072636"
      },
      {
        "name": "DANDUT",
        "zip": "515506",
        "lat": "46.354271",
        "long": "23.088375"
      },
      {
        "name": "DARLESTI",
        "zip": "517343",
        "lat": "46.516698",
        "long": "22.920885"
      },
      {
        "name": "DAROAIA",
        "zip": "517624",
        "lat": "46.30473",
        "long": "23.053441"
      },
      {
        "name": "DEAL",
        "zip": "517207",
        "lat": "45.857414",
        "long": "23.623284"
      },
      {
        "name": "DEALU BAJULUI",
        "zip": "517046",
        "lat": "46.458761",
        "long": "22.779549"
      },
      {
        "name": "DEALU BISTRII",
        "zip": "515507",
        "lat": "46.375418",
        "long": "23.055952"
      },
      {
        "name": "DEALU CAPSEI",
        "zip": "515508",
        "lat": "46.393458",
        "long": "23.064437"
      },
      {
        "name": "DEALU CASELOR",
        "zip": "517646",
        "lat": "46.380404",
        "long": "23.387261"
      },
      {
        "name": "DEALU CRISULUI",
        "zip": "517081",
        "lat": "46.340631",
        "long": "22.835897"
      },
      {
        "name": "DEALU DOSTATULUI",
        "zip": "517277",
        "lat": "45.964454",
        "long": "23.850894"
      },
      {
        "name": "DEALU FERULUI",
        "zip": "517879",
        "lat": "46.003014",
        "long": "23.421768"
      },
      {
        "name": "DEALU FRUMOS",
        "zip": "517312",
        "lat": "46.490179",
        "long": "22.830863"
      },
      {
        "name": "DEALU FRUMOS",
        "zip": "517798",
        "lat": "46.420654",
        "long": "22.977539"
      },
      {
        "name": "DEALU GEOAGIULUI",
        "zip": "517366",
        "lat": "46.274749",
        "long": "23.428643"
      },
      {
        "name": "DEALU GOIESTI",
        "zip": "517832",
        "lat": "46.391178",
        "long": "22.910754"
      },
      {
        "name": "DEALU LAMASOI",
        "zip": "517011",
        "lat": "46.486103",
        "long": "22.98639"
      },
      {
        "name": "DEALU MUNTELUI",
        "zip": "517126",
        "lat": "46.378809",
        "long": "23.117896000000002"
      },
      {
        "name": "DEALU ORDANCUSII",
        "zip": "517313",
        "lat": "46.512139",
        "long": "22.839854"
      },
      {
        "name": "DEALU ROATEI",
        "zip": "516103",
        "lat": "46.124756",
        "long": "23.153142"
      },
      {
        "name": "DECEA",
        "zip": "517472",
        "lat": "46.383087",
        "long": "23.763082"
      },
      {
        "name": "DELENI-OBARSIE",
        "zip": "515401",
        "lat": "46.095352",
        "long": "23.852203"
      },
      {
        "name": "DEONCESTI",
        "zip": "517707",
        "lat": "46.299922",
        "long": "22.999225"
      },
      {
        "name": "DEVE",
        "zip": "517012",
        "lat": "46.461221",
        "long": "22.931981"
      },
      {
        "name": "DILIMANI",
        "zip": "517708",
        "lat": "46.355174",
        "long": "23.016704"
      },
      {
        "name": "DOBRA",
        "zip": "517778",
        "lat": "45.761464",
        "long": "23.658981"
      },
      {
        "name": "DOBRESTI",
        "zip": "517314",
        "lat": "46.470339",
        "long": "22.819527"
      },
      {
        "name": "DOBROT",
        "zip": "516104",
        "lat": "46.169759",
        "long": "23.140808"
      },
      {
        "name": "DOGARESTI",
        "zip": "517173",
        "lat": "46.271087",
        "long": "23.125973"
      },
      {
        "name": "DOLESTI",
        "zip": "517082",
        "lat": "46.368897",
        "long": "22.837682"
      },
      {
        "name": "DOPTAU",
        "zip": "517758",
        "lat": "46.263501",
        "long": "23.932776"
      },
      {
        "name": "DOS",
        "zip": "517833",
        "lat": "46.374297",
        "long": "22.949573"
      },
      {
        "name": "DOSTAT",
        "zip": "517275",
        "lat": "45.970884",
        "long": "23.842788"
      },
      {
        "name": "DOSU LUNCII",
        "zip": "517834",
        "lat": "46.362877",
        "long": "22.898864"
      },
      {
        "name": "DOSU VASESTI",
        "zip": "517836",
        "lat": "46.367607",
        "long": "22.868416"
      },
      {
        "name": "DRAGOIESTI-LUNCA",
        "zip": "517837",
        "lat": "46.365656",
        "long": "22.980084"
      },
      {
        "name": "DRAMBAR",
        "zip": "517241",
        "lat": "46.076592",
        "long": "23.630139"
      },
      {
        "name": "DRASOV",
        "zip": "517769",
        "lat": "45.938197",
        "long": "23.742273"
      },
      {
        "name": "DRIC",
        "zip": "515509",
        "lat": "46.408732",
        "long": "23.04085"
      },
      {
        "name": "DUDUIENI",
        "zip": "517547",
        "lat": "46.404578",
        "long": "22.857456"
      },
      {
        "name": "DUMACESTI",
        "zip": "517083",
        "lat": "46.393912",
        "long": "22.798227"
      },
      {
        "name": "DUMBRAVA",
        "zip": "516105",
        "lat": "46.141117",
        "long": "23.197187"
      },
      {
        "name": "DUMBRAVA",
        "zip": "517662",
        "lat": "45.882906",
        "long": "23.605589"
      },
      {
        "name": "DUMBRAVA",
        "zip": "517788",
        "lat": "46.435859",
        "long": "23.771424"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "517226",
        "lat": "45.989116",
        "long": "23.255879"
      },
      {
        "name": "DUMESTI",
        "zip": "517647",
        "lat": "46.382201",
        "long": "23.443508"
      },
      {
        "name": "DUMITRA",
        "zip": "517677",
        "lat": "46.097118",
        "long": "23.680197"
      },
      {
        "name": "DUPA DEAL",
        "zip": "517414",
        "lat": "46.34036",
        "long": "23.157445"
      },
      {
        "name": "DUPA DEAL",
        "zip": "517566",
        "lat": "46.325991",
        "long": "23.426489"
      },
      {
        "name": "DUPA PLESE",
        "zip": "517013",
        "lat": "46.43602",
        "long": "22.94375"
      },
      {
        "name": "DURASTI",
        "zip": "517127",
        "lat": "46.439082",
        "long": "23.102481"
      },
      {
        "name": "FAGET",
        "zip": "517816",
        "lat": "46.153087",
        "long": "24.165695"
      },
      {
        "name": "FAGETU DE JOS",
        "zip": "517548",
        "lat": "46.403798",
        "long": "22.904968"
      },
      {
        "name": "FAGETU DE SUS",
        "zip": "517549",
        "lat": "46.395662",
        "long": "22.840745"
      },
      {
        "name": "FANTANELE",
        "zip": "517227",
        "lat": "46.029279",
        "long": "23.271811"
      },
      {
        "name": "FARAU",
        "zip": "517280",
        "lat": "46.337968",
        "long": "24.007859"
      },
      {
        "name": "FATA",
        "zip": "517014",
        "lat": "46.461425",
        "long": "22.960634"
      },
      {
        "name": "FATA ABRUDULUI",
        "zip": "515510",
        "lat": "46.344177",
        "long": "23.054736"
      },
      {
        "name": "FATA CRISTESEI",
        "zip": "517047",
        "lat": "46.483683",
        "long": "22.749204"
      },
      {
        "name": "FATA LAPUSULUI",
        "zip": "517048",
        "lat": "46.466676",
        "long": "22.765442"
      },
      {
        "name": "FATA PIETRII",
        "zip": "517746",
        "lat": "46.296265",
        "long": "23.539041"
      },
      {
        "name": "FATA-LAZESTI",
        "zip": "517683",
        "lat": "46.430372",
        "long": "22.856675"
      },
      {
        "name": "FEISA",
        "zip": "517388",
        "lat": "46.226085",
        "long": "24.144923"
      },
      {
        "name": "FENES",
        "zip": "516106",
        "lat": "46.104418",
        "long": "23.292868"
      },
      {
        "name": "FERESTI",
        "zip": "517174",
        "lat": "46.240798",
        "long": "23.100832"
      },
      {
        "name": "FERICET",
        "zip": "517344",
        "lat": "46.487359",
        "long": "22.936647"
      },
      {
        "name": "FETENI",
        "zip": "515604",
        "lat": "45.809953",
        "long": "23.351572"
      },
      {
        "name": "FICARESTI",
        "zip": "517838",
        "lat": "46.378486",
        "long": "22.967145"
      },
      {
        "name": "FLITESTI",
        "zip": "515402",
        "lat": "46.110642",
        "long": "23.874515"
      },
      {
        "name": "FLORESTI",
        "zip": "515511",
        "lat": "46.394673",
        "long": "23.003212"
      },
      {
        "name": "FLORESTI",
        "zip": "517176",
        "lat": "46.292448",
        "long": "23.150693"
      },
      {
        "name": "FLORESTI",
        "zip": "517596",
        "lat": "46.337592",
        "long": "23.492944"
      },
      {
        "name": "FLORESTI",
        "zip": "517684",
        "lat": "46.441552",
        "long": "22.897685"
      },
      {
        "name": "FURDUIESTI",
        "zip": "515512",
        "lat": "46.335918",
        "long": "23.077959"
      },
      {
        "name": "FURDUIESTI",
        "zip": "517709",
        "lat": "46.312707",
        "long": "22.991038"
      },
      {
        "name": "GABUD",
        "zip": "517518",
        "lat": "46.409363",
        "long": "24.011452"
      },
      {
        "name": "GALATI",
        "zip": "516107",
        "lat": "46.09073",
        "long": "23.292104"
      },
      {
        "name": "GALBENA",
        "zip": "517049",
        "lat": "46.473559",
        "long": "22.734584"
      },
      {
        "name": "GALDA DE JOS",
        "zip": "517285",
        "lat": "46.179171",
        "long": "23.621791"
      },
      {
        "name": "GALDA DE SUS",
        "zip": "517288",
        "lat": "46.221898",
        "long": "23.565688"
      },
      {
        "name": "GALTIU",
        "zip": "517678",
        "lat": "46.142972",
        "long": "23.666241"
      },
      {
        "name": "GAMBAS",
        "zip": "515203",
        "lat": "46.346133",
        "long": "23.723575"
      },
      {
        "name": "GANESTI",
        "zip": "517128",
        "lat": "46.386548",
        "long": "23.127797"
      },
      {
        "name": "GARBOVA",
        "zip": "517305",
        "lat": "45.860515",
        "long": "23.723625"
      },
      {
        "name": "GARBOVA DE JOS",
        "zip": "515204",
        "lat": "46.257681",
        "long": "23.667453"
      },
      {
        "name": "GARBOVA DE SUS",
        "zip": "515205",
        "lat": "46.292798",
        "long": "23.622982"
      },
      {
        "name": "GARBOVITA",
        "zip": "515206",
        "lat": "46.281021",
        "long": "23.641395"
      },
      {
        "name": "GARDA DE SUS",
        "zip": "517310",
        "lat": "46.455435",
        "long": "22.828553"
      },
      {
        "name": "GARDA SEACA",
        "zip": "517316",
        "lat": "46.477823",
        "long": "22.811766"
      },
      {
        "name": "GARDA-BARBULESTI",
        "zip": "517626",
        "lat": "46.324829",
        "long": "23.116734"
      },
      {
        "name": "GARDE",
        "zip": "517129",
        "lat": "46.382748",
        "long": "23.138202"
      },
      {
        "name": "GEAMANA",
        "zip": "517416",
        "lat": "46.333257",
        "long": "23.20354"
      },
      {
        "name": "GEOAGIU DE SUS",
        "zip": "517747",
        "lat": "46.254529",
        "long": "23.592574"
      },
      {
        "name": "GEOGEL",
        "zip": "517567",
        "lat": "46.309715",
        "long": "23.382188"
      },
      {
        "name": "GEOMAL",
        "zip": "517748",
        "lat": "46.261437",
        "long": "23.621928"
      },
      {
        "name": "GHEDULESTI",
        "zip": "517256",
        "lat": "46.234419",
        "long": "23.066245"
      },
      {
        "name": "GHETARI",
        "zip": "517317",
        "lat": "46.491334",
        "long": "22.815389"
      },
      {
        "name": "GHIONCANI",
        "zip": "517367",
        "lat": "46.241335",
        "long": "23.325614"
      },
      {
        "name": "GHIRBOM",
        "zip": "517111",
        "lat": "46.034761",
        "long": "23.723289"
      },
      {
        "name": "GIURGIUT",
        "zip": "517346",
        "lat": "46.521396",
        "long": "22.9501"
      },
      {
        "name": "GLIGORESTI",
        "zip": "517839",
        "lat": "46.384388",
        "long": "22.843687"
      },
      {
        "name": "GLOD",
        "zip": "517036",
        "lat": "46.063033",
        "long": "23.156661"
      },
      {
        "name": "GLOGOVET",
        "zip": "517817",
        "lat": "46.148408",
        "long": "24.008881"
      },
      {
        "name": "GOASELE",
        "zip": "515605",
        "lat": "45.774287",
        "long": "23.455486"
      },
      {
        "name": "GOIESTI",
        "zip": "517841",
        "lat": "46.376841",
        "long": "22.920008"
      },
      {
        "name": "GOJEIESTI",
        "zip": "517084",
        "lat": "46.379856",
        "long": "22.827535"
      },
      {
        "name": "GORGAN",
        "zip": "517212",
        "lat": "46.092264",
        "long": "24.006812"
      },
      {
        "name": "GROSI",
        "zip": "517228",
        "lat": "46.004327",
        "long": "23.245174"
      },
      {
        "name": "GURA ARIESULUI",
        "zip": "517406",
        "lat": "46.429354",
        "long": "23.955528"
      },
      {
        "name": "GURA CORNEI",
        "zip": "515102",
        "lat": "46.261478",
        "long": "23.090911"
      },
      {
        "name": "GURA CUTULUI",
        "zip": "517881",
        "lat": "46.036947",
        "long": "23.409242"
      },
      {
        "name": "GURA IZBITEI",
        "zip": "517177",
        "lat": "46.247453",
        "long": "23.157935"
      },
      {
        "name": "GURA ROSIEI",
        "zip": "517627",
        "lat": "46.307074",
        "long": "23.059364"
      },
      {
        "name": "GURA SOHODOL",
        "zip": "517711",
        "lat": "46.354632",
        "long": "23.03067"
      },
      {
        "name": "HADARAU",
        "zip": "517417",
        "lat": "46.361586",
        "long": "23.19879"
      },
      {
        "name": "HAIDUCESTI",
        "zip": "517842",
        "lat": "46.393839",
        "long": "22.927681"
      },
      {
        "name": "HANASESTI",
        "zip": "517318",
        "lat": "46.498954",
        "long": "22.826751"
      },
      {
        "name": "HANASESTI",
        "zip": "517551",
        "lat": "46.391437",
        "long": "22.853411"
      },
      {
        "name": "HAPRIA",
        "zip": "517243",
        "lat": "46.080821",
        "long": "23.669132"
      },
      {
        "name": "HARASTI",
        "zip": "517843",
        "lat": "46.349173",
        "long": "22.898133"
      },
      {
        "name": "HATEGANA",
        "zip": "517882",
        "lat": "46.028237",
        "long": "23.444835"
      },
      {
        "name": "HELERESTI",
        "zip": "517086",
        "lat": "46.368209",
        "long": "22.84167"
      },
      {
        "name": "HELESTI",
        "zip": "517178",
        "lat": "46.282504",
        "long": "23.143688"
      },
      {
        "name": "HENIG",
        "zip": "517112",
        "lat": "46.10576",
        "long": "23.730889"
      },
      {
        "name": "HERIA",
        "zip": "517281",
        "lat": "46.36474",
        "long": "23.980339"
      },
      {
        "name": "HOANCA",
        "zip": "517712",
        "lat": "46.331775",
        "long": "22.969981"
      },
      {
        "name": "HOANCA",
        "zip": "517844",
        "lat": "46.342604",
        "long": "22.916308"
      },
      {
        "name": "HODISESTI",
        "zip": "517131",
        "lat": "46.400223",
        "long": "23.103701"
      },
      {
        "name": "HODOBANA",
        "zip": "517051",
        "lat": "46.515962",
        "long": "22.770692"
      },
      {
        "name": "HOLOBANI",
        "zip": "517418",
        "lat": "46.319967",
        "long": "23.232196"
      },
      {
        "name": "HOPARTA",
        "zip": "517335",
        "lat": "46.321337",
        "long": "23.872445"
      },
      {
        "name": "HOREA",
        "zip": "517340",
        "lat": "46.502065",
        "long": "22.950048"
      },
      {
        "name": "HUDRICESTI",
        "zip": "517132",
        "lat": "46.394032",
        "long": "23.09305"
      },
      {
        "name": "HUZARESTI",
        "zip": "517319",
        "lat": "46.445175",
        "long": "22.844785"
      },
      {
        "name": "IACOBESTI",
        "zip": "517628",
        "lat": "46.307964",
        "long": "23.068448"
      },
      {
        "name": "IBRU",
        "zip": "517162",
        "lat": "46.018882",
        "long": "23.356798"
      },
      {
        "name": "ICLOD",
        "zip": "517671",
        "lat": "46.210306",
        "long": "23.938929"
      },
      {
        "name": "IGHIEL",
        "zip": "517362",
        "lat": "46.146804",
        "long": "23.479682"
      },
      {
        "name": "IGHIU",
        "zip": "517360",
        "lat": "46.144756",
        "long": "23.51876"
      },
      {
        "name": "IGNATESTI",
        "zip": "517629",
        "lat": "46.30692",
        "long": "23.078825"
      },
      {
        "name": "ILIESTI",
        "zip": "517368",
        "lat": "46.273761",
        "long": "23.387127"
      },
      {
        "name": "INCESTI",
        "zip": "517087",
        "lat": "46.359497",
        "long": "22.860463"
      },
      {
        "name": "INCESTI",
        "zip": "517577",
        "lat": "46.458889",
        "long": "23.285759"
      },
      {
        "name": "INOC",
        "zip": "517789",
        "lat": "46.385211",
        "long": "23.787227"
      },
      {
        "name": "INTREGALDE",
        "zip": "517365",
        "lat": "46.244574",
        "long": "23.413223"
      },
      {
        "name": "INURI",
        "zip": "517883",
        "lat": "46.044392",
        "long": "23.453147"
      },
      {
        "name": "ISCA",
        "zip": "517447",
        "lat": "46.104595",
        "long": "23.406227"
      },
      {
        "name": "IVANIS",
        "zip": "517369",
        "lat": "46.226789",
        "long": "23.390666"
      },
      {
        "name": "IZBICIOARA",
        "zip": "517179",
        "lat": "46.242005",
        "long": "23.167959"
      },
      {
        "name": "IZBITA",
        "zip": "517181",
        "lat": "46.246318",
        "long": "23.153427"
      },
      {
        "name": "IZLAZ",
        "zip": "517052",
        "lat": "46.481451",
        "long": "22.725571"
      },
      {
        "name": "IZVOARELE",
        "zip": "515403",
        "lat": "46.170109",
        "long": "23.90377"
      },
      {
        "name": "IZVOARELE",
        "zip": "517321",
        "lat": "46.458973",
        "long": "22.834775"
      },
      {
        "name": "IZVOARELE",
        "zip": "517391",
        "lat": "46.400481",
        "long": "23.536851"
      },
      {
        "name": "IZVORU AMPOIULUI",
        "zip": "516108",
        "lat": "46.146832",
        "long": "23.174263"
      },
      {
        "name": "JEFLESTI",
        "zip": "517846",
        "lat": "46.375296",
        "long": "22.872782"
      },
      {
        "name": "JIDOSTINA",
        "zip": "517779",
        "lat": "45.716916",
        "long": "23.587122"
      },
      {
        "name": "JIDVEI",
        "zip": "517385",
        "lat": "46.223096",
        "long": "24.111099"
      },
      {
        "name": "JOJEI",
        "zip": "517088",
        "lat": "46.34099",
        "long": "22.830769"
      },
      {
        "name": "JOLDISESTI",
        "zip": "517713",
        "lat": "46.31914",
        "long": "22.936586"
      },
      {
        "name": "JURCUIESTI",
        "zip": "517182",
        "lat": "46.294329",
        "long": "23.182738"
      },
      {
        "name": "LANCRAM",
        "zip": "515801",
        "lat": "45.987175",
        "long": "23.555679"
      },
      {
        "name": "LAZ",
        "zip": "517663",
        "lat": "45.868401",
        "long": "23.58122"
      },
      {
        "name": "LAZ",
        "zip": "517884",
        "lat": "46.051812",
        "long": "23.416607"
      },
      {
        "name": "LAZESTI",
        "zip": "517686",
        "lat": "46.420733",
        "long": "22.909012"
      },
      {
        "name": "LAZESTI",
        "zip": "517799",
        "lat": "46.419604",
        "long": "22.937942"
      },
      {
        "name": "LAZURI",
        "zip": "517419",
        "lat": "46.350304",
        "long": "23.170322"
      },
      {
        "name": "LAZURI",
        "zip": "517714",
        "lat": "46.363474",
        "long": "23.023593"
      },
      {
        "name": "LEHESTI",
        "zip": "517716",
        "lat": "46.307066",
        "long": "22.981494"
      },
      {
        "name": "LEORINT",
        "zip": "517586",
        "lat": "46.254014",
        "long": "23.724265"
      },
      {
        "name": "LESPEZEA",
        "zip": "517687",
        "lat": "46.475437",
        "long": "22.900859"
      },
      {
        "name": "LIMBA",
        "zip": "517242",
        "lat": "46.039994",
        "long": "23.597689"
      },
      {
        "name": "LIPAIA",
        "zip": "517133",
        "lat": "46.384895",
        "long": "23.077167"
      },
      {
        "name": "LIVEZILE",
        "zip": "517390",
        "lat": "46.347272",
        "long": "23.647716"
      },
      {
        "name": "LODROMAN",
        "zip": "517818",
        "lat": "46.117917",
        "long": "24.074104"
      },
      {
        "name": "LOMAN",
        "zip": "517664",
        "lat": "45.857042",
        "long": "23.551211"
      },
      {
        "name": "LOPADEA NOUA",
        "zip": "517395",
        "lat": "46.290905",
        "long": "23.819014"
      },
      {
        "name": "LOPADEA VECHE",
        "zip": "517473",
        "lat": "46.377071",
        "long": "23.66232"
      },
      {
        "name": "LUMINESTI",
        "zip": "517717",
        "lat": "46.325958",
        "long": "22.942007"
      },
      {
        "name": "LUNCA",
        "zip": "517421",
        "lat": "46.378695",
        "long": "23.217615"
      },
      {
        "name": "LUNCA",
        "zip": "517578",
        "lat": "46.439494",
        "long": "23.459487"
      },
      {
        "name": "LUNCA",
        "zip": "517819",
        "lat": "46.102146",
        "long": "24.052472"
      },
      {
        "name": "LUNCA",
        "zip": "517847",
        "lat": "46.373453",
        "long": "22.908313"
      },
      {
        "name": "LUNCA AMPOITEI",
        "zip": "517448",
        "lat": "46.139948",
        "long": "23.385181"
      },
      {
        "name": "LUNCA BISERICII",
        "zip": "517848",
        "lat": "46.367428",
        "long": "22.880075"
      },
      {
        "name": "LUNCA DE JOS",
        "zip": "517852",
        "lat": "46.373841",
        "long": "22.907406"
      },
      {
        "name": "LUNCA GOIESTI",
        "zip": "517849",
        "lat": "46.36895",
        "long": "22.923297"
      },
      {
        "name": "LUNCA LARGA",
        "zip": "517134",
        "lat": "46.379671",
        "long": "23.127502"
      },
      {
        "name": "LUNCA LARGA",
        "zip": "517526",
        "lat": "46.524629",
        "long": "23.425428"
      },
      {
        "name": "LUNCA MERILOR",
        "zip": "517136",
        "lat": "46.366653",
        "long": "23.097711"
      },
      {
        "name": "LUNCA METESULUI",
        "zip": "517449",
        "lat": "46.139646",
        "long": "23.366482"
      },
      {
        "name": "LUNCA MURESULUI",
        "zip": "517405",
        "lat": "46.428075",
        "long": "23.909731"
      },
      {
        "name": "LUNCA TARNAVEI",
        "zip": "517759",
        "lat": "46.218083",
        "long": "23.984387"
      },
      {
        "name": "LUNCA VESESTI",
        "zip": "517851",
        "lat": "46.372581",
        "long": "22.952945"
      },
      {
        "name": "LUPAIESTI",
        "zip": "517552",
        "lat": "46.412434",
        "long": "22.900602"
      },
      {
        "name": "LUPSA",
        "zip": "517410",
        "lat": "46.369259",
        "long": "23.207453"
      },
      {
        "name": "LUPSENI",
        "zip": "517289",
        "lat": "46.219507",
        "long": "23.55211"
      },
      {
        "name": "LUPU",
        "zip": "517218",
        "lat": "46.100475",
        "long": "23.969213"
      },
      {
        "name": "LUPULESTI",
        "zip": "517183",
        "lat": "46.253261",
        "long": "23.192703"
      },
      {
        "name": "MACARESTI",
        "zip": "517568",
        "lat": "46.303128",
        "long": "23.390737"
      },
      {
        "name": "MAGHIERAT",
        "zip": "517532",
        "lat": "46.052279",
        "long": "23.816649"
      },
      {
        "name": "MAGINA",
        "zip": "515207",
        "lat": "46.341599",
        "long": "23.654539"
      },
      {
        "name": "MAGURA",
        "zip": "517184",
        "lat": "46.247021",
        "long": "23.135848"
      },
      {
        "name": "MAGURA",
        "zip": "517291",
        "lat": "46.233989",
        "long": "23.542282"
      },
      {
        "name": "MAHACENI",
        "zip": "517791",
        "lat": "46.446686",
        "long": "23.742964"
      },
      {
        "name": "MAMALIGANI",
        "zip": "517492",
        "lat": "46.293264",
        "long": "23.278943"
      },
      {
        "name": "MANARADE",
        "zip": "515404",
        "lat": "46.141439",
        "long": "23.970764"
      },
      {
        "name": "MANASTIRE",
        "zip": "517422",
        "lat": "46.37638",
        "long": "23.174582"
      },
      {
        "name": "MANCESTI",
        "zip": "517347",
        "lat": "46.492682",
        "long": "22.957127"
      },
      {
        "name": "MARGAIA",
        "zip": "517423",
        "lat": "46.363384",
        "long": "23.22755"
      },
      {
        "name": "MARGINENI",
        "zip": "517656",
        "lat": "45.838766",
        "long": "23.427175"
      },
      {
        "name": "MARINESTI",
        "zip": "517371",
        "lat": "46.270568",
        "long": "23.39232"
      },
      {
        "name": "MARTESTI",
        "zip": "517089",
        "lat": "46.3579",
        "long": "22.862086"
      },
      {
        "name": "MARTINIE",
        "zip": "517781",
        "lat": "45.79626",
        "long": "23.614224"
      },
      {
        "name": "MATACINA",
        "zip": "517886",
        "lat": "46.03635",
        "long": "23.424544"
      },
      {
        "name": "MATEI",
        "zip": "517688",
        "lat": "46.436437",
        "long": "22.888436"
      },
      {
        "name": "MATISESTI",
        "zip": "517257",
        "lat": "46.232451",
        "long": "23.010519"
      },
      {
        "name": "MATISESTI",
        "zip": "517348",
        "lat": "46.508887",
        "long": "22.902301"
      },
      {
        "name": "MEDRESTI",
        "zip": "517718",
        "lat": "46.295671",
        "long": "22.952955"
      },
      {
        "name": "MEDVES",
        "zip": "517282",
        "lat": "46.304991",
        "long": "24.063105"
      },
      {
        "name": "MERETEU",
        "zip": "517887",
        "lat": "45.996404",
        "long": "23.433767"
      },
      {
        "name": "MESCREAC",
        "zip": "517587",
        "lat": "46.241209",
        "long": "23.738698"
      },
      {
        "name": "MESENTEA",
        "zip": "517292",
        "lat": "46.193301",
        "long": "23.603816"
      },
      {
        "name": "METES",
        "zip": "517445",
        "lat": "46.097293",
        "long": "23.424807"
      },
      {
        "name": "MICESTI",
        "zip": "510002",
        "lat": "46.101415",
        "long": "23.555731"
      },
      {
        "name": "MICOSLACA",
        "zip": "515702",
        "lat": "46.370123",
        "long": "23.793263"
      },
      {
        "name": "MIHAIESTI",
        "zip": "517137",
        "lat": "46.353632",
        "long": "23.112511"
      },
      {
        "name": "MIHALT",
        "zip": "517465",
        "lat": "46.16005",
        "long": "23.725273"
      },
      {
        "name": "MIHOESTI",
        "zip": "515513",
        "lat": "46.370427",
        "long": "23.025025"
      },
      {
        "name": "MIRASLAU",
        "zip": "517470",
        "lat": "46.364362",
        "long": "23.708021"
      },
      {
        "name": "MODOLESTI",
        "zip": "517372",
        "lat": "46.250494",
        "long": "23.424018"
      },
      {
        "name": "MODOLESTI",
        "zip": "517853",
        "lat": "46.377664",
        "long": "22.873201"
      },
      {
        "name": "MOGOS",
        "zip": "517480",
        "lat": "46.273359",
        "long": "23.278363"
      },
      {
        "name": "MORARESTI",
        "zip": "517258",
        "lat": "46.222615",
        "long": "23.023949"
      },
      {
        "name": "MORARESTI",
        "zip": "517719",
        "lat": "46.336817",
        "long": "23.023603"
      },
      {
        "name": "MORCANESTI",
        "zip": "517553",
        "lat": "46.40938",
        "long": "22.919545"
      },
      {
        "name": "MOTORASTI",
        "zip": "515514",
        "lat": "46.383091",
        "long": "23.043717"
      },
      {
        "name": "MUGESTI",
        "zip": "515606",
        "lat": "45.816169",
        "long": "23.446045"
      },
      {
        "name": "MUNCELU",
        "zip": "515303",
        "lat": "46.375296",
        "long": "23.258187"
      },
      {
        "name": "MUNESTI",
        "zip": "517721",
        "lat": "46.289994",
        "long": "22.999111"
      },
      {
        "name": "MUNTARI",
        "zip": "517186",
        "lat": "46.30108",
        "long": "23.158396"
      },
      {
        "name": "MUNUNA",
        "zip": "517322",
        "lat": "46.469101",
        "long": "22.832468"
      },
      {
        "name": "MUSCA",
        "zip": "517424",
        "lat": "46.356663",
        "long": "23.171235"
      },
      {
        "name": "NADASTIA",
        "zip": "517038",
        "lat": "46.081467",
        "long": "23.149333"
      },
      {
        "name": "NAMAS",
        "zip": "517138",
        "lat": "46.395312",
        "long": "23.125118"
      },
      {
        "name": "NAPAIESTI",
        "zip": "517722",
        "lat": "46.347573",
        "long": "22.99975"
      },
      {
        "name": "NECRILESTI",
        "zip": "517373",
        "lat": "46.209825",
        "long": "23.365831"
      },
      {
        "name": "NECSESTI",
        "zip": "517801",
        "lat": "46.388818",
        "long": "22.989985"
      },
      {
        "name": "NEGESTI",
        "zip": "517689",
        "lat": "46.510573",
        "long": "22.854271"
      },
      {
        "name": "NEGRESTI",
        "zip": "517493",
        "lat": "46.267385",
        "long": "23.31543"
      },
      {
        "name": "NELEGESTI",
        "zip": "517723",
        "lat": "46.344119",
        "long": "23.005654"
      },
      {
        "name": "NEMESI",
        "zip": "517854",
        "lat": "46.364456",
        "long": "22.875843"
      },
      {
        "name": "NICORESTI",
        "zip": "517724",
        "lat": "46.322714",
        "long": "23.012665"
      },
      {
        "name": "NICULESTI",
        "zip": "517349",
        "lat": "46.504605",
        "long": "22.956872"
      },
      {
        "name": "NOSLAC",
        "zip": "517515",
        "lat": "46.404279",
        "long": "23.932844"
      },
      {
        "name": "NOVACESTI",
        "zip": "517139",
        "lat": "46.417877",
        "long": "23.131117"
      },
      {
        "name": "OARDA",
        "zip": "510003",
        "lat": "46.032317",
        "long": "23.567939"
      },
      {
        "name": "OBREJA",
        "zip": "517467",
        "lat": "46.174287",
        "long": "23.764055"
      },
      {
        "name": "OCNA MURES",
        "zip": "515700",
        "lat": "46.381403",
        "long": "23.857735"
      },
      {
        "name": "OCNISOARA",
        "zip": "517402",
        "lat": "46.253342",
        "long": "23.877053"
      },
      {
        "name": "OCOALE",
        "zip": "517323",
        "lat": "46.509085",
        "long": "22.808696"
      },
      {
        "name": "OCOLIS",
        "zip": "517525",
        "lat": "46.478735",
        "long": "23.46608"
      },
      {
        "name": "ODVEREM",
        "zip": "517403",
        "lat": "46.258447",
        "long": "23.838444"
      },
      {
        "name": "OHABA",
        "zip": "517530",
        "lat": "46.070587",
        "long": "23.789439"
      },
      {
        "name": "OIDESTI",
        "zip": "517856",
        "lat": "46.379726",
        "long": "22.937975"
      },
      {
        "name": "OIEJDEA",
        "zip": "517293",
        "lat": "46.157564",
        "long": "23.632314"
      },
      {
        "name": "OLTENI",
        "zip": "517597",
        "lat": "46.34357",
        "long": "23.532838"
      },
      {
        "name": "ONCESTI",
        "zip": "517494",
        "lat": "46.300773",
        "long": "23.414223"
      },
      {
        "name": "ORASTI",
        "zip": "517579",
        "lat": "46.450053",
        "long": "23.339033"
      },
      {
        "name": "ORGESTI",
        "zip": "517091",
        "lat": "46.376397",
        "long": "22.803195"
      },
      {
        "name": "ORMENIS",
        "zip": "517474",
        "lat": "46.396299",
        "long": "23.716559"
      },
      {
        "name": "PACLISA",
        "zip": "510004",
        "lat": "46.047738",
        "long": "23.521085"
      },
      {
        "name": "PADURE",
        "zip": "517263",
        "lat": "46.196874",
        "long": "23.880053"
      },
      {
        "name": "PADUREA",
        "zip": "517451",
        "lat": "46.090633",
        "long": "23.486675"
      },
      {
        "name": "PAGIDA",
        "zip": "515208",
        "lat": "46.341004",
        "long": "23.743135"
      },
      {
        "name": "PANADE",
        "zip": "517672",
        "lat": "46.224029",
        "long": "23.957869"
      },
      {
        "name": "PANCA",
        "zip": "517264",
        "lat": "46.22628",
        "long": "23.885054"
      },
      {
        "name": "PANTESTI",
        "zip": "517053",
        "lat": "46.47707",
        "long": "22.778238"
      },
      {
        "name": "PARAU GRUIULUI",
        "zip": "516110",
        "lat": "46.132693",
        "long": "23.188785"
      },
      {
        "name": "PARAU LUI MIHAI",
        "zip": "517888",
        "lat": "46.012974",
        "long": "23.485973"
      },
      {
        "name": "PARAU-CARBUNARI",
        "zip": "517426",
        "lat": "46.354348",
        "long": "23.207632"
      },
      {
        "name": "PASTESTI",
        "zip": "517554",
        "lat": "46.4054",
        "long": "22.832113"
      },
      {
        "name": "PATRAHAITESTI",
        "zip": "517054",
        "lat": "46.446285",
        "long": "22.743355"
      },
      {
        "name": "PATRANGENI",
        "zip": "516109",
        "lat": "46.089561",
        "long": "23.263718"
      },
      {
        "name": "PATRUSESTI",
        "zip": "517351",
        "lat": "46.524233",
        "long": "22.976122"
      },
      {
        "name": "PATRUTESTI",
        "zip": "517092",
        "lat": "46.375131",
        "long": "22.836824"
      },
      {
        "name": "PELES",
        "zip": "517726",
        "lat": "46.336285",
        "long": "22.983264"
      },
      {
        "name": "PERJESTI",
        "zip": "517141",
        "lat": "46.348866",
        "long": "23.144755"
      },
      {
        "name": "PESTE VALEA BISTRII",
        "zip": "515515",
        "lat": "46.444571",
        "long": "23.032649"
      },
      {
        "name": "PETELCA",
        "zip": "515904",
        "lat": "46.221392",
        "long": "23.736705"
      },
      {
        "name": "PETELEI",
        "zip": "517556",
        "lat": "46.418485",
        "long": "22.830022"
      },
      {
        "name": "PETREASA",
        "zip": "517352",
        "lat": "46.53561",
        "long": "22.942773"
      },
      {
        "name": "PETRENI",
        "zip": "517187",
        "lat": "46.294883",
        "long": "23.166568"
      },
      {
        "name": "PETRESTI",
        "zip": "515850",
        "lat": "45.920833",
        "long": "23.560794"
      },
      {
        "name": "PETRISAT",
        "zip": "515405",
        "lat": "46.192983",
        "long": "23.917347"
      },
      {
        "name": "PIANU DE JOS",
        "zip": "517536",
        "lat": "45.935828",
        "long": "23.487285"
      },
      {
        "name": "PIANU DE SUS",
        "zip": "517537",
        "lat": "45.896318",
        "long": "23.483863"
      },
      {
        "name": "PIRITA",
        "zip": "516111",
        "lat": "46.137276",
        "long": "23.159933"
      },
      {
        "name": "PITARCESTI",
        "zip": "517857",
        "lat": "46.373948",
        "long": "23.001117"
      },
      {
        "name": "PITIGA",
        "zip": "517427",
        "lat": "46.371718",
        "long": "23.168132"
      },
      {
        "name": "PLAI",
        "zip": "517093",
        "lat": "46.398956",
        "long": "22.771832"
      },
      {
        "name": "PLAI",
        "zip": "517324",
        "lat": "46.441418",
        "long": "22.822272"
      },
      {
        "name": "PLAIURI",
        "zip": "517538",
        "lat": "45.834872",
        "long": "23.509485"
      },
      {
        "name": "PLESCUTA",
        "zip": "517858",
        "lat": "46.360208",
        "long": "22.950789"
      },
      {
        "name": "PLESESTI",
        "zip": "517016",
        "lat": "46.447078",
        "long": "22.931179"
      },
      {
        "name": "PLESI",
        "zip": "517666",
        "lat": "45.81564",
        "long": "23.573892"
      },
      {
        "name": "PLISTI",
        "zip": "517326",
        "lat": "46.483396",
        "long": "22.808961"
      },
      {
        "name": "PODU LUI PAUL",
        "zip": "516112",
        "lat": "46.103655",
        "long": "23.245796"
      },
      {
        "name": "PODURI",
        "zip": "515516",
        "lat": "46.351007",
        "long": "23.047287"
      },
      {
        "name": "PODURI-BRICESTI",
        "zip": "517802",
        "lat": "46.41803",
        "long": "22.950499"
      },
      {
        "name": "POIANA",
        "zip": "517142",
        "lat": "46.454564",
        "long": "23.127864"
      },
      {
        "name": "POIANA",
        "zip": "517188",
        "lat": "46.299932",
        "long": "23.170251"
      },
      {
        "name": "POIANA",
        "zip": "517727",
        "lat": "46.299423",
        "long": "22.975135"
      },
      {
        "name": "POIANA AIUDULUI",
        "zip": "517392",
        "lat": "46.365631",
        "long": "23.603371"
      },
      {
        "name": "POIANA AMPOIULUI",
        "zip": "517452",
        "lat": "46.088925",
        "long": "23.392912"
      },
      {
        "name": "POIANA GALDEI",
        "zip": "517294",
        "lat": "46.241981",
        "long": "23.529469"
      },
      {
        "name": "POIANA URSULUI",
        "zip": "517453",
        "lat": "46.073346",
        "long": "23.430407"
      },
      {
        "name": "POIANA VADULUI",
        "zip": "517545",
        "lat": "46.395654",
        "long": "22.883229"
      },
      {
        "name": "POIENI",
        "zip": "517163",
        "lat": "46.017123",
        "long": "23.344808"
      },
      {
        "name": "POIENI",
        "zip": "517189",
        "lat": "46.251544",
        "long": "23.19928"
      },
      {
        "name": "POIENI",
        "zip": "517859",
        "lat": "46.346871",
        "long": "22.909006"
      },
      {
        "name": "POIENILE-MOGOS",
        "zip": "517496",
        "lat": "46.276447",
        "long": "23.244128"
      },
      {
        "name": "POIENITA",
        "zip": "517056",
        "lat": "46.518415",
        "long": "22.718838"
      },
      {
        "name": "POIENITA",
        "zip": "517889",
        "lat": "46.03188",
        "long": "23.454544"
      },
      {
        "name": "POIU",
        "zip": "517143",
        "lat": "46.398642",
        "long": "23.147958"
      },
      {
        "name": "PONOR",
        "zip": "517565",
        "lat": "46.332144",
        "long": "23.417972"
      },
      {
        "name": "PONOREL",
        "zip": "517861",
        "lat": "46.377579",
        "long": "22.943206"
      },
      {
        "name": "POPESTI",
        "zip": "517374",
        "lat": "46.257519",
        "long": "23.39319"
      },
      {
        "name": "POPESTII DE JOS",
        "zip": "517803",
        "lat": "46.415106",
        "long": "22.969776"
      },
      {
        "name": "POPESTII DE SUS",
        "zip": "517804",
        "lat": "46.414913",
        "long": "22.936303"
      },
      {
        "name": "POSAGA DE JOS",
        "zip": "517581",
        "lat": "46.430888",
        "long": "23.438911"
      },
      {
        "name": "POSAGA DE SUS",
        "zip": "517582",
        "lat": "46.466039",
        "long": "23.378935"
      },
      {
        "name": "POSOGANI",
        "zip": "517428",
        "lat": "46.364664",
        "long": "23.196336"
      },
      {
        "name": "POTIONCI",
        "zip": "517017",
        "lat": "46.441603",
        "long": "22.9284"
      },
      {
        "name": "PRELUCA",
        "zip": "517353",
        "lat": "46.510233",
        "long": "22.976809"
      },
      {
        "name": "PRELUCA",
        "zip": "517691",
        "lat": "46.495263",
        "long": "22.851971"
      },
      {
        "name": "PRESACA AMPOIULUI",
        "zip": "517454",
        "lat": "46.09681",
        "long": "23.329868"
      },
      {
        "name": "PUIULETESTI",
        "zip": "517862",
        "lat": "46.369754",
        "long": "22.996569"
      },
      {
        "name": "PURCARETI",
        "zip": "517539",
        "lat": "45.829953",
        "long": "23.488306"
      },
      {
        "name": "PUSELESTI",
        "zip": "517094",
        "lat": "46.377946",
        "long": "22.832433"
      },
      {
        "name": "RACATAU",
        "zip": "517164",
        "lat": "46.02663",
        "long": "23.324503"
      },
      {
        "name": "RACHIS",
        "zip": "517476",
        "lat": "46.394862",
        "long": "23.626204"
      },
      {
        "name": "RACHITA",
        "zip": "517667",
        "lat": "45.875334",
        "long": "23.517072"
      },
      {
        "name": "RADESTI",
        "zip": "517585",
        "lat": "46.272937",
        "long": "23.723551"
      },
      {
        "name": "RAHAU",
        "zip": "515802",
        "lat": "45.903945",
        "long": "23.620653"
      },
      {
        "name": "RAICANI",
        "zip": "517296",
        "lat": "46.266535",
        "long": "23.496849"
      },
      {
        "name": "RAMET",
        "zip": "517590",
        "lat": "46.315733",
        "long": "23.529576"
      },
      {
        "name": "RATITIS",
        "zip": "517144",
        "lat": "46.419666",
        "long": "23.093542"
      },
      {
        "name": "RAVICESTI",
        "zip": "517057",
        "lat": "46.484461",
        "long": "22.777382"
      },
      {
        "name": "RAZBOIENI-CETATE",
        "zip": "515703",
        "lat": "46.413105",
        "long": "23.870899"
      },
      {
        "name": "RECIU",
        "zip": "517307",
        "lat": "45.864969",
        "long": "23.673749"
      },
      {
        "name": "REMETEA",
        "zip": "517456",
        "lat": "46.120022",
        "long": "23.42781"
      },
      {
        "name": "RIMETEA",
        "zip": "517610",
        "lat": "46.454254",
        "long": "23.567496"
      },
      {
        "name": "ROBESTI",
        "zip": "517728",
        "lat": "46.29538",
        "long": "22.984455"
      },
      {
        "name": "ROGOZ",
        "zip": "517018",
        "lat": "46.426452",
        "long": "22.963352"
      },
      {
        "name": "ROSESTI",
        "zip": "517019",
        "lat": "46.477653",
        "long": "22.932248"
      },
      {
        "name": "ROSIA DE SECAS",
        "zip": "517640",
        "lat": "46.056952",
        "long": "23.888649"
      },
      {
        "name": "ROSIA MONTANA",
        "zip": "517615",
        "lat": "46.306253",
        "long": "23.130985"
      },
      {
        "name": "RUNC",
        "zip": "516113",
        "lat": "46.180387",
        "long": "23.213232"
      },
      {
        "name": "RUNC",
        "zip": "517527",
        "lat": "46.501981",
        "long": "23.449071"
      },
      {
        "name": "RUNC",
        "zip": "517692",
        "lat": "46.488957",
        "long": "22.858265"
      },
      {
        "name": "RUNC",
        "zip": "517863",
        "lat": "46.377196",
        "long": "22.994314"
      },
      {
        "name": "RUNCURI",
        "zip": "517146",
        "lat": "46.412312",
        "long": "23.151633"
      },
      {
        "name": "RUSESTI",
        "zip": "517021",
        "lat": "46.480459",
        "long": "22.960803"
      },
      {
        "name": "RUSI",
        "zip": "516114",
        "lat": "46.214432",
        "long": "23.125352"
      },
      {
        "name": "SAGAGEA",
        "zip": "517583",
        "lat": "46.486726",
        "long": "23.314457"
      },
      {
        "name": "SALAGESTI",
        "zip": "517147",
        "lat": "46.400664",
        "long": "23.082133"
      },
      {
        "name": "SALCIUA DE JOS",
        "zip": "517648",
        "lat": "46.398696",
        "long": "23.421324"
      },
      {
        "name": "SALCIUA DE SUS",
        "zip": "517649",
        "lat": "46.393674",
        "long": "23.40244"
      },
      {
        "name": "SALISTEA",
        "zip": "517655",
        "lat": "45.907375",
        "long": "23.39866"
      },
      {
        "name": "SALISTEA-DEAL",
        "zip": "517657",
        "lat": "45.900571",
        "long": "23.423473"
      },
      {
        "name": "SANBENEDIC",
        "zip": "517283",
        "lat": "46.314268",
        "long": "24.043749"
      },
      {
        "name": "SANCEL",
        "zip": "517670",
        "lat": "46.200119",
        "long": "23.94576"
      },
      {
        "name": "SANCRAI",
        "zip": "515209",
        "lat": "46.29379",
        "long": "23.750899"
      },
      {
        "name": "SANMICLAUS",
        "zip": "517761",
        "lat": "46.246832",
        "long": "24.056129"
      },
      {
        "name": "SANTAMARIE",
        "zip": "517237",
        "lat": "46.24252",
        "long": "24.145305"
      },
      {
        "name": "SANTIMBRU",
        "zip": "517675",
        "lat": "46.136075",
        "long": "23.650297"
      },
      {
        "name": "SARACSAU",
        "zip": "517753",
        "lat": "45.945017",
        "long": "23.307123"
      },
      {
        "name": "SARD",
        "zip": "517363",
        "lat": "46.122287",
        "long": "23.532457"
      },
      {
        "name": "SARTAS",
        "zip": "515304",
        "lat": "46.392168",
        "long": "23.295874"
      },
      {
        "name": "SASA",
        "zip": "517429",
        "lat": "46.342963",
        "long": "23.210093"
      },
      {
        "name": "SASCIORI",
        "zip": "517660",
        "lat": "45.878494",
        "long": "23.576504"
      },
      {
        "name": "SCARISOARA",
        "zip": "517680",
        "lat": "46.460821",
        "long": "22.880677"
      },
      {
        "name": "SCOARTA",
        "zip": "517327",
        "lat": "46.43624",
        "long": "22.781782"
      },
      {
        "name": "SEBES",
        "zip": "515800",
        "lat": "45.959106",
        "long": "23.569926"
      },
      {
        "name": "SEBESEL",
        "zip": "517668",
        "lat": "45.887679",
        "long": "23.565654"
      },
      {
        "name": "SEBISESTI",
        "zip": "517729",
        "lat": "46.346062",
        "long": "22.993732"
      },
      {
        "name": "SECASEL",
        "zip": "517533",
        "lat": "46.095044",
        "long": "23.80973"
      },
      {
        "name": "SEGAJ",
        "zip": "517864",
        "lat": "46.38085",
        "long": "22.859418"
      },
      {
        "name": "SEUSA",
        "zip": "517244",
        "lat": "46.059711",
        "long": "23.627393"
      },
      {
        "name": "SFARCEA",
        "zip": "517376",
        "lat": "46.216581",
        "long": "23.305976"
      },
      {
        "name": "SFOARTEA",
        "zip": "517693",
        "lat": "46.524566",
        "long": "22.846"
      },
      {
        "name": "SIBOT",
        "zip": "517750",
        "lat": "45.941061",
        "long": "23.336176"
      },
      {
        "name": "SICOIESTI",
        "zip": "517731",
        "lat": "46.344275",
        "long": "22.978972"
      },
      {
        "name": "SILEA",
        "zip": "517284",
        "lat": "46.325148",
        "long": "24.112379"
      },
      {
        "name": "SILIVAS",
        "zip": "517336",
        "lat": "46.341483",
        "long": "23.875852"
      },
      {
        "name": "SIMOCESTI",
        "zip": "517733",
        "lat": "46.311453",
        "long": "23.001695"
      },
      {
        "name": "SIMULESTI",
        "zip": "515305",
        "lat": "46.354059",
        "long": "23.321113"
      },
      {
        "name": "SNIDE",
        "zip": "517328",
        "lat": "46.447322",
        "long": "22.788712"
      },
      {
        "name": "SOAL",
        "zip": "517631",
        "lat": "46.332453",
        "long": "23.06951"
      },
      {
        "name": "SOHARU",
        "zip": "515103",
        "lat": "46.278379",
        "long": "23.028179"
      },
      {
        "name": "SOHODOL",
        "zip": "517022",
        "lat": "46.471103",
        "long": "22.948412"
      },
      {
        "name": "SOHODOL",
        "zip": "517700",
        "lat": "46.337289",
        "long": "23.010004"
      },
      {
        "name": "SOICESTI",
        "zip": "517096",
        "lat": "46.36332",
        "long": "22.828964"
      },
      {
        "name": "SOIMUS",
        "zip": "517588",
        "lat": "46.2269",
        "long": "23.785433"
      },
      {
        "name": "SONA",
        "zip": "517755",
        "lat": "46.219257",
        "long": "24.016047"
      },
      {
        "name": "SORLITA",
        "zip": "515517",
        "lat": "46.379728",
        "long": "23.008771"
      },
      {
        "name": "SPALNACA",
        "zip": "517337",
        "lat": "46.341242",
        "long": "23.908668"
      },
      {
        "name": "SPATAC",
        "zip": "515406",
        "lat": "46.138592",
        "long": "23.940758"
      },
      {
        "name": "SPRING",
        "zip": "517765",
        "lat": "45.974437",
        "long": "23.777544"
      },
      {
        "name": "STALNISOARA",
        "zip": "517191",
        "lat": "46.239258",
        "long": "23.204269"
      },
      {
        "name": "STANA DE MURES",
        "zip": "517519",
        "lat": "46.42504",
        "long": "23.995785"
      },
      {
        "name": "STANESTI",
        "zip": "517557",
        "lat": "46.412213",
        "long": "22.881435"
      },
      {
        "name": "STAUINI",
        "zip": "517891",
        "lat": "46.03288",
        "long": "23.4883"
      },
      {
        "name": "STEFANCA",
        "zip": "517148",
        "lat": "46.36919",
        "long": "23.130855"
      },
      {
        "name": "STEI-ARIESENI",
        "zip": "517059",
        "lat": "46.468859",
        "long": "22.751692"
      },
      {
        "name": "STERTESTI",
        "zip": "517097",
        "lat": "46.348416",
        "long": "22.843264"
      },
      {
        "name": "STIULETI",
        "zip": "517694",
        "lat": "46.454719",
        "long": "22.915771"
      },
      {
        "name": "STRAJA",
        "zip": "517113",
        "lat": "46.067234",
        "long": "23.686301"
      },
      {
        "name": "STREMT",
        "zip": "517745",
        "lat": "46.221717",
        "long": "23.639504"
      },
      {
        "name": "STRUNGARI",
        "zip": "517541",
        "lat": "45.857148",
        "long": "23.501661"
      },
      {
        "name": "STURU",
        "zip": "517058",
        "lat": "46.468207",
        "long": "22.800108"
      },
      {
        "name": "SUB PIATRA",
        "zip": "517651",
        "lat": "46.384678",
        "long": "23.457593"
      },
      {
        "name": "SUCESTI",
        "zip": "517329",
        "lat": "46.436654",
        "long": "22.795483"
      },
      {
        "name": "SUGAG",
        "zip": "517775",
        "lat": "45.775386",
        "long": "23.627478"
      },
      {
        "name": "SURDESTI",
        "zip": "517732",
        "lat": "46.323013",
        "long": "23.002925"
      },
      {
        "name": "SUSENI",
        "zip": "516115",
        "lat": "46.099552",
        "long": "23.244336"
      },
      {
        "name": "TAMBORESTI",
        "zip": "517023",
        "lat": "46.447537",
        "long": "22.926387"
      },
      {
        "name": "TARANESTI",
        "zip": "517153",
        "lat": "46.40246",
        "long": "23.118922"
      },
      {
        "name": "TARINA",
        "zip": "517632",
        "lat": "46.318382",
        "long": "23.12886"
      },
      {
        "name": "TARSA",
        "zip": "517098",
        "lat": "46.382175",
        "long": "22.796338"
      },
      {
        "name": "TARSA-PLAI",
        "zip": "517099",
        "lat": "46.392702",
        "long": "22.779454"
      },
      {
        "name": "TARTARIA",
        "zip": "517658",
        "lat": "45.934105",
        "long": "23.414085"
      },
      {
        "name": "TATARLAUA",
        "zip": "517238",
        "lat": "46.202759",
        "long": "24.166681"
      },
      {
        "name": "TAU",
        "zip": "517641",
        "lat": "46.070674",
        "long": "23.84219"
      },
      {
        "name": "TAU BISTRA",
        "zip": "517782",
        "lat": "45.684647",
        "long": "23.590498"
      },
      {
        "name": "TAUNI",
        "zip": "517821",
        "lat": "46.150535",
        "long": "24.130526"
      },
      {
        "name": "TAUTI",
        "zip": "517457",
        "lat": "46.096104",
        "long": "23.467853"
      },
      {
        "name": "TECSESTI",
        "zip": "517377",
        "lat": "46.273503",
        "long": "23.476829"
      },
      {
        "name": "TEIU",
        "zip": "517354",
        "lat": "46.50783",
        "long": "22.982883"
      },
      {
        "name": "TEIUS",
        "zip": "515900",
        "lat": "46.206079",
        "long": "23.67533"
      },
      {
        "name": "TELEAC",
        "zip": "517246",
        "lat": "46.090613",
        "long": "23.631216"
      },
      {
        "name": "TELNA",
        "zip": "517364",
        "lat": "46.165453",
        "long": "23.496227"
      },
      {
        "name": "TIBRU",
        "zip": "517267",
        "lat": "46.196661",
        "long": "23.564062"
      },
      {
        "name": "TIFRA",
        "zip": "515210",
        "lat": "46.257702",
        "long": "23.692884"
      },
      {
        "name": "TIUR",
        "zip": "515407",
        "lat": "46.160088",
        "long": "23.88927"
      },
      {
        "name": "TOCI",
        "zip": "517734",
        "lat": "46.294387",
        "long": "22.97945"
      },
      {
        "name": "TOLACESTI",
        "zip": "517149",
        "lat": "46.352469",
        "long": "23.143341"
      },
      {
        "name": "TOMESTI",
        "zip": "517497",
        "lat": "46.29533",
        "long": "23.360399"
      },
      {
        "name": "TOMNATEC",
        "zip": "517151",
        "lat": "46.422966",
        "long": "23.074136"
      },
      {
        "name": "TOMUSESTI",
        "zip": "515518",
        "lat": "46.4524",
        "long": "23.014321"
      },
      {
        "name": "TOMUTESTI",
        "zip": "517806",
        "lat": "46.41083",
        "long": "22.925562"
      },
      {
        "name": "TONEA",
        "zip": "517669",
        "lat": "45.804144",
        "long": "23.53299"
      },
      {
        "name": "TOTESTI",
        "zip": "517807",
        "lat": "46.425788",
        "long": "22.92444"
      },
      {
        "name": "TOTOI",
        "zip": "517679",
        "lat": "46.113216",
        "long": "23.657414"
      },
      {
        "name": "TRAMPOIELE",
        "zip": "516116",
        "lat": "46.147814",
        "long": "23.150734"
      },
      {
        "name": "TRANCESTI",
        "zip": "517696",
        "lat": "46.477421",
        "long": "22.858938"
      },
      {
        "name": "TRIFESTI",
        "zip": "517356",
        "lat": "46.52614",
        "long": "22.930373"
      },
      {
        "name": "TRIFESTI",
        "zip": "517431",
        "lat": "46.321142",
        "long": "23.193808"
      },
      {
        "name": "TRISORESTI",
        "zip": "517152",
        "lat": "46.412665",
        "long": "23.131437"
      },
      {
        "name": "TURDAS",
        "zip": "517338",
        "lat": "46.306203",
        "long": "23.918409"
      },
      {
        "name": "UIOARA DE JOS",
        "zip": "515704",
        "lat": "46.371184",
        "long": "23.836438"
      },
      {
        "name": "UIOARA DE SUS",
        "zip": "515705",
        "lat": "46.3898",
        "long": "23.880079"
      },
      {
        "name": "UNGUREI",
        "zip": "517642",
        "lat": "46.016589",
        "long": "23.829033"
      },
      {
        "name": "UNIREA",
        "zip": "517785",
        "lat": "46.402188",
        "long": "23.811558"
      },
      {
        "name": "URDES",
        "zip": "517866",
        "lat": "46.371426",
        "long": "22.941302"
      },
      {
        "name": "VADU MOTILOR",
        "zip": "517795",
        "lat": "46.394267",
        "long": "22.965817"
      },
      {
        "name": "VAI",
        "zip": "517436",
        "lat": "46.348466",
        "long": "23.212832"
      },
      {
        "name": "VALCANEASA",
        "zip": "517869",
        "lat": "46.365184",
        "long": "22.935844"
      },
      {
        "name": "VALCEA",
        "zip": "517201",
        "lat": "46.266222",
        "long": "23.163649"
      },
      {
        "name": "VALCESTI",
        "zip": "517871",
        "lat": "46.379343",
        "long": "22.871693"
      },
      {
        "name": "VALE IN JOS",
        "zip": "517569",
        "lat": "46.349477",
        "long": "23.435538"
      },
      {
        "name": "VALEA ABRUZEL",
        "zip": "517192",
        "lat": "46.263853",
        "long": "23.136803"
      },
      {
        "name": "VALEA ALBA",
        "zip": "517193",
        "lat": "46.254107",
        "long": "23.208449"
      },
      {
        "name": "VALEA BARLUTESTI",
        "zip": "517499",
        "lat": "46.302625",
        "long": "23.265385"
      },
      {
        "name": "VALEA BARNII",
        "zip": "517498",
        "lat": "46.260071",
        "long": "23.329405"
      },
      {
        "name": "VALEA BISTRII",
        "zip": "515519",
        "lat": "46.379684",
        "long": "23.067192"
      },
      {
        "name": "VALEA BUCURULUI",
        "zip": "517571",
        "lat": "46.329336",
        "long": "23.373965"
      },
      {
        "name": "VALEA CASELOR",
        "zip": "515520",
        "lat": "46.398357",
        "long": "23.033616"
      },
      {
        "name": "VALEA CERBULUI",
        "zip": "517194",
        "lat": "46.239612",
        "long": "23.117765"
      },
      {
        "name": "VALEA CIUCIULUI",
        "zip": "517521",
        "lat": "46.407394",
        "long": "23.992016"
      },
      {
        "name": "VALEA COCESTI",
        "zip": "517501",
        "lat": "46.29665",
        "long": "23.288705"
      },
      {
        "name": "VALEA FAGETULUI",
        "zip": "517598",
        "lat": "46.337158",
        "long": "23.513075"
      },
      {
        "name": "VALEA GIOGESTI",
        "zip": "517502",
        "lat": "46.309533",
        "long": "23.281324"
      },
      {
        "name": "VALEA GOBLII",
        "zip": "517892",
        "lat": "46.003268",
        "long": "23.450948"
      },
      {
        "name": "VALEA HOLHORII",
        "zip": "517432",
        "lat": "46.319098",
        "long": "23.206561"
      },
      {
        "name": "VALEA INZELULUI",
        "zip": "517599",
        "lat": "46.332019",
        "long": "23.507123"
      },
      {
        "name": "VALEA LARGA",
        "zip": "517652",
        "lat": "46.366374",
        "long": "23.400712"
      },
      {
        "name": "VALEA LUI MIHAI",
        "zip": "517894",
        "lat": "46.024366",
        "long": "23.472853"
      },
      {
        "name": "VALEA LUNGA",
        "zip": "517815",
        "lat": "46.125924",
        "long": "24.045406"
      },
      {
        "name": "VALEA LUPSII",
        "zip": "517433",
        "lat": "46.38072",
        "long": "23.227533"
      },
      {
        "name": "VALEA MACIULUI",
        "zip": "517101",
        "lat": "46.338524",
        "long": "22.832316"
      },
      {
        "name": "VALEA MANASTIRII",
        "zip": "517601",
        "lat": "46.303271",
        "long": "23.510146"
      },
      {
        "name": "VALEA MARE",
        "zip": "517229",
        "lat": "46.018771",
        "long": "23.258104"
      },
      {
        "name": "VALEA MICA",
        "zip": "516117",
        "lat": "46.078955",
        "long": "23.277472"
      },
      {
        "name": "VALEA MLACII",
        "zip": "517503",
        "lat": "46.233143",
        "long": "23.276255"
      },
      {
        "name": "VALEA MORII",
        "zip": "517867",
        "lat": "46.358173",
        "long": "22.959488"
      },
      {
        "name": "VALEA NEGRILESII",
        "zip": "517196",
        "lat": "46.241652",
        "long": "23.216815"
      },
      {
        "name": "VALEA POIENII",
        "zip": "517197",
        "lat": "46.225205",
        "long": "23.142712"
      },
      {
        "name": "VALEA POIENII",
        "zip": "517602",
        "lat": "46.346038",
        "long": "23.472421"
      },
      {
        "name": "VALEA SASULUI",
        "zip": "517762",
        "lat": "46.28343",
        "long": "24.026927"
      },
      {
        "name": "VALEA SESII",
        "zip": "517198",
        "lat": "46.275449",
        "long": "23.180188"
      },
      {
        "name": "VALEA SESII",
        "zip": "517434",
        "lat": "46.380401",
        "long": "23.239731"
      },
      {
        "name": "VALEA TUPILOR",
        "zip": "517504",
        "lat": "46.265297",
        "long": "23.27036"
      },
      {
        "name": "VALEA UTULUI",
        "zip": "517102",
        "lat": "46.349653",
        "long": "22.822576"
      },
      {
        "name": "VALEA UZEI",
        "zip": "517603",
        "lat": "46.312873",
        "long": "23.510149"
      },
      {
        "name": "VALEA VERDE",
        "zip": "517736",
        "lat": "46.310353",
        "long": "22.956188"
      },
      {
        "name": "VALEA VINTULUI",
        "zip": "517893",
        "lat": "46.017638",
        "long": "23.455877"
      },
      {
        "name": "VALENI",
        "zip": "517199",
        "lat": "46.277643",
        "long": "23.156389"
      },
      {
        "name": "VALENI",
        "zip": "517458",
        "lat": "46.093008",
        "long": "23.427297"
      },
      {
        "name": "VALISOARA",
        "zip": "517393",
        "lat": "46.387439",
        "long": "23.562056"
      },
      {
        "name": "VALTORI",
        "zip": "516118",
        "lat": "46.145642",
        "long": "23.214694"
      },
      {
        "name": "VALTORI",
        "zip": "517808",
        "lat": "46.403814",
        "long": "22.939476"
      },
      {
        "name": "VAMA SEACA",
        "zip": "517339",
        "lat": "46.348792",
        "long": "23.936855"
      },
      {
        "name": "VANVUCESTI",
        "zip": "517061",
        "lat": "46.479731",
        "long": "22.722057"
      },
      {
        "name": "VARSI",
        "zip": "515521",
        "lat": "46.357385",
        "long": "23.074635"
      },
      {
        "name": "VARSI-RONTU",
        "zip": "517154",
        "lat": "46.347832",
        "long": "23.15801"
      },
      {
        "name": "VARSII MARI",
        "zip": "517156",
        "lat": "46.34302",
        "long": "23.130668"
      },
      {
        "name": "VARSII MICI",
        "zip": "517157",
        "lat": "46.346908",
        "long": "23.115969"
      },
      {
        "name": "VARTANESTI",
        "zip": "517872",
        "lat": "46.377835",
        "long": "22.930844"
      },
      {
        "name": "VARTOP",
        "zip": "517633",
        "lat": "46.324129",
        "long": "23.092245"
      },
      {
        "name": "VASESTI",
        "zip": "517868",
        "lat": "46.378226",
        "long": "22.902417"
      },
      {
        "name": "VERDESTI",
        "zip": "517103",
        "lat": "46.382322",
        "long": "22.791151"
      },
      {
        "name": "VESEUS",
        "zip": "517389",
        "lat": "46.275128",
        "long": "24.142501"
      },
      {
        "name": "VEZA",
        "zip": "515408",
        "lat": "46.167473",
        "long": "23.924701"
      },
      {
        "name": "VIDOLM",
        "zip": "517528",
        "lat": "46.479561",
        "long": "23.510586"
      },
      {
        "name": "VIDRA",
        "zip": "517825",
        "lat": "46.367815",
        "long": "22.888218"
      },
      {
        "name": "VIDRISOARA",
        "zip": "517104",
        "lat": "46.354671",
        "long": "22.841456"
      },
      {
        "name": "VIEZURI",
        "zip": "517231",
        "lat": "46.003431",
        "long": "23.293742"
      },
      {
        "name": "VINEREA",
        "zip": "515607",
        "lat": "45.886054",
        "long": "23.353044"
      },
      {
        "name": "VINGARD",
        "zip": "517771",
        "lat": "46.014617",
        "long": "23.742593"
      },
      {
        "name": "VINTA",
        "zip": "517437",
        "lat": "46.309787",
        "long": "23.227761"
      },
      {
        "name": "VINTU DE JOS",
        "zip": "517875",
        "lat": "45.994432",
        "long": "23.48557"
      },
      {
        "name": "VLADESTI",
        "zip": "517604",
        "lat": "46.306762",
        "long": "23.561457"
      },
      {
        "name": "VLADOSESTI",
        "zip": "517737",
        "lat": "46.348683",
        "long": "23.021843"
      },
      {
        "name": "VULCAN",
        "zip": "517259",
        "lat": "46.236575",
        "long": "22.974666"
      },
      {
        "name": "VURPAR",
        "zip": "517896",
        "lat": "46.00403",
        "long": "23.472674"
      },
      {
        "name": "ZAGRIS",
        "zip": "517297",
        "lat": "46.227993",
        "long": "23.541617"
      },
      {
        "name": "ZANZESTI",
        "zip": "517357",
        "lat": "46.533567",
        "long": "22.957146"
      },
      {
        "name": "ZARIES",
        "zip": "517468",
        "lat": "46.183543",
        "long": "23.705422"
      },
      {
        "name": "ZLATNA",
        "zip": "516100",
        "lat": "46.1114",
        "long": "23.224757"
      }
    ],
    "ARAD": [
      {
        "name": "ACIUTA",
        "zip": "317261",
        "lat": "46.289168",
        "long": "22.451404"
      },
      {
        "name": "ADEA",
        "zip": "317301",
        "lat": "46.555518",
        "long": "21.58097"
      },
      {
        "name": "AGRISU MARE",
        "zip": "317365",
        "lat": "46.271814",
        "long": "21.755622"
      },
      {
        "name": "AGRISU MIC",
        "zip": "317186",
        "lat": "46.527837",
        "long": "22.054823"
      },
      {
        "name": "ALDESTI",
        "zip": "317026",
        "lat": "46.391859",
        "long": "22.0402"
      },
      {
        "name": "ALMAS",
        "zip": "317005",
        "lat": "46.284598",
        "long": "22.234865"
      },
      {
        "name": "ALUNIS",
        "zip": "317121",
        "lat": "46.093845",
        "long": "21.490366"
      },
      {
        "name": "ANDREI SAGUNA",
        "zip": "317426",
        "lat": "46.286245",
        "long": "21.390056"
      },
      {
        "name": "APATEU",
        "zip": "317010",
        "lat": "46.622388",
        "long": "21.776894"
      },
      {
        "name": "ARAD",
        "zip": "310001",
        "lat": "46.175379",
        "long": "21.319634"
      },
      {
        "name": "ARANEAG",
        "zip": "317361",
        "lat": "46.252049",
        "long": "21.776151"
      },
      {
        "name": "ARCHIS",
        "zip": "317015",
        "lat": "46.477856",
        "long": "22.05282"
      },
      {
        "name": "AVRAM IANCU",
        "zip": "317076",
        "lat": "46.540269",
        "long": "21.916696"
      },
      {
        "name": "AVRAM IANCU",
        "zip": "317391",
        "lat": "46.330693",
        "long": "22.488676"
      },
      {
        "name": "BACAU DE MIJLOC",
        "zip": "317021",
        "lat": "45.976871",
        "long": "22.096587"
      },
      {
        "name": "BAIA",
        "zip": "317381",
        "lat": "46.09056",
        "long": "22.17307"
      },
      {
        "name": "BANESTI",
        "zip": "317161",
        "lat": "46.288914",
        "long": "22.60697"
      },
      {
        "name": "BARATCA",
        "zip": "317231",
        "lat": "46.107204",
        "long": "21.632272"
      },
      {
        "name": "BARSA",
        "zip": "317025",
        "lat": "46.377767",
        "long": "22.072503"
      },
      {
        "name": "BARZAVA",
        "zip": "317030",
        "lat": "46.106362",
        "long": "21.992566"
      },
      {
        "name": "BARZESTI",
        "zip": "317016",
        "lat": "46.485409",
        "long": "22.132464"
      },
      {
        "name": "BATA",
        "zip": "317020",
        "lat": "46.017034",
        "long": "22.037292"
      },
      {
        "name": "BATUTA",
        "zip": "317031",
        "lat": "46.050251",
        "long": "22.055259"
      },
      {
        "name": "BELIU",
        "zip": "317040",
        "lat": "46.493541",
        "long": "21.986444"
      },
      {
        "name": "BELOTINT",
        "zip": "317086",
        "lat": "46.076705",
        "long": "21.938392"
      },
      {
        "name": "BENESTI",
        "zip": "317041",
        "lat": "46.531287",
        "long": "22.003446"
      },
      {
        "name": "BERECHIU",
        "zip": "317011",
        "lat": "46.638939",
        "long": "21.84421"
      },
      {
        "name": "BERINDIA",
        "zip": "317066",
        "lat": "46.321022",
        "long": "22.160048"
      },
      {
        "name": "BIRCHIS",
        "zip": "317050",
        "lat": "45.96496",
        "long": "22.169987"
      },
      {
        "name": "BOCHIA",
        "zip": "317042",
        "lat": "46.545157",
        "long": "22.004415"
      },
      {
        "name": "BOCSIG",
        "zip": "317055",
        "lat": "46.422387",
        "long": "21.943296"
      },
      {
        "name": "BODESTI",
        "zip": "317162",
        "lat": "46.291656",
        "long": "22.579831"
      },
      {
        "name": "BODROGU NOU",
        "zip": "317126",
        "lat": "46.128116",
        "long": "21.197971"
      },
      {
        "name": "BODROGU VECHI",
        "zip": "317236",
        "lat": "46.138903",
        "long": "21.174656"
      },
      {
        "name": "BONTESTI",
        "zip": "317146",
        "lat": "46.274711",
        "long": "22.305694"
      },
      {
        "name": "BOTFEI",
        "zip": "317187",
        "lat": "46.547927",
        "long": "22.062745"
      },
      {
        "name": "BRAZII",
        "zip": "317060",
        "lat": "46.241284",
        "long": "22.335919"
      },
      {
        "name": "BRUSTURI",
        "zip": "317163",
        "lat": "46.345025",
        "long": "22.585512"
      },
      {
        "name": "BRUZNIC",
        "zip": "317376",
        "lat": "45.981276",
        "long": "21.892251"
      },
      {
        "name": "BUCEAVA-SOIMUS",
        "zip": "317061",
        "lat": "46.203136",
        "long": "22.342104"
      },
      {
        "name": "BUDESTI",
        "zip": "317262",
        "lat": "46.260463",
        "long": "22.445202"
      },
      {
        "name": "BUHANI",
        "zip": "317111",
        "lat": "46.406094",
        "long": "22.205362"
      },
      {
        "name": "BULCI",
        "zip": "317022",
        "lat": "46.003787",
        "long": "22.105248"
      },
      {
        "name": "BUTENI",
        "zip": "317065",
        "lat": "46.330894",
        "long": "22.119058"
      },
      {
        "name": "CALUGARENI",
        "zip": "317127",
        "lat": "46.12634",
        "long": "21.186249"
      },
      {
        "name": "CAMNA",
        "zip": "317331",
        "lat": "46.310535",
        "long": "21.94879"
      },
      {
        "name": "CAPALNAS",
        "zip": "317051",
        "lat": "45.974618",
        "long": "22.224027"
      },
      {
        "name": "CAPORAL ALEXA",
        "zip": "317281",
        "lat": "46.337932",
        "long": "21.58316"
      },
      {
        "name": "CAPRIOARA",
        "zip": "317271",
        "lat": "45.982372",
        "long": "22.277553"
      },
      {
        "name": "CAPRUTA",
        "zip": "317032",
        "lat": "46.088608",
        "long": "22.025219"
      },
      {
        "name": "CARAND",
        "zip": "317070",
        "lat": "46.445122",
        "long": "22.088593"
      },
      {
        "name": "CERMEI",
        "zip": "317075",
        "lat": "46.548317",
        "long": "21.845652"
      },
      {
        "name": "CHELMAC",
        "zip": "317087",
        "lat": "46.081797",
        "long": "21.884631"
      },
      {
        "name": "CHERELUS",
        "zip": "317326",
        "lat": "46.46521",
        "long": "21.705337"
      },
      {
        "name": "CHESINT",
        "zip": "317411",
        "lat": "46.053899",
        "long": "21.576302"
      },
      {
        "name": "CHIER",
        "zip": "317362",
        "lat": "46.341996",
        "long": "21.824886"
      },
      {
        "name": "CHISINDIA",
        "zip": "317080",
        "lat": "46.292268",
        "long": "22.099112"
      },
      {
        "name": "CHISINEU-CRIS",
        "zip": "315100",
        "lat": "46.524223",
        "long": "21.517932"
      },
      {
        "name": "CHISLACA",
        "zip": "317096",
        "lat": "46.554593",
        "long": "21.962045"
      },
      {
        "name": "CICIR",
        "zip": "317406",
        "lat": "46.145258",
        "long": "21.48074"
      },
      {
        "name": "CIL",
        "zip": "317006",
        "lat": "46.283092",
        "long": "22.263366"
      },
      {
        "name": "CINTEI",
        "zip": "317416",
        "lat": "46.443814",
        "long": "21.564238"
      },
      {
        "name": "CIUNTESTI",
        "zip": "317097",
        "lat": "46.625101",
        "long": "22.041703"
      },
      {
        "name": "CLADOVA",
        "zip": "317232",
        "lat": "46.135799",
        "long": "21.655893"
      },
      {
        "name": "CLIT",
        "zip": "317188",
        "lat": "46.514328",
        "long": "22.092696"
      },
      {
        "name": "COCIUBA",
        "zip": "317116",
        "lat": "46.306463",
        "long": "22.179154"
      },
      {
        "name": "COMANESTI",
        "zip": "317189",
        "lat": "46.510073",
        "long": "22.044488"
      },
      {
        "name": "CONOP",
        "zip": "317085",
        "lat": "46.10056",
        "long": "21.878658"
      },
      {
        "name": "CORBESTI",
        "zip": "317246",
        "lat": "46.073881",
        "long": "22.389103"
      },
      {
        "name": "COROI",
        "zip": "317098",
        "lat": "46.591853",
        "long": "21.953666"
      },
      {
        "name": "COVASANT",
        "zip": "317090",
        "lat": "46.206131",
        "long": "21.613105"
      },
      {
        "name": "CRAIVA",
        "zip": "317095",
        "lat": "46.582539",
        "long": "21.973701"
      },
      {
        "name": "CRISTESTI",
        "zip": "317164",
        "lat": "46.30135",
        "long": "22.596079"
      },
      {
        "name": "CROCNA",
        "zip": "317117",
        "lat": "46.327135",
        "long": "22.295174"
      },
      {
        "name": "CRUCENI",
        "zip": "317311",
        "lat": "46.067933",
        "long": "21.332179"
      },
      {
        "name": "CUIAS",
        "zip": "317272",
        "lat": "46.002153",
        "long": "22.293409"
      },
      {
        "name": "CUIED",
        "zip": "317067",
        "lat": "46.337979",
        "long": "22.017433"
      },
      {
        "name": "CURTICI",
        "zip": "315200",
        "lat": "46.340587",
        "long": "21.310495"
      },
      {
        "name": "CUVESDIA",
        "zip": "317346",
        "lat": "45.952747",
        "long": "21.679935"
      },
      {
        "name": "CUVIN",
        "zip": "317136",
        "lat": "46.166392",
        "long": "21.595005"
      },
      {
        "name": "DEZNA",
        "zip": "317110",
        "lat": "46.406523",
        "long": "22.245413"
      },
      {
        "name": "DIECI",
        "zip": "317115",
        "lat": "46.316274",
        "long": "22.248324"
      },
      {
        "name": "DONCENI",
        "zip": "315701",
        "lat": "46.390698",
        "long": "22.174236"
      },
      {
        "name": "DORGOS",
        "zip": "317377",
        "lat": "46.050047",
        "long": "21.835639"
      },
      {
        "name": "DOROBANTI",
        "zip": "315201",
        "lat": "46.349971",
        "long": "21.242634"
      },
      {
        "name": "DRAUT",
        "zip": "317363",
        "lat": "46.261106",
        "long": "21.807584"
      },
      {
        "name": "DUD",
        "zip": "317364",
        "lat": "46.298181",
        "long": "21.857255"
      },
      {
        "name": "DULCELE",
        "zip": "317147",
        "lat": "46.354606",
        "long": "22.364928"
      },
      {
        "name": "DUMBRAVA",
        "zip": "317263",
        "lat": "46.277713",
        "long": "22.430462"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "317033",
        "lat": "46.095396",
        "long": "22.083108"
      },
      {
        "name": "FANTANELE",
        "zip": "317120",
        "lat": "46.124407",
        "long": "21.381111"
      },
      {
        "name": "FELNAC",
        "zip": "317125",
        "lat": "46.116664",
        "long": "21.150009"
      },
      {
        "name": "FENIS",
        "zip": "317148",
        "lat": "46.296695",
        "long": "22.333653"
      },
      {
        "name": "FIRITEAZ",
        "zip": "317312",
        "lat": "46.018232",
        "long": "21.372878"
      },
      {
        "name": "FISCUT",
        "zip": "317313",
        "lat": "46.029932",
        "long": "21.392874"
      },
      {
        "name": "FRUMUSENI",
        "zip": "317122",
        "lat": "46.101856",
        "long": "21.460316"
      },
      {
        "name": "GALSA",
        "zip": "317341",
        "lat": "46.288101",
        "long": "21.651342"
      },
      {
        "name": "GHIOROC",
        "zip": "317135",
        "lat": "46.155884",
        "long": "21.595441"
      },
      {
        "name": "GRANICERI",
        "zip": "317140",
        "lat": "46.519768",
        "long": "21.304422"
      },
      {
        "name": "GROSENI",
        "zip": "317017",
        "lat": "46.497624",
        "long": "22.1183"
      },
      {
        "name": "GROSI",
        "zip": "317392",
        "lat": "46.37266",
        "long": "22.546773"
      },
      {
        "name": "GROSII NOI",
        "zip": "317034",
        "lat": "46.119711",
        "long": "22.120025"
      },
      {
        "name": "GURA VAII",
        "zip": "317264",
        "lat": "46.292692",
        "long": "22.394758"
      },
      {
        "name": "GURAHONT",
        "zip": "317145",
        "lat": "46.269891",
        "long": "22.342091"
      },
      {
        "name": "GURBA",
        "zip": "317327",
        "lat": "46.467564",
        "long": "21.787866"
      },
      {
        "name": "HALALIS",
        "zip": "317273",
        "lat": "46.009451",
        "long": "22.204332"
      },
      {
        "name": "HALMAGEL",
        "zip": "317180",
        "lat": "46.270378",
        "long": "22.61842"
      },
      {
        "name": "HALMAGIU",
        "zip": "317160",
        "lat": "46.263473",
        "long": "22.58744"
      },
      {
        "name": "HASMAS",
        "zip": "317185",
        "lat": "46.503869",
        "long": "22.077439"
      },
      {
        "name": "HODIS",
        "zip": "317027",
        "lat": "46.35938",
        "long": "22.029198"
      },
      {
        "name": "HONTISOR",
        "zip": "317149",
        "lat": "46.253195",
        "long": "22.340326"
      },
      {
        "name": "HORIA",
        "zip": "317407",
        "lat": "46.208573",
        "long": "21.459892"
      },
      {
        "name": "HUNEDOARA TIMISANA",
        "zip": "317314",
        "lat": "46.030723",
        "long": "21.320472"
      },
      {
        "name": "IACOBINI",
        "zip": "317062",
        "lat": "46.23155",
        "long": "22.341966"
      },
      {
        "name": "IERCOSENI",
        "zip": "317332",
        "lat": "46.346736",
        "long": "21.978059"
      },
      {
        "name": "IERMATA",
        "zip": "317291",
        "lat": "46.383865",
        "long": "21.768772"
      },
      {
        "name": "IERMATA NEAGRA",
        "zip": "317421",
        "lat": "46.637228",
        "long": "21.499127"
      },
      {
        "name": "IGNESTI",
        "zip": "317195",
        "lat": "46.40992",
        "long": "22.169568"
      },
      {
        "name": "ILTEU",
        "zip": "317247",
        "lat": "46.016571",
        "long": "22.359424"
      },
      {
        "name": "INEU",
        "zip": "315300",
        "lat": "46.425991",
        "long": "21.841691"
      },
      {
        "name": "IONESTI",
        "zip": "317166",
        "lat": "46.234958",
        "long": "22.556282"
      },
      {
        "name": "IOSAS",
        "zip": "317151",
        "lat": "46.283578",
        "long": "22.335457"
      },
      {
        "name": "IRATOSU",
        "zip": "317200",
        "lat": "46.317332",
        "long": "21.206944"
      },
      {
        "name": "JOIA MARE",
        "zip": "317007",
        "lat": "46.299893",
        "long": "22.178019"
      },
      {
        "name": "JULITA",
        "zip": "317382",
        "lat": "46.038802",
        "long": "22.134047"
      },
      {
        "name": "LABASINT",
        "zip": "317347",
        "lat": "45.960967",
        "long": "21.789147"
      },
      {
        "name": "LALASINT",
        "zip": "317036",
        "lat": "46.07178",
        "long": "22.004504"
      },
      {
        "name": "LAZ",
        "zip": "317112",
        "lat": "46.370302",
        "long": "22.25006"
      },
      {
        "name": "LAZURI",
        "zip": "317393",
        "lat": "46.342801",
        "long": "22.55962"
      },
      {
        "name": "LEASA",
        "zip": "317167",
        "lat": "46.274275",
        "long": "22.543757"
      },
      {
        "name": "LESTIOARA",
        "zip": "317168",
        "lat": "46.280011",
        "long": "22.562481"
      },
      {
        "name": "LIPOVA",
        "zip": "315400",
        "lat": "46.093465",
        "long": "21.699811"
      },
      {
        "name": "LIVADA",
        "zip": "317205",
        "lat": "46.225984",
        "long": "21.386249"
      },
      {
        "name": "LUGUZAU",
        "zip": "317333",
        "lat": "46.332607",
        "long": "21.937037"
      },
      {
        "name": "LUNCSOARA",
        "zip": "317181",
        "lat": "46.321682",
        "long": "22.626533"
      },
      {
        "name": "LUPESTI",
        "zip": "317383",
        "lat": "46.06938",
        "long": "22.218878"
      },
      {
        "name": "MACEA",
        "zip": "317210",
        "lat": "46.386817",
        "long": "21.310918"
      },
      {
        "name": "MADERAT",
        "zip": "315601",
        "lat": "46.299158",
        "long": "21.712257"
      },
      {
        "name": "MADRIGESTI",
        "zip": "317063",
        "lat": "46.203193",
        "long": "22.30387"
      },
      {
        "name": "MAGULICEA",
        "zip": "317394",
        "lat": "46.329472",
        "long": "22.541554"
      },
      {
        "name": "MAILAT",
        "zip": "317401",
        "lat": "46.044074",
        "long": "21.106529"
      },
      {
        "name": "MANASTUR",
        "zip": "317402",
        "lat": "46.008979",
        "long": "21.132751"
      },
      {
        "name": "MANDRULOC",
        "zip": "317408",
        "lat": "46.147055",
        "long": "21.464251"
      },
      {
        "name": "MANERAU",
        "zip": "317056",
        "lat": "46.415967",
        "long": "21.98683"
      },
      {
        "name": "MARAUS",
        "zip": "317099",
        "lat": "46.594403",
        "long": "22.034298"
      },
      {
        "name": "MASCA",
        "zip": "317342",
        "lat": "46.29669",
        "long": "21.671465"
      },
      {
        "name": "MERMESTI",
        "zip": "317396",
        "lat": "46.310507",
        "long": "22.563468"
      },
      {
        "name": "MILOVA",
        "zip": "317088",
        "lat": "46.108387",
        "long": "21.800238"
      },
      {
        "name": "MINEAD",
        "zip": "317196",
        "lat": "46.416934",
        "long": "22.187231"
      },
      {
        "name": "MINIS",
        "zip": "317137",
        "lat": "46.135019",
        "long": "21.604521"
      },
      {
        "name": "MINISEL",
        "zip": "317356",
        "lat": "46.257581",
        "long": "21.995366"
      },
      {
        "name": "MINISU DE SUS",
        "zip": "317357",
        "lat": "46.281931",
        "long": "22.009124"
      },
      {
        "name": "MISCA",
        "zip": "317215",
        "lat": "46.60113",
        "long": "21.59918"
      },
      {
        "name": "MOCREA",
        "zip": "315301",
        "lat": "46.387921",
        "long": "21.820478"
      },
      {
        "name": "MONEASA",
        "zip": "317220",
        "lat": "46.457897",
        "long": "22.251827"
      },
      {
        "name": "MONOROSTIA",
        "zip": "317037",
        "lat": "46.10476",
        "long": "22.013779"
      },
      {
        "name": "MORODA",
        "zip": "317292",
        "lat": "46.371352",
        "long": "21.759661"
      },
      {
        "name": "MOTIORI",
        "zip": "317012",
        "lat": "46.615807",
        "long": "21.851341"
      },
      {
        "name": "MUNAR",
        "zip": "317286",
        "lat": "46.103534",
        "long": "21.019532"
      },
      {
        "name": "MUSTESTI",
        "zip": "317152",
        "lat": "46.237137",
        "long": "22.263583"
      },
      {
        "name": "NADAB",
        "zip": "315101",
        "lat": "46.481807",
        "long": "21.509884"
      },
      {
        "name": "NADALBESTI",
        "zip": "317197",
        "lat": "46.454106",
        "long": "22.193724"
      },
      {
        "name": "NADAS",
        "zip": "317358",
        "lat": "46.224172",
        "long": "21.947996"
      },
      {
        "name": "NADLAC",
        "zip": "315500",
        "lat": "46.166681",
        "long": "20.749992"
      },
      {
        "name": "NEAGRA",
        "zip": "317113",
        "lat": "46.434775",
        "long": "22.208644"
      },
      {
        "name": "NERMIS",
        "zip": "317018",
        "lat": "46.472522",
        "long": "22.082929"
      },
      {
        "name": "NEUDORF",
        "zip": "317412",
        "lat": "46.070482",
        "long": "21.617556"
      },
      {
        "name": "NICOLAE BALCESCU",
        "zip": "317384",
        "lat": "46.033412",
        "long": "22.093358"
      },
      {
        "name": "OBARSIA",
        "zip": "317248",
        "lat": "46.135659",
        "long": "22.437782"
      },
      {
        "name": "ODVOS",
        "zip": "317089",
        "lat": "46.109038",
        "long": "21.820939"
      },
      {
        "name": "OLARI",
        "zip": "317225",
        "lat": "46.384678",
        "long": "21.548097"
      },
      {
        "name": "OSTROV",
        "zip": "317052",
        "lat": "45.972166",
        "long": "22.134243"
      },
      {
        "name": "PAIUSENI",
        "zip": "317081",
        "lat": "46.249298",
        "long": "22.094379"
      },
      {
        "name": "PANCOTA",
        "zip": "315600",
        "lat": "46.327537",
        "long": "21.689609"
      },
      {
        "name": "PARNESTI",
        "zip": "317274",
        "lat": "46.071911",
        "long": "22.243162"
      },
      {
        "name": "PATARS",
        "zip": "317378",
        "lat": "45.997737",
        "long": "21.852113"
      },
      {
        "name": "PAULIAN",
        "zip": "317068",
        "lat": "46.334722",
        "long": "22.157521"
      },
      {
        "name": "PAULIS",
        "zip": "317230",
        "lat": "46.116895",
        "long": "21.592834"
      },
      {
        "name": "PECICA",
        "zip": "317235",
        "lat": "46.166679",
        "long": "21.066681"
      },
      {
        "name": "PEREGU MARE",
        "zip": "317240",
        "lat": "46.23175",
        "long": "20.908152"
      },
      {
        "name": "PEREGU MIC",
        "zip": "317241",
        "lat": "46.250091",
        "long": "20.946046"
      },
      {
        "name": "PESCARI",
        "zip": "317153",
        "lat": "46.296718",
        "long": "22.309291"
      },
      {
        "name": "PETRIS",
        "zip": "317245",
        "lat": "46.042801",
        "long": "22.391273"
      },
      {
        "name": "PILU",
        "zip": "317255",
        "lat": "46.575505",
        "long": "21.344244"
      },
      {
        "name": "PLESCUTA",
        "zip": "317260",
        "lat": "46.301592",
        "long": "22.424421"
      },
      {
        "name": "POIANA",
        "zip": "317397",
        "lat": "46.360503",
        "long": "22.443092"
      },
      {
        "name": "POIENARI",
        "zip": "317169",
        "lat": "46.239545",
        "long": "22.600059"
      },
      {
        "name": "PRUNISOR",
        "zip": "315702",
        "lat": "46.418955",
        "long": "22.120467"
      },
      {
        "name": "RADESTI",
        "zip": "317008",
        "lat": "46.27055",
        "long": "22.251511"
      },
      {
        "name": "RADNA",
        "zip": "315401",
        "lat": "46.098418",
        "long": "21.689476"
      },
      {
        "name": "RANUSA",
        "zip": "317221",
        "lat": "46.430961",
        "long": "22.254634"
      },
      {
        "name": "RAPSIG",
        "zip": "317057",
        "lat": "46.420217",
        "long": "22.019413"
      },
      {
        "name": "REVETIS",
        "zip": "317118",
        "lat": "46.313384",
        "long": "22.19532"
      },
      {
        "name": "ROGOZ DE BELIU",
        "zip": "317101",
        "lat": "46.605902",
        "long": "22.002842"
      },
      {
        "name": "ROSIA",
        "zip": "317119",
        "lat": "46.337573",
        "long": "22.195412"
      },
      {
        "name": "ROSIA NOUA",
        "zip": "317249",
        "lat": "46.114865",
        "long": "22.400635"
      },
      {
        "name": "ROSTOCI",
        "zip": "317266",
        "lat": "46.285616",
        "long": "22.399053"
      },
      {
        "name": "SAGU",
        "zip": "317310",
        "lat": "46.063358",
        "long": "21.281419"
      },
      {
        "name": "SALAJENI",
        "zip": "315703",
        "lat": "46.367415",
        "long": "22.186531"
      },
      {
        "name": "SAMBATENI",
        "zip": "317233",
        "lat": "46.141105",
        "long": "21.526866"
      },
      {
        "name": "SANLEANI",
        "zip": "317206",
        "lat": "46.212493",
        "long": "21.388687"
      },
      {
        "name": "SANMARTIN",
        "zip": "317211",
        "lat": "46.416531",
        "long": "21.348214"
      },
      {
        "name": "SANPAUL",
        "zip": "317351",
        "lat": "46.258354",
        "long": "21.266728"
      },
      {
        "name": "SANPETRU GERMAN",
        "zip": "317288",
        "lat": "46.114863",
        "long": "21.049056"
      },
      {
        "name": "SANTANA",
        "zip": "317280",
        "lat": "46.34466",
        "long": "21.511867"
      },
      {
        "name": "SARBI",
        "zip": "317182",
        "lat": "46.286331",
        "long": "22.643001"
      },
      {
        "name": "SATU MARE",
        "zip": "317287",
        "lat": "46.066941",
        "long": "20.957475"
      },
      {
        "name": "SATU MIC",
        "zip": "317334",
        "lat": "46.35045",
        "long": "21.895289"
      },
      {
        "name": "SATU NOU",
        "zip": "317216",
        "lat": "46.622681",
        "long": "21.702797"
      },
      {
        "name": "SAVARSIN",
        "zip": "317270",
        "lat": "46.01398",
        "long": "22.234845"
      },
      {
        "name": "SEBIS",
        "zip": "315700",
        "lat": "46.373377",
        "long": "22.130024"
      },
      {
        "name": "SECACI",
        "zip": "317043",
        "lat": "46.572937",
        "long": "22.037838"
      },
      {
        "name": "SECAS",
        "zip": "317064",
        "lat": "46.228939",
        "long": "22.304609"
      },
      {
        "name": "SECUSIGIU",
        "zip": "317285",
        "lat": "46.087896",
        "long": "20.984234"
      },
      {
        "name": "SEDERHAT",
        "zip": "317237",
        "lat": "46.214036",
        "long": "21.156902"
      },
      {
        "name": "SEITIN",
        "zip": "317315",
        "lat": "46.109098",
        "long": "20.839887"
      },
      {
        "name": "SELEUS",
        "zip": "317290",
        "lat": "46.384309",
        "long": "21.708791"
      },
      {
        "name": "SELISTE",
        "zip": "317251",
        "lat": "46.029239",
        "long": "22.387791"
      },
      {
        "name": "SELISTEA",
        "zip": "317071",
        "lat": "46.465898",
        "long": "22.026511"
      },
      {
        "name": "SEMLAC",
        "zip": "317295",
        "lat": "46.112125",
        "long": "20.930413"
      },
      {
        "name": "SEPREUS",
        "zip": "317320",
        "lat": "46.571249",
        "long": "21.734175"
      },
      {
        "name": "SIAD",
        "zip": "317104",
        "lat": "46.605347",
        "long": "21.989246"
      },
      {
        "name": "SICLAU",
        "zip": "317141",
        "lat": "46.490297",
        "long": "21.366579"
      },
      {
        "name": "SICULA",
        "zip": "317325",
        "lat": "46.435544",
        "long": "21.759161"
      },
      {
        "name": "SILINDIA",
        "zip": "317330",
        "lat": "46.339561",
        "long": "21.916102"
      },
      {
        "name": "SIMAND",
        "zip": "317335",
        "lat": "46.428594",
        "long": "21.454748"
      },
      {
        "name": "SINTEA MARE",
        "zip": "317300",
        "lat": "46.519804",
        "long": "21.605318"
      },
      {
        "name": "SINTEA MICA",
        "zip": "317226",
        "lat": "46.412926",
        "long": "21.602982"
      },
      {
        "name": "SIRIA",
        "zip": "317340",
        "lat": "46.267305",
        "long": "21.638563"
      },
      {
        "name": "SISTAROVAT",
        "zip": "317345",
        "lat": "46.010478",
        "long": "21.743207"
      },
      {
        "name": "SLATINA DE CRIS",
        "zip": "317114",
        "lat": "46.432534",
        "long": "22.228324"
      },
      {
        "name": "SLATINA DE MURES",
        "zip": "317038",
        "lat": "46.153298",
        "long": "22.179327"
      },
      {
        "name": "SOCODOR",
        "zip": "317305",
        "lat": "46.510103",
        "long": "21.441258"
      },
      {
        "name": "SOFRONEA",
        "zip": "317350",
        "lat": "46.278438",
        "long": "21.315556"
      },
      {
        "name": "SOIMOS",
        "zip": "315402",
        "lat": "46.106481",
        "long": "21.718107"
      },
      {
        "name": "SOMOSCHES",
        "zip": "317077",
        "lat": "46.572583",
        "long": "21.845211"
      },
      {
        "name": "STEJAR",
        "zip": "317386",
        "lat": "46.034429",
        "long": "22.155362"
      },
      {
        "name": "STOINESTI",
        "zip": "317102",
        "lat": "46.610073",
        "long": "22.023498"
      },
      {
        "name": "SUSAG",
        "zip": "317103",
        "lat": "46.614001",
        "long": "21.921246"
      },
      {
        "name": "SUSANI",
        "zip": "317198",
        "lat": "46.454561",
        "long": "22.178542"
      },
      {
        "name": "TAGADAU",
        "zip": "317044",
        "lat": "46.508948",
        "long": "22.004199"
      },
      {
        "name": "TALAGIU",
        "zip": "317267",
        "lat": "46.276871",
        "long": "22.478232"
      },
      {
        "name": "TALMACI",
        "zip": "317106",
        "lat": "46.610054",
        "long": "21.889999"
      },
      {
        "name": "TARMURE",
        "zip": "317172",
        "lat": "46.248034",
        "long": "22.566977"
      },
      {
        "name": "TARNAVITA",
        "zip": "317183",
        "lat": "46.255121",
        "long": "22.649529"
      },
      {
        "name": "TARNOVA",
        "zip": "317360",
        "lat": "46.319218",
        "long": "21.795945"
      },
      {
        "name": "TAUT",
        "zip": "317355",
        "lat": "46.293884",
        "long": "21.911767"
      },
      {
        "name": "TELA",
        "zip": "317023",
        "lat": "45.987234",
        "long": "22.068546"
      },
      {
        "name": "TEMESESTI",
        "zip": "317276",
        "lat": "46.052128",
        "long": "22.272609"
      },
      {
        "name": "TIPAR",
        "zip": "317302",
        "lat": "46.475859",
        "long": "21.632892"
      },
      {
        "name": "TISA",
        "zip": "317171",
        "lat": "46.258554",
        "long": "22.548612"
      },
      {
        "name": "TISA NOUA",
        "zip": "317123",
        "lat": "46.082573",
        "long": "21.373958"
      },
      {
        "name": "TOC",
        "zip": "317277",
        "lat": "46.013966",
        "long": "22.316496"
      },
      {
        "name": "TOHESTI",
        "zip": "317184",
        "lat": "46.249052",
        "long": "22.614837"
      },
      {
        "name": "TROAS",
        "zip": "317278",
        "lat": "46.098204",
        "long": "22.295528"
      },
      {
        "name": "TURNU",
        "zip": "317238",
        "lat": "46.256898",
        "long": "21.126108"
      },
      {
        "name": "URVISU DE BELIU",
        "zip": "317191",
        "lat": "46.52657",
        "long": "22.08632"
      },
      {
        "name": "USUSAU",
        "zip": "317375",
        "lat": "46.070628",
        "long": "21.813712"
      },
      {
        "name": "VALEA MARE",
        "zip": "317154",
        "lat": "46.320751",
        "long": "22.358447"
      },
      {
        "name": "VALEA MARE",
        "zip": "317279",
        "lat": "45.990038",
        "long": "22.238391"
      },
      {
        "name": "VANATORI",
        "zip": "317217",
        "lat": "46.624231",
        "long": "21.671756"
      },
      {
        "name": "VARADIA DE MURES",
        "zip": "317380",
        "lat": "46.011563",
        "long": "22.158235"
      },
      {
        "name": "VARFURILE",
        "zip": "317390",
        "lat": "46.305819",
        "long": "22.524944"
      },
      {
        "name": "VARIASU MARE",
        "zip": "317201",
        "lat": "46.275977",
        "long": "21.17281"
      },
      {
        "name": "VARIASU MIC",
        "zip": "317202",
        "lat": "46.293336",
        "long": "21.182774"
      },
      {
        "name": "VARNITA",
        "zip": "317348",
        "lat": "46.022542",
        "long": "21.806531"
      },
      {
        "name": "VARSAND",
        "zip": "317256",
        "lat": "46.61758",
        "long": "21.344894"
      },
      {
        "name": "VASILE GOLDIS",
        "zip": "317046",
        "lat": "46.525084",
        "long": "21.935322"
      },
      {
        "name": "VASOAIA",
        "zip": "317082",
        "lat": "46.24436",
        "long": "22.062298"
      },
      {
        "name": "VIDRA",
        "zip": "317398",
        "lat": "46.328748",
        "long": "22.512209"
      },
      {
        "name": "VINGA",
        "zip": "317400",
        "lat": "46.016185",
        "long": "21.215725"
      },
      {
        "name": "VIRISMORT",
        "zip": "317053",
        "lat": "45.967138",
        "long": "22.145063"
      },
      {
        "name": "VLADIMIRESCU",
        "zip": "317405",
        "lat": "46.163829",
        "long": "21.406381"
      },
      {
        "name": "VOIVODENI",
        "zip": "317028",
        "lat": "46.399294",
        "long": "22.030748"
      },
      {
        "name": "ZABALT",
        "zip": "317379",
        "lat": "46.008181",
        "long": "21.922396"
      },
      {
        "name": "ZABRANI",
        "zip": "317410",
        "lat": "46.070697",
        "long": "21.555194"
      },
      {
        "name": "ZADARENI",
        "zip": "317130",
        "lat": "46.132313",
        "long": "21.21901"
      },
      {
        "name": "ZARAND",
        "zip": "317415",
        "lat": "46.406919",
        "long": "21.650753"
      },
      {
        "name": "ZERIND",
        "zip": "317420",
        "lat": "46.623519",
        "long": "21.516982"
      },
      {
        "name": "ZERINDU MIC",
        "zip": "317218",
        "lat": "46.63234",
        "long": "21.636489"
      },
      {
        "name": "ZIMANDCUZ",
        "zip": "317427",
        "lat": "46.255687",
        "long": "21.382858"
      },
      {
        "name": "ZIMANDU NOU",
        "zip": "317425",
        "lat": "46.281083",
        "long": "21.400218"
      },
      {
        "name": "ZIMBRU",
        "zip": "317156",
        "lat": "46.335458",
        "long": "22.387161"
      }
    ],
    "ARGEȘ": [
      {
        "name": "ADUNATI",
        "zip": "117591",
        "lat": "44.451971",
        "long": "25.029325"
      },
      {
        "name": "AFRIMESTI",
        "zip": "117091",
        "lat": "44.47973",
        "long": "24.765754"
      },
      {
        "name": "ALBESTI",
        "zip": "117026",
        "lat": "45.311883",
        "long": "25.002747"
      },
      {
        "name": "ALBESTII PAMANTENI",
        "zip": "117010",
        "lat": "45.210469",
        "long": "24.664084"
      },
      {
        "name": "ALBESTII UNGURENI",
        "zip": "117006",
        "lat": "45.223117",
        "long": "24.670225"
      },
      {
        "name": "ALBOTA",
        "zip": "117030",
        "lat": "44.780792",
        "long": "24.848342"
      },
      {
        "name": "ALBOTELE",
        "zip": "117601",
        "lat": "44.892822",
        "long": "25.084145"
      },
      {
        "name": "ALUNIS",
        "zip": "117481",
        "lat": "45.234325",
        "long": "25.138072"
      },
      {
        "name": "ALUNISU",
        "zip": "117066",
        "lat": "45.06669",
        "long": "24.595514"
      },
      {
        "name": "ALUNISU",
        "zip": "117146",
        "lat": "45.294622",
        "long": "24.773107"
      },
      {
        "name": "ANGHINESTI",
        "zip": "117067",
        "lat": "45.073317",
        "long": "24.665273"
      },
      {
        "name": "ANINOASA",
        "zip": "117035",
        "lat": "45.192251",
        "long": "24.926841"
      },
      {
        "name": "AREFU",
        "zip": "117040",
        "lat": "45.329963",
        "long": "24.609821"
      },
      {
        "name": "ARGESANI",
        "zip": "117068",
        "lat": "45.059128",
        "long": "24.705787"
      },
      {
        "name": "ARGESELU",
        "zip": "117451",
        "lat": "44.927402",
        "long": "24.871147"
      },
      {
        "name": "BABANA",
        "zip": "117055",
        "lat": "44.869085",
        "long": "24.708302"
      },
      {
        "name": "BABAROAGA",
        "zip": "117516",
        "lat": "44.54735",
        "long": "25.193155"
      },
      {
        "name": "BACESTI",
        "zip": "117381",
        "lat": "44.940224",
        "long": "24.686057"
      },
      {
        "name": "BADENI",
        "zip": "117676",
        "lat": "45.240633",
        "long": "25.179958"
      },
      {
        "name": "BADESTI",
        "zip": "117092",
        "lat": "44.393493",
        "long": "24.760541"
      },
      {
        "name": "BADESTI",
        "zip": "117551",
        "lat": "45.17157",
        "long": "24.860643"
      },
      {
        "name": "BADICEA",
        "zip": "117816",
        "lat": "44.754151",
        "long": "24.695859"
      },
      {
        "name": "BADILA",
        "zip": "117796",
        "lat": "45.201936",
        "long": "24.707696"
      },
      {
        "name": "BADISLAVA",
        "zip": "117741",
        "lat": "45.155548",
        "long": "24.515854"
      },
      {
        "name": "BADULESTI",
        "zip": "117756",
        "lat": "44.822981",
        "long": "24.570021"
      },
      {
        "name": "BAICULESTI",
        "zip": "117065",
        "lat": "45.071762",
        "long": "24.688106"
      },
      {
        "name": "BAILA",
        "zip": "117412",
        "lat": "44.803252",
        "long": "25.137018"
      },
      {
        "name": "BAJANESTI",
        "zip": "117056",
        "lat": "44.859427",
        "long": "24.710662"
      },
      {
        "name": "BAJESTI",
        "zip": "117081",
        "lat": "45.026152",
        "long": "24.942334"
      },
      {
        "name": "BALABANI",
        "zip": "117131",
        "lat": "45.154524",
        "long": "25.137187"
      },
      {
        "name": "BALILESTI",
        "zip": "117080",
        "lat": "45.062429",
        "long": "24.941383"
      },
      {
        "name": "BALILESTI",
        "zip": "117742",
        "lat": "45.141789",
        "long": "24.53534"
      },
      {
        "name": "BALOTEASCA",
        "zip": "117411",
        "lat": "44.757343",
        "long": "25.169484"
      },
      {
        "name": "BALTATA",
        "zip": "117331",
        "lat": "44.962266",
        "long": "24.506056"
      },
      {
        "name": "BALTENI",
        "zip": "117743",
        "lat": "45.148329",
        "long": "24.563624"
      },
      {
        "name": "BANARESTI",
        "zip": "117641",
        "lat": "44.730442",
        "long": "24.760665"
      },
      {
        "name": "BANICESTI",
        "zip": "117791",
        "lat": "45.190872",
        "long": "24.607396"
      },
      {
        "name": "BANTAU",
        "zip": "117413",
        "lat": "44.818827",
        "long": "25.186614"
      },
      {
        "name": "BARANESTI",
        "zip": "117757",
        "lat": "44.852634",
        "long": "24.577313"
      },
      {
        "name": "BARASTI",
        "zip": "117246",
        "lat": "45.253379",
        "long": "24.596543"
      },
      {
        "name": "BARBALANI",
        "zip": "117332",
        "lat": "44.904425",
        "long": "24.511349"
      },
      {
        "name": "BARBALATESTI",
        "zip": "117797",
        "lat": "45.200465",
        "long": "24.725765"
      },
      {
        "name": "BARBATESTI",
        "zip": "117266",
        "lat": "44.910758",
        "long": "24.631393"
      },
      {
        "name": "BARLA",
        "zip": "117090",
        "lat": "44.427101",
        "long": "24.779671"
      },
      {
        "name": "BARLOGU",
        "zip": "117536",
        "lat": "44.626576",
        "long": "25.080655"
      },
      {
        "name": "BARLOI",
        "zip": "117121",
        "lat": "44.883588",
        "long": "25.135402"
      },
      {
        "name": "BARSESTII DE JOS",
        "zip": "117744",
        "lat": "45.174298",
        "long": "24.560978"
      },
      {
        "name": "BARSESTII DE SUS",
        "zip": "117746",
        "lat": "45.17573",
        "long": "24.546084"
      },
      {
        "name": "BARZESTI",
        "zip": "117396",
        "lat": "45.04592",
        "long": "25.07909"
      },
      {
        "name": "BASCOV",
        "zip": "117045",
        "lat": "44.897692",
        "long": "24.816355"
      },
      {
        "name": "BASCOVELE",
        "zip": "117306",
        "lat": "45.010945",
        "long": "24.6435"
      },
      {
        "name": "BATRANI",
        "zip": "117506",
        "lat": "44.841727",
        "long": "24.757556"
      },
      {
        "name": "BECULESTI",
        "zip": "117256",
        "lat": "44.823138",
        "long": "24.437838"
      },
      {
        "name": "BELETI",
        "zip": "117111",
        "lat": "44.906662",
        "long": "25.086052"
      },
      {
        "name": "BEREVOESTI",
        "zip": "117115",
        "lat": "45.221836",
        "long": "24.934599"
      },
      {
        "name": "BERINDESTI",
        "zip": "117276",
        "lat": "45.322946",
        "long": "24.664844"
      },
      {
        "name": "BILCESTI",
        "zip": "117806",
        "lat": "45.279465",
        "long": "25.104691"
      },
      {
        "name": "BLAJU",
        "zip": "117747",
        "lat": "45.157822",
        "long": "24.600729"
      },
      {
        "name": "BLEJANI",
        "zip": "117817",
        "lat": "44.790677",
        "long": "24.63161"
      },
      {
        "name": "BOGATI",
        "zip": "117120",
        "lat": "44.868158",
        "long": "25.135069"
      },
      {
        "name": "BOLCULESTI",
        "zip": "117792",
        "lat": "45.208859",
        "long": "24.61342"
      },
      {
        "name": "BOLOVANESTI",
        "zip": "117521",
        "lat": "45.234034",
        "long": "24.730226"
      },
      {
        "name": "BORDEIENI",
        "zip": "117386",
        "lat": "45.255358",
        "long": "24.975357"
      },
      {
        "name": "BORLESTI",
        "zip": "117456",
        "lat": "44.947937",
        "long": "24.763859"
      },
      {
        "name": "BOROBANESTI",
        "zip": "117793",
        "lat": "45.170103",
        "long": "24.62862"
      },
      {
        "name": "BOROVINESTI",
        "zip": "117798",
        "lat": "45.200441",
        "long": "24.690253"
      },
      {
        "name": "BOTARCANI",
        "zip": "115501",
        "lat": "44.846076",
        "long": "25.085455"
      },
      {
        "name": "BOTENI",
        "zip": "117130",
        "lat": "45.179421",
        "long": "25.127879"
      },
      {
        "name": "BOTESTI",
        "zip": "117135",
        "lat": "45.010866",
        "long": "25.136437"
      },
      {
        "name": "BRABETI",
        "zip": "117093",
        "lat": "44.460524",
        "long": "24.765767"
      },
      {
        "name": "BRADETU",
        "zip": "117147",
        "lat": "45.30992",
        "long": "24.76212"
      },
      {
        "name": "BRADU",
        "zip": "117140",
        "lat": "44.78034",
        "long": "24.896167"
      },
      {
        "name": "BRADULET",
        "zip": "117145",
        "lat": "45.281607",
        "long": "24.779204"
      },
      {
        "name": "BRAILENI",
        "zip": "117046",
        "lat": "44.884703",
        "long": "24.775781"
      },
      {
        "name": "BRANISTEA",
        "zip": "117758",
        "lat": "44.901125",
        "long": "24.567766"
      },
      {
        "name": "BRANZARI",
        "zip": "117466",
        "lat": "44.958676",
        "long": "24.836573"
      },
      {
        "name": "BRATEASCA",
        "zip": "117457",
        "lat": "44.994208",
        "long": "24.717703"
      },
      {
        "name": "BRATESTI",
        "zip": "117007",
        "lat": "45.224145",
        "long": "24.707766"
      },
      {
        "name": "BRATIA",
        "zip": "117116",
        "lat": "45.27341",
        "long": "24.9465"
      },
      {
        "name": "BRATIA",
        "zip": "117257",
        "lat": "44.877154",
        "long": "24.499884"
      },
      {
        "name": "BROSTENI",
        "zip": "115201",
        "lat": "44.716605",
        "long": "24.867152"
      },
      {
        "name": "BROSTENI",
        "zip": "117036",
        "lat": "45.194227",
        "long": "24.916656"
      },
      {
        "name": "BUCOV",
        "zip": "117592",
        "lat": "44.44035",
        "long": "25.037534"
      },
      {
        "name": "BUCSENESTI",
        "zip": "117277",
        "lat": "45.296274",
        "long": "24.653361"
      },
      {
        "name": "BUCSENESTI-LOTASI",
        "zip": "117751",
        "lat": "45.012389",
        "long": "24.966856"
      },
      {
        "name": "BUDEASA MARE",
        "zip": "117156",
        "lat": "44.920334",
        "long": "24.833782"
      },
      {
        "name": "BUDEASA MICA",
        "zip": "117157",
        "lat": "44.932505",
        "long": "24.849508"
      },
      {
        "name": "BUDISTENI",
        "zip": "117414",
        "lat": "44.803909",
        "long": "25.155767"
      },
      {
        "name": "BUGHEA DE JOS",
        "zip": "117165",
        "lat": "45.276106",
        "long": "24.997833"
      },
      {
        "name": "BUGHEA DE SUS",
        "zip": "117027",
        "lat": "45.298123",
        "long": "25.032835"
      },
      {
        "name": "BUJOI",
        "zip": "117122",
        "lat": "44.889148",
        "long": "25.138668"
      },
      {
        "name": "BUJORENI",
        "zip": "117171",
        "lat": "44.602064",
        "long": "24.914481"
      },
      {
        "name": "BUMBUENI",
        "zip": "117436",
        "lat": "44.733437",
        "long": "24.787388"
      },
      {
        "name": "BUNESTI",
        "zip": "117307",
        "lat": "45.032406",
        "long": "24.613745"
      },
      {
        "name": "BUNESTI",
        "zip": "117446",
        "lat": "45.015888",
        "long": "24.75384"
      },
      {
        "name": "BURDEA",
        "zip": "117191",
        "lat": "44.449112",
        "long": "24.898134"
      },
      {
        "name": "BURDESTI",
        "zip": "117696",
        "lat": "44.721454",
        "long": "24.956286"
      },
      {
        "name": "BURETESTI",
        "zip": "117818",
        "lat": "44.82431",
        "long": "24.630425"
      },
      {
        "name": "BURLUSI",
        "zip": "117251",
        "lat": "45.115692",
        "long": "24.5299"
      },
      {
        "name": "BURNESTI",
        "zip": "117651",
        "lat": "45.173835",
        "long": "25.007425"
      },
      {
        "name": "BUTA",
        "zip": "117537",
        "lat": "44.626228",
        "long": "25.118439"
      },
      {
        "name": "BUZOESTI",
        "zip": "117170",
        "lat": "44.581129",
        "long": "24.918155"
      },
      {
        "name": "CALDARARU",
        "zip": "117190",
        "lat": "44.443773",
        "long": "24.956607"
      },
      {
        "name": "CALINESTI",
        "zip": "117195",
        "lat": "44.824437",
        "long": "25.04531"
      },
      {
        "name": "CALOTESTI",
        "zip": "117158",
        "lat": "44.983555",
        "long": "24.761975"
      },
      {
        "name": "CAMPULUNG",
        "zip": "115100",
        "lat": "45.273767",
        "long": "25.046576"
      },
      {
        "name": "CANDESTI",
        "zip": "117028",
        "lat": "45.322981",
        "long": "24.97173"
      },
      {
        "name": "CAPATANENII PAMANTENI",
        "zip": "117041",
        "lat": "45.317748",
        "long": "24.642546"
      },
      {
        "name": "CAPATANENII UNGURENI",
        "zip": "117042",
        "lat": "45.330783",
        "long": "24.639119"
      },
      {
        "name": "CAPU PISCULUI",
        "zip": "117387",
        "lat": "45.179987",
        "long": "24.97679"
      },
      {
        "name": "CAPU PISCULUI",
        "zip": "117458",
        "lat": "45.000697",
        "long": "24.733728"
      },
      {
        "name": "CARCESTI",
        "zip": "117333",
        "lat": "44.957346",
        "long": "24.533521"
      },
      {
        "name": "CARCIUMARESTI",
        "zip": "117416",
        "lat": "44.796464",
        "long": "25.112367"
      },
      {
        "name": "CARPENIS",
        "zip": "117231",
        "lat": "45.219043",
        "long": "24.523263"
      },
      {
        "name": "CARSTIENI",
        "zip": "117196",
        "lat": "44.883202",
        "long": "25.03009"
      },
      {
        "name": "CATANE",
        "zip": "117437",
        "lat": "44.637311",
        "long": "24.760885"
      },
      {
        "name": "CATANELE",
        "zip": "117221",
        "lat": "44.800003",
        "long": "24.999633"
      },
      {
        "name": "CATEASCA",
        "zip": "117220",
        "lat": "44.76177",
        "long": "25.089252"
      },
      {
        "name": "CATUNASI",
        "zip": "117556",
        "lat": "44.827842",
        "long": "24.732756"
      },
      {
        "name": "CEAURESTI",
        "zip": "117576",
        "lat": "45.05306",
        "long": "24.524852"
      },
      {
        "name": "CEAUSESTI",
        "zip": "117546",
        "lat": "44.75257",
        "long": "24.964432"
      },
      {
        "name": "CEPARI",
        "zip": "117557",
        "lat": "44.795208",
        "long": "24.680408"
      },
      {
        "name": "CEPARII PAMANTENI",
        "zip": "117232",
        "lat": "45.205202",
        "long": "24.552352"
      },
      {
        "name": "CEPARII UNGURENI",
        "zip": "117233",
        "lat": "45.191424",
        "long": "24.547138"
      },
      {
        "name": "CERBU",
        "zip": "117031",
        "lat": "44.758311",
        "long": "24.817175"
      },
      {
        "name": "CERBURENI",
        "zip": "117799",
        "lat": "45.185195",
        "long": "24.670269"
      },
      {
        "name": "CERSANI",
        "zip": "117697",
        "lat": "44.719665",
        "long": "24.941127"
      },
      {
        "name": "CETATENI",
        "zip": "117240",
        "lat": "45.191032",
        "long": "25.211224"
      },
      {
        "name": "CHILII",
        "zip": "117482",
        "lat": "45.237426",
        "long": "25.057416"
      },
      {
        "name": "CHIRITESTI",
        "zip": "117698",
        "lat": "44.714557",
        "long": "24.976398"
      },
      {
        "name": "CHIRITESTI",
        "zip": "117759",
        "lat": "44.842518",
        "long": "24.596754"
      },
      {
        "name": "CHIRITESTI",
        "zip": "117819",
        "lat": "44.752951",
        "long": "24.659264"
      },
      {
        "name": "CHITANI",
        "zip": "117821",
        "lat": "44.746521",
        "long": "24.646092"
      },
      {
        "name": "CHITESTI",
        "zip": "117123",
        "lat": "44.862303",
        "long": "25.139787"
      },
      {
        "name": "CICANESTI",
        "zip": "117245",
        "lat": "45.244232",
        "long": "24.604564"
      },
      {
        "name": "CIESTI",
        "zip": "117438",
        "lat": "44.6262",
        "long": "24.762903"
      },
      {
        "name": "CIOBANESTI",
        "zip": "117057",
        "lat": "44.859385",
        "long": "24.722851"
      },
      {
        "name": "CIOBANI",
        "zip": "117391",
        "lat": "44.502445",
        "long": "24.774664"
      },
      {
        "name": "CIOCANAI",
        "zip": "117507",
        "lat": "44.845064",
        "long": "24.78612"
      },
      {
        "name": "CIOCANESTI",
        "zip": "117197",
        "lat": "44.851412",
        "long": "24.969546"
      },
      {
        "name": "CIOCANU",
        "zip": "117356",
        "lat": "45.457867",
        "long": "25.244797"
      },
      {
        "name": "CIOCESTI",
        "zip": "117094",
        "lat": "44.448529",
        "long": "24.782725"
      },
      {
        "name": "CIOFRANGENI",
        "zip": "117250",
        "lat": "45.107831",
        "long": "24.541403"
      },
      {
        "name": "CIOLCESTI",
        "zip": "117417",
        "lat": "44.798441",
        "long": "25.199702"
      },
      {
        "name": "CIOMAGESTI",
        "zip": "117255",
        "lat": "44.840219",
        "long": "24.449483"
      },
      {
        "name": "CIRESU",
        "zip": "117222",
        "lat": "44.760798",
        "long": "25.036479"
      },
      {
        "name": "CISMEA",
        "zip": "117752",
        "lat": "45.014325",
        "long": "24.955322"
      },
      {
        "name": "CIULNITA",
        "zip": "117418",
        "lat": "44.787793",
        "long": "25.153781"
      },
      {
        "name": "CIUPA-MANCIULESCU",
        "zip": "117611",
        "lat": "44.701535",
        "long": "25.157578"
      },
      {
        "name": "CIURESTI",
        "zip": "117822",
        "lat": "44.781315",
        "long": "24.670228"
      },
      {
        "name": "CLUCEREASA",
        "zip": "115401",
        "lat": "44.981118",
        "long": "24.939939"
      },
      {
        "name": "COCENESTI",
        "zip": "117483",
        "lat": "45.222299",
        "long": "25.098467"
      },
      {
        "name": "COCHINESTI",
        "zip": "117686",
        "lat": "44.580935",
        "long": "24.763389"
      },
      {
        "name": "COCU",
        "zip": "117265",
        "lat": "44.851678",
        "long": "24.658341"
      },
      {
        "name": "COLIBASI",
        "zip": "115402",
        "lat": "44.934828",
        "long": "24.908676"
      },
      {
        "name": "COLNIC",
        "zip": "117807",
        "lat": "45.265475",
        "long": "25.107283"
      },
      {
        "name": "COLTU",
        "zip": "117781",
        "lat": "44.493946",
        "long": "24.930393"
      },
      {
        "name": "CONTESTI",
        "zip": "117351",
        "lat": "44.985429",
        "long": "25.010497"
      },
      {
        "name": "CORBENI",
        "zip": "117275",
        "lat": "45.305242",
        "long": "24.654348"
      },
      {
        "name": "CORBI",
        "zip": "117285",
        "lat": "45.285752",
        "long": "24.803201"
      },
      {
        "name": "CORBSORI",
        "zip": "117286",
        "lat": "45.253228",
        "long": "24.824104"
      },
      {
        "name": "CORNATEL",
        "zip": "117172",
        "lat": "44.574685",
        "long": "24.95505"
      },
      {
        "name": "COSACI",
        "zip": "117148",
        "lat": "45.280014",
        "long": "24.782208"
      },
      {
        "name": "COSERI",
        "zip": "117223",
        "lat": "44.779398",
        "long": "25.055901"
      },
      {
        "name": "COSESTI",
        "zip": "117295",
        "lat": "45.071309",
        "long": "24.872107"
      },
      {
        "name": "COSTESTI",
        "zip": "115200",
        "lat": "44.662134",
        "long": "24.877452"
      },
      {
        "name": "COSTESTI",
        "zip": "117310",
        "lat": "44.986321",
        "long": "24.596364"
      },
      {
        "name": "COSTESTI-VALSAN",
        "zip": "117522",
        "lat": "45.147947",
        "long": "24.773252"
      },
      {
        "name": "COSTITA",
        "zip": "117652",
        "lat": "45.206265",
        "long": "25.004727"
      },
      {
        "name": "COTEASCA",
        "zip": "117841",
        "lat": "45.130491",
        "long": "24.937833"
      },
      {
        "name": "COTENESTI",
        "zip": "117677",
        "lat": "45.234618",
        "long": "25.186168"
      },
      {
        "name": "COTESTI",
        "zip": "117388",
        "lat": "45.197365",
        "long": "24.975179"
      },
      {
        "name": "COTMEANA",
        "zip": "117305",
        "lat": "44.97246",
        "long": "24.616254"
      },
      {
        "name": "COTMEANA",
        "zip": "117687",
        "lat": "44.59851",
        "long": "24.758618"
      },
      {
        "name": "COTMENITA",
        "zip": "117058",
        "lat": "44.890523",
        "long": "24.70287"
      },
      {
        "name": "COTU",
        "zip": "117334",
        "lat": "44.914018",
        "long": "24.483097"
      },
      {
        "name": "COTU",
        "zip": "117761",
        "lat": "44.893954",
        "long": "24.594157"
      },
      {
        "name": "COTU MALULUI",
        "zip": "117419",
        "lat": "44.751559",
        "long": "25.190969"
      },
      {
        "name": "CRAMPOTANI",
        "zip": "117459",
        "lat": "45.016863",
        "long": "24.693773"
      },
      {
        "name": "CRINTESTI",
        "zip": "115502",
        "lat": "44.851732",
        "long": "25.091162"
      },
      {
        "name": "CRIVATU",
        "zip": "117336",
        "lat": "44.955827",
        "long": "24.513656"
      },
      {
        "name": "CRUCISOARA",
        "zip": "117267",
        "lat": "44.822841",
        "long": "24.659978"
      },
      {
        "name": "CUCA",
        "zip": "117330",
        "lat": "44.966776",
        "long": "24.514654"
      },
      {
        "name": "CUNGREA",
        "zip": "117258",
        "lat": "44.879433",
        "long": "24.489761"
      },
      {
        "name": "CURTEA DE ARGES",
        "zip": "115300",
        "lat": "45.146934",
        "long": "24.677961"
      },
      {
        "name": "CURTEANCA",
        "zip": "117173",
        "lat": "44.573916",
        "long": "24.929491"
      },
      {
        "name": "DAMBOVICIOARA",
        "zip": "117355",
        "lat": "45.437771",
        "long": "25.232989"
      },
      {
        "name": "DARMANESTI",
        "zip": "117360",
        "lat": "45.01049",
        "long": "24.901432"
      },
      {
        "name": "DAVIDESTI",
        "zip": "117350",
        "lat": "45.009631",
        "long": "25.033136"
      },
      {
        "name": "DEAGU DE JOS",
        "zip": "117621",
        "lat": "44.54812",
        "long": "25.023511"
      },
      {
        "name": "DEAGU DE SUS",
        "zip": "117622",
        "lat": "44.564395",
        "long": "25.006151"
      },
      {
        "name": "DEALU",
        "zip": "117397",
        "lat": "45.111476",
        "long": "25.10497"
      },
      {
        "name": "DEALU BISERICII",
        "zip": "117762",
        "lat": "44.873023",
        "long": "24.595232"
      },
      {
        "name": "DEALU BRADULUI",
        "zip": "117642",
        "lat": "44.73848",
        "long": "24.725629"
      },
      {
        "name": "DEALU FRUMOS",
        "zip": "117666",
        "lat": "45.027741",
        "long": "24.967351"
      },
      {
        "name": "DEALU OBEJDEANULUI",
        "zip": "117496",
        "lat": "44.992069",
        "long": "24.562075"
      },
      {
        "name": "DEALU ORASULUI",
        "zip": "117558",
        "lat": "44.820253",
        "long": "24.716612"
      },
      {
        "name": "DEALU PADURII",
        "zip": "117308",
        "lat": "44.95978",
        "long": "24.594705"
      },
      {
        "name": "DEALU TOLCESII",
        "zip": "117763",
        "lat": "44.871491",
        "long": "24.566346"
      },
      {
        "name": "DEALU VIILOR",
        "zip": "117508",
        "lat": "44.807721",
        "long": "24.825368"
      },
      {
        "name": "DEALU VIILOR",
        "zip": "117559",
        "lat": "44.834562",
        "long": "24.702104"
      },
      {
        "name": "DEDULESTI",
        "zip": "117497",
        "lat": "45.016747",
        "long": "24.53811"
      },
      {
        "name": "DICONESTI",
        "zip": "117764",
        "lat": "44.841157",
        "long": "24.609473"
      },
      {
        "name": "DINCANI",
        "zip": "117823",
        "lat": "44.822643",
        "long": "24.613393"
      },
      {
        "name": "DINCULESTI",
        "zip": "117561",
        "lat": "44.81365",
        "long": "24.723575"
      },
      {
        "name": "DOBLEA",
        "zip": "117008",
        "lat": "45.214132",
        "long": "24.706116"
      },
      {
        "name": "DOBRESTI",
        "zip": "117365",
        "lat": "44.966417",
        "long": "25.129969"
      },
      {
        "name": "DOBROGOSTEA",
        "zip": "117461",
        "lat": "44.929483",
        "long": "24.782769"
      },
      {
        "name": "DOBROTU",
        "zip": "117009",
        "lat": "45.206459",
        "long": "24.657461"
      },
      {
        "name": "DOGARI",
        "zip": "117259",
        "lat": "44.846661",
        "long": "24.479429"
      },
      {
        "name": "DOMNESTI",
        "zip": "117370",
        "lat": "45.206701",
        "long": "24.839921"
      },
      {
        "name": "DRAGANU-OLTENI",
        "zip": "117382",
        "lat": "44.937467",
        "long": "24.706398"
      },
      {
        "name": "DRAGHESCU",
        "zip": "117842",
        "lat": "45.136517",
        "long": "24.956651"
      },
      {
        "name": "DRAGHICESTI",
        "zip": "117643",
        "lat": "44.755396",
        "long": "24.749286"
      },
      {
        "name": "DRAGHICI",
        "zip": "117471",
        "lat": "45.12951",
        "long": "25.044728"
      },
      {
        "name": "DRAGOLESTI",
        "zip": "117309",
        "lat": "45.039096",
        "long": "24.611897"
      },
      {
        "name": "DRAGOSLAVELE",
        "zip": "117375",
        "lat": "45.348083",
        "long": "25.169138"
      },
      {
        "name": "DUMBRAVA",
        "zip": "117124",
        "lat": "44.89302",
        "long": "25.193885"
      },
      {
        "name": "DUMBRAVESTI",
        "zip": "117383",
        "lat": "44.962029",
        "long": "24.690272"
      },
      {
        "name": "DUMIRESTI",
        "zip": "117011",
        "lat": "45.247907",
        "long": "24.695073"
      },
      {
        "name": "ENCULESTI",
        "zip": "117716",
        "lat": "44.902824",
        "long": "24.940514"
      },
      {
        "name": "FACALETESTI",
        "zip": "117268",
        "lat": "44.850605",
        "long": "24.675915"
      },
      {
        "name": "FAGETU",
        "zip": "115403",
        "lat": "44.905513",
        "long": "24.905763"
      },
      {
        "name": "FALFANI",
        "zip": "117688",
        "lat": "44.612488",
        "long": "24.761245"
      },
      {
        "name": "FANTANEA",
        "zip": "117808",
        "lat": "45.274408",
        "long": "25.10471"
      },
      {
        "name": "FATA",
        "zip": "117824",
        "lat": "44.810151",
        "long": "24.624224"
      },
      {
        "name": "FEDELESOIU",
        "zip": "117261",
        "lat": "44.848858",
        "long": "24.457603"
      },
      {
        "name": "FLORIENI",
        "zip": "117012",
        "lat": "45.23989",
        "long": "24.721398"
      },
      {
        "name": "FRATESTI",
        "zip": "117032",
        "lat": "44.799862",
        "long": "24.790307"
      },
      {
        "name": "FRATICI",
        "zip": "117826",
        "lat": "44.762804",
        "long": "24.617885"
      },
      {
        "name": "FURDUESTI",
        "zip": "117612",
        "lat": "44.724113",
        "long": "25.105175"
      },
      {
        "name": "FURESTI",
        "zip": "117366",
        "lat": "44.933471",
        "long": "25.108519"
      },
      {
        "name": "FURNICOSI",
        "zip": "117472",
        "lat": "45.142191",
        "long": "25.001081"
      },
      {
        "name": "GAINUSA",
        "zip": "117644",
        "lat": "44.762001",
        "long": "24.738705"
      },
      {
        "name": "GALASESTI",
        "zip": "117159",
        "lat": "44.94958",
        "long": "24.799848"
      },
      {
        "name": "GALCESTI",
        "zip": "117564",
        "lat": "44.815663",
        "long": "24.743084"
      },
      {
        "name": "GALESESTI",
        "zip": "117699",
        "lat": "44.709101",
        "long": "24.96879"
      },
      {
        "name": "GALESU",
        "zip": "117149",
        "lat": "45.272767",
        "long": "24.761782"
      },
      {
        "name": "GALETEANU",
        "zip": "117562",
        "lat": "44.80589",
        "long": "24.684762"
      },
      {
        "name": "GAMACESTI",
        "zip": "117117",
        "lat": "45.251345",
        "long": "24.930561"
      },
      {
        "name": "GANESTI",
        "zip": "117552",
        "lat": "45.122163",
        "long": "24.840654"
      },
      {
        "name": "GARDINESTI",
        "zip": "117563",
        "lat": "44.793596",
        "long": "24.667078"
      },
      {
        "name": "GAUJANI",
        "zip": "117782",
        "lat": "44.543225",
        "long": "24.960196"
      },
      {
        "name": "GEAMANA",
        "zip": "117141",
        "lat": "44.818853",
        "long": "24.889812"
      },
      {
        "name": "GIUCLANI",
        "zip": "117262",
        "lat": "44.886666",
        "long": "24.514991"
      },
      {
        "name": "GLAMBOCATA",
        "zip": "117421",
        "lat": "44.778898",
        "long": "25.201731"
      },
      {
        "name": "GLAMBOCATA-DEAL",
        "zip": "117422",
        "lat": "44.782223",
        "long": "25.177759000000002"
      },
      {
        "name": "GLAMBOCEL",
        "zip": "117126",
        "lat": "44.854727",
        "long": "25.164851"
      },
      {
        "name": "GLAMBOCELU",
        "zip": "117127",
        "lat": "44.841443",
        "long": "25.137339"
      },
      {
        "name": "GLAMBOCU",
        "zip": "117047",
        "lat": "44.888203",
        "long": "24.79363"
      },
      {
        "name": "GLAVACIOC",
        "zip": "117711",
        "lat": "44.467511",
        "long": "25.257348"
      },
      {
        "name": "GLIGANU DE JOS",
        "zip": "117626",
        "lat": "44.657141",
        "long": "25.036297"
      },
      {
        "name": "GLIGANU DE SUS",
        "zip": "117627",
        "lat": "44.656381",
        "long": "25.001544"
      },
      {
        "name": "GLODU",
        "zip": "117198",
        "lat": "44.848486",
        "long": "25.042255"
      },
      {
        "name": "GLODU",
        "zip": "117423",
        "lat": "44.820665",
        "long": "25.169545"
      },
      {
        "name": "GODENI",
        "zip": "117385",
        "lat": "45.227534",
        "long": "24.985241"
      },
      {
        "name": "GOIA",
        "zip": "117783",
        "lat": "44.525385",
        "long": "24.999811"
      },
      {
        "name": "GOLEASCA",
        "zip": "117623",
        "lat": "44.569858",
        "long": "25.056221"
      },
      {
        "name": "GOLESTI",
        "zip": "117717",
        "lat": "44.839394",
        "long": "24.963712"
      },
      {
        "name": "GOLESTI",
        "zip": "117082",
        "lat": "45.08702",
        "long": "24.931918"
      },
      {
        "name": "GORANESTI",
        "zip": "115503",
        "lat": "44.855313",
        "long": "25.087013"
      },
      {
        "name": "GORANI",
        "zip": "117766",
        "lat": "44.919087",
        "long": "24.565143"
      },
      {
        "name": "GORGANU",
        "zip": "117199",
        "lat": "44.842412",
        "long": "25.03838"
      },
      {
        "name": "GREABAN",
        "zip": "117767",
        "lat": "44.908756",
        "long": "24.596832"
      },
      {
        "name": "GREABANU",
        "zip": "117269",
        "lat": "44.912831",
        "long": "24.62006"
      },
      {
        "name": "GROSANI",
        "zip": "117581",
        "lat": "45.228021",
        "long": "25.032326"
      },
      {
        "name": "GROSI",
        "zip": "117059",
        "lat": "44.871482",
        "long": "24.685654"
      },
      {
        "name": "GRUIU",
        "zip": "117224",
        "lat": "44.735174",
        "long": "25.070088"
      },
      {
        "name": "GRUIU",
        "zip": "117541",
        "lat": "45.326759",
        "long": "24.763451"
      },
      {
        "name": "GURA PRAVAT",
        "zip": "117809",
        "lat": "45.324685",
        "long": "25.128622"
      },
      {
        "name": "GURA VAII",
        "zip": "117033",
        "lat": "44.801194",
        "long": "24.840086"
      },
      {
        "name": "HARSESTI",
        "zip": "117390",
        "lat": "44.522701",
        "long": "24.7829"
      },
      {
        "name": "HARTIESTI",
        "zip": "117395",
        "lat": "45.112655",
        "long": "25.099549"
      },
      {
        "name": "HINTESTI",
        "zip": "117509",
        "lat": "44.809669",
        "long": "24.836396"
      },
      {
        "name": "HULUBA",
        "zip": "117398",
        "lat": "45.067865",
        "long": "25.058521"
      },
      {
        "name": "HUMELE",
        "zip": "117784",
        "lat": "44.526121",
        "long": "24.977141"
      },
      {
        "name": "IANCULESTI",
        "zip": "117726",
        "lat": "45.244984",
        "long": "24.485194"
      },
      {
        "name": "IOANICESTI",
        "zip": "117577",
        "lat": "45.063713",
        "long": "24.511544"
      },
      {
        "name": "IONESTI",
        "zip": "117174",
        "lat": "44.612316",
        "long": "24.902255"
      },
      {
        "name": "IZBASESTI",
        "zip": "117689",
        "lat": "44.584891",
        "long": "24.779366"
      },
      {
        "name": "IZVORANI",
        "zip": "117718",
        "lat": "44.872028",
        "long": "24.939507"
      },
      {
        "name": "IZVORU",
        "zip": "117405",
        "lat": "44.494138",
        "long": "25.064703"
      },
      {
        "name": "IZVORU DE JOS",
        "zip": "117827",
        "lat": "44.783872",
        "long": "24.644931"
      },
      {
        "name": "IZVORU DE SUS",
        "zip": "117828",
        "lat": "44.810271",
        "long": "24.644947"
      },
      {
        "name": "JGHEABURI",
        "zip": "117287",
        "lat": "45.282019",
        "long": "24.808215"
      },
      {
        "name": "JUGUR",
        "zip": "117582",
        "lat": "45.187772",
        "long": "25.086141"
      },
      {
        "name": "JUPANESTI",
        "zip": "117296",
        "lat": "45.067621",
        "long": "24.851373"
      },
      {
        "name": "LACENI",
        "zip": "115202",
        "lat": "44.716561",
        "long": "24.876341"
      },
      {
        "name": "LACURILE",
        "zip": "117252",
        "lat": "45.084934",
        "long": "24.539221"
      },
      {
        "name": "LAICAI",
        "zip": "117241",
        "lat": "45.178719",
        "long": "25.210663"
      },
      {
        "name": "LANGESTI",
        "zip": "117439",
        "lat": "44.698926",
        "long": "24.778673"
      },
      {
        "name": "LAPUSANI",
        "zip": "117297",
        "lat": "45.122938",
        "long": "24.853991"
      },
      {
        "name": "LAUNELE DE SUS",
        "zip": "117337",
        "lat": "44.93416",
        "long": "24.489707"
      },
      {
        "name": "LAZARESTI",
        "zip": "117511",
        "lat": "44.825944",
        "long": "24.756294"
      },
      {
        "name": "LAZARESTI",
        "zip": "117653",
        "lat": "45.164582",
        "long": "24.998066"
      },
      {
        "name": "LEICESTI",
        "zip": "117298",
        "lat": "45.09571",
        "long": "24.861035"
      },
      {
        "name": "LENTEA",
        "zip": "117112",
        "lat": "44.958682",
        "long": "25.080668"
      },
      {
        "name": "LEORDENI",
        "zip": "117410",
        "lat": "44.791885",
        "long": "25.129355"
      },
      {
        "name": "LERESTI",
        "zip": "117430",
        "lat": "45.328833",
        "long": "25.071759"
      },
      {
        "name": "LESILE",
        "zip": "117736",
        "lat": "44.629304",
        "long": "25.152282"
      },
      {
        "name": "LESPEZI",
        "zip": "117399",
        "lat": "45.138221",
        "long": "25.119707"
      },
      {
        "name": "LINTESTI",
        "zip": "117311",
        "lat": "45.006708",
        "long": "24.611092"
      },
      {
        "name": "LIPIA",
        "zip": "117646",
        "lat": "44.771621",
        "long": "24.725731"
      },
      {
        "name": "LIVEZENI",
        "zip": "117667",
        "lat": "45.038377",
        "long": "24.976759"
      },
      {
        "name": "LOTURI",
        "zip": "117654",
        "lat": "45.214019",
        "long": "25.016531"
      },
      {
        "name": "LUCIENI",
        "zip": "117401",
        "lat": "45.13267",
        "long": "25.110709"
      },
      {
        "name": "LUMINILE",
        "zip": "117498",
        "lat": "45.036374",
        "long": "24.540576"
      },
      {
        "name": "LUNCA",
        "zip": "117132",
        "lat": "45.158555",
        "long": "25.118728"
      },
      {
        "name": "LUNCA CORBULUI",
        "zip": "117435",
        "lat": "44.683796",
        "long": "24.760632"
      },
      {
        "name": "LUNCA GARTII",
        "zip": "117678",
        "lat": "45.293581",
        "long": "25.165659"
      },
      {
        "name": "LUNGANI",
        "zip": "117829",
        "lat": "44.760682",
        "long": "24.644666"
      },
      {
        "name": "LUNGULESTI",
        "zip": "117768",
        "lat": "44.880205",
        "long": "24.612368"
      },
      {
        "name": "LUPUENI",
        "zip": "117061",
        "lat": "44.879792",
        "long": "24.724454"
      },
      {
        "name": "MACAI",
        "zip": "117338",
        "lat": "44.985146",
        "long": "24.501025"
      },
      {
        "name": "MALU",
        "zip": "117096",
        "lat": "44.453756",
        "long": "24.780855"
      },
      {
        "name": "MALU",
        "zip": "117389",
        "lat": "45.25019",
        "long": "24.977979"
      },
      {
        "name": "MALU VANAT",
        "zip": "117462",
        "lat": "44.985862",
        "long": "24.727509"
      },
      {
        "name": "MALURENI",
        "zip": "117445",
        "lat": "45.096974",
        "long": "24.801468"
      },
      {
        "name": "MANCIOIU",
        "zip": "117499",
        "lat": "45.013709",
        "long": "24.504905"
      },
      {
        "name": "MANDRA",
        "zip": "117097",
        "lat": "44.45924",
        "long": "24.775789"
      },
      {
        "name": "MANESTI",
        "zip": "117339",
        "lat": "44.983862",
        "long": "24.514641"
      },
      {
        "name": "MANICESTI",
        "zip": "117069",
        "lat": "45.021435",
        "long": "24.714729"
      },
      {
        "name": "MARACINENI",
        "zip": "117450",
        "lat": "44.889581",
        "long": "24.877029"
      },
      {
        "name": "MARES",
        "zip": "117034",
        "lat": "44.778244",
        "long": "24.790045"
      },
      {
        "name": "MARGHIA DE JOS",
        "zip": "117441",
        "lat": "44.681592",
        "long": "24.718067"
      },
      {
        "name": "MARGHIA DE SUS",
        "zip": "117442",
        "lat": "44.691551",
        "long": "24.711411"
      },
      {
        "name": "MARTALOGI",
        "zip": "117392",
        "lat": "44.502959",
        "long": "24.789249"
      },
      {
        "name": "MARTESTI",
        "zip": "117647",
        "lat": "44.712199",
        "long": "24.752095"
      },
      {
        "name": "MATAU",
        "zip": "117484",
        "lat": "45.235434",
        "long": "25.082774"
      },
      {
        "name": "MAVRODOLU",
        "zip": "117613",
        "lat": "44.691732",
        "long": "25.218281"
      },
      {
        "name": "MERISANI",
        "zip": "117455",
        "lat": "44.968864",
        "long": "24.744598"
      },
      {
        "name": "METOFU",
        "zip": "117566",
        "lat": "44.84506",
        "long": "24.716913"
      },
      {
        "name": "MICA",
        "zip": "117048",
        "lat": "44.884728",
        "long": "24.757804"
      },
      {
        "name": "MICESTI",
        "zip": "117465",
        "lat": "44.948398",
        "long": "24.863739"
      },
      {
        "name": "MIERCANI",
        "zip": "117769",
        "lat": "44.925842",
        "long": "24.58529"
      },
      {
        "name": "MIHAESTI",
        "zip": "117470",
        "lat": "45.111131",
        "long": "25.007046"
      },
      {
        "name": "MIOARELE",
        "zip": "117247",
        "lat": "45.246089",
        "long": "24.633928"
      },
      {
        "name": "MIOVENI",
        "zip": "115400",
        "lat": "44.956615",
        "long": "24.937751"
      },
      {
        "name": "MIROSI",
        "zip": "117490",
        "lat": "44.414154",
        "long": "24.945431"
      },
      {
        "name": "MOARA MOCANULUI",
        "zip": "117424",
        "lat": "44.768787",
        "long": "25.140423"
      },
      {
        "name": "MOGOSESTI",
        "zip": "117831",
        "lat": "44.741431",
        "long": "24.692212"
      },
      {
        "name": "MORARESTI",
        "zip": "117495",
        "lat": "45.007477",
        "long": "24.563138"
      },
      {
        "name": "MORASTI",
        "zip": "117234",
        "lat": "45.227764",
        "long": "24.507967"
      },
      {
        "name": "MOSOAIA",
        "zip": "117505",
        "lat": "44.835611",
        "long": "24.790703"
      },
      {
        "name": "MOSTENI-GRECI",
        "zip": "117136",
        "lat": "45.0031",
        "long": "25.156603"
      },
      {
        "name": "MOZACENI",
        "zip": "117515",
        "lat": "44.565189",
        "long": "25.163329"
      },
      {
        "name": "MOZACENII-VALE",
        "zip": "117098",
        "lat": "44.400722",
        "long": "24.804033"
      },
      {
        "name": "MOZACU",
        "zip": "117538",
        "lat": "44.608651",
        "long": "25.167504"
      },
      {
        "name": "MUSATESTI",
        "zip": "117520",
        "lat": "45.228157",
        "long": "24.775997"
      },
      {
        "name": "MUSCEL",
        "zip": "117133",
        "lat": "45.20152",
        "long": "25.132683"
      },
      {
        "name": "MUSTATESTI",
        "zip": "117801",
        "lat": "45.193521",
        "long": "24.67883"
      },
      {
        "name": "NAMAESTI",
        "zip": "117811",
        "lat": "45.30458",
        "long": "25.112755"
      },
      {
        "name": "NEGESTI",
        "zip": "117312",
        "lat": "45.004813",
        "long": "24.656986"
      },
      {
        "name": "NEGRASI",
        "zip": "117535",
        "lat": "44.596752",
        "long": "25.126842"
      },
      {
        "name": "NEGRENI",
        "zip": "117361",
        "lat": "44.992078",
        "long": "24.913159"
      },
      {
        "name": "NEGRESTI",
        "zip": "117113",
        "lat": "44.961936",
        "long": "25.070499"
      },
      {
        "name": "NEJLOVELU",
        "zip": "117614",
        "lat": "44.69098",
        "long": "25.173425"
      },
      {
        "name": "NIGRISOARA",
        "zip": "117661",
        "lat": "44.503551",
        "long": "25.23387"
      },
      {
        "name": "NOAPTES",
        "zip": "115301",
        "lat": "45.104186",
        "long": "24.652966"
      },
      {
        "name": "NUCSOARA",
        "zip": "117540",
        "lat": "45.338841",
        "long": "24.780705"
      },
      {
        "name": "OARJA",
        "zip": "117545",
        "lat": "44.757873",
        "long": "24.97516"
      },
      {
        "name": "ODAENI",
        "zip": "117701",
        "lat": "44.681914",
        "long": "24.973737"
      },
      {
        "name": "OESTII PAMANTENI",
        "zip": "117278",
        "lat": "45.252725",
        "long": "24.655198"
      },
      {
        "name": "OESTII UNGURENI",
        "zip": "117279",
        "lat": "45.25618",
        "long": "24.652031"
      },
      {
        "name": "OGREZEA",
        "zip": "117668",
        "lat": "45.05673",
        "long": "24.995442"
      },
      {
        "name": "OPRESTI",
        "zip": "117669",
        "lat": "45.074388",
        "long": "24.987906"
      },
      {
        "name": "ORODEL",
        "zip": "117624",
        "lat": "44.511101",
        "long": "25.017155"
      },
      {
        "name": "OTELU",
        "zip": "117118",
        "lat": "45.253961",
        "long": "24.953988"
      },
      {
        "name": "PACIOIU",
        "zip": "117299",
        "lat": "45.082335",
        "long": "24.865283"
      },
      {
        "name": "PADURENI",
        "zip": "117702",
        "lat": "44.707368",
        "long": "24.986383"
      },
      {
        "name": "PADURETI",
        "zip": "117443",
        "lat": "44.658367",
        "long": "24.766651"
      },
      {
        "name": "PADUROIU DIN DEAL",
        "zip": "117567",
        "lat": "44.793377",
        "long": "24.721182"
      },
      {
        "name": "PADUROIU DIN VALE",
        "zip": "117568",
        "lat": "44.783931",
        "long": "24.701414"
      },
      {
        "name": "PALANGA",
        "zip": "117593",
        "lat": "44.451457",
        "long": "25.08467"
      },
      {
        "name": "PALTENU",
        "zip": "117727",
        "lat": "45.256013",
        "long": "24.494123"
      },
      {
        "name": "PARASCHIVESTI",
        "zip": "117602",
        "lat": "44.880361",
        "long": "25.090747"
      },
      {
        "name": "PARVU ROSU",
        "zip": "115203",
        "lat": "44.734596",
        "long": "24.902918"
      },
      {
        "name": "PATULENI",
        "zip": "117616",
        "lat": "44.732264",
        "long": "25.162956"
      },
      {
        "name": "PAULEASCA",
        "zip": "117447",
        "lat": "45.016931",
        "long": "24.831139"
      },
      {
        "name": "PAULEASCA",
        "zip": "117467",
        "lat": "45.009631",
        "long": "24.838763"
      },
      {
        "name": "PAULENI",
        "zip": "117728",
        "lat": "45.25878",
        "long": "24.520295"
      },
      {
        "name": "PAUNESTI",
        "zip": "117263",
        "lat": "44.847655",
        "long": "24.447165"
      },
      {
        "name": "PETRESTI",
        "zip": "117301",
        "lat": "45.043636",
        "long": "24.889888"
      },
      {
        "name": "PIATRA",
        "zip": "117151",
        "lat": "45.249956",
        "long": "24.769934"
      },
      {
        "name": "PIATRA",
        "zip": "117253",
        "lat": "45.104324",
        "long": "24.508323"
      },
      {
        "name": "PIATRA",
        "zip": "117679",
        "lat": "45.273539",
        "long": "25.151576"
      },
      {
        "name": "PIELESTI",
        "zip": "117313",
        "lat": "45.048044",
        "long": "24.575479"
      },
      {
        "name": "PIETROASA",
        "zip": "117812",
        "lat": "45.288229",
        "long": "25.084966"
      },
      {
        "name": "PIETROSANI",
        "zip": "117550",
        "lat": "45.176953",
        "long": "24.84755"
      },
      {
        "name": "PISCANI",
        "zip": "117362",
        "lat": "44.973199",
        "long": "24.916218"
      },
      {
        "name": "PITESTI",
        "zip": "110001",
        "lat": "44.857234",
        "long": "24.871942"
      },
      {
        "name": "PITIGAIA",
        "zip": "117671",
        "lat": "45.06963",
        "long": "25.033262"
      },
      {
        "name": "PITOI",
        "zip": "117603",
        "lat": "44.874699",
        "long": "25.091953"
      },
      {
        "name": "PODENI",
        "zip": "117176",
        "lat": "44.586626",
        "long": "24.907815"
      },
      {
        "name": "PODISORU",
        "zip": "117099",
        "lat": "44.411885",
        "long": "24.79178"
      },
      {
        "name": "PODU BROSTENI",
        "zip": "115204",
        "lat": "44.743016",
        "long": "24.85714"
      },
      {
        "name": "PODU DAMBOVITEI",
        "zip": "117357",
        "lat": "45.407971",
        "long": "25.200523"
      },
      {
        "name": "PODURI",
        "zip": "117288",
        "lat": "45.227551",
        "long": "24.824069"
      },
      {
        "name": "POIANA LACULUI",
        "zip": "117555",
        "lat": "44.801044",
        "long": "24.74085"
      },
      {
        "name": "POIENAREI",
        "zip": "117289",
        "lat": "45.254799",
        "long": "24.80471"
      },
      {
        "name": "POIENARI",
        "zip": "117281",
        "lat": "45.314432",
        "long": "24.656253"
      },
      {
        "name": "POIENARI",
        "zip": "117578",
        "lat": "45.067909",
        "long": "24.528389"
      },
      {
        "name": "POIENARI",
        "zip": "117583",
        "lat": "45.219736",
        "long": "25.048896"
      },
      {
        "name": "POIENITA",
        "zip": "117083",
        "lat": "45.111749",
        "long": "24.927885"
      },
      {
        "name": "POJORATA",
        "zip": "117431",
        "lat": "45.354798",
        "long": "25.063393"
      },
      {
        "name": "POPESTI",
        "zip": "117271",
        "lat": "44.852959",
        "long": "24.638154"
      },
      {
        "name": "POPESTI",
        "zip": "117590",
        "lat": "44.441949",
        "long": "25.101376"
      },
      {
        "name": "POPESTI",
        "zip": "117648",
        "lat": "44.743507",
        "long": "24.752728"
      },
      {
        "name": "PRIBOAIA",
        "zip": "117084",
        "lat": "45.088731",
        "long": "24.944034"
      },
      {
        "name": "PRIBOIENI",
        "zip": "117600",
        "lat": "44.874969",
        "long": "25.083159"
      },
      {
        "name": "PRISEACA",
        "zip": "117302",
        "lat": "45.092436",
        "long": "24.845497"
      },
      {
        "name": "PRISLOPU MARE",
        "zip": "117384",
        "lat": "44.902779",
        "long": "24.733805"
      },
      {
        "name": "PRISLOPU MIC",
        "zip": "117049",
        "lat": "44.896089",
        "long": "24.74265"
      },
      {
        "name": "PRODANI",
        "zip": "117832",
        "lat": "44.753026",
        "long": "24.637136"
      },
      {
        "name": "PROSIA",
        "zip": "117523",
        "lat": "45.216959",
        "long": "24.794836"
      },
      {
        "name": "PURCARENI",
        "zip": "117468",
        "lat": "44.964526",
        "long": "24.887685"
      },
      {
        "name": "PURCARENI",
        "zip": "117594",
        "lat": "44.447043",
        "long": "25.134627"
      },
      {
        "name": "PUTINA",
        "zip": "117843",
        "lat": "45.146866",
        "long": "24.935084"
      },
      {
        "name": "RACA",
        "zip": "117596",
        "lat": "44.434658",
        "long": "25.04321"
      },
      {
        "name": "RACHITELE DE JOS",
        "zip": "117272",
        "lat": "44.878983",
        "long": "24.64705"
      },
      {
        "name": "RACHITELE DE SUS",
        "zip": "117273",
        "lat": "44.905393",
        "long": "24.651094"
      },
      {
        "name": "RACOVITA",
        "zip": "115404",
        "lat": "44.970807",
        "long": "24.975822"
      },
      {
        "name": "RADESTI",
        "zip": "117672",
        "lat": "45.07184",
        "long": "25.00207"
      },
      {
        "name": "RADU NEGRU",
        "zip": "117201",
        "lat": "44.862362",
        "long": "25.009921"
      },
      {
        "name": "RADUTESTI",
        "zip": "117264",
        "lat": "44.866229",
        "long": "24.476376"
      },
      {
        "name": "RAJLETU-GOVORA",
        "zip": "117771",
        "lat": "44.833651",
        "long": "24.585422"
      },
      {
        "name": "RANCACIOV",
        "zip": "117202",
        "lat": "44.853693",
        "long": "25.035337"
      },
      {
        "name": "RATESTI",
        "zip": "117610",
        "lat": "44.743785",
        "long": "25.127691"
      },
      {
        "name": "RATOI",
        "zip": "117833",
        "lat": "44.788333",
        "long": "24.65197"
      },
      {
        "name": "RECEA",
        "zip": "117226",
        "lat": "44.808288",
        "long": "24.969911"
      },
      {
        "name": "RECEA",
        "zip": "117620",
        "lat": "44.520287",
        "long": "25.03209"
      },
      {
        "name": "REDEA",
        "zip": "117177",
        "lat": "44.600888",
        "long": "24.904214"
      },
      {
        "name": "RETEVOIESTI",
        "zip": "117553",
        "lat": "45.14021",
        "long": "24.843172"
      },
      {
        "name": "ROBAIA",
        "zip": "117524",
        "lat": "45.218351",
        "long": "24.773094"
      },
      {
        "name": "ROCIU",
        "zip": "117625",
        "lat": "44.671232",
        "long": "25.042979"
      },
      {
        "name": "ROGOJINA",
        "zip": "117161",
        "lat": "44.937563",
        "long": "24.813496"
      },
      {
        "name": "ROMANA",
        "zip": "117772",
        "lat": "44.895955",
        "long": "24.55029"
      },
      {
        "name": "ROTUNDA",
        "zip": "117282",
        "lat": "45.282086",
        "long": "24.654205"
      },
      {
        "name": "RUCAR",
        "zip": "117630",
        "lat": "45.388571",
        "long": "25.174051"
      },
      {
        "name": "RUDENI",
        "zip": "117473",
        "lat": "45.123102",
        "long": "25.006331"
      },
      {
        "name": "RUDENI",
        "zip": "117729",
        "lat": "45.229137",
        "long": "24.55267"
      },
      {
        "name": "RUGINOASA",
        "zip": "117802",
        "lat": "45.213985",
        "long": "24.72191"
      },
      {
        "name": "SALATRUCU",
        "zip": "117635",
        "lat": "45.320323",
        "long": "24.513627"
      },
      {
        "name": "SALISTEA",
        "zip": "117773",
        "lat": "44.863856",
        "long": "24.603026"
      },
      {
        "name": "SAMAILA",
        "zip": "117604",
        "lat": "44.865543",
        "long": "25.096418"
      },
      {
        "name": "SAMARA",
        "zip": "117569",
        "lat": "44.825741",
        "long": "24.714095"
      },
      {
        "name": "SANDULESTI",
        "zip": "117314",
        "lat": "45.027826",
        "long": "24.644698"
      },
      {
        "name": "SAPUNARI",
        "zip": "117501",
        "lat": "44.971461",
        "long": "24.558839"
      },
      {
        "name": "SATIC",
        "zip": "117631",
        "lat": "45.442907",
        "long": "25.173445"
      },
      {
        "name": "SATU NOU",
        "zip": "117786",
        "lat": "44.484064",
        "long": "24.886255"
      },
      {
        "name": "SBOGHITESTI",
        "zip": "117542",
        "lat": "45.332234",
        "long": "24.806696"
      },
      {
        "name": "SCHIAU",
        "zip": "117051",
        "lat": "44.912256",
        "long": "24.799537"
      },
      {
        "name": "SCHITU GOLESTI",
        "zip": "117650",
        "lat": "45.195466",
        "long": "25.002933"
      },
      {
        "name": "SCHITU SCOICESTI",
        "zip": "117426",
        "lat": "44.816614",
        "long": "25.149623"
      },
      {
        "name": "SCHITU-MATEI",
        "zip": "117254",
        "lat": "45.095399",
        "long": "24.559263"
      },
      {
        "name": "SELAREASCA",
        "zip": "117101",
        "lat": "44.436682",
        "long": "24.780404"
      },
      {
        "name": "SELARI",
        "zip": "117813",
        "lat": "45.285101",
        "long": "25.101347"
      },
      {
        "name": "SENDRULESTI",
        "zip": "117236",
        "lat": "45.209955",
        "long": "24.545029"
      },
      {
        "name": "SERBANESTI",
        "zip": "117584",
        "lat": "45.198076",
        "long": "25.053622"
      },
      {
        "name": "SERBANESTI",
        "zip": "117628",
        "lat": "44.681422",
        "long": "24.992356"
      },
      {
        "name": "SERBOENI",
        "zip": "117178",
        "lat": "44.638182",
        "long": "24.893551"
      },
      {
        "name": "SILISTEA",
        "zip": "117227",
        "lat": "44.738737",
        "long": "25.043175"
      },
      {
        "name": "SILISTENI",
        "zip": "117444",
        "lat": "44.72031",
        "long": "24.779161"
      },
      {
        "name": "SINESTI",
        "zip": "117341",
        "lat": "44.99357",
        "long": "24.514243"
      },
      {
        "name": "SLAMNESTI",
        "zip": "117152",
        "lat": "45.274422",
        "long": "24.772218"
      },
      {
        "name": "SLANIC",
        "zip": "117037",
        "lat": "45.229591",
        "long": "24.893009"
      },
      {
        "name": "SLATINA",
        "zip": "117543",
        "lat": "45.357284",
        "long": "24.803598"
      },
      {
        "name": "SLATIOARELE",
        "zip": "117062",
        "lat": "44.859761",
        "long": "24.752658"
      },
      {
        "name": "SLOBOZIA",
        "zip": "117597",
        "lat": "44.434653",
        "long": "25.129305"
      },
      {
        "name": "SLOBOZIA",
        "zip": "117660",
        "lat": "44.52137",
        "long": "25.238137"
      },
      {
        "name": "SLOBOZIA",
        "zip": "117681",
        "lat": "45.27491",
        "long": "25.18031"
      },
      {
        "name": "SMEI",
        "zip": "115205",
        "lat": "44.729738",
        "long": "24.841215"
      },
      {
        "name": "SMEURA",
        "zip": "117512",
        "lat": "44.834055",
        "long": "24.835589"
      },
      {
        "name": "SPIRIDONI",
        "zip": "117316",
        "lat": "44.977633",
        "long": "24.587565"
      },
      {
        "name": "STALPENI",
        "zip": "117665",
        "lat": "45.054273",
        "long": "24.975992"
      },
      {
        "name": "STANESTI",
        "zip": "117291",
        "lat": "45.22909",
        "long": "24.836036"
      },
      {
        "name": "STANICEI",
        "zip": "117342",
        "lat": "44.972701",
        "long": "24.501312"
      },
      {
        "name": "STARCI",
        "zip": "115206",
        "lat": "44.700095",
        "long": "24.830155"
      },
      {
        "name": "STEFAN CEL MARE",
        "zip": "117710",
        "lat": "44.49125",
        "long": "25.248785"
      },
      {
        "name": "STEFANESTI",
        "zip": "117715",
        "lat": "44.875148",
        "long": "24.960625"
      },
      {
        "name": "STEFANESTI",
        "zip": "117704",
        "lat": "44.725571",
        "long": "24.969673"
      },
      {
        "name": "STEFANESTII NOI",
        "zip": "117719",
        "lat": "44.862515",
        "long": "24.933573"
      },
      {
        "name": "STEJARI",
        "zip": "117071",
        "lat": "45.039217",
        "long": "24.705189"
      },
      {
        "name": "STOENESTI",
        "zip": "117675",
        "lat": "45.263013",
        "long": "25.174194"
      },
      {
        "name": "STOLNICI",
        "zip": "117685",
        "lat": "44.562578",
        "long": "24.781396"
      },
      {
        "name": "STRAMBENI",
        "zip": "117192",
        "lat": "44.468972",
        "long": "24.973155"
      },
      {
        "name": "STRAMBENI",
        "zip": "117703",
        "lat": "44.694262",
        "long": "24.937905"
      },
      {
        "name": "STROESTI",
        "zip": "117526",
        "lat": "45.123502",
        "long": "24.794859"
      },
      {
        "name": "SUICI",
        "zip": "117725",
        "lat": "45.248368",
        "long": "24.538784"
      },
      {
        "name": "SURDULESTI",
        "zip": "117491",
        "lat": "44.392173",
        "long": "24.957978"
      },
      {
        "name": "SUSENI",
        "zip": "117128",
        "lat": "44.900924",
        "long": "25.14423"
      },
      {
        "name": "SUSENI",
        "zip": "117695",
        "lat": "44.710664",
        "long": "24.95424"
      },
      {
        "name": "SUSLANESTI",
        "zip": "117486",
        "lat": "45.239449",
        "long": "25.120441"
      },
      {
        "name": "TEIU",
        "zip": "117735",
        "lat": "44.655328",
        "long": "25.128608"
      },
      {
        "name": "TEODORESTI",
        "zip": "117343",
        "lat": "44.927035",
        "long": "24.485941"
      },
      {
        "name": "TIGANESTI",
        "zip": "115504",
        "lat": "44.833115",
        "long": "25.082128"
      },
      {
        "name": "TIGVENI",
        "zip": "117617",
        "lat": "44.736505",
        "long": "25.148474"
      },
      {
        "name": "TIGVENI",
        "zip": "117740",
        "lat": "45.137658",
        "long": "24.561957"
      },
      {
        "name": "TITESTI",
        "zip": "117750",
        "lat": "45.009895",
        "long": "24.988607"
      },
      {
        "name": "TOMSANCA",
        "zip": "117179",
        "lat": "44.622512",
        "long": "24.940168"
      },
      {
        "name": "TOMULESTI",
        "zip": "117579",
        "lat": "45.071107",
        "long": "24.492162"
      },
      {
        "name": "TOPLITA",
        "zip": "117448",
        "lat": "45.05714",
        "long": "24.759411"
      },
      {
        "name": "TOPOLOVENI",
        "zip": "115500",
        "lat": "44.807972",
        "long": "25.085283"
      },
      {
        "name": "TURBUREA",
        "zip": "117283",
        "lat": "45.325199",
        "long": "24.700359"
      },
      {
        "name": "TURCESTI",
        "zip": "117649",
        "lat": "44.736066",
        "long": "24.755982"
      },
      {
        "name": "TUTANA",
        "zip": "117072",
        "lat": "45.042393",
        "long": "24.650826"
      },
      {
        "name": "TUTULESTI",
        "zip": "117706",
        "lat": "44.696133",
        "long": "24.973648"
      },
      {
        "name": "UDA",
        "zip": "117755",
        "lat": "44.891032",
        "long": "24.56885"
      },
      {
        "name": "UDENI-ZAVOI",
        "zip": "117203",
        "lat": "44.82864",
        "long": "24.998609"
      },
      {
        "name": "UIASCA",
        "zip": "117052",
        "lat": "44.883878",
        "long": "24.821218"
      },
      {
        "name": "ULENI",
        "zip": "117153",
        "lat": "45.266768",
        "long": "24.779678"
      },
      {
        "name": "ULITA",
        "zip": "117086",
        "lat": "45.109749",
        "long": "24.939783"
      },
      {
        "name": "UNGHENI",
        "zip": "117780",
        "lat": "44.496049",
        "long": "24.962165"
      },
      {
        "name": "UNGURENI",
        "zip": "117154",
        "lat": "45.25593",
        "long": "24.77206"
      },
      {
        "name": "UNGURENI",
        "zip": "117803",
        "lat": "45.185281",
        "long": "24.700721"
      },
      {
        "name": "URECHESTI",
        "zip": "117248",
        "lat": "45.259326",
        "long": "24.615351"
      },
      {
        "name": "URLUCEA",
        "zip": "117204",
        "lat": "44.867208",
        "long": "25.03236"
      },
      {
        "name": "URLUENI",
        "zip": "117102",
        "lat": "44.480064",
        "long": "24.784745"
      },
      {
        "name": "URLUIESTI",
        "zip": "117237",
        "lat": "45.198323",
        "long": "24.522083"
      },
      {
        "name": "URSOAIA",
        "zip": "117317",
        "lat": "44.988885",
        "long": "24.665207"
      },
      {
        "name": "VACAREA",
        "zip": "117477",
        "lat": "45.113345",
        "long": "25.049379"
      },
      {
        "name": "VALCELELE",
        "zip": "117464",
        "lat": "45.003251",
        "long": "24.706487"
      },
      {
        "name": "VALEA BADENILOR",
        "zip": "117682",
        "lat": "45.265181",
        "long": "25.1951"
      },
      {
        "name": "VALEA BRADULUI",
        "zip": "117474",
        "lat": "45.097444",
        "long": "25.001944"
      },
      {
        "name": "VALEA BRAZILOR",
        "zip": "117073",
        "lat": "45.050032",
        "long": "24.683299"
      },
      {
        "name": "VALEA CALULUI",
        "zip": "117731",
        "lat": "45.226705",
        "long": "24.591387"
      },
      {
        "name": "VALEA CETATUIA",
        "zip": "117242",
        "lat": "45.209701",
        "long": "25.210883"
      },
      {
        "name": "VALEA CORBULUI",
        "zip": "117206",
        "lat": "44.911406",
        "long": "25.034791"
      },
      {
        "name": "VALEA CUCII",
        "zip": "117344",
        "lat": "44.9726",
        "long": "24.487094"
      },
      {
        "name": "VALEA DANULUI",
        "zip": "117790",
        "lat": "45.1783",
        "long": "24.63638"
      },
      {
        "name": "VALEA FAURULUI",
        "zip": "117527",
        "lat": "45.199714",
        "long": "24.785187"
      },
      {
        "name": "VALEA HOTARULUI",
        "zip": "117376",
        "lat": "45.320206",
        "long": "25.169442"
      },
      {
        "name": "VALEA IASULUI",
        "zip": "117795",
        "lat": "45.185803",
        "long": "24.711397"
      },
      {
        "name": "VALEA INDARAT",
        "zip": "117586",
        "lat": "45.207712",
        "long": "25.056066"
      },
      {
        "name": "VALEA LUI ENACHE",
        "zip": "117074",
        "lat": "45.079503",
        "long": "24.645573"
      },
      {
        "name": "VALEA LUI MAS",
        "zip": "117529",
        "lat": "45.21521",
        "long": "24.774389"
      },
      {
        "name": "VALEA MAGUREI",
        "zip": "117238",
        "lat": "45.191327",
        "long": "24.55979"
      },
      {
        "name": "VALEA MANASTIRII",
        "zip": "117753",
        "lat": "45.025599",
        "long": "25.012297"
      },
      {
        "name": "VALEA MARE",
        "zip": "117606",
        "lat": "44.874198",
        "long": "25.074123"
      },
      {
        "name": "VALEA MARE PRAVAT",
        "zip": "117805",
        "lat": "45.293554",
        "long": "25.093859"
      },
      {
        "name": "VALEA MARE-BRATIA",
        "zip": "117087",
        "lat": "45.072658",
        "long": "24.950784"
      },
      {
        "name": "VALEA MARE-PODGORIA",
        "zip": "117721",
        "lat": "44.885129",
        "long": "24.906131"
      },
      {
        "name": "VALEA MARULUI",
        "zip": "117162",
        "lat": "44.970183",
        "long": "24.772834"
      },
      {
        "name": "VALEA MUSCELULUI",
        "zip": "117528",
        "lat": "45.161709",
        "long": "24.76396"
      },
      {
        "name": "VALEA NANDRII",
        "zip": "117363",
        "lat": "45.017829",
        "long": "24.880271"
      },
      {
        "name": "VALEA NENII",
        "zip": "117607",
        "lat": "44.888074",
        "long": "25.09004"
      },
      {
        "name": "VALEA PECHII",
        "zip": "117656",
        "lat": "45.191467",
        "long": "25.013221"
      },
      {
        "name": "VALEA POPII",
        "zip": "117476",
        "lat": "45.091764",
        "long": "25.01766"
      },
      {
        "name": "VALEA POPII",
        "zip": "117608",
        "lat": "44.867261",
        "long": "25.086677"
      },
      {
        "name": "VALEA RIZII",
        "zip": "117364",
        "lat": "45.034198",
        "long": "24.894681"
      },
      {
        "name": "VALEA RUMANESTILOR",
        "zip": "115101",
        "lat": "45.265935",
        "long": "25.077574"
      },
      {
        "name": "VALEA SILISTII",
        "zip": "117038",
        "lat": "45.190265",
        "long": "24.907307"
      },
      {
        "name": "VALEA STANII",
        "zip": "117754",
        "lat": "44.986342",
        "long": "24.962997"
      },
      {
        "name": "VALEA ULEIULUI",
        "zip": "117804",
        "lat": "45.181353",
        "long": "24.678084"
      },
      {
        "name": "VALEA URSULUI",
        "zip": "117053",
        "lat": "44.889903",
        "long": "24.768201"
      },
      {
        "name": "VALENI",
        "zip": "117636",
        "lat": "45.260995",
        "long": "24.530588"
      },
      {
        "name": "VALENI-PODGORIA",
        "zip": "117207",
        "lat": "44.857547",
        "long": "24.989295"
      },
      {
        "name": "VALSANESTI",
        "zip": "117531",
        "lat": "45.179025",
        "long": "24.791473"
      },
      {
        "name": "VARLOVENI",
        "zip": "117318",
        "lat": "45.03119",
        "long": "24.596591"
      },
      {
        "name": "VARSESTI",
        "zip": "117836",
        "lat": "44.779953",
        "long": "24.608369"
      },
      {
        "name": "VARZAROAIA",
        "zip": "117554",
        "lat": "45.157901",
        "long": "24.835135"
      },
      {
        "name": "VARZARU",
        "zip": "117463",
        "lat": "44.937553",
        "long": "24.775524"
      },
      {
        "name": "VATA",
        "zip": "117834",
        "lat": "44.758835",
        "long": "24.669704"
      },
      {
        "name": "VEDEA",
        "zip": "117815",
        "lat": "44.780486",
        "long": "24.624091"
      },
      {
        "name": "VERNESTI",
        "zip": "117794",
        "lat": "45.200052",
        "long": "24.606784"
      },
      {
        "name": "VETISOARA",
        "zip": "117837",
        "lat": "44.762752",
        "long": "24.65433"
      },
      {
        "name": "VIISOARA",
        "zip": "117722",
        "lat": "44.854617",
        "long": "24.959775"
      },
      {
        "name": "VLADESTI",
        "zip": "117748",
        "lat": "45.156724",
        "long": "24.528998"
      },
      {
        "name": "VLADESTI",
        "zip": "117840",
        "lat": "45.154011",
        "long": "24.926941"
      },
      {
        "name": "VLADUTA",
        "zip": "117181",
        "lat": "44.625522",
        "long": "24.895919"
      },
      {
        "name": "VLASCUTA",
        "zip": "117691",
        "lat": "44.542608",
        "long": "24.787368"
      },
      {
        "name": "VOINESTI",
        "zip": "117432",
        "lat": "45.296673",
        "long": "25.077654"
      },
      {
        "name": "VONIGEASA",
        "zip": "117346",
        "lat": "44.982312",
        "long": "24.542219"
      },
      {
        "name": "VOROVENI",
        "zip": "117352",
        "lat": "45.026329",
        "long": "25.063618"
      },
      {
        "name": "VRANESTI",
        "zip": "117210",
        "lat": "44.839836",
        "long": "24.999886"
      },
      {
        "name": "VULPESTI",
        "zip": "117182",
        "lat": "44.592133",
        "long": "24.931371"
      },
      {
        "name": "VULTURESTI",
        "zip": "117402",
        "lat": "45.066029",
        "long": "25.082803"
      },
      {
        "name": "ZAMFIRESTI",
        "zip": "117239",
        "lat": "45.191967",
        "long": "24.506837"
      },
      {
        "name": "ZAMFIRESTI",
        "zip": "117319",
        "lat": "44.982485",
        "long": "24.654381"
      },
      {
        "name": "ZARNESTI",
        "zip": "117449",
        "lat": "45.017002",
        "long": "24.778372"
      },
      {
        "name": "ZAVOI",
        "zip": "117723",
        "lat": "44.860617",
        "long": "24.891806"
      },
      {
        "name": "ZGRIPCESTI",
        "zip": "117114",
        "lat": "44.937766",
        "long": "25.075301"
      },
      {
        "name": "ZIDURILE",
        "zip": "117517",
        "lat": "44.57852",
        "long": "25.169515"
      },
      {
        "name": "ZIGONENI",
        "zip": "117076",
        "lat": "45.090731",
        "long": "24.676804"
      },
      {
        "name": "ZUVELCATI",
        "zip": "117103",
        "lat": "44.469482",
        "long": "24.762865"
      }
    ],
    "BACĂU": [
      {
        "name": "AGAS",
        "zip": "607005",
        "lat": "46.481985",
        "long": "26.227059"
      },
      {
        "name": "ALBELE",
        "zip": "607036",
        "lat": "46.364867",
        "long": "26.67338"
      },
      {
        "name": "ANTOHESTI",
        "zip": "607261",
        "lat": "46.550992",
        "long": "27.245024"
      },
      {
        "name": "APA ASAU",
        "zip": "607021",
        "lat": "46.487469",
        "long": "26.378875"
      },
      {
        "name": "ARDEOANI",
        "zip": "607015",
        "lat": "46.533436",
        "long": "26.619425"
      },
      {
        "name": "ARINI",
        "zip": "607196",
        "lat": "46.347789",
        "long": "27.194638"
      },
      {
        "name": "ASAU",
        "zip": "607020",
        "lat": "46.438897",
        "long": "26.40084"
      },
      {
        "name": "BACAU",
        "zip": "600001",
        "lat": "46.556049",
        "long": "26.915356"
      },
      {
        "name": "BACIOIU",
        "zip": "607121",
        "lat": "46.31431",
        "long": "27.157452"
      },
      {
        "name": "BACLESTI",
        "zip": "607326",
        "lat": "46.354248",
        "long": "27.443829"
      },
      {
        "name": "BAHNA",
        "zip": "607426",
        "lat": "46.225919",
        "long": "26.648965"
      },
      {
        "name": "BAHNASENI",
        "zip": "607431",
        "lat": "46.572529",
        "long": "26.581841"
      },
      {
        "name": "BAIMAC",
        "zip": "607262",
        "lat": "46.625011",
        "long": "27.215503"
      },
      {
        "name": "BALAIA",
        "zip": "607176",
        "lat": "46.574358",
        "long": "27.188945"
      },
      {
        "name": "BALANEASA",
        "zip": "607286",
        "lat": "46.389555",
        "long": "26.732955"
      },
      {
        "name": "BALANESTI",
        "zip": "607142",
        "lat": "46.332636",
        "long": "27.317409"
      },
      {
        "name": "BALANESTI",
        "zip": "607451",
        "lat": "46.197949",
        "long": "27.358989"
      },
      {
        "name": "BALCA",
        "zip": "607131",
        "lat": "46.136486",
        "long": "26.975432"
      },
      {
        "name": "BALCANI",
        "zip": "607030",
        "lat": "46.645706",
        "long": "26.566653"
      },
      {
        "name": "BALOTESTI",
        "zip": "607586",
        "lat": "46.401676",
        "long": "27.3135"
      },
      {
        "name": "BALTATA",
        "zip": "607356",
        "lat": "46.489148",
        "long": "26.869746"
      },
      {
        "name": "BALUSA",
        "zip": "607561",
        "lat": "46.653577",
        "long": "27.111711"
      },
      {
        "name": "BANCA",
        "zip": "607141",
        "lat": "46.347594",
        "long": "27.291414"
      },
      {
        "name": "BARATI",
        "zip": "607316",
        "lat": "46.574625",
        "long": "26.871867"
      },
      {
        "name": "BARBOASA",
        "zip": "607376",
        "lat": "46.463761",
        "long": "27.240238"
      },
      {
        "name": "BARCANA",
        "zip": "607491",
        "lat": "46.487597",
        "long": "27.361087"
      },
      {
        "name": "BARNA",
        "zip": "607401",
        "lat": "46.495777",
        "long": "27.168804"
      },
      {
        "name": "BARNESTI",
        "zip": "607432",
        "lat": "46.592579",
        "long": "26.571959"
      },
      {
        "name": "BARSANESTI",
        "zip": "607035",
        "lat": "46.330768",
        "long": "26.689901"
      },
      {
        "name": "BARTASESTI",
        "zip": "607646",
        "lat": "46.590702",
        "long": "27.127992"
      },
      {
        "name": "BARZULESTI",
        "zip": "607531",
        "lat": "46.493688",
        "long": "26.774154"
      },
      {
        "name": "BASASTI",
        "zip": "607433",
        "lat": "46.622333",
        "long": "26.601386"
      },
      {
        "name": "BAZGA",
        "zip": "607241",
        "lat": "46.379828",
        "long": "27.023769"
      },
      {
        "name": "BELCIUNEASA",
        "zip": "607587",
        "lat": "46.375395",
        "long": "27.316525"
      },
      {
        "name": "BELEGHET",
        "zip": "607006",
        "lat": "46.472566",
        "long": "26.260125"
      },
      {
        "name": "BENESTI",
        "zip": "607588",
        "lat": "46.362655",
        "long": "27.337678"
      },
      {
        "name": "BERBINCENI",
        "zip": "607562",
        "lat": "46.679465",
        "long": "27.065178"
      },
      {
        "name": "BERESTI",
        "zip": "607521",
        "lat": "46.203288",
        "long": "27.144762"
      },
      {
        "name": "BERESTI-BISTRITA",
        "zip": "607040",
        "lat": "46.709399",
        "long": "26.858044"
      },
      {
        "name": "BERESTI-TAZLAU",
        "zip": "607050",
        "lat": "46.469616",
        "long": "26.677333"
      },
      {
        "name": "BERZUNTI",
        "zip": "607060",
        "lat": "46.411751",
        "long": "26.659865"
      },
      {
        "name": "BIBIRESTI",
        "zip": "607647",
        "lat": "46.518551",
        "long": "27.077468"
      },
      {
        "name": "BIJGHIR",
        "zip": "607086",
        "lat": "46.600859",
        "long": "27.019967"
      },
      {
        "name": "BLAGA",
        "zip": "607143",
        "lat": "46.26317",
        "long": "27.281204"
      },
      {
        "name": "BLAGESTI",
        "zip": "607065",
        "lat": "46.690729",
        "long": "26.674404"
      },
      {
        "name": "BLIDARI",
        "zip": "607096",
        "lat": "46.161222",
        "long": "26.921309"
      },
      {
        "name": "BOANTA",
        "zip": "607186",
        "lat": "46.776838",
        "long": "26.917622"
      },
      {
        "name": "BOBOS",
        "zip": "607144",
        "lat": "46.293705",
        "long": "27.320696"
      },
      {
        "name": "BODEASA",
        "zip": "607146",
        "lat": "46.304062",
        "long": "27.264122"
      },
      {
        "name": "BOGATA",
        "zip": "607161",
        "lat": "46.299131",
        "long": "26.558594"
      },
      {
        "name": "BOGDAN VODA",
        "zip": "607541",
        "lat": "46.619911",
        "long": "26.921789"
      },
      {
        "name": "BOGDANA",
        "zip": "607606",
        "lat": "46.187546",
        "long": "26.844748"
      },
      {
        "name": "BOGDANESTI",
        "zip": "607070",
        "lat": "46.212047",
        "long": "26.682083"
      },
      {
        "name": "BOGDANESTI",
        "zip": "607551",
        "lat": "46.604915",
        "long": "26.697351"
      },
      {
        "name": "BOGDANESTI",
        "zip": "607636",
        "lat": "46.665703",
        "long": "27.016069"
      },
      {
        "name": "BOISTEA",
        "zip": "607097",
        "lat": "46.191628",
        "long": "26.966989"
      },
      {
        "name": "BOISTEA DE JOS",
        "zip": "607132",
        "lat": "46.178159",
        "long": "26.989282"
      },
      {
        "name": "BOLATAU",
        "zip": "607691",
        "lat": "46.624052",
        "long": "26.418005"
      },
      {
        "name": "BOLOVANIS",
        "zip": "607206",
        "lat": "46.616365",
        "long": "26.051691"
      },
      {
        "name": "BORSANI",
        "zip": "607133",
        "lat": "46.150328",
        "long": "26.978581"
      },
      {
        "name": "BORZESTI",
        "zip": "601001",
        "lat": "46.242134",
        "long": "26.82053"
      },
      {
        "name": "BOSIA",
        "zip": "607666",
        "lat": "46.386562",
        "long": "27.279799"
      },
      {
        "name": "BOSOTENI",
        "zip": "607051",
        "lat": "46.50122",
        "long": "26.680255"
      },
      {
        "name": "BOSTANESTI",
        "zip": "607147",
        "lat": "46.316465",
        "long": "27.318989"
      },
      {
        "name": "BOTA",
        "zip": "607648",
        "lat": "46.521269",
        "long": "27.141171"
      },
      {
        "name": "BOTESTI",
        "zip": "607649",
        "lat": "46.567529",
        "long": "27.082635"
      },
      {
        "name": "BRAD",
        "zip": "607041",
        "lat": "46.687479",
        "long": "26.878481"
      },
      {
        "name": "BRAD",
        "zip": "607177",
        "lat": "46.566078",
        "long": "27.171384"
      },
      {
        "name": "BRAD",
        "zip": "607346",
        "lat": "46.724685",
        "long": "26.952247"
      },
      {
        "name": "BRATESTI",
        "zip": "607037",
        "lat": "46.325316",
        "long": "26.642866"
      },
      {
        "name": "BRATILA",
        "zip": "607231",
        "lat": "46.323017",
        "long": "26.77411"
      },
      {
        "name": "BRUSTUROASA",
        "zip": "607075",
        "lat": "46.521755",
        "long": "26.17844"
      },
      {
        "name": "BUCHILA",
        "zip": "607357",
        "lat": "46.455349",
        "long": "26.878398"
      },
      {
        "name": "BUCIUMI",
        "zip": "607607",
        "lat": "46.202298",
        "long": "26.784452"
      },
      {
        "name": "BUCSA",
        "zip": "607492",
        "lat": "46.361378",
        "long": "27.416443"
      },
      {
        "name": "BUCSESTI",
        "zip": "607466",
        "lat": "46.483716",
        "long": "26.582242"
      },
      {
        "name": "BUDA",
        "zip": "607061",
        "lat": "46.422506",
        "long": "26.589667"
      },
      {
        "name": "BUDA",
        "zip": "607066",
        "lat": "46.671112",
        "long": "26.719529"
      },
      {
        "name": "BUDA",
        "zip": "607493",
        "lat": "46.514309",
        "long": "27.35992"
      },
      {
        "name": "BUDESTI",
        "zip": "607441",
        "lat": "46.658119",
        "long": "27.249877"
      },
      {
        "name": "BUHOCEL",
        "zip": "607087",
        "lat": "46.547276",
        "long": "27.0107"
      },
      {
        "name": "BUHOCI",
        "zip": "607085",
        "lat": "46.566403",
        "long": "27.01933"
      },
      {
        "name": "BUHUSI",
        "zip": "605100",
        "lat": "46.716285",
        "long": "26.704703"
      },
      {
        "name": "BURDUSACI",
        "zip": "607494",
        "lat": "46.368751",
        "long": "27.403258"
      },
      {
        "name": "BURUIENIS",
        "zip": "607076",
        "lat": "46.508842",
        "long": "26.198708"
      },
      {
        "name": "BURUIENISU DE SUS",
        "zip": "607077",
        "lat": "46.516235",
        "long": "26.22293"
      },
      {
        "name": "CABESTI",
        "zip": "607452",
        "lat": "46.202191",
        "long": "27.441171"
      },
      {
        "name": "CADARESTI",
        "zip": "607391",
        "lat": "46.473274",
        "long": "26.082619"
      },
      {
        "name": "CAIUTI",
        "zip": "607095",
        "lat": "46.183589",
        "long": "26.929892"
      },
      {
        "name": "CALAPODESTI",
        "zip": "607148",
        "lat": "46.344444",
        "long": "27.306228"
      },
      {
        "name": "CALCAI",
        "zip": "607366",
        "lat": "46.20595",
        "long": "26.59942"
      },
      {
        "name": "CALINESTI",
        "zip": "607347",
        "lat": "46.713494",
        "long": "26.960291"
      },
      {
        "name": "CALINI",
        "zip": "607111",
        "lat": "46.593652",
        "long": "27.274721"
      },
      {
        "name": "CALUGARENI",
        "zip": "607136",
        "lat": "46.744851",
        "long": "27.022614"
      },
      {
        "name": "CAMENCA",
        "zip": "607078",
        "lat": "46.531622",
        "long": "26.199723"
      },
      {
        "name": "CAMPENI",
        "zip": "607434",
        "lat": "46.600608",
        "long": "26.627382"
      },
      {
        "name": "CAPATA",
        "zip": "607221",
        "lat": "46.324744",
        "long": "26.881951"
      },
      {
        "name": "CAPOTESTI",
        "zip": "607251",
        "lat": "46.253721",
        "long": "27.265167"
      },
      {
        "name": "CARACLAU",
        "zip": "607038",
        "lat": "46.306959",
        "long": "26.716407"
      },
      {
        "name": "CARLIGI",
        "zip": "607187",
        "lat": "46.765833",
        "long": "26.850531"
      },
      {
        "name": "CASIN",
        "zip": "607090",
        "lat": "46.1992",
        "long": "26.744917"
      },
      {
        "name": "CAUIA",
        "zip": "607149",
        "lat": "46.281538",
        "long": "27.282536"
      },
      {
        "name": "CERDAC",
        "zip": "605501",
        "lat": "46.237939",
        "long": "26.516384"
      },
      {
        "name": "CERNU",
        "zip": "607467",
        "lat": "46.469992",
        "long": "26.584767"
      },
      {
        "name": "CETATUIA",
        "zip": "607596",
        "lat": "46.553618",
        "long": "26.706075"
      },
      {
        "name": "CHETRENI",
        "zip": "607327",
        "lat": "46.301003",
        "long": "27.430995"
      },
      {
        "name": "CHETRIS",
        "zip": "607616",
        "lat": "46.466232",
        "long": "26.991324"
      },
      {
        "name": "CHICEREA",
        "zip": "607328",
        "lat": "46.307203",
        "long": "27.412537"
      },
      {
        "name": "CHILIA BENEI",
        "zip": "607416",
        "lat": "46.341401",
        "long": "27.129173"
      },
      {
        "name": "CHITICENI",
        "zip": "607563",
        "lat": "46.665745",
        "long": "27.09305"
      },
      {
        "name": "CIOBANUS",
        "zip": "607022",
        "lat": "46.445277",
        "long": "26.338439"
      },
      {
        "name": "CIRESOAIA",
        "zip": "605502",
        "lat": "46.248277",
        "long": "26.549607"
      },
      {
        "name": "CIUCANI",
        "zip": "607481",
        "lat": "46.361615",
        "long": "26.923405"
      },
      {
        "name": "CIUGHES",
        "zip": "607392",
        "lat": "46.522198",
        "long": "26.119696"
      },
      {
        "name": "CIUMASI",
        "zip": "607042",
        "lat": "46.677834",
        "long": "26.838847"
      },
      {
        "name": "CIUTURESTI",
        "zip": "607564",
        "lat": "46.69163",
        "long": "27.123602"
      },
      {
        "name": "CLEJA",
        "zip": "607105",
        "lat": "46.409755",
        "long": "26.918043"
      },
      {
        "name": "CLIMESTI",
        "zip": "607043",
        "lat": "46.723728",
        "long": "26.848916"
      },
      {
        "name": "COCIU",
        "zip": "607329",
        "lat": "46.287305",
        "long": "27.433506"
      },
      {
        "name": "COLONESTI",
        "zip": "607110",
        "lat": "46.578261",
        "long": "27.301443"
      },
      {
        "name": "COMAN",
        "zip": "607532",
        "lat": "46.473713",
        "long": "26.768127"
      },
      {
        "name": "COMANESTI",
        "zip": "605200",
        "lat": "46.421524",
        "long": "26.440327"
      },
      {
        "name": "CONTESTI",
        "zip": "607522",
        "lat": "46.168868",
        "long": "27.07534"
      },
      {
        "name": "CORBASCA",
        "zip": "607120",
        "lat": "46.288183",
        "long": "27.162205"
      },
      {
        "name": "CORNATEL",
        "zip": "607656",
        "lat": "46.13036",
        "long": "27.044129"
      },
      {
        "name": "CORNATELU",
        "zip": "607331",
        "lat": "46.326277",
        "long": "27.358607"
      },
      {
        "name": "CORNESTI",
        "zip": "607188",
        "lat": "46.766962",
        "long": "26.925522"
      },
      {
        "name": "CORNET",
        "zip": "607468",
        "lat": "46.493465",
        "long": "26.593083"
      },
      {
        "name": "CORNII DE JOS",
        "zip": "607621",
        "lat": "46.204012",
        "long": "27.19353"
      },
      {
        "name": "CORNII DE SUS",
        "zip": "607622",
        "lat": "46.218054",
        "long": "27.1826"
      },
      {
        "name": "COSNEA",
        "zip": "607007",
        "lat": "46.43179",
        "long": "26.075973"
      },
      {
        "name": "COSTEI",
        "zip": "607542",
        "lat": "46.60918",
        "long": "26.971597"
      },
      {
        "name": "COTENI",
        "zip": "607088",
        "lat": "46.531945",
        "long": "27.001813"
      },
      {
        "name": "COTOFANESTI",
        "zip": "607130",
        "lat": "46.14844",
        "long": "26.992974"
      },
      {
        "name": "COTU GROSULUI",
        "zip": "607189",
        "lat": "46.740095",
        "long": "26.930959"
      },
      {
        "name": "COTUMBA",
        "zip": "607008",
        "lat": "46.497427",
        "long": "26.191116"
      },
      {
        "name": "CRAIESTI",
        "zip": "607589",
        "lat": "46.387001",
        "long": "27.340231"
      },
      {
        "name": "CRIHAN",
        "zip": "607306",
        "lat": "46.570784",
        "long": "26.828602"
      },
      {
        "name": "CUCHINIS",
        "zip": "607079",
        "lat": "46.529536",
        "long": "26.14425"
      },
      {
        "name": "CUCOVA",
        "zip": "607661",
        "lat": "46.254223",
        "long": "27.044753"
      },
      {
        "name": "CUCUIETI",
        "zip": "607162",
        "lat": "46.326088",
        "long": "26.553037"
      },
      {
        "name": "CUCUIETI",
        "zip": "607581",
        "lat": "46.589796",
        "long": "26.528746"
      },
      {
        "name": "CURITA",
        "zip": "607091",
        "lat": "46.191239",
        "long": "26.710384"
      },
      {
        "name": "DADESTI",
        "zip": "607667",
        "lat": "46.381229",
        "long": "27.263218"
      },
      {
        "name": "DAMIENESTI",
        "zip": "607135",
        "lat": "46.737769",
        "long": "26.99553"
      },
      {
        "name": "DANAILA",
        "zip": "607496",
        "lat": "46.537157",
        "long": "27.330306"
      },
      {
        "name": "DARMANEASCA",
        "zip": "605301",
        "lat": "46.387174",
        "long": "26.48734"
      },
      {
        "name": "DARMANESTI",
        "zip": "605300",
        "lat": "46.369045",
        "long": "26.470511"
      },
      {
        "name": "DEALU MARE",
        "zip": "607307",
        "lat": "46.549935",
        "long": "26.842133"
      },
      {
        "name": "DEALU MORII",
        "zip": "607140",
        "lat": "46.302613",
        "long": "27.297592"
      },
      {
        "name": "DEALU PERJULUI",
        "zip": "607377",
        "lat": "46.462459",
        "long": "27.263484"
      },
      {
        "name": "DELENI",
        "zip": "607232",
        "lat": "46.3536",
        "long": "26.776284"
      },
      {
        "name": "DIACONESTI",
        "zip": "607009",
        "lat": "46.461955",
        "long": "26.26516"
      },
      {
        "name": "DIENET",
        "zip": "607417",
        "lat": "46.324126",
        "long": "27.085192"
      },
      {
        "name": "DOFTEANA",
        "zip": "607160",
        "lat": "46.321638",
        "long": "26.527839"
      },
      {
        "name": "DORNENI",
        "zip": "607442",
        "lat": "46.660375",
        "long": "27.243552"
      },
      {
        "name": "DORNENI",
        "zip": "607668",
        "lat": "46.425375",
        "long": "27.176693"
      },
      {
        "name": "DOROFEI",
        "zip": "607151",
        "lat": "46.327714",
        "long": "27.306456"
      },
      {
        "name": "DOSPINESTI",
        "zip": "607089",
        "lat": "46.58216",
        "long": "26.987873"
      },
      {
        "name": "DRAGESTI",
        "zip": "607137",
        "lat": "46.73839",
        "long": "26.96071"
      },
      {
        "name": "DRAGESTI",
        "zip": "607623",
        "lat": "46.24924",
        "long": "27.191875"
      },
      {
        "name": "DRAGOMIR",
        "zip": "607062",
        "lat": "46.413731",
        "long": "26.631634"
      },
      {
        "name": "DRAGUGESTI",
        "zip": "607233",
        "lat": "46.367957",
        "long": "26.774331"
      },
      {
        "name": "DRAGUSANI",
        "zip": "607396",
        "lat": "46.29823",
        "long": "26.986529"
      },
      {
        "name": "DUMBRAVA",
        "zip": "607222",
        "lat": "46.308887",
        "long": "26.885812"
      },
      {
        "name": "DUMBRAVA",
        "zip": "607044",
        "lat": "46.670511",
        "long": "26.900539"
      },
      {
        "name": "DUMBRAVA",
        "zip": "607497",
        "lat": "46.418182",
        "long": "27.352336"
      },
      {
        "name": "ENACHESTI",
        "zip": "607052",
        "lat": "46.48918",
        "long": "26.705853"
      },
      {
        "name": "FAGET",
        "zip": "607207",
        "lat": "46.588907",
        "long": "26.053494"
      },
      {
        "name": "FAGETEL",
        "zip": "607046",
        "lat": "46.687518",
        "long": "26.81339"
      },
      {
        "name": "FAGETU DE SUS",
        "zip": "607208",
        "lat": "46.603585",
        "long": "26.011165"
      },
      {
        "name": "FAGHIENI",
        "zip": "607263",
        "lat": "46.538563",
        "long": "27.257156"
      },
      {
        "name": "FANTANELE",
        "zip": "607236",
        "lat": "46.602763",
        "long": "26.845719"
      },
      {
        "name": "FANTANELE",
        "zip": "607332",
        "lat": "46.338724",
        "long": "27.442168"
      },
      {
        "name": "FARAOANI",
        "zip": "607170",
        "lat": "46.432109",
        "long": "26.896309"
      },
      {
        "name": "FARCASA",
        "zip": "607498",
        "lat": "46.499184",
        "long": "27.351578"
      },
      {
        "name": "FERESTRAU-OITUZ",
        "zip": "607367",
        "lat": "46.202492",
        "long": "26.576288"
      },
      {
        "name": "FICHITESTI",
        "zip": "607453",
        "lat": "46.194793",
        "long": "27.477459"
      },
      {
        "name": "FILIPENI",
        "zip": "607175",
        "lat": "46.540733",
        "long": "27.188423"
      },
      {
        "name": "FILIPESTI",
        "zip": "607071",
        "lat": "46.223751",
        "long": "26.716917"
      },
      {
        "name": "FILIPESTI",
        "zip": "607185",
        "lat": "46.744508",
        "long": "26.886485"
      },
      {
        "name": "FLORESTI",
        "zip": "607098",
        "lat": "46.217544",
        "long": "26.893696"
      },
      {
        "name": "FLORESTI",
        "zip": "607252",
        "lat": "46.25861",
        "long": "27.224451"
      },
      {
        "name": "FLORESTI",
        "zip": "607552",
        "lat": "46.52441",
        "long": "26.665707"
      },
      {
        "name": "FRUMOASA",
        "zip": "607031",
        "lat": "46.66442",
        "long": "26.532558"
      },
      {
        "name": "FRUMUSELU",
        "zip": "607216",
        "lat": "46.277963",
        "long": "27.352029"
      },
      {
        "name": "FRUNTESTI",
        "zip": "607178",
        "lat": "46.49662",
        "long": "27.212065"
      },
      {
        "name": "FULGERIS",
        "zip": "607418",
        "lat": "46.333847",
        "long": "27.119202"
      },
      {
        "name": "FUNDATURA",
        "zip": "607333",
        "lat": "46.337011",
        "long": "27.463728"
      },
      {
        "name": "FUNDATURA RACHITOASA",
        "zip": "607499",
        "lat": "46.460746",
        "long": "27.351578"
      },
      {
        "name": "FUNDENI",
        "zip": "607566",
        "lat": "46.655866",
        "long": "27.073332"
      },
      {
        "name": "FUNDOAIA",
        "zip": "607253",
        "lat": "46.302796",
        "long": "27.202747"
      },
      {
        "name": "FUNDU RACACIUNI",
        "zip": "607482",
        "lat": "46.358642",
        "long": "26.889871"
      },
      {
        "name": "FUNDU TUTOVEI",
        "zip": "607443",
        "lat": "46.699429",
        "long": "27.182239"
      },
      {
        "name": "FUNDU VAII",
        "zip": "607419",
        "lat": "46.421415",
        "long": "27.135449"
      },
      {
        "name": "FURNICARI",
        "zip": "607617",
        "lat": "46.508146",
        "long": "26.997932"
      },
      {
        "name": "GAICEANA",
        "zip": "607195",
        "lat": "46.330061",
        "long": "27.232593"
      },
      {
        "name": "GALBENI",
        "zip": "607191",
        "lat": "46.742345",
        "long": "26.84282"
      },
      {
        "name": "GALBENI",
        "zip": "607358",
        "lat": "46.456606",
        "long": "26.946635"
      },
      {
        "name": "GALERI",
        "zip": "607242",
        "lat": "46.399376",
        "long": "27.047085"
      },
      {
        "name": "GARLA ANEI",
        "zip": "607651",
        "lat": "46.553003",
        "long": "27.093244"
      },
      {
        "name": "GARLENI",
        "zip": "607200",
        "lat": "46.658229",
        "long": "26.807897"
      },
      {
        "name": "GARLENII DE SUS",
        "zip": "607201",
        "lat": "46.651097",
        "long": "26.801379"
      },
      {
        "name": "GASTENI",
        "zip": "607483",
        "lat": "46.339742",
        "long": "26.966952"
      },
      {
        "name": "GAZARIE",
        "zip": "605401",
        "lat": "46.489104",
        "long": "26.519244"
      },
      {
        "name": "GHEORGHE DOJA",
        "zip": "607484",
        "lat": "46.378362",
        "long": "26.962399"
      },
      {
        "name": "GHERDANA",
        "zip": "607624",
        "lat": "46.265177",
        "long": "27.184583"
      },
      {
        "name": "GHILAVESTI",
        "zip": "607669",
        "lat": "46.439269",
        "long": "27.175825"
      },
      {
        "name": "GHIMES",
        "zip": "607209",
        "lat": "46.567602",
        "long": "26.08901"
      },
      {
        "name": "GHIONOAIA",
        "zip": "607152",
        "lat": "46.352433",
        "long": "27.272145"
      },
      {
        "name": "GIOSENI",
        "zip": "607618",
        "lat": "46.429245",
        "long": "26.99239"
      },
      {
        "name": "GIURGENI",
        "zip": "607626",
        "lat": "46.238073",
        "long": "27.198169"
      },
      {
        "name": "GIURGIOANA",
        "zip": "607454",
        "lat": "46.172388",
        "long": "27.357676"
      },
      {
        "name": "GLAVANESTI",
        "zip": "607215",
        "lat": "46.244696",
        "long": "27.397467"
      },
      {
        "name": "GLODISOARELE",
        "zip": "607567",
        "lat": "46.620938",
        "long": "27.152303"
      },
      {
        "name": "GODINESTII DE JOS",
        "zip": "607671",
        "lat": "46.419323",
        "long": "27.230195"
      },
      {
        "name": "GODINESTII DE SUS",
        "zip": "607672",
        "lat": "46.427926",
        "long": "27.217377"
      },
      {
        "name": "GOIOASA",
        "zip": "607011",
        "lat": "46.447226",
        "long": "26.298064"
      },
      {
        "name": "GORGHESTI",
        "zip": "607591",
        "lat": "46.442925",
        "long": "27.288626"
      },
      {
        "name": "GRADESTI",
        "zip": "607153",
        "lat": "46.298018",
        "long": "27.27769"
      },
      {
        "name": "GRIGORENI",
        "zip": "607553",
        "lat": "46.596586",
        "long": "26.681751"
      },
      {
        "name": "GURA CRAIESTI",
        "zip": "607334",
        "lat": "46.339334",
        "long": "27.365185"
      },
      {
        "name": "GURA VAII",
        "zip": "607220",
        "lat": "46.269198",
        "long": "26.830287"
      },
      {
        "name": "GURA VAII",
        "zip": "607476",
        "lat": "46.685204",
        "long": "26.795552"
      },
      {
        "name": "GUTINAS",
        "zip": "607608",
        "lat": "46.206674",
        "long": "26.820528"
      },
      {
        "name": "HAGHIAC",
        "zip": "607163",
        "lat": "46.312003",
        "long": "26.518411"
      },
      {
        "name": "HAGHIAC",
        "zip": "607501",
        "lat": "46.373097",
        "long": "27.38473"
      },
      {
        "name": "HAINEALA",
        "zip": "607436",
        "lat": "46.614711",
        "long": "26.608723"
      },
      {
        "name": "HALMACIOAIA",
        "zip": "607477",
        "lat": "46.701225",
        "long": "26.781431"
      },
      {
        "name": "HANGANESTI",
        "zip": "607081",
        "lat": "46.505339",
        "long": "26.19439"
      },
      {
        "name": "HANTA",
        "zip": "607456",
        "lat": "46.184803",
        "long": "27.367186"
      },
      {
        "name": "HARJA",
        "zip": "607368",
        "lat": "46.16867",
        "long": "26.474419"
      },
      {
        "name": "HARLESTI",
        "zip": "607192",
        "lat": "46.816961",
        "long": "26.894259"
      },
      {
        "name": "HELEGIU",
        "zip": "607230",
        "lat": "46.353646",
        "long": "26.742229"
      },
      {
        "name": "HELTIU",
        "zip": "607099",
        "lat": "46.200804",
        "long": "26.928765"
      },
      {
        "name": "HEMEIUS",
        "zip": "607235",
        "lat": "46.626426",
        "long": "26.854396"
      },
      {
        "name": "HEMIENI",
        "zip": "607439",
        "lat": "46.557996",
        "long": "26.626335"
      },
      {
        "name": "HERTIOANA DE JOS",
        "zip": "607637",
        "lat": "46.64619",
        "long": "27.039731"
      },
      {
        "name": "HERTIOANA-RAZESI",
        "zip": "607638",
        "lat": "46.651711",
        "long": "27.030979"
      },
      {
        "name": "HOLT",
        "zip": "607271",
        "lat": "46.578558",
        "long": "26.974991"
      },
      {
        "name": "HORGESTI",
        "zip": "607240",
        "lat": "46.439585",
        "long": "27.068725"
      },
      {
        "name": "HURUIESTI",
        "zip": "607250",
        "lat": "46.251047",
        "long": "27.24394"
      },
      {
        "name": "HUTU",
        "zip": "607197",
        "lat": "46.375076",
        "long": "27.217961"
      },
      {
        "name": "IAZ",
        "zip": "607597",
        "lat": "46.505905",
        "long": "26.749747"
      },
      {
        "name": "ILIESI",
        "zip": "607478",
        "lat": "46.703122",
        "long": "26.801729"
      },
      {
        "name": "ITCANI",
        "zip": "607444",
        "lat": "46.677908",
        "long": "27.258173"
      },
      {
        "name": "ITESTI",
        "zip": "607047",
        "lat": "46.657899",
        "long": "26.864706"
      },
      {
        "name": "IZVORU BERHECIULUI",
        "zip": "607260",
        "lat": "46.586537",
        "long": "27.220234"
      },
      {
        "name": "LAPOS",
        "zip": "605302",
        "lat": "46.393509",
        "long": "26.462688"
      },
      {
        "name": "LARGA",
        "zip": "607164",
        "lat": "46.350601",
        "long": "26.533213"
      },
      {
        "name": "LARGUTA",
        "zip": "607359",
        "lat": "46.479641",
        "long": "26.813954"
      },
      {
        "name": "LEHANCEA",
        "zip": "607457",
        "lat": "46.196159",
        "long": "27.34385"
      },
      {
        "name": "LEONTINESTI",
        "zip": "607016",
        "lat": "46.520666",
        "long": "26.592777"
      },
      {
        "name": "LESPEZI",
        "zip": "607202",
        "lat": "46.66493",
        "long": "26.768821"
      },
      {
        "name": "LETEA VECHE",
        "zip": "607270",
        "lat": "46.555264",
        "long": "26.946933"
      },
      {
        "name": "LICHITISENI",
        "zip": "607673",
        "lat": "46.377283",
        "long": "27.287919"
      },
      {
        "name": "LILIECI",
        "zip": "607237",
        "lat": "46.62861",
        "long": "26.871765"
      },
      {
        "name": "LIPOVA",
        "zip": "607275",
        "lat": "46.715342",
        "long": "27.244522"
      },
      {
        "name": "LIVEZI",
        "zip": "607285",
        "lat": "46.406393",
        "long": "26.736128"
      },
      {
        "name": "LUDASI",
        "zip": "607032",
        "lat": "46.620267",
        "long": "26.579965"
      },
      {
        "name": "LUIZI-CALUGARA",
        "zip": "607295",
        "lat": "46.531565",
        "long": "26.844782"
      },
      {
        "name": "LUNCA ASAU",
        "zip": "607023",
        "lat": "46.434576",
        "long": "26.411376"
      },
      {
        "name": "LUNCA DOCHIEI",
        "zip": "607657",
        "lat": "46.117213",
        "long": "27.072287"
      },
      {
        "name": "LUNCANI",
        "zip": "607317",
        "lat": "46.6089",
        "long": "26.762605"
      },
      {
        "name": "LUPESTI",
        "zip": "607311",
        "lat": "46.169011",
        "long": "26.732907"
      },
      {
        "name": "MAGAZIA",
        "zip": "607502",
        "lat": "46.525938",
        "long": "27.343621"
      },
      {
        "name": "MAGIRESTI",
        "zip": "607300",
        "lat": "46.510992",
        "long": "26.545702"
      },
      {
        "name": "MAGLA",
        "zip": "607348",
        "lat": "46.697421",
        "long": "26.959497"
      },
      {
        "name": "MAGURA",
        "zip": "607305",
        "lat": "46.561628",
        "long": "26.8605"
      },
      {
        "name": "MALOSU",
        "zip": "607276",
        "lat": "46.737996",
        "long": "27.175518"
      },
      {
        "name": "MANASTIREA CASIN",
        "zip": "607310",
        "lat": "46.152127",
        "long": "26.691021"
      },
      {
        "name": "MARASCU",
        "zip": "607243",
        "lat": "46.424575",
        "long": "27.109157"
      },
      {
        "name": "MARASTI",
        "zip": "607179",
        "lat": "46.582078",
        "long": "27.16714"
      },
      {
        "name": "MARCESTI",
        "zip": "607101",
        "lat": "46.173152",
        "long": "26.897278"
      },
      {
        "name": "MARGINEA",
        "zip": "605101",
        "lat": "46.729382",
        "long": "26.727677"
      },
      {
        "name": "MARGINEA",
        "zip": "607369",
        "lat": "46.21478",
        "long": "26.641348"
      },
      {
        "name": "MARGINENI",
        "zip": "607315",
        "lat": "46.586185",
        "long": "26.852109"
      },
      {
        "name": "MARVILA",
        "zip": "607122",
        "lat": "46.301867",
        "long": "27.098087"
      },
      {
        "name": "MATEIESTI",
        "zip": "607533",
        "lat": "46.424139",
        "long": "26.720591"
      },
      {
        "name": "MEDELENI",
        "zip": "607674",
        "lat": "46.442993",
        "long": "27.214991"
      },
      {
        "name": "MILESTII DE JOS",
        "zip": "607402",
        "lat": "46.478883",
        "long": "27.073181"
      },
      {
        "name": "MILESTII DE SUS",
        "zip": "607403",
        "lat": "46.494548",
        "long": "27.073055"
      },
      {
        "name": "MISIHANESTI",
        "zip": "607511",
        "lat": "46.72913",
        "long": "27.13814"
      },
      {
        "name": "MOINESTI",
        "zip": "605400",
        "lat": "46.474498",
        "long": "26.490254"
      },
      {
        "name": "MOTOC",
        "zip": "607421",
        "lat": "46.358336",
        "long": "27.100187"
      },
      {
        "name": "MOTOCESTI",
        "zip": "607223",
        "lat": "46.269203",
        "long": "26.873994"
      },
      {
        "name": "MOTOSENI",
        "zip": "607325",
        "lat": "46.331227",
        "long": "27.390052"
      },
      {
        "name": "MOVILITA",
        "zip": "607503",
        "lat": "46.398306",
        "long": "27.367394"
      },
      {
        "name": "MUNCELU",
        "zip": "607217",
        "lat": "46.265287",
        "long": "27.344426"
      },
      {
        "name": "NADISA",
        "zip": "607598",
        "lat": "46.520582",
        "long": "26.704941"
      },
      {
        "name": "NANESTI",
        "zip": "607404",
        "lat": "46.454826",
        "long": "27.113899"
      },
      {
        "name": "NASTASENI",
        "zip": "607406",
        "lat": "46.477703",
        "long": "27.190248"
      },
      {
        "name": "NAZARIOAIA",
        "zip": "607676",
        "lat": "46.370415",
        "long": "27.263172"
      },
      {
        "name": "NEGOIESTI",
        "zip": "607609",
        "lat": "46.198129",
        "long": "26.886371"
      },
      {
        "name": "NEGRENI",
        "zip": "607469",
        "lat": "46.494618",
        "long": "26.559728"
      },
      {
        "name": "NEGRI",
        "zip": "607345",
        "lat": "46.707275",
        "long": "26.980037"
      },
      {
        "name": "NEGULESTI",
        "zip": "607154",
        "lat": "46.230459",
        "long": "27.291187"
      },
      {
        "name": "NEGUSENI",
        "zip": "607512",
        "lat": "46.712313",
        "long": "27.069577"
      },
      {
        "name": "NICOLAE BALCESCU",
        "zip": "607355",
        "lat": "46.478148",
        "long": "26.918455"
      },
      {
        "name": "NICORESTI",
        "zip": "607427",
        "lat": "46.234731",
        "long": "26.647492"
      },
      {
        "name": "OBARSIA",
        "zip": "607264",
        "lat": "46.615753",
        "long": "27.183157"
      },
      {
        "name": "OCHENI",
        "zip": "607254",
        "lat": "46.284289",
        "long": "27.232364"
      },
      {
        "name": "ODOBESTI",
        "zip": "607568",
        "lat": "46.675934",
        "long": "27.149214"
      },
      {
        "name": "OITUZ",
        "zip": "607365",
        "lat": "46.203912",
        "long": "26.623125"
      },
      {
        "name": "ONCESTI",
        "zip": "607375",
        "lat": "46.477302",
        "long": "27.260606"
      },
      {
        "name": "ONCESTII VECHI",
        "zip": "607378",
        "lat": "46.43564",
        "long": "27.267229"
      },
      {
        "name": "ONESTI",
        "zip": "601003",
        "lat": "46.252027",
        "long": "26.770213"
      },
      {
        "name": "ONISCANI",
        "zip": "607193",
        "lat": "46.791444",
        "long": "26.889033"
      },
      {
        "name": "OPRISESTI",
        "zip": "607504",
        "lat": "46.380528",
        "long": "27.384333"
      },
      {
        "name": "ORASA",
        "zip": "607287",
        "lat": "46.422252",
        "long": "26.743696"
      },
      {
        "name": "ORBENI",
        "zip": "607385",
        "lat": "46.277343",
        "long": "27.021963"
      },
      {
        "name": "OSEBITI",
        "zip": "607296",
        "lat": "46.538394",
        "long": "26.839465"
      },
      {
        "name": "OTELESTI",
        "zip": "607266",
        "lat": "46.541831",
        "long": "27.236222"
      },
      {
        "name": "PADURENI",
        "zip": "607318",
        "lat": "46.579687",
        "long": "26.829594"
      },
      {
        "name": "PADURENI",
        "zip": "607048",
        "lat": "46.714208",
        "long": "26.840468"
      },
      {
        "name": "PADURENI",
        "zip": "607138",
        "lat": "46.752383",
        "long": "27.044557"
      },
      {
        "name": "PADURENI",
        "zip": "607181",
        "lat": "46.47974",
        "long": "27.230685"
      },
      {
        "name": "PADURENI",
        "zip": "607267",
        "lat": "46.581427",
        "long": "27.238691"
      },
      {
        "name": "PAGUBENI",
        "zip": "605303",
        "lat": "46.36468",
        "long": "26.520398"
      },
      {
        "name": "PAJISTEA",
        "zip": "607393",
        "lat": "46.462746",
        "long": "26.098816"
      },
      {
        "name": "PALANCA",
        "zip": "607390",
        "lat": "46.53317",
        "long": "26.13043"
      },
      {
        "name": "PALTINATA",
        "zip": "607224",
        "lat": "46.284265",
        "long": "26.885163"
      },
      {
        "name": "PALTINIS",
        "zip": "607024",
        "lat": "46.543448",
        "long": "26.356431"
      },
      {
        "name": "PANCESTI",
        "zip": "607415",
        "lat": "46.33627",
        "long": "27.087906"
      },
      {
        "name": "PANCESTI",
        "zip": "607523",
        "lat": "46.211181",
        "long": "27.067971"
      },
      {
        "name": "PARAU BOGHII",
        "zip": "607428",
        "lat": "46.261354",
        "long": "26.643192"
      },
      {
        "name": "PARAVA",
        "zip": "607395",
        "lat": "46.309541",
        "long": "26.986652"
      },
      {
        "name": "PARGARESTI",
        "zip": "607425",
        "lat": "46.2526",
        "long": "26.651449"
      },
      {
        "name": "PARINCEA",
        "zip": "607400",
        "lat": "46.485317",
        "long": "27.10804"
      },
      {
        "name": "PARJOL",
        "zip": "607430",
        "lat": "46.5909",
        "long": "26.610199"
      },
      {
        "name": "PARVULESTI",
        "zip": "607312",
        "lat": "46.151791",
        "long": "26.712039"
      },
      {
        "name": "PERCHIU",
        "zip": "607256",
        "lat": "46.220166",
        "long": "27.247591"
      },
      {
        "name": "PETRESTI",
        "zip": "607422",
        "lat": "46.387631",
        "long": "27.113987"
      },
      {
        "name": "PETRICICA",
        "zip": "607599",
        "lat": "46.511256",
        "long": "26.785838"
      },
      {
        "name": "PLOPANA",
        "zip": "607440",
        "lat": "46.68247",
        "long": "27.218911"
      },
      {
        "name": "PLOPU",
        "zip": "605304",
        "lat": "46.392563",
        "long": "26.502677"
      },
      {
        "name": "PLOPU",
        "zip": "607458",
        "lat": "46.194335",
        "long": "27.437643"
      },
      {
        "name": "PODEI",
        "zip": "605201",
        "lat": "46.405915",
        "long": "26.448597"
      },
      {
        "name": "PODIS",
        "zip": "607319",
        "lat": "46.614268",
        "long": "26.725044"
      },
      {
        "name": "PODU TURCULUI",
        "zip": "607450",
        "lat": "46.201956",
        "long": "27.387757"
      },
      {
        "name": "PODURI",
        "zip": "607465",
        "lat": "46.466649",
        "long": "26.533634"
      },
      {
        "name": "POGLET",
        "zip": "607123",
        "lat": "46.329217",
        "long": "27.133654"
      },
      {
        "name": "POIANA",
        "zip": "607321",
        "lat": "46.625022",
        "long": "26.740914"
      },
      {
        "name": "POIANA",
        "zip": "607112",
        "lat": "46.64681",
        "long": "27.209139"
      },
      {
        "name": "POIANA",
        "zip": "607288",
        "lat": "46.379584",
        "long": "26.7122"
      },
      {
        "name": "POIANA",
        "zip": "607336",
        "lat": "46.274875",
        "long": "27.420994"
      },
      {
        "name": "POIANA",
        "zip": "607349",
        "lat": "46.697748",
        "long": "27.015193"
      },
      {
        "name": "POIANA NEGUSTORULUI",
        "zip": "607067",
        "lat": "46.676392",
        "long": "26.614028"
      },
      {
        "name": "POIANA SARATA",
        "zip": "607371",
        "lat": "46.142619",
        "long": "26.455161"
      },
      {
        "name": "POIENI",
        "zip": "605601",
        "lat": "46.283173",
        "long": "26.573753"
      },
      {
        "name": "POIENI",
        "zip": "607407",
        "lat": "46.481803",
        "long": "27.173519"
      },
      {
        "name": "POIENI",
        "zip": "607513",
        "lat": "46.752777",
        "long": "27.076812"
      },
      {
        "name": "POPENI",
        "zip": "607102",
        "lat": "46.175905",
        "long": "26.938385"
      },
      {
        "name": "POPESTI",
        "zip": "607198",
        "lat": "46.349486",
        "long": "27.240752"
      },
      {
        "name": "POPOIU",
        "zip": "607394",
        "lat": "46.542076",
        "long": "26.117523"
      },
      {
        "name": "PRADAIS",
        "zip": "607257",
        "lat": "46.192196",
        "long": "27.249099"
      },
      {
        "name": "PRAJA",
        "zip": "607337",
        "lat": "46.33725",
        "long": "27.421443"
      },
      {
        "name": "PRAJESTI",
        "zip": "607301",
        "lat": "46.505831",
        "long": "26.525932"
      },
      {
        "name": "PRAJESTI",
        "zip": "607639",
        "lat": "46.654686",
        "long": "26.97631"
      },
      {
        "name": "PRAJOAIA",
        "zip": "607289",
        "lat": "46.405845",
        "long": "26.719341"
      },
      {
        "name": "PRALEA",
        "zip": "607103",
        "lat": "46.108477",
        "long": "26.864053"
      },
      {
        "name": "PRELUCI",
        "zip": "607012",
        "lat": "46.455239",
        "long": "26.275477"
      },
      {
        "name": "PRISACA",
        "zip": "607053",
        "lat": "46.465366",
        "long": "26.717444"
      },
      {
        "name": "PROHOZESTI",
        "zip": "607471",
        "lat": "46.481931",
        "long": "26.551397"
      },
      {
        "name": "PUSTIANA",
        "zip": "607437",
        "lat": "46.589896",
        "long": "26.630835"
      },
      {
        "name": "PUTINI",
        "zip": "607506",
        "lat": "46.54211",
        "long": "27.341831"
      },
      {
        "name": "PUTREDENI",
        "zip": "607218",
        "lat": "46.247108",
        "long": "27.44787"
      },
      {
        "name": "RACACIUNI",
        "zip": "607480",
        "lat": "46.326058",
        "long": "27.013841"
      },
      {
        "name": "RACATAU DE JOS",
        "zip": "607244",
        "lat": "46.370335",
        "long": "27.028674"
      },
      {
        "name": "RACATAU-RAZESI",
        "zip": "607246",
        "lat": "46.378095",
        "long": "27.038946"
      },
      {
        "name": "RACAUTI",
        "zip": "607611",
        "lat": "46.224774",
        "long": "26.784414"
      },
      {
        "name": "RACHITIS",
        "zip": "607211",
        "lat": "46.660959",
        "long": "26.027048"
      },
      {
        "name": "RACHITISU",
        "zip": "607601",
        "lat": "46.539702",
        "long": "26.755327"
      },
      {
        "name": "RACHITOASA",
        "zip": "607490",
        "lat": "46.440512",
        "long": "27.374606"
      },
      {
        "name": "RACOVA",
        "zip": "607475",
        "lat": "46.702059",
        "long": "26.745161"
      },
      {
        "name": "RACUSANA",
        "zip": "607459",
        "lat": "46.17732",
        "long": "27.362473"
      },
      {
        "name": "RADEANA",
        "zip": "607612",
        "lat": "46.219621",
        "long": "26.838611"
      },
      {
        "name": "RADOAIA",
        "zip": "607397",
        "lat": "46.309426",
        "long": "26.928024"
      },
      {
        "name": "RADOMIRESTI",
        "zip": "607272",
        "lat": "46.545876",
        "long": "26.991805"
      },
      {
        "name": "RASTOACA",
        "zip": "607486",
        "lat": "46.33358",
        "long": "27.040819"
      },
      {
        "name": "RAZESU",
        "zip": "607219",
        "lat": "46.279842",
        "long": "27.395596"
      },
      {
        "name": "RECEA",
        "zip": "607247",
        "lat": "46.391368",
        "long": "27.0545"
      },
      {
        "name": "REPRIVAT",
        "zip": "607677",
        "lat": "46.411683",
        "long": "27.254663"
      },
      {
        "name": "ROGOAZA",
        "zip": "607124",
        "lat": "46.256562",
        "long": "27.145148"
      },
      {
        "name": "ROMANESTI",
        "zip": "607054",
        "lat": "46.491254",
        "long": "26.66821"
      },
      {
        "name": "ROSIORI",
        "zip": "607510",
        "lat": "46.722813",
        "long": "27.086163"
      },
      {
        "name": "ROTARIA",
        "zip": "607338",
        "lat": "46.356961",
        "long": "27.455017"
      },
      {
        "name": "RUNCU",
        "zip": "605102",
        "lat": "46.74765",
        "long": "26.745411"
      },
      {
        "name": "RUSENII DE SUS",
        "zip": "607447",
        "lat": "46.654004",
        "long": "27.264646"
      },
      {
        "name": "RUSENII RAZESI",
        "zip": "607446",
        "lat": "46.651314",
        "long": "27.279629"
      },
      {
        "name": "RUSI-CIUTEA",
        "zip": "607273",
        "lat": "46.523195",
        "long": "26.960507"
      },
      {
        "name": "SALATRUC",
        "zip": "605305",
        "lat": "46.343791",
        "long": "26.417622"
      },
      {
        "name": "SANDULENI",
        "zip": "607530",
        "lat": "46.440455",
        "long": "26.738456"
      },
      {
        "name": "SARATA",
        "zip": "607361",
        "lat": "46.502495",
        "long": "26.868572"
      },
      {
        "name": "SARATA",
        "zip": "607582",
        "lat": "46.566901",
        "long": "26.5524"
      },
      {
        "name": "SARBI",
        "zip": "607461",
        "lat": "46.230493",
        "long": "27.338046"
      },
      {
        "name": "SASCUT",
        "zip": "607520",
        "lat": "46.207483",
        "long": "27.110326"
      },
      {
        "name": "SASCUT-SAT",
        "zip": "607524",
        "lat": "46.187267",
        "long": "27.068514"
      },
      {
        "name": "SATU NOU",
        "zip": "607113",
        "lat": "46.62724",
        "long": "27.237113"
      },
      {
        "name": "SATU NOU",
        "zip": "607277",
        "lat": "46.688887",
        "long": "27.300197"
      },
      {
        "name": "SATU NOU",
        "zip": "607379",
        "lat": "46.500716",
        "long": "27.253935"
      },
      {
        "name": "SATU NOU",
        "zip": "607408",
        "lat": "46.503957",
        "long": "27.166444"
      },
      {
        "name": "SATU NOU",
        "zip": "607429",
        "lat": "46.244466",
        "long": "26.653433"
      },
      {
        "name": "SATU NOU",
        "zip": "607658",
        "lat": "46.127983",
        "long": "27.027866"
      },
      {
        "name": "SAUCESTI",
        "zip": "607540",
        "lat": "46.618528",
        "long": "26.941409"
      },
      {
        "name": "SCARIGA",
        "zip": "607291",
        "lat": "46.392445",
        "long": "26.701806"
      },
      {
        "name": "SCARISOARA",
        "zip": "607126",
        "lat": "46.283049",
        "long": "27.128798"
      },
      {
        "name": "SCHINENI",
        "zip": "607526",
        "lat": "46.193645",
        "long": "27.102451"
      },
      {
        "name": "SCHINENI",
        "zip": "607543",
        "lat": "46.641937",
        "long": "26.948723"
      },
      {
        "name": "SCHITU FRUMOASA",
        "zip": "607033",
        "lat": "46.633515",
        "long": "26.501525"
      },
      {
        "name": "SCORTENI",
        "zip": "607550",
        "lat": "46.552365",
        "long": "26.663278"
      },
      {
        "name": "SCURTA",
        "zip": "607386",
        "lat": "46.261329",
        "long": "27.015484"
      },
      {
        "name": "SCUTARU",
        "zip": "607313",
        "lat": "46.101265",
        "long": "26.636727"
      },
      {
        "name": "SEACA",
        "zip": "607166",
        "lat": "46.331111",
        "long": "26.507987"
      },
      {
        "name": "SECUIENI",
        "zip": "607560",
        "lat": "46.6432",
        "long": "27.098392"
      },
      {
        "name": "SENDRESTI",
        "zip": "607339",
        "lat": "46.38448",
        "long": "27.431567"
      },
      {
        "name": "SERBESTI",
        "zip": "607546",
        "lat": "46.701874",
        "long": "26.924981"
      },
      {
        "name": "SERPENI",
        "zip": "607556",
        "lat": "46.613261",
        "long": "26.698458"
      },
      {
        "name": "SESURI",
        "zip": "607303",
        "lat": "46.507097",
        "long": "26.571504"
      },
      {
        "name": "SIRETU",
        "zip": "607274",
        "lat": "46.506632",
        "long": "26.968382"
      },
      {
        "name": "SIRETU",
        "zip": "607544",
        "lat": "46.671632",
        "long": "26.931744"
      },
      {
        "name": "SLANIC-MOLDOVA",
        "zip": "605500",
        "lat": "46.206632",
        "long": "26.438397"
      },
      {
        "name": "SLOBOZIA",
        "zip": "601002",
        "lat": "46.279744",
        "long": "26.78379"
      },
      {
        "name": "SLOBOZIA",
        "zip": "607182",
        "lat": "46.508827",
        "long": "27.190125"
      },
      {
        "name": "SLOBOZIA",
        "zip": "607592",
        "lat": "46.474085",
        "long": "27.308672"
      },
      {
        "name": "SLOBOZIA",
        "zip": "607659",
        "lat": "46.112039",
        "long": "27.119379"
      },
      {
        "name": "SLOBOZIA NOUA",
        "zip": "607593",
        "lat": "46.539591",
        "long": "27.297729"
      },
      {
        "name": "SOCI",
        "zip": "607423",
        "lat": "46.407498",
        "long": "27.133793"
      },
      {
        "name": "SOHODOL",
        "zip": "607308",
        "lat": "46.56432",
        "long": "26.824286"
      },
      {
        "name": "SOHODOR",
        "zip": "607248",
        "lat": "46.407729",
        "long": "27.063048"
      },
      {
        "name": "SOLONT",
        "zip": "607580",
        "lat": "46.551175",
        "long": "26.534736"
      },
      {
        "name": "SOMUSCA",
        "zip": "607106",
        "lat": "46.401139",
        "long": "26.910091"
      },
      {
        "name": "SPRIA",
        "zip": "607114",
        "lat": "46.602554",
        "long": "27.260289"
      },
      {
        "name": "STANESTI",
        "zip": "607302",
        "lat": "46.526763",
        "long": "26.533039"
      },
      {
        "name": "STANISESTI",
        "zip": "607585",
        "lat": "46.430952",
        "long": "27.306091"
      },
      {
        "name": "STEFAN CEL MARE",
        "zip": "607605",
        "lat": "46.215474",
        "long": "26.859763"
      },
      {
        "name": "STEFAN VODA",
        "zip": "607167",
        "lat": "46.317597",
        "long": "26.519756"
      },
      {
        "name": "STEJARU",
        "zip": "607554",
        "lat": "46.588947",
        "long": "26.701623"
      },
      {
        "name": "STRAJA",
        "zip": "607026",
        "lat": "46.4396",
        "long": "26.362639"
      },
      {
        "name": "STRAMINOASA",
        "zip": "607448",
        "lat": "46.646187",
        "long": "27.295762"
      },
      {
        "name": "STRUGARI",
        "zip": "607595",
        "lat": "46.536504",
        "long": "26.716314"
      },
      {
        "name": "STUFU",
        "zip": "607534",
        "lat": "46.440165",
        "long": "26.768647"
      },
      {
        "name": "SULTA",
        "zip": "607013",
        "lat": "46.468621",
        "long": "26.238963"
      },
      {
        "name": "SURINA",
        "zip": "607203",
        "lat": "46.673252",
        "long": "26.791663"
      },
      {
        "name": "TAGARA",
        "zip": "607449",
        "lat": "46.666693",
        "long": "27.197277"
      },
      {
        "name": "TAMASI",
        "zip": "607615",
        "lat": "46.491121",
        "long": "26.996803"
      },
      {
        "name": "TAMASOAIA",
        "zip": "607134",
        "lat": "46.131089",
        "long": "27.001168"
      },
      {
        "name": "TARATA",
        "zip": "607438",
        "lat": "46.569327",
        "long": "26.620923"
      },
      {
        "name": "TARDENII MARI",
        "zip": "607068",
        "lat": "46.686021",
        "long": "26.599982"
      },
      {
        "name": "TARGU OCNA",
        "zip": "605600",
        "lat": "46.280193",
        "long": "26.609551"
      },
      {
        "name": "TARGU TROTUS",
        "zip": "607630",
        "lat": "46.263983",
        "long": "26.674714"
      },
      {
        "name": "TARHAUSI",
        "zip": "607212",
        "lat": "46.591015",
        "long": "26.088045"
      },
      {
        "name": "TARNITA",
        "zip": "607381",
        "lat": "46.521406",
        "long": "27.253027"
      },
      {
        "name": "TATARASTI",
        "zip": "607620",
        "lat": "46.21787",
        "long": "27.205348"
      },
      {
        "name": "TAULA",
        "zip": "607382",
        "lat": "46.45636",
        "long": "27.281911"
      },
      {
        "name": "TAVADARESTI",
        "zip": "607156",
        "lat": "46.326572",
        "long": "27.29171"
      },
      {
        "name": "TEIUS",
        "zip": "607398",
        "lat": "46.322504",
        "long": "26.970271"
      },
      {
        "name": "TEMELIA",
        "zip": "607226",
        "lat": "46.289893",
        "long": "26.875139"
      },
      {
        "name": "TEPOAIA",
        "zip": "607341",
        "lat": "46.310258",
        "long": "27.360287"
      },
      {
        "name": "TESCANI",
        "zip": "607056",
        "lat": "46.511596",
        "long": "26.656082"
      },
      {
        "name": "TIGANESTI",
        "zip": "607679",
        "lat": "46.396684",
        "long": "27.260557"
      },
      {
        "name": "TISA",
        "zip": "607536",
        "lat": "46.434422",
        "long": "26.719472"
      },
      {
        "name": "TISA-SILVESTRI",
        "zip": "607569",
        "lat": "46.653463",
        "long": "27.140674"
      },
      {
        "name": "TOCHILEA",
        "zip": "607507",
        "lat": "46.396911",
        "long": "27.402861"
      },
      {
        "name": "TOMOZIA",
        "zip": "607678",
        "lat": "46.428483",
        "long": "27.258958"
      },
      {
        "name": "TRAIAN",
        "zip": "607635",
        "lat": "46.6265",
        "long": "27.034802"
      },
      {
        "name": "TREBES",
        "zip": "607322",
        "lat": "46.595133",
        "long": "26.833271"
      },
      {
        "name": "TURLUIANU",
        "zip": "607057",
        "lat": "46.45249",
        "long": "26.644796"
      },
      {
        "name": "TUTA",
        "zip": "607631",
        "lat": "46.256426",
        "long": "26.691026"
      },
      {
        "name": "UNGURENI",
        "zip": "607627",
        "lat": "46.204769",
        "long": "27.213515"
      },
      {
        "name": "UNGURENI",
        "zip": "607645",
        "lat": "46.522829",
        "long": "27.111858"
      },
      {
        "name": "URECHESTI",
        "zip": "607655",
        "lat": "46.132502",
        "long": "27.086014"
      },
      {
        "name": "URSOAIA",
        "zip": "607351",
        "lat": "46.684288",
        "long": "26.967461"
      },
      {
        "name": "VALCELE",
        "zip": "605602",
        "lat": "46.300772",
        "long": "26.599436"
      },
      {
        "name": "VALCELE",
        "zip": "607127",
        "lat": "46.307183",
        "long": "27.129978"
      },
      {
        "name": "VALEA ARINILOR",
        "zip": "607304",
        "lat": "46.497926",
        "long": "26.509176"
      },
      {
        "name": "VALEA BOTULUI",
        "zip": "607183",
        "lat": "46.52011",
        "long": "27.175571"
      },
      {
        "name": "VALEA BUDULUI",
        "zip": "607323",
        "lat": "46.596197",
        "long": "26.819009"
      },
      {
        "name": "VALEA CASELOR",
        "zip": "607278",
        "lat": "46.720382",
        "long": "27.210105"
      },
      {
        "name": "VALEA FANATULUI",
        "zip": "607571",
        "lat": "46.61887",
        "long": "27.092557"
      },
      {
        "name": "VALEA HOGEI",
        "zip": "607279",
        "lat": "46.704458",
        "long": "27.274541"
      },
      {
        "name": "VALEA LUI ION",
        "zip": "607069",
        "lat": "46.703495",
        "long": "26.624987"
      },
      {
        "name": "VALEA LUPULUI",
        "zip": "607681",
        "lat": "46.404293",
        "long": "27.233457"
      },
      {
        "name": "VALEA MARE",
        "zip": "607116",
        "lat": "46.619254",
        "long": "27.260175"
      },
      {
        "name": "VALEA MARE",
        "zip": "607514",
        "lat": "46.725797",
        "long": "27.118863"
      },
      {
        "name": "VALEA MARULUI",
        "zip": "607281",
        "lat": "46.738612",
        "long": "27.2033"
      },
      {
        "name": "VALEA MERILOR",
        "zip": "607682",
        "lat": "46.448698",
        "long": "27.201016"
      },
      {
        "name": "VALEA MICA",
        "zip": "607107",
        "lat": "46.391505",
        "long": "26.944546"
      },
      {
        "name": "VALEA MICA",
        "zip": "607516",
        "lat": "46.713704",
        "long": "27.135446"
      },
      {
        "name": "VALEA MOSNEAGULUI",
        "zip": "607282",
        "lat": "46.730103",
        "long": "27.217707"
      },
      {
        "name": "VALEA NACULUI",
        "zip": "607527",
        "lat": "46.17999",
        "long": "27.060998"
      },
      {
        "name": "VALEA SALCIEI",
        "zip": "607683",
        "lat": "46.458541",
        "long": "27.192738"
      },
      {
        "name": "VALEA SEACA",
        "zip": "607362",
        "lat": "46.465344",
        "long": "26.881889"
      },
      {
        "name": "VALEA SEACA",
        "zip": "607660",
        "lat": "46.242807",
        "long": "27.045938"
      },
      {
        "name": "VALEA SOSII",
        "zip": "607472",
        "lat": "46.461242",
        "long": "26.546593"
      },
      {
        "name": "VALENI",
        "zip": "607409",
        "lat": "46.466118",
        "long": "27.07758"
      },
      {
        "name": "VALENI",
        "zip": "607572",
        "lat": "46.693486",
        "long": "27.075899"
      },
      {
        "name": "VALENI",
        "zip": "607594",
        "lat": "46.428231",
        "long": "27.280245"
      },
      {
        "name": "VERMESTI",
        "zip": "605202",
        "lat": "46.421716",
        "long": "26.476604"
      },
      {
        "name": "VERSESTI",
        "zip": "607537",
        "lat": "46.449041",
        "long": "26.701669"
      },
      {
        "name": "VIFORENI",
        "zip": "607652",
        "lat": "46.581216",
        "long": "27.097225"
      },
      {
        "name": "VIISOARA",
        "zip": "607613",
        "lat": "46.231176",
        "long": "26.88458"
      },
      {
        "name": "VIISOARA",
        "zip": "607632",
        "lat": "46.281793",
        "long": "26.667414"
      },
      {
        "name": "VLADNIC",
        "zip": "607411",
        "lat": "46.445422",
        "long": "27.138156"
      },
      {
        "name": "VRANCENI",
        "zip": "607104",
        "lat": "46.213077",
        "long": "26.908807"
      },
      {
        "name": "VULTURENI",
        "zip": "607665",
        "lat": "46.402783",
        "long": "27.274697"
      },
      {
        "name": "ZAPODIA",
        "zip": "607117",
        "lat": "46.564499",
        "long": "27.313612"
      },
      {
        "name": "ZAPODIA",
        "zip": "607641",
        "lat": "46.645936",
        "long": "27.074075"
      },
      {
        "name": "ZEMES",
        "zip": "607690",
        "lat": "46.549376",
        "long": "26.465377"
      },
      {
        "name": "ZLATARI",
        "zip": "607653",
        "lat": "46.50686",
        "long": "27.11742"
      }
    ],
    "BIHOR": [
      {
        "name": "ABRAM",
        "zip": "417005",
        "lat": "47.316792",
        "long": "22.379994"
      },
      {
        "name": "ABRAMUT",
        "zip": "417015",
        "lat": "47.322958",
        "long": "22.254395"
      },
      {
        "name": "ADONI",
        "zip": "417571",
        "lat": "47.432389",
        "long": "22.175819"
      },
      {
        "name": "ALBESTI",
        "zip": "417401",
        "lat": "46.769489",
        "long": "22.250172"
      },
      {
        "name": "ALBIS",
        "zip": "417106",
        "lat": "47.390239",
        "long": "22.245281"
      },
      {
        "name": "ALESD",
        "zip": "415100",
        "lat": "47.058254",
        "long": "22.397981"
      },
      {
        "name": "ALMASU MARE",
        "zip": "417041",
        "lat": "47.328172",
        "long": "22.532851"
      },
      {
        "name": "ALMASU MIC",
        "zip": "417042",
        "lat": "47.31728",
        "long": "22.510317"
      },
      {
        "name": "ALMASU MIC",
        "zip": "417521",
        "lat": "47.171314",
        "long": "22.135179"
      },
      {
        "name": "ALPAREA",
        "zip": "417361",
        "lat": "47.025915",
        "long": "22.059763"
      },
      {
        "name": "ANT",
        "zip": "417036",
        "lat": "46.666346",
        "long": "21.467553"
      },
      {
        "name": "APATEU",
        "zip": "417346",
        "lat": "46.971445",
        "long": "21.922812"
      },
      {
        "name": "ARPASEL",
        "zip": "417046",
        "lat": "46.741085",
        "long": "21.722647"
      },
      {
        "name": "ASTILEU",
        "zip": "417020",
        "lat": "47.028728",
        "long": "22.393495"
      },
      {
        "name": "ATEAS",
        "zip": "417146",
        "lat": "46.914743",
        "long": "21.615123"
      },
      {
        "name": "AUSEU",
        "zip": "417025",
        "lat": "47.036855",
        "long": "22.496393"
      },
      {
        "name": "AVRAM IANCU",
        "zip": "417035",
        "lat": "46.669482",
        "long": "21.524193"
      },
      {
        "name": "BAILE FELIX",
        "zip": "417500",
        "lat": "46.989623",
        "long": "21.981262"
      },
      {
        "name": "BAITA",
        "zip": "415401",
        "lat": "46.48184",
        "long": "22.580562"
      },
      {
        "name": "BAITA-PLAI",
        "zip": "415402",
        "lat": "46.484035",
        "long": "22.62252"
      },
      {
        "name": "BALAIA",
        "zip": "417586",
        "lat": "47.107807",
        "long": "22.170596"
      },
      {
        "name": "BALC",
        "zip": "417040",
        "lat": "47.298401",
        "long": "22.535059"
      },
      {
        "name": "BALC",
        "zip": "417216",
        "lat": "46.40314",
        "long": "22.594564"
      },
      {
        "name": "BALENI",
        "zip": "417301",
        "lat": "46.609328",
        "long": "22.399296"
      },
      {
        "name": "BALNACA",
        "zip": "417566",
        "lat": "46.942147",
        "long": "22.569343"
      },
      {
        "name": "BALNACA-GROSI",
        "zip": "417567",
        "lat": "46.919039",
        "long": "22.55048"
      },
      {
        "name": "BATAR",
        "zip": "417045",
        "lat": "46.707037",
        "long": "21.804965"
      },
      {
        "name": "BEIUS",
        "zip": "415200",
        "lat": "46.666753",
        "long": "22.352709"
      },
      {
        "name": "BEIUSELE",
        "zip": "417221",
        "lat": "46.718283",
        "long": "22.451173"
      },
      {
        "name": "BELEJENI",
        "zip": "417251",
        "lat": "46.62498",
        "long": "22.430948"
      },
      {
        "name": "BELFIR",
        "zip": "417596",
        "lat": "46.737837",
        "long": "21.941451"
      },
      {
        "name": "BERECHIU",
        "zip": "417147",
        "lat": "46.949577",
        "long": "21.732537"
      },
      {
        "name": "BETFIA",
        "zip": "417497",
        "lat": "46.974486",
        "long": "22.015668"
      },
      {
        "name": "BEZNEA",
        "zip": "417081",
        "lat": "46.959147",
        "long": "22.617465"
      },
      {
        "name": "BICACEL",
        "zip": "417306",
        "lat": "46.855219",
        "long": "22.0948"
      },
      {
        "name": "BICACI",
        "zip": "417148",
        "lat": "46.901988",
        "long": "21.787901"
      },
      {
        "name": "BIHARIA",
        "zip": "417050",
        "lat": "47.151508",
        "long": "21.922188"
      },
      {
        "name": "BIRTIN",
        "zip": "417616",
        "lat": "46.989971",
        "long": "22.497697"
      },
      {
        "name": "BISTRA",
        "zip": "417391",
        "lat": "47.254782",
        "long": "22.42295"
      },
      {
        "name": "BOGEI",
        "zip": "417581",
        "lat": "47.265504",
        "long": "22.360792"
      },
      {
        "name": "BOIANU MARE",
        "zip": "417060",
        "lat": "47.38272",
        "long": "22.522425"
      },
      {
        "name": "BOIU",
        "zip": "417196",
        "lat": "46.685982",
        "long": "21.608906"
      },
      {
        "name": "BOROD",
        "zip": "417065",
        "lat": "46.991702",
        "long": "22.615562"
      },
      {
        "name": "BOROZEL",
        "zip": "417066",
        "lat": "47.005965",
        "long": "22.562154"
      },
      {
        "name": "BORS",
        "zip": "417075",
        "lat": "47.117015",
        "long": "21.802371"
      },
      {
        "name": "BORSA",
        "zip": "417431",
        "lat": "47.02399",
        "long": "22.176936"
      },
      {
        "name": "BORUMLACA",
        "zip": "417536",
        "lat": "47.215742",
        "long": "22.477145"
      },
      {
        "name": "BORZ",
        "zip": "417556",
        "lat": "46.673618",
        "long": "22.191395"
      },
      {
        "name": "BOTEAN",
        "zip": "417296",
        "lat": "47.101438",
        "long": "22.143695"
      },
      {
        "name": "BRADET",
        "zip": "417116",
        "lat": "46.583015",
        "long": "22.532127"
      },
      {
        "name": "BRATCA",
        "zip": "417080",
        "lat": "46.92943",
        "long": "22.605821"
      },
      {
        "name": "BRATESTI",
        "zip": "417402",
        "lat": "46.759496",
        "long": "22.19697"
      },
      {
        "name": "BRIHENI",
        "zip": "417321",
        "lat": "46.499694",
        "long": "22.402778"
      },
      {
        "name": "BRUSTURI",
        "zip": "417090",
        "lat": "47.158775",
        "long": "22.240104"
      },
      {
        "name": "BRUSTURI",
        "zip": "417266",
        "lat": "46.581393",
        "long": "22.241249"
      },
      {
        "name": "BUCIUM",
        "zip": "417156",
        "lat": "46.879539",
        "long": "22.153566"
      },
      {
        "name": "BUCUROAIA",
        "zip": "417206",
        "lat": "46.92662",
        "long": "22.183039"
      },
      {
        "name": "BUDOI",
        "zip": "417392",
        "lat": "47.207467",
        "long": "22.357136"
      },
      {
        "name": "BUDUREASA",
        "zip": "417100",
        "lat": "46.679182",
        "long": "22.495174"
      },
      {
        "name": "BUDUSLAU",
        "zip": "417105",
        "lat": "47.400931",
        "long": "22.262462"
      },
      {
        "name": "BULZ",
        "zip": "417110",
        "lat": "46.914173",
        "long": "22.675343"
      },
      {
        "name": "BUNTESTI",
        "zip": "417115",
        "lat": "46.6128",
        "long": "22.468561"
      },
      {
        "name": "BURDA",
        "zip": "417101",
        "lat": "46.695127",
        "long": "22.478954"
      },
      {
        "name": "BURZUC",
        "zip": "417522",
        "lat": "47.156015",
        "long": "22.171903"
      },
      {
        "name": "BUTANI",
        "zip": "417336",
        "lat": "47.018121",
        "long": "22.431444"
      },
      {
        "name": "CABESTI",
        "zip": "417125",
        "lat": "46.770835",
        "long": "22.373602"
      },
      {
        "name": "CACUCIU NOU",
        "zip": "417337",
        "lat": "47.02618",
        "long": "22.475213"
      },
      {
        "name": "CACUCIU VECHI",
        "zip": "417026",
        "lat": "47.0234",
        "long": "22.492161"
      },
      {
        "name": "CADEA",
        "zip": "417436",
        "lat": "47.311853",
        "long": "22.062248"
      },
      {
        "name": "CALACEA",
        "zip": "417356",
        "lat": "46.676866",
        "long": "21.93292"
      },
      {
        "name": "CALATANI",
        "zip": "417587",
        "lat": "47.046855",
        "long": "22.195815"
      },
      {
        "name": "CALATEA",
        "zip": "417021",
        "lat": "46.987265",
        "long": "22.407176"
      },
      {
        "name": "CALEA MARE",
        "zip": "417307",
        "lat": "46.90815",
        "long": "22.065106"
      },
      {
        "name": "CALUGARI",
        "zip": "417136",
        "lat": "46.423705",
        "long": "22.478464"
      },
      {
        "name": "CAMP",
        "zip": "415801",
        "lat": "46.469439",
        "long": "22.443571"
      },
      {
        "name": "CAMP-MOTI",
        "zip": "415802",
        "lat": "46.462619",
        "long": "22.413595"
      },
      {
        "name": "CAMPANI",
        "zip": "417140",
        "lat": "46.517389",
        "long": "22.516037"
      },
      {
        "name": "CAMPANI DE POMEZEU",
        "zip": "417381",
        "lat": "46.795902",
        "long": "22.312153"
      },
      {
        "name": "CAPALNA",
        "zip": "417130",
        "lat": "46.73548",
        "long": "22.102738"
      },
      {
        "name": "CARANDENI",
        "zip": "417308",
        "lat": "46.85384",
        "long": "22.073871"
      },
      {
        "name": "CARANZEL",
        "zip": "417309",
        "lat": "46.829491",
        "long": "22.0361"
      },
      {
        "name": "CARASAU",
        "zip": "417201",
        "lat": "46.706275",
        "long": "22.052044"
      },
      {
        "name": "CARPINET",
        "zip": "417135",
        "lat": "46.455993",
        "long": "22.493792"
      },
      {
        "name": "CAUACEU",
        "zip": "417051",
        "lat": "47.165515",
        "long": "21.943818"
      },
      {
        "name": "CAUASD",
        "zip": "417601",
        "lat": "46.790949",
        "long": "21.820263"
      },
      {
        "name": "CEFA",
        "zip": "417145",
        "lat": "46.914498",
        "long": "21.714085"
      },
      {
        "name": "CEICA",
        "zip": "417155",
        "lat": "46.85781",
        "long": "22.167143"
      },
      {
        "name": "CEISOARA",
        "zip": "417157",
        "lat": "46.85672",
        "long": "22.202652"
      },
      {
        "name": "CENALOS",
        "zip": "417191",
        "lat": "47.244152",
        "long": "22.156873"
      },
      {
        "name": "CETARIU",
        "zip": "417165",
        "lat": "47.140976",
        "long": "21.99714"
      },
      {
        "name": "CETEA",
        "zip": "417067",
        "lat": "47.016813",
        "long": "22.578164"
      },
      {
        "name": "CHERECHIU",
        "zip": "417175",
        "lat": "47.381632",
        "long": "22.124724"
      },
      {
        "name": "CHERESIG",
        "zip": "417271",
        "lat": "47.038111",
        "long": "21.685256"
      },
      {
        "name": "CHERIU",
        "zip": "417362",
        "lat": "47.012531",
        "long": "22.021975"
      },
      {
        "name": "CHESA",
        "zip": "417202",
        "lat": "46.751044",
        "long": "22.026886"
      },
      {
        "name": "CHESEREU",
        "zip": "417176",
        "lat": "47.427793",
        "long": "22.114163"
      },
      {
        "name": "CHET",
        "zip": "415301",
        "lat": "47.419427",
        "long": "22.338766"
      },
      {
        "name": "CHIJIC",
        "zip": "417207",
        "lat": "46.995819",
        "long": "22.151654"
      },
      {
        "name": "CHIOAG",
        "zip": "417523",
        "lat": "47.177227",
        "long": "22.153381"
      },
      {
        "name": "CHIRALEU",
        "zip": "417181",
        "lat": "47.305463",
        "long": "22.297701"
      },
      {
        "name": "CHIRIBIS",
        "zip": "417582",
        "lat": "47.311015",
        "long": "22.34184"
      },
      {
        "name": "CHISCAU",
        "zip": "417366",
        "lat": "46.560063",
        "long": "22.550891"
      },
      {
        "name": "CHISIRID",
        "zip": "417347",
        "lat": "46.96894",
        "long": "21.888164"
      },
      {
        "name": "CHISLAZ",
        "zip": "417180",
        "lat": "47.281254",
        "long": "22.231949"
      },
      {
        "name": "CHISTAG",
        "zip": "417022",
        "lat": "47.04119",
        "long": "22.348963"
      },
      {
        "name": "CIHEI",
        "zip": "417498",
        "lat": "46.998915",
        "long": "21.952543"
      },
      {
        "name": "CIOCAIA",
        "zip": "417437",
        "lat": "47.33912",
        "long": "22.042821"
      },
      {
        "name": "CIUHOI",
        "zip": "417190",
        "lat": "47.238081",
        "long": "22.124465"
      },
      {
        "name": "CIULESTI",
        "zip": "417531",
        "lat": "47.219428",
        "long": "22.192553"
      },
      {
        "name": "CIUMEGHIU",
        "zip": "417195",
        "lat": "46.732807",
        "long": "21.580865"
      },
      {
        "name": "CIUTELEC",
        "zip": "417583",
        "lat": "47.262004",
        "long": "22.386893"
      },
      {
        "name": "COCIUBA MARE",
        "zip": "417200",
        "lat": "46.739193",
        "long": "21.998773"
      },
      {
        "name": "COCIUBA MICA",
        "zip": "417367",
        "lat": "46.598375",
        "long": "22.534501"
      },
      {
        "name": "CODRISORU",
        "zip": "417027",
        "lat": "47.103547",
        "long": "22.522354"
      },
      {
        "name": "CODRU",
        "zip": "417557",
        "lat": "46.633197",
        "long": "22.145188"
      },
      {
        "name": "COHANI",
        "zip": "417006",
        "lat": "47.321322",
        "long": "22.403498"
      },
      {
        "name": "COLESTI",
        "zip": "415803",
        "lat": "46.479003",
        "long": "22.431351"
      },
      {
        "name": "COPACEL",
        "zip": "417205",
        "lat": "46.981672",
        "long": "22.167182"
      },
      {
        "name": "COPACENI",
        "zip": "417456",
        "lat": "46.772752",
        "long": "22.189868"
      },
      {
        "name": "CORBESTI",
        "zip": "417158",
        "lat": "46.895016",
        "long": "22.229832"
      },
      {
        "name": "CORBOAIA",
        "zip": "417061",
        "lat": "47.361057",
        "long": "22.53103"
      },
      {
        "name": "CORDAU",
        "zip": "417499",
        "lat": "46.965934",
        "long": "21.975499"
      },
      {
        "name": "CORNISESTI",
        "zip": "417241",
        "lat": "46.828644",
        "long": "22.235243"
      },
      {
        "name": "CORNITEL",
        "zip": "417068",
        "lat": "46.984257",
        "long": "22.643439"
      },
      {
        "name": "COSDENI",
        "zip": "417382",
        "lat": "46.769538",
        "long": "22.274797"
      },
      {
        "name": "COTIGLET",
        "zip": "417159",
        "lat": "46.889453",
        "long": "22.199933"
      },
      {
        "name": "CRANCESTI",
        "zip": "417242",
        "lat": "46.817909",
        "long": "22.253017"
      },
      {
        "name": "CRESTUR",
        "zip": "417016",
        "lat": "47.349426",
        "long": "22.239412"
      },
      {
        "name": "CRESUIA",
        "zip": "417222",
        "lat": "46.708572",
        "long": "22.479717"
      },
      {
        "name": "CRISTIORU DE JOS",
        "zip": "417215",
        "lat": "46.418218",
        "long": "22.535521"
      },
      {
        "name": "CRISTIORU DE SUS",
        "zip": "417217",
        "lat": "46.412998",
        "long": "22.575875"
      },
      {
        "name": "CUBULCUT",
        "zip": "417438",
        "lat": "47.322548",
        "long": "22.186511"
      },
      {
        "name": "CUCUCENI",
        "zip": "417416",
        "lat": "46.565265",
        "long": "22.424608"
      },
      {
        "name": "CUIESD",
        "zip": "417091",
        "lat": "47.11143",
        "long": "22.29485"
      },
      {
        "name": "CURATELE",
        "zip": "417220",
        "lat": "46.703739",
        "long": "22.421699"
      },
      {
        "name": "CURTUISENI",
        "zip": "417225",
        "lat": "47.545611",
        "long": "22.203113"
      },
      {
        "name": "CUSUIUS",
        "zip": "417302",
        "lat": "46.581653",
        "long": "22.417296"
      },
      {
        "name": "CUZAP",
        "zip": "417393",
        "lat": "47.202877",
        "long": "22.415235"
      },
      {
        "name": "DAMIS",
        "zip": "417082",
        "lat": "46.869226",
        "long": "22.555361"
      },
      {
        "name": "DELANI",
        "zip": "415201",
        "lat": "46.693538",
        "long": "22.339733"
      },
      {
        "name": "DERNA",
        "zip": "417230",
        "lat": "47.204854",
        "long": "22.307814"
      },
      {
        "name": "DERNISOARA",
        "zip": "417231",
        "lat": "47.220539",
        "long": "22.253494"
      },
      {
        "name": "DICANESTI",
        "zip": "417261",
        "lat": "46.894998",
        "long": "22.098871"
      },
      {
        "name": "DIJIR",
        "zip": "417007",
        "lat": "47.349035",
        "long": "22.46352"
      },
      {
        "name": "DIOSIG",
        "zip": "417235",
        "lat": "47.306779",
        "long": "21.995341"
      },
      {
        "name": "DOBRESTI",
        "zip": "417240",
        "lat": "46.845014",
        "long": "22.27982"
      },
      {
        "name": "DOBRICIONESTI",
        "zip": "417338",
        "lat": "46.994923",
        "long": "22.477963"
      },
      {
        "name": "DOLEA",
        "zip": "417537",
        "lat": "47.2729",
        "long": "22.488101"
      },
      {
        "name": "DRAGANESTI",
        "zip": "417250",
        "lat": "46.629863",
        "long": "22.391018"
      },
      {
        "name": "DRAGESTI",
        "zip": "417260",
        "lat": "46.899892",
        "long": "22.128419"
      },
      {
        "name": "DRAGOTENI",
        "zip": "417411",
        "lat": "46.732146",
        "long": "22.306684"
      },
      {
        "name": "DUMBRAVA",
        "zip": "417281",
        "lat": "46.785153",
        "long": "22.068167"
      },
      {
        "name": "DUMBRAVANI",
        "zip": "417117",
        "lat": "46.586338",
        "long": "22.501378"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "417282",
        "lat": "46.793991",
        "long": "22.152321"
      },
      {
        "name": "DUMBRAVITA DE CODRU",
        "zip": "417558",
        "lat": "46.655598",
        "long": "22.162326"
      },
      {
        "name": "DUSESTI",
        "zip": "417161",
        "lat": "46.834279",
        "long": "22.179155"
      },
      {
        "name": "FANATE",
        "zip": "417141",
        "lat": "46.504229",
        "long": "22.539162"
      },
      {
        "name": "FANCICA",
        "zip": "417017",
        "lat": "47.324093",
        "long": "22.234392"
      },
      {
        "name": "FASCA",
        "zip": "417621",
        "lat": "46.984417",
        "long": "22.32942"
      },
      {
        "name": "FEGERNIC",
        "zip": "417524",
        "lat": "47.203674",
        "long": "22.128581"
      },
      {
        "name": "FEGERNICU NOU",
        "zip": "417526",
        "lat": "47.22008",
        "long": "22.10098"
      },
      {
        "name": "FELCHERIU",
        "zip": "417363",
        "lat": "46.996179",
        "long": "22.07906"
      },
      {
        "name": "FENERIS",
        "zip": "417376",
        "lat": "46.711925",
        "long": "22.287621"
      },
      {
        "name": "FERICE",
        "zip": "417118",
        "lat": "46.637151",
        "long": "22.522747"
      },
      {
        "name": "FINIS",
        "zip": "417265",
        "lat": "46.651994",
        "long": "22.315593"
      },
      {
        "name": "FIZIS",
        "zip": "417267",
        "lat": "46.655287",
        "long": "22.283504"
      },
      {
        "name": "FOGLAS",
        "zip": "417538",
        "lat": "47.243511",
        "long": "22.475355"
      },
      {
        "name": "FONAU",
        "zip": "417291",
        "lat": "46.817189",
        "long": "21.972264"
      },
      {
        "name": "FORAU",
        "zip": "417611",
        "lat": "46.710544",
        "long": "22.200155"
      },
      {
        "name": "FOROSIG",
        "zip": "417283",
        "lat": "46.821464",
        "long": "22.100343"
      },
      {
        "name": "FUGHIU",
        "zip": "417364",
        "lat": "47.058401",
        "long": "22.048496"
      },
      {
        "name": "GALASENI",
        "zip": "417339",
        "lat": "46.985336",
        "long": "22.426045"
      },
      {
        "name": "GALOSPETREU",
        "zip": "417572",
        "lat": "47.482474",
        "long": "22.2162"
      },
      {
        "name": "GEPIS",
        "zip": "417311",
        "lat": "46.845675",
        "long": "22.018856"
      },
      {
        "name": "GEPIU",
        "zip": "417149",
        "lat": "46.930341",
        "long": "21.790159"
      },
      {
        "name": "GHEGHIE",
        "zip": "417028",
        "lat": "47.018186",
        "long": "22.517417"
      },
      {
        "name": "GHENETEA",
        "zip": "415302",
        "lat": "47.391714",
        "long": "22.389419"
      },
      {
        "name": "GHIDA",
        "zip": "417043",
        "lat": "47.311121",
        "long": "22.451821"
      },
      {
        "name": "GHIGHISENI",
        "zip": "417417",
        "lat": "46.551415",
        "long": "22.431483"
      },
      {
        "name": "GHIORAC",
        "zip": "417197",
        "lat": "46.714044",
        "long": "21.682488"
      },
      {
        "name": "GINTA",
        "zip": "417131",
        "lat": "46.753418",
        "long": "22.088069"
      },
      {
        "name": "GIRISU DE CRIS",
        "zip": "417270",
        "lat": "47.066152",
        "long": "21.759881"
      },
      {
        "name": "GIRISU NEGRU",
        "zip": "417597",
        "lat": "46.725878",
        "long": "21.908393"
      },
      {
        "name": "GIULESTI",
        "zip": "417368",
        "lat": "46.548097",
        "long": "22.588602"
      },
      {
        "name": "GOILA",
        "zip": "417126",
        "lat": "46.772875",
        "long": "22.339746"
      },
      {
        "name": "GRADINARI",
        "zip": "417252",
        "lat": "46.639826",
        "long": "22.374246"
      },
      {
        "name": "GROSI",
        "zip": "417029",
        "lat": "47.045247",
        "long": "22.479652"
      },
      {
        "name": "GRUILUNG",
        "zip": "417312",
        "lat": "46.879068",
        "long": "22.100379"
      },
      {
        "name": "GURANI",
        "zip": "417369",
        "lat": "46.595182",
        "long": "22.545495"
      },
      {
        "name": "GURBEDIU",
        "zip": "417598",
        "lat": "46.794299",
        "long": "21.864038"
      },
      {
        "name": "GURBESTI",
        "zip": "417127",
        "lat": "46.75107",
        "long": "22.359347"
      },
      {
        "name": "GURBESTI",
        "zip": "417532",
        "lat": "47.194453",
        "long": "22.224528"
      },
      {
        "name": "HAIEU",
        "zip": "417501",
        "lat": "46.994423",
        "long": "21.996454"
      },
      {
        "name": "HARSESTI",
        "zip": "417142",
        "lat": "46.536437",
        "long": "22.504506"
      },
      {
        "name": "HAUCESTI",
        "zip": "417182",
        "lat": "47.228487",
        "long": "22.202212"
      },
      {
        "name": "HIDIS",
        "zip": "417383",
        "lat": "46.778102",
        "long": "22.260991"
      },
      {
        "name": "HIDISEL",
        "zip": "417243",
        "lat": "46.834436",
        "long": "22.258423"
      },
      {
        "name": "HIDISELU DE JOS",
        "zip": "417276",
        "lat": "46.946876",
        "long": "22.026336"
      },
      {
        "name": "HIDISELU DE SUS",
        "zip": "417275",
        "lat": "46.933011",
        "long": "22.044506"
      },
      {
        "name": "HINCHIRIS",
        "zip": "417303",
        "lat": "46.591013",
        "long": "22.366538"
      },
      {
        "name": "HODIS",
        "zip": "417284",
        "lat": "46.80161",
        "long": "22.105313"
      },
      {
        "name": "HODISEL",
        "zip": "417357",
        "lat": "46.646145",
        "long": "22.063557"
      },
      {
        "name": "HODOS",
        "zip": "417451",
        "lat": "47.224884",
        "long": "21.984946"
      },
      {
        "name": "HOLOD",
        "zip": "417280",
        "lat": "46.785037",
        "long": "22.12228"
      },
      {
        "name": "HOMOROG",
        "zip": "417331",
        "lat": "46.831698",
        "long": "21.746728"
      },
      {
        "name": "HOTAR",
        "zip": "417606",
        "lat": "47.01967",
        "long": "22.285146"
      },
      {
        "name": "HOTAREL",
        "zip": "417322",
        "lat": "46.533195",
        "long": "22.440552"
      },
      {
        "name": "HUSASAU DE CRIS",
        "zip": "417297",
        "lat": "47.085505",
        "long": "22.064232"
      },
      {
        "name": "HUSASAU DE TINCA",
        "zip": "417290",
        "lat": "46.820576",
        "long": "21.9125"
      },
      {
        "name": "HUTA",
        "zip": "417062",
        "lat": "47.366339",
        "long": "22.566013"
      },
      {
        "name": "HUTA VOIVOZI",
        "zip": "417551",
        "lat": "47.156307",
        "long": "22.479798"
      },
      {
        "name": "IANCA",
        "zip": "417236",
        "lat": "47.282532",
        "long": "21.986862"
      },
      {
        "name": "IANOSDA",
        "zip": "417332",
        "lat": "46.837936",
        "long": "21.80511"
      },
      {
        "name": "INAND",
        "zip": "417151",
        "lat": "46.894531",
        "long": "21.750526"
      },
      {
        "name": "INCESTI",
        "zip": "417162",
        "lat": "46.845479",
        "long": "22.128942"
      },
      {
        "name": "INEU",
        "zip": "417295",
        "lat": "47.086296",
        "long": "22.115307"
      },
      {
        "name": "IOANIS",
        "zip": "417268",
        "lat": "46.67073",
        "long": "22.274529"
      },
      {
        "name": "ITEU",
        "zip": "417008",
        "lat": "47.351941",
        "long": "22.41699"
      },
      {
        "name": "ITEU NOU",
        "zip": "417009",
        "lat": "47.339801",
        "long": "22.391747"
      },
      {
        "name": "IZBUC",
        "zip": "417137",
        "lat": "46.440264",
        "long": "22.465715"
      },
      {
        "name": "IZVOARELE",
        "zip": "417626",
        "lat": "47.401031",
        "long": "22.400353"
      },
      {
        "name": "JOSANI",
        "zip": "417128",
        "lat": "46.754186",
        "long": "22.354061"
      },
      {
        "name": "JOSANI",
        "zip": "417341",
        "lat": "47.000049",
        "long": "22.46382"
      },
      {
        "name": "LACU SARAT",
        "zip": "417384",
        "lat": "46.803418",
        "long": "22.355276"
      },
      {
        "name": "LAZARENI",
        "zip": "417305",
        "lat": "46.878002",
        "long": "22.063905"
      },
      {
        "name": "LAZURI",
        "zip": "417426",
        "lat": "46.795254",
        "long": "22.413058"
      },
      {
        "name": "LAZURI DE BEIUS",
        "zip": "417300",
        "lat": "46.593031",
        "long": "22.402115"
      },
      {
        "name": "LEHECENI",
        "zip": "417138",
        "lat": "46.446566",
        "long": "22.516385"
      },
      {
        "name": "LELESTI",
        "zip": "417119",
        "lat": "46.620125",
        "long": "22.457092"
      },
      {
        "name": "LES",
        "zip": "417348",
        "lat": "46.96586",
        "long": "21.835834"
      },
      {
        "name": "LIVADA BEIUSULUI",
        "zip": "417253",
        "lat": "46.648864",
        "long": "22.399698"
      },
      {
        "name": "LIVADA DE BIHOR",
        "zip": "417349",
        "lat": "47.010394",
        "long": "21.808363"
      },
      {
        "name": "LORANTA",
        "zip": "417092",
        "lat": "47.136539",
        "long": "22.31994"
      },
      {
        "name": "LORAU",
        "zip": "417083",
        "lat": "46.91659",
        "long": "22.631387"
      },
      {
        "name": "LUGASU DE JOS",
        "zip": "417315",
        "lat": "47.062792",
        "long": "22.347626"
      },
      {
        "name": "LUGASU DE SUS",
        "zip": "417316",
        "lat": "47.078261",
        "long": "22.35709"
      },
      {
        "name": "LUNCA",
        "zip": "417320",
        "lat": "46.520728",
        "long": "22.463977"
      },
      {
        "name": "LUNCASPRIE",
        "zip": "417244",
        "lat": "46.845815",
        "long": "22.312035"
      },
      {
        "name": "LUNCSOARA",
        "zip": "417031",
        "lat": "47.036632",
        "long": "22.54213"
      },
      {
        "name": "LUPOAIA",
        "zip": "417286",
        "lat": "46.803304",
        "long": "22.125174"
      },
      {
        "name": "MADARAS",
        "zip": "417330",
        "lat": "46.829747",
        "long": "21.679663"
      },
      {
        "name": "MAGESTI",
        "zip": "417335",
        "lat": "47.010056",
        "long": "22.450772"
      },
      {
        "name": "MAGURA",
        "zip": "417371",
        "lat": "46.553803",
        "long": "22.553449"
      },
      {
        "name": "MARGHITA",
        "zip": "415300",
        "lat": "47.34662",
        "long": "22.341499"
      },
      {
        "name": "MARGINE",
        "zip": "417011",
        "lat": "47.293512",
        "long": "22.423212"
      },
      {
        "name": "MARTIHAZ",
        "zip": "417333",
        "lat": "46.873477",
        "long": "21.648213"
      },
      {
        "name": "MEZIAD",
        "zip": "417412",
        "lat": "46.740898",
        "long": "22.42846"
      },
      {
        "name": "MIERAG",
        "zip": "417576",
        "lat": "46.604333",
        "long": "22.366104"
      },
      {
        "name": "MIERLAU",
        "zip": "417277",
        "lat": "46.91723",
        "long": "22.018364"
      },
      {
        "name": "MIERSIG",
        "zip": "417292",
        "lat": "46.886204",
        "long": "21.841996"
      },
      {
        "name": "MIHAI BRAVU",
        "zip": "417237",
        "lat": "47.257798",
        "long": "21.938112"
      },
      {
        "name": "MIHELEU",
        "zip": "417313",
        "lat": "46.826148",
        "long": "22.063475"
      },
      {
        "name": "MISCA",
        "zip": "417183",
        "lat": "47.262666",
        "long": "22.258118"
      },
      {
        "name": "MIZIES",
        "zip": "417254",
        "lat": "46.663341",
        "long": "22.400249"
      },
      {
        "name": "MOTESTI",
        "zip": "417372",
        "lat": "46.561245",
        "long": "22.508384"
      },
      {
        "name": "MUNTENI",
        "zip": "417112",
        "lat": "46.877931",
        "long": "22.694916"
      },
      {
        "name": "NADAR",
        "zip": "417533",
        "lat": "47.207479",
        "long": "22.167928"
      },
      {
        "name": "NIMAIESTI",
        "zip": "417223",
        "lat": "46.682944",
        "long": "22.391533"
      },
      {
        "name": "NIUVED",
        "zip": "417052",
        "lat": "47.233798",
        "long": "21.895297"
      },
      {
        "name": "NOJORID",
        "zip": "417345",
        "lat": "46.998917",
        "long": "21.886042"
      },
      {
        "name": "NUCET",
        "zip": "415400",
        "lat": "46.486912",
        "long": "22.558775"
      },
      {
        "name": "OGESTI",
        "zip": "417457",
        "lat": "46.80433",
        "long": "22.238054"
      },
      {
        "name": "OLCEA",
        "zip": "417355",
        "lat": "46.683257",
        "long": "21.982438"
      },
      {
        "name": "OLOSIG",
        "zip": "417439",
        "lat": "47.351404",
        "long": "22.173956"
      },
      {
        "name": "ORADEA",
        "zip": "410001",
        "lat": "47.056927",
        "long": "21.932605"
      },
      {
        "name": "ORTITEAG",
        "zip": "417342",
        "lat": "47.032159",
        "long": "22.442279"
      },
      {
        "name": "ORVISELE",
        "zip": "417093",
        "lat": "47.133447",
        "long": "22.22701"
      },
      {
        "name": "OSAND",
        "zip": "417293",
        "lat": "46.841093",
        "long": "21.962277"
      },
      {
        "name": "OSORHEI",
        "zip": "417360",
        "lat": "47.04129",
        "long": "22.02909"
      },
      {
        "name": "OTOMANI",
        "zip": "417446",
        "lat": "47.436526",
        "long": "22.236499"
      },
      {
        "name": "PACALESTI",
        "zip": "417255",
        "lat": "46.62326",
        "long": "22.405079"
      },
      {
        "name": "PADUREA NEAGRA",
        "zip": "415101",
        "lat": "47.165542",
        "long": "22.41323"
      },
      {
        "name": "PADURENI",
        "zip": "417627",
        "lat": "47.426706",
        "long": "22.456805"
      },
      {
        "name": "PAGAIA",
        "zip": "417063",
        "lat": "47.408065",
        "long": "22.494336"
      },
      {
        "name": "PALEU",
        "zip": "417166",
        "lat": "47.11646",
        "long": "21.955407"
      },
      {
        "name": "PALOTA",
        "zip": "417516",
        "lat": "47.060838",
        "long": "21.823553"
      },
      {
        "name": "PANTASESTI",
        "zip": "417256",
        "lat": "46.617395",
        "long": "22.404619"
      },
      {
        "name": "PARHIDA",
        "zip": "417053",
        "lat": "47.234365",
        "long": "21.871599"
      },
      {
        "name": "PAULESTI",
        "zip": "417094",
        "lat": "47.174961",
        "long": "22.219648"
      },
      {
        "name": "PAUSA",
        "zip": "417351",
        "lat": "46.946052",
        "long": "21.868736"
      },
      {
        "name": "PESTERE",
        "zip": "417023",
        "lat": "47.026877",
        "long": "22.373879"
      },
      {
        "name": "PESTIS",
        "zip": "415102",
        "lat": "47.072517",
        "long": "22.412255"
      },
      {
        "name": "PETID",
        "zip": "417203",
        "lat": "46.71843",
        "long": "22.077312"
      },
      {
        "name": "PETRANI",
        "zip": "417377",
        "lat": "46.68924",
        "long": "22.268405"
      },
      {
        "name": "PETREASA",
        "zip": "417413",
        "lat": "46.714317",
        "long": "22.34817"
      },
      {
        "name": "PETREU",
        "zip": "417018",
        "lat": "47.337382",
        "long": "22.296068"
      },
      {
        "name": "PETRILENI",
        "zip": "417418",
        "lat": "46.555448",
        "long": "22.447707"
      },
      {
        "name": "PICLEU",
        "zip": "417096",
        "lat": "47.144702",
        "long": "22.260585"
      },
      {
        "name": "PIETROASA",
        "zip": "417365",
        "lat": "46.590806",
        "long": "22.555638"
      },
      {
        "name": "POCIOVELISTE",
        "zip": "417224",
        "lat": "46.701172",
        "long": "22.438593"
      },
      {
        "name": "POCLUSA DE BARCAU",
        "zip": "417184",
        "lat": "47.256911",
        "long": "22.196572"
      },
      {
        "name": "POCLUSA DE BEIUS",
        "zip": "417559",
        "lat": "46.649515",
        "long": "22.089942"
      },
      {
        "name": "POCOLA",
        "zip": "417375",
        "lat": "46.694958",
        "long": "22.293535"
      },
      {
        "name": "POIANA",
        "zip": "417218",
        "lat": "46.448302",
        "long": "22.579979"
      },
      {
        "name": "POIANA",
        "zip": "417584",
        "lat": "47.296522",
        "long": "22.352157"
      },
      {
        "name": "POIANA TASAD",
        "zip": "417208",
        "lat": "46.954299",
        "long": "22.16193"
      },
      {
        "name": "POIENII DE JOS",
        "zip": "417121",
        "lat": "46.608408",
        "long": "22.500643"
      },
      {
        "name": "POIENII DE SUS",
        "zip": "417122",
        "lat": "46.608025",
        "long": "22.517415"
      },
      {
        "name": "POIETARI",
        "zip": "417378",
        "lat": "46.707681",
        "long": "22.305069"
      },
      {
        "name": "POMEZEU",
        "zip": "417380",
        "lat": "46.794281",
        "long": "22.288979"
      },
      {
        "name": "PONOARA",
        "zip": "417084",
        "lat": "46.885605",
        "long": "22.65776"
      },
      {
        "name": "POPESTI",
        "zip": "417390",
        "lat": "47.238506",
        "long": "22.418619"
      },
      {
        "name": "POSOLOACA",
        "zip": "417588",
        "lat": "47.061194",
        "long": "22.241667"
      },
      {
        "name": "PRISACA",
        "zip": "417612",
        "lat": "46.710692",
        "long": "22.226477"
      },
      {
        "name": "RABAGANI",
        "zip": "417400",
        "lat": "46.74667",
        "long": "22.236256"
      },
      {
        "name": "RACAS",
        "zip": "417246",
        "lat": "46.872259",
        "long": "22.333763"
      },
      {
        "name": "RAPA",
        "zip": "417599",
        "lat": "46.782189",
        "long": "22.028446"
      },
      {
        "name": "REGHEA",
        "zip": "417628",
        "lat": "47.376281",
        "long": "22.487052"
      },
      {
        "name": "REMETEA",
        "zip": "417410",
        "lat": "46.739246",
        "long": "22.347956"
      },
      {
        "name": "REMETI",
        "zip": "417113",
        "lat": "46.84545",
        "long": "22.65513"
      },
      {
        "name": "RIENI",
        "zip": "417415",
        "lat": "46.575532",
        "long": "22.446651"
      },
      {
        "name": "ROGOZ",
        "zip": "417458",
        "lat": "46.794533",
        "long": "22.170237"
      },
      {
        "name": "ROHANI",
        "zip": "417132",
        "lat": "46.749106",
        "long": "22.093278"
      },
      {
        "name": "ROIT",
        "zip": "417152",
        "lat": "46.981826",
        "long": "21.709386"
      },
      {
        "name": "RONTAU",
        "zip": "417502",
        "lat": "47.002209",
        "long": "21.996724"
      },
      {
        "name": "ROSIA",
        "zip": "417425",
        "lat": "46.803725",
        "long": "22.397415"
      },
      {
        "name": "ROSIORI",
        "zip": "417238",
        "lat": "47.256772",
        "long": "21.95209"
      },
      {
        "name": "ROTARESTI",
        "zip": "417459",
        "lat": "46.79639",
        "long": "22.23049"
      },
      {
        "name": "RUGEA",
        "zip": "417064",
        "lat": "47.354119",
        "long": "22.49788"
      },
      {
        "name": "SABOLCIU",
        "zip": "417432",
        "lat": "47.074417",
        "long": "22.152622"
      },
      {
        "name": "SACA",
        "zip": "417102",
        "lat": "46.661584",
        "long": "22.469551"
      },
      {
        "name": "SACADAT",
        "zip": "417430",
        "lat": "47.043162",
        "long": "22.125165"
      },
      {
        "name": "SACALASAU",
        "zip": "417232",
        "lat": "47.196832",
        "long": "22.286245"
      },
      {
        "name": "SACALASAU NOU",
        "zip": "417233",
        "lat": "47.184268",
        "long": "22.32813"
      },
      {
        "name": "SACUENI",
        "zip": "417435",
        "lat": "47.356669",
        "long": "22.084534"
      },
      {
        "name": "SALACEA",
        "zip": "417445",
        "lat": "47.459379",
        "long": "22.306444"
      },
      {
        "name": "SALARD",
        "zip": "417450",
        "lat": "47.218241",
        "long": "22.031022"
      },
      {
        "name": "SALDABAGIU DE BARCAU",
        "zip": "417044",
        "lat": "47.301334",
        "long": "22.463679"
      },
      {
        "name": "SALDABAGIU DE MUNTE",
        "zip": "417167",
        "lat": "47.089268",
        "long": "21.973104"
      },
      {
        "name": "SALDABAGIU MIC",
        "zip": "417133",
        "lat": "46.738462",
        "long": "22.152347"
      },
      {
        "name": "SALISTE",
        "zip": "417534",
        "lat": "47.188269",
        "long": "22.234972"
      },
      {
        "name": "SALISTE DE BEIUS",
        "zip": "417103",
        "lat": "46.651021",
        "long": "22.446463"
      },
      {
        "name": "SALISTE DE POMEZEU",
        "zip": "417403",
        "lat": "46.746918",
        "long": "22.288884"
      },
      {
        "name": "SALISTE DE VASCAU",
        "zip": "417219",
        "lat": "46.43388",
        "long": "22.540872"
      },
      {
        "name": "SALONTA",
        "zip": "415500",
        "lat": "46.802477",
        "long": "21.659401"
      },
      {
        "name": "SAMBATA",
        "zip": "417455",
        "lat": "46.80146",
        "long": "22.201916"
      },
      {
        "name": "SANIOB",
        "zip": "417192",
        "lat": "47.262846",
        "long": "22.130132"
      },
      {
        "name": "SANLAZAR",
        "zip": "417187",
        "lat": "47.290898",
        "long": "22.252956"
      },
      {
        "name": "SANMARTIN",
        "zip": "417495",
        "lat": "47.005213",
        "long": "21.97416"
      },
      {
        "name": "SANMARTIN DE BEIUS",
        "zip": "417379",
        "lat": "46.690686",
        "long": "22.322658"
      },
      {
        "name": "SANNICOLAU DE BEIUS",
        "zip": "417561",
        "lat": "46.694375",
        "long": "22.113225"
      },
      {
        "name": "SANNICOLAU DE MUNTE",
        "zip": "417441",
        "lat": "47.303621",
        "long": "22.136706"
      },
      {
        "name": "SANNICOLAU ROMAN",
        "zip": "417153",
        "lat": "46.960717",
        "long": "21.712513"
      },
      {
        "name": "SANTANDREI",
        "zip": "417515",
        "lat": "47.06824",
        "long": "21.854759"
      },
      {
        "name": "SANTAUL MARE",
        "zip": "417076",
        "lat": "47.169411",
        "long": "21.837692"
      },
      {
        "name": "SANTAUL MIC",
        "zip": "417077",
        "lat": "47.142796",
        "long": "21.832542"
      },
      {
        "name": "SANTELEC",
        "zip": "417278",
        "lat": "46.959577",
        "long": "22.063838"
      },
      {
        "name": "SANTIMREU",
        "zip": "417452",
        "lat": "47.248773",
        "long": "22.045099"
      },
      {
        "name": "SANTION",
        "zip": "417078",
        "lat": "47.096342",
        "long": "21.836603"
      },
      {
        "name": "SARAND",
        "zip": "417209",
        "lat": "47.001365",
        "long": "22.119463"
      },
      {
        "name": "SARBESTI",
        "zip": "417323",
        "lat": "46.501573",
        "long": "22.486492"
      },
      {
        "name": "SARBI",
        "zip": "417520",
        "lat": "47.193147",
        "long": "22.122146"
      },
      {
        "name": "SARCAU",
        "zip": "417527",
        "lat": "47.210831",
        "long": "22.152709"
      },
      {
        "name": "SARSIG",
        "zip": "417186",
        "lat": "47.239052",
        "long": "22.186043"
      },
      {
        "name": "SATU BARBA",
        "zip": "417012",
        "lat": "47.296888",
        "long": "22.445014"
      },
      {
        "name": "SATU NOU",
        "zip": "417054",
        "lat": "47.19453",
        "long": "21.921479"
      },
      {
        "name": "SAUAIEU",
        "zip": "417352",
        "lat": "46.937468",
        "long": "21.917195"
      },
      {
        "name": "SAUCANI",
        "zip": "417404",
        "lat": "46.732471",
        "long": "22.267559"
      },
      {
        "name": "SAUD",
        "zip": "417123",
        "lat": "46.619765",
        "long": "22.495642"
      },
      {
        "name": "SEBIS",
        "zip": "417257",
        "lat": "46.619078",
        "long": "22.432284"
      },
      {
        "name": "SEGHISTE",
        "zip": "417324",
        "lat": "46.538556",
        "long": "22.489187"
      },
      {
        "name": "SERANI",
        "zip": "417069",
        "lat": "47.038407",
        "long": "22.680985"
      },
      {
        "name": "SERGHIS",
        "zip": "417623",
        "lat": "46.980396",
        "long": "22.239977"
      },
      {
        "name": "SFARNAS",
        "zip": "417193",
        "lat": "47.235774",
        "long": "22.087885"
      },
      {
        "name": "SIGHISTEL",
        "zip": "417143",
        "lat": "46.518477",
        "long": "22.541119"
      },
      {
        "name": "SILINDRU",
        "zip": "417546",
        "lat": "47.437247",
        "long": "22.046833"
      },
      {
        "name": "SIMIAN",
        "zip": "417545",
        "lat": "47.487488",
        "long": "22.089266"
      },
      {
        "name": "SINTEU",
        "zip": "417550",
        "lat": "47.139552",
        "long": "22.520327"
      },
      {
        "name": "SISTEREA",
        "zip": "417168",
        "lat": "47.160069",
        "long": "22.074034"
      },
      {
        "name": "SITANI",
        "zip": "417386",
        "lat": "46.813178",
        "long": "22.302285"
      },
      {
        "name": "SITITELEC",
        "zip": "417294",
        "lat": "46.8767",
        "long": "21.900854"
      },
      {
        "name": "SOCET",
        "zip": "417552",
        "lat": "47.158068",
        "long": "22.495926"
      },
      {
        "name": "SOHODOL",
        "zip": "417129",
        "lat": "46.78015",
        "long": "22.427172"
      },
      {
        "name": "SOIMI",
        "zip": "417555",
        "lat": "46.685629",
        "long": "22.123702"
      },
      {
        "name": "SOIMUS",
        "zip": "417414",
        "lat": "46.720453",
        "long": "22.329"
      },
      {
        "name": "SPINUS",
        "zip": "417530",
        "lat": "47.200821",
        "long": "22.190859"
      },
      {
        "name": "SPINUS DE POMEZEU",
        "zip": "417387",
        "lat": "46.78727",
        "long": "22.274497"
      },
      {
        "name": "STANCESTI",
        "zip": "417124",
        "lat": "46.591649",
        "long": "22.511576"
      },
      {
        "name": "STEI",
        "zip": "415600",
        "lat": "46.539937",
        "long": "22.45809"
      },
      {
        "name": "STRACOS",
        "zip": "417262",
        "lat": "46.910889",
        "long": "22.144931"
      },
      {
        "name": "SUBPIATRA",
        "zip": "417607",
        "lat": "47.025381",
        "long": "22.307271"
      },
      {
        "name": "SUDRIGIU",
        "zip": "417419",
        "lat": "46.591795",
        "long": "22.432429"
      },
      {
        "name": "SUIUG",
        "zip": "417013",
        "lat": "47.32018",
        "long": "22.432189"
      },
      {
        "name": "SUMUGIU",
        "zip": "417279",
        "lat": "46.890768",
        "long": "21.970982"
      },
      {
        "name": "SUNCUIS",
        "zip": "417269",
        "lat": "46.674377",
        "long": "22.264374"
      },
      {
        "name": "SUNCUIUS",
        "zip": "417565",
        "lat": "46.945758",
        "long": "22.53574"
      },
      {
        "name": "SUPLACU DE BARCAU",
        "zip": "417535",
        "lat": "47.257289",
        "long": "22.531883"
      },
      {
        "name": "SUPLACU DE TINCA",
        "zip": "417134",
        "lat": "46.706813",
        "long": "22.111471"
      },
      {
        "name": "SURDUC",
        "zip": "417211",
        "lat": "46.976105",
        "long": "22.201604"
      },
      {
        "name": "SURDUCEL",
        "zip": "417622",
        "lat": "46.928676",
        "long": "22.332882"
      },
      {
        "name": "SUSTIU",
        "zip": "417326",
        "lat": "46.500349",
        "long": "22.457862"
      },
      {
        "name": "SUSTUROGI",
        "zip": "417169",
        "lat": "47.140231",
        "long": "22.112696"
      },
      {
        "name": "TALPE",
        "zip": "417258",
        "lat": "46.650264",
        "long": "22.420647"
      },
      {
        "name": "TALPOS",
        "zip": "417047",
        "lat": "46.692466",
        "long": "21.798618"
      },
      {
        "name": "TAMASDA",
        "zip": "417037",
        "lat": "46.644533",
        "long": "21.556846"
      },
      {
        "name": "TAMASEU",
        "zip": "417056",
        "lat": "47.221161",
        "long": "21.9276"
      },
      {
        "name": "TARCAIA",
        "zip": "417575",
        "lat": "46.634226",
        "long": "22.363657"
      },
      {
        "name": "TARCAITA",
        "zip": "417577",
        "lat": "46.588658",
        "long": "22.335031"
      },
      {
        "name": "TARCEA",
        "zip": "417570",
        "lat": "47.457159",
        "long": "22.174985"
      },
      {
        "name": "TARGUSOR",
        "zip": "417177",
        "lat": "47.388466",
        "long": "22.163268"
      },
      {
        "name": "TARIAN",
        "zip": "417272",
        "lat": "47.076217",
        "long": "21.777339"
      },
      {
        "name": "TASAD",
        "zip": "417263",
        "lat": "46.937731",
        "long": "22.125158"
      },
      {
        "name": "TAUT",
        "zip": "417048",
        "lat": "46.719899",
        "long": "21.838447"
      },
      {
        "name": "TAUTELEC",
        "zip": "417171",
        "lat": "47.155162",
        "long": "22.03217"
      },
      {
        "name": "TAUTEU",
        "zip": "417580",
        "lat": "47.271538",
        "long": "22.338879"
      },
      {
        "name": "TELEAC",
        "zip": "417104",
        "lat": "46.661456",
        "long": "22.43051"
      },
      {
        "name": "TELECHIU",
        "zip": "417608",
        "lat": "47.054291",
        "long": "22.274634"
      },
      {
        "name": "TETCHEA",
        "zip": "417605",
        "lat": "47.045939",
        "long": "22.324848"
      },
      {
        "name": "TIGANESTII DE BEIUS",
        "zip": "417259",
        "lat": "46.629163",
        "long": "22.414131"
      },
      {
        "name": "TIGANESTII DE CRIS",
        "zip": "417097",
        "lat": "47.127324",
        "long": "22.281881"
      },
      {
        "name": "TILEAGD",
        "zip": "417585",
        "lat": "47.073925",
        "long": "22.200692"
      },
      {
        "name": "TILECUS",
        "zip": "417589",
        "lat": "47.022435",
        "long": "22.218337"
      },
      {
        "name": "TINAUD",
        "zip": "415103",
        "lat": "47.052854",
        "long": "22.433647"
      },
      {
        "name": "TINCA",
        "zip": "417595",
        "lat": "46.774923",
        "long": "21.931602"
      },
      {
        "name": "TOBOLIU",
        "zip": "417273",
        "lat": "47.042727",
        "long": "21.721143"
      },
      {
        "name": "TOMNATIC",
        "zip": "417617",
        "lat": "46.911709",
        "long": "22.446203"
      },
      {
        "name": "TOPA DE CRIS",
        "zip": "417618",
        "lat": "47.002106",
        "long": "22.533415"
      },
      {
        "name": "TOPA DE JOS",
        "zip": "417247",
        "lat": "46.8437",
        "long": "22.232161"
      },
      {
        "name": "TOPA DE SUS",
        "zip": "417248",
        "lat": "46.864967",
        "long": "22.25104"
      },
      {
        "name": "TOPESTI",
        "zip": "417264",
        "lat": "46.876693",
        "long": "22.127373"
      },
      {
        "name": "TOTORENI",
        "zip": "417578",
        "lat": "46.614095",
        "long": "22.388085"
      },
      {
        "name": "TRIA",
        "zip": "417234",
        "lat": "47.233421",
        "long": "22.265808"
      },
      {
        "name": "TULCA",
        "zip": "417600",
        "lat": "46.78803",
        "long": "21.773256"
      },
      {
        "name": "UCURIS",
        "zip": "417358",
        "lat": "46.637162",
        "long": "21.95763"
      },
      {
        "name": "UILEACU DE BEIUS",
        "zip": "417610",
        "lat": "46.684581",
        "long": "22.221351"
      },
      {
        "name": "UILEACU DE CRIS",
        "zip": "417591",
        "lat": "47.081217",
        "long": "22.212831"
      },
      {
        "name": "UILEACU DE MUNTE",
        "zip": "417172",
        "lat": "47.117857",
        "long": "21.997628"
      },
      {
        "name": "URSAD",
        "zip": "417562",
        "lat": "46.6816",
        "long": "22.091922"
      },
      {
        "name": "URVIND",
        "zip": "417317",
        "lat": "47.067268",
        "long": "22.281748"
      },
      {
        "name": "URVIS DE BEIUS",
        "zip": "417563",
        "lat": "46.690283",
        "long": "22.157272"
      },
      {
        "name": "VADU CRISULUI",
        "zip": "417615",
        "lat": "46.986049",
        "long": "22.516934"
      },
      {
        "name": "VAIDA",
        "zip": "417239",
        "lat": "47.252795",
        "long": "21.994771"
      },
      {
        "name": "VALANI DE POMEZEU",
        "zip": "417388",
        "lat": "46.786077",
        "long": "22.323478"
      },
      {
        "name": "VALANII DE BEIUS",
        "zip": "417613",
        "lat": "46.700048",
        "long": "22.245408"
      },
      {
        "name": "VALCELELE",
        "zip": "417541",
        "lat": "47.23036",
        "long": "22.482039"
      },
      {
        "name": "VALEA CERULUI",
        "zip": "417539",
        "lat": "47.237894",
        "long": "22.496403"
      },
      {
        "name": "VALEA CRISULUI",
        "zip": "417086",
        "lat": "46.950976",
        "long": "22.64372"
      },
      {
        "name": "VALEA DE JOS",
        "zip": "417421",
        "lat": "46.572112",
        "long": "22.486263"
      },
      {
        "name": "VALEA DE SUS",
        "zip": "417144",
        "lat": "46.546699",
        "long": "22.527075"
      },
      {
        "name": "VALEA LUI MIHAI",
        "zip": "415700",
        "lat": "47.51713",
        "long": "22.134894"
      },
      {
        "name": "VALEA MARE DE CODRU",
        "zip": "417287",
        "lat": "46.807775",
        "long": "22.078759"
      },
      {
        "name": "VALEA MARE DE CRIS",
        "zip": "417071",
        "lat": "46.993025",
        "long": "22.574101"
      },
      {
        "name": "VALEA TARNEI",
        "zip": "417553",
        "lat": "47.125168",
        "long": "22.530192"
      },
      {
        "name": "VARASAU",
        "zip": "417098",
        "lat": "47.162555",
        "long": "22.268133"
      },
      {
        "name": "VARASENI",
        "zip": "417406",
        "lat": "46.767586",
        "long": "22.211686"
      },
      {
        "name": "VARCIOROG",
        "zip": "417620",
        "lat": "46.96969",
        "long": "22.284146"
      },
      {
        "name": "VARVIZ",
        "zip": "417394",
        "lat": "47.224876",
        "long": "22.438547"
      },
      {
        "name": "VARZARI",
        "zip": "417396",
        "lat": "47.202976",
        "long": "22.454756"
      },
      {
        "name": "VARZARII DE JOS",
        "zip": "415804",
        "lat": "46.489592",
        "long": "22.498737"
      },
      {
        "name": "VARZARII DE SUS",
        "zip": "415805",
        "lat": "46.472986",
        "long": "22.516224"
      },
      {
        "name": "VASAD",
        "zip": "417226",
        "lat": "47.517452",
        "long": "22.254828"
      },
      {
        "name": "VASCAU",
        "zip": "415800",
        "lat": "46.470681",
        "long": "22.47513"
      },
      {
        "name": "VIISOARA",
        "zip": "417625",
        "lat": "47.385173",
        "long": "22.44318"
      },
      {
        "name": "VINTERE",
        "zip": "417288",
        "lat": "46.76855",
        "long": "22.145216"
      },
      {
        "name": "VOIVOZI",
        "zip": "417397",
        "lat": "47.215563",
        "long": "22.387132"
      },
      {
        "name": "VOIVOZI",
        "zip": "417547",
        "lat": "47.469566",
        "long": "22.040333"
      },
      {
        "name": "ZAVOIU",
        "zip": "417461",
        "lat": "46.821317",
        "long": "22.195081"
      },
      {
        "name": "ZECE HOTARE",
        "zip": "417568",
        "lat": "46.888496",
        "long": "22.47695"
      }
    ],
    "BISTRIȚA-NĂSĂUD": [
      {
        "name": "AGRIES",
        "zip": "427331",
        "lat": "47.400205",
        "long": "24.133203"
      },
      {
        "name": "AGRIESEL",
        "zip": "427332",
        "lat": "47.400521",
        "long": "24.093874"
      },
      {
        "name": "AGRISU DE JOS",
        "zip": "427306",
        "lat": "47.157028",
        "long": "24.237612"
      },
      {
        "name": "AGRISU DE SUS",
        "zip": "427307",
        "lat": "47.151057",
        "long": "24.229823"
      },
      {
        "name": "ALBESTII BISTRITEI",
        "zip": "427086",
        "lat": "46.993009",
        "long": "24.451137"
      },
      {
        "name": "ALUNISUL",
        "zip": "427386",
        "lat": "47.391779",
        "long": "24.277808"
      },
      {
        "name": "ANIES",
        "zip": "427131",
        "lat": "47.413474",
        "long": "24.76853"
      },
      {
        "name": "APATIU",
        "zip": "427046",
        "lat": "46.999678",
        "long": "24.186179"
      },
      {
        "name": "ARCALIA",
        "zip": "427296",
        "lat": "47.087344",
        "long": "24.355489"
      },
      {
        "name": "ARCHIUD",
        "zip": "427346",
        "lat": "46.890377",
        "long": "24.437421"
      },
      {
        "name": "ARDAN",
        "zip": "427291",
        "lat": "47.029898",
        "long": "24.672192"
      },
      {
        "name": "ARSITA",
        "zip": "427146",
        "lat": "47.359147",
        "long": "24.834599"
      },
      {
        "name": "BARLA",
        "zip": "427151",
        "lat": "47.01181",
        "long": "24.557018"
      },
      {
        "name": "BATA",
        "zip": "427216",
        "lat": "47.188449",
        "long": "23.994462"
      },
      {
        "name": "BECLEAN",
        "zip": "425100",
        "lat": "47.180175",
        "long": "24.179742"
      },
      {
        "name": "BEUDIU",
        "zip": "427201",
        "lat": "47.06222",
        "long": "24.173111"
      },
      {
        "name": "BICHIGIU",
        "zip": "427071",
        "lat": "47.423232",
        "long": "24.339309"
      },
      {
        "name": "BIDIU",
        "zip": "427136",
        "lat": "47.043352",
        "long": "24.234974"
      },
      {
        "name": "BISTRITA",
        "zip": "420008",
        "lat": "47.132687",
        "long": "24.496524"
      },
      {
        "name": "BISTRITA BARGAULUI",
        "zip": "427005",
        "lat": "47.20863",
        "long": "24.761809"
      },
      {
        "name": "BLAJENII DE JOS",
        "zip": "427321",
        "lat": "47.168205",
        "long": "24.354632"
      },
      {
        "name": "BLAJENII DE SUS",
        "zip": "427322",
        "lat": "47.162537",
        "long": "24.392606"
      },
      {
        "name": "BORLEASA",
        "zip": "427333",
        "lat": "47.343977",
        "long": "24.174455"
      },
      {
        "name": "BOZIES",
        "zip": "427047",
        "lat": "47.03237",
        "long": "24.191655"
      },
      {
        "name": "BRANISTEA",
        "zip": "427010",
        "lat": "47.172026",
        "long": "24.06615"
      },
      {
        "name": "BRATENI",
        "zip": "427261",
        "lat": "46.911867",
        "long": "24.391894"
      },
      {
        "name": "BREAZA",
        "zip": "427066",
        "lat": "47.351049",
        "long": "24.060447"
      },
      {
        "name": "BRETEA",
        "zip": "427308",
        "lat": "47.124309",
        "long": "24.243242"
      },
      {
        "name": "BUDACU DE JOS",
        "zip": "427015",
        "lat": "47.087164",
        "long": "24.520273"
      },
      {
        "name": "BUDACU DE SUS",
        "zip": "427036",
        "lat": "47.061181",
        "long": "24.65752"
      },
      {
        "name": "BUDESTI",
        "zip": "427020",
        "lat": "46.876879",
        "long": "24.244534"
      },
      {
        "name": "BUDESTI-FANATE",
        "zip": "427021",
        "lat": "46.844105",
        "long": "24.236913"
      },
      {
        "name": "BUDURLENI",
        "zip": "427347",
        "lat": "46.918778",
        "long": "24.422564"
      },
      {
        "name": "BUDUS",
        "zip": "427016",
        "lat": "47.078597",
        "long": "24.536217"
      },
      {
        "name": "BUNGARD",
        "zip": "427106",
        "lat": "46.939757",
        "long": "24.32862"
      },
      {
        "name": "BUZA CATUN",
        "zip": "427048",
        "lat": "46.940198",
        "long": "24.188702"
      },
      {
        "name": "CAIANU MARE",
        "zip": "427026",
        "lat": "47.232563",
        "long": "24.162442"
      },
      {
        "name": "CAIANU MIC",
        "zip": "427025",
        "lat": "47.235808",
        "long": "24.15723"
      },
      {
        "name": "CAILA",
        "zip": "427323",
        "lat": "47.143095",
        "long": "24.365709"
      },
      {
        "name": "CAMP",
        "zip": "427371",
        "lat": "46.778717",
        "long": "24.390109"
      },
      {
        "name": "CEPARI",
        "zip": "427076",
        "lat": "47.234891",
        "long": "24.428088"
      },
      {
        "name": "CHETIU",
        "zip": "427049",
        "lat": "47.030836",
        "long": "24.199713"
      },
      {
        "name": "CHINTELNIC",
        "zip": "427297",
        "lat": "47.101144",
        "long": "24.337203"
      },
      {
        "name": "CHIOCHIS",
        "zip": "427045",
        "lat": "46.984482",
        "long": "24.182613"
      },
      {
        "name": "CHIRALES",
        "zip": "427107",
        "lat": "47.087895",
        "long": "24.316028"
      },
      {
        "name": "CHIUZA",
        "zip": "427060",
        "lat": "47.234749",
        "long": "24.240722"
      },
      {
        "name": "CICEU-CORABIA",
        "zip": "427217",
        "lat": "47.244294",
        "long": "23.938765"
      },
      {
        "name": "CICEU-GIURGESTI",
        "zip": "427065",
        "lat": "47.244749",
        "long": "24.016777"
      },
      {
        "name": "CICEU-MIHAIESTI",
        "zip": "427218",
        "lat": "47.188783",
        "long": "23.972257"
      },
      {
        "name": "CICEU-POIENI",
        "zip": "427027",
        "lat": "47.299311",
        "long": "24.087986"
      },
      {
        "name": "CIOSA",
        "zip": "427361",
        "lat": "47.277619",
        "long": "24.94866"
      },
      {
        "name": "CIREASI",
        "zip": "427334",
        "lat": "47.412301",
        "long": "24.194482"
      },
      {
        "name": "CIRESOAIA",
        "zip": "427011",
        "lat": "47.142557",
        "long": "24.059827"
      },
      {
        "name": "COASTA",
        "zip": "427309",
        "lat": "47.126328",
        "long": "24.279879"
      },
      {
        "name": "COCIU",
        "zip": "427324",
        "lat": "47.196692",
        "long": "24.230522"
      },
      {
        "name": "COLDAU",
        "zip": "425101",
        "lat": "47.181993",
        "long": "24.133533"
      },
      {
        "name": "COLIBITA",
        "zip": "427007",
        "lat": "47.177953",
        "long": "24.9063"
      },
      {
        "name": "COMLOD",
        "zip": "427166",
        "lat": "46.858808",
        "long": "24.442934"
      },
      {
        "name": "CORMAIA",
        "zip": "425301",
        "lat": "47.390067",
        "long": "24.684306"
      },
      {
        "name": "CORVINESTI",
        "zip": "427137",
        "lat": "47.017134",
        "long": "24.260135"
      },
      {
        "name": "COSBUC",
        "zip": "427070",
        "lat": "47.365443",
        "long": "24.392203"
      },
      {
        "name": "COSERIU",
        "zip": "427372",
        "lat": "46.814725",
        "long": "24.37756"
      },
      {
        "name": "CRAINIMAT",
        "zip": "427298",
        "lat": "47.071159",
        "long": "24.401384"
      },
      {
        "name": "CRISTESTII CICEULUI",
        "zip": "427366",
        "lat": "47.194161",
        "long": "24.093562"
      },
      {
        "name": "CRISTUR-SIEU",
        "zip": "427311",
        "lat": "47.123476",
        "long": "24.299245"
      },
      {
        "name": "CUSMA",
        "zip": "427121",
        "lat": "47.129648",
        "long": "24.706171"
      },
      {
        "name": "DEALUL STEFANITEI",
        "zip": "427251",
        "lat": "47.578785",
        "long": "24.420953"
      },
      {
        "name": "DELURENI",
        "zip": "427373",
        "lat": "46.815026",
        "long": "24.346689"
      },
      {
        "name": "DIPSA",
        "zip": "427087",
        "lat": "46.962375",
        "long": "24.438974"
      },
      {
        "name": "DOBRIC",
        "zip": "427028",
        "lat": "47.245806",
        "long": "24.126231"
      },
      {
        "name": "DOBRICEL",
        "zip": "427029",
        "lat": "47.296488",
        "long": "24.11174"
      },
      {
        "name": "DOMNESTI",
        "zip": "427152",
        "lat": "47.034751",
        "long": "24.476508"
      },
      {
        "name": "DOROLEA",
        "zip": "427122",
        "lat": "47.172724",
        "long": "24.63528"
      },
      {
        "name": "DRAGA",
        "zip": "427271",
        "lat": "46.77173",
        "long": "24.272946"
      },
      {
        "name": "DUMBRAVA",
        "zip": "427123",
        "lat": "47.212984",
        "long": "24.620304"
      },
      {
        "name": "DUMBRAVA",
        "zip": "427202",
        "lat": "47.099866",
        "long": "24.129167"
      },
      {
        "name": "DUMBRAVENI",
        "zip": "427067",
        "lat": "47.282946",
        "long": "23.984651"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "427031",
        "lat": "47.257562",
        "long": "24.184519"
      },
      {
        "name": "DUMITRA",
        "zip": "427075",
        "lat": "47.222745",
        "long": "24.469523"
      },
      {
        "name": "DUMITRITA",
        "zip": "427037",
        "lat": "47.071429",
        "long": "24.625787"
      },
      {
        "name": "DUPA DEAL",
        "zip": "427167",
        "lat": "46.805519",
        "long": "24.445251"
      },
      {
        "name": "ENCIU",
        "zip": "427138",
        "lat": "47.050628",
        "long": "24.250225"
      },
      {
        "name": "FANATE",
        "zip": "427374",
        "lat": "46.793525",
        "long": "24.398223"
      },
      {
        "name": "FANATELE SILIVASULUI",
        "zip": "427272",
        "lat": "46.799963",
        "long": "24.275726"
      },
      {
        "name": "FANTANELE",
        "zip": "427139",
        "lat": "46.937185",
        "long": "24.273309"
      },
      {
        "name": "FANTANITA",
        "zip": "427161",
        "lat": "46.831644",
        "long": "24.340367"
      },
      {
        "name": "FELDRU",
        "zip": "427080",
        "lat": "47.277531",
        "long": "24.598067"
      },
      {
        "name": "FELEAC",
        "zip": "427203",
        "lat": "47.087177",
        "long": "24.248202"
      },
      {
        "name": "FIAD",
        "zip": "427356",
        "lat": "47.487093",
        "long": "24.386269"
      },
      {
        "name": "FIGA",
        "zip": "425102",
        "lat": "47.143098",
        "long": "24.210626"
      },
      {
        "name": "FLORESTI",
        "zip": "427181",
        "lat": "47.238398",
        "long": "24.279623"
      },
      {
        "name": "GALATII BISTRITEI",
        "zip": "427085",
        "lat": "46.992598",
        "long": "24.418367"
      },
      {
        "name": "GERSA I",
        "zip": "427241",
        "lat": "47.336246",
        "long": "24.459057"
      },
      {
        "name": "GERSA II",
        "zip": "427242",
        "lat": "47.374956",
        "long": "24.468133"
      },
      {
        "name": "GHEMES",
        "zip": "427168",
        "lat": "46.784425",
        "long": "24.444129"
      },
      {
        "name": "GHINDA",
        "zip": "420001",
        "lat": "47.135345",
        "long": "24.573712"
      },
      {
        "name": "GLEDIN",
        "zip": "427176",
        "lat": "46.9577",
        "long": "24.705871"
      },
      {
        "name": "HALMASAU",
        "zip": "427276",
        "lat": "47.344858",
        "long": "24.137975"
      },
      {
        "name": "HASMASU CICEULUI",
        "zip": "427367",
        "lat": "47.230452",
        "long": "24.058787"
      },
      {
        "name": "HERINA",
        "zip": "427088",
        "lat": "47.020335",
        "long": "24.414427"
      },
      {
        "name": "HIREAN",
        "zip": "427169",
        "lat": "46.812588",
        "long": "24.410031"
      },
      {
        "name": "ILISUA",
        "zip": "427368",
        "lat": "47.218563",
        "long": "24.088839"
      },
      {
        "name": "ILVA MARE",
        "zip": "427090",
        "lat": "47.363219",
        "long": "24.884089"
      },
      {
        "name": "ILVA MICA",
        "zip": "427095",
        "lat": "47.312243",
        "long": "24.650569"
      },
      {
        "name": "IVANEASA",
        "zip": "427091",
        "lat": "47.338782",
        "long": "24.908504"
      },
      {
        "name": "JEICA",
        "zip": "427153",
        "lat": "46.980442",
        "long": "24.504617"
      },
      {
        "name": "JELNA",
        "zip": "427017",
        "lat": "47.109548",
        "long": "24.555979"
      },
      {
        "name": "JIMBOR",
        "zip": "427051",
        "lat": "46.926284",
        "long": "24.208676"
      },
      {
        "name": "JOSENII BARGAULUI",
        "zip": "427100",
        "lat": "47.211739",
        "long": "24.670996"
      },
      {
        "name": "LA CURTE",
        "zip": "427262",
        "lat": "46.884425",
        "long": "24.373227"
      },
      {
        "name": "LECHINTA",
        "zip": "427105",
        "lat": "47.02022",
        "long": "24.329455"
      },
      {
        "name": "LELESTI",
        "zip": "427219",
        "lat": "47.222008",
        "long": "23.955539"
      },
      {
        "name": "LESU",
        "zip": "427115",
        "lat": "47.312105",
        "long": "24.751363"
      },
      {
        "name": "LIVEZILE",
        "zip": "427120",
        "lat": "47.181981",
        "long": "24.581171"
      },
      {
        "name": "LIVIU REBREANU",
        "zip": "425201",
        "lat": "47.260184",
        "long": "24.432906"
      },
      {
        "name": "LUNCA",
        "zip": "427316",
        "lat": "47.018512",
        "long": "24.679418"
      },
      {
        "name": "LUNCA BORLESEI",
        "zip": "427277",
        "lat": "47.319112",
        "long": "24.162817"
      },
      {
        "name": "LUNCA ILVEI",
        "zip": "427125",
        "lat": "47.364092",
        "long": "24.971058"
      },
      {
        "name": "LUNCA LESULUI",
        "zip": "427116",
        "lat": "47.309429",
        "long": "24.776016"
      },
      {
        "name": "LUNCA SATEASCA",
        "zip": "427336",
        "lat": "47.407438",
        "long": "24.180241"
      },
      {
        "name": "LUSCA",
        "zip": "425202",
        "lat": "47.279489",
        "long": "24.406443"
      },
      {
        "name": "MAGURA ILVEI",
        "zip": "427145",
        "lat": "47.373347",
        "long": "24.809091"
      },
      {
        "name": "MAGURELE",
        "zip": "427154",
        "lat": "47.014385",
        "long": "24.507751"
      },
      {
        "name": "MAIERU",
        "zip": "427130",
        "lat": "47.400116",
        "long": "24.743133"
      },
      {
        "name": "MALIN",
        "zip": "427204",
        "lat": "47.118702",
        "long": "24.135375"
      },
      {
        "name": "MALUT",
        "zip": "427012",
        "lat": "47.169379",
        "long": "24.101995"
      },
      {
        "name": "MANIC",
        "zip": "427052",
        "lat": "46.961852",
        "long": "24.199829"
      },
      {
        "name": "MARISELU",
        "zip": "427150",
        "lat": "47.011928",
        "long": "24.508094"
      },
      {
        "name": "MATEI",
        "zip": "427135",
        "lat": "46.981719",
        "long": "24.266562"
      },
      {
        "name": "MICESTII DE CAMPIE",
        "zip": "427160",
        "lat": "46.860582",
        "long": "24.311631"
      },
      {
        "name": "MIJLOCENII BARGAULUI",
        "zip": "427101",
        "lat": "47.215925",
        "long": "24.689357"
      },
      {
        "name": "MILAS",
        "zip": "427165",
        "lat": "46.820244",
        "long": "24.433276"
      },
      {
        "name": "MINTIU",
        "zip": "427182",
        "lat": "47.237793",
        "long": "24.351143"
      },
      {
        "name": "MIRES",
        "zip": "427061",
        "lat": "47.266386",
        "long": "24.23299"
      },
      {
        "name": "MITITEI",
        "zip": "427183",
        "lat": "47.283543",
        "long": "24.317262"
      },
      {
        "name": "MOCOD",
        "zip": "427184",
        "lat": "47.262488",
        "long": "24.296981"
      },
      {
        "name": "MOGOSENI",
        "zip": "427186",
        "lat": "47.213911",
        "long": "24.254206"
      },
      {
        "name": "MOLISET",
        "zip": "427337",
        "lat": "47.444713",
        "long": "24.135298"
      },
      {
        "name": "MONARIU",
        "zip": "427018",
        "lat": "47.066062",
        "long": "24.476036"
      },
      {
        "name": "MONOR",
        "zip": "427175",
        "lat": "46.950076",
        "long": "24.692062"
      },
      {
        "name": "MORUT",
        "zip": "427141",
        "lat": "46.961191",
        "long": "24.272767"
      },
      {
        "name": "MURESENII BARGAULUI",
        "zip": "427362",
        "lat": "47.210662",
        "long": "24.859955"
      },
      {
        "name": "NASAUD",
        "zip": "425200",
        "lat": "47.283106",
        "long": "24.4103"
      },
      {
        "name": "NEGRILESTI",
        "zip": "427068",
        "lat": "47.267249",
        "long": "24.049667"
      },
      {
        "name": "NEPOS",
        "zip": "427081",
        "lat": "47.277499",
        "long": "24.533196"
      },
      {
        "name": "NETENI",
        "zip": "427156",
        "lat": "47.011116",
        "long": "24.460655"
      },
      {
        "name": "NIMIGEA DE JOS",
        "zip": "427190",
        "lat": "47.253569",
        "long": "24.300837"
      },
      {
        "name": "NIMIGEA DE SUS",
        "zip": "427187",
        "lat": "47.280348",
        "long": "24.326358"
      },
      {
        "name": "NUSENI",
        "zip": "427200",
        "lat": "47.098441",
        "long": "24.202632"
      },
      {
        "name": "OARZINA",
        "zip": "427338",
        "lat": "47.419199",
        "long": "24.194266"
      },
      {
        "name": "OCNITA",
        "zip": "427348",
        "lat": "46.862665",
        "long": "24.486765"
      },
      {
        "name": "ORHEIU BISTRITEI",
        "zip": "427038",
        "lat": "47.096262",
        "long": "24.594656"
      },
      {
        "name": "OROSFAIA",
        "zip": "427171",
        "lat": "46.850516",
        "long": "24.420987"
      },
      {
        "name": "PALTINEASA",
        "zip": "427278",
        "lat": "47.295027",
        "long": "24.205912"
      },
      {
        "name": "PARVA",
        "zip": "427210",
        "lat": "47.396007",
        "long": "24.542177"
      },
      {
        "name": "PERISOR",
        "zip": "427387",
        "lat": "47.314174",
        "long": "24.227189"
      },
      {
        "name": "PETRIS",
        "zip": "427039",
        "lat": "47.103006",
        "long": "24.623143"
      },
      {
        "name": "PIATRA",
        "zip": "427062",
        "lat": "47.248755",
        "long": "24.265705"
      },
      {
        "name": "PIATRA FANTANELE",
        "zip": "427363",
        "lat": "47.237713",
        "long": "25.009915"
      },
      {
        "name": "PINTICU",
        "zip": "427349",
        "lat": "46.940387",
        "long": "24.540488"
      },
      {
        "name": "PODENII",
        "zip": "427376",
        "lat": "46.812804",
        "long": "24.296145"
      },
      {
        "name": "PODEREI",
        "zip": "427243",
        "lat": "47.281031",
        "long": "24.481743"
      },
      {
        "name": "PODIREI",
        "zip": "427299",
        "lat": "47.116667",
        "long": "24.335754"
      },
      {
        "name": "POIANA ILVEI",
        "zip": "427147",
        "lat": "47.357491",
        "long": "24.741038"
      },
      {
        "name": "POIENILE ZAGREI",
        "zip": "427388",
        "lat": "47.387286",
        "long": "24.254586"
      },
      {
        "name": "PORUMBENII",
        "zip": "427273",
        "lat": "46.767401",
        "long": "24.285946"
      },
      {
        "name": "POSMUS",
        "zip": "427292",
        "lat": "46.976335",
        "long": "24.591886"
      },
      {
        "name": "PRUNDU BARGAULUI",
        "zip": "427230",
        "lat": "47.220214",
        "long": "24.741652"
      },
      {
        "name": "PURCARETE",
        "zip": "427069",
        "lat": "47.309797",
        "long": "24.054078"
      },
      {
        "name": "RACATESU",
        "zip": "427339",
        "lat": "47.382332",
        "long": "24.196417"
      },
      {
        "name": "RAGLA",
        "zip": "427041",
        "lat": "47.070813",
        "long": "24.621788"
      },
      {
        "name": "REBRA",
        "zip": "427235",
        "lat": "47.325883",
        "long": "24.499844"
      },
      {
        "name": "REBRISOARA",
        "zip": "427240",
        "lat": "47.287478",
        "long": "24.451735"
      },
      {
        "name": "RETEAG",
        "zip": "427220",
        "lat": "47.195744",
        "long": "24.018458"
      },
      {
        "name": "RODNA",
        "zip": "427245",
        "lat": "47.416071",
        "long": "24.817046"
      },
      {
        "name": "ROMULI",
        "zip": "427250",
        "lat": "47.54615",
        "long": "24.436985"
      },
      {
        "name": "RUNCU SALVEI",
        "zip": "427256",
        "lat": "47.343816",
        "long": "24.325295"
      },
      {
        "name": "RUSTIOR",
        "zip": "427317",
        "lat": "46.99317",
        "long": "24.670797"
      },
      {
        "name": "RUSU BARGAULUI",
        "zip": "427102",
        "lat": "47.197572",
        "long": "24.639388"
      },
      {
        "name": "RUSU DE JOS",
        "zip": "425103",
        "lat": "47.144338",
        "long": "24.170477"
      },
      {
        "name": "RUSU DE SUS",
        "zip": "427206",
        "lat": "47.122424",
        "long": "24.180936"
      },
      {
        "name": "SALCUTA",
        "zip": "427263",
        "lat": "46.917293",
        "long": "24.300485"
      },
      {
        "name": "SALVA",
        "zip": "427255",
        "lat": "47.305865",
        "long": "24.35557"
      },
      {
        "name": "SANGEORZ-BAI",
        "zip": "425300",
        "lat": "47.368498",
        "long": "24.67212"
      },
      {
        "name": "SANGEORZU NOU",
        "zip": "427108",
        "lat": "46.961547",
        "long": "24.358574"
      },
      {
        "name": "SANIACOB",
        "zip": "427109",
        "lat": "47.054779",
        "long": "24.293262"
      },
      {
        "name": "SANMIHAIU DE CAMPIE",
        "zip": "427260",
        "lat": "46.892565",
        "long": "24.335885"
      },
      {
        "name": "SANNICOARA",
        "zip": "427053",
        "lat": "46.979897",
        "long": "24.127879"
      },
      {
        "name": "SANT",
        "zip": "427285",
        "lat": "47.439477",
        "long": "24.889254"
      },
      {
        "name": "SANTIOANA",
        "zip": "427157",
        "lat": "47.006673",
        "long": "24.564721"
      },
      {
        "name": "SARATA",
        "zip": "420002",
        "lat": "47.076322",
        "long": "24.437404"
      },
      {
        "name": "SARATEL",
        "zip": "427301",
        "lat": "47.052398",
        "long": "24.411672"
      },
      {
        "name": "SASARM",
        "zip": "427063",
        "lat": "47.211703",
        "long": "24.219409"
      },
      {
        "name": "SATU NOU",
        "zip": "427042",
        "lat": "47.110126",
        "long": "24.627086"
      },
      {
        "name": "SCOABE",
        "zip": "427377",
        "lat": "46.812675",
        "long": "24.312146"
      },
      {
        "name": "SEBIS",
        "zip": "427318",
        "lat": "47.006154",
        "long": "24.714853"
      },
      {
        "name": "SENDROAIA",
        "zip": "427341",
        "lat": "47.440445",
        "long": "24.17885"
      },
      {
        "name": "SESURI SPERMEZEU-VALE",
        "zip": "427281",
        "lat": "47.316496",
        "long": "24.157385"
      },
      {
        "name": "SIEU",
        "zip": "427290",
        "lat": "47.001073",
        "long": "24.60855"
      },
      {
        "name": "SIEU-MAGHERUS",
        "zip": "427295",
        "lat": "47.092079",
        "long": "24.373169"
      },
      {
        "name": "SIEU-ODORHEI",
        "zip": "427305",
        "lat": "47.152934",
        "long": "24.291286"
      },
      {
        "name": "SIEU-SFANTU",
        "zip": "427326",
        "lat": "47.145346",
        "long": "24.30695"
      },
      {
        "name": "SIEUT",
        "zip": "427315",
        "lat": "46.976649",
        "long": "24.648069"
      },
      {
        "name": "SIGMIR",
        "zip": "420003",
        "lat": "47.133116",
        "long": "24.424536"
      },
      {
        "name": "SILIVASU DE CAMPIE",
        "zip": "427270",
        "lat": "46.782247",
        "long": "24.300377"
      },
      {
        "name": "SIMIONESTI",
        "zip": "427019",
        "lat": "47.066438",
        "long": "24.499523"
      },
      {
        "name": "SINTEREAG",
        "zip": "427320",
        "lat": "47.180565",
        "long": "24.288583"
      },
      {
        "name": "SINTEREAG-GARA",
        "zip": "427327",
        "lat": "47.179137",
        "long": "24.268794"
      },
      {
        "name": "SIRIOARA",
        "zip": "427312",
        "lat": "47.101992",
        "long": "24.295032"
      },
      {
        "name": "SITA",
        "zip": "427279",
        "lat": "47.315026",
        "long": "24.18156"
      },
      {
        "name": "SLATINITA",
        "zip": "420004",
        "lat": "47.204148",
        "long": "24.526956"
      },
      {
        "name": "SOIMUS",
        "zip": "427293",
        "lat": "47.04148",
        "long": "24.62127"
      },
      {
        "name": "SOPTERIU",
        "zip": "427378",
        "lat": "46.797802",
        "long": "24.347604"
      },
      {
        "name": "SPERMEZEU",
        "zip": "427275",
        "lat": "47.293557",
        "long": "24.154741"
      },
      {
        "name": "STRAMBA",
        "zip": "427103",
        "lat": "47.226931",
        "long": "24.646283"
      },
      {
        "name": "STRUGURENI",
        "zip": "427054",
        "lat": "46.982633",
        "long": "24.199101"
      },
      {
        "name": "STUPINI",
        "zip": "427264",
        "lat": "46.875535",
        "long": "24.379798"
      },
      {
        "name": "SUPLAI",
        "zip": "427389",
        "lat": "47.438168",
        "long": "24.25739"
      },
      {
        "name": "SUSENII BARGAULUI",
        "zip": "427231",
        "lat": "47.223114",
        "long": "24.707301"
      },
      {
        "name": "TAGSORU",
        "zip": "427023",
        "lat": "46.794834",
        "long": "24.235182"
      },
      {
        "name": "TAGU",
        "zip": "427022",
        "lat": "46.819514",
        "long": "24.228092"
      },
      {
        "name": "TARLISUA",
        "zip": "427330",
        "lat": "47.383892",
        "long": "24.174108"
      },
      {
        "name": "TARPIU",
        "zip": "427077",
        "lat": "47.192612",
        "long": "24.405416"
      },
      {
        "name": "TAURE",
        "zip": "427188",
        "lat": "47.206427",
        "long": "24.321569"
      },
      {
        "name": "TEACA",
        "zip": "427345",
        "lat": "46.910552",
        "long": "24.506424"
      },
      {
        "name": "TELCISOR",
        "zip": "427357",
        "lat": "47.448229",
        "long": "24.429653"
      },
      {
        "name": "TELCIU",
        "zip": "427355",
        "lat": "47.430606",
        "long": "24.396925"
      },
      {
        "name": "TENTEA",
        "zip": "427056",
        "lat": "47.000319",
        "long": "24.136832"
      },
      {
        "name": "TIGAU",
        "zip": "427111",
        "lat": "47.069818",
        "long": "24.331299"
      },
      {
        "name": "TIHA BARGAULUI",
        "zip": "427360",
        "lat": "47.22532",
        "long": "24.763227"
      },
      {
        "name": "TONCIU",
        "zip": "427089",
        "lat": "46.99817",
        "long": "24.376836"
      },
      {
        "name": "TUREAC",
        "zip": "427364",
        "lat": "47.229673",
        "long": "24.805891"
      },
      {
        "name": "UNIREA",
        "zip": "420005",
        "lat": "47.160595",
        "long": "24.530782"
      },
      {
        "name": "URIU",
        "zip": "427365",
        "lat": "47.202139",
        "long": "24.062309"
      },
      {
        "name": "URMENIS",
        "zip": "427370",
        "lat": "46.770052",
        "long": "24.365041"
      },
      {
        "name": "VALEA",
        "zip": "427379",
        "lat": "46.761225",
        "long": "24.38282"
      },
      {
        "name": "VALEA BORCUTULUI",
        "zip": "425302",
        "lat": "47.374051",
        "long": "24.647334"
      },
      {
        "name": "VALEA MAGHERUSULUI",
        "zip": "427302",
        "lat": "47.115298",
        "long": "24.400274"
      },
      {
        "name": "VALEA MARE",
        "zip": "427286",
        "lat": "47.466111",
        "long": "24.949741"
      },
      {
        "name": "VALEA MARE",
        "zip": "427381",
        "lat": "46.802917",
        "long": "24.392891"
      },
      {
        "name": "VALEA POENII",
        "zip": "427124",
        "lat": "47.187766",
        "long": "24.636511"
      },
      {
        "name": "VALEA VINULUI",
        "zip": "427246",
        "lat": "47.479093",
        "long": "24.82911"
      },
      {
        "name": "VERMES",
        "zip": "427112",
        "lat": "47.002576",
        "long": "24.319791"
      },
      {
        "name": "VIILE TECII",
        "zip": "427351",
        "lat": "46.945021",
        "long": "24.463231"
      },
      {
        "name": "VIISOARA",
        "zip": "420006",
        "lat": "47.102648",
        "long": "24.448235"
      },
      {
        "name": "VISUIA",
        "zip": "427162",
        "lat": "46.837035",
        "long": "24.295029"
      },
      {
        "name": "VITA",
        "zip": "427207",
        "lat": "47.041467",
        "long": "24.148547"
      },
      {
        "name": "ZAGRA",
        "zip": "427385",
        "lat": "47.324597",
        "long": "24.279734"
      },
      {
        "name": "ZORENI",
        "zip": "427266",
        "lat": "46.896611",
        "long": "24.275734"
      }
    ],
    "BOTOȘANI": [
      {
        "name": "ADASENI",
        "zip": "717016",
        "lat": "48.069198",
        "long": "26.937888"
      },
      {
        "name": "AGAFTON",
        "zip": "717111",
        "lat": "47.708518",
        "long": "26.598197"
      },
      {
        "name": "ALBA",
        "zip": "717211",
        "lat": "48.157857",
        "long": "26.477518"
      },
      {
        "name": "ALBESTI",
        "zip": "717005",
        "lat": "47.693019",
        "long": "27.072922"
      },
      {
        "name": "ARBOREA",
        "zip": "717171",
        "lat": "48.05185",
        "long": "26.517165"
      },
      {
        "name": "AUREL VLAICU",
        "zip": "717017",
        "lat": "48.000355",
        "long": "26.910003"
      },
      {
        "name": "AVRAM IANCU",
        "zip": "717091",
        "lat": "48.069041",
        "long": "26.882228"
      },
      {
        "name": "AVRAMENI",
        "zip": "717015",
        "lat": "48.016046",
        "long": "26.952319"
      },
      {
        "name": "BABICENI",
        "zip": "717146",
        "lat": "47.754286",
        "long": "27.0727"
      },
      {
        "name": "BADARAI",
        "zip": "717346",
        "lat": "47.59007",
        "long": "27.381967"
      },
      {
        "name": "BADIUTI",
        "zip": "717386",
        "lat": "47.783547",
        "long": "27.208761"
      },
      {
        "name": "BAICENI",
        "zip": "717112",
        "lat": "47.693233",
        "long": "26.657413"
      },
      {
        "name": "BAISA",
        "zip": "717246",
        "lat": "47.72394",
        "long": "26.565472"
      },
      {
        "name": "BAJURA",
        "zip": "715101",
        "lat": "48.198076",
        "long": "26.539241"
      },
      {
        "name": "BALINTI",
        "zip": "717186",
        "lat": "48.049986",
        "long": "26.692695"
      },
      {
        "name": "BALTA ARSA",
        "zip": "717086",
        "lat": "47.674618",
        "long": "26.62269"
      },
      {
        "name": "BALUSENI",
        "zip": "717025",
        "lat": "47.66918",
        "long": "26.79617"
      },
      {
        "name": "BALUSENII NOI",
        "zip": "717026",
        "lat": "47.686104",
        "long": "26.823826"
      },
      {
        "name": "BARANCA",
        "zip": "717106",
        "lat": "48.133131",
        "long": "26.313758"
      },
      {
        "name": "BARANCA",
        "zip": "717212",
        "lat": "48.196399",
        "long": "26.482554"
      },
      {
        "name": "BARSANESTI",
        "zip": "717147",
        "lat": "47.788641",
        "long": "27.083245"
      },
      {
        "name": "BASEU",
        "zip": "717209",
        "lat": "48.140602",
        "long": "26.495856"
      },
      {
        "name": "BATRANESTI",
        "zip": "717176",
        "lat": "47.786731",
        "long": "26.885504"
      },
      {
        "name": "BELCEA",
        "zip": "717221",
        "lat": "47.805669",
        "long": "26.442212"
      },
      {
        "name": "BERZA",
        "zip": "717347",
        "lat": "47.643401",
        "long": "27.309384"
      },
      {
        "name": "BIVOLARI",
        "zip": "717131",
        "lat": "47.814461",
        "long": "27.058261"
      },
      {
        "name": "BLANDESTI",
        "zip": "717371",
        "lat": "47.71185",
        "long": "26.863109"
      },
      {
        "name": "BOBULESTI",
        "zip": "717387",
        "lat": "47.753298",
        "long": "27.224752"
      },
      {
        "name": "BODEASA",
        "zip": "715301",
        "lat": "47.972171",
        "long": "26.922404"
      },
      {
        "name": "BOGDANESTI",
        "zip": "717348",
        "lat": "47.646216",
        "long": "27.253556"
      },
      {
        "name": "BOHOGHINA",
        "zip": "717046",
        "lat": "47.80105",
        "long": "26.412428"
      },
      {
        "name": "BOLD",
        "zip": "717231",
        "lat": "47.972168",
        "long": "27.123323"
      },
      {
        "name": "BOROLEA",
        "zip": "717196",
        "lat": "47.952607",
        "long": "27.021402"
      },
      {
        "name": "BORZESTI",
        "zip": "717416",
        "lat": "47.910913",
        "long": "26.754234"
      },
      {
        "name": "BOSCOTENI",
        "zip": "717161",
        "lat": "47.499929",
        "long": "26.86427"
      },
      {
        "name": "BOTOSANI",
        "zip": "710001",
        "lat": "47.745071",
        "long": "26.659986"
      },
      {
        "name": "BOZIENI",
        "zip": "715302",
        "lat": "47.944703",
        "long": "26.901467"
      },
      {
        "name": "BRAESTI",
        "zip": "717035",
        "lat": "47.859283",
        "long": "26.459895"
      },
      {
        "name": "BRATENI",
        "zip": "717132",
        "lat": "47.860847",
        "long": "27.027683"
      },
      {
        "name": "BREHUIESTI",
        "zip": "717461",
        "lat": "47.70177",
        "long": "26.542149"
      },
      {
        "name": "BROSCAUTI",
        "zip": "717040",
        "lat": "47.95263",
        "long": "26.45088"
      },
      {
        "name": "BROSTENI",
        "zip": "717148",
        "lat": "47.754032",
        "long": "27.088365"
      },
      {
        "name": "BUCECEA",
        "zip": "717045",
        "lat": "47.77265",
        "long": "26.439767"
      },
      {
        "name": "BUDA",
        "zip": "717061",
        "lat": "47.625498",
        "long": "26.808757"
      },
      {
        "name": "BUHACENI",
        "zip": "717401",
        "lat": "47.812675",
        "long": "26.999726"
      },
      {
        "name": "BUIMACENI",
        "zip": "717006",
        "lat": "47.671773",
        "long": "27.090386"
      },
      {
        "name": "BURLA",
        "zip": "717436",
        "lat": "47.784338",
        "long": "26.796855"
      },
      {
        "name": "BURLESTI",
        "zip": "717437",
        "lat": "47.757576",
        "long": "26.82753"
      },
      {
        "name": "BUZENI",
        "zip": "717027",
        "lat": "47.68021",
        "long": "26.745299"
      },
      {
        "name": "CALARASI",
        "zip": "717050",
        "lat": "47.605409",
        "long": "27.258113"
      },
      {
        "name": "CALINESTI",
        "zip": "717047",
        "lat": "47.758162",
        "long": "26.473475"
      },
      {
        "name": "CALINESTI",
        "zip": "717261",
        "lat": "47.921075",
        "long": "26.237971"
      },
      {
        "name": "CALUGARENI",
        "zip": "717417",
        "lat": "47.916294",
        "long": "26.691553"
      },
      {
        "name": "CALUGARENII NOI",
        "zip": "717418",
        "lat": "47.918813",
        "long": "26.669784"
      },
      {
        "name": "CAMPENI",
        "zip": "717306",
        "lat": "47.506251",
        "long": "26.99522"
      },
      {
        "name": "CANDESTI",
        "zip": "717262",
        "lat": "47.925747",
        "long": "26.197134"
      },
      {
        "name": "CARAIMAN",
        "zip": "717271",
        "lat": "47.922695",
        "long": "27.086463"
      },
      {
        "name": "CARASA",
        "zip": "717076",
        "lat": "47.948442",
        "long": "26.507125"
      },
      {
        "name": "CATAMARESTI",
        "zip": "717247",
        "lat": "47.751114",
        "long": "26.572479"
      },
      {
        "name": "CATAMARESTI-DEAL",
        "zip": "717248",
        "lat": "47.770702",
        "long": "26.600717"
      },
      {
        "name": "CERBU",
        "zip": "717062",
        "lat": "47.617427",
        "long": "26.886108"
      },
      {
        "name": "CERCHEJENI",
        "zip": "717372",
        "lat": "47.691951",
        "long": "26.882517"
      },
      {
        "name": "CERNESTI",
        "zip": "717396",
        "lat": "47.610073",
        "long": "27.096888"
      },
      {
        "name": "CERVICESTI",
        "zip": "717249",
        "lat": "47.798751",
        "long": "26.511492"
      },
      {
        "name": "CERVICESTI-DEAL",
        "zip": "717251",
        "lat": "47.808278",
        "long": "26.517812"
      },
      {
        "name": "CHELIS",
        "zip": "717373",
        "lat": "47.635348",
        "long": "26.949885"
      },
      {
        "name": "CHISCARENI",
        "zip": "715303",
        "lat": "47.961617",
        "long": "26.831464"
      },
      {
        "name": "CHITOVENI",
        "zip": "717156",
        "lat": "47.567253",
        "long": "26.932413"
      },
      {
        "name": "CINGHINIIA",
        "zip": "717326",
        "lat": "47.90634",
        "long": "27.136783"
      },
      {
        "name": "CIRITEI",
        "zip": "717402",
        "lat": "47.772956",
        "long": "26.971453"
      },
      {
        "name": "CISMANESTI",
        "zip": "717133",
        "lat": "47.848706",
        "long": "27.073175"
      },
      {
        "name": "CISMEA",
        "zip": "717311",
        "lat": "47.766415",
        "long": "26.66981"
      },
      {
        "name": "CODRENI",
        "zip": "717281",
        "lat": "48.093608",
        "long": "26.78558"
      },
      {
        "name": "CONCESTI",
        "zip": "717055",
        "lat": "48.156607",
        "long": "26.559404"
      },
      {
        "name": "COPALAU",
        "zip": "717060",
        "lat": "47.617806",
        "long": "26.856233"
      },
      {
        "name": "CORDARENI",
        "zip": "717070",
        "lat": "48.001449",
        "long": "26.590305"
      },
      {
        "name": "CORJAUTI",
        "zip": "717201",
        "lat": "48.033661",
        "long": "26.274468"
      },
      {
        "name": "CORLATENI",
        "zip": "717075",
        "lat": "47.928435",
        "long": "26.551808"
      },
      {
        "name": "CORNI",
        "zip": "717085",
        "lat": "47.646031",
        "long": "26.574894"
      },
      {
        "name": "COSTESTI",
        "zip": "717312",
        "lat": "47.800318",
        "long": "26.675837"
      },
      {
        "name": "COSTINESTI",
        "zip": "717222",
        "lat": "47.805698",
        "long": "26.459286"
      },
      {
        "name": "COSTIUGENI",
        "zip": "717007",
        "lat": "47.685635",
        "long": "27.044424"
      },
      {
        "name": "COSULA",
        "zip": "717063",
        "lat": "47.6257",
        "long": "26.778266"
      },
      {
        "name": "COSULENI",
        "zip": "717028",
        "lat": "47.683568",
        "long": "26.758354"
      },
      {
        "name": "COTARGACI",
        "zip": "717336",
        "lat": "47.854632",
        "long": "26.542117"
      },
      {
        "name": "COTU",
        "zip": "717064",
        "lat": "47.598366",
        "long": "26.861011"
      },
      {
        "name": "COTU MICULINTI",
        "zip": "717092",
        "lat": "48.187219",
        "long": "26.943321"
      },
      {
        "name": "COTUSCA",
        "zip": "717090",
        "lat": "48.129858",
        "long": "26.856219"
      },
      {
        "name": "CRASNALEUCA",
        "zip": "717093",
        "lat": "48.157984",
        "long": "26.959314"
      },
      {
        "name": "CRISTESTI",
        "zip": "717100",
        "lat": "47.636076",
        "long": "26.736184"
      },
      {
        "name": "CRISTINESTI",
        "zip": "717105",
        "lat": "48.093542",
        "long": "26.395006"
      },
      {
        "name": "CUCORANI",
        "zip": "717252",
        "lat": "47.779852",
        "long": "26.515928"
      },
      {
        "name": "CUCUTENI",
        "zip": "717149",
        "lat": "47.776897",
        "long": "27.124465"
      },
      {
        "name": "CURTESTI",
        "zip": "717110",
        "lat": "47.71695",
        "long": "26.647464"
      },
      {
        "name": "CUZA VODA",
        "zip": "717456",
        "lat": "48.186522",
        "long": "26.696088"
      },
      {
        "name": "CUZLAU",
        "zip": "717296",
        "lat": "48.23972",
        "long": "26.677164"
      },
      {
        "name": "DACIA",
        "zip": "717291",
        "lat": "47.843448",
        "long": "26.692405"
      },
      {
        "name": "DAMIDENI",
        "zip": "717341",
        "lat": "47.696217",
        "long": "27.253558"
      },
      {
        "name": "DAMILENI",
        "zip": "717104",
        "lat": "48.110775",
        "long": "26.399028"
      },
      {
        "name": "DANGENI",
        "zip": "717120",
        "lat": "47.852023",
        "long": "26.968942"
      },
      {
        "name": "DARABANI",
        "zip": "715100",
        "lat": "48.186634",
        "long": "26.596826"
      },
      {
        "name": "DAVIDOAIA",
        "zip": "717471",
        "lat": "47.959907",
        "long": "26.628227"
      },
      {
        "name": "DEALU CRUCII",
        "zip": "717472",
        "lat": "47.939616",
        "long": "26.645688"
      },
      {
        "name": "DEALU MARE",
        "zip": "715201",
        "lat": "47.92435",
        "long": "26.41413"
      },
      {
        "name": "DERSCA",
        "zip": "717125",
        "lat": "47.98958",
        "long": "26.214958"
      },
      {
        "name": "DIMACHENI",
        "zip": "717077",
        "lat": "47.911386",
        "long": "26.545597"
      },
      {
        "name": "DIMITRIE CANTEMIR",
        "zip": "717018",
        "lat": "48.055413",
        "long": "26.994635"
      },
      {
        "name": "DOBARCENI",
        "zip": "717130",
        "lat": "47.825772",
        "long": "27.065701"
      },
      {
        "name": "DOBRINAUTI-HAPAI",
        "zip": "717449",
        "lat": "47.893868",
        "long": "26.279685"
      },
      {
        "name": "DOINA",
        "zip": "717321",
        "lat": "47.54288",
        "long": "27.193935"
      },
      {
        "name": "DOLINA",
        "zip": "717223",
        "lat": "47.827916",
        "long": "26.454156"
      },
      {
        "name": "DOROBANTI",
        "zip": "717292",
        "lat": "47.88198",
        "long": "26.651308"
      },
      {
        "name": "DOROHOI",
        "zip": "715200",
        "lat": "47.953761",
        "long": "26.396997"
      },
      {
        "name": "DRACSANI",
        "zip": "717374",
        "lat": "47.629448",
        "long": "26.930282"
      },
      {
        "name": "DRAGALINA",
        "zip": "717107",
        "lat": "48.056325",
        "long": "26.45335"
      },
      {
        "name": "DRAGALINA",
        "zip": "717206",
        "lat": "47.607384",
        "long": "27.195459"
      },
      {
        "name": "DRAGUSENI",
        "zip": "717140",
        "lat": "48.018796",
        "long": "26.806551"
      },
      {
        "name": "DRAXINI",
        "zip": "717029",
        "lat": "47.656453",
        "long": "26.822952"
      },
      {
        "name": "DRISLEA",
        "zip": "717403",
        "lat": "47.759907",
        "long": "26.967352"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "717216",
        "lat": "48.019447",
        "long": "26.428064"
      },
      {
        "name": "DUMENI",
        "zip": "717172",
        "lat": "48.007236",
        "long": "26.542867"
      },
      {
        "name": "DURNESTI",
        "zip": "717145",
        "lat": "47.765945",
        "long": "27.112172"
      },
      {
        "name": "DURNESTI",
        "zip": "717349",
        "lat": "47.595719",
        "long": "27.370582"
      },
      {
        "name": "DURNESTI",
        "zip": "717419",
        "lat": "47.893927",
        "long": "26.774372"
      },
      {
        "name": "ESANCA",
        "zip": "715102",
        "lat": "48.171749",
        "long": "26.655758"
      },
      {
        "name": "FLAMANZI",
        "zip": "717155",
        "lat": "47.553914",
        "long": "26.877183"
      },
      {
        "name": "FLONDORA",
        "zip": "717232",
        "lat": "48.002861",
        "long": "27.032207"
      },
      {
        "name": "FLORESTI",
        "zip": "717397",
        "lat": "47.620399",
        "long": "27.1387"
      },
      {
        "name": "FRUMUSICA",
        "zip": "717160",
        "lat": "47.532218",
        "long": "26.901106"
      },
      {
        "name": "FUNDU HERTII",
        "zip": "717108",
        "lat": "48.110576",
        "long": "26.310535"
      },
      {
        "name": "GALBENI",
        "zip": "717187",
        "lat": "48.036523",
        "long": "26.700559"
      },
      {
        "name": "GARBENI",
        "zip": "717188",
        "lat": "48.081713",
        "long": "26.657115"
      },
      {
        "name": "GARBESTI",
        "zip": "717398",
        "lat": "47.599894",
        "long": "27.082836"
      },
      {
        "name": "GEORGE COSBUC",
        "zip": "717177",
        "lat": "47.800755",
        "long": "26.869715"
      },
      {
        "name": "GEORGE ENESCU",
        "zip": "717170",
        "lat": "48.036929",
        "long": "26.48637"
      },
      {
        "name": "GHIRENI",
        "zip": "717094",
        "lat": "48.153612",
        "long": "26.88537"
      },
      {
        "name": "GORBANESTI",
        "zip": "717175",
        "lat": "47.775339",
        "long": "26.858889"
      },
      {
        "name": "GOROVEI",
        "zip": "717446",
        "lat": "47.876935",
        "long": "26.344877"
      },
      {
        "name": "GRIVITA",
        "zip": "717071",
        "lat": "48.0149",
        "long": "26.574404"
      },
      {
        "name": "GURANDA",
        "zip": "717151",
        "lat": "47.777229",
        "long": "27.074726"
      },
      {
        "name": "HANESTI",
        "zip": "717195",
        "lat": "47.907835",
        "long": "26.978174"
      },
      {
        "name": "HAVARNA",
        "zip": "717185",
        "lat": "48.074394",
        "long": "26.64582"
      },
      {
        "name": "HILISEU-CLOSCA",
        "zip": "717202",
        "lat": "48.015334",
        "long": "26.334664"
      },
      {
        "name": "HILISEU-CRISAN",
        "zip": "717203",
        "lat": "48.036062",
        "long": "26.236859"
      },
      {
        "name": "HILISEU-HORIA",
        "zip": "717200",
        "lat": "47.998547",
        "long": "26.304865"
      },
      {
        "name": "HLIPICENI",
        "zip": "717205",
        "lat": "47.596533",
        "long": "27.148645"
      },
      {
        "name": "HORIA",
        "zip": "717286",
        "lat": "48.121328",
        "long": "26.973483"
      },
      {
        "name": "HORLACENI",
        "zip": "717381",
        "lat": "47.913581",
        "long": "26.338357"
      },
      {
        "name": "HORODISTEA",
        "zip": "717297",
        "lat": "48.235887",
        "long": "26.733106"
      },
      {
        "name": "HRISCANI",
        "zip": "717462",
        "lat": "47.746857",
        "long": "26.511276"
      },
      {
        "name": "HUDESTI",
        "zip": "717210",
        "lat": "48.140441",
        "long": "26.516126"
      },
      {
        "name": "HUDUM",
        "zip": "717113",
        "lat": "47.734727",
        "long": "26.629265"
      },
      {
        "name": "HULUB",
        "zip": "717121",
        "lat": "47.825798",
        "long": "26.964879"
      },
      {
        "name": "HULUBESTI",
        "zip": "717301",
        "lat": "48.048068",
        "long": "26.348758"
      },
      {
        "name": "HUTANI",
        "zip": "717463",
        "lat": "47.709533",
        "long": "26.485729"
      },
      {
        "name": "IACOBENI",
        "zip": "717122",
        "lat": "47.861149",
        "long": "26.913037"
      },
      {
        "name": "IBANEASA",
        "zip": "717391",
        "lat": "47.962123",
        "long": "26.733461"
      },
      {
        "name": "IBANESTI",
        "zip": "717215",
        "lat": "48.061665",
        "long": "26.383992"
      },
      {
        "name": "ICHIMENI",
        "zip": "717019",
        "lat": "48.040979",
        "long": "26.874802"
      },
      {
        "name": "ICUSENI",
        "zip": "717476",
        "lat": "47.592329",
        "long": "26.596107"
      },
      {
        "name": "IEZER",
        "zip": "717204",
        "lat": "47.983205",
        "long": "26.33338"
      },
      {
        "name": "ILISENI",
        "zip": "717351",
        "lat": "47.671372",
        "long": "27.259816"
      },
      {
        "name": "IONASENI",
        "zip": "717404",
        "lat": "47.731216",
        "long": "26.994466"
      },
      {
        "name": "IONASENI",
        "zip": "717451",
        "lat": "47.813012",
        "long": "26.388556"
      },
      {
        "name": "IORGA",
        "zip": "717233",
        "lat": "48.026272",
        "long": "27.082323"
      },
      {
        "name": "IPOTESTI",
        "zip": "717253",
        "lat": "47.766299",
        "long": "26.558188"
      },
      {
        "name": "IURESTI",
        "zip": "717399",
        "lat": "47.620002",
        "long": "27.075241"
      },
      {
        "name": "IZVOARE",
        "zip": "717361",
        "lat": "48.093154",
        "long": "26.51531"
      },
      {
        "name": "JIJIA",
        "zip": "717008",
        "lat": "47.648634",
        "long": "27.097941"
      },
      {
        "name": "JOLDESTI",
        "zip": "717477",
        "lat": "47.559969",
        "long": "26.57717"
      },
      {
        "name": "LEHNESTI",
        "zip": "717327",
        "lat": "47.889342",
        "long": "27.19348"
      },
      {
        "name": "LEORDA",
        "zip": "717220",
        "lat": "47.817136",
        "long": "26.477462"
      },
      {
        "name": "LIBERTATEA",
        "zip": "717051",
        "lat": "47.615901",
        "long": "27.287344"
      },
      {
        "name": "LISMANITA",
        "zip": "715103",
        "lat": "48.138887",
        "long": "26.65789"
      },
      {
        "name": "LISNA",
        "zip": "717362",
        "lat": "48.107325",
        "long": "26.479219"
      },
      {
        "name": "LIVADA",
        "zip": "717134",
        "lat": "47.824422",
        "long": "27.093866"
      },
      {
        "name": "LIVENI",
        "zip": "717234",
        "lat": "48.058471",
        "long": "27.061838"
      },
      {
        "name": "LOTURI",
        "zip": "717236",
        "lat": "48.045207",
        "long": "27.07064"
      },
      {
        "name": "LOTURI ENESCU",
        "zip": "715202",
        "lat": "47.988926",
        "long": "26.385816"
      },
      {
        "name": "LOZNA",
        "zip": "717126",
        "lat": "47.951438",
        "long": "26.277229"
      },
      {
        "name": "LUNCA",
        "zip": "717225",
        "lat": "47.622029",
        "long": "27.003364"
      },
      {
        "name": "LUNCA",
        "zip": "717452",
        "lat": "47.88313",
        "long": "26.272138"
      },
      {
        "name": "LUPARIA",
        "zip": "717307",
        "lat": "47.485634",
        "long": "27.021118"
      },
      {
        "name": "MAGHERA",
        "zip": "717453",
        "lat": "47.861801",
        "long": "26.302611"
      },
      {
        "name": "MANASTIREA DOAMNEI",
        "zip": "717114",
        "lat": "47.722871",
        "long": "26.609341"
      },
      {
        "name": "MANASTIRENI",
        "zip": "717438",
        "lat": "47.831008",
        "long": "26.763612"
      },
      {
        "name": "MANDRESTI",
        "zip": "717421",
        "lat": "47.909152",
        "long": "26.734536"
      },
      {
        "name": "MANDRESTI",
        "zip": "717464",
        "lat": "47.735834",
        "long": "26.484334"
      },
      {
        "name": "MANOLEASA",
        "zip": "717230",
        "lat": "47.991854",
        "long": "27.059998"
      },
      {
        "name": "MANOLEASA-PRUT",
        "zip": "717237",
        "lat": "48.012022",
        "long": "27.086073"
      },
      {
        "name": "MANOLESTI",
        "zip": "717254",
        "lat": "47.748662",
        "long": "26.621079"
      },
      {
        "name": "MASCATENI",
        "zip": "717009",
        "lat": "47.718686",
        "long": "27.042367"
      },
      {
        "name": "MATEIENI",
        "zip": "717078",
        "lat": "47.918853",
        "long": "26.59357"
      },
      {
        "name": "MESTEACAN",
        "zip": "717087",
        "lat": "47.62329",
        "long": "26.629784"
      },
      {
        "name": "MIHAI EMINESCU",
        "zip": "717178",
        "lat": "47.799194",
        "long": "26.858367"
      },
      {
        "name": "MIHAI VITEAZU",
        "zip": "717422",
        "lat": "47.9285",
        "long": "26.782668"
      },
      {
        "name": "MIHAIL KOGALNICEANU",
        "zip": "717096",
        "lat": "48.080975",
        "long": "26.835805"
      },
      {
        "name": "MIHAILENI",
        "zip": "717260",
        "lat": "47.967075",
        "long": "26.142905"
      },
      {
        "name": "MIHALASENI",
        "zip": "717270",
        "lat": "47.883348",
        "long": "27.073479"
      },
      {
        "name": "MILEANCA",
        "zip": "717280",
        "lat": "48.090446",
        "long": "26.694133"
      },
      {
        "name": "MILETIN",
        "zip": "717308",
        "lat": "47.481429",
        "long": "27.063116"
      },
      {
        "name": "MIORCANI",
        "zip": "717316",
        "lat": "48.201123",
        "long": "26.85285"
      },
      {
        "name": "MIRON COSTIN",
        "zip": "717466",
        "lat": "47.940368",
        "long": "26.950961"
      },
      {
        "name": "MITOC",
        "zip": "717224",
        "lat": "47.836958",
        "long": "26.440258"
      },
      {
        "name": "MITOC",
        "zip": "717285",
        "lat": "48.098383",
        "long": "27.022699"
      },
      {
        "name": "MLENAUTI",
        "zip": "717213",
        "lat": "48.128411",
        "long": "26.485056"
      },
      {
        "name": "MOARA JORII",
        "zip": "717197",
        "lat": "47.884235",
        "long": "27.020947"
      },
      {
        "name": "MOVILA RUPTA",
        "zip": "717328",
        "lat": "47.919324",
        "long": "27.130982"
      },
      {
        "name": "MOVILENI",
        "zip": "717056",
        "lat": "48.134511",
        "long": "26.597381"
      },
      {
        "name": "MURGUTA",
        "zip": "717136",
        "lat": "47.821609",
        "long": "27.131467"
      },
      {
        "name": "NASTASE",
        "zip": "717272",
        "lat": "47.854494",
        "long": "27.131025"
      },
      {
        "name": "NEGRENI",
        "zip": "717392",
        "lat": "47.999447",
        "long": "26.760201"
      },
      {
        "name": "NEGRESTI",
        "zip": "717273",
        "lat": "47.864655",
        "long": "27.107112"
      },
      {
        "name": "NICHITENI",
        "zip": "717097",
        "lat": "48.095396",
        "long": "26.862262"
      },
      {
        "name": "NICOLAE BALCESCU",
        "zip": "717098",
        "lat": "48.103931",
        "long": "26.783931"
      },
      {
        "name": "NICOLAE BALCESCU",
        "zip": "717157",
        "lat": "47.572481",
        "long": "26.887695"
      },
      {
        "name": "NICSENI",
        "zip": "717290",
        "lat": "47.85688",
        "long": "26.633931"
      },
      {
        "name": "NICULCEA",
        "zip": "717189",
        "lat": "48.035066",
        "long": "26.711621"
      },
      {
        "name": "ONEAGA",
        "zip": "717101",
        "lat": "47.576259",
        "long": "26.732435"
      },
      {
        "name": "ORASENI-DEAL",
        "zip": "717116",
        "lat": "47.675974",
        "long": "26.676714"
      },
      {
        "name": "ORASENI-VALE",
        "zip": "717117",
        "lat": "47.664981",
        "long": "26.666126"
      },
      {
        "name": "OROFTIANA",
        "zip": "717363",
        "lat": "48.177744",
        "long": "26.364107"
      },
      {
        "name": "PADURENI",
        "zip": "717066",
        "lat": "47.615351",
        "long": "26.769498"
      },
      {
        "name": "PADURENI",
        "zip": "717382",
        "lat": "47.973983",
        "long": "26.316051"
      },
      {
        "name": "PALTINIS",
        "zip": "717295",
        "lat": "48.21576",
        "long": "26.650709"
      },
      {
        "name": "PANAITOAIA",
        "zip": "717021",
        "lat": "48.040933",
        "long": "26.975635"
      },
      {
        "name": "PARAU NEGRU",
        "zip": "717263",
        "lat": "47.962799",
        "long": "26.176163"
      },
      {
        "name": "PASATENI",
        "zip": "717406",
        "lat": "47.804563",
        "long": "26.990714"
      },
      {
        "name": "PAUN",
        "zip": "717274",
        "lat": "47.855344",
        "long": "27.115575"
      },
      {
        "name": "PETRICANI",
        "zip": "715304",
        "lat": "47.956339",
        "long": "26.843428"
      },
      {
        "name": "PLESANI",
        "zip": "717052",
        "lat": "47.587997",
        "long": "27.287268"
      },
      {
        "name": "PLEVNA",
        "zip": "717364",
        "lat": "48.103942",
        "long": "26.453399"
      },
      {
        "name": "PLOPENII MARI",
        "zip": "717423",
        "lat": "47.890439",
        "long": "26.791092"
      },
      {
        "name": "PLOPENII MICI",
        "zip": "717424",
        "lat": "47.905274",
        "long": "26.769254"
      },
      {
        "name": "PODENI",
        "zip": "717079",
        "lat": "47.925516",
        "long": "26.650903"
      },
      {
        "name": "PODRIGA",
        "zip": "717141",
        "lat": "48.00531",
        "long": "26.834487"
      },
      {
        "name": "POGORASTI",
        "zip": "717322",
        "lat": "47.580173",
        "long": "27.225515"
      },
      {
        "name": "POIANA",
        "zip": "717036",
        "lat": "47.845239",
        "long": "26.424396"
      },
      {
        "name": "POIANA",
        "zip": "717109",
        "lat": "48.098161",
        "long": "26.345109"
      },
      {
        "name": "POIANA",
        "zip": "717158",
        "lat": "47.571239",
        "long": "26.853636"
      },
      {
        "name": "POIANA",
        "zip": "717478",
        "lat": "47.601484",
        "long": "26.608266"
      },
      {
        "name": "POMARLA",
        "zip": "717300",
        "lat": "48.041829",
        "long": "26.318091"
      },
      {
        "name": "POPENI",
        "zip": "717037",
        "lat": "47.844141",
        "long": "26.491252"
      },
      {
        "name": "POPENI",
        "zip": "717173",
        "lat": "48.024254",
        "long": "26.467368"
      },
      {
        "name": "POPOAIA",
        "zip": "717329",
        "lat": "47.864991",
        "long": "27.163889"
      },
      {
        "name": "PRAJENI",
        "zip": "717305",
        "lat": "47.504057",
        "long": "27.013393"
      },
      {
        "name": "PRISACANI",
        "zip": "717159",
        "lat": "47.55766",
        "long": "26.949362"
      },
      {
        "name": "PROGRESUL",
        "zip": "715203",
        "lat": "48.008853",
        "long": "26.46297"
      },
      {
        "name": "PUSTOAIA",
        "zip": "717454",
        "lat": "47.869849",
        "long": "26.317975"
      },
      {
        "name": "PUTURENI",
        "zip": "717099",
        "lat": "48.113673",
        "long": "26.834331"
      },
      {
        "name": "RACHITI",
        "zip": "717310",
        "lat": "47.763705",
        "long": "26.686629"
      },
      {
        "name": "RACOVAT",
        "zip": "717302",
        "lat": "48.097441",
        "long": "26.294974"
      },
      {
        "name": "RADAUTI-PRUT",
        "zip": "717315",
        "lat": "48.24002",
        "long": "26.806836"
      },
      {
        "name": "RADENI",
        "zip": "717162",
        "lat": "47.51186",
        "long": "26.892502"
      },
      {
        "name": "RANGHILESTI",
        "zip": "717352",
        "lat": "47.648335",
        "long": "27.231848"
      },
      {
        "name": "RANGHILESTI-DEAL",
        "zip": "717353",
        "lat": "47.663253",
        "long": "27.255452"
      },
      {
        "name": "RASCA",
        "zip": "717331",
        "lat": "47.886345",
        "long": "27.179496"
      },
      {
        "name": "RAUSENI",
        "zip": "717320",
        "lat": "47.563834",
        "long": "27.202694"
      },
      {
        "name": "RECIA-VERBIA",
        "zip": "717081",
        "lat": "47.918692",
        "long": "26.499506"
      },
      {
        "name": "REDIU",
        "zip": "717317",
        "lat": "48.228798",
        "long": "26.774305"
      },
      {
        "name": "REDIU",
        "zip": "717323",
        "lat": "47.540391",
        "long": "27.239404"
      },
      {
        "name": "RIPICENI",
        "zip": "717325",
        "lat": "47.947749",
        "long": "27.14372"
      },
      {
        "name": "RIPICENII VECHI",
        "zip": "717332",
        "lat": "47.956636",
        "long": "27.139112"
      },
      {
        "name": "ROGOJESTI",
        "zip": "717264",
        "lat": "47.938853",
        "long": "26.16223"
      },
      {
        "name": "ROMA",
        "zip": "717335",
        "lat": "47.836931",
        "long": "26.612928"
      },
      {
        "name": "ROMANESTI",
        "zip": "717340",
        "lat": "47.732057",
        "long": "27.234709"
      },
      {
        "name": "ROMANESTI-VALE",
        "zip": "717342",
        "lat": "47.7529",
        "long": "27.277427"
      },
      {
        "name": "ROSIORI",
        "zip": "717313",
        "lat": "47.759319",
        "long": "26.72145"
      },
      {
        "name": "SADOVENI",
        "zip": "717238",
        "lat": "47.987969",
        "long": "27.131868"
      },
      {
        "name": "SANTA MARE",
        "zip": "717345",
        "lat": "47.607097",
        "long": "27.342503"
      },
      {
        "name": "SARAFINESTI",
        "zip": "717088",
        "lat": "47.61708",
        "long": "26.607402"
      },
      {
        "name": "SARATA",
        "zip": "717276",
        "lat": "47.915256",
        "long": "27.078414"
      },
      {
        "name": "SARATA",
        "zip": "717343",
        "lat": "47.694659",
        "long": "27.208667"
      },
      {
        "name": "SARATA-BASARAB",
        "zip": "717198",
        "lat": "47.941629",
        "long": "27.039669"
      },
      {
        "name": "SARATA-DRAGUSENI",
        "zip": "717142",
        "lat": "48.073015",
        "long": "26.817732"
      },
      {
        "name": "SARBI",
        "zip": "717467",
        "lat": "47.9426",
        "long": "26.917835"
      },
      {
        "name": "SAT NOU",
        "zip": "715305",
        "lat": "47.969026",
        "long": "26.841928"
      },
      {
        "name": "SAUCENITA",
        "zip": "717447",
        "lat": "47.892529",
        "long": "26.396821"
      },
      {
        "name": "SAVENI",
        "zip": "715300",
        "lat": "47.956266",
        "long": "26.860286"
      },
      {
        "name": "SCHIT-ORASENI",
        "zip": "717102",
        "lat": "47.639482",
        "long": "26.689573"
      },
      {
        "name": "SCUTARI",
        "zip": "717282",
        "lat": "48.059822",
        "long": "26.757396"
      },
      {
        "name": "SELISTEA",
        "zip": "717283",
        "lat": "48.120955",
        "long": "26.681473"
      },
      {
        "name": "SENDRENI",
        "zip": "717164",
        "lat": "47.52982",
        "long": "26.863712"
      },
      {
        "name": "SENDRICENI",
        "zip": "717380",
        "lat": "47.953224",
        "long": "26.329902"
      },
      {
        "name": "SERPENITA",
        "zip": "717239",
        "lat": "48.03175",
        "long": "27.095185"
      },
      {
        "name": "SILISCANI",
        "zip": "717179",
        "lat": "47.729402",
        "long": "26.85481"
      },
      {
        "name": "SILISTEA",
        "zip": "717356",
        "lat": "47.716646",
        "long": "26.762283"
      },
      {
        "name": "SLOBOZIA",
        "zip": "717041",
        "lat": "47.95819",
        "long": "26.48124"
      },
      {
        "name": "SLOBOZIA",
        "zip": "717298",
        "lat": "48.243348",
        "long": "26.695275"
      },
      {
        "name": "SLOBOZIA",
        "zip": "717072",
        "lat": "47.993993",
        "long": "26.611546"
      },
      {
        "name": "SLOBOZIA HANESTI",
        "zip": "717199",
        "lat": "47.913826",
        "long": "26.995482"
      },
      {
        "name": "SLOBOZIA SILISCANI",
        "zip": "717277",
        "lat": "47.860863",
        "long": "27.081832"
      },
      {
        "name": "SMARDAN",
        "zip": "717366",
        "lat": "48.081642",
        "long": "26.472353"
      },
      {
        "name": "SOCRUJENI",
        "zip": "717181",
        "lat": "47.782859",
        "long": "26.912232"
      },
      {
        "name": "SOLDANESTI",
        "zip": "717376",
        "lat": "47.73522",
        "long": "26.925286"
      },
      {
        "name": "SOROCENI",
        "zip": "717439",
        "lat": "47.784132",
        "long": "26.820928"
      },
      {
        "name": "STANCA",
        "zip": "717174",
        "lat": "48.06228",
        "long": "26.552366"
      },
      {
        "name": "STANCA",
        "zip": "717388",
        "lat": "47.817927",
        "long": "27.194518"
      },
      {
        "name": "STANCESTI",
        "zip": "717256",
        "lat": "47.744954",
        "long": "26.598507"
      },
      {
        "name": "STAUCENI",
        "zip": "717355",
        "lat": "47.729437",
        "long": "26.748645"
      },
      {
        "name": "STEFANESTI",
        "zip": "717385",
        "lat": "47.791691",
        "long": "27.200532"
      },
      {
        "name": "STEFANESTI-SAT",
        "zip": "717389",
        "lat": "47.792344",
        "long": "27.187823"
      },
      {
        "name": "STIUBIENI",
        "zip": "717390",
        "lat": "47.970478",
        "long": "26.806734"
      },
      {
        "name": "STOLNICENI",
        "zip": "717324",
        "lat": "47.568166",
        "long": "27.249186"
      },
      {
        "name": "STORESTI",
        "zip": "717163",
        "lat": "47.542797",
        "long": "26.867043"
      },
      {
        "name": "STRAHOTIN",
        "zip": "717123",
        "lat": "47.851521",
        "long": "26.945817"
      },
      {
        "name": "STRATENI",
        "zip": "717127",
        "lat": "47.936213",
        "long": "26.296234"
      },
      {
        "name": "STROIESTI",
        "zip": "717226",
        "lat": "47.61042",
        "long": "26.96562"
      },
      {
        "name": "SUHARAU",
        "zip": "717360",
        "lat": "48.128844",
        "long": "26.424876"
      },
      {
        "name": "SULITA",
        "zip": "717370",
        "lat": "47.646911",
        "long": "26.92513"
      },
      {
        "name": "SUPITCA",
        "zip": "717067",
        "lat": "47.609408",
        "long": "26.783592"
      },
      {
        "name": "TALPA",
        "zip": "717266",
        "lat": "47.901936",
        "long": "26.236304"
      },
      {
        "name": "TATARASENI",
        "zip": "717191",
        "lat": "48.066322",
        "long": "26.683081"
      },
      {
        "name": "TAUTESTI",
        "zip": "717426",
        "lat": "47.921269",
        "long": "26.722679"
      },
      {
        "name": "TIMUS",
        "zip": "717022",
        "lat": "48.031588",
        "long": "26.99254"
      },
      {
        "name": "TOCILENI",
        "zip": "717357",
        "lat": "47.71104",
        "long": "26.786566"
      },
      {
        "name": "TODIRENI",
        "zip": "717395",
        "lat": "47.618689",
        "long": "27.112632"
      },
      {
        "name": "TRUSESTI",
        "zip": "717400",
        "lat": "47.769806",
        "long": "27.010561"
      },
      {
        "name": "TUDOR VLADIMIRESCU",
        "zip": "717011",
        "lat": "47.684571",
        "long": "27.170898"
      },
      {
        "name": "TUDOR VLADIMIRESCU",
        "zip": "717023",
        "lat": "47.986185",
        "long": "26.997826"
      },
      {
        "name": "TUDORA",
        "zip": "717410",
        "lat": "47.507572",
        "long": "26.634221"
      },
      {
        "name": "UNGURENI",
        "zip": "717415",
        "lat": "47.875434",
        "long": "26.807237"
      },
      {
        "name": "UNGUROAIA",
        "zip": "717103",
        "lat": "47.611412",
        "long": "26.701531"
      },
      {
        "name": "UNTENI",
        "zip": "717435",
        "lat": "47.793913",
        "long": "26.779555"
      },
      {
        "name": "VACULESTI",
        "zip": "717445",
        "lat": "47.878022",
        "long": "26.40529"
      },
      {
        "name": "VALCELELE",
        "zip": "717038",
        "lat": "47.845069",
        "long": "26.455537"
      },
      {
        "name": "VALEA GRAJDULUI",
        "zip": "717441",
        "lat": "47.885623",
        "long": "26.716222"
      },
      {
        "name": "VANATORI",
        "zip": "717182",
        "lat": "47.751515",
        "long": "26.869857"
      },
      {
        "name": "VARFU CAMPULUI",
        "zip": "717450",
        "lat": "47.844856",
        "long": "26.327466"
      },
      {
        "name": "VATRA",
        "zip": "717214",
        "lat": "48.14721",
        "long": "26.536911"
      },
      {
        "name": "VICOLENI",
        "zip": "717427",
        "lat": "47.879582",
        "long": "26.848255"
      },
      {
        "name": "VICTORIA",
        "zip": "717358",
        "lat": "47.72594",
        "long": "26.800281"
      },
      {
        "name": "VICTORIA",
        "zip": "717207",
        "lat": "47.610179",
        "long": "27.167304"
      },
      {
        "name": "VIFORENI",
        "zip": "717183",
        "lat": "47.763779",
        "long": "26.945063"
      },
      {
        "name": "VIISOARA",
        "zip": "717455",
        "lat": "48.16234",
        "long": "26.745513"
      },
      {
        "name": "VIISOARA MICA",
        "zip": "717457",
        "lat": "48.153277",
        "long": "26.786707"
      },
      {
        "name": "VITCANI",
        "zip": "717267",
        "lat": "47.944225",
        "long": "26.210605"
      },
      {
        "name": "VLADENI",
        "zip": "717082",
        "lat": "47.929111",
        "long": "26.608229"
      },
      {
        "name": "VLADENI",
        "zip": "717460",
        "lat": "47.716619",
        "long": "26.517957"
      },
      {
        "name": "VLADENI-DEAL",
        "zip": "717166",
        "lat": "47.522167",
        "long": "26.871892"
      },
      {
        "name": "VLASINESTI",
        "zip": "717465",
        "lat": "47.936594",
        "long": "26.887882"
      },
      {
        "name": "VORNICENI",
        "zip": "717470",
        "lat": "47.97641",
        "long": "26.675597"
      },
      {
        "name": "VORONA",
        "zip": "717475",
        "lat": "47.596676",
        "long": "26.64482"
      },
      {
        "name": "VORONA MARE",
        "zip": "717479",
        "lat": "47.556137",
        "long": "26.615862"
      },
      {
        "name": "VORONA-TEODORU",
        "zip": "717481",
        "lat": "47.564524",
        "long": "26.640752"
      },
      {
        "name": "VULTURENI",
        "zip": "717442",
        "lat": "47.853768",
        "long": "26.711898"
      },
      {
        "name": "ZAHORENI",
        "zip": "717241",
        "lat": "47.961638",
        "long": "27.050207"
      },
      {
        "name": "ZAICESTI",
        "zip": "717031",
        "lat": "47.690039",
        "long": "26.724987"
      },
      {
        "name": "ZLATUNOAIA",
        "zip": "717227",
        "lat": "47.65026",
        "long": "27.007434"
      },
      {
        "name": "ZOITANI",
        "zip": "717024",
        "lat": "48.0573",
        "long": "26.966619"
      }
    ],
    "BRĂILA": [
      {
        "name": "AGAUA",
        "zip": "817046",
        "lat": "44.832028",
        "long": "28.072941"
      },
      {
        "name": "ALBINA",
        "zip": "817171",
        "lat": "45.168501",
        "long": "27.868734"
      },
      {
        "name": "ARICIU",
        "zip": "817126",
        "lat": "45.369118",
        "long": "27.521248"
      },
      {
        "name": "BALDOVINESTI",
        "zip": "817201",
        "lat": "45.32264",
        "long": "27.909165"
      },
      {
        "name": "BANDOIU",
        "zip": "817081",
        "lat": "44.866551",
        "long": "27.940531"
      },
      {
        "name": "BARAGANUL",
        "zip": "817005",
        "lat": "44.810679",
        "long": "27.515151"
      },
      {
        "name": "BATOGU",
        "zip": "817036",
        "lat": "44.99709",
        "long": "27.42717"
      },
      {
        "name": "BERLESTI",
        "zip": "815201",
        "lat": "45.079377",
        "long": "27.448033"
      },
      {
        "name": "BERTESTII DE JOS",
        "zip": "817010",
        "lat": "44.834631",
        "long": "27.755875"
      },
      {
        "name": "BERTESTII DE SUS",
        "zip": "817011",
        "lat": "44.812471",
        "long": "27.763773"
      },
      {
        "name": "BOARCA",
        "zip": "817111",
        "lat": "45.306426",
        "long": "27.506666"
      },
      {
        "name": "BORDEI VERDE",
        "zip": "817020",
        "lat": "45.063739",
        "long": "27.573425"
      },
      {
        "name": "BRADEANCA",
        "zip": "817076",
        "lat": "45.141307",
        "long": "27.210247"
      },
      {
        "name": "BRAILA",
        "zip": "810001",
        "lat": "45.271505",
        "long": "27.97438"
      },
      {
        "name": "BRATESU VECHI",
        "zip": "817161",
        "lat": "45.065312",
        "long": "27.292398"
      },
      {
        "name": "BUMBACARI",
        "zip": "817041",
        "lat": "44.893662",
        "long": "27.455653"
      },
      {
        "name": "CAINENI-BAI",
        "zip": "817211",
        "lat": "45.186898",
        "long": "27.323272"
      },
      {
        "name": "CALDARUSA",
        "zip": "817176",
        "lat": "45.125552",
        "long": "27.605104"
      },
      {
        "name": "CAZASU",
        "zip": "817181",
        "lat": "45.271308",
        "long": "27.888346"
      },
      {
        "name": "CHICHINETU",
        "zip": "817031",
        "lat": "44.807963",
        "long": "27.274661"
      },
      {
        "name": "CHIOIBASESTI",
        "zip": "817032",
        "lat": "44.786505",
        "long": "27.266048"
      },
      {
        "name": "CHISCANI",
        "zip": "817025",
        "lat": "45.180735",
        "long": "27.930311"
      },
      {
        "name": "CIOCILE",
        "zip": "817030",
        "lat": "44.823194",
        "long": "27.246686"
      },
      {
        "name": "CIRESU",
        "zip": "817035",
        "lat": "44.966464",
        "long": "27.362599"
      },
      {
        "name": "CISTIA",
        "zip": "817047",
        "lat": "44.779738",
        "long": "28.049965"
      },
      {
        "name": "COLTEA",
        "zip": "817121",
        "lat": "44.845898",
        "long": "27.330539"
      },
      {
        "name": "COMANEASCA",
        "zip": "817182",
        "lat": "45.221843",
        "long": "27.697438"
      },
      {
        "name": "CONSTANTIN GABRIELESCU",
        "zip": "817021",
        "lat": "45.072687",
        "long": "27.63777"
      },
      {
        "name": "CONSTANTINESTI",
        "zip": "817112",
        "lat": "45.291324",
        "long": "27.484394"
      },
      {
        "name": "CORBENI",
        "zip": "817106",
        "lat": "45.326064",
        "long": "27.488039"
      },
      {
        "name": "CORBU NOU",
        "zip": "817091",
        "lat": "45.410116",
        "long": "27.590265"
      },
      {
        "name": "CORBU VECHI",
        "zip": "817092",
        "lat": "45.470477",
        "long": "27.672632"
      },
      {
        "name": "COTU LUNG",
        "zip": "817141",
        "lat": "45.388528",
        "long": "27.822731"
      },
      {
        "name": "COTU MIHALEA",
        "zip": "817142",
        "lat": "45.396816",
        "long": "27.839039"
      },
      {
        "name": "CUSTURA",
        "zip": "817107",
        "lat": "45.293871",
        "long": "27.446664"
      },
      {
        "name": "CUZA VODA",
        "zip": "817127",
        "lat": "45.388645",
        "long": "27.447462"
      },
      {
        "name": "CUZA VODA",
        "zip": "817151",
        "lat": "44.92367",
        "long": "27.732359"
      },
      {
        "name": "DEDULESTI",
        "zip": "817096",
        "lat": "45.146788",
        "long": "27.389068"
      },
      {
        "name": "DESIRATI",
        "zip": "817131",
        "lat": "45.323434",
        "long": "27.553298"
      },
      {
        "name": "DROGU",
        "zip": "817056",
        "lat": "45.182643",
        "long": "27.231741"
      },
      {
        "name": "DUDESCU",
        "zip": "817221",
        "lat": "44.949896",
        "long": "27.430259"
      },
      {
        "name": "DUDESTI",
        "zip": "817040",
        "lat": "44.888914",
        "long": "27.434601"
      },
      {
        "name": "ESNA",
        "zip": "817101",
        "lat": "45.200654",
        "long": "27.56425"
      },
      {
        "name": "FAUREI",
        "zip": "815100",
        "lat": "45.085308",
        "long": "27.271319"
      },
      {
        "name": "FAUREI-SAT",
        "zip": "817162",
        "lat": "45.058554",
        "long": "27.225782"
      },
      {
        "name": "FILIPESTI",
        "zip": "817156",
        "lat": "45.112031",
        "long": "27.342521"
      },
      {
        "name": "FILIU",
        "zip": "817022",
        "lat": "44.985651",
        "long": "27.522842"
      },
      {
        "name": "FLORICA",
        "zip": "817122",
        "lat": "44.830275",
        "long": "27.334394"
      },
      {
        "name": "FRECATEI",
        "zip": "817045",
        "lat": "44.89493",
        "long": "28.125347"
      },
      {
        "name": "GALBENU",
        "zip": "817055",
        "lat": "45.210329",
        "long": "27.158505"
      },
      {
        "name": "GARA IANCA",
        "zip": "815202",
        "lat": "45.137586",
        "long": "27.516613"
      },
      {
        "name": "GAVANI",
        "zip": "817061",
        "lat": "45.292432",
        "long": "27.671424"
      },
      {
        "name": "GEMENELE",
        "zip": "817060",
        "lat": "45.285188",
        "long": "27.640687"
      },
      {
        "name": "GRADISTEA",
        "zip": "817065",
        "lat": "45.266958",
        "long": "27.39258"
      },
      {
        "name": "GROPENI",
        "zip": "817070",
        "lat": "45.074489",
        "long": "27.883018"
      },
      {
        "name": "GULIANCA",
        "zip": "817128",
        "lat": "45.431321",
        "long": "27.523158"
      },
      {
        "name": "GURA CALMATUI",
        "zip": "817012",
        "lat": "44.81882",
        "long": "27.783005"
      },
      {
        "name": "GURA GARLUTEI",
        "zip": "817013",
        "lat": "44.831707",
        "long": "27.823432"
      },
      {
        "name": "GURGUIETI",
        "zip": "817132",
        "lat": "45.363308",
        "long": "27.661753"
      },
      {
        "name": "HORIA",
        "zip": "817163",
        "lat": "45.103919",
        "long": "27.294222"
      },
      {
        "name": "IANCA",
        "zip": "815200",
        "lat": "45.137289",
        "long": "27.468883"
      },
      {
        "name": "IBRIANU",
        "zip": "817066",
        "lat": "45.247557",
        "long": "27.380156"
      },
      {
        "name": "INSURATEI",
        "zip": "815300",
        "lat": "44.913441",
        "long": "27.605181"
      },
      {
        "name": "IONESTI",
        "zip": "817037",
        "lat": "45.004391",
        "long": "27.492224"
      },
      {
        "name": "JIRLAU",
        "zip": "817075",
        "lat": "45.164072",
        "long": "27.189119"
      },
      {
        "name": "JUGUREANU",
        "zip": "817191",
        "lat": "44.941076",
        "long": "27.277515"
      },
      {
        "name": "LACU REZII",
        "zip": "815301",
        "lat": "44.897062",
        "long": "27.671521"
      },
      {
        "name": "LACU SARAT",
        "zip": "817026",
        "lat": "45.216685",
        "long": "27.88913"
      },
      {
        "name": "LANURILE",
        "zip": "817216",
        "lat": "45.037989",
        "long": "27.754101"
      },
      {
        "name": "LATINU",
        "zip": "817093",
        "lat": "45.392534",
        "long": "27.698747"
      },
      {
        "name": "LISCOTEANCA",
        "zip": "817023",
        "lat": "45.004345",
        "long": "27.551556"
      },
      {
        "name": "MAGURENI",
        "zip": "817082",
        "lat": "44.782493",
        "long": "27.919401"
      },
      {
        "name": "MARALOIU",
        "zip": "817067",
        "lat": "45.230346",
        "long": "27.371712"
      },
      {
        "name": "MARASU",
        "zip": "817080",
        "lat": "44.845246",
        "long": "27.968947"
      },
      {
        "name": "MARTACESTI",
        "zip": "817143",
        "lat": "45.280301",
        "long": "27.835362"
      },
      {
        "name": "MARU ROSU",
        "zip": "815302",
        "lat": "44.900866",
        "long": "27.652909"
      },
      {
        "name": "MAXINENI",
        "zip": "817090",
        "lat": "45.410664",
        "long": "27.638973"
      },
      {
        "name": "MIHAI BRAVU",
        "zip": "817206",
        "lat": "44.782867",
        "long": "27.718986"
      },
      {
        "name": "MIHAIL KOGALNICEANU",
        "zip": "817113",
        "lat": "45.310888",
        "long": "27.521005"
      },
      {
        "name": "MIHAIL KOGALNICEANU",
        "zip": "817166",
        "lat": "45.214956",
        "long": "27.504232"
      },
      {
        "name": "MIRCEA VODA",
        "zip": "817095",
        "lat": "45.116465",
        "long": "27.376869"
      },
      {
        "name": "MOROTESTI",
        "zip": "817196",
        "lat": "45.129453",
        "long": "27.742249"
      },
      {
        "name": "MOVILA MIRESII",
        "zip": "817100",
        "lat": "45.215288",
        "long": "27.621993"
      },
      {
        "name": "MUCHEA",
        "zip": "817144",
        "lat": "45.335842",
        "long": "27.8229"
      },
      {
        "name": "NEDELCU",
        "zip": "817083",
        "lat": "44.811606",
        "long": "27.932526"
      },
      {
        "name": "NICOLAE BALCESCU",
        "zip": "817133",
        "lat": "45.374097",
        "long": "27.570544"
      },
      {
        "name": "NICOLESTI",
        "zip": "817014",
        "lat": "44.820863",
        "long": "27.834837"
      },
      {
        "name": "OANCEA",
        "zip": "817116",
        "lat": "45.345596",
        "long": "27.731857"
      },
      {
        "name": "ODAIENI",
        "zip": "817033",
        "lat": "44.870828",
        "long": "27.219526"
      },
      {
        "name": "OLANEASCA",
        "zip": "817129",
        "lat": "45.450707",
        "long": "27.529269"
      },
      {
        "name": "OPRISENESTI",
        "zip": "815203",
        "lat": "45.136206",
        "long": "27.545217"
      },
      {
        "name": "PANTECANI",
        "zip": "817057",
        "lat": "45.192373",
        "long": "27.174329"
      },
      {
        "name": "PERISORU",
        "zip": "815204",
        "lat": "45.112676",
        "long": "27.498173"
      },
      {
        "name": "PIETROIU",
        "zip": "817202",
        "lat": "45.319803",
        "long": "27.880878"
      },
      {
        "name": "PITULATII NOI",
        "zip": "817134",
        "lat": "45.345005",
        "long": "27.616867"
      },
      {
        "name": "PLASOIU",
        "zip": "817212",
        "lat": "45.208989",
        "long": "27.304974"
      },
      {
        "name": "PLOPI",
        "zip": "817084",
        "lat": "44.773776",
        "long": "27.986728"
      },
      {
        "name": "PLOPU",
        "zip": "815205",
        "lat": "45.148472",
        "long": "27.513869"
      },
      {
        "name": "POLIZESTI",
        "zip": "817152",
        "lat": "44.856769",
        "long": "27.796724"
      },
      {
        "name": "PRIBEAGU",
        "zip": "817123",
        "lat": "44.879531",
        "long": "27.31189"
      },
      {
        "name": "RACOVITA",
        "zip": "817105",
        "lat": "45.298822",
        "long": "27.46677"
      },
      {
        "name": "RAMNICELU",
        "zip": "817110",
        "lat": "45.28141",
        "long": "27.54388"
      },
      {
        "name": "ROMANU",
        "zip": "817115",
        "lat": "45.291434",
        "long": "27.744724"
      },
      {
        "name": "ROSIORI",
        "zip": "817120",
        "lat": "44.80612",
        "long": "27.384024"
      },
      {
        "name": "SALCIA",
        "zip": "817048",
        "lat": "44.853311",
        "long": "28.088885"
      },
      {
        "name": "SALCIA TUDOR",
        "zip": "817125",
        "lat": "45.371877",
        "long": "27.49686"
      },
      {
        "name": "SATUC",
        "zip": "817058",
        "lat": "45.188242",
        "long": "27.15921"
      },
      {
        "name": "SCARLATESTI",
        "zip": "817038",
        "lat": "44.947861",
        "long": "27.392728"
      },
      {
        "name": "SCORTARU NOU",
        "zip": "817130",
        "lat": "45.330001",
        "long": "27.616816"
      },
      {
        "name": "SCORTARU VECHI",
        "zip": "817183",
        "lat": "45.218858",
        "long": "27.754887"
      },
      {
        "name": "SIHLEANU",
        "zip": "817136",
        "lat": "45.349642",
        "long": "27.651419"
      },
      {
        "name": "SILISTEA",
        "zip": "817140",
        "lat": "45.308251",
        "long": "27.828779"
      },
      {
        "name": "SILISTRARU",
        "zip": "817177",
        "lat": "45.168685",
        "long": "27.777876"
      },
      {
        "name": "SPIRU HARET",
        "zip": "817016",
        "lat": "44.868097",
        "long": "27.744204"
      },
      {
        "name": "STANCA",
        "zip": "817153",
        "lat": "44.876867",
        "long": "27.81832"
      },
      {
        "name": "STANCUTA",
        "zip": "817150",
        "lat": "44.896624",
        "long": "27.836799"
      },
      {
        "name": "STOIENESTI",
        "zip": "817049",
        "lat": "44.798079",
        "long": "28.03676"
      },
      {
        "name": "SURDILA-GAISEANCA",
        "zip": "817155",
        "lat": "45.083938",
        "long": "27.321916"
      },
      {
        "name": "SURDILA-GRECI",
        "zip": "817160",
        "lat": "45.060836",
        "long": "27.256813"
      },
      {
        "name": "SUTESTI",
        "zip": "817165",
        "lat": "45.225338",
        "long": "27.437278"
      },
      {
        "name": "TACAU",
        "zip": "817086",
        "lat": "44.928134",
        "long": "27.945836"
      },
      {
        "name": "TARLELE FILIU",
        "zip": "815206",
        "lat": "45.045778",
        "long": "27.498128"
      },
      {
        "name": "TATARU",
        "zip": "817042",
        "lat": "44.848446",
        "long": "27.431442"
      },
      {
        "name": "TEPES VODA",
        "zip": "817102",
        "lat": "45.171389",
        "long": "27.622016"
      },
      {
        "name": "TICHILESTI",
        "zip": "817170",
        "lat": "45.128945",
        "long": "27.908221"
      },
      {
        "name": "TITCOV",
        "zip": "817051",
        "lat": "44.997032",
        "long": "28.125503"
      },
      {
        "name": "TRAIAN",
        "zip": "817175",
        "lat": "45.183633",
        "long": "27.733622"
      },
      {
        "name": "TUDOR VLADIMIRESCU",
        "zip": "817180",
        "lat": "45.234903",
        "long": "27.804858"
      },
      {
        "name": "TUFESTI",
        "zip": "817185",
        "lat": "44.991431",
        "long": "27.809749"
      },
      {
        "name": "ULMU",
        "zip": "817190",
        "lat": "44.950674",
        "long": "27.329357"
      },
      {
        "name": "UNIREA",
        "zip": "817195",
        "lat": "45.108422",
        "long": "27.785"
      },
      {
        "name": "URLEASCA",
        "zip": "817178",
        "lat": "45.136725",
        "long": "27.645585"
      },
      {
        "name": "VADENI",
        "zip": "817200",
        "lat": "45.375782",
        "long": "27.941604"
      },
      {
        "name": "VALEA CALMATUIULUI",
        "zip": "815303",
        "lat": "44.958055",
        "long": "27.628071"
      },
      {
        "name": "VALEA CANEPII",
        "zip": "817197",
        "lat": "45.077156",
        "long": "27.805771"
      },
      {
        "name": "VAMESU",
        "zip": "817146",
        "lat": "45.401262",
        "long": "27.801377"
      },
      {
        "name": "VARSATURA",
        "zip": "817027",
        "lat": "45.225243",
        "long": "27.931581"
      },
      {
        "name": "VICTORIA",
        "zip": "817205",
        "lat": "44.806675",
        "long": "27.619273"
      },
      {
        "name": "VISANI",
        "zip": "817210",
        "lat": "45.156673",
        "long": "27.285508"
      },
      {
        "name": "VIZIRU",
        "zip": "817215",
        "lat": "45.001869",
        "long": "27.712985"
      },
      {
        "name": "VOINESTI",
        "zip": "817094",
        "lat": "45.408388",
        "long": "27.722606"
      },
      {
        "name": "VULTURENI",
        "zip": "817039",
        "lat": "44.940039",
        "long": "27.365401"
      },
      {
        "name": "ZAMFIRESTI",
        "zip": "817059",
        "lat": "45.193357",
        "long": "27.210954"
      },
      {
        "name": "ZAVOAIA",
        "zip": "817220",
        "lat": "44.953829",
        "long": "27.479633"
      }
    ],
    "BRAȘOV": [
      {
        "name": "ACRIS",
        "zip": "507246",
        "lat": "45.636729",
        "long": "25.992467"
      },
      {
        "name": "APATA",
        "zip": "507005",
        "lat": "45.950432",
        "long": "25.533116"
      },
      {
        "name": "ARINI",
        "zip": "507121",
        "lat": "45.88776",
        "long": "25.564681"
      },
      {
        "name": "AUGUSTIN",
        "zip": "507151",
        "lat": "46.04613",
        "long": "25.553331"
      },
      {
        "name": "BARCUT",
        "zip": "507216",
        "lat": "46.000936",
        "long": "24.923582"
      },
      {
        "name": "BECLEAN",
        "zip": "507010",
        "lat": "45.832867",
        "long": "24.923911"
      },
      {
        "name": "BEIA",
        "zip": "507041",
        "lat": "46.145984",
        "long": "25.184166"
      },
      {
        "name": "BERIVOI",
        "zip": "507181",
        "lat": "45.745055",
        "long": "24.974254"
      },
      {
        "name": "BOD",
        "zip": "507015",
        "lat": "45.763126",
        "long": "25.639242"
      },
      {
        "name": "BOGATA OLTEANA",
        "zip": "507096",
        "lat": "45.979914",
        "long": "25.35672"
      },
      {
        "name": "BOHOLT",
        "zip": "507011",
        "lat": "45.887943",
        "long": "24.919894"
      },
      {
        "name": "BRAN",
        "zip": "507025",
        "lat": "45.51636",
        "long": "25.371402"
      },
      {
        "name": "BRASOV",
        "zip": "500002",
        "lat": "45.652309",
        "long": "25.610275"
      },
      {
        "name": "BREAZA",
        "zip": "507116",
        "lat": "45.70572",
        "long": "24.882884"
      },
      {
        "name": "BUCIUM",
        "zip": "507201",
        "lat": "45.740715",
        "long": "25.095661"
      },
      {
        "name": "BUDILA",
        "zip": "507030",
        "lat": "45.674088",
        "long": "25.806577"
      },
      {
        "name": "BUNESTI",
        "zip": "507035",
        "lat": "46.106675",
        "long": "25.059754"
      },
      {
        "name": "BUZAIEL",
        "zip": "507247",
        "lat": "45.605474",
        "long": "26.022802"
      },
      {
        "name": "CALBOR",
        "zip": "507012",
        "lat": "45.869585",
        "long": "24.901883"
      },
      {
        "name": "CARPINIS",
        "zip": "507221",
        "lat": "45.664414",
        "long": "25.767587"
      },
      {
        "name": "CATA",
        "zip": "507040",
        "lat": "46.090227",
        "long": "25.281133"
      },
      {
        "name": "CHEIA",
        "zip": "507131",
        "lat": "45.463622",
        "long": "25.306006"
      },
      {
        "name": "CINCSOR",
        "zip": "507261",
        "lat": "45.836335",
        "long": "24.832934"
      },
      {
        "name": "CINCU",
        "zip": "507045",
        "lat": "45.914722",
        "long": "24.803824"
      },
      {
        "name": "COBOR",
        "zip": "507231",
        "lat": "45.946616",
        "long": "25.05103"
      },
      {
        "name": "CODLEA",
        "zip": "505100",
        "lat": "45.697613",
        "long": "25.446158"
      },
      {
        "name": "COLONIA 1 MAI",
        "zip": "507271",
        "lat": "45.663116",
        "long": "25.409016"
      },
      {
        "name": "COLONIA BOD",
        "zip": "507020",
        "lat": "45.755295",
        "long": "25.59772"
      },
      {
        "name": "COLONIA RECONSTRUCTIA",
        "zip": "507066",
        "lat": "45.826835",
        "long": "25.571028"
      },
      {
        "name": "COMANA DE JOS",
        "zip": "507051",
        "lat": "45.913745",
        "long": "25.231289"
      },
      {
        "name": "COMANA DE SUS",
        "zip": "507052",
        "lat": "45.895701",
        "long": "25.268679"
      },
      {
        "name": "COPACEL",
        "zip": "507091",
        "lat": "45.745849",
        "long": "24.995013"
      },
      {
        "name": "CORBI",
        "zip": "507236",
        "lat": "45.7765",
        "long": "24.695807"
      },
      {
        "name": "CRIHALMA",
        "zip": "507053",
        "lat": "45.924324",
        "long": "25.198346"
      },
      {
        "name": "CRISTIAN",
        "zip": "507055",
        "lat": "45.628842",
        "long": "25.483342"
      },
      {
        "name": "CRIT",
        "zip": "507036",
        "lat": "46.122147",
        "long": "25.018996"
      },
      {
        "name": "CRIZBAV",
        "zip": "507081",
        "lat": "45.815149",
        "long": "25.467178"
      },
      {
        "name": "CUCIULATA",
        "zip": "507097",
        "lat": "45.943834",
        "long": "25.27266"
      },
      {
        "name": "CUTUS",
        "zip": "507082",
        "lat": "45.825472",
        "long": "25.46649"
      },
      {
        "name": "DACIA",
        "zip": "507111",
        "lat": "46.008937",
        "long": "25.151895"
      },
      {
        "name": "DAISOARA",
        "zip": "507241",
        "lat": "45.972159",
        "long": "25.167849"
      },
      {
        "name": "DALGHIU",
        "zip": "507248",
        "lat": "45.575961",
        "long": "25.911844"
      },
      {
        "name": "DEJANI",
        "zip": "507182",
        "lat": "45.712212",
        "long": "24.931859"
      },
      {
        "name": "DOPCA",
        "zip": "507098",
        "lat": "45.982123",
        "long": "25.384354"
      },
      {
        "name": "DRAGUS",
        "zip": "507251",
        "lat": "45.761851",
        "long": "24.778081"
      },
      {
        "name": "DRAUSENI",
        "zip": "507042",
        "lat": "46.140161",
        "long": "25.30909"
      },
      {
        "name": "DRIDIF",
        "zip": "507262",
        "lat": "45.8222",
        "long": "24.885188"
      },
      {
        "name": "DRUMUL CARULUI",
        "zip": "507132",
        "lat": "45.473144",
        "long": "25.299341"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "507060",
        "lat": "45.769062",
        "long": "25.435393"
      },
      {
        "name": "FAGARAS",
        "zip": "505200",
        "lat": "45.840864",
        "long": "24.971106"
      },
      {
        "name": "FANTANA",
        "zip": "507099",
        "lat": "45.966237",
        "long": "25.299595"
      },
      {
        "name": "FELDIOARA",
        "zip": "507065",
        "lat": "45.81736",
        "long": "25.591447"
      },
      {
        "name": "FELDIOARA",
        "zip": "507237",
        "lat": "45.805767",
        "long": "24.689639"
      },
      {
        "name": "FELMER",
        "zip": "507217",
        "lat": "45.928926",
        "long": "25.008374"
      },
      {
        "name": "FISER",
        "zip": "505501",
        "lat": "46.078656",
        "long": "25.148613"
      },
      {
        "name": "FUNDATA",
        "zip": "507070",
        "lat": "45.436681",
        "long": "25.275116"
      },
      {
        "name": "FUNDATICA",
        "zip": "507071",
        "lat": "45.424895",
        "long": "25.282815"
      },
      {
        "name": "GHIMBAV",
        "zip": "507075",
        "lat": "45.663822",
        "long": "25.507864"
      },
      {
        "name": "GRANARI",
        "zip": "507112",
        "lat": "46.039526",
        "long": "24.971729"
      },
      {
        "name": "GRID",
        "zip": "507156",
        "lat": "45.824",
        "long": "25.21625"
      },
      {
        "name": "GURA VAII",
        "zip": "507183",
        "lat": "45.729274",
        "long": "24.905833"
      },
      {
        "name": "HALCHIU",
        "zip": "507080",
        "lat": "45.760565",
        "long": "25.543947"
      },
      {
        "name": "HALMEAG",
        "zip": "507196",
        "lat": "45.866299",
        "long": "25.132245"
      },
      {
        "name": "HARMAN",
        "zip": "507085",
        "lat": "45.70668",
        "long": "25.685289"
      },
      {
        "name": "HARSENI",
        "zip": "507090",
        "lat": "45.755416",
        "long": "25.013066"
      },
      {
        "name": "HOGHIZ",
        "zip": "507095",
        "lat": "45.986202",
        "long": "25.309741"
      },
      {
        "name": "HOLBAV",
        "zip": "507272",
        "lat": "45.659221",
        "long": "25.387437"
      },
      {
        "name": "HOMOROD",
        "zip": "507105",
        "lat": "46.041291",
        "long": "25.279368"
      },
      {
        "name": "HUREZ",
        "zip": "507013",
        "lat": "45.801689",
        "long": "24.952454"
      },
      {
        "name": "IASI",
        "zip": "507184",
        "lat": "45.762786",
        "long": "24.930378"
      },
      {
        "name": "ILENI",
        "zip": "507126",
        "lat": "45.787992",
        "long": "24.999934"
      },
      {
        "name": "IONESTI",
        "zip": "507043",
        "lat": "46.160294",
        "long": "25.33679"
      },
      {
        "name": "JIBERT",
        "zip": "507110",
        "lat": "46.004908",
        "long": "25.070544"
      },
      {
        "name": "JIMBOR",
        "zip": "507106",
        "lat": "46.10954",
        "long": "25.388189"
      },
      {
        "name": "LISA",
        "zip": "507115",
        "lat": "45.726272",
        "long": "24.850664"
      },
      {
        "name": "LOVNIC",
        "zip": "507113",
        "lat": "45.985316",
        "long": "25.008948"
      },
      {
        "name": "LUDISOR",
        "zip": "507263",
        "lat": "45.77566",
        "long": "24.886208"
      },
      {
        "name": "LUNCA CALNICULUI",
        "zip": "507170",
        "lat": "45.755509",
        "long": "25.775514"
      },
      {
        "name": "LUPSA",
        "zip": "507101",
        "lat": "45.935759",
        "long": "25.2985"
      },
      {
        "name": "LUTA",
        "zip": "507014",
        "lat": "45.799144",
        "long": "24.906927"
      },
      {
        "name": "MAGURA",
        "zip": "507133",
        "lat": "45.525118",
        "long": "25.294905"
      },
      {
        "name": "MAIERUS",
        "zip": "507120",
        "lat": "45.898944",
        "long": "25.540997"
      },
      {
        "name": "MALINIS",
        "zip": "507092",
        "lat": "45.71275",
        "long": "25.032837"
      },
      {
        "name": "MANDRA",
        "zip": "507125",
        "lat": "45.822892",
        "long": "25.046656"
      },
      {
        "name": "MARGINENI",
        "zip": "507093",
        "lat": "45.73118",
        "long": "25.046106"
      },
      {
        "name": "MATEIAS",
        "zip": "507176",
        "lat": "46.016829",
        "long": "25.381267"
      },
      {
        "name": "MERCHEASA",
        "zip": "507107",
        "lat": "46.06661",
        "long": "25.33619"
      },
      {
        "name": "MESENDORF",
        "zip": "507037",
        "lat": "46.088",
        "long": "24.984925"
      },
      {
        "name": "MOIECIU DE JOS",
        "zip": "507135",
        "lat": "45.494096",
        "long": "25.327171"
      },
      {
        "name": "MOIECIU DE SUS",
        "zip": "507134",
        "lat": "45.443409",
        "long": "25.330495"
      },
      {
        "name": "OHABA",
        "zip": "507202",
        "lat": "45.765744",
        "long": "25.152035"
      },
      {
        "name": "OLTET",
        "zip": "507252",
        "lat": "45.802792",
        "long": "24.762302"
      },
      {
        "name": "ORMENIS",
        "zip": "507150",
        "lat": "46.004727",
        "long": "25.556831"
      },
      {
        "name": "PALOS",
        "zip": "507044",
        "lat": "46.120762",
        "long": "25.234106"
      },
      {
        "name": "PALTIN",
        "zip": "507211",
        "lat": "45.66866",
        "long": "25.306382"
      },
      {
        "name": "PARAU",
        "zip": "507155",
        "lat": "45.847431",
        "long": "25.192485"
      },
      {
        "name": "PARAUL RECE",
        "zip": "505301",
        "lat": "45.51192",
        "long": "25.510341"
      },
      {
        "name": "PERSANI",
        "zip": "507203",
        "lat": "45.779733",
        "long": "25.213109"
      },
      {
        "name": "PESTERA",
        "zip": "507136",
        "lat": "45.505172",
        "long": "25.270108"
      },
      {
        "name": "PODU OLT",
        "zip": "507086",
        "lat": "45.76401",
        "long": "25.728805"
      },
      {
        "name": "POIANA BRASOV",
        "zip": "500001",
        "lat": "45.595358",
        "long": "25.554113"
      },
      {
        "name": "POIANA MARULUI",
        "zip": "507160",
        "lat": "45.606401",
        "long": "25.307265"
      },
      {
        "name": "POJORTA",
        "zip": "507117",
        "lat": "45.747961",
        "long": "24.868938"
      },
      {
        "name": "PREDEAL",
        "zip": "505300",
        "lat": "45.502691",
        "long": "25.576103"
      },
      {
        "name": "PREDELUT",
        "zip": "507026",
        "lat": "45.529436",
        "long": "25.357563"
      },
      {
        "name": "PREJMER",
        "zip": "507165",
        "lat": "45.720534",
        "long": "25.771479"
      },
      {
        "name": "PURCARENI",
        "zip": "507222",
        "lat": "45.644757",
        "long": "25.791294"
      },
      {
        "name": "RACOS",
        "zip": "507175",
        "lat": "46.024455",
        "long": "25.409374"
      },
      {
        "name": "RASNOV",
        "zip": "505400",
        "lat": "45.593567",
        "long": "25.463942"
      },
      {
        "name": "RAUSOR",
        "zip": "507127",
        "lat": "45.816079",
        "long": "25.004762"
      },
      {
        "name": "RECEA",
        "zip": "507180",
        "lat": "45.731546",
        "long": "24.942772"
      },
      {
        "name": "ROADES",
        "zip": "507038",
        "lat": "46.128035",
        "long": "25.109106"
      },
      {
        "name": "RODBAV",
        "zip": "507218",
        "lat": "45.911891",
        "long": "24.87421"
      },
      {
        "name": "ROTBAV",
        "zip": "507067",
        "lat": "45.839292",
        "long": "25.55558"
      },
      {
        "name": "RUCAR",
        "zip": "507253",
        "lat": "45.820568",
        "long": "24.767967"
      },
      {
        "name": "RUPEA",
        "zip": "505500",
        "lat": "46.037528",
        "long": "25.221498"
      },
      {
        "name": "SACELE",
        "zip": "505600",
        "lat": "45.616651",
        "long": "25.69103"
      },
      {
        "name": "SAMBATA DE JOS",
        "zip": "507264",
        "lat": "45.811154",
        "long": "24.820654"
      },
      {
        "name": "SAMBATA DE SUS",
        "zip": "507266",
        "lat": "45.75892",
        "long": "24.826078"
      },
      {
        "name": "SANPETRU",
        "zip": "507190",
        "lat": "45.706641",
        "long": "25.632262"
      },
      {
        "name": "SASCIORI",
        "zip": "507186",
        "lat": "45.760085",
        "long": "24.954147"
      },
      {
        "name": "SATU NOU",
        "zip": "507083",
        "lat": "45.77376",
        "long": "25.51363"
      },
      {
        "name": "SAVASTRENI",
        "zip": "507187",
        "lat": "45.76264",
        "long": "24.943727"
      },
      {
        "name": "SEBES",
        "zip": "507094",
        "lat": "45.727",
        "long": "25.03079"
      },
      {
        "name": "SELISTAT",
        "zip": "507219",
        "lat": "45.98612",
        "long": "24.861777"
      },
      {
        "name": "SERCAIA",
        "zip": "507195",
        "lat": "45.831636",
        "long": "25.139249"
      },
      {
        "name": "SERCAITA",
        "zip": "507204",
        "lat": "45.74666",
        "long": "25.124385"
      },
      {
        "name": "SIMON",
        "zip": "507028",
        "lat": "45.49483",
        "long": "25.357514"
      },
      {
        "name": "SINCA NOUA",
        "zip": "507210",
        "lat": "45.699648",
        "long": "25.24464"
      },
      {
        "name": "SINCA VECHE",
        "zip": "507206",
        "lat": "45.763129",
        "long": "25.171231"
      },
      {
        "name": "SIRNEA",
        "zip": "507072",
        "lat": "45.471392",
        "long": "25.254865"
      },
      {
        "name": "SOARS",
        "zip": "507215",
        "lat": "45.929495",
        "long": "24.930378"
      },
      {
        "name": "SOHODOL",
        "zip": "507027",
        "lat": "45.526533",
        "long": "25.39515"
      },
      {
        "name": "SONA",
        "zip": "507128",
        "lat": "45.847894",
        "long": "25.042098"
      },
      {
        "name": "STATIUNEA CLIMATERICA SAMBATA",
        "zip": "507267",
        "lat": "45.692184",
        "long": "24.800806"
      },
      {
        "name": "STUPINII PREJMERULUI",
        "zip": "507166",
        "lat": "45.717627",
        "long": "25.819137"
      },
      {
        "name": "TARLUNGENI",
        "zip": "507220",
        "lat": "45.648249",
        "long": "25.764449"
      },
      {
        "name": "TELIU",
        "zip": "507225",
        "lat": "45.697916",
        "long": "25.858019"
      },
      {
        "name": "TICUSU NOU",
        "zip": "507054",
        "lat": "45.918785",
        "long": "25.181244"
      },
      {
        "name": "TICUSU VECHI",
        "zip": "507232",
        "lat": "45.929145",
        "long": "25.101833"
      },
      {
        "name": "TIMISU DE JOS",
        "zip": "505302",
        "lat": "45.594354",
        "long": "25.637184"
      },
      {
        "name": "TIMISU DE SUS",
        "zip": "505303",
        "lat": "45.527604",
        "long": "25.578342"
      },
      {
        "name": "TOARCLA",
        "zip": "507046",
        "lat": "45.897767",
        "long": "24.736946"
      },
      {
        "name": "TODERITA",
        "zip": "507129",
        "lat": "45.787117",
        "long": "25.063747"
      },
      {
        "name": "TOHANU NOU",
        "zip": "505801",
        "lat": "45.545639",
        "long": "25.381216"
      },
      {
        "name": "UCEA DE JOS",
        "zip": "507238",
        "lat": "45.786351",
        "long": "24.670783"
      },
      {
        "name": "UCEA DE SUS",
        "zip": "507239",
        "lat": "45.752093",
        "long": "24.682405"
      },
      {
        "name": "UNGRA",
        "zip": "507240",
        "lat": "45.981679",
        "long": "25.262227"
      },
      {
        "name": "VAD",
        "zip": "507197",
        "lat": "45.793112",
        "long": "25.14921"
      },
      {
        "name": "VALCEA",
        "zip": "507207",
        "lat": "45.740032",
        "long": "25.200897"
      },
      {
        "name": "VALENI",
        "zip": "507114",
        "lat": "45.960951",
        "long": "24.968966"
      },
      {
        "name": "VAMA BUZAULUI",
        "zip": "507245",
        "lat": "45.596293",
        "long": "25.992114"
      },
      {
        "name": "VENETIA DE JOS",
        "zip": "507157",
        "lat": "45.875119",
        "long": "25.211311"
      },
      {
        "name": "VENETIA DE SUS",
        "zip": "507158",
        "lat": "45.85751",
        "long": "25.242683"
      },
      {
        "name": "VICTORIA",
        "zip": "505700",
        "lat": "45.72616",
        "long": "24.702811"
      },
      {
        "name": "VISCRI",
        "zip": "507039",
        "lat": "46.056738",
        "long": "25.097113"
      },
      {
        "name": "VISTEA DE JOS",
        "zip": "507254",
        "lat": "45.79529",
        "long": "24.723776"
      },
      {
        "name": "VISTEA DE SUS",
        "zip": "507256",
        "lat": "45.745494",
        "long": "24.741166"
      },
      {
        "name": "VISTISOARA",
        "zip": "507257",
        "lat": "45.694716",
        "long": "24.760052"
      },
      {
        "name": "VLADENI",
        "zip": "507061",
        "lat": "45.766534",
        "long": "25.369168"
      },
      {
        "name": "VOILA",
        "zip": "507260",
        "lat": "45.816637",
        "long": "24.840215"
      },
      {
        "name": "VOIVODENI",
        "zip": "507268",
        "lat": "45.776998",
        "long": "24.860832"
      },
      {
        "name": "VULCAN",
        "zip": "507270",
        "lat": "45.633307",
        "long": "25.422615"
      },
      {
        "name": "ZARNESTI",
        "zip": "505800",
        "lat": "45.559528",
        "long": "25.315467"
      },
      {
        "name": "ZIZIN",
        "zip": "507223",
        "lat": "45.637606",
        "long": "25.774698"
      }
    ],
    "BUZĂU": [
      {
        "name": "ALBESTI",
        "zip": "127596",
        "lat": "44.990419",
        "long": "26.925492"
      },
      {
        "name": "ALDENI",
        "zip": "127151",
        "lat": "45.319132",
        "long": "26.756762"
      },
      {
        "name": "ALEXANDRU ODOBESCU",
        "zip": "127111",
        "lat": "45.515853",
        "long": "26.91285"
      },
      {
        "name": "ALICENI",
        "zip": "127486",
        "lat": "45.262985",
        "long": "26.864017"
      },
      {
        "name": "ALUNIS",
        "zip": "127196",
        "lat": "45.408601",
        "long": "26.416322"
      },
      {
        "name": "AMARA",
        "zip": "127016",
        "lat": "45.246117",
        "long": "27.293156"
      },
      {
        "name": "AMARU",
        "zip": "127005",
        "lat": "44.927286",
        "long": "26.588597"
      },
      {
        "name": "ANINI",
        "zip": "127211",
        "lat": "45.35421",
        "long": "26.465526"
      },
      {
        "name": "ARBANASI",
        "zip": "127026",
        "lat": "45.399435",
        "long": "26.735544"
      },
      {
        "name": "ARCANU",
        "zip": "127576",
        "lat": "44.836716",
        "long": "26.987297"
      },
      {
        "name": "BABENI",
        "zip": "127631",
        "lat": "45.446278",
        "long": "26.979848"
      },
      {
        "name": "BACENI",
        "zip": "127036",
        "lat": "45.339355",
        "long": "26.5919"
      },
      {
        "name": "BADENI",
        "zip": "127106",
        "lat": "45.098866",
        "long": "26.554723"
      },
      {
        "name": "BADILA",
        "zip": "127451",
        "lat": "45.266201",
        "long": "26.510766"
      },
      {
        "name": "BAESTI",
        "zip": "127152",
        "lat": "45.31766",
        "long": "26.787327"
      },
      {
        "name": "BAILE",
        "zip": "127017",
        "lat": "45.289159",
        "long": "27.361504"
      },
      {
        "name": "BAJANI",
        "zip": "127651",
        "lat": "45.166696",
        "long": "26.873079"
      },
      {
        "name": "BALACEANU",
        "zip": "127020",
        "lat": "45.246637",
        "long": "27.136966"
      },
      {
        "name": "BALAIA",
        "zip": "127597",
        "lat": "45.013215",
        "long": "26.830481"
      },
      {
        "name": "BALANESTI",
        "zip": "127212",
        "lat": "45.340899",
        "long": "26.485467"
      },
      {
        "name": "BALHACU",
        "zip": "127122",
        "lat": "45.04833",
        "long": "27.132458"
      },
      {
        "name": "BALTA ALBA",
        "zip": "127015",
        "lat": "45.305236",
        "long": "27.287591"
      },
      {
        "name": "BALTA TOCILA",
        "zip": "127556",
        "lat": "45.40343",
        "long": "26.696577"
      },
      {
        "name": "BALTAGARI",
        "zip": "127056",
        "lat": "45.548725",
        "long": "26.725929"
      },
      {
        "name": "BALTARETI",
        "zip": "127646",
        "lat": "45.061067",
        "long": "26.622484"
      },
      {
        "name": "BALTENI",
        "zip": "127121",
        "lat": "45.009118",
        "long": "27.146414"
      },
      {
        "name": "BANITA",
        "zip": "127526",
        "lat": "45.10019",
        "long": "27.102097"
      },
      {
        "name": "BARASTI",
        "zip": "127186",
        "lat": "45.226951",
        "long": "26.383193"
      },
      {
        "name": "BARBUNCESTI",
        "zip": "127611",
        "lat": "45.225859",
        "long": "26.600377"
      },
      {
        "name": "BASCA CHIOJDULUI",
        "zip": "127171",
        "lat": "45.374883",
        "long": "26.177117"
      },
      {
        "name": "BASCA ROZILEI",
        "zip": "125101",
        "lat": "45.453492",
        "long": "26.337274"
      },
      {
        "name": "BASCENII DE JOS",
        "zip": "127131",
        "lat": "45.247127",
        "long": "26.316475"
      },
      {
        "name": "BASCENII DE SUS",
        "zip": "127132",
        "lat": "45.262849",
        "long": "26.270049"
      },
      {
        "name": "BATOGU",
        "zip": "127386",
        "lat": "45.4105",
        "long": "26.879844"
      },
      {
        "name": "BECENI",
        "zip": "127025",
        "lat": "45.3821",
        "long": "26.769004"
      },
      {
        "name": "BECIU",
        "zip": "127557",
        "lat": "45.376583",
        "long": "26.711925"
      },
      {
        "name": "BEGU",
        "zip": "127421",
        "lat": "45.337992",
        "long": "26.398502"
      },
      {
        "name": "BEILIC",
        "zip": "127527",
        "lat": "45.083732",
        "long": "27.014336"
      },
      {
        "name": "BENTU",
        "zip": "127241",
        "lat": "45.067538",
        "long": "26.972043"
      },
      {
        "name": "BERCA",
        "zip": "127035",
        "lat": "45.287339",
        "long": "26.680974"
      },
      {
        "name": "BERCESTI",
        "zip": "127213",
        "lat": "45.34912",
        "long": "26.473133"
      },
      {
        "name": "BESLII",
        "zip": "127336",
        "lat": "45.482497",
        "long": "26.676285"
      },
      {
        "name": "BISOCA",
        "zip": "127055",
        "lat": "45.542233",
        "long": "26.706427"
      },
      {
        "name": "BLAJANI",
        "zip": "127065",
        "lat": "45.316004",
        "long": "26.813166"
      },
      {
        "name": "BOBOC",
        "zip": "127191",
        "lat": "45.19325",
        "long": "26.982254"
      },
      {
        "name": "BODINESTI",
        "zip": "127696",
        "lat": "45.465816",
        "long": "26.722319"
      },
      {
        "name": "BOLDU",
        "zip": "127070",
        "lat": "45.322786",
        "long": "27.240269"
      },
      {
        "name": "BORDUSANI",
        "zip": "127528",
        "lat": "45.108572",
        "long": "26.968589"
      },
      {
        "name": "BOZIORU",
        "zip": "127075",
        "lat": "45.38344",
        "long": "26.495387"
      },
      {
        "name": "BRADEANCA",
        "zip": "127676",
        "lat": "45.185767",
        "long": "26.749473"
      },
      {
        "name": "BRADEANU",
        "zip": "127090",
        "lat": "44.92659",
        "long": "26.864193"
      },
      {
        "name": "BRAESTI",
        "zip": "127095",
        "lat": "45.430343",
        "long": "26.510252"
      },
      {
        "name": "BRAGAREASA",
        "zip": "127577",
        "lat": "44.824029",
        "long": "26.932892"
      },
      {
        "name": "BRATILESTI",
        "zip": "127096",
        "lat": "45.469506",
        "long": "26.481099"
      },
      {
        "name": "BREAZA",
        "zip": "127105",
        "lat": "45.091268",
        "long": "26.532805"
      },
      {
        "name": "BREBU",
        "zip": "127296",
        "lat": "45.496979",
        "long": "26.59348"
      },
      {
        "name": "BUDA",
        "zip": "127110",
        "lat": "45.496525",
        "long": "26.902266"
      },
      {
        "name": "BUDA CRACIUNESTI",
        "zip": "127187",
        "lat": "45.183719",
        "long": "26.382855"
      },
      {
        "name": "BUDESTI",
        "zip": "127161",
        "lat": "45.448801",
        "long": "26.545421"
      },
      {
        "name": "BUDISTENI",
        "zip": "127201",
        "lat": "45.043643",
        "long": "26.785702"
      },
      {
        "name": "BUDREA",
        "zip": "127506",
        "lat": "45.364185",
        "long": "26.907706"
      },
      {
        "name": "BUDUILE",
        "zip": "127076",
        "lat": "45.388105",
        "long": "26.440203"
      },
      {
        "name": "BUSTEA",
        "zip": "127337",
        "lat": "45.51722",
        "long": "26.59747"
      },
      {
        "name": "BUZAU",
        "zip": "120001",
        "lat": "45.155975",
        "long": "26.817054"
      },
      {
        "name": "C.A. ROSETTI",
        "zip": "127120",
        "lat": "45.047397",
        "long": "27.164784"
      },
      {
        "name": "CALDARASTI",
        "zip": "125201",
        "lat": "44.893838",
        "long": "27.033305"
      },
      {
        "name": "CALDARUSA",
        "zip": "127153",
        "lat": "45.292508",
        "long": "26.756203"
      },
      {
        "name": "CALDARUSANCA",
        "zip": "127256",
        "lat": "44.880312",
        "long": "26.695079"
      },
      {
        "name": "CALEA CHIOJDULUI",
        "zip": "127431",
        "lat": "45.329278",
        "long": "26.294444"
      },
      {
        "name": "CALTESTI",
        "zip": "127471",
        "lat": "45.116548",
        "long": "26.593839"
      },
      {
        "name": "CALTUNA",
        "zip": "127598",
        "lat": "44.964854",
        "long": "26.948424"
      },
      {
        "name": "CALVINI",
        "zip": "127130",
        "lat": "45.251841",
        "long": "26.291584"
      },
      {
        "name": "CAMPENI",
        "zip": "127006",
        "lat": "44.968193",
        "long": "26.631989"
      },
      {
        "name": "CAMPULUNGEANCA",
        "zip": "127331",
        "lat": "45.450435",
        "long": "26.820412"
      },
      {
        "name": "CANDESTI",
        "zip": "127677",
        "lat": "45.249177",
        "long": "26.704626"
      },
      {
        "name": "CANESTI",
        "zip": "127135",
        "lat": "45.397578",
        "long": "26.602707"
      },
      {
        "name": "CAPATANESTI",
        "zip": "127326",
        "lat": "45.189925",
        "long": "26.793113"
      },
      {
        "name": "CAPU SATULUI",
        "zip": "127396",
        "lat": "45.387057",
        "long": "26.527324"
      },
      {
        "name": "CARAGELE",
        "zip": "127316",
        "lat": "44.979569",
        "long": "27.031707"
      },
      {
        "name": "CARATNAU DE JOS",
        "zip": "127546",
        "lat": "45.463769",
        "long": "26.756308"
      },
      {
        "name": "CARATNAU DE SUS",
        "zip": "127547",
        "lat": "45.461553",
        "long": "26.79002"
      },
      {
        "name": "CARLIGU MARE",
        "zip": "127262",
        "lat": "44.847736",
        "long": "26.749671"
      },
      {
        "name": "CARLIGU MIC",
        "zip": "127263",
        "lat": "44.84064",
        "long": "26.766558"
      },
      {
        "name": "CARLOMANESTI",
        "zip": "127678",
        "lat": "45.229114",
        "long": "26.691619"
      },
      {
        "name": "CARPINISTEA",
        "zip": "127027",
        "lat": "45.35791",
        "long": "26.765357"
      },
      {
        "name": "CASOCA",
        "zip": "127581",
        "lat": "45.488122",
        "long": "26.264681"
      },
      {
        "name": "CASOTA",
        "zip": "127261",
        "lat": "44.852237",
        "long": "26.713858"
      },
      {
        "name": "CATIASU",
        "zip": "127172",
        "lat": "45.394514",
        "long": "26.228506"
      },
      {
        "name": "CATINA",
        "zip": "127145",
        "lat": "45.293956",
        "long": "26.247014"
      },
      {
        "name": "CEAIRU",
        "zip": "127632",
        "lat": "45.481459",
        "long": "26.93585"
      },
      {
        "name": "CERNATESTI",
        "zip": "127150",
        "lat": "45.264054",
        "long": "26.760055"
      },
      {
        "name": "CHILIILE",
        "zip": "127160",
        "lat": "45.446734",
        "long": "26.599444"
      },
      {
        "name": "CHIOJDU",
        "zip": "127170",
        "lat": "45.349796",
        "long": "26.215569"
      },
      {
        "name": "CHIPERU",
        "zip": "127416",
        "lat": "45.436488",
        "long": "26.901332"
      },
      {
        "name": "CHIRLESTI",
        "zip": "125102",
        "lat": "45.374556",
        "long": "26.324303"
      },
      {
        "name": "CILIBIA",
        "zip": "127180",
        "lat": "45.060185",
        "long": "27.065294"
      },
      {
        "name": "CIOBANOAIA",
        "zip": "127356",
        "lat": "45.154357",
        "long": "26.691684"
      },
      {
        "name": "CIOCANESTI",
        "zip": "127214",
        "lat": "45.322657",
        "long": "26.513505"
      },
      {
        "name": "CIORANCA",
        "zip": "127381",
        "lat": "44.987345",
        "long": "26.716388"
      },
      {
        "name": "CIRESU",
        "zip": "127338",
        "lat": "45.529632",
        "long": "26.631348"
      },
      {
        "name": "CISLAU",
        "zip": "127185",
        "lat": "45.245479",
        "long": "26.376255"
      },
      {
        "name": "CIUTA",
        "zip": "127321",
        "lat": "45.260944",
        "long": "26.523118"
      },
      {
        "name": "CLONDIRU",
        "zip": "127647",
        "lat": "45.053558",
        "long": "26.615718"
      },
      {
        "name": "CLONDIRU DE SUS",
        "zip": "127472",
        "lat": "45.0978",
        "long": "26.592264"
      },
      {
        "name": "COCA-ANTIMIRESTI",
        "zip": "127697",
        "lat": "45.455924",
        "long": "26.700613"
      },
      {
        "name": "COCA-NICULESTI",
        "zip": "127698",
        "lat": "45.44006",
        "long": "26.689433"
      },
      {
        "name": "COCARCENI",
        "zip": "127216",
        "lat": "45.357966",
        "long": "26.474223"
      },
      {
        "name": "COCHIRLEANCA",
        "zip": "127190",
        "lat": "45.209372",
        "long": "27.039982"
      },
      {
        "name": "COCONARI",
        "zip": "127487",
        "lat": "45.241891",
        "long": "26.868879"
      },
      {
        "name": "COJANU",
        "zip": "127037",
        "lat": "45.298886",
        "long": "26.617051"
      },
      {
        "name": "COLIBASI",
        "zip": "127511",
        "lat": "45.385255",
        "long": "27.124826"
      },
      {
        "name": "COLTANENI",
        "zip": "127376",
        "lat": "44.925569",
        "long": "26.668993"
      },
      {
        "name": "COLTENI",
        "zip": "127217",
        "lat": "45.324962",
        "long": "26.534121"
      },
      {
        "name": "COLTI",
        "zip": "127195",
        "lat": "45.377777",
        "long": "26.390733"
      },
      {
        "name": "COLTII DE JOS",
        "zip": "127197",
        "lat": "45.393184",
        "long": "26.386748"
      },
      {
        "name": "COLTU PIETRII",
        "zip": "127582",
        "lat": "45.468079",
        "long": "26.280826"
      },
      {
        "name": "COMISOAIA",
        "zip": "127716",
        "lat": "45.302437",
        "long": "26.921951"
      },
      {
        "name": "CORBU",
        "zip": "127146",
        "lat": "45.319234",
        "long": "26.249527"
      },
      {
        "name": "CORBU",
        "zip": "127264",
        "lat": "44.857276",
        "long": "26.706996"
      },
      {
        "name": "CORNEANU",
        "zip": "127397",
        "lat": "45.360293",
        "long": "26.535569"
      },
      {
        "name": "COSTESTI",
        "zip": "127200",
        "lat": "45.047607",
        "long": "26.758996"
      },
      {
        "name": "COSTIENI",
        "zip": "127721",
        "lat": "45.278436",
        "long": "27.041548"
      },
      {
        "name": "COSTOMIRU",
        "zip": "127417",
        "lat": "45.459049",
        "long": "26.857483"
      },
      {
        "name": "COTATCU",
        "zip": "127481",
        "lat": "45.466843",
        "long": "27.01247"
      },
      {
        "name": "COTORCA",
        "zip": "127266",
        "lat": "44.822584",
        "long": "26.825445"
      },
      {
        "name": "COTU CIORII",
        "zip": "127123",
        "lat": "45.062986",
        "long": "27.142288"
      },
      {
        "name": "COZIENI",
        "zip": "127210",
        "lat": "45.330967",
        "long": "26.49063"
      },
      {
        "name": "CRANG",
        "zip": "127432",
        "lat": "45.324211",
        "long": "26.345502"
      },
      {
        "name": "CREVELESTI",
        "zip": "127162",
        "lat": "45.449608",
        "long": "26.579182"
      },
      {
        "name": "CUCULEASA",
        "zip": "127722",
        "lat": "45.280389",
        "long": "27.004113"
      },
      {
        "name": "CURCANESTI",
        "zip": "127452",
        "lat": "45.307547",
        "long": "26.524301"
      },
      {
        "name": "CURMATURA",
        "zip": "125103",
        "lat": "45.380383",
        "long": "26.295103"
      },
      {
        "name": "DALMA",
        "zip": "127558",
        "lat": "45.362818",
        "long": "26.596796"
      },
      {
        "name": "DAMBROCA",
        "zip": "127529",
        "lat": "45.11976",
        "long": "26.952421"
      },
      {
        "name": "DANULESTI",
        "zip": "127112",
        "lat": "45.507477",
        "long": "26.936541"
      },
      {
        "name": "DARA",
        "zip": "127473",
        "lat": "45.106118",
        "long": "26.596279"
      },
      {
        "name": "DASCALESTI",
        "zip": "127496",
        "lat": "45.407073",
        "long": "27.248251"
      },
      {
        "name": "DEALUL VIEI",
        "zip": "127357",
        "lat": "45.113352",
        "long": "26.655099"
      },
      {
        "name": "DEDULESTI",
        "zip": "127633",
        "lat": "45.468818",
        "long": "26.966922"
      },
      {
        "name": "DELENI",
        "zip": "127559",
        "lat": "45.413273",
        "long": "26.714201"
      },
      {
        "name": "DOBRILESTI",
        "zip": "127358",
        "lat": "45.116553",
        "long": "26.615144"
      },
      {
        "name": "DOGARI",
        "zip": "127028",
        "lat": "45.412845",
        "long": "26.756333"
      },
      {
        "name": "DULBANU",
        "zip": "127007",
        "lat": "44.90618",
        "long": "26.597361"
      },
      {
        "name": "FANTANELE",
        "zip": "127332",
        "lat": "45.422719",
        "long": "26.848978"
      },
      {
        "name": "FANTANELE",
        "zip": "127391",
        "lat": "45.10682",
        "long": "26.500822"
      },
      {
        "name": "FATA LUI NAN",
        "zip": "127218",
        "lat": "45.359662",
        "long": "26.484433"
      },
      {
        "name": "FINTESTI",
        "zip": "127392",
        "lat": "45.088153",
        "long": "26.464347"
      },
      {
        "name": "FISICI",
        "zip": "127077",
        "lat": "45.40227",
        "long": "26.467677"
      },
      {
        "name": "FLORESTI",
        "zip": "127029",
        "lat": "45.405739",
        "long": "26.818478"
      },
      {
        "name": "FLORICA",
        "zip": "127377",
        "lat": "44.90825",
        "long": "26.771124"
      },
      {
        "name": "FOCSANEI",
        "zip": "127652",
        "lat": "45.179134",
        "long": "26.861171"
      },
      {
        "name": "FOTIN",
        "zip": "127512",
        "lat": "45.387537",
        "long": "27.148626"
      },
      {
        "name": "FRASINET",
        "zip": "127133",
        "lat": "45.237127",
        "long": "26.292655"
      },
      {
        "name": "FULGA",
        "zip": "127154",
        "lat": "45.330172",
        "long": "26.766867"
      },
      {
        "name": "FUNDATA",
        "zip": "127297",
        "lat": "45.468485",
        "long": "26.521212"
      },
      {
        "name": "FUNDATURILE",
        "zip": "127433",
        "lat": "45.334309",
        "long": "26.320974"
      },
      {
        "name": "FUNDENI",
        "zip": "127717",
        "lat": "45.291411",
        "long": "26.880282"
      },
      {
        "name": "FURTUNESTI",
        "zip": "127281",
        "lat": "45.46208",
        "long": "26.403532"
      },
      {
        "name": "GAGENI",
        "zip": "127536",
        "lat": "45.013889",
        "long": "26.585203"
      },
      {
        "name": "GALBINASI",
        "zip": "127240",
        "lat": "45.076497",
        "long": "26.936777"
      },
      {
        "name": "GARA BOBOCU",
        "zip": "127192",
        "lat": "45.210572",
        "long": "26.935307"
      },
      {
        "name": "GARA CILIBIA",
        "zip": "127181",
        "lat": "45.042702",
        "long": "27.022315"
      },
      {
        "name": "GAVANELE",
        "zip": "127078",
        "lat": "45.40939",
        "long": "26.463693"
      },
      {
        "name": "GAVANESTI",
        "zip": "127531",
        "lat": "45.08589",
        "long": "27.063988"
      },
      {
        "name": "GHERASENI",
        "zip": "127245",
        "lat": "45.025251",
        "long": "26.791596"
      },
      {
        "name": "GHERGHEASA",
        "zip": "127250",
        "lat": "45.269158",
        "long": "27.206301"
      },
      {
        "name": "GHIOCARI",
        "zip": "127163",
        "lat": "45.455198",
        "long": "26.599106"
      },
      {
        "name": "GHIZDITA",
        "zip": "127339",
        "lat": "45.49755",
        "long": "26.651933"
      },
      {
        "name": "GLODEANU SARAT",
        "zip": "127255",
        "lat": "44.871464",
        "long": "26.650692"
      },
      {
        "name": "GLODEANU-SILISTEA",
        "zip": "127260",
        "lat": "44.830192",
        "long": "26.802137"
      },
      {
        "name": "GLODU-PETCARI",
        "zip": "127164",
        "lat": "45.454004",
        "long": "26.627108"
      },
      {
        "name": "GLODURILE",
        "zip": "127219",
        "lat": "45.333606",
        "long": "26.54029"
      },
      {
        "name": "GOICELU",
        "zip": "127548",
        "lat": "45.484394",
        "long": "26.798757"
      },
      {
        "name": "GOIDESTI",
        "zip": "127097",
        "lat": "45.462916",
        "long": "26.505073"
      },
      {
        "name": "GOLU GRABICINA",
        "zip": "127561",
        "lat": "45.422594",
        "long": "26.683612"
      },
      {
        "name": "GOMOESTI",
        "zip": "127202",
        "lat": "45.066531",
        "long": "26.800519"
      },
      {
        "name": "GONTESTI",
        "zip": "127136",
        "lat": "45.387972",
        "long": "26.594144"
      },
      {
        "name": "GORANI",
        "zip": "127398",
        "lat": "45.367385",
        "long": "26.540865"
      },
      {
        "name": "GORNET",
        "zip": "127434",
        "lat": "45.347291",
        "long": "26.384891"
      },
      {
        "name": "GRABICINA DE JOS",
        "zip": "127562",
        "lat": "45.403712",
        "long": "26.662253"
      },
      {
        "name": "GRABICINA DE SUS",
        "zip": "127563",
        "lat": "45.428765",
        "long": "26.664828"
      },
      {
        "name": "GRAJDANA",
        "zip": "127612",
        "lat": "45.208987",
        "long": "26.630784"
      },
      {
        "name": "GREBANU",
        "zip": "127270",
        "lat": "45.376451",
        "long": "26.982475"
      },
      {
        "name": "GRECEANCA",
        "zip": "127107",
        "lat": "45.075781",
        "long": "26.548651"
      },
      {
        "name": "GRESIA",
        "zip": "127079",
        "lat": "45.374687",
        "long": "26.489498"
      },
      {
        "name": "GROSANI",
        "zip": "127203",
        "lat": "45.067921",
        "long": "26.753672"
      },
      {
        "name": "GURA BADICULUI",
        "zip": "127341",
        "lat": "45.511317",
        "long": "26.629951"
      },
      {
        "name": "GURA BASCEI",
        "zip": "127188",
        "lat": "45.256984",
        "long": "26.359369"
      },
      {
        "name": "GURA CALNAULUI",
        "zip": "127653",
        "lat": "45.174731",
        "long": "26.847924"
      },
      {
        "name": "GURA DIMIENII",
        "zip": "127031",
        "lat": "45.403647",
        "long": "26.758298"
      },
      {
        "name": "GURA FAGETULUI",
        "zip": "127634",
        "lat": "45.483078",
        "long": "26.94485"
      },
      {
        "name": "GURA SARATII",
        "zip": "127359",
        "lat": "45.119931",
        "long": "26.64373"
      },
      {
        "name": "GURA SIRIULUI",
        "zip": "127583",
        "lat": "45.519257",
        "long": "26.209018"
      },
      {
        "name": "GURA TEGHII",
        "zip": "127280",
        "lat": "45.48954",
        "long": "26.427949"
      },
      {
        "name": "GURA VAII",
        "zip": "127564",
        "lat": "45.378576",
        "long": "26.663662"
      },
      {
        "name": "HALES",
        "zip": "127613",
        "lat": "45.188407",
        "long": "26.561451"
      },
      {
        "name": "HELIADE RADULESCU",
        "zip": "127723",
        "lat": "45.291514",
        "long": "27.120574"
      },
      {
        "name": "HOMESTI",
        "zip": "127271",
        "lat": "45.398051",
        "long": "26.958768"
      },
      {
        "name": "ILEANA",
        "zip": "127257",
        "lat": "44.860962",
        "long": "26.628706"
      },
      {
        "name": "ISTRITA DE JOS",
        "zip": "127537",
        "lat": "45.053447",
        "long": "26.563819"
      },
      {
        "name": "IVANETU",
        "zip": "127098",
        "lat": "45.462267",
        "long": "26.491784"
      },
      {
        "name": "IZVOARELE",
        "zip": "127081",
        "lat": "45.369821",
        "long": "26.483333"
      },
      {
        "name": "IZVORANU",
        "zip": "127614",
        "lat": "45.233336",
        "long": "26.582856"
      },
      {
        "name": "IZVORU",
        "zip": "127221",
        "lat": "45.33411",
        "long": "26.519203"
      },
      {
        "name": "IZVORU",
        "zip": "127616",
        "lat": "45.188518",
        "long": "26.577449"
      },
      {
        "name": "IZVORU DULCE",
        "zip": "127032",
        "lat": "45.341782",
        "long": "26.7773"
      },
      {
        "name": "IZVORU DULCE",
        "zip": "127361",
        "lat": "45.11153",
        "long": "26.632123"
      },
      {
        "name": "JGHIAB",
        "zip": "127342",
        "lat": "45.521873",
        "long": "26.635362"
      },
      {
        "name": "JOSENI",
        "zip": "127038",
        "lat": "45.312213",
        "long": "26.655064"
      },
      {
        "name": "LACU",
        "zip": "127399",
        "lat": "45.403247",
        "long": "26.527492"
      },
      {
        "name": "LACU CU ANINI",
        "zip": "127422",
        "lat": "45.326098",
        "long": "26.421819"
      },
      {
        "name": "LACU SINAIA",
        "zip": "127008",
        "lat": "44.925141",
        "long": "26.556912"
      },
      {
        "name": "LACURILE",
        "zip": "127057",
        "lat": "45.544047",
        "long": "26.646317"
      },
      {
        "name": "LANURILE",
        "zip": "127724",
        "lat": "45.269521",
        "long": "27.087729"
      },
      {
        "name": "LARGU",
        "zip": "127290",
        "lat": "44.976884",
        "long": "27.14434"
      },
      {
        "name": "LEICULESTI",
        "zip": "127617",
        "lat": "45.182217",
        "long": "26.581215"
      },
      {
        "name": "LERA",
        "zip": "127173",
        "lat": "45.332268",
        "long": "26.236481"
      },
      {
        "name": "LIMPEZIS",
        "zip": "127382",
        "lat": "44.953462",
        "long": "26.701968"
      },
      {
        "name": "LIPANESCU",
        "zip": "127578",
        "lat": "44.852463",
        "long": "26.904488"
      },
      {
        "name": "LIPIA",
        "zip": "127362",
        "lat": "45.139475",
        "long": "26.735626"
      },
      {
        "name": "LIVADA",
        "zip": "127272",
        "lat": "45.381824",
        "long": "26.947642"
      },
      {
        "name": "LIVADA MICA",
        "zip": "127273",
        "lat": "45.389812",
        "long": "26.920828"
      },
      {
        "name": "LOPATAREASA",
        "zip": "127058",
        "lat": "45.5397",
        "long": "26.658551"
      },
      {
        "name": "LOPATARI",
        "zip": "127295",
        "lat": "45.483224",
        "long": "26.59224"
      },
      {
        "name": "LUCIU",
        "zip": "127315",
        "lat": "44.974075",
        "long": "27.077145"
      },
      {
        "name": "LUNCA",
        "zip": "127009",
        "lat": "44.95601",
        "long": "26.6374"
      },
      {
        "name": "LUNCA",
        "zip": "127124",
        "lat": "45.004958",
        "long": "27.21349"
      },
      {
        "name": "LUNCA",
        "zip": "127436",
        "lat": "45.29661",
        "long": "26.357367"
      },
      {
        "name": "LUNCA",
        "zip": "127497",
        "lat": "45.375166",
        "long": "27.179066"
      },
      {
        "name": "LUNCA FRUMOASA",
        "zip": "127453",
        "lat": "45.306985",
        "long": "26.539498"
      },
      {
        "name": "LUNCA JARISTEI",
        "zip": "127585",
        "lat": "45.47881",
        "long": "26.260486"
      },
      {
        "name": "LUNCA PRIPORULUI",
        "zip": "125104",
        "lat": "45.439088",
        "long": "26.308689"
      },
      {
        "name": "LUNCILE",
        "zip": "127298",
        "lat": "45.496327",
        "long": "26.544282"
      },
      {
        "name": "LUNGESTI",
        "zip": "127222",
        "lat": "45.319096",
        "long": "26.495406"
      },
      {
        "name": "MACRINA",
        "zip": "127498",
        "lat": "45.387787",
        "long": "27.196409"
      },
      {
        "name": "MAGURA",
        "zip": "127320",
        "lat": "45.27883",
        "long": "26.577252"
      },
      {
        "name": "MAGURICEA",
        "zip": "127423",
        "lat": "45.288828",
        "long": "26.407246"
      },
      {
        "name": "MANASIA",
        "zip": "127156",
        "lat": "45.303631",
        "long": "26.756344"
      },
      {
        "name": "MANASTIREA",
        "zip": "127437",
        "lat": "45.29958",
        "long": "26.330798"
      },
      {
        "name": "MANASTIREA RATESTI",
        "zip": "127039",
        "lat": "45.307333",
        "long": "26.6337"
      },
      {
        "name": "MANZALESTI",
        "zip": "127335",
        "lat": "45.491391",
        "long": "26.630591"
      },
      {
        "name": "MANZU",
        "zip": "127182",
        "lat": "45.062116",
        "long": "27.043686"
      },
      {
        "name": "MARACINENI",
        "zip": "127325",
        "lat": "45.177305",
        "long": "26.824212"
      },
      {
        "name": "MARGARITESTI",
        "zip": "127330",
        "lat": "45.431831",
        "long": "26.838663"
      },
      {
        "name": "MARGARITI",
        "zip": "127033",
        "lat": "45.394918",
        "long": "26.758851"
      },
      {
        "name": "MARGINEANU",
        "zip": "127378",
        "lat": "44.940073",
        "long": "26.665704"
      },
      {
        "name": "MARUNTISU",
        "zip": "127438",
        "lat": "45.286099",
        "long": "26.354208"
      },
      {
        "name": "MATESTI",
        "zip": "127541",
        "lat": "45.213393",
        "long": "26.756067"
      },
      {
        "name": "MAXENU",
        "zip": "127641",
        "lat": "45.050906",
        "long": "26.855816"
      },
      {
        "name": "MEREI",
        "zip": "127355",
        "lat": "45.129205",
        "long": "26.677884"
      },
      {
        "name": "MIEREA",
        "zip": "127679",
        "lat": "45.218",
        "long": "26.656667"
      },
      {
        "name": "MIHAILESTI",
        "zip": "127375",
        "lat": "44.915061",
        "long": "26.68154"
      },
      {
        "name": "MITROPOLIA",
        "zip": "127091",
        "lat": "44.878756",
        "long": "26.878103"
      },
      {
        "name": "MLAJET",
        "zip": "125105",
        "lat": "45.376514",
        "long": "26.333799"
      },
      {
        "name": "MODRENI",
        "zip": "127666",
        "lat": "45.496942",
        "long": "26.837162"
      },
      {
        "name": "MOISICA",
        "zip": "127599",
        "lat": "44.996903",
        "long": "26.892473"
      },
      {
        "name": "MOSESTI",
        "zip": "127516",
        "lat": "45.123647",
        "long": "27.145714"
      },
      {
        "name": "MOVILA BANULUI",
        "zip": "127380",
        "lat": "44.983821",
        "long": "26.68495"
      },
      {
        "name": "MOVILA OII",
        "zip": "127183",
        "lat": "45.030877",
        "long": "27.071212"
      },
      {
        "name": "MOVILITA",
        "zip": "127532",
        "lat": "45.099073",
        "long": "27.080424"
      },
      {
        "name": "MUCESTI-DANULESTI",
        "zip": "127113",
        "lat": "45.521605",
        "long": "26.929333"
      },
      {
        "name": "MURGESTI",
        "zip": "127385",
        "lat": "45.395202",
        "long": "26.886897"
      },
      {
        "name": "MUSCEL",
        "zip": "127439",
        "lat": "45.330768",
        "long": "26.311219"
      },
      {
        "name": "MUSCEL",
        "zip": "127706",
        "lat": "45.288636",
        "long": "26.427846"
      },
      {
        "name": "MUSCELU CARAMANESTI",
        "zip": "127198",
        "lat": "45.383923",
        "long": "26.432265"
      },
      {
        "name": "MUSCELUSA",
        "zip": "127584",
        "lat": "45.47603",
        "long": "26.272487"
      },
      {
        "name": "NAENI",
        "zip": "127390",
        "lat": "45.093212",
        "long": "26.492266"
      },
      {
        "name": "NEGOSINA",
        "zip": "127137",
        "lat": "45.377575",
        "long": "26.610948"
      },
      {
        "name": "NEHOIASU",
        "zip": "125106",
        "lat": "45.429585",
        "long": "26.300735"
      },
      {
        "name": "NEHOIU",
        "zip": "125100",
        "lat": "45.41828",
        "long": "26.303482"
      },
      {
        "name": "NEMERTEA",
        "zip": "127282",
        "lat": "45.477749",
        "long": "26.411642"
      },
      {
        "name": "NENCIU",
        "zip": "127681",
        "lat": "45.178443",
        "long": "26.667272"
      },
      {
        "name": "NENCIULESTI",
        "zip": "127363",
        "lat": "45.125879",
        "long": "26.629542"
      },
      {
        "name": "NICOLESTI",
        "zip": "127499",
        "lat": "45.398771",
        "long": "27.230405"
      },
      {
        "name": "NICULESTI",
        "zip": "127699",
        "lat": "45.438013",
        "long": "26.74252"
      },
      {
        "name": "NISCOV",
        "zip": "127682",
        "lat": "45.21746",
        "long": "26.691954"
      },
      {
        "name": "NISTORESTI",
        "zip": "127223",
        "lat": "45.31075",
        "long": "26.47417"
      },
      {
        "name": "NUCU",
        "zip": "127082",
        "lat": "45.414855",
        "long": "26.445163"
      },
      {
        "name": "ODAIA BANULUI",
        "zip": "127642",
        "lat": "45.076962",
        "long": "26.82991"
      },
      {
        "name": "ODAILE",
        "zip": "127395",
        "lat": "45.396772",
        "long": "26.535378"
      },
      {
        "name": "OGRAZILE",
        "zip": "127364",
        "lat": "45.117078",
        "long": "26.680382"
      },
      {
        "name": "OJASCA",
        "zip": "127323",
        "lat": "45.279479",
        "long": "26.64972"
      },
      {
        "name": "OLARI",
        "zip": "127134",
        "lat": "45.239871",
        "long": "26.323178"
      },
      {
        "name": "OLESESTI",
        "zip": "127454",
        "lat": "45.322664",
        "long": "26.585163"
      },
      {
        "name": "ORATIA",
        "zip": "127482",
        "lat": "45.434329",
        "long": "27.0238"
      },
      {
        "name": "OREAVU",
        "zip": "127661",
        "lat": "45.368256",
        "long": "27.023011"
      },
      {
        "name": "PACLELE",
        "zip": "127041",
        "lat": "45.329028",
        "long": "26.702743"
      },
      {
        "name": "PACURILE",
        "zip": "127138",
        "lat": "45.415688",
        "long": "26.618823"
      },
      {
        "name": "PADINA",
        "zip": "127410",
        "lat": "44.822823",
        "long": "27.111395"
      },
      {
        "name": "PADURENII",
        "zip": "127618",
        "lat": "45.184236",
        "long": "26.5433"
      },
      {
        "name": "PALICI",
        "zip": "127707",
        "lat": "45.247565",
        "long": "26.469576"
      },
      {
        "name": "PALTINENI",
        "zip": "125107",
        "lat": "45.395743",
        "long": "26.323004"
      },
      {
        "name": "PALTINIS",
        "zip": "127283",
        "lat": "45.460834",
        "long": "26.371092"
      },
      {
        "name": "PANATAU",
        "zip": "127420",
        "lat": "45.32386",
        "long": "26.392393"
      },
      {
        "name": "PARDOSI",
        "zip": "127415",
        "lat": "45.454574",
        "long": "26.882734"
      },
      {
        "name": "PARJOLESTI",
        "zip": "127456",
        "lat": "45.317188",
        "long": "26.528077"
      },
      {
        "name": "PARSCOV",
        "zip": "127450",
        "lat": "45.288818",
        "long": "26.54802"
      },
      {
        "name": "PARSCOVELU",
        "zip": "127099",
        "lat": "45.42393",
        "long": "26.492845"
      },
      {
        "name": "PATARLAGELE",
        "zip": "127430",
        "lat": "45.320599",
        "long": "26.360502"
      },
      {
        "name": "PESTRITU",
        "zip": "127299",
        "lat": "45.488301",
        "long": "26.543317"
      },
      {
        "name": "PETRACHESTI",
        "zip": "127701",
        "lat": "45.433664",
        "long": "26.735899"
      },
      {
        "name": "PETRISORU",
        "zip": "127507",
        "lat": "45.331206",
        "long": "26.89586"
      },
      {
        "name": "PIATRA ALBA",
        "zip": "127401",
        "lat": "45.380143",
        "long": "26.539361"
      },
      {
        "name": "PIETRARU",
        "zip": "127224",
        "lat": "45.30711",
        "long": "26.481786"
      },
      {
        "name": "PIETROASA MICA",
        "zip": "127474",
        "lat": "45.109766",
        "long": "26.576819"
      },
      {
        "name": "PIETROASELE",
        "zip": "127470",
        "lat": "45.094581",
        "long": "26.577409"
      },
      {
        "name": "PIETROSU",
        "zip": "127204",
        "lat": "45.05998",
        "long": "26.75663"
      },
      {
        "name": "PINU",
        "zip": "127101",
        "lat": "45.419588",
        "long": "26.494493"
      },
      {
        "name": "PITULICEA",
        "zip": "127258",
        "lat": "44.891529",
        "long": "26.661604"
      },
      {
        "name": "PLAISOR",
        "zip": "127424",
        "lat": "45.31323",
        "long": "26.389264"
      },
      {
        "name": "PLAIU NUCULUI",
        "zip": "127301",
        "lat": "45.481999",
        "long": "26.522725"
      },
      {
        "name": "PLAVATU",
        "zip": "127343",
        "lat": "45.531468",
        "long": "26.659576"
      },
      {
        "name": "PLESCIOARA",
        "zip": "127174",
        "lat": "45.375837",
        "long": "26.197464"
      },
      {
        "name": "PLESCOI",
        "zip": "127042",
        "lat": "45.274069",
        "long": "26.717769"
      },
      {
        "name": "PLESESTI",
        "zip": "127043",
        "lat": "45.283075",
        "long": "26.703648"
      },
      {
        "name": "PLESESTI",
        "zip": "127483",
        "lat": "45.511851",
        "long": "26.966121"
      },
      {
        "name": "PLESI",
        "zip": "127059",
        "lat": "45.578944",
        "long": "26.685383"
      },
      {
        "name": "PLEVNA",
        "zip": "127274",
        "lat": "45.378154",
        "long": "27.013098"
      },
      {
        "name": "PLOPEASA",
        "zip": "127566",
        "lat": "45.347777",
        "long": "26.630603"
      },
      {
        "name": "PLOPI",
        "zip": "127501",
        "lat": "45.388234",
        "long": "27.183163"
      },
      {
        "name": "PLOSTINA",
        "zip": "127302",
        "lat": "45.515615",
        "long": "26.5172"
      },
      {
        "name": "PODGORIA",
        "zip": "127480",
        "lat": "45.418064",
        "long": "27.031696"
      },
      {
        "name": "PODU MUNCII",
        "zip": "127702",
        "lat": "45.424648",
        "long": "26.7451"
      },
      {
        "name": "POENITELE",
        "zip": "127176",
        "lat": "45.373764",
        "long": "26.247169"
      },
      {
        "name": "POGOANELE",
        "zip": "125200",
        "lat": "44.914248",
        "long": "26.992096"
      },
      {
        "name": "POGONELE",
        "zip": "127643",
        "lat": "45.08645",
        "long": "26.864539"
      },
      {
        "name": "POIANA PLETARI",
        "zip": "127166",
        "lat": "45.442526",
        "long": "26.630677"
      },
      {
        "name": "POIANA VALCULUI",
        "zip": "127344",
        "lat": "45.506016",
        "long": "26.642104"
      },
      {
        "name": "POIENILE",
        "zip": "127441",
        "lat": "45.266141",
        "long": "26.355324"
      },
      {
        "name": "POLICIORI",
        "zip": "127567",
        "lat": "45.344597",
        "long": "26.666147"
      },
      {
        "name": "POSOBESTI",
        "zip": "127402",
        "lat": "45.373776",
        "long": "26.533705"
      },
      {
        "name": "POSTA",
        "zip": "127184",
        "lat": "45.0673",
        "long": "27.014122"
      },
      {
        "name": "POSTA",
        "zip": "127636",
        "lat": "45.383215",
        "long": "27.02711"
      },
      {
        "name": "POSTA CALNAU",
        "zip": "127485",
        "lat": "45.235497",
        "long": "26.864689"
      },
      {
        "name": "POTARNICHESTI",
        "zip": "127488",
        "lat": "45.217899",
        "long": "26.861566"
      },
      {
        "name": "POTECU",
        "zip": "127303",
        "lat": "45.464119",
        "long": "26.523608"
      },
      {
        "name": "POTOCENI",
        "zip": "127327",
        "lat": "45.196604",
        "long": "26.776489"
      },
      {
        "name": "PROSCA",
        "zip": "127393",
        "lat": "45.09484",
        "long": "26.482398"
      },
      {
        "name": "PRUNENI",
        "zip": "127718",
        "lat": "45.334074",
        "long": "26.844132"
      },
      {
        "name": "PUIESTII DE JOS",
        "zip": "127502",
        "lat": "45.398349",
        "long": "27.2142"
      },
      {
        "name": "PUIESTII DE SUS",
        "zip": "127503",
        "lat": "45.396226",
        "long": "27.190401"
      },
      {
        "name": "PUNGA",
        "zip": "127226",
        "lat": "45.305041",
        "long": "26.452057"
      },
      {
        "name": "RACOVITENI",
        "zip": "127505",
        "lat": "45.355369",
        "long": "26.894003"
      },
      {
        "name": "RADUCESTI",
        "zip": "127637",
        "lat": "45.425268",
        "long": "27.005296"
      },
      {
        "name": "RAMNICELU",
        "zip": "127510",
        "lat": "45.364083",
        "long": "27.106664"
      },
      {
        "name": "RAMNICU SARAT",
        "zip": "125300",
        "lat": "45.385446",
        "long": "27.041701"
      },
      {
        "name": "RAPILE",
        "zip": "127426",
        "lat": "45.265134",
        "long": "26.379774"
      },
      {
        "name": "RATESTI",
        "zip": "127044",
        "lat": "45.296414",
        "long": "26.645707"
      },
      {
        "name": "RECEA",
        "zip": "127061",
        "lat": "45.549577",
        "long": "26.691342"
      },
      {
        "name": "ROBEASCA",
        "zip": "127515",
        "lat": "45.161374",
        "long": "27.145217"
      },
      {
        "name": "ROBESTI",
        "zip": "127457",
        "lat": "45.296061",
        "long": "26.590973"
      },
      {
        "name": "ROSIORU",
        "zip": "127193",
        "lat": "45.211546",
        "long": "27.080269"
      },
      {
        "name": "RUBLA",
        "zip": "127662",
        "lat": "45.353002",
        "long": "27.075253"
      },
      {
        "name": "RUGINOASA",
        "zip": "127102",
        "lat": "45.428138",
        "long": "26.486949"
      },
      {
        "name": "RUNCU",
        "zip": "127458",
        "lat": "45.301447",
        "long": "26.570934"
      },
      {
        "name": "RUSAVAT",
        "zip": "127708",
        "lat": "45.247631",
        "long": "26.423307"
      },
      {
        "name": "RUSETU",
        "zip": "127520",
        "lat": "44.957557",
        "long": "27.218079"
      },
      {
        "name": "SAGEATA",
        "zip": "127525",
        "lat": "45.100001",
        "long": "26.985567"
      },
      {
        "name": "SAHATENI",
        "zip": "127535",
        "lat": "45.035983",
        "long": "26.521232"
      },
      {
        "name": "SALCIA",
        "zip": "127619",
        "lat": "45.191768",
        "long": "26.606505"
      },
      {
        "name": "SALCIOARA",
        "zip": "127251",
        "lat": "45.308738",
        "long": "27.176915"
      },
      {
        "name": "SAPOCA",
        "zip": "127540",
        "lat": "45.239991",
        "long": "26.749258"
      },
      {
        "name": "SARANGA",
        "zip": "127476",
        "lat": "45.095982",
        "long": "26.61105"
      },
      {
        "name": "SARATA",
        "zip": "127648",
        "lat": "45.060313",
        "long": "26.605877"
      },
      {
        "name": "SARATA-MONTEORU",
        "zip": "127366",
        "lat": "45.148558",
        "long": "26.637538"
      },
      {
        "name": "SARBESTI",
        "zip": "127703",
        "lat": "45.476994",
        "long": "26.703041"
      },
      {
        "name": "SARENI",
        "zip": "127304",
        "lat": "45.482547",
        "long": "26.616716"
      },
      {
        "name": "SARILE",
        "zip": "127062",
        "lat": "45.533037",
        "long": "26.750676"
      },
      {
        "name": "SARILE-CATUN",
        "zip": "127549",
        "lat": "45.502791",
        "long": "26.776459"
      },
      {
        "name": "SARULESTI",
        "zip": "127545",
        "lat": "45.484375",
        "long": "26.766128"
      },
      {
        "name": "SASENII NOI",
        "zip": "127683",
        "lat": "45.205671",
        "long": "26.698711"
      },
      {
        "name": "SASENII PE VALE",
        "zip": "127686",
        "lat": "45.191668",
        "long": "26.680812"
      },
      {
        "name": "SASENII VECHI",
        "zip": "127684",
        "lat": "45.21589",
        "long": "26.680683"
      },
      {
        "name": "SATU NOU",
        "zip": "127267",
        "lat": "44.819806",
        "long": "26.832226"
      },
      {
        "name": "SATU NOU",
        "zip": "127379",
        "lat": "44.920029",
        "long": "26.680815"
      },
      {
        "name": "SATU VECHI",
        "zip": "127346",
        "lat": "45.486936",
        "long": "26.657315"
      },
      {
        "name": "SATUC",
        "zip": "127046",
        "lat": "45.278656",
        "long": "26.671553"
      },
      {
        "name": "SCAENI",
        "zip": "127083",
        "lat": "45.391151",
        "long": "26.449105"
      },
      {
        "name": "SCARISOARA",
        "zip": "127189",
        "lat": "45.221451",
        "long": "26.392053"
      },
      {
        "name": "SCARLATESTI",
        "zip": "127291",
        "lat": "44.972072",
        "long": "27.18087"
      },
      {
        "name": "SCOROSESTI",
        "zip": "127403",
        "lat": "45.40383",
        "long": "26.567653"
      },
      {
        "name": "SCORTEANCA",
        "zip": "127011",
        "lat": "44.941259",
        "long": "26.58112"
      },
      {
        "name": "SCORTOASA",
        "zip": "127555",
        "lat": "45.361797",
        "long": "26.661929"
      },
      {
        "name": "SCURTESTI",
        "zip": "127654",
        "lat": "45.138288",
        "long": "26.903974"
      },
      {
        "name": "SCUTELNICI",
        "zip": "127575",
        "lat": "44.850246",
        "long": "26.922453"
      },
      {
        "name": "SECUIU",
        "zip": "127284",
        "lat": "45.612832",
        "long": "26.505368"
      },
      {
        "name": "SERGENT IONEL STEFAN",
        "zip": "127521",
        "lat": "44.923207",
        "long": "27.219586"
      },
      {
        "name": "SIBICIU DE JOS",
        "zip": "127427",
        "lat": "45.318179",
        "long": "26.377212"
      },
      {
        "name": "SIBICIU DE SUS",
        "zip": "127442",
        "lat": "45.340532",
        "long": "26.357613"
      },
      {
        "name": "SINDRILA",
        "zip": "127063",
        "lat": "45.564424",
        "long": "26.704547"
      },
      {
        "name": "SLOBOZIA",
        "zip": "127147",
        "lat": "45.272693",
        "long": "26.258452"
      },
      {
        "name": "SMARDAN",
        "zip": "127092",
        "lat": "44.876897",
        "long": "26.84079"
      },
      {
        "name": "SMEENI",
        "zip": "127595",
        "lat": "44.99576",
        "long": "26.858029"
      },
      {
        "name": "SMEESTI",
        "zip": "127704",
        "lat": "45.497491",
        "long": "26.734992"
      },
      {
        "name": "SORESTI",
        "zip": "127066",
        "lat": "45.283388",
        "long": "26.820985"
      },
      {
        "name": "SPATARU",
        "zip": "127206",
        "lat": "45.086151",
        "long": "26.777655"
      },
      {
        "name": "SPIDELE",
        "zip": "127114",
        "lat": "45.518385",
        "long": "26.84842"
      },
      {
        "name": "STALPU",
        "zip": "127605",
        "lat": "45.085186",
        "long": "26.708386"
      },
      {
        "name": "STANCESTI",
        "zip": "127656",
        "lat": "45.126649",
        "long": "26.92319"
      },
      {
        "name": "STANILA",
        "zip": "125108",
        "lat": "45.414685",
        "long": "26.345935"
      },
      {
        "name": "STAVARASTI",
        "zip": "127018",
        "lat": "45.212435",
        "long": "27.282555"
      },
      {
        "name": "STIUBEI",
        "zip": "127513",
        "lat": "45.377748",
        "long": "27.143024"
      },
      {
        "name": "STREZENI",
        "zip": "127621",
        "lat": "45.157352",
        "long": "26.494669"
      },
      {
        "name": "STROESTI",
        "zip": "127443",
        "lat": "45.308795",
        "long": "26.327074"
      },
      {
        "name": "SUCHEA",
        "zip": "127139",
        "lat": "45.408892",
        "long": "26.585139"
      },
      {
        "name": "SUDITI",
        "zip": "127246",
        "lat": "45.022976",
        "long": "26.810095"
      },
      {
        "name": "SUDITI",
        "zip": "127489",
        "lat": "45.268905",
        "long": "26.871835"
      },
      {
        "name": "TABACARI",
        "zip": "127484",
        "lat": "45.442577",
        "long": "27.001372"
      },
      {
        "name": "TABARASTI",
        "zip": "127242",
        "lat": "45.079475",
        "long": "26.919435"
      },
      {
        "name": "TARCOV",
        "zip": "127459",
        "lat": "45.326607",
        "long": "26.571718"
      },
      {
        "name": "TARLELE",
        "zip": "127194",
        "lat": "45.179268",
        "long": "27.018294"
      },
      {
        "name": "TATARLIGU",
        "zip": "127047",
        "lat": "45.315817",
        "long": "26.604517"
      },
      {
        "name": "TATULESTI",
        "zip": "127411",
        "lat": "44.908012",
        "long": "27.116788"
      },
      {
        "name": "TEGA",
        "zip": "127428",
        "lat": "45.276149",
        "long": "26.37703"
      },
      {
        "name": "TEISU",
        "zip": "127227",
        "lat": "45.315727",
        "long": "26.488722"
      },
      {
        "name": "TERCA",
        "zip": "127306",
        "lat": "45.51689",
        "long": "26.533395"
      },
      {
        "name": "TINTESTI",
        "zip": "127640",
        "lat": "45.075473",
        "long": "26.880579"
      },
      {
        "name": "TISAU",
        "zip": "127610",
        "lat": "45.171524",
        "long": "26.522031"
      },
      {
        "name": "TOCILENI",
        "zip": "127461",
        "lat": "45.302115",
        "long": "26.526943"
      },
      {
        "name": "TOPLICENI",
        "zip": "127630",
        "lat": "45.400237",
        "long": "27.013375"
      },
      {
        "name": "TOROPALESTI",
        "zip": "127116",
        "lat": "45.492509",
        "long": "26.918506"
      },
      {
        "name": "TRESTIA",
        "zip": "127228",
        "lat": "45.328801",
        "long": "26.516908"
      },
      {
        "name": "TRESTIENI",
        "zip": "127462",
        "lat": "45.338254",
        "long": "26.578468"
      },
      {
        "name": "TRESTIOARA",
        "zip": "127167",
        "lat": "45.434827",
        "long": "26.566316"
      },
      {
        "name": "TRESTIOARA",
        "zip": "127347",
        "lat": "45.503166",
        "long": "26.610939"
      },
      {
        "name": "TRONARI",
        "zip": "127709",
        "lat": "45.218593",
        "long": "26.437904"
      },
      {
        "name": "TULBUREA",
        "zip": "127229",
        "lat": "45.336182",
        "long": "26.475836"
      },
      {
        "name": "UDATI-LUCIENI",
        "zip": "127601",
        "lat": "44.971688",
        "long": "26.969689"
      },
      {
        "name": "UDATI-MANZU",
        "zip": "127602",
        "lat": "44.984674",
        "long": "26.952038"
      },
      {
        "name": "ULMENI",
        "zip": "127645",
        "lat": "45.081659",
        "long": "26.638682"
      },
      {
        "name": "ULMET",
        "zip": "127084",
        "lat": "45.368532",
        "long": "26.472387"
      },
      {
        "name": "UNGURIU",
        "zip": "127322",
        "lat": "45.278779",
        "long": "26.623688"
      },
      {
        "name": "URSOAIA",
        "zip": "127711",
        "lat": "45.247238",
        "long": "26.44881"
      },
      {
        "name": "VACAREASCA",
        "zip": "127268",
        "lat": "44.847447",
        "long": "26.729866"
      },
      {
        "name": "VADU OII",
        "zip": "127286",
        "lat": "45.534185",
        "long": "26.475436"
      },
      {
        "name": "VADU PASII",
        "zip": "127650",
        "lat": "45.159086",
        "long": "26.884618"
      },
      {
        "name": "VADU SORESTI",
        "zip": "127719",
        "lat": "45.315004",
        "long": "26.877482"
      },
      {
        "name": "VALCELE",
        "zip": "127649",
        "lat": "45.087853",
        "long": "26.635636"
      },
      {
        "name": "VALCELELE",
        "zip": "127670",
        "lat": "45.344611",
        "long": "27.348539"
      },
      {
        "name": "VALEA BANULUI",
        "zip": "127231",
        "lat": "45.337701",
        "long": "26.508866"
      },
      {
        "name": "VALEA CATINEI",
        "zip": "127148",
        "lat": "45.291948",
        "long": "26.228756"
      },
      {
        "name": "VALEA COTOAREI",
        "zip": "127348",
        "lat": "45.498117",
        "long": "26.672196"
      },
      {
        "name": "VALEA FANTANEI",
        "zip": "127404",
        "lat": "45.405511",
        "long": "26.524304"
      },
      {
        "name": "VALEA LARGA",
        "zip": "127117",
        "lat": "45.509684",
        "long": "26.883914"
      },
      {
        "name": "VALEA LARGA-SARULESTI",
        "zip": "127551",
        "lat": "45.509882",
        "long": "26.778834"
      },
      {
        "name": "VALEA LUI LALU",
        "zip": "127419",
        "lat": "45.458985",
        "long": "26.866319"
      },
      {
        "name": "VALEA LUPULUI",
        "zip": "127444",
        "lat": "45.350228",
        "long": "26.344687"
      },
      {
        "name": "VALEA NUCULUI",
        "zip": "127048",
        "lat": "45.257816",
        "long": "26.730033"
      },
      {
        "name": "VALEA PARULUI",
        "zip": "127034",
        "lat": "45.363728",
        "long": "26.775267"
      },
      {
        "name": "VALEA PURCARULUI",
        "zip": "127463",
        "lat": "45.313034",
        "long": "26.552726"
      },
      {
        "name": "VALEA PUTULUI MEREI",
        "zip": "127367",
        "lat": "45.160361",
        "long": "26.664485"
      },
      {
        "name": "VALEA RAMNICULUI",
        "zip": "127660",
        "lat": "45.362302",
        "long": "27.045642"
      },
      {
        "name": "VALEA RATEI",
        "zip": "127387",
        "lat": "45.415549",
        "long": "26.897214"
      },
      {
        "name": "VALEA ROATEI",
        "zip": "127232",
        "lat": "45.305592",
        "long": "26.473042"
      },
      {
        "name": "VALEA SALCIEI",
        "zip": "127665",
        "lat": "45.497034",
        "long": "26.826007"
      },
      {
        "name": "VALEA SALCIEI-CATUN",
        "zip": "127667",
        "lat": "45.471366",
        "long": "26.826113"
      },
      {
        "name": "VALEA SALCIILOR",
        "zip": "127622",
        "lat": "45.198113",
        "long": "26.609959"
      },
      {
        "name": "VALEA SCHIOPULUI",
        "zip": "127418",
        "lat": "45.440369",
        "long": "26.888831"
      },
      {
        "name": "VALEA SIBICIULUI",
        "zip": "127446",
        "lat": "45.363125",
        "long": "26.379695"
      },
      {
        "name": "VALEA STANEI",
        "zip": "127552",
        "lat": "45.474101",
        "long": "26.782551"
      },
      {
        "name": "VALEA STEFANULUI",
        "zip": "127406",
        "lat": "45.361595",
        "long": "26.52935"
      },
      {
        "name": "VALEA URSULUI",
        "zip": "127349",
        "lat": "45.463785",
        "long": "26.649663"
      },
      {
        "name": "VALEA VERZEI",
        "zip": "127141",
        "lat": "45.394565",
        "long": "26.63298"
      },
      {
        "name": "VALEA VIEI",
        "zip": "127447",
        "lat": "45.310103",
        "long": "26.348916"
      },
      {
        "name": "VALEANCA-VILANESTI",
        "zip": "127108",
        "lat": "45.091788",
        "long": "26.505775"
      },
      {
        "name": "VARF",
        "zip": "127394",
        "lat": "45.114993",
        "long": "26.506885"
      },
      {
        "name": "VARLAAM",
        "zip": "127287",
        "lat": "45.509254",
        "long": "26.444624"
      },
      {
        "name": "VARTEJU",
        "zip": "127307",
        "lat": "45.471371",
        "long": "26.58055"
      },
      {
        "name": "VAVALUCILE",
        "zip": "127086",
        "lat": "45.39456",
        "long": "26.463912"
      },
      {
        "name": "VERNESTI",
        "zip": "127675",
        "lat": "45.206574",
        "long": "26.728763"
      },
      {
        "name": "VIFORATA",
        "zip": "127049",
        "lat": "45.333736",
        "long": "26.617006"
      },
      {
        "name": "VINETISU",
        "zip": "125109",
        "lat": "45.467789",
        "long": "26.333861"
      },
      {
        "name": "VINTILA VODA",
        "zip": "127695",
        "lat": "45.46869",
        "long": "26.73191"
      },
      {
        "name": "VINTILEANCA",
        "zip": "127538",
        "lat": "44.983269",
        "long": "26.576972"
      },
      {
        "name": "VIPERESTI",
        "zip": "127705",
        "lat": "45.227693",
        "long": "26.463412"
      },
      {
        "name": "VISPESTI",
        "zip": "127109",
        "lat": "45.097103",
        "long": "26.521667"
      },
      {
        "name": "VIZIRENI",
        "zip": "127126",
        "lat": "45.047643",
        "long": "27.196019"
      },
      {
        "name": "VLADENI",
        "zip": "127157",
        "lat": "45.282237",
        "long": "26.760308"
      },
      {
        "name": "ZAHARESTI",
        "zip": "127429",
        "lat": "45.297936",
        "long": "26.375827"
      },
      {
        "name": "ZAPLAZI",
        "zip": "127276",
        "lat": "45.402828",
        "long": "26.97396"
      },
      {
        "name": "ZAPODIA",
        "zip": "127233",
        "lat": "45.346262",
        "long": "26.515992"
      },
      {
        "name": "ZARNESTI",
        "zip": "127715",
        "lat": "45.297794",
        "long": "26.870929"
      },
      {
        "name": "ZARNESTII DE SLANIC",
        "zip": "127158",
        "lat": "45.277082",
        "long": "26.755494"
      },
      {
        "name": "ZELETIN",
        "zip": "127149",
        "lat": "45.262353",
        "long": "26.231159"
      },
      {
        "name": "ZIDURI",
        "zip": "127720",
        "lat": "45.285419",
        "long": "27.077399"
      },
      {
        "name": "ZILISTEANCA",
        "zip": "127491",
        "lat": "45.249551",
        "long": "26.870315"
      },
      {
        "name": "ZOITA",
        "zip": "127726",
        "lat": "45.286751",
        "long": "27.022956"
      },
      {
        "name": "ZORESTI",
        "zip": "127687",
        "lat": "45.181774",
        "long": "26.702907"
      }
    ],
    "CĂLĂRAȘI": [
      {
        "name": "ALEXANDRU I. CUZA",
        "zip": "915201",
        "lat": "44.418148",
        "long": "26.518472"
      },
      {
        "name": "ALEXANDRU ODOBESCU",
        "zip": "917005",
        "lat": "44.267467",
        "long": "27.09017"
      },
      {
        "name": "APROZI",
        "zip": "915101",
        "lat": "44.265976",
        "long": "26.502034"
      },
      {
        "name": "ARTARI",
        "zip": "917131",
        "lat": "44.567175",
        "long": "26.671641"
      },
      {
        "name": "BELCIUGATELE",
        "zip": "917010",
        "lat": "44.485913",
        "long": "26.432735"
      },
      {
        "name": "BOGATA",
        "zip": "917116",
        "lat": "44.208621",
        "long": "27.118501"
      },
      {
        "name": "BOGDANA",
        "zip": "917086",
        "lat": "44.429814",
        "long": "27.137911"
      },
      {
        "name": "BORCEA",
        "zip": "917015",
        "lat": "44.329375",
        "long": "27.731492"
      },
      {
        "name": "BOSNEAGU",
        "zip": "917066",
        "lat": "44.238431",
        "long": "26.93361"
      },
      {
        "name": "BUCIUMENI",
        "zip": "915102",
        "lat": "44.253623",
        "long": "26.413282"
      },
      {
        "name": "BUDESTI",
        "zip": "915100",
        "lat": "44.233673",
        "long": "26.466029"
      },
      {
        "name": "BUZOENI",
        "zip": "915301",
        "lat": "44.414015",
        "long": "26.810778"
      },
      {
        "name": "CALARASI",
        "zip": "910001",
        "lat": "44.196165",
        "long": "27.331323"
      },
      {
        "name": "CALARASII VECHI",
        "zip": "917046",
        "lat": "44.270906",
        "long": "27.287097"
      },
      {
        "name": "CALARETI",
        "zip": "917251",
        "lat": "44.485086",
        "long": "26.604207"
      },
      {
        "name": "CANDEASCA",
        "zip": "917011",
        "lat": "44.487007",
        "long": "26.444003"
      },
      {
        "name": "CASCIOARELE",
        "zip": "917020",
        "lat": "44.125334",
        "long": "26.468079"
      },
      {
        "name": "CEACU",
        "zip": "917047",
        "lat": "44.265673",
        "long": "27.251324"
      },
      {
        "name": "CETATEA VECHE",
        "zip": "917231",
        "lat": "44.135111",
        "long": "26.762554"
      },
      {
        "name": "CHIRNOGI",
        "zip": "917266",
        "lat": "44.272483",
        "long": "26.917719"
      },
      {
        "name": "CHIRNOGI",
        "zip": "917025",
        "lat": "44.109257",
        "long": "26.579634"
      },
      {
        "name": "CHISELET",
        "zip": "917030",
        "lat": "44.170286",
        "long": "26.85519"
      },
      {
        "name": "CIOCANESTI",
        "zip": "917035",
        "lat": "44.198059",
        "long": "27.0594"
      },
      {
        "name": "CLATESTI",
        "zip": "917176",
        "lat": "44.142643",
        "long": "26.596993"
      },
      {
        "name": "COCONI",
        "zip": "917171",
        "lat": "44.24187",
        "long": "26.878839"
      },
      {
        "name": "CODRENI",
        "zip": "917121",
        "lat": "44.392219",
        "long": "26.64968"
      },
      {
        "name": "COJESTI",
        "zip": "917012",
        "lat": "44.498182",
        "long": "26.404514"
      },
      {
        "name": "CONSTANTIN BRANCOVEANU",
        "zip": "917082",
        "lat": "44.477044",
        "long": "27.412024"
      },
      {
        "name": "COSLOGENI",
        "zip": "917051",
        "lat": "44.225365",
        "long": "27.500024"
      },
      {
        "name": "COTOFANCA",
        "zip": "917122",
        "lat": "44.381364",
        "long": "26.702367"
      },
      {
        "name": "CRIVAT",
        "zip": "915103",
        "lat": "44.191282",
        "long": "26.437558"
      },
      {
        "name": "CUCUIETI",
        "zip": "917201",
        "lat": "44.331017",
        "long": "26.394016"
      },
      {
        "name": "CUNESTI",
        "zip": "917117",
        "lat": "44.226393",
        "long": "27.180667"
      },
      {
        "name": "CURATESTI",
        "zip": "917091",
        "lat": "44.275595",
        "long": "26.831568"
      },
      {
        "name": "CURCANI",
        "zip": "917040",
        "lat": "44.198506",
        "long": "26.588156"
      },
      {
        "name": "CUZA VODA",
        "zip": "917045",
        "lat": "44.265305",
        "long": "27.273441"
      },
      {
        "name": "DALGA",
        "zip": "917056",
        "lat": "44.441863",
        "long": "27.07164"
      },
      {
        "name": "DALGA-GARA",
        "zip": "917057",
        "lat": "44.435218",
        "long": "27.052247"
      },
      {
        "name": "DANESTI",
        "zip": "917092",
        "lat": "44.335734",
        "long": "26.831361"
      },
      {
        "name": "DARVARI",
        "zip": "917252",
        "lat": "44.474475",
        "long": "26.539771000000002"
      },
      {
        "name": "DICHISENI",
        "zip": "917050",
        "lat": "44.230936",
        "long": "27.536946"
      },
      {
        "name": "DOR MARUNT",
        "zip": "917055",
        "lat": "44.444297",
        "long": "26.933333"
      },
      {
        "name": "DOROBANTU",
        "zip": "917065",
        "lat": "44.219715",
        "long": "26.954515"
      },
      {
        "name": "DOROBANTU",
        "zip": "917202",
        "lat": "44.354156",
        "long": "26.393406"
      },
      {
        "name": "DRAGALINA",
        "zip": "917080",
        "lat": "44.434557",
        "long": "27.331766"
      },
      {
        "name": "DRAGOS VODA",
        "zip": "917085",
        "lat": "44.438485",
        "long": "27.164864"
      },
      {
        "name": "DRAJNA NOUA",
        "zip": "917083",
        "lat": "44.422625",
        "long": "27.380073"
      },
      {
        "name": "FANTANA DOAMNEI",
        "zip": "917191",
        "lat": "44.426256",
        "long": "26.734448"
      },
      {
        "name": "FAUREI",
        "zip": "917267",
        "lat": "44.293449",
        "long": "26.897935"
      },
      {
        "name": "FLORICA",
        "zip": "917132",
        "lat": "44.49321",
        "long": "26.636251"
      },
      {
        "name": "FLOROAICA",
        "zip": "917291",
        "lat": "44.359323",
        "long": "27.182523"
      },
      {
        "name": "FRASINET",
        "zip": "917090",
        "lat": "44.321198",
        "long": "26.815568"
      },
      {
        "name": "FRASINETU DE JOS",
        "zip": "917093",
        "lat": "44.309711",
        "long": "26.82227"
      },
      {
        "name": "FRUMUSANI",
        "zip": "917100",
        "lat": "44.297605",
        "long": "26.321109"
      },
      {
        "name": "FUNDENI",
        "zip": "917110",
        "lat": "44.382245",
        "long": "26.343595"
      },
      {
        "name": "FUNDULEA",
        "zip": "915200",
        "lat": "44.468378",
        "long": "26.509582"
      },
      {
        "name": "GALATUI",
        "zip": "917006",
        "lat": "44.262702",
        "long": "27.111497"
      },
      {
        "name": "GALBINASI",
        "zip": "917285",
        "lat": "44.318166",
        "long": "26.417102"
      },
      {
        "name": "GALDAU",
        "zip": "917146",
        "lat": "44.30544",
        "long": "27.669724"
      },
      {
        "name": "GOSTILELE",
        "zip": "915202",
        "lat": "44.503524",
        "long": "26.496311"
      },
      {
        "name": "GRADISTEA",
        "zip": "917115",
        "lat": "44.238866",
        "long": "27.212358"
      },
      {
        "name": "GRUIU",
        "zip": "915104",
        "lat": "44.232456",
        "long": "26.415443"
      },
      {
        "name": "GURBANESTI",
        "zip": "917120",
        "lat": "44.38019",
        "long": "26.694878"
      },
      {
        "name": "IEZERU",
        "zip": "917147",
        "lat": "44.28643",
        "long": "27.625092"
      },
      {
        "name": "ILEANA",
        "zip": "917130",
        "lat": "44.510072",
        "long": "26.660903"
      },
      {
        "name": "INDEPENDENTA",
        "zip": "917140",
        "lat": "44.277575",
        "long": "27.16265"
      },
      {
        "name": "INFRATIREA",
        "zip": "917058",
        "lat": "44.408474",
        "long": "26.990095"
      },
      {
        "name": "JEGALIA",
        "zip": "917145",
        "lat": "44.291448",
        "long": "27.63434"
      },
      {
        "name": "LEHLIU",
        "zip": "917150",
        "lat": "44.47542",
        "long": "26.814436"
      },
      {
        "name": "LEHLIU GARA",
        "zip": "915300",
        "lat": "44.439839",
        "long": "26.851534"
      },
      {
        "name": "LIBERTATEA",
        "zip": "917052",
        "lat": "44.268285",
        "long": "27.498806"
      },
      {
        "name": "LUICA",
        "zip": "917155",
        "lat": "44.229989",
        "long": "26.585456"
      },
      {
        "name": "LUNCA",
        "zip": "917276",
        "lat": "44.341935",
        "long": "26.773465"
      },
      {
        "name": "LUPSANU",
        "zip": "917160",
        "lat": "44.387394",
        "long": "26.911756"
      },
      {
        "name": "LUPTATORI",
        "zip": "917094",
        "lat": "44.303608",
        "long": "26.809331"
      },
      {
        "name": "MAGURENI",
        "zip": "917216",
        "lat": "44.414677",
        "long": "26.623242"
      },
      {
        "name": "MANASTIREA",
        "zip": "917170",
        "lat": "44.210658",
        "long": "26.898105"
      },
      {
        "name": "MARCULESTI-GARA",
        "zip": "917196",
        "lat": "44.425108",
        "long": "27.496369"
      },
      {
        "name": "MARIUTA",
        "zip": "917014",
        "lat": "44.534308",
        "long": "26.484894"
      },
      {
        "name": "MATARAUA",
        "zip": "917013",
        "lat": "44.551817",
        "long": "26.460588"
      },
      {
        "name": "MIHAI VITEAZU",
        "zip": "917296",
        "lat": "44.350868",
        "long": "27.069248"
      },
      {
        "name": "MITRENI",
        "zip": "917175",
        "lat": "44.169464",
        "long": "26.608933"
      },
      {
        "name": "MODELU",
        "zip": "917180",
        "lat": "44.196246",
        "long": "27.385194"
      },
      {
        "name": "NANA",
        "zip": "917185",
        "lat": "44.267058",
        "long": "26.591171"
      },
      {
        "name": "NEGOESTI",
        "zip": "917236",
        "lat": "44.230557",
        "long": "26.501318"
      },
      {
        "name": "NICOLAE BALCESCU",
        "zip": "917007",
        "lat": "44.280596",
        "long": "27.077477"
      },
      {
        "name": "NICOLAE BALCESCU",
        "zip": "917190",
        "lat": "44.449453",
        "long": "26.748828"
      },
      {
        "name": "NUCETU",
        "zip": "917161",
        "lat": "44.394864",
        "long": "26.899338"
      },
      {
        "name": "NUCI",
        "zip": "917281",
        "lat": "44.28068",
        "long": "26.411525"
      },
      {
        "name": "OGORU",
        "zip": "917059",
        "lat": "44.455447",
        "long": "26.904308"
      },
      {
        "name": "OLTENITA",
        "zip": "915400",
        "lat": "44.090456",
        "long": "26.640701"
      },
      {
        "name": "OLTINA",
        "zip": "917271",
        "lat": "44.242497",
        "long": "27.565424"
      },
      {
        "name": "ORASTI",
        "zip": "917101",
        "lat": "44.318819",
        "long": "26.283283"
      },
      {
        "name": "OSTROVU",
        "zip": "917277",
        "lat": "44.330615",
        "long": "26.787892"
      },
      {
        "name": "PADURISU",
        "zip": "917103",
        "lat": "44.316064",
        "long": "26.303962"
      },
      {
        "name": "PAICU",
        "zip": "917192",
        "lat": "44.458751",
        "long": "26.79124"
      },
      {
        "name": "PASAREA",
        "zip": "917102",
        "lat": "44.279373",
        "long": "26.33289"
      },
      {
        "name": "PELINU",
        "zip": "917061",
        "lat": "44.462884",
        "long": "27.013122"
      },
      {
        "name": "PERISORU",
        "zip": "917195",
        "lat": "44.435448",
        "long": "27.546967"
      },
      {
        "name": "PITIGAIA",
        "zip": "917104",
        "lat": "44.357233",
        "long": "26.340182"
      },
      {
        "name": "PLATARESTI",
        "zip": "917200",
        "lat": "44.354324",
        "long": "26.363764"
      },
      {
        "name": "PLEVNA",
        "zip": "917162",
        "lat": "44.36414",
        "long": "26.995437"
      },
      {
        "name": "PLUMBUITA",
        "zip": "917253",
        "lat": "44.451605",
        "long": "26.57332"
      },
      {
        "name": "PODARI",
        "zip": "917133",
        "lat": "44.488388",
        "long": "26.644375"
      },
      {
        "name": "PODU PITARULUI",
        "zip": "917203",
        "lat": "44.338998",
        "long": "26.377723"
      },
      {
        "name": "POLCESTI",
        "zip": "917217",
        "lat": "44.437882",
        "long": "26.606715"
      },
      {
        "name": "POPESTI",
        "zip": "917282",
        "lat": "44.303475",
        "long": "26.401375"
      },
      {
        "name": "POSTAVARI",
        "zip": "917106",
        "lat": "44.330261",
        "long": "26.275644"
      },
      {
        "name": "POTCOAVA",
        "zip": "917141",
        "lat": "44.263868",
        "long": "27.130033"
      },
      {
        "name": "PREASNA",
        "zip": "917123",
        "lat": "44.386769",
        "long": "26.669578"
      },
      {
        "name": "PREASNA VECHE",
        "zip": "917124",
        "lat": "44.360591",
        "long": "26.716167"
      },
      {
        "name": "PROGRESU",
        "zip": "917226",
        "lat": "44.359406",
        "long": "26.459002"
      },
      {
        "name": "RADOVANU",
        "zip": "917205",
        "lat": "44.193866",
        "long": "26.515149"
      },
      {
        "name": "RADU NEGRU",
        "zip": "917181",
        "lat": "44.286409",
        "long": "27.355876"
      },
      {
        "name": "RADU VODA",
        "zip": "917165",
        "lat": "44.386589",
        "long": "26.926394"
      },
      {
        "name": "RASA",
        "zip": "917118",
        "lat": "44.213802",
        "long": "27.144395"
      },
      {
        "name": "RASURILE",
        "zip": "917134",
        "lat": "44.54497",
        "long": "26.763202"
      },
      {
        "name": "RAZOARELE",
        "zip": "917136",
        "lat": "44.523433",
        "long": "26.676991"
      },
      {
        "name": "RAZVANI",
        "zip": "915302",
        "lat": "44.420824",
        "long": "26.878296"
      },
      {
        "name": "ROSETI",
        "zip": "917210",
        "lat": "44.210552",
        "long": "27.448134"
      },
      {
        "name": "SACELE",
        "zip": "917254",
        "lat": "44.436338",
        "long": "26.588427"
      },
      {
        "name": "SALCIOARA",
        "zip": "917041",
        "lat": "44.205029",
        "long": "26.564237"
      },
      {
        "name": "SANDULITA",
        "zip": "917218",
        "lat": "44.417897",
        "long": "26.633141"
      },
      {
        "name": "SAPUNARI",
        "zip": "917151",
        "lat": "44.500449",
        "long": "26.836767"
      },
      {
        "name": "SARULESTI",
        "zip": "917215",
        "lat": "44.413547",
        "long": "26.646241"
      },
      {
        "name": "SARULESTI-GARA",
        "zip": "917219",
        "lat": "44.444267",
        "long": "26.657866"
      },
      {
        "name": "SATNOENI",
        "zip": "917053",
        "lat": "44.233455",
        "long": "27.551595"
      },
      {
        "name": "SATU NOU",
        "zip": "917137",
        "lat": "44.519854",
        "long": "26.745513"
      },
      {
        "name": "SATUCU",
        "zip": "917221",
        "lat": "44.384266",
        "long": "26.585628"
      },
      {
        "name": "SEINOIU",
        "zip": "917256",
        "lat": "44.440813",
        "long": "26.578749"
      },
      {
        "name": "SILISTEA",
        "zip": "917278",
        "lat": "44.364988",
        "long": "26.758472"
      },
      {
        "name": "SOCOALELE",
        "zip": "917087",
        "lat": "44.478577",
        "long": "27.160384"
      },
      {
        "name": "SOHATU",
        "zip": "917225",
        "lat": "44.324289",
        "long": "26.500451"
      },
      {
        "name": "SOLACOLU",
        "zip": "917222",
        "lat": "44.379437",
        "long": "26.557598"
      },
      {
        "name": "SOLDANU",
        "zip": "917235",
        "lat": "44.221092",
        "long": "26.524363"
      },
      {
        "name": "SPANTOV",
        "zip": "917230",
        "lat": "44.12396",
        "long": "26.787563"
      },
      {
        "name": "STANCEA",
        "zip": "917232",
        "lat": "44.136735",
        "long": "26.812862"
      },
      {
        "name": "STEFAN CEL MARE",
        "zip": "917245",
        "lat": "44.426207",
        "long": "27.638039"
      },
      {
        "name": "STEFAN VODA",
        "zip": "917240",
        "lat": "44.330164",
        "long": "27.325263"
      },
      {
        "name": "STEFANESTI",
        "zip": "917138",
        "lat": "44.511778",
        "long": "26.736764"
      },
      {
        "name": "STOENESTI",
        "zip": "917182",
        "lat": "44.266945",
        "long": "27.36477"
      },
      {
        "name": "SULTANA",
        "zip": "917172",
        "lat": "44.260439",
        "long": "26.852725"
      },
      {
        "name": "TAMADAU MARE",
        "zip": "917250",
        "lat": "44.467054",
        "long": "26.569165"
      },
      {
        "name": "TAMADAU MIC",
        "zip": "917257",
        "lat": "44.456403",
        "long": "26.568888"
      },
      {
        "name": "TARICENI",
        "zip": "917096",
        "lat": "44.293497",
        "long": "26.829246"
      },
      {
        "name": "TONEA",
        "zip": "917183",
        "lat": "44.205934",
        "long": "27.410327"
      },
      {
        "name": "TUDOR VLADIMIRESCU",
        "zip": "917197",
        "lat": "44.435571",
        "long": "27.465084"
      },
      {
        "name": "ULMENI",
        "zip": "917260",
        "lat": "44.144793",
        "long": "26.722839"
      },
      {
        "name": "ULMU",
        "zip": "917265",
        "lat": "44.264866",
        "long": "26.92105"
      },
      {
        "name": "UNIREA",
        "zip": "917270",
        "lat": "44.256766",
        "long": "27.596773"
      },
      {
        "name": "VALCELELE",
        "zip": "917290",
        "lat": "44.389661",
        "long": "27.145441"
      },
      {
        "name": "VALEA ARGOVEI",
        "zip": "917275",
        "lat": "44.353965",
        "long": "26.790916"
      },
      {
        "name": "VALEA POPII",
        "zip": "917206",
        "lat": "44.163581",
        "long": "26.547422"
      },
      {
        "name": "VALEA PRESNEI",
        "zip": "917126",
        "lat": "44.348584",
        "long": "26.720636"
      },
      {
        "name": "VALEA ROSIE",
        "zip": "917177",
        "lat": "44.177523",
        "long": "26.634441"
      },
      {
        "name": "VALEA RUSULUI",
        "zip": "917163",
        "lat": "44.371735",
        "long": "27.007076"
      },
      {
        "name": "VALEA SEACA",
        "zip": "915303",
        "lat": "44.415143",
        "long": "26.890077"
      },
      {
        "name": "VALEA STANII",
        "zip": "917156",
        "lat": "44.251378",
        "long": "26.61636"
      },
      {
        "name": "VARASTI",
        "zip": "917067",
        "lat": "44.215043",
        "long": "26.968586"
      },
      {
        "name": "VASILATI",
        "zip": "917280",
        "lat": "44.288892",
        "long": "26.445923"
      },
      {
        "name": "VISINII",
        "zip": "917142",
        "lat": "44.296897",
        "long": "27.18602"
      },
      {
        "name": "VLAD TEPES",
        "zip": "917295",
        "lat": "44.340084",
        "long": "27.094787"
      },
      {
        "name": "VLADICEASCA",
        "zip": "917279",
        "lat": "44.349015",
        "long": "26.797845"
      },
      {
        "name": "VLAICULESTI",
        "zip": "917139",
        "lat": "44.585797",
        "long": "26.666753"
      },
      {
        "name": "ZIMBRU",
        "zip": "917268",
        "lat": "44.316756",
        "long": "26.935034"
      }
    ],
    "CARAȘ-SEVERIN": [
      {
        "name": "23 AUGUST",
        "zip": "327436",
        "lat": "45.523393",
        "long": "22.396515"
      },
      {
        "name": "AGADICI",
        "zip": "325601",
        "lat": "45.108992",
        "long": "21.695539"
      },
      {
        "name": "ANINA",
        "zip": "325100",
        "lat": "45.088071",
        "long": "21.853167"
      },
      {
        "name": "APADIA",
        "zip": "327046",
        "lat": "45.391084",
        "long": "22.045488"
      },
      {
        "name": "ARMENIS",
        "zip": "327005",
        "lat": "45.20936",
        "long": "22.310058"
      },
      {
        "name": "ARSURI",
        "zip": "327111",
        "lat": "45.122339",
        "long": "22.428747"
      },
      {
        "name": "BAILE HERCULANE",
        "zip": "325200",
        "lat": "44.878506",
        "long": "22.414388"
      },
      {
        "name": "BANIA",
        "zip": "327010",
        "lat": "44.876242",
        "long": "22.045131"
      },
      {
        "name": "BARBOSU",
        "zip": "327311",
        "lat": "45.464875",
        "long": "21.75379"
      },
      {
        "name": "BARZ",
        "zip": "327166",
        "lat": "44.842069",
        "long": "21.914569"
      },
      {
        "name": "BARZA",
        "zip": "327401",
        "lat": "44.810658",
        "long": "22.385603"
      },
      {
        "name": "BAUTAR",
        "zip": "327015",
        "lat": "45.515399",
        "long": "22.540272"
      },
      {
        "name": "BAZIAS",
        "zip": "327366",
        "lat": "44.815734",
        "long": "21.389684"
      },
      {
        "name": "BELOBRESCA",
        "zip": "327301",
        "lat": "44.786109",
        "long": "21.512443"
      },
      {
        "name": "BERLISTE",
        "zip": "327020",
        "lat": "44.99053",
        "long": "21.46685"
      },
      {
        "name": "BERZASCA",
        "zip": "327025",
        "lat": "44.647617",
        "long": "21.952626"
      },
      {
        "name": "BERZOVIA",
        "zip": "327030",
        "lat": "45.425972",
        "long": "21.629009"
      },
      {
        "name": "BIGAR",
        "zip": "327026",
        "lat": "44.664886",
        "long": "22.103314"
      },
      {
        "name": "BINIS",
        "zip": "327176",
        "lat": "45.336643",
        "long": "21.688725"
      },
      {
        "name": "BOCSA",
        "zip": "325300",
        "lat": "45.378176",
        "long": "21.731259"
      },
      {
        "name": "BOGALTIN",
        "zip": "327112",
        "lat": "45.039046",
        "long": "22.414917"
      },
      {
        "name": "BOGODINT",
        "zip": "327331",
        "lat": "44.898422",
        "long": "21.662344"
      },
      {
        "name": "BOINA",
        "zip": "327167",
        "lat": "44.82304",
        "long": "21.888385"
      },
      {
        "name": "BOINITA",
        "zip": "327168",
        "lat": "44.836259",
        "long": "21.890254"
      },
      {
        "name": "BOJIA",
        "zip": "327113",
        "lat": "45.1065",
        "long": "22.41473"
      },
      {
        "name": "BOLVASNITA",
        "zip": "327035",
        "lat": "45.345577",
        "long": "22.310117"
      },
      {
        "name": "BORLOVA",
        "zip": "327406",
        "lat": "45.367375",
        "long": "22.352001"
      },
      {
        "name": "BORLOVENII NOI",
        "zip": "327306",
        "lat": "44.968758",
        "long": "22.143367"
      },
      {
        "name": "BORLOVENII VECHI",
        "zip": "327307",
        "lat": "44.9554",
        "long": "22.10769"
      },
      {
        "name": "BORUGI",
        "zip": "327114",
        "lat": "45.05386",
        "long": "22.411332"
      },
      {
        "name": "BOZOVICI",
        "zip": "327040",
        "lat": "44.929844",
        "long": "22.000379"
      },
      {
        "name": "BRADISORU DE JOS",
        "zip": "325602",
        "lat": "45.08155",
        "long": "21.720251"
      },
      {
        "name": "BRATOVA",
        "zip": "327386",
        "lat": "45.326902",
        "long": "21.933278"
      },
      {
        "name": "BREBU",
        "zip": "327045",
        "lat": "45.420278",
        "long": "21.9925"
      },
      {
        "name": "BREBU NOU",
        "zip": "327050",
        "lat": "45.233333",
        "long": "22.133333"
      },
      {
        "name": "BRESTELNIC",
        "zip": "327336",
        "lat": "44.70577",
        "long": "21.883689"
      },
      {
        "name": "BREZON",
        "zip": "327211",
        "lat": "45.242238",
        "long": "21.579334"
      },
      {
        "name": "BROSTENI",
        "zip": "325603",
        "lat": "45.045865",
        "long": "21.650955"
      },
      {
        "name": "BUCHIN",
        "zip": "327055",
        "lat": "45.363159",
        "long": "22.242916"
      },
      {
        "name": "BUCOSNITA",
        "zip": "327060",
        "lat": "45.299998",
        "long": "22.266662"
      },
      {
        "name": "BUCOVA",
        "zip": "327016",
        "lat": "45.509062",
        "long": "22.637308"
      },
      {
        "name": "CALINA",
        "zip": "327181",
        "lat": "45.228067",
        "long": "21.699459"
      },
      {
        "name": "CALNIC",
        "zip": "320001",
        "lat": "45.338443",
        "long": "21.857537"
      },
      {
        "name": "CAMENA",
        "zip": "327116",
        "lat": "45.111339",
        "long": "22.474452"
      },
      {
        "name": "CAMENITA",
        "zip": "327337",
        "lat": "44.719588",
        "long": "21.823511"
      },
      {
        "name": "CAMPIA",
        "zip": "327367",
        "lat": "44.862662",
        "long": "21.411819"
      },
      {
        "name": "CANICEA",
        "zip": "327186",
        "lat": "45.069216",
        "long": "22.356375"
      },
      {
        "name": "CARANSEBES",
        "zip": "325400",
        "lat": "45.410611",
        "long": "22.218223"
      },
      {
        "name": "CARASOVA",
        "zip": "327065",
        "lat": "45.198325",
        "long": "21.86359"
      },
      {
        "name": "CARBUNARI",
        "zip": "327070",
        "lat": "44.836635",
        "long": "21.748596"
      },
      {
        "name": "CARNECEA",
        "zip": "327396",
        "lat": "45.197332",
        "long": "21.631202"
      },
      {
        "name": "CARSA ROSIE",
        "zip": "327371",
        "lat": "44.784826",
        "long": "21.814156"
      },
      {
        "name": "CARSIE",
        "zip": "327338",
        "lat": "44.730142",
        "long": "21.805348"
      },
      {
        "name": "CICLENI",
        "zip": "327407",
        "lat": "45.427355",
        "long": "22.308065"
      },
      {
        "name": "CICLOVA MONTANA",
        "zip": "325604",
        "lat": "45.025938",
        "long": "21.729726"
      },
      {
        "name": "CICLOVA ROMANA",
        "zip": "327075",
        "lat": "45.009709",
        "long": "21.705997"
      },
      {
        "name": "CIORTEA",
        "zip": "327431",
        "lat": "45.032042",
        "long": "21.446982"
      },
      {
        "name": "CIRESA",
        "zip": "325701",
        "lat": "45.525816",
        "long": "22.388376"
      },
      {
        "name": "CIRESEL",
        "zip": "327117",
        "lat": "45.077541",
        "long": "22.416553"
      },
      {
        "name": "CIUCHICI",
        "zip": "327080",
        "lat": "44.944421",
        "long": "21.615355"
      },
      {
        "name": "CIUDANOVITA",
        "zip": "327085",
        "lat": "45.156643",
        "long": "21.779076"
      },
      {
        "name": "CIUTA",
        "zip": "327286",
        "lat": "45.479889",
        "long": "22.225651"
      },
      {
        "name": "CLOCOTICI",
        "zip": "327256",
        "lat": "45.243894",
        "long": "21.831879"
      },
      {
        "name": "COMORASTE",
        "zip": "327212",
        "lat": "45.180485",
        "long": "21.56095"
      },
      {
        "name": "CONSTANTIN DAICOVICIU",
        "zip": "327090",
        "lat": "45.547652",
        "long": "22.14853"
      },
      {
        "name": "COPACELE",
        "zip": "327100",
        "lat": "45.499467",
        "long": "22.094362"
      },
      {
        "name": "CORNEA",
        "zip": "327105",
        "lat": "45.04108",
        "long": "22.325164"
      },
      {
        "name": "CORNEREVA",
        "zip": "327110",
        "lat": "45.0646",
        "long": "22.421665"
      },
      {
        "name": "CORNISORU",
        "zip": "327017",
        "lat": "45.520587",
        "long": "22.562375"
      },
      {
        "name": "CORNUTEL",
        "zip": "327296",
        "lat": "45.434891",
        "long": "22.095564"
      },
      {
        "name": "CORONINI",
        "zip": "327160",
        "lat": "44.680036",
        "long": "21.685523"
      },
      {
        "name": "COSTIS",
        "zip": "327118",
        "lat": "45.026014",
        "long": "22.395558"
      },
      {
        "name": "COZIA",
        "zip": "327119",
        "lat": "45.118316",
        "long": "22.441109"
      },
      {
        "name": "COZLA",
        "zip": "327027",
        "lat": "44.632999",
        "long": "22.000926"
      },
      {
        "name": "CRACU ALMAJ",
        "zip": "327339",
        "lat": "44.738041",
        "long": "21.848995"
      },
      {
        "name": "CRACU MARE",
        "zip": "327121",
        "lat": "45.00738",
        "long": "22.522716"
      },
      {
        "name": "CRACU TEIULUI",
        "zip": "327122",
        "lat": "45.026486",
        "long": "22.411066"
      },
      {
        "name": "CRUSOVAT",
        "zip": "327106",
        "lat": "44.996762",
        "long": "22.320609"
      },
      {
        "name": "CRUSOVITA",
        "zip": "327341",
        "lat": "44.683956",
        "long": "21.815002"
      },
      {
        "name": "CUPTOARE",
        "zip": "320002",
        "lat": "45.26119",
        "long": "21.967127"
      },
      {
        "name": "CUPTOARE",
        "zip": "327107",
        "lat": "45.009993",
        "long": "22.306717"
      },
      {
        "name": "CURMATURA",
        "zip": "327342",
        "lat": "44.720637",
        "long": "21.803803"
      },
      {
        "name": "DALBOSET",
        "zip": "327165",
        "lat": "44.863988",
        "long": "21.958543"
      },
      {
        "name": "DALCI",
        "zip": "327408",
        "lat": "45.415106",
        "long": "22.31526"
      },
      {
        "name": "DELINESTI",
        "zip": "327297",
        "lat": "45.388233",
        "long": "22.071211"
      },
      {
        "name": "DEZESTI",
        "zip": "327201",
        "lat": "45.469498",
        "long": "21.890783"
      },
      {
        "name": "DIVICI",
        "zip": "327302",
        "lat": "44.782578",
        "long": "21.480594"
      },
      {
        "name": "DOBRAIA",
        "zip": "327123",
        "lat": "45.003921",
        "long": "22.468495"
      },
      {
        "name": "DOCLIN",
        "zip": "327175",
        "lat": "45.298781",
        "long": "21.651305"
      },
      {
        "name": "DOGNECEA",
        "zip": "327180",
        "lat": "45.270412",
        "long": "21.751545"
      },
      {
        "name": "DOLINA",
        "zip": "327124",
        "lat": "45.068131",
        "long": "22.451994"
      },
      {
        "name": "DOMAN",
        "zip": "320003",
        "lat": "45.265326",
        "long": "21.916206"
      },
      {
        "name": "DOMASNEA",
        "zip": "327185",
        "lat": "45.082498",
        "long": "22.317292"
      },
      {
        "name": "DRENCOVA",
        "zip": "327028",
        "lat": "44.637817",
        "long": "21.973985"
      },
      {
        "name": "DRISTIE",
        "zip": "327372",
        "lat": "44.835052",
        "long": "21.856672"
      },
      {
        "name": "DULEU",
        "zip": "327202",
        "lat": "45.511818",
        "long": "21.777146"
      },
      {
        "name": "EFTIMIE MURGU",
        "zip": "327190",
        "lat": "44.877442",
        "long": "22.095222"
      },
      {
        "name": "ERSIG",
        "zip": "327426",
        "lat": "45.499931",
        "long": "21.624478"
      },
      {
        "name": "EZERIS",
        "zip": "327195",
        "lat": "45.410833",
        "long": "21.885833"
      },
      {
        "name": "FARLIUG",
        "zip": "327200",
        "lat": "45.488333",
        "long": "21.849444"
      },
      {
        "name": "FENES",
        "zip": "327006",
        "lat": "45.190657",
        "long": "22.34678"
      },
      {
        "name": "FIZES",
        "zip": "327031",
        "lat": "45.363522",
        "long": "21.592614"
      },
      {
        "name": "FOROTIC",
        "zip": "327210",
        "lat": "45.232063",
        "long": "21.581291"
      },
      {
        "name": "FRASINIS",
        "zip": "327343",
        "lat": "44.727376",
        "long": "21.773333"
      },
      {
        "name": "GARANA",
        "zip": "327051",
        "lat": "45.227758",
        "long": "22.097357"
      },
      {
        "name": "GARBOVAT",
        "zip": "327011",
        "lat": "44.86776",
        "long": "22.009805"
      },
      {
        "name": "GARLISTE",
        "zip": "327226",
        "lat": "45.17753",
        "long": "21.813431"
      },
      {
        "name": "GARNIC",
        "zip": "327215",
        "lat": "44.752229",
        "long": "21.792142"
      },
      {
        "name": "GHERTENIS",
        "zip": "327032",
        "lat": "45.430075",
        "long": "21.58205"
      },
      {
        "name": "GIURGIOVA",
        "zip": "327227",
        "lat": "45.185108",
        "long": "21.720231"
      },
      {
        "name": "GLIMBOCA",
        "zip": "327220",
        "lat": "45.492295",
        "long": "22.322805"
      },
      {
        "name": "GLOBU CRAIOVEI",
        "zip": "327236",
        "lat": "44.995198",
        "long": "22.270974"
      },
      {
        "name": "GLOBURAU",
        "zip": "327271",
        "lat": "45.005469",
        "long": "22.369105"
      },
      {
        "name": "GOLET",
        "zip": "327061",
        "lat": "45.283388",
        "long": "22.256661"
      },
      {
        "name": "GORNEA",
        "zip": "327344",
        "lat": "44.682078",
        "long": "21.854431"
      },
      {
        "name": "GORUIA",
        "zip": "327225",
        "lat": "45.186182",
        "long": "21.778086"
      },
      {
        "name": "GRADINARI",
        "zip": "327230",
        "lat": "45.121079",
        "long": "21.593379"
      },
      {
        "name": "GREONI",
        "zip": "327231",
        "lat": "45.088704",
        "long": "21.615496"
      },
      {
        "name": "GRUNI",
        "zip": "327126",
        "lat": "45.109205",
        "long": "22.423018"
      },
      {
        "name": "HORA MARE",
        "zip": "327127",
        "lat": "45.114706",
        "long": "22.421875"
      },
      {
        "name": "HORA MICA",
        "zip": "327128",
        "lat": "45.110351",
        "long": "22.410574"
      },
      {
        "name": "IABALCEA",
        "zip": "327066",
        "lat": "45.218425",
        "long": "21.916365"
      },
      {
        "name": "IABLANITA",
        "zip": "327235",
        "lat": "44.951174",
        "long": "22.31375"
      },
      {
        "name": "IAM",
        "zip": "327021",
        "lat": "45.010094",
        "long": "21.401245"
      },
      {
        "name": "IAZ",
        "zip": "327287",
        "lat": "45.465087",
        "long": "22.233839"
      },
      {
        "name": "IERTOF",
        "zip": "327432",
        "lat": "45.01152",
        "long": "21.512658"
      },
      {
        "name": "ILIDIA",
        "zip": "327076",
        "lat": "44.969822",
        "long": "21.703957"
      },
      {
        "name": "ILOVA",
        "zip": "327361",
        "lat": "45.277711",
        "long": "22.341512"
      },
      {
        "name": "INELET",
        "zip": "327129",
        "lat": "45.016278",
        "long": "22.538975"
      },
      {
        "name": "IZGAR",
        "zip": "327427",
        "lat": "45.543721",
        "long": "21.605906"
      },
      {
        "name": "IZVOR",
        "zip": "327131",
        "lat": "45.0712",
        "long": "22.405168"
      },
      {
        "name": "JITIN",
        "zip": "327086",
        "lat": "45.148763",
        "long": "21.728469"
      },
      {
        "name": "JUPA",
        "zip": "325401",
        "lat": "45.457568",
        "long": "22.186896"
      },
      {
        "name": "LAPUSNICEL",
        "zip": "327240",
        "lat": "44.98378",
        "long": "22.228252"
      },
      {
        "name": "LAPUSNICU MARE",
        "zip": "327245",
        "lat": "44.899923",
        "long": "21.943328"
      },
      {
        "name": "LESCOVITA",
        "zip": "327281",
        "lat": "44.870602",
        "long": "21.54553"
      },
      {
        "name": "LIBORAJDEA",
        "zip": "327346",
        "lat": "44.677475",
        "long": "21.772673"
      },
      {
        "name": "LINDENFELD",
        "zip": "327056",
        "lat": "45.314057",
        "long": "22.111538"
      },
      {
        "name": "LIUBCOVA",
        "zip": "327029",
        "lat": "44.659359",
        "long": "21.893847"
      },
      {
        "name": "LUCACEVAT",
        "zip": "327347",
        "lat": "44.690237",
        "long": "21.790779"
      },
      {
        "name": "LUNCA FLORII",
        "zip": "327132",
        "lat": "45.080158",
        "long": "22.452162"
      },
      {
        "name": "LUNCA ZAICII",
        "zip": "327133",
        "lat": "45.086229",
        "long": "22.458947"
      },
      {
        "name": "LUNCAVITA",
        "zip": "327250",
        "lat": "45.092862",
        "long": "22.267861"
      },
      {
        "name": "LUPAC",
        "zip": "327255",
        "lat": "45.281611",
        "long": "21.810569"
      },
      {
        "name": "MACESTI",
        "zip": "325501",
        "lat": "44.754319",
        "long": "21.608274"
      },
      {
        "name": "MACIOVA",
        "zip": "327092",
        "lat": "45.521551",
        "long": "22.204462"
      },
      {
        "name": "MACOVISTE",
        "zip": "327081",
        "lat": "44.939196",
        "long": "21.655801"
      },
      {
        "name": "MACOVISTE",
        "zip": "327108",
        "lat": "45.028874",
        "long": "22.327534"
      },
      {
        "name": "MAGURA",
        "zip": "327437",
        "lat": "45.499549",
        "long": "22.41443"
      },
      {
        "name": "MAL",
        "zip": "325702",
        "lat": "45.504663",
        "long": "22.393366"
      },
      {
        "name": "MARGA",
        "zip": "327260",
        "lat": "45.503059",
        "long": "22.520677"
      },
      {
        "name": "MARILA",
        "zip": "325605",
        "lat": "45.062087",
        "long": "21.777468"
      },
      {
        "name": "MARTINOVAT",
        "zip": "327348",
        "lat": "44.703125",
        "long": "21.776399"
      },
      {
        "name": "MARU",
        "zip": "327438",
        "lat": "45.475858",
        "long": "22.450386"
      },
      {
        "name": "MATNICU MARE",
        "zip": "327093",
        "lat": "45.509616",
        "long": "22.121933"
      },
      {
        "name": "MAURENI",
        "zip": "327265",
        "lat": "45.40752",
        "long": "21.501848"
      },
      {
        "name": "MEHADIA",
        "zip": "327270",
        "lat": "44.904794",
        "long": "22.365338"
      },
      {
        "name": "MEHADICA",
        "zip": "327275",
        "lat": "45.038944",
        "long": "22.264762"
      },
      {
        "name": "MERCINA",
        "zip": "327421",
        "lat": "45.06378",
        "long": "21.536802"
      },
      {
        "name": "MESTEACAN",
        "zip": "327134",
        "lat": "45.043274",
        "long": "22.397698"
      },
      {
        "name": "MILCOVENI",
        "zip": "327022",
        "lat": "45.000757",
        "long": "21.44771"
      },
      {
        "name": "MOCERIS",
        "zip": "327246",
        "lat": "44.870465",
        "long": "21.92309"
      },
      {
        "name": "MOLDOVA NOUA",
        "zip": "325500",
        "lat": "44.735109",
        "long": "21.665773"
      },
      {
        "name": "MOLDOVA VECHE",
        "zip": "325550",
        "lat": "44.721353",
        "long": "21.619835"
      },
      {
        "name": "MOLDOVITA",
        "zip": "325502",
        "lat": "44.78439",
        "long": "21.711776"
      },
      {
        "name": "MONIOM",
        "zip": "320004",
        "lat": "45.349479",
        "long": "21.832845"
      },
      {
        "name": "NAIDAS",
        "zip": "327280",
        "lat": "44.881661",
        "long": "21.589927"
      },
      {
        "name": "NEGIUDIN",
        "zip": "327136",
        "lat": "45.059093",
        "long": "22.398545"
      },
      {
        "name": "NERMED",
        "zip": "327067",
        "lat": "45.229369",
        "long": "21.863709"
      },
      {
        "name": "NICOLINT",
        "zip": "327082",
        "lat": "44.955889",
        "long": "21.555256"
      },
      {
        "name": "OBITA",
        "zip": "327137",
        "lat": "45.138466",
        "long": "22.427762"
      },
      {
        "name": "OBREJA",
        "zip": "327285",
        "lat": "45.480714",
        "long": "22.25568"
      },
      {
        "name": "OCNA DE FIER",
        "zip": "327290",
        "lat": "45.341665",
        "long": "21.776294"
      },
      {
        "name": "OGASU PODULUI",
        "zip": "327349",
        "lat": "44.696204",
        "long": "21.870195"
      },
      {
        "name": "OHABA-MATNIC",
        "zip": "327101",
        "lat": "45.470462",
        "long": "22.077947"
      },
      {
        "name": "OHABITA",
        "zip": "327298",
        "lat": "45.387311",
        "long": "22.097657"
      },
      {
        "name": "ORAVITA",
        "zip": "325600",
        "lat": "45.038133",
        "long": "21.686059"
      },
      {
        "name": "OTELU ROSU",
        "zip": "325700",
        "lat": "45.519829",
        "long": "22.357742"
      },
      {
        "name": "PADINA MATEI",
        "zip": "327216",
        "lat": "44.759761",
        "long": "21.747805"
      },
      {
        "name": "PALTINIS",
        "zip": "327295",
        "lat": "45.434226",
        "long": "22.160598"
      },
      {
        "name": "PARNEAURA",
        "zip": "327368",
        "lat": "44.863393",
        "long": "21.44149"
      },
      {
        "name": "PARVOVA",
        "zip": "327241",
        "lat": "45.01527",
        "long": "22.205904"
      },
      {
        "name": "PATAS",
        "zip": "327308",
        "lat": "44.951292",
        "long": "22.099886"
      },
      {
        "name": "PECINISCA",
        "zip": "325201",
        "lat": "44.858707",
        "long": "22.402788"
      },
      {
        "name": "PESTERE",
        "zip": "327094",
        "lat": "45.52905",
        "long": "22.186209"
      },
      {
        "name": "PETNIC",
        "zip": "327237",
        "lat": "44.977667",
        "long": "22.289096"
      },
      {
        "name": "PETRILOVA",
        "zip": "327083",
        "lat": "44.918557",
        "long": "21.629579"
      },
      {
        "name": "PETROSNITA",
        "zip": "327062",
        "lat": "45.323374",
        "long": "22.258947"
      },
      {
        "name": "PLOPU",
        "zip": "327007",
        "lat": "45.236326",
        "long": "22.419023"
      },
      {
        "name": "PLUGOVA",
        "zip": "327272",
        "lat": "44.96309",
        "long": "22.356202"
      },
      {
        "name": "POGARA",
        "zip": "327138",
        "lat": "45.044097",
        "long": "22.40803"
      },
      {
        "name": "POGARA DE SUS",
        "zip": "327139",
        "lat": "45.096266",
        "long": "22.413945"
      },
      {
        "name": "POIANA",
        "zip": "327057",
        "lat": "45.353326",
        "long": "22.176027"
      },
      {
        "name": "POIANA LUNGA",
        "zip": "327141",
        "lat": "45.002148",
        "long": "22.456808"
      },
      {
        "name": "POIANA MARULUI",
        "zip": "327439",
        "lat": "45.403278",
        "long": "22.540706"
      },
      {
        "name": "POIENILE BOINEI",
        "zip": "327373",
        "lat": "44.786588",
        "long": "21.876766"
      },
      {
        "name": "POJEJENA",
        "zip": "327300",
        "lat": "44.773316",
        "long": "21.577203"
      },
      {
        "name": "PONEASCA",
        "zip": "327041",
        "lat": "45.015998",
        "long": "21.956915"
      },
      {
        "name": "POTOC",
        "zip": "327332",
        "lat": "44.927556",
        "long": "21.722579"
      },
      {
        "name": "PREVECIORI",
        "zip": "327018",
        "lat": "45.576222",
        "long": "22.563116"
      },
      {
        "name": "PRIGOR",
        "zip": "327305",
        "lat": "44.927245",
        "long": "22.113522"
      },
      {
        "name": "PRILIPET",
        "zip": "327042",
        "lat": "44.930473",
        "long": "22.063336"
      },
      {
        "name": "PRISACA",
        "zip": "327096",
        "lat": "45.499026",
        "long": "22.154217"
      },
      {
        "name": "PRISACINA",
        "zip": "327142",
        "lat": "45.015875",
        "long": "22.485033"
      },
      {
        "name": "PRISIAN",
        "zip": "327058",
        "lat": "45.358988",
        "long": "22.241507"
      },
      {
        "name": "PRISLOP",
        "zip": "327143",
        "lat": "45.108677",
        "long": "22.447212"
      },
      {
        "name": "PRISLOP",
        "zip": "327169",
        "lat": "44.833558",
        "long": "21.924328"
      },
      {
        "name": "PUTNA",
        "zip": "327309",
        "lat": "44.934776",
        "long": "22.173379"
      },
      {
        "name": "RACASDIA",
        "zip": "327315",
        "lat": "44.993993",
        "long": "21.625772"
      },
      {
        "name": "RACHITA",
        "zip": "327376",
        "lat": "44.780205",
        "long": "21.84605"
      },
      {
        "name": "RACHITOVA",
        "zip": "325606",
        "lat": "45.062039",
        "long": "21.680721"
      },
      {
        "name": "RADIMNA",
        "zip": "327303",
        "lat": "44.795021",
        "long": "21.563799"
      },
      {
        "name": "RAFNIC",
        "zip": "327257",
        "lat": "45.232309",
        "long": "21.78758"
      },
      {
        "name": "RAMNA",
        "zip": "327310",
        "lat": "45.438333",
        "long": "21.688333"
      },
      {
        "name": "RAVENSCA",
        "zip": "327374",
        "lat": "44.774274",
        "long": "21.914219"
      },
      {
        "name": "REMETEA-POGANICI",
        "zip": "327203",
        "lat": "45.509944",
        "long": "21.87529"
      },
      {
        "name": "RESITA",
        "zip": "320011",
        "lat": "45.289011",
        "long": "21.887767"
      },
      {
        "name": "RESITA MICA",
        "zip": "327171",
        "lat": "44.852543",
        "long": "21.942116"
      },
      {
        "name": "RUGI",
        "zip": "327299",
        "lat": "45.385077",
        "long": "22.131374"
      },
      {
        "name": "RUGINOSU",
        "zip": "327102",
        "lat": "45.460423",
        "long": "22.112313"
      },
      {
        "name": "RUSCA",
        "zip": "327391",
        "lat": "45.146186",
        "long": "22.335836"
      },
      {
        "name": "RUSCA MONTANA",
        "zip": "327320",
        "lat": "45.56741",
        "long": "22.458161"
      },
      {
        "name": "RUSCHITA",
        "zip": "327321",
        "lat": "45.63389",
        "long": "22.412805"
      },
      {
        "name": "RUSOVA NOUA",
        "zip": "327023",
        "lat": "44.970726",
        "long": "21.51931"
      },
      {
        "name": "RUSOVA VECHE",
        "zip": "327024",
        "lat": "44.977781",
        "long": "21.506486"
      },
      {
        "name": "RUSTIN",
        "zip": "327144",
        "lat": "45.102471",
        "long": "22.411761"
      },
      {
        "name": "SACU",
        "zip": "327325",
        "lat": "45.574319",
        "long": "22.119158"
      },
      {
        "name": "SADOVA NOUA",
        "zip": "327362",
        "lat": "45.256866",
        "long": "22.345538"
      },
      {
        "name": "SADOVA VECHE",
        "zip": "327363",
        "lat": "45.249062",
        "long": "22.298024"
      },
      {
        "name": "SALBAGELU NOU",
        "zip": "327326",
        "lat": "45.567054",
        "long": "22.06317"
      },
      {
        "name": "SASCA MONTANA",
        "zip": "327330",
        "lat": "44.885828",
        "long": "21.709423"
      },
      {
        "name": "SASCA ROMANA",
        "zip": "327333",
        "lat": "44.892347",
        "long": "21.724575"
      },
      {
        "name": "SAT BATRAN",
        "zip": "327008",
        "lat": "45.234648",
        "long": "22.330526"
      },
      {
        "name": "SCAIUS",
        "zip": "327204",
        "lat": "45.51767",
        "long": "21.919442"
      },
      {
        "name": "SCARISOARA",
        "zip": "327146",
        "lat": "45.030633",
        "long": "22.545062"
      },
      {
        "name": "SECASENI",
        "zip": "327397",
        "lat": "45.178789",
        "long": "21.696128"
      },
      {
        "name": "SECU",
        "zip": "320005",
        "lat": "45.26976",
        "long": "21.978649"
      },
      {
        "name": "SFANTA ELENA",
        "zip": "327161",
        "lat": "44.678271",
        "long": "21.712051"
      },
      {
        "name": "SICHEVITA",
        "zip": "327335",
        "lat": "44.693914",
        "long": "21.843354"
      },
      {
        "name": "SLATINA-NERA",
        "zip": "327334",
        "lat": "44.915937",
        "long": "21.689692"
      },
      {
        "name": "SLATINA-TIMIS",
        "zip": "327360",
        "lat": "45.260482",
        "long": "22.284244"
      },
      {
        "name": "SOCENI",
        "zip": "327196",
        "lat": "45.376445",
        "long": "21.941621"
      },
      {
        "name": "SOCOL",
        "zip": "327365",
        "lat": "44.860898",
        "long": "21.370522"
      },
      {
        "name": "SOCOLARI",
        "zip": "327077",
        "lat": "44.943784",
        "long": "21.72829"
      },
      {
        "name": "SOPOTU NOU",
        "zip": "327370",
        "lat": "44.817877",
        "long": "21.861204"
      },
      {
        "name": "SOPOTU VECHI",
        "zip": "327172",
        "lat": "44.858232",
        "long": "21.995443"
      },
      {
        "name": "SOSDEA",
        "zip": "327266",
        "lat": "45.454568",
        "long": "21.519087"
      },
      {
        "name": "STANCILOVA",
        "zip": "327377",
        "lat": "44.817339",
        "long": "21.817384"
      },
      {
        "name": "STEIERDORF",
        "zip": "325150",
        "lat": "45.063586",
        "long": "21.852165"
      },
      {
        "name": "STINAPARI",
        "zip": "327071",
        "lat": "44.846195",
        "long": "21.735483"
      },
      {
        "name": "STRENEAC",
        "zip": "327351",
        "lat": "44.699934",
        "long": "21.751735"
      },
      {
        "name": "STRUGASCA",
        "zip": "327147",
        "lat": "45.094817",
        "long": "22.447493"
      },
      {
        "name": "STUDENA",
        "zip": "327148",
        "lat": "45.064558",
        "long": "22.461411"
      },
      {
        "name": "SUB CRANG",
        "zip": "327149",
        "lat": "45.100807",
        "long": "22.468027"
      },
      {
        "name": "SUB MARGINE",
        "zip": "327009",
        "lat": "45.221626",
        "long": "22.348769"
      },
      {
        "name": "SUB PLAI",
        "zip": "327151",
        "lat": "45.069169",
        "long": "22.462918"
      },
      {
        "name": "SUMITA",
        "zip": "327242",
        "lat": "44.960297",
        "long": "22.18665"
      },
      {
        "name": "SURDUCU MARE",
        "zip": "327213",
        "lat": "45.265481",
        "long": "21.586865"
      },
      {
        "name": "SUSCA",
        "zip": "327304",
        "lat": "44.784475",
        "long": "21.531333"
      },
      {
        "name": "TARNOVA",
        "zip": "327385",
        "lat": "45.340214",
        "long": "22.000971"
      },
      {
        "name": "TATU",
        "zip": "327153",
        "lat": "45.043356",
        "long": "22.575352"
      },
      {
        "name": "TEREGOVA",
        "zip": "327390",
        "lat": "45.14806",
        "long": "22.28194"
      },
      {
        "name": "TEROVA",
        "zip": "320006",
        "lat": "45.308122",
        "long": "21.92258"
      },
      {
        "name": "TICVANIU MARE",
        "zip": "327395",
        "lat": "45.140454",
        "long": "21.641074"
      },
      {
        "name": "TICVANIU MIC",
        "zip": "327398",
        "lat": "45.115826",
        "long": "21.651636"
      },
      {
        "name": "TINCOVA",
        "zip": "327327",
        "lat": "45.571357",
        "long": "22.149027"
      },
      {
        "name": "TIROL",
        "zip": "327177",
        "lat": "45.332924",
        "long": "21.595414"
      },
      {
        "name": "TOPLA",
        "zip": "327152",
        "lat": "45.058632",
        "long": "22.461107"
      },
      {
        "name": "TOPLET",
        "zip": "327400",
        "lat": "44.79821",
        "long": "22.395908"
      },
      {
        "name": "TURNU RUIENI",
        "zip": "327405",
        "lat": "45.390702",
        "long": "22.335574"
      },
      {
        "name": "URCU",
        "zip": "327378",
        "lat": "44.8066",
        "long": "21.835555"
      },
      {
        "name": "VALEA BISTREI",
        "zip": "327441",
        "lat": "45.525589",
        "long": "22.427383"
      },
      {
        "name": "VALEA BOLVASNITA",
        "zip": "327273",
        "lat": "44.945685",
        "long": "22.387897"
      },
      {
        "name": "VALEA MARE",
        "zip": "327206",
        "lat": "45.50467",
        "long": "21.802262"
      },
      {
        "name": "VALEA MINISULUI",
        "zip": "327043",
        "lat": "45.01839",
        "long": "21.904561"
      },
      {
        "name": "VALEA OREVITA",
        "zip": "327352",
        "lat": "44.693634",
        "long": "21.91704"
      },
      {
        "name": "VALEA RACHITEI",
        "zip": "327379",
        "lat": "44.759729",
        "long": "21.873058"
      },
      {
        "name": "VALEA RAVENSCA",
        "zip": "327353",
        "lat": "44.721931",
        "long": "21.853718"
      },
      {
        "name": "VALEA ROSIE",
        "zip": "327381",
        "lat": "44.797817",
        "long": "21.82695"
      },
      {
        "name": "VALEA SICHEVITEI",
        "zip": "327354",
        "lat": "44.708496",
        "long": "21.863774"
      },
      {
        "name": "VALEA TIMISULUI",
        "zip": "327059",
        "lat": "45.348915",
        "long": "22.265925"
      },
      {
        "name": "VALEADENI",
        "zip": "327047",
        "lat": "45.40016",
        "long": "22.013369"
      },
      {
        "name": "VALEAPAI",
        "zip": "327312",
        "lat": "45.491009",
        "long": "21.722207"
      },
      {
        "name": "VALISOARA",
        "zip": "327063",
        "lat": "45.317704",
        "long": "22.288063"
      },
      {
        "name": "VALIUG",
        "zip": "327415",
        "lat": "45.226538",
        "long": "22.029112"
      },
      {
        "name": "VAMA MARGA",
        "zip": "327261",
        "lat": "45.52352",
        "long": "22.51223"
      },
      {
        "name": "VAR",
        "zip": "327288",
        "lat": "45.448372",
        "long": "22.305131"
      },
      {
        "name": "VARADIA",
        "zip": "327420",
        "lat": "45.081703",
        "long": "21.542329"
      },
      {
        "name": "VARCIOROVA",
        "zip": "327036",
        "lat": "45.326395",
        "long": "22.350839"
      },
      {
        "name": "VERENDIN",
        "zip": "327251",
        "lat": "45.077546",
        "long": "22.23917"
      },
      {
        "name": "VERMES",
        "zip": "327425",
        "lat": "45.520556",
        "long": "21.659722"
      },
      {
        "name": "VODNIC",
        "zip": "327258",
        "lat": "45.246636",
        "long": "21.797637"
      },
      {
        "name": "VOISLOVA",
        "zip": "327442",
        "lat": "45.527521",
        "long": "22.459671"
      },
      {
        "name": "VRANI",
        "zip": "327430",
        "lat": "45.040427",
        "long": "21.490316"
      },
      {
        "name": "VRANIUT",
        "zip": "327316",
        "lat": "45.00137",
        "long": "21.550625"
      },
      {
        "name": "ZAGUJENI",
        "zip": "327097",
        "lat": "45.482122",
        "long": "22.160802"
      },
      {
        "name": "ZANOGI",
        "zip": "327154",
        "lat": "45.090313",
        "long": "22.466592"
      },
      {
        "name": "ZANOU",
        "zip": "327356",
        "lat": "44.734562",
        "long": "21.835785"
      },
      {
        "name": "ZASLOANE",
        "zip": "327357",
        "lat": "44.708035",
        "long": "21.834377"
      },
      {
        "name": "ZAVOI",
        "zip": "327435",
        "lat": "45.524867",
        "long": "22.412046"
      },
      {
        "name": "ZBEGU",
        "zip": "327156",
        "lat": "45.092582",
        "long": "22.412352"
      },
      {
        "name": "ZERVESTI",
        "zip": "327409",
        "lat": "45.406785",
        "long": "22.292384"
      },
      {
        "name": "ZLAGNA",
        "zip": "327411",
        "lat": "45.378021",
        "long": "22.296774"
      },
      {
        "name": "ZLATITA",
        "zip": "327445",
        "lat": "44.864946",
        "long": "21.469172"
      },
      {
        "name": "ZMOGOTIN",
        "zip": "327157",
        "lat": "45.098069",
        "long": "22.469284"
      },
      {
        "name": "ZOINA",
        "zip": "327158",
        "lat": "45.055098",
        "long": "22.456566"
      },
      {
        "name": "ZORILE",
        "zip": "327103",
        "lat": "45.493538",
        "long": "22.063171"
      },
      {
        "name": "ZORLENCIOR",
        "zip": "327451",
        "lat": "45.475797",
        "long": "22.005785"
      },
      {
        "name": "ZORLENTU MARE",
        "zip": "327450",
        "lat": "45.451237",
        "long": "21.95016"
      }
    ],
    "CLUJ": [
      {
        "name": "AGARBICIU",
        "zip": "407146",
        "lat": "46.771694",
        "long": "23.282688"
      },
      {
        "name": "AGHIRESU",
        "zip": "407005",
        "lat": "46.872093",
        "long": "23.237731"
      },
      {
        "name": "AGHIRESU-FABRICI",
        "zip": "407010",
        "lat": "46.866878",
        "long": "23.270057"
      },
      {
        "name": "AGRIS",
        "zip": "407316",
        "lat": "46.593507",
        "long": "23.51908"
      },
      {
        "name": "AITON",
        "zip": "407025",
        "lat": "46.684227",
        "long": "23.743231"
      },
      {
        "name": "ALUNIS",
        "zip": "407030",
        "lat": "47.041418",
        "long": "23.746393"
      },
      {
        "name": "ALUNISU",
        "zip": "407516",
        "lat": "46.831611",
        "long": "22.941822"
      },
      {
        "name": "ANDICI",
        "zip": "407186",
        "lat": "46.647841",
        "long": "23.918289"
      },
      {
        "name": "ANTAS",
        "zip": "407086",
        "lat": "47.112221",
        "long": "23.581185"
      },
      {
        "name": "APAHIDA",
        "zip": "407035",
        "lat": "46.802173",
        "long": "23.754639"
      },
      {
        "name": "ARDEOVA",
        "zip": "407371",
        "lat": "46.795331",
        "long": "23.105024"
      },
      {
        "name": "ARGHISU",
        "zip": "407006",
        "lat": "46.937066",
        "long": "23.24017"
      },
      {
        "name": "ARUNCUTA",
        "zip": "407546",
        "lat": "46.733276",
        "long": "23.968015"
      },
      {
        "name": "ASCHILEU MARE",
        "zip": "407046",
        "lat": "46.982843",
        "long": "23.492631"
      },
      {
        "name": "ASCHILEU MIC",
        "zip": "407047",
        "lat": "46.984678",
        "long": "23.437"
      },
      {
        "name": "BABDIU",
        "zip": "407087",
        "lat": "47.126494",
        "long": "23.695925"
      },
      {
        "name": "BABUTIU",
        "zip": "407596",
        "lat": "46.939667",
        "long": "23.53066"
      },
      {
        "name": "BACIU",
        "zip": "407055",
        "lat": "46.789735",
        "long": "23.527688"
      },
      {
        "name": "BADENI",
        "zip": "407431",
        "lat": "46.49194",
        "long": "23.735442"
      },
      {
        "name": "BADESTI",
        "zip": "407597",
        "lat": "46.96984",
        "long": "23.636315"
      },
      {
        "name": "BAGACIU",
        "zip": "407451",
        "lat": "46.885572",
        "long": "23.946152"
      },
      {
        "name": "BAGARA",
        "zip": "407007",
        "lat": "46.864144",
        "long": "23.304083"
      },
      {
        "name": "BAISOARA",
        "zip": "407065",
        "lat": "46.577554",
        "long": "23.461516"
      },
      {
        "name": "BAITA",
        "zip": "405301",
        "lat": "47.030499",
        "long": "23.865916"
      },
      {
        "name": "BALCESTI",
        "zip": "407076",
        "lat": "46.674563",
        "long": "23.002232"
      },
      {
        "name": "BALCESTI",
        "zip": "407147",
        "lat": "46.771872",
        "long": "23.193741"
      },
      {
        "name": "BARAI",
        "zip": "407121",
        "lat": "46.844205",
        "long": "23.907669"
      },
      {
        "name": "BARLEA",
        "zip": "407251",
        "lat": "46.991448",
        "long": "23.721637"
      },
      {
        "name": "BATIN",
        "zip": "407571",
        "lat": "47.072765",
        "long": "24.061398"
      },
      {
        "name": "BEDECIU",
        "zip": "407372",
        "lat": "46.794178",
        "long": "23.130446"
      },
      {
        "name": "BELIS",
        "zip": "407075",
        "lat": "46.68157",
        "long": "23.031328"
      },
      {
        "name": "BERCHIESU",
        "zip": "407286",
        "lat": "46.728421",
        "long": "24.038086"
      },
      {
        "name": "BERINDU",
        "zip": "407531",
        "lat": "46.934276",
        "long": "23.437277"
      },
      {
        "name": "BICA",
        "zip": "407373",
        "lat": "46.794435",
        "long": "23.083179"
      },
      {
        "name": "BICALATU",
        "zip": "405401",
        "lat": "46.879504",
        "long": "23.052374"
      },
      {
        "name": "BLIDARESTI",
        "zip": "407088",
        "lat": "47.106463",
        "long": "23.567277"
      },
      {
        "name": "BOBALNA",
        "zip": "407085",
        "lat": "47.141165",
        "long": "23.643109"
      },
      {
        "name": "BOCIU",
        "zip": "407381",
        "lat": "46.779022",
        "long": "22.945986"
      },
      {
        "name": "BODROG",
        "zip": "407036",
        "lat": "46.731638",
        "long": "23.766742"
      },
      {
        "name": "BOGATA",
        "zip": "407131",
        "lat": "46.509915",
        "long": "23.81729"
      },
      {
        "name": "BOGATA DE JOS",
        "zip": "407576",
        "lat": "47.204232",
        "long": "23.706202"
      },
      {
        "name": "BOGATA DE SUS",
        "zip": "407577",
        "lat": "47.193678",
        "long": "23.668088"
      },
      {
        "name": "BOIAN",
        "zip": "407187",
        "lat": "46.637363",
        "long": "23.990796"
      },
      {
        "name": "BOJ-CATUN",
        "zip": "407241",
        "lat": "46.694633",
        "long": "23.840501"
      },
      {
        "name": "BOJU",
        "zip": "407242",
        "lat": "46.71012",
        "long": "23.781593"
      },
      {
        "name": "BOLDUT",
        "zip": "407188",
        "lat": "46.623761",
        "long": "23.949907"
      },
      {
        "name": "BOLOGA",
        "zip": "407471",
        "lat": "46.882454",
        "long": "22.878893"
      },
      {
        "name": "BONT",
        "zip": "407276",
        "lat": "46.988206",
        "long": "23.924069"
      },
      {
        "name": "BONTIDA",
        "zip": "407105",
        "lat": "46.912131",
        "long": "23.815706"
      },
      {
        "name": "BORSA",
        "zip": "407110",
        "lat": "46.932989",
        "long": "23.662727"
      },
      {
        "name": "BORSA-CATUN",
        "zip": "407111",
        "lat": "46.907081",
        "long": "23.707873"
      },
      {
        "name": "BORSA-CRESTAIA",
        "zip": "407112",
        "lat": "46.911626",
        "long": "23.643526"
      },
      {
        "name": "BORZESTI",
        "zip": "407317",
        "lat": "46.539101",
        "long": "23.611888"
      },
      {
        "name": "BOTENI",
        "zip": "407421",
        "lat": "46.766238",
        "long": "24.026314"
      },
      {
        "name": "BRAISORU",
        "zip": "407517",
        "lat": "46.857393",
        "long": "22.957174"
      },
      {
        "name": "BUCEA",
        "zip": "407441",
        "lat": "46.94913",
        "long": "22.694811"
      },
      {
        "name": "BUNESTI",
        "zip": "407411",
        "lat": "47.05926",
        "long": "23.882892"
      },
      {
        "name": "BURU",
        "zip": "407318",
        "lat": "46.50623",
        "long": "23.601235"
      },
      {
        "name": "BUTENI",
        "zip": "407382",
        "lat": "46.786879",
        "long": "22.981678"
      },
      {
        "name": "BUZA",
        "zip": "407115",
        "lat": "46.909732",
        "long": "24.147486"
      },
      {
        "name": "CACOVA IERII",
        "zip": "407319",
        "lat": "46.541786",
        "long": "23.462338"
      },
      {
        "name": "CAIANU",
        "zip": "407120",
        "lat": "46.784603",
        "long": "23.918496"
      },
      {
        "name": "CAIANU MIC",
        "zip": "407122",
        "lat": "46.794132",
        "long": "23.907783"
      },
      {
        "name": "CAIANU-VAMA",
        "zip": "407123",
        "lat": "46.796459",
        "long": "23.885724"
      },
      {
        "name": "CALARASI",
        "zip": "407130",
        "lat": "46.483488",
        "long": "23.855637"
      },
      {
        "name": "CALARASI-GARA",
        "zip": "407132",
        "lat": "46.48522",
        "long": "23.887455"
      },
      {
        "name": "CALATA",
        "zip": "407136",
        "lat": "46.803135",
        "long": "22.99567"
      },
      {
        "name": "CALATELE",
        "zip": "407135",
        "lat": "46.764279",
        "long": "23.00986"
      },
      {
        "name": "CALNA",
        "zip": "407578",
        "lat": "47.17676",
        "long": "23.64605"
      },
      {
        "name": "CAMARASU",
        "zip": "407140",
        "lat": "46.798276",
        "long": "24.142795"
      },
      {
        "name": "CAMPENESTI",
        "zip": "407037",
        "lat": "46.850873",
        "long": "23.698096"
      },
      {
        "name": "CAMPIA TURZII",
        "zip": "405100",
        "lat": "46.547181",
        "long": "23.886967"
      },
      {
        "name": "CAPRIOARA",
        "zip": "407481",
        "lat": "47.101211",
        "long": "23.52752"
      },
      {
        "name": "CAPUSU MARE",
        "zip": "407145",
        "lat": "46.787333",
        "long": "23.293498"
      },
      {
        "name": "CAPUSU MIC",
        "zip": "407148",
        "lat": "46.798093",
        "long": "23.254917"
      },
      {
        "name": "CARA",
        "zip": "407243",
        "lat": "46.75557",
        "long": "23.780078"
      },
      {
        "name": "CASEIU",
        "zip": "407155",
        "lat": "47.196903",
        "long": "23.853771"
      },
      {
        "name": "CASELE MICESTI",
        "zip": "407271",
        "lat": "46.698309",
        "long": "23.574095"
      },
      {
        "name": "CATALINA",
        "zip": "407446",
        "lat": "47.036197",
        "long": "23.504439"
      },
      {
        "name": "CATCAU",
        "zip": "407180",
        "lat": "47.217649",
        "long": "23.789674"
      },
      {
        "name": "CATINA",
        "zip": "407170",
        "lat": "46.845044",
        "long": "24.163281"
      },
      {
        "name": "CEABA",
        "zip": "407521",
        "lat": "47.050093",
        "long": "24.097992"
      },
      {
        "name": "CEANU MARE",
        "zip": "407185",
        "lat": "46.661723",
        "long": "23.959764"
      },
      {
        "name": "CEANU MIC",
        "zip": "407561",
        "lat": "46.64274",
        "long": "23.711215"
      },
      {
        "name": "CERBESTI",
        "zip": "407472",
        "lat": "46.899215",
        "long": "22.867928"
      },
      {
        "name": "CERC",
        "zip": "407586",
        "lat": "46.620151",
        "long": "23.275329"
      },
      {
        "name": "CETAN",
        "zip": "407579",
        "lat": "47.192992",
        "long": "23.802821"
      },
      {
        "name": "CHEIA",
        "zip": "407406",
        "lat": "46.541535",
        "long": "23.709636"
      },
      {
        "name": "CHESAU",
        "zip": "407422",
        "lat": "46.818718",
        "long": "24.010195"
      },
      {
        "name": "CHIDEA",
        "zip": "407598",
        "lat": "46.977483",
        "long": "23.600683"
      },
      {
        "name": "CHINTENI",
        "zip": "407205",
        "lat": "46.861747",
        "long": "23.540455"
      },
      {
        "name": "CHIRIS",
        "zip": "407301",
        "lat": "46.884369",
        "long": "24.041777"
      },
      {
        "name": "CHIUIESTI",
        "zip": "407215",
        "lat": "47.295627",
        "long": "23.87467"
      },
      {
        "name": "CIUBANCA",
        "zip": "407482",
        "lat": "47.162733",
        "long": "23.572746"
      },
      {
        "name": "CIUBANCUTA",
        "zip": "407483",
        "lat": "47.141572",
        "long": "23.551554"
      },
      {
        "name": "CIUCEA",
        "zip": "407225",
        "lat": "46.954341",
        "long": "22.81275"
      },
      {
        "name": "CIULENI",
        "zip": "407383",
        "lat": "46.769793",
        "long": "22.98078"
      },
      {
        "name": "CIUMAFAIA",
        "zip": "407113",
        "lat": "46.94372",
        "long": "23.622721"
      },
      {
        "name": "CIURGAU",
        "zip": "407189",
        "lat": "46.661241",
        "long": "23.939312"
      },
      {
        "name": "CIURILA",
        "zip": "407230",
        "lat": "46.649125",
        "long": "23.542826"
      },
      {
        "name": "CLAPA",
        "zip": "407551",
        "lat": "46.569132",
        "long": "24.025365"
      },
      {
        "name": "CLUJ-NAPOCA",
        "zip": "400001",
        "lat": "46.772579",
        "long": "23.595373"
      },
      {
        "name": "COASTA",
        "zip": "407106",
        "lat": "46.885767",
        "long": "23.897201"
      },
      {
        "name": "CODOR",
        "zip": "407346",
        "lat": "47.127207",
        "long": "23.824225"
      },
      {
        "name": "COJOCNA",
        "zip": "407240",
        "lat": "46.750743",
        "long": "23.831776"
      },
      {
        "name": "COLONIA",
        "zip": "407552",
        "lat": "46.597229",
        "long": "23.972232"
      },
      {
        "name": "COMORATA",
        "zip": "407156",
        "lat": "47.284367",
        "long": "23.824895"
      },
      {
        "name": "COMSESTI",
        "zip": "407562",
        "lat": "46.633564",
        "long": "23.670707"
      },
      {
        "name": "COPACENI",
        "zip": "407501",
        "lat": "46.596057",
        "long": "23.738209"
      },
      {
        "name": "COPLEAN",
        "zip": "407157",
        "lat": "47.197599",
        "long": "23.825958"
      },
      {
        "name": "COPRU",
        "zip": "407171",
        "lat": "46.873396",
        "long": "24.202243"
      },
      {
        "name": "CORNENI",
        "zip": "407031",
        "lat": "47.0754",
        "long": "23.747276"
      },
      {
        "name": "CORNESTI",
        "zip": "407407",
        "lat": "46.522494",
        "long": "23.690517"
      },
      {
        "name": "CORNESTI",
        "zip": "407250",
        "lat": "47.036077",
        "long": "23.678875"
      },
      {
        "name": "CORNESTI",
        "zip": "407296",
        "lat": "46.888671",
        "long": "23.32735"
      },
      {
        "name": "CORPADEA",
        "zip": "407038",
        "lat": "46.791952",
        "long": "23.8281"
      },
      {
        "name": "CORUSU",
        "zip": "407056",
        "lat": "46.845439",
        "long": "23.500857"
      },
      {
        "name": "CRAESTI",
        "zip": "407456",
        "lat": "46.61256",
        "long": "23.590664"
      },
      {
        "name": "CRAIRAT",
        "zip": "407466",
        "lat": "46.655735",
        "long": "23.816916"
      },
      {
        "name": "CREMENEA",
        "zip": "407089",
        "lat": "47.145061",
        "long": "23.722817"
      },
      {
        "name": "CRISENI",
        "zip": "407423",
        "lat": "46.752186",
        "long": "24.048073"
      },
      {
        "name": "CRISTOREL",
        "zip": "407048",
        "lat": "46.964803",
        "long": "23.463312"
      },
      {
        "name": "CUBLESU SOMESAN",
        "zip": "407447",
        "lat": "47.051456",
        "long": "23.628267"
      },
      {
        "name": "CURTUIUSU DEJULUI",
        "zip": "407581",
        "lat": "47.215999",
        "long": "23.680182"
      },
      {
        "name": "CUSTURA",
        "zip": "407158",
        "lat": "47.258611",
        "long": "23.851152"
      },
      {
        "name": "CUTCA",
        "zip": "407522",
        "lat": "47.031929",
        "long": "24.07928"
      },
      {
        "name": "CUZDRIOARA",
        "zip": "407260",
        "lat": "47.16773",
        "long": "23.919916"
      },
      {
        "name": "DABACA",
        "zip": "407265",
        "lat": "46.969974",
        "long": "23.675259"
      },
      {
        "name": "DAMBU MARE",
        "zip": "407396",
        "lat": "47.151532",
        "long": "23.950193"
      },
      {
        "name": "DAMBURILE",
        "zip": "407547",
        "lat": "46.755555",
        "long": "23.937429"
      },
      {
        "name": "DANCU",
        "zip": "407008",
        "lat": "46.911592",
        "long": "23.226046"
      },
      {
        "name": "DANGAU MARE",
        "zip": "407149",
        "lat": "46.756509",
        "long": "23.199942"
      },
      {
        "name": "DANGAU MIC",
        "zip": "407151",
        "lat": "46.755184",
        "long": "23.191391"
      },
      {
        "name": "DARJA",
        "zip": "407448",
        "lat": "47.016535",
        "long": "23.59504"
      },
      {
        "name": "DAROT",
        "zip": "407572",
        "lat": "47.121682",
        "long": "24.104512"
      },
      {
        "name": "DEALU BOTII",
        "zip": "407077",
        "lat": "46.673046",
        "long": "22.923073"
      },
      {
        "name": "DEALU MARE",
        "zip": "407491",
        "lat": "46.720069",
        "long": "23.156531"
      },
      {
        "name": "DEALU NEGRU",
        "zip": "407137",
        "lat": "46.711928",
        "long": "23.04153"
      },
      {
        "name": "DEJ",
        "zip": "405200",
        "lat": "47.142667",
        "long": "23.875988"
      },
      {
        "name": "DELENI",
        "zip": "407457",
        "lat": "46.604533",
        "long": "23.638907"
      },
      {
        "name": "DEUSU",
        "zip": "407206",
        "lat": "46.897917",
        "long": "23.522804"
      },
      {
        "name": "DEZMIR",
        "zip": "407039",
        "lat": "46.763847",
        "long": "23.716269"
      },
      {
        "name": "DIVICIORII MARI",
        "zip": "407523",
        "lat": "46.989038",
        "long": "24.075254"
      },
      {
        "name": "DIVICIORII MICI",
        "zip": "407524",
        "lat": "46.973275",
        "long": "24.100548"
      },
      {
        "name": "DOMOSU",
        "zip": "407518",
        "lat": "46.831705",
        "long": "23.023248"
      },
      {
        "name": "DORNA",
        "zip": "407049",
        "lat": "47.013629",
        "long": "23.504124"
      },
      {
        "name": "DOROLTU",
        "zip": "407009",
        "lat": "46.855865",
        "long": "23.292192"
      },
      {
        "name": "DOSU BRICII",
        "zip": "407216",
        "lat": "47.285692",
        "long": "23.906586"
      },
      {
        "name": "DOSU NAPULUI",
        "zip": "407191",
        "lat": "46.663935",
        "long": "23.90941"
      },
      {
        "name": "DRETEA",
        "zip": "407374",
        "lat": "46.804379",
        "long": "23.098929"
      },
      {
        "name": "DUMBRAVA",
        "zip": "407152",
        "lat": "46.82502",
        "long": "23.217628"
      },
      {
        "name": "ELCIU",
        "zip": "407484",
        "lat": "47.081192",
        "long": "23.566927"
      },
      {
        "name": "ESCU",
        "zip": "407486",
        "lat": "47.128279",
        "long": "23.527447"
      },
      {
        "name": "FAGETU IERII",
        "zip": "407321",
        "lat": "46.538868",
        "long": "23.522505"
      },
      {
        "name": "FALCA",
        "zip": "407424",
        "lat": "46.787294",
        "long": "24.00858"
      },
      {
        "name": "FANATE",
        "zip": "407192",
        "lat": "46.682562",
        "long": "23.958738"
      },
      {
        "name": "FAURENI",
        "zip": "407599",
        "lat": "46.92844",
        "long": "23.544339"
      },
      {
        "name": "FEIURDENI",
        "zip": "407207",
        "lat": "46.882411",
        "long": "23.627337"
      },
      {
        "name": "FELDIOARA",
        "zip": "407172",
        "lat": "46.884061",
        "long": "24.15456"
      },
      {
        "name": "FELEACU",
        "zip": "407270",
        "lat": "46.71413",
        "long": "23.623068"
      },
      {
        "name": "FILEA DE JOS",
        "zip": "407231",
        "lat": "46.620482",
        "long": "23.508347"
      },
      {
        "name": "FILEA DE SUS",
        "zip": "407232",
        "lat": "46.6099",
        "long": "23.481217"
      },
      {
        "name": "FINCIU",
        "zip": "407138",
        "lat": "46.754415",
        "long": "23.041291"
      },
      {
        "name": "FINISEL",
        "zip": "407506",
        "lat": "46.67605",
        "long": "23.427764"
      },
      {
        "name": "FIZESU GHERLII",
        "zip": "407275",
        "lat": "47.023079",
        "long": "23.988025"
      },
      {
        "name": "FLORESTI",
        "zip": "407280",
        "lat": "46.744109",
        "long": "23.484036"
      },
      {
        "name": "FODORA",
        "zip": "407051",
        "lat": "46.978446",
        "long": "23.52554"
      },
      {
        "name": "FRASINET",
        "zip": "407066",
        "lat": "46.615216",
        "long": "23.401183"
      },
      {
        "name": "FRATA",
        "zip": "407285",
        "lat": "46.70311",
        "long": "24.056554"
      },
      {
        "name": "FUNDATURA",
        "zip": "407336",
        "lat": "46.956388",
        "long": "23.778618"
      },
      {
        "name": "GADALIN",
        "zip": "407351",
        "lat": "46.840221",
        "long": "23.848517"
      },
      {
        "name": "GARBAU",
        "zip": "407295",
        "lat": "46.833055",
        "long": "23.3524"
      },
      {
        "name": "GARBAU DEJULUI",
        "zip": "407159",
        "lat": "47.236459",
        "long": "23.908596"
      },
      {
        "name": "GEACA",
        "zip": "407300",
        "lat": "46.852476",
        "long": "24.092416"
      },
      {
        "name": "GHEORGHIENI",
        "zip": "407272",
        "lat": "46.712917",
        "long": "23.689275"
      },
      {
        "name": "GHERLA",
        "zip": "405300",
        "lat": "47.02877",
        "long": "23.90774"
      },
      {
        "name": "GHIRISU ROMAN",
        "zip": "407426",
        "lat": "46.804731",
        "long": "23.97663"
      },
      {
        "name": "GHIROLT",
        "zip": "407032",
        "lat": "47.038834",
        "long": "23.784922"
      },
      {
        "name": "GILAU",
        "zip": "407310",
        "lat": "46.7538",
        "long": "23.388946"
      },
      {
        "name": "GIULA",
        "zip": "407114",
        "lat": "46.92828",
        "long": "23.609966"
      },
      {
        "name": "GIURCUTA DE JOS",
        "zip": "407078",
        "lat": "46.652704",
        "long": "22.971368"
      },
      {
        "name": "GIURCUTA DE SUS",
        "zip": "407079",
        "lat": "46.646246",
        "long": "22.918674"
      },
      {
        "name": "GLIGORESTI",
        "zip": "407361",
        "lat": "46.451028",
        "long": "23.974048"
      },
      {
        "name": "GUGA",
        "zip": "407161",
        "lat": "47.274488",
        "long": "23.830983"
      },
      {
        "name": "HAGAU",
        "zip": "407173",
        "lat": "46.825434",
        "long": "24.168265"
      },
      {
        "name": "HASDATE",
        "zip": "405302",
        "lat": "47.008458",
        "long": "23.87994"
      },
      {
        "name": "HASDATE",
        "zip": "407507",
        "lat": "46.643552",
        "long": "23.429941"
      },
      {
        "name": "HODAI-BOIAN",
        "zip": "407193",
        "lat": "46.641",
        "long": "24.009572"
      },
      {
        "name": "HODAIE",
        "zip": "407174",
        "lat": "46.831178",
        "long": "24.132856"
      },
      {
        "name": "HODISU",
        "zip": "407473",
        "lat": "46.906596",
        "long": "22.908278"
      },
      {
        "name": "HORLACEA",
        "zip": "407519",
        "lat": "46.818757",
        "long": "23.040231"
      },
      {
        "name": "HUCI",
        "zip": "407244",
        "lat": "46.681744",
        "long": "23.898103"
      },
      {
        "name": "HUEDIN",
        "zip": "405400",
        "lat": "46.864339",
        "long": "23.025882"
      },
      {
        "name": "HUTA",
        "zip": "407217",
        "lat": "47.332674",
        "long": "24.009456"
      },
      {
        "name": "IACOBENI",
        "zip": "407194",
        "lat": "46.669579",
        "long": "24.027619"
      },
      {
        "name": "IARA",
        "zip": "407315",
        "lat": "46.553967",
        "long": "23.518267"
      },
      {
        "name": "ICLOD",
        "zip": "407335",
        "lat": "46.981425",
        "long": "23.807354"
      },
      {
        "name": "ICLOZEL",
        "zip": "407337",
        "lat": "46.97264",
        "long": "23.821201"
      },
      {
        "name": "IGRITIA",
        "zip": "407252",
        "lat": "47.091979",
        "long": "23.634256"
      },
      {
        "name": "INUCU",
        "zip": "407011",
        "lat": "46.848402",
        "long": "23.248403"
      },
      {
        "name": "IURIU DE CAMPIE",
        "zip": "407246",
        "lat": "46.698462",
        "long": "23.912379"
      },
      {
        "name": "IZVORU CRISULUI",
        "zip": "407340",
        "lat": "46.838296",
        "long": "23.105866"
      },
      {
        "name": "JICHISU DE JOS",
        "zip": "407345",
        "lat": "47.128902",
        "long": "23.788374"
      },
      {
        "name": "JICHISU DE SUS",
        "zip": "407347",
        "lat": "47.100814",
        "long": "23.747832"
      },
      {
        "name": "JUC-HERGHELIE",
        "zip": "407352",
        "lat": "46.851195",
        "long": "23.755735"
      },
      {
        "name": "JUCU DE MIJLOC",
        "zip": "407353",
        "lat": "46.842358",
        "long": "23.7738"
      },
      {
        "name": "JUCU DE SUS",
        "zip": "407354",
        "lat": "46.854862",
        "long": "23.793165"
      },
      {
        "name": "JURCA",
        "zip": "407487",
        "lat": "47.125498",
        "long": "23.546037"
      },
      {
        "name": "LACU",
        "zip": "407302",
        "lat": "46.884211",
        "long": "24.109532"
      },
      {
        "name": "LAPUSTESTI",
        "zip": "407492",
        "lat": "46.714802",
        "long": "23.181669"
      },
      {
        "name": "LEGHIA",
        "zip": "407012",
        "lat": "46.847073",
        "long": "23.189192"
      },
      {
        "name": "LEGII",
        "zip": "407303",
        "lat": "46.85594",
        "long": "24.049624"
      },
      {
        "name": "LEURDA",
        "zip": "407162",
        "lat": "47.261029",
        "long": "23.904554"
      },
      {
        "name": "LITA",
        "zip": "407508",
        "lat": "46.639346",
        "long": "23.465842"
      },
      {
        "name": "LITENI",
        "zip": "407509",
        "lat": "46.619495",
        "long": "23.452819"
      },
      {
        "name": "LIVADA",
        "zip": "407338",
        "lat": "47.000866",
        "long": "23.845244"
      },
      {
        "name": "LIVADA",
        "zip": "407458",
        "lat": "46.569579",
        "long": "23.591898"
      },
      {
        "name": "LOBODAS",
        "zip": "407467",
        "lat": "46.676525",
        "long": "23.84263"
      },
      {
        "name": "LUJERDIU",
        "zip": "407253",
        "lat": "46.969777",
        "long": "23.717193"
      },
      {
        "name": "LUNA",
        "zip": "407360",
        "lat": "46.506911",
        "long": "23.918894"
      },
      {
        "name": "LUNA DE JOS",
        "zip": "407266",
        "lat": "46.936297",
        "long": "23.75935"
      },
      {
        "name": "LUNA DE SUS",
        "zip": "407281",
        "lat": "46.742549",
        "long": "23.431841"
      },
      {
        "name": "LUNCA BONTULUI",
        "zip": "407277",
        "lat": "46.984349",
        "long": "23.959265"
      },
      {
        "name": "LUNCA VISAGULUI",
        "zip": "407474",
        "lat": "46.827967",
        "long": "22.767602"
      },
      {
        "name": "LUNCANI",
        "zip": "407362",
        "lat": "46.472745",
        "long": "23.950954"
      },
      {
        "name": "LUNGESTI",
        "zip": "407322",
        "lat": "46.500757",
        "long": "23.540683"
      },
      {
        "name": "MACAU",
        "zip": "407013",
        "lat": "46.830915",
        "long": "23.29378"
      },
      {
        "name": "MACICASU",
        "zip": "407208",
        "lat": "46.890397",
        "long": "23.568546"
      },
      {
        "name": "MAGOAJA",
        "zip": "407218",
        "lat": "47.347876",
        "long": "23.861758"
      },
      {
        "name": "MAGURA IERII",
        "zip": "407324",
        "lat": "46.543332",
        "long": "23.583938"
      },
      {
        "name": "MAGURI",
        "zip": "407366",
        "lat": "46.627936",
        "long": "23.121627"
      },
      {
        "name": "MAGURI-RACATAU",
        "zip": "407365",
        "lat": "46.645161",
        "long": "23.19362"
      },
      {
        "name": "MAHAL",
        "zip": "407526",
        "lat": "46.975201",
        "long": "24.045689"
      },
      {
        "name": "MAIA",
        "zip": "407091",
        "lat": "47.151466",
        "long": "23.724207"
      },
      {
        "name": "MANASTIREA",
        "zip": "407397",
        "lat": "47.120616",
        "long": "23.923779"
      },
      {
        "name": "MANASTIRENI",
        "zip": "407370",
        "lat": "46.781865",
        "long": "23.085223"
      },
      {
        "name": "MANASTUREL",
        "zip": "407261",
        "lat": "47.171264",
        "long": "23.952885"
      },
      {
        "name": "MANASTURU ROMANESC",
        "zip": "407376",
        "lat": "46.775208",
        "long": "23.083914"
      },
      {
        "name": "MARCESTI",
        "zip": "407493",
        "lat": "46.745052",
        "long": "23.153185"
      },
      {
        "name": "MARGAU",
        "zip": "407380",
        "lat": "46.752703",
        "long": "22.959314"
      },
      {
        "name": "MARISEL",
        "zip": "407390",
        "lat": "46.683115",
        "long": "23.115498"
      },
      {
        "name": "MARTINESTI",
        "zip": "407563",
        "lat": "46.655856",
        "long": "23.68004"
      },
      {
        "name": "MASCA",
        "zip": "407323",
        "lat": "46.553664",
        "long": "23.457564"
      },
      {
        "name": "MERA",
        "zip": "407057",
        "lat": "46.815253",
        "long": "23.454047"
      },
      {
        "name": "MICA",
        "zip": "407395",
        "lat": "47.147078",
        "long": "23.926352"
      },
      {
        "name": "MICESTI",
        "zip": "407564",
        "lat": "46.6401",
        "long": "23.620331"
      },
      {
        "name": "MIHAI VITEAZU",
        "zip": "407405",
        "lat": "46.540464",
        "long": "23.747235"
      },
      {
        "name": "MIHAIESTI",
        "zip": "407532",
        "lat": "46.903593",
        "long": "23.418746"
      },
      {
        "name": "MINTIU GHERLII",
        "zip": "407410",
        "lat": "47.054601",
        "long": "23.943993"
      },
      {
        "name": "MOARA DE PADURE",
        "zip": "407067",
        "lat": "46.600668",
        "long": "23.431327"
      },
      {
        "name": "MOCIU",
        "zip": "407420",
        "lat": "46.797404",
        "long": "24.032476"
      },
      {
        "name": "MOLDOVENESTI",
        "zip": "407430",
        "lat": "46.498979",
        "long": "23.670687"
      },
      {
        "name": "MORAU",
        "zip": "407254",
        "lat": "46.997038",
        "long": "23.693099"
      },
      {
        "name": "MORISTI",
        "zip": "407247",
        "lat": "46.769518",
        "long": "23.791201"
      },
      {
        "name": "MORLACA",
        "zip": "407476",
        "lat": "46.857514",
        "long": "22.918693"
      },
      {
        "name": "MORTESTI",
        "zip": "407196",
        "lat": "46.638698",
        "long": "23.904536"
      },
      {
        "name": "MUNCEL",
        "zip": "407181",
        "lat": "47.256458",
        "long": "23.766507"
      },
      {
        "name": "MUNTELE BAISORII",
        "zip": "407068",
        "lat": "46.560432",
        "long": "23.348231"
      },
      {
        "name": "MUNTELE BOCULUI",
        "zip": "407069",
        "lat": "46.578807",
        "long": "23.343131"
      },
      {
        "name": "MUNTELE CACOVEI",
        "zip": "407071",
        "lat": "46.537314",
        "long": "23.337144"
      },
      {
        "name": "MUNTELE FILII",
        "zip": "407072",
        "lat": "46.585214",
        "long": "23.393894"
      },
      {
        "name": "MUNTELE RECE",
        "zip": "407367",
        "lat": "46.655575",
        "long": "23.301084"
      },
      {
        "name": "MUNTELE SACELULUI",
        "zip": "407073",
        "lat": "46.600731",
        "long": "23.387106"
      },
      {
        "name": "MURESENII DE CAMPIE",
        "zip": "407452",
        "lat": "46.891028",
        "long": "23.98807"
      },
      {
        "name": "NADASELU",
        "zip": "407297",
        "lat": "46.827479",
        "long": "23.415497"
      },
      {
        "name": "NADASU",
        "zip": "407341",
        "lat": "46.856404",
        "long": "23.151062"
      },
      {
        "name": "NAOIU",
        "zip": "407141",
        "lat": "46.763731",
        "long": "24.101961"
      },
      {
        "name": "NASAL",
        "zip": "407566",
        "lat": "46.944485",
        "long": "24.112219"
      },
      {
        "name": "NEARSOVA",
        "zip": "407342",
        "lat": "46.837203",
        "long": "23.064366"
      },
      {
        "name": "NEGRENI",
        "zip": "407440",
        "lat": "46.955409",
        "long": "22.756521"
      },
      {
        "name": "NICULA",
        "zip": "407278",
        "lat": "47.011498",
        "long": "23.937375"
      },
      {
        "name": "NIMA",
        "zip": "407412",
        "lat": "47.07594",
        "long": "23.867538"
      },
      {
        "name": "NIRES",
        "zip": "407398",
        "lat": "47.114989",
        "long": "23.980917"
      },
      {
        "name": "OAS",
        "zip": "407287",
        "lat": "46.699884",
        "long": "24.091753"
      },
      {
        "name": "OCNA DEJULUI",
        "zip": "405201",
        "lat": "47.115465",
        "long": "23.859676"
      },
      {
        "name": "OCOLISEL",
        "zip": "407326",
        "lat": "46.514385",
        "long": "23.487394"
      },
      {
        "name": "OLARIU",
        "zip": "407288",
        "lat": "46.692731",
        "long": "24.069185"
      },
      {
        "name": "ORMAN",
        "zip": "407339",
        "lat": "47.046874",
        "long": "23.818995"
      },
      {
        "name": "OSOI",
        "zip": "407488",
        "lat": "47.147873",
        "long": "23.521581"
      },
      {
        "name": "OSORHEL",
        "zip": "407092",
        "lat": "47.125612",
        "long": "23.603122"
      },
      {
        "name": "PADUREA IACOBENI",
        "zip": "407289",
        "lat": "46.685589",
        "long": "24.050463"
      },
      {
        "name": "PADURENI",
        "zip": "407209",
        "lat": "46.870266",
        "long": "23.594892"
      },
      {
        "name": "PADURENI",
        "zip": "407233",
        "lat": "46.606779",
        "long": "23.559547"
      },
      {
        "name": "PADURENI",
        "zip": "407553",
        "lat": "46.593162",
        "long": "24.026999"
      },
      {
        "name": "PADURENII",
        "zip": "407413",
        "lat": "47.070246",
        "long": "23.99919"
      },
      {
        "name": "PAGLISA",
        "zip": "407267",
        "lat": "47.002985",
        "long": "23.646265"
      },
      {
        "name": "PALATCA",
        "zip": "407450",
        "lat": "46.840891",
        "long": "23.988719"
      },
      {
        "name": "PANICENI",
        "zip": "407153",
        "lat": "46.80865",
        "long": "23.187437"
      },
      {
        "name": "PANTICEU",
        "zip": "407445",
        "lat": "47.042346",
        "long": "23.557337"
      },
      {
        "name": "PATA",
        "zip": "407041",
        "lat": "46.727007",
        "long": "23.747063"
      },
      {
        "name": "PESTERA",
        "zip": "405202",
        "lat": "47.186586",
        "long": "23.726963"
      },
      {
        "name": "PETEA",
        "zip": "407453",
        "lat": "46.866576",
        "long": "24.015596"
      },
      {
        "name": "PETRESTI",
        "zip": "407414",
        "lat": "47.076252",
        "long": "23.938187"
      },
      {
        "name": "PETRESTII DE JOS",
        "zip": "407455",
        "lat": "46.580233",
        "long": "23.652142"
      },
      {
        "name": "PETRESTII DE MIJLOC",
        "zip": "407459",
        "lat": "46.564111",
        "long": "23.654686"
      },
      {
        "name": "PETRESTII DE SUS",
        "zip": "407461",
        "lat": "46.547879",
        "long": "23.643823"
      },
      {
        "name": "PIETROASA",
        "zip": "407432",
        "lat": "46.463234",
        "long": "23.635925"
      },
      {
        "name": "PINTIC",
        "zip": "405203",
        "lat": "47.077962",
        "long": "23.793693"
      },
      {
        "name": "PLAIESTI",
        "zip": "407433",
        "lat": "46.499619",
        "long": "23.711463"
      },
      {
        "name": "PLAIURI",
        "zip": "407462",
        "lat": "46.588943",
        "long": "23.57139"
      },
      {
        "name": "PLOPI",
        "zip": "407587",
        "lat": "46.652982",
        "long": "23.345585"
      },
      {
        "name": "PLOSCOS",
        "zip": "407465",
        "lat": "46.643247",
        "long": "23.84802"
      },
      {
        "name": "PODENI",
        "zip": "407434",
        "lat": "46.426017",
        "long": "23.640436"
      },
      {
        "name": "POIANA FRATII",
        "zip": "407291",
        "lat": "46.66871",
        "long": "24.085388"
      },
      {
        "name": "POIANA HOREA",
        "zip": "407081",
        "lat": "46.595301",
        "long": "22.913848"
      },
      {
        "name": "POIENI",
        "zip": "407470",
        "lat": "46.917246",
        "long": "22.859763"
      },
      {
        "name": "POPESTI",
        "zip": "407058",
        "lat": "46.823922",
        "long": "23.534282"
      },
      {
        "name": "PRELUCELE",
        "zip": "407442",
        "lat": "46.940131",
        "long": "22.778234"
      },
      {
        "name": "PRUNENI",
        "zip": "407033",
        "lat": "47.042814",
        "long": "23.717866"
      },
      {
        "name": "PRUNI",
        "zip": "407093",
        "lat": "47.162536",
        "long": "23.609631"
      },
      {
        "name": "PRUNIS",
        "zip": "407234",
        "lat": "46.639238",
        "long": "23.565879"
      },
      {
        "name": "PUINI",
        "zip": "407304",
        "lat": "46.908725",
        "long": "24.014078"
      },
      {
        "name": "PUSTUTA",
        "zip": "407489",
        "lat": "47.123828",
        "long": "23.564552"
      },
      {
        "name": "RACHITELE",
        "zip": "407384",
        "lat": "46.706293",
        "long": "22.892309"
      },
      {
        "name": "RADAIA",
        "zip": "407059",
        "lat": "46.802116",
        "long": "23.462953"
      },
      {
        "name": "RASCA",
        "zip": "407490",
        "lat": "46.744175",
        "long": "23.105705"
      },
      {
        "name": "RASCRUCI",
        "zip": "407107",
        "lat": "46.905691",
        "long": "23.768599"
      },
      {
        "name": "RAZBUNENI",
        "zip": "407094",
        "lat": "47.146769",
        "long": "23.6989"
      },
      {
        "name": "RAZOARE",
        "zip": "407292",
        "lat": "46.707111",
        "long": "24.022714"
      },
      {
        "name": "RECEA-CRISTUR",
        "zip": "407480",
        "lat": "47.079678",
        "long": "23.52094"
      },
      {
        "name": "REDIU",
        "zip": "407026",
        "lat": "46.684227",
        "long": "23.692762"
      },
      {
        "name": "ROGOJEL",
        "zip": "407496",
        "lat": "46.786574",
        "long": "22.844199"
      },
      {
        "name": "ROSIENI",
        "zip": "407427",
        "lat": "46.815709",
        "long": "24.069096"
      },
      {
        "name": "ROTUNDA",
        "zip": "407116",
        "lat": "46.899133",
        "long": "24.212984"
      },
      {
        "name": "RUGASESTI",
        "zip": "407163",
        "lat": "47.231327",
        "long": "23.871715"
      },
      {
        "name": "SACALAIA",
        "zip": "407279",
        "lat": "46.964516",
        "long": "23.920553"
      },
      {
        "name": "SACEL",
        "zip": "407074",
        "lat": "46.601632",
        "long": "23.456666"
      },
      {
        "name": "SACUIEU",
        "zip": "407495",
        "lat": "46.82335",
        "long": "22.888238"
      },
      {
        "name": "SALATIU",
        "zip": "407416",
        "lat": "47.099731",
        "long": "23.929032"
      },
      {
        "name": "SALATRUC",
        "zip": "407164",
        "lat": "47.261366",
        "long": "23.879644"
      },
      {
        "name": "SALICEA",
        "zip": "407236",
        "lat": "46.676607",
        "long": "23.524788"
      },
      {
        "name": "SALISCA",
        "zip": "407182",
        "lat": "47.22113",
        "long": "23.823796"
      },
      {
        "name": "SALISTE",
        "zip": "407237",
        "lat": "46.651128",
        "long": "23.584318"
      },
      {
        "name": "SALISTEA NOUA",
        "zip": "407061",
        "lat": "46.873224",
        "long": "23.491901"
      },
      {
        "name": "SALISTEA VECHE",
        "zip": "407212",
        "lat": "46.893608",
        "long": "23.464255"
      },
      {
        "name": "SAMBOIENI",
        "zip": "407527",
        "lat": "47.029768",
        "long": "24.062277"
      },
      {
        "name": "SAMBOLENI",
        "zip": "407142",
        "lat": "46.807141",
        "long": "24.108634"
      },
      {
        "name": "SANCRAIU",
        "zip": "407515",
        "lat": "46.830073",
        "long": "22.985319"
      },
      {
        "name": "SANDULESTI",
        "zip": "407500",
        "lat": "46.581369",
        "long": "23.727594"
      },
      {
        "name": "SANMARGHITA",
        "zip": "407399",
        "lat": "47.157525",
        "long": "23.992797"
      },
      {
        "name": "SANMARTIN",
        "zip": "407213",
        "lat": "46.899558",
        "long": "23.567295"
      },
      {
        "name": "SANMARTIN",
        "zip": "407520",
        "lat": "47.009184",
        "long": "24.076464"
      },
      {
        "name": "SANNICOARA",
        "zip": "407042",
        "lat": "46.786365",
        "long": "23.719603"
      },
      {
        "name": "SANPAUL",
        "zip": "407530",
        "lat": "46.869369",
        "long": "23.419704"
      },
      {
        "name": "SANTEJUDE",
        "zip": "407567",
        "lat": "46.926831",
        "long": "23.990529"
      },
      {
        "name": "SANTEJUDE-VALE",
        "zip": "407568",
        "lat": "46.961651",
        "long": "23.972857"
      },
      {
        "name": "SANTIOANA",
        "zip": "407569",
        "lat": "46.969813",
        "long": "24.011611"
      },
      {
        "name": "SARADIS",
        "zip": "407273",
        "lat": "46.700863",
        "long": "23.663488"
      },
      {
        "name": "SARATA",
        "zip": "407449",
        "lat": "47.055825",
        "long": "23.496319"
      },
      {
        "name": "SARDU",
        "zip": "407534",
        "lat": "46.861594",
        "long": "23.391714"
      },
      {
        "name": "SATU LUNG",
        "zip": "407211",
        "lat": "46.908759",
        "long": "23.602813"
      },
      {
        "name": "SAULA",
        "zip": "407343",
        "lat": "46.851818",
        "long": "23.07559"
      },
      {
        "name": "SAVA",
        "zip": "407454",
        "lat": "46.884413",
        "long": "23.969561"
      },
      {
        "name": "SAVADISLA",
        "zip": "407505",
        "lat": "46.674872",
        "long": "23.456259"
      },
      {
        "name": "SCRIND-FRASINET",
        "zip": "407386",
        "lat": "46.74607",
        "long": "22.902368"
      },
      {
        "name": "SIC",
        "zip": "407540",
        "lat": "46.931338",
        "long": "23.896154"
      },
      {
        "name": "SICFA",
        "zip": "407573",
        "lat": "47.090466",
        "long": "24.118989"
      },
      {
        "name": "SIGAU",
        "zip": "407348",
        "lat": "47.101644",
        "long": "23.714692"
      },
      {
        "name": "SILIVAS",
        "zip": "405303",
        "lat": "46.987612",
        "long": "23.86796"
      },
      {
        "name": "SMIDA",
        "zip": "407082",
        "lat": "46.643831",
        "long": "22.874022"
      },
      {
        "name": "SOIMENI",
        "zip": "407601",
        "lat": "46.958455",
        "long": "23.533392"
      },
      {
        "name": "SOMCUTU MIC",
        "zip": "405204",
        "lat": "47.162421",
        "long": "23.764117"
      },
      {
        "name": "SOMESU CALD",
        "zip": "407311",
        "lat": "46.731151",
        "long": "23.327141"
      },
      {
        "name": "SOMESU RECE",
        "zip": "407312",
        "lat": "46.731737",
        "long": "23.363393"
      },
      {
        "name": "SOPORU DE CAMPIE",
        "zip": "407293",
        "lat": "46.696184",
        "long": "24.006577"
      },
      {
        "name": "STARCU",
        "zip": "407197",
        "lat": "46.651022",
        "long": "23.889091"
      },
      {
        "name": "STEJERIS",
        "zip": "407436",
        "lat": "46.465662",
        "long": "23.735348"
      },
      {
        "name": "STOIANA",
        "zip": "407256",
        "lat": "47.017754",
        "long": "23.686769"
      },
      {
        "name": "STOLNA",
        "zip": "407511",
        "lat": "46.71421",
        "long": "23.404722"
      },
      {
        "name": "STRAJA",
        "zip": "407154",
        "lat": "46.807325",
        "long": "23.295229"
      },
      {
        "name": "STRAJA",
        "zip": "407248",
        "lat": "46.69989",
        "long": "23.868022"
      },
      {
        "name": "STRAMBU",
        "zip": "407219",
        "lat": "47.336874",
        "long": "23.953191"
      },
      {
        "name": "STRUCUT",
        "zip": "407198",
        "lat": "46.679213",
        "long": "23.938273"
      },
      {
        "name": "SUARAS",
        "zip": "407096",
        "lat": "47.136608",
        "long": "23.710271"
      },
      {
        "name": "SUATU",
        "zip": "407545",
        "lat": "46.772069",
        "long": "23.968633"
      },
      {
        "name": "SUB COASTA",
        "zip": "407043",
        "lat": "46.799799",
        "long": "23.720004"
      },
      {
        "name": "SUCEAGU",
        "zip": "407062",
        "lat": "46.78429",
        "long": "23.465004"
      },
      {
        "name": "SUCUTARD",
        "zip": "407306",
        "lat": "46.895308",
        "long": "24.068211"
      },
      {
        "name": "SUMURDUCU",
        "zip": "407533",
        "lat": "46.870706",
        "long": "23.449239"
      },
      {
        "name": "SURDUC",
        "zip": "407327",
        "lat": "46.540517",
        "long": "23.546054"
      },
      {
        "name": "SUTU",
        "zip": "407238",
        "lat": "46.614315",
        "long": "23.541466"
      },
      {
        "name": "TAGA",
        "zip": "407565",
        "lat": "46.943357",
        "long": "24.051475"
      },
      {
        "name": "TARGUSOR",
        "zip": "407528",
        "lat": "46.996853",
        "long": "24.046372"
      },
      {
        "name": "TARPIU",
        "zip": "407349",
        "lat": "47.143534",
        "long": "23.761488"
      },
      {
        "name": "TAUSENI",
        "zip": "407108",
        "lat": "46.873238",
        "long": "23.926267"
      },
      {
        "name": "TAUTI",
        "zip": "407282",
        "lat": "46.71187",
        "long": "23.507728"
      },
      {
        "name": "TICU",
        "zip": "407014",
        "lat": "46.918169",
        "long": "23.233955"
      },
      {
        "name": "TICU-COLONIE",
        "zip": "407016",
        "lat": "46.907324",
        "long": "23.244271"
      },
      {
        "name": "TIOCU DE JOS",
        "zip": "407257",
        "lat": "47.059074",
        "long": "23.660933"
      },
      {
        "name": "TIOCU DE SUS",
        "zip": "407258",
        "lat": "47.075702",
        "long": "23.646568"
      },
      {
        "name": "TIOLTIUR",
        "zip": "407259",
        "lat": "47.013333",
        "long": "23.718091"
      },
      {
        "name": "TOPA MICA",
        "zip": "407536",
        "lat": "46.936168",
        "long": "23.387216"
      },
      {
        "name": "TRANISU",
        "zip": "407477",
        "lat": "46.857165",
        "long": "22.836012"
      },
      {
        "name": "TRITENII DE JOS",
        "zip": "407550",
        "lat": "46.585159",
        "long": "24.001379"
      },
      {
        "name": "TRITENII DE SUS",
        "zip": "407554",
        "lat": "46.605442",
        "long": "23.998488"
      },
      {
        "name": "TRITENII-HOTAR",
        "zip": "407556",
        "lat": "46.564154",
        "long": "24.004124"
      },
      {
        "name": "TURDA",
        "zip": "401001",
        "lat": "46.564971",
        "long": "23.779842"
      },
      {
        "name": "TUREA",
        "zip": "407298",
        "lat": "46.85111",
        "long": "23.353399"
      },
      {
        "name": "TURENI",
        "zip": "407560",
        "lat": "46.622114",
        "long": "23.699678"
      },
      {
        "name": "TURMASI",
        "zip": "407428",
        "lat": "46.798156",
        "long": "24.005826"
      },
      {
        "name": "UNGURAS",
        "zip": "407570",
        "lat": "47.112116",
        "long": "24.051155"
      },
      {
        "name": "URCA",
        "zip": "407591",
        "lat": "46.548852",
        "long": "23.961872"
      },
      {
        "name": "URISOR",
        "zip": "407166",
        "lat": "47.168958",
        "long": "23.877774"
      },
      {
        "name": "VAD",
        "zip": "407575",
        "lat": "47.220294",
        "long": "23.748204"
      },
      {
        "name": "VAIDA-CAMARAS",
        "zip": "407124",
        "lat": "46.828228",
        "long": "23.947240999999998"
      },
      {
        "name": "VALCELE",
        "zip": "407274",
        "lat": "46.680141",
        "long": "23.648934"
      },
      {
        "name": "VALCELELE",
        "zip": "407097",
        "lat": "47.106726",
        "long": "23.596023"
      },
      {
        "name": "VALE",
        "zip": "407034",
        "lat": "47.081275",
        "long": "23.721772"
      },
      {
        "name": "VALEA AGRISULUI",
        "zip": "407328",
        "lat": "46.57026",
        "long": "23.557991"
      },
      {
        "name": "VALEA CALDA",
        "zip": "407176",
        "lat": "46.849852",
        "long": "24.139446"
      },
      {
        "name": "VALEA CASEIELULUI",
        "zip": "407221",
        "lat": "47.328254",
        "long": "23.926589"
      },
      {
        "name": "VALEA CIRESOII",
        "zip": "407401",
        "lat": "47.156196",
        "long": "24.022116"
      },
      {
        "name": "VALEA DRAGANULUI",
        "zip": "407478",
        "lat": "46.902848",
        "long": "22.83146"
      },
      {
        "name": "VALEA FLORILOR",
        "zip": "407468",
        "lat": "46.664641",
        "long": "23.86035"
      },
      {
        "name": "VALEA GARBOULUI",
        "zip": "407262",
        "lat": "47.207914",
        "long": "23.919165"
      },
      {
        "name": "VALEA GROSILOR",
        "zip": "407582",
        "lat": "47.23972",
        "long": "23.745095"
      },
      {
        "name": "VALEA IERII",
        "zip": "407585",
        "lat": "46.64729",
        "long": "23.343803"
      },
      {
        "name": "VALEA LUI CATI",
        "zip": "407199",
        "lat": "46.645468",
        "long": "23.942422"
      },
      {
        "name": "VALEA LUI OPRIS",
        "zip": "407222",
        "lat": "47.329066",
        "long": "23.901381"
      },
      {
        "name": "VALEA LUNCII",
        "zip": "407402",
        "lat": "47.166836",
        "long": "24.022919"
      },
      {
        "name": "VALEA UNGURASULUI",
        "zip": "407574",
        "lat": "47.076446",
        "long": "24.115026"
      },
      {
        "name": "VALEA VADULUI",
        "zip": "407329",
        "lat": "46.554041",
        "long": "23.423663"
      },
      {
        "name": "VALENI",
        "zip": "407126",
        "lat": "46.784055",
        "long": "23.904334"
      },
      {
        "name": "VALENI",
        "zip": "407139",
        "lat": "46.781199",
        "long": "23.032938"
      },
      {
        "name": "VALISOARA",
        "zip": "407512",
        "lat": "46.666586",
        "long": "23.493001"
      },
      {
        "name": "VANATORI",
        "zip": "407226",
        "lat": "46.962513",
        "long": "22.847748"
      },
      {
        "name": "VECHEA",
        "zip": "407214",
        "lat": "46.895209",
        "long": "23.509318"
      },
      {
        "name": "VIISOARA",
        "zip": "407590",
        "lat": "46.558721",
        "long": "23.90734"
      },
      {
        "name": "VISAGU",
        "zip": "407497",
        "lat": "46.829829",
        "long": "22.829609"
      },
      {
        "name": "VISEA",
        "zip": "407356",
        "lat": "46.856414",
        "long": "23.873611"
      },
      {
        "name": "VISTEA",
        "zip": "407299",
        "lat": "46.802596",
        "long": "23.402175"
      },
      {
        "name": "VLAHA",
        "zip": "407513",
        "lat": "46.694892",
        "long": "23.456259"
      },
      {
        "name": "VULTURENI",
        "zip": "407595",
        "lat": "46.960755",
        "long": "23.556914"
      },
      {
        "name": "ZORENII DE VALE",
        "zip": "407429",
        "lat": "46.790695",
        "long": "24.072553"
      }
    ],
    "CONSTANȚA": [
      {
        "name": "2 MAI",
        "zip": "907161",
        "lat": "43.786635",
        "long": "28.575294"
      },
      {
        "name": "23 AUGUST",
        "zip": "907005",
        "lat": "43.918723",
        "long": "28.583639"
      },
      {
        "name": "ABRUD",
        "zip": "907011",
        "lat": "44.145523",
        "long": "27.978891"
      },
      {
        "name": "ADAMCLISI",
        "zip": "907010",
        "lat": "44.083439",
        "long": "27.954654"
      },
      {
        "name": "AGIGEA",
        "zip": "907015",
        "lat": "44.091197",
        "long": "28.610421"
      },
      {
        "name": "ALBESTI",
        "zip": "907020",
        "lat": "43.802642",
        "long": "28.425089"
      },
      {
        "name": "ALIMAN",
        "zip": "907025",
        "lat": "44.184199",
        "long": "27.857138"
      },
      {
        "name": "ALMALAU",
        "zip": "907221",
        "lat": "44.084746",
        "long": "27.342113"
      },
      {
        "name": "AMZACEA",
        "zip": "907030",
        "lat": "43.961601",
        "long": "28.393041"
      },
      {
        "name": "ARSA",
        "zip": "907021",
        "lat": "43.837946",
        "long": "28.464449"
      },
      {
        "name": "BALTAGESTI",
        "zip": "907096",
        "lat": "44.480895",
        "long": "28.192079"
      },
      {
        "name": "BANEASA",
        "zip": "907035",
        "lat": "44.06477",
        "long": "27.701559"
      },
      {
        "name": "BARAGANU",
        "zip": "907181",
        "lat": "44.086318",
        "long": "28.420867"
      },
      {
        "name": "BIRUINTA",
        "zip": "907286",
        "lat": "43.995119",
        "long": "28.503955"
      },
      {
        "name": "BREBENI",
        "zip": "907151",
        "lat": "44.088794",
        "long": "27.788801"
      },
      {
        "name": "BUGEAC",
        "zip": "907222",
        "lat": "44.097805",
        "long": "27.43112"
      },
      {
        "name": "CALUGARENI",
        "zip": "907231",
        "lat": "44.661123",
        "long": "28.372636"
      },
      {
        "name": "CANLIA",
        "zip": "907166",
        "lat": "44.125833",
        "long": "27.529331"
      },
      {
        "name": "CAP AURORA",
        "zip": "905501",
        "lat": "43.850331",
        "long": "28.605194"
      },
      {
        "name": "CAPIDAVA",
        "zip": "907281",
        "lat": "44.496653",
        "long": "28.091157"
      },
      {
        "name": "CARVAN",
        "zip": "907167",
        "lat": "44.034797",
        "long": "27.574135"
      },
      {
        "name": "CASCIOARELE",
        "zip": "907046",
        "lat": "43.85855",
        "long": "28.10253"
      },
      {
        "name": "CASIAN",
        "zip": "907276",
        "lat": "44.497944",
        "long": "28.481226"
      },
      {
        "name": "CASICEA",
        "zip": "907031",
        "lat": "43.966588",
        "long": "28.26641"
      },
      {
        "name": "CASTELU",
        "zip": "907040",
        "lat": "44.259227",
        "long": "28.339309"
      },
      {
        "name": "CERCHEZU",
        "zip": "907045",
        "lat": "43.824093",
        "long": "28.097514"
      },
      {
        "name": "CERNAVODA",
        "zip": "905200",
        "lat": "44.341977",
        "long": "28.031754"
      },
      {
        "name": "CETATEA",
        "zip": "907116",
        "lat": "44.005486",
        "long": "27.880991"
      },
      {
        "name": "CHEIA",
        "zip": "907277",
        "lat": "44.512685",
        "long": "28.433044"
      },
      {
        "name": "CHIRNOGENI",
        "zip": "907050",
        "lat": "43.896831",
        "long": "28.227563"
      },
      {
        "name": "CIOBANITA",
        "zip": "907182",
        "lat": "44.012588",
        "long": "28.275856"
      },
      {
        "name": "CIOBANU",
        "zip": "907055",
        "lat": "44.71674",
        "long": "27.98646"
      },
      {
        "name": "CIOCARLIA",
        "zip": "907060",
        "lat": "44.103827",
        "long": "28.289071"
      },
      {
        "name": "CIOCARLIA DE SUS",
        "zip": "907061",
        "lat": "44.117531",
        "long": "28.332816"
      },
      {
        "name": "CLOSCA",
        "zip": "907141",
        "lat": "44.66857",
        "long": "28.142721"
      },
      {
        "name": "COBADIN",
        "zip": "907065",
        "lat": "44.063983",
        "long": "28.233042"
      },
      {
        "name": "COCHIRLENI",
        "zip": "907251",
        "lat": "44.274317",
        "long": "27.998756"
      },
      {
        "name": "COGEALAC",
        "zip": "907070",
        "lat": "44.557959",
        "long": "28.558185"
      },
      {
        "name": "COMANA",
        "zip": "907080",
        "lat": "43.89547",
        "long": "28.313737"
      },
      {
        "name": "CONACU",
        "zip": "907066",
        "lat": "43.989184",
        "long": "28.173923"
      },
      {
        "name": "CONSTANTA",
        "zip": "900003",
        "lat": "44.171786",
        "long": "28.631976"
      },
      {
        "name": "CORBU",
        "zip": "907085",
        "lat": "44.408943",
        "long": "28.657677"
      },
      {
        "name": "COROANA",
        "zip": "907022",
        "lat": "43.761971",
        "long": "28.386973"
      },
      {
        "name": "COSLUGEA",
        "zip": "907168",
        "lat": "44.118777",
        "long": "27.578719"
      },
      {
        "name": "COSTINESTI",
        "zip": "907090",
        "lat": "43.94877",
        "long": "28.631021"
      },
      {
        "name": "COTU VAII",
        "zip": "907023",
        "lat": "43.822155",
        "long": "28.341059"
      },
      {
        "name": "CRANGU",
        "zip": "907152",
        "lat": "44.095434",
        "long": "27.853622"
      },
      {
        "name": "CREDINTA",
        "zip": "907051",
        "lat": "43.978615",
        "long": "28.240447"
      },
      {
        "name": "CRISAN",
        "zip": "907097",
        "lat": "44.602927",
        "long": "28.175874"
      },
      {
        "name": "CRUCEA",
        "zip": "907095",
        "lat": "44.531527",
        "long": "28.231028"
      },
      {
        "name": "CUIUGIUC",
        "zip": "907169",
        "lat": "44.047038",
        "long": "27.528412"
      },
      {
        "name": "CULMEA",
        "zip": "905902",
        "lat": "44.254909",
        "long": "28.459082"
      },
      {
        "name": "CUMPANA",
        "zip": "907105",
        "lat": "44.111727",
        "long": "28.55535"
      },
      {
        "name": "CURCANI",
        "zip": "907067",
        "lat": "43.998728",
        "long": "28.096959"
      },
      {
        "name": "CUZA VODA",
        "zip": "907041",
        "lat": "44.286897",
        "long": "28.307107"
      },
      {
        "name": "DARABANI",
        "zip": "905801",
        "lat": "43.78639",
        "long": "28.296571"
      },
      {
        "name": "DELENI",
        "zip": "907110",
        "lat": "44.091261",
        "long": "28.008578"
      },
      {
        "name": "DOBROMIR",
        "zip": "907115",
        "lat": "44.02015",
        "long": "27.779149"
      },
      {
        "name": "DOBROMIRU DIN DEAL",
        "zip": "907117",
        "lat": "43.99192",
        "long": "27.796174"
      },
      {
        "name": "DOROBANTU",
        "zip": "907211",
        "lat": "44.41078",
        "long": "28.326474"
      },
      {
        "name": "DROPIA",
        "zip": "907291",
        "lat": "44.345279",
        "long": "28.305495"
      },
      {
        "name": "DULCESTI",
        "zip": "907006",
        "lat": "43.904149",
        "long": "28.545105"
      },
      {
        "name": "DULGHERU",
        "zip": "907256",
        "lat": "44.703345",
        "long": "28.239508"
      },
      {
        "name": "DUMBRAVENI",
        "zip": "907125",
        "lat": "43.929464",
        "long": "27.983708"
      },
      {
        "name": "DUNAREA",
        "zip": "907266",
        "lat": "44.440096",
        "long": "28.119294"
      },
      {
        "name": "DUNARENI",
        "zip": "907026",
        "lat": "44.204634",
        "long": "27.790575"
      },
      {
        "name": "EFORIE NORD",
        "zip": "905350",
        "lat": "44.063793",
        "long": "28.633744"
      },
      {
        "name": "EFORIE SUD",
        "zip": "905360",
        "lat": "44.027874",
        "long": "28.650451"
      },
      {
        "name": "ESECHIOI",
        "zip": "907223",
        "lat": "44.03272",
        "long": "27.421416"
      },
      {
        "name": "FACLIA",
        "zip": "907201",
        "lat": "44.279435",
        "long": "28.102789"
      },
      {
        "name": "FANTANA MARE",
        "zip": "907146",
        "lat": "43.980013",
        "long": "28.056248"
      },
      {
        "name": "FANTANELE",
        "zip": "907071",
        "lat": "44.612784",
        "long": "28.576546"
      },
      {
        "name": "FAUREI",
        "zip": "907036",
        "lat": "44.040916",
        "long": "27.698061"
      },
      {
        "name": "FLORIILE",
        "zip": "907027",
        "lat": "44.144218",
        "long": "27.83309"
      },
      {
        "name": "FURNICA",
        "zip": "907126",
        "lat": "43.961419",
        "long": "28.000376"
      },
      {
        "name": "GALBIORI",
        "zip": "907098",
        "lat": "44.492824",
        "long": "28.257757"
      },
      {
        "name": "GALITA",
        "zip": "907224",
        "lat": "44.098541",
        "long": "27.488904"
      },
      {
        "name": "GARLICIU",
        "zip": "907130",
        "lat": "44.779541",
        "long": "28.092976"
      },
      {
        "name": "GARLITA",
        "zip": "907226",
        "lat": "44.066738",
        "long": "27.462463"
      },
      {
        "name": "GENERAL SCARISOREANU",
        "zip": "907032",
        "lat": "43.955932",
        "long": "28.298936"
      },
      {
        "name": "GHERGHINA",
        "zip": "907202",
        "lat": "44.322627",
        "long": "28.18185"
      },
      {
        "name": "GHINDARESTI",
        "zip": "907135",
        "lat": "44.640682",
        "long": "28.029104"
      },
      {
        "name": "GORUNI",
        "zip": "907171",
        "lat": "44.046973",
        "long": "27.612913"
      },
      {
        "name": "GRADINA",
        "zip": "907278",
        "lat": "44.553923",
        "long": "28.434761"
      },
      {
        "name": "GRANICERU",
        "zip": "905802",
        "lat": "43.802176",
        "long": "28.256198"
      },
      {
        "name": "GURA DOBROGEI",
        "zip": "907072",
        "lat": "44.481364",
        "long": "28.527744"
      },
      {
        "name": "HAGIENI",
        "zip": "907162",
        "lat": "43.784082",
        "long": "28.480133"
      },
      {
        "name": "HARSOVA",
        "zip": "905400",
        "lat": "44.684581",
        "long": "27.951277"
      },
      {
        "name": "HATEG",
        "zip": "907012",
        "lat": "44.162326",
        "long": "27.961014"
      },
      {
        "name": "HORIA",
        "zip": "907140",
        "lat": "44.633129",
        "long": "28.123739"
      },
      {
        "name": "INDEPENDENTA",
        "zip": "907145",
        "lat": "43.949863",
        "long": "28.085513"
      },
      {
        "name": "ION CORVIN",
        "zip": "907150",
        "lat": "44.115526",
        "long": "27.805557"
      },
      {
        "name": "ISTRIA",
        "zip": "907155",
        "lat": "44.571939",
        "long": "28.7095"
      },
      {
        "name": "IVRINEZU MARE",
        "zip": "907241",
        "lat": "44.22983",
        "long": "28.065181"
      },
      {
        "name": "IVRINEZU MIC",
        "zip": "907242",
        "lat": "44.230396",
        "long": "28.040348"
      },
      {
        "name": "IZVOARELE",
        "zip": "907172",
        "lat": "44.16615",
        "long": "27.543338"
      },
      {
        "name": "IZVORU MARE",
        "zip": "907243",
        "lat": "44.152158",
        "long": "28.165625"
      },
      {
        "name": "JUPITER",
        "zip": "905502",
        "lat": "43.858061",
        "long": "28.601095"
      },
      {
        "name": "LANURILE",
        "zip": "907183",
        "lat": "44.068567",
        "long": "28.376276"
      },
      {
        "name": "LAZU",
        "zip": "907016",
        "lat": "44.114816",
        "long": "28.606446"
      },
      {
        "name": "LESPEZI",
        "zip": "907118",
        "lat": "44.018975",
        "long": "27.830839"
      },
      {
        "name": "LIMANU",
        "zip": "907160",
        "lat": "43.799105",
        "long": "28.528269"
      },
      {
        "name": "LIPNITA",
        "zip": "907165",
        "lat": "44.095746",
        "long": "27.604236"
      },
      {
        "name": "LUMINA",
        "zip": "907175",
        "lat": "44.293923",
        "long": "28.566303"
      },
      {
        "name": "LUMINITA",
        "zip": "907086",
        "lat": "44.365782",
        "long": "28.634397"
      },
      {
        "name": "MAGURA",
        "zip": "907047",
        "lat": "43.845081",
        "long": "28.049153"
      },
      {
        "name": "MAMAIA",
        "zip": "900001",
        "lat": "44.233786",
        "long": "28.625567"
      },
      {
        "name": "MAMAIA-SAT",
        "zip": "905701",
        "lat": "44.291441",
        "long": "28.61815"
      },
      {
        "name": "MANGALIA",
        "zip": "905500",
        "lat": "43.815079",
        "long": "28.583031"
      },
      {
        "name": "MEDGIDIA",
        "zip": "905600",
        "lat": "44.2443",
        "long": "28.269625"
      },
      {
        "name": "MERENI",
        "zip": "907180",
        "lat": "44.033799",
        "long": "28.381673"
      },
      {
        "name": "MIHAI VITEAZU",
        "zip": "907190",
        "lat": "44.646064",
        "long": "28.674426"
      },
      {
        "name": "MIHAIL KOGALNICEANU",
        "zip": "907195",
        "lat": "44.370305",
        "long": "28.463098"
      },
      {
        "name": "MIORITA",
        "zip": "907056",
        "lat": "44.682794",
        "long": "28.077226"
      },
      {
        "name": "MIRCEA VODA",
        "zip": "907200",
        "lat": "44.284194",
        "long": "28.178876"
      },
      {
        "name": "MIREASA",
        "zip": "907279",
        "lat": "44.492818",
        "long": "28.358318"
      },
      {
        "name": "MIRISTEA",
        "zip": "907184",
        "lat": "44.001776",
        "long": "28.354437"
      },
      {
        "name": "MOSNENI",
        "zip": "907007",
        "lat": "43.93473",
        "long": "28.52945"
      },
      {
        "name": "MOVILA VERDE",
        "zip": "907147",
        "lat": "43.963351",
        "long": "28.13741"
      },
      {
        "name": "MOVILITA",
        "zip": "907287",
        "lat": "44.047598",
        "long": "28.509291"
      },
      {
        "name": "MURFATLAR",
        "zip": "905100",
        "lat": "44.173302",
        "long": "28.410868"
      },
      {
        "name": "NAVODARI",
        "zip": "905700",
        "lat": "44.32084",
        "long": "28.611393"
      },
      {
        "name": "NAZARCEA",
        "zip": "907246",
        "lat": "44.227886",
        "long": "28.43415"
      },
      {
        "name": "NEGRESTI",
        "zip": "907068",
        "lat": "43.999839",
        "long": "28.133365"
      },
      {
        "name": "NEGRU VODA",
        "zip": "905800",
        "lat": "43.818909",
        "long": "28.214047"
      },
      {
        "name": "NEGURENI",
        "zip": "907037",
        "lat": "44.096171",
        "long": "27.754964"
      },
      {
        "name": "NEPTUN",
        "zip": "905550",
        "lat": "43.866409",
        "long": "28.601322"
      },
      {
        "name": "NICOLAE BALCESCU",
        "zip": "907210",
        "lat": "44.385414",
        "long": "28.377909"
      },
      {
        "name": "NISIPARI",
        "zip": "907042",
        "lat": "44.259642",
        "long": "28.398399"
      },
      {
        "name": "NISTORESTI",
        "zip": "907232",
        "lat": "44.620306",
        "long": "28.377"
      },
      {
        "name": "NUNTASI",
        "zip": "907156",
        "lat": "44.538141",
        "long": "28.651226"
      },
      {
        "name": "OITUZ",
        "zip": "907176",
        "lat": "44.329011",
        "long": "28.522"
      },
      {
        "name": "OLIMP",
        "zip": "905503",
        "lat": "43.885555",
        "long": "28.606466"
      },
      {
        "name": "OLTENI",
        "zip": "907148",
        "lat": "43.914246",
        "long": "28.023538"
      },
      {
        "name": "OLTINA",
        "zip": "907215",
        "lat": "44.169072",
        "long": "27.666811"
      },
      {
        "name": "OSMANCEA",
        "zip": "907186",
        "lat": "44.013803",
        "long": "28.323137"
      },
      {
        "name": "OSTROV",
        "zip": "907220",
        "lat": "44.10655",
        "long": "27.370878"
      },
      {
        "name": "OVIDIU",
        "zip": "905900",
        "lat": "44.255932",
        "long": "28.562175"
      },
      {
        "name": "PADURENI",
        "zip": "907119",
        "lat": "44.050977",
        "long": "27.865342"
      },
      {
        "name": "PALAZU MARE",
        "zip": "900002",
        "lat": "44.229018",
        "long": "28.601141"
      },
      {
        "name": "PALAZU MIC",
        "zip": "907196",
        "lat": "44.439839",
        "long": "28.530118"
      },
      {
        "name": "PANTELIMON",
        "zip": "907230",
        "lat": "44.545892",
        "long": "28.330943"
      },
      {
        "name": "PANTELIMON DE JOS",
        "zip": "907233",
        "lat": "44.572858",
        "long": "28.387737"
      },
      {
        "name": "PECINEAGA",
        "zip": "907235",
        "lat": "43.897168",
        "long": "28.497981"
      },
      {
        "name": "PELINU",
        "zip": "907081",
        "lat": "43.923667",
        "long": "28.384461"
      },
      {
        "name": "PESTERA",
        "zip": "907240",
        "lat": "44.184283",
        "long": "28.126983"
      },
      {
        "name": "PETROSANI",
        "zip": "907111",
        "lat": "44.01463",
        "long": "28.052158"
      },
      {
        "name": "PIATRA",
        "zip": "907197",
        "lat": "44.404522",
        "long": "28.56125"
      },
      {
        "name": "PIETRENI",
        "zip": "907112",
        "lat": "44.095528",
        "long": "28.066122"
      },
      {
        "name": "PLOPENI",
        "zip": "907052",
        "lat": "43.950888",
        "long": "28.194516"
      },
      {
        "name": "POARTA ALBA",
        "zip": "907245",
        "lat": "44.202731",
        "long": "28.396876"
      },
      {
        "name": "POIANA",
        "zip": "905901",
        "lat": "44.222007",
        "long": "28.499485"
      },
      {
        "name": "POTARNICHEA",
        "zip": "907288",
        "lat": "44.070433",
        "long": "28.479526"
      },
      {
        "name": "RAMNICU DE JOS",
        "zip": "907073",
        "lat": "44.629195",
        "long": "28.45536"
      },
      {
        "name": "RAMNICU DE SUS",
        "zip": "907074",
        "lat": "44.651081",
        "long": "28.462942"
      },
      {
        "name": "RARISTEA",
        "zip": "907153",
        "lat": "44.075948",
        "long": "27.803247"
      },
      {
        "name": "RASOVA",
        "zip": "907250",
        "lat": "44.243995",
        "long": "27.935759"
      },
      {
        "name": "RAZOARELE",
        "zip": "907216",
        "lat": "44.101615",
        "long": "27.680058"
      },
      {
        "name": "REMUS OPREANU",
        "zip": "905601",
        "lat": "44.240816",
        "long": "28.21157"
      },
      {
        "name": "RUNCU",
        "zip": "907234",
        "lat": "44.599075",
        "long": "28.328041"
      },
      {
        "name": "SACELE",
        "zip": "907260",
        "lat": "44.487248",
        "long": "28.642937"
      },
      {
        "name": "SALIGNY",
        "zip": "907203",
        "lat": "44.280127",
        "long": "28.090559"
      },
      {
        "name": "SANATORIUL AGIGEA",
        "zip": "907017",
        "lat": "44.0932",
        "long": "28.638921"
      },
      {
        "name": "SARAIU",
        "zip": "907255",
        "lat": "44.719417",
        "long": "28.155973"
      },
      {
        "name": "SATU NOU",
        "zip": "907204",
        "lat": "44.269691",
        "long": "28.224195"
      },
      {
        "name": "SATU NOU",
        "zip": "907217",
        "lat": "44.160864",
        "long": "27.60588"
      },
      {
        "name": "SATURN",
        "zip": "905560",
        "lat": "43.828283",
        "long": "28.588173"
      },
      {
        "name": "SCHITU",
        "zip": "907091",
        "lat": "43.941225",
        "long": "28.625536"
      },
      {
        "name": "SEIMENI",
        "zip": "907265",
        "lat": "44.393203",
        "long": "28.071208"
      },
      {
        "name": "SEIMENII MICI",
        "zip": "907267",
        "lat": "44.371432",
        "long": "28.069294"
      },
      {
        "name": "SIBIOARA",
        "zip": "907177",
        "lat": "44.363249",
        "long": "28.553332"
      },
      {
        "name": "SILISTEA",
        "zip": "907270",
        "lat": "44.401721",
        "long": "28.178517"
      },
      {
        "name": "SIMINOC",
        "zip": "905101",
        "lat": "44.168863",
        "long": "28.352686"
      },
      {
        "name": "SINOE",
        "zip": "907191",
        "lat": "44.628706",
        "long": "28.73028"
      },
      {
        "name": "SIPOTELE",
        "zip": "907113",
        "lat": "44.044745",
        "long": "27.959701"
      },
      {
        "name": "SIRIU",
        "zip": "907099",
        "lat": "44.630543",
        "long": "28.183942"
      },
      {
        "name": "STATIUNEA ZOOLOGICA MARINA AGIGEA",
        "zip": "907018",
        "lat": "44.087408",
        "long": "28.641151"
      },
      {
        "name": "STEFAN CEL MARE",
        "zip": "907206",
        "lat": "44.301273",
        "long": "28.077081"
      },
      {
        "name": "STEJARU",
        "zip": "907257",
        "lat": "44.730109",
        "long": "28.22484"
      },
      {
        "name": "STRAJA",
        "zip": "907106",
        "lat": "44.103904",
        "long": "28.457187"
      },
      {
        "name": "STRUNGA",
        "zip": "907218",
        "lat": "44.123847",
        "long": "27.638349"
      },
      {
        "name": "STUPINA",
        "zip": "907101",
        "lat": "44.565368",
        "long": "28.179262"
      },
      {
        "name": "TARGUSOR",
        "zip": "907275",
        "lat": "44.461571",
        "long": "28.419564"
      },
      {
        "name": "TARIVERDE",
        "zip": "907076",
        "lat": "44.562932",
        "long": "28.601927"
      },
      {
        "name": "TATARU",
        "zip": "907082",
        "lat": "43.880466",
        "long": "28.357671"
      },
      {
        "name": "TECHIRGHIOL",
        "zip": "906100",
        "lat": "44.055507",
        "long": "28.59988"
      },
      {
        "name": "TEPES VODA",
        "zip": "907271",
        "lat": "44.445366",
        "long": "28.236367"
      },
      {
        "name": "TIBRINU",
        "zip": "907207",
        "lat": "44.331358",
        "long": "28.156735"
      },
      {
        "name": "TICHILESTI",
        "zip": "907142",
        "lat": "44.601259",
        "long": "28.092318"
      },
      {
        "name": "TOPALU",
        "zip": "907280",
        "lat": "44.542785",
        "long": "28.044946"
      },
      {
        "name": "TOPRAISAR",
        "zip": "907285",
        "lat": "44.014318",
        "long": "28.454039"
      },
      {
        "name": "TORTOMAN",
        "zip": "907290",
        "lat": "44.344469",
        "long": "28.222791"
      },
      {
        "name": "TRAIAN",
        "zip": "907261",
        "lat": "44.491172",
        "long": "28.679689"
      },
      {
        "name": "TUDOR VLADIMIRESCU",
        "zip": "907038",
        "lat": "43.999428",
        "long": "27.703266"
      },
      {
        "name": "TUFANI",
        "zip": "907149",
        "lat": "43.991042",
        "long": "28.008006"
      },
      {
        "name": "TUZLA",
        "zip": "907295",
        "lat": "44.004308",
        "long": "28.637527"
      },
      {
        "name": "URLUIA",
        "zip": "907013",
        "lat": "44.103928",
        "long": "27.912858"
      },
      {
        "name": "VADU",
        "zip": "907087",
        "lat": "44.450765",
        "long": "28.737665"
      },
      {
        "name": "VADU OII",
        "zip": "905401",
        "lat": "44.739807",
        "long": "27.886203"
      },
      {
        "name": "VALCELELE",
        "zip": "905803",
        "lat": "43.782045",
        "long": "28.339746"
      },
      {
        "name": "VALEA DACILOR",
        "zip": "905602",
        "lat": "44.194058",
        "long": "28.318247"
      },
      {
        "name": "VALENI",
        "zip": "907121",
        "lat": "44.020611",
        "long": "27.874638"
      },
      {
        "name": "VALU LUI TRAIAN",
        "zip": "907300",
        "lat": "44.16368",
        "long": "28.470671"
      },
      {
        "name": "VAMA VECHE",
        "zip": "907163",
        "lat": "43.753225",
        "long": "28.571406"
      },
      {
        "name": "VANATORI",
        "zip": "907236",
        "lat": "43.877519",
        "long": "28.5211"
      },
      {
        "name": "VARTOP",
        "zip": "907024",
        "lat": "43.818818",
        "long": "28.384178"
      },
      {
        "name": "VENUS",
        "zip": "905504",
        "lat": "43.845495",
        "long": "28.594198"
      },
      {
        "name": "VETERANU",
        "zip": "907244",
        "lat": "44.155061",
        "long": "28.131618"
      },
      {
        "name": "VIILE",
        "zip": "907154",
        "lat": "44.161816",
        "long": "27.756106"
      },
      {
        "name": "VIISOARA",
        "zip": "907069",
        "lat": "44.078205",
        "long": "28.191129"
      },
      {
        "name": "VIROAGA",
        "zip": "907048",
        "lat": "43.871656",
        "long": "28.088552"
      },
      {
        "name": "VLAHII",
        "zip": "907028",
        "lat": "44.202415",
        "long": "27.862631"
      },
      {
        "name": "VULTURU",
        "zip": "907305",
        "lat": "44.648062",
        "long": "28.272942"
      },
      {
        "name": "ZORILE",
        "zip": "907014",
        "lat": "44.075401",
        "long": "27.934884"
      }
    ],
    "COVASNA": [
      {
        "name": "AITA MARE",
        "zip": "527005",
        "lat": "45.968067",
        "long": "25.563793"
      },
      {
        "name": "AITA MEDIE",
        "zip": "527006",
        "lat": "45.977566",
        "long": "25.607086"
      },
      {
        "name": "AITA SEACA",
        "zip": "527016",
        "lat": "46.038136",
        "long": "25.689986"
      },
      {
        "name": "ALBIS",
        "zip": "527071",
        "lat": "45.935723",
        "long": "26.006516"
      },
      {
        "name": "ALUNGENI",
        "zip": "527161",
        "lat": "46.017134",
        "long": "26.024968"
      },
      {
        "name": "ANGHELUS",
        "zip": "527096",
        "lat": "45.87673",
        "long": "25.885259"
      },
      {
        "name": "ANINOASA",
        "zip": "527146",
        "lat": "45.816715",
        "long": "25.966966"
      },
      {
        "name": "ARACI",
        "zip": "527176",
        "lat": "45.806686",
        "long": "25.653618"
      },
      {
        "name": "ARCUS",
        "zip": "527166",
        "lat": "45.90078",
        "long": "25.775436"
      },
      {
        "name": "ARIUSD",
        "zip": "527177",
        "lat": "45.777078",
        "long": "25.677774"
      },
      {
        "name": "BACEL",
        "zip": "527076",
        "lat": "45.758861",
        "long": "25.823072"
      },
      {
        "name": "BARAOLT",
        "zip": "525100",
        "lat": "46.075192",
        "long": "25.599624"
      },
      {
        "name": "BARCANI",
        "zip": "527010",
        "lat": "45.688154",
        "long": "26.08514"
      },
      {
        "name": "BATANII MARI",
        "zip": "527020",
        "lat": "46.088502",
        "long": "25.697888"
      },
      {
        "name": "BATANII MICI",
        "zip": "527017",
        "lat": "46.103831",
        "long": "25.695112"
      },
      {
        "name": "BELANI",
        "zip": "527141",
        "lat": "46.085893",
        "long": "26.187551"
      },
      {
        "name": "BELIN",
        "zip": "527030",
        "lat": "45.933523",
        "long": "25.569469"
      },
      {
        "name": "BELIN-VALE",
        "zip": "527031",
        "lat": "45.932328",
        "long": "25.605805"
      },
      {
        "name": "BIBORTENI",
        "zip": "525101",
        "lat": "46.093709",
        "long": "25.655832"
      },
      {
        "name": "BICFALAU",
        "zip": "527131",
        "lat": "45.758762",
        "long": "25.876305"
      },
      {
        "name": "BITA",
        "zip": "527147",
        "lat": "45.83483",
        "long": "25.975443"
      },
      {
        "name": "BIXAD",
        "zip": "527116",
        "lat": "46.101642",
        "long": "25.860519"
      },
      {
        "name": "BODOC",
        "zip": "527035",
        "lat": "45.956419",
        "long": "25.855259"
      },
      {
        "name": "BODOS",
        "zip": "525102",
        "lat": "46.076358",
        "long": "25.663127"
      },
      {
        "name": "BOROSNEU MARE",
        "zip": "527040",
        "lat": "45.819232",
        "long": "26.007836"
      },
      {
        "name": "BOROSNEU MIC",
        "zip": "527041",
        "lat": "45.785016",
        "long": "26.011855"
      },
      {
        "name": "BRADET",
        "zip": "525301",
        "lat": "45.652638",
        "long": "25.992762"
      },
      {
        "name": "BRADUT",
        "zip": "527055",
        "lat": "46.131287",
        "long": "25.608169"
      },
      {
        "name": "BRATES",
        "zip": "527050",
        "lat": "45.835786",
        "long": "26.070367"
      },
      {
        "name": "BRETCU",
        "zip": "527060",
        "lat": "46.044234",
        "long": "26.302137"
      },
      {
        "name": "CALNIC",
        "zip": "527167",
        "lat": "45.929441",
        "long": "25.795521"
      },
      {
        "name": "CAPENI",
        "zip": "525103",
        "lat": "46.040101",
        "long": "25.578329"
      },
      {
        "name": "CARPINENII",
        "zip": "527142",
        "lat": "46.16775",
        "long": "26.206433"
      },
      {
        "name": "CASINU MIC",
        "zip": "527151",
        "lat": "46.060957",
        "long": "26.134248"
      },
      {
        "name": "CATALINA",
        "zip": "527065",
        "lat": "45.968596",
        "long": "26.159079"
      },
      {
        "name": "CERNAT",
        "zip": "527070",
        "lat": "45.950345",
        "long": "26.03532"
      },
      {
        "name": "CHICHIS",
        "zip": "527075",
        "lat": "45.775232",
        "long": "25.800331"
      },
      {
        "name": "CHILIENI",
        "zip": "520001",
        "lat": "45.837133",
        "long": "25.803156"
      },
      {
        "name": "CHIURUS",
        "zip": "525201",
        "lat": "45.823184",
        "long": "26.156683"
      },
      {
        "name": "COMANDAU",
        "zip": "527080",
        "lat": "45.758679",
        "long": "26.274522"
      },
      {
        "name": "COSENI",
        "zip": "520002",
        "lat": "45.81187",
        "long": "25.799883"
      },
      {
        "name": "COVASNA",
        "zip": "525200",
        "lat": "45.844899",
        "long": "26.169311"
      },
      {
        "name": "CRASNA",
        "zip": "527156",
        "lat": "45.589962",
        "long": "26.144448"
      },
      {
        "name": "DALNIC",
        "zip": "527121",
        "lat": "45.922417",
        "long": "25.98741"
      },
      {
        "name": "DOBARLAU",
        "zip": "527085",
        "lat": "45.737493",
        "long": "25.886992"
      },
      {
        "name": "DOBOLII DE JOS",
        "zip": "527106",
        "lat": "45.779514",
        "long": "25.756139"
      },
      {
        "name": "DOBOLII DE SUS",
        "zip": "527042",
        "lat": "45.783276",
        "long": "26.034276"
      },
      {
        "name": "DOBOSENI",
        "zip": "527056",
        "lat": "46.124492",
        "long": "25.592536"
      },
      {
        "name": "ESTELNIC",
        "zip": "527143",
        "lat": "46.103974",
        "long": "26.209609"
      },
      {
        "name": "FILIA",
        "zip": "527057",
        "lat": "46.144092",
        "long": "25.621397"
      },
      {
        "name": "FLOROAIA",
        "zip": "525302",
        "lat": "45.694968",
        "long": "26.015627"
      },
      {
        "name": "FOTOS",
        "zip": "527097",
        "lat": "45.898201",
        "long": "25.870076"
      },
      {
        "name": "GHELINTA",
        "zip": "527090",
        "lat": "45.943176",
        "long": "26.241133"
      },
      {
        "name": "GHIDFALAU",
        "zip": "527095",
        "lat": "45.904344",
        "long": "25.843272"
      },
      {
        "name": "HAGHIG",
        "zip": "527100",
        "lat": "45.837937",
        "long": "25.593085"
      },
      {
        "name": "HARALE",
        "zip": "527091",
        "lat": "45.925746",
        "long": "26.208518"
      },
      {
        "name": "HATUICA",
        "zip": "527066",
        "lat": "45.93992",
        "long": "26.126177"
      },
      {
        "name": "HERCULIAN",
        "zip": "527018",
        "lat": "46.133385",
        "long": "25.708868"
      },
      {
        "name": "HETEA",
        "zip": "527178",
        "lat": "45.824358",
        "long": "25.694015"
      },
      {
        "name": "HILIB",
        "zip": "527126",
        "lat": "45.971221",
        "long": "26.238387"
      },
      {
        "name": "IARAS",
        "zip": "527101",
        "lat": "45.86981",
        "long": "25.598276"
      },
      {
        "name": "ICAFALAU",
        "zip": "527072",
        "lat": "45.99947",
        "long": "26.023648"
      },
      {
        "name": "ILIENI",
        "zip": "527105",
        "lat": "45.79443",
        "long": "25.771004"
      },
      {
        "name": "IMENI",
        "zip": "527067",
        "lat": "45.943563",
        "long": "26.17148"
      },
      {
        "name": "INTORSURA BUZAULUI",
        "zip": "525300",
        "lat": "45.674129",
        "long": "26.033531"
      },
      {
        "name": "LADAUTI",
        "zip": "527011",
        "lat": "45.721859",
        "long": "26.063051"
      },
      {
        "name": "LEMNIA",
        "zip": "527110",
        "lat": "46.050625",
        "long": "26.266611"
      },
      {
        "name": "LET",
        "zip": "527043",
        "lat": "45.856148",
        "long": "26.019162"
      },
      {
        "name": "LISNAU",
        "zip": "527132",
        "lat": "45.775414",
        "long": "25.889222"
      },
      {
        "name": "LISNAU-VALE",
        "zip": "527133",
        "lat": "45.766282",
        "long": "25.931824"
      },
      {
        "name": "LUNCA MARCUSULUI",
        "zip": "527086",
        "lat": "45.733134",
        "long": "25.854477"
      },
      {
        "name": "LUNCA OZUNULUI",
        "zip": "527134",
        "lat": "45.771857",
        "long": "25.830849"
      },
      {
        "name": "LUNGA",
        "zip": "525401",
        "lat": "46.020938",
        "long": "26.209631"
      },
      {
        "name": "LUTOASA",
        "zip": "527111",
        "lat": "46.090683",
        "long": "26.233235"
      },
      {
        "name": "MAGHERUS",
        "zip": "527136",
        "lat": "45.78787",
        "long": "25.924353"
      },
      {
        "name": "MALNAS",
        "zip": "527117",
        "lat": "46.009144",
        "long": "25.843071"
      },
      {
        "name": "MALNAS-BAI",
        "zip": "527118",
        "lat": "46.032773",
        "long": "25.823063"
      },
      {
        "name": "MARCUS",
        "zip": "527087",
        "lat": "45.720155",
        "long": "25.860336"
      },
      {
        "name": "MARCUSA",
        "zip": "527068",
        "lat": "45.915716",
        "long": "26.057418"
      },
      {
        "name": "MARTANUS",
        "zip": "527061",
        "lat": "46.018764",
        "long": "26.290295"
      },
      {
        "name": "MARTINENI",
        "zip": "527069",
        "lat": "45.921589",
        "long": "26.096888"
      },
      {
        "name": "MERENI",
        "zip": "527112",
        "lat": "46.079449",
        "long": "26.235981"
      },
      {
        "name": "MERISOR",
        "zip": "527157",
        "lat": "45.638069",
        "long": "26.09262"
      },
      {
        "name": "MICFALAU",
        "zip": "527115",
        "lat": "46.050176",
        "long": "25.834654"
      },
      {
        "name": "MICLOSOARA",
        "zip": "525104",
        "lat": "46.008256",
        "long": "25.581817"
      },
      {
        "name": "MOACSA",
        "zip": "527120",
        "lat": "45.875947",
        "long": "25.977039"
      },
      {
        "name": "OITUZ",
        "zip": "527062",
        "lat": "46.07179",
        "long": "26.389801"
      },
      {
        "name": "OJDULA",
        "zip": "527125",
        "lat": "45.987352",
        "long": "26.260502"
      },
      {
        "name": "OLTENI",
        "zip": "527036",
        "lat": "45.976733",
        "long": "25.847991"
      },
      {
        "name": "OZUN",
        "zip": "527130",
        "lat": "45.800819",
        "long": "25.847664"
      },
      {
        "name": "OZUNCA-BAI",
        "zip": "527019",
        "lat": "46.089834",
        "long": "25.801602"
      },
      {
        "name": "PACHIA",
        "zip": "527051",
        "lat": "45.825386",
        "long": "26.118046"
      },
      {
        "name": "PADURENI",
        "zip": "527122",
        "lat": "45.884908",
        "long": "25.931253"
      },
      {
        "name": "PAPAUTI",
        "zip": "527186",
        "lat": "45.789465",
        "long": "26.144753"
      },
      {
        "name": "PETENI",
        "zip": "527191",
        "lat": "45.921228",
        "long": "26.144704"
      },
      {
        "name": "PETRICENI",
        "zip": "527152",
        "lat": "46.068364",
        "long": "26.086963"
      },
      {
        "name": "POIAN",
        "zip": "527140",
        "lat": "46.068735",
        "long": "26.160911"
      },
      {
        "name": "RACOSUL DE SUS",
        "zip": "525105",
        "lat": "46.079095",
        "long": "25.547828"
      },
      {
        "name": "RECI",
        "zip": "527145",
        "lat": "45.840265",
        "long": "25.929373"
      },
      {
        "name": "SACIOVA",
        "zip": "527148",
        "lat": "45.783554",
        "long": "25.95541"
      },
      {
        "name": "SANCRAIU",
        "zip": "527107",
        "lat": "45.823717",
        "long": "25.762669"
      },
      {
        "name": "SANTIONLUNCA",
        "zip": "527137",
        "lat": "45.82486",
        "long": "25.874475"
      },
      {
        "name": "SANZIENI",
        "zip": "527150",
        "lat": "46.044553",
        "long": "26.130474"
      },
      {
        "name": "SARAMAS",
        "zip": "527012",
        "lat": "45.698777",
        "long": "26.049464"
      },
      {
        "name": "SCRADOASA",
        "zip": "525303",
        "lat": "45.719734",
        "long": "26.007726"
      },
      {
        "name": "SFANTU GHEORGHE",
        "zip": "520003",
        "lat": "45.861728",
        "long": "25.789396"
      },
      {
        "name": "SITA BUZAULUI",
        "zip": "527155",
        "lat": "45.652555",
        "long": "26.067549"
      },
      {
        "name": "SURCEA",
        "zip": "527192",
        "lat": "45.880264",
        "long": "26.08018"
      },
      {
        "name": "TALISOARA",
        "zip": "527058",
        "lat": "46.104942",
        "long": "25.588747"
      },
      {
        "name": "TAMASFALAU",
        "zip": "527193",
        "lat": "45.884381",
        "long": "26.115867"
      },
      {
        "name": "TARGU SECUIESC",
        "zip": "525400",
        "lat": "45.998897",
        "long": "26.135312"
      },
      {
        "name": "TELECHIA",
        "zip": "527052",
        "lat": "45.85904",
        "long": "26.042329"
      },
      {
        "name": "TUFALAU",
        "zip": "527044",
        "lat": "45.835923",
        "long": "26.023677"
      },
      {
        "name": "TURIA",
        "zip": "527160",
        "lat": "46.041076",
        "long": "26.053488"
      },
      {
        "name": "VALCELE",
        "zip": "527175",
        "lat": "45.852876",
        "long": "25.681602"
      },
      {
        "name": "VALEA CRISULUI",
        "zip": "527165",
        "lat": "45.916785",
        "long": "25.779212"
      },
      {
        "name": "VALEA DOBARLAULUI",
        "zip": "527088",
        "lat": "45.730505",
        "long": "25.935006"
      },
      {
        "name": "VALEA MARE",
        "zip": "527170",
        "lat": "45.76389",
        "long": "26.014347"
      },
      {
        "name": "VALEA MICA",
        "zip": "527046",
        "lat": "45.781644",
        "long": "25.993138"
      },
      {
        "name": "VALEA SCURTA",
        "zip": "527144",
        "lat": "46.10351",
        "long": "26.198266"
      },
      {
        "name": "VALEA SEACA",
        "zip": "527153",
        "lat": "46.08446",
        "long": "26.119934"
      },
      {
        "name": "VALEA ZALANULUI",
        "zip": "527119",
        "lat": "46.011362",
        "long": "25.755391"
      },
      {
        "name": "VARGHIS",
        "zip": "527180",
        "lat": "46.127777",
        "long": "25.556739"
      },
      {
        "name": "ZABALA",
        "zip": "527190",
        "lat": "45.892322",
        "long": "26.18693"
      },
      {
        "name": "ZABRATAU",
        "zip": "527158",
        "lat": "45.616237",
        "long": "26.131326"
      },
      {
        "name": "ZAGON",
        "zip": "527185",
        "lat": "45.769682",
        "long": "26.113249"
      },
      {
        "name": "ZALAN",
        "zip": "527037",
        "lat": "45.959955",
        "long": "25.817403"
      },
      {
        "name": "ZOLTAN",
        "zip": "527098",
        "lat": "45.922456",
        "long": "25.852168"
      }
    ],
    "DÂMBOVIȚA": [
      {
        "name": "ADANCA",
        "zip": "137241",
        "lat": "44.922424",
        "long": "25.609887"
      },
      {
        "name": "ALUNIS",
        "zip": "137021",
        "lat": "45.085711",
        "long": "25.310622"
      },
      {
        "name": "ALUNISU",
        "zip": "137146",
        "lat": "44.722392",
        "long": "25.727325"
      },
      {
        "name": "ANINOASA",
        "zip": "137005",
        "lat": "44.972559",
        "long": "25.435323"
      },
      {
        "name": "ANINOSANI",
        "zip": "137081",
        "lat": "45.069493",
        "long": "25.229548"
      },
      {
        "name": "BACESTI",
        "zip": "137466",
        "lat": "45.080136",
        "long": "25.574676"
      },
      {
        "name": "BADENI",
        "zip": "137401",
        "lat": "45.152717",
        "long": "25.402631"
      },
      {
        "name": "BADULESTI",
        "zip": "137171",
        "lat": "44.76098",
        "long": "25.270702"
      },
      {
        "name": "BALANESTI",
        "zip": "137386",
        "lat": "44.68003",
        "long": "25.748475"
      },
      {
        "name": "BALDANA",
        "zip": "137436",
        "lat": "44.602602",
        "long": "25.778965"
      },
      {
        "name": "BALENI-ROMANI",
        "zip": "137015",
        "lat": "44.817391",
        "long": "25.659507"
      },
      {
        "name": "BALENI-SARBI",
        "zip": "137011",
        "lat": "44.818948",
        "long": "25.64541"
      },
      {
        "name": "BALTENI",
        "zip": "137126",
        "lat": "44.664884",
        "long": "25.693395"
      },
      {
        "name": "BANESTI",
        "zip": "137411",
        "lat": "44.735946",
        "long": "25.571379"
      },
      {
        "name": "BARACENI",
        "zip": "137136",
        "lat": "44.545284",
        "long": "25.457854"
      },
      {
        "name": "BARBUCEANU",
        "zip": "137076",
        "lat": "44.704907",
        "long": "25.919315"
      },
      {
        "name": "BARBULETU",
        "zip": "137020",
        "lat": "45.143409",
        "long": "25.294993"
      },
      {
        "name": "BECHINESTI",
        "zip": "137221",
        "lat": "44.790441",
        "long": "25.818761"
      },
      {
        "name": "BELA",
        "zip": "135401",
        "lat": "45.100883",
        "long": "25.435317"
      },
      {
        "name": "BEREVOESTI",
        "zip": "135101",
        "lat": "45.117335",
        "long": "25.423366"
      },
      {
        "name": "BEZDEAD",
        "zip": "137035",
        "lat": "45.151916",
        "long": "25.520887"
      },
      {
        "name": "BILCIURESTI",
        "zip": "137045",
        "lat": "44.739966",
        "long": "25.813047"
      },
      {
        "name": "BLIDARI",
        "zip": "137096",
        "lat": "44.816711",
        "long": "25.324469"
      },
      {
        "name": "BOBOCI",
        "zip": "137201",
        "lat": "44.798144",
        "long": "25.394636"
      },
      {
        "name": "BOLOVANI",
        "zip": "137147",
        "lat": "44.725195",
        "long": "25.634322"
      },
      {
        "name": "BOTENI",
        "zip": "137127",
        "lat": "44.664954",
        "long": "25.629243"
      },
      {
        "name": "BRADATEL",
        "zip": "137381",
        "lat": "45.186503",
        "long": "25.298541"
      },
      {
        "name": "BRANCOVEANU",
        "zip": "137346",
        "lat": "44.607595",
        "long": "25.535486"
      },
      {
        "name": "BRANESTI",
        "zip": "137055",
        "lat": "45.038569",
        "long": "25.416613"
      },
      {
        "name": "BRANISTEA",
        "zip": "137050",
        "lat": "44.679611",
        "long": "25.577292"
      },
      {
        "name": "BRATESTII DE JOS",
        "zip": "137496",
        "lat": "44.820746",
        "long": "25.533877"
      },
      {
        "name": "BREBU",
        "zip": "137402",
        "lat": "45.190837",
        "long": "25.341355"
      },
      {
        "name": "BREZOAELE",
        "zip": "137060",
        "lat": "44.575892",
        "long": "25.747894"
      },
      {
        "name": "BREZOAIA",
        "zip": "137061",
        "lat": "44.562768",
        "long": "25.768677"
      },
      {
        "name": "BROSTENI",
        "zip": "137036",
        "lat": "45.123899",
        "long": "25.467142"
      },
      {
        "name": "BROSTENI",
        "zip": "137376",
        "lat": "44.718775",
        "long": "25.505052"
      },
      {
        "name": "BROSTENI",
        "zip": "137516",
        "lat": "44.606289",
        "long": "25.347965"
      },
      {
        "name": "BUCIUMENI",
        "zip": "137065",
        "lat": "45.153258",
        "long": "25.45565"
      },
      {
        "name": "BUCSANI",
        "zip": "137070",
        "lat": "44.866532",
        "long": "25.647542"
      },
      {
        "name": "BUJOREANCA",
        "zip": "137151",
        "lat": "44.730587",
        "long": "25.890706"
      },
      {
        "name": "BUMBUIA",
        "zip": "137236",
        "lat": "44.783809",
        "long": "25.318225"
      },
      {
        "name": "BUNGETU",
        "zip": "137497",
        "lat": "44.843557",
        "long": "25.536123"
      },
      {
        "name": "BURDUCA",
        "zip": "137202",
        "lat": "44.742392",
        "long": "25.405294"
      },
      {
        "name": "BUTIMANU",
        "zip": "137075",
        "lat": "44.692932",
        "long": "25.896139"
      },
      {
        "name": "BUTOIU DE JOS",
        "zip": "137251",
        "lat": "44.838052",
        "long": "25.267587"
      },
      {
        "name": "BUTOIU DE SUS",
        "zip": "137252",
        "lat": "44.860409",
        "long": "25.286463"
      },
      {
        "name": "CALUGARENI",
        "zip": "137097",
        "lat": "44.796506",
        "long": "25.338368"
      },
      {
        "name": "CALUGARENI",
        "zip": "137128",
        "lat": "44.691463",
        "long": "25.700942"
      },
      {
        "name": "CANDESTI-DEAL",
        "zip": "137082",
        "lat": "45.057844",
        "long": "25.184432"
      },
      {
        "name": "CANDESTI-VALE",
        "zip": "137083",
        "lat": "45.085885",
        "long": "25.214426"
      },
      {
        "name": "CAPRIORU",
        "zip": "137441",
        "lat": "44.982192",
        "long": "25.28125"
      },
      {
        "name": "CAPSUNA",
        "zip": "137098",
        "lat": "44.819986",
        "long": "25.33832"
      },
      {
        "name": "CAPU COASTEI",
        "zip": "137286",
        "lat": "45.148514",
        "long": "25.221326"
      },
      {
        "name": "CARLANESTI",
        "zip": "137506",
        "lat": "45.096729",
        "long": "25.491249"
      },
      {
        "name": "CATANELE",
        "zip": "137237",
        "lat": "44.750925",
        "long": "25.309862"
      },
      {
        "name": "CATUNU",
        "zip": "137152",
        "lat": "44.742096",
        "long": "25.899532"
      },
      {
        "name": "CATUNU",
        "zip": "137412",
        "lat": "44.736756",
        "long": "25.503647"
      },
      {
        "name": "CAZACI",
        "zip": "137336",
        "lat": "44.801525",
        "long": "25.55405"
      },
      {
        "name": "CETATUIA",
        "zip": "137022",
        "lat": "45.147812",
        "long": "25.295212"
      },
      {
        "name": "CHIRCA",
        "zip": "137306",
        "lat": "44.683129",
        "long": "25.382775"
      },
      {
        "name": "CIOCANARI",
        "zip": "137331",
        "lat": "44.69764",
        "long": "25.976435"
      },
      {
        "name": "CIOCANESTI",
        "zip": "137090",
        "lat": "44.60295",
        "long": "25.869647"
      },
      {
        "name": "COADA IZVORULUI",
        "zip": "137351",
        "lat": "44.637792",
        "long": "25.363108"
      },
      {
        "name": "COBIUTA",
        "zip": "137099",
        "lat": "44.806464",
        "long": "25.336103"
      },
      {
        "name": "COCANI",
        "zip": "137181",
        "lat": "44.628476",
        "long": "25.894721"
      },
      {
        "name": "COJASCA",
        "zip": "137115",
        "lat": "44.724271",
        "long": "25.852472"
      },
      {
        "name": "COJOCARU",
        "zip": "137307",
        "lat": "44.694412",
        "long": "25.381174"
      },
      {
        "name": "COJOIU",
        "zip": "137507",
        "lat": "45.112678",
        "long": "25.525313"
      },
      {
        "name": "COLACU",
        "zip": "137387",
        "lat": "44.668945",
        "long": "25.758811"
      },
      {
        "name": "COLANU",
        "zip": "137456",
        "lat": "44.893371",
        "long": "25.460742"
      },
      {
        "name": "COLIBASI",
        "zip": "137261",
        "lat": "45.032445",
        "long": "25.624057"
      },
      {
        "name": "COMISANI",
        "zip": "137120",
        "lat": "44.871962",
        "long": "25.590537"
      },
      {
        "name": "CONTESTI",
        "zip": "137125",
        "lat": "44.683852",
        "long": "25.637261"
      },
      {
        "name": "COPACENI",
        "zip": "137287",
        "lat": "45.171309",
        "long": "25.24409"
      },
      {
        "name": "CORBII MARI",
        "zip": "137135",
        "lat": "44.54249",
        "long": "25.496239"
      },
      {
        "name": "CORNATELU",
        "zip": "137145",
        "lat": "44.750461",
        "long": "25.671739"
      },
      {
        "name": "CORNESTI",
        "zip": "137150",
        "lat": "44.769712",
        "long": "25.886657"
      },
      {
        "name": "CORNI",
        "zip": "137148",
        "lat": "44.731429",
        "long": "25.686131"
      },
      {
        "name": "COSTESTI",
        "zip": "135102",
        "lat": "45.145101",
        "long": "25.390266"
      },
      {
        "name": "COSTESTII DIN DEAL",
        "zip": "137377",
        "lat": "44.678989",
        "long": "25.490509"
      },
      {
        "name": "COSTESTII DIN VALE",
        "zip": "137165",
        "lat": "44.649348",
        "long": "25.492679"
      },
      {
        "name": "COSTISATA",
        "zip": "137037",
        "lat": "45.171827",
        "long": "25.555562"
      },
      {
        "name": "CRACIUNESTI",
        "zip": "137101",
        "lat": "44.808378",
        "long": "25.343346"
      },
      {
        "name": "CRANGASI",
        "zip": "137129",
        "lat": "44.702235",
        "long": "25.626616"
      },
      {
        "name": "CRANGURILE DE JOS",
        "zip": "137172",
        "lat": "44.747355",
        "long": "25.257156"
      },
      {
        "name": "CRANGURILE DE SUS",
        "zip": "137173",
        "lat": "44.766924",
        "long": "25.245274"
      },
      {
        "name": "CRETU",
        "zip": "137091",
        "lat": "44.625646",
        "long": "25.827227"
      },
      {
        "name": "CRETULESTI",
        "zip": "137296",
        "lat": "44.694264",
        "long": "25.434992"
      },
      {
        "name": "CREVEDIA",
        "zip": "137180",
        "lat": "44.59952",
        "long": "25.915995"
      },
      {
        "name": "CRICOVU DULCE",
        "zip": "137262",
        "lat": "45.021934",
        "long": "25.629298"
      },
      {
        "name": "CRISTEASCA",
        "zip": "137153",
        "lat": "44.797261",
        "long": "25.902888"
      },
      {
        "name": "CRIVATU",
        "zip": "137154",
        "lat": "44.756008",
        "long": "25.926884"
      },
      {
        "name": "CROITORI",
        "zip": "137446",
        "lat": "44.574695",
        "long": "25.413565"
      },
      {
        "name": "CROVU",
        "zip": "137347",
        "lat": "44.589936",
        "long": "25.53711"
      },
      {
        "name": "CUCUTENI",
        "zip": "137326",
        "lat": "45.114601",
        "long": "25.401036"
      },
      {
        "name": "CUPARU",
        "zip": "137203",
        "lat": "44.722983",
        "long": "25.400747"
      },
      {
        "name": "CUZA VODA",
        "zip": "137413",
        "lat": "44.738983",
        "long": "25.60011"
      },
      {
        "name": "DAMBOVICIOARA",
        "zip": "137051",
        "lat": "44.675051",
        "long": "25.552777"
      },
      {
        "name": "DARMANESTI",
        "zip": "137185",
        "lat": "44.916777",
        "long": "25.766495"
      },
      {
        "name": "DARZA",
        "zip": "137182",
        "lat": "44.600842",
        "long": "25.948506"
      },
      {
        "name": "DEALU FRUMOS",
        "zip": "137361",
        "lat": "45.185775",
        "long": "25.41289"
      },
      {
        "name": "DEALU MARE",
        "zip": "137066",
        "lat": "45.160564",
        "long": "25.448329"
      },
      {
        "name": "DECINDEA",
        "zip": "137092",
        "lat": "44.609217",
        "long": "25.87503"
      },
      {
        "name": "DECINDENI",
        "zip": "137211",
        "lat": "44.908493",
        "long": "25.328114"
      },
      {
        "name": "DIACONESTI",
        "zip": "135402",
        "lat": "45.091968",
        "long": "25.452651"
      },
      {
        "name": "DIMOIU",
        "zip": "137457",
        "lat": "44.904196",
        "long": "25.548447"
      },
      {
        "name": "DOBRA",
        "zip": "137190",
        "lat": "44.785911",
        "long": "25.717998"
      },
      {
        "name": "DOBRESTI",
        "zip": "137311",
        "lat": "45.294004",
        "long": "25.406699"
      },
      {
        "name": "DOICESTI",
        "zip": "137195",
        "lat": "44.995966",
        "long": "25.399687"
      },
      {
        "name": "DOSPINESTI",
        "zip": "137521",
        "lat": "45.102145",
        "long": "25.562257"
      },
      {
        "name": "DRAGAESTI-PAMANTENI",
        "zip": "137291",
        "lat": "44.931565",
        "long": "25.30919"
      },
      {
        "name": "DRAGAESTI-UNGURENI",
        "zip": "137292",
        "lat": "44.953026",
        "long": "25.308318"
      },
      {
        "name": "DRAGODANA",
        "zip": "137200",
        "lat": "44.732508",
        "long": "25.365247"
      },
      {
        "name": "DRAGODANESTI",
        "zip": "137084",
        "lat": "45.055501",
        "long": "25.235294"
      },
      {
        "name": "DRAGOMIRESTI",
        "zip": "137210",
        "lat": "44.91448",
        "long": "25.343162"
      },
      {
        "name": "DUMBRAVA",
        "zip": "137458",
        "lat": "44.890388",
        "long": "25.437307"
      },
      {
        "name": "DUPA DEAL",
        "zip": "137023",
        "lat": "45.111695",
        "long": "25.291255"
      },
      {
        "name": "FAGETU",
        "zip": "137238",
        "lat": "44.755817",
        "long": "25.327279"
      },
      {
        "name": "FANTANELE",
        "zip": "137116",
        "lat": "44.712606",
        "long": "25.881199"
      },
      {
        "name": "FERESTRE",
        "zip": "137403",
        "lat": "45.181454",
        "long": "25.394515"
      },
      {
        "name": "FETENI",
        "zip": "137486",
        "lat": "44.773739",
        "long": "25.220609"
      },
      {
        "name": "FIENI",
        "zip": "135100",
        "lat": "45.130649",
        "long": "25.419574"
      },
      {
        "name": "FIERBINTI",
        "zip": "137426",
        "lat": "44.507539",
        "long": "25.287564"
      },
      {
        "name": "FINTA MARE",
        "zip": "137222",
        "lat": "44.790712",
        "long": "25.794975"
      },
      {
        "name": "FINTA VECHE",
        "zip": "137223",
        "lat": "44.791311",
        "long": "25.836201"
      },
      {
        "name": "FRASIN-DEAL",
        "zip": "137102",
        "lat": "44.827041",
        "long": "25.319483"
      },
      {
        "name": "FRASIN-VALE",
        "zip": "137103",
        "lat": "44.830706",
        "long": "25.335585"
      },
      {
        "name": "FRASINU",
        "zip": "137156",
        "lat": "44.791779",
        "long": "25.862388"
      },
      {
        "name": "FUSEA",
        "zip": "135501",
        "lat": "44.656208",
        "long": "25.535625"
      },
      {
        "name": "GAESTI",
        "zip": "135200",
        "lat": "44.720588",
        "long": "25.319407"
      },
      {
        "name": "GAMANESTI",
        "zip": "137131",
        "lat": "44.65454",
        "long": "25.711566"
      },
      {
        "name": "GARLENI",
        "zip": "137487",
        "lat": "44.799692",
        "long": "25.258369"
      },
      {
        "name": "GEANGOESTI",
        "zip": "137212",
        "lat": "44.893932",
        "long": "25.378524"
      },
      {
        "name": "GEMENEA-BRATULESTI",
        "zip": "137526",
        "lat": "45.106638",
        "long": "25.228337"
      },
      {
        "name": "GHEBOAIA",
        "zip": "137224",
        "lat": "44.801878",
        "long": "25.748552"
      },
      {
        "name": "GHEBOIENI",
        "zip": "137442",
        "lat": "44.982223",
        "long": "25.30573"
      },
      {
        "name": "GHERGANI",
        "zip": "137388",
        "lat": "44.635973",
        "long": "25.722999"
      },
      {
        "name": "GHERGHESTI",
        "zip": "137352",
        "lat": "44.679356",
        "long": "25.311676"
      },
      {
        "name": "GHERGHITESTI",
        "zip": "137104",
        "lat": "44.789962",
        "long": "25.333642"
      },
      {
        "name": "GHIMPATI",
        "zip": "137389",
        "lat": "44.654091",
        "long": "25.79127"
      },
      {
        "name": "GHINESTI",
        "zip": "137414",
        "lat": "44.747325",
        "long": "25.553285"
      },
      {
        "name": "GHIRDOVENI",
        "zip": "137256",
        "lat": "44.941456",
        "long": "25.670012"
      },
      {
        "name": "GLOD",
        "zip": "137312",
        "lat": "45.241783",
        "long": "25.450186"
      },
      {
        "name": "GLODENI",
        "zip": "135403",
        "lat": "45.063471",
        "long": "25.452238"
      },
      {
        "name": "GLODENI",
        "zip": "137225",
        "lat": "45.019065",
        "long": "25.465446"
      },
      {
        "name": "GLOGOVEANU",
        "zip": "137427",
        "lat": "44.484778",
        "long": "25.346117"
      },
      {
        "name": "GORGOTA",
        "zip": "137396",
        "lat": "44.975842",
        "long": "25.508251"
      },
      {
        "name": "GRECI",
        "zip": "137353",
        "lat": "44.661587",
        "long": "25.341287"
      },
      {
        "name": "GROZAVESTI",
        "zip": "137137",
        "lat": "44.568823",
        "long": "25.453597"
      },
      {
        "name": "GULIA",
        "zip": "137437",
        "lat": "44.546923",
        "long": "25.87166"
      },
      {
        "name": "GURA BARBULETULUI",
        "zip": "137024",
        "lat": "45.121435",
        "long": "25.30065"
      },
      {
        "name": "GURA FOII",
        "zip": "137235",
        "lat": "44.754504",
        "long": "25.293707"
      },
      {
        "name": "GURA OCNITEI",
        "zip": "137240",
        "lat": "44.941662",
        "long": "25.568461"
      },
      {
        "name": "GURA SUTII",
        "zip": "137245",
        "lat": "44.757105",
        "long": "25.499269"
      },
      {
        "name": "GURA VULCANEI",
        "zip": "137541",
        "lat": "45.032504",
        "long": "25.393609"
      },
      {
        "name": "GUSOIU",
        "zip": "137226",
        "lat": "45.012189",
        "long": "25.457074"
      },
      {
        "name": "HABENI",
        "zip": "137071",
        "lat": "44.856048",
        "long": "25.626854"
      },
      {
        "name": "HAGIOAICA",
        "zip": "135502",
        "lat": "44.668205",
        "long": "25.541031"
      },
      {
        "name": "HANU LUI PALA",
        "zip": "137447",
        "lat": "44.548935",
        "long": "25.382266"
      },
      {
        "name": "HELESTEU",
        "zip": "137132",
        "lat": "44.672495",
        "long": "25.680559"
      },
      {
        "name": "HODARASTI",
        "zip": "137157",
        "lat": "44.752071",
        "long": "25.892888"
      },
      {
        "name": "HULUBESTI",
        "zip": "137250",
        "lat": "44.846225",
        "long": "25.25137"
      },
      {
        "name": "I. L. CARAGIALE",
        "zip": "137255",
        "lat": "44.911532",
        "long": "25.702744"
      },
      {
        "name": "IAZU",
        "zip": "137117",
        "lat": "44.717662",
        "long": "25.830867"
      },
      {
        "name": "IBRIANU",
        "zip": "137158",
        "lat": "44.775091",
        "long": "25.843748"
      },
      {
        "name": "IEDERA DE JOS",
        "zip": "137263",
        "lat": "45.026515",
        "long": "25.635285"
      },
      {
        "name": "IEDERA DE SUS",
        "zip": "137264",
        "lat": "45.041743",
        "long": "25.630837"
      },
      {
        "name": "ILFOVENI",
        "zip": "137337",
        "lat": "44.827481",
        "long": "25.561684"
      },
      {
        "name": "IONESTI",
        "zip": "137354",
        "lat": "44.694156",
        "long": "25.277474"
      },
      {
        "name": "IZVOARELE",
        "zip": "137527",
        "lat": "45.043708",
        "long": "25.28424"
      },
      {
        "name": "IZVORU",
        "zip": "137467",
        "lat": "45.076051",
        "long": "25.528614"
      },
      {
        "name": "IZVORU",
        "zip": "137517",
        "lat": "44.609598",
        "long": "25.371995"
      },
      {
        "name": "JUGURENI",
        "zip": "137448",
        "lat": "44.622527",
        "long": "25.402949"
      },
      {
        "name": "LACULETE",
        "zip": "137227",
        "lat": "45.019839",
        "long": "25.434254"
      },
      {
        "name": "LACULETE-GARA",
        "zip": "137542",
        "lat": "45.016935",
        "long": "25.409204"
      },
      {
        "name": "LAZURI",
        "zip": "137121",
        "lat": "44.87842",
        "long": "25.549407"
      },
      {
        "name": "LIVEZILE",
        "zip": "137228",
        "lat": "45.014494",
        "long": "25.468927"
      },
      {
        "name": "LIVEZILE",
        "zip": "137488",
        "lat": "44.778306",
        "long": "25.250554"
      },
      {
        "name": "LUCIANCA",
        "zip": "137077",
        "lat": "44.67437",
        "long": "25.894569"
      },
      {
        "name": "LUCIENI",
        "zip": "137265",
        "lat": "44.847765",
        "long": "25.441864"
      },
      {
        "name": "LUDESTI",
        "zip": "137270",
        "lat": "44.873847",
        "long": "25.244579"
      },
      {
        "name": "LUNCA",
        "zip": "137313",
        "lat": "45.200218",
        "long": "25.443512"
      },
      {
        "name": "LUNCA",
        "zip": "137528",
        "lat": "45.046807",
        "long": "25.268692"
      },
      {
        "name": "LUNGULETU",
        "zip": "137280",
        "lat": "44.611948",
        "long": "25.66213"
      },
      {
        "name": "MAGURA",
        "zip": "137038",
        "lat": "45.12707",
        "long": "25.472158"
      },
      {
        "name": "MAGURA",
        "zip": "137253",
        "lat": "44.834254",
        "long": "25.235304"
      },
      {
        "name": "MALU CU FLORI",
        "zip": "137285",
        "lat": "45.148775",
        "long": "25.215801"
      },
      {
        "name": "MALU MIERII",
        "zip": "137229",
        "lat": "45.019442",
        "long": "25.476209"
      },
      {
        "name": "MALURILE",
        "zip": "135404",
        "lat": "45.059302",
        "long": "25.473192"
      },
      {
        "name": "MANASTIOARA",
        "zip": "137449",
        "lat": "44.612691",
        "long": "25.425266"
      },
      {
        "name": "MANASTIREA",
        "zip": "137106",
        "lat": "44.769603",
        "long": "25.330715"
      },
      {
        "name": "MANASTIREA",
        "zip": "137183",
        "lat": "44.581327",
        "long": "25.928838"
      },
      {
        "name": "MANESTI",
        "zip": "137290",
        "lat": "44.96543",
        "long": "25.287255"
      },
      {
        "name": "MANGA",
        "zip": "137529",
        "lat": "45.069748",
        "long": "25.276551"
      },
      {
        "name": "MANJINA",
        "zip": "137531",
        "lat": "45.059663",
        "long": "25.278597"
      },
      {
        "name": "MARCESTI",
        "zip": "137191",
        "lat": "44.805783",
        "long": "25.709007"
      },
      {
        "name": "MARGINENII DE SUS",
        "zip": "137186",
        "lat": "44.931724",
        "long": "25.752278"
      },
      {
        "name": "MARUNTISU",
        "zip": "137166",
        "lat": "44.627501",
        "long": "25.506651"
      },
      {
        "name": "MATASARU",
        "zip": "137295",
        "lat": "44.70899",
        "long": "25.429538"
      },
      {
        "name": "MATRACA",
        "zip": "137459",
        "lat": "44.89526",
        "long": "25.51716"
      },
      {
        "name": "MAVRODIN",
        "zip": "137391",
        "lat": "44.649024",
        "long": "25.717161"
      },
      {
        "name": "MEISOARE",
        "zip": "137382",
        "lat": "45.19806",
        "long": "25.260144"
      },
      {
        "name": "MERENI",
        "zip": "135503",
        "lat": "44.657881",
        "long": "25.576883"
      },
      {
        "name": "MERENI",
        "zip": "137133",
        "lat": "44.696305",
        "long": "25.712333"
      },
      {
        "name": "MERII",
        "zip": "137308",
        "lat": "44.694145",
        "long": "25.362163"
      },
      {
        "name": "MERISORU",
        "zip": "137508",
        "lat": "45.096447",
        "long": "25.5303"
      },
      {
        "name": "MESTEACAN",
        "zip": "137501",
        "lat": "45.186656",
        "long": "25.178301"
      },
      {
        "name": "MICLOSANII MARI",
        "zip": "137288",
        "lat": "45.161956",
        "long": "25.227889"
      },
      {
        "name": "MICLOSANII MICI",
        "zip": "137289",
        "lat": "45.150327",
        "long": "25.256872"
      },
      {
        "name": "MICULESTI",
        "zip": "135405",
        "lat": "45.094139",
        "long": "25.445456"
      },
      {
        "name": "MIJA",
        "zip": "137257",
        "lat": "44.913693",
        "long": "25.674774"
      },
      {
        "name": "MILOSARI",
        "zip": "137271",
        "lat": "44.875999",
        "long": "25.235376"
      },
      {
        "name": "MIRCEA VODA",
        "zip": "137416",
        "lat": "44.766922",
        "long": "25.588437"
      },
      {
        "name": "MISLEA",
        "zip": "137107",
        "lat": "44.840883",
        "long": "25.332126"
      },
      {
        "name": "MIULESTI",
        "zip": "137348",
        "lat": "44.600037",
        "long": "25.514657"
      },
      {
        "name": "MOARA DIN GROAPA",
        "zip": "137138",
        "lat": "44.534525",
        "long": "25.474614"
      },
      {
        "name": "MOARA NOUA",
        "zip": "137417",
        "lat": "44.709638",
        "long": "25.60463"
      },
      {
        "name": "MOGOSANI",
        "zip": "137305",
        "lat": "44.681892",
        "long": "25.405154"
      },
      {
        "name": "MOGOSESTI",
        "zip": "137213",
        "lat": "44.881101",
        "long": "25.397922"
      },
      {
        "name": "MORENI",
        "zip": "135300",
        "lat": "44.983068",
        "long": "25.645355"
      },
      {
        "name": "MOROENI",
        "zip": "137310",
        "lat": "45.214377",
        "long": "25.437079"
      },
      {
        "name": "MORTENI",
        "zip": "137320",
        "lat": "44.665099",
        "long": "25.237454"
      },
      {
        "name": "MOSIA MICA",
        "zip": "137468",
        "lat": "45.070729",
        "long": "25.546124"
      },
      {
        "name": "MOTAIENI",
        "zip": "137325",
        "lat": "45.096728",
        "long": "25.41924"
      },
      {
        "name": "MOVILA",
        "zip": "137418",
        "lat": "44.767821",
        "long": "25.571967"
      },
      {
        "name": "MOVILA",
        "zip": "137332",
        "lat": "44.674973",
        "long": "25.967785"
      },
      {
        "name": "MUSCEL",
        "zip": "137314",
        "lat": "45.227079",
        "long": "25.496385"
      },
      {
        "name": "NEAJLOVU",
        "zip": "137321",
        "lat": "44.659284",
        "long": "25.266352"
      },
      {
        "name": "NICOLAESTI",
        "zip": "137536",
        "lat": "45.08718",
        "long": "25.374905"
      },
      {
        "name": "NICULESTI",
        "zip": "137330",
        "lat": "44.686258",
        "long": "25.945543"
      },
      {
        "name": "NISIPURILE",
        "zip": "137461",
        "lat": "44.911249",
        "long": "25.534933"
      },
      {
        "name": "NUCET",
        "zip": "137335",
        "lat": "44.780733",
        "long": "25.546536"
      },
      {
        "name": "OCHIURI",
        "zip": "137242",
        "lat": "44.962367",
        "long": "25.542585"
      },
      {
        "name": "OCNITA",
        "zip": "137340",
        "lat": "44.988747",
        "long": "25.554571"
      },
      {
        "name": "ODAIA TURCULUI",
        "zip": "137297",
        "lat": "44.697799",
        "long": "25.450456"
      },
      {
        "name": "ODOBESTI",
        "zip": "137345",
        "lat": "44.614896",
        "long": "25.559195"
      },
      {
        "name": "OLTENI",
        "zip": "137266",
        "lat": "44.847166",
        "long": "25.39766"
      },
      {
        "name": "OLTENI",
        "zip": "137451",
        "lat": "44.628556",
        "long": "25.406988"
      },
      {
        "name": "ONCESTI",
        "zip": "137532",
        "lat": "45.110712",
        "long": "25.212484"
      },
      {
        "name": "OREASCA",
        "zip": "137281",
        "lat": "44.609327",
        "long": "25.633776"
      },
      {
        "name": "PADURENI",
        "zip": "137204",
        "lat": "44.802429",
        "long": "25.381542"
      },
      {
        "name": "PATROAIA-DEAL",
        "zip": "137174",
        "lat": "44.719304",
        "long": "25.205687"
      },
      {
        "name": "PATROAIA-VALE",
        "zip": "137176",
        "lat": "44.726015",
        "long": "25.230155"
      },
      {
        "name": "PERSINARI",
        "zip": "137498",
        "lat": "44.801854",
        "long": "25.498799"
      },
      {
        "name": "PETRESTI",
        "zip": "137350",
        "lat": "44.648384",
        "long": "25.338824"
      },
      {
        "name": "PETRESTI",
        "zip": "137139",
        "lat": "44.557697",
        "long": "25.447555"
      },
      {
        "name": "PIATRA",
        "zip": "137404",
        "lat": "45.167158",
        "long": "25.395876"
      },
      {
        "name": "PICIOR DE MUNTE",
        "zip": "137206",
        "lat": "44.782502",
        "long": "25.3902"
      },
      {
        "name": "PIETRARI",
        "zip": "137026",
        "lat": "45.093694",
        "long": "25.291435"
      },
      {
        "name": "PIETROSITA",
        "zip": "137360",
        "lat": "45.189535",
        "long": "25.443109"
      },
      {
        "name": "PITARU",
        "zip": "137371",
        "lat": "44.590615",
        "long": "25.584072"
      },
      {
        "name": "PLOPU",
        "zip": "135504",
        "lat": "44.651133",
        "long": "25.52624"
      },
      {
        "name": "PODU CORBENCII",
        "zip": "137141",
        "lat": "44.556764",
        "long": "25.528444"
      },
      {
        "name": "PODU CRISTINII",
        "zip": "137372",
        "lat": "44.566772",
        "long": "25.606225"
      },
      {
        "name": "PODU RIZII",
        "zip": "137419",
        "lat": "44.70724",
        "long": "25.583052"
      },
      {
        "name": "POIANA",
        "zip": "137365",
        "lat": "44.566582",
        "long": "25.676837"
      },
      {
        "name": "POIENITA",
        "zip": "137366",
        "lat": "44.580921",
        "long": "25.676077"
      },
      {
        "name": "POROINICA",
        "zip": "137298",
        "lat": "44.663681",
        "long": "25.446106"
      },
      {
        "name": "POSTARNACU",
        "zip": "137159",
        "lat": "44.805552",
        "long": "25.876232"
      },
      {
        "name": "POTLOGENI-DEAL",
        "zip": "137356",
        "lat": "44.704272",
        "long": "25.259535"
      },
      {
        "name": "POTLOGENI-VALE",
        "zip": "137177",
        "lat": "44.72135",
        "long": "25.256781"
      },
      {
        "name": "POTLOGI",
        "zip": "137370",
        "lat": "44.560632",
        "long": "25.587972"
      },
      {
        "name": "POTOCELU",
        "zip": "137272",
        "lat": "44.888151",
        "long": "25.246775"
      },
      {
        "name": "PRIBOIU",
        "zip": "137056",
        "lat": "45.028031",
        "long": "25.423822"
      },
      {
        "name": "PRIBOIU",
        "zip": "137443",
        "lat": "45.030058",
        "long": "25.257905"
      },
      {
        "name": "PRISEACA",
        "zip": "130001",
        "lat": "44.923767",
        "long": "25.403052"
      },
      {
        "name": "PRODULESTI",
        "zip": "137375",
        "lat": "44.707934",
        "long": "25.512529"
      },
      {
        "name": "PUCHENI",
        "zip": "137316",
        "lat": "45.230828",
        "long": "25.430148"
      },
      {
        "name": "PUCHENI",
        "zip": "137380",
        "lat": "45.184933",
        "long": "25.280047"
      },
      {
        "name": "PUCIOASA",
        "zip": "135400",
        "lat": "45.07615",
        "long": "25.434266"
      },
      {
        "name": "PUCIOASA-SAT",
        "zip": "135406",
        "lat": "45.0647",
        "long": "25.424725"
      },
      {
        "name": "PUNTEA DE GRECI",
        "zip": "137357",
        "lat": "44.647682",
        "long": "25.309187"
      },
      {
        "name": "PUTU CU SALCIE",
        "zip": "137299",
        "lat": "44.652661",
        "long": "25.456491"
      },
      {
        "name": "RACARI",
        "zip": "137385",
        "lat": "44.625133",
        "long": "25.743218"
      },
      {
        "name": "RACIU",
        "zip": "137267",
        "lat": "44.817907",
        "long": "25.441065"
      },
      {
        "name": "RACOVITA",
        "zip": "137072",
        "lat": "44.840022",
        "long": "25.619995"
      },
      {
        "name": "RAGU",
        "zip": "137452",
        "lat": "44.598008",
        "long": "25.401063"
      },
      {
        "name": "RANCACIOV",
        "zip": "137214",
        "lat": "44.889763",
        "long": "25.352964"
      },
      {
        "name": "RASCAETI",
        "zip": "137518",
        "lat": "44.592209",
        "long": "25.269895"
      },
      {
        "name": "RATESTI",
        "zip": "137178",
        "lat": "44.756879",
        "long": "25.255038"
      },
      {
        "name": "RATOAIA",
        "zip": "137073",
        "lat": "44.847829",
        "long": "25.682941"
      },
      {
        "name": "RAU ALB DE JOS",
        "zip": "137027",
        "lat": "45.136529",
        "long": "25.347446"
      },
      {
        "name": "RAU ALB DE SUS",
        "zip": "137028",
        "lat": "45.160475",
        "long": "25.326832"
      },
      {
        "name": "RAZVAD",
        "zip": "137395",
        "lat": "44.936905",
        "long": "25.533751"
      },
      {
        "name": "ROMANESTI",
        "zip": "137373",
        "lat": "44.56279",
        "long": "25.627914"
      },
      {
        "name": "RUNCU",
        "zip": "137400",
        "lat": "45.185792",
        "long": "25.378192"
      },
      {
        "name": "SABIESTI",
        "zip": "137392",
        "lat": "44.682786",
        "long": "25.758424"
      },
      {
        "name": "SACUENI",
        "zip": "137243",
        "lat": "44.910773",
        "long": "25.572232"
      },
      {
        "name": "SALCIOARA",
        "zip": "137301",
        "lat": "44.633031",
        "long": "25.44467"
      },
      {
        "name": "SALCIOARA",
        "zip": "137410",
        "lat": "44.717972",
        "long": "25.585696"
      },
      {
        "name": "SALCUTA",
        "zip": "135505",
        "lat": "44.643609",
        "long": "25.580569"
      },
      {
        "name": "SAMURCASI",
        "zip": "137184",
        "lat": "44.581127",
        "long": "25.909647"
      },
      {
        "name": "SARU",
        "zip": "137489",
        "lat": "44.804117",
        "long": "25.212424"
      },
      {
        "name": "SATENI",
        "zip": "137006",
        "lat": "44.971952",
        "long": "25.41747"
      },
      {
        "name": "SATU NOU",
        "zip": "137142",
        "lat": "44.596339",
        "long": "25.479128"
      },
      {
        "name": "SAVESTI",
        "zip": "137052",
        "lat": "44.68888",
        "long": "25.620346"
      },
      {
        "name": "SCHEIU DE JOS",
        "zip": "137273",
        "lat": "44.934598",
        "long": "25.199861"
      },
      {
        "name": "SCHEIU DE SUS",
        "zip": "137274",
        "lat": "44.95602",
        "long": "25.193168"
      },
      {
        "name": "SCHELA",
        "zip": "137231",
        "lat": "45.030361",
        "long": "25.475618"
      },
      {
        "name": "SELARU",
        "zip": "137425",
        "lat": "44.468968",
        "long": "25.304857"
      },
      {
        "name": "SERBANEASA",
        "zip": "137469",
        "lat": "45.07472",
        "long": "25.577858"
      },
      {
        "name": "SERDANU",
        "zip": "137282",
        "lat": "44.627323",
        "long": "25.631239"
      },
      {
        "name": "SILISTEA",
        "zip": "137268",
        "lat": "44.801867",
        "long": "25.452776"
      },
      {
        "name": "SILISTEA",
        "zip": "137406",
        "lat": "45.189487",
        "long": "25.381721"
      },
      {
        "name": "SIPOT",
        "zip": "137029",
        "lat": "45.098352",
        "long": "25.311197"
      },
      {
        "name": "SLOBOZIA",
        "zip": "137149",
        "lat": "44.724007",
        "long": "25.707621"
      },
      {
        "name": "SLOBOZIA MOARA",
        "zip": "137420",
        "lat": "44.600762",
        "long": "25.727778"
      },
      {
        "name": "SOTANGA",
        "zip": "137430",
        "lat": "44.988897",
        "long": "25.383125"
      },
      {
        "name": "SPERIETENI",
        "zip": "137246",
        "lat": "44.766114",
        "long": "25.452225"
      },
      {
        "name": "STANESTI",
        "zip": "137393",
        "lat": "44.68539",
        "long": "25.732687"
      },
      {
        "name": "STATESTI",
        "zip": "137509",
        "lat": "45.090962",
        "long": "25.489623"
      },
      {
        "name": "STAVROPOLIA",
        "zip": "137453",
        "lat": "44.638328",
        "long": "25.391836"
      },
      {
        "name": "STRAOSTI",
        "zip": "137207",
        "lat": "44.731204",
        "long": "25.350808"
      },
      {
        "name": "STRATONESTI",
        "zip": "137491",
        "lat": "44.818366",
        "long": "25.200422"
      },
      {
        "name": "STUBEIE TISA",
        "zip": "137471",
        "lat": "45.066403",
        "long": "25.516594"
      },
      {
        "name": "SUDULENI",
        "zip": "137533",
        "lat": "45.050395",
        "long": "25.281202"
      },
      {
        "name": "SULTANU",
        "zip": "137522",
        "lat": "45.110461",
        "long": "25.586979"
      },
      {
        "name": "SUSENI-SOCETU",
        "zip": "137046",
        "lat": "44.756256",
        "long": "25.797769"
      },
      {
        "name": "SUTA SEACA",
        "zip": "137269",
        "lat": "44.829672",
        "long": "25.409436"
      },
      {
        "name": "SUVITA",
        "zip": "137511",
        "lat": "45.083401",
        "long": "25.507782"
      },
      {
        "name": "TARGOVISTE",
        "zip": "130002",
        "lat": "44.926754",
        "long": "25.462862"
      },
      {
        "name": "TARTASESTI",
        "zip": "137435",
        "lat": "44.577142",
        "long": "25.816933"
      },
      {
        "name": "TATARANI",
        "zip": "137440",
        "lat": "45.003226",
        "long": "25.274404"
      },
      {
        "name": "TEIS",
        "zip": "137431",
        "lat": "44.963507",
        "long": "25.402858"
      },
      {
        "name": "TELESTI",
        "zip": "137276",
        "lat": "44.887798",
        "long": "25.230226"
      },
      {
        "name": "TETCOIU",
        "zip": "137302",
        "lat": "44.681885",
        "long": "25.438456"
      },
      {
        "name": "TITU",
        "zip": "135500",
        "lat": "44.662369",
        "long": "25.57387"
      },
      {
        "name": "TOCULESTI",
        "zip": "137543",
        "lat": "45.030382",
        "long": "25.387275"
      },
      {
        "name": "TOMSANI",
        "zip": "137167",
        "lat": "44.639944",
        "long": "25.504524"
      },
      {
        "name": "TUNARI",
        "zip": "137039",
        "lat": "45.132729",
        "long": "25.467347"
      },
      {
        "name": "UDRESTI",
        "zip": "137462",
        "lat": "44.88647",
        "long": "25.47529"
      },
      {
        "name": "ULIESTI",
        "zip": "137445",
        "lat": "44.588805",
        "long": "25.427684"
      },
      {
        "name": "ULMETU",
        "zip": "137512",
        "lat": "45.091384",
        "long": "25.47827"
      },
      {
        "name": "ULMI",
        "zip": "137455",
        "lat": "44.896086",
        "long": "25.501752"
      },
      {
        "name": "UNGURENI",
        "zip": "137143",
        "lat": "44.578041",
        "long": "25.500058"
      },
      {
        "name": "UNGURENI",
        "zip": "137161",
        "lat": "44.784709",
        "long": "25.898178"
      },
      {
        "name": "UNGURENI",
        "zip": "137216",
        "lat": "44.87143",
        "long": "25.390369"
      },
      {
        "name": "UNGURENI",
        "zip": "137078",
        "lat": "44.677306",
        "long": "25.912601"
      },
      {
        "name": "URSEIU",
        "zip": "137523",
        "lat": "45.13235",
        "long": "25.565347"
      },
      {
        "name": "URZICEANCA",
        "zip": "137093",
        "lat": "44.63161",
        "long": "25.840403"
      },
      {
        "name": "VACARESTI",
        "zip": "137495",
        "lat": "44.857243",
        "long": "25.487628"
      },
      {
        "name": "VADU STANCHII",
        "zip": "137144",
        "lat": "44.527901",
        "long": "25.48686"
      },
      {
        "name": "VALEA",
        "zip": "137031",
        "lat": "45.102245",
        "long": "25.258106"
      },
      {
        "name": "VALEA CASELOR",
        "zip": "137492",
        "lat": "44.800516",
        "long": "25.247035"
      },
      {
        "name": "VALEA DADEI",
        "zip": "137254",
        "lat": "44.825708",
        "long": "25.272298"
      },
      {
        "name": "VALEA LARGA",
        "zip": "137383",
        "lat": "45.16205",
        "long": "25.25311"
      },
      {
        "name": "VALEA LEURZII",
        "zip": "137067",
        "lat": "45.161736",
        "long": "25.484768"
      },
      {
        "name": "VALEA LUI DAN",
        "zip": "137476",
        "lat": "45.082058",
        "long": "25.591268"
      },
      {
        "name": "VALEA LUNGA-CRICOV",
        "zip": "137475",
        "lat": "45.066967",
        "long": "25.582186"
      },
      {
        "name": "VALEA LUNGA-GORGOTA",
        "zip": "137472",
        "lat": "45.065852",
        "long": "25.552275"
      },
      {
        "name": "VALEA LUNGA-OGREA",
        "zip": "137473",
        "lat": "45.059662",
        "long": "25.591005"
      },
      {
        "name": "VALEA MARE",
        "zip": "137086",
        "lat": "45.063965",
        "long": "25.156808"
      },
      {
        "name": "VALEA MARE",
        "zip": "137474",
        "lat": "45.060298",
        "long": "25.605854"
      },
      {
        "name": "VALEA MARE",
        "zip": "137485",
        "lat": "44.779832999999996",
        "long": "25.240103"
      },
      {
        "name": "VALEA MORII",
        "zip": "137041",
        "lat": "45.121931",
        "long": "25.492316"
      },
      {
        "name": "VALEA VOIEVOZILOR",
        "zip": "137397",
        "lat": "44.93524",
        "long": "25.480983"
      },
      {
        "name": "VALENI-DAMBOVITA",
        "zip": "137500",
        "lat": "45.164472",
        "long": "25.175434"
      },
      {
        "name": "VARFURENI",
        "zip": "137384",
        "lat": "45.178551",
        "long": "25.256607"
      },
      {
        "name": "VARFURI",
        "zip": "137505",
        "lat": "45.097041",
        "long": "25.510085"
      },
      {
        "name": "VIFORATA",
        "zip": "137007",
        "lat": "44.960391",
        "long": "25.456412"
      },
      {
        "name": "VIISOARA",
        "zip": "137463",
        "lat": "44.880353",
        "long": "25.426029"
      },
      {
        "name": "VISINA",
        "zip": "137515",
        "lat": "44.590702",
        "long": "25.333012"
      },
      {
        "name": "VISINESTI",
        "zip": "137520",
        "lat": "45.10792",
        "long": "25.553408"
      },
      {
        "name": "VIZURESTI",
        "zip": "137094",
        "lat": "44.63925",
        "long": "25.805595"
      },
      {
        "name": "VLADENI",
        "zip": "137187",
        "lat": "44.87556",
        "long": "25.775329"
      },
      {
        "name": "VLASCENI",
        "zip": "137374",
        "lat": "44.585216",
        "long": "25.599306"
      },
      {
        "name": "VOIA",
        "zip": "137179",
        "lat": "44.745009",
        "long": "25.204128"
      },
      {
        "name": "VOINESTI",
        "zip": "137525",
        "lat": "45.068201",
        "long": "25.248643"
      },
      {
        "name": "VULCANA DE SUS",
        "zip": "137537",
        "lat": "45.101252",
        "long": "25.35826"
      },
      {
        "name": "VULCANA-BAI",
        "zip": "137535",
        "lat": "45.074098",
        "long": "25.379983"
      },
      {
        "name": "VULCANA-PANDELE",
        "zip": "137540",
        "lat": "45.021032",
        "long": "25.398667"
      },
      {
        "name": "VULTUREANCA",
        "zip": "137519",
        "lat": "44.60299",
        "long": "25.242534"
      },
      {
        "name": "ZAVOIU",
        "zip": "137309",
        "lat": "44.66038",
        "long": "25.403501"
      },
      {
        "name": "ZIDURILE",
        "zip": "137349",
        "lat": "44.581428",
        "long": "25.554954"
      }
    ],
    "DOLJ": [
      {
        "name": "ADANCATA",
        "zip": "207311",
        "lat": "44.482335",
        "long": "23.740133"
      },
      {
        "name": "AFUMATI",
        "zip": "207005",
        "lat": "44.002297",
        "long": "23.482938"
      },
      {
        "name": "ALBESTI",
        "zip": "207551",
        "lat": "44.374559",
        "long": "23.767035"
      },
      {
        "name": "ALMAJ",
        "zip": "207010",
        "lat": "44.446907",
        "long": "23.706931"
      },
      {
        "name": "ALMAJEL",
        "zip": "205301",
        "lat": "44.556097",
        "long": "23.594315"
      },
      {
        "name": "AMARASTI",
        "zip": "207256",
        "lat": "44.585968",
        "long": "23.727666"
      },
      {
        "name": "AMARASTII DE JOS",
        "zip": "207020",
        "lat": "43.95207",
        "long": "24.16388"
      },
      {
        "name": "AMARASTII DE SUS",
        "zip": "207025",
        "lat": "43.980319",
        "long": "24.158496"
      },
      {
        "name": "APELE VII",
        "zip": "207030",
        "lat": "44.065884",
        "long": "24.063867"
      },
      {
        "name": "ARGETOAIA",
        "zip": "207035",
        "lat": "44.515338",
        "long": "23.378153"
      },
      {
        "name": "BADOSI",
        "zip": "207096",
        "lat": "44.147728",
        "long": "23.888498"
      },
      {
        "name": "BAILESTI",
        "zip": "205100",
        "lat": "44.023093",
        "long": "23.345008"
      },
      {
        "name": "BALASAN",
        "zip": "205101",
        "lat": "44.024691",
        "long": "23.261833"
      },
      {
        "name": "BALOTA DE JOS",
        "zip": "207421",
        "lat": "44.547298",
        "long": "23.814795"
      },
      {
        "name": "BALOTA DE SUS",
        "zip": "207422",
        "lat": "44.560743",
        "long": "23.793445"
      },
      {
        "name": "BALTA",
        "zip": "205302",
        "lat": "44.535765",
        "long": "23.469764"
      },
      {
        "name": "BALTA VERDE",
        "zip": "207466",
        "lat": "44.262552",
        "long": "23.801926"
      },
      {
        "name": "BARANU",
        "zip": "207036",
        "lat": "44.496846",
        "long": "23.38725"
      },
      {
        "name": "BARBOI",
        "zip": "207331",
        "lat": "44.446237",
        "long": "23.322611"
      },
      {
        "name": "BARCA",
        "zip": "207055",
        "lat": "43.966273",
        "long": "23.621065"
      },
      {
        "name": "BASARABI",
        "zip": "205201",
        "lat": "44.005316",
        "long": "23.005496"
      },
      {
        "name": "BASCOV",
        "zip": "207541",
        "lat": "44.38848",
        "long": "23.520292"
      },
      {
        "name": "BAZDANA",
        "zip": "207151",
        "lat": "44.149321",
        "long": "23.836341"
      },
      {
        "name": "BECHET",
        "zip": "207060",
        "lat": "43.784314",
        "long": "23.957442"
      },
      {
        "name": "BECHET",
        "zip": "207436",
        "lat": "44.294132",
        "long": "23.295691"
      },
      {
        "name": "BEHARCA",
        "zip": "207011",
        "lat": "44.445794",
        "long": "23.684179"
      },
      {
        "name": "BELCINU",
        "zip": "207152",
        "lat": "44.129697",
        "long": "23.79186"
      },
      {
        "name": "BELOT",
        "zip": "207542",
        "lat": "44.395283",
        "long": "23.538094"
      },
      {
        "name": "BENESTI",
        "zip": "207241",
        "lat": "44.259052",
        "long": "24.094725"
      },
      {
        "name": "BERBESU",
        "zip": "207037",
        "lat": "44.50457",
        "long": "23.349994"
      },
      {
        "name": "BISTRET",
        "zip": "207065",
        "lat": "43.89123",
        "long": "23.499091"
      },
      {
        "name": "BISTRETU NOU",
        "zip": "207066",
        "lat": "43.900567",
        "long": "23.470527"
      },
      {
        "name": "BOBEANU",
        "zip": "207242",
        "lat": "44.273047",
        "long": "24.075917"
      },
      {
        "name": "BODAIESTI",
        "zip": "207386",
        "lat": "44.586742",
        "long": "23.684538"
      },
      {
        "name": "BODAIESTII DE SUS",
        "zip": "207387",
        "lat": "44.568022",
        "long": "23.647244"
      },
      {
        "name": "BOGEA",
        "zip": "207012",
        "lat": "44.434196",
        "long": "23.7063"
      },
      {
        "name": "BOJOIU",
        "zip": "207496",
        "lat": "44.306324",
        "long": "24.037739"
      },
      {
        "name": "BOOVENI",
        "zip": "207251",
        "lat": "44.076966",
        "long": "23.833878"
      },
      {
        "name": "BOTOSESTI-PAIA",
        "zip": "207070",
        "lat": "44.404054",
        "long": "23.263388"
      },
      {
        "name": "BOURENI",
        "zip": "207006",
        "lat": "44.016575",
        "long": "23.432778"
      },
      {
        "name": "BRABETI",
        "zip": "207216",
        "lat": "43.960724",
        "long": "24.013765"
      },
      {
        "name": "BRABOVA",
        "zip": "207075",
        "lat": "44.37158",
        "long": "23.43032"
      },
      {
        "name": "BRADESTI",
        "zip": "207105",
        "lat": "44.492639",
        "long": "23.621374"
      },
      {
        "name": "BRADESTII BATRANI",
        "zip": "207106",
        "lat": "44.499922",
        "long": "23.648892"
      },
      {
        "name": "BRALOSTITA",
        "zip": "207085",
        "lat": "44.498776",
        "long": "23.525465"
      },
      {
        "name": "BRANDUSA",
        "zip": "207067",
        "lat": "43.916955",
        "long": "23.56373"
      },
      {
        "name": "BRANISTE",
        "zip": "207467",
        "lat": "44.270698",
        "long": "23.790297"
      },
      {
        "name": "BRANISTE",
        "zip": "205303",
        "lat": "44.603627",
        "long": "23.556719"
      },
      {
        "name": "BRANISTE",
        "zip": "207217",
        "lat": "43.982253",
        "long": "24.011955"
      },
      {
        "name": "BRATOVOESTI",
        "zip": "207095",
        "lat": "44.127925",
        "long": "23.903693"
      },
      {
        "name": "BREASTA",
        "zip": "207115",
        "lat": "44.341787",
        "long": "23.688603"
      },
      {
        "name": "BUCICANI",
        "zip": "207476",
        "lat": "44.335324",
        "long": "23.561965"
      },
      {
        "name": "BUCOVAT",
        "zip": "207125",
        "lat": "44.292674",
        "long": "23.738138"
      },
      {
        "name": "BUCOVICIOR",
        "zip": "207626",
        "lat": "44.299035",
        "long": "23.353212"
      },
      {
        "name": "BUJOR",
        "zip": "207616",
        "lat": "44.22728",
        "long": "23.653194"
      },
      {
        "name": "BULZESTI",
        "zip": "207135",
        "lat": "44.538165",
        "long": "23.886159"
      },
      {
        "name": "BUSTENI",
        "zip": "207423",
        "lat": "44.532303",
        "long": "23.8337"
      },
      {
        "name": "BUSU",
        "zip": "207332",
        "lat": "44.450826",
        "long": "23.226163"
      },
      {
        "name": "BUSULETU",
        "zip": "207333",
        "lat": "44.462492",
        "long": "23.246602"
      },
      {
        "name": "BUZDUC",
        "zip": "207243",
        "lat": "44.255949",
        "long": "24.035869"
      },
      {
        "name": "CACIULATESTI",
        "zip": "207236",
        "lat": "43.936313",
        "long": "23.949884"
      },
      {
        "name": "CACIULATU",
        "zip": "207576",
        "lat": "44.313024",
        "long": "23.422295"
      },
      {
        "name": "CALAFAT",
        "zip": "205200",
        "lat": "43.99044",
        "long": "22.93362"
      },
      {
        "name": "CALARASI",
        "zip": "207170",
        "lat": "43.793419",
        "long": "24.045139"
      },
      {
        "name": "CALINESTI",
        "zip": "207406",
        "lat": "44.453408",
        "long": "23.877072"
      },
      {
        "name": "CALOPAR",
        "zip": "207150",
        "lat": "44.165021",
        "long": "23.760599"
      },
      {
        "name": "CALUGAREI",
        "zip": "207437",
        "lat": "44.293893",
        "long": "23.25516"
      },
      {
        "name": "CAMPENI",
        "zip": "207451",
        "lat": "44.365802",
        "long": "24.014985"
      },
      {
        "name": "CARAIMAN",
        "zip": "207076",
        "lat": "44.346707",
        "long": "23.379357"
      },
      {
        "name": "CARAULA",
        "zip": "207155",
        "lat": "44.194316",
        "long": "23.248049"
      },
      {
        "name": "CARCEA",
        "zip": "207206",
        "lat": "44.268688",
        "long": "23.898435"
      },
      {
        "name": "CARLIGEI",
        "zip": "207126",
        "lat": "44.283627",
        "long": "23.74718"
      },
      {
        "name": "CARNA",
        "zip": "207306",
        "lat": "43.883546",
        "long": "23.597324"
      },
      {
        "name": "CARPEN",
        "zip": "207160",
        "lat": "44.335317",
        "long": "23.259387"
      },
      {
        "name": "CARSTOVANI",
        "zip": "207477",
        "lat": "44.342662",
        "long": "23.57149"
      },
      {
        "name": "CARUIA",
        "zip": "207577",
        "lat": "44.317923",
        "long": "23.551917"
      },
      {
        "name": "CASTRANOVA",
        "zip": "207165",
        "lat": "44.117429",
        "long": "24.013525"
      },
      {
        "name": "CASTRELE TRAIANE",
        "zip": "207461",
        "lat": "44.228728",
        "long": "23.137511"
      },
      {
        "name": "CATANE",
        "zip": "207431",
        "lat": "43.927712",
        "long": "23.41181"
      },
      {
        "name": "CATANELE NOI",
        "zip": "207432",
        "lat": "43.943187",
        "long": "23.414305"
      },
      {
        "name": "CELARU",
        "zip": "207175",
        "lat": "44.039958",
        "long": "24.129324"
      },
      {
        "name": "CERAT",
        "zip": "207180",
        "lat": "44.060988",
        "long": "23.671611"
      },
      {
        "name": "CERNAT",
        "zip": "207543",
        "lat": "44.402711",
        "long": "23.422968"
      },
      {
        "name": "CERNATESTI",
        "zip": "207185",
        "lat": "44.449033",
        "long": "23.435159"
      },
      {
        "name": "CERNELE",
        "zip": "200794",
        "lat": "44.333427",
        "long": "23.739228"
      },
      {
        "name": "CERNELELE DE SUS",
        "zip": "1140",
        "lat": "44.342317",
        "long": "23.733946"
      },
      {
        "name": "CETATE",
        "zip": "207190",
        "lat": "44.111426",
        "long": "23.047551"
      },
      {
        "name": "CETATUIA",
        "zip": "207196",
        "lat": "44.109919",
        "long": "23.470396"
      },
      {
        "name": "CETATUIA",
        "zip": "207627",
        "lat": "44.295699",
        "long": "23.382063"
      },
      {
        "name": "CHIASU",
        "zip": "207221",
        "lat": "43.758682",
        "long": "24.081328"
      },
      {
        "name": "CIOCANELE",
        "zip": "207086",
        "lat": "44.513386",
        "long": "23.447493"
      },
      {
        "name": "CIOCANESTI",
        "zip": "207231",
        "lat": "44.159851",
        "long": "24.162376"
      },
      {
        "name": "CIOROIASI",
        "zip": "207195",
        "lat": "44.085433",
        "long": "23.451646"
      },
      {
        "name": "CIOROIU NOU",
        "zip": "207197",
        "lat": "44.063801",
        "long": "23.433067"
      },
      {
        "name": "CIUPERCENII NOI",
        "zip": "207200",
        "lat": "43.910689",
        "long": "22.947002"
      },
      {
        "name": "CIUPERCENII VECHI",
        "zip": "205202",
        "lat": "43.945122",
        "long": "22.894687"
      },
      {
        "name": "CIUTURA",
        "zip": "207617",
        "lat": "44.225704",
        "long": "23.569297"
      },
      {
        "name": "CLEANOV",
        "zip": "207161",
        "lat": "44.352881",
        "long": "23.210321"
      },
      {
        "name": "COMANICEA",
        "zip": "207531",
        "lat": "44.485374",
        "long": "23.331231"
      },
      {
        "name": "COMOSTENI",
        "zip": "207276",
        "lat": "43.87437",
        "long": "23.863655"
      },
      {
        "name": "CORLATE",
        "zip": "207346",
        "lat": "44.176778",
        "long": "23.316241"
      },
      {
        "name": "CORNETU",
        "zip": "207552",
        "lat": "44.439384",
        "long": "23.787081"
      },
      {
        "name": "CORNITA",
        "zip": "207186",
        "lat": "44.452444",
        "long": "23.491652"
      },
      {
        "name": "CORNU",
        "zip": "207438",
        "lat": "44.233995",
        "long": "23.275638"
      },
      {
        "name": "COSERENI",
        "zip": "207581",
        "lat": "44.195597",
        "long": "24.189319"
      },
      {
        "name": "COSOVENI",
        "zip": "207205",
        "lat": "44.246016",
        "long": "23.926518"
      },
      {
        "name": "COTOFENII DIN DOS",
        "zip": "207210",
        "lat": "44.435604",
        "long": "23.614671"
      },
      {
        "name": "COTOFENII DIN FATA",
        "zip": "207013",
        "lat": "44.45971",
        "long": "23.656881"
      },
      {
        "name": "COTU",
        "zip": "207116",
        "lat": "44.354573",
        "long": "23.693057"
      },
      {
        "name": "COVEI",
        "zip": "207007",
        "lat": "43.973575",
        "long": "23.42035"
      },
      {
        "name": "CRAIOVA",
        "zip": "200008",
        "lat": "44.319016",
        "long": "23.796561"
      },
      {
        "name": "CRIVA",
        "zip": "207618",
        "lat": "44.249771",
        "long": "23.632213"
      },
      {
        "name": "CROVNA",
        "zip": "207117",
        "lat": "44.365601",
        "long": "23.65177"
      },
      {
        "name": "CURMATURA",
        "zip": "207296",
        "lat": "44.0037",
        "long": "23.63623"
      },
      {
        "name": "DABULENI",
        "zip": "207220",
        "lat": "43.8008",
        "long": "24.092398"
      },
      {
        "name": "DANETI",
        "zip": "207215",
        "lat": "43.974269",
        "long": "24.043305"
      },
      {
        "name": "DELENI",
        "zip": "207553",
        "lat": "44.431712",
        "long": "23.795543"
      },
      {
        "name": "DESA",
        "zip": "207225",
        "lat": "43.870254",
        "long": "23.032898"
      },
      {
        "name": "DESNATUI",
        "zip": "207628",
        "lat": "44.269796",
        "long": "23.371365"
      },
      {
        "name": "DIOSTI",
        "zip": "207230",
        "lat": "44.106696",
        "long": "24.183985"
      },
      {
        "name": "DOBRESTI",
        "zip": "207235",
        "lat": "43.973769",
        "long": "23.945259"
      },
      {
        "name": "DOBRIDOR",
        "zip": "207416",
        "lat": "44.11844",
        "long": "23.167798"
      },
      {
        "name": "DOBROMIRA",
        "zip": "207619",
        "lat": "44.262687",
        "long": "23.614701"
      },
      {
        "name": "DOBROTESTI",
        "zip": "207026",
        "lat": "43.96146",
        "long": "24.123951"
      },
      {
        "name": "DOMNU TUDOR",
        "zip": "207347",
        "lat": "44.140055",
        "long": "23.318802"
      },
      {
        "name": "DRAGOAIA",
        "zip": "207621",
        "lat": "44.233818",
        "long": "23.522996"
      },
      {
        "name": "DRAGOTESTI",
        "zip": "207240",
        "lat": "44.242978",
        "long": "24.09793"
      },
      {
        "name": "DRANIC",
        "zip": "207250",
        "lat": "44.05508",
        "long": "23.843333"
      },
      {
        "name": "DUDOVICESTI",
        "zip": "207554",
        "lat": "44.385607",
        "long": "23.778655"
      },
      {
        "name": "DUTULESTI",
        "zip": "207556",
        "lat": "44.459591",
        "long": "23.777953"
      },
      {
        "name": "FACAI",
        "zip": "200001",
        "lat": "44.273121",
        "long": "23.818064"
      },
      {
        "name": "FAGET",
        "zip": "207118",
        "lat": "44.33088",
        "long": "23.621613"
      },
      {
        "name": "FANTANELE",
        "zip": "207486",
        "lat": "44.192741",
        "long": "23.601155"
      },
      {
        "name": "FANTANELE",
        "zip": "207582",
        "lat": "44.200854",
        "long": "24.089563"
      },
      {
        "name": "FANTANI",
        "zip": "207312",
        "lat": "44.473473",
        "long": "23.763329"
      },
      {
        "name": "FARCAS",
        "zip": "207255",
        "lat": "44.606141",
        "long": "23.745639"
      },
      {
        "name": "FILARET",
        "zip": "207297",
        "lat": "44.001145",
        "long": "23.623422"
      },
      {
        "name": "FILIASI",
        "zip": "205300",
        "lat": "44.552648",
        "long": "23.522657"
      },
      {
        "name": "FLORAN",
        "zip": "207578",
        "lat": "44.31075",
        "long": "23.438835"
      },
      {
        "name": "FLORESTI",
        "zip": "207557",
        "lat": "44.396497",
        "long": "23.794989"
      },
      {
        "name": "FOISOR",
        "zip": "207252",
        "lat": "44.104541",
        "long": "23.865484"
      },
      {
        "name": "FRASIN",
        "zip": "207478",
        "lat": "44.358122",
        "long": "23.495877"
      },
      {
        "name": "FRATILA",
        "zip": "207136",
        "lat": "44.622278",
        "long": "23.853041"
      },
      {
        "name": "FRATOSTITA",
        "zip": "205304",
        "lat": "44.586858",
        "long": "23.570447"
      },
      {
        "name": "GABRU",
        "zip": "207622",
        "lat": "44.256853",
        "long": "23.567871"
      },
      {
        "name": "GAIA",
        "zip": "207424",
        "lat": "44.515908",
        "long": "23.846195"
      },
      {
        "name": "GALICEA MARE",
        "zip": "207270",
        "lat": "44.09661",
        "long": "23.310771"
      },
      {
        "name": "GALICIUICA",
        "zip": "207291",
        "lat": "44.103288",
        "long": "23.391282"
      },
      {
        "name": "GANGIOVA",
        "zip": "207275",
        "lat": "43.898113",
        "long": "23.859814"
      },
      {
        "name": "GARLESTI",
        "zip": "207281",
        "lat": "44.349761",
        "long": "23.916308"
      },
      {
        "name": "GEBLESTI",
        "zip": "207162",
        "lat": "44.335376",
        "long": "23.311098"
      },
      {
        "name": "GEOROCEL",
        "zip": "207237",
        "lat": "43.97749",
        "long": "23.957583"
      },
      {
        "name": "GEOROCU MARE",
        "zip": "207097",
        "lat": "44.121087",
        "long": "23.950972"
      },
      {
        "name": "GHERCESTI",
        "zip": "207280",
        "lat": "44.357545",
        "long": "23.892837"
      },
      {
        "name": "GHIDICI",
        "zip": "207456",
        "lat": "43.891462",
        "long": "23.196804"
      },
      {
        "name": "GHINDENI",
        "zip": "207366",
        "lat": "44.213528",
        "long": "23.927369"
      },
      {
        "name": "GHIZDAVESTI",
        "zip": "207176",
        "lat": "44.057566",
        "long": "24.10811"
      },
      {
        "name": "GIGHERA",
        "zip": "207285",
        "lat": "43.849145",
        "long": "23.793431"
      },
      {
        "name": "GIUBEGA",
        "zip": "207290",
        "lat": "44.128211",
        "long": "23.411636"
      },
      {
        "name": "GIURGITA",
        "zip": "207295",
        "lat": "44.02737",
        "long": "23.630455"
      },
      {
        "name": "GODENI",
        "zip": "207388",
        "lat": "44.54805",
        "long": "23.739692"
      },
      {
        "name": "GOGOSESTI",
        "zip": "207407",
        "lat": "44.454991",
        "long": "23.887005"
      },
      {
        "name": "GOGOSITA",
        "zip": "207301",
        "lat": "44.399",
        "long": "23.359144"
      },
      {
        "name": "GOGOSU",
        "zip": "207300",
        "lat": "44.426383",
        "long": "23.366155"
      },
      {
        "name": "GOICEA",
        "zip": "207305",
        "lat": "43.920417",
        "long": "23.619348"
      },
      {
        "name": "GOIESTI",
        "zip": "207310",
        "lat": "44.477393",
        "long": "23.759414"
      },
      {
        "name": "GOLENTI",
        "zip": "205203",
        "lat": "44.012904",
        "long": "23.05666"
      },
      {
        "name": "GOLFIN",
        "zip": "207497",
        "lat": "44.290879",
        "long": "24.020954"
      },
      {
        "name": "GOLUMBELU",
        "zip": "207257",
        "lat": "44.627173",
        "long": "23.739875"
      },
      {
        "name": "GOLUMBU",
        "zip": "207258",
        "lat": "44.633785",
        "long": "23.754112"
      },
      {
        "name": "GRADISTEA",
        "zip": "207334",
        "lat": "44.44873",
        "long": "23.260281"
      },
      {
        "name": "GRECESTI",
        "zip": "207330",
        "lat": "44.448231",
        "long": "23.281273"
      },
      {
        "name": "GROPANELE",
        "zip": "207336",
        "lat": "44.468653",
        "long": "23.240888"
      },
      {
        "name": "GRUITA",
        "zip": "207313",
        "lat": "44.50909",
        "long": "23.798937"
      },
      {
        "name": "GUBAUCEA",
        "zip": "207629",
        "lat": "44.277895",
        "long": "23.344653"
      },
      {
        "name": "GURA RACULUI",
        "zip": "207137",
        "lat": "44.520968",
        "long": "23.896695"
      },
      {
        "name": "GURA VAII",
        "zip": "207468",
        "lat": "44.215328",
        "long": "23.792116"
      },
      {
        "name": "HOREZU-POENARI",
        "zip": "207606",
        "lat": "43.958042",
        "long": "23.871128"
      },
      {
        "name": "HUNIA",
        "zip": "207361",
        "lat": "44.055377",
        "long": "23.098582"
      },
      {
        "name": "INFRATIREA",
        "zip": "207138",
        "lat": "44.612267",
        "long": "23.857686"
      },
      {
        "name": "INTORSURA",
        "zip": "207487",
        "lat": "44.112097",
        "long": "23.573807"
      },
      {
        "name": "IORDACHESTI",
        "zip": "207038",
        "lat": "44.506095",
        "long": "23.366377"
      },
      {
        "name": "ISALNITA",
        "zip": "207340",
        "lat": "44.394651",
        "long": "23.733251"
      },
      {
        "name": "ITALIENI",
        "zip": "207127",
        "lat": "44.30235",
        "long": "23.59535"
      },
      {
        "name": "IZVOARE",
        "zip": "207345",
        "lat": "44.148053",
        "long": "23.295933"
      },
      {
        "name": "IZVOR",
        "zip": "207558",
        "lat": "44.424329",
        "long": "23.799011"
      },
      {
        "name": "IZVORUL RECE",
        "zip": "200801",
        "lat": "44.357349",
        "long": "23.749143"
      },
      {
        "name": "JIENI",
        "zip": "207559",
        "lat": "44.378043",
        "long": "23.799601"
      },
      {
        "name": "JIUL",
        "zip": "207591",
        "lat": "44.213183",
        "long": "23.834152"
      },
      {
        "name": "LACRITA MARE",
        "zip": "207498",
        "lat": "44.294637",
        "long": "23.991005"
      },
      {
        "name": "LACRITA MICA",
        "zip": "207499",
        "lat": "44.296414",
        "long": "23.961727"
      },
      {
        "name": "LANGA",
        "zip": "207452",
        "lat": "44.36149",
        "long": "23.962418"
      },
      {
        "name": "LAZU",
        "zip": "207579",
        "lat": "44.295725",
        "long": "23.542546"
      },
      {
        "name": "LEAMNA DE JOS",
        "zip": "207128",
        "lat": "44.311601",
        "long": "23.722834"
      },
      {
        "name": "LEAMNA DE SUS",
        "zip": "207129",
        "lat": "44.301337",
        "long": "23.683305"
      },
      {
        "name": "LEORDOASA",
        "zip": "207039",
        "lat": "44.510868",
        "long": "23.4138"
      },
      {
        "name": "LESILE",
        "zip": "207561",
        "lat": "44.427137",
        "long": "23.783585"
      },
      {
        "name": "LEU",
        "zip": "207350",
        "lat": "44.187482",
        "long": "23.999976"
      },
      {
        "name": "LIPOVU",
        "zip": "207355",
        "lat": "44.10483",
        "long": "23.627885"
      },
      {
        "name": "LIPOVU DE SUS",
        "zip": "207356",
        "lat": "44.123567",
        "long": "23.623756"
      },
      {
        "name": "LISTEAVA",
        "zip": "207441",
        "lat": "43.833997",
        "long": "23.920159"
      },
      {
        "name": "LIVEZI",
        "zip": "207469",
        "lat": "44.228684",
        "long": "23.788545"
      },
      {
        "name": "LOCUSTENI",
        "zip": "207218",
        "lat": "43.974556",
        "long": "23.997541"
      },
      {
        "name": "LUNCSORU",
        "zip": "207282",
        "lat": "44.405651",
        "long": "23.951795"
      },
      {
        "name": "MACESU DE JOS",
        "zip": "207370",
        "lat": "43.878936",
        "long": "23.711134"
      },
      {
        "name": "MACESU DE SUS",
        "zip": "207375",
        "lat": "43.916672",
        "long": "23.711263"
      },
      {
        "name": "MAGLAVIT",
        "zip": "207360",
        "lat": "44.033427",
        "long": "23.098839"
      },
      {
        "name": "MALAESTI",
        "zip": "207314",
        "lat": "44.462891",
        "long": "23.741449"
      },
      {
        "name": "MALAICA",
        "zip": "207181",
        "lat": "44.087523",
        "long": "23.670022"
      },
      {
        "name": "MALU MARE",
        "zip": "207365",
        "lat": "44.239755",
        "long": "23.855027"
      },
      {
        "name": "MALUMNIC",
        "zip": "207041",
        "lat": "44.517767",
        "long": "23.318748"
      },
      {
        "name": "MARACINELE",
        "zip": "207446",
        "lat": "44.173541",
        "long": "23.509191"
      },
      {
        "name": "MAROTINU DE JOS",
        "zip": "207177",
        "lat": "44.031145",
        "long": "24.146634"
      },
      {
        "name": "MAROTINU DE SUS",
        "zip": "207178",
        "lat": "44.026024",
        "long": "24.084841"
      },
      {
        "name": "MARSANI",
        "zip": "207380",
        "lat": "44.010834",
        "long": "24.014669"
      },
      {
        "name": "MARZA",
        "zip": "207511",
        "lat": "44.195639",
        "long": "23.476514"
      },
      {
        "name": "MELINESTI",
        "zip": "207385",
        "lat": "44.572",
        "long": "23.709515"
      },
      {
        "name": "METEU",
        "zip": "207107",
        "lat": "44.540375",
        "long": "23.62718"
      },
      {
        "name": "MIHAITA",
        "zip": "207211",
        "lat": "44.392406",
        "long": "23.665234"
      },
      {
        "name": "MILESTI",
        "zip": "207562",
        "lat": "44.450294",
        "long": "23.785281"
      },
      {
        "name": "MILOVAN",
        "zip": "207479",
        "lat": "44.361923",
        "long": "23.564341"
      },
      {
        "name": "MISCHII",
        "zip": "207405",
        "lat": "44.387255",
        "long": "23.85593"
      },
      {
        "name": "MLECANESTI",
        "zip": "207408",
        "lat": "44.377069",
        "long": "23.87209"
      },
      {
        "name": "MOFLENI",
        "zip": "200002",
        "lat": "44.303182",
        "long": "23.757428"
      },
      {
        "name": "MOFLESTI",
        "zip": "207259",
        "lat": "44.659296",
        "long": "23.749785"
      },
      {
        "name": "MOGOSESTI",
        "zip": "207316",
        "lat": "44.468137",
        "long": "23.768865"
      },
      {
        "name": "MORENI",
        "zip": "207191",
        "lat": "44.087705",
        "long": "23.077396"
      },
      {
        "name": "MOSNA",
        "zip": "207077",
        "lat": "44.335863",
        "long": "23.370606"
      },
      {
        "name": "MOSNENI",
        "zip": "207014",
        "lat": "44.460562",
        "long": "23.700263"
      },
      {
        "name": "MOTATEI",
        "zip": "207415",
        "lat": "44.096147",
        "long": "23.200348"
      },
      {
        "name": "MOTATEI-GARA",
        "zip": "207417",
        "lat": "44.038764",
        "long": "23.190976"
      },
      {
        "name": "MOTOCI",
        "zip": "207409",
        "lat": "44.427142",
        "long": "23.842202"
      },
      {
        "name": "MUERENI",
        "zip": "207317",
        "lat": "44.510913",
        "long": "23.757374"
      },
      {
        "name": "MUIERUSU",
        "zip": "207389",
        "lat": "44.565428",
        "long": "23.691344"
      },
      {
        "name": "MURGASI",
        "zip": "207420",
        "lat": "44.498402",
        "long": "23.86568"
      },
      {
        "name": "MURTA",
        "zip": "207238",
        "lat": "43.982292",
        "long": "23.949847"
      },
      {
        "name": "NEDEIA",
        "zip": "207286",
        "lat": "43.848508",
        "long": "23.774584"
      },
      {
        "name": "NEGOI",
        "zip": "207430",
        "lat": "43.914606",
        "long": "23.369066"
      },
      {
        "name": "NEGOIESTI",
        "zip": "207391",
        "lat": "44.533663",
        "long": "23.726111"
      },
      {
        "name": "NISIPURI",
        "zip": "207027",
        "lat": "43.973567",
        "long": "24.132644"
      },
      {
        "name": "NISTOI",
        "zip": "207261",
        "lat": "44.699886",
        "long": "23.733333"
      },
      {
        "name": "NOVAC",
        "zip": "207042",
        "lat": "44.498239",
        "long": "23.376054"
      },
      {
        "name": "OBEDIN",
        "zip": "207119",
        "lat": "44.365603",
        "long": "23.69015"
      },
      {
        "name": "OCOLNA",
        "zip": "207021",
        "lat": "43.877192",
        "long": "24.143445"
      },
      {
        "name": "ODOLENI",
        "zip": "207392",
        "lat": "44.573872",
        "long": "23.679921"
      },
      {
        "name": "OHABA",
        "zip": "207393",
        "lat": "44.591055",
        "long": "23.660193"
      },
      {
        "name": "ORODEL",
        "zip": "207435",
        "lat": "44.244019",
        "long": "23.246341"
      },
      {
        "name": "OSTROVENI",
        "zip": "207440",
        "lat": "43.816475",
        "long": "23.89699"
      },
      {
        "name": "PADEA",
        "zip": "207253",
        "lat": "44.021277",
        "long": "23.868265"
      },
      {
        "name": "PALILULA",
        "zip": "207131",
        "lat": "44.268313",
        "long": "23.721022"
      },
      {
        "name": "PANAGHIA",
        "zip": "207153",
        "lat": "44.173756",
        "long": "23.704428"
      },
      {
        "name": "PERENI",
        "zip": "207544",
        "lat": "44.386527",
        "long": "23.560256"
      },
      {
        "name": "PERISOR",
        "zip": "207445",
        "lat": "44.144252",
        "long": "23.475874"
      },
      {
        "name": "PICATURILE",
        "zip": "207426",
        "lat": "44.488667",
        "long": "23.883082"
      },
      {
        "name": "PIELESTI",
        "zip": "207450",
        "lat": "44.331274",
        "long": "23.96442"
      },
      {
        "name": "PIETROAIA",
        "zip": "207546",
        "lat": "44.377543",
        "long": "23.505877"
      },
      {
        "name": "PIORESTI",
        "zip": "207318",
        "lat": "44.47798",
        "long": "23.743703"
      },
      {
        "name": "PIRIA",
        "zip": "207043",
        "lat": "44.506804",
        "long": "23.314248"
      },
      {
        "name": "PISCANI",
        "zip": "207108",
        "lat": "44.542167",
        "long": "23.606157"
      },
      {
        "name": "PISCU LUNG",
        "zip": "207139",
        "lat": "44.618384",
        "long": "23.883785"
      },
      {
        "name": "PISCU NOU",
        "zip": "207521",
        "lat": "43.926806",
        "long": "23.177384"
      },
      {
        "name": "PISCU SADOVEI",
        "zip": "207506",
        "lat": "43.87479",
        "long": "23.935562"
      },
      {
        "name": "PISCU VECHI",
        "zip": "207455",
        "lat": "43.899888",
        "long": "23.161708"
      },
      {
        "name": "PISCULET",
        "zip": "207457",
        "lat": "43.851037",
        "long": "23.146869"
      },
      {
        "name": "PLENITA",
        "zip": "207460",
        "lat": "44.22274",
        "long": "23.186259"
      },
      {
        "name": "PLESOI",
        "zip": "207481",
        "lat": "44.350769",
        "long": "23.533448"
      },
      {
        "name": "PLOPSOR",
        "zip": "207512",
        "lat": "44.250948",
        "long": "23.416696"
      },
      {
        "name": "PLOPU-AMARASTI",
        "zip": "207262",
        "lat": "44.610314",
        "long": "23.736318"
      },
      {
        "name": "PLOSCA",
        "zip": "207068",
        "lat": "43.895533",
        "long": "23.553469"
      },
      {
        "name": "PLOSTINA",
        "zip": "207394",
        "lat": "44.54166",
        "long": "23.704818"
      },
      {
        "name": "PODARI",
        "zip": "207465",
        "lat": "44.247532",
        "long": "23.781151"
      },
      {
        "name": "POIANA FANTANII",
        "zip": "207044",
        "lat": "44.51429",
        "long": "23.366673"
      },
      {
        "name": "POIANA MARE",
        "zip": "207470",
        "lat": "43.920912",
        "long": "23.058883"
      },
      {
        "name": "POIENILE",
        "zip": "207141",
        "lat": "44.630534",
        "long": "23.835192"
      },
      {
        "name": "POMETESTI",
        "zip": "207319",
        "lat": "44.510605",
        "long": "23.732528"
      },
      {
        "name": "POPANZALESTI",
        "zip": "207244",
        "lat": "44.280742",
        "long": "24.068244"
      },
      {
        "name": "POPEASA",
        "zip": "207321",
        "lat": "44.494765",
        "long": "23.734835"
      },
      {
        "name": "POPESTI",
        "zip": "207396",
        "lat": "44.571386",
        "long": "23.687228"
      },
      {
        "name": "POPOVENI",
        "zip": "200003",
        "lat": "44.286502",
        "long": "23.780487"
      },
      {
        "name": "POTMELTU",
        "zip": "207212",
        "lat": "44.410387",
        "long": "23.650756"
      },
      {
        "name": "PRAPOR",
        "zip": "207022",
        "lat": "43.944687",
        "long": "24.175166"
      },
      {
        "name": "PREAJBA",
        "zip": "207367",
        "lat": "44.26676",
        "long": "23.84532"
      },
      {
        "name": "PREAJBA DE JOS",
        "zip": "207583",
        "lat": "44.19566",
        "long": "24.21438"
      },
      {
        "name": "PREAJBA DE PADURE",
        "zip": "207584",
        "lat": "44.200886",
        "long": "24.203081"
      },
      {
        "name": "PREDESTI",
        "zip": "207475",
        "lat": "44.36056",
        "long": "23.605574"
      },
      {
        "name": "PREDESTII MICI",
        "zip": "207482",
        "lat": "44.342456",
        "long": "23.582839"
      },
      {
        "name": "PREJOI",
        "zip": "207142",
        "lat": "44.576471",
        "long": "23.874719"
      },
      {
        "name": "PRUNET",
        "zip": "207098",
        "lat": "44.152751",
        "long": "23.913401"
      },
      {
        "name": "PUTINEI",
        "zip": "207263",
        "lat": "44.686406",
        "long": "23.739912"
      },
      {
        "name": "PUTURI",
        "zip": "207166",
        "lat": "44.138346",
        "long": "24.010172"
      },
      {
        "name": "RACARII DE JOS",
        "zip": "207109",
        "lat": "44.523887",
        "long": "23.575206"
      },
      {
        "name": "RACARII DE SUS",
        "zip": "205305",
        "lat": "44.535389",
        "long": "23.55746"
      },
      {
        "name": "RACHITA DE JOS",
        "zip": "207078",
        "lat": "44.345997",
        "long": "23.404946"
      },
      {
        "name": "RACHITA DE SUS",
        "zip": "207526",
        "lat": "44.364355",
        "long": "23.362522"
      },
      {
        "name": "RACOVITA",
        "zip": "207087",
        "lat": "44.519611",
        "long": "23.435286"
      },
      {
        "name": "RADOMIR",
        "zip": "207232",
        "lat": "44.121151",
        "long": "24.168317"
      },
      {
        "name": "RADOVAN",
        "zip": "207485",
        "lat": "44.159657",
        "long": "23.605053"
      },
      {
        "name": "RASNICU BATRAN",
        "zip": "207187",
        "lat": "44.425372",
        "long": "23.537501"
      },
      {
        "name": "RASNICU OGHIAN",
        "zip": "207188",
        "lat": "44.441293",
        "long": "23.533296"
      },
      {
        "name": "RAST",
        "zip": "207490",
        "lat": "43.885167",
        "long": "23.281347"
      },
      {
        "name": "ROBANESTII DE JOS",
        "zip": "207501",
        "lat": "44.311127",
        "long": "24.016639"
      },
      {
        "name": "ROBANESTII DE SUS",
        "zip": "207502",
        "lat": "44.321985",
        "long": "24.006852"
      },
      {
        "name": "ROJISTE",
        "zip": "207099",
        "lat": "44.068352",
        "long": "23.93835"
      },
      {
        "name": "ROMANESTI",
        "zip": "207563",
        "lat": "44.395389",
        "long": "23.782399"
      },
      {
        "name": "ROSIENI",
        "zip": "207121",
        "lat": "44.332564",
        "long": "23.67619"
      },
      {
        "name": "ROVINE",
        "zip": "200058",
        "lat": "44.361356",
        "long": "23.720296"
      },
      {
        "name": "RUPTURILE",
        "zip": "207427",
        "lat": "44.598997",
        "long": "23.812344"
      },
      {
        "name": "SADOVA",
        "zip": "207505",
        "lat": "43.898929",
        "long": "23.947913"
      },
      {
        "name": "SALCIA",
        "zip": "207046",
        "lat": "44.482951",
        "long": "23.447229"
      },
      {
        "name": "SALCUTA",
        "zip": "207154",
        "lat": "44.159855",
        "long": "23.702474"
      },
      {
        "name": "SALCUTA",
        "zip": "207510",
        "lat": "44.244302",
        "long": "23.439628"
      },
      {
        "name": "SALISTE",
        "zip": "207143",
        "lat": "44.597011",
        "long": "23.864008"
      },
      {
        "name": "SAPATA",
        "zip": "207371",
        "lat": "43.882296",
        "long": "23.662921"
      },
      {
        "name": "SARATA",
        "zip": "207171",
        "lat": "43.774365",
        "long": "24.033508"
      },
      {
        "name": "SARBATOAREA",
        "zip": "207132",
        "lat": "44.298815",
        "long": "23.652567"
      },
      {
        "name": "SARSCA",
        "zip": "207547",
        "lat": "44.370405",
        "long": "23.545686"
      },
      {
        "name": "SCAESTI",
        "zip": "207515",
        "lat": "44.459534",
        "long": "23.575163"
      },
      {
        "name": "SCHITU",
        "zip": "207088",
        "lat": "44.508403",
        "long": "23.505252"
      },
      {
        "name": "SEACA DE CAMP",
        "zip": "207520",
        "lat": "43.932485",
        "long": "23.219927"
      },
      {
        "name": "SEACA DE PADURE",
        "zip": "207525",
        "lat": "44.366106",
        "long": "23.305873"
      },
      {
        "name": "SECU",
        "zip": "207530",
        "lat": "44.474199",
        "long": "23.292217"
      },
      {
        "name": "SECUI",
        "zip": "207571",
        "lat": "44.194231",
        "long": "23.861158"
      },
      {
        "name": "SECULESTI",
        "zip": "207144",
        "lat": "44.561248",
        "long": "23.879852"
      },
      {
        "name": "SEGARCEA",
        "zip": "205400",
        "lat": "44.093048",
        "long": "23.746887"
      },
      {
        "name": "SEGLET",
        "zip": "207631",
        "lat": "44.26719",
        "long": "23.407499"
      },
      {
        "name": "SFARCEA",
        "zip": "207089",
        "lat": "44.486126",
        "long": "23.546608"
      },
      {
        "name": "SILISTEA CRUCII",
        "zip": "207535",
        "lat": "44.044879",
        "long": "23.481944"
      },
      {
        "name": "SIMNICU DE JOS",
        "zip": "200004",
        "lat": "44.360042",
        "long": "23.82082"
      },
      {
        "name": "SIMNICU DE SUS",
        "zip": "207550",
        "lat": "44.39286",
        "long": "23.796581"
      },
      {
        "name": "SITOAIA",
        "zip": "207016",
        "lat": "44.422264",
        "long": "23.722214"
      },
      {
        "name": "SMADOVICIOARA DE SECU",
        "zip": "207532",
        "lat": "44.490433",
        "long": "23.268604"
      },
      {
        "name": "SMARDAN",
        "zip": "207201",
        "lat": "43.934177",
        "long": "22.964549"
      },
      {
        "name": "SOCENI",
        "zip": "207264",
        "lat": "44.700477",
        "long": "23.747837"
      },
      {
        "name": "SOPOT",
        "zip": "207540",
        "lat": "44.412682",
        "long": "23.493844"
      },
      {
        "name": "SORENI",
        "zip": "207179",
        "lat": "44.052416",
        "long": "24.127268"
      },
      {
        "name": "SPINENI",
        "zip": "207397",
        "lat": "44.55889",
        "long": "23.730557"
      },
      {
        "name": "STEFANEL",
        "zip": "207302",
        "lat": "44.426339",
        "long": "23.409247"
      },
      {
        "name": "STIUBEI",
        "zip": "207633",
        "lat": "44.324549",
        "long": "23.358619"
      },
      {
        "name": "STOICESTI",
        "zip": "207146",
        "lat": "44.620908",
        "long": "23.875037"
      },
      {
        "name": "SUHARU",
        "zip": "207632",
        "lat": "44.268284",
        "long": "23.388142"
      },
      {
        "name": "SUMANDRA",
        "zip": "207533",
        "lat": "44.463957",
        "long": "23.289557"
      },
      {
        "name": "TALPAS",
        "zip": "207266",
        "lat": "44.680469",
        "long": "23.74394"
      },
      {
        "name": "TAMBURESTI",
        "zip": "207101",
        "lat": "44.02779",
        "long": "23.93602"
      },
      {
        "name": "TANDARA",
        "zip": "207322",
        "lat": "44.489392",
        "long": "23.737582"
      },
      {
        "name": "TARNAVA",
        "zip": "207488",
        "lat": "44.17705",
        "long": "23.54902"
      },
      {
        "name": "TARTAL",
        "zip": "207586",
        "lat": "44.199945",
        "long": "24.115449"
      },
      {
        "name": "TATOMIRESTI",
        "zip": "207111",
        "lat": "44.516811",
        "long": "23.596675"
      },
      {
        "name": "TEASC",
        "zip": "207570",
        "lat": "44.161253",
        "long": "23.86562"
      },
      {
        "name": "TEASCU DIN DEAL",
        "zip": "207047",
        "lat": "44.524415",
        "long": "23.389763"
      },
      {
        "name": "TEIU",
        "zip": "207439",
        "lat": "44.253314",
        "long": "23.294726"
      },
      {
        "name": "TENCANAU",
        "zip": "207513",
        "lat": "44.22785",
        "long": "23.486408"
      },
      {
        "name": "TERPEZITA",
        "zip": "207575",
        "lat": "44.294919",
        "long": "23.503672"
      },
      {
        "name": "TESLUI",
        "zip": "207580",
        "lat": "44.205525",
        "long": "24.157627"
      },
      {
        "name": "TIU",
        "zip": "207189",
        "lat": "44.445702",
        "long": "23.381891"
      },
      {
        "name": "TOCENI",
        "zip": "207239",
        "lat": "43.96429",
        "long": "23.945047"
      },
      {
        "name": "TUGLUI",
        "zip": "207590",
        "lat": "44.187506",
        "long": "23.811764"
      },
      {
        "name": "TUNARII NOI",
        "zip": "207471",
        "lat": "43.930705",
        "long": "23.135552"
      },
      {
        "name": "TUNARII VECHI",
        "zip": "207472",
        "lat": "43.91155",
        "long": "23.11903"
      },
      {
        "name": "UNGURENI",
        "zip": "207283",
        "lat": "44.401045",
        "long": "23.942564"
      },
      {
        "name": "UNGURENII MICI",
        "zip": "207284",
        "lat": "44.416479",
        "long": "23.911935"
      },
      {
        "name": "UNIREA",
        "zip": "207595",
        "lat": "44.159598",
        "long": "23.171496"
      },
      {
        "name": "URDINITA",
        "zip": "207079",
        "lat": "44.388471",
        "long": "23.424625"
      },
      {
        "name": "URECHESTI",
        "zip": "207411",
        "lat": "44.40105",
        "long": "23.846626"
      },
      {
        "name": "URIENI",
        "zip": "207587",
        "lat": "44.219698",
        "long": "24.146697"
      },
      {
        "name": "URSOAIA",
        "zip": "207048",
        "lat": "44.533195",
        "long": "23.403371"
      },
      {
        "name": "URZICA MARE",
        "zip": "207601",
        "lat": "44.014764",
        "long": "23.595894"
      },
      {
        "name": "URZICUTA",
        "zip": "207600",
        "lat": "44.009087",
        "long": "23.539243"
      },
      {
        "name": "USCACI",
        "zip": "205306",
        "lat": "44.608457",
        "long": "23.588236"
      },
      {
        "name": "VALEA FANTANILOR",
        "zip": "207091",
        "lat": "44.501371",
        "long": "23.483142"
      },
      {
        "name": "VALEA LUI PATRU",
        "zip": "207516",
        "lat": "44.472295",
        "long": "23.521276"
      },
      {
        "name": "VALEA LUNGULUI",
        "zip": "207122",
        "lat": "44.351409",
        "long": "23.66663"
      },
      {
        "name": "VALEA MARE",
        "zip": "207398",
        "lat": "44.549283",
        "long": "23.695361"
      },
      {
        "name": "VALEA MUIERII DE JOS",
        "zip": "207399",
        "lat": "44.558006",
        "long": "23.678547"
      },
      {
        "name": "VALEA STANCIULUI",
        "zip": "207605",
        "lat": "43.985288",
        "long": "23.874521"
      },
      {
        "name": "VARTOP",
        "zip": "207610",
        "lat": "44.206254",
        "long": "23.348642"
      },
      {
        "name": "VARVOR",
        "zip": "207623",
        "lat": "44.228102",
        "long": "23.62659"
      },
      {
        "name": "VARVORU DE JOS",
        "zip": "207615",
        "lat": "44.244876",
        "long": "23.608878"
      },
      {
        "name": "VELA",
        "zip": "207625",
        "lat": "44.277738",
        "long": "23.420877"
      },
      {
        "name": "VELENI",
        "zip": "207527",
        "lat": "44.382336",
        "long": "23.305988"
      },
      {
        "name": "VELESTI",
        "zip": "207428",
        "lat": "44.600573",
        "long": "23.787829"
      },
      {
        "name": "VERBICIOARA",
        "zip": "207636",
        "lat": "44.283826",
        "long": "23.187668"
      },
      {
        "name": "VERBITA",
        "zip": "207635",
        "lat": "44.302283",
        "long": "23.167729"
      },
      {
        "name": "VIISOARA",
        "zip": "207246",
        "lat": "44.233491",
        "long": "24.114801"
      },
      {
        "name": "VIISOARA-MOSNENI",
        "zip": "207588",
        "lat": "44.229726",
        "long": "24.141467"
      },
      {
        "name": "VLADIMIR",
        "zip": "207323",
        "lat": "44.502045",
        "long": "23.761183"
      },
      {
        "name": "VOITA",
        "zip": "207081",
        "lat": "44.363953",
        "long": "23.380306"
      },
      {
        "name": "ZANOAGA",
        "zip": "207351",
        "lat": "44.155308",
        "long": "24.09747"
      },
      {
        "name": "ZAVAL",
        "zip": "207287",
        "lat": "43.847173",
        "long": "23.842079"
      },
      {
        "name": "ZLATARI",
        "zip": "207324",
        "lat": "44.457448",
        "long": "23.746978"
      },
      {
        "name": "ZVORSCA",
        "zip": "207028",
        "lat": "43.990774",
        "long": "24.173001"
      }
    ],
    "GALAȚI": [
      {
        "name": "ADAM",
        "zip": "807116",
        "lat": "46.028684",
        "long": "27.732957"
      },
      {
        "name": "ALDESTI",
        "zip": "807036",
        "lat": "46.132356",
        "long": "27.915181"
      },
      {
        "name": "BALABANESTI",
        "zip": "807010",
        "lat": "46.095457",
        "long": "27.72206"
      },
      {
        "name": "BALASESTI",
        "zip": "807020",
        "lat": "46.101337",
        "long": "27.673876"
      },
      {
        "name": "BALENI",
        "zip": "807025",
        "lat": "45.809832",
        "long": "27.853527"
      },
      {
        "name": "BALINTESTI",
        "zip": "807037",
        "lat": "46.028199",
        "long": "27.921112"
      },
      {
        "name": "BALTARETI",
        "zip": "807086",
        "lat": "45.850937",
        "long": "27.325187"
      },
      {
        "name": "BANEASA",
        "zip": "807030",
        "lat": "45.947206",
        "long": "27.935806"
      },
      {
        "name": "BARCEA",
        "zip": "807005",
        "lat": "45.750206",
        "long": "27.475952"
      },
      {
        "name": "BERESTI",
        "zip": "805100",
        "lat": "46.096481",
        "long": "27.886231"
      },
      {
        "name": "BERESTI-MERIA",
        "zip": "807035",
        "lat": "46.085258",
        "long": "27.902127"
      },
      {
        "name": "BLANZI",
        "zip": "807081",
        "lat": "45.935748",
        "long": "27.650629"
      },
      {
        "name": "BRAHASESTI",
        "zip": "807055",
        "lat": "46.039917",
        "long": "27.370146"
      },
      {
        "name": "BRANESTI",
        "zip": "807336",
        "lat": "45.802223",
        "long": "28.085857"
      },
      {
        "name": "BRANISTEA",
        "zip": "807050",
        "lat": "45.436766",
        "long": "27.834197"
      },
      {
        "name": "BRANISTEA",
        "zip": "807216",
        "lat": "45.945333",
        "long": "27.326034"
      },
      {
        "name": "BRATULESTI",
        "zip": "807082",
        "lat": "45.946097",
        "long": "27.665794"
      },
      {
        "name": "BUCESTI",
        "zip": "807171",
        "lat": "45.652872",
        "long": "27.528666"
      },
      {
        "name": "BUCIUMENI",
        "zip": "807060",
        "lat": "46.001599",
        "long": "27.306073"
      },
      {
        "name": "BURSUCANI",
        "zip": "807011",
        "lat": "46.044242",
        "long": "27.771691"
      },
      {
        "name": "CALMATUI",
        "zip": "807161",
        "lat": "45.684032",
        "long": "27.637302"
      },
      {
        "name": "CARAPCESTI",
        "zip": "807083",
        "lat": "45.965173",
        "long": "27.658456"
      },
      {
        "name": "CARLOMANESTI",
        "zip": "807071",
        "lat": "45.993101",
        "long": "27.588781"
      },
      {
        "name": "CAUIESTI",
        "zip": "807117",
        "lat": "46.009091",
        "long": "27.703609"
      },
      {
        "name": "CAVADINESTI",
        "zip": "807065",
        "lat": "46.066104",
        "long": "28.018835"
      },
      {
        "name": "CERTESTI",
        "zip": "807070",
        "lat": "46.015212",
        "long": "27.633147"
      },
      {
        "name": "CHIRAFTEI",
        "zip": "807191",
        "lat": "45.770201",
        "long": "28.028771"
      },
      {
        "name": "CIORASTI",
        "zip": "807251",
        "lat": "46.113802",
        "long": "27.453111"
      },
      {
        "name": "CISMELE",
        "zip": "807276",
        "lat": "45.514693",
        "long": "27.927676"
      },
      {
        "name": "CIURESTI",
        "zip": "807021",
        "lat": "46.078561",
        "long": "27.635642"
      },
      {
        "name": "CIURESTII NOI",
        "zip": "807022",
        "lat": "46.100869",
        "long": "27.639408"
      },
      {
        "name": "COASTA LUPEI",
        "zip": "807217",
        "lat": "45.946093",
        "long": "27.273126"
      },
      {
        "name": "COMANESTI",
        "zip": "807066",
        "lat": "46.099018",
        "long": "27.967135"
      },
      {
        "name": "CONDREA",
        "zip": "807311",
        "lat": "45.709274",
        "long": "27.431453"
      },
      {
        "name": "CORCIOVENI",
        "zip": "807056",
        "lat": "46.070714",
        "long": "27.367312"
      },
      {
        "name": "CORNI",
        "zip": "807075",
        "lat": "45.85782",
        "long": "27.784029"
      },
      {
        "name": "COROD",
        "zip": "807080",
        "lat": "45.900008",
        "long": "27.630528"
      },
      {
        "name": "COSITENI",
        "zip": "807057",
        "lat": "46.07204",
        "long": "27.376266"
      },
      {
        "name": "COSMESTI",
        "zip": "807085",
        "lat": "45.868805",
        "long": "27.308328"
      },
      {
        "name": "COSMESTII-VALE",
        "zip": "807087",
        "lat": "45.869311",
        "long": "27.287708"
      },
      {
        "name": "COSTACHE NEGRI",
        "zip": "807095",
        "lat": "45.698342",
        "long": "27.720237"
      },
      {
        "name": "COSTI",
        "zip": "807326",
        "lat": "45.498728",
        "long": "28.017789"
      },
      {
        "name": "COTOROAIA",
        "zip": "807072",
        "lat": "46.043979",
        "long": "27.645708"
      },
      {
        "name": "CRAIESTI",
        "zip": "807331",
        "lat": "45.943256",
        "long": "27.811623"
      },
      {
        "name": "CRANGENI",
        "zip": "807211",
        "lat": "45.49397",
        "long": "27.558025"
      },
      {
        "name": "CRUCEANU",
        "zip": "807012",
        "lat": "46.09401",
        "long": "27.800133"
      },
      {
        "name": "CUCA",
        "zip": "807100",
        "lat": "45.731906",
        "long": "27.891571"
      },
      {
        "name": "CUDALBI",
        "zip": "807105",
        "lat": "45.772316",
        "long": "27.686149"
      },
      {
        "name": "CUZA VODA",
        "zip": "807271",
        "lat": "45.595152",
        "long": "27.788576"
      },
      {
        "name": "DOBRINESTI",
        "zip": "807218",
        "lat": "45.913388",
        "long": "27.319875"
      },
      {
        "name": "DRAGANESTI",
        "zip": "807110",
        "lat": "45.786146",
        "long": "27.46265"
      },
      {
        "name": "DRAGUSENI",
        "zip": "807115",
        "lat": "45.978353",
        "long": "27.76339"
      },
      {
        "name": "FANTANELE",
        "zip": "807261",
        "lat": "45.701223",
        "long": "28.003277"
      },
      {
        "name": "FANTANI",
        "zip": "807219",
        "lat": "45.954486",
        "long": "27.290026"
      },
      {
        "name": "FARTANESTI",
        "zip": "807125",
        "lat": "45.78964",
        "long": "27.991316"
      },
      {
        "name": "FOLTESTI",
        "zip": "807130",
        "lat": "45.745888",
        "long": "28.059346"
      },
      {
        "name": "FRUMUSITA",
        "zip": "807135",
        "lat": "45.653019",
        "long": "28.066254"
      },
      {
        "name": "FRUNZEASCA",
        "zip": "807201",
        "lat": "45.918121",
        "long": "27.423501"
      },
      {
        "name": "FUNDEANU",
        "zip": "807118",
        "lat": "45.9852",
        "long": "27.732843"
      },
      {
        "name": "FUNDENI",
        "zip": "807140",
        "lat": "45.541225",
        "long": "27.540564"
      },
      {
        "name": "FUNDENII NOI",
        "zip": "807141",
        "lat": "45.577977",
        "long": "27.547023"
      },
      {
        "name": "FURCENII NOI",
        "zip": "807088",
        "lat": "45.811175",
        "long": "27.339537"
      },
      {
        "name": "FURCENII VECHI",
        "zip": "807089",
        "lat": "45.843157",
        "long": "27.32629"
      },
      {
        "name": "GALATI",
        "zip": "800001",
        "lat": "45.433822",
        "long": "28.05494"
      },
      {
        "name": "GANESTI",
        "zip": "807067",
        "lat": "46.089519",
        "long": "27.993655"
      },
      {
        "name": "GARA BERHECI",
        "zip": "807156",
        "lat": "45.974288",
        "long": "27.437468"
      },
      {
        "name": "GARA GHIDIGENI",
        "zip": "807146",
        "lat": "46.070307",
        "long": "27.483649"
      },
      {
        "name": "GARBOVAT",
        "zip": "807147",
        "lat": "46.02192",
        "long": "27.519696"
      },
      {
        "name": "GEFU",
        "zip": "807148",
        "lat": "46.064292",
        "long": "27.501276"
      },
      {
        "name": "GHIDIGENI",
        "zip": "807145",
        "lat": "46.049328",
        "long": "27.489024"
      },
      {
        "name": "GHINGHESTI",
        "zip": "807119",
        "lat": "46.013527",
        "long": "27.765442"
      },
      {
        "name": "GOHOR",
        "zip": "807155",
        "lat": "46.064916",
        "long": "27.412179"
      },
      {
        "name": "GRIVITA",
        "zip": "807160",
        "lat": "45.712491",
        "long": "27.650746"
      },
      {
        "name": "GROZAVESTI",
        "zip": "807221",
        "lat": "45.942483",
        "long": "27.306807"
      },
      {
        "name": "GURA GARBOVATULUI",
        "zip": "807149",
        "lat": "46.025473",
        "long": "27.484123"
      },
      {
        "name": "HANTESTI",
        "zip": "807061",
        "lat": "45.964049",
        "long": "27.309497"
      },
      {
        "name": "HANU CONACHI",
        "zip": "807142",
        "lat": "45.585523",
        "long": "27.60348"
      },
      {
        "name": "HUSTIU",
        "zip": "807252",
        "lat": "46.129964",
        "long": "27.429714"
      },
      {
        "name": "IJDILENI",
        "zip": "807136",
        "lat": "45.63517",
        "long": "28.057024"
      },
      {
        "name": "INDEPENDENTA",
        "zip": "807165",
        "lat": "45.473066",
        "long": "27.762326"
      },
      {
        "name": "IONASESTI",
        "zip": "807222",
        "lat": "45.90993",
        "long": "27.284163"
      },
      {
        "name": "IREASCA",
        "zip": "807157",
        "lat": "46.040211",
        "long": "27.430323"
      },
      {
        "name": "IVESTI",
        "zip": "807170",
        "lat": "45.684778",
        "long": "27.51802"
      },
      {
        "name": "IZVOARELE",
        "zip": "807272",
        "lat": "45.554304",
        "long": "27.768829"
      },
      {
        "name": "JORASTI",
        "zip": "807175",
        "lat": "45.991426",
        "long": "27.871689"
      },
      {
        "name": "LIESTI",
        "zip": "807180",
        "lat": "45.616011",
        "long": "27.544218"
      },
      {
        "name": "LIESTI",
        "zip": "807253",
        "lat": "46.105446",
        "long": "27.433032"
      },
      {
        "name": "LOZOVA",
        "zip": "807051",
        "lat": "45.44732",
        "long": "27.819525"
      },
      {
        "name": "LUNCA",
        "zip": "807176",
        "lat": "45.946689",
        "long": "27.8894"
      },
      {
        "name": "LUNGESTI",
        "zip": "807013",
        "lat": "46.10911",
        "long": "27.753728"
      },
      {
        "name": "LUNGOCI",
        "zip": "807143",
        "lat": "45.566238",
        "long": "27.517969"
      },
      {
        "name": "LUPELE",
        "zip": "807241",
        "lat": "45.6612",
        "long": "27.856608"
      },
      {
        "name": "MACISENI",
        "zip": "807076",
        "lat": "45.855833",
        "long": "27.753546"
      },
      {
        "name": "MALU ALB",
        "zip": "807111",
        "lat": "45.796917",
        "long": "27.462999"
      },
      {
        "name": "MALURENI",
        "zip": "807223",
        "lat": "45.930397",
        "long": "27.275204"
      },
      {
        "name": "MANDRESTI",
        "zip": "807321",
        "lat": "45.877124",
        "long": "27.696855"
      },
      {
        "name": "MASTACANI",
        "zip": "807190",
        "lat": "45.763801",
        "long": "28.054727"
      },
      {
        "name": "MATCA",
        "zip": "807185",
        "lat": "45.856857",
        "long": "27.536597"
      },
      {
        "name": "MIHAIL KOGALNICEANU",
        "zip": "807277",
        "lat": "45.505821",
        "long": "27.927676"
      },
      {
        "name": "MOSCU",
        "zip": "805201",
        "lat": "45.902315",
        "long": "27.931482"
      },
      {
        "name": "MOVILENI",
        "zip": "807291",
        "lat": "45.404776",
        "long": "27.966333"
      },
      {
        "name": "MOVILENI",
        "zip": "807195",
        "lat": "45.765841",
        "long": "27.375873"
      },
      {
        "name": "MUNTENI",
        "zip": "807200",
        "lat": "45.927643",
        "long": "27.440454"
      },
      {
        "name": "NAMOLOASA",
        "zip": "807210",
        "lat": "45.53627",
        "long": "27.551563"
      },
      {
        "name": "NAMOLOASA-SAT",
        "zip": "807212",
        "lat": "45.541303",
        "long": "27.578768"
      },
      {
        "name": "NARTESTI",
        "zip": "807158",
        "lat": "46.013732",
        "long": "27.407551"
      },
      {
        "name": "NEGREA",
        "zip": "807266",
        "lat": "45.535977",
        "long": "27.871019"
      },
      {
        "name": "NEGRILESTI",
        "zip": "807202",
        "lat": "45.957287",
        "long": "27.480847"
      },
      {
        "name": "NICOPOLE",
        "zip": "807121",
        "lat": "45.966378",
        "long": "27.716611"
      },
      {
        "name": "NICORESTI",
        "zip": "807215",
        "lat": "45.929174",
        "long": "27.308339"
      },
      {
        "name": "OANCEA",
        "zip": "807235",
        "lat": "45.918503",
        "long": "28.111965"
      },
      {
        "name": "ODAIA MANOLACHE",
        "zip": "807327",
        "lat": "45.550276",
        "long": "27.987125"
      },
      {
        "name": "ONCIU",
        "zip": "807038",
        "lat": "46.055881",
        "long": "27.950097"
      },
      {
        "name": "PECHEA",
        "zip": "807240",
        "lat": "45.624057",
        "long": "27.795807"
      },
      {
        "name": "PISCU",
        "zip": "807245",
        "lat": "45.501556",
        "long": "27.728399"
      },
      {
        "name": "PISCU CORBULUI",
        "zip": "807224",
        "lat": "45.957706",
        "long": "27.261212"
      },
      {
        "name": "PLESA",
        "zip": "807039",
        "lat": "46.143104",
        "long": "27.866429"
      },
      {
        "name": "PLEVNA",
        "zip": "807256",
        "lat": "45.728329",
        "long": "27.853072"
      },
      {
        "name": "PODOLENI",
        "zip": "807006",
        "lat": "45.748304",
        "long": "27.446613"
      },
      {
        "name": "POIANA",
        "zip": "807226",
        "lat": "45.99232",
        "long": "27.255883"
      },
      {
        "name": "POSTA",
        "zip": "807159",
        "lat": "45.984942",
        "long": "27.444353"
      },
      {
        "name": "PRIPONESTI",
        "zip": "807250",
        "lat": "46.086069",
        "long": "27.439269"
      },
      {
        "name": "PRIPONESTII DE JOS",
        "zip": "807254",
        "lat": "46.071496",
        "long": "27.448973"
      },
      {
        "name": "PRODANESTI",
        "zip": "807041",
        "lat": "46.109975",
        "long": "27.953201"
      },
      {
        "name": "PUPEZENI",
        "zip": "807023",
        "lat": "46.079351",
        "long": "27.684831"
      },
      {
        "name": "PURICANI",
        "zip": "807042",
        "lat": "46.120588",
        "long": "27.939217"
      },
      {
        "name": "RADESTI",
        "zip": "807014",
        "lat": "46.07305",
        "long": "27.790334"
      },
      {
        "name": "REDIU",
        "zip": "807255",
        "lat": "45.712976",
        "long": "27.839875"
      },
      {
        "name": "ROGOJENI",
        "zip": "807286",
        "lat": "45.980436",
        "long": "28.091768"
      },
      {
        "name": "ROSCANI",
        "zip": "807031",
        "lat": "45.911424",
        "long": "28.020096"
      },
      {
        "name": "SALCIA",
        "zip": "807312",
        "lat": "45.696631",
        "long": "27.441771"
      },
      {
        "name": "SARBI",
        "zip": "807227",
        "lat": "45.927113",
        "long": "27.325456"
      },
      {
        "name": "SASENI",
        "zip": "807043",
        "lat": "46.127792",
        "long": "27.931068"
      },
      {
        "name": "SATU NOU",
        "zip": "807091",
        "lat": "45.846392",
        "long": "27.318557"
      },
      {
        "name": "SCANTEIESTI",
        "zip": "807260",
        "lat": "45.674869",
        "long": "28.004481"
      },
      {
        "name": "SCHELA",
        "zip": "807265",
        "lat": "45.507977",
        "long": "27.830881"
      },
      {
        "name": "SENDRENI",
        "zip": "807290",
        "lat": "45.412366",
        "long": "27.927586"
      },
      {
        "name": "SERBESTII VECHI",
        "zip": "807292",
        "lat": "45.421562",
        "long": "27.879705"
      },
      {
        "name": "SILISTEA",
        "zip": "807313",
        "lat": "45.733722",
        "long": "27.438173"
      },
      {
        "name": "SIPOTE",
        "zip": "807046",
        "lat": "46.147253",
        "long": "27.908179"
      },
      {
        "name": "SIVITA",
        "zip": "807301",
        "lat": "45.612848",
        "long": "28.057566"
      },
      {
        "name": "SLIVNA",
        "zip": "807044",
        "lat": "46.084363",
        "long": "27.941534"
      },
      {
        "name": "SLOBOZIA BLANEASA",
        "zip": "807203",
        "lat": "45.938653",
        "long": "27.479049"
      },
      {
        "name": "SLOBOZIA CONACHI",
        "zip": "807270",
        "lat": "45.584285",
        "long": "27.769778"
      },
      {
        "name": "SLOBOZIA CORNI",
        "zip": "807151",
        "lat": "45.991664",
        "long": "27.480342"
      },
      {
        "name": "SLOBOZIA OANCEA",
        "zip": "807236",
        "lat": "45.894729",
        "long": "28.110331"
      },
      {
        "name": "SMARDAN",
        "zip": "807275",
        "lat": "45.472415",
        "long": "27.945631"
      },
      {
        "name": "SMULTI",
        "zip": "807280",
        "lat": "45.93246",
        "long": "27.754877"
      },
      {
        "name": "STIETESTI",
        "zip": "807122",
        "lat": "46.029402",
        "long": "27.708317"
      },
      {
        "name": "STOICANI",
        "zip": "807131",
        "lat": "45.704669",
        "long": "28.073671"
      },
      {
        "name": "SUCEVENI",
        "zip": "807285",
        "lat": "46.009504",
        "long": "28.022342"
      },
      {
        "name": "SUHURLUI",
        "zip": "807257",
        "lat": "45.728537",
        "long": "27.826287"
      },
      {
        "name": "TALPIGI",
        "zip": "807152",
        "lat": "46.008677",
        "long": "27.475451"
      },
      {
        "name": "TAMAOANI",
        "zip": "807137",
        "lat": "45.679263",
        "long": "28.074412"
      },
      {
        "name": "TAPLAU",
        "zip": "807153",
        "lat": "46.033151",
        "long": "27.487781"
      },
      {
        "name": "TARGU BUJOR",
        "zip": "805200",
        "lat": "45.870212",
        "long": "27.913812"
      },
      {
        "name": "TATARCA",
        "zip": "807302",
        "lat": "45.598752",
        "long": "28.051769"
      },
      {
        "name": "TECUCELU SEC",
        "zip": "807062",
        "lat": "45.981529",
        "long": "27.32941"
      },
      {
        "name": "TECUCI",
        "zip": "805300",
        "lat": "45.845782",
        "long": "27.42908"
      },
      {
        "name": "TEPU",
        "zip": "807305",
        "lat": "45.96912",
        "long": "27.37945"
      },
      {
        "name": "TEPU DE SUS",
        "zip": "807306",
        "lat": "45.98555",
        "long": "27.374099"
      },
      {
        "name": "TIGANESTI",
        "zip": "807204",
        "lat": "45.901464",
        "long": "27.434424"
      },
      {
        "name": "TOFLEA",
        "zip": "807058",
        "lat": "46.063719",
        "long": "27.334106"
      },
      {
        "name": "TORCESTI",
        "zip": "807314",
        "lat": "45.697079",
        "long": "27.485992"
      },
      {
        "name": "TRAIAN",
        "zip": "807052",
        "lat": "45.424746",
        "long": "27.868231"
      },
      {
        "name": "TUDOR VLADIMIRESCU",
        "zip": "807295",
        "lat": "45.563407",
        "long": "27.648908"
      },
      {
        "name": "TULUCESTI",
        "zip": "807300",
        "lat": "45.566573",
        "long": "28.047667"
      },
      {
        "name": "UMBRARESTI",
        "zip": "805202",
        "lat": "45.848348",
        "long": "27.918446"
      },
      {
        "name": "UMBRARESTI",
        "zip": "807310",
        "lat": "45.714965",
        "long": "27.467454"
      },
      {
        "name": "UMBRARESTI-DEAL",
        "zip": "807316",
        "lat": "45.73124",
        "long": "27.486406"
      },
      {
        "name": "UNGURENI",
        "zip": "807206",
        "lat": "45.913074",
        "long": "27.470002"
      },
      {
        "name": "URLESTI",
        "zip": "807077",
        "lat": "45.894238",
        "long": "27.791477"
      },
      {
        "name": "VADENI",
        "zip": "807068",
        "lat": "46.067523",
        "long": "28.085266"
      },
      {
        "name": "VALEA MARULUI",
        "zip": "807320",
        "lat": "45.838656",
        "long": "27.691381"
      },
      {
        "name": "VAMES",
        "zip": "807246",
        "lat": "45.531136",
        "long": "27.707134"
      },
      {
        "name": "VANATORI",
        "zip": "807325",
        "lat": "45.529936",
        "long": "28.015421"
      },
      {
        "name": "VARLEZI",
        "zip": "807330",
        "lat": "45.901748",
        "long": "27.847971"
      },
      {
        "name": "VASILE ALECSANDRI",
        "zip": "807053",
        "lat": "45.451519",
        "long": "27.798015"
      },
      {
        "name": "VIILE",
        "zip": "807126",
        "lat": "45.805883",
        "long": "27.946018"
      },
      {
        "name": "VISINA",
        "zip": "807228",
        "lat": "45.998439",
        "long": "27.277277"
      },
      {
        "name": "VIZURESTI",
        "zip": "807063",
        "lat": "45.959851",
        "long": "27.332669"
      },
      {
        "name": "VLADESTI",
        "zip": "807335",
        "lat": "45.837598",
        "long": "28.091036"
      },
      {
        "name": "ZARNESTI",
        "zip": "807177",
        "lat": "46.018007",
        "long": "27.854119"
      },
      {
        "name": "ZIMBRU",
        "zip": "807016",
        "lat": "46.056516",
        "long": "27.765701"
      }
    ],
    "GIURGIU": [
      {
        "name": "ADUNATII-COPACENI",
        "zip": "087005",
        "lat": "44.251572",
        "long": "26.045189"
      },
      {
        "name": "ANGHELESTI",
        "zip": "087021",
        "lat": "44.337154",
        "long": "25.64159"
      },
      {
        "name": "BACU",
        "zip": "087151",
        "lat": "44.482384",
        "long": "25.890665"
      },
      {
        "name": "BALANU",
        "zip": "087216",
        "lat": "43.919221",
        "long": "25.919191"
      },
      {
        "name": "BANEASA",
        "zip": "087010",
        "lat": "44.046659",
        "long": "26.068809"
      },
      {
        "name": "BANESTI",
        "zip": "087131",
        "lat": "44.274061",
        "long": "25.890979"
      },
      {
        "name": "BILA",
        "zip": "087201",
        "lat": "44.169802",
        "long": "25.85131"
      },
      {
        "name": "BOLINTIN-DEAL",
        "zip": "087015",
        "lat": "44.452718",
        "long": "25.82437"
      },
      {
        "name": "BOLINTIN-VALE",
        "zip": "085100",
        "lat": "44.447488",
        "long": "25.758435"
      },
      {
        "name": "BRANISTARI",
        "zip": "087041",
        "lat": "44.177695",
        "long": "26.056592"
      },
      {
        "name": "BRANISTEA",
        "zip": "087176",
        "lat": "43.966267",
        "long": "26.036868"
      },
      {
        "name": "BUCSANI",
        "zip": "087020",
        "lat": "44.370471",
        "long": "25.660644"
      },
      {
        "name": "BUDENI",
        "zip": "087056",
        "lat": "44.191342",
        "long": "26.113164"
      },
      {
        "name": "BULBUCATA",
        "zip": "087030",
        "lat": "44.277194",
        "long": "25.822484"
      },
      {
        "name": "BUTURUGENI",
        "zip": "087035",
        "lat": "44.366397",
        "long": "25.836696"
      },
      {
        "name": "CALUGARENI",
        "zip": "087040",
        "lat": "44.186113",
        "long": "26.001348"
      },
      {
        "name": "CAMINEASCA",
        "zip": "087202",
        "lat": "44.170776",
        "long": "25.81815"
      },
      {
        "name": "CAMPURELU",
        "zip": "087051",
        "lat": "44.232356",
        "long": "26.182475"
      },
      {
        "name": "CARAPANCEA",
        "zip": "087191",
        "lat": "44.099986",
        "long": "25.711619"
      },
      {
        "name": "CARPENISU",
        "zip": "087086",
        "lat": "44.533889",
        "long": "25.634016"
      },
      {
        "name": "CARTOJANI",
        "zip": "087196",
        "lat": "44.432208",
        "long": "25.489941"
      },
      {
        "name": "CASCIOARELE",
        "zip": "087087",
        "lat": "44.499273",
        "long": "25.635165"
      },
      {
        "name": "CASCIOARELE",
        "zip": "087231",
        "lat": "44.518124",
        "long": "25.747046"
      },
      {
        "name": "CETATEA",
        "zip": "087081",
        "lat": "43.945089",
        "long": "25.952636"
      },
      {
        "name": "CETATUIA",
        "zip": "087091",
        "lat": "43.757675",
        "long": "25.743788"
      },
      {
        "name": "CHIRCULESTI",
        "zip": "087132",
        "lat": "44.263813",
        "long": "25.920979"
      },
      {
        "name": "CHIRIACU",
        "zip": "087141",
        "lat": "44.050363",
        "long": "25.777257"
      },
      {
        "name": "CLEJANI",
        "zip": "087045",
        "lat": "44.318134",
        "long": "25.701568"
      },
      {
        "name": "COLIBASI",
        "zip": "087050",
        "lat": "44.208266",
        "long": "26.192997"
      },
      {
        "name": "COMANA",
        "zip": "087055",
        "lat": "44.174446",
        "long": "26.143656"
      },
      {
        "name": "COMASCA",
        "zip": "087177",
        "lat": "43.950522",
        "long": "26.048712"
      },
      {
        "name": "COPACIU",
        "zip": "087096",
        "lat": "44.184627",
        "long": "25.767212"
      },
      {
        "name": "CORBEANCA",
        "zip": "087251",
        "lat": "44.476845",
        "long": "25.566399"
      },
      {
        "name": "COSOBA",
        "zip": "087152",
        "lat": "44.523545",
        "long": "25.81557"
      },
      {
        "name": "COTENI",
        "zip": "087031",
        "lat": "44.309741",
        "long": "25.831217"
      },
      {
        "name": "CRANGURI",
        "zip": "087206",
        "lat": "44.207486",
        "long": "25.979077"
      },
      {
        "name": "CREVEDIA MARE",
        "zip": "087060",
        "lat": "44.430112",
        "long": "25.62512"
      },
      {
        "name": "CREVEDIA MICA",
        "zip": "087061",
        "lat": "44.441073",
        "long": "25.608612"
      },
      {
        "name": "CRIVINA",
        "zip": "085101",
        "lat": "44.431755",
        "long": "25.783964"
      },
      {
        "name": "CRUCEA DE PIATRA",
        "zip": "087042",
        "lat": "44.157221",
        "long": "26.000324"
      },
      {
        "name": "CUCURUZU",
        "zip": "087192",
        "lat": "44.078272",
        "long": "25.733599"
      },
      {
        "name": "CUPELE",
        "zip": "087252",
        "lat": "44.503711",
        "long": "25.527197"
      },
      {
        "name": "DAIA",
        "zip": "087070",
        "lat": "43.984753",
        "long": "25.989369"
      },
      {
        "name": "DARASTI-VLASCA",
        "zip": "087006",
        "lat": "44.28888",
        "long": "26.009992"
      },
      {
        "name": "DEALU",
        "zip": "087062",
        "lat": "44.399648",
        "long": "25.648186"
      },
      {
        "name": "DIMITRIE CANTEMIR",
        "zip": "087142",
        "lat": "44.026818",
        "long": "25.819022"
      },
      {
        "name": "DOBRENI",
        "zip": "087246",
        "lat": "44.253504",
        "long": "26.21539"
      },
      {
        "name": "DRAGANEASCA",
        "zip": "087232",
        "lat": "44.529099",
        "long": "25.740035"
      },
      {
        "name": "DRAGANESCU",
        "zip": "085201",
        "lat": "44.342719",
        "long": "25.885111"
      },
      {
        "name": "DRAGHICEANU",
        "zip": "087101",
        "lat": "43.866404",
        "long": "25.676043"
      },
      {
        "name": "FACAU",
        "zip": "087032",
        "lat": "44.292715",
        "long": "25.832624"
      },
      {
        "name": "FALASTOACA",
        "zip": "087057",
        "lat": "44.200337",
        "long": "26.182733"
      },
      {
        "name": "FLORESTI",
        "zip": "087076",
        "lat": "44.508521",
        "long": "25.693762"
      },
      {
        "name": "FRASINU",
        "zip": "087011",
        "lat": "44.027766",
        "long": "26.022983"
      },
      {
        "name": "FRATESTI",
        "zip": "087080",
        "lat": "43.970322",
        "long": "25.969964"
      },
      {
        "name": "GAISEANCA",
        "zip": "087063",
        "lat": "44.464496",
        "long": "25.586914"
      },
      {
        "name": "GAISENI",
        "zip": "087085",
        "lat": "44.5154",
        "long": "25.645949"
      },
      {
        "name": "GAUJANI",
        "zip": "087090",
        "lat": "43.7391",
        "long": "25.711156"
      },
      {
        "name": "GHIMPATI",
        "zip": "087095",
        "lat": "44.194988",
        "long": "25.783403"
      },
      {
        "name": "GHIONEA",
        "zip": "087233",
        "lat": "44.483391",
        "long": "25.80237"
      },
      {
        "name": "GHIZDARU",
        "zip": "087217",
        "lat": "43.931678",
        "long": "25.882699"
      },
      {
        "name": "GIURGIU",
        "zip": "080011",
        "lat": "43.895861",
        "long": "25.96583"
      },
      {
        "name": "GOGOSARI",
        "zip": "087100",
        "lat": "43.858595",
        "long": "25.706097"
      },
      {
        "name": "GOLEASCA",
        "zip": "087022",
        "lat": "44.355549",
        "long": "25.588157"
      },
      {
        "name": "GORNENI",
        "zip": "087133",
        "lat": "44.28183",
        "long": "25.864546"
      },
      {
        "name": "GOSTINARI",
        "zip": "087105",
        "lat": "44.186606",
        "long": "26.22524"
      },
      {
        "name": "GOSTINU",
        "zip": "087110",
        "lat": "43.998443",
        "long": "26.118798"
      },
      {
        "name": "GRADINARI",
        "zip": "087115",
        "lat": "44.393448",
        "long": "25.816886"
      },
      {
        "name": "GRADISTEA",
        "zip": "087058",
        "lat": "44.213228",
        "long": "26.15952"
      },
      {
        "name": "GREACA",
        "zip": "087120",
        "lat": "44.109306",
        "long": "26.336772"
      },
      {
        "name": "HERASTI",
        "zip": "087126",
        "lat": "44.211743",
        "long": "26.359034"
      },
      {
        "name": "HOBAIA",
        "zip": "087171",
        "lat": "44.389768",
        "long": "25.776134"
      },
      {
        "name": "HODIVOAIA",
        "zip": "087186",
        "lat": "43.901844",
        "long": "25.795093"
      },
      {
        "name": "HOTARELE",
        "zip": "087125",
        "lat": "44.175933",
        "long": "26.36781"
      },
      {
        "name": "HULUBESTI",
        "zip": "087043",
        "lat": "44.166359",
        "long": "25.943093"
      },
      {
        "name": "IANCULESTI",
        "zip": "087221",
        "lat": "44.1392",
        "long": "25.925049"
      },
      {
        "name": "ICOANA",
        "zip": "087234",
        "lat": "44.492669",
        "long": "25.745861"
      },
      {
        "name": "IEPURESTI",
        "zip": "087130",
        "lat": "44.258327",
        "long": "25.883643"
      },
      {
        "name": "IZVOARELE",
        "zip": "087127",
        "lat": "44.169189",
        "long": "26.313984"
      },
      {
        "name": "IZVOARELE",
        "zip": "087140",
        "lat": "44.032515",
        "long": "25.774727"
      },
      {
        "name": "IZVORU",
        "zip": "087102",
        "lat": "43.883024",
        "long": "25.663207"
      },
      {
        "name": "IZVORU",
        "zip": "087253",
        "lat": "44.509331",
        "long": "25.539992"
      },
      {
        "name": "JOITA",
        "zip": "087150",
        "lat": "44.495892",
        "long": "25.855439"
      },
      {
        "name": "LETCA NOUA",
        "zip": "087155",
        "lat": "44.235351",
        "long": "25.741431"
      },
      {
        "name": "LETCA VECHE",
        "zip": "087156",
        "lat": "44.199276",
        "long": "25.685415"
      },
      {
        "name": "MALU",
        "zip": "087261",
        "lat": "43.815175",
        "long": "25.818635"
      },
      {
        "name": "MALU SPART",
        "zip": "085102",
        "lat": "44.443778",
        "long": "25.715743"
      },
      {
        "name": "MARSA",
        "zip": "087160",
        "lat": "44.373524",
        "long": "25.559725"
      },
      {
        "name": "MIHAI BRAVU",
        "zip": "087165",
        "lat": "44.139987",
        "long": "26.05847"
      },
      {
        "name": "MIHAI VODA",
        "zip": "087016",
        "lat": "44.444026",
        "long": "25.815351"
      },
      {
        "name": "MIHAILESTI",
        "zip": "085200",
        "lat": "44.324622",
        "long": "25.906888"
      },
      {
        "name": "MILCOVATU",
        "zip": "087157",
        "lat": "44.265699",
        "long": "25.698816"
      },
      {
        "name": "MILOSESTI",
        "zip": "087128",
        "lat": "44.209791",
        "long": "26.374517"
      },
      {
        "name": "MIRAU",
        "zip": "087222",
        "lat": "44.140192",
        "long": "25.864148"
      },
      {
        "name": "MIRONESTI",
        "zip": "087106",
        "lat": "44.169533",
        "long": "26.248224"
      },
      {
        "name": "MOGOSESTI",
        "zip": "087007",
        "lat": "44.238222",
        "long": "26.111042"
      },
      {
        "name": "MOSTENI",
        "zip": "087236",
        "lat": "44.463623",
        "long": "25.78847"
      },
      {
        "name": "NAIPU",
        "zip": "087097",
        "lat": "44.153682",
        "long": "25.760973"
      },
      {
        "name": "NEAJLOVU",
        "zip": "087046",
        "lat": "44.313633",
        "long": "25.752018"
      },
      {
        "name": "NOVACI",
        "zip": "085202",
        "lat": "44.300101",
        "long": "25.984485"
      },
      {
        "name": "OBEDENI",
        "zip": "087023",
        "lat": "44.351218",
        "long": "25.654375"
      },
      {
        "name": "OGREZENI",
        "zip": "087170",
        "lat": "44.40727",
        "long": "25.779378"
      },
      {
        "name": "OINACU",
        "zip": "087175",
        "lat": "43.956791",
        "long": "26.014568"
      },
      {
        "name": "ONCESTI",
        "zip": "087218",
        "lat": "43.955638",
        "long": "25.873346"
      },
      {
        "name": "PADURENI",
        "zip": "087036",
        "lat": "44.341389",
        "long": "25.806025"
      },
      {
        "name": "PALANCA",
        "zip": "087077",
        "lat": "44.474296",
        "long": "25.724731"
      },
      {
        "name": "PETRU RARES",
        "zip": "087143",
        "lat": "44.099468",
        "long": "25.790746"
      },
      {
        "name": "PIETRELE",
        "zip": "087012",
        "lat": "44.064917",
        "long": "26.115844"
      },
      {
        "name": "PIETRISU",
        "zip": "087092",
        "lat": "43.725878",
        "long": "25.673228"
      },
      {
        "name": "PLOPSORU",
        "zip": "087071",
        "lat": "44.01131",
        "long": "25.9872"
      },
      {
        "name": "PODISOR",
        "zip": "087024",
        "lat": "44.388643",
        "long": "25.716467"
      },
      {
        "name": "PODU DOAMNEI",
        "zip": "087047",
        "lat": "44.308309",
        "long": "25.745031"
      },
      {
        "name": "PODU ILFOVATULUI",
        "zip": "087037",
        "lat": "44.318545",
        "long": "25.818267"
      },
      {
        "name": "PODU POPA NAE",
        "zip": "087088",
        "lat": "44.518952",
        "long": "25.608929"
      },
      {
        "name": "POENARI",
        "zip": "087237",
        "lat": "44.471908",
        "long": "25.769046"
      },
      {
        "name": "POIANA LUI STANGA",
        "zip": "087254",
        "lat": "44.510169",
        "long": "25.586147"
      },
      {
        "name": "POPESTI",
        "zip": "085203",
        "lat": "44.304247",
        "long": "25.96174"
      },
      {
        "name": "POSTA",
        "zip": "087038",
        "lat": "44.353269",
        "long": "25.874141"
      },
      {
        "name": "PRIBOIU",
        "zip": "087064",
        "lat": "44.448829",
        "long": "25.589851"
      },
      {
        "name": "PRUNDU",
        "zip": "087180",
        "lat": "44.09439",
        "long": "26.228454"
      },
      {
        "name": "PUIENI",
        "zip": "087181",
        "lat": "44.076006",
        "long": "26.190009"
      },
      {
        "name": "PUTINEIU",
        "zip": "087185",
        "lat": "43.909384",
        "long": "25.741459"
      },
      {
        "name": "PUTU GRECI",
        "zip": "087121",
        "lat": "44.142141",
        "long": "26.348509"
      },
      {
        "name": "RADU VODA",
        "zip": "087144",
        "lat": "44.004852",
        "long": "25.81786"
      },
      {
        "name": "RALESTI",
        "zip": "087103",
        "lat": "43.855426",
        "long": "25.685031"
      },
      {
        "name": "RASUCENI",
        "zip": "087190",
        "lat": "44.093371",
        "long": "25.66985"
      },
      {
        "name": "REMUS",
        "zip": "087082",
        "lat": "43.943298",
        "long": "25.980396"
      },
      {
        "name": "ROATA DE JOS",
        "zip": "087195",
        "lat": "44.41182",
        "long": "25.545591"
      },
      {
        "name": "ROATA MICA",
        "zip": "087197",
        "lat": "44.400045",
        "long": "25.557368"
      },
      {
        "name": "SABARENI",
        "zip": "087153",
        "lat": "44.507456",
        "long": "25.878747"
      },
      {
        "name": "SADINA",
        "zip": "087198",
        "lat": "44.421306",
        "long": "25.513976"
      },
      {
        "name": "SATU NOU",
        "zip": "087193",
        "lat": "44.060605",
        "long": "25.635136"
      },
      {
        "name": "SCHITU",
        "zip": "087200",
        "lat": "44.141294",
        "long": "25.838532"
      },
      {
        "name": "SFANTU GHEORGHE",
        "zip": "087013",
        "lat": "44.015669",
        "long": "26.032424"
      },
      {
        "name": "SFANTU GHEORGHE",
        "zip": "087066",
        "lat": "44.435236",
        "long": "25.600602"
      },
      {
        "name": "SINGURENI",
        "zip": "087205",
        "lat": "44.233103",
        "long": "25.94308"
      },
      {
        "name": "SLOBOZIA",
        "zip": "087210",
        "lat": "43.856244",
        "long": "25.910123"
      },
      {
        "name": "STALPU",
        "zip": "087134",
        "lat": "44.268277",
        "long": "25.851744"
      },
      {
        "name": "STANESTI",
        "zip": "087215",
        "lat": "43.923277",
        "long": "25.836702"
      },
      {
        "name": "STEJARU",
        "zip": "087207",
        "lat": "44.249736",
        "long": "25.93042"
      },
      {
        "name": "STEREA",
        "zip": "087048",
        "lat": "44.323358",
        "long": "25.735854"
      },
      {
        "name": "STOENESTI",
        "zip": "087078",
        "lat": "44.485689",
        "long": "25.71196"
      },
      {
        "name": "STOENESTI",
        "zip": "087220",
        "lat": "44.144941",
        "long": "25.88989"
      },
      {
        "name": "SUSENI",
        "zip": "085103",
        "lat": "44.451478",
        "long": "25.695715"
      },
      {
        "name": "TANTAVA",
        "zip": "087116",
        "lat": "44.415132",
        "long": "25.825563"
      },
      {
        "name": "TEISORI",
        "zip": "087033",
        "lat": "44.294243",
        "long": "25.812086"
      },
      {
        "name": "TEIUSU",
        "zip": "087129",
        "lat": "44.167431",
        "long": "26.279727"
      },
      {
        "name": "TOMULESTI",
        "zip": "087226",
        "lat": "43.976759",
        "long": "25.638285"
      },
      {
        "name": "TOPORU",
        "zip": "087225",
        "lat": "44.018632",
        "long": "25.659884"
      },
      {
        "name": "TRESTIENI",
        "zip": "087238",
        "lat": "44.505019",
        "long": "25.757592"
      },
      {
        "name": "UIESTI",
        "zip": "087026",
        "lat": "44.357988",
        "long": "25.613785"
      },
      {
        "name": "ULMI",
        "zip": "087230",
        "lat": "44.486332",
        "long": "25.78176"
      },
      {
        "name": "UZUNU",
        "zip": "087044",
        "lat": "44.145278",
        "long": "25.966389"
      },
      {
        "name": "VADU LAT",
        "zip": "087027",
        "lat": "44.344932",
        "long": "25.676384"
      },
      {
        "name": "VALCELELE",
        "zip": "087256",
        "lat": "44.46819",
        "long": "25.570904"
      },
      {
        "name": "VALEA BUJORULUI",
        "zip": "087146",
        "lat": "44.076975",
        "long": "25.833685"
      },
      {
        "name": "VALEA DRAGULUI",
        "zip": "087240",
        "lat": "44.211051",
        "long": "26.302972"
      },
      {
        "name": "VALEA PLOPILOR",
        "zip": "087098",
        "lat": "44.239628",
        "long": "25.818422"
      },
      {
        "name": "VALTER MARACINEANU",
        "zip": "087136",
        "lat": "44.237035",
        "long": "25.86575"
      },
      {
        "name": "VANATORII MARI",
        "zip": "087257",
        "lat": "44.489168",
        "long": "25.541721"
      },
      {
        "name": "VANATORII MICI",
        "zip": "087250",
        "lat": "44.490274",
        "long": "25.558742"
      },
      {
        "name": "VARASTI",
        "zip": "087245",
        "lat": "44.237349",
        "long": "26.246808"
      },
      {
        "name": "VARLAAM",
        "zip": "087008",
        "lat": "44.245374",
        "long": "26.085359"
      },
      {
        "name": "VEDEA",
        "zip": "087260",
        "lat": "43.782175",
        "long": "25.788601"
      },
      {
        "name": "VIERU",
        "zip": "087187",
        "lat": "43.889215",
        "long": "25.810542"
      },
      {
        "name": "VLAD TEPES",
        "zip": "087059",
        "lat": "44.132476",
        "long": "26.132139"
      },
      {
        "name": "VLASIN",
        "zip": "087203",
        "lat": "44.099508",
        "long": "25.859266"
      },
      {
        "name": "ZADARICIU",
        "zip": "087258",
        "lat": "44.473278",
        "long": "25.581206"
      },
      {
        "name": "ZBOIU",
        "zip": "087122",
        "lat": "44.126301",
        "long": "26.310001"
      },
      {
        "name": "ZORILE",
        "zip": "087117",
        "lat": "44.379401",
        "long": "25.802633"
      }
    ],
    "GORJ": [
      {
        "name": "ALBENI",
        "zip": "217005",
        "lat": "45.029247",
        "long": "23.60426"
      },
      {
        "name": "ALEXENI",
        "zip": "217456",
        "lat": "45.135982",
        "long": "23.248909"
      },
      {
        "name": "ALIMPESTI",
        "zip": "217015",
        "lat": "45.102701",
        "long": "23.801055"
      },
      {
        "name": "ALUNIS",
        "zip": "217126",
        "lat": "44.738875",
        "long": "23.642663"
      },
      {
        "name": "ANDREESTI",
        "zip": "217551",
        "lat": "44.783658",
        "long": "23.541455"
      },
      {
        "name": "ANINISU DIN DEAL",
        "zip": "217166",
        "lat": "45.177848",
        "long": "23.61659"
      },
      {
        "name": "ANINISU DIN VALE",
        "zip": "217167",
        "lat": "45.173391",
        "long": "23.606966"
      },
      {
        "name": "ANINOASA",
        "zip": "217020",
        "lat": "44.745298",
        "long": "23.484054"
      },
      {
        "name": "APA NEAGRA",
        "zip": "217326",
        "lat": "44.995299",
        "long": "22.859357"
      },
      {
        "name": "ARCANI",
        "zip": "217025",
        "lat": "45.075623",
        "long": "23.134444"
      },
      {
        "name": "ARJOCI",
        "zip": "217251",
        "lat": "44.979712",
        "long": "22.955203"
      },
      {
        "name": "ARPADIA",
        "zip": "217536",
        "lat": "44.638824",
        "long": "23.576045"
      },
      {
        "name": "ARSENI",
        "zip": "217301",
        "lat": "45.177166",
        "long": "23.433842"
      },
      {
        "name": "ARSURI",
        "zip": "217421",
        "lat": "45.154024",
        "long": "23.315721"
      },
      {
        "name": "ARTANU",
        "zip": "217311",
        "lat": "44.791792",
        "long": "23.224394"
      },
      {
        "name": "BACESTI",
        "zip": "217472",
        "lat": "44.741359",
        "long": "23.68004"
      },
      {
        "name": "BADESTI",
        "zip": "217101",
        "lat": "44.688521",
        "long": "23.467798"
      },
      {
        "name": "BAIA DE FIER",
        "zip": "217030",
        "lat": "45.17086",
        "long": "23.766877"
      },
      {
        "name": "BALACESTI",
        "zip": "217081",
        "lat": "44.753498",
        "long": "23.19837"
      },
      {
        "name": "BALANESTI",
        "zip": "217036",
        "lat": "45.058513",
        "long": "23.390288"
      },
      {
        "name": "BALANI",
        "zip": "217457",
        "lat": "45.088225",
        "long": "23.258041"
      },
      {
        "name": "BALCESTI",
        "zip": "217066",
        "lat": "45.105164",
        "long": "23.632899"
      },
      {
        "name": "BALESTI",
        "zip": "217045",
        "lat": "45.01909",
        "long": "23.209731"
      },
      {
        "name": "BALOSANI",
        "zip": "217471",
        "lat": "44.727378",
        "long": "23.652046"
      },
      {
        "name": "BALTA",
        "zip": "217391",
        "lat": "45.118053",
        "long": "23.101956"
      },
      {
        "name": "BALTENI",
        "zip": "217060",
        "lat": "44.869192",
        "long": "23.273114"
      },
      {
        "name": "BALTISOARA",
        "zip": "217392",
        "lat": "45.119957",
        "long": "23.119474"
      },
      {
        "name": "BANIU",
        "zip": "217091",
        "lat": "44.738791",
        "long": "23.28533"
      },
      {
        "name": "BARBATESTI",
        "zip": "217055",
        "lat": "44.86928",
        "long": "23.508217"
      },
      {
        "name": "BARCACIU",
        "zip": "217302",
        "lat": "45.141109",
        "long": "23.44032"
      },
      {
        "name": "BARSESTI",
        "zip": "210001",
        "lat": "45.053491",
        "long": "23.235432"
      },
      {
        "name": "BARZA",
        "zip": "217201",
        "lat": "44.979629",
        "long": "23.343705"
      },
      {
        "name": "BARZEIU",
        "zip": "217071",
        "lat": "44.949642",
        "long": "23.651317"
      },
      {
        "name": "BARZEIU DE GILORT",
        "zip": "217006",
        "lat": "44.999953",
        "long": "23.598072"
      },
      {
        "name": "BAZAVANI",
        "zip": "217401",
        "lat": "44.798315",
        "long": "23.031251"
      },
      {
        "name": "BECHENI",
        "zip": "217381",
        "lat": "45.078931",
        "long": "23.767165"
      },
      {
        "name": "BENGESTI",
        "zip": "217067",
        "lat": "45.071639",
        "long": "23.588969"
      },
      {
        "name": "BERCESTI",
        "zip": "215301",
        "lat": "45.176139",
        "long": "23.705034"
      },
      {
        "name": "BERLESTI",
        "zip": "217070",
        "lat": "44.913444",
        "long": "23.668221"
      },
      {
        "name": "BIBESTI",
        "zip": "217416",
        "lat": "44.780009",
        "long": "23.491712"
      },
      {
        "name": "BIBULESTI",
        "zip": "217191",
        "lat": "44.807103",
        "long": "23.767185"
      },
      {
        "name": "BIRCII",
        "zip": "217068",
        "lat": "45.099666",
        "long": "23.593293"
      },
      {
        "name": "BLAHNITA DE JOS",
        "zip": "215501",
        "lat": "45.005849",
        "long": "23.521528"
      },
      {
        "name": "BLAHNITA DE SUS",
        "zip": "217411",
        "lat": "45.135864",
        "long": "23.550992"
      },
      {
        "name": "BLIDARI",
        "zip": "217037",
        "lat": "45.113388",
        "long": "23.499306"
      },
      {
        "name": "BOBAIA",
        "zip": "217021",
        "lat": "44.753834",
        "long": "23.520164"
      },
      {
        "name": "BOBOIESTI",
        "zip": "217156",
        "lat": "44.939594",
        "long": "22.959971"
      },
      {
        "name": "BOBU",
        "zip": "217426",
        "lat": "45.035443",
        "long": "23.509747"
      },
      {
        "name": "BOCA",
        "zip": "217402",
        "lat": "44.765657",
        "long": "23.027028"
      },
      {
        "name": "BOHOREL",
        "zip": "217312",
        "lat": "44.833761",
        "long": "23.170559"
      },
      {
        "name": "BOIA",
        "zip": "217271",
        "lat": "44.923657",
        "long": "23.501467"
      },
      {
        "name": "BOJINU",
        "zip": "217176",
        "lat": "44.634803",
        "long": "23.681057"
      },
      {
        "name": "BOLBOASA",
        "zip": "217082",
        "lat": "44.744297",
        "long": "23.210165"
      },
      {
        "name": "BOLBOCESTI",
        "zip": "217007",
        "lat": "45.006295",
        "long": "23.595459"
      },
      {
        "name": "BOLBOSI",
        "zip": "217080",
        "lat": "44.746148",
        "long": "23.226908"
      },
      {
        "name": "BORASCU",
        "zip": "217090",
        "lat": "44.694668",
        "long": "23.284021"
      },
      {
        "name": "BOROSTENI",
        "zip": "217336",
        "lat": "45.097106",
        "long": "23.028056"
      },
      {
        "name": "BOTOROGI",
        "zip": "217202",
        "lat": "44.988646",
        "long": "23.289422"
      },
      {
        "name": "BRADET",
        "zip": "217296",
        "lat": "44.866986",
        "long": "23.072061"
      },
      {
        "name": "BRADETEL",
        "zip": "217297",
        "lat": "44.883072",
        "long": "23.058773"
      },
      {
        "name": "BRADICENI",
        "zip": "217337",
        "lat": "45.058109",
        "long": "23.079102"
      },
      {
        "name": "BRANESTI",
        "zip": "217100",
        "lat": "44.651546",
        "long": "23.45506"
      },
      {
        "name": "BRATESTI",
        "zip": "217127",
        "lat": "44.718871",
        "long": "23.610416"
      },
      {
        "name": "BRATUIA",
        "zip": "217203",
        "lat": "44.935124",
        "long": "23.364111"
      },
      {
        "name": "BREBENEI",
        "zip": "217102",
        "lat": "44.663604",
        "long": "23.44649"
      },
      {
        "name": "BROSTENI",
        "zip": "217346",
        "lat": "44.688116",
        "long": "23.414919"
      },
      {
        "name": "BROSTENII DE SUS",
        "zip": "217347",
        "lat": "44.671685",
        "long": "23.438816"
      },
      {
        "name": "BUCSANA",
        "zip": "217371",
        "lat": "45.064007",
        "long": "23.714545"
      },
      {
        "name": "BUCUREASA",
        "zip": "217204",
        "lat": "44.998653",
        "long": "23.316283"
      },
      {
        "name": "BUDIENI",
        "zip": "217427",
        "lat": "45.016857",
        "long": "23.403497"
      },
      {
        "name": "BUDUHALA",
        "zip": "217491",
        "lat": "44.984352",
        "long": "23.128922"
      },
      {
        "name": "BULBUCENI",
        "zip": "217128",
        "lat": "44.704092",
        "long": "23.577178"
      },
      {
        "name": "BUMBESTI-JIU",
        "zip": "215100",
        "lat": "45.179386",
        "long": "23.379511"
      },
      {
        "name": "BUMBESTI-PITIC",
        "zip": "217110",
        "lat": "45.128519",
        "long": "23.686894"
      },
      {
        "name": "BURLANI",
        "zip": "217372",
        "lat": "45.043739",
        "long": "23.692992"
      },
      {
        "name": "BUSTUCHIN",
        "zip": "217115",
        "lat": "44.970517",
        "long": "23.724491"
      },
      {
        "name": "BUSUIOCI",
        "zip": "217261",
        "lat": "44.812327",
        "long": "23.667652"
      },
      {
        "name": "BUZESTI",
        "zip": "217168",
        "lat": "45.123354",
        "long": "23.511013"
      },
      {
        "name": "CALAPARU",
        "zip": "217092",
        "lat": "44.684065",
        "long": "23.324631"
      },
      {
        "name": "CALCESTI",
        "zip": "217252",
        "lat": "44.968596",
        "long": "22.96696"
      },
      {
        "name": "CALESTI",
        "zip": "217458",
        "lat": "45.097344",
        "long": "23.264187"
      },
      {
        "name": "CALNIC",
        "zip": "217145",
        "lat": "44.957251",
        "long": "23.072821"
      },
      {
        "name": "CALNICU DE SUS",
        "zip": "217146",
        "lat": "44.955316",
        "long": "23.040212"
      },
      {
        "name": "CALUGAREASA",
        "zip": "217373",
        "lat": "45.041635",
        "long": "23.641559"
      },
      {
        "name": "CALUGARENI",
        "zip": "217327",
        "lat": "45.05085",
        "long": "22.820848"
      },
      {
        "name": "CAMPOFENI",
        "zip": "217026",
        "lat": "45.055628",
        "long": "23.140776"
      },
      {
        "name": "CAMPU MARE",
        "zip": "217428",
        "lat": "45.037446",
        "long": "23.551163"
      },
      {
        "name": "CAMUIESTI",
        "zip": "217246",
        "lat": "44.949384",
        "long": "22.897814"
      },
      {
        "name": "CANEPESTI",
        "zip": "217038",
        "lat": "45.092385",
        "long": "23.425746"
      },
      {
        "name": "CAPRENI",
        "zip": "217125",
        "lat": "44.753678",
        "long": "23.62797"
      },
      {
        "name": "CAPU DEALULUI",
        "zip": "217103",
        "lat": "44.629401",
        "long": "23.47813"
      },
      {
        "name": "CARBESTI",
        "zip": "217226",
        "lat": "44.95664",
        "long": "23.213751"
      },
      {
        "name": "CARBUNESTI-SAT",
        "zip": "215502",
        "lat": "44.946186",
        "long": "23.538933"
      },
      {
        "name": "CARCIU",
        "zip": "217546",
        "lat": "44.740278",
        "long": "23.059424"
      },
      {
        "name": "CARLIGEI",
        "zip": "217111",
        "lat": "45.105107",
        "long": "23.686647"
      },
      {
        "name": "CARPINIS",
        "zip": "217169",
        "lat": "45.186173",
        "long": "23.578685"
      },
      {
        "name": "CARTIU",
        "zip": "217531",
        "lat": "45.122318",
        "long": "23.31613"
      },
      {
        "name": "CATUNELE",
        "zip": "217135",
        "lat": "44.864421",
        "long": "22.907065"
      },
      {
        "name": "CEAURU",
        "zip": "217046",
        "lat": "45.01196",
        "long": "23.201029"
      },
      {
        "name": "CELEI",
        "zip": "217496",
        "lat": "45.01176",
        "long": "22.926222"
      },
      {
        "name": "CEPLEA",
        "zip": "217348",
        "lat": "44.697808",
        "long": "23.407983"
      },
      {
        "name": "CERATU DE COPACIOASA",
        "zip": "217429",
        "lat": "45.015168",
        "long": "23.434099"
      },
      {
        "name": "CERNA-SAT",
        "zip": "217328",
        "lat": "45.128528",
        "long": "22.68576"
      },
      {
        "name": "CERNADIA",
        "zip": "217031",
        "lat": "45.177709",
        "long": "23.72125"
      },
      {
        "name": "CETATEA",
        "zip": "217129",
        "lat": "44.776545",
        "long": "23.618132"
      },
      {
        "name": "CHICIORA",
        "zip": "217537",
        "lat": "44.621714",
        "long": "23.574591"
      },
      {
        "name": "CHILIU",
        "zip": "217253",
        "lat": "44.978726",
        "long": "22.93228"
      },
      {
        "name": "CIOCADIA",
        "zip": "217069",
        "lat": "45.116033",
        "long": "23.608114"
      },
      {
        "name": "CIONTI",
        "zip": "217116",
        "lat": "44.965952",
        "long": "23.684338"
      },
      {
        "name": "CIORARI",
        "zip": "217481",
        "lat": "44.702882",
        "long": "23.626263"
      },
      {
        "name": "CIUPERCENI",
        "zip": "217155",
        "lat": "44.938953",
        "long": "23.012436"
      },
      {
        "name": "CIUPERCENII DE OLTET",
        "zip": "217016",
        "lat": "45.138281",
        "long": "23.791821"
      },
      {
        "name": "CLESNESTI",
        "zip": "217247",
        "lat": "44.899748",
        "long": "22.901609"
      },
      {
        "name": "CLOSANI",
        "zip": "217329",
        "lat": "45.068967",
        "long": "22.802497"
      },
      {
        "name": "COCORENI",
        "zip": "217061",
        "lat": "44.827722",
        "long": "23.314055"
      },
      {
        "name": "COCOROVA",
        "zip": "217516",
        "lat": "44.656903",
        "long": "23.557338"
      },
      {
        "name": "COJANI",
        "zip": "215503",
        "lat": "44.998548",
        "long": "23.545784"
      },
      {
        "name": "COJMANESTI",
        "zip": "217446",
        "lat": "44.80361",
        "long": "23.116929"
      },
      {
        "name": "COLIBASI",
        "zip": "217431",
        "lat": "45.020631",
        "long": "23.524509"
      },
      {
        "name": "COLTESTI",
        "zip": "217286",
        "lat": "44.832454",
        "long": "23.680047"
      },
      {
        "name": "CONDEIESTI",
        "zip": "217313",
        "lat": "44.753632",
        "long": "23.262012"
      },
      {
        "name": "COPACIOASA",
        "zip": "217432",
        "lat": "45.033312",
        "long": "23.432508"
      },
      {
        "name": "CORNESTI",
        "zip": "217047",
        "lat": "44.995594",
        "long": "23.145276"
      },
      {
        "name": "CORNETU",
        "zip": "217131",
        "lat": "44.738257",
        "long": "23.619923"
      },
      {
        "name": "COROBAI",
        "zip": "217221",
        "lat": "44.797249",
        "long": "23.161383"
      },
      {
        "name": "CORSORU",
        "zip": "217017",
        "lat": "45.079148",
        "long": "23.79337"
      },
      {
        "name": "COSTENI",
        "zip": "217497",
        "lat": "45.017561",
        "long": "22.895425"
      },
      {
        "name": "COSTESTI",
        "zip": "217022",
        "lat": "44.732644",
        "long": "23.444912"
      },
      {
        "name": "COVRIGI",
        "zip": "217547",
        "lat": "44.738247",
        "long": "23.149207"
      },
      {
        "name": "CRASNA",
        "zip": "217165",
        "lat": "45.178504",
        "long": "23.522831"
      },
      {
        "name": "CRASNA DIN DEAL",
        "zip": "217171",
        "lat": "45.182959",
        "long": "23.540466"
      },
      {
        "name": "CRETESTI",
        "zip": "215504",
        "lat": "44.952041",
        "long": "23.434996"
      },
      {
        "name": "CROICI",
        "zip": "217298",
        "lat": "44.831503",
        "long": "23.09748"
      },
      {
        "name": "CRUSET",
        "zip": "217175",
        "lat": "44.630832",
        "long": "23.660578"
      },
      {
        "name": "CURPEN",
        "zip": "217459",
        "lat": "45.157164",
        "long": "23.258748"
      },
      {
        "name": "CURSARU",
        "zip": "217349",
        "lat": "44.676022",
        "long": "23.431951"
      },
      {
        "name": "CURTEANA",
        "zip": "215505",
        "lat": "44.956002",
        "long": "23.445626"
      },
      {
        "name": "CURTISOARA",
        "zip": "215101",
        "lat": "45.104193",
        "long": "23.360919"
      },
      {
        "name": "DAMBOVA",
        "zip": "217227",
        "lat": "44.944879",
        "long": "23.198626"
      },
      {
        "name": "DANCIULESTI",
        "zip": "217190",
        "lat": "44.733391",
        "long": "23.758213"
      },
      {
        "name": "DANESTI",
        "zip": "217200",
        "lat": "44.976985",
        "long": "23.320264"
      },
      {
        "name": "DEALU LEULUI",
        "zip": "217473",
        "lat": "44.733103",
        "long": "23.717637"
      },
      {
        "name": "DEALU POMILOR",
        "zip": "215201",
        "lat": "44.81053",
        "long": "22.991209"
      },
      {
        "name": "DEALU SPIREI",
        "zip": "217132",
        "lat": "44.770554",
        "long": "23.62384"
      },
      {
        "name": "DEALU VIEI",
        "zip": "217382",
        "lat": "45.07034",
        "long": "23.739002"
      },
      {
        "name": "DEALU VIILOR",
        "zip": "217136",
        "lat": "44.850077",
        "long": "22.901512"
      },
      {
        "name": "DELENI",
        "zip": "217351",
        "lat": "44.791013",
        "long": "23.372697"
      },
      {
        "name": "DIDILESTI",
        "zip": "217147",
        "lat": "44.961493",
        "long": "23.026865"
      },
      {
        "name": "DOBRANA",
        "zip": "217374",
        "lat": "45.054282",
        "long": "23.667453"
      },
      {
        "name": "DOBRITA",
        "zip": "217393",
        "lat": "45.135035",
        "long": "23.174063"
      },
      {
        "name": "DOLCESTI",
        "zip": "217417",
        "lat": "44.815611",
        "long": "23.504949"
      },
      {
        "name": "DOSENI",
        "zip": "217008",
        "lat": "44.992535",
        "long": "23.576295"
      },
      {
        "name": "DRAGOIENI",
        "zip": "210002",
        "lat": "45.042276",
        "long": "23.336118"
      },
      {
        "name": "DRAGOIESTI",
        "zip": "217172",
        "lat": "45.178746",
        "long": "23.504978"
      },
      {
        "name": "DRAGOTESTI",
        "zip": "217220",
        "lat": "44.822678",
        "long": "23.139598"
      },
      {
        "name": "DRAGUTESTI",
        "zip": "217225",
        "lat": "44.975536",
        "long": "23.232828"
      },
      {
        "name": "DUCULESTI",
        "zip": "217403",
        "lat": "44.790889",
        "long": "23.044424"
      },
      {
        "name": "DUMBRAVENI",
        "zip": "217173",
        "lat": "45.149555",
        "long": "23.513604"
      },
      {
        "name": "FANTANELE",
        "zip": "217541",
        "lat": "44.778073",
        "long": "23.310966"
      },
      {
        "name": "FARCASESTI",
        "zip": "217235",
        "lat": "44.860909",
        "long": "23.218996"
      },
      {
        "name": "FARCASESTI-MOSNENI",
        "zip": "217236",
        "lat": "44.871588",
        "long": "23.199809"
      },
      {
        "name": "FLORESTENI",
        "zip": "215506",
        "lat": "44.946266",
        "long": "23.422911"
      },
      {
        "name": "FLORESTI",
        "zip": "217538",
        "lat": "44.619177",
        "long": "23.52838"
      },
      {
        "name": "FRANCESTI",
        "zip": "217338",
        "lat": "45.087506",
        "long": "23.058477"
      },
      {
        "name": "FRASIN",
        "zip": "217552",
        "lat": "44.817031",
        "long": "23.532884"
      },
      {
        "name": "FRATESTI",
        "zip": "217276",
        "lat": "45.123362",
        "long": "23.21595"
      },
      {
        "name": "FRUMUSEI",
        "zip": "217281",
        "lat": "44.884274",
        "long": "23.630132"
      },
      {
        "name": "FRUNZA",
        "zip": "217287",
        "lat": "44.850236",
        "long": "23.695339"
      },
      {
        "name": "GALCESTI",
        "zip": "217072",
        "lat": "44.859012",
        "long": "23.661503"
      },
      {
        "name": "GALESOAIA",
        "zip": "217148",
        "lat": "44.922606",
        "long": "23.078803"
      },
      {
        "name": "GAMANI",
        "zip": "217303",
        "lat": "45.13627",
        "long": "23.426176"
      },
      {
        "name": "GARBOVU",
        "zip": "217521",
        "lat": "44.731357",
        "long": "23.346425"
      },
      {
        "name": "GAVANESTI",
        "zip": "217048",
        "lat": "45.025843",
        "long": "23.138267"
      },
      {
        "name": "GILORTU",
        "zip": "217104",
        "lat": "44.671891",
        "long": "23.486746"
      },
      {
        "name": "GLODENI",
        "zip": "217039",
        "lat": "45.081678",
        "long": "23.462682"
      },
      {
        "name": "GLOGOVA",
        "zip": "217245",
        "lat": "44.93549",
        "long": "22.9022"
      },
      {
        "name": "GODINESTI",
        "zip": "217250",
        "lat": "45.007224",
        "long": "22.965943"
      },
      {
        "name": "GORNACEL",
        "zip": "217422",
        "lat": "45.172017",
        "long": "23.347223"
      },
      {
        "name": "GORNOVITA",
        "zip": "217498",
        "lat": "45.069233",
        "long": "22.968532"
      },
      {
        "name": "GROSEREA",
        "zip": "217023",
        "lat": "44.720323",
        "long": "23.481351"
      },
      {
        "name": "GRUI",
        "zip": "217304",
        "lat": "45.124204",
        "long": "23.433027"
      },
      {
        "name": "GURA SUSITEI",
        "zip": "217266",
        "lat": "44.605068",
        "long": "23.429923"
      },
      {
        "name": "GURA-MENTI",
        "zip": "217093",
        "lat": "44.690641",
        "long": "23.244743"
      },
      {
        "name": "GURENI",
        "zip": "217339",
        "lat": "45.111874",
        "long": "23.039772"
      },
      {
        "name": "HAIESTI",
        "zip": "217412",
        "lat": "45.073362",
        "long": "23.539305"
      },
      {
        "name": "HALANGESTI",
        "zip": "217192",
        "lat": "44.766454",
        "long": "23.761957"
      },
      {
        "name": "HIRISESTI",
        "zip": "215302",
        "lat": "45.176124",
        "long": "23.643542"
      },
      {
        "name": "HOBITA",
        "zip": "217341",
        "lat": "45.051271",
        "long": "23.057149"
      },
      {
        "name": "HODOREASCA",
        "zip": "217149",
        "lat": "44.939158",
        "long": "23.0579"
      },
      {
        "name": "HORASTI",
        "zip": "215202",
        "lat": "44.785923",
        "long": "23.013906"
      },
      {
        "name": "HOREZU",
        "zip": "217532",
        "lat": "45.152492",
        "long": "23.293939"
      },
      {
        "name": "HOTAROASA",
        "zip": "217542",
        "lat": "44.823026",
        "long": "23.282512"
      },
      {
        "name": "HUREZANI",
        "zip": "217260",
        "lat": "44.803678",
        "long": "23.647581"
      },
      {
        "name": "IASI-GORJ",
        "zip": "217228",
        "lat": "44.993344",
        "long": "23.248208"
      },
      {
        "name": "IEZURENI",
        "zip": "210003",
        "lat": "45.095881",
        "long": "23.329575"
      },
      {
        "name": "IGIROSU",
        "zip": "217083",
        "lat": "44.734944",
        "long": "23.240435"
      },
      {
        "name": "ILIESTI",
        "zip": "217267",
        "lat": "44.643743",
        "long": "23.402362"
      },
      {
        "name": "INSURATEI",
        "zip": "215203",
        "lat": "44.792066",
        "long": "22.992602"
      },
      {
        "name": "IONESTI",
        "zip": "217265",
        "lat": "44.623877",
        "long": "23.430138"
      },
      {
        "name": "IORMANESTI",
        "zip": "217248",
        "lat": "44.906425",
        "long": "22.915558"
      },
      {
        "name": "ISVARNA",
        "zip": "217499",
        "lat": "45.032724",
        "long": "22.908334"
      },
      {
        "name": "IZVOARELE",
        "zip": "217352",
        "lat": "44.71723",
        "long": "23.398875"
      },
      {
        "name": "JERISTEA",
        "zip": "217413",
        "lat": "45.123483",
        "long": "23.528249"
      },
      {
        "name": "JILTU",
        "zip": "217522",
        "lat": "44.689609",
        "long": "23.379949"
      },
      {
        "name": "JUPANESTI",
        "zip": "217270",
        "lat": "44.906513",
        "long": "23.530738"
      },
      {
        "name": "LARGA",
        "zip": "217404",
        "lat": "44.772612",
        "long": "23.065571"
      },
      {
        "name": "LAZARESTI",
        "zip": "215102",
        "lat": "45.133351",
        "long": "23.412968"
      },
      {
        "name": "LAZURI",
        "zip": "217433",
        "lat": "45.024687",
        "long": "23.480098"
      },
      {
        "name": "LELESTI",
        "zip": "217275",
        "lat": "45.093618",
        "long": "23.20363"
      },
      {
        "name": "LEURDA",
        "zip": "215204",
        "lat": "44.799288",
        "long": "23.000946"
      },
      {
        "name": "LICURICI",
        "zip": "217280",
        "lat": "44.914634",
        "long": "23.621853"
      },
      {
        "name": "LIHULESTI",
        "zip": "217073",
        "lat": "44.965817",
        "long": "23.667097"
      },
      {
        "name": "LINTEA",
        "zip": "217434",
        "lat": "45.030388",
        "long": "23.443251"
      },
      {
        "name": "LOGRESTI-MOSTENI",
        "zip": "217288",
        "lat": "44.906633",
        "long": "23.704804"
      },
      {
        "name": "LUPOAIA",
        "zip": "217137",
        "lat": "44.814491",
        "long": "22.961257"
      },
      {
        "name": "LUPOITA",
        "zip": "215205",
        "lat": "44.856801",
        "long": "22.954596"
      },
      {
        "name": "MACESU",
        "zip": "215507",
        "lat": "44.941748",
        "long": "23.464147"
      },
      {
        "name": "MAGHERESTI",
        "zip": "217414",
        "lat": "45.090007",
        "long": "23.524005"
      },
      {
        "name": "MAIAG",
        "zip": "217178",
        "lat": "44.611954",
        "long": "23.622108"
      },
      {
        "name": "MARINESTI",
        "zip": "217177",
        "lat": "44.686521",
        "long": "23.700329"
      },
      {
        "name": "MARU",
        "zip": "217289",
        "lat": "44.904907",
        "long": "23.745382"
      },
      {
        "name": "MATASARI",
        "zip": "217295",
        "lat": "44.847764",
        "long": "23.088727"
      },
      {
        "name": "MAZAROI",
        "zip": "217461",
        "lat": "45.100156",
        "long": "23.266495"
      },
      {
        "name": "MENTII DIN DOS",
        "zip": "217094",
        "lat": "44.692365",
        "long": "23.223443"
      },
      {
        "name": "MERFULESTI",
        "zip": "217206",
        "lat": "44.94971",
        "long": "23.367345"
      },
      {
        "name": "MICLOSU",
        "zip": "217084",
        "lat": "44.739906",
        "long": "23.222767"
      },
      {
        "name": "MICULESTI",
        "zip": "217447",
        "lat": "44.822828",
        "long": "23.045304"
      },
      {
        "name": "MIELUSEI",
        "zip": "217482",
        "lat": "44.67411",
        "long": "23.664703"
      },
      {
        "name": "MIEREA",
        "zip": "217179",
        "lat": "44.614138",
        "long": "23.699981"
      },
      {
        "name": "MIERICEAUA",
        "zip": "217181",
        "lat": "44.618388",
        "long": "23.653893"
      },
      {
        "name": "MILUTA",
        "zip": "217096",
        "lat": "44.703211",
        "long": "23.172979"
      },
      {
        "name": "MIROSLOVENI",
        "zip": "217009",
        "lat": "45.044516",
        "long": "23.599368"
      },
      {
        "name": "MOGOSANI",
        "zip": "217436",
        "lat": "45.052091",
        "long": "23.532809"
      },
      {
        "name": "MOI",
        "zip": "217062",
        "lat": "44.900929",
        "long": "23.208339"
      },
      {
        "name": "MOTORGI",
        "zip": "217117",
        "lat": "44.977729",
        "long": "23.683914"
      },
      {
        "name": "MOTRU",
        "zip": "215200",
        "lat": "44.801102",
        "long": "22.967876"
      },
      {
        "name": "MOTRU SEC",
        "zip": "217331",
        "lat": "45.062582",
        "long": "22.792621"
      },
      {
        "name": "MURGESTI",
        "zip": "217523",
        "lat": "44.710648",
        "long": "23.364015"
      },
      {
        "name": "MURGILESTI",
        "zip": "217548",
        "lat": "44.754223",
        "long": "23.096634"
      },
      {
        "name": "MUSCULESTI",
        "zip": "217056",
        "lat": "44.828762",
        "long": "23.507692"
      },
      {
        "name": "MUSETESTI",
        "zip": "217300",
        "lat": "45.140343",
        "long": "23.462594"
      },
      {
        "name": "NAMETE",
        "zip": "217118",
        "lat": "44.984295",
        "long": "23.701274"
      },
      {
        "name": "NEGOIESTI",
        "zip": "217376",
        "lat": "45.035336",
        "long": "23.664546"
      },
      {
        "name": "NEGOMIR",
        "zip": "217310",
        "lat": "44.823185",
        "long": "23.191973"
      },
      {
        "name": "NEGRENI",
        "zip": "217282",
        "lat": "44.844235",
        "long": "23.641316"
      },
      {
        "name": "NISTORESTI",
        "zip": "217018",
        "lat": "45.084356",
        "long": "23.802711"
      },
      {
        "name": "NOVACI",
        "zip": "215300",
        "lat": "45.176646",
        "long": "23.671061"
      },
      {
        "name": "NUCETU",
        "zip": "217314",
        "lat": "44.750022",
        "long": "23.274377"
      },
      {
        "name": "OBARSIA",
        "zip": "217193",
        "lat": "44.824562",
        "long": "23.767922"
      },
      {
        "name": "OBREJA",
        "zip": "217462",
        "lat": "45.109206",
        "long": "23.264771"
      },
      {
        "name": "OHABA",
        "zip": "217041",
        "lat": "45.096978",
        "long": "23.478499"
      },
      {
        "name": "OHABA-JIU",
        "zip": "217086",
        "lat": "44.72067",
        "long": "23.246882"
      },
      {
        "name": "OLARI",
        "zip": "217353",
        "lat": "44.807614",
        "long": "23.332221"
      },
      {
        "name": "OLTEANU",
        "zip": "217249",
        "lat": "44.885509",
        "long": "22.920107"
      },
      {
        "name": "ORZESTI",
        "zip": "217332",
        "lat": "45.048094",
        "long": "22.81557"
      },
      {
        "name": "ORZU",
        "zip": "217316",
        "lat": "44.774909",
        "long": "23.238903"
      },
      {
        "name": "PADES",
        "zip": "217325",
        "lat": "45.020671",
        "long": "22.857391"
      },
      {
        "name": "PAISANI",
        "zip": "217483",
        "lat": "44.666901",
        "long": "23.642118"
      },
      {
        "name": "PAJISTELE",
        "zip": "217423",
        "lat": "45.153429",
        "long": "23.325394"
      },
      {
        "name": "PALTINU",
        "zip": "217317",
        "lat": "44.768079",
        "long": "23.238306"
      },
      {
        "name": "PARAU",
        "zip": "217106",
        "lat": "44.68427",
        "long": "23.49568"
      },
      {
        "name": "PARAU BOIA",
        "zip": "217272",
        "lat": "44.926174",
        "long": "23.53867"
      },
      {
        "name": "PARAU DE PRIPOR",
        "zip": "217254",
        "lat": "44.963768",
        "long": "22.985841"
      },
      {
        "name": "PARAU DE VALE",
        "zip": "217256",
        "lat": "44.978575",
        "long": "22.997574"
      },
      {
        "name": "PARAU VIU",
        "zip": "217074",
        "lat": "44.935146",
        "long": "23.668386"
      },
      {
        "name": "PARVULESTI",
        "zip": "217463",
        "lat": "45.156457",
        "long": "23.220634"
      },
      {
        "name": "PEGENI",
        "zip": "217262",
        "lat": "44.78528",
        "long": "23.639593"
      },
      {
        "name": "PESTEANA DE JOS",
        "zip": "217237",
        "lat": "44.833335",
        "long": "23.269743"
      },
      {
        "name": "PESTEANA-JIU",
        "zip": "217063",
        "lat": "44.846951",
        "long": "23.304011"
      },
      {
        "name": "PESTEANA-VULCAN",
        "zip": "217157",
        "lat": "44.926961",
        "long": "22.974715"
      },
      {
        "name": "PESTISANI",
        "zip": "217335",
        "lat": "45.078016",
        "long": "23.047515"
      },
      {
        "name": "PETRACHEI",
        "zip": "217194",
        "lat": "44.723478",
        "long": "23.754928"
      },
      {
        "name": "PETRESTI",
        "zip": "217057",
        "lat": "44.84947",
        "long": "23.508885"
      },
      {
        "name": "PICU",
        "zip": "217268",
        "lat": "44.594123",
        "long": "23.444133"
      },
      {
        "name": "PIEPTANI",
        "zip": "217151",
        "lat": "44.937847",
        "long": "23.044387"
      },
      {
        "name": "PINOASA",
        "zip": "217152",
        "lat": "44.907628",
        "long": "23.098251"
      },
      {
        "name": "PISCOIU",
        "zip": "217474",
        "lat": "44.852391",
        "long": "23.753552"
      },
      {
        "name": "PISCURI",
        "zip": "217354",
        "lat": "44.776458",
        "long": "23.393417"
      },
      {
        "name": "PISTESTII DIN DEAL",
        "zip": "217437",
        "lat": "45.031972",
        "long": "23.399353"
      },
      {
        "name": "PLESA",
        "zip": "215103",
        "lat": "45.180405",
        "long": "23.363668"
      },
      {
        "name": "PLOPSORU",
        "zip": "217345",
        "lat": "44.789841",
        "long": "23.350245"
      },
      {
        "name": "PLOPU",
        "zip": "217263",
        "lat": "44.790283",
        "long": "23.601897"
      },
      {
        "name": "PLOSTINA",
        "zip": "215206",
        "lat": "44.824178",
        "long": "22.987805"
      },
      {
        "name": "POCIOVALISTEA",
        "zip": "215303",
        "lat": "45.153151",
        "long": "23.643916"
      },
      {
        "name": "POCRUIA",
        "zip": "217501",
        "lat": "45.044826",
        "long": "22.924548"
      },
      {
        "name": "POIANA",
        "zip": "217517",
        "lat": "44.651745",
        "long": "23.53148"
      },
      {
        "name": "POIANA-SECIURI",
        "zip": "217119",
        "lat": "44.99559",
        "long": "23.724973"
      },
      {
        "name": "POIENARI",
        "zip": "217112",
        "lat": "45.13933",
        "long": "23.737295"
      },
      {
        "name": "POIENITA",
        "zip": "217121",
        "lat": "44.990074",
        "long": "23.682129"
      },
      {
        "name": "POJARU",
        "zip": "217122",
        "lat": "44.938603",
        "long": "23.695423"
      },
      {
        "name": "POJOGENI",
        "zip": "215508",
        "lat": "44.991189",
        "long": "23.484251"
      },
      {
        "name": "POLATA",
        "zip": "210004",
        "lat": "45.073146",
        "long": "23.243932"
      },
      {
        "name": "POLOVRAGI",
        "zip": "217365",
        "lat": "45.173719",
        "long": "23.804271"
      },
      {
        "name": "POPESTI",
        "zip": "217291",
        "lat": "44.923276",
        "long": "23.696951"
      },
      {
        "name": "POPESTI-STEJARI",
        "zip": "217476",
        "lat": "44.81641",
        "long": "23.733893"
      },
      {
        "name": "PREAJBA MARE",
        "zip": "210005",
        "lat": "45.063387",
        "long": "23.348589"
      },
      {
        "name": "PRIGORIA",
        "zip": "217370",
        "lat": "45.070751",
        "long": "23.686526"
      },
      {
        "name": "PRIPORU",
        "zip": "217158",
        "lat": "44.928922",
        "long": "22.975755"
      },
      {
        "name": "PRUNESTI",
        "zip": "217011",
        "lat": "45.018355",
        "long": "23.638092"
      },
      {
        "name": "PURCARU",
        "zip": "217418",
        "lat": "44.844595",
        "long": "23.470795"
      },
      {
        "name": "RACHITI",
        "zip": "217394",
        "lat": "45.097508",
        "long": "23.151682"
      },
      {
        "name": "RACI",
        "zip": "217318",
        "lat": "44.766625",
        "long": "23.250042"
      },
      {
        "name": "RACOTI",
        "zip": "217502",
        "lat": "44.989069",
        "long": "22.935209"
      },
      {
        "name": "RACOVITA",
        "zip": "217366",
        "lat": "45.169253",
        "long": "23.837627"
      },
      {
        "name": "RADINESTI",
        "zip": "217196",
        "lat": "44.790055",
        "long": "23.759903"
      },
      {
        "name": "RADOSI",
        "zip": "217174",
        "lat": "45.188609",
        "long": "23.596293"
      },
      {
        "name": "RAPA",
        "zip": "215207",
        "lat": "44.797791",
        "long": "22.94615"
      },
      {
        "name": "RASOVA",
        "zip": "217049",
        "lat": "45.047211",
        "long": "23.183459"
      },
      {
        "name": "RASOVITA",
        "zip": "217277",
        "lat": "45.079261",
        "long": "23.17325"
      },
      {
        "name": "RATEZ",
        "zip": "217257",
        "lat": "44.96024",
        "long": "22.923163"
      },
      {
        "name": "ROGOJEL",
        "zip": "217238",
        "lat": "44.906723",
        "long": "23.130201"
      },
      {
        "name": "ROGOJENI",
        "zip": "215509",
        "lat": "44.9441",
        "long": "23.5163"
      },
      {
        "name": "ROMANESTI",
        "zip": "210006",
        "lat": "45.010837",
        "long": "23.263542"
      },
      {
        "name": "ROSIA DE AMARADIA",
        "zip": "217380",
        "lat": "45.056625",
        "long": "23.752992"
      },
      {
        "name": "ROSIA-JIU",
        "zip": "217239",
        "lat": "44.89041",
        "long": "23.161365"
      },
      {
        "name": "ROSIUTA",
        "zip": "215208",
        "lat": "44.857914",
        "long": "22.980363"
      },
      {
        "name": "ROVINARI",
        "zip": "215400",
        "lat": "44.897875",
        "long": "23.163126"
      },
      {
        "name": "RUGET",
        "zip": "217383",
        "lat": "45.015366",
        "long": "23.767656"
      },
      {
        "name": "RUGI",
        "zip": "217533",
        "lat": "45.135099",
        "long": "23.290603"
      },
      {
        "name": "RUNCU",
        "zip": "217390",
        "lat": "45.119249",
        "long": "23.142308"
      },
      {
        "name": "RUNCUREL",
        "zip": "217299",
        "lat": "44.859064",
        "long": "23.019909"
      },
      {
        "name": "SACELU",
        "zip": "217410",
        "lat": "45.095309",
        "long": "23.540576"
      },
      {
        "name": "SAMARINESTI",
        "zip": "217400",
        "lat": "44.7568",
        "long": "23.044059"
      },
      {
        "name": "SAMBOTIN",
        "zip": "217424",
        "lat": "45.136236",
        "long": "23.341148"
      },
      {
        "name": "SANATESTI",
        "zip": "217027",
        "lat": "45.095022",
        "long": "23.136768"
      },
      {
        "name": "SARBESTI",
        "zip": "217019",
        "lat": "45.120158",
        "long": "23.792092"
      },
      {
        "name": "SARDANESTI",
        "zip": "217356",
        "lat": "44.77086",
        "long": "23.360874"
      },
      {
        "name": "SASA",
        "zip": "217207",
        "lat": "44.981344",
        "long": "23.383935"
      },
      {
        "name": "SATU NOU",
        "zip": "217133",
        "lat": "44.765708",
        "long": "23.633942"
      },
      {
        "name": "SAULESTI",
        "zip": "217415",
        "lat": "44.807988",
        "long": "23.482971"
      },
      {
        "name": "SCHELA",
        "zip": "217420",
        "lat": "45.177375",
        "long": "23.289487"
      },
      {
        "name": "SCOARTA",
        "zip": "217425",
        "lat": "45.017807",
        "long": "23.465021"
      },
      {
        "name": "SCORUSU",
        "zip": "217097",
        "lat": "44.705787",
        "long": "23.331638"
      },
      {
        "name": "SCRADA",
        "zip": "217076",
        "lat": "44.885912",
        "long": "23.656062"
      },
      {
        "name": "SCURTU",
        "zip": "217077",
        "lat": "44.969474",
        "long": "23.630676"
      },
      {
        "name": "SEACA",
        "zip": "217292",
        "lat": "44.929016",
        "long": "23.746855"
      },
      {
        "name": "SECIURILE",
        "zip": "217384",
        "lat": "45.020774",
        "long": "23.732475"
      },
      {
        "name": "SEUCA",
        "zip": "217342",
        "lat": "45.010213",
        "long": "23.033438"
      },
      {
        "name": "SIACU",
        "zip": "217451",
        "lat": "44.755896",
        "long": "23.1773"
      },
      {
        "name": "SIPOTU",
        "zip": "217519",
        "lat": "44.701343",
        "long": "23.523612"
      },
      {
        "name": "SITESTI",
        "zip": "215304",
        "lat": "45.141937",
        "long": "23.678228"
      },
      {
        "name": "SITOAIA",
        "zip": "217387",
        "lat": "45.068909",
        "long": "23.766889"
      },
      {
        "name": "SLAMNESTI",
        "zip": "217182",
        "lat": "44.604417",
        "long": "23.691366"
      },
      {
        "name": "SLAVUTA",
        "zip": "217183",
        "lat": "44.69891",
        "long": "23.683459"
      },
      {
        "name": "SLIVILESTI",
        "zip": "217445",
        "lat": "44.778179",
        "long": "23.136253"
      },
      {
        "name": "SLOBOZIA",
        "zip": "210007",
        "lat": "45.02922",
        "long": "23.231289"
      },
      {
        "name": "SOCU",
        "zip": "217058",
        "lat": "44.889118",
        "long": "23.505597"
      },
      {
        "name": "SOHODOL",
        "zip": "217503",
        "lat": "45.055313",
        "long": "22.881939"
      },
      {
        "name": "SOMANESTI",
        "zip": "217492",
        "lat": "44.960419",
        "long": "23.110401"
      },
      {
        "name": "SPAHII",
        "zip": "217518",
        "lat": "44.683247",
        "long": "23.529464"
      },
      {
        "name": "STANCESTI",
        "zip": "217306",
        "lat": "45.176167",
        "long": "23.466777"
      },
      {
        "name": "STANCESTI-LARGA",
        "zip": "217307",
        "lat": "45.173784",
        "long": "23.484207"
      },
      {
        "name": "STANESTI",
        "zip": "217455",
        "lat": "45.123176",
        "long": "23.240823"
      },
      {
        "name": "STEFANESTI",
        "zip": "215510",
        "lat": "44.980605",
        "long": "23.566494"
      },
      {
        "name": "STEIC",
        "zip": "217138",
        "lat": "44.834198",
        "long": "22.918897"
      },
      {
        "name": "STEJARI",
        "zip": "217470",
        "lat": "44.773494",
        "long": "23.69183"
      },
      {
        "name": "STEJARU",
        "zip": "217386",
        "lat": "45.017924",
        "long": "23.712749"
      },
      {
        "name": "STEJEREI",
        "zip": "217153",
        "lat": "44.941142",
        "long": "23.101735"
      },
      {
        "name": "STERPOAIA",
        "zip": "217024",
        "lat": "44.790584",
        "long": "23.436009"
      },
      {
        "name": "STIUCANI",
        "zip": "217452",
        "lat": "44.829691",
        "long": "23.039886"
      },
      {
        "name": "STOINA",
        "zip": "217480",
        "lat": "44.68437",
        "long": "23.632203"
      },
      {
        "name": "STOLOJANI",
        "zip": "217051",
        "lat": "45.039531",
        "long": "23.144988"
      },
      {
        "name": "STRAMBA-JIU",
        "zip": "217524",
        "lat": "44.759789",
        "long": "23.321043"
      },
      {
        "name": "STRAMBA-VULCAN",
        "zip": "217159",
        "lat": "44.91132",
        "long": "23.042165"
      },
      {
        "name": "STRAMTU",
        "zip": "217448",
        "lat": "44.77632",
        "long": "23.113238"
      },
      {
        "name": "STROIESTI",
        "zip": "217028",
        "lat": "45.063018",
        "long": "23.152346"
      },
      {
        "name": "SURA",
        "zip": "217449",
        "lat": "44.764256",
        "long": "23.155934"
      },
      {
        "name": "SUSENI",
        "zip": "217396",
        "lat": "45.141674",
        "long": "23.20555"
      },
      {
        "name": "TALPASESTI",
        "zip": "217052",
        "lat": "45.025113",
        "long": "23.161077"
      },
      {
        "name": "TALVESTI",
        "zip": "217229",
        "lat": "44.948405",
        "long": "23.23614"
      },
      {
        "name": "TAMASESTI",
        "zip": "217053",
        "lat": "44.995125",
        "long": "23.187505"
      },
      {
        "name": "TANTARENI",
        "zip": "217535",
        "lat": "44.595246",
        "long": "23.492373"
      },
      {
        "name": "TARCULESTI",
        "zip": "217209",
        "lat": "44.926881",
        "long": "23.348992"
      },
      {
        "name": "TARGU CARBUNESTI",
        "zip": "215500",
        "lat": "44.960523",
        "long": "23.510216"
      },
      {
        "name": "TARGU JIU",
        "zip": "210101",
        "lat": "45.042295",
        "long": "23.272812"
      },
      {
        "name": "TARGU LOGRESTI",
        "zip": "217293",
        "lat": "44.873876",
        "long": "23.707005"
      },
      {
        "name": "TEHOMIR",
        "zip": "217453",
        "lat": "44.805932",
        "long": "23.07896"
      },
      {
        "name": "TELESTI",
        "zip": "217490",
        "lat": "44.999808",
        "long": "23.08226"
      },
      {
        "name": "TETILA",
        "zip": "215104",
        "lat": "45.137589",
        "long": "23.391338"
      },
      {
        "name": "TICLENI",
        "zip": "215600",
        "lat": "44.88352",
        "long": "23.393601"
      },
      {
        "name": "TIMISENI",
        "zip": "217241",
        "lat": "44.875244",
        "long": "23.118189"
      },
      {
        "name": "TIRIOI",
        "zip": "217406",
        "lat": "44.781134",
        "long": "23.047412"
      },
      {
        "name": "TISMANA",
        "zip": "217495",
        "lat": "45.04952",
        "long": "22.947085"
      },
      {
        "name": "TOIAGA",
        "zip": "217484",
        "lat": "44.692284",
        "long": "23.645985"
      },
      {
        "name": "TOPESTI",
        "zip": "217504",
        "lat": "45.075394",
        "long": "22.968956"
      },
      {
        "name": "TOTEA",
        "zip": "217283",
        "lat": "44.852576",
        "long": "23.609979"
      },
      {
        "name": "TOTEA DE HUREZANI",
        "zip": "217264",
        "lat": "44.82411",
        "long": "23.623431"
      },
      {
        "name": "TRESTIOARA",
        "zip": "217222",
        "lat": "44.779565",
        "long": "23.179882"
      },
      {
        "name": "TROCANI",
        "zip": "217208",
        "lat": "44.944319",
        "long": "23.377317"
      },
      {
        "name": "TURBUREA",
        "zip": "217515",
        "lat": "44.71919",
        "long": "23.516677"
      },
      {
        "name": "TURCENI",
        "zip": "217520",
        "lat": "44.681258",
        "long": "23.371473"
      },
      {
        "name": "TURCINESTI",
        "zip": "217530",
        "lat": "45.098486",
        "long": "23.311431"
      },
      {
        "name": "ULMET",
        "zip": "217486",
        "lat": "44.681509",
        "long": "23.657921"
      },
      {
        "name": "UNGURENI",
        "zip": "217211",
        "lat": "44.988744",
        "long": "23.36485"
      },
      {
        "name": "URDA DE JOS",
        "zip": "217184",
        "lat": "44.631384",
        "long": "23.624229"
      },
      {
        "name": "URDA DE SUS",
        "zip": "217487",
        "lat": "44.657956",
        "long": "23.648244"
      },
      {
        "name": "URDARI",
        "zip": "217540",
        "lat": "44.796935",
        "long": "23.294533"
      },
      {
        "name": "URECHESTI",
        "zip": "217231",
        "lat": "44.96079",
        "long": "23.274056"
      },
      {
        "name": "URSATI",
        "zip": "210008",
        "lat": "45.077884",
        "long": "23.232253"
      },
      {
        "name": "URSOAIA",
        "zip": "217319",
        "lat": "44.811623",
        "long": "23.207327"
      },
      {
        "name": "VACAREA",
        "zip": "217212",
        "lat": "44.966898",
        "long": "23.300636"
      },
      {
        "name": "VAGIULESTI",
        "zip": "217545",
        "lat": "44.718048",
        "long": "23.083341"
      },
      {
        "name": "VAIDEI",
        "zip": "217464",
        "lat": "45.186168",
        "long": "23.269949"
      },
      {
        "name": "VAIENI",
        "zip": "217333",
        "lat": "45.031574",
        "long": "22.841757"
      },
      {
        "name": "VALARI",
        "zip": "217466",
        "lat": "45.157672",
        "long": "23.231828"
      },
      {
        "name": "VALCEAUA",
        "zip": "217154",
        "lat": "44.961662",
        "long": "23.017997"
      },
      {
        "name": "VALCELE",
        "zip": "217506",
        "lat": "45.08418",
        "long": "22.987627"
      },
      {
        "name": "VALEA",
        "zip": "217087",
        "lat": "44.722419",
        "long": "23.202944"
      },
      {
        "name": "VALEA BISERICII",
        "zip": "217407",
        "lat": "44.756629",
        "long": "23.026505"
      },
      {
        "name": "VALEA CU APA",
        "zip": "217242",
        "lat": "44.845525",
        "long": "23.257052"
      },
      {
        "name": "VALEA DESULUI",
        "zip": "217553",
        "lat": "44.855914",
        "long": "23.569425"
      },
      {
        "name": "VALEA MANASTIRII",
        "zip": "217139",
        "lat": "44.823453",
        "long": "22.935769"
      },
      {
        "name": "VALEA MARE",
        "zip": "217397",
        "lat": "45.112626",
        "long": "23.080043"
      },
      {
        "name": "VALEA MICA",
        "zip": "217408",
        "lat": "44.776043",
        "long": "23.076404"
      },
      {
        "name": "VALEA MOTRULUI",
        "zip": "217549",
        "lat": "44.697034",
        "long": "23.114882"
      },
      {
        "name": "VALEA PERILOR",
        "zip": "217141",
        "lat": "44.847306",
        "long": "22.921484"
      },
      {
        "name": "VALEA POIENII",
        "zip": "217409",
        "lat": "44.74462",
        "long": "23.052861"
      },
      {
        "name": "VALEA POJARULUI",
        "zip": "217123",
        "lat": "44.932302",
        "long": "23.727003"
      },
      {
        "name": "VALEA RACILOR",
        "zip": "217321",
        "lat": "44.772231",
        "long": "23.252559"
      },
      {
        "name": "VALEA VIEI",
        "zip": "217526",
        "lat": "44.740716",
        "long": "23.334382"
      },
      {
        "name": "VALENI",
        "zip": "217357",
        "lat": "44.740882",
        "long": "23.386698"
      },
      {
        "name": "VALUTA",
        "zip": "217186",
        "lat": "44.656355",
        "long": "23.693506"
      },
      {
        "name": "VANATA",
        "zip": "217507",
        "lat": "45.04814",
        "long": "22.972462"
      },
      {
        "name": "VART",
        "zip": "",
        "lat": "44.947269",
        "long": "23.133135"
      },
      {
        "name": "VARTOPU",
        "zip": "217161",
        "lat": "44.913486",
        "long": "22.982794"
      },
      {
        "name": "VIDIN",
        "zip": "217273",
        "lat": "44.926139",
        "long": "23.51318"
      },
      {
        "name": "VIERSANI",
        "zip": "217274",
        "lat": "44.878752",
        "long": "23.531199"
      },
      {
        "name": "VLADIMIR",
        "zip": "217550",
        "lat": "44.827733",
        "long": "23.565975"
      },
      {
        "name": "VLADULENI",
        "zip": "217064",
        "lat": "44.888566",
        "long": "23.237266"
      },
      {
        "name": "VOINIGESTI",
        "zip": "217054",
        "lat": "45.00476",
        "long": "23.245181"
      },
      {
        "name": "VOITESTII DIN DEAL",
        "zip": "217042",
        "lat": "45.101807",
        "long": "23.447141"
      },
      {
        "name": "VOITESTII DIN VALE",
        "zip": "217035",
        "lat": "45.087456",
        "long": "23.421449"
      },
      {
        "name": "ZAICOIU",
        "zip": "217197",
        "lat": "44.743725",
        "long": "23.745546"
      },
      {
        "name": "ZORLESTI",
        "zip": "217377",
        "lat": "45.091359",
        "long": "23.720127"
      },
      {
        "name": "ZORZILA",
        "zip": "217162",
        "lat": "44.942312",
        "long": "22.983448"
      }
    ],
    "HARGHITA": [
      {
        "name": "ALDEA",
        "zip": "537176",
        "lat": "46.252486",
        "long": "25.434959"
      },
      {
        "name": "ALEXANDRITA",
        "zip": "537096",
        "lat": "46.234502",
        "long": "25.315622"
      },
      {
        "name": "ALUNIS",
        "zip": "537206",
        "lat": "46.264183",
        "long": "25.1864"
      },
      {
        "name": "ANDREENI",
        "zip": "537011",
        "lat": "46.347104",
        "long": "25.023237"
      },
      {
        "name": "ARMASENI",
        "zip": "537041",
        "lat": "46.353122",
        "long": "25.960656"
      },
      {
        "name": "ARMASENII NOI",
        "zip": "537042",
        "lat": "46.337603",
        "long": "25.971583"
      },
      {
        "name": "ARVATENI",
        "zip": "537097",
        "lat": "46.269672",
        "long": "25.307415"
      },
      {
        "name": "ATIA",
        "zip": "537061",
        "lat": "46.486767",
        "long": "25.12963"
      },
      {
        "name": "ATID",
        "zip": "537005",
        "lat": "46.453307",
        "long": "25.048439"
      },
      {
        "name": "AVRAMESTI",
        "zip": "537010",
        "lat": "46.33903",
        "long": "25.010669"
      },
      {
        "name": "BADENI",
        "zip": "537177",
        "lat": "46.217794",
        "long": "25.3476"
      },
      {
        "name": "BAILE CHIRUI",
        "zip": "537141",
        "lat": "46.297286",
        "long": "25.578651"
      },
      {
        "name": "BAILE HOMOROD",
        "zip": "535801",
        "lat": "46.352632",
        "long": "25.469681"
      },
      {
        "name": "BAILE TUSNAD",
        "zip": "535100",
        "lat": "46.144053",
        "long": "25.858824"
      },
      {
        "name": "BALAN",
        "zip": "535200",
        "lat": "46.652595",
        "long": "25.811344"
      },
      {
        "name": "BANCU",
        "zip": "537043",
        "lat": "46.301907",
        "long": "25.942257"
      },
      {
        "name": "BARATCOS",
        "zip": "537146",
        "lat": "46.63699",
        "long": "25.974148"
      },
      {
        "name": "BARZAVA",
        "zip": "537116",
        "lat": "46.430082",
        "long": "25.824946"
      },
      {
        "name": "BECAS",
        "zip": "537241",
        "lat": "46.512395",
        "long": "25.19396"
      },
      {
        "name": "BENTID",
        "zip": "537311",
        "lat": "46.372596",
        "long": "25.172606"
      },
      {
        "name": "BETA",
        "zip": "537207",
        "lat": "46.277799",
        "long": "25.225339"
      },
      {
        "name": "BETESTI",
        "zip": "537208",
        "lat": "46.290274",
        "long": "25.082425"
      },
      {
        "name": "BILBOR",
        "zip": "537020",
        "lat": "47.066687",
        "long": "25.490772"
      },
      {
        "name": "BISERICANI",
        "zip": "537166",
        "lat": "46.368044",
        "long": "25.243075"
      },
      {
        "name": "BODOGAIA",
        "zip": "537291",
        "lat": "46.27444",
        "long": "24.996565"
      },
      {
        "name": "BORSEC",
        "zip": "535300",
        "lat": "46.963627",
        "long": "25.561322"
      },
      {
        "name": "BORZONT",
        "zip": "537131",
        "lat": "46.695381",
        "long": "25.449913"
      },
      {
        "name": "BRADESTI",
        "zip": "537025",
        "lat": "46.341988",
        "long": "25.342337"
      },
      {
        "name": "BUCIN",
        "zip": "537132",
        "lat": "46.689325",
        "long": "25.425108"
      },
      {
        "name": "BUCIN",
        "zip": "537242",
        "lat": "46.573469",
        "long": "25.204872"
      },
      {
        "name": "BULGARENI",
        "zip": "537167",
        "lat": "46.365905",
        "long": "25.25257"
      },
      {
        "name": "CADACIU MARE",
        "zip": "537312",
        "lat": "46.353213",
        "long": "25.134227"
      },
      {
        "name": "CADACIU MIC",
        "zip": "537313",
        "lat": "46.346398",
        "long": "25.120879"
      },
      {
        "name": "CALIMANEL",
        "zip": "535701",
        "lat": "46.938954",
        "long": "25.320059"
      },
      {
        "name": "CALNACI",
        "zip": "537301",
        "lat": "46.855189",
        "long": "25.36674"
      },
      {
        "name": "CALONDA",
        "zip": "537062",
        "lat": "46.443561",
        "long": "25.217611"
      },
      {
        "name": "CALUGARENI",
        "zip": "537178",
        "lat": "46.292068",
        "long": "25.400963"
      },
      {
        "name": "CAPALNITA",
        "zip": "537030",
        "lat": "46.356869",
        "long": "25.511265"
      },
      {
        "name": "CAPU CORBULUI",
        "zip": "537056",
        "lat": "46.999752",
        "long": "25.629215"
      },
      {
        "name": "CARPITUS",
        "zip": "535101",
        "lat": "46.121706",
        "long": "25.855433"
      },
      {
        "name": "CARTA",
        "zip": "537035",
        "lat": "46.533275",
        "long": "25.760823"
      },
      {
        "name": "CASINU NOU",
        "zip": "537236",
        "lat": "46.19712",
        "long": "26.048611"
      },
      {
        "name": "CECHESTI",
        "zip": "537012",
        "lat": "46.31493",
        "long": "25.021336"
      },
      {
        "name": "CEHETEL",
        "zip": "537314",
        "lat": "46.397637",
        "long": "25.142257"
      },
      {
        "name": "CETATUIA",
        "zip": "537286",
        "lat": "46.242054",
        "long": "25.897839"
      },
      {
        "name": "CHEDIA MARE",
        "zip": "537316",
        "lat": "46.33533",
        "long": "25.048534"
      },
      {
        "name": "CHEDIA MICA",
        "zip": "537317",
        "lat": "46.340317",
        "long": "25.060209"
      },
      {
        "name": "CHILENI",
        "zip": "537306",
        "lat": "46.681267",
        "long": "25.569338"
      },
      {
        "name": "CHINUSU",
        "zip": "537179",
        "lat": "46.25759",
        "long": "25.360938"
      },
      {
        "name": "CIARACIO",
        "zip": "537296",
        "lat": "46.411588",
        "long": "25.748539"
      },
      {
        "name": "CIBA",
        "zip": "530001",
        "lat": "46.37886",
        "long": "25.745822"
      },
      {
        "name": "CICEU",
        "zip": "537297",
        "lat": "46.411959",
        "long": "25.78056"
      },
      {
        "name": "CIOBANIS",
        "zip": "537044",
        "lat": "46.384226",
        "long": "26.166622"
      },
      {
        "name": "CIRESENI",
        "zip": "537098",
        "lat": "46.32069",
        "long": "25.201358"
      },
      {
        "name": "CIUCANI",
        "zip": "537281",
        "lat": "46.258895",
        "long": "25.941851"
      },
      {
        "name": "CIUCSANGEORGIU",
        "zip": "537040",
        "lat": "46.322018",
        "long": "25.956616"
      },
      {
        "name": "CIUMANI",
        "zip": "537050",
        "lat": "46.678288",
        "long": "25.517863"
      },
      {
        "name": "COBATESTI",
        "zip": "537318",
        "lat": "46.357025",
        "long": "25.142599"
      },
      {
        "name": "COMANESTI",
        "zip": "537181",
        "lat": "46.264986",
        "long": "25.438799"
      },
      {
        "name": "COMIAT",
        "zip": "537156",
        "lat": "46.491288",
        "long": "25.944685"
      },
      {
        "name": "CORBU",
        "zip": "537055",
        "lat": "46.99142",
        "long": "25.684697"
      },
      {
        "name": "CORUND",
        "zip": "537060",
        "lat": "46.471641",
        "long": "25.183633"
      },
      {
        "name": "COTORMANI",
        "zip": "537046",
        "lat": "46.304969",
        "long": "25.908414"
      },
      {
        "name": "COVACIPETER",
        "zip": "535501",
        "lat": "46.726188",
        "long": "25.719533"
      },
      {
        "name": "COZMENI",
        "zip": "537065",
        "lat": "46.226481",
        "long": "25.941072"
      },
      {
        "name": "CRACIUNEL",
        "zip": "537226",
        "lat": "46.182191",
        "long": "25.432759"
      },
      {
        "name": "CRISENI",
        "zip": "537006",
        "lat": "46.41693",
        "long": "24.970777"
      },
      {
        "name": "CRISTURU SECUIESC",
        "zip": "535400",
        "lat": "46.288977",
        "long": "25.035599"
      },
      {
        "name": "CUSMED",
        "zip": "537007",
        "lat": "46.476111",
        "long": "25.045564"
      },
      {
        "name": "DAIA",
        "zip": "537341",
        "lat": "46.193655",
        "long": "25.30983"
      },
      {
        "name": "DANESTI",
        "zip": "537070",
        "lat": "46.51688",
        "long": "25.757601"
      },
      {
        "name": "DARJIU",
        "zip": "537075",
        "lat": "46.200732",
        "long": "25.198886"
      },
      {
        "name": "DEALU",
        "zip": "537080",
        "lat": "46.395525",
        "long": "25.305275"
      },
      {
        "name": "DEALU ARMANULUI",
        "zip": "537121",
        "lat": "46.896104",
        "long": "25.397534"
      },
      {
        "name": "DEJUTIU",
        "zip": "537209",
        "lat": "46.254613",
        "long": "25.176632"
      },
      {
        "name": "DELNITA",
        "zip": "537231",
        "lat": "46.412901",
        "long": "25.829702"
      },
      {
        "name": "DESAG",
        "zip": "537361",
        "lat": "46.444397",
        "long": "25.46565"
      },
      {
        "name": "DITRAU",
        "zip": "537090",
        "lat": "46.803913",
        "long": "25.500907"
      },
      {
        "name": "DOBENI",
        "zip": "537211",
        "lat": "46.287792",
        "long": "25.187921"
      },
      {
        "name": "DUDA",
        "zip": "537302",
        "lat": "46.846222",
        "long": "25.40611"
      },
      {
        "name": "EGHERSEC",
        "zip": "537047",
        "lat": "46.333859",
        "long": "26.067052"
      },
      {
        "name": "ELISENI",
        "zip": "537292",
        "lat": "46.292527",
        "long": "24.93723"
      },
      {
        "name": "FAGETEL",
        "zip": "537117",
        "lat": "46.462604",
        "long": "25.951958"
      },
      {
        "name": "FAGETEL",
        "zip": "537251",
        "lat": "46.836841",
        "long": "25.384315"
      },
      {
        "name": "FANCEL",
        "zip": "537081",
        "lat": "46.368305",
        "long": "25.299647"
      },
      {
        "name": "FANTANA BRAZILOR",
        "zip": "537063",
        "lat": "46.486296",
        "long": "25.250986"
      },
      {
        "name": "FELICENI",
        "zip": "537095",
        "lat": "46.273144",
        "long": "25.278435"
      },
      {
        "name": "FILIAS",
        "zip": "535401",
        "lat": "46.270368",
        "long": "25.020797"
      },
      {
        "name": "FILPEA",
        "zip": "537303",
        "lat": "46.868591",
        "long": "25.420472"
      },
      {
        "name": "FIRTANUS",
        "zip": "537013",
        "lat": "46.407663",
        "long": "25.095778"
      },
      {
        "name": "FIRTUSU",
        "zip": "537168",
        "lat": "46.426582",
        "long": "25.148664"
      },
      {
        "name": "FITOD",
        "zip": "537266",
        "lat": "46.357036",
        "long": "25.846813"
      },
      {
        "name": "FORTENI",
        "zip": "537099",
        "lat": "46.306593",
        "long": "25.23622"
      },
      {
        "name": "FRUMOASA",
        "zip": "537115",
        "lat": "46.453679",
        "long": "25.853326"
      },
      {
        "name": "FUNDOAIA",
        "zip": "537261",
        "lat": "46.892967",
        "long": "25.45763"
      },
      {
        "name": "GALAUTAS",
        "zip": "537120",
        "lat": "46.910682",
        "long": "25.405984"
      },
      {
        "name": "GALAUTAS-PARAU",
        "zip": "537122",
        "lat": "46.892417",
        "long": "25.378502"
      },
      {
        "name": "GARCIU",
        "zip": "537299",
        "lat": "46.455576",
        "long": "25.781361"
      },
      {
        "name": "GHEORGHENI",
        "zip": "535500",
        "lat": "46.722612",
        "long": "25.602244"
      },
      {
        "name": "GHIDUT",
        "zip": "537136",
        "lat": "46.786529",
        "long": "25.541144"
      },
      {
        "name": "GHIPES",
        "zip": "537182",
        "lat": "46.263187",
        "long": "25.403161"
      },
      {
        "name": "GHIURCHE",
        "zip": "537048",
        "lat": "46.388574",
        "long": "26.067503"
      },
      {
        "name": "GOAGIU",
        "zip": "537014",
        "lat": "46.365273",
        "long": "25.030299"
      },
      {
        "name": "HAGOTA",
        "zip": "537331",
        "lat": "46.874503",
        "long": "25.682122"
      },
      {
        "name": "HARGHITA-BAI",
        "zip": "530002",
        "lat": "46.387623",
        "long": "25.637672"
      },
      {
        "name": "HODOSA",
        "zip": "537262",
        "lat": "46.865579",
        "long": "25.446199"
      },
      {
        "name": "HOGHIA",
        "zip": "537101",
        "lat": "46.284754",
        "long": "25.251793"
      },
      {
        "name": "HOSASAU",
        "zip": "537267",
        "lat": "46.343231",
        "long": "25.905162"
      },
      {
        "name": "IACOBENI",
        "zip": "537237",
        "lat": "46.200573",
        "long": "26.10719"
      },
      {
        "name": "IASU",
        "zip": "537342",
        "lat": "46.209549",
        "long": "25.258034"
      },
      {
        "name": "IGHIU",
        "zip": "537343",
        "lat": "46.204295",
        "long": "25.286399"
      },
      {
        "name": "IMPER",
        "zip": "537238",
        "lat": "46.220049",
        "long": "26.107866"
      },
      {
        "name": "INEU",
        "zip": "537036",
        "lat": "46.543931",
        "long": "25.761797"
      },
      {
        "name": "INLACENI",
        "zip": "537008",
        "lat": "46.430048",
        "long": "25.108857"
      },
      {
        "name": "IZVOARE",
        "zip": "537362",
        "lat": "46.461954",
        "long": "25.456346"
      },
      {
        "name": "IZVORU MURESULUI",
        "zip": "537356",
        "lat": "46.623963",
        "long": "25.687207"
      },
      {
        "name": "IZVORUL TROTUSULUI",
        "zip": "537157",
        "lat": "46.503999",
        "long": "25.946327"
      },
      {
        "name": "JIGODIN-BAI",
        "zip": "530003",
        "lat": "46.327943",
        "long": "25.810709"
      },
      {
        "name": "JOLOTCA",
        "zip": "537091",
        "lat": "46.864029",
        "long": "25.527882"
      },
      {
        "name": "JOSENI",
        "zip": "537130",
        "lat": "46.701136",
        "long": "25.505107"
      },
      {
        "name": "LACU ROSU",
        "zip": "535502",
        "lat": "46.793013",
        "long": "25.795313"
      },
      {
        "name": "LAZ-FIRTANUS",
        "zip": "537016",
        "lat": "46.39409",
        "long": "25.042214"
      },
      {
        "name": "LAZ-SOIMUS",
        "zip": "537017",
        "lat": "46.356904",
        "long": "24.98431"
      },
      {
        "name": "LAZAREA",
        "zip": "537135",
        "lat": "46.746022",
        "long": "25.532673"
      },
      {
        "name": "LAZARESTI",
        "zip": "537066",
        "lat": "46.191982",
        "long": "25.941887"
      },
      {
        "name": "LELICENI",
        "zip": "537268",
        "lat": "46.346761",
        "long": "25.847657"
      },
      {
        "name": "LIBAN",
        "zip": "537307",
        "lat": "46.537333",
        "long": "25.496597"
      },
      {
        "name": "LIVEZI",
        "zip": "537201",
        "lat": "46.517836",
        "long": "25.85087"
      },
      {
        "name": "LOCODENI",
        "zip": "537183",
        "lat": "46.240455",
        "long": "25.356702"
      },
      {
        "name": "LUETA",
        "zip": "537140",
        "lat": "46.273788",
        "long": "25.489914"
      },
      {
        "name": "LUNCA DE JOS",
        "zip": "537145",
        "lat": "46.562296",
        "long": "25.974304"
      },
      {
        "name": "LUNCA DE SUS",
        "zip": "537155",
        "lat": "46.530044",
        "long": "25.959666"
      },
      {
        "name": "LUNCANI",
        "zip": "535702",
        "lat": "46.903407",
        "long": "25.315055"
      },
      {
        "name": "LUPENI",
        "zip": "537165",
        "lat": "46.380457",
        "long": "25.225681"
      },
      {
        "name": "LUTITA",
        "zip": "537212",
        "lat": "46.244968",
        "long": "25.185077"
      },
      {
        "name": "MADARAS",
        "zip": "537071",
        "lat": "46.493692",
        "long": "25.748501"
      },
      {
        "name": "MAGHERUS",
        "zip": "535703",
        "lat": "46.920102",
        "long": "25.346406"
      },
      {
        "name": "MARTINIS",
        "zip": "537175",
        "lat": "46.232803",
        "long": "25.390898"
      },
      {
        "name": "MARTONCA",
        "zip": "537252",
        "lat": "46.828899",
        "long": "25.42862"
      },
      {
        "name": "MATISENI",
        "zip": "537213",
        "lat": "46.235047",
        "long": "25.168303"
      },
      {
        "name": "MEDISORU MARE",
        "zip": "537319",
        "lat": "46.361537",
        "long": "25.073161"
      },
      {
        "name": "MEDISORU MIC",
        "zip": "537018",
        "lat": "46.386812",
        "long": "25.050362"
      },
      {
        "name": "MERESTI",
        "zip": "537195",
        "lat": "46.234585",
        "long": "25.460986"
      },
      {
        "name": "MIERCUREA CIUC",
        "zip": "530100",
        "lat": "46.361404",
        "long": "25.802667"
      },
      {
        "name": "MIHAILENI",
        "zip": "537200",
        "lat": "46.474899",
        "long": "25.83219"
      },
      {
        "name": "MIHAILENI",
        "zip": "537321",
        "lat": "46.362862",
        "long": "25.175362"
      },
      {
        "name": "MINELE LUETA",
        "zip": "535802",
        "lat": "46.30637",
        "long": "25.506428"
      },
      {
        "name": "MISENTEA",
        "zip": "537269",
        "lat": "46.32689",
        "long": "25.894735"
      },
      {
        "name": "MOGLANESTI",
        "zip": "535704",
        "lat": "46.92355",
        "long": "25.382843"
      },
      {
        "name": "MORARENI",
        "zip": "537169",
        "lat": "46.357078",
        "long": "25.218403"
      },
      {
        "name": "MUGENI",
        "zip": "537205",
        "lat": "46.257246",
        "long": "25.220443"
      },
      {
        "name": "MUJNA",
        "zip": "537076",
        "lat": "46.206835",
        "long": "25.150357"
      },
      {
        "name": "NADEJDEA",
        "zip": "537202",
        "lat": "46.496396",
        "long": "25.839513"
      },
      {
        "name": "NICOLENI",
        "zip": "537322",
        "lat": "46.338798",
        "long": "25.087668"
      },
      {
        "name": "NICOLESTI",
        "zip": "537118",
        "lat": "46.439176",
        "long": "25.844455"
      },
      {
        "name": "NICOLESTI",
        "zip": "537344",
        "lat": "46.24214",
        "long": "25.258337"
      },
      {
        "name": "NUTENI",
        "zip": "537123",
        "lat": "46.919186",
        "long": "25.394746"
      },
      {
        "name": "OBRANESTI",
        "zip": "537346",
        "lat": "46.22808",
        "long": "25.292234"
      },
      {
        "name": "OCLAND",
        "zip": "537225",
        "lat": "46.159561",
        "long": "25.426833"
      },
      {
        "name": "OCNA DE JOS",
        "zip": "537243",
        "lat": "46.524383",
        "long": "25.130593"
      },
      {
        "name": "OCNA DE SUS",
        "zip": "537244",
        "lat": "46.526731",
        "long": "25.150677"
      },
      {
        "name": "ODORHEIU SECUIESC",
        "zip": "535600",
        "lat": "46.304746",
        "long": "25.295026"
      },
      {
        "name": "ORASENI",
        "zip": "537184",
        "lat": "46.164028",
        "long": "25.365827"
      },
      {
        "name": "OTENI",
        "zip": "537102",
        "lat": "46.258681",
        "long": "25.254022"
      },
      {
        "name": "PALTINIS",
        "zip": "537171",
        "lat": "46.390548",
        "long": "25.200704"
      },
      {
        "name": "PALTINIS-CIUC",
        "zip": "537158",
        "lat": "46.543997",
        "long": "25.968684"
      },
      {
        "name": "PAULENI",
        "zip": "537172",
        "lat": "46.427121",
        "long": "25.183357"
      },
      {
        "name": "PAULENI-CIUC",
        "zip": "537230",
        "lat": "46.395506",
        "long": "25.833988"
      },
      {
        "name": "PETECU",
        "zip": "537347",
        "lat": "46.172744",
        "long": "25.234839"
      },
      {
        "name": "PETRENI",
        "zip": "537186",
        "lat": "46.176538",
        "long": "25.374819"
      },
      {
        "name": "PINTIC",
        "zip": "537332",
        "lat": "46.964543",
        "long": "25.788355"
      },
      {
        "name": "PLAIESII DE JOS",
        "zip": "537235",
        "lat": "46.228266",
        "long": "26.100329"
      },
      {
        "name": "PLAIESII DE SUS",
        "zip": "537239",
        "lat": "46.235153",
        "long": "26.107456"
      },
      {
        "name": "PLATONESTI",
        "zip": "537263",
        "lat": "46.904378",
        "long": "25.419741"
      },
      {
        "name": "PLOPIS",
        "zip": "537124",
        "lat": "46.915378",
        "long": "25.389729"
      },
      {
        "name": "POIANA FAGULUI",
        "zip": "537147",
        "lat": "46.639806",
        "long": "25.953645"
      },
      {
        "name": "POIANA TARNAVEI",
        "zip": "537363",
        "lat": "46.502619",
        "long": "25.407304"
      },
      {
        "name": "POLONITA",
        "zip": "537103",
        "lat": "46.33501",
        "long": "25.251763"
      },
      {
        "name": "PORUMBENII MARI",
        "zip": "537214",
        "lat": "46.273921",
        "long": "25.132714"
      },
      {
        "name": "PORUMBENII MICI",
        "zip": "537216",
        "lat": "46.272318",
        "long": "25.102345"
      },
      {
        "name": "POTIOND",
        "zip": "537049",
        "lat": "46.362819",
        "long": "25.952172"
      },
      {
        "name": "PRAID",
        "zip": "537240",
        "lat": "46.552912",
        "long": "25.124522"
      },
      {
        "name": "PRELUCA",
        "zip": "537126",
        "lat": "46.890377",
        "long": "25.35783"
      },
      {
        "name": "PUNTEA LUPULUI",
        "zip": "537148",
        "lat": "46.694291",
        "long": "25.929113"
      },
      {
        "name": "RACHITIS",
        "zip": "537021",
        "lat": "47.046864",
        "long": "25.507438"
      },
      {
        "name": "RACU",
        "zip": "537298",
        "lat": "46.451775",
        "long": "25.7606"
      },
      {
        "name": "RARES",
        "zip": "537187",
        "lat": "46.207622",
        "long": "25.386031"
      },
      {
        "name": "RECEA",
        "zip": "537333",
        "lat": "46.900785",
        "long": "25.728719"
      },
      {
        "name": "REMETEA",
        "zip": "537250",
        "lat": "46.793533",
        "long": "25.450284"
      },
      {
        "name": "RUGANESTI",
        "zip": "537323",
        "lat": "46.304686",
        "long": "25.073449"
      },
      {
        "name": "RUNC",
        "zip": "537264",
        "lat": "46.910356",
        "long": "25.418541"
      },
      {
        "name": "SACEL",
        "zip": "537255",
        "lat": "46.313624",
        "long": "24.929994"
      },
      {
        "name": "SANCEL",
        "zip": "537174",
        "lat": "46.469336",
        "long": "25.29608"
      },
      {
        "name": "SANCRAI",
        "zip": "537082",
        "lat": "46.367856",
        "long": "25.325759"
      },
      {
        "name": "SANCRAIENI",
        "zip": "537265",
        "lat": "46.312374",
        "long": "25.838748"
      },
      {
        "name": "SANDOMINIC",
        "zip": "537275",
        "lat": "46.579328",
        "long": "25.793053"
      },
      {
        "name": "SANMARTIN",
        "zip": "537280",
        "lat": "46.265681",
        "long": "25.937501"
      },
      {
        "name": "SANPAUL",
        "zip": "537188",
        "lat": "46.191403",
        "long": "25.382351"
      },
      {
        "name": "SANSIMION",
        "zip": "537285",
        "lat": "46.258254",
        "long": "25.886076"
      },
      {
        "name": "SANTIMBRU",
        "zip": "537271",
        "lat": "46.281261",
        "long": "25.854389"
      },
      {
        "name": "SANTIMBRU-BAI",
        "zip": "537272",
        "lat": "46.271195",
        "long": "25.7612"
      },
      {
        "name": "SARMAS",
        "zip": "537260",
        "lat": "46.877362",
        "long": "25.443361"
      },
      {
        "name": "SASVERES",
        "zip": "537246",
        "lat": "46.563666",
        "long": "25.091094"
      },
      {
        "name": "SATU MARE",
        "zip": "537026",
        "lat": "46.341424",
        "long": "25.383828"
      },
      {
        "name": "SATU MIC",
        "zip": "537173",
        "lat": "46.372972",
        "long": "25.197363"
      },
      {
        "name": "SATU NOU",
        "zip": "537227",
        "lat": "46.145523",
        "long": "25.417118"
      },
      {
        "name": "SECU",
        "zip": "535705",
        "lat": "46.989154",
        "long": "25.483493"
      },
      {
        "name": "SECUIENI",
        "zip": "537290",
        "lat": "46.261305",
        "long": "24.972114"
      },
      {
        "name": "SENETEA",
        "zip": "537308",
        "lat": "46.635458",
        "long": "25.592874"
      },
      {
        "name": "SICASAU",
        "zip": "537366",
        "lat": "46.515073",
        "long": "25.46574"
      },
      {
        "name": "SICLOD",
        "zip": "537009",
        "lat": "46.517201",
        "long": "25.040757"
      },
      {
        "name": "SICULENI",
        "zip": "537295",
        "lat": "46.435567",
        "long": "25.752423"
      },
      {
        "name": "SIMONESTI",
        "zip": "537310",
        "lat": "46.335829",
        "long": "25.108851"
      },
      {
        "name": "SINEU",
        "zip": "537253",
        "lat": "46.814397",
        "long": "25.417247"
      },
      {
        "name": "SOIMENI",
        "zip": "537232",
        "lat": "46.394364",
        "long": "25.852753"
      },
      {
        "name": "SOIMUSU MARE",
        "zip": "537256",
        "lat": "46.347871",
        "long": "24.926509"
      },
      {
        "name": "SOIMUSU MIC",
        "zip": "537257",
        "lat": "46.336205",
        "long": "24.959736"
      },
      {
        "name": "SUB CETATE",
        "zip": "537364",
        "lat": "46.444268",
        "long": "25.392188"
      },
      {
        "name": "SUBCETATE",
        "zip": "537300",
        "lat": "46.855788",
        "long": "25.432754"
      },
      {
        "name": "SUSENI",
        "zip": "537305",
        "lat": "46.659552",
        "long": "25.557154"
      },
      {
        "name": "TAIETURA",
        "zip": "537217",
        "lat": "46.297509",
        "long": "25.198689"
      },
      {
        "name": "TAMASU",
        "zip": "537083",
        "lat": "46.348104",
        "long": "25.288689"
      },
      {
        "name": "TARCESTI",
        "zip": "537324",
        "lat": "46.376279",
        "long": "25.131481"
      },
      {
        "name": "TARNOVITA",
        "zip": "537027",
        "lat": "46.371355",
        "long": "25.3594"
      },
      {
        "name": "TAURENI",
        "zip": "537104",
        "lat": "46.267282",
        "long": "25.259063"
      },
      {
        "name": "TELEAC",
        "zip": "537106",
        "lat": "46.245367",
        "long": "25.320891"
      },
      {
        "name": "TENGHELER",
        "zip": "537092",
        "lat": "46.867721",
        "long": "25.552239"
      },
      {
        "name": "TIBOD",
        "zip": "537084",
        "lat": "46.347789",
        "long": "25.312971"
      },
      {
        "name": "TOLESENI",
        "zip": "537127",
        "lat": "46.918179",
        "long": "25.403762"
      },
      {
        "name": "TOMESTI",
        "zip": "537037",
        "lat": "46.557353",
        "long": "25.784397"
      },
      {
        "name": "TOPLITA",
        "zip": "535700",
        "lat": "46.92408",
        "long": "25.352478"
      },
      {
        "name": "TULGHES",
        "zip": "537330",
        "lat": "46.965407",
        "long": "25.762642"
      },
      {
        "name": "TURDENI",
        "zip": "537326",
        "lat": "46.379649",
        "long": "25.102133"
      },
      {
        "name": "TUSNAD",
        "zip": "537335",
        "lat": "46.2056",
        "long": "25.914327"
      },
      {
        "name": "TUSNADU NOU",
        "zip": "537336",
        "lat": "46.193243",
        "long": "25.894268"
      },
      {
        "name": "UILAC",
        "zip": "537258",
        "lat": "46.308103",
        "long": "24.868086"
      },
      {
        "name": "ULCANI",
        "zip": "537086",
        "lat": "46.35961",
        "long": "25.278296"
      },
      {
        "name": "ULIES",
        "zip": "537340",
        "lat": "46.213007",
        "long": "25.241611"
      },
      {
        "name": "VACARESTI",
        "zip": "537203",
        "lat": "46.465843",
        "long": "25.798494"
      },
      {
        "name": "VAGANI",
        "zip": "535707",
        "lat": "46.9486",
        "long": "25.291317"
      },
      {
        "name": "VALE",
        "zip": "535706",
        "lat": "46.949096",
        "long": "25.378688"
      },
      {
        "name": "VALEA BOROS",
        "zip": "537149",
        "lat": "46.547391",
        "long": "25.988489"
      },
      {
        "name": "VALEA CAPELEI",
        "zip": "537151",
        "lat": "46.559301",
        "long": "25.98997"
      },
      {
        "name": "VALEA GARBEA",
        "zip": "537159",
        "lat": "46.535548",
        "long": "25.943786"
      },
      {
        "name": "VALEA INTUNECOASA",
        "zip": "537152",
        "lat": "46.561246",
        "long": "25.953648"
      },
      {
        "name": "VALEA LUI ANTALOC",
        "zip": "537154",
        "lat": "46.568982",
        "long": "25.96683"
      },
      {
        "name": "VALEA LUI PAVEL",
        "zip": "537064",
        "lat": "46.515933",
        "long": "25.216817"
      },
      {
        "name": "VALEA RECE",
        "zip": "537153",
        "lat": "46.620819",
        "long": "25.958267"
      },
      {
        "name": "VALEA ROTUNDA",
        "zip": "537087",
        "lat": "46.406957",
        "long": "25.327448"
      },
      {
        "name": "VALEA STRAMBA",
        "zip": "537309",
        "lat": "46.692648",
        "long": "25.595055"
      },
      {
        "name": "VALEA UGRA",
        "zip": "537161",
        "lat": "46.525276",
        "long": "25.976683"
      },
      {
        "name": "VALEA UZULUI",
        "zip": "537282",
        "lat": "46.341991",
        "long": "26.248944"
      },
      {
        "name": "VALENI",
        "zip": "537107",
        "lat": "46.267592",
        "long": "25.330525"
      },
      {
        "name": "VARGATAC",
        "zip": "535503",
        "lat": "46.751656",
        "long": "25.630484"
      },
      {
        "name": "VARSAG",
        "zip": "537350",
        "lat": "46.528858",
        "long": "25.335921"
      },
      {
        "name": "VASILENI",
        "zip": "537348",
        "lat": "46.228944",
        "long": "25.272284"
      },
      {
        "name": "VIDACUT",
        "zip": "537259",
        "lat": "46.338465",
        "long": "24.894981"
      },
      {
        "name": "VISAFOLIO",
        "zip": "535504",
        "lat": "46.704664",
        "long": "25.630829"
      },
      {
        "name": "VLAHITA",
        "zip": "535800",
        "lat": "46.34454",
        "long": "25.529805"
      },
      {
        "name": "VOSLABENI",
        "zip": "537355",
        "lat": "46.646011",
        "long": "25.622596"
      },
      {
        "name": "VRABIA",
        "zip": "537337",
        "lat": "46.223028",
        "long": "25.905048"
      },
      {
        "name": "ZAPODEA",
        "zip": "537128",
        "lat": "46.898644",
        "long": "25.35841"
      },
      {
        "name": "ZENCANI",
        "zip": "535708",
        "lat": "46.926798",
        "long": "25.333885"
      },
      {
        "name": "ZETEA",
        "zip": "537360",
        "lat": "46.38758",
        "long": "25.36867"
      }
    ],
    "HUNEDOARA": [
      {
        "name": "ABUCEA",
        "zip": "337216",
        "lat": "45.905754",
        "long": "22.540973"
      },
      {
        "name": "ALMAS-SALISTE",
        "zip": "337551",
        "lat": "46.059433",
        "long": "22.519639"
      },
      {
        "name": "ALMASEL",
        "zip": "337552",
        "lat": "46.092371",
        "long": "22.433801"
      },
      {
        "name": "ALMASU MIC",
        "zip": "337336",
        "lat": "45.818297",
        "long": "22.89312"
      },
      {
        "name": "ALMASU MIC DE MUNTE",
        "zip": "337016",
        "lat": "46.056298",
        "long": "23.08131"
      },
      {
        "name": "ALMASU SEC",
        "zip": "337176",
        "lat": "45.848283",
        "long": "22.863439"
      },
      {
        "name": "ALUN",
        "zip": "337096",
        "lat": "45.605506",
        "long": "23.165338"
      },
      {
        "name": "ALUN",
        "zip": "337161",
        "lat": "45.706214",
        "long": "22.68445"
      },
      {
        "name": "ANINOASA",
        "zip": "335100",
        "lat": "45.408006",
        "long": "23.316923"
      },
      {
        "name": "ARANIES",
        "zip": "337181",
        "lat": "45.794878",
        "long": "22.738248"
      },
      {
        "name": "ARCHIA",
        "zip": "330001",
        "lat": "45.843883",
        "long": "22.899236"
      },
      {
        "name": "ARDEU",
        "zip": "337017",
        "lat": "46.022282",
        "long": "23.142941"
      },
      {
        "name": "AUREL VLAICU",
        "zip": "335401",
        "lat": "45.910833",
        "long": "23.275997"
      },
      {
        "name": "BACAIA",
        "zip": "335402",
        "lat": "46.016086",
        "long": "23.176107"
      },
      {
        "name": "BACEA",
        "zip": "337271",
        "lat": "45.957168",
        "long": "22.668558"
      },
      {
        "name": "BACIA",
        "zip": "337040",
        "lat": "45.802582",
        "long": "23.006228"
      },
      {
        "name": "BAIA DE CRIS",
        "zip": "337005",
        "lat": "46.173703",
        "long": "22.713383"
      },
      {
        "name": "BAIESTI",
        "zip": "337346",
        "lat": "45.53422",
        "long": "23.012326"
      },
      {
        "name": "BAITA",
        "zip": "337045",
        "lat": "46.031234",
        "long": "22.892808"
      },
      {
        "name": "BALATA",
        "zip": "337451",
        "lat": "45.918159",
        "long": "22.929123"
      },
      {
        "name": "BALDOVIN",
        "zip": "337006",
        "lat": "46.209323",
        "long": "22.716253"
      },
      {
        "name": "BALOMIR",
        "zip": "337441",
        "lat": "45.58512",
        "long": "22.998929"
      },
      {
        "name": "BALSA",
        "zip": "337015",
        "lat": "46.028346",
        "long": "23.09971"
      },
      {
        "name": "BANITA",
        "zip": "337065",
        "lat": "45.448131",
        "long": "23.262605"
      },
      {
        "name": "BANPOTOC",
        "zip": "337266",
        "lat": "45.894486",
        "long": "23.012445"
      },
      {
        "name": "BARASTII HATEGULUI",
        "zip": "337442",
        "lat": "45.571294",
        "long": "22.943466"
      },
      {
        "name": "BARASTII ILIEI",
        "zip": "337106",
        "lat": "46.020276",
        "long": "22.72782"
      },
      {
        "name": "BARBURA",
        "zip": "337046",
        "lat": "46.005552",
        "long": "22.900435"
      },
      {
        "name": "BARCEA MARE",
        "zip": "335901",
        "lat": "45.82806",
        "long": "22.959958"
      },
      {
        "name": "BARCEA MICA",
        "zip": "330002",
        "lat": "45.821718",
        "long": "22.955136"
      },
      {
        "name": "BARSAU",
        "zip": "337267",
        "lat": "45.927815",
        "long": "22.958529"
      },
      {
        "name": "BARU",
        "zip": "337035",
        "lat": "45.470393",
        "long": "23.165874"
      },
      {
        "name": "BARZA",
        "zip": "337201",
        "lat": "46.107205",
        "long": "22.846292"
      },
      {
        "name": "BASARABASA",
        "zip": "337501",
        "lat": "46.192974",
        "long": "22.587542"
      },
      {
        "name": "BASTEA",
        "zip": "337281",
        "lat": "45.877688",
        "long": "22.411566"
      },
      {
        "name": "BATALAR",
        "zip": "337116",
        "lat": "45.698089",
        "long": "23.017987"
      },
      {
        "name": "BATIZ",
        "zip": "335301",
        "lat": "45.778469",
        "long": "23.000701"
      },
      {
        "name": "BATRANA",
        "zip": "337070",
        "lat": "45.791691",
        "long": "22.585493"
      },
      {
        "name": "BEJAN",
        "zip": "337452",
        "lat": "45.938496",
        "long": "22.852113"
      },
      {
        "name": "BEJAN-TARNAVITA",
        "zip": "337453",
        "lat": "45.930982",
        "long": "22.836738"
      },
      {
        "name": "BERCU",
        "zip": "337117",
        "lat": "45.606802",
        "long": "23.021448"
      },
      {
        "name": "BERIU",
        "zip": "337075",
        "lat": "45.790253",
        "long": "23.191047"
      },
      {
        "name": "BIRTIN",
        "zip": "337502",
        "lat": "46.173327",
        "long": "22.640282"
      },
      {
        "name": "BLAJENI",
        "zip": "337085",
        "lat": "46.211826",
        "long": "22.906111"
      },
      {
        "name": "BLAJENI-VULCAN",
        "zip": "337086",
        "lat": "46.24015",
        "long": "22.939361"
      },
      {
        "name": "BOBAIA",
        "zip": "337097",
        "lat": "45.679342",
        "long": "23.114694"
      },
      {
        "name": "BOBALNA",
        "zip": "337366",
        "lat": "45.875656",
        "long": "23.130255"
      },
      {
        "name": "BOCSA MARE",
        "zip": "337191",
        "lat": "45.998827",
        "long": "23.017893"
      },
      {
        "name": "BOCSA MICA",
        "zip": "337192",
        "lat": "45.983981",
        "long": "23.012303"
      },
      {
        "name": "BOHOLT",
        "zip": "337454",
        "lat": "45.948619",
        "long": "22.923006"
      },
      {
        "name": "BOIA BARZII",
        "zip": "337526",
        "lat": "45.84694",
        "long": "22.699587"
      },
      {
        "name": "BOITA",
        "zip": "337371",
        "lat": "45.609638",
        "long": "22.819106"
      },
      {
        "name": "BOIU",
        "zip": "337367",
        "lat": "45.898035",
        "long": "23.147794"
      },
      {
        "name": "BOIU DE JOS",
        "zip": "337246",
        "lat": "46.005543",
        "long": "22.59784"
      },
      {
        "name": "BOIU DE SUS",
        "zip": "337247",
        "lat": "46.020964",
        "long": "22.587324"
      },
      {
        "name": "BOS",
        "zip": "331001",
        "lat": "45.752016",
        "long": "22.837415"
      },
      {
        "name": "BOSOROD",
        "zip": "337095",
        "lat": "45.683702",
        "long": "23.090991"
      },
      {
        "name": "BOZ",
        "zip": "337107",
        "lat": "45.94758",
        "long": "22.754983"
      },
      {
        "name": "BOZES",
        "zip": "335403",
        "lat": "45.97227",
        "long": "23.171801"
      },
      {
        "name": "BRAD",
        "zip": "335200",
        "lat": "46.130308",
        "long": "22.79212"
      },
      {
        "name": "BRADATEL",
        "zip": "337166",
        "lat": "45.984587",
        "long": "22.531809"
      },
      {
        "name": "BRANISCA",
        "zip": "337105",
        "lat": "45.915537",
        "long": "22.78007"
      },
      {
        "name": "BRASEU",
        "zip": "337553",
        "lat": "46.077816",
        "long": "22.582799"
      },
      {
        "name": "BRAZI",
        "zip": "337381",
        "lat": "45.484118",
        "long": "22.834184"
      },
      {
        "name": "BRAZNIC",
        "zip": "337272",
        "lat": "45.919706",
        "long": "22.653217"
      },
      {
        "name": "BREAZOVA",
        "zip": "337416",
        "lat": "45.528904",
        "long": "22.79289"
      },
      {
        "name": "BRETEA MURESANA",
        "zip": "337273",
        "lat": "45.937633",
        "long": "22.710494"
      },
      {
        "name": "BRETEA ROMANA",
        "zip": "337115",
        "lat": "45.660527",
        "long": "23.016347"
      },
      {
        "name": "BRETEA STREIULUI",
        "zip": "337118",
        "lat": "45.657346",
        "long": "22.999491"
      },
      {
        "name": "BRETELIN",
        "zip": "337527",
        "lat": "45.880247",
        "long": "22.817789"
      },
      {
        "name": "BROTUNA",
        "zip": "337503",
        "lat": "46.198517",
        "long": "22.603906"
      },
      {
        "name": "BUCES",
        "zip": "337135",
        "lat": "46.187687",
        "long": "22.943302"
      },
      {
        "name": "BUCES-VULCAN",
        "zip": "337136",
        "lat": "46.223329",
        "long": "22.967064"
      },
      {
        "name": "BUCIUM",
        "zip": "337326",
        "lat": "45.741025",
        "long": "23.182952"
      },
      {
        "name": "BUCIUM-ORLEA",
        "zip": "337443",
        "lat": "45.601421",
        "long": "23.008324"
      },
      {
        "name": "BUCURESCI",
        "zip": "337145",
        "lat": "46.128152",
        "long": "22.903174"
      },
      {
        "name": "BUJORU",
        "zip": "337217",
        "lat": "45.874698",
        "long": "22.61544"
      },
      {
        "name": "BULZESTII DE JOS",
        "zip": "337151",
        "lat": "46.268248",
        "long": "22.742207"
      },
      {
        "name": "BULZESTII DE SUS",
        "zip": "337150",
        "lat": "46.30116",
        "long": "22.762255"
      },
      {
        "name": "BUNESTI",
        "zip": "337018",
        "lat": "46.069765",
        "long": "23.02843"
      },
      {
        "name": "BUNILA",
        "zip": "337160",
        "lat": "45.693983",
        "long": "22.672826"
      },
      {
        "name": "BURJUC",
        "zip": "337165",
        "lat": "45.952238",
        "long": "22.486663"
      },
      {
        "name": "CABESTI",
        "zip": "337108",
        "lat": "45.997863",
        "long": "22.763525"
      },
      {
        "name": "CAINELU DE JOS",
        "zip": "337456",
        "lat": "45.950163",
        "long": "22.831588"
      },
      {
        "name": "CAINELU DE SUS",
        "zip": "337047",
        "lat": "46.048126",
        "long": "22.890757"
      },
      {
        "name": "CALAN",
        "zip": "335300",
        "lat": "45.734831",
        "long": "22.997225"
      },
      {
        "name": "CALANU MIC",
        "zip": "335302",
        "lat": "45.758595",
        "long": "22.998184"
      },
      {
        "name": "CAMPU LUI NEAG",
        "zip": "336101",
        "lat": "45.303876",
        "long": "23.036812"
      },
      {
        "name": "CAMPURI DE SUS",
        "zip": "337249",
        "lat": "45.956474",
        "long": "22.553248"
      },
      {
        "name": "CAMPURI-SURDUC",
        "zip": "337251",
        "lat": "45.93961",
        "long": "22.553559"
      },
      {
        "name": "CAOI",
        "zip": "337528",
        "lat": "45.866278",
        "long": "22.798505"
      },
      {
        "name": "CARACI",
        "zip": "337007",
        "lat": "46.150634",
        "long": "22.689149"
      },
      {
        "name": "CARASTAU",
        "zip": "337008",
        "lat": "46.175005",
        "long": "22.659491"
      },
      {
        "name": "CARJITI",
        "zip": "337175",
        "lat": "45.844377",
        "long": "22.827038"
      },
      {
        "name": "CARMAZANESTI",
        "zip": "337248",
        "lat": "46.017012",
        "long": "22.615666"
      },
      {
        "name": "CARNESTI",
        "zip": "337491",
        "lat": "45.548284",
        "long": "22.866039"
      },
      {
        "name": "CARPINIS",
        "zip": "335902",
        "lat": "45.882076",
        "long": "23.03338"
      },
      {
        "name": "CASTAU",
        "zip": "337076",
        "lat": "45.814653",
        "long": "23.211728"
      },
      {
        "name": "CAZANESTI",
        "zip": "337504",
        "lat": "46.144638",
        "long": "22.509784"
      },
      {
        "name": "CERBAL",
        "zip": "337180",
        "lat": "45.781222",
        "long": "22.715474"
      },
      {
        "name": "CERBIA",
        "zip": "337554",
        "lat": "46.042905",
        "long": "22.449305"
      },
      {
        "name": "CERISOR",
        "zip": "337296",
        "lat": "45.743586",
        "long": "22.754746"
      },
      {
        "name": "CERNISOARA FLORESE",
        "zip": "337162",
        "lat": "45.679765",
        "long": "22.674897"
      },
      {
        "name": "CERTEJU DE JOS",
        "zip": "337541",
        "lat": "46.014231",
        "long": "22.654374"
      },
      {
        "name": "CERTEJU DE SUS",
        "zip": "337190",
        "lat": "45.97422",
        "long": "22.970702"
      },
      {
        "name": "CHERGHES",
        "zip": "337177",
        "lat": "45.844667",
        "long": "22.79378"
      },
      {
        "name": "CHIMINDIA",
        "zip": "337268",
        "lat": "45.892553",
        "long": "22.993344"
      },
      {
        "name": "CHISCADAGA",
        "zip": "337457",
        "lat": "45.956532",
        "long": "22.879335"
      },
      {
        "name": "CHITID",
        "zip": "337098",
        "lat": "45.705168",
        "long": "23.066111"
      },
      {
        "name": "CIGMAU",
        "zip": "335404",
        "lat": "45.896652",
        "long": "23.166763"
      },
      {
        "name": "CIMPA",
        "zip": "335801",
        "lat": "45.45819",
        "long": "23.443095"
      },
      {
        "name": "CINCIS-CERNA",
        "zip": "337466",
        "lat": "45.701185",
        "long": "22.890238"
      },
      {
        "name": "CIOCLOVINA",
        "zip": "337099",
        "lat": "45.586736",
        "long": "23.136935"
      },
      {
        "name": "CIOPEIA",
        "zip": "337444",
        "lat": "45.561638",
        "long": "22.975223"
      },
      {
        "name": "CIULA MARE",
        "zip": "337372",
        "lat": "45.594419",
        "long": "22.815372"
      },
      {
        "name": "CIULA MICA",
        "zip": "337373",
        "lat": "45.599587",
        "long": "22.782912"
      },
      {
        "name": "CIULPAZ",
        "zip": "337337",
        "lat": "45.795425",
        "long": "22.777741"
      },
      {
        "name": "CIUMITA",
        "zip": "337301",
        "lat": "45.663824",
        "long": "22.57902"
      },
      {
        "name": "CIUNGANI",
        "zip": "337506",
        "lat": "46.18281",
        "long": "22.502584"
      },
      {
        "name": "CIUNGU MARE",
        "zip": "337411",
        "lat": "45.758578",
        "long": "23.342251"
      },
      {
        "name": "CLOPOTIVA",
        "zip": "337382",
        "lat": "45.495737",
        "long": "22.821898"
      },
      {
        "name": "COAJA",
        "zip": "337542",
        "lat": "45.998052",
        "long": "22.649196"
      },
      {
        "name": "COPACI",
        "zip": "337492",
        "lat": "45.591728",
        "long": "22.902568"
      },
      {
        "name": "COROIESTI",
        "zip": "337421",
        "lat": "45.481876",
        "long": "23.000001"
      },
      {
        "name": "COSESTI",
        "zip": "337282",
        "lat": "45.891979",
        "long": "22.418794"
      },
      {
        "name": "COSTESTI",
        "zip": "337327",
        "lat": "45.701116",
        "long": "23.163888"
      },
      {
        "name": "COSTESTI-DEAL",
        "zip": "337328",
        "lat": "45.68706",
        "long": "23.182336"
      },
      {
        "name": "COVRAGIU",
        "zip": "337119",
        "lat": "45.623261",
        "long": "23.018145"
      },
      {
        "name": "COZIA",
        "zip": "337178",
        "lat": "45.867836",
        "long": "22.84137"
      },
      {
        "name": "CRACIUNESTI",
        "zip": "337048",
        "lat": "46.014509",
        "long": "22.870384"
      },
      {
        "name": "CRAGUIS",
        "zip": "337236",
        "lat": "45.626301",
        "long": "22.898575"
      },
      {
        "name": "CRIS",
        "zip": "337087",
        "lat": "46.250578",
        "long": "22.900064"
      },
      {
        "name": "CRISAN",
        "zip": "337401",
        "lat": "46.17068",
        "long": "22.798363"
      },
      {
        "name": "CRISCIOR",
        "zip": "337200",
        "lat": "46.122476",
        "long": "22.860995"
      },
      {
        "name": "CRISTUR",
        "zip": "330003",
        "lat": "45.82572",
        "long": "22.943124"
      },
      {
        "name": "CRIVA",
        "zip": "337206",
        "lat": "45.566529",
        "long": "22.718523"
      },
      {
        "name": "CRIVADIA",
        "zip": "337066",
        "lat": "45.465533",
        "long": "23.20468"
      },
      {
        "name": "CUCUIS",
        "zip": "337077",
        "lat": "45.772855",
        "long": "23.270607"
      },
      {
        "name": "CUIES",
        "zip": "337274",
        "lat": "45.95808",
        "long": "22.64019"
      },
      {
        "name": "CURECHIU",
        "zip": "337146",
        "lat": "46.097822",
        "long": "22.96958"
      },
      {
        "name": "CURPENII SILVASULUI",
        "zip": "337481",
        "lat": "45.654977",
        "long": "22.821322"
      },
      {
        "name": "CUTIN",
        "zip": "337338",
        "lat": "45.809598",
        "long": "22.766442"
      },
      {
        "name": "DABACA",
        "zip": "337482",
        "lat": "45.653907",
        "long": "22.753669"
      },
      {
        "name": "DALJA MARE",
        "zip": "332001",
        "lat": "45.41393",
        "long": "23.34004"
      },
      {
        "name": "DALJA MICA",
        "zip": "332002",
        "lat": "45.40468",
        "long": "23.357919"
      },
      {
        "name": "DANCU MARE",
        "zip": "337316",
        "lat": "45.759238",
        "long": "23.115187"
      },
      {
        "name": "DANCU MIC",
        "zip": "337317",
        "lat": "45.778859",
        "long": "23.141064"
      },
      {
        "name": "DANULESTI",
        "zip": "337252",
        "lat": "46.05365",
        "long": "22.59568"
      },
      {
        "name": "DEALU BABII",
        "zip": "336201",
        "lat": "45.416347",
        "long": "23.247483"
      },
      {
        "name": "DEALU MARE",
        "zip": "337521",
        "lat": "46.04171",
        "long": "22.795902"
      },
      {
        "name": "DEALU MIC",
        "zip": "337483",
        "lat": "45.684537",
        "long": "22.819826"
      },
      {
        "name": "DELENI",
        "zip": "337556",
        "lat": "46.091855",
        "long": "22.568243"
      },
      {
        "name": "DENSUS",
        "zip": "337205",
        "lat": "45.580215",
        "long": "22.790964"
      },
      {
        "name": "DEVA",
        "zip": "330005",
        "lat": "45.882009",
        "long": "22.90441"
      },
      {
        "name": "DOBRA",
        "zip": "337215",
        "lat": "45.912844",
        "long": "22.569607"
      },
      {
        "name": "DOBROT",
        "zip": "337471",
        "lat": "46.246666",
        "long": "22.680114"
      },
      {
        "name": "DRAGU-BRAD",
        "zip": "337088",
        "lat": "46.300785",
        "long": "22.865282"
      },
      {
        "name": "DUDESTI",
        "zip": "337311",
        "lat": "46.053479",
        "long": "22.808374"
      },
      {
        "name": "DUMBRAVA",
        "zip": "337339",
        "lat": "45.801968",
        "long": "22.783081"
      },
      {
        "name": "DUMBRAVA DE JOS",
        "zip": "337402",
        "lat": "46.225586",
        "long": "22.822721"
      },
      {
        "name": "DUMBRAVA DE SUS",
        "zip": "337403",
        "lat": "46.245247",
        "long": "22.848041"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "337276",
        "lat": "45.886929",
        "long": "22.701523"
      },
      {
        "name": "DUMESTI",
        "zip": "337543",
        "lat": "46.016331",
        "long": "22.708396"
      },
      {
        "name": "DUPAPIATRA",
        "zip": "337137",
        "lat": "46.18731",
        "long": "23.023061"
      },
      {
        "name": "FAGETEL",
        "zip": "337218",
        "lat": "45.879148",
        "long": "22.590211"
      },
      {
        "name": "FANTANA",
        "zip": "337302",
        "lat": "45.655518",
        "long": "22.606699"
      },
      {
        "name": "FARCADIN",
        "zip": "337237",
        "lat": "45.609113",
        "long": "22.87374"
      },
      {
        "name": "FATA ROSIE",
        "zip": "337071",
        "lat": "45.817611",
        "long": "22.607012"
      },
      {
        "name": "FEDERI",
        "zip": "337347",
        "lat": "45.534629",
        "long": "23.14203"
      },
      {
        "name": "FEREGI",
        "zip": "337182",
        "lat": "45.791711",
        "long": "22.649339"
      },
      {
        "name": "FINTOAG",
        "zip": "337283",
        "lat": "45.910809",
        "long": "22.43434"
      },
      {
        "name": "FIZES",
        "zip": "337049",
        "lat": "45.995573",
        "long": "22.878352"
      },
      {
        "name": "FIZESTI",
        "zip": "337348",
        "lat": "45.536984",
        "long": "23.076867"
      },
      {
        "name": "FOLT",
        "zip": "337368",
        "lat": "45.876256",
        "long": "23.156046"
      },
      {
        "name": "FORNADIA",
        "zip": "337458",
        "lat": "45.965968",
        "long": "22.841256"
      },
      {
        "name": "FURCSOARA",
        "zip": "337109",
        "lat": "46.014481",
        "long": "22.757389"
      },
      {
        "name": "GALATI",
        "zip": "337349",
        "lat": "45.522646",
        "long": "23.065062"
      },
      {
        "name": "GALBINA",
        "zip": "337019",
        "lat": "46.027143",
        "long": "23.070432"
      },
      {
        "name": "GANTAGA",
        "zip": "337121",
        "lat": "45.632767",
        "long": "23.03474"
      },
      {
        "name": "GELMAR",
        "zip": "335405",
        "lat": "45.902266",
        "long": "23.223181"
      },
      {
        "name": "GENERAL BERTHELOT",
        "zip": "337235",
        "lat": "45.613548",
        "long": "22.887771"
      },
      {
        "name": "GEOAGIU",
        "zip": "335400",
        "lat": "45.920737",
        "long": "23.199754"
      },
      {
        "name": "GEOAGIU-BAI",
        "zip": "335450",
        "lat": "45.937499",
        "long": "23.164015"
      },
      {
        "name": "GHELARI",
        "zip": "337240",
        "lat": "45.708347",
        "long": "22.782365"
      },
      {
        "name": "GIALACUTA",
        "zip": "337111",
        "lat": "46.002117",
        "long": "22.784115"
      },
      {
        "name": "GIURGESTI",
        "zip": "337152",
        "lat": "46.316058",
        "long": "22.752725"
      },
      {
        "name": "GLODGHILESTI",
        "zip": "337167",
        "lat": "45.978481",
        "long": "22.476686"
      },
      {
        "name": "GODINESTI",
        "zip": "337557",
        "lat": "46.024437",
        "long": "22.536274"
      },
      {
        "name": "GOLES",
        "zip": "337484",
        "lat": "45.676256",
        "long": "22.757131"
      },
      {
        "name": "GOTESTI",
        "zip": "337374",
        "lat": "45.610579",
        "long": "22.674394"
      },
      {
        "name": "GOTHATEA",
        "zip": "337253",
        "lat": "45.944548",
        "long": "22.607072"
      },
      {
        "name": "GOVAJDIA",
        "zip": "337241",
        "lat": "45.739997",
        "long": "22.795125"
      },
      {
        "name": "GRADISTEA DE MUNTE",
        "zip": "337329",
        "lat": "45.633041",
        "long": "23.215236"
      },
      {
        "name": "GRID",
        "zip": "335303",
        "lat": "45.733446",
        "long": "23.101259"
      },
      {
        "name": "GRIND",
        "zip": "337284",
        "lat": "45.912868",
        "long": "22.502265"
      },
      {
        "name": "GROHOT",
        "zip": "337153",
        "lat": "46.244025",
        "long": "22.768398"
      },
      {
        "name": "GROHOTELE",
        "zip": "337138",
        "lat": "46.204982",
        "long": "22.986691"
      },
      {
        "name": "GROS",
        "zip": "331002",
        "lat": "45.774098",
        "long": "22.806273"
      },
      {
        "name": "GROSURI",
        "zip": "337089",
        "lat": "46.294594",
        "long": "22.933114"
      },
      {
        "name": "GURA BORDULUI",
        "zip": "337303",
        "lat": "45.636048",
        "long": "22.522444"
      },
      {
        "name": "GURASADA",
        "zip": "337245",
        "lat": "45.951194",
        "long": "22.589513"
      },
      {
        "name": "HARAU",
        "zip": "337265",
        "lat": "45.900755",
        "long": "22.958807"
      },
      {
        "name": "HARTAGANI",
        "zip": "337051",
        "lat": "46.047698",
        "long": "22.928389"
      },
      {
        "name": "HASDAT",
        "zip": "331003",
        "lat": "45.734456",
        "long": "22.921769"
      },
      {
        "name": "HASDAU",
        "zip": "337486",
        "lat": "45.656325",
        "long": "22.715752"
      },
      {
        "name": "HATAGEL",
        "zip": "337207",
        "lat": "45.575942",
        "long": "22.836835"
      },
      {
        "name": "HATEG",
        "zip": "335500",
        "lat": "45.609725",
        "long": "22.948699"
      },
      {
        "name": "HEREPEIA",
        "zip": "337529",
        "lat": "45.897964",
        "long": "22.817434"
      },
      {
        "name": "HOBITA",
        "zip": "337351",
        "lat": "45.470921",
        "long": "23.080461"
      },
      {
        "name": "HOBITA-GRADISTE",
        "zip": "337417",
        "lat": "45.49679",
        "long": "22.78776"
      },
      {
        "name": "HOLDEA",
        "zip": "337286",
        "lat": "45.891404",
        "long": "22.389306"
      },
      {
        "name": "HOMOROD",
        "zip": "335406",
        "lat": "45.940172",
        "long": "23.247275"
      },
      {
        "name": "HONDOL",
        "zip": "337193",
        "lat": "45.986747",
        "long": "22.986259"
      },
      {
        "name": "HUNEDOARA",
        "zip": "331006",
        "lat": "45.757516",
        "long": "22.907766"
      },
      {
        "name": "ILIA",
        "zip": "337270",
        "lat": "45.934358",
        "long": "22.649895"
      },
      {
        "name": "ISCRONI",
        "zip": "335101",
        "lat": "45.377033",
        "long": "23.335948"
      },
      {
        "name": "IZVOARELE",
        "zip": "337467",
        "lat": "45.667964",
        "long": "22.857843"
      },
      {
        "name": "JELEDINTI",
        "zip": "337318",
        "lat": "45.8037",
        "long": "23.075139"
      },
      {
        "name": "JIET",
        "zip": "335802",
        "lat": "45.427017",
        "long": "23.428375"
      },
      {
        "name": "JIU-PAROSENI",
        "zip": "336250",
        "lat": "45.361131",
        "long": "23.259973"
      },
      {
        "name": "JOSANI",
        "zip": "337341",
        "lat": "45.80037",
        "long": "22.855234"
      },
      {
        "name": "LAPUGIU DE JOS",
        "zip": "337280",
        "lat": "45.886026",
        "long": "22.481125"
      },
      {
        "name": "LAPUGIU DE SUS",
        "zip": "337287",
        "lat": "45.844324",
        "long": "22.480625"
      },
      {
        "name": "LAPUSNIC",
        "zip": "337219",
        "lat": "45.911721",
        "long": "22.618703"
      },
      {
        "name": "LASAU",
        "zip": "337288",
        "lat": "45.921166",
        "long": "22.492234"
      },
      {
        "name": "LEAUT",
        "zip": "337472",
        "lat": "46.231929",
        "long": "22.689008"
      },
      {
        "name": "LELESE",
        "zip": "337295",
        "lat": "45.732585",
        "long": "22.697306"
      },
      {
        "name": "LESNIC",
        "zip": "337531",
        "lat": "45.913645",
        "long": "22.74178"
      },
      {
        "name": "LIVADA",
        "zip": "337473",
        "lat": "46.219679",
        "long": "22.631538"
      },
      {
        "name": "LIVADIA",
        "zip": "337036",
        "lat": "45.489872",
        "long": "23.129114"
      },
      {
        "name": "LIVEZI",
        "zip": "337238",
        "lat": "45.614173",
        "long": "22.868046"
      },
      {
        "name": "LUDESTII DE JOS",
        "zip": "337331",
        "lat": "45.71787",
        "long": "23.170478"
      },
      {
        "name": "LUDESTII DE SUS",
        "zip": "337332",
        "lat": "45.698461",
        "long": "23.221725"
      },
      {
        "name": "LUNCA",
        "zip": "337009",
        "lat": "46.169277",
        "long": "22.67673"
      },
      {
        "name": "LUNCA",
        "zip": "337052",
        "lat": "45.976641",
        "long": "22.8714"
      },
      {
        "name": "LUNCA CERNII DE JOS",
        "zip": "337300",
        "lat": "45.63741",
        "long": "22.610117"
      },
      {
        "name": "LUNCA CERNII DE SUS",
        "zip": "337304",
        "lat": "45.639409",
        "long": "22.584387"
      },
      {
        "name": "LUNCANI",
        "zip": "337101",
        "lat": "45.620046",
        "long": "23.120985"
      },
      {
        "name": "LUNCOIU DE JOS",
        "zip": "337310",
        "lat": "46.088472",
        "long": "22.78246"
      },
      {
        "name": "LUNCOIU DE SUS",
        "zip": "337312",
        "lat": "46.075833",
        "long": "22.811929"
      },
      {
        "name": "LUNCSOARA",
        "zip": "337544",
        "lat": "46.066162",
        "long": "22.707966"
      },
      {
        "name": "LUPENI",
        "zip": "335600",
        "lat": "45.354033",
        "long": "23.210319"
      },
      {
        "name": "MACEU",
        "zip": "337122",
        "lat": "45.670067",
        "long": "22.979665"
      },
      {
        "name": "MADA",
        "zip": "337021",
        "lat": "45.989513",
        "long": "23.139294"
      },
      {
        "name": "MAGURA",
        "zip": "337319",
        "lat": "45.778789",
        "long": "23.076838"
      },
      {
        "name": "MAGURA-TOPLITA",
        "zip": "337194",
        "lat": "45.979507",
        "long": "22.938614"
      },
      {
        "name": "MAGURENI",
        "zip": "337078",
        "lat": "45.68135",
        "long": "23.31697"
      },
      {
        "name": "MALAIESTI",
        "zip": "337422",
        "lat": "45.486668",
        "long": "22.944834"
      },
      {
        "name": "MANERAU",
        "zip": "337342",
        "lat": "45.788599",
        "long": "22.883227"
      },
      {
        "name": "MARTINESTI",
        "zip": "337315",
        "lat": "45.813052",
        "long": "23.126457"
      },
      {
        "name": "MERIA",
        "zip": "337306",
        "lat": "45.660706",
        "long": "22.633699"
      },
      {
        "name": "MERISOR",
        "zip": "337067",
        "lat": "45.456586",
        "long": "23.226203"
      },
      {
        "name": "MERISOR",
        "zip": "337147",
        "lat": "46.141686",
        "long": "22.930662"
      },
      {
        "name": "MERISORU DE MUNTE",
        "zip": "337183",
        "lat": "45.818474",
        "long": "22.667483"
      },
      {
        "name": "MERMEZEU-VALENI",
        "zip": "335407",
        "lat": "45.992651",
        "long": "23.20268"
      },
      {
        "name": "MESTEACAN",
        "zip": "335201",
        "lat": "46.148852",
        "long": "22.769381"
      },
      {
        "name": "MESTEACAN",
        "zip": "337376",
        "lat": "45.634087",
        "long": "22.738178"
      },
      {
        "name": "MICANESTI",
        "zip": "337558",
        "lat": "46.066939",
        "long": "22.478151"
      },
      {
        "name": "MIHAIESTI",
        "zip": "337221",
        "lat": "45.876436",
        "long": "22.561828"
      },
      {
        "name": "MIHAILENI",
        "zip": "337139",
        "lat": "46.184598",
        "long": "22.896613"
      },
      {
        "name": "MINTIA",
        "zip": "337532",
        "lat": "45.92336",
        "long": "22.848289"
      },
      {
        "name": "MOSORU",
        "zip": "337487",
        "lat": "45.652707",
        "long": "22.801385"
      },
      {
        "name": "MUNCELU MARE",
        "zip": "337533",
        "lat": "45.826454",
        "long": "22.684743"
      },
      {
        "name": "MUNCELU MIC",
        "zip": "337534",
        "lat": "45.847177",
        "long": "22.732109"
      },
      {
        "name": "NADASTIA DE JOS",
        "zip": "335304",
        "lat": "45.72073",
        "long": "22.959152"
      },
      {
        "name": "NADASTIA DE SUS",
        "zip": "335305",
        "lat": "45.711768",
        "long": "22.935613"
      },
      {
        "name": "NALATVAD",
        "zip": "335501",
        "lat": "45.591494",
        "long": "22.930496"
      },
      {
        "name": "NANDRU",
        "zip": "337343",
        "lat": "45.804792",
        "long": "22.821103"
      },
      {
        "name": "NEGOIU",
        "zip": "337307",
        "lat": "45.610869",
        "long": "22.563454"
      },
      {
        "name": "NOJAG",
        "zip": "337196",
        "lat": "45.95461",
        "long": "22.988479"
      },
      {
        "name": "NUCSOARA",
        "zip": "337423",
        "lat": "45.482502",
        "long": "22.919973"
      },
      {
        "name": "OBARSA",
        "zip": "337474",
        "lat": "46.254686",
        "long": "22.668855"
      },
      {
        "name": "OCISOR",
        "zip": "337507",
        "lat": "46.223739",
        "long": "22.560806"
      },
      {
        "name": "OCIU",
        "zip": "337508",
        "lat": "46.210773",
        "long": "22.572866"
      },
      {
        "name": "OCOLISU MARE",
        "zip": "337123",
        "lat": "45.690116",
        "long": "22.944279"
      },
      {
        "name": "OCOLISU MIC",
        "zip": "337333",
        "lat": "45.711293",
        "long": "23.128263"
      },
      {
        "name": "OHABA",
        "zip": "337289",
        "lat": "45.887628",
        "long": "22.451831"
      },
      {
        "name": "OHABA DE SUB PIATRA",
        "zip": "337424",
        "lat": "45.545835",
        "long": "22.989527"
      },
      {
        "name": "OHABA STREIULUI",
        "zip": "335306",
        "lat": "45.718831",
        "long": "23.03601"
      },
      {
        "name": "OHABA-PONOR",
        "zip": "337352",
        "lat": "45.519584",
        "long": "23.136861"
      },
      {
        "name": "OHABA-SIBISEL",
        "zip": "337383",
        "lat": "45.49501",
        "long": "22.902905"
      },
      {
        "name": "OPRISESTI",
        "zip": "337022",
        "lat": "46.088143",
        "long": "23.016592"
      },
      {
        "name": "ORASTIE",
        "zip": "335700",
        "lat": "45.836764",
        "long": "23.195845"
      },
      {
        "name": "ORASTIOARA DE JOS",
        "zip": "337079",
        "lat": "45.760483",
        "long": "23.182707"
      },
      {
        "name": "ORASTIOARA DE SUS",
        "zip": "337325",
        "lat": "45.733491",
        "long": "23.170657"
      },
      {
        "name": "ORMINDEA",
        "zip": "337053",
        "lat": "46.056042",
        "long": "22.853165"
      },
      {
        "name": "OSTROV",
        "zip": "337384",
        "lat": "45.526855",
        "long": "22.846848"
      },
      {
        "name": "OSTROVEL",
        "zip": "337386",
        "lat": "45.504878",
        "long": "22.854692"
      },
      {
        "name": "OSTROVU MIC",
        "zip": "337387",
        "lat": "45.515641",
        "long": "22.842194"
      },
      {
        "name": "PACLISA",
        "zip": "337493",
        "lat": "45.564744",
        "long": "22.878578"
      },
      {
        "name": "PANC",
        "zip": "337222",
        "lat": "45.856862",
        "long": "22.521905"
      },
      {
        "name": "PANC-SALISTE",
        "zip": "337223",
        "lat": "45.865264",
        "long": "22.520168"
      },
      {
        "name": "PAROS",
        "zip": "337426",
        "lat": "45.495601",
        "long": "22.970048"
      },
      {
        "name": "PAUCINESTI",
        "zip": "337418",
        "lat": "45.506385",
        "long": "22.75485"
      },
      {
        "name": "PAULESTI",
        "zip": "337154",
        "lat": "46.298993",
        "long": "22.770151"
      },
      {
        "name": "PAULIS",
        "zip": "337459",
        "lat": "45.941997",
        "long": "22.864282"
      },
      {
        "name": "PESTEANA",
        "zip": "337208",
        "lat": "45.550105",
        "long": "22.822717"
      },
      {
        "name": "PESTENITA",
        "zip": "337209",
        "lat": "45.553098",
        "long": "22.805883"
      },
      {
        "name": "PESTERA",
        "zip": "332003",
        "lat": "45.449904",
        "long": "23.317796"
      },
      {
        "name": "PESTERA",
        "zip": "337054",
        "lat": "46.031866",
        "long": "22.854728"
      },
      {
        "name": "PESTERA",
        "zip": "337427",
        "lat": "45.474068",
        "long": "22.961103"
      },
      {
        "name": "PESTISU MARE",
        "zip": "331004",
        "lat": "45.803034",
        "long": "22.927029"
      },
      {
        "name": "PESTISU MIC",
        "zip": "337335",
        "lat": "45.798099",
        "long": "22.886891"
      },
      {
        "name": "PETRENI",
        "zip": "337041",
        "lat": "45.790402",
        "long": "23.020998"
      },
      {
        "name": "PETRESTI",
        "zip": "337168",
        "lat": "46.007115",
        "long": "22.524043"
      },
      {
        "name": "PETRILA",
        "zip": "335800",
        "lat": "45.443702",
        "long": "23.376505"
      },
      {
        "name": "PETROS",
        "zip": "337037",
        "lat": "45.471144",
        "long": "23.191413"
      },
      {
        "name": "PETROSANI",
        "zip": "332005",
        "lat": "45.414391",
        "long": "23.37409"
      },
      {
        "name": "PIATRA",
        "zip": "337072",
        "lat": "45.809648",
        "long": "22.586346"
      },
      {
        "name": "PISCHINTI",
        "zip": "337412",
        "lat": "45.875609",
        "long": "23.308987"
      },
      {
        "name": "PLAI",
        "zip": "337091",
        "lat": "46.230717",
        "long": "22.912505"
      },
      {
        "name": "PLOP",
        "zip": "337242",
        "lat": "45.720508",
        "long": "22.766221"
      },
      {
        "name": "PLOPI",
        "zip": "337124",
        "lat": "45.637118",
        "long": "23.002147"
      },
      {
        "name": "PODELE",
        "zip": "337313",
        "lat": "46.060126",
        "long": "22.787493"
      },
      {
        "name": "POGANESTI",
        "zip": "337559",
        "lat": "46.060012",
        "long": "22.45852"
      },
      {
        "name": "POIANA",
        "zip": "337023",
        "lat": "46.086139",
        "long": "23.053314"
      },
      {
        "name": "POIANA RACHITELII",
        "zip": "337184",
        "lat": "45.737302",
        "long": "22.568117"
      },
      {
        "name": "POIENI",
        "zip": "337081",
        "lat": "45.763362",
        "long": "23.220102"
      },
      {
        "name": "POIENI",
        "zip": "337211",
        "lat": "45.54468",
        "long": "22.723318"
      },
      {
        "name": "POIENITA",
        "zip": "337024",
        "lat": "46.095393",
        "long": "23.030925"
      },
      {
        "name": "POIENITA TOMII",
        "zip": "337186",
        "lat": "45.800431",
        "long": "22.679149"
      },
      {
        "name": "POIENITA VOINII",
        "zip": "337163",
        "lat": "45.695407",
        "long": "22.705675"
      },
      {
        "name": "POJOGA",
        "zip": "337561",
        "lat": "45.992128",
        "long": "22.400059"
      },
      {
        "name": "PONOR",
        "zip": "337353",
        "lat": "45.510506",
        "long": "23.127008"
      },
      {
        "name": "POPESTI",
        "zip": "337179",
        "lat": "45.82651",
        "long": "22.847182"
      },
      {
        "name": "POTINGANI",
        "zip": "335202",
        "lat": "46.201245",
        "long": "22.843224"
      },
      {
        "name": "PRAVALENI",
        "zip": "337509",
        "lat": "46.193895",
        "long": "22.556707"
      },
      {
        "name": "PRICAZ",
        "zip": "337496",
        "lat": "45.859053",
        "long": "23.170907"
      },
      {
        "name": "PRIHODISTE",
        "zip": "337102",
        "lat": "45.616927",
        "long": "23.201405"
      },
      {
        "name": "PRIHODISTE",
        "zip": "337511",
        "lat": "46.167452",
        "long": "22.605304"
      },
      {
        "name": "PUI",
        "zip": "337345",
        "lat": "45.51423",
        "long": "23.094297"
      },
      {
        "name": "RACASTIA",
        "zip": "331005",
        "lat": "45.767635",
        "long": "22.873611"
      },
      {
        "name": "RACHITAUA",
        "zip": "337073",
        "lat": "45.814096",
        "long": "22.567874"
      },
      {
        "name": "RACHITOVA",
        "zip": "337370",
        "lat": "45.605525",
        "long": "22.746761"
      },
      {
        "name": "RADULESTI",
        "zip": "337224",
        "lat": "45.882382",
        "long": "22.624905"
      },
      {
        "name": "RAPAS",
        "zip": "337497",
        "lat": "45.827416",
        "long": "23.063633"
      },
      {
        "name": "RAPOLTEL",
        "zip": "337369",
        "lat": "45.880433",
        "long": "23.061602"
      },
      {
        "name": "RAPOLTU MARE",
        "zip": "337365",
        "lat": "45.865542",
        "long": "23.075184"
      },
      {
        "name": "RASCOALA",
        "zip": "335803",
        "lat": "45.470466",
        "long": "23.456942"
      },
      {
        "name": "RAU ALB",
        "zip": "337428",
        "lat": "45.518143",
        "long": "23.00571"
      },
      {
        "name": "RAU BARBAT",
        "zip": "337354",
        "lat": "45.484202",
        "long": "23.090214"
      },
      {
        "name": "RAU DE MORI",
        "zip": "337380",
        "lat": "45.497511",
        "long": "22.854436"
      },
      {
        "name": "RAU MIC",
        "zip": "337429",
        "lat": "45.492363",
        "long": "23.008919"
      },
      {
        "name": "REEA",
        "zip": "337494",
        "lat": "45.580192",
        "long": "22.912616"
      },
      {
        "name": "RENGHET",
        "zip": "335408",
        "lat": "45.955653",
        "long": "23.142558"
      },
      {
        "name": "RET",
        "zip": "337092",
        "lat": "46.267329",
        "long": "22.87938"
      },
      {
        "name": "RIBICIOARA",
        "zip": "337404",
        "lat": "46.21073",
        "long": "22.776359"
      },
      {
        "name": "RIBITA",
        "zip": "337400",
        "lat": "46.182789",
        "long": "22.767522"
      },
      {
        "name": "RISCA",
        "zip": "337011",
        "lat": "46.187322",
        "long": "22.709398"
      },
      {
        "name": "RISCULITA",
        "zip": "337012",
        "lat": "46.226675",
        "long": "22.721692"
      },
      {
        "name": "ROMOS",
        "zip": "337410",
        "lat": "45.840438",
        "long": "23.275462"
      },
      {
        "name": "ROMOSEL",
        "zip": "337413",
        "lat": "45.804999",
        "long": "23.311205"
      },
      {
        "name": "ROSCANI",
        "zip": "337226",
        "lat": "45.867472",
        "long": "22.561631"
      },
      {
        "name": "ROSIA",
        "zip": "337026",
        "lat": "46.009127",
        "long": "23.070045"
      },
      {
        "name": "ROVINA",
        "zip": "337112",
        "lat": "45.925369",
        "long": "22.791644"
      },
      {
        "name": "ROVINA",
        "zip": "337148",
        "lat": "46.154589",
        "long": "22.921039"
      },
      {
        "name": "RUDA",
        "zip": "337243",
        "lat": "45.696241",
        "long": "22.747386"
      },
      {
        "name": "RUDA-BRAD",
        "zip": "335203",
        "lat": "46.099152",
        "long": "22.817154"
      },
      {
        "name": "RUNCSOR",
        "zip": "337254",
        "lat": "45.986753",
        "long": "22.573226"
      },
      {
        "name": "RUNCU MARE",
        "zip": "337297",
        "lat": "45.743182",
        "long": "22.639618"
      },
      {
        "name": "RUNCU MIC",
        "zip": "337536",
        "lat": "45.835682",
        "long": "22.729984"
      },
      {
        "name": "RUSESTI",
        "zip": "337156",
        "lat": "46.316753",
        "long": "22.770412"
      },
      {
        "name": "RUSI",
        "zip": "337126",
        "lat": "45.69532",
        "long": "22.993794"
      },
      {
        "name": "RUSOR",
        "zip": "337356",
        "lat": "45.52664",
        "long": "23.02666"
      },
      {
        "name": "SACAMAS",
        "zip": "337277",
        "lat": "45.922455",
        "long": "22.672126"
      },
      {
        "name": "SACARAMB",
        "zip": "337197",
        "lat": "45.974595",
        "long": "23.038908"
      },
      {
        "name": "SACEL",
        "zip": "337446",
        "lat": "45.558584",
        "long": "22.921591"
      },
      {
        "name": "SALASU DE JOS",
        "zip": "337431",
        "lat": "45.533319",
        "long": "22.972338"
      },
      {
        "name": "SALASU DE SUS",
        "zip": "337420",
        "lat": "45.509397",
        "long": "22.953576"
      },
      {
        "name": "SALATRUC",
        "zip": "337093",
        "lat": "46.238401",
        "long": "22.880008"
      },
      {
        "name": "SALCIVA",
        "zip": "337562",
        "lat": "45.994493",
        "long": "22.413176"
      },
      {
        "name": "SALISTE",
        "zip": "337056",
        "lat": "46.034725",
        "long": "22.918314"
      },
      {
        "name": "SALISTIOARA",
        "zip": "337522",
        "lat": "46.005801",
        "long": "22.824871"
      },
      {
        "name": "SANCRAI",
        "zip": "335307",
        "lat": "45.753827",
        "long": "22.978978"
      },
      {
        "name": "SANPETRU",
        "zip": "337447",
        "lat": "45.553588",
        "long": "22.914086"
      },
      {
        "name": "SANTAMARIA DE PIATRA",
        "zip": "335308",
        "lat": "45.768983",
        "long": "23.020215"
      },
      {
        "name": "SANTAMARIA-ORLEA",
        "zip": "337440",
        "lat": "45.589024",
        "long": "22.969451"
      },
      {
        "name": "SANTANDREI",
        "zip": "335903",
        "lat": "45.846617",
        "long": "22.966988"
      },
      {
        "name": "SANTUHALM",
        "zip": "330004",
        "lat": "45.856078",
        "long": "22.953898"
      },
      {
        "name": "SARBI",
        "zip": "337278",
        "lat": "45.960963",
        "long": "22.705632"
      },
      {
        "name": "SARMIZEGETUSA",
        "zip": "337415",
        "lat": "45.515257",
        "long": "22.782541"
      },
      {
        "name": "SAULESTI",
        "zip": "335905",
        "lat": "45.863975",
        "long": "22.989873"
      },
      {
        "name": "SERECA",
        "zip": "337082",
        "lat": "45.781781",
        "long": "23.18261"
      },
      {
        "name": "SEREL",
        "zip": "337357",
        "lat": "45.479844",
        "long": "23.047093"
      },
      {
        "name": "SESURI",
        "zip": "337149",
        "lat": "46.096807",
        "long": "22.926058"
      },
      {
        "name": "SIBISEL",
        "zip": "337083",
        "lat": "45.760109",
        "long": "23.246566"
      },
      {
        "name": "SIBISEL",
        "zip": "337388",
        "lat": "45.508149",
        "long": "22.90038"
      },
      {
        "name": "SILVASU DE JOS",
        "zip": "335502",
        "lat": "45.65277",
        "long": "22.925949"
      },
      {
        "name": "SILVASU DE SUS",
        "zip": "335503",
        "lat": "45.64762",
        "long": "22.882891"
      },
      {
        "name": "SIMERIA",
        "zip": "335900",
        "lat": "45.848795",
        "long": "23.012821"
      },
      {
        "name": "SIMERIA VECHE",
        "zip": "335904",
        "lat": "45.833765",
        "long": "23.05076"
      },
      {
        "name": "SLATINIOARA",
        "zip": "332004",
        "lat": "45.410504",
        "long": "23.39508"
      },
      {
        "name": "SOCET",
        "zip": "337187",
        "lat": "45.776756",
        "long": "22.668887"
      },
      {
        "name": "SOHODOL",
        "zip": "337298",
        "lat": "45.726306",
        "long": "22.666632"
      },
      {
        "name": "SOIMUS",
        "zip": "337450",
        "lat": "45.916979",
        "long": "22.889848"
      },
      {
        "name": "SPINI",
        "zip": "337498",
        "lat": "45.833559",
        "long": "23.088825"
      },
      {
        "name": "STANCESTI",
        "zip": "337227",
        "lat": "45.878424",
        "long": "22.649012"
      },
      {
        "name": "STANCESTI-OHABA",
        "zip": "337228",
        "lat": "45.876798",
        "long": "22.671246"
      },
      {
        "name": "STANCULESTI",
        "zip": "337157",
        "lat": "46.296533",
        "long": "22.740682"
      },
      {
        "name": "STANIJA",
        "zip": "337141",
        "lat": "46.173322",
        "long": "22.984749"
      },
      {
        "name": "STAUINI",
        "zip": "337027",
        "lat": "45.998291",
        "long": "23.110396"
      },
      {
        "name": "STEI",
        "zip": "337212",
        "lat": "45.57865",
        "long": "22.734952"
      },
      {
        "name": "STEIA",
        "zip": "337476",
        "lat": "46.197816",
        "long": "22.643361"
      },
      {
        "name": "STEJAREL",
        "zip": "337314",
        "lat": "46.078038",
        "long": "22.759433"
      },
      {
        "name": "STOIENEASA",
        "zip": "337523",
        "lat": "45.999857",
        "long": "22.843063"
      },
      {
        "name": "STREI",
        "zip": "335309",
        "lat": "45.714593",
        "long": "22.993631"
      },
      {
        "name": "STREI-SACEL",
        "zip": "335310",
        "lat": "45.744705",
        "long": "23.023553"
      },
      {
        "name": "STREISANGEORGIU",
        "zip": "335311",
        "lat": "45.7273",
        "long": "23.018244"
      },
      {
        "name": "STRETEA",
        "zip": "337229",
        "lat": "45.93309",
        "long": "22.583076"
      },
      {
        "name": "SUBCETATE",
        "zip": "337448",
        "lat": "45.602913",
        "long": "22.997577"
      },
      {
        "name": "SULIGHETE",
        "zip": "337461",
        "lat": "45.976785",
        "long": "22.804953"
      },
      {
        "name": "SUSENI",
        "zip": "337389",
        "lat": "45.490622",
        "long": "22.865238"
      },
      {
        "name": "TAMASASA",
        "zip": "337321",
        "lat": "45.79836",
        "long": "23.154389"
      },
      {
        "name": "TAMASESTI",
        "zip": "337563",
        "lat": "46.012906",
        "long": "22.488723"
      },
      {
        "name": "TAMPA",
        "zip": "337042",
        "lat": "45.821469",
        "long": "23.011291"
      },
      {
        "name": "TARATEL",
        "zip": "335204",
        "lat": "46.120255",
        "long": "22.830618"
      },
      {
        "name": "TARNAVA",
        "zip": "337113",
        "lat": "45.967462",
        "long": "22.780017"
      },
      {
        "name": "TARNAVA DE CRIS",
        "zip": "337513",
        "lat": "46.187846",
        "long": "22.62219"
      },
      {
        "name": "TARNAVITA",
        "zip": "337114",
        "lat": "45.949244",
        "long": "22.772151"
      },
      {
        "name": "TARNITA",
        "zip": "337142",
        "lat": "46.174773",
        "long": "23.057328"
      },
      {
        "name": "TARSA",
        "zip": "337103",
        "lat": "45.632931",
        "long": "23.157291"
      },
      {
        "name": "TATARASTI",
        "zip": "337169",
        "lat": "45.950812",
        "long": "22.511584"
      },
      {
        "name": "TATARASTII DE CRIS",
        "zip": "337512",
        "lat": "46.16408",
        "long": "22.614879"
      },
      {
        "name": "TEBEA",
        "zip": "337013",
        "lat": "46.16838",
        "long": "22.736673"
      },
      {
        "name": "TECHEREU",
        "zip": "337028",
        "lat": "46.093474",
        "long": "23.066539"
      },
      {
        "name": "TEIU",
        "zip": "337291",
        "lat": "45.895342",
        "long": "22.501922"
      },
      {
        "name": "TELIUCU INFERIOR",
        "zip": "337465",
        "lat": "45.71526",
        "long": "22.888104"
      },
      {
        "name": "TELIUCU SUPERIOR",
        "zip": "337468",
        "lat": "45.707758",
        "long": "22.875837"
      },
      {
        "name": "TICERA",
        "zip": "337158",
        "lat": "46.319426",
        "long": "22.87897"
      },
      {
        "name": "TIRICI",
        "zip": "335804",
        "lat": "45.462259",
        "long": "23.466349"
      },
      {
        "name": "TISA",
        "zip": "337171",
        "lat": "45.953956",
        "long": "22.469235"
      },
      {
        "name": "TIULESTI",
        "zip": "337477",
        "lat": "46.223451",
        "long": "22.677255"
      },
      {
        "name": "TOMESTI",
        "zip": "337470",
        "lat": "46.210473",
        "long": "22.663656"
      },
      {
        "name": "TOMNATEC",
        "zip": "337159",
        "lat": "46.286622",
        "long": "22.795805"
      },
      {
        "name": "TOPLITA",
        "zip": "337480",
        "lat": "45.687487",
        "long": "22.785663"
      },
      {
        "name": "TOPLITA MURESULUI",
        "zip": "337198",
        "lat": "45.97569",
        "long": "22.920592"
      },
      {
        "name": "TOTESTI",
        "zip": "337490",
        "lat": "45.575095",
        "long": "22.887615"
      },
      {
        "name": "TOTIA",
        "zip": "337043",
        "lat": "45.811879",
        "long": "23.049622"
      },
      {
        "name": "TRESTIA",
        "zip": "337057",
        "lat": "46.023895",
        "long": "22.933553"
      },
      {
        "name": "TURDAS",
        "zip": "337495",
        "lat": "45.85285",
        "long": "23.123528"
      },
      {
        "name": "TURMAS",
        "zip": "337322",
        "lat": "45.819465",
        "long": "23.136326"
      },
      {
        "name": "TUSTEA",
        "zip": "337239",
        "lat": "45.600311",
        "long": "22.846992"
      },
      {
        "name": "UIBARESTI",
        "zip": "337406",
        "lat": "46.206077",
        "long": "22.761609"
      },
      {
        "name": "ULIES",
        "zip": "337256",
        "lat": "45.962177",
        "long": "22.62141"
      },
      {
        "name": "ULM",
        "zip": "337188",
        "lat": "45.787578",
        "long": "22.750838"
      },
      {
        "name": "UNCIUC",
        "zip": "337391",
        "lat": "45.544449",
        "long": "22.882389"
      },
      {
        "name": "URIC",
        "zip": "337358",
        "lat": "45.462739",
        "long": "23.084439"
      },
      {
        "name": "URICANI",
        "zip": "336100",
        "lat": "45.329313",
        "long": "23.114875"
      },
      {
        "name": "UROI",
        "zip": "335906",
        "lat": "45.86201",
        "long": "23.033835"
      },
      {
        "name": "URSICI",
        "zip": "337104",
        "lat": "45.605011",
        "long": "23.090714"
      },
      {
        "name": "VADU",
        "zip": "337449",
        "lat": "45.585381",
        "long": "22.937546"
      },
      {
        "name": "VADU DOBRII",
        "zip": "337164",
        "lat": "45.693022",
        "long": "22.55168"
      },
      {
        "name": "VAIDEI",
        "zip": "337414",
        "lat": "45.86114",
        "long": "23.298575"
      },
      {
        "name": "VALARI",
        "zip": "337488",
        "lat": "45.683499",
        "long": "22.732007"
      },
      {
        "name": "VALCELE",
        "zip": "337127",
        "lat": "45.670728",
        "long": "23.053643"
      },
      {
        "name": "VALCELELE BUNE",
        "zip": "337128",
        "lat": "45.65192",
        "long": "23.054859"
      },
      {
        "name": "VALCELUTA",
        "zip": "337129",
        "lat": "45.676571",
        "long": "23.062287"
      },
      {
        "name": "VALEA",
        "zip": "337564",
        "lat": "46.072513",
        "long": "22.565895"
      },
      {
        "name": "VALEA ARSULUI",
        "zip": "337202",
        "lat": "46.093607",
        "long": "22.869994"
      },
      {
        "name": "VALEA BABII",
        "zip": "337308",
        "lat": "45.623992",
        "long": "22.572126"
      },
      {
        "name": "VALEA BRADULUI",
        "zip": "335205",
        "lat": "46.151363",
        "long": "22.828828"
      },
      {
        "name": "VALEA DALJII",
        "zip": "337392",
        "lat": "45.51491",
        "long": "22.884211"
      },
      {
        "name": "VALEA DE BRAZI",
        "zip": "336102",
        "lat": "45.317462",
        "long": "23.082101"
      },
      {
        "name": "VALEA LUNGA",
        "zip": "337279",
        "lat": "45.983319",
        "long": "22.683324"
      },
      {
        "name": "VALEA LUPULUI",
        "zip": "337038",
        "lat": "45.471856",
        "long": "23.124184"
      },
      {
        "name": "VALEA MARE DE CRIS",
        "zip": "337478",
        "lat": "46.206125",
        "long": "22.701319"
      },
      {
        "name": "VALEA NANDRULUI",
        "zip": "337344",
        "lat": "45.796972",
        "long": "22.836663"
      },
      {
        "name": "VALEA POIENII",
        "zip": "337546",
        "lat": "46.06956",
        "long": "22.638673"
      },
      {
        "name": "VALEA SANGEORGIULUI",
        "zip": "335312",
        "lat": "45.745625",
        "long": "23.06292"
      },
      {
        "name": "VALENI",
        "zip": "337014",
        "lat": "46.189596",
        "long": "22.686148"
      },
      {
        "name": "VALENI",
        "zip": "335409",
        "lat": "45.984426",
        "long": "23.219195"
      },
      {
        "name": "VALIOARA",
        "zip": "337377",
        "lat": "45.615343",
        "long": "22.792686"
      },
      {
        "name": "VALISOARA",
        "zip": "337029",
        "lat": "46.05858",
        "long": "22.996074"
      },
      {
        "name": "VALISOARA",
        "zip": "337520",
        "lat": "46.057054",
        "long": "22.825874"
      },
      {
        "name": "VARMAGA",
        "zip": "337199",
        "lat": "45.942605",
        "long": "23.012623"
      },
      {
        "name": "VATA DE JOS",
        "zip": "337500",
        "lat": "46.183333",
        "long": "22.6"
      },
      {
        "name": "VATA DE SUS",
        "zip": "337514",
        "lat": "46.171202",
        "long": "22.570601"
      },
      {
        "name": "VETEL",
        "zip": "337525",
        "lat": "45.904929",
        "long": "22.800274"
      },
      {
        "name": "VICA",
        "zip": "337257",
        "lat": "45.995159",
        "long": "22.577255"
      },
      {
        "name": "VISCA",
        "zip": "337547",
        "lat": "46.069313",
        "long": "22.668296"
      },
      {
        "name": "VOIA",
        "zip": "337031",
        "lat": "46.036877",
        "long": "23.04634"
      },
      {
        "name": "VORTA",
        "zip": "337540",
        "lat": "46.021536",
        "long": "22.672293"
      },
      {
        "name": "VULCAN",
        "zip": "336200",
        "lat": "45.374864",
        "long": "23.294087"
      },
      {
        "name": "ZAM",
        "zip": "337550",
        "lat": "46.006186",
        "long": "22.443576"
      },
      {
        "name": "ZAVOI",
        "zip": "337432",
        "lat": "45.518029",
        "long": "22.979827"
      },
      {
        "name": "ZDRAPTI",
        "zip": "337203",
        "lat": "46.155734",
        "long": "22.868812"
      },
      {
        "name": "ZEICANI",
        "zip": "337419",
        "lat": "45.500158",
        "long": "22.726422"
      }
    ],
    "IALOMIȚA": [
      {
        "name": "ADANCATA",
        "zip": "927005",
        "lat": "44.769006",
        "long": "26.43473"
      },
      {
        "name": "ALBESTI",
        "zip": "927010",
        "lat": "44.539329",
        "long": "27.133161"
      },
      {
        "name": "ALEXENI",
        "zip": "927015",
        "lat": "44.679657",
        "long": "26.710639"
      },
      {
        "name": "AMARA",
        "zip": "927020",
        "lat": "44.617354",
        "long": "27.314991"
      },
      {
        "name": "AMARA NOUA",
        "zip": "927021",
        "lat": "44.613977",
        "long": "27.342629"
      },
      {
        "name": "ANDRASESTI",
        "zip": "927025",
        "lat": "44.575626",
        "long": "27.144804"
      },
      {
        "name": "ARMASESTI",
        "zip": "927030",
        "lat": "44.750237",
        "long": "26.584401"
      },
      {
        "name": "AXINTELE",
        "zip": "927035",
        "lat": "44.612495",
        "long": "26.761414"
      },
      {
        "name": "BALACIU",
        "zip": "927040",
        "lat": "44.635586",
        "long": "26.903056"
      },
      {
        "name": "BARBATESCU",
        "zip": "927036",
        "lat": "44.610659",
        "long": "26.80018"
      },
      {
        "name": "BARBULESTI",
        "zip": "927031",
        "lat": "44.726293",
        "long": "26.599294"
      },
      {
        "name": "BARCANESTI",
        "zip": "927045",
        "lat": "44.642724",
        "long": "26.644247"
      },
      {
        "name": "BATALURI",
        "zip": "927011",
        "lat": "44.527387",
        "long": "27.149289"
      },
      {
        "name": "BITINA-PAMANTENI",
        "zip": "927181",
        "lat": "44.607563",
        "long": "26.472853"
      },
      {
        "name": "BITINA-UNGURENI",
        "zip": "927182",
        "lat": "44.605684",
        "long": "26.4812"
      },
      {
        "name": "BORA",
        "zip": "920001",
        "lat": "44.558278",
        "long": "27.393303"
      },
      {
        "name": "BORANESTI",
        "zip": "927096",
        "lat": "44.660838",
        "long": "26.607124"
      },
      {
        "name": "BORDUSANI",
        "zip": "927050",
        "lat": "44.481922",
        "long": "27.904548"
      },
      {
        "name": "BORDUSELU",
        "zip": "927076",
        "lat": "44.556605",
        "long": "27.042275"
      },
      {
        "name": "BOTENI",
        "zip": "927221",
        "lat": "44.569719",
        "long": "26.451603"
      },
      {
        "name": "BROSTENI",
        "zip": "927151",
        "lat": "44.671922",
        "long": "26.747871"
      },
      {
        "name": "BUCSA",
        "zip": "927241",
        "lat": "44.717397",
        "long": "27.52255"
      },
      {
        "name": "BUCU",
        "zip": "927060",
        "lat": "44.605175",
        "long": "27.491012"
      },
      {
        "name": "BUESTI",
        "zip": "927012",
        "lat": "44.544731",
        "long": "27.187294"
      },
      {
        "name": "BULIGA",
        "zip": "925101",
        "lat": "44.35745",
        "long": "27.792185"
      },
      {
        "name": "BUTOIU",
        "zip": "927216",
        "lat": "44.648442",
        "long": "26.839391"
      },
      {
        "name": "CATRUNESTI",
        "zip": "927222",
        "lat": "44.556839",
        "long": "26.390532"
      },
      {
        "name": "CAZANESTI",
        "zip": "927065",
        "lat": "44.624445",
        "long": "27.0132"
      },
      {
        "name": "CEGANI",
        "zip": "927051",
        "lat": "44.462792",
        "long": "27.901751"
      },
      {
        "name": "CHIROIU-PAMANTENI",
        "zip": "927101",
        "lat": "44.597611",
        "long": "26.505787"
      },
      {
        "name": "CHIROIU-SATU NOU",
        "zip": "927102",
        "lat": "44.594246",
        "long": "26.49144"
      },
      {
        "name": "CHIROIU-UNGURENI",
        "zip": "927103",
        "lat": "44.591733",
        "long": "26.495853"
      },
      {
        "name": "CIOCARLIA",
        "zip": "927070",
        "lat": "44.800069",
        "long": "26.67021"
      },
      {
        "name": "CIOCHINA",
        "zip": "927075",
        "lat": "44.597919",
        "long": "27.058692"
      },
      {
        "name": "CIULNITA",
        "zip": "927080",
        "lat": "44.536993",
        "long": "27.343506"
      },
      {
        "name": "COCORA",
        "zip": "927085",
        "lat": "44.737466",
        "long": "27.044625"
      },
      {
        "name": "COLELIA",
        "zip": "927086",
        "lat": "44.761117",
        "long": "27.006927"
      },
      {
        "name": "CONDEESTI",
        "zip": "927046",
        "lat": "44.627607",
        "long": "26.69147"
      },
      {
        "name": "COPUZU",
        "zip": "927041",
        "lat": "44.602801",
        "long": "26.899528"
      },
      {
        "name": "COSAMBESTI",
        "zip": "927090",
        "lat": "44.560259",
        "long": "27.436571"
      },
      {
        "name": "COSERENI",
        "zip": "927095",
        "lat": "44.682889",
        "long": "26.563783"
      },
      {
        "name": "COTORCA",
        "zip": "927071",
        "lat": "44.777653",
        "long": "26.659911"
      },
      {
        "name": "CRASANII DE JOS",
        "zip": "927042",
        "lat": "44.598898",
        "long": "26.875097"
      },
      {
        "name": "CRASANII DE SUS",
        "zip": "927043",
        "lat": "44.599609",
        "long": "26.848935"
      },
      {
        "name": "CRUNTI",
        "zip": "927196",
        "lat": "44.661711",
        "long": "27.110427"
      },
      {
        "name": "DRAGOESTI",
        "zip": "927100",
        "lat": "44.567859",
        "long": "26.539495"
      },
      {
        "name": "DRIDU",
        "zip": "927105",
        "lat": "44.695208",
        "long": "26.453252"
      },
      {
        "name": "DRIDU-SNAGOV",
        "zip": "927106",
        "lat": "44.712951",
        "long": "26.453141"
      },
      {
        "name": "DUMITRESTI",
        "zip": "927242",
        "lat": "44.715796",
        "long": "27.505928"
      },
      {
        "name": "FACAENI",
        "zip": "927110",
        "lat": "44.560138",
        "long": "27.894852"
      },
      {
        "name": "FETESTI",
        "zip": "925100",
        "lat": "44.370285",
        "long": "27.836798"
      },
      {
        "name": "FETESTI-GARA",
        "zip": "925150",
        "lat": "44.417089",
        "long": "27.824307"
      },
      {
        "name": "FIERBINTI-TARG",
        "zip": "927115",
        "lat": "44.682445",
        "long": "26.382132"
      },
      {
        "name": "FIERBINTII DE JOS",
        "zip": "927116",
        "lat": "44.695234",
        "long": "26.396293"
      },
      {
        "name": "FIERBINTII DE SUS",
        "zip": "927117",
        "lat": "44.69114",
        "long": "26.396748"
      },
      {
        "name": "FRATILESTI",
        "zip": "927206",
        "lat": "44.614524",
        "long": "27.604444"
      },
      {
        "name": "FUNDATA",
        "zip": "927191",
        "lat": "44.585148",
        "long": "27.256473"
      },
      {
        "name": "GARBOVI",
        "zip": "927120",
        "lat": "44.786669",
        "long": "26.767371"
      },
      {
        "name": "GHEORGHE DOJA",
        "zip": "927125",
        "lat": "44.6132",
        "long": "27.180923"
      },
      {
        "name": "GHEORGHE LAZAR",
        "zip": "927130",
        "lat": "44.632397",
        "long": "27.455976"
      },
      {
        "name": "GIMBASANI",
        "zip": "927091",
        "lat": "44.561436",
        "long": "27.480075"
      },
      {
        "name": "GIURGENI",
        "zip": "927135",
        "lat": "44.744321",
        "long": "27.85699"
      },
      {
        "name": "GRECII DE JOS",
        "zip": "927118",
        "lat": "44.672276",
        "long": "26.352522"
      },
      {
        "name": "GRINDASI",
        "zip": "927246",
        "lat": "44.727287",
        "long": "26.84015"
      },
      {
        "name": "GRINDU",
        "zip": "927140",
        "lat": "44.772656",
        "long": "26.906245"
      },
      {
        "name": "GRIVITA",
        "zip": "927145",
        "lat": "44.734295",
        "long": "27.29113"
      },
      {
        "name": "GURA IALOMITEI",
        "zip": "927166",
        "lat": "44.709597",
        "long": "27.756048"
      },
      {
        "name": "GURA VAII",
        "zip": "927236",
        "lat": "44.570351",
        "long": "27.568331"
      },
      {
        "name": "HAGIENI",
        "zip": "927167",
        "lat": "44.645487",
        "long": "27.757294"
      },
      {
        "name": "HAGIESTI",
        "zip": "927223",
        "lat": "44.543698",
        "long": "26.429294"
      },
      {
        "name": "HORIA",
        "zip": "927037",
        "lat": "44.537478",
        "long": "26.802689"
      },
      {
        "name": "IAZU",
        "zip": "927211",
        "lat": "44.728391",
        "long": "27.424035"
      },
      {
        "name": "ION GHICA",
        "zip": "927081",
        "lat": "44.531487",
        "long": "27.306084"
      },
      {
        "name": "ION ROATA",
        "zip": "927150",
        "lat": "44.662667",
        "long": "26.788303"
      },
      {
        "name": "IVANESTI",
        "zip": "927082",
        "lat": "44.534301",
        "long": "27.279819"
      },
      {
        "name": "JILAVELE",
        "zip": "927155",
        "lat": "44.762213",
        "long": "26.531303"
      },
      {
        "name": "LACUSTENI",
        "zip": "927207",
        "lat": "44.607149",
        "long": "27.675688"
      },
      {
        "name": "LILIECI",
        "zip": "927224",
        "lat": "44.549138",
        "long": "26.376868"
      },
      {
        "name": "LIVEDEA",
        "zip": "927226",
        "lat": "44.587985",
        "long": "26.427612"
      },
      {
        "name": "LUCIU",
        "zip": "927168",
        "lat": "44.739722",
        "long": "27.729956"
      },
      {
        "name": "MAIA",
        "zip": "927056",
        "lat": "44.736157",
        "long": "26.401506"
      },
      {
        "name": "MALTEZI",
        "zip": "927231",
        "lat": "44.423171",
        "long": "27.887765"
      },
      {
        "name": "MALU",
        "zip": "927217",
        "lat": "44.649164",
        "long": "26.824207"
      },
      {
        "name": "MALU ROSU",
        "zip": "927032",
        "lat": "44.781156",
        "long": "26.579368"
      },
      {
        "name": "MANASIA",
        "zip": "927160",
        "lat": "44.706278",
        "long": "26.675362"
      },
      {
        "name": "MARCULESTI",
        "zip": "927092",
        "lat": "44.566976",
        "long": "27.51562"
      },
      {
        "name": "MARSILIENI",
        "zip": "927013",
        "lat": "44.538951",
        "long": "27.092365"
      },
      {
        "name": "MIHAIL KOGALNICEANU",
        "zip": "927165",
        "lat": "44.678839",
        "long": "27.711314"
      },
      {
        "name": "MILOSESTI",
        "zip": "927170",
        "lat": "44.736559",
        "long": "27.228514"
      },
      {
        "name": "MIRCEA CEL BATRAN",
        "zip": "927197",
        "lat": "44.699165",
        "long": "27.124619"
      },
      {
        "name": "MISLEANU",
        "zip": "927192",
        "lat": "44.574158",
        "long": "27.214325"
      },
      {
        "name": "MOLDOVENI",
        "zip": "927107",
        "lat": "44.714246",
        "long": "26.518791"
      },
      {
        "name": "MOVILA",
        "zip": "927175",
        "lat": "44.537454",
        "long": "27.717403"
      },
      {
        "name": "MOVILEANCA",
        "zip": "927057",
        "lat": "44.784163",
        "long": "26.320065"
      },
      {
        "name": "MOVILITA",
        "zip": "927180",
        "lat": "44.642622",
        "long": "26.488101"
      },
      {
        "name": "MUNTENI-BUZAU",
        "zip": "927185",
        "lat": "44.638383",
        "long": "26.972877"
      },
      {
        "name": "MURGEANCA",
        "zip": "927243",
        "lat": "44.707097",
        "long": "27.569973"
      },
      {
        "name": "NENISORI",
        "zip": "927033",
        "lat": "44.760803",
        "long": "26.576115"
      },
      {
        "name": "NICOLESTI",
        "zip": "927171",
        "lat": "44.759239",
        "long": "27.2125"
      },
      {
        "name": "OGRADA",
        "zip": "927061",
        "lat": "44.612725",
        "long": "27.556398"
      },
      {
        "name": "ORBOESTI",
        "zip": "927026",
        "lat": "44.578276",
        "long": "27.104237"
      },
      {
        "name": "OREZU",
        "zip": "927077",
        "lat": "44.58545",
        "long": "26.995863"
      },
      {
        "name": "PALTINISU",
        "zip": "927193",
        "lat": "44.566869",
        "long": "27.302369"
      },
      {
        "name": "PATRU FRATI",
        "zip": "927006",
        "lat": "44.736719",
        "long": "26.470593"
      },
      {
        "name": "PERIETI",
        "zip": "927190",
        "lat": "44.563083",
        "long": "27.241444"
      },
      {
        "name": "PIERSICA",
        "zip": "927078",
        "lat": "44.566555",
        "long": "27.000762"
      },
      {
        "name": "PLATONESTI",
        "zip": "927208",
        "lat": "44.607355",
        "long": "27.693728"
      },
      {
        "name": "POIANA",
        "zip": "927083",
        "lat": "44.548961",
        "long": "27.259516"
      },
      {
        "name": "PROGRESU",
        "zip": "927111",
        "lat": "44.58111",
        "long": "27.868433"
      },
      {
        "name": "RADULESTI",
        "zip": "927055",
        "lat": "44.766452",
        "long": "26.359582"
      },
      {
        "name": "RASI",
        "zip": "927201",
        "lat": "44.535641",
        "long": "26.925241"
      },
      {
        "name": "RASIMNICEA",
        "zip": "927058",
        "lat": "44.778542",
        "long": "26.336421"
      },
      {
        "name": "RETEZATU",
        "zip": "927232",
        "lat": "44.441546",
        "long": "27.893587"
      },
      {
        "name": "REVIGA",
        "zip": "927195",
        "lat": "44.713317",
        "long": "27.102646"
      },
      {
        "name": "ROSIORI",
        "zip": "927183",
        "lat": "44.612898",
        "long": "26.534574"
      },
      {
        "name": "ROVINE",
        "zip": "927198",
        "lat": "44.69832",
        "long": "27.090695"
      },
      {
        "name": "SALCIOARA",
        "zip": "927200",
        "lat": "44.539756",
        "long": "26.88138"
      },
      {
        "name": "SARATENI",
        "zip": "927044",
        "lat": "44.634219",
        "long": "26.926861"
      },
      {
        "name": "SAVENI",
        "zip": "927205",
        "lat": "44.603245",
        "long": "27.635911"
      },
      {
        "name": "SCANTEIA",
        "zip": "927210",
        "lat": "44.733741",
        "long": "27.465699"
      },
      {
        "name": "SFANTU GHEORGHE",
        "zip": "927215",
        "lat": "44.643475",
        "long": "26.86562"
      },
      {
        "name": "SINESTI",
        "zip": "927220",
        "lat": "44.566178",
        "long": "26.381664"
      },
      {
        "name": "SINTESTI",
        "zip": "927097",
        "lat": "44.667798",
        "long": "26.588514"
      },
      {
        "name": "SLATIOARELE",
        "zip": "927156",
        "lat": "44.786149",
        "long": "26.516943"
      },
      {
        "name": "SLOBOZIA",
        "zip": "920003",
        "lat": "44.5636",
        "long": "27.361848"
      },
      {
        "name": "SLOBOZIA NOUA",
        "zip": "920002",
        "lat": "44.602251",
        "long": "27.387692"
      },
      {
        "name": "SMIRNA",
        "zip": "927146",
        "lat": "44.723606",
        "long": "27.352877"
      },
      {
        "name": "STEJARU",
        "zip": "927194",
        "lat": "44.567533",
        "long": "27.283471"
      },
      {
        "name": "STELNICA",
        "zip": "927230",
        "lat": "44.413172",
        "long": "27.877543"
      },
      {
        "name": "SUDITI",
        "zip": "927235",
        "lat": "44.572356",
        "long": "27.595976"
      },
      {
        "name": "TANDAREI",
        "zip": "925200",
        "lat": "44.642405",
        "long": "27.65298"
      },
      {
        "name": "TOVARASIA",
        "zip": "927172",
        "lat": "44.781121",
        "long": "27.16435"
      },
      {
        "name": "TRAIAN",
        "zip": "927147",
        "lat": "44.760856",
        "long": "27.338091"
      },
      {
        "name": "URZICENI",
        "zip": "925300",
        "lat": "44.717002",
        "long": "26.632407"
      },
      {
        "name": "VALEA BISERICII",
        "zip": "927104",
        "lat": "44.590088",
        "long": "26.564263"
      },
      {
        "name": "VALEA CIORII",
        "zip": "927240",
        "lat": "44.717954",
        "long": "27.554867"
      },
      {
        "name": "VALEA MACRISULUI",
        "zip": "927245",
        "lat": "44.743768",
        "long": "26.829169"
      },
      {
        "name": "VLADENI",
        "zip": "927250",
        "lat": "44.605338",
        "long": "27.848571"
      },
      {
        "name": "VLASCA",
        "zip": "925102",
        "lat": "44.396638",
        "long": "27.848646"
      }
    ],
    "IAȘI": [
      {
        "name": "ALBESTI",
        "zip": "707061",
        "lat": "47.185166",
        "long": "27.104952"
      },
      {
        "name": "ALEXANDRU CEL BUN",
        "zip": "707591",
        "lat": "47.458727",
        "long": "27.297408"
      },
      {
        "name": "ALEXANDRU I. CUZA",
        "zip": "707005",
        "lat": "47.131794",
        "long": "26.8606"
      },
      {
        "name": "ALEXENI",
        "zip": "707531",
        "lat": "46.97008",
        "long": "27.368603"
      },
      {
        "name": "ALEXESTI",
        "zip": "707266",
        "lat": "46.877343",
        "long": "27.441597"
      },
      {
        "name": "ANDRIESENI",
        "zip": "707010",
        "lat": "47.529151",
        "long": "27.290219"
      },
      {
        "name": "ARAMA",
        "zip": "707101",
        "lat": "47.398292",
        "long": "27.114378"
      },
      {
        "name": "ARONEANU",
        "zip": "707020",
        "lat": "47.20447",
        "long": "27.604242"
      },
      {
        "name": "AVANTU",
        "zip": "707416",
        "lat": "47.259846",
        "long": "27.366756"
      },
      {
        "name": "BACU",
        "zip": "707267",
        "lat": "46.924239",
        "long": "27.459764"
      },
      {
        "name": "BADENI",
        "zip": "707446",
        "lat": "47.405902",
        "long": "26.948937"
      },
      {
        "name": "BAHLUIU",
        "zip": "707121",
        "lat": "47.358581",
        "long": "26.983523"
      },
      {
        "name": "BAICENI",
        "zip": "707151",
        "lat": "47.300889",
        "long": "26.914847"
      },
      {
        "name": "BAICENI",
        "zip": "707506",
        "lat": "47.310457",
        "long": "26.913075"
      },
      {
        "name": "BALCIU",
        "zip": "707306",
        "lat": "47.140337",
        "long": "27.528941"
      },
      {
        "name": "BALS",
        "zip": "705301",
        "lat": "47.29628",
        "long": "26.978561"
      },
      {
        "name": "BALTATI",
        "zip": "707025",
        "lat": "47.222034",
        "long": "27.123423"
      },
      {
        "name": "BALTENI",
        "zip": "707396",
        "lat": "47.406259",
        "long": "27.500946"
      },
      {
        "name": "BALUSESTI",
        "zip": "707156",
        "lat": "46.886665",
        "long": "27.209488"
      },
      {
        "name": "BANU",
        "zip": "707186",
        "lat": "47.190399",
        "long": "27.372193"
      },
      {
        "name": "BARBATESTI",
        "zip": "707152",
        "lat": "47.276538",
        "long": "26.90563"
      },
      {
        "name": "BARLESTI",
        "zip": "707191",
        "lat": "47.252285",
        "long": "27.260772"
      },
      {
        "name": "BARNOVA",
        "zip": "707035",
        "lat": "47.081943",
        "long": "27.621171"
      },
      {
        "name": "BELCESTI",
        "zip": "707045",
        "lat": "47.306639",
        "long": "27.085187"
      },
      {
        "name": "BEREZLOGI",
        "zip": "707456",
        "lat": "47.430297",
        "long": "26.75489"
      },
      {
        "name": "BIVOLARI",
        "zip": "707055",
        "lat": "47.518644",
        "long": "27.444435"
      },
      {
        "name": "BLAGA",
        "zip": "707436",
        "lat": "47.030608",
        "long": "27.742816"
      },
      {
        "name": "BLAGESTI",
        "zip": "705201",
        "lat": "47.249658",
        "long": "26.764308"
      },
      {
        "name": "BOATCA",
        "zip": "707157",
        "lat": "46.950374",
        "long": "27.219957"
      },
      {
        "name": "BOCNITA",
        "zip": "707451",
        "lat": "47.160053",
        "long": "27.189525"
      },
      {
        "name": "BODESTI",
        "zip": "707426",
        "lat": "46.914775",
        "long": "27.599275"
      },
      {
        "name": "BOGDANESTI",
        "zip": "707261",
        "lat": "47.115751",
        "long": "27.434966"
      },
      {
        "name": "BOGONOS",
        "zip": "707281",
        "lat": "47.209245",
        "long": "27.433508"
      },
      {
        "name": "BOHOTIN",
        "zip": "707401",
        "lat": "46.9392",
        "long": "27.975906"
      },
      {
        "name": "BOJILA",
        "zip": "707291",
        "lat": "47.017716",
        "long": "27.273022"
      },
      {
        "name": "BOLDESTI",
        "zip": "707507",
        "lat": "47.282218",
        "long": "26.82688"
      },
      {
        "name": "BOROSESTI",
        "zip": "707427",
        "lat": "46.942845",
        "long": "27.594803"
      },
      {
        "name": "BOROSOAIA",
        "zip": "707361",
        "lat": "47.462997",
        "long": "27.098621"
      },
      {
        "name": "BORSA",
        "zip": "707592",
        "lat": "47.411707",
        "long": "27.361596"
      },
      {
        "name": "BOSIA",
        "zip": "707566",
        "lat": "47.216959",
        "long": "27.767072"
      },
      {
        "name": "BOSTENI",
        "zip": "705202",
        "lat": "47.231993",
        "long": "26.684349"
      },
      {
        "name": "BOURENI",
        "zip": "705302",
        "lat": "47.264972",
        "long": "26.976723"
      },
      {
        "name": "BOURENI",
        "zip": "707346",
        "lat": "47.208975",
        "long": "26.625262"
      },
      {
        "name": "BRADICESTI",
        "zip": "707181",
        "lat": "46.848102",
        "long": "27.902701"
      },
      {
        "name": "BRAESTI",
        "zip": "707060",
        "lat": "47.155117",
        "long": "27.10204"
      },
      {
        "name": "BRAN",
        "zip": "707201",
        "lat": "47.245999",
        "long": "27.738778"
      },
      {
        "name": "BRATESTI",
        "zip": "707461",
        "lat": "47.186444",
        "long": "26.704056"
      },
      {
        "name": "BRATULENI",
        "zip": "707307",
        "lat": "47.164202",
        "long": "27.458618"
      },
      {
        "name": "BRATULESTI",
        "zip": "707466",
        "lat": "47.127155",
        "long": "26.966963"
      },
      {
        "name": "BREAZU",
        "zip": "707406",
        "lat": "47.216631",
        "long": "27.516948"
      },
      {
        "name": "BROSTENI",
        "zip": "707593",
        "lat": "47.45608",
        "long": "27.33751"
      },
      {
        "name": "BUDA",
        "zip": "707062",
        "lat": "47.119541",
        "long": "27.073804"
      },
      {
        "name": "BUDA",
        "zip": "707271",
        "lat": "47.403179",
        "long": "26.678346"
      },
      {
        "name": "BUDAI",
        "zip": "707366",
        "lat": "47.21839",
        "long": "27.21708"
      },
      {
        "name": "BUDESTI",
        "zip": "707331",
        "lat": "47.051187",
        "long": "27.485819"
      },
      {
        "name": "BUHAENI",
        "zip": "707011",
        "lat": "47.508612",
        "long": "27.278696"
      },
      {
        "name": "BUHALNITA",
        "zip": "707071",
        "lat": "47.378677",
        "long": "26.913858"
      },
      {
        "name": "BULBUCANI",
        "zip": "707226",
        "lat": "47.359131",
        "long": "27.24953"
      },
      {
        "name": "BURSUC-DEAL",
        "zip": "707272",
        "lat": "47.324293",
        "long": "26.675843"
      },
      {
        "name": "BURSUC-VALE",
        "zip": "707273",
        "lat": "47.313399",
        "long": "26.69862"
      },
      {
        "name": "BURUIENESTI",
        "zip": "707056",
        "lat": "47.553799",
        "long": "27.401381"
      },
      {
        "name": "BUTEA",
        "zip": "707065",
        "lat": "47.073647",
        "long": "26.935798"
      },
      {
        "name": "BUZDUG",
        "zip": "707158",
        "lat": "46.962853",
        "long": "27.167106"
      },
      {
        "name": "BUZNEA",
        "zip": "705303",
        "lat": "47.195148",
        "long": "27.015716"
      },
      {
        "name": "CARBUNARI",
        "zip": "707216",
        "lat": "46.995124",
        "long": "27.520763"
      },
      {
        "name": "CARJOAIA",
        "zip": "707122",
        "lat": "47.34032",
        "long": "26.908637"
      },
      {
        "name": "CARLIG",
        "zip": "707381",
        "lat": "47.210726",
        "long": "27.558865"
      },
      {
        "name": "CARNICENI",
        "zip": "707556",
        "lat": "47.33988",
        "long": "27.508229"
      },
      {
        "name": "CAUESTI",
        "zip": "707476",
        "lat": "46.91841",
        "long": "27.547605"
      },
      {
        "name": "CEPLENITA",
        "zip": "707070",
        "lat": "47.381589",
        "long": "26.961088"
      },
      {
        "name": "CERCU",
        "zip": "707036",
        "lat": "47.081939",
        "long": "27.608977"
      },
      {
        "name": "CHICEREA",
        "zip": "707516",
        "lat": "47.102667",
        "long": "27.747931"
      },
      {
        "name": "CHILISOAIA",
        "zip": "707187",
        "lat": "47.163957",
        "long": "27.306193"
      },
      {
        "name": "CHIPERESTI",
        "zip": "707561",
        "lat": "47.117694",
        "long": "27.764162"
      },
      {
        "name": "CHISCARENI",
        "zip": "707486",
        "lat": "47.457703",
        "long": "27.204217"
      },
      {
        "name": "CILIBIU",
        "zip": "707202",
        "lat": "47.255017",
        "long": "27.678515"
      },
      {
        "name": "CIOCA-BOCA",
        "zip": "707477",
        "lat": "46.94591",
        "long": "27.465598"
      },
      {
        "name": "CIOCARLESTI",
        "zip": "707428",
        "lat": "46.934936",
        "long": "27.551389"
      },
      {
        "name": "CIOHORANI",
        "zip": "707326",
        "lat": "47.134851",
        "long": "26.686227"
      },
      {
        "name": "CIORTESTI",
        "zip": "707075",
        "lat": "46.917608",
        "long": "27.847253"
      },
      {
        "name": "CIRESENI",
        "zip": "707123",
        "lat": "47.380971",
        "long": "26.838731"
      },
      {
        "name": "CIURBESTI",
        "zip": "707308",
        "lat": "47.096271",
        "long": "27.525498"
      },
      {
        "name": "CIUREA",
        "zip": "707080",
        "lat": "47.060962",
        "long": "27.567547"
      },
      {
        "name": "COADA STANCII",
        "zip": "707567",
        "lat": "47.207944",
        "long": "27.715561"
      },
      {
        "name": "COARNELE CAPREI",
        "zip": "707100",
        "lat": "47.391198",
        "long": "27.107235"
      },
      {
        "name": "COASTA MAGURII",
        "zip": "705304",
        "lat": "47.31588",
        "long": "26.929005"
      },
      {
        "name": "COGEASCA",
        "zip": "707282",
        "lat": "47.164728",
        "long": "27.390427"
      },
      {
        "name": "COLTU CORNII",
        "zip": "707236",
        "lat": "47.028431",
        "long": "27.992463"
      },
      {
        "name": "COMARNA",
        "zip": "707105",
        "lat": "47.056742",
        "long": "27.788692"
      },
      {
        "name": "CONTESTI",
        "zip": "707571",
        "lat": "47.308627",
        "long": "26.656047"
      },
      {
        "name": "CORCODEL",
        "zip": "707217",
        "lat": "46.94437",
        "long": "27.550507"
      },
      {
        "name": "CORNESTI",
        "zip": "707309",
        "lat": "47.106755",
        "long": "27.513199"
      },
      {
        "name": "COROPCENI",
        "zip": "707076",
        "lat": "46.942458",
        "long": "27.834509"
      },
      {
        "name": "COSITENI",
        "zip": "707367",
        "lat": "47.202424",
        "long": "27.237552"
      },
      {
        "name": "COSTESTI",
        "zip": "705305",
        "lat": "47.232764",
        "long": "26.930469"
      },
      {
        "name": "COSTULENI",
        "zip": "707115",
        "lat": "47.030521",
        "long": "27.866478999999998"
      },
      {
        "name": "COTARGACI",
        "zip": "707026",
        "lat": "47.219788",
        "long": "27.167404"
      },
      {
        "name": "COTNARI",
        "zip": "707120",
        "lat": "47.347944",
        "long": "26.944081"
      },
      {
        "name": "COTU LUI IVAN",
        "zip": "707203",
        "lat": "47.273529",
        "long": "27.653535"
      },
      {
        "name": "COTU MORII",
        "zip": "707382",
        "lat": "47.302105",
        "long": "27.550551"
      },
      {
        "name": "COVASNA",
        "zip": "707116",
        "lat": "47.00725",
        "long": "27.84637"
      },
      {
        "name": "COZIA",
        "zip": "707117",
        "lat": "47.003014",
        "long": "27.896012"
      },
      {
        "name": "COZMESTI",
        "zip": "707140",
        "lat": "46.875985",
        "long": "27.996746"
      },
      {
        "name": "COZMESTI",
        "zip": "707462",
        "lat": "47.167993",
        "long": "26.762837"
      },
      {
        "name": "CRISTESTI",
        "zip": "707251",
        "lat": "47.170639",
        "long": "27.724017"
      },
      {
        "name": "CRISTESTI",
        "zip": "707063",
        "lat": "47.159262",
        "long": "27.078254"
      },
      {
        "name": "CRISTESTI",
        "zip": "707145",
        "lat": "47.250334",
        "long": "26.567782"
      },
      {
        "name": "CRIVESTI",
        "zip": "707467",
        "lat": "47.198978",
        "long": "26.930475"
      },
      {
        "name": "CRIVESTI",
        "zip": "707576",
        "lat": "47.324297",
        "long": "26.782401"
      },
      {
        "name": "CRUCEA",
        "zip": "707286",
        "lat": "47.165924",
        "long": "27.173797"
      },
      {
        "name": "CUCOVA",
        "zip": "707468",
        "lat": "47.15957",
        "long": "26.917009"
      },
      {
        "name": "CUCUTENI",
        "zip": "707150",
        "lat": "47.275018",
        "long": "26.940324"
      },
      {
        "name": "CUCUTENI",
        "zip": "707283",
        "lat": "47.150219",
        "long": "27.421412"
      },
      {
        "name": "CURAGAU",
        "zip": "707106",
        "lat": "47.058617",
        "long": "27.753845"
      },
      {
        "name": "CURATURI",
        "zip": "707081",
        "lat": "47.026375",
        "long": "27.561093"
      },
      {
        "name": "CUZA VODA",
        "zip": "707268",
        "lat": "46.894725",
        "long": "27.409763"
      },
      {
        "name": "CUZA VODA",
        "zip": "707383",
        "lat": "47.235979",
        "long": "27.571041"
      },
      {
        "name": "DADESTI",
        "zip": "705306",
        "lat": "47.217486",
        "long": "26.974766"
      },
      {
        "name": "DAGATA",
        "zip": "707155",
        "lat": "46.919108",
        "long": "27.193573"
      },
      {
        "name": "DANCAS",
        "zip": "707311",
        "lat": "47.108566",
        "long": "27.523576"
      },
      {
        "name": "DANCU",
        "zip": "707252",
        "lat": "47.153204",
        "long": "27.661692"
      },
      {
        "name": "DELENI",
        "zip": "707077",
        "lat": "46.920983",
        "long": "27.827665"
      },
      {
        "name": "DELENI",
        "zip": "707165",
        "lat": "47.455619",
        "long": "26.880009"
      },
      {
        "name": "DOBROVAT",
        "zip": "707175",
        "lat": "46.967374",
        "long": "27.723224"
      },
      {
        "name": "DOLHESTI",
        "zip": "707180",
        "lat": "46.875111",
        "long": "27.896727"
      },
      {
        "name": "DOMNITA",
        "zip": "707532",
        "lat": "47.02884",
        "long": "27.336299"
      },
      {
        "name": "DOROBANT",
        "zip": "707021",
        "lat": "47.223654",
        "long": "27.594792"
      },
      {
        "name": "DOROSCANI",
        "zip": "707371",
        "lat": "47.145842",
        "long": "27.267347"
      },
      {
        "name": "DRAGANESTI",
        "zip": "707012",
        "lat": "47.520902",
        "long": "27.26182"
      },
      {
        "name": "DRAGUSENI",
        "zip": "707478",
        "lat": "46.901159",
        "long": "27.512601"
      },
      {
        "name": "DUMBRAVA",
        "zip": "707082",
        "lat": "47.076795",
        "long": "27.550184"
      },
      {
        "name": "DUMBRAVA",
        "zip": "707274",
        "lat": "47.353844",
        "long": "26.7157"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "707421",
        "lat": "47.254828",
        "long": "26.841692"
      },
      {
        "name": "DUMESTI",
        "zip": "707185",
        "lat": "47.174724",
        "long": "27.34309"
      },
      {
        "name": "DUMITRESTII GALATII",
        "zip": "707437",
        "lat": "47.015408",
        "long": "27.774878"
      },
      {
        "name": "ERBICENI",
        "zip": "707190",
        "lat": "47.258208",
        "long": "27.238571"
      },
      {
        "name": "FAGAT",
        "zip": "707124",
        "lat": "47.379735",
        "long": "26.848423"
      },
      {
        "name": "FANTANELE",
        "zip": "707013",
        "lat": "47.511408",
        "long": "27.317632"
      },
      {
        "name": "FANTANELE",
        "zip": "707196",
        "lat": "47.414977",
        "long": "27.180664"
      },
      {
        "name": "FARCASENI",
        "zip": "707469",
        "lat": "47.159878",
        "long": "26.896152"
      },
      {
        "name": "FEDELESENI",
        "zip": "707471",
        "lat": "47.123011",
        "long": "26.978472"
      },
      {
        "name": "FEREDENI",
        "zip": "707166",
        "lat": "47.48512",
        "long": "26.876347"
      },
      {
        "name": "FETESTI",
        "zip": "707447",
        "lat": "47.41043",
        "long": "26.906283"
      },
      {
        "name": "FILIASI",
        "zip": "707027",
        "lat": "47.257839",
        "long": "27.040889"
      },
      {
        "name": "FOCURI",
        "zip": "707195",
        "lat": "47.351352",
        "long": "27.201862"
      },
      {
        "name": "FORASTI",
        "zip": "707227",
        "lat": "47.354879",
        "long": "27.287479"
      },
      {
        "name": "FRASULENI",
        "zip": "707581",
        "lat": "47.335123",
        "long": "27.589411"
      },
      {
        "name": "FRENCIUGI",
        "zip": "707479",
        "lat": "46.887472",
        "long": "27.47722"
      },
      {
        "name": "FRUMUSICA",
        "zip": "707292",
        "lat": "47.05516",
        "long": "27.296628"
      },
      {
        "name": "GANESTI",
        "zip": "705307",
        "lat": "47.167179",
        "long": "27.031893"
      },
      {
        "name": "GARBESTI",
        "zip": "707533",
        "lat": "46.977722",
        "long": "27.294403"
      },
      {
        "name": "GASTESTI",
        "zip": "705203",
        "lat": "47.247379",
        "long": "26.661789"
      },
      {
        "name": "GAURENI",
        "zip": "707312",
        "lat": "47.153078",
        "long": "27.505052"
      },
      {
        "name": "GIURGESTI",
        "zip": "705308",
        "lat": "47.248491",
        "long": "26.905415"
      },
      {
        "name": "GLAVANESTI",
        "zip": "707014",
        "lat": "47.549899",
        "long": "27.275797"
      },
      {
        "name": "GLODENII GANDULUI",
        "zip": "707546",
        "lat": "46.951597",
        "long": "27.29921"
      },
      {
        "name": "GOESTI",
        "zip": "707287",
        "lat": "47.156546",
        "long": "27.136598"
      },
      {
        "name": "GOLAIESTI",
        "zip": "707200",
        "lat": "47.241774",
        "long": "27.695672"
      },
      {
        "name": "GORBAN",
        "zip": "707210",
        "lat": "46.879857",
        "long": "28.08189"
      },
      {
        "name": "GORUNI",
        "zip": "707517",
        "lat": "47.105014",
        "long": "27.712979"
      },
      {
        "name": "GRADINARI",
        "zip": "707204",
        "lat": "47.270344",
        "long": "27.669662"
      },
      {
        "name": "GRAJDURI",
        "zip": "707215",
        "lat": "46.972817",
        "long": "27.538824"
      },
      {
        "name": "GRIESTI",
        "zip": "707547",
        "lat": "46.903063",
        "long": "27.376114"
      },
      {
        "name": "GROPNITA",
        "zip": "707225",
        "lat": "47.354838",
        "long": "27.268588"
      },
      {
        "name": "GROZESTI",
        "zip": "707235",
        "lat": "46.990376",
        "long": "28.055473"
      },
      {
        "name": "GURA BADILITEI",
        "zip": "707577",
        "lat": "47.300036",
        "long": "26.750422"
      },
      {
        "name": "GURA BOHOTIN",
        "zip": "707211",
        "lat": "46.917694",
        "long": "28.044882"
      },
      {
        "name": "GURA VAII",
        "zip": "707472",
        "lat": "47.191526",
        "long": "26.943017"
      },
      {
        "name": "HABASESTI",
        "zip": "707473",
        "lat": "47.154725",
        "long": "26.953658"
      },
      {
        "name": "HADAMBU",
        "zip": "707332",
        "lat": "47.014953",
        "long": "27.456108"
      },
      {
        "name": "HALAUCESTI",
        "zip": "707240",
        "lat": "47.094912",
        "long": "26.813696"
      },
      {
        "name": "HALCENI",
        "zip": "707487",
        "lat": "47.440252",
        "long": "27.261846"
      },
      {
        "name": "HANDRESTI",
        "zip": "707356",
        "lat": "47.105762",
        "long": "27.027172"
      },
      {
        "name": "HARLAU",
        "zip": "705100",
        "lat": "47.427835",
        "long": "26.900739"
      },
      {
        "name": "HARMANEASA",
        "zip": "707246",
        "lat": "47.190717",
        "long": "26.866223"
      },
      {
        "name": "HARMANESTII NOI",
        "zip": "707508",
        "lat": "47.2531",
        "long": "26.79791"
      },
      {
        "name": "HARMANESTII VECHI",
        "zip": "707509",
        "lat": "47.277305",
        "long": "26.813191"
      },
      {
        "name": "HARPASESTI",
        "zip": "707372",
        "lat": "47.150197",
        "long": "27.282436"
      },
      {
        "name": "HARTOAPE",
        "zip": "707578",
        "lat": "47.321905",
        "long": "26.721164"
      },
      {
        "name": "HECI",
        "zip": "707276",
        "lat": "47.340335",
        "long": "26.661283"
      },
      {
        "name": "HELESTENI",
        "zip": "707245",
        "lat": "47.203032",
        "long": "26.877549"
      },
      {
        "name": "HERMEZIU",
        "zip": "707521",
        "lat": "47.442684",
        "long": "27.553008"
      },
      {
        "name": "HILITA",
        "zip": "707118",
        "lat": "47.002663",
        "long": "27.825867"
      },
      {
        "name": "HLINCEA",
        "zip": "707083",
        "lat": "47.110588",
        "long": "27.582319"
      },
      {
        "name": "HODORA",
        "zip": "707126",
        "lat": "47.337398",
        "long": "27.019637"
      },
      {
        "name": "HOISESTI",
        "zip": "707188",
        "lat": "47.196222",
        "long": "27.326073"
      },
      {
        "name": "HOLBOCA",
        "zip": "707250",
        "lat": "47.154821",
        "long": "27.686331"
      },
      {
        "name": "HOLM",
        "zip": "707368",
        "lat": "47.208367",
        "long": "27.307497"
      },
      {
        "name": "HOMITA",
        "zip": "707146",
        "lat": "47.295991",
        "long": "26.594307"
      },
      {
        "name": "HORLESTI",
        "zip": "707407",
        "lat": "47.258126",
        "long": "27.461203"
      },
      {
        "name": "HORLESTI",
        "zip": "707260",
        "lat": "47.107717",
        "long": "27.380044"
      },
      {
        "name": "HORODISTEA",
        "zip": "707127",
        "lat": "47.355691",
        "long": "26.90236"
      },
      {
        "name": "HORPAZ",
        "zip": "707313",
        "lat": "47.105552",
        "long": "27.549583"
      },
      {
        "name": "HUMOSU",
        "zip": "707457",
        "lat": "47.457283",
        "long": "26.732523"
      },
      {
        "name": "IACOBENI",
        "zip": "707594",
        "lat": "47.446651",
        "long": "27.320674"
      },
      {
        "name": "IASI",
        "zip": "700001",
        "lat": "47.161494",
        "long": "27.58405"
      },
      {
        "name": "IAZU NOU",
        "zip": "707488",
        "lat": "47.483811",
        "long": "27.206448"
      },
      {
        "name": "IAZU VECHI",
        "zip": "707489",
        "lat": "47.432768",
        "long": "27.229173"
      },
      {
        "name": "ICUSENI",
        "zip": "707582",
        "lat": "47.276897",
        "long": "27.634846"
      },
      {
        "name": "IEPURENI",
        "zip": "707016",
        "lat": "47.470624",
        "long": "27.326619"
      },
      {
        "name": "IEPURENI",
        "zip": "707351",
        "lat": "47.300323",
        "long": "27.43525"
      },
      {
        "name": "ION NECULCE",
        "zip": "705309",
        "lat": "47.202288",
        "long": "27.050913"
      },
      {
        "name": "IORCANI",
        "zip": "707501",
        "lat": "47.35322",
        "long": "26.524683"
      },
      {
        "name": "IOSUPENI",
        "zip": "707128",
        "lat": "47.342211",
        "long": "27.003368"
      },
      {
        "name": "IPATELE",
        "zip": "707265",
        "lat": "46.919131",
        "long": "27.435838"
      },
      {
        "name": "ISAIIA",
        "zip": "707402",
        "lat": "46.935742",
        "long": "28.007329"
      },
      {
        "name": "IUGANI",
        "zip": "707296",
        "lat": "47.044312",
        "long": "26.828913"
      },
      {
        "name": "IZVOARELE",
        "zip": "707297",
        "lat": "47.045467",
        "long": "26.897853"
      },
      {
        "name": "JIGORENI",
        "zip": "707548",
        "lat": "46.89644",
        "long": "27.314155"
      },
      {
        "name": "KOGALNICENI",
        "zip": "707006",
        "lat": "47.158896",
        "long": "26.842001"
      },
      {
        "name": "LARGA-JIJIA",
        "zip": "707352",
        "lat": "47.320976",
        "long": "27.39424"
      },
      {
        "name": "LEAHU-NACU",
        "zip": "707167",
        "lat": "47.494354",
        "long": "26.94102"
      },
      {
        "name": "LESPEZI",
        "zip": "707270",
        "lat": "47.360685",
        "long": "26.692441"
      },
      {
        "name": "LETCANI",
        "zip": "707280",
        "lat": "47.195479",
        "long": "27.406446"
      },
      {
        "name": "LITENI",
        "zip": "707046",
        "lat": "47.301689",
        "long": "27.038367"
      },
      {
        "name": "LUCENI",
        "zip": "707583",
        "lat": "47.287597",
        "long": "27.614422"
      },
      {
        "name": "LUNCA",
        "zip": "705204",
        "lat": "47.286038",
        "long": "26.737201"
      },
      {
        "name": "LUNCA",
        "zip": "707218",
        "lat": "46.958014",
        "long": "27.562855"
      },
      {
        "name": "LUNCA CETATUII",
        "zip": "707085",
        "lat": "47.093131",
        "long": "27.566183"
      },
      {
        "name": "LUNCA RATES",
        "zip": "707429",
        "lat": "46.951784",
        "long": "27.575919"
      },
      {
        "name": "LUNCASI",
        "zip": "707241",
        "lat": "47.117086",
        "long": "26.805984"
      },
      {
        "name": "LUNGANI",
        "zip": "707285",
        "lat": "47.185497",
        "long": "27.139635"
      },
      {
        "name": "LUNGANI",
        "zip": "707601",
        "lat": "47.094077",
        "long": "27.400564"
      },
      {
        "name": "LUPARIA",
        "zip": "707129",
        "lat": "47.365072",
        "long": "26.889852"
      },
      {
        "name": "MACARESTI",
        "zip": "707391",
        "lat": "47.034638",
        "long": "27.965838"
      },
      {
        "name": "MADARJAC",
        "zip": "707290",
        "lat": "47.049943",
        "long": "27.26182"
      },
      {
        "name": "MADARJESTI",
        "zip": "707028",
        "lat": "47.216592",
        "long": "27.14904"
      },
      {
        "name": "MALAESTI",
        "zip": "707228",
        "lat": "47.353366",
        "long": "27.306331"
      },
      {
        "name": "MANASTIREA",
        "zip": "707159",
        "lat": "46.948403",
        "long": "27.205615"
      },
      {
        "name": "MANJESTI",
        "zip": "707333",
        "lat": "47.056915",
        "long": "27.474315"
      },
      {
        "name": "MANZATESTI",
        "zip": "707568",
        "lat": "47.185887",
        "long": "27.723554"
      },
      {
        "name": "MAXUT",
        "zip": "707168",
        "lat": "47.44175",
        "long": "26.892757"
      },
      {
        "name": "MEDELENI",
        "zip": "707206",
        "lat": "47.287611",
        "long": "27.678131"
      },
      {
        "name": "MICLAUSENI",
        "zip": "707066",
        "lat": "47.093986",
        "long": "26.931335"
      },
      {
        "name": "MIHAIL KOGALNICEANU",
        "zip": "707557",
        "lat": "47.347619",
        "long": "27.4132"
      },
      {
        "name": "MIRCESTI",
        "zip": "707295",
        "lat": "47.065112",
        "long": "26.847392"
      },
      {
        "name": "MIRONEASA",
        "zip": "707300",
        "lat": "46.969346",
        "long": "27.429692"
      },
      {
        "name": "MIROSLAVA",
        "zip": "707305",
        "lat": "47.145901",
        "long": "27.526046"
      },
      {
        "name": "MIROSLOVESTI",
        "zip": "707325",
        "lat": "47.152153",
        "long": "26.647817"
      },
      {
        "name": "MITESTI",
        "zip": "707327",
        "lat": "47.102172",
        "long": "26.643139"
      },
      {
        "name": "MITOC",
        "zip": "707491",
        "lat": "47.463506",
        "long": "27.239064"
      },
      {
        "name": "MOARA CIORNEI",
        "zip": "707534",
        "lat": "46.9633",
        "long": "27.348562"
      },
      {
        "name": "MOGOSESTI",
        "zip": "707330",
        "lat": "47.041734",
        "long": "27.51518"
      },
      {
        "name": "MOGOSESTI-SIRET",
        "zip": "707335",
        "lat": "47.138434",
        "long": "26.792288"
      },
      {
        "name": "MOIMESTI",
        "zip": "707384",
        "lat": "47.277844",
        "long": "27.511828"
      },
      {
        "name": "MORENI",
        "zip": "707392",
        "lat": "47.099065",
        "long": "27.869914"
      },
      {
        "name": "MOSNA",
        "zip": "707340",
        "lat": "46.92173",
        "long": "27.958809"
      },
      {
        "name": "MOTCA",
        "zip": "707345",
        "lat": "47.242606",
        "long": "26.607045"
      },
      {
        "name": "MOVILENI",
        "zip": "707247",
        "lat": "47.200949",
        "long": "26.900237"
      },
      {
        "name": "MOVILENI",
        "zip": "707350",
        "lat": "47.329717",
        "long": "27.361529"
      },
      {
        "name": "MUNCELU DE SUS",
        "zip": "707336",
        "lat": "47.123839",
        "long": "26.735184"
      },
      {
        "name": "MUNTENI",
        "zip": "707047",
        "lat": "47.315302",
        "long": "27.138394"
      },
      {
        "name": "OBOROCENI",
        "zip": "707248",
        "lat": "47.176806",
        "long": "26.877655"
      },
      {
        "name": "OBRIJENI",
        "zip": "707373",
        "lat": "47.149237",
        "long": "27.215458"
      },
      {
        "name": "ONESTI",
        "zip": "707362",
        "lat": "47.481341",
        "long": "27.121413"
      },
      {
        "name": "OPRISENI",
        "zip": "707562",
        "lat": "47.129082",
        "long": "27.824226"
      },
      {
        "name": "OPROAIA",
        "zip": "707536",
        "lat": "46.955986",
        "long": "27.369064"
      },
      {
        "name": "ORZENI",
        "zip": "707253",
        "lat": "47.181514",
        "long": "27.692929"
      },
      {
        "name": "OSOI",
        "zip": "707110",
        "lat": "47.093221",
        "long": "27.792151"
      },
      {
        "name": "OSOI",
        "zip": "707452",
        "lat": "47.09132",
        "long": "27.193134"
      },
      {
        "name": "OTELENI",
        "zip": "707355",
        "lat": "47.065562",
        "long": "27.027423"
      },
      {
        "name": "PADURENI",
        "zip": "707219",
        "lat": "46.991855",
        "long": "27.554827"
      },
      {
        "name": "PADURENI",
        "zip": "707374",
        "lat": "47.10977",
        "long": "27.315116"
      },
      {
        "name": "PARCOVACI",
        "zip": "705101",
        "lat": "47.436347",
        "long": "26.847317"
      },
      {
        "name": "PASCANI",
        "zip": "705200",
        "lat": "47.248077",
        "long": "26.725642"
      },
      {
        "name": "PAUN",
        "zip": "707037",
        "lat": "47.097107",
        "long": "27.662864"
      },
      {
        "name": "PAUSESTI",
        "zip": "707189",
        "lat": "47.15675",
        "long": "27.321712"
      },
      {
        "name": "PERIENI",
        "zip": "707397",
        "lat": "47.389371",
        "long": "27.464874"
      },
      {
        "name": "PETRESTI",
        "zip": "707207",
        "lat": "47.289783",
        "long": "27.711098"
      },
      {
        "name": "PETROSICA",
        "zip": "707102",
        "lat": "47.418481",
        "long": "27.065587"
      },
      {
        "name": "PICIORU LUPULUI",
        "zip": "707084",
        "lat": "47.039023",
        "long": "27.57662"
      },
      {
        "name": "PIETRARIA",
        "zip": "707038",
        "lat": "47.080434",
        "long": "27.641115"
      },
      {
        "name": "PIETRIS",
        "zip": "707182",
        "lat": "46.885206",
        "long": "27.920331"
      },
      {
        "name": "PIETROSU",
        "zip": "707502",
        "lat": "47.339608",
        "long": "26.614171"
      },
      {
        "name": "PISCU RUSULUI",
        "zip": "707161",
        "lat": "46.956363",
        "long": "27.144698"
      },
      {
        "name": "PLUGARI",
        "zip": "707360",
        "lat": "47.48763",
        "long": "27.127278"
      },
      {
        "name": "POCREACA",
        "zip": "707438",
        "lat": "46.969835",
        "long": "27.769397"
      },
      {
        "name": "PODISU",
        "zip": "707029",
        "lat": "47.255593",
        "long": "27.065678"
      },
      {
        "name": "PODOLENII DE JOS",
        "zip": "707141",
        "lat": "46.848775",
        "long": "28.031733"
      },
      {
        "name": "PODOLENII DE SUS",
        "zip": "707142",
        "lat": "46.857303",
        "long": "28.015209"
      },
      {
        "name": "PODU HAGIULUI",
        "zip": "707212",
        "lat": "46.861085",
        "long": "28.078285"
      },
      {
        "name": "PODU ILOAIEI",
        "zip": "707365",
        "lat": "47.212233",
        "long": "27.273661"
      },
      {
        "name": "PODU JIJIEI",
        "zip": "707208",
        "lat": "47.240672",
        "long": "27.720127"
      },
      {
        "name": "POIANA",
        "zip": "707169",
        "lat": "47.489064",
        "long": "26.859353"
      },
      {
        "name": "POIANA",
        "zip": "707439",
        "lat": "46.983478",
        "long": "27.790812"
      },
      {
        "name": "POIANA CU CETATE",
        "zip": "707221",
        "lat": "46.987285",
        "long": "27.604707"
      },
      {
        "name": "POIANA DE SUS",
        "zip": "707538",
        "lat": "47.007189",
        "long": "27.317759"
      },
      {
        "name": "POIANA MANASTIRII",
        "zip": "707537",
        "lat": "46.985689",
        "long": "27.356926"
      },
      {
        "name": "POIANA MARULUI",
        "zip": "707072",
        "lat": "47.379507",
        "long": "26.892432"
      },
      {
        "name": "POIANA SCHEII",
        "zip": "707481",
        "lat": "46.960001",
        "long": "27.493761"
      },
      {
        "name": "POIENI",
        "zip": "707441",
        "lat": "47.050841",
        "long": "27.713466"
      },
      {
        "name": "POIENILE",
        "zip": "707162",
        "lat": "46.96038",
        "long": "27.210064"
      },
      {
        "name": "POPESTI",
        "zip": "707370",
        "lat": "47.152193",
        "long": "27.240937"
      },
      {
        "name": "POPRICANI",
        "zip": "707380",
        "lat": "47.287465",
        "long": "27.513583"
      },
      {
        "name": "POTANGENI",
        "zip": "707353",
        "lat": "47.330041",
        "long": "27.336905"
      },
      {
        "name": "PRIGORENI",
        "zip": "705310",
        "lat": "47.207435",
        "long": "27.068116"
      },
      {
        "name": "PRISACANI",
        "zip": "707390",
        "lat": "47.079158",
        "long": "27.883226"
      },
      {
        "name": "PROBOTA",
        "zip": "707395",
        "lat": "47.376504",
        "long": "27.504508"
      },
      {
        "name": "PROSELNICI",
        "zip": "707314",
        "lat": "47.108741",
        "long": "27.493458"
      },
      {
        "name": "RACHITENI",
        "zip": "707298",
        "lat": "47.053348",
        "long": "26.913375"
      },
      {
        "name": "RADENI",
        "zip": "707522",
        "lat": "47.426275",
        "long": "27.43624"
      },
      {
        "name": "RADUCANENI",
        "zip": "707400",
        "lat": "46.95769",
        "long": "27.938413"
      },
      {
        "name": "RASBOIENI",
        "zip": "707549",
        "lat": "46.931764",
        "long": "27.317163"
      },
      {
        "name": "RAZBOIENI",
        "zip": "705311",
        "lat": "47.217075",
        "long": "27.046573"
      },
      {
        "name": "RECEA",
        "zip": "707551",
        "lat": "46.931184",
        "long": "27.388352"
      },
      {
        "name": "REDIU",
        "zip": "707405",
        "lat": "47.213542",
        "long": "27.505135"
      },
      {
        "name": "REDIU",
        "zip": "707064",
        "lat": "47.193824",
        "long": "27.089205"
      },
      {
        "name": "REDIU",
        "zip": "707422",
        "lat": "47.240414",
        "long": "26.864291"
      },
      {
        "name": "REDIU",
        "zip": "707431",
        "lat": "46.895779",
        "long": "27.591266"
      },
      {
        "name": "REDIU ALDEI",
        "zip": "707022",
        "lat": "47.224376",
        "long": "27.63782"
      },
      {
        "name": "REDIU MITROPOLIEI",
        "zip": "707386",
        "lat": "47.300899",
        "long": "27.491701"
      },
      {
        "name": "ROMANESTI",
        "zip": "707415",
        "lat": "47.282958",
        "long": "27.320025"
      },
      {
        "name": "ROSCANI",
        "zip": "707523",
        "lat": "47.456013",
        "long": "27.398903"
      },
      {
        "name": "ROSU",
        "zip": "707403",
        "lat": "46.988563",
        "long": "27.956855"
      },
      {
        "name": "ROTARIA",
        "zip": "707078",
        "lat": "46.940595",
        "long": "27.871024"
      },
      {
        "name": "RUGINOASA",
        "zip": "707420",
        "lat": "47.242594",
        "long": "26.847186"
      },
      {
        "name": "RUNCU",
        "zip": "707539",
        "lat": "47.007189",
        "long": "27.283256"
      },
      {
        "name": "RUSENII NOI",
        "zip": "707254",
        "lat": "47.197876",
        "long": "27.666845"
      },
      {
        "name": "RUSENII VECHI",
        "zip": "707256",
        "lat": "47.18201",
        "long": "27.682775"
      },
      {
        "name": "SACARESTI",
        "zip": "707153",
        "lat": "47.256624",
        "long": "26.938305"
      },
      {
        "name": "SALAGENI",
        "zip": "707237",
        "lat": "47.013605",
        "long": "28.022119"
      },
      {
        "name": "SANGERI",
        "zip": "707231",
        "lat": "47.388821",
        "long": "27.229179"
      },
      {
        "name": "SARCA",
        "zip": "707031",
        "lat": "47.22981",
        "long": "27.179727"
      },
      {
        "name": "SATU NOU",
        "zip": "707048",
        "lat": "47.32183",
        "long": "27.095"
      },
      {
        "name": "SATU NOU",
        "zip": "707442",
        "lat": "46.966066",
        "long": "27.810269"
      },
      {
        "name": "SATU NOU",
        "zip": "707458",
        "lat": "47.41798",
        "long": "26.719091"
      },
      {
        "name": "SATU NOU",
        "zip": "707482",
        "lat": "46.933214",
        "long": "27.479773"
      },
      {
        "name": "SAVENI",
        "zip": "707229",
        "lat": "47.399703",
        "long": "27.248099"
      },
      {
        "name": "SCANTEIA",
        "zip": "707425",
        "lat": "46.920152",
        "long": "27.578853"
      },
      {
        "name": "SCHEIA",
        "zip": "707007",
        "lat": "47.117139",
        "long": "26.88154"
      },
      {
        "name": "SCHEIA",
        "zip": "707475",
        "lat": "46.930365",
        "long": "27.51622"
      },
      {
        "name": "SCHITU DUCA",
        "zip": "707435",
        "lat": "47.035157",
        "long": "27.769727"
      },
      {
        "name": "SCHITU HADAMBULUI",
        "zip": "707301",
        "lat": "47.009941",
        "long": "27.433512"
      },
      {
        "name": "SCHITU STAVNIC",
        "zip": "707602",
        "lat": "47.068567",
        "long": "27.390926"
      },
      {
        "name": "SCOBALTENI",
        "zip": "707369",
        "lat": "47.201506",
        "long": "27.281054"
      },
      {
        "name": "SCOBINTI",
        "zip": "707445",
        "lat": "47.398964",
        "long": "26.911444"
      },
      {
        "name": "SCOPOSENI",
        "zip": "707213",
        "lat": "46.905436",
        "long": "28.057681"
      },
      {
        "name": "SCOPOSENI",
        "zip": "707262",
        "lat": "47.134059",
        "long": "27.412245"
      },
      {
        "name": "SCULENI",
        "zip": "707584",
        "lat": "47.315207",
        "long": "27.607024"
      },
      {
        "name": "SENDRENI",
        "zip": "707587",
        "lat": "47.356552",
        "long": "27.582593"
      },
      {
        "name": "SERBESTI",
        "zip": "707079",
        "lat": "46.877515",
        "long": "27.849383"
      },
      {
        "name": "SINESTI",
        "zip": "707450",
        "lat": "47.114413",
        "long": "27.193402"
      },
      {
        "name": "SIPOTE",
        "zip": "707485",
        "lat": "47.46954",
        "long": "27.216062"
      },
      {
        "name": "SIRETEL",
        "zip": "707455",
        "lat": "47.384633",
        "long": "26.722181"
      },
      {
        "name": "SLOBOZIA",
        "zip": "707086",
        "lat": "47.018194",
        "long": "27.613535"
      },
      {
        "name": "SLOBOZIA",
        "zip": "707171",
        "lat": "47.477197",
        "long": "26.889582"
      },
      {
        "name": "SLOBOZIA",
        "zip": "707443",
        "lat": "46.988004",
        "long": "27.744362"
      },
      {
        "name": "SLOBOZIA",
        "zip": "707459",
        "lat": "47.398509",
        "long": "26.742737"
      },
      {
        "name": "SLOBOZIA",
        "zip": "707603",
        "lat": "47.056838",
        "long": "27.415988"
      },
      {
        "name": "SOCI",
        "zip": "707328",
        "lat": "47.182731",
        "long": "26.643973"
      },
      {
        "name": "SODOMENI",
        "zip": "705205",
        "lat": "47.222333",
        "long": "26.684475"
      },
      {
        "name": "SOLONET",
        "zip": "707057",
        "lat": "47.497803",
        "long": "27.459251"
      },
      {
        "name": "SOROGARI",
        "zip": "707023",
        "lat": "47.20498",
        "long": "27.584607"
      },
      {
        "name": "SPINENI",
        "zip": "707017",
        "lat": "47.496107",
        "long": "27.318028"
      },
      {
        "name": "SPINOASA",
        "zip": "707192",
        "lat": "47.262769",
        "long": "27.191561"
      },
      {
        "name": "SPRANCEANA",
        "zip": "707193",
        "lat": "47.236203",
        "long": "27.258025"
      },
      {
        "name": "STANCA",
        "zip": "707107",
        "lat": "47.068063",
        "long": "27.807092"
      },
      {
        "name": "STANCA",
        "zip": "707586",
        "lat": "47.283807",
        "long": "27.584707"
      },
      {
        "name": "STEJARII",
        "zip": "707558",
        "lat": "47.377279",
        "long": "27.434242"
      },
      {
        "name": "STICLARIA",
        "zip": "707448",
        "lat": "47.401021",
        "long": "26.836393"
      },
      {
        "name": "STOLNICENI-PRAJESCU",
        "zip": "707460",
        "lat": "47.203892",
        "long": "26.739512"
      },
      {
        "name": "STORNESTI",
        "zip": "707453",
        "lat": "47.115715",
        "long": "27.166252"
      },
      {
        "name": "STROESTI",
        "zip": "707511",
        "lat": "47.326088",
        "long": "26.887039"
      },
      {
        "name": "STRUNGA",
        "zip": "707465",
        "lat": "47.164312",
        "long": "26.955483"
      },
      {
        "name": "SUHULET",
        "zip": "707496",
        "lat": "46.903681",
        "long": "27.258492"
      },
      {
        "name": "TABARA",
        "zip": "707058",
        "lat": "47.574102",
        "long": "27.413399"
      },
      {
        "name": "TANSA",
        "zip": "707049",
        "lat": "47.301392",
        "long": "27.076527"
      },
      {
        "name": "TANSA",
        "zip": "707495",
        "lat": "46.912555",
        "long": "27.237667"
      },
      {
        "name": "TARGU FRUMOS",
        "zip": "705300",
        "lat": "47.210064",
        "long": "27.013665"
      },
      {
        "name": "TARNITA",
        "zip": "707163",
        "lat": "46.977259",
        "long": "27.18101"
      },
      {
        "name": "TATARUSI",
        "zip": "707500",
        "lat": "47.344461",
        "long": "26.593736"
      },
      {
        "name": "TAUTESTI",
        "zip": "707408",
        "lat": "47.233438",
        "long": "27.46522"
      },
      {
        "name": "TIBANA",
        "zip": "707530",
        "lat": "46.986648",
        "long": "27.339452"
      },
      {
        "name": "TIBANESTI",
        "zip": "707545",
        "lat": "46.907089",
        "long": "27.338088"
      },
      {
        "name": "TIGANASI",
        "zip": "707555",
        "lat": "47.330346",
        "long": "27.470805"
      },
      {
        "name": "TIPILESTI",
        "zip": "707387",
        "lat": "47.299962",
        "long": "27.48141"
      },
      {
        "name": "TODIREL",
        "zip": "707039",
        "lat": "47.067552",
        "long": "27.611849"
      },
      {
        "name": "TODIRESTI",
        "zip": "707505",
        "lat": "47.324591",
        "long": "26.833856"
      },
      {
        "name": "TOMESTI",
        "zip": "707515",
        "lat": "47.131367",
        "long": "27.698602"
      },
      {
        "name": "TOPILE",
        "zip": "707572",
        "lat": "47.262226",
        "long": "26.668793"
      },
      {
        "name": "TOTOESTI",
        "zip": "707194",
        "lat": "47.25227",
        "long": "27.286843"
      },
      {
        "name": "TRAIAN",
        "zip": "707059",
        "lat": "47.50236",
        "long": "27.418368"
      },
      {
        "name": "TRIFESTI",
        "zip": "707520",
        "lat": "47.465245",
        "long": "27.503693"
      },
      {
        "name": "TUDOR VLADIMIRESCU",
        "zip": "707337",
        "lat": "47.133171",
        "long": "26.779503"
      },
      {
        "name": "TUFESTII DE SUS",
        "zip": "707432",
        "lat": "46.913176",
        "long": "27.626968"
      },
      {
        "name": "TUNGUJEI",
        "zip": "707552",
        "lat": "46.92546",
        "long": "27.36633"
      },
      {
        "name": "TUTORA",
        "zip": "707560",
        "lat": "47.134106",
        "long": "27.793918"
      },
      {
        "name": "UDA",
        "zip": "707503",
        "lat": "47.336452",
        "long": "26.57165"
      },
      {
        "name": "ULMI",
        "zip": "707051",
        "lat": "47.283026",
        "long": "27.067744"
      },
      {
        "name": "UNGHENI",
        "zip": "707565",
        "lat": "47.201245",
        "long": "27.784646"
      },
      {
        "name": "URICANI",
        "zip": "707316",
        "lat": "47.156943",
        "long": "27.486111"
      },
      {
        "name": "URSARESTI",
        "zip": "707299",
        "lat": "47.058798",
        "long": "26.894599"
      },
      {
        "name": "URSITA",
        "zip": "707302",
        "lat": "47.015531",
        "long": "27.409772"
      },
      {
        "name": "URSOAIA",
        "zip": "707417",
        "lat": "47.272726",
        "long": "27.385623"
      },
      {
        "name": "VADU VEJEI",
        "zip": "707541",
        "lat": "46.996084",
        "long": "27.243993"
      },
      {
        "name": "VALCELELE",
        "zip": "707596",
        "lat": "47.43323",
        "long": "27.365001"
      },
      {
        "name": "VALCICA",
        "zip": "707504",
        "lat": "47.332651",
        "long": "26.635148"
      },
      {
        "name": "VALEA ADANCA",
        "zip": "707317",
        "lat": "47.125551",
        "long": "27.556496"
      },
      {
        "name": "VALEA LUNGA",
        "zip": "707257",
        "lat": "47.186438",
        "long": "27.647104"
      },
      {
        "name": "VALEA LUPULUI",
        "zip": "707410",
        "lat": "47.177386",
        "long": "27.502139"
      },
      {
        "name": "VALEA OILOR",
        "zip": "707032",
        "lat": "47.24375",
        "long": "27.101732"
      },
      {
        "name": "VALEA RACULUI",
        "zip": "707131",
        "lat": "47.362604",
        "long": "26.876673"
      },
      {
        "name": "VALEA SATULUI",
        "zip": "707222",
        "lat": "46.952859",
        "long": "27.551605"
      },
      {
        "name": "VALEA SEACA",
        "zip": "707570",
        "lat": "47.291627",
        "long": "26.668237"
      },
      {
        "name": "VALEA URSULUI",
        "zip": "707318",
        "lat": "47.135553",
        "long": "27.490255"
      },
      {
        "name": "VALENII",
        "zip": "707553",
        "lat": "46.895364",
        "long": "27.280034"
      },
      {
        "name": "VAMA",
        "zip": "707376",
        "lat": "47.115679",
        "long": "27.24171"
      },
      {
        "name": "VANATORI",
        "zip": "707388",
        "lat": "47.24338",
        "long": "27.524177"
      },
      {
        "name": "VANATORI",
        "zip": "707575",
        "lat": "47.359797",
        "long": "26.764226"
      },
      {
        "name": "VASCANI",
        "zip": "707423",
        "lat": "47.272709",
        "long": "26.873738"
      },
      {
        "name": "VERSENI",
        "zip": "707329",
        "lat": "47.112596",
        "long": "26.642769"
      },
      {
        "name": "VICTORIA",
        "zip": "707580",
        "lat": "47.295209",
        "long": "27.593675"
      },
      {
        "name": "VISAN",
        "zip": "707041",
        "lat": "47.112467",
        "long": "27.604417"
      },
      {
        "name": "VLADENI",
        "zip": "707590",
        "lat": "47.4159",
        "long": "27.330221"
      },
      {
        "name": "VLADICENI",
        "zip": "707518",
        "lat": "47.130095",
        "long": "27.664142"
      },
      {
        "name": "VLADNICUT",
        "zip": "707579",
        "lat": "47.364225",
        "long": "26.799257"
      },
      {
        "name": "VLADOMIRA",
        "zip": "707524",
        "lat": "47.419156",
        "long": "27.562983"
      },
      {
        "name": "VOCOTESTI",
        "zip": "707604",
        "lat": "47.081863",
        "long": "27.464448"
      },
      {
        "name": "VOINESTI",
        "zip": "707600",
        "lat": "47.077239",
        "long": "27.432001"
      },
      {
        "name": "VOLINTIRESTI",
        "zip": "707008",
        "lat": "47.169461",
        "long": "26.827849"
      },
      {
        "name": "VOROVESTI",
        "zip": "707319",
        "lat": "47.140376",
        "long": "27.460781"
      },
      {
        "name": "VULTURI",
        "zip": "707389",
        "lat": "47.247412",
        "long": "27.535979"
      },
      {
        "name": "ZABOLOTENI",
        "zip": "707526",
        "lat": "47.475925",
        "long": "27.497803"
      },
      {
        "name": "ZAGAVIA",
        "zip": "707449",
        "lat": "47.419101",
        "long": "26.897908"
      },
      {
        "name": "ZBERENI",
        "zip": "707132",
        "lat": "47.368529",
        "long": "26.849032"
      },
      {
        "name": "ZBEROAIA",
        "zip": "707214",
        "lat": "46.926225",
        "long": "28.039624"
      },
      {
        "name": "ZECE PRAJINI",
        "zip": "707164",
        "lat": "46.939434",
        "long": "27.183216"
      },
      {
        "name": "ZLODICA",
        "zip": "707073",
        "lat": "47.367539",
        "long": "26.936677"
      },
      {
        "name": "ZMEU",
        "zip": "707288",
        "lat": "47.191612",
        "long": "27.179161"
      }
    ],
    "ILFOV": [
      {
        "name": "1 DECEMBRIE",
        "zip": "077005",
        "lat": "44.288061",
        "long": "26.060031"
      },
      {
        "name": "AFUMATI",
        "zip": "077010",
        "lat": "44.525471",
        "long": "26.249642"
      },
      {
        "name": "ALUNISU",
        "zip": "077126",
        "lat": "44.341066",
        "long": "26.050778"
      },
      {
        "name": "BALACEANCA",
        "zip": "077036",
        "lat": "44.393112",
        "long": "26.289654"
      },
      {
        "name": "BALOTESTI",
        "zip": "077015",
        "lat": "44.612794",
        "long": "26.078737"
      },
      {
        "name": "BALTA NEAGRA",
        "zip": "077141",
        "lat": "44.697478",
        "long": "26.304975"
      },
      {
        "name": "BALTENI",
        "zip": "077151",
        "lat": "44.714445",
        "long": "26.032798"
      },
      {
        "name": "BERCENI",
        "zip": "077020",
        "lat": "44.317075",
        "long": "26.184704"
      },
      {
        "name": "BRAGADIRU",
        "zip": "077025",
        "lat": "44.373512",
        "long": "25.980494"
      },
      {
        "name": "BRANESTI",
        "zip": "077030",
        "lat": "44.457562",
        "long": "26.33501"
      },
      {
        "name": "BUCIUMENI",
        "zip": "070001",
        "lat": "44.549144",
        "long": "25.963754"
      },
      {
        "name": "BUDA",
        "zip": "077071",
        "lat": "44.354401",
        "long": "25.959366"
      },
      {
        "name": "BUFTEA",
        "zip": "070000",
        "lat": "44.559864",
        "long": "25.949868"
      },
      {
        "name": "BURIAS",
        "zip": "077152",
        "lat": "44.733036",
        "long": "25.980527"
      },
      {
        "name": "CACIULATI",
        "zip": "077131",
        "lat": "44.626589",
        "long": "26.171389"
      },
      {
        "name": "CALDARARU",
        "zip": "077037",
        "lat": "44.412296",
        "long": "26.262364"
      },
      {
        "name": "CATELU",
        "zip": "077106",
        "lat": "44.402966",
        "long": "26.217932"
      },
      {
        "name": "CERNICA",
        "zip": "077035",
        "lat": "44.417714",
        "long": "26.281724"
      },
      {
        "name": "CHIAJNA",
        "zip": "077040",
        "lat": "44.459431",
        "long": "25.97845"
      },
      {
        "name": "CHITILA",
        "zip": "077045",
        "lat": "44.505979",
        "long": "25.987679"
      },
      {
        "name": "CIOFLICENI",
        "zip": "077166",
        "lat": "44.682181",
        "long": "26.118201"
      },
      {
        "name": "CIOLPANI",
        "zip": "077050",
        "lat": "44.725391",
        "long": "26.105216"
      },
      {
        "name": "CIOROGARLA",
        "zip": "077055",
        "lat": "44.443366",
        "long": "25.884539"
      },
      {
        "name": "CLINCENI",
        "zip": "077060",
        "lat": "44.378684",
        "long": "25.9412"
      },
      {
        "name": "COPACENI",
        "zip": "077006",
        "lat": "44.271623",
        "long": "26.079382"
      },
      {
        "name": "CORBEANCA",
        "zip": "077065",
        "lat": "44.595013",
        "long": "26.042808"
      },
      {
        "name": "CORNETU",
        "zip": "077070",
        "lat": "44.343315",
        "long": "25.942342"
      },
      {
        "name": "COZIENI",
        "zip": "077101",
        "lat": "44.478973",
        "long": "26.300334"
      },
      {
        "name": "CREATA",
        "zip": "077076",
        "lat": "44.596155",
        "long": "26.271505"
      },
      {
        "name": "CRETESTI",
        "zip": "077186",
        "lat": "44.27694",
        "long": "26.136397"
      },
      {
        "name": "CRETULEASCA",
        "zip": "077176",
        "lat": "44.533325",
        "long": "26.187983"
      },
      {
        "name": "DARASTI-ILFOV",
        "zip": "077080",
        "lat": "44.309578",
        "long": "26.018152"
      },
      {
        "name": "DARVARI",
        "zip": "077056",
        "lat": "44.421314",
        "long": "25.878049"
      },
      {
        "name": "DASCALU",
        "zip": "077075",
        "lat": "44.601162",
        "long": "26.230094"
      },
      {
        "name": "DIMIENI",
        "zip": "077181",
        "lat": "44.588658",
        "long": "26.135895"
      },
      {
        "name": "DOBROESTI",
        "zip": "077085",
        "lat": "44.450877",
        "long": "26.182501"
      },
      {
        "name": "DOMNESTI",
        "zip": "077090",
        "lat": "44.400395",
        "long": "25.911145"
      },
      {
        "name": "DRAGOMIRESTI-DEAL",
        "zip": "077096",
        "lat": "44.458948",
        "long": "25.94575"
      },
      {
        "name": "DRAGOMIRESTI-VALE",
        "zip": "077095",
        "lat": "44.474817",
        "long": "25.93671"
      },
      {
        "name": "DUDU",
        "zip": "077041",
        "lat": "44.456238",
        "long": "25.990478"
      },
      {
        "name": "DUMBRAVENI",
        "zip": "077016",
        "lat": "44.630816",
        "long": "26.107855"
      },
      {
        "name": "DUMITRANA",
        "zip": "077127",
        "lat": "44.323334",
        "long": "25.997292"
      },
      {
        "name": "FUNDENI",
        "zip": "077086",
        "lat": "44.46198",
        "long": "26.166898"
      },
      {
        "name": "GAGU",
        "zip": "077077",
        "lat": "44.615205",
        "long": "26.262631"
      },
      {
        "name": "GANEASA",
        "zip": "077100",
        "lat": "44.491848",
        "long": "26.285433"
      },
      {
        "name": "GHERMANESTI",
        "zip": "077170",
        "lat": "44.68934",
        "long": "26.14466"
      },
      {
        "name": "GLINA",
        "zip": "077105",
        "lat": "44.386237",
        "long": "26.245198"
      },
      {
        "name": "GRADISTEA",
        "zip": "077110",
        "lat": "44.662085",
        "long": "26.300577"
      },
      {
        "name": "GRUIU",
        "zip": "077115",
        "lat": "44.724739",
        "long": "26.227937"
      },
      {
        "name": "ISLAZ",
        "zip": "077031",
        "lat": "44.461173",
        "long": "26.387239"
      },
      {
        "name": "IZVORANI",
        "zip": "077051",
        "lat": "44.69356",
        "long": "26.119725"
      },
      {
        "name": "JILAVA",
        "zip": "077120",
        "lat": "44.335871",
        "long": "26.080996"
      },
      {
        "name": "LIPIA",
        "zip": "077116",
        "lat": "44.713395",
        "long": "26.263557"
      },
      {
        "name": "LUPARIA",
        "zip": "077052",
        "lat": "44.744532",
        "long": "26.110842"
      },
      {
        "name": "MAGURELE",
        "zip": "077125",
        "lat": "44.350263",
        "long": "26.029239"
      },
      {
        "name": "MAINEASCA",
        "zip": "077156",
        "lat": "44.575284",
        "long": "26.350597"
      },
      {
        "name": "MANOLACHE",
        "zip": "077107",
        "lat": "44.404626",
        "long": "26.246863"
      },
      {
        "name": "MERII PETCHII",
        "zip": "077142",
        "lat": "44.741677",
        "long": "26.309589"
      },
      {
        "name": "MICSUNESTI-MOARA",
        "zip": "077143",
        "lat": "44.700756",
        "long": "26.328786"
      },
      {
        "name": "MICSUNESTII MARI",
        "zip": "077144",
        "lat": "44.690953",
        "long": "26.355359"
      },
      {
        "name": "MOARA DOMNEASCA",
        "zip": "077102",
        "lat": "44.492712",
        "long": "26.255702"
      },
      {
        "name": "MOARA VLASIEI",
        "zip": "077130",
        "lat": "44.642435",
        "long": "26.22192"
      },
      {
        "name": "MOGOSOAIA",
        "zip": "077135",
        "lat": "44.530002",
        "long": "26.000486"
      },
      {
        "name": "NUCI",
        "zip": "077140",
        "lat": "44.721416",
        "long": "26.300836"
      },
      {
        "name": "ODAILE",
        "zip": "075101",
        "lat": "44.534439",
        "long": "26.057744"
      },
      {
        "name": "OLTENI",
        "zip": "077061",
        "lat": "44.396495",
        "long": "25.960143"
      },
      {
        "name": "ORDOREANU",
        "zip": "077062",
        "lat": "44.363867",
        "long": "25.893435"
      },
      {
        "name": "OSTRATU",
        "zip": "077066",
        "lat": "44.605954",
        "long": "26.013938"
      },
      {
        "name": "OTOPENI",
        "zip": "075100",
        "lat": "44.550813",
        "long": "26.072911"
      },
      {
        "name": "PANTELIMON",
        "zip": "077145",
        "lat": "44.451879",
        "long": "26.203556"
      },
      {
        "name": "PASAREA",
        "zip": "077032",
        "lat": "44.473185",
        "long": "26.319271"
      },
      {
        "name": "PERIS",
        "zip": "077150",
        "lat": "44.678429",
        "long": "26.014578"
      },
      {
        "name": "PETRACHIOAIA",
        "zip": "077155",
        "lat": "44.582785",
        "long": "26.312098"
      },
      {
        "name": "PETRESTI",
        "zip": "077067",
        "lat": "44.600318",
        "long": "26.064962"
      },
      {
        "name": "PISCU",
        "zip": "077053",
        "lat": "44.734654",
        "long": "26.071899"
      },
      {
        "name": "PITEASCA",
        "zip": "077103",
        "lat": "44.493305",
        "long": "26.329128"
      },
      {
        "name": "POPESTI-LEORDENI",
        "zip": "077160",
        "lat": "44.379452",
        "long": "26.167727"
      },
      {
        "name": "POSTA",
        "zip": "077038",
        "lat": "44.378538",
        "long": "26.310669"
      },
      {
        "name": "PRUNI",
        "zip": "077128",
        "lat": "44.329606",
        "long": "25.989068"
      },
      {
        "name": "ROSU",
        "zip": "077042",
        "lat": "44.450887",
        "long": "26.00827"
      },
      {
        "name": "RUDENI",
        "zip": "077046",
        "lat": "44.472541",
        "long": "25.970598"
      },
      {
        "name": "RUNCU",
        "zip": "077078",
        "lat": "44.585194",
        "long": "26.206169"
      },
      {
        "name": "SAFTICA",
        "zip": "077017",
        "lat": "44.620605",
        "long": "26.069531"
      },
      {
        "name": "SANTU-FLORESTI",
        "zip": "077118",
        "lat": "44.733927",
        "long": "26.208677"
      },
      {
        "name": "SILISTEA SNAGOVULUI",
        "zip": "077117",
        "lat": "44.739747",
        "long": "26.178434"
      },
      {
        "name": "SINDRILITA",
        "zip": "077104",
        "lat": "44.514128",
        "long": "26.319507"
      },
      {
        "name": "SINTESTI",
        "zip": "077187",
        "lat": "44.313919",
        "long": "26.109428"
      },
      {
        "name": "SITARU",
        "zip": "077111",
        "lat": "44.66889",
        "long": "26.328204"
      },
      {
        "name": "SNAGOV",
        "zip": "077165",
        "lat": "44.707498",
        "long": "26.172865"
      },
      {
        "name": "STEFANESTII DE JOS",
        "zip": "077175",
        "lat": "44.532974",
        "long": "26.202937"
      },
      {
        "name": "STEFANESTII DE SUS",
        "zip": "077177",
        "lat": "44.539062",
        "long": "26.205823"
      },
      {
        "name": "SURLARI",
        "zip": "077157",
        "lat": "44.571672",
        "long": "26.315236"
      },
      {
        "name": "TAMASI",
        "zip": "077068",
        "lat": "44.583637",
        "long": "26.006027"
      },
      {
        "name": "TANCABESTI",
        "zip": "077167",
        "lat": "44.675562",
        "long": "26.078855"
      },
      {
        "name": "TANGANU",
        "zip": "077039",
        "lat": "44.405583",
        "long": "26.31165"
      },
      {
        "name": "TEGHES",
        "zip": "077091",
        "lat": "44.381134",
        "long": "25.868328"
      },
      {
        "name": "TUNARI",
        "zip": "077180",
        "lat": "44.547175",
        "long": "26.141276"
      },
      {
        "name": "VADU ANEI",
        "zip": "077033",
        "lat": "44.422688",
        "long": "26.353341"
      },
      {
        "name": "VANATORI",
        "zip": "077158",
        "lat": "44.592091",
        "long": "26.294079"
      },
      {
        "name": "VARTEJU",
        "zip": "077129",
        "lat": "44.356231",
        "long": "25.989428"
      },
      {
        "name": "VIDRA",
        "zip": "077185",
        "lat": "44.262616",
        "long": "26.164419"
      },
      {
        "name": "VLADICEASCA",
        "zip": "077168",
        "lat": "44.668789",
        "long": "26.086166"
      },
      {
        "name": "VOLUNTARI",
        "zip": "077190",
        "lat": "44.490278",
        "long": "26.177279"
      },
      {
        "name": "ZURBAUA",
        "zip": "077097",
        "lat": "44.489456",
        "long": "25.913928"
      }
    ],
    "MARAMUREȘ": [
      {
        "name": "ARDUSAT",
        "zip": "437005",
        "lat": "47.649873",
        "long": "23.362281"
      },
      {
        "name": "ARDUZEL",
        "zip": "437356",
        "lat": "47.448045",
        "long": "23.266862"
      },
      {
        "name": "ARIESU DE CAMP",
        "zip": "437006",
        "lat": "47.63977",
        "long": "23.398726"
      },
      {
        "name": "ARIESU DE PADURE",
        "zip": "437271",
        "lat": "47.586238",
        "long": "23.479106"
      },
      {
        "name": "ARINIS",
        "zip": "437010",
        "lat": "47.501023",
        "long": "23.230477"
      },
      {
        "name": "ASPRA",
        "zip": "437381",
        "lat": "47.449421",
        "long": "23.637461"
      },
      {
        "name": "ASUAJU DE JOS",
        "zip": "437016",
        "lat": "47.540519",
        "long": "23.222987"
      },
      {
        "name": "ASUAJU DE SUS",
        "zip": "437015",
        "lat": "47.567033",
        "long": "23.182451"
      },
      {
        "name": "BABA",
        "zip": "437127",
        "lat": "47.340268",
        "long": "23.745611"
      },
      {
        "name": "BAIA MARE",
        "zip": "430011",
        "lat": "47.656558",
        "long": "23.571984"
      },
      {
        "name": "BAIA SPRIE",
        "zip": "435100",
        "lat": "47.661591",
        "long": "23.692209"
      },
      {
        "name": "BAILE BORSA",
        "zip": "435250",
        "lat": "47.684158",
        "long": "24.713912"
      },
      {
        "name": "BAITA",
        "zip": "437346",
        "lat": "47.704521",
        "long": "23.492201"
      },
      {
        "name": "BAITA DE SUB CODRU",
        "zip": "437020",
        "lat": "47.52975",
        "long": "23.149826"
      },
      {
        "name": "BAIUT",
        "zip": "437025",
        "lat": "47.613987",
        "long": "23.997519"
      },
      {
        "name": "BARGAU",
        "zip": "437096",
        "lat": "47.683438",
        "long": "23.399712"
      },
      {
        "name": "BARSANA",
        "zip": "437035",
        "lat": "47.816864",
        "long": "24.05902"
      },
      {
        "name": "BASESTI",
        "zip": "437030",
        "lat": "47.480591",
        "long": "23.146224"
      },
      {
        "name": "BERBESTI",
        "zip": "437161",
        "lat": "47.848651",
        "long": "23.934477"
      },
      {
        "name": "BERCHEZ",
        "zip": "437231",
        "lat": "47.518924",
        "long": "23.505693"
      },
      {
        "name": "BERCHEZOAIA",
        "zip": "437232",
        "lat": "47.49842",
        "long": "23.53844"
      },
      {
        "name": "BERINTA",
        "zip": "437101",
        "lat": "47.540669",
        "long": "23.676929"
      },
      {
        "name": "BICAZ",
        "zip": "437040",
        "lat": "47.46177",
        "long": "23.03685"
      },
      {
        "name": "BISTRA",
        "zip": "437045",
        "lat": "47.865025",
        "long": "24.191371"
      },
      {
        "name": "BLIDARI",
        "zip": "430001",
        "lat": "47.783822",
        "long": "23.612339"
      },
      {
        "name": "BOCICOEL",
        "zip": "437056",
        "lat": "47.697884",
        "long": "24.319946"
      },
      {
        "name": "BOCICOIU MARE",
        "zip": "437050",
        "lat": "47.963455",
        "long": "24.013564"
      },
      {
        "name": "BOGDAN VODA",
        "zip": "437055",
        "lat": "47.690365",
        "long": "24.267471"
      },
      {
        "name": "BOIERENI",
        "zip": "435601",
        "lat": "47.388859",
        "long": "23.930483"
      },
      {
        "name": "BOIU MARE",
        "zip": "437060",
        "lat": "47.395601",
        "long": "23.584135"
      },
      {
        "name": "BONTAIENI",
        "zip": "437326",
        "lat": "47.612215",
        "long": "23.7216"
      },
      {
        "name": "BORCUT",
        "zip": "435602",
        "lat": "47.481998",
        "long": "23.840714"
      },
      {
        "name": "BORSA",
        "zip": "435200",
        "lat": "47.655657",
        "long": "24.664542"
      },
      {
        "name": "BOTIZA",
        "zip": "437065",
        "lat": "47.668518",
        "long": "24.151517"
      },
      {
        "name": "BOZANTA MARE",
        "zip": "437347",
        "lat": "47.639658",
        "long": "23.441655"
      },
      {
        "name": "BOZANTA MICA",
        "zip": "437226",
        "lat": "47.636414",
        "long": "23.422357"
      },
      {
        "name": "BREB",
        "zip": "437206",
        "lat": "47.748541",
        "long": "23.904939"
      },
      {
        "name": "BREBENI",
        "zip": "437086",
        "lat": "47.503582",
        "long": "23.781356"
      },
      {
        "name": "BUCIUMI",
        "zip": "437336",
        "lat": "47.470325",
        "long": "23.489258"
      },
      {
        "name": "BUDESTI",
        "zip": "437070",
        "lat": "47.730449",
        "long": "23.946482"
      },
      {
        "name": "BUSAG",
        "zip": "437348",
        "lat": "47.658715",
        "long": "23.427752"
      },
      {
        "name": "BUTEASA",
        "zip": "437337",
        "lat": "47.448303",
        "long": "23.549878"
      },
      {
        "name": "BUZESTI",
        "zip": "437156",
        "lat": "47.608449",
        "long": "23.354169"
      },
      {
        "name": "CALINESTI",
        "zip": "437075",
        "lat": "47.7858",
        "long": "23.971524"
      },
      {
        "name": "CAMPULUNG LA TISA",
        "zip": "437080",
        "lat": "47.987382",
        "long": "23.769229"
      },
      {
        "name": "CARBUNARI",
        "zip": "437146",
        "lat": "47.574582",
        "long": "23.638893"
      },
      {
        "name": "CARPINIS",
        "zip": "437102",
        "lat": "47.571708",
        "long": "23.699626"
      },
      {
        "name": "CATALINA",
        "zip": "437281",
        "lat": "47.603835",
        "long": "23.544591"
      },
      {
        "name": "CAVNIC",
        "zip": "435300",
        "lat": "47.654006",
        "long": "23.828325"
      },
      {
        "name": "CERNESTI",
        "zip": "437085",
        "lat": "47.508368",
        "long": "23.742527"
      },
      {
        "name": "CETATELE",
        "zip": "437327",
        "lat": "47.598809",
        "long": "23.73945"
      },
      {
        "name": "CHECHIS",
        "zip": "437147",
        "lat": "47.584414",
        "long": "23.603885"
      },
      {
        "name": "CHELINTA",
        "zip": "437357",
        "lat": "47.453107",
        "long": "23.317987"
      },
      {
        "name": "CHIUZBAIA",
        "zip": "435101",
        "lat": "47.701076",
        "long": "23.680029"
      },
      {
        "name": "CICARLAU",
        "zip": "437095",
        "lat": "47.691545",
        "long": "23.403797"
      },
      {
        "name": "CIOCOTIS",
        "zip": "437087",
        "lat": "47.55666",
        "long": "23.796499"
      },
      {
        "name": "CIOLT",
        "zip": "437338",
        "lat": "47.483853",
        "long": "23.509443"
      },
      {
        "name": "CIUTA",
        "zip": "437041",
        "lat": "47.447138",
        "long": "22.98833"
      },
      {
        "name": "COAS",
        "zip": "437282",
        "lat": "47.539569",
        "long": "23.585838"
      },
      {
        "name": "CODRU BUTESII",
        "zip": "437339",
        "lat": "47.468179",
        "long": "23.601463"
      },
      {
        "name": "COLTAU",
        "zip": "437283",
        "lat": "47.598305",
        "long": "23.523863"
      },
      {
        "name": "COLTIREA",
        "zip": "437007",
        "lat": "47.609961",
        "long": "23.405197"
      },
      {
        "name": "COPALNIC",
        "zip": "437103",
        "lat": "47.520418",
        "long": "23.655627"
      },
      {
        "name": "COPALNIC-DEAL",
        "zip": "437104",
        "lat": "47.512435",
        "long": "23.64907"
      },
      {
        "name": "COPALNIC-MANASTUR",
        "zip": "437100",
        "lat": "47.509149",
        "long": "23.679265"
      },
      {
        "name": "CORNESTI",
        "zip": "437076",
        "lat": "47.816755",
        "long": "23.968117"
      },
      {
        "name": "CORNI",
        "zip": "437042",
        "lat": "47.478318",
        "long": "23.019043"
      },
      {
        "name": "COROIENI",
        "zip": "437126",
        "lat": "47.374654",
        "long": "23.764299"
      },
      {
        "name": "CORUIA",
        "zip": "437284",
        "lat": "47.563348",
        "long": "23.59653"
      },
      {
        "name": "COSTENI",
        "zip": "437131",
        "lat": "47.537054",
        "long": "23.914646"
      },
      {
        "name": "COSTIUI",
        "zip": "437251",
        "lat": "47.879312",
        "long": "24.030317"
      },
      {
        "name": "CRACIUNESTI",
        "zip": "437051",
        "lat": "47.955505",
        "long": "23.98267"
      },
      {
        "name": "CRASNA VISEULUI",
        "zip": "437046",
        "lat": "47.83686",
        "long": "24.237024"
      },
      {
        "name": "CUFOAIA",
        "zip": "435603",
        "lat": "47.479244",
        "long": "23.803382"
      },
      {
        "name": "CULCEA",
        "zip": "437286",
        "lat": "47.56609",
        "long": "23.555362"
      },
      {
        "name": "CUPSENI",
        "zip": "437130",
        "lat": "47.541428",
        "long": "23.934338"
      },
      {
        "name": "CURTUIUSU MARE",
        "zip": "437371",
        "lat": "47.427433",
        "long": "23.447772"
      },
      {
        "name": "CURTUIUSU MIC",
        "zip": "437106",
        "lat": "47.542993",
        "long": "23.625311"
      },
      {
        "name": "DAMACUSENI",
        "zip": "435604",
        "lat": "47.455386",
        "long": "23.907039"
      },
      {
        "name": "DANESTI",
        "zip": "437328",
        "lat": "47.616568",
        "long": "23.734735"
      },
      {
        "name": "DANESTII CHIOARULUI",
        "zip": "437186",
        "lat": "47.553816",
        "long": "23.344784"
      },
      {
        "name": "DEALU CORBULUI",
        "zip": "437382",
        "lat": "47.449665",
        "long": "23.685233"
      },
      {
        "name": "DEALU MARE",
        "zip": "437128",
        "lat": "47.360265",
        "long": "23.815206"
      },
      {
        "name": "DESESTI",
        "zip": "437135",
        "lat": "47.772458",
        "long": "23.859147"
      },
      {
        "name": "DOBRICU LAPUSULUI",
        "zip": "435605",
        "lat": "47.497059",
        "long": "23.905085"
      },
      {
        "name": "DRAGHIA",
        "zip": "437129",
        "lat": "47.351663",
        "long": "23.774784"
      },
      {
        "name": "DRAGOMIRESTI",
        "zip": "437140",
        "lat": "47.666564",
        "long": "24.291793"
      },
      {
        "name": "DUMBRAVA",
        "zip": "435606",
        "lat": "47.490311",
        "long": "23.874027"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "437145",
        "lat": "47.598927",
        "long": "23.652179"
      },
      {
        "name": "DURUSA",
        "zip": "437372",
        "lat": "47.412914",
        "long": "23.464734"
      },
      {
        "name": "FANATE",
        "zip": "437088",
        "lat": "47.534638",
        "long": "23.757919"
      },
      {
        "name": "FANTANELE",
        "zip": "435607",
        "lat": "47.411351",
        "long": "23.826001"
      },
      {
        "name": "FARCASA",
        "zip": "437155",
        "lat": "47.584186",
        "long": "23.327167"
      },
      {
        "name": "FAURESTI",
        "zip": "437107",
        "lat": "47.563194",
        "long": "23.750049"
      },
      {
        "name": "FERESTI",
        "zip": "437162",
        "lat": "47.832187",
        "long": "23.94961"
      },
      {
        "name": "FERICEA",
        "zip": "437373",
        "lat": "47.406323",
        "long": "23.389843"
      },
      {
        "name": "FERSIG",
        "zip": "437272",
        "lat": "47.544148",
        "long": "23.382181"
      },
      {
        "name": "FINTEUSU MARE",
        "zip": "437341",
        "lat": "47.540006",
        "long": "23.464512"
      },
      {
        "name": "FINTEUSU MIC",
        "zip": "437273",
        "lat": "47.567788",
        "long": "23.453901"
      },
      {
        "name": "FIRIZA",
        "zip": "430002",
        "lat": "47.751165",
        "long": "23.604595"
      },
      {
        "name": "FRANCENII BOIULUI",
        "zip": "437061",
        "lat": "47.399692",
        "long": "23.61791"
      },
      {
        "name": "GARDANI",
        "zip": "437301",
        "lat": "47.551354",
        "long": "23.308798"
      },
      {
        "name": "GIULESTI",
        "zip": "437160",
        "lat": "47.82198",
        "long": "23.931328"
      },
      {
        "name": "GLOD",
        "zip": "437311",
        "lat": "47.725728",
        "long": "24.078567"
      },
      {
        "name": "GROAPE",
        "zip": "435608",
        "lat": "47.44449",
        "long": "23.725301"
      },
      {
        "name": "GROSI",
        "zip": "437165",
        "lat": "47.617401",
        "long": "23.611502"
      },
      {
        "name": "GROSII TIBLESULUI",
        "zip": "437316",
        "lat": "47.48927",
        "long": "24.061794"
      },
      {
        "name": "HANDALU ILBEI",
        "zip": "437097",
        "lat": "47.735498",
        "long": "23.36451"
      },
      {
        "name": "HARNICESTI",
        "zip": "437136",
        "lat": "47.782131",
        "long": "23.886589"
      },
      {
        "name": "HIDEAGA",
        "zip": "437274",
        "lat": "47.591325",
        "long": "23.42202"
      },
      {
        "name": "HOTENI",
        "zip": "437207",
        "lat": "47.771915",
        "long": "23.899933"
      },
      {
        "name": "HOVRILA",
        "zip": "437342",
        "lat": "47.459091",
        "long": "23.50806"
      },
      {
        "name": "IADARA",
        "zip": "437187",
        "lat": "47.478885",
        "long": "23.397198"
      },
      {
        "name": "IAPA",
        "zip": "435501",
        "lat": "47.925131",
        "long": "23.825387"
      },
      {
        "name": "IEUD",
        "zip": "437170",
        "lat": "47.679908",
        "long": "24.237601"
      },
      {
        "name": "ILBA",
        "zip": "437098",
        "lat": "47.71264",
        "long": "23.358408"
      },
      {
        "name": "INAU",
        "zip": "435609",
        "lat": "47.517334",
        "long": "23.824835"
      },
      {
        "name": "INTRERAURI",
        "zip": "437287",
        "lat": "47.486073",
        "long": "23.615087"
      },
      {
        "name": "IZVOARELE",
        "zip": "437089",
        "lat": "47.595579",
        "long": "23.867512"
      },
      {
        "name": "JUGASTRENI",
        "zip": "437383",
        "lat": "47.39527",
        "long": "23.664248"
      },
      {
        "name": "LAPUS",
        "zip": "437175",
        "lat": "47.493715",
        "long": "24.006175"
      },
      {
        "name": "LAPUSEL",
        "zip": "437227",
        "lat": "47.618299",
        "long": "23.479133"
      },
      {
        "name": "LARGA",
        "zip": "437317",
        "lat": "47.452008",
        "long": "24.105069"
      },
      {
        "name": "LASCHIA",
        "zip": "437108",
        "lat": "47.543318",
        "long": "23.732142"
      },
      {
        "name": "LAZU BACIULUI",
        "zip": "435502",
        "lat": "47.905131",
        "long": "23.920522"
      },
      {
        "name": "LEORDINA",
        "zip": "437180",
        "lat": "47.789486",
        "long": "24.247288"
      },
      {
        "name": "LIBOTIN",
        "zip": "437132",
        "lat": "47.505412",
        "long": "23.968326"
      },
      {
        "name": "LUCACESTI",
        "zip": "437188",
        "lat": "47.539956",
        "long": "23.335504"
      },
      {
        "name": "LUNCA LA TISA",
        "zip": "437052",
        "lat": "47.95212",
        "long": "24.048878"
      },
      {
        "name": "MAGURENI",
        "zip": "437091",
        "lat": "47.486716",
        "long": "23.743535"
      },
      {
        "name": "MANASTIREA",
        "zip": "437163",
        "lat": "47.802992",
        "long": "23.922221"
      },
      {
        "name": "MANAU",
        "zip": "437358",
        "lat": "47.481787",
        "long": "23.262474"
      },
      {
        "name": "MARA",
        "zip": "437137",
        "lat": "47.755523",
        "long": "23.831262"
      },
      {
        "name": "MERISOR",
        "zip": "437349",
        "lat": "47.660906",
        "long": "23.410258"
      },
      {
        "name": "MESTEACAN",
        "zip": "437374",
        "lat": "47.380435",
        "long": "23.51975"
      },
      {
        "name": "MIRESU MARE",
        "zip": "437185",
        "lat": "47.503222",
        "long": "23.335311"
      },
      {
        "name": "MOCIRA",
        "zip": "437228",
        "lat": "47.62295",
        "long": "23.52506"
      },
      {
        "name": "MOGOSESTI",
        "zip": "437276",
        "lat": "47.58681",
        "long": "23.403652"
      },
      {
        "name": "MOISEI",
        "zip": "437195",
        "lat": "47.654253",
        "long": "24.548994"
      },
      {
        "name": "NANESTI",
        "zip": "437036",
        "lat": "47.83812",
        "long": "24.011049"
      },
      {
        "name": "NEGREIA",
        "zip": "437329",
        "lat": "47.635388",
        "long": "23.744065"
      },
      {
        "name": "NISTRU",
        "zip": "437351",
        "lat": "47.720349",
        "long": "23.453496"
      },
      {
        "name": "OARTA DE JOS",
        "zip": "437200",
        "lat": "47.459003",
        "long": "23.131866"
      },
      {
        "name": "OARTA DE SUS",
        "zip": "437201",
        "lat": "47.467933",
        "long": "23.077673"
      },
      {
        "name": "OCNA SUGATAG",
        "zip": "437205",
        "lat": "47.781321",
        "long": "23.939477"
      },
      {
        "name": "OCOLIS",
        "zip": "437166",
        "lat": "47.602034",
        "long": "23.579269"
      },
      {
        "name": "ODESTI",
        "zip": "437031",
        "lat": "47.51595",
        "long": "23.095873"
      },
      {
        "name": "ONCESTI",
        "zip": "437037",
        "lat": "47.848139",
        "long": "23.981827"
      },
      {
        "name": "ORTITA",
        "zip": "437202",
        "lat": "47.46262",
        "long": "23.094275"
      },
      {
        "name": "PETERITEA",
        "zip": "437384",
        "lat": "47.422911",
        "long": "23.743684"
      },
      {
        "name": "PETROVA",
        "zip": "437210",
        "lat": "47.837033",
        "long": "24.20253"
      },
      {
        "name": "PIATRA",
        "zip": "437236",
        "lat": "47.995655",
        "long": "23.538421"
      },
      {
        "name": "PLOPIS",
        "zip": "437331",
        "lat": "47.589622",
        "long": "23.772737"
      },
      {
        "name": "POIANA BOTIZII",
        "zip": "437026",
        "lat": "47.593404",
        "long": "24.023734"
      },
      {
        "name": "POIENILE DE SUB MUNTE",
        "zip": "437220",
        "lat": "47.822011",
        "long": "24.435654"
      },
      {
        "name": "POIENILE IZEI",
        "zip": "437215",
        "lat": "47.70309",
        "long": "24.112759"
      },
      {
        "name": "POSTA",
        "zip": "437233",
        "lat": "47.547813",
        "long": "23.493902"
      },
      {
        "name": "PRELUCA NOUA",
        "zip": "437109",
        "lat": "47.46876",
        "long": "23.650951"
      },
      {
        "name": "PRELUCA VECHE",
        "zip": "437111",
        "lat": "47.469413",
        "long": "23.707897"
      },
      {
        "name": "PRIBILESTI",
        "zip": "437277",
        "lat": "47.56523",
        "long": "23.373284"
      },
      {
        "name": "PRISLOP",
        "zip": "437062",
        "lat": "47.411554",
        "long": "23.553394"
      },
      {
        "name": "RAZOARE",
        "zip": "435610",
        "lat": "47.444406",
        "long": "23.779432"
      },
      {
        "name": "RECEA",
        "zip": "437225",
        "lat": "47.633871",
        "long": "23.505596"
      },
      {
        "name": "REMECIOARA",
        "zip": "437234",
        "lat": "47.513977",
        "long": "23.55886"
      },
      {
        "name": "REMETEA CHIOARULUI",
        "zip": "437230",
        "lat": "47.527611",
        "long": "23.547799"
      },
      {
        "name": "REMETI",
        "zip": "437235",
        "lat": "47.990595",
        "long": "23.643056"
      },
      {
        "name": "REMETI PE SOMES",
        "zip": "437189",
        "lat": "47.481435",
        "long": "23.339298"
      },
      {
        "name": "REPEDEA",
        "zip": "437240",
        "lat": "47.832406",
        "long": "24.398373"
      },
      {
        "name": "RODINA",
        "zip": "437011",
        "lat": "47.518267",
        "long": "23.253529"
      },
      {
        "name": "ROGOZ",
        "zip": "435611",
        "lat": "47.468073",
        "long": "23.928969"
      },
      {
        "name": "ROHIA",
        "zip": "435612",
        "lat": "47.406126",
        "long": "23.85804"
      },
      {
        "name": "ROMANESTI",
        "zip": "437063",
        "lat": "47.403774",
        "long": "23.642428"
      },
      {
        "name": "RONA DE JOS",
        "zip": "437245",
        "lat": "47.924399",
        "long": "24.017606"
      },
      {
        "name": "RONA DE SUS",
        "zip": "437250",
        "lat": "47.898334",
        "long": "24.037853"
      },
      {
        "name": "ROZAVLEA",
        "zip": "437255",
        "lat": "47.738416",
        "long": "24.222862"
      },
      {
        "name": "RUS",
        "zip": "437148",
        "lat": "47.612924",
        "long": "23.669383"
      },
      {
        "name": "RUSCOVA",
        "zip": "437260",
        "lat": "47.788269",
        "long": "24.280807"
      },
      {
        "name": "RUSOR",
        "zip": "437112",
        "lat": "47.504405",
        "long": "23.711018"
      },
      {
        "name": "SABISA",
        "zip": "435401",
        "lat": "47.729462",
        "long": "23.329006"
      },
      {
        "name": "SACALASENI",
        "zip": "437280",
        "lat": "47.581439",
        "long": "23.564215"
      },
      {
        "name": "SACEL",
        "zip": "437290",
        "lat": "47.636897",
        "long": "24.435078"
      },
      {
        "name": "SALISTE",
        "zip": "437032",
        "lat": "47.495957",
        "long": "23.112225"
      },
      {
        "name": "SALISTEA DE SUS",
        "zip": "437295",
        "lat": "47.658622",
        "long": "24.351656"
      },
      {
        "name": "SALNITA",
        "zip": "437386",
        "lat": "47.41159",
        "long": "23.672189"
      },
      {
        "name": "SALSIG",
        "zip": "437300",
        "lat": "47.519339",
        "long": "23.302696"
      },
      {
        "name": "SALTA",
        "zip": "437256",
        "lat": "47.737407",
        "long": "24.179451"
      },
      {
        "name": "SAPANTA",
        "zip": "437305",
        "lat": "47.971945",
        "long": "23.698418"
      },
      {
        "name": "SARASAU",
        "zip": "437265",
        "lat": "47.956007",
        "long": "23.825534"
      },
      {
        "name": "SARBI",
        "zip": "437071",
        "lat": "47.761844",
        "long": "23.944897"
      },
      {
        "name": "SARBI",
        "zip": "437157",
        "lat": "47.590739",
        "long": "23.343474"
      },
      {
        "name": "SASAR",
        "zip": "437229",
        "lat": "47.644064",
        "long": "23.498693"
      },
      {
        "name": "SAT-SUGATAG",
        "zip": "437208",
        "lat": "47.798044",
        "long": "23.905927"
      },
      {
        "name": "SATU NOU DE JOS",
        "zip": "437167",
        "lat": "47.616205",
        "long": "23.5685"
      },
      {
        "name": "SATU NOU DE SUS",
        "zip": "435102",
        "lat": "47.638473",
        "long": "23.634765"
      },
      {
        "name": "SATULUNG",
        "zip": "437270",
        "lat": "47.571104",
        "long": "23.428149"
      },
      {
        "name": "SEINI",
        "zip": "435400",
        "lat": "47.7485",
        "long": "23.283194"
      },
      {
        "name": "SIEU",
        "zip": "437320",
        "lat": "47.723064",
        "long": "24.225532"
      },
      {
        "name": "SIGHETU MARMATIEI",
        "zip": "435500",
        "lat": "47.92936",
        "long": "23.887968"
      },
      {
        "name": "SINDRESTI",
        "zip": "437149",
        "lat": "47.606595",
        "long": "23.695133"
      },
      {
        "name": "SISESTI",
        "zip": "437325",
        "lat": "47.632837",
        "long": "23.707768"
      },
      {
        "name": "SLATIOARA",
        "zip": "437312",
        "lat": "47.756082",
        "long": "24.092628"
      },
      {
        "name": "SOMCUTA MARE",
        "zip": "437335",
        "lat": "47.497049",
        "long": "23.471637"
      },
      {
        "name": "SOMES-UILEAC",
        "zip": "437359",
        "lat": "47.459182",
        "long": "23.227554"
      },
      {
        "name": "STEJERA",
        "zip": "437191",
        "lat": "47.441644",
        "long": "23.422877"
      },
      {
        "name": "STOICENI",
        "zip": "435613",
        "lat": "47.511213",
        "long": "23.880799"
      },
      {
        "name": "STRAMBU-BAIUT",
        "zip": "437027",
        "lat": "47.598077",
        "long": "23.981723"
      },
      {
        "name": "STRAMTURA",
        "zip": "437310",
        "lat": "47.774312",
        "long": "24.135753"
      },
      {
        "name": "STREMT",
        "zip": "437033",
        "lat": "47.491836",
        "long": "23.077103"
      },
      {
        "name": "SUCIU DE JOS",
        "zip": "437318",
        "lat": "47.445901",
        "long": "23.982162"
      },
      {
        "name": "SUCIU DE SUS",
        "zip": "437315",
        "lat": "47.431486",
        "long": "24.04119"
      },
      {
        "name": "SUGAU",
        "zip": "435503",
        "lat": "47.8827",
        "long": "23.90937"
      },
      {
        "name": "SURDESTI",
        "zip": "437332",
        "lat": "47.605761",
        "long": "23.762871"
      },
      {
        "name": "TAMAIA",
        "zip": "437158",
        "lat": "47.593535",
        "long": "23.363404"
      },
      {
        "name": "TAMASESTI",
        "zip": "437012",
        "lat": "47.503434",
        "long": "23.189042"
      },
      {
        "name": "TARGU LAPUS",
        "zip": "435600",
        "lat": "47.453546",
        "long": "23.864685"
      },
      {
        "name": "TAUTII DE SUS",
        "zip": "435103",
        "lat": "47.656658",
        "long": "23.658376"
      },
      {
        "name": "TAUTII-MAGHERAUS",
        "zip": "437345",
        "lat": "47.665871",
        "long": "23.467888"
      },
      {
        "name": "TECEU MIC",
        "zip": "437237",
        "lat": "48.002662",
        "long": "23.583223"
      },
      {
        "name": "TICAU",
        "zip": "437362",
        "lat": "47.445663",
        "long": "23.307228"
      },
      {
        "name": "TISA",
        "zip": "437053",
        "lat": "47.948441",
        "long": "23.957679"
      },
      {
        "name": "TOHAT",
        "zip": "437361",
        "lat": "47.494757",
        "long": "23.306691"
      },
      {
        "name": "TRESTIA",
        "zip": "437092",
        "lat": "47.564744",
        "long": "23.793685"
      },
      {
        "name": "TULGHIES",
        "zip": "437192",
        "lat": "47.50091",
        "long": "23.370814"
      },
      {
        "name": "ULMENI",
        "zip": "437355",
        "lat": "47.465738",
        "long": "23.300515"
      },
      {
        "name": "ULMOASA",
        "zip": "437352",
        "lat": "47.731876",
        "long": "23.531553"
      },
      {
        "name": "UNGURAS",
        "zip": "437151",
        "lat": "47.629348",
        "long": "23.678611"
      },
      {
        "name": "UNGURENI",
        "zip": "437133",
        "lat": "47.546306",
        "long": "23.952415"
      },
      {
        "name": "URMENIS",
        "zip": "437021",
        "lat": "47.523572",
        "long": "23.196259"
      },
      {
        "name": "VAD",
        "zip": "437113",
        "lat": "47.521458",
        "long": "23.711615"
      },
      {
        "name": "VADU IZEI",
        "zip": "437365",
        "lat": "47.888952",
        "long": "23.93055"
      },
      {
        "name": "VALEA CHIOARULUI",
        "zip": "437370",
        "lat": "47.429685",
        "long": "23.484762"
      },
      {
        "name": "VALEA CUFUNDOASA",
        "zip": "435504",
        "lat": "47.936694",
        "long": "23.944071"
      },
      {
        "name": "VALEA HOTARULUI",
        "zip": "435505",
        "lat": "47.932593",
        "long": "23.848898"
      },
      {
        "name": "VALEA NEAGRA",
        "zip": "430003",
        "lat": "47.766449",
        "long": "23.622676"
      },
      {
        "name": "VALEA STEJARULUI",
        "zip": "437366",
        "lat": "47.874415",
        "long": "23.989528"
      },
      {
        "name": "VALEA VISEULUI",
        "zip": "437047",
        "lat": "47.91438",
        "long": "24.153151"
      },
      {
        "name": "VALENI",
        "zip": "437077",
        "lat": "47.785593",
        "long": "24.016249"
      },
      {
        "name": "VALENII LAPUSULUI",
        "zip": "437125",
        "lat": "47.405729",
        "long": "23.785921"
      },
      {
        "name": "VALENII SOMCUTEI",
        "zip": "437343",
        "lat": "47.472912",
        "long": "23.451385"
      },
      {
        "name": "VARAI",
        "zip": "437376",
        "lat": "47.385175",
        "long": "23.446525"
      },
      {
        "name": "VICEA",
        "zip": "437363",
        "lat": "47.450716",
        "long": "23.239332"
      },
      {
        "name": "VIILE APEI",
        "zip": "435402",
        "lat": "47.781091",
        "long": "23.291035"
      },
      {
        "name": "VIMA MARE",
        "zip": "437387",
        "lat": "47.381702",
        "long": "23.708534"
      },
      {
        "name": "VIMA MICA",
        "zip": "437380",
        "lat": "47.412287",
        "long": "23.7068"
      },
      {
        "name": "VISEU DE JOS",
        "zip": "437390",
        "lat": "47.724422",
        "long": "24.365709"
      },
      {
        "name": "VISEU DE MIJLOC",
        "zip": "435701",
        "lat": "47.715546",
        "long": "24.405751"
      },
      {
        "name": "VISEU DE SUS",
        "zip": "435700",
        "lat": "47.70996",
        "long": "24.431155"
      }
    ],
    "MEHEDINȚI": [
      {
        "name": "23 AUGUST",
        "zip": "227316",
        "lat": "44.716151",
        "long": "22.762506"
      },
      {
        "name": "ADUNATII TEIULUI",
        "zip": "227471",
        "lat": "44.519995",
        "long": "23.050621"
      },
      {
        "name": "ALBULESTI",
        "zip": "227176",
        "lat": "44.514579",
        "long": "23.2001"
      },
      {
        "name": "ALMAJEL",
        "zip": "227501",
        "lat": "44.383082",
        "long": "23.029977"
      },
      {
        "name": "ALUNISUL",
        "zip": "227251",
        "lat": "44.634561",
        "long": "22.860398"
      },
      {
        "name": "ARGINESTI",
        "zip": "227091",
        "lat": "44.573965",
        "long": "23.41467"
      },
      {
        "name": "ARVATESTI",
        "zip": "227391",
        "lat": "44.563341",
        "long": "22.918993"
      },
      {
        "name": "AURORA",
        "zip": "227151",
        "lat": "44.192849",
        "long": "22.939163"
      },
      {
        "name": "BACLES",
        "zip": "227045",
        "lat": "44.484751",
        "long": "23.124499"
      },
      {
        "name": "BADITESTI",
        "zip": "227252",
        "lat": "44.63915",
        "long": "22.869317"
      },
      {
        "name": "BAHNA",
        "zip": "227281",
        "lat": "44.775789",
        "long": "22.497447"
      },
      {
        "name": "BAIA DE ARAMA",
        "zip": "225100",
        "lat": "45.000081",
        "long": "22.81044"
      },
      {
        "name": "BAIA NOUA",
        "zip": "227171",
        "lat": "44.554647",
        "long": "22.128892"
      },
      {
        "name": "BALA",
        "zip": "227010",
        "lat": "44.883202",
        "long": "22.836982"
      },
      {
        "name": "BALA DE SUS",
        "zip": "227011",
        "lat": "44.89834",
        "long": "22.81346"
      },
      {
        "name": "BALACITA",
        "zip": "227040",
        "lat": "44.385462",
        "long": "23.126098"
      },
      {
        "name": "BALOTA",
        "zip": "227392",
        "lat": "44.618935",
        "long": "22.801859"
      },
      {
        "name": "BALOTESTI",
        "zip": "227296",
        "lat": "44.735838",
        "long": "22.637587"
      },
      {
        "name": "BALTA",
        "zip": "227030",
        "lat": "44.88737",
        "long": "22.636706"
      },
      {
        "name": "BALTA VERDE",
        "zip": "227221",
        "lat": "44.344114",
        "long": "22.59878"
      },
      {
        "name": "BALTANELE",
        "zip": "227226",
        "lat": "44.57865",
        "long": "23.147978"
      },
      {
        "name": "BALTANELE",
        "zip": "227393",
        "lat": "44.577433",
        "long": "22.946735"
      },
      {
        "name": "BALUTA",
        "zip": "227361",
        "lat": "44.956051",
        "long": "22.753952"
      },
      {
        "name": "BALVANESTI",
        "zip": "227055",
        "lat": "44.797148",
        "long": "22.677778"
      },
      {
        "name": "BALVANESTII DE JOS",
        "zip": "227056",
        "lat": "44.794928",
        "long": "22.722166"
      },
      {
        "name": "BARAIACU",
        "zip": "227362",
        "lat": "45.007575",
        "long": "22.738883"
      },
      {
        "name": "BARDA",
        "zip": "227317",
        "lat": "44.729882",
        "long": "22.70039"
      },
      {
        "name": "BARLOGENI",
        "zip": "227431",
        "lat": "44.62605",
        "long": "23.292114"
      },
      {
        "name": "BATOTI",
        "zip": "227161",
        "lat": "44.513488",
        "long": "22.677539"
      },
      {
        "name": "BIBAN",
        "zip": "227341",
        "lat": "44.436023",
        "long": "23.075256"
      },
      {
        "name": "BISTRETU",
        "zip": "227162",
        "lat": "44.450618",
        "long": "22.61929"
      },
      {
        "name": "BISTRITA",
        "zip": "227246",
        "lat": "44.585108",
        "long": "22.787619"
      },
      {
        "name": "BLIDARU",
        "zip": "227227",
        "lat": "44.559277",
        "long": "23.07003"
      },
      {
        "name": "BOBAITA",
        "zip": "227318",
        "lat": "44.760107",
        "long": "22.721136"
      },
      {
        "name": "BOCENI",
        "zip": "227472",
        "lat": "44.56174",
        "long": "23.003623"
      },
      {
        "name": "BOROGEA",
        "zip": "227253",
        "lat": "44.65191",
        "long": "22.91083"
      },
      {
        "name": "BRAGLEASA",
        "zip": "227177",
        "lat": "44.51892",
        "long": "23.065996"
      },
      {
        "name": "BRANISTEA",
        "zip": "227491",
        "lat": "44.242151",
        "long": "22.97294"
      },
      {
        "name": "BRANZENI",
        "zip": "227363",
        "lat": "44.948417",
        "long": "22.795469"
      },
      {
        "name": "BRATESUL",
        "zip": "227012",
        "lat": "44.91026",
        "long": "22.828053"
      },
      {
        "name": "BRATILOVU",
        "zip": "225101",
        "lat": "45.022584",
        "long": "22.784623"
      },
      {
        "name": "BRATIVOESTI",
        "zip": "227013",
        "lat": "44.924468",
        "long": "22.847235"
      },
      {
        "name": "BREBINA",
        "zip": "225102",
        "lat": "45.012646",
        "long": "22.816228"
      },
      {
        "name": "BRETA",
        "zip": "227126",
        "lat": "44.656759",
        "long": "23.125217"
      },
      {
        "name": "BREZNICIOARA",
        "zip": "227432",
        "lat": "44.580549",
        "long": "23.262836"
      },
      {
        "name": "BREZNITA-MOTRU",
        "zip": "227060",
        "lat": "44.566935",
        "long": "23.215105"
      },
      {
        "name": "BREZNITA-OCOL",
        "zip": "227070",
        "lat": "44.672674",
        "long": "22.612696"
      },
      {
        "name": "BROSTENI",
        "zip": "227075",
        "lat": "44.759071",
        "long": "22.987346"
      },
      {
        "name": "BUCURA",
        "zip": "225401",
        "lat": "44.399424",
        "long": "22.864374"
      },
      {
        "name": "BUDANESTI",
        "zip": "227271",
        "lat": "44.782069",
        "long": "22.734463"
      },
      {
        "name": "BUICANI",
        "zip": "227364",
        "lat": "44.970455",
        "long": "22.738098"
      },
      {
        "name": "BUICESTI",
        "zip": "227092",
        "lat": "44.565019",
        "long": "23.364266"
      },
      {
        "name": "BUNOAICA",
        "zip": "227121",
        "lat": "44.799142",
        "long": "22.543907"
      },
      {
        "name": "BURILA MARE",
        "zip": "227085",
        "lat": "44.453231",
        "long": "22.572998"
      },
      {
        "name": "BURILA MICA",
        "zip": "227222",
        "lat": "44.41848",
        "long": "22.590142"
      },
      {
        "name": "BUSESTI",
        "zip": "227286",
        "lat": "44.949259",
        "long": "22.713181"
      },
      {
        "name": "BUTOIESTI",
        "zip": "227090",
        "lat": "44.588015",
        "long": "23.372354"
      },
      {
        "name": "CALINESTII DE JOS",
        "zip": "227057",
        "lat": "44.809577",
        "long": "22.676724"
      },
      {
        "name": "CALINESTII DE SUS",
        "zip": "227058",
        "lat": "44.821531",
        "long": "22.649723"
      },
      {
        "name": "CAMPU MARE",
        "zip": "227014",
        "lat": "44.858016",
        "long": "22.888886"
      },
      {
        "name": "CAPATANESTI",
        "zip": "227076",
        "lat": "44.749041",
        "long": "22.994317"
      },
      {
        "name": "CARAMIDARU",
        "zip": "227456",
        "lat": "44.785982",
        "long": "22.864163"
      },
      {
        "name": "CARCENI",
        "zip": "227236",
        "lat": "44.660904",
        "long": "23.265115"
      },
      {
        "name": "CARJEI",
        "zip": "227247",
        "lat": "44.537078",
        "long": "22.815417"
      },
      {
        "name": "CARSU",
        "zip": "227016",
        "lat": "44.900089",
        "long": "22.824817"
      },
      {
        "name": "CAZANESTI",
        "zip": "227100",
        "lat": "44.724084",
        "long": "22.893435"
      },
      {
        "name": "CEARANGU",
        "zip": "227411",
        "lat": "44.282203",
        "long": "22.979362"
      },
      {
        "name": "CELNATA",
        "zip": "227254",
        "lat": "44.677647",
        "long": "22.809062"
      },
      {
        "name": "CEPTURENI",
        "zip": "227366",
        "lat": "44.993452",
        "long": "22.762456"
      },
      {
        "name": "CERANGANUL",
        "zip": "227433",
        "lat": "44.639168",
        "long": "23.274316"
      },
      {
        "name": "CERNA-VARF",
        "zip": "227287",
        "lat": "44.923359",
        "long": "22.679578"
      },
      {
        "name": "CERNAIA",
        "zip": "227127",
        "lat": "44.663148",
        "long": "23.137599"
      },
      {
        "name": "CERNETI",
        "zip": "227446",
        "lat": "44.634782",
        "long": "22.709422"
      },
      {
        "name": "CERVENITA",
        "zip": "227394",
        "lat": "44.636341",
        "long": "22.966174"
      },
      {
        "name": "CIOCHIUTA",
        "zip": "225301",
        "lat": "44.604818",
        "long": "23.122258"
      },
      {
        "name": "CIOROBORENI",
        "zip": "227306",
        "lat": "44.388852",
        "long": "22.763301"
      },
      {
        "name": "CIOVARNASANI",
        "zip": "227457",
        "lat": "44.757496",
        "long": "22.871049"
      },
      {
        "name": "CIRESU",
        "zip": "227120",
        "lat": "44.824124",
        "long": "22.539875"
      },
      {
        "name": "COADA CORNETULUI",
        "zip": "227031",
        "lat": "44.908808",
        "long": "22.656114"
      },
      {
        "name": "COCOROVA",
        "zip": "227458",
        "lat": "44.747718",
        "long": "22.806929"
      },
      {
        "name": "COLARET",
        "zip": "227473",
        "lat": "44.540855",
        "long": "23.027063"
      },
      {
        "name": "COLIBASI",
        "zip": "227319",
        "lat": "44.727991",
        "long": "22.744522"
      },
      {
        "name": "COMANDA",
        "zip": "225302",
        "lat": "44.648766",
        "long": "23.164134"
      },
      {
        "name": "COMANESTI",
        "zip": "227017",
        "lat": "44.9361",
        "long": "22.867128"
      },
      {
        "name": "COPACIOASA",
        "zip": "227201",
        "lat": "44.779102",
        "long": "22.904255"
      },
      {
        "name": "CORCOVA",
        "zip": "227125",
        "lat": "44.69756",
        "long": "23.045951"
      },
      {
        "name": "CORDUN",
        "zip": "227128",
        "lat": "44.68651",
        "long": "23.04456"
      },
      {
        "name": "CORLATEL",
        "zip": "227145",
        "lat": "44.397361",
        "long": "22.934184"
      },
      {
        "name": "CORZU",
        "zip": "227046",
        "lat": "44.451993",
        "long": "23.168547"
      },
      {
        "name": "COSOVAT",
        "zip": "227061",
        "lat": "44.543941",
        "long": "23.259182"
      },
      {
        "name": "COSTESTI",
        "zip": "227032",
        "lat": "44.925563",
        "long": "22.584822"
      },
      {
        "name": "COTOROAIA",
        "zip": "227506",
        "lat": "44.649223",
        "long": "23.033976"
      },
      {
        "name": "COZIA",
        "zip": "227386",
        "lat": "44.215113",
        "long": "22.713518"
      },
      {
        "name": "CRACU LUNG",
        "zip": "227272",
        "lat": "44.826813",
        "long": "22.689111"
      },
      {
        "name": "CRACU MUNTELUI",
        "zip": "227367",
        "lat": "44.986138",
        "long": "22.754042"
      },
      {
        "name": "CRAGUESTI",
        "zip": "227459",
        "lat": "44.759947",
        "long": "22.773158"
      },
      {
        "name": "CRAINICI",
        "zip": "227018",
        "lat": "44.903462",
        "long": "22.873675"
      },
      {
        "name": "CREMENEA",
        "zip": "227474",
        "lat": "44.606876",
        "long": "23.01869"
      },
      {
        "name": "CRIVINA",
        "zip": "227086",
        "lat": "44.506632",
        "long": "22.569908"
      },
      {
        "name": "CROICA",
        "zip": "227129",
        "lat": "44.667857",
        "long": "23.123978"
      },
      {
        "name": "CUJMIR",
        "zip": "227150",
        "lat": "44.20892",
        "long": "22.928693"
      },
      {
        "name": "CUJMIRU MIC",
        "zip": "227152",
        "lat": "44.190079",
        "long": "22.926076"
      },
      {
        "name": "DALBOCITA",
        "zip": "227273",
        "lat": "44.831207",
        "long": "22.741152"
      },
      {
        "name": "DALMA",
        "zip": "227019",
        "lat": "44.905067",
        "long": "22.74288"
      },
      {
        "name": "DANCEU",
        "zip": "227307",
        "lat": "44.363987",
        "long": "22.719339"
      },
      {
        "name": "DARVARI",
        "zip": "227155",
        "lat": "44.191037",
        "long": "23.050452"
      },
      {
        "name": "DEALU MARE",
        "zip": "225103",
        "lat": "44.98355",
        "long": "22.813736"
      },
      {
        "name": "DEDOVITA NOUA",
        "zip": "227447",
        "lat": "44.626827",
        "long": "22.731297"
      },
      {
        "name": "DEDOVITA VECHE",
        "zip": "227448",
        "lat": "44.627236",
        "long": "22.772967"
      },
      {
        "name": "DELENI",
        "zip": "227062",
        "lat": "44.556778",
        "long": "23.298266"
      },
      {
        "name": "DELURENI",
        "zip": "227368",
        "lat": "44.950248",
        "long": "22.769315"
      },
      {
        "name": "DEVESEL",
        "zip": "227160",
        "lat": "44.469335",
        "long": "22.66734"
      },
      {
        "name": "DOBRA",
        "zip": "227041",
        "lat": "44.390695",
        "long": "23.090405"
      },
      {
        "name": "DRAGHESTI",
        "zip": "227288",
        "lat": "44.983536",
        "long": "22.676059"
      },
      {
        "name": "DRAGOTESTI",
        "zip": "227396",
        "lat": "44.581831",
        "long": "22.94207"
      },
      {
        "name": "DRINCEA",
        "zip": "227412",
        "lat": "44.304594",
        "long": "22.998343"
      },
      {
        "name": "DROBETA-TURNU SEVERIN",
        "zip": "220004",
        "lat": "44.630191",
        "long": "22.659342"
      },
      {
        "name": "DUBOVA",
        "zip": "227170",
        "lat": "44.620024",
        "long": "22.25578"
      },
      {
        "name": "DUDASU",
        "zip": "227449",
        "lat": "44.652051",
        "long": "22.695875"
      },
      {
        "name": "DUDASU SCHELEI",
        "zip": "220001",
        "lat": "44.641279",
        "long": "22.596013"
      },
      {
        "name": "DUMBRAVA DE JOS",
        "zip": "227178",
        "lat": "44.515197",
        "long": "23.149184"
      },
      {
        "name": "DUMBRAVA DE MIJLOC",
        "zip": "227179",
        "lat": "44.517729",
        "long": "23.136786"
      },
      {
        "name": "DUMBRAVA DE SUS",
        "zip": "227181",
        "lat": "44.517052",
        "long": "23.113337"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "227256",
        "lat": "44.668535",
        "long": "22.789971"
      },
      {
        "name": "DUNAREA MICA",
        "zip": "227163",
        "lat": "44.504438",
        "long": "22.712791"
      },
      {
        "name": "EIBENTHAL",
        "zip": "227172",
        "lat": "44.543826",
        "long": "22.15683"
      },
      {
        "name": "ERCEA",
        "zip": "227101",
        "lat": "44.677462",
        "long": "22.98578"
      },
      {
        "name": "ERGHEVITA",
        "zip": "227451",
        "lat": "44.607438",
        "long": "22.783708"
      },
      {
        "name": "ESELNITA",
        "zip": "227195",
        "lat": "44.699047",
        "long": "22.365773"
      },
      {
        "name": "FANTANA DOMNEASCA",
        "zip": "227397",
        "lat": "44.58427",
        "long": "22.924697"
      },
      {
        "name": "FANTANILE NEGRE",
        "zip": "227381",
        "lat": "44.488118",
        "long": "22.916993"
      },
      {
        "name": "FATA CREMENII",
        "zip": "227476",
        "lat": "44.591827",
        "long": "22.997365"
      },
      {
        "name": "FATA MOTRULUI",
        "zip": "227434",
        "lat": "44.601238",
        "long": "23.301544"
      },
      {
        "name": "FAUROAIA",
        "zip": "227063",
        "lat": "44.545104",
        "long": "23.289882"
      },
      {
        "name": "FIRIZU",
        "zip": "227274",
        "lat": "44.843798",
        "long": "22.724217"
      },
      {
        "name": "FLORESTI",
        "zip": "227200",
        "lat": "44.767463",
        "long": "22.940019"
      },
      {
        "name": "GARBOVATU DE JOS",
        "zip": "227131",
        "lat": "44.705024",
        "long": "23.001825"
      },
      {
        "name": "GARBOVATU DE SUS",
        "zip": "227102",
        "lat": "44.726134",
        "long": "22.831719"
      },
      {
        "name": "GARDANEASA",
        "zip": "227369",
        "lat": "44.965203",
        "long": "22.788011"
      },
      {
        "name": "GARDOAIA",
        "zip": "227202",
        "lat": "44.763146",
        "long": "22.922199"
      },
      {
        "name": "GARLA MARE",
        "zip": "227210",
        "lat": "44.211706",
        "long": "22.772983"
      },
      {
        "name": "GARNITA",
        "zip": "227398",
        "lat": "44.589874",
        "long": "22.854463"
      },
      {
        "name": "GEMENI",
        "zip": "227156",
        "lat": "44.172651",
        "long": "23.082507"
      },
      {
        "name": "GHELMEGIOAIA",
        "zip": "227399",
        "lat": "44.613839",
        "long": "22.832719"
      },
      {
        "name": "GHEORGHESTI",
        "zip": "227371",
        "lat": "44.970735",
        "long": "22.720311"
      },
      {
        "name": "GIURA",
        "zip": "227047",
        "lat": "44.506599",
        "long": "23.095678"
      },
      {
        "name": "GIURGIANI",
        "zip": "227289",
        "lat": "44.969914",
        "long": "22.573365"
      },
      {
        "name": "GOANTA",
        "zip": "227492",
        "lat": "44.233344",
        "long": "22.962315"
      },
      {
        "name": "GODEANU",
        "zip": "227331",
        "lat": "45.019873",
        "long": "22.65228"
      },
      {
        "name": "GODEANU",
        "zip": "227215",
        "lat": "44.800533",
        "long": "22.607913"
      },
      {
        "name": "GOGOSU",
        "zip": "227220",
        "lat": "44.373947",
        "long": "22.593807"
      },
      {
        "name": "GOLINEASA",
        "zip": "227182",
        "lat": "44.526064",
        "long": "23.144225"
      },
      {
        "name": "GORNENTI",
        "zip": "227356",
        "lat": "44.912554",
        "long": "22.546208"
      },
      {
        "name": "GORNOVITA",
        "zip": "227033",
        "lat": "44.93357",
        "long": "22.6288"
      },
      {
        "name": "GOVODARVA",
        "zip": "227103",
        "lat": "44.692246",
        "long": "22.894945"
      },
      {
        "name": "GRECI",
        "zip": "227225",
        "lat": "44.562287",
        "long": "23.105614"
      },
      {
        "name": "GROZESTI",
        "zip": "227235",
        "lat": "44.648261",
        "long": "23.310772"
      },
      {
        "name": "GRUIA",
        "zip": "227240",
        "lat": "44.266803",
        "long": "22.70552"
      },
      {
        "name": "GURA MOTRULUI",
        "zip": "227093",
        "lat": "44.555328",
        "long": "23.436784"
      },
      {
        "name": "GURA VAII",
        "zip": "220002",
        "lat": "44.66732",
        "long": "22.556457"
      },
      {
        "name": "GUTU",
        "zip": "227401",
        "lat": "44.604102",
        "long": "22.874658"
      },
      {
        "name": "GVARDINITA",
        "zip": "227042",
        "lat": "44.39505",
        "long": "23.14635"
      },
      {
        "name": "HALANGA",
        "zip": "227297",
        "lat": "44.681159",
        "long": "22.690368"
      },
      {
        "name": "HIGIU",
        "zip": "227183",
        "lat": "44.536026",
        "long": "23.178115"
      },
      {
        "name": "HINOVA",
        "zip": "227245",
        "lat": "44.540081",
        "long": "22.77769"
      },
      {
        "name": "HOTARANI",
        "zip": "227496",
        "lat": "44.418322",
        "long": "22.810814"
      },
      {
        "name": "HURDUCESTI",
        "zip": "225303",
        "lat": "44.601634",
        "long": "23.143384"
      },
      {
        "name": "HUSNICIOARA",
        "zip": "227250",
        "lat": "44.676015",
        "long": "22.848032"
      },
      {
        "name": "IABLANITA",
        "zip": "227342",
        "lat": "44.464882",
        "long": "22.988596"
      },
      {
        "name": "IGIROASA",
        "zip": "227402",
        "lat": "44.576128",
        "long": "22.963103"
      },
      {
        "name": "ILOVAT",
        "zip": "227270",
        "lat": "44.811971",
        "long": "22.763332"
      },
      {
        "name": "ILOVITA",
        "zip": "227280",
        "lat": "44.756563",
        "long": "22.474331"
      },
      {
        "name": "ILOVU",
        "zip": "227104",
        "lat": "44.724168",
        "long": "22.869477"
      },
      {
        "name": "IMOASA",
        "zip": "227132",
        "lat": "44.718123",
        "long": "23.04207"
      },
      {
        "name": "ISVERNA",
        "zip": "227285",
        "lat": "44.979178",
        "long": "22.629935"
      },
      {
        "name": "IUPCA",
        "zip": "227021",
        "lat": "44.866931",
        "long": "22.863695"
      },
      {
        "name": "IZIMSA",
        "zip": "227326",
        "lat": "44.178188",
        "long": "22.956492"
      },
      {
        "name": "IZVOARELE",
        "zip": "227241",
        "lat": "44.308854",
        "long": "22.66199"
      },
      {
        "name": "IZVORALU",
        "zip": "227477",
        "lat": "44.541053",
        "long": "22.966899"
      },
      {
        "name": "IZVORALU DE JOS",
        "zip": "227311",
        "lat": "44.535968",
        "long": "22.920511"
      },
      {
        "name": "IZVORU ANESTILOR",
        "zip": "227312",
        "lat": "44.556621",
        "long": "22.854773"
      },
      {
        "name": "IZVORU BARZII",
        "zip": "227295",
        "lat": "44.709128",
        "long": "22.677288"
      },
      {
        "name": "IZVORU FRUMOS",
        "zip": "227087",
        "lat": "44.453299",
        "long": "22.495239"
      },
      {
        "name": "JIANA",
        "zip": "227305",
        "lat": "44.401838",
        "long": "22.71278"
      },
      {
        "name": "JIANA MARE",
        "zip": "227308",
        "lat": "44.411126",
        "long": "22.688905"
      },
      {
        "name": "JIANA VECHE",
        "zip": "227309",
        "lat": "44.391907",
        "long": "22.667866"
      },
      {
        "name": "JIDOSTITA",
        "zip": "227071",
        "lat": "44.715818",
        "long": "22.593113"
      },
      {
        "name": "JIGNITA",
        "zip": "227106",
        "lat": "44.715546",
        "long": "22.901135"
      },
      {
        "name": "JIROV",
        "zip": "227133",
        "lat": "44.670933",
        "long": "23.085764"
      },
      {
        "name": "JUGASTRU",
        "zip": "227094",
        "lat": "44.57863",
        "long": "23.395123"
      },
      {
        "name": "JUPANESTI",
        "zip": "227122",
        "lat": "44.832796",
        "long": "22.564016"
      },
      {
        "name": "LAC",
        "zip": "227507",
        "lat": "44.611563",
        "long": "23.074666"
      },
      {
        "name": "LAZU",
        "zip": "227321",
        "lat": "44.7271",
        "long": "22.777195"
      },
      {
        "name": "LIVEZI",
        "zip": "227203",
        "lat": "44.777209",
        "long": "22.920517"
      },
      {
        "name": "LIVEZILE",
        "zip": "227310",
        "lat": "44.515367",
        "long": "22.861374"
      },
      {
        "name": "LUDU",
        "zip": "227372",
        "lat": "44.959562",
        "long": "22.807095"
      },
      {
        "name": "LUMNIC",
        "zip": "227403",
        "lat": "44.629968",
        "long": "23.003267"
      },
      {
        "name": "LUNCA BANULUI",
        "zip": "225304",
        "lat": "44.614164",
        "long": "23.245176"
      },
      {
        "name": "LUNCSOARA",
        "zip": "227077",
        "lat": "44.727059",
        "long": "23.040338"
      },
      {
        "name": "LUPSA DE JOS",
        "zip": "227078",
        "lat": "44.731298",
        "long": "22.99572"
      },
      {
        "name": "LUPSA DE SUS",
        "zip": "227079",
        "lat": "44.732077",
        "long": "22.946925"
      },
      {
        "name": "MAGHERU",
        "zip": "227072",
        "lat": "44.65467",
        "long": "22.631024"
      },
      {
        "name": "MAGURELE",
        "zip": "227413",
        "lat": "44.270566",
        "long": "22.948848"
      },
      {
        "name": "MALARISCA",
        "zip": "227357",
        "lat": "44.886648",
        "long": "22.569891"
      },
      {
        "name": "MALOVAT",
        "zip": "227315",
        "lat": "44.705663",
        "long": "22.72939"
      },
      {
        "name": "MANU",
        "zip": "227478",
        "lat": "44.550326",
        "long": "22.946259"
      },
      {
        "name": "MARASESTI",
        "zip": "225104",
        "lat": "45.021856",
        "long": "22.769892"
      },
      {
        "name": "MARGA",
        "zip": "227216",
        "lat": "44.817334",
        "long": "22.584284"
      },
      {
        "name": "MARMANU",
        "zip": "227257",
        "lat": "44.642786",
        "long": "22.802649"
      },
      {
        "name": "MARU ROSU",
        "zip": "227134",
        "lat": "44.670803",
        "long": "23.114632"
      },
      {
        "name": "MENTI",
        "zip": "225305",
        "lat": "44.677211",
        "long": "23.167066"
      },
      {
        "name": "MERIS",
        "zip": "227081",
        "lat": "44.782545",
        "long": "22.977284"
      },
      {
        "name": "MIJARCA",
        "zip": "227404",
        "lat": "44.572843",
        "long": "22.902723"
      },
      {
        "name": "MOISESTI",
        "zip": "227282",
        "lat": "44.808807",
        "long": "22.501272"
      },
      {
        "name": "MOLANI",
        "zip": "227022",
        "lat": "44.93081",
        "long": "22.85207"
      },
      {
        "name": "MOSNENI",
        "zip": "227204",
        "lat": "44.776837",
        "long": "22.930502"
      },
      {
        "name": "MOTRULENI",
        "zip": "225306",
        "lat": "44.664443",
        "long": "23.187091"
      },
      {
        "name": "NADANOVA",
        "zip": "227291",
        "lat": "44.945295",
        "long": "22.664682"
      },
      {
        "name": "NEGOESTI",
        "zip": "225105",
        "lat": "44.980907",
        "long": "22.86118"
      },
      {
        "name": "NEGRESTI",
        "zip": "227322",
        "lat": "44.683286",
        "long": "22.781177"
      },
      {
        "name": "NEGRUSA",
        "zip": "227123",
        "lat": "44.82306",
        "long": "22.513068"
      },
      {
        "name": "NEVATU",
        "zip": "227034",
        "lat": "44.89396",
        "long": "22.613068"
      },
      {
        "name": "NICOLAE BALCESCU",
        "zip": "225402",
        "lat": "44.374269",
        "long": "22.858368"
      },
      {
        "name": "NOAPTESA",
        "zip": "227461",
        "lat": "44.801101",
        "long": "22.867835"
      },
      {
        "name": "OBARSIA DE CAMP",
        "zip": "227325",
        "lat": "44.171944",
        "long": "22.985037"
      },
      {
        "name": "OBARSIA-CLOSANI",
        "zip": "227330",
        "lat": "45.021737",
        "long": "22.689062"
      },
      {
        "name": "OHABA",
        "zip": "227466",
        "lat": "44.850377",
        "long": "22.855785"
      },
      {
        "name": "OLTEANCA",
        "zip": "227343",
        "lat": "44.437583",
        "long": "22.964155"
      },
      {
        "name": "OPRANESTI",
        "zip": "227258",
        "lat": "44.656916",
        "long": "22.782537"
      },
      {
        "name": "OPRISOR",
        "zip": "227335",
        "lat": "44.284711",
        "long": "23.078356"
      },
      {
        "name": "OREVITA MARE",
        "zip": "225403",
        "lat": "44.457446",
        "long": "22.913171"
      },
      {
        "name": "ORSOVA",
        "zip": "225200",
        "lat": "44.723469",
        "long": "22.398276"
      },
      {
        "name": "OSTROVU CORBULUI",
        "zip": "227248",
        "lat": "44.518096",
        "long": "22.723054"
      },
      {
        "name": "OSTROVU MARE",
        "zip": "227223",
        "lat": "44.379909",
        "long": "22.514118"
      },
      {
        "name": "PADINA MARE",
        "zip": "227344",
        "lat": "44.442082",
        "long": "23.013449"
      },
      {
        "name": "PADINA MICA",
        "zip": "227346",
        "lat": "44.426566",
        "long": "22.993257"
      },
      {
        "name": "PALTINISU",
        "zip": "227107",
        "lat": "44.687124",
        "long": "22.904456"
      },
      {
        "name": "PARLAGELE",
        "zip": "227059",
        "lat": "44.765757",
        "long": "22.691319"
      },
      {
        "name": "PARVULESTI",
        "zip": "227136",
        "lat": "44.681941",
        "long": "23.013801"
      },
      {
        "name": "PASARANI",
        "zip": "227237",
        "lat": "44.608906",
        "long": "23.399528"
      },
      {
        "name": "PATULELE",
        "zip": "227350",
        "lat": "44.34531",
        "long": "22.781597"
      },
      {
        "name": "PAUNESTI",
        "zip": "227217",
        "lat": "44.78732",
        "long": "22.63001"
      },
      {
        "name": "PAVAT",
        "zip": "227479",
        "lat": "44.570103",
        "long": "22.985465"
      },
      {
        "name": "PERI",
        "zip": "227259",
        "lat": "44.656961",
        "long": "22.894222"
      },
      {
        "name": "PESTEANA",
        "zip": "227206",
        "lat": "44.821246",
        "long": "22.884881"
      },
      {
        "name": "PESTENUTA",
        "zip": "227207",
        "lat": "44.834491",
        "long": "22.854271"
      },
      {
        "name": "PETRA",
        "zip": "227048",
        "lat": "44.458894",
        "long": "23.095164"
      },
      {
        "name": "PETRIS",
        "zip": "227313",
        "lat": "44.538852",
        "long": "22.860477"
      },
      {
        "name": "PISTRITA",
        "zip": "225106",
        "lat": "44.967723",
        "long": "22.839834"
      },
      {
        "name": "PLAI",
        "zip": "227064",
        "lat": "44.544042",
        "long": "23.235311"
      },
      {
        "name": "PLOPI",
        "zip": "227481",
        "lat": "44.532689",
        "long": "23.01574"
      },
      {
        "name": "PLUTA",
        "zip": "227096",
        "lat": "44.574881",
        "long": "23.330289"
      },
      {
        "name": "PODENI",
        "zip": "227355",
        "lat": "44.878414",
        "long": "22.544139"
      },
      {
        "name": "PODU GROSULUI",
        "zip": "227049",
        "lat": "44.482931",
        "long": "23.065818"
      },
      {
        "name": "POIANA",
        "zip": "227108",
        "lat": "44.685571",
        "long": "22.976079"
      },
      {
        "name": "POIANA GRUII",
        "zip": "227242",
        "lat": "44.279397",
        "long": "22.816714"
      },
      {
        "name": "PONOARELE",
        "zip": "227360",
        "lat": "44.974872",
        "long": "22.764225"
      },
      {
        "name": "POROINA",
        "zip": "227452",
        "lat": "44.617847",
        "long": "22.778018"
      },
      {
        "name": "POROINA MARE",
        "zip": "227380",
        "lat": "44.496628",
        "long": "22.931916"
      },
      {
        "name": "POROINITA",
        "zip": "227421",
        "lat": "44.471193",
        "long": "22.850318"
      },
      {
        "name": "POSTA VECHE",
        "zip": "227436",
        "lat": "44.595793",
        "long": "23.323481"
      },
      {
        "name": "PREJNA",
        "zip": "227036",
        "lat": "44.935936",
        "long": "22.594561"
      },
      {
        "name": "PRIBOIESTI",
        "zip": "227261",
        "lat": "44.710796",
        "long": "22.816723"
      },
      {
        "name": "PRISACEAUA",
        "zip": "227336",
        "lat": "44.31739",
        "long": "23.094562"
      },
      {
        "name": "PRISTOL",
        "zip": "227385",
        "lat": "44.226346",
        "long": "22.70552"
      },
      {
        "name": "PROITESTI",
        "zip": "227373",
        "lat": "44.979064",
        "long": "22.720243"
      },
      {
        "name": "PRUNARU",
        "zip": "227406",
        "lat": "44.611403",
        "long": "22.881475"
      },
      {
        "name": "PRUNISOR",
        "zip": "227390",
        "lat": "44.608354",
        "long": "22.916088"
      },
      {
        "name": "PUNGHINA",
        "zip": "227410",
        "lat": "44.281894",
        "long": "22.937841"
      },
      {
        "name": "PUSCASU",
        "zip": "227137",
        "lat": "44.669557",
        "long": "23.103201"
      },
      {
        "name": "PUTINEI",
        "zip": "227298",
        "lat": "44.681016",
        "long": "22.70323"
      },
      {
        "name": "RACOVA",
        "zip": "227276",
        "lat": "44.797136",
        "long": "22.767414"
      },
      {
        "name": "RADUTESTI",
        "zip": "227097",
        "lat": "44.589478",
        "long": "23.351606"
      },
      {
        "name": "RAICULESTI",
        "zip": "227374",
        "lat": "44.968357",
        "long": "22.776235"
      },
      {
        "name": "RASCOLESTI",
        "zip": "227299",
        "lat": "44.692546",
        "long": "22.690377"
      },
      {
        "name": "RECEA",
        "zip": "227414",
        "lat": "44.319321",
        "long": "22.916534"
      },
      {
        "name": "ROCSORENI",
        "zip": "227184",
        "lat": "44.531832",
        "long": "23.066796"
      },
      {
        "name": "ROGOVA",
        "zip": "227420",
        "lat": "44.471062",
        "long": "22.807502"
      },
      {
        "name": "ROSIA",
        "zip": "227109",
        "lat": "44.696191",
        "long": "22.880651"
      },
      {
        "name": "ROSIORI",
        "zip": "227493",
        "lat": "44.256225",
        "long": "22.926347"
      },
      {
        "name": "RUDINA",
        "zip": "227023",
        "lat": "44.879701",
        "long": "22.79555"
      },
      {
        "name": "RUNCUSORU",
        "zip": "227024",
        "lat": "44.891654",
        "long": "22.728632"
      },
      {
        "name": "RUPTURA",
        "zip": "227508",
        "lat": "44.62569",
        "long": "23.037117"
      },
      {
        "name": "SALATRUC",
        "zip": "227228",
        "lat": "44.574079",
        "long": "23.09506"
      },
      {
        "name": "SALCIA",
        "zip": "227425",
        "lat": "44.139806",
        "long": "22.930053"
      },
      {
        "name": "SARDANESTI",
        "zip": "227026",
        "lat": "44.878724",
        "long": "22.888159"
      },
      {
        "name": "SATU MARE",
        "zip": "227437",
        "lat": "44.576069",
        "long": "23.276445"
      },
      {
        "name": "SATU NOU",
        "zip": "227416",
        "lat": "44.314196",
        "long": "22.990898"
      },
      {
        "name": "SCAPAU",
        "zip": "227164",
        "lat": "44.461061",
        "long": "22.722541"
      },
      {
        "name": "SCHELA CLADOVEI",
        "zip": "220003",
        "lat": "44.628365",
        "long": "22.613426"
      },
      {
        "name": "SCHINTEIESTI",
        "zip": "227301",
        "lat": "44.701071",
        "long": "22.667227"
      },
      {
        "name": "SCHITU TOPOLNITEI",
        "zip": "227302",
        "lat": "44.755455",
        "long": "22.622783"
      },
      {
        "name": "SCORILA",
        "zip": "227502",
        "lat": "44.347703",
        "long": "23.086136"
      },
      {
        "name": "SELISTEA",
        "zip": "227292",
        "lat": "44.984473",
        "long": "22.649152"
      },
      {
        "name": "SELISTENI",
        "zip": "227262",
        "lat": "44.672558",
        "long": "22.842988"
      },
      {
        "name": "SELISTIUTA",
        "zip": "227051",
        "lat": "44.494231",
        "long": "23.1026"
      },
      {
        "name": "SEVERINESTI",
        "zip": "227111",
        "lat": "44.694889",
        "long": "22.938523"
      },
      {
        "name": "SFODEA",
        "zip": "227037",
        "lat": "44.859355",
        "long": "22.602492"
      },
      {
        "name": "SIMIAN",
        "zip": "227445",
        "lat": "44.612165",
        "long": "22.710752"
      },
      {
        "name": "SIPOTU",
        "zip": "227376",
        "lat": "44.997214",
        "long": "22.722243"
      },
      {
        "name": "SIPOTU",
        "zip": "227383",
        "lat": "44.502891",
        "long": "22.916158"
      },
      {
        "name": "SIROCA",
        "zip": "227218",
        "lat": "44.827699",
        "long": "22.60982"
      },
      {
        "name": "SISESTI",
        "zip": "227455",
        "lat": "44.776543",
        "long": "22.842096"
      },
      {
        "name": "SLASOMA",
        "zip": "227347",
        "lat": "44.419807",
        "long": "23.049618"
      },
      {
        "name": "SLATINICU MARE",
        "zip": "225307",
        "lat": "44.599366",
        "long": "23.205666"
      },
      {
        "name": "SLATINICU MIC",
        "zip": "225308",
        "lat": "44.590309",
        "long": "23.190858"
      },
      {
        "name": "SMADOVITA",
        "zip": "227052",
        "lat": "44.480499",
        "long": "23.201617"
      },
      {
        "name": "SOVARNA",
        "zip": "227465",
        "lat": "44.851328",
        "long": "22.802464"
      },
      {
        "name": "SPERLESTI",
        "zip": "227509",
        "lat": "44.649143",
        "long": "23.009882"
      },
      {
        "name": "STANCESTI",
        "zip": "225309",
        "lat": "44.616729",
        "long": "23.267302"
      },
      {
        "name": "STANESTI",
        "zip": "225107",
        "lat": "45.019985",
        "long": "22.75409"
      },
      {
        "name": "STANGACEAUA",
        "zip": "227430",
        "lat": "44.608957",
        "long": "23.312732"
      },
      {
        "name": "STEFAN ODOBLEJA",
        "zip": "227314",
        "lat": "44.57457",
        "long": "22.829493"
      },
      {
        "name": "STEJARU",
        "zip": "227138",
        "lat": "44.68455",
        "long": "23.073507"
      },
      {
        "name": "STIGNITA",
        "zip": "227382",
        "lat": "44.492985",
        "long": "23.001373"
      },
      {
        "name": "STIRCOVITA",
        "zip": "227503",
        "lat": "44.355568",
        "long": "23.006506"
      },
      {
        "name": "STREHAIA",
        "zip": "225300",
        "lat": "44.62304",
        "long": "23.195746"
      },
      {
        "name": "STROESTI",
        "zip": "227208",
        "lat": "44.828578",
        "long": "22.897513"
      },
      {
        "name": "STUDINA",
        "zip": "227467",
        "lat": "44.842589",
        "long": "22.78224"
      },
      {
        "name": "SUHARU",
        "zip": "227112",
        "lat": "44.72716",
        "long": "22.858588"
      },
      {
        "name": "SUSITA",
        "zip": "227073",
        "lat": "44.727493",
        "long": "22.602839"
      },
      {
        "name": "SUSITA",
        "zip": "227238",
        "lat": "44.624496",
        "long": "23.356274"
      },
      {
        "name": "SVINITA",
        "zip": "227440",
        "lat": "44.500095",
        "long": "22.093917"
      },
      {
        "name": "TALAPANU",
        "zip": "227066",
        "lat": "44.578395",
        "long": "23.235951"
      },
      {
        "name": "TAMNA",
        "zip": "227470",
        "lat": "44.571336",
        "long": "23.014938"
      },
      {
        "name": "TANTARU",
        "zip": "227098",
        "lat": "44.537627",
        "long": "23.341863"
      },
      {
        "name": "TARSA",
        "zip": "227438",
        "lat": "44.569663",
        "long": "23.29978"
      },
      {
        "name": "TIGANASI",
        "zip": "227088",
        "lat": "44.432308",
        "long": "22.500372"
      },
      {
        "name": "TISMANA",
        "zip": "227166",
        "lat": "44.523548",
        "long": "22.663868"
      },
      {
        "name": "TITERLESTI",
        "zip": "225108",
        "lat": "45.02208",
        "long": "22.800459"
      },
      {
        "name": "TITIRIGI",
        "zip": "227511",
        "lat": "44.639371",
        "long": "23.048698"
      },
      {
        "name": "TRAIAN",
        "zip": "225404",
        "lat": "44.458473",
        "long": "22.856505"
      },
      {
        "name": "TURTABA",
        "zip": "227293",
        "lat": "44.979855",
        "long": "22.691967"
      },
      {
        "name": "VALEA ANILOR",
        "zip": "227146",
        "lat": "44.364902",
        "long": "22.920526"
      },
      {
        "name": "VALEA BUNA",
        "zip": "227512",
        "lat": "44.635981",
        "long": "23.110798"
      },
      {
        "name": "VALEA COPCII",
        "zip": "227453",
        "lat": "44.635436",
        "long": "22.760306"
      },
      {
        "name": "VALEA COSUSTEI",
        "zip": "227113",
        "lat": "44.707292",
        "long": "22.915726"
      },
      {
        "name": "VALEA MARCULUI",
        "zip": "227186",
        "lat": "44.515966",
        "long": "23.242339"
      },
      {
        "name": "VALEA PETRII",
        "zip": "227229",
        "lat": "44.582688",
        "long": "23.091997"
      },
      {
        "name": "VALEA TEIULUI",
        "zip": "227067",
        "lat": "44.5609",
        "long": "23.155712"
      },
      {
        "name": "VALEA URSULUI",
        "zip": "227377",
        "lat": "44.987943",
        "long": "22.728255"
      },
      {
        "name": "VALEA URSULUI",
        "zip": "227482",
        "lat": "44.590336",
        "long": "23.05532"
      },
      {
        "name": "VANATORI",
        "zip": "227490",
        "lat": "44.240287",
        "long": "22.930008"
      },
      {
        "name": "VANJU MARE",
        "zip": "225400",
        "lat": "44.425033",
        "long": "22.871267"
      },
      {
        "name": "VANJULET",
        "zip": "227495",
        "lat": "44.443755",
        "long": "22.79336"
      },
      {
        "name": "VARODIA",
        "zip": "227187",
        "lat": "44.528358",
        "long": "23.104197"
      },
      {
        "name": "VIASU",
        "zip": "227351",
        "lat": "44.354172",
        "long": "22.825665"
      },
      {
        "name": "VIDIMIRESTI",
        "zip": "227027",
        "lat": "44.859675",
        "long": "22.82538"
      },
      {
        "name": "VISINA",
        "zip": "227231",
        "lat": "44.573073",
        "long": "23.12806"
      },
      {
        "name": "VLADAIA",
        "zip": "227500",
        "lat": "44.357612",
        "long": "23.028024"
      },
      {
        "name": "VLADASESTI",
        "zip": "227139",
        "lat": "44.649922",
        "long": "23.132847"
      },
      {
        "name": "VLADICA",
        "zip": "227188",
        "lat": "44.50845",
        "long": "23.072724"
      },
      {
        "name": "VOLOIAC",
        "zip": "227505",
        "lat": "44.62501",
        "long": "23.095121"
      },
      {
        "name": "VOLOICEL",
        "zip": "227513",
        "lat": "44.623276",
        "long": "23.064342"
      },
      {
        "name": "VRANCEA",
        "zip": "227089",
        "lat": "44.544816",
        "long": "22.598747"
      },
      {
        "name": "VRATA",
        "zip": "227211",
        "lat": "44.188693",
        "long": "22.850918"
      },
      {
        "name": "ZEGAIA",
        "zip": "227407",
        "lat": "44.633126",
        "long": "22.833189"
      },
      {
        "name": "ZEGUJANI",
        "zip": "227209",
        "lat": "44.808539",
        "long": "22.915228"
      }
    ],
    "MUREȘ": [
      {
        "name": "ABUD",
        "zip": "547266",
        "lat": "46.525105",
        "long": "24.916361"
      },
      {
        "name": "ABUS",
        "zip": "547401",
        "lat": "46.357585",
        "long": "24.383033"
      },
      {
        "name": "ACATARI",
        "zip": "547005",
        "lat": "46.479546",
        "long": "24.633858"
      },
      {
        "name": "ADAMUS",
        "zip": "547015",
        "lat": "46.304211",
        "long": "24.236176"
      },
      {
        "name": "ADRIAN",
        "zip": "547296",
        "lat": "46.782092",
        "long": "24.833242"
      },
      {
        "name": "ADRIANU MARE",
        "zip": "547246",
        "lat": "46.493573",
        "long": "24.803244"
      },
      {
        "name": "ADRIANU MIC",
        "zip": "547247",
        "lat": "46.500821",
        "long": "24.790514"
      },
      {
        "name": "AGRISTEU",
        "zip": "547101",
        "lat": "46.391728",
        "long": "24.683796"
      },
      {
        "name": "ALBESTI",
        "zip": "547025",
        "lat": "46.239527",
        "long": "24.850026"
      },
      {
        "name": "ALUNIS",
        "zip": "547035",
        "lat": "46.891566",
        "long": "24.814752"
      },
      {
        "name": "ANDRENEASA",
        "zip": "547481",
        "lat": "46.967843",
        "long": "25.024235"
      },
      {
        "name": "ANGOFA",
        "zip": "545401",
        "lat": "46.186582",
        "long": "24.78418"
      },
      {
        "name": "APALINA",
        "zip": "545301",
        "lat": "46.752313",
        "long": "24.692755"
      },
      {
        "name": "APOLD",
        "zip": "547040",
        "lat": "46.127376",
        "long": "24.820359"
      },
      {
        "name": "ARCHITA",
        "zip": "547636",
        "lat": "46.180672",
        "long": "25.089005"
      },
      {
        "name": "ARSITA",
        "zip": "547311",
        "lat": "46.785135",
        "long": "24.988857"
      },
      {
        "name": "ATINTIS",
        "zip": "547045",
        "lat": "46.430674",
        "long": "24.105109"
      },
      {
        "name": "AUREL VLAICU",
        "zip": "545402",
        "lat": "46.191545",
        "long": "24.802161"
      },
      {
        "name": "AVRAMESTI",
        "zip": "545201",
        "lat": "46.53539",
        "long": "24.099841"
      },
      {
        "name": "BAGACIU",
        "zip": "547090",
        "lat": "46.271322",
        "long": "24.373635"
      },
      {
        "name": "BAHNEA",
        "zip": "547055",
        "lat": "46.374045",
        "long": "24.479028"
      },
      {
        "name": "BAITA",
        "zip": "547376",
        "lat": "46.836352",
        "long": "24.529997"
      },
      {
        "name": "BALA",
        "zip": "547095",
        "lat": "46.71309",
        "long": "24.50019"
      },
      {
        "name": "BALAUSERI",
        "zip": "547100",
        "lat": "46.408966",
        "long": "24.688941"
      },
      {
        "name": "BALDA",
        "zip": "547516",
        "lat": "46.733528",
        "long": "24.143616"
      },
      {
        "name": "BAND",
        "zip": "547065",
        "lat": "46.579349",
        "long": "24.373936"
      },
      {
        "name": "BARA",
        "zip": "547386",
        "lat": "46.572213",
        "long": "24.87262"
      },
      {
        "name": "BARBOSI",
        "zip": "547661",
        "lat": "46.580872",
        "long": "24.181935"
      },
      {
        "name": "BARDESTI",
        "zip": "547566",
        "lat": "46.594513",
        "long": "24.513093"
      },
      {
        "name": "BARLIBAS",
        "zip": "547556",
        "lat": "46.688965",
        "long": "24.245494"
      },
      {
        "name": "BARLIBASOAIA",
        "zip": "547026",
        "lat": "46.296288",
        "long": "24.83137"
      },
      {
        "name": "BARZA",
        "zip": "547541",
        "lat": "46.574152",
        "long": "24.146232"
      },
      {
        "name": "BATOS",
        "zip": "547085",
        "lat": "46.884797",
        "long": "24.652554"
      },
      {
        "name": "BEDENI",
        "zip": "547248",
        "lat": "46.467342",
        "long": "24.782714"
      },
      {
        "name": "BEICA DE JOS",
        "zip": "547110",
        "lat": "46.734693",
        "long": "24.796685"
      },
      {
        "name": "BEICA DE SUS",
        "zip": "547111",
        "lat": "46.737954",
        "long": "24.822701"
      },
      {
        "name": "BERENI",
        "zip": "547387",
        "lat": "46.557335",
        "long": "24.868207"
      },
      {
        "name": "BERGHIA",
        "zip": "547451",
        "lat": "46.539646",
        "long": "24.429614"
      },
      {
        "name": "BERNADEA",
        "zip": "547056",
        "lat": "46.374068",
        "long": "24.458466"
      },
      {
        "name": "BEU",
        "zip": "547411",
        "lat": "46.573394",
        "long": "24.717897"
      },
      {
        "name": "BEZID",
        "zip": "547536",
        "lat": "46.403416",
        "long": "24.923401"
      },
      {
        "name": "BEZIDU NOU",
        "zip": "547537",
        "lat": "46.420474",
        "long": "24.908054"
      },
      {
        "name": "BICASU",
        "zip": "547312",
        "lat": "46.807994",
        "long": "24.950174"
      },
      {
        "name": "BICHIS",
        "zip": "547120",
        "lat": "46.374262",
        "long": "24.091968"
      },
      {
        "name": "BISTRA MURESULUI",
        "zip": "547206",
        "lat": "46.960932",
        "long": "24.905059"
      },
      {
        "name": "BLIDIREASA",
        "zip": "547326",
        "lat": "46.761838",
        "long": "25.030615"
      },
      {
        "name": "BOBOHALMA",
        "zip": "545601",
        "lat": "46.351139",
        "long": "24.234903"
      },
      {
        "name": "BOGATA",
        "zip": "547125",
        "lat": "46.456408",
        "long": "24.119617"
      },
      {
        "name": "BOIU",
        "zip": "547027",
        "lat": "46.265703",
        "long": "24.874823"
      },
      {
        "name": "BOLINTINENI",
        "zip": "547456",
        "lat": "46.492457",
        "long": "24.713093"
      },
      {
        "name": "BOLOGAIA",
        "zip": "547466",
        "lat": "46.638212",
        "long": "24.25686"
      },
      {
        "name": "BORD",
        "zip": "547191",
        "lat": "46.392681",
        "long": "24.225235"
      },
      {
        "name": "BORDOSIU",
        "zip": "547236",
        "lat": "46.396296",
        "long": "24.784141"
      },
      {
        "name": "BORZIA",
        "zip": "547482",
        "lat": "46.968773",
        "long": "24.933033"
      },
      {
        "name": "BOTEI",
        "zip": "547662",
        "lat": "46.635768",
        "long": "24.135373"
      },
      {
        "name": "BOTEZ",
        "zip": "547046",
        "lat": "46.38688",
        "long": "24.02354"
      },
      {
        "name": "BOTORCA",
        "zip": "545602",
        "lat": "46.282317",
        "long": "24.301574"
      },
      {
        "name": "BOZED",
        "zip": "547141",
        "lat": "46.687357",
        "long": "24.46226"
      },
      {
        "name": "BOZENI",
        "zip": "547366",
        "lat": "46.530936",
        "long": "24.670248"
      },
      {
        "name": "BRADETELU",
        "zip": "547327",
        "lat": "46.755389",
        "long": "25.05171"
      },
      {
        "name": "BRANCOVENESTI",
        "zip": "547130",
        "lat": "46.857125",
        "long": "24.761303"
      },
      {
        "name": "BREAZA",
        "zip": "547135",
        "lat": "46.761177",
        "long": "24.636739"
      },
      {
        "name": "BUDIU MIC",
        "zip": "547176",
        "lat": "46.509206",
        "long": "24.584807"
      },
      {
        "name": "BUJOR",
        "zip": "547421",
        "lat": "46.65534",
        "long": "24.173422"
      },
      {
        "name": "BUJOR-HODAIE",
        "zip": "547663",
        "lat": "46.645983",
        "long": "24.162911"
      },
      {
        "name": "CACIULATA",
        "zip": "547486",
        "lat": "46.715497",
        "long": "24.402257"
      },
      {
        "name": "CACUCIU",
        "zip": "547112",
        "lat": "46.725594",
        "long": "24.849867"
      },
      {
        "name": "CALIMANESTI",
        "zip": "547237",
        "lat": "46.413325",
        "long": "24.732709"
      },
      {
        "name": "CALUGARENI",
        "zip": "547211",
        "lat": "46.629819",
        "long": "24.877723"
      },
      {
        "name": "CALUSERI",
        "zip": "547216",
        "lat": "46.604046",
        "long": "24.734782"
      },
      {
        "name": "CAMPENITA",
        "zip": "547142",
        "lat": "46.65125",
        "long": "24.486803"
      },
      {
        "name": "CAMPU CETATII",
        "zip": "547212",
        "lat": "46.670427",
        "long": "25.013973"
      },
      {
        "name": "CANDU",
        "zip": "547388",
        "lat": "46.599177",
        "long": "24.887908"
      },
      {
        "name": "CAPALNA DE SUS",
        "zip": "547402",
        "lat": "46.377744",
        "long": "24.434403"
      },
      {
        "name": "CAPETI",
        "zip": "545501",
        "lat": "46.630616",
        "long": "25.077962"
      },
      {
        "name": "CAPUSU DE CAMPIE",
        "zip": "547341",
        "lat": "46.542263",
        "long": "24.314142"
      },
      {
        "name": "CASVA",
        "zip": "547297",
        "lat": "46.781936",
        "long": "24.87788"
      },
      {
        "name": "CECALACA",
        "zip": "547047",
        "lat": "46.396077",
        "long": "24.0415"
      },
      {
        "name": "CEIE",
        "zip": "547267",
        "lat": "46.463287",
        "long": "24.979241"
      },
      {
        "name": "CERGHID",
        "zip": "547606",
        "lat": "46.414509",
        "long": "24.44602"
      },
      {
        "name": "CERGHIZEL",
        "zip": "547607",
        "lat": "46.44451",
        "long": "24.446878"
      },
      {
        "name": "CEUAS",
        "zip": "547403",
        "lat": "46.343084",
        "long": "24.442932"
      },
      {
        "name": "CEUASU DE CAMPIE",
        "zip": "547140",
        "lat": "46.642931",
        "long": "24.513871"
      },
      {
        "name": "CHENDU",
        "zip": "547102",
        "lat": "46.391226",
        "long": "24.730019"
      },
      {
        "name": "CHETANI",
        "zip": "547150",
        "lat": "46.464351",
        "long": "24.02788"
      },
      {
        "name": "CHIBED",
        "zip": "547268",
        "lat": "46.532876",
        "long": "24.962435"
      },
      {
        "name": "CHIHERU DE JOS",
        "zip": "547160",
        "lat": "46.687002",
        "long": "24.881636"
      },
      {
        "name": "CHIHERU DE SUS",
        "zip": "547161",
        "lat": "46.681348",
        "long": "24.903598"
      },
      {
        "name": "CHINARI",
        "zip": "547567",
        "lat": "46.605257",
        "long": "24.589691"
      },
      {
        "name": "CHINCIUS",
        "zip": "547016",
        "lat": "46.352354",
        "long": "24.183233"
      },
      {
        "name": "CHIRILEU",
        "zip": "547551",
        "lat": "46.476644",
        "long": "24.382965"
      },
      {
        "name": "CHISALITA",
        "zip": "547342",
        "lat": "46.561859",
        "long": "24.314299"
      },
      {
        "name": "CIBA",
        "zip": "547184",
        "lat": "46.478901",
        "long": "24.566626"
      },
      {
        "name": "CIBU",
        "zip": "547238",
        "lat": "46.379038",
        "long": "24.803708"
      },
      {
        "name": "CINTA",
        "zip": "547177",
        "lat": "46.46022",
        "long": "24.551038"
      },
      {
        "name": "CIOARGA",
        "zip": "545202",
        "lat": "46.493856",
        "long": "24.072965"
      },
      {
        "name": "CIOBOTANI",
        "zip": "547576",
        "lat": "46.950376",
        "long": "25.268729"
      },
      {
        "name": "CIPAIENI",
        "zip": "547542",
        "lat": "46.532477",
        "long": "24.167709"
      },
      {
        "name": "CIPAU",
        "zip": "545101",
        "lat": "46.448757",
        "long": "24.277859"
      },
      {
        "name": "CIRETEA",
        "zip": "547664",
        "lat": "46.603707",
        "long": "24.168518"
      },
      {
        "name": "CIRHAGAU",
        "zip": "547422",
        "lat": "46.660415",
        "long": "24.106869"
      },
      {
        "name": "CIULEA",
        "zip": "547467",
        "lat": "46.666199",
        "long": "24.260766"
      },
      {
        "name": "CIURGAU",
        "zip": "545203",
        "lat": "46.501323",
        "long": "24.105043"
      },
      {
        "name": "CLOASTERF",
        "zip": "547511",
        "lat": "46.145506",
        "long": "24.99536"
      },
      {
        "name": "COASTA GRINDULUI",
        "zip": "547151",
        "lat": "46.494921",
        "long": "23.973961"
      },
      {
        "name": "COASTA MARE",
        "zip": "547487",
        "lat": "46.692907",
        "long": "24.36331"
      },
      {
        "name": "COMORI",
        "zip": "547298",
        "lat": "46.735803",
        "long": "24.896906"
      },
      {
        "name": "CORBESTI",
        "zip": "547006",
        "lat": "46.42943",
        "long": "24.590755"
      },
      {
        "name": "CORDOS",
        "zip": "547152",
        "lat": "46.513953",
        "long": "24.02441"
      },
      {
        "name": "CORNESTI",
        "zip": "547017",
        "lat": "46.293151",
        "long": "24.211506"
      },
      {
        "name": "CORNESTI",
        "zip": "547178",
        "lat": "46.456601",
        "long": "24.586742"
      },
      {
        "name": "COROI",
        "zip": "547166",
        "lat": "46.409099",
        "long": "24.633891"
      },
      {
        "name": "COROISANMARTIN",
        "zip": "547165",
        "lat": "46.407472",
        "long": "24.602019"
      },
      {
        "name": "CORUNCA",
        "zip": "547367",
        "lat": "46.520907",
        "long": "24.61764"
      },
      {
        "name": "COTORINAU",
        "zip": "547488",
        "lat": "46.727401",
        "long": "24.353773"
      },
      {
        "name": "COTUS",
        "zip": "547531",
        "lat": "46.575621",
        "long": "24.671699"
      },
      {
        "name": "COZMA",
        "zip": "547170",
        "lat": "46.807072",
        "long": "24.522532"
      },
      {
        "name": "CRACIUNESTI",
        "zip": "547175",
        "lat": "46.479779",
        "long": "24.581893"
      },
      {
        "name": "CRAIESTI",
        "zip": "547018",
        "lat": "46.29628",
        "long": "24.196748"
      },
      {
        "name": "CRAIESTI",
        "zip": "547180",
        "lat": "46.757708",
        "long": "24.424986"
      },
      {
        "name": "CRIS",
        "zip": "547201",
        "lat": "46.143557",
        "long": "24.693845"
      },
      {
        "name": "CRISTESTI",
        "zip": "547185",
        "lat": "46.503859",
        "long": "24.484457"
      },
      {
        "name": "CUCERDEA",
        "zip": "547190",
        "lat": "46.402476",
        "long": "24.266058"
      },
      {
        "name": "CUCI",
        "zip": "547195",
        "lat": "46.464269",
        "long": "24.156226"
      },
      {
        "name": "CUIESD",
        "zip": "547452",
        "lat": "46.601682",
        "long": "24.478116"
      },
      {
        "name": "CULPIU",
        "zip": "547143",
        "lat": "46.639608",
        "long": "24.43258"
      },
      {
        "name": "CUND",
        "zip": "547057",
        "lat": "46.271353",
        "long": "24.51342"
      },
      {
        "name": "CURETE",
        "zip": "547489",
        "lat": "46.740489",
        "long": "24.429807"
      },
      {
        "name": "CURTENI",
        "zip": "547568",
        "lat": "46.594767",
        "long": "24.573342"
      },
      {
        "name": "CUSTELNIC",
        "zip": "545603",
        "lat": "46.338962",
        "long": "24.311768"
      },
      {
        "name": "DAIA",
        "zip": "547041",
        "lat": "46.147079",
        "long": "24.902744"
      },
      {
        "name": "DAIA",
        "zip": "547058",
        "lat": "46.305601",
        "long": "24.462762"
      },
      {
        "name": "DALU",
        "zip": "547543",
        "lat": "46.545264",
        "long": "24.089695"
      },
      {
        "name": "DAMBAU",
        "zip": "547019",
        "lat": "46.318811",
        "long": "24.232793"
      },
      {
        "name": "DAMBU",
        "zip": "547557",
        "lat": "46.74256",
        "long": "24.268585"
      },
      {
        "name": "DAMIENI",
        "zip": "547213",
        "lat": "46.626122",
        "long": "24.860714"
      },
      {
        "name": "DANES",
        "zip": "547200",
        "lat": "46.22059",
        "long": "24.707711"
      },
      {
        "name": "DATASENI",
        "zip": "547196",
        "lat": "46.474748",
        "long": "24.174852"
      },
      {
        "name": "DEAG",
        "zip": "545102",
        "lat": "46.389185",
        "long": "24.192204"
      },
      {
        "name": "DEAJ",
        "zip": "547404",
        "lat": "46.347107",
        "long": "24.402065"
      },
      {
        "name": "DEDA",
        "zip": "547205",
        "lat": "46.947477",
        "long": "24.871765"
      },
      {
        "name": "DEDRAD",
        "zip": "547086",
        "lat": "46.826321",
        "long": "24.657994"
      },
      {
        "name": "DELENI",
        "zip": "547091",
        "lat": "46.263403",
        "long": "24.34119"
      },
      {
        "name": "DELENI",
        "zip": "547361",
        "lat": "46.836972",
        "long": "24.808662"
      },
      {
        "name": "DELENI",
        "zip": "547468",
        "lat": "46.67505",
        "long": "24.281243"
      },
      {
        "name": "DILEU NOU",
        "zip": "547552",
        "lat": "46.463265",
        "long": "24.332676"
      },
      {
        "name": "DILEU VECHI",
        "zip": "547441",
        "lat": "46.47109",
        "long": "24.309875"
      },
      {
        "name": "DOBRA",
        "zip": "547446",
        "lat": "46.58091",
        "long": "24.237833"
      },
      {
        "name": "DRACULEA BANDULUI",
        "zip": "547066",
        "lat": "46.619438",
        "long": "24.337411"
      },
      {
        "name": "DROJDII",
        "zip": "547389",
        "lat": "46.545966",
        "long": "24.85711"
      },
      {
        "name": "DUBISTEA DE PADURE",
        "zip": "547313",
        "lat": "46.776791",
        "long": "24.965151"
      },
      {
        "name": "DULCEA",
        "zip": "547328",
        "lat": "46.762091",
        "long": "25.02395"
      },
      {
        "name": "DUMBRAVA",
        "zip": "547631",
        "lat": "46.942068",
        "long": "24.804914"
      },
      {
        "name": "DUMBRAVIOARA",
        "zip": "547217",
        "lat": "46.643064",
        "long": "24.636128"
      },
      {
        "name": "DUMITRENI",
        "zip": "547103",
        "lat": "46.400926",
        "long": "24.758548"
      },
      {
        "name": "DUMITRESTI",
        "zip": "547412",
        "lat": "46.521707",
        "long": "24.787885"
      },
      {
        "name": "DUPA DEAL",
        "zip": "547197",
        "lat": "46.493934",
        "long": "24.178542"
      },
      {
        "name": "DUPA DEAL",
        "zip": "547343",
        "lat": "46.517408",
        "long": "24.246296"
      },
      {
        "name": "ERCEA",
        "zip": "547096",
        "lat": "46.730814",
        "long": "24.510574"
      },
      {
        "name": "EREMIENI",
        "zip": "547391",
        "lat": "46.536419",
        "long": "24.871582"
      },
      {
        "name": "EREMITU",
        "zip": "547210",
        "lat": "46.661686",
        "long": "24.924111"
      },
      {
        "name": "ERNEI",
        "zip": "547215",
        "lat": "46.605858",
        "long": "24.643109"
      },
      {
        "name": "FANATE",
        "zip": "547067",
        "lat": "46.6462",
        "long": "24.317041"
      },
      {
        "name": "FANATE",
        "zip": "547226",
        "lat": "46.769461",
        "long": "24.471828"
      },
      {
        "name": "FANATE",
        "zip": "547344",
        "lat": "46.533032",
        "long": "24.218661"
      },
      {
        "name": "FANATE",
        "zip": "547601",
        "lat": "46.566883",
        "long": "24.074191"
      },
      {
        "name": "FANATELE CAPUSULUI",
        "zip": "547346",
        "lat": "46.579495",
        "long": "24.267324"
      },
      {
        "name": "FANATELE MADARASULUI",
        "zip": "547068",
        "lat": "46.620138",
        "long": "24.386912"
      },
      {
        "name": "FANATELE SOCOLULUI",
        "zip": "547171",
        "lat": "46.79265",
        "long": "24.485918"
      },
      {
        "name": "FANTANA BABII",
        "zip": "547469",
        "lat": "46.677422",
        "long": "24.337764"
      },
      {
        "name": "FANTANELE",
        "zip": "547235",
        "lat": "46.421302",
        "long": "24.769637"
      },
      {
        "name": "FARAGAU",
        "zip": "547225",
        "lat": "46.762608",
        "long": "24.517452"
      },
      {
        "name": "FELEAG",
        "zip": "547637",
        "lat": "46.239948",
        "long": "25.015176"
      },
      {
        "name": "FILEA",
        "zip": "547207",
        "lat": "46.941797",
        "long": "24.883755"
      },
      {
        "name": "FILITELNIC",
        "zip": "547104",
        "lat": "46.366389",
        "long": "24.668003"
      },
      {
        "name": "FILPISU MARE",
        "zip": "547136",
        "lat": "46.753327",
        "long": "24.587499"
      },
      {
        "name": "FILPISU MIC",
        "zip": "547137",
        "lat": "46.782197",
        "long": "24.601248"
      },
      {
        "name": "FITCAU",
        "zip": "547036",
        "lat": "46.899082",
        "long": "24.870002"
      },
      {
        "name": "FOI",
        "zip": "547187",
        "lat": "46.479652",
        "long": "24.597918"
      },
      {
        "name": "FRUNZENI",
        "zip": "547377",
        "lat": "46.814458",
        "long": "24.567969"
      },
      {
        "name": "FUNDATURA",
        "zip": "545204",
        "lat": "46.548173",
        "long": "24.036746"
      },
      {
        "name": "FUNDOAIA",
        "zip": "547299",
        "lat": "46.827625",
        "long": "24.90466"
      },
      {
        "name": "GAIESTI",
        "zip": "547007",
        "lat": "46.425497",
        "long": "24.67088"
      },
      {
        "name": "GALAOAIA",
        "zip": "547483",
        "lat": "46.97075",
        "long": "24.924591"
      },
      {
        "name": "GALATENI",
        "zip": "547457",
        "lat": "46.473197",
        "long": "24.707854"
      },
      {
        "name": "GALESTI",
        "zip": "547245",
        "lat": "46.512453",
        "long": "24.757406"
      },
      {
        "name": "GAMBUT",
        "zip": "547121",
        "lat": "46.352424",
        "long": "24.065234"
      },
      {
        "name": "GANESTI",
        "zip": "547255",
        "lat": "46.334315",
        "long": "24.360407"
      },
      {
        "name": "GAURA SANGERULUI",
        "zip": "547666",
        "lat": "46.599607",
        "long": "24.123304"
      },
      {
        "name": "GHEJA",
        "zip": "545205",
        "lat": "46.444948",
        "long": "24.061359"
      },
      {
        "name": "GHEORGHE DOJA",
        "zip": "547260",
        "lat": "46.463278",
        "long": "24.51122"
      },
      {
        "name": "GHIDASTEU",
        "zip": "547347",
        "lat": "46.547686",
        "long": "24.279519"
      },
      {
        "name": "GHINDARI",
        "zip": "547265",
        "lat": "46.504928",
        "long": "24.925352"
      },
      {
        "name": "GHINESTI",
        "zip": "547436",
        "lat": "46.496309",
        "long": "24.865739"
      },
      {
        "name": "GIULUS",
        "zip": "547442",
        "lat": "46.401682",
        "long": "24.311366"
      },
      {
        "name": "GIURGIS",
        "zip": "547153",
        "lat": "46.515752",
        "long": "23.968569"
      },
      {
        "name": "GLAJARIE",
        "zip": "547301",
        "lat": "46.83271",
        "long": "24.932849"
      },
      {
        "name": "GLODENI",
        "zip": "547275",
        "lat": "46.65348",
        "long": "24.609997"
      },
      {
        "name": "GOGAN",
        "zip": "547059",
        "lat": "46.307781",
        "long": "24.515391"
      },
      {
        "name": "GORENI",
        "zip": "547087",
        "lat": "46.85426",
        "long": "24.654535"
      },
      {
        "name": "GORNESTI",
        "zip": "547280",
        "lat": "46.673061",
        "long": "24.645497"
      },
      {
        "name": "GRADINI",
        "zip": "547616",
        "lat": "46.614744",
        "long": "24.090343"
      },
      {
        "name": "GRAUSORUL",
        "zip": "547626",
        "lat": "46.599134",
        "long": "24.830486"
      },
      {
        "name": "GREBENISU DE CAMPIE",
        "zip": "547290",
        "lat": "46.608806",
        "long": "24.311713"
      },
      {
        "name": "GRINDENI",
        "zip": "547154",
        "lat": "46.500059",
        "long": "23.996923"
      },
      {
        "name": "GROAPA RADAII",
        "zip": "547423",
        "lat": "46.658203",
        "long": "24.232037"
      },
      {
        "name": "GRUISOR",
        "zip": "547008",
        "lat": "46.452739",
        "long": "24.61717"
      },
      {
        "name": "GURGHIU",
        "zip": "547295",
        "lat": "46.77223",
        "long": "24.857979"
      },
      {
        "name": "HABIC",
        "zip": "547461",
        "lat": "46.70796",
        "long": "24.790601"
      },
      {
        "name": "HADARENI",
        "zip": "547156",
        "lat": "46.466984",
        "long": "23.983739"
      },
      {
        "name": "HAGAU",
        "zip": "547491",
        "lat": "46.715078",
        "long": "24.375322"
      },
      {
        "name": "HARANGLAB",
        "zip": "547406",
        "lat": "46.304758",
        "long": "24.415353"
      },
      {
        "name": "HARTAU",
        "zip": "547453",
        "lat": "46.577328",
        "long": "24.478623"
      },
      {
        "name": "HEREPEA",
        "zip": "547021",
        "lat": "46.330743",
        "long": "24.155157"
      },
      {
        "name": "HERGHELIA",
        "zip": "547144",
        "lat": "46.63106",
        "long": "24.478188"
      },
      {
        "name": "HETIUR",
        "zip": "545403",
        "lat": "46.27194",
        "long": "24.770024"
      },
      {
        "name": "HODAC",
        "zip": "547310",
        "lat": "46.774477",
        "long": "24.922324"
      },
      {
        "name": "HODAIA",
        "zip": "547227",
        "lat": "46.773676",
        "long": "24.479282"
      },
      {
        "name": "HODOSA",
        "zip": "547320",
        "lat": "46.636979",
        "long": "24.825378"
      },
      {
        "name": "IARA DE MURES",
        "zip": "547281",
        "lat": "46.661484",
        "long": "24.730556"
      },
      {
        "name": "IBANESTI",
        "zip": "547325",
        "lat": "46.770503",
        "long": "24.92991"
      },
      {
        "name": "IBANESTI-PADURE",
        "zip": "547329",
        "lat": "46.764294",
        "long": "24.98382"
      },
      {
        "name": "ICLAND",
        "zip": "547218",
        "lat": "46.611969",
        "long": "24.693377"
      },
      {
        "name": "ICLANDU MARE",
        "zip": "547348",
        "lat": "46.528104",
        "long": "24.265365"
      },
      {
        "name": "ICLANZEL",
        "zip": "547340",
        "lat": "46.523368",
        "long": "24.275183"
      },
      {
        "name": "IDECIU DE JOS",
        "zip": "547360",
        "lat": "46.816901",
        "long": "24.761145"
      },
      {
        "name": "IDECIU DE SUS",
        "zip": "547362",
        "lat": "46.842506",
        "long": "24.770627"
      },
      {
        "name": "IDICEL",
        "zip": "547131",
        "lat": "46.854806",
        "long": "24.82252"
      },
      {
        "name": "IDICEL-PADURE",
        "zip": "547132",
        "lat": "46.854457",
        "long": "24.857101"
      },
      {
        "name": "IDICIU",
        "zip": "547061",
        "lat": "46.276974",
        "long": "24.458446"
      },
      {
        "name": "IDRIFAIA",
        "zip": "547581",
        "lat": "46.387866",
        "long": "24.464762"
      },
      {
        "name": "IERNUT",
        "zip": "545100",
        "lat": "46.451336",
        "long": "24.233575"
      },
      {
        "name": "IERNUTENI",
        "zip": "545302",
        "lat": "46.764506",
        "long": "24.717481"
      },
      {
        "name": "IHOD",
        "zip": "547321",
        "lat": "46.634947",
        "long": "24.798986"
      },
      {
        "name": "ILIENI",
        "zip": "547261",
        "lat": "46.463709",
        "long": "24.530214"
      },
      {
        "name": "ILIESI",
        "zip": "545502",
        "lat": "46.582589",
        "long": "25.127767"
      },
      {
        "name": "ILIOARA",
        "zip": "547282",
        "lat": "46.644704",
        "long": "24.744581"
      },
      {
        "name": "IOD",
        "zip": "547484",
        "lat": "46.973368",
        "long": "24.977196"
      },
      {
        "name": "ISLA",
        "zip": "547322",
        "lat": "46.626615",
        "long": "24.783016"
      },
      {
        "name": "ISTAN-TAU",
        "zip": "547069",
        "lat": "46.649843",
        "long": "24.301999"
      },
      {
        "name": "ISTIHAZA",
        "zip": "547048",
        "lat": "46.392679",
        "long": "24.105241"
      },
      {
        "name": "IVANESTI",
        "zip": "547368",
        "lat": "46.541739",
        "long": "24.675153"
      },
      {
        "name": "JABENITA",
        "zip": "547571",
        "lat": "46.78259",
        "long": "24.793953"
      },
      {
        "name": "JACODU",
        "zip": "547641",
        "lat": "46.327815",
        "long": "24.83056"
      },
      {
        "name": "JACU",
        "zip": "547028",
        "lat": "46.321579",
        "long": "24.814065"
      },
      {
        "name": "LAPUSNA",
        "zip": "547331",
        "lat": "46.767949",
        "long": "25.215018"
      },
      {
        "name": "LARGA",
        "zip": "547302",
        "lat": "46.825054",
        "long": "24.916301"
      },
      {
        "name": "LARGA",
        "zip": "547517",
        "lat": "46.729076",
        "long": "24.183094"
      },
      {
        "name": "LASCUD",
        "zip": "547443",
        "lat": "46.391821",
        "long": "24.355646"
      },
      {
        "name": "LASLAU MARE",
        "zip": "547582",
        "lat": "46.38396",
        "long": "24.540571"
      },
      {
        "name": "LASLAU MIC",
        "zip": "547583",
        "lat": "46.369272",
        "long": "24.55267"
      },
      {
        "name": "LAURENI",
        "zip": "547413",
        "lat": "46.543221",
        "long": "24.734696"
      },
      {
        "name": "LECHINCIOARA",
        "zip": "547596",
        "lat": "46.665702",
        "long": "24.420089"
      },
      {
        "name": "LECHINTA",
        "zip": "545103",
        "lat": "46.473756",
        "long": "24.226536"
      },
      {
        "name": "LEFAIA",
        "zip": "547181",
        "lat": "46.749406",
        "long": "24.468477"
      },
      {
        "name": "LENIS",
        "zip": "547492",
        "lat": "46.730893",
        "long": "24.419636"
      },
      {
        "name": "LEORDENI",
        "zip": "547262",
        "lat": "46.471077",
        "long": "24.486318"
      },
      {
        "name": "LEORINTA",
        "zip": "547291",
        "lat": "46.60825",
        "long": "24.229741"
      },
      {
        "name": "LEORINTA-SAULIA",
        "zip": "547591",
        "lat": "46.618973",
        "long": "24.212209"
      },
      {
        "name": "LEPINDEA",
        "zip": "547062",
        "lat": "46.327769",
        "long": "24.471321"
      },
      {
        "name": "LINT",
        "zip": "547157",
        "lat": "46.535652",
        "long": "24.003935"
      },
      {
        "name": "LIVEZENI",
        "zip": "547365",
        "lat": "46.550526",
        "long": "24.633374"
      },
      {
        "name": "LOGIG",
        "zip": "547378",
        "lat": "46.879456",
        "long": "24.573776"
      },
      {
        "name": "LOTU",
        "zip": "547538",
        "lat": "46.400288",
        "long": "24.896336"
      },
      {
        "name": "LUDUS",
        "zip": "545200",
        "lat": "46.483305",
        "long": "24.095084"
      },
      {
        "name": "LUIERIU",
        "zip": "547586",
        "lat": "46.845479",
        "long": "24.721051"
      },
      {
        "name": "LUNCA",
        "zip": "547375",
        "lat": "46.849255",
        "long": "24.575918"
      },
      {
        "name": "LUNCA BRADULUI",
        "zip": "547380",
        "lat": "46.956979",
        "long": "25.113736"
      },
      {
        "name": "LUNCA MURESULUI",
        "zip": "547037",
        "lat": "46.874599",
        "long": "24.790733"
      },
      {
        "name": "MACICASESTI",
        "zip": "547592",
        "lat": "46.623665",
        "long": "24.245546"
      },
      {
        "name": "MADARAS",
        "zip": "547071",
        "lat": "46.605428",
        "long": "24.433808"
      },
      {
        "name": "MADARASENI",
        "zip": "547349",
        "lat": "46.50326",
        "long": "24.256877"
      },
      {
        "name": "MAGHERANI",
        "zip": "547385",
        "lat": "46.563759",
        "long": "24.90716"
      },
      {
        "name": "MAGHERUS",
        "zip": "547431",
        "lat": "46.321541",
        "long": "24.688501"
      },
      {
        "name": "MAIA",
        "zip": "547392",
        "lat": "46.581181",
        "long": "24.848184"
      },
      {
        "name": "MAIAD",
        "zip": "547249",
        "lat": "46.519671",
        "long": "24.714854"
      },
      {
        "name": "MAIORESTI",
        "zip": "547506",
        "lat": "46.907872",
        "long": "24.8106"
      },
      {
        "name": "MALAESTI",
        "zip": "547617",
        "lat": "46.627934",
        "long": "24.096749"
      },
      {
        "name": "MALDAOCI",
        "zip": "547049",
        "lat": "46.416494",
        "long": "24.037308"
      },
      {
        "name": "MALEA",
        "zip": "547667",
        "lat": "46.582426",
        "long": "24.190807"
      },
      {
        "name": "MARASESTI",
        "zip": "547072",
        "lat": "46.593022",
        "long": "24.353275"
      },
      {
        "name": "MARCULENI",
        "zip": "547393",
        "lat": "46.597128",
        "long": "24.86524"
      },
      {
        "name": "MATRICI",
        "zip": "547214",
        "lat": "46.652993",
        "long": "24.902375"
      },
      {
        "name": "MERISOR",
        "zip": "547276",
        "lat": "46.698641",
        "long": "24.54715"
      },
      {
        "name": "MERISORU",
        "zip": "547447",
        "lat": "46.570262",
        "long": "24.214033"
      },
      {
        "name": "MESTERA",
        "zip": "547577",
        "lat": "46.968458",
        "long": "25.192894"
      },
      {
        "name": "MICA",
        "zip": "547400",
        "lat": "46.368046",
        "long": "24.412405"
      },
      {
        "name": "MIERCUREA NIRAJULUI",
        "zip": "547410",
        "lat": "46.534301",
        "long": "24.799838"
      },
      {
        "name": "MIHAI VITEAZU",
        "zip": "547512",
        "lat": "46.155626",
        "long": "25.026601"
      },
      {
        "name": "MIHESU DE CAMPIE",
        "zip": "547420",
        "lat": "46.680191",
        "long": "24.154271"
      },
      {
        "name": "MILASEL",
        "zip": "547182",
        "lat": "46.742161",
        "long": "24.450188"
      },
      {
        "name": "MIRIGIOAIA",
        "zip": "547314",
        "lat": "46.802047",
        "long": "24.928235"
      },
      {
        "name": "MITRESTI",
        "zip": "547627",
        "lat": "46.584493",
        "long": "24.801468"
      },
      {
        "name": "MOARA DE JOS",
        "zip": "547602",
        "lat": "46.565926",
        "long": "24.086911"
      },
      {
        "name": "MOGOAIA",
        "zip": "547424",
        "lat": "46.66991",
        "long": "24.226028"
      },
      {
        "name": "MOISA",
        "zip": "547277",
        "lat": "46.68456",
        "long": "24.528195"
      },
      {
        "name": "MORARENI",
        "zip": "547507",
        "lat": "46.924358",
        "long": "24.831386"
      },
      {
        "name": "MORESTI",
        "zip": "547608",
        "lat": "46.489378",
        "long": "24.43994"
      },
      {
        "name": "MORUT",
        "zip": "547518",
        "lat": "46.743555",
        "long": "24.199084"
      },
      {
        "name": "MOSUNI",
        "zip": "547414",
        "lat": "46.569174",
        "long": "24.742946"
      },
      {
        "name": "MURA MARE",
        "zip": "547283",
        "lat": "46.656737",
        "long": "24.777835"
      },
      {
        "name": "MURA MICA",
        "zip": "547284",
        "lat": "46.647723",
        "long": "24.764467"
      },
      {
        "name": "MURENI",
        "zip": "547638",
        "lat": "46.230817",
        "long": "24.991912"
      },
      {
        "name": "MURESENI",
        "zip": "540001",
        "lat": "46.525385",
        "long": "24.514885"
      },
      {
        "name": "MURGESTI",
        "zip": "547009",
        "lat": "46.480879",
        "long": "24.655164"
      },
      {
        "name": "NADASA",
        "zip": "547113",
        "lat": "46.703119",
        "long": "24.815025"
      },
      {
        "name": "NADES",
        "zip": "547430",
        "lat": "46.320764",
        "long": "24.728713"
      },
      {
        "name": "NANDRA",
        "zip": "547122",
        "lat": "46.383004",
        "long": "24.076637"
      },
      {
        "name": "NAZNA",
        "zip": "547526",
        "lat": "46.53552",
        "long": "24.5021"
      },
      {
        "name": "NEAGRA",
        "zip": "547381",
        "lat": "46.972296",
        "long": "25.146853"
      },
      {
        "name": "NEAUA",
        "zip": "547435",
        "lat": "46.477113",
        "long": "24.830612"
      },
      {
        "name": "NEGRENII DE CAMPIE",
        "zip": "547073",
        "lat": "46.631389",
        "long": "24.35189"
      },
      {
        "name": "NICOLESTI",
        "zip": "547188",
        "lat": "46.475353",
        "long": "24.554429"
      },
      {
        "name": "NIMA MILASELULUI",
        "zip": "547183",
        "lat": "46.727149",
        "long": "24.445569"
      },
      {
        "name": "NIMA RACIULUI",
        "zip": "547493",
        "lat": "46.703652",
        "long": "24.443567"
      },
      {
        "name": "OARBA DE MURES",
        "zip": "545104",
        "lat": "46.463254",
        "long": "24.290783"
      },
      {
        "name": "OBARSIE",
        "zip": "547494",
        "lat": "46.744797",
        "long": "24.391483"
      },
      {
        "name": "ODRIHEI",
        "zip": "547167",
        "lat": "46.404673",
        "long": "24.56789"
      },
      {
        "name": "OGRA",
        "zip": "547440",
        "lat": "46.446682",
        "long": "24.318044"
      },
      {
        "name": "ONUCA",
        "zip": "547228",
        "lat": "46.727251",
        "long": "24.579116"
      },
      {
        "name": "ORMENIS",
        "zip": "547646",
        "lat": "46.323731",
        "long": "24.54523"
      },
      {
        "name": "OROIU",
        "zip": "547074",
        "lat": "46.543092",
        "long": "24.3547"
      },
      {
        "name": "OROSIA",
        "zip": "547198",
        "lat": "46.456511",
        "long": "24.140508"
      },
      {
        "name": "ORSOVA",
        "zip": "547303",
        "lat": "46.751534",
        "long": "24.906428"
      },
      {
        "name": "ORSOVA-PADURE",
        "zip": "547304",
        "lat": "46.735815",
        "long": "24.941726"
      },
      {
        "name": "OZD",
        "zip": "547123",
        "lat": "46.357869",
        "long": "24.119871"
      },
      {
        "name": "PACURENI",
        "zip": "547278",
        "lat": "46.661855",
        "long": "24.556515"
      },
      {
        "name": "PADUREA",
        "zip": "547593",
        "lat": "46.632982",
        "long": "24.177314"
      },
      {
        "name": "PADURENI",
        "zip": "547286",
        "lat": "46.640532",
        "long": "24.716247"
      },
      {
        "name": "PAINGENI",
        "zip": "547279",
        "lat": "46.680033",
        "long": "24.561963"
      },
      {
        "name": "PANET",
        "zip": "547450",
        "lat": "46.556204",
        "long": "24.470387"
      },
      {
        "name": "PAPIU ILARIAN",
        "zip": "547445",
        "lat": "46.559321",
        "long": "24.20059"
      },
      {
        "name": "PARAU CRUCII",
        "zip": "547471",
        "lat": "46.694172",
        "long": "24.33705"
      },
      {
        "name": "PARAU CRUCII",
        "zip": "547496",
        "lat": "46.705926",
        "long": "24.353349"
      },
      {
        "name": "PARAU MARE",
        "zip": "547332",
        "lat": "46.763568",
        "long": "25.003577"
      },
      {
        "name": "PASARENI",
        "zip": "547455",
        "lat": "46.491883",
        "long": "24.697804"
      },
      {
        "name": "PAUCISOARA",
        "zip": "547256",
        "lat": "46.350889",
        "long": "24.351188"
      },
      {
        "name": "PAULOAIA",
        "zip": "547306",
        "lat": "46.796483",
        "long": "24.892095"
      },
      {
        "name": "PERIS",
        "zip": "547287",
        "lat": "46.694223",
        "long": "24.663368"
      },
      {
        "name": "PETEA",
        "zip": "547076",
        "lat": "46.510483",
        "long": "24.345711"
      },
      {
        "name": "PETELEA",
        "zip": "547460",
        "lat": "46.730377",
        "long": "24.707199"
      },
      {
        "name": "PETRILACA",
        "zip": "547199",
        "lat": "46.411112",
        "long": "24.145945"
      },
      {
        "name": "PETRILACA DE MURES",
        "zip": "547288",
        "lat": "46.689453",
        "long": "24.751083"
      },
      {
        "name": "PIETRIS",
        "zip": "547208",
        "lat": "46.935937",
        "long": "24.844078"
      },
      {
        "name": "PIPEA",
        "zip": "547432",
        "lat": "46.325235",
        "long": "24.774546"
      },
      {
        "name": "POARTA",
        "zip": "547229",
        "lat": "46.735167",
        "long": "24.561467"
      },
      {
        "name": "PODURI",
        "zip": "547618",
        "lat": "46.629479",
        "long": "24.070518"
      },
      {
        "name": "POGACEAUA",
        "zip": "547465",
        "lat": "46.676058",
        "long": "24.312198"
      },
      {
        "name": "POIENITA",
        "zip": "547369",
        "lat": "46.555623",
        "long": "24.670084"
      },
      {
        "name": "PORUMBAC",
        "zip": "545105",
        "lat": "46.492335",
        "long": "24.260043"
      },
      {
        "name": "PORUMBENI",
        "zip": "547146",
        "lat": "46.63684",
        "long": "24.546804"
      },
      {
        "name": "PRIPOARE",
        "zip": "547544",
        "lat": "46.525723",
        "long": "24.196026"
      },
      {
        "name": "PUSTA",
        "zip": "547597",
        "lat": "46.678123",
        "long": "24.358149"
      },
      {
        "name": "RACAMET",
        "zip": "545106",
        "lat": "46.486797",
        "long": "24.238194"
      },
      {
        "name": "RACIU",
        "zip": "547485",
        "lat": "46.690192",
        "long": "24.396998"
      },
      {
        "name": "RANTA",
        "zip": "547126",
        "lat": "46.506886",
        "long": "24.148544"
      },
      {
        "name": "RAPA DE JOS",
        "zip": "547632",
        "lat": "46.940848",
        "long": "24.76608"
      },
      {
        "name": "RASTOLITA",
        "zip": "547480",
        "lat": "46.972351",
        "long": "24.992944"
      },
      {
        "name": "RAZOARE",
        "zip": "547426",
        "lat": "46.69243",
        "long": "24.19386"
      },
      {
        "name": "RECEA",
        "zip": "547609",
        "lat": "46.465006",
        "long": "24.416718"
      },
      {
        "name": "REGHIN",
        "zip": "545300",
        "lat": "46.779893",
        "long": "24.699145"
      },
      {
        "name": "REMETEA",
        "zip": "540002",
        "lat": "46.572377",
        "long": "24.520868"
      },
      {
        "name": "RIGMANI",
        "zip": "547437",
        "lat": "46.5091",
        "long": "24.838079"
      },
      {
        "name": "RORA",
        "zip": "545404",
        "lat": "46.226064",
        "long": "24.743327"
      },
      {
        "name": "ROSIORI",
        "zip": "545206",
        "lat": "46.514334",
        "long": "24.094756"
      },
      {
        "name": "ROTENI",
        "zip": "547011",
        "lat": "46.458749",
        "long": "24.681826"
      },
      {
        "name": "ROUA",
        "zip": "547239",
        "lat": "46.381293",
        "long": "24.828823"
      },
      {
        "name": "RUSII-MUNTI",
        "zip": "547505",
        "lat": "46.915249",
        "long": "24.832819"
      },
      {
        "name": "SABED",
        "zip": "547147",
        "lat": "46.664423",
        "long": "24.444669"
      },
      {
        "name": "SACADAT",
        "zip": "545503",
        "lat": "46.634174",
        "long": "25.042143"
      },
      {
        "name": "SACALU DE PADURE",
        "zip": "547133",
        "lat": "46.883686",
        "long": "24.711337"
      },
      {
        "name": "SACARENI",
        "zip": "547219",
        "lat": "46.599877",
        "long": "24.697296"
      },
      {
        "name": "SAES",
        "zip": "547042",
        "lat": "46.155738",
        "long": "24.768362"
      },
      {
        "name": "SALARD",
        "zip": "547382",
        "lat": "46.951456",
        "long": "25.075454"
      },
      {
        "name": "SALASURI",
        "zip": "547642",
        "lat": "46.375514",
        "long": "24.776067"
      },
      {
        "name": "SALCUD",
        "zip": "545107",
        "lat": "46.407555",
        "long": "24.171407"
      },
      {
        "name": "SAMBRIAS",
        "zip": "547323",
        "lat": "46.661809",
        "long": "24.82884"
      },
      {
        "name": "SANCRAIU DE MURES",
        "zip": "547525",
        "lat": "46.551036",
        "long": "24.526578"
      },
      {
        "name": "SANDRU",
        "zip": "547448",
        "lat": "46.55197",
        "long": "24.215935"
      },
      {
        "name": "SANGEORGIU DE CAMPIE",
        "zip": "547559",
        "lat": "46.726953",
        "long": "24.296652"
      },
      {
        "name": "SANGEORGIU DE MURES",
        "zip": "547530",
        "lat": "46.576434",
        "long": "24.604208"
      },
      {
        "name": "SANGEORGIU DE PADURE",
        "zip": "547535",
        "lat": "46.431444",
        "long": "24.84217"
      },
      {
        "name": "SANGER",
        "zip": "547540",
        "lat": "46.558342",
        "long": "24.140424"
      },
      {
        "name": "SANGERU DE PADURE",
        "zip": "547221",
        "lat": "46.640718",
        "long": "24.665063"
      },
      {
        "name": "SANIACOB",
        "zip": "547051",
        "lat": "46.423543",
        "long": "24.131916"
      },
      {
        "name": "SANISOR",
        "zip": "547371",
        "lat": "46.542587",
        "long": "24.696111"
      },
      {
        "name": "SANMARGHITA",
        "zip": "547553",
        "lat": "46.481571",
        "long": "24.372332"
      },
      {
        "name": "SANMARTINU DE CAMPIE",
        "zip": "547497",
        "lat": "46.728121",
        "long": "24.408433"
      },
      {
        "name": "SANMIHAI DE PADURE",
        "zip": "547114",
        "lat": "46.728664",
        "long": "24.872627"
      },
      {
        "name": "SANPAUL",
        "zip": "547550",
        "lat": "46.452862",
        "long": "24.352462"
      },
      {
        "name": "SANPETRU DE CAMPIE",
        "zip": "547555",
        "lat": "46.715888",
        "long": "24.262429"
      },
      {
        "name": "SANSIMION",
        "zip": "547438",
        "lat": "46.495494",
        "long": "24.834585"
      },
      {
        "name": "SANTANA DE MURES",
        "zip": "547565",
        "lat": "46.580742",
        "long": "24.559754"
      },
      {
        "name": "SANTIOANA",
        "zip": "547647",
        "lat": "46.283675",
        "long": "24.551323"
      },
      {
        "name": "SANTIOANA DE MURES",
        "zip": "547454",
        "lat": "46.514657",
        "long": "24.457141"
      },
      {
        "name": "SANTU",
        "zip": "547379",
        "lat": "46.80168",
        "long": "24.600744"
      },
      {
        "name": "SANVASII",
        "zip": "547244",
        "lat": "46.495733",
        "long": "24.740026"
      },
      {
        "name": "SAPARTOC",
        "zip": "547029",
        "lat": "46.17115",
        "long": "24.856179"
      },
      {
        "name": "SARATENI",
        "zip": "545504",
        "lat": "46.561975",
        "long": "25.01029"
      },
      {
        "name": "SARDU NIRAJULUI",
        "zip": "547416",
        "lat": "46.54426",
        "long": "24.752856"
      },
      {
        "name": "SARMASEL",
        "zip": "547519",
        "lat": "46.760625",
        "long": "24.178854"
      },
      {
        "name": "SARMASEL-GARA",
        "zip": "547521",
        "lat": "46.784391",
        "long": "24.203792"
      },
      {
        "name": "SARMASU",
        "zip": "547515",
        "lat": "46.753393",
        "long": "24.160083"
      },
      {
        "name": "SASCHIZ",
        "zip": "547510",
        "lat": "46.194125",
        "long": "24.961897"
      },
      {
        "name": "SATU NOU",
        "zip": "547263",
        "lat": "46.456813",
        "long": "24.512254"
      },
      {
        "name": "SATU NOU",
        "zip": "547558",
        "lat": "46.761785",
        "long": "24.266781"
      },
      {
        "name": "SAULIA",
        "zip": "547590",
        "lat": "46.643866",
        "long": "24.213646"
      },
      {
        "name": "SAULITA",
        "zip": "547427",
        "lat": "46.663406",
        "long": "24.213082"
      },
      {
        "name": "SAUSA",
        "zip": "547611",
        "lat": "46.503762",
        "long": "24.396147"
      },
      {
        "name": "SCURTA",
        "zip": "547472",
        "lat": "46.660985",
        "long": "24.247722"
      },
      {
        "name": "SEBES",
        "zip": "547508",
        "lat": "46.928294",
        "long": "24.866189"
      },
      {
        "name": "SELEUS",
        "zip": "547202",
        "lat": "46.242911",
        "long": "24.692594"
      },
      {
        "name": "SELEUS",
        "zip": "547656",
        "lat": "46.362803",
        "long": "24.588708"
      },
      {
        "name": "SENEREUS",
        "zip": "547106",
        "lat": "46.332315",
        "long": "24.647041"
      },
      {
        "name": "SERBENI",
        "zip": "547116",
        "lat": "46.714754",
        "long": "24.866478999999998"
      },
      {
        "name": "SEUCA",
        "zip": "547258",
        "lat": "46.330606",
        "long": "24.329071"
      },
      {
        "name": "SEULIA DE MURES",
        "zip": "547192",
        "lat": "46.415888",
        "long": "24.247196"
      },
      {
        "name": "SFANTU GHEORGHE",
        "zip": "545108",
        "lat": "46.45355",
        "long": "24.265935"
      },
      {
        "name": "SICELE",
        "zip": "547473",
        "lat": "46.692067",
        "long": "24.289825"
      },
      {
        "name": "SIGHISOARA",
        "zip": "545400",
        "lat": "46.217697",
        "long": "24.793776"
      },
      {
        "name": "SILEA NIRAJULUI",
        "zip": "547394",
        "lat": "46.598873",
        "long": "24.923193"
      },
      {
        "name": "SINCAI",
        "zip": "547595",
        "lat": "46.654887",
        "long": "24.390502"
      },
      {
        "name": "SINCAI-FANATE",
        "zip": "547598",
        "lat": "46.654204",
        "long": "24.336216"
      },
      {
        "name": "SOARD",
        "zip": "547639",
        "lat": "46.263158",
        "long": "24.922177"
      },
      {
        "name": "SOCOLU DE CAMPIE",
        "zip": "547172",
        "lat": "46.791415",
        "long": "24.515753"
      },
      {
        "name": "SOIMUS",
        "zip": "547168",
        "lat": "46.393877",
        "long": "24.587032"
      },
      {
        "name": "SOLOCMA",
        "zip": "547269",
        "lat": "46.475917",
        "long": "24.995259"
      },
      {
        "name": "SOLOVASTRU",
        "zip": "547570",
        "lat": "46.778086",
        "long": "24.773796"
      },
      {
        "name": "SOMOSTELNIC",
        "zip": "547407",
        "lat": "46.391749",
        "long": "24.385297"
      },
      {
        "name": "SOROMICLEA",
        "zip": "545405",
        "lat": "46.260245",
        "long": "24.7711"
      },
      {
        "name": "SOVATA",
        "zip": "545500",
        "lat": "46.597168",
        "long": "25.07328"
      },
      {
        "name": "STANCENI",
        "zip": "547575",
        "lat": "46.960185",
        "long": "25.239212"
      },
      {
        "name": "STEFANCA",
        "zip": "547428",
        "lat": "46.682748",
        "long": "24.217049"
      },
      {
        "name": "STEFANEACA",
        "zip": "547668",
        "lat": "46.611851",
        "long": "24.110801"
      },
      {
        "name": "STEJARENII",
        "zip": "547203",
        "lat": "46.152866",
        "long": "24.722447"
      },
      {
        "name": "STEJERIS",
        "zip": "547012",
        "lat": "46.478897",
        "long": "24.616421"
      },
      {
        "name": "SUB PADURE",
        "zip": "547257",
        "lat": "46.369555",
        "long": "24.324565"
      },
      {
        "name": "SUPLAC",
        "zip": "547580",
        "lat": "46.396745",
        "long": "24.519915"
      },
      {
        "name": "SUSENI",
        "zip": "547585",
        "lat": "46.814371",
        "long": "24.731695"
      },
      {
        "name": "SUVEICA",
        "zip": "547013",
        "lat": "46.433979",
        "long": "24.715841"
      },
      {
        "name": "TABLASENI",
        "zip": "547351",
        "lat": "46.517627",
        "long": "24.306669"
      },
      {
        "name": "TAMPA",
        "zip": "547417",
        "lat": "46.535719",
        "long": "24.760235"
      },
      {
        "name": "TARGU MURES",
        "zip": "540003",
        "lat": "46.544624",
        "long": "24.561195"
      },
      {
        "name": "TARNAVENI",
        "zip": "545600",
        "lat": "46.329713",
        "long": "24.284313"
      },
      {
        "name": "TAU",
        "zip": "547669",
        "lat": "46.594416",
        "long": "24.154188"
      },
      {
        "name": "TAURENI",
        "zip": "547600",
        "lat": "46.579522",
        "long": "24.08077"
      },
      {
        "name": "TELEAC",
        "zip": "547289",
        "lat": "46.672651",
        "long": "24.793356"
      },
      {
        "name": "TIGMANDRU",
        "zip": "547433",
        "lat": "46.352086",
        "long": "24.716241"
      },
      {
        "name": "TIPTELNIC",
        "zip": "547077",
        "lat": "46.584282",
        "long": "24.412422"
      },
      {
        "name": "TIREU",
        "zip": "547333",
        "lat": "46.776572",
        "long": "24.991226"
      },
      {
        "name": "TIRIMIA",
        "zip": "547264",
        "lat": "46.449273",
        "long": "24.491622"
      },
      {
        "name": "TIRIMIOARA",
        "zip": "547179",
        "lat": "46.454629",
        "long": "24.547894"
      },
      {
        "name": "TISIEU",
        "zip": "547334",
        "lat": "46.765594",
        "long": "25.012583"
      },
      {
        "name": "TITIANA",
        "zip": "547522",
        "lat": "46.715804",
        "long": "24.186081"
      },
      {
        "name": "TOACA",
        "zip": "547316",
        "lat": "46.798609",
        "long": "24.965504"
      },
      {
        "name": "TOFALAU",
        "zip": "547532",
        "lat": "46.587061",
        "long": "24.657705"
      },
      {
        "name": "TOLDAL",
        "zip": "547651",
        "lat": "46.705092",
        "long": "24.58155"
      },
      {
        "name": "TONCIU",
        "zip": "547231",
        "lat": "46.780252",
        "long": "24.552013"
      },
      {
        "name": "TOPA",
        "zip": "547031",
        "lat": "46.254447",
        "long": "24.881619"
      },
      {
        "name": "TORBA",
        "zip": "547396",
        "lat": "46.547458",
        "long": "24.887584"
      },
      {
        "name": "TREI SATE",
        "zip": "547271",
        "lat": "46.476443",
        "long": "24.897035"
      },
      {
        "name": "TROITA",
        "zip": "547251",
        "lat": "46.485801",
        "long": "24.767854"
      },
      {
        "name": "TUSINU",
        "zip": "547561",
        "lat": "46.733313",
        "long": "24.227593"
      },
      {
        "name": "UILA",
        "zip": "547088",
        "lat": "46.931478",
        "long": "24.617537"
      },
      {
        "name": "ULIES",
        "zip": "547498",
        "lat": "46.73348",
        "long": "24.333548"
      },
      {
        "name": "UNGHENI",
        "zip": "547605",
        "lat": "46.485892",
        "long": "24.456547"
      },
      {
        "name": "URICEA",
        "zip": "547317",
        "lat": "46.798935",
        "long": "24.953731"
      },
      {
        "name": "URISIU DE JOS",
        "zip": "547162",
        "lat": "46.710853",
        "long": "24.896089"
      },
      {
        "name": "URISIU DE SUS",
        "zip": "547163",
        "lat": "46.706223",
        "long": "24.911087"
      },
      {
        "name": "URSOAIA",
        "zip": "547449",
        "lat": "46.549487",
        "long": "24.224713"
      },
      {
        "name": "VADAS",
        "zip": "547439",
        "lat": "46.45505",
        "long": "24.819297"
      },
      {
        "name": "VADU",
        "zip": "547628",
        "lat": "46.608122",
        "long": "24.781877"
      },
      {
        "name": "VAIDACUTA",
        "zip": "547584",
        "lat": "46.419062",
        "long": "24.526264"
      },
      {
        "name": "VAIDEIU",
        "zip": "547444",
        "lat": "46.495356",
        "long": "24.320889"
      },
      {
        "name": "VALEA",
        "zip": "547629",
        "lat": "46.563287",
        "long": "24.796914"
      },
      {
        "name": "VALEA ALBESTIULUI",
        "zip": "547032",
        "lat": "46.214617",
        "long": "24.848339"
      },
      {
        "name": "VALEA DAII",
        "zip": "547033",
        "lat": "46.223064",
        "long": "24.897018"
      },
      {
        "name": "VALEA FRATIEI",
        "zip": "547619",
        "lat": "46.645049",
        "long": "24.066565"
      },
      {
        "name": "VALEA GLODULUI",
        "zip": "547621",
        "lat": "46.646994",
        "long": "24.084808"
      },
      {
        "name": "VALEA ICLANDULUI",
        "zip": "547352",
        "lat": "46.534392",
        "long": "24.253911"
      },
      {
        "name": "VALEA IZVOARELOR",
        "zip": "547554",
        "lat": "46.438439",
        "long": "24.376996"
      },
      {
        "name": "VALEA LARGA",
        "zip": "547615",
        "lat": "46.62257",
        "long": "24.077577"
      },
      {
        "name": "VALEA MARE",
        "zip": "547078",
        "lat": "46.643065",
        "long": "24.295603"
      },
      {
        "name": "VALEA PADURII",
        "zip": "547622",
        "lat": "46.619686",
        "long": "24.053702"
      },
      {
        "name": "VALEA RECE",
        "zip": "547079",
        "lat": "46.571068",
        "long": "24.336065"
      },
      {
        "name": "VALEA SANMARTINULUI",
        "zip": "547499",
        "lat": "46.742913",
        "long": "24.335133"
      },
      {
        "name": "VALEA SANPETRULUI",
        "zip": "547292",
        "lat": "46.622582",
        "long": "24.286661"
      },
      {
        "name": "VALEA SANPETRULUI",
        "zip": "547474",
        "lat": "46.680475",
        "long": "24.262722"
      },
      {
        "name": "VALEA SAPARTOCULUI",
        "zip": "547034",
        "lat": "46.206398",
        "long": "24.849042"
      },
      {
        "name": "VALEA SASULUI",
        "zip": "547173",
        "lat": "46.822755",
        "long": "24.481423"
      },
      {
        "name": "VALEA SEACA",
        "zip": "547501",
        "lat": "46.745365",
        "long": "24.407525"
      },
      {
        "name": "VALEA SURII",
        "zip": "547623",
        "lat": "46.636764",
        "long": "24.052609"
      },
      {
        "name": "VALEA ULIESULUI",
        "zip": "547502",
        "lat": "46.736567",
        "long": "24.368806"
      },
      {
        "name": "VALEA UNGURULUI",
        "zip": "547174",
        "lat": "46.80871",
        "long": "24.485214"
      },
      {
        "name": "VALEA URIESULUI",
        "zip": "547624",
        "lat": "46.630047",
        "long": "24.084902"
      },
      {
        "name": "VALENI",
        "zip": "547476",
        "lat": "46.661059",
        "long": "24.269591"
      },
      {
        "name": "VALENII",
        "zip": "547014",
        "lat": "46.445479",
        "long": "24.646629"
      },
      {
        "name": "VALENII DE MURES",
        "zip": "547134",
        "lat": "46.892744",
        "long": "24.797926"
      },
      {
        "name": "VALISOARA",
        "zip": "547546",
        "lat": "46.533624",
        "long": "24.196094"
      },
      {
        "name": "VALURENI",
        "zip": "547186",
        "lat": "46.500214",
        "long": "24.546007"
      },
      {
        "name": "VANATORI",
        "zip": "547635",
        "lat": "46.24158",
        "long": "24.922692"
      },
      {
        "name": "VARGATA",
        "zip": "547625",
        "lat": "46.579591",
        "long": "24.802139"
      },
      {
        "name": "VATAVA",
        "zip": "547630",
        "lat": "46.961093",
        "long": "24.765068"
      },
      {
        "name": "VENCHI",
        "zip": "545406",
        "lat": "46.245523",
        "long": "24.743062"
      },
      {
        "name": "VETA",
        "zip": "547418",
        "lat": "46.560072",
        "long": "24.721888"
      },
      {
        "name": "VETCA",
        "zip": "547640",
        "lat": "46.352014",
        "long": "24.790262"
      },
      {
        "name": "VIDRASAU",
        "zip": "547612",
        "lat": "46.474834",
        "long": "24.412662"
      },
      {
        "name": "VIFOROASA",
        "zip": "547241",
        "lat": "46.432256",
        "long": "24.806903"
      },
      {
        "name": "VIILOR",
        "zip": "545407",
        "lat": "46.243865",
        "long": "24.815895"
      },
      {
        "name": "VIISOARA",
        "zip": "547645",
        "lat": "46.296126",
        "long": "24.59906"
      },
      {
        "name": "VISINELU",
        "zip": "547523",
        "lat": "46.7379",
        "long": "24.1024"
      },
      {
        "name": "VOINICENI",
        "zip": "547148",
        "lat": "46.613758",
        "long": "24.523989"
      },
      {
        "name": "VOIVODENI",
        "zip": "547650",
        "lat": "46.702976",
        "long": "24.627459"
      },
      {
        "name": "VULCAN",
        "zip": "547043",
        "lat": "46.148917",
        "long": "24.85367"
      },
      {
        "name": "ZAGAR",
        "zip": "547655",
        "lat": "46.350595",
        "long": "24.61809"
      },
      {
        "name": "ZAPODEA",
        "zip": "547547",
        "lat": "46.54057",
        "long": "24.117512"
      },
      {
        "name": "ZAU DE CAMPIE",
        "zip": "547660",
        "lat": "46.616083",
        "long": "24.125438"
      },
      {
        "name": "ZIMTI",
        "zip": "547336",
        "lat": "46.75792",
        "long": "25.052103"
      }
    ],
    "NEAMȚ": [
      {
        "name": "ADJUDENI",
        "zip": "617466",
        "lat": "47.014085",
        "long": "26.949027"
      },
      {
        "name": "AGAPIA",
        "zip": "617010",
        "lat": "47.173559",
        "long": "26.285718"
      },
      {
        "name": "AGARCIA",
        "zip": "617506",
        "lat": "46.926531",
        "long": "26.295231"
      },
      {
        "name": "ALMAS",
        "zip": "617201",
        "lat": "47.008975",
        "long": "26.344192"
      },
      {
        "name": "ARAMESTI",
        "zip": "617016",
        "lat": "46.77911",
        "long": "26.818092"
      },
      {
        "name": "ARAMOAIA",
        "zip": "617481",
        "lat": "47.072483",
        "long": "26.619852"
      },
      {
        "name": "ARDELUTA",
        "zip": "617446",
        "lat": "46.72357",
        "long": "26.197488"
      },
      {
        "name": "AVERESTI",
        "zip": "617261",
        "lat": "46.873305",
        "long": "27.039647"
      },
      {
        "name": "BAHNA",
        "zip": "617015",
        "lat": "46.778032",
        "long": "26.796784"
      },
      {
        "name": "BAHNA MARE",
        "zip": "617041",
        "lat": "46.96645",
        "long": "26.604018"
      },
      {
        "name": "BAHNISOARA",
        "zip": "617017",
        "lat": "46.75957",
        "long": "26.791369"
      },
      {
        "name": "BALANESTI",
        "zip": "617043",
        "lat": "46.951632",
        "long": "26.635535"
      },
      {
        "name": "BALTATESTI",
        "zip": "617025",
        "lat": "47.125667",
        "long": "26.309269"
      },
      {
        "name": "BALUSESTI",
        "zip": "617211",
        "lat": "46.927492",
        "long": "26.602061"
      },
      {
        "name": "BALUSESTI",
        "zip": "617251",
        "lat": "46.81558",
        "long": "26.998953"
      },
      {
        "name": "BANEASA",
        "zip": "617101",
        "lat": "46.855218",
        "long": "27.097684"
      },
      {
        "name": "BARA",
        "zip": "617030",
        "lat": "47.023095",
        "long": "27.045039"
      },
      {
        "name": "BARATCA",
        "zip": "617042",
        "lat": "46.960321",
        "long": "26.664654"
      },
      {
        "name": "BARCANESTI",
        "zip": "617116",
        "lat": "46.716985",
        "long": "26.591412"
      },
      {
        "name": "BARGAUANI",
        "zip": "617040",
        "lat": "46.98768",
        "long": "26.643973"
      },
      {
        "name": "BARJOVENI",
        "zip": "617417",
        "lat": "46.863781",
        "long": "26.782583"
      },
      {
        "name": "BARNADU",
        "zip": "617061",
        "lat": "46.832596",
        "long": "25.822973"
      },
      {
        "name": "BARTICESTI",
        "zip": "617091",
        "lat": "47.056459",
        "long": "26.785079"
      },
      {
        "name": "BASTA",
        "zip": "617416",
        "lat": "46.865464",
        "long": "26.913375"
      },
      {
        "name": "BATRANESTI",
        "zip": "617252",
        "lat": "46.771422",
        "long": "26.993727"
      },
      {
        "name": "BETESTI",
        "zip": "617381",
        "lat": "46.74238",
        "long": "26.583477"
      },
      {
        "name": "BICAZ",
        "zip": "615100",
        "lat": "46.911157",
        "long": "26.092833"
      },
      {
        "name": "BICAZ-CHEI",
        "zip": "617060",
        "lat": "46.827775",
        "long": "25.875423"
      },
      {
        "name": "BICAZU ARDELEAN",
        "zip": "617065",
        "lat": "46.854873",
        "long": "25.93332"
      },
      {
        "name": "BISERICANI",
        "zip": "617507",
        "lat": "46.958094",
        "long": "26.239188"
      },
      {
        "name": "BISTRICIOARA",
        "zip": "617127",
        "lat": "47.053572",
        "long": "25.927908"
      },
      {
        "name": "BISTRITA",
        "zip": "617508",
        "lat": "46.943237",
        "long": "26.293315"
      },
      {
        "name": "BLEBEA",
        "zip": "615201",
        "lat": "47.196393",
        "long": "26.408484"
      },
      {
        "name": "BOBOIESTI",
        "zip": "617326",
        "lat": "47.253703",
        "long": "26.037492"
      },
      {
        "name": "BODESTI",
        "zip": "617070",
        "lat": "47.030653",
        "long": "26.41829"
      },
      {
        "name": "BODESTII DE JOS",
        "zip": "617071",
        "lat": "47.027524",
        "long": "26.444825"
      },
      {
        "name": "BOGHICEA",
        "zip": "617031",
        "lat": "47.052478",
        "long": "27.073555"
      },
      {
        "name": "BOGZESTI",
        "zip": "617418",
        "lat": "46.897874",
        "long": "26.776316"
      },
      {
        "name": "BOISTEA",
        "zip": "617316",
        "lat": "47.17657",
        "long": "26.429463"
      },
      {
        "name": "BORCA",
        "zip": "617075",
        "lat": "47.178928",
        "long": "25.788692"
      },
      {
        "name": "BORDEA",
        "zip": "617436",
        "lat": "47.03334",
        "long": "26.49023"
      },
      {
        "name": "BORLESTI",
        "zip": "617085",
        "lat": "46.778387",
        "long": "26.510077"
      },
      {
        "name": "BORNIS",
        "zip": "617166",
        "lat": "47.018937",
        "long": "26.593419"
      },
      {
        "name": "BORSENI",
        "zip": "617376",
        "lat": "47.080656",
        "long": "26.585891"
      },
      {
        "name": "BOTESTI",
        "zip": "617090",
        "lat": "47.048579",
        "long": "26.744488"
      },
      {
        "name": "BOTESTI",
        "zip": "617212",
        "lat": "46.935741",
        "long": "26.501854"
      },
      {
        "name": "BOZIENI",
        "zip": "617100",
        "lat": "46.841218",
        "long": "27.148968"
      },
      {
        "name": "BOZIENII DE SUS",
        "zip": "617176",
        "lat": "46.962406",
        "long": "26.705262"
      },
      {
        "name": "BRADU",
        "zip": "617231",
        "lat": "47.004241",
        "long": "25.853458"
      },
      {
        "name": "BRASAUTI",
        "zip": "617186",
        "lat": "46.865441",
        "long": "26.436962"
      },
      {
        "name": "BRATES",
        "zip": "617447",
        "lat": "46.79852",
        "long": "26.148592"
      },
      {
        "name": "BREAZA",
        "zip": "617044",
        "lat": "47.0193",
        "long": "26.639227"
      },
      {
        "name": "BRITCANI",
        "zip": "617177",
        "lat": "46.992337",
        "long": "26.733558"
      },
      {
        "name": "BROSTENI",
        "zip": "617018",
        "lat": "46.796834",
        "long": "26.797078"
      },
      {
        "name": "BRUSTURI",
        "zip": "617106",
        "lat": "47.280439",
        "long": "26.38277"
      },
      {
        "name": "BUCIUM",
        "zip": "617496",
        "lat": "46.778553",
        "long": "27.071667"
      },
      {
        "name": "BUDESTI",
        "zip": "617196",
        "lat": "46.940843",
        "long": "26.711773"
      },
      {
        "name": "BUHALNITA",
        "zip": "617241",
        "lat": "47.018885",
        "long": "26.089032"
      },
      {
        "name": "BUHONCA",
        "zip": "617161",
        "lat": "47.047474",
        "long": "26.988202"
      },
      {
        "name": "BUNGHI",
        "zip": "617361",
        "lat": "46.908429",
        "long": "27.108027"
      },
      {
        "name": "BURUIENESTI",
        "zip": "617162",
        "lat": "46.995219",
        "long": "26.976727"
      },
      {
        "name": "BUSMEI",
        "zip": "617191",
        "lat": "47.151153",
        "long": "25.841549"
      },
      {
        "name": "BUTNARESTI",
        "zip": "617419",
        "lat": "46.873106",
        "long": "26.794536"
      },
      {
        "name": "CACIULESTI",
        "zip": "617213",
        "lat": "46.963764",
        "long": "26.476538"
      },
      {
        "name": "CALUGARENI",
        "zip": "617341",
        "lat": "47.074271",
        "long": "25.948162"
      },
      {
        "name": "CANDESTI",
        "zip": "617115",
        "lat": "46.722609",
        "long": "26.585006"
      },
      {
        "name": "CAPSA",
        "zip": "615101",
        "lat": "46.904665",
        "long": "26.109275"
      },
      {
        "name": "CARLIG",
        "zip": "617178",
        "lat": "46.991763",
        "long": "26.753072"
      },
      {
        "name": "CARLIGI",
        "zip": "617437",
        "lat": "47.005882",
        "long": "26.520718"
      },
      {
        "name": "CASARIA",
        "zip": "617156",
        "lat": "46.986497",
        "long": "26.41491"
      },
      {
        "name": "CAUSENI",
        "zip": "617032",
        "lat": "47.042075",
        "long": "27.106453"
      },
      {
        "name": "CAZACI",
        "zip": "617448",
        "lat": "46.857707",
        "long": "26.143113"
      },
      {
        "name": "CEAHLAU",
        "zip": "617125",
        "lat": "47.041848",
        "long": "25.960976"
      },
      {
        "name": "CERTIENI",
        "zip": "617046",
        "lat": "46.976991",
        "long": "26.664565"
      },
      {
        "name": "CHICEREA",
        "zip": "617426",
        "lat": "46.976199",
        "long": "27.132355"
      },
      {
        "name": "CHILIA",
        "zip": "617047",
        "lat": "47.036912",
        "long": "26.631219"
      },
      {
        "name": "CHILII",
        "zip": "617497",
        "lat": "46.802541",
        "long": "27.033935"
      },
      {
        "name": "CHINTINICI",
        "zip": "617391",
        "lat": "46.828334",
        "long": "26.494066"
      },
      {
        "name": "CHIRITENI",
        "zip": "617242",
        "lat": "47.050933",
        "long": "26.025113"
      },
      {
        "name": "CIORNEI",
        "zip": "617281",
        "lat": "46.802283",
        "long": "27.177044"
      },
      {
        "name": "CIRITEI",
        "zip": "610001",
        "lat": "46.931903",
        "long": "26.408844"
      },
      {
        "name": "CIUREA",
        "zip": "617362",
        "lat": "46.888299",
        "long": "27.186799"
      },
      {
        "name": "CLIMESTI",
        "zip": "617197",
        "lat": "46.909716",
        "long": "26.741733"
      },
      {
        "name": "CORDUN",
        "zip": "617135",
        "lat": "46.950574",
        "long": "26.895097"
      },
      {
        "name": "CORHANA",
        "zip": "617179",
        "lat": "46.980321",
        "long": "26.809971"
      },
      {
        "name": "CORNI",
        "zip": "617072",
        "lat": "47.040355",
        "long": "26.480467"
      },
      {
        "name": "COSTISA",
        "zip": "617140",
        "lat": "46.751603",
        "long": "26.663853"
      },
      {
        "name": "COTU VAMES",
        "zip": "617246",
        "lat": "46.907659",
        "long": "26.956554"
      },
      {
        "name": "CRACAOANI",
        "zip": "617145",
        "lat": "47.093426",
        "long": "26.31946"
      },
      {
        "name": "CRACAUL NEGRU",
        "zip": "617146",
        "lat": "47.094092",
        "long": "26.238313"
      },
      {
        "name": "CRAIESTI",
        "zip": "617102",
        "lat": "46.852169",
        "long": "27.175224"
      },
      {
        "name": "CUCI",
        "zip": "617103",
        "lat": "46.828191",
        "long": "27.197895"
      },
      {
        "name": "CUEJDIU",
        "zip": "617202",
        "lat": "46.990402",
        "long": "26.294552"
      },
      {
        "name": "CURECHISTEA",
        "zip": "617236",
        "lat": "47.134005",
        "long": "26.414717"
      },
      {
        "name": "CUT",
        "zip": "617187",
        "lat": "46.882576",
        "long": "26.41928"
      },
      {
        "name": "DAMUC",
        "zip": "617150",
        "lat": "46.804309",
        "long": "25.910739"
      },
      {
        "name": "DANESTI",
        "zip": "617214",
        "lat": "46.920988",
        "long": "26.522348"
      },
      {
        "name": "DARLOAIA",
        "zip": "617048",
        "lat": "46.940492",
        "long": "26.665893"
      },
      {
        "name": "DAVID",
        "zip": "617092",
        "lat": "47.038302",
        "long": "26.668617"
      },
      {
        "name": "DAVIDENI",
        "zip": "617486",
        "lat": "47.12623",
        "long": "26.600033"
      },
      {
        "name": "DELENI",
        "zip": "617438",
        "lat": "46.999653",
        "long": "26.539546"
      },
      {
        "name": "DOAMNA",
        "zip": "610002",
        "lat": "46.923754",
        "long": "26.324914"
      },
      {
        "name": "DOBRENI",
        "zip": "617155",
        "lat": "47.005796",
        "long": "26.418719"
      },
      {
        "name": "DOCHIA",
        "zip": "617216",
        "lat": "46.907957",
        "long": "26.566124"
      },
      {
        "name": "DODENI",
        "zip": "615102",
        "lat": "46.923121",
        "long": "26.088238"
      },
      {
        "name": "DOINA",
        "zip": "617217",
        "lat": "46.918619",
        "long": "26.51043"
      },
      {
        "name": "DOLHESTI",
        "zip": "617327",
        "lat": "47.211886",
        "long": "26.067381"
      },
      {
        "name": "DOLJESTI",
        "zip": "617160",
        "lat": "47.046558",
        "long": "26.974461"
      },
      {
        "name": "DORNESTI",
        "zip": "617141",
        "lat": "46.778901",
        "long": "26.66406"
      },
      {
        "name": "DRAGANESTI",
        "zip": "617107",
        "lat": "47.308863",
        "long": "26.405513"
      },
      {
        "name": "DRAGOMIRESTI",
        "zip": "617165",
        "lat": "47.029143",
        "long": "26.571574"
      },
      {
        "name": "DRAGOVA",
        "zip": "617117",
        "lat": "46.71742",
        "long": "26.609829"
      },
      {
        "name": "DREPTU",
        "zip": "617342",
        "lat": "47.135268",
        "long": "25.87476"
      },
      {
        "name": "DULCESTI",
        "zip": "617175",
        "lat": "46.966386",
        "long": "26.78553"
      },
      {
        "name": "DUMBRAVA",
        "zip": "617471",
        "lat": "47.216196",
        "long": "26.463087"
      },
      {
        "name": "DUMBRAVA ROSIE",
        "zip": "617185",
        "lat": "46.88254",
        "long": "26.437391"
      },
      {
        "name": "DUMBRAVA-DEAL",
        "zip": "617411",
        "lat": "46.87572",
        "long": "26.500978"
      },
      {
        "name": "DUSESTI",
        "zip": "617439",
        "lat": "47.016442",
        "long": "26.515961"
      },
      {
        "name": "FARCASA",
        "zip": "617190",
        "lat": "47.155933",
        "long": "25.841718"
      },
      {
        "name": "FAUREI",
        "zip": "617195",
        "lat": "46.911518",
        "long": "26.709284"
      },
      {
        "name": "FILIOARA",
        "zip": "617011",
        "lat": "47.160401",
        "long": "26.279197"
      },
      {
        "name": "FRUMOSU",
        "zip": "617192",
        "lat": "47.146645",
        "long": "25.866045"
      },
      {
        "name": "FRUNZENI",
        "zip": "617142",
        "lat": "46.737868",
        "long": "26.626354"
      },
      {
        "name": "GADINTI",
        "zip": "617396",
        "lat": "46.936393",
        "long": "27.005623"
      },
      {
        "name": "GALU",
        "zip": "617343",
        "lat": "47.126274",
        "long": "25.904657"
      },
      {
        "name": "GARCINA",
        "zip": "617200",
        "lat": "46.97745",
        "long": "26.345546"
      },
      {
        "name": "GHELAIESTI",
        "zip": "617049",
        "lat": "46.944177",
        "long": "26.648073"
      },
      {
        "name": "GHERAESTI",
        "zip": "617205",
        "lat": "47.02392",
        "long": "26.822575"
      },
      {
        "name": "GHERAESTII NOI",
        "zip": "617206",
        "lat": "47.050354",
        "long": "26.793845"
      },
      {
        "name": "GHERMAN",
        "zip": "617062",
        "lat": "46.838673",
        "long": "25.877194"
      },
      {
        "name": "GHIDION",
        "zip": "617427",
        "lat": "47.040845",
        "long": "27.155931"
      },
      {
        "name": "GHIGOIESTI",
        "zip": "617441",
        "lat": "46.98319",
        "long": "26.574931"
      },
      {
        "name": "GHINDAOANI",
        "zip": "617026",
        "lat": "47.109826",
        "long": "26.339089"
      },
      {
        "name": "GIROV",
        "zip": "617210",
        "lat": "46.955712",
        "long": "26.501423"
      },
      {
        "name": "GIULESTI",
        "zip": "617421",
        "lat": "46.885322",
        "long": "26.772368"
      },
      {
        "name": "GIURGENI",
        "zip": "617498",
        "lat": "46.816351",
        "long": "27.108684"
      },
      {
        "name": "GORUN",
        "zip": "617282",
        "lat": "46.780582",
        "long": "27.140441"
      },
      {
        "name": "GOSMANI",
        "zip": "617386",
        "lat": "46.836198",
        "long": "26.715223"
      },
      {
        "name": "GRINTIES",
        "zip": "617230",
        "lat": "47.039456",
        "long": "25.894764"
      },
      {
        "name": "GROSI",
        "zip": "617108",
        "lat": "47.29183",
        "long": "26.314582"
      },
      {
        "name": "GROZAVESTI",
        "zip": "617243",
        "lat": "47.036176",
        "long": "26.067062"
      },
      {
        "name": "GRUMAZESTI",
        "zip": "617235",
        "lat": "47.133606",
        "long": "26.377268"
      },
      {
        "name": "GURA VAII",
        "zip": "617218",
        "lat": "46.95654",
        "long": "26.450117"
      },
      {
        "name": "HAMZOAIA",
        "zip": "617456",
        "lat": "46.902521",
        "long": "26.038395"
      },
      {
        "name": "HANGU",
        "zip": "617240",
        "lat": "47.065747",
        "long": "26.040589"
      },
      {
        "name": "HANUL ANCUTEI",
        "zip": "617482",
        "lat": "47.09892",
        "long": "26.698259"
      },
      {
        "name": "HARTESTI",
        "zip": "617271",
        "lat": "46.872232",
        "long": "26.687471"
      },
      {
        "name": "HARTOP",
        "zip": "617051",
        "lat": "46.949639",
        "long": "26.605713"
      },
      {
        "name": "HLAPESTI",
        "zip": "617167",
        "lat": "47.038168",
        "long": "26.598422"
      },
      {
        "name": "HOCIUNGI",
        "zip": "617276",
        "lat": "46.812908",
        "long": "26.775925"
      },
      {
        "name": "HOISESTI",
        "zip": "617272",
        "lat": "46.87825",
        "long": "26.662818"
      },
      {
        "name": "HOLM",
        "zip": "617363",
        "lat": "46.879353",
        "long": "27.169705"
      },
      {
        "name": "HOMICENI",
        "zip": "617052",
        "lat": "47.01936",
        "long": "26.656627"
      },
      {
        "name": "HORIA",
        "zip": "617245",
        "lat": "46.907503",
        "long": "26.916129"
      },
      {
        "name": "HUISUREZ",
        "zip": "617151",
        "lat": "46.745174",
        "long": "25.913413"
      },
      {
        "name": "HUMULESTI",
        "zip": "615202",
        "lat": "47.197929",
        "long": "26.349989"
      },
      {
        "name": "HUMULESTII NOI",
        "zip": "615203",
        "lat": "47.187092",
        "long": "26.338135"
      },
      {
        "name": "ICUSESTI",
        "zip": "617250",
        "lat": "46.80643",
        "long": "26.952365"
      },
      {
        "name": "INGARESTI",
        "zip": "617491",
        "lat": "47.183287",
        "long": "26.512344"
      },
      {
        "name": "ION CREANGA",
        "zip": "617260",
        "lat": "46.87016",
        "long": "26.983948"
      },
      {
        "name": "ITRINESTI",
        "zip": "617273",
        "lat": "46.926279",
        "long": "26.627154"
      },
      {
        "name": "IUCSA",
        "zip": "617104",
        "lat": "46.844226",
        "long": "27.134765"
      },
      {
        "name": "IVANES",
        "zip": "617063",
        "lat": "46.824763",
        "long": "25.901106"
      },
      {
        "name": "IZVOARE",
        "zip": "617188",
        "lat": "46.912413",
        "long": "26.466217"
      },
      {
        "name": "IZVOARE",
        "zip": "617019",
        "lat": "46.746992",
        "long": "26.802213"
      },
      {
        "name": "IZVORU",
        "zip": "617262",
        "lat": "46.865566",
        "long": "27.015972"
      },
      {
        "name": "IZVORU ALB",
        "zip": "615103",
        "lat": "46.998753",
        "long": "26.045926"
      },
      {
        "name": "IZVORU MUNTELUI",
        "zip": "615104",
        "lat": "46.940872",
        "long": "26.074601"
      },
      {
        "name": "LEGHIN",
        "zip": "617328",
        "lat": "47.224452",
        "long": "26.196749"
      },
      {
        "name": "LILIAC",
        "zip": "617021",
        "lat": "46.787429",
        "long": "26.830305"
      },
      {
        "name": "LINSESTI",
        "zip": "617283",
        "lat": "46.801698",
        "long": "27.137957"
      },
      {
        "name": "LUMINIS",
        "zip": "617321",
        "lat": "46.813316",
        "long": "26.452751"
      },
      {
        "name": "LUNCA",
        "zip": "617076",
        "lat": "47.217008",
        "long": "25.742695"
      },
      {
        "name": "LUNCA",
        "zip": "617284",
        "lat": "46.797889",
        "long": "27.164301"
      },
      {
        "name": "LUNCA",
        "zip": "617501",
        "lat": "47.227655",
        "long": "26.29979"
      },
      {
        "name": "LUNCA MOLDOVEI",
        "zip": "617301",
        "lat": "47.185175",
        "long": "26.592414"
      },
      {
        "name": "LUTCA",
        "zip": "617397",
        "lat": "46.963532",
        "long": "26.978325"
      },
      {
        "name": "MADEI",
        "zip": "617077",
        "lat": "47.204655",
        "long": "25.752543"
      },
      {
        "name": "MAGAZIA",
        "zip": "617147",
        "lat": "47.103139",
        "long": "26.261666"
      },
      {
        "name": "MANASTIREA NEAMT",
        "zip": "617502",
        "lat": "47.266909",
        "long": "26.204486"
      },
      {
        "name": "MANOAIA",
        "zip": "617143",
        "lat": "46.764343",
        "long": "26.630668"
      },
      {
        "name": "MARGINENI",
        "zip": "617270",
        "lat": "46.894234",
        "long": "26.648178"
      },
      {
        "name": "MARMURENI",
        "zip": "617286",
        "lat": "46.811293",
        "long": "27.183605"
      },
      {
        "name": "MASTACAN",
        "zip": "617086",
        "lat": "46.789182",
        "long": "26.48677"
      },
      {
        "name": "MASTACAN",
        "zip": "617168",
        "lat": "47.011002",
        "long": "26.573703"
      },
      {
        "name": "MESTEACAN",
        "zip": "617253",
        "lat": "46.832443",
        "long": "27.023753"
      },
      {
        "name": "MICSUNESTI",
        "zip": "617198",
        "lat": "46.898256",
        "long": "26.710545"
      },
      {
        "name": "MIRON COSTIN",
        "zip": "617476",
        "lat": "46.9203",
        "long": "26.805666"
      },
      {
        "name": "MITOCU BALAN",
        "zip": "617148",
        "lat": "47.11569",
        "long": "26.170063"
      },
      {
        "name": "MOLDOVENI",
        "zip": "617275",
        "lat": "46.830289",
        "long": "26.7972"
      },
      {
        "name": "MORENI",
        "zip": "617093",
        "lat": "47.025364",
        "long": "26.737966"
      },
      {
        "name": "MUNCELU",
        "zip": "617263",
        "lat": "46.858552",
        "long": "26.971126"
      },
      {
        "name": "MUNCELU DE JOS",
        "zip": "617499",
        "lat": "46.774609",
        "long": "27.111924"
      },
      {
        "name": "MUNTENI",
        "zip": "617094",
        "lat": "47.023614",
        "long": "26.764485"
      },
      {
        "name": "NEAGRA",
        "zip": "617457",
        "lat": "46.877023",
        "long": "25.970642"
      },
      {
        "name": "NECHIT",
        "zip": "617087",
        "lat": "46.77307",
        "long": "26.415791"
      },
      {
        "name": "NEGRESTI",
        "zip": "617033",
        "lat": "47.006605",
        "long": "27.070118"
      },
      {
        "name": "NEGRESTI",
        "zip": "617157",
        "lat": "47.029383",
        "long": "26.379582"
      },
      {
        "name": "NEGRITESTI",
        "zip": "617336",
        "lat": "46.838494",
        "long": "26.645051"
      },
      {
        "name": "NEGULESTI",
        "zip": "617322",
        "lat": "46.810638",
        "long": "26.408291"
      },
      {
        "name": "NEMTISOR",
        "zip": "617503",
        "lat": "47.239622",
        "long": "26.272088"
      },
      {
        "name": "NETEZI",
        "zip": "617237",
        "lat": "47.153765",
        "long": "26.370985"
      },
      {
        "name": "NISIPORESTI",
        "zip": "617096",
        "lat": "47.0772",
        "long": "26.737911"
      },
      {
        "name": "NISTRIA",
        "zip": "617034",
        "lat": "47.080637",
        "long": "27.152575"
      },
      {
        "name": "OANTU",
        "zip": "617306",
        "lat": "46.909806",
        "long": "26.198506"
      },
      {
        "name": "OGLINZI",
        "zip": "617371",
        "lat": "47.248162",
        "long": "26.350538"
      },
      {
        "name": "ONICENI",
        "zip": "617280",
        "lat": "46.803415",
        "long": "27.164302"
      },
      {
        "name": "ORTASTI",
        "zip": "617109",
        "lat": "47.32216",
        "long": "26.38653"
      },
      {
        "name": "OSLOBENI",
        "zip": "617073",
        "lat": "47.052563",
        "long": "26.402462"
      },
      {
        "name": "PADURENI",
        "zip": "617118",
        "lat": "46.696323",
        "long": "26.562651"
      },
      {
        "name": "PANCESTI",
        "zip": "617366",
        "lat": "46.901927",
        "long": "27.154054"
      },
      {
        "name": "PANGARACIOR",
        "zip": "617307",
        "lat": "46.935065",
        "long": "26.218157"
      },
      {
        "name": "PANGARATI",
        "zip": "617305",
        "lat": "46.929395",
        "long": "26.208315"
      },
      {
        "name": "PARAUL CARJEI",
        "zip": "617078",
        "lat": "47.198298",
        "long": "25.764518"
      },
      {
        "name": "PARAUL FAGULUI",
        "zip": "617344",
        "lat": "47.140011",
        "long": "25.884737"
      },
      {
        "name": "PARAUL MARE",
        "zip": "617128",
        "lat": "47.039325",
        "long": "25.988109"
      },
      {
        "name": "PARAUL PANTEI",
        "zip": "617079",
        "lat": "47.165982",
        "long": "25.81222"
      },
      {
        "name": "PASTRAVENI",
        "zip": "617300",
        "lat": "47.159984",
        "long": "26.571397"
      },
      {
        "name": "PATALIGENI",
        "zip": "617329",
        "lat": "47.228254",
        "long": "26.110189"
      },
      {
        "name": "PATRICHENI",
        "zip": "617364",
        "lat": "46.915611",
        "long": "27.17115"
      },
      {
        "name": "PETRICANI",
        "zip": "617315",
        "lat": "47.169564",
        "long": "26.45104"
      },
      {
        "name": "PETRU VODA",
        "zip": "617346",
        "lat": "47.136299",
        "long": "25.997864"
      },
      {
        "name": "PIATRA NEAMT",
        "zip": "610004",
        "lat": "46.931989",
        "long": "26.369505"
      },
      {
        "name": "PIATRA SOIMULUI",
        "zip": "617320",
        "lat": "46.833671",
        "long": "26.449408"
      },
      {
        "name": "PIETROSU",
        "zip": "617287",
        "lat": "46.777994",
        "long": "27.164136"
      },
      {
        "name": "PILDESTI",
        "zip": "617136",
        "lat": "46.996748",
        "long": "26.82558"
      },
      {
        "name": "PIPIRIG",
        "zip": "617325",
        "lat": "47.229166",
        "long": "26.082864"
      },
      {
        "name": "PLAIESU",
        "zip": "617472",
        "lat": "47.22927",
        "long": "26.502274"
      },
      {
        "name": "PLUGARI",
        "zip": "617492",
        "lat": "47.198119",
        "long": "26.556251"
      },
      {
        "name": "PLUTON",
        "zip": "617331",
        "lat": "47.200281",
        "long": "26.013308"
      },
      {
        "name": "PODOLENI",
        "zip": "617335",
        "lat": "46.797344",
        "long": "26.61946"
      },
      {
        "name": "POIANA",
        "zip": "617111",
        "lat": "47.296723",
        "long": "26.360492"
      },
      {
        "name": "POIANA",
        "zip": "617158",
        "lat": "47.066197",
        "long": "26.320519"
      },
      {
        "name": "POIANA",
        "zip": "617181",
        "lat": "47.005696",
        "long": "26.771231"
      },
      {
        "name": "POIANA",
        "zip": "617232",
        "lat": "47.029038",
        "long": "25.880119"
      },
      {
        "name": "POIANA",
        "zip": "617308",
        "lat": "46.903805",
        "long": "26.183988"
      },
      {
        "name": "POIANA CRACAOANI",
        "zip": "617149",
        "lat": "47.06896",
        "long": "26.30672"
      },
      {
        "name": "POIANA HUMEI",
        "zip": "617288",
        "lat": "46.743965",
        "long": "27.152403"
      },
      {
        "name": "POIANA LARGULUI",
        "zip": "617347",
        "lat": "47.094696",
        "long": "25.97836"
      },
      {
        "name": "POIANA TEIULUI",
        "zip": "617340",
        "lat": "47.115674",
        "long": "25.923962"
      },
      {
        "name": "POIENARI",
        "zip": "617360",
        "lat": "46.885283",
        "long": "27.133062"
      },
      {
        "name": "POIENI",
        "zip": "617323",
        "lat": "46.840392",
        "long": "26.363601"
      },
      {
        "name": "POIENILE OANCEI",
        "zip": "617428",
        "lat": "47.030481",
        "long": "27.10948"
      },
      {
        "name": "POLOBOC",
        "zip": "617382",
        "lat": "46.76129",
        "long": "26.549824"
      },
      {
        "name": "POPESTI",
        "zip": "617193",
        "lat": "47.150669",
        "long": "25.870488"
      },
      {
        "name": "POPESTI",
        "zip": "617219",
        "lat": "46.970187",
        "long": "26.443819"
      },
      {
        "name": "POTOCI",
        "zip": "615105",
        "lat": "46.984778",
        "long": "26.110839"
      },
      {
        "name": "PRAJESTI",
        "zip": "617422",
        "lat": "46.869411",
        "long": "26.727282"
      },
      {
        "name": "PRELUCA",
        "zip": "617309",
        "lat": "46.929065",
        "long": "26.232708"
      },
      {
        "name": "PREUTESTI",
        "zip": "617473",
        "lat": "47.256688",
        "long": "26.514381"
      },
      {
        "name": "PUSTIETA",
        "zip": "617289",
        "lat": "46.801888",
        "long": "27.199562"
      },
      {
        "name": "RADENI",
        "zip": "617302",
        "lat": "47.142605",
        "long": "26.537027"
      },
      {
        "name": "RASCA",
        "zip": "617112",
        "lat": "47.308672",
        "long": "26.427015"
      },
      {
        "name": "RAUCESTI",
        "zip": "617370",
        "lat": "47.254605",
        "long": "26.407778"
      },
      {
        "name": "RAZBOIENI",
        "zip": "617375",
        "lat": "47.092116",
        "long": "26.556942"
      },
      {
        "name": "RAZBOIENII DE JOS",
        "zip": "617377",
        "lat": "47.074448",
        "long": "26.566717"
      },
      {
        "name": "RECEA",
        "zip": "617264",
        "lat": "46.849234",
        "long": "26.954296"
      },
      {
        "name": "REDIU",
        "zip": "617036",
        "lat": "47.009863",
        "long": "27.005336"
      },
      {
        "name": "REDIU",
        "zip": "617380",
        "lat": "46.756802",
        "long": "26.565227"
      },
      {
        "name": "ROCNA",
        "zip": "617254",
        "lat": "46.769926",
        "long": "26.973578"
      },
      {
        "name": "ROMAN",
        "zip": "611001",
        "lat": "46.924876",
        "long": "26.928177"
      },
      {
        "name": "ROMANI",
        "zip": "617385",
        "lat": "46.793025",
        "long": "26.689691"
      },
      {
        "name": "ROSENI",
        "zip": "617348",
        "lat": "47.095019",
        "long": "25.941374"
      },
      {
        "name": "ROSIORI",
        "zip": "617182",
        "lat": "46.964766",
        "long": "26.828061"
      },
      {
        "name": "ROTUNDA",
        "zip": "617163",
        "lat": "47.022096",
        "long": "26.962659"
      },
      {
        "name": "ROZNOV",
        "zip": "617390",
        "lat": "46.838886",
        "long": "26.509354"
      },
      {
        "name": "RUGINESTI",
        "zip": "617244",
        "lat": "47.004493",
        "long": "26.098224"
      },
      {
        "name": "RUGINOASA",
        "zip": "617183",
        "lat": "46.986106",
        "long": "26.706716"
      },
      {
        "name": "RUSENI",
        "zip": "617088",
        "lat": "46.797249",
        "long": "26.539602"
      },
      {
        "name": "RUSENI",
        "zip": "617349",
        "lat": "47.118956",
        "long": "25.909289"
      },
      {
        "name": "SABAOANI",
        "zip": "617400",
        "lat": "47.012059",
        "long": "26.865031"
      },
      {
        "name": "SABASA",
        "zip": "617081",
        "lat": "47.201681",
        "long": "25.817138"
      },
      {
        "name": "SACALENI",
        "zip": "617367",
        "lat": "46.865046",
        "long": "27.117899"
      },
      {
        "name": "SACALUSESTI",
        "zip": "617012",
        "lat": "47.171558",
        "long": "26.323219"
      },
      {
        "name": "SAGNA",
        "zip": "617395",
        "lat": "46.97087",
        "long": "27.007982"
      },
      {
        "name": "SARATA",
        "zip": "617159",
        "lat": "46.988384",
        "long": "26.389251"
      },
      {
        "name": "SAVESTI",
        "zip": "617372",
        "lat": "47.276212",
        "long": "26.429311"
      },
      {
        "name": "SAVINESTI",
        "zip": "617410",
        "lat": "46.857502",
        "long": "26.471071"
      },
      {
        "name": "SAVINESTI",
        "zip": "617351",
        "lat": "47.134699",
        "long": "25.893694"
      },
      {
        "name": "SCARICICA",
        "zip": "617509",
        "lat": "46.945695",
        "long": "26.25856"
      },
      {
        "name": "SCHITU TARCAU",
        "zip": "617449",
        "lat": "46.75614",
        "long": "26.186482"
      },
      {
        "name": "SECU",
        "zip": "615106",
        "lat": "46.975363",
        "long": "26.033853"
      },
      {
        "name": "SECUIENI",
        "zip": "617415",
        "lat": "46.855582",
        "long": "26.848975"
      },
      {
        "name": "SECUIENII NOI",
        "zip": "617423",
        "lat": "46.845719",
        "long": "26.884493"
      },
      {
        "name": "SILISTEA",
        "zip": "617387",
        "lat": "46.777855",
        "long": "26.692605"
      },
      {
        "name": "SIMIONESTI",
        "zip": "617137",
        "lat": "46.971364",
        "long": "26.867261"
      },
      {
        "name": "SLOBOZIA",
        "zip": "617037",
        "lat": "47.064164",
        "long": "27.114888"
      },
      {
        "name": "SLOBOZIA",
        "zip": "617392",
        "lat": "46.848196",
        "long": "26.530976"
      },
      {
        "name": "SOCEA",
        "zip": "617383",
        "lat": "46.738608",
        "long": "26.564255"
      },
      {
        "name": "SOCI",
        "zip": "617082",
        "lat": "47.170335",
        "long": "25.791547"
      },
      {
        "name": "SOCI",
        "zip": "617442",
        "lat": "47.0273",
        "long": "26.503228"
      },
      {
        "name": "SOIMARESTI",
        "zip": "617113",
        "lat": "47.30527",
        "long": "26.448272"
      },
      {
        "name": "SOLCA",
        "zip": "617291",
        "lat": "46.760889",
        "long": "27.154043"
      },
      {
        "name": "SOVOAIA",
        "zip": "617089",
        "lat": "46.804929",
        "long": "26.498365"
      },
      {
        "name": "SPIESTI",
        "zip": "617303",
        "lat": "47.149393",
        "long": "26.604217"
      },
      {
        "name": "SPIRIDONESTI",
        "zip": "617256",
        "lat": "46.778907",
        "long": "26.954446"
      },
      {
        "name": "STANCA",
        "zip": "617332",
        "lat": "47.230692",
        "long": "26.131388"
      },
      {
        "name": "STANITA",
        "zip": "617425",
        "lat": "47.008932",
        "long": "27.103226"
      },
      {
        "name": "STEFAN CEL MARE",
        "zip": "617435",
        "lat": "46.984659",
        "long": "26.51778"
      },
      {
        "name": "STEJARU",
        "zip": "617194",
        "lat": "47.157801",
        "long": "25.823139"
      },
      {
        "name": "STEJARU",
        "zip": "617266",
        "lat": "46.849031",
        "long": "27.04815"
      },
      {
        "name": "STEJARU",
        "zip": "617311",
        "lat": "46.915041",
        "long": "26.17775"
      },
      {
        "name": "STRAJA",
        "zip": "617451",
        "lat": "46.902759",
        "long": "26.170738"
      },
      {
        "name": "TABARA",
        "zip": "617257",
        "lat": "46.820481",
        "long": "27.039248"
      },
      {
        "name": "TALPA",
        "zip": "617053",
        "lat": "47.034991",
        "long": "26.646534"
      },
      {
        "name": "TALPALAI",
        "zip": "617368",
        "lat": "46.923434",
        "long": "27.162265"
      },
      {
        "name": "TAMASENI",
        "zip": "617465",
        "lat": "46.992463",
        "long": "26.952705"
      },
      {
        "name": "TARCAU",
        "zip": "617445",
        "lat": "46.890929",
        "long": "26.130938"
      },
      {
        "name": "TARDENII MICI",
        "zip": "617119",
        "lat": "46.691832",
        "long": "26.586106"
      },
      {
        "name": "TARGU NEAMT",
        "zip": "615200",
        "lat": "47.206427",
        "long": "26.360439"
      },
      {
        "name": "TARPESTI",
        "zip": "617317",
        "lat": "47.149557",
        "long": "26.432613"
      },
      {
        "name": "TARZIA",
        "zip": "617114",
        "lat": "47.309185",
        "long": "26.350789"
      },
      {
        "name": "TASCA",
        "zip": "617455",
        "lat": "46.893685",
        "long": "26.022642"
      },
      {
        "name": "TAZLAU",
        "zip": "617460",
        "lat": "46.717024",
        "long": "26.479812"
      },
      {
        "name": "TELEC",
        "zip": "617066",
        "lat": "46.879791",
        "long": "25.877746"
      },
      {
        "name": "TETCANI",
        "zip": "617207",
        "lat": "47.035094",
        "long": "26.84193"
      },
      {
        "name": "TIBUCANI",
        "zip": "617485",
        "lat": "47.113721",
        "long": "26.538907"
      },
      {
        "name": "TIBUCANII DE JOS",
        "zip": "617487",
        "lat": "47.117991",
        "long": "26.58351"
      },
      {
        "name": "TICOS",
        "zip": "617067",
        "lat": "46.8727",
        "long": "25.963564"
      },
      {
        "name": "TICOS-FLOAREA",
        "zip": "617458",
        "lat": "46.880703",
        "long": "25.991698"
      },
      {
        "name": "TIMISESTI",
        "zip": "617470",
        "lat": "47.232215",
        "long": "26.550449"
      },
      {
        "name": "TODIRENI",
        "zip": "617429",
        "lat": "47.011573",
        "long": "27.131904"
      },
      {
        "name": "TOLICI",
        "zip": "617318",
        "lat": "47.118404",
        "long": "26.448409"
      },
      {
        "name": "TOPOLICENI",
        "zip": "617352",
        "lat": "47.110219",
        "long": "25.934654"
      },
      {
        "name": "TOPOLITA",
        "zip": "617238",
        "lat": "47.167873",
        "long": "26.383449"
      },
      {
        "name": "TOTOIESTI",
        "zip": "617483",
        "lat": "47.073265",
        "long": "26.601793"
      },
      {
        "name": "TRAIAN",
        "zip": "617398",
        "lat": "46.991399",
        "long": "26.904379"
      },
      {
        "name": "TRAIAN",
        "zip": "617516",
        "lat": "46.833347",
        "long": "26.576546"
      },
      {
        "name": "TREI FANTANI",
        "zip": "617152",
        "lat": "46.719417",
        "long": "25.851147"
      },
      {
        "name": "TRIFESTI",
        "zip": "617475",
        "lat": "46.898687",
        "long": "26.858539"
      },
      {
        "name": "TUPILATI",
        "zip": "617480",
        "lat": "47.080688",
        "long": "26.645295"
      },
      {
        "name": "TURTURESTI",
        "zip": "617221",
        "lat": "46.940461",
        "long": "26.450745"
      },
      {
        "name": "TUTCANII DIN DEAL",
        "zip": "617022",
        "lat": "46.797205",
        "long": "26.774868"
      },
      {
        "name": "TUTCANII DIN VALE",
        "zip": "617023",
        "lat": "46.78365",
        "long": "26.768688"
      },
      {
        "name": "UNCESTI",
        "zip": "617424",
        "lat": "46.860469",
        "long": "26.796984"
      },
      {
        "name": "UNGHENI",
        "zip": "617373",
        "lat": "47.264671",
        "long": "26.45944"
      },
      {
        "name": "UNGHI",
        "zip": "617169",
        "lat": "47.04498",
        "long": "26.563492"
      },
      {
        "name": "URECHENI",
        "zip": "617490",
        "lat": "47.157034",
        "long": "26.507827"
      },
      {
        "name": "VAD",
        "zip": "617171",
        "lat": "47.025669",
        "long": "26.551401"
      },
      {
        "name": "VADURELE",
        "zip": "617121",
        "lat": "46.729301",
        "long": "26.570384"
      },
      {
        "name": "VADURELE",
        "zip": "617512",
        "lat": "46.921785",
        "long": "26.243596"
      },
      {
        "name": "VADURI",
        "zip": "617511",
        "lat": "46.935002",
        "long": "26.257085"
      },
      {
        "name": "VALEA ALBA",
        "zip": "617378",
        "lat": "47.075094",
        "long": "26.531283"
      },
      {
        "name": "VALEA ARINI",
        "zip": "617027",
        "lat": "47.133005",
        "long": "26.29115"
      },
      {
        "name": "VALEA ENEI",
        "zip": "617292",
        "lat": "46.800423",
        "long": "27.150551"
      },
      {
        "name": "VALEA MARE",
        "zip": "617379",
        "lat": "47.054452",
        "long": "26.569652"
      },
      {
        "name": "VALEA SEACA",
        "zip": "617028",
        "lat": "47.13954",
        "long": "26.299717"
      },
      {
        "name": "VALEA URSULUI",
        "zip": "617495",
        "lat": "46.800413",
        "long": "27.080174"
      },
      {
        "name": "VALENI",
        "zip": "610003",
        "lat": "46.905904",
        "long": "26.388695"
      },
      {
        "name": "VALENI",
        "zip": "617097",
        "lat": "47.031038",
        "long": "26.688458"
      },
      {
        "name": "VANATORI-NEAMT",
        "zip": "617500",
        "lat": "47.213025",
        "long": "26.318815"
      },
      {
        "name": "VARATEC",
        "zip": "617013",
        "lat": "47.142964",
        "long": "26.277071"
      },
      {
        "name": "VEJA",
        "zip": "617431",
        "lat": "47.015055",
        "long": "27.152675"
      },
      {
        "name": "VERSESTI",
        "zip": "617222",
        "lat": "46.97973",
        "long": "26.483093"
      },
      {
        "name": "VIISOARA",
        "zip": "617513",
        "lat": "46.942074",
        "long": "26.275904"
      },
      {
        "name": "VLADICENI",
        "zip": "617054",
        "lat": "46.933551",
        "long": "26.679622"
      },
      {
        "name": "VLADNICELE",
        "zip": "617432",
        "lat": "46.998579",
        "long": "27.160014"
      },
      {
        "name": "VULPASESTI",
        "zip": "617399",
        "lat": "46.969757",
        "long": "27.056493"
      },
      {
        "name": "ZANESTI",
        "zip": "617515",
        "lat": "46.817971",
        "long": "26.547836"
      },
      {
        "name": "ZVORANESTI",
        "zip": "617474",
        "lat": "47.212556",
        "long": "26.569745"
      }
    ],
    "OLT": [
      {
        "name": "AFUMATI",
        "zip": "237241",
        "lat": "44.769487",
        "long": "24.45379"
      },
      {
        "name": "ALBESTI",
        "zip": "237346",
        "lat": "44.685039",
        "long": "24.439807"
      },
      {
        "name": "ALIMANESTI",
        "zip": "237236",
        "lat": "44.256927",
        "long": "24.538949"
      },
      {
        "name": "ALUNISU",
        "zip": "237416",
        "lat": "44.741494",
        "long": "24.53529"
      },
      {
        "name": "ARCESTI",
        "zip": "237336",
        "lat": "44.466454",
        "long": "24.234211"
      },
      {
        "name": "ARCESTI-COT",
        "zip": "237337",
        "lat": "44.457625",
        "long": "24.269436"
      },
      {
        "name": "ARVATEASCA",
        "zip": "237446",
        "lat": "43.948618",
        "long": "24.383645"
      },
      {
        "name": "BABICIU",
        "zip": "237015",
        "lat": "44.038979",
        "long": "24.558704"
      },
      {
        "name": "BACEA",
        "zip": "237276",
        "lat": "44.39824",
        "long": "24.637593"
      },
      {
        "name": "BAGESTI",
        "zip": "237166",
        "lat": "44.806791",
        "long": "24.530666"
      },
      {
        "name": "BALANESTI",
        "zip": "237251",
        "lat": "44.247394",
        "long": "24.477322"
      },
      {
        "name": "BALDOVINESTI",
        "zip": "237005",
        "lat": "44.389248",
        "long": "24.047193"
      },
      {
        "name": "BALEASA",
        "zip": "237006",
        "lat": "44.399064",
        "long": "24.008304"
      },
      {
        "name": "BALS",
        "zip": "235100",
        "lat": "44.350577",
        "long": "24.100028"
      },
      {
        "name": "BALTATI",
        "zip": "235601",
        "lat": "44.509691",
        "long": "24.58265"
      },
      {
        "name": "BALTENI",
        "zip": "237331",
        "lat": "44.447554",
        "long": "24.536437"
      },
      {
        "name": "BARASTI",
        "zip": "237081",
        "lat": "44.619278",
        "long": "24.68396"
      },
      {
        "name": "BARASTI",
        "zip": "237271",
        "lat": "44.44861",
        "long": "24.142103"
      },
      {
        "name": "BARASTII DE CEPTURI",
        "zip": "237021",
        "lat": "44.703174",
        "long": "24.633476"
      },
      {
        "name": "BARASTII DE VEDE",
        "zip": "237022",
        "lat": "44.707941",
        "long": "24.660443"
      },
      {
        "name": "BARBALAI",
        "zip": "237461",
        "lat": "44.657142",
        "long": "24.60212"
      },
      {
        "name": "BARCA",
        "zip": "237506",
        "lat": "44.450085",
        "long": "24.455832"
      },
      {
        "name": "BARCANESTI",
        "zip": "237526",
        "lat": "44.300455",
        "long": "24.547062"
      },
      {
        "name": "BARSESTII DE SUS",
        "zip": "237426",
        "lat": "44.038227",
        "long": "24.655998"
      },
      {
        "name": "BARZA",
        "zip": "237030",
        "lat": "44.324595",
        "long": "24.144543"
      },
      {
        "name": "BARZA",
        "zip": "237496",
        "lat": "44.326494",
        "long": "24.786888"
      },
      {
        "name": "BATARENI",
        "zip": "237082",
        "lat": "44.606985",
        "long": "24.684355"
      },
      {
        "name": "BATIA",
        "zip": "237146",
        "lat": "44.747087",
        "long": "24.308133"
      },
      {
        "name": "BECHET",
        "zip": "237036",
        "lat": "44.393826",
        "long": "24.175931"
      },
      {
        "name": "BECULESTI",
        "zip": "237066",
        "lat": "44.509796",
        "long": "24.166224"
      },
      {
        "name": "BELGUN",
        "zip": "237037",
        "lat": "44.378781",
        "long": "24.149474"
      },
      {
        "name": "BERIA DE JOS",
        "zip": "237296",
        "lat": "44.562379",
        "long": "24.412619"
      },
      {
        "name": "BERIA DE SUS",
        "zip": "237297",
        "lat": "44.572262",
        "long": "24.422472"
      },
      {
        "name": "BERINDEI",
        "zip": "237126",
        "lat": "44.10693",
        "long": "24.56196"
      },
      {
        "name": "BIRCII",
        "zip": "235602",
        "lat": "44.516731",
        "long": "24.60324"
      },
      {
        "name": "BISTRITA NOUA",
        "zip": "235501",
        "lat": "44.399407",
        "long": "24.229533"
      },
      {
        "name": "BLAJ",
        "zip": "237561",
        "lat": "44.270334",
        "long": "24.198156"
      },
      {
        "name": "BOBICESTI",
        "zip": "237035",
        "lat": "44.39465",
        "long": "24.142492"
      },
      {
        "name": "BOBU",
        "zip": "237151",
        "lat": "44.231347",
        "long": "24.309693"
      },
      {
        "name": "BONDREA",
        "zip": "237071",
        "lat": "44.192337",
        "long": "24.230045"
      },
      {
        "name": "BOROESTI",
        "zip": "237023",
        "lat": "44.682817",
        "long": "24.628156"
      },
      {
        "name": "BRANCOVENI",
        "zip": "237050",
        "lat": "44.313852",
        "long": "24.307107"
      },
      {
        "name": "BRANET",
        "zip": "237031",
        "lat": "44.325897",
        "long": "24.177743"
      },
      {
        "name": "BRASTAVATU",
        "zip": "237045",
        "lat": "43.906026",
        "long": "24.407038"
      },
      {
        "name": "BREBENI",
        "zip": "237055",
        "lat": "44.362255",
        "long": "24.446423"
      },
      {
        "name": "BROSTENI",
        "zip": "237007",
        "lat": "44.433745",
        "long": "24.002598"
      },
      {
        "name": "BUCINISU",
        "zip": "237060",
        "lat": "43.947962",
        "long": "24.251009"
      },
      {
        "name": "BUCINISU MIC",
        "zip": "237061",
        "lat": "43.936077",
        "long": "24.258246"
      },
      {
        "name": "BUICESTI",
        "zip": "237361",
        "lat": "44.493951",
        "long": "24.430862"
      },
      {
        "name": "BULIMANU",
        "zip": "237546",
        "lat": "44.887394",
        "long": "24.415772"
      },
      {
        "name": "BURDULESTI",
        "zip": "237091",
        "lat": "44.462338",
        "long": "24.716989"
      },
      {
        "name": "BUSCA",
        "zip": "237256",
        "lat": "44.111974",
        "long": "24.802456"
      },
      {
        "name": "BUTA",
        "zip": "237101",
        "lat": "44.30812",
        "long": "24.709708"
      },
      {
        "name": "BUTOI",
        "zip": "237326",
        "lat": "44.290839",
        "long": "24.214414"
      },
      {
        "name": "BUZESTI",
        "zip": "237092",
        "lat": "44.451602",
        "long": "24.717308"
      },
      {
        "name": "CALINESTI",
        "zip": "237366",
        "lat": "44.077269",
        "long": "24.687962"
      },
      {
        "name": "CALUI",
        "zip": "237291",
        "lat": "44.45297",
        "long": "24.063595"
      },
      {
        "name": "CAMPU MARE",
        "zip": "237147",
        "lat": "44.756919",
        "long": "24.305493"
      },
      {
        "name": "CAMPU PARULUI",
        "zip": "237286",
        "lat": "43.899901",
        "long": "24.289955"
      },
      {
        "name": "CANDELESTI",
        "zip": "237486",
        "lat": "44.84164",
        "long": "24.526475"
      },
      {
        "name": "CARACAL",
        "zip": "235200",
        "lat": "44.112167",
        "long": "24.34559"
      },
      {
        "name": "CARLOGANI",
        "zip": "237065",
        "lat": "44.529044",
        "long": "24.140666"
      },
      {
        "name": "CARSTANI",
        "zip": "237083",
        "lat": "44.65153",
        "long": "24.657068"
      },
      {
        "name": "CATANELE",
        "zip": "237401",
        "lat": "44.381849",
        "long": "24.560823"
      },
      {
        "name": "CAZANESTI",
        "zip": "237531",
        "lat": "44.619217",
        "long": "24.359355"
      },
      {
        "name": "CEPARI",
        "zip": "237067",
        "lat": "44.497011",
        "long": "24.171441"
      },
      {
        "name": "CEPESTI",
        "zip": "237106",
        "lat": "44.712042",
        "long": "24.385676"
      },
      {
        "name": "CERBENI",
        "zip": "237386",
        "lat": "44.797294",
        "long": "24.379972"
      },
      {
        "name": "CEZIENI",
        "zip": "237070",
        "lat": "44.182849",
        "long": "24.268612"
      },
      {
        "name": "CHELBESTI",
        "zip": "237084",
        "lat": "44.660685",
        "long": "24.658615"
      },
      {
        "name": "CHERLESTII DIN DEAL",
        "zip": "237472",
        "lat": "44.522071",
        "long": "24.337596"
      },
      {
        "name": "CHERLESTII MOSTENI",
        "zip": "237471",
        "lat": "44.536255",
        "long": "24.337558"
      },
      {
        "name": "CHILIA",
        "zip": "237167",
        "lat": "44.783083",
        "long": "24.559719"
      },
      {
        "name": "CHILII",
        "zip": "237152",
        "lat": "44.265842",
        "long": "24.211016"
      },
      {
        "name": "CHINTESTI",
        "zip": "237038",
        "lat": "44.405995",
        "long": "24.113495"
      },
      {
        "name": "CHITEASCA",
        "zip": "235603",
        "lat": "44.535401",
        "long": "24.594429"
      },
      {
        "name": "CILIENI",
        "zip": "237075",
        "lat": "43.902408",
        "long": "24.612171"
      },
      {
        "name": "CIOCANESTI",
        "zip": "237024",
        "lat": "44.687897",
        "long": "24.654832"
      },
      {
        "name": "CIOFLANU",
        "zip": "237127",
        "lat": "44.095072",
        "long": "24.559416"
      },
      {
        "name": "CIORACA",
        "zip": "237487",
        "lat": "44.833029",
        "long": "24.548354"
      },
      {
        "name": "CIOROIASU",
        "zip": "237176",
        "lat": "44.243516",
        "long": "24.368162"
      },
      {
        "name": "CIOROIU",
        "zip": "237177",
        "lat": "44.238052",
        "long": "24.375596"
      },
      {
        "name": "CIREASOV",
        "zip": "230001",
        "lat": "44.454969",
        "long": "24.373849"
      },
      {
        "name": "CIURESTI",
        "zip": "237093",
        "lat": "44.44262",
        "long": "24.710201"
      },
      {
        "name": "COCORASTI",
        "zip": "237338",
        "lat": "44.484648",
        "long": "24.212799"
      },
      {
        "name": "COJGAREI",
        "zip": "237488",
        "lat": "44.831044",
        "long": "24.535854"
      },
      {
        "name": "COLIBASI",
        "zip": "237441",
        "lat": "44.506126",
        "long": "24.275174"
      },
      {
        "name": "COLONESTI",
        "zip": "237080",
        "lat": "44.628698",
        "long": "24.67266"
      },
      {
        "name": "COMANCA",
        "zip": "237131",
        "lat": "44.076951",
        "long": "24.358973"
      },
      {
        "name": "COMANESTI",
        "zip": "237039",
        "lat": "44.422961",
        "long": "24.131377"
      },
      {
        "name": "COMANI",
        "zip": "235401",
        "lat": "44.192032",
        "long": "24.490711"
      },
      {
        "name": "COMANITA",
        "zip": "237473",
        "lat": "44.564513",
        "long": "24.344253"
      },
      {
        "name": "CONSTANTINESTI",
        "zip": "235604",
        "lat": "44.594006",
        "long": "24.500167"
      },
      {
        "name": "CORABIA",
        "zip": "235300",
        "lat": "43.774826",
        "long": "24.500866"
      },
      {
        "name": "CORBENI",
        "zip": "235101",
        "lat": "44.379371",
        "long": "24.109249"
      },
      {
        "name": "CORBU",
        "zip": "237090",
        "lat": "44.491337",
        "long": "24.712061"
      },
      {
        "name": "CORBU",
        "zip": "237474",
        "lat": "44.54558",
        "long": "24.401105"
      },
      {
        "name": "CORLATESTI",
        "zip": "237072",
        "lat": "44.186733",
        "long": "24.246275"
      },
      {
        "name": "CORNATELU",
        "zip": "237347",
        "lat": "44.686976",
        "long": "24.461665"
      },
      {
        "name": "COTEANA",
        "zip": "237095",
        "lat": "44.300061",
        "long": "24.460692"
      },
      {
        "name": "COTENI",
        "zip": "237287",
        "lat": "43.877938",
        "long": "24.339838"
      },
      {
        "name": "COTORBESTI",
        "zip": "237566",
        "lat": "44.449172",
        "long": "23.922549"
      },
      {
        "name": "CRACIUNEI",
        "zip": "237367",
        "lat": "44.145495",
        "long": "24.662461"
      },
      {
        "name": "CRAMPOIA",
        "zip": "237100",
        "lat": "44.302149",
        "long": "24.745128"
      },
      {
        "name": "CRETI",
        "zip": "237348",
        "lat": "44.684163",
        "long": "24.511533"
      },
      {
        "name": "CRIVA DE JOS",
        "zip": "235502",
        "lat": "44.369096",
        "long": "24.313605"
      },
      {
        "name": "CRIVA DE SUS",
        "zip": "235503",
        "lat": "44.376029",
        "long": "24.318433"
      },
      {
        "name": "CRUSOVU",
        "zip": "237046",
        "lat": "43.923474",
        "long": "24.415019"
      },
      {
        "name": "CUCUETI",
        "zip": "237532",
        "lat": "44.611924",
        "long": "24.346579"
      },
      {
        "name": "CUNGREA",
        "zip": "237105",
        "lat": "44.667005",
        "long": "24.380382"
      },
      {
        "name": "CURTISOARA",
        "zip": "237115",
        "lat": "44.494492",
        "long": "24.332354"
      },
      {
        "name": "CURTISOARA",
        "zip": "237136",
        "lat": "44.492948",
        "long": "23.953755"
      },
      {
        "name": "CUZA VODA",
        "zip": "237417",
        "lat": "44.698768",
        "long": "24.578765"
      },
      {
        "name": "DAMBURILE",
        "zip": "237008",
        "lat": "44.406075",
        "long": "24.007217"
      },
      {
        "name": "DANEASA",
        "zip": "237125",
        "lat": "44.140944",
        "long": "24.560972"
      },
      {
        "name": "DAVIDESTI",
        "zip": "237418",
        "lat": "44.713468",
        "long": "24.572714"
      },
      {
        "name": "DEJESTI",
        "zip": "237547",
        "lat": "44.83093",
        "long": "24.356593"
      },
      {
        "name": "DELENI",
        "zip": "237476",
        "lat": "44.565275",
        "long": "24.356733"
      },
      {
        "name": "DEVESELU",
        "zip": "237130",
        "lat": "44.055403",
        "long": "24.389384"
      },
      {
        "name": "DIENCI",
        "zip": "237581",
        "lat": "44.756916",
        "long": "24.357582"
      },
      {
        "name": "DOANCA",
        "zip": "237481",
        "lat": "43.8487",
        "long": "24.649486"
      },
      {
        "name": "DOBA",
        "zip": "237339",
        "lat": "44.486788",
        "long": "24.243974"
      },
      {
        "name": "DOBRETU",
        "zip": "237135",
        "lat": "44.505843",
        "long": "23.945298"
      },
      {
        "name": "DOBRICENI",
        "zip": "237221",
        "lat": "44.523221",
        "long": "24.01216"
      },
      {
        "name": "DOBROSLOVENI",
        "zip": "237140",
        "lat": "44.173644",
        "long": "24.356111"
      },
      {
        "name": "DOBROTEASA",
        "zip": "237145",
        "lat": "44.786255",
        "long": "24.355093"
      },
      {
        "name": "DOBROTINET",
        "zip": "237116",
        "lat": "44.480311",
        "long": "24.345456"
      },
      {
        "name": "DOBRUN",
        "zip": "237150",
        "lat": "44.259721",
        "long": "24.220551"
      },
      {
        "name": "DONESTI",
        "zip": "237548",
        "lat": "44.805806",
        "long": "24.333437"
      },
      {
        "name": "DRAGANESTI-OLT",
        "zip": "235400",
        "lat": "44.167055",
        "long": "24.525588"
      },
      {
        "name": "DRAGHICENI",
        "zip": "237160",
        "lat": "44.124662",
        "long": "24.259298"
      },
      {
        "name": "DRANOVATU",
        "zip": "237186",
        "lat": "44.436195",
        "long": "24.27894"
      },
      {
        "name": "DUMITRESTI",
        "zip": "237533",
        "lat": "44.683699",
        "long": "24.316281"
      },
      {
        "name": "ENOSESTI",
        "zip": "235504",
        "lat": "44.375057",
        "long": "24.284813"
      },
      {
        "name": "FAGETELU",
        "zip": "237165",
        "lat": "44.783544",
        "long": "24.532259"
      },
      {
        "name": "FALCOIU",
        "zip": "237175",
        "lat": "44.22885",
        "long": "24.372307"
      },
      {
        "name": "FARCASELE",
        "zip": "237180",
        "lat": "44.148806",
        "long": "24.433954"
      },
      {
        "name": "FARCASU DE JOS",
        "zip": "237181",
        "lat": "44.135391",
        "long": "24.459012"
      },
      {
        "name": "FLORU",
        "zip": "237226",
        "lat": "44.376712",
        "long": "24.752658"
      },
      {
        "name": "FRASINET-GARA",
        "zip": "237556",
        "lat": "44.001091",
        "long": "24.420745"
      },
      {
        "name": "FRASINETU",
        "zip": "237141",
        "lat": "44.157039",
        "long": "24.323477"
      },
      {
        "name": "FRUNZARU",
        "zip": "237427",
        "lat": "44.042285",
        "long": "24.591472"
      },
      {
        "name": "GANEASA",
        "zip": "237185",
        "lat": "44.402114",
        "long": "24.282935"
      },
      {
        "name": "GARCOV",
        "zip": "237190",
        "lat": "43.759769",
        "long": "24.612543"
      },
      {
        "name": "GAVANESTI",
        "zip": "237009",
        "lat": "44.414064",
        "long": "24.014125"
      },
      {
        "name": "GHIMPATI",
        "zip": "237182",
        "lat": "44.153534",
        "long": "24.42691"
      },
      {
        "name": "GHIMPETENI",
        "zip": "237281",
        "lat": "44.279429",
        "long": "24.769446"
      },
      {
        "name": "GHIMPETENII NOI",
        "zip": "237282",
        "lat": "44.299031",
        "long": "24.791482"
      },
      {
        "name": "GHIOSANI",
        "zip": "237272",
        "lat": "44.482745",
        "long": "24.089148"
      },
      {
        "name": "GIUVARASTI",
        "zip": "237195",
        "lat": "43.794366",
        "long": "24.685573"
      },
      {
        "name": "GOSTAVATU",
        "zip": "237200",
        "lat": "44.061429",
        "long": "24.550841"
      },
      {
        "name": "GOVORA",
        "zip": "237041",
        "lat": "44.418445",
        "long": "24.112905"
      },
      {
        "name": "GRADINARI",
        "zip": "237205",
        "lat": "44.573792",
        "long": "24.268499"
      },
      {
        "name": "GRADINILE",
        "zip": "237447",
        "lat": "43.945528",
        "long": "24.393102"
      },
      {
        "name": "GRADISTEA",
        "zip": "237187",
        "lat": "44.445904",
        "long": "24.244332"
      },
      {
        "name": "GRECI",
        "zip": "237311",
        "lat": "44.280658",
        "long": "24.351044"
      },
      {
        "name": "GRECI",
        "zip": "237402",
        "lat": "44.329785",
        "long": "24.555944"
      },
      {
        "name": "GREERESTI",
        "zip": "237242",
        "lat": "44.729827",
        "long": "24.424071"
      },
      {
        "name": "GROJDIBODU",
        "zip": "237210",
        "lat": "43.757371",
        "long": "24.264291"
      },
      {
        "name": "GROPSANI",
        "zip": "237567",
        "lat": "44.437146",
        "long": "23.951584"
      },
      {
        "name": "GROZAVESTI",
        "zip": "237161",
        "lat": "44.131303",
        "long": "24.236809"
      },
      {
        "name": "GRUIU",
        "zip": "237168",
        "lat": "44.760871",
        "long": "24.538009"
      },
      {
        "name": "GUBANDRU",
        "zip": "237011",
        "lat": "44.385885",
        "long": "24.01714"
      },
      {
        "name": "GUESTI",
        "zip": "237086",
        "lat": "44.586905",
        "long": "24.692463"
      },
      {
        "name": "GURA CALUIU",
        "zip": "237292",
        "lat": "44.459033",
        "long": "24.035474"
      },
      {
        "name": "GURA PADINII",
        "zip": "237306",
        "lat": "43.757044",
        "long": "24.313497"
      },
      {
        "name": "HOREZU",
        "zip": "237137",
        "lat": "44.470166",
        "long": "23.955632"
      },
      {
        "name": "HOTARANI",
        "zip": "237183",
        "lat": "44.164516",
        "long": "24.409357"
      },
      {
        "name": "HOTARU",
        "zip": "237211",
        "lat": "43.76528",
        "long": "24.250631"
      },
      {
        "name": "IANCA",
        "zip": "237215",
        "lat": "43.78326",
        "long": "24.176601"
      },
      {
        "name": "IANCA NOUA",
        "zip": "237456",
        "lat": "43.821646",
        "long": "24.212709"
      },
      {
        "name": "IANCU JIANU",
        "zip": "237220",
        "lat": "44.496755",
        "long": "24.032613"
      },
      {
        "name": "IBANESTI",
        "zip": "237107",
        "lat": "44.647141",
        "long": "24.385059"
      },
      {
        "name": "ICOANA",
        "zip": "237225",
        "lat": "44.415045",
        "long": "24.71361"
      },
      {
        "name": "IONICESTI",
        "zip": "237387",
        "lat": "44.813343",
        "long": "24.416283"
      },
      {
        "name": "IPOTESTI",
        "zip": "237261",
        "lat": "44.315604",
        "long": "24.398415"
      },
      {
        "name": "ISACI",
        "zip": "237169",
        "lat": "44.770639",
        "long": "24.521647"
      },
      {
        "name": "IZBICENI",
        "zip": "237230",
        "lat": "43.820042",
        "long": "24.663356"
      },
      {
        "name": "IZVOARELE",
        "zip": "237235",
        "lat": "44.264757",
        "long": "24.52742"
      },
      {
        "name": "IZVORU",
        "zip": "237188",
        "lat": "44.427655",
        "long": "24.250097"
      },
      {
        "name": "JIENI",
        "zip": "237381",
        "lat": "43.952723",
        "long": "24.591282"
      },
      {
        "name": "JITARU",
        "zip": "235605",
        "lat": "44.545973",
        "long": "24.547263"
      },
      {
        "name": "LAUNELE",
        "zip": "237388",
        "lat": "44.814747",
        "long": "24.4"
      },
      {
        "name": "LAZARESTI",
        "zip": "237026",
        "lat": "44.717427",
        "long": "24.629052"
      },
      {
        "name": "LELEASCA",
        "zip": "237240",
        "lat": "44.784091",
        "long": "24.452456"
      },
      {
        "name": "LEOTESTI",
        "zip": "237042",
        "lat": "44.365901",
        "long": "24.149149"
      },
      {
        "name": "LIICENI",
        "zip": "237162",
        "lat": "44.124002",
        "long": "24.272543"
      },
      {
        "name": "LINIA DIN VALE",
        "zip": "237117",
        "lat": "44.470789",
        "long": "24.335248"
      },
      {
        "name": "LISA",
        "zip": "237403",
        "lat": "44.351657",
        "long": "24.531583"
      },
      {
        "name": "LUNCA",
        "zip": "237462",
        "lat": "44.661246",
        "long": "24.62182"
      },
      {
        "name": "MAGURA",
        "zip": "237332",
        "lat": "44.393579",
        "long": "24.555045"
      },
      {
        "name": "MAGURA",
        "zip": "237463",
        "lat": "44.668064",
        "long": "24.623085"
      },
      {
        "name": "MALU ROSU",
        "zip": "237252",
        "lat": "44.247908",
        "long": "24.442071"
      },
      {
        "name": "MAMURA",
        "zip": "237442",
        "lat": "44.534091",
        "long": "24.30848"
      },
      {
        "name": "MANDRA",
        "zip": "237521",
        "lat": "44.214928",
        "long": "24.809744"
      },
      {
        "name": "MANULESTI",
        "zip": "237389",
        "lat": "44.811745",
        "long": "24.387692"
      },
      {
        "name": "MARDALE",
        "zip": "237568",
        "lat": "44.446866",
        "long": "23.99099"
      },
      {
        "name": "MARGARITESTI",
        "zip": "237562",
        "lat": "44.29796",
        "long": "24.14794"
      },
      {
        "name": "MARGHENI",
        "zip": "237051",
        "lat": "44.328949",
        "long": "24.350285"
      },
      {
        "name": "MARGINENI-SLOBOZIA",
        "zip": "235606",
        "lat": "44.529513",
        "long": "24.556415"
      },
      {
        "name": "MARUNTEI",
        "zip": "237087",
        "lat": "44.600192",
        "long": "24.689232"
      },
      {
        "name": "MARUNTEI",
        "zip": "237250",
        "lat": "44.221744",
        "long": "24.461881"
      },
      {
        "name": "MERENI",
        "zip": "237027",
        "lat": "44.719835",
        "long": "24.606924"
      },
      {
        "name": "MIERLESTII DE SUS",
        "zip": "237333",
        "lat": "44.40596",
        "long": "24.559003"
      },
      {
        "name": "MIERLICESTI",
        "zip": "237243",
        "lat": "44.733793",
        "long": "24.433788"
      },
      {
        "name": "MIESTI",
        "zip": "237108",
        "lat": "44.660234",
        "long": "24.415182"
      },
      {
        "name": "MIHAESTI",
        "zip": "237255",
        "lat": "44.12384",
        "long": "24.78771"
      },
      {
        "name": "MIHAILESTI-POPESTI",
        "zip": "235607",
        "lat": "44.531775",
        "long": "24.543484"
      },
      {
        "name": "MILCOVENI",
        "zip": "237094",
        "lat": "44.426093",
        "long": "24.722893"
      },
      {
        "name": "MILCOVU DIN DEAL",
        "zip": "237262",
        "lat": "44.394349",
        "long": "24.389059"
      },
      {
        "name": "MILCOVU DIN VALE",
        "zip": "237263",
        "lat": "44.387448",
        "long": "24.367382"
      },
      {
        "name": "MIRCESTI",
        "zip": "237464",
        "lat": "44.681624",
        "long": "24.613392"
      },
      {
        "name": "MIRILA",
        "zip": "237043",
        "lat": "44.357543",
        "long": "24.152082"
      },
      {
        "name": "MOGOSESTI",
        "zip": "235608",
        "lat": "44.56321",
        "long": "24.512221"
      },
      {
        "name": "MOMAIU",
        "zip": "237466",
        "lat": "44.674673",
        "long": "24.60712"
      },
      {
        "name": "MORUNESTI",
        "zip": "237273",
        "lat": "44.479915",
        "long": "24.126238"
      },
      {
        "name": "MORUNGLAV",
        "zip": "237270",
        "lat": "44.460875",
        "long": "24.108123"
      },
      {
        "name": "MOSTENI",
        "zip": "237404",
        "lat": "44.366024",
        "long": "24.571896"
      },
      {
        "name": "MOTOESTI",
        "zip": "237028",
        "lat": "44.721072",
        "long": "24.69663"
      },
      {
        "name": "MOVILENI",
        "zip": "237275",
        "lat": "44.369735",
        "long": "24.640355"
      },
      {
        "name": "NAVARGENI",
        "zip": "237088",
        "lat": "44.612408",
        "long": "24.68161"
      },
      {
        "name": "NEGRENI",
        "zip": "235609",
        "lat": "44.568235",
        "long": "24.595325"
      },
      {
        "name": "NICOLAE TITULESCU",
        "zip": "237280",
        "lat": "44.2706",
        "long": "24.758616"
      },
      {
        "name": "OBARSIA",
        "zip": "237285",
        "lat": "43.888743",
        "long": "24.329131"
      },
      {
        "name": "OBARSIA NOUA",
        "zip": "237288",
        "lat": "43.887229",
        "long": "24.314959"
      },
      {
        "name": "OBOGA",
        "zip": "237290",
        "lat": "44.42404",
        "long": "24.087158"
      },
      {
        "name": "OCIOGI",
        "zip": "237052",
        "lat": "44.319892",
        "long": "24.350174"
      },
      {
        "name": "OLARI",
        "zip": "237327",
        "lat": "44.307835",
        "long": "24.208569"
      },
      {
        "name": "OLTISORU",
        "zip": "237189",
        "lat": "44.389702",
        "long": "24.283259"
      },
      {
        "name": "OPORELU",
        "zip": "237295",
        "lat": "44.59617",
        "long": "24.425091"
      },
      {
        "name": "OPTASANI",
        "zip": "237419",
        "lat": "44.738759",
        "long": "24.509957"
      },
      {
        "name": "OPTASI",
        "zip": "237301",
        "lat": "44.579197",
        "long": "24.651217"
      },
      {
        "name": "ORLEA",
        "zip": "237305",
        "lat": "43.753369",
        "long": "24.377165"
      },
      {
        "name": "ORLEA NOUA",
        "zip": "237307",
        "lat": "43.755224",
        "long": "24.358336"
      },
      {
        "name": "OSICA DE JOS",
        "zip": "237153",
        "lat": "44.243777",
        "long": "24.279888"
      },
      {
        "name": "OSICA DE SUS",
        "zip": "237310",
        "lat": "44.254649",
        "long": "24.327126"
      },
      {
        "name": "OSTROV",
        "zip": "237312",
        "lat": "44.279758",
        "long": "24.317501"
      },
      {
        "name": "OTESTII DE JOS",
        "zip": "237109",
        "lat": "44.692678",
        "long": "24.381328"
      },
      {
        "name": "OTESTII DE SUS",
        "zip": "237111",
        "lat": "44.717857",
        "long": "24.387558"
      },
      {
        "name": "PARSCOVENI",
        "zip": "237325",
        "lat": "44.291663",
        "long": "24.232108"
      },
      {
        "name": "PERETU",
        "zip": "237313",
        "lat": "44.273197",
        "long": "24.35018"
      },
      {
        "name": "PERIETI",
        "zip": "237330",
        "lat": "44.414167",
        "long": "24.55417"
      },
      {
        "name": "PESCARESTI",
        "zip": "237569",
        "lat": "44.439484",
        "long": "23.956844"
      },
      {
        "name": "PESTRA",
        "zip": "237128",
        "lat": "44.12311",
        "long": "24.530927"
      },
      {
        "name": "PETCULESTI",
        "zip": "237206",
        "lat": "44.587224",
        "long": "24.266817"
      },
      {
        "name": "PIATRA",
        "zip": "235505",
        "lat": "44.360771",
        "long": "24.295206"
      },
      {
        "name": "PIATRA-OLT",
        "zip": "235500",
        "lat": "44.36906",
        "long": "24.258915"
      },
      {
        "name": "PIELCANI",
        "zip": "237171",
        "lat": "44.813626",
        "long": "24.566017"
      },
      {
        "name": "PIETRIS",
        "zip": "237012",
        "lat": "44.400724",
        "long": "24.052603"
      },
      {
        "name": "PIETRISU",
        "zip": "237118",
        "lat": "44.487546",
        "long": "24.344401"
      },
      {
        "name": "PISCANI",
        "zip": "235610",
        "lat": "44.566262",
        "long": "24.553214"
      },
      {
        "name": "PLAVICEANCA",
        "zip": "237448",
        "lat": "43.951305",
        "long": "24.398293"
      },
      {
        "name": "PLAVICENI",
        "zip": "237396",
        "lat": "43.971806",
        "long": "24.578984"
      },
      {
        "name": "PLESOIU",
        "zip": "237335",
        "lat": "44.475509",
        "long": "24.262672"
      },
      {
        "name": "PLOPSORELU",
        "zip": "237571",
        "lat": "44.480892",
        "long": "23.890142"
      },
      {
        "name": "POBORU",
        "zip": "237345",
        "lat": "44.664436",
        "long": "24.498287"
      },
      {
        "name": "POGANU",
        "zip": "237534",
        "lat": "44.660835",
        "long": "24.318583"
      },
      {
        "name": "POIANA",
        "zip": "237368",
        "lat": "44.101326",
        "long": "24.683989"
      },
      {
        "name": "POIANA MARE",
        "zip": "237274",
        "lat": "44.492899",
        "long": "24.113142"
      },
      {
        "name": "POPESTI",
        "zip": "237029",
        "lat": "44.725626",
        "long": "24.646903"
      },
      {
        "name": "POPESTI",
        "zip": "237522",
        "lat": "44.220869",
        "long": "24.805866"
      },
      {
        "name": "POTCOAVA",
        "zip": "237355",
        "lat": "44.474522",
        "long": "24.631109"
      },
      {
        "name": "POTCOAVA-FALCOENI",
        "zip": "237356",
        "lat": "44.494836",
        "long": "24.616504"
      },
      {
        "name": "POTELU",
        "zip": "237216",
        "lat": "43.764874",
        "long": "24.204232"
      },
      {
        "name": "POTLOGENI",
        "zip": "237482",
        "lat": "43.879508",
        "long": "24.631127"
      },
      {
        "name": "POTOPINU",
        "zip": "237142",
        "lat": "44.193485",
        "long": "24.352172"
      },
      {
        "name": "PREOTESTI",
        "zip": "237222",
        "lat": "44.535297",
        "long": "23.987923"
      },
      {
        "name": "PRISACA",
        "zip": "237572",
        "lat": "44.472326",
        "long": "23.911516"
      },
      {
        "name": "PRISEACA",
        "zip": "237360",
        "lat": "44.515443",
        "long": "24.450562"
      },
      {
        "name": "PROASPETI",
        "zip": "237119",
        "lat": "44.459855",
        "long": "24.337618"
      },
      {
        "name": "PROFA",
        "zip": "237421",
        "lat": "44.74152",
        "long": "24.578173"
      },
      {
        "name": "RACOVITA",
        "zip": "237563",
        "lat": "44.315223",
        "long": "24.120084"
      },
      {
        "name": "RADESTI",
        "zip": "237298",
        "lat": "44.616021",
        "long": "24.433474"
      },
      {
        "name": "RADOMIRESTI",
        "zip": "237365",
        "lat": "44.118042",
        "long": "24.677713"
      },
      {
        "name": "RAITIU",
        "zip": "237121",
        "lat": "44.500666",
        "long": "24.344295"
      },
      {
        "name": "RECEA",
        "zip": "237507",
        "lat": "44.428695",
        "long": "24.460486"
      },
      {
        "name": "REDEA",
        "zip": "237370",
        "lat": "44.052304",
        "long": "24.295373"
      },
      {
        "name": "REDISOARA",
        "zip": "237371",
        "lat": "44.042294",
        "long": "24.346269"
      },
      {
        "name": "RESCA",
        "zip": "237143",
        "lat": "44.171792",
        "long": "24.392247"
      },
      {
        "name": "RESCUTA",
        "zip": "237144",
        "lat": "44.170823",
        "long": "24.400659"
      },
      {
        "name": "ROMANA",
        "zip": "235102",
        "lat": "44.387753",
        "long": "24.108628"
      },
      {
        "name": "ROSIENII MARI",
        "zip": "237154",
        "lat": "44.241839",
        "long": "24.247754"
      },
      {
        "name": "ROSIENII MICI",
        "zip": "237156",
        "lat": "44.245236",
        "long": "24.234557"
      },
      {
        "name": "ROTUNDA",
        "zip": "237375",
        "lat": "43.983605",
        "long": "24.312884"
      },
      {
        "name": "RUDARI",
        "zip": "237397",
        "lat": "43.991624",
        "long": "24.593599"
      },
      {
        "name": "RUNCU MARE",
        "zip": "237207",
        "lat": "44.556628",
        "long": "24.270371"
      },
      {
        "name": "RUSANESTI",
        "zip": "237380",
        "lat": "43.936952",
        "long": "24.594499"
      },
      {
        "name": "RUSANESTII DE SUS",
        "zip": "237564",
        "lat": "44.284499",
        "long": "24.168722"
      },
      {
        "name": "RUSCIORI",
        "zip": "235611",
        "lat": "44.626013",
        "long": "24.518205"
      },
      {
        "name": "SALCIA",
        "zip": "237411",
        "lat": "44.427001",
        "long": "24.314194"
      },
      {
        "name": "SALTANESTI",
        "zip": "237362",
        "lat": "44.52706",
        "long": "24.432058"
      },
      {
        "name": "SAMBURESTI",
        "zip": "237385",
        "lat": "44.807352",
        "long": "24.3941"
      },
      {
        "name": "SATU NOU",
        "zip": "237208",
        "lat": "44.552815",
        "long": "24.301075"
      },
      {
        "name": "SATU NOU",
        "zip": "237308",
        "lat": "43.76864",
        "long": "24.31766"
      },
      {
        "name": "SCARISOARA",
        "zip": "237395",
        "lat": "43.993571",
        "long": "24.576935"
      },
      {
        "name": "SCHITU",
        "zip": "237400",
        "lat": "44.353919",
        "long": "24.568971"
      },
      {
        "name": "SCHITU DELENI",
        "zip": "237477",
        "lat": "44.571726",
        "long": "24.338267"
      },
      {
        "name": "SCHITU DIN DEAL",
        "zip": "237341",
        "lat": "44.502461",
        "long": "24.227388"
      },
      {
        "name": "SCHITU DIN VALE",
        "zip": "237342",
        "lat": "44.505944",
        "long": "24.24027"
      },
      {
        "name": "SCORBURA",
        "zip": "237068",
        "lat": "44.513464",
        "long": "24.16141"
      },
      {
        "name": "SCORNICESTI",
        "zip": "235600",
        "lat": "44.600955",
        "long": "24.542914"
      },
      {
        "name": "SEACA",
        "zip": "237349",
        "lat": "44.711797",
        "long": "24.452962"
      },
      {
        "name": "SEACA",
        "zip": "237405",
        "lat": "44.151587",
        "long": "24.761486"
      },
      {
        "name": "SERBANESTI",
        "zip": "237450",
        "lat": "44.328467",
        "long": "24.693561"
      },
      {
        "name": "SERBANESTII DE SUS",
        "zip": "237452",
        "lat": "44.337124",
        "long": "24.679871"
      },
      {
        "name": "SIMNICENI",
        "zip": "237573",
        "lat": "44.475279",
        "long": "23.901131"
      },
      {
        "name": "SINESTI",
        "zip": "237357",
        "lat": "44.467769",
        "long": "24.665849"
      },
      {
        "name": "SLATINA",
        "zip": "230002",
        "lat": "44.429668",
        "long": "24.366499"
      },
      {
        "name": "SLATIOARA",
        "zip": "237410",
        "lat": "44.400575",
        "long": "24.322342"
      },
      {
        "name": "SLAVENI",
        "zip": "237201",
        "lat": "44.08619",
        "long": "24.521568"
      },
      {
        "name": "SOPARLITA",
        "zip": "237328",
        "lat": "44.2766",
        "long": "24.27436"
      },
      {
        "name": "SPATARU",
        "zip": "237112",
        "lat": "44.697436",
        "long": "24.41095"
      },
      {
        "name": "SPINENI",
        "zip": "237415",
        "lat": "44.700278",
        "long": "24.560915"
      },
      {
        "name": "SPRANCENATA",
        "zip": "237425",
        "lat": "44.07497",
        "long": "24.626165"
      },
      {
        "name": "STANULEASA",
        "zip": "237391",
        "lat": "44.831257",
        "long": "24.407889"
      },
      {
        "name": "STANULEASA",
        "zip": "237549",
        "lat": "44.85793",
        "long": "24.411323"
      },
      {
        "name": "STAVARU",
        "zip": "237501",
        "lat": "43.863355",
        "long": "24.255302"
      },
      {
        "name": "STEFAN CEL MARE",
        "zip": "237455",
        "lat": "43.809866",
        "long": "24.224928"
      },
      {
        "name": "STEJARU",
        "zip": "237264",
        "lat": "44.350401",
        "long": "24.382437"
      },
      {
        "name": "STOBORASTI",
        "zip": "237497",
        "lat": "44.341301",
        "long": "24.785712"
      },
      {
        "name": "STOENESTI",
        "zip": "237430",
        "lat": "44.119064",
        "long": "24.497623"
      },
      {
        "name": "STOICANESTI",
        "zip": "237435",
        "lat": "44.184544",
        "long": "24.64069"
      },
      {
        "name": "STREJESTI",
        "zip": "237440",
        "lat": "44.535016",
        "long": "24.270489"
      },
      {
        "name": "STREJESTII DE SUS",
        "zip": "237443",
        "lat": "44.543488",
        "long": "24.225376"
      },
      {
        "name": "STRUGURELU",
        "zip": "237451",
        "lat": "44.341503",
        "long": "24.687708"
      },
      {
        "name": "STUDINA",
        "zip": "237445",
        "lat": "43.958769",
        "long": "24.415602"
      },
      {
        "name": "STUDINITA",
        "zip": "237449",
        "lat": "43.974056",
        "long": "24.425141"
      },
      {
        "name": "STUPINA",
        "zip": "237069",
        "lat": "44.554802",
        "long": "24.146435"
      },
      {
        "name": "SUICA",
        "zip": "235612",
        "lat": "44.618759",
        "long": "24.567017"
      },
      {
        "name": "SURPENI",
        "zip": "237351",
        "lat": "44.669316",
        "long": "24.530743"
      },
      {
        "name": "TABACI",
        "zip": "237574",
        "lat": "44.460866",
        "long": "23.911479"
      },
      {
        "name": "TABONU",
        "zip": "237289",
        "lat": "43.900099",
        "long": "24.330378"
      },
      {
        "name": "TATULESTI",
        "zip": "237460",
        "lat": "44.638145",
        "long": "24.614206"
      },
      {
        "name": "TEIS",
        "zip": "235103",
        "lat": "44.339534",
        "long": "24.133971"
      },
      {
        "name": "TEIUS",
        "zip": "235613",
        "lat": "44.635595",
        "long": "24.525017"
      },
      {
        "name": "TEIUSU",
        "zip": "237056",
        "lat": "44.342001",
        "long": "24.436078"
      },
      {
        "name": "TESLUI",
        "zip": "237470",
        "lat": "44.514491",
        "long": "24.359104"
      },
      {
        "name": "TIA MARE",
        "zip": "237480",
        "lat": "43.865702",
        "long": "24.634195"
      },
      {
        "name": "TIRISNEAG",
        "zip": "237523",
        "lat": "44.203918",
        "long": "24.788282"
      },
      {
        "name": "TOMENI",
        "zip": "237314",
        "lat": "44.289114",
        "long": "24.363607"
      },
      {
        "name": "TONESTI",
        "zip": "237244",
        "lat": "44.786938",
        "long": "24.425937"
      },
      {
        "name": "TONESTI",
        "zip": "237392",
        "lat": "44.8032",
        "long": "24.4122"
      },
      {
        "name": "TOPANA",
        "zip": "237485",
        "lat": "44.825173",
        "long": "24.500262"
      },
      {
        "name": "TRAIAN",
        "zip": "237490",
        "lat": "44.021793",
        "long": "24.45515"
      },
      {
        "name": "TREPTENI",
        "zip": "237551",
        "lat": "44.863194",
        "long": "24.351887"
      },
      {
        "name": "TRUFINESTI",
        "zip": "237358",
        "lat": "44.490483",
        "long": "24.638405"
      },
      {
        "name": "TUDOR VLADIMIRESCU",
        "zip": "235301",
        "lat": "43.826416",
        "long": "24.493497"
      },
      {
        "name": "TUFARU",
        "zip": "237246",
        "lat": "44.74762",
        "long": "24.424957"
      },
      {
        "name": "TUFENI",
        "zip": "237495",
        "lat": "44.371157",
        "long": "24.798919"
      },
      {
        "name": "TURIA",
        "zip": "237508",
        "lat": "44.446577",
        "long": "24.477359"
      },
      {
        "name": "ULMET",
        "zip": "237157",
        "lat": "44.25087",
        "long": "24.251216"
      },
      {
        "name": "ULMI",
        "zip": "237266",
        "lat": "44.36201",
        "long": "24.376042"
      },
      {
        "name": "UNGURENI",
        "zip": "237489",
        "lat": "44.882514",
        "long": "24.52284"
      },
      {
        "name": "URIA",
        "zip": "237428",
        "lat": "44.074539",
        "long": "24.593943"
      },
      {
        "name": "URSA",
        "zip": "237191",
        "lat": "43.78783",
        "long": "24.637874"
      },
      {
        "name": "URSI",
        "zip": "237247",
        "lat": "44.754195",
        "long": "24.44323"
      },
      {
        "name": "URSOAIA",
        "zip": "237227",
        "lat": "44.434742",
        "long": "24.695243"
      },
      {
        "name": "URZICA",
        "zip": "237500",
        "lat": "43.857667",
        "long": "24.288072"
      },
      {
        "name": "VADASTRA",
        "zip": "237510",
        "lat": "43.86542",
        "long": "24.379117"
      },
      {
        "name": "VADASTRITA",
        "zip": "237515",
        "lat": "43.847101",
        "long": "24.338605"
      },
      {
        "name": "VALCELE",
        "zip": "237525",
        "lat": "44.281406",
        "long": "24.539061"
      },
      {
        "name": "VALCELELE DE SUS",
        "zip": "237527",
        "lat": "44.282648",
        "long": "24.554238"
      },
      {
        "name": "VALEA FETEI",
        "zip": "237536",
        "lat": "44.631658",
        "long": "24.339952"
      },
      {
        "name": "VALEA LUI ALB",
        "zip": "237582",
        "lat": "44.707215",
        "long": "24.314714"
      },
      {
        "name": "VALEA MARE",
        "zip": "237505",
        "lat": "44.467091",
        "long": "24.445967"
      },
      {
        "name": "VALEA MERILOR",
        "zip": "237359",
        "lat": "44.47169",
        "long": "24.656111"
      },
      {
        "name": "VALEA SATULUI",
        "zip": "237576",
        "lat": "44.44679",
        "long": "23.904249"
      },
      {
        "name": "VALEA SOARELUI",
        "zip": "237372",
        "lat": "44.028488",
        "long": "24.27322"
      },
      {
        "name": "VALENI",
        "zip": "237053",
        "lat": "44.295735",
        "long": "24.306035"
      },
      {
        "name": "VALENI",
        "zip": "237520",
        "lat": "44.236627",
        "long": "24.78596"
      },
      {
        "name": "VANESTI",
        "zip": "237537",
        "lat": "44.632499",
        "long": "24.372859"
      },
      {
        "name": "VARTOPU",
        "zip": "235302",
        "lat": "43.806269",
        "long": "24.411049"
      },
      {
        "name": "VERGULEASA",
        "zip": "237530",
        "lat": "44.646453",
        "long": "24.333182"
      },
      {
        "name": "VINETI",
        "zip": "237422",
        "lat": "44.682582",
        "long": "24.571516"
      },
      {
        "name": "VISINA",
        "zip": "237540",
        "lat": "43.866111",
        "long": "24.453427"
      },
      {
        "name": "VISINA NOUA",
        "zip": "237511",
        "lat": "43.871314",
        "long": "24.414125"
      },
      {
        "name": "VITANESTI",
        "zip": "237302",
        "lat": "44.538015",
        "long": "24.68718"
      },
      {
        "name": "VITOMIRESTI",
        "zip": "237545",
        "lat": "44.863719",
        "long": "24.390902"
      },
      {
        "name": "VLADILA",
        "zip": "237555",
        "lat": "43.997288",
        "long": "24.408381"
      },
      {
        "name": "VLADILA NOUA",
        "zip": "237557",
        "lat": "44.003477",
        "long": "24.408949"
      },
      {
        "name": "VLADULENI",
        "zip": "237315",
        "lat": "44.260605",
        "long": "24.324534"
      },
      {
        "name": "VLAICI",
        "zip": "237089",
        "lat": "44.671883",
        "long": "24.655982"
      },
      {
        "name": "VLANGARESTI",
        "zip": "237583",
        "lat": "44.723171",
        "long": "24.348077"
      },
      {
        "name": "VOINEASA",
        "zip": "237560",
        "lat": "44.277102",
        "long": "24.138605"
      },
      {
        "name": "VULPENI",
        "zip": "237565",
        "lat": "44.451402",
        "long": "23.930518"
      },
      {
        "name": "VULPESTI",
        "zip": "237148",
        "lat": "44.793726",
        "long": "24.342649"
      },
      {
        "name": "VULTURESTI",
        "zip": "237580",
        "lat": "44.734307",
        "long": "24.3117"
      },
      {
        "name": "ZANOAGA",
        "zip": "237129",
        "lat": "44.103856",
        "long": "24.610974"
      },
      {
        "name": "ZORLEASCA",
        "zip": "237509",
        "lat": "44.418292",
        "long": "24.458325"
      }
    ],
    "PRAHOVA": [
      {
        "name": "ADUNATI",
        "zip": "107005",
        "lat": "45.183557",
        "long": "25.599326"
      },
      {
        "name": "ALBESTI-MURU",
        "zip": "107011",
        "lat": "44.944082",
        "long": "26.211288"
      },
      {
        "name": "ALBESTI-PALEOLOGU",
        "zip": "107010",
        "lat": "44.954123",
        "long": "26.229415"
      },
      {
        "name": "ALBINARI",
        "zip": "107031",
        "lat": "45.211335",
        "long": "26.153222"
      },
      {
        "name": "ALUNIS",
        "zip": "107015",
        "lat": "45.198917",
        "long": "25.888763"
      },
      {
        "name": "ANTOFILOAIA",
        "zip": "107496",
        "lat": "44.863574",
        "long": "26.143891"
      },
      {
        "name": "APOSTOLACHE",
        "zip": "107020",
        "lat": "45.128754",
        "long": "26.261501"
      },
      {
        "name": "ARICESTII RAHTIVANI",
        "zip": "107025",
        "lat": "44.947411",
        "long": "25.833278"
      },
      {
        "name": "ARICESTII ZELETIN",
        "zip": "107030",
        "lat": "45.221499",
        "long": "26.180343"
      },
      {
        "name": "ARIONESTII NOI",
        "zip": "106301",
        "lat": "44.994804",
        "long": "26.218439"
      },
      {
        "name": "ARIONESTII VECHI",
        "zip": "106302",
        "lat": "44.98809",
        "long": "26.221068"
      },
      {
        "name": "ARVA",
        "zip": "107621",
        "lat": "44.9575",
        "long": "26.178279"
      },
      {
        "name": "AZUGA",
        "zip": "105100",
        "lat": "45.444454",
        "long": "25.569464"
      },
      {
        "name": "BABA ANA",
        "zip": "107035",
        "lat": "44.968498",
        "long": "26.463506"
      },
      {
        "name": "BAICOI",
        "zip": "105200",
        "lat": "45.033647",
        "long": "25.862829"
      },
      {
        "name": "BALTA DOAMNEI",
        "zip": "107040",
        "lat": "44.758445",
        "long": "26.17471"
      },
      {
        "name": "BALTESTI",
        "zip": "107045",
        "lat": "45.109264",
        "long": "26.131054"
      },
      {
        "name": "BALTITA",
        "zip": "107376",
        "lat": "44.837402",
        "long": "25.852454"
      },
      {
        "name": "BANESTI",
        "zip": "107050",
        "lat": "45.10099",
        "long": "25.760591"
      },
      {
        "name": "BARA",
        "zip": "107041",
        "lat": "44.747976",
        "long": "26.240154"
      },
      {
        "name": "BARAITARU",
        "zip": "107211",
        "lat": "44.861783",
        "long": "26.347827"
      },
      {
        "name": "BARCANESTI",
        "zip": "107055",
        "lat": "44.881511",
        "long": "26.050647"
      },
      {
        "name": "BARZILA",
        "zip": "107396",
        "lat": "45.141472",
        "long": "26.138665"
      },
      {
        "name": "BATESTI",
        "zip": "107082",
        "lat": "44.845412",
        "long": "26.042948"
      },
      {
        "name": "BATRANI",
        "zip": "107536",
        "lat": "45.312668",
        "long": "26.153253"
      },
      {
        "name": "BELCIUG",
        "zip": "107212",
        "lat": "44.818898",
        "long": "26.248012"
      },
      {
        "name": "BERCENI",
        "zip": "107060",
        "lat": "44.931052",
        "long": "26.122229"
      },
      {
        "name": "BERTEA",
        "zip": "107065",
        "lat": "45.230412",
        "long": "25.869055"
      },
      {
        "name": "BIGHILIN",
        "zip": "107111",
        "lat": "44.996549",
        "long": "26.115297"
      },
      {
        "name": "BLEJOI",
        "zip": "107070",
        "lat": "44.992917",
        "long": "26.011146"
      },
      {
        "name": "BOBICESTI",
        "zip": "107461",
        "lat": "45.191269",
        "long": "26.097147"
      },
      {
        "name": "BOBOCI",
        "zip": "107331",
        "lat": "45.084989",
        "long": "26.412239"
      },
      {
        "name": "BOBOLIA",
        "zip": "107426",
        "lat": "45.092003",
        "long": "25.741143"
      },
      {
        "name": "BODESTI",
        "zip": "107441",
        "lat": "45.264975",
        "long": "26.159253"
      },
      {
        "name": "BOGDANESTI",
        "zip": "107286",
        "lat": "45.142318",
        "long": "26.06793"
      },
      {
        "name": "BOLDESTI",
        "zip": "107076",
        "lat": "44.866967",
        "long": "26.54823"
      },
      {
        "name": "BOLDESTI-SCAENI",
        "zip": "105300",
        "lat": "45.031753",
        "long": "26.030944"
      },
      {
        "name": "BORDENII MARI",
        "zip": "107526",
        "lat": "45.089508",
        "long": "25.869638"
      },
      {
        "name": "BORDENII MICI",
        "zip": "107527",
        "lat": "45.077197",
        "long": "25.865532"
      },
      {
        "name": "BOSILCESTI",
        "zip": "107601",
        "lat": "45.152122",
        "long": "25.839167"
      },
      {
        "name": "BOZIENI",
        "zip": "107241",
        "lat": "45.04499",
        "long": "26.347563"
      },
      {
        "name": "BRADET",
        "zip": "107537",
        "lat": "45.344508",
        "long": "26.18627"
      },
      {
        "name": "BRATASANCA",
        "zip": "107251",
        "lat": "44.934056",
        "long": "25.810821"
      },
      {
        "name": "BRATESTI",
        "zip": "107551",
        "lat": "44.801517",
        "long": "25.915155"
      },
      {
        "name": "BRAZII DE JOS",
        "zip": "107083",
        "lat": "44.8493",
        "long": "26.023789"
      },
      {
        "name": "BRAZII DE SUS",
        "zip": "107084",
        "lat": "44.853763",
        "long": "26.015287"
      },
      {
        "name": "BREAZA DE JOS",
        "zip": "105401",
        "lat": "45.17856",
        "long": "25.669869"
      },
      {
        "name": "BREAZA DE SUS",
        "zip": "105402",
        "lat": "45.198793",
        "long": "25.655777"
      },
      {
        "name": "BREBU MANASTIREI",
        "zip": "107105",
        "lat": "45.181596",
        "long": "25.771364"
      },
      {
        "name": "BREBU MEGIESESC",
        "zip": "107101",
        "lat": "45.16774",
        "long": "25.774743"
      },
      {
        "name": "BUCHILASI",
        "zip": "107497",
        "lat": "44.874289",
        "long": "26.143337"
      },
      {
        "name": "BUCOV",
        "zip": "107110",
        "lat": "44.97417",
        "long": "26.084074"
      },
      {
        "name": "BUDA",
        "zip": "107026",
        "lat": "44.965723",
        "long": "25.919592"
      },
      {
        "name": "BUDA",
        "zip": "107498",
        "lat": "44.824541",
        "long": "26.182995"
      },
      {
        "name": "BUGHEA DE JOS",
        "zip": "107306",
        "lat": "45.180592",
        "long": "26.017578"
      },
      {
        "name": "BUGHEA DE SUS",
        "zip": "107596",
        "lat": "45.201829",
        "long": "25.993381"
      },
      {
        "name": "BUSTENARI",
        "zip": "107602",
        "lat": "45.141242",
        "long": "25.83308"
      },
      {
        "name": "BUSTENI",
        "zip": "105500",
        "lat": "45.414771",
        "long": "25.535485"
      },
      {
        "name": "BUTUCI",
        "zip": "107516",
        "lat": "45.159326",
        "long": "26.384109"
      },
      {
        "name": "BUZOTA",
        "zip": "107021",
        "lat": "45.118073",
        "long": "26.242146"
      },
      {
        "name": "CALINESTI",
        "zip": "107257",
        "lat": "45.01877",
        "long": "25.781365"
      },
      {
        "name": "CALUGARENI",
        "zip": "107115",
        "lat": "45.085339",
        "long": "26.379046"
      },
      {
        "name": "CAMPINA",
        "zip": "105600",
        "lat": "45.125696",
        "long": "25.734804"
      },
      {
        "name": "CAP ROSU",
        "zip": "107256",
        "lat": "45.047881",
        "long": "25.787546"
      },
      {
        "name": "CARBUNARI",
        "zip": "107431",
        "lat": "44.757894",
        "long": "25.980506"
      },
      {
        "name": "CARBUNESTI",
        "zip": "107120",
        "lat": "45.225471",
        "long": "26.206614"
      },
      {
        "name": "CARJARI",
        "zip": "107656",
        "lat": "45.106941",
        "long": "25.949563"
      },
      {
        "name": "CARTIERUL DAMBU",
        "zip": "107061",
        "lat": "44.92414",
        "long": "26.071245"
      },
      {
        "name": "CATINA",
        "zip": "107258",
        "lat": "45.007795",
        "long": "25.783599"
      },
      {
        "name": "CATUNU",
        "zip": "107062",
        "lat": "44.899951",
        "long": "26.134136"
      },
      {
        "name": "CATUNU",
        "zip": "107191",
        "lat": "45.251879",
        "long": "26.094928"
      },
      {
        "name": "CEPTURA DE JOS",
        "zip": "107126",
        "lat": "45.013751",
        "long": "26.333369"
      },
      {
        "name": "CEPTURA DE SUS",
        "zip": "107130",
        "lat": "45.025251",
        "long": "26.32372"
      },
      {
        "name": "CERASU",
        "zip": "107140",
        "lat": "45.321885",
        "long": "26.039117"
      },
      {
        "name": "CERNESTI",
        "zip": "107321",
        "lat": "45.261694",
        "long": "26.027999"
      },
      {
        "name": "CHEIA",
        "zip": "107356",
        "lat": "45.458421",
        "long": "25.937625"
      },
      {
        "name": "CHERBA",
        "zip": "106303",
        "lat": "44.996658",
        "long": "26.291322"
      },
      {
        "name": "CHESNOIU",
        "zip": "107377",
        "lat": "44.842278",
        "long": "25.878838"
      },
      {
        "name": "CHICIURENI",
        "zip": "107357",
        "lat": "45.326882",
        "long": "25.999748"
      },
      {
        "name": "CHIOJDEANCA",
        "zip": "107150",
        "lat": "45.15651",
        "long": "26.269491"
      },
      {
        "name": "CHIRITESTI",
        "zip": "107322",
        "lat": "45.272502",
        "long": "26.023112"
      },
      {
        "name": "CHITORANI",
        "zip": "107112",
        "lat": "44.970347",
        "long": "26.123167"
      },
      {
        "name": "CIOCENI",
        "zip": "107012",
        "lat": "44.907795",
        "long": "26.285635"
      },
      {
        "name": "CIOCRAC",
        "zip": "107192",
        "lat": "45.24018",
        "long": "26.079946"
      },
      {
        "name": "CIORANII DE JOS",
        "zip": "107160",
        "lat": "44.820713",
        "long": "26.413363"
      },
      {
        "name": "CIORANII DE SUS",
        "zip": "107156",
        "lat": "44.839233",
        "long": "26.394732"
      },
      {
        "name": "CIRESANU",
        "zip": "107036",
        "lat": "44.98285",
        "long": "26.510885"
      },
      {
        "name": "CIUPELNITA",
        "zip": "107221",
        "lat": "44.844991",
        "long": "26.234757"
      },
      {
        "name": "COADA IZVORULUI",
        "zip": "107378",
        "lat": "44.85728",
        "long": "25.817936"
      },
      {
        "name": "COADA MALULUI",
        "zip": "107346",
        "lat": "45.122503",
        "long": "26.035585"
      },
      {
        "name": "COCEANA",
        "zip": "107552",
        "lat": "44.817307",
        "long": "25.924535"
      },
      {
        "name": "COCORASTII CAPLII",
        "zip": "107351",
        "lat": "45.069148",
        "long": "25.759062"
      },
      {
        "name": "COCORASTII COLT",
        "zip": "107379",
        "lat": "44.833346",
        "long": "25.899252"
      },
      {
        "name": "COCORASTII GRIND",
        "zip": "107381",
        "lat": "44.846909",
        "long": "25.874945"
      },
      {
        "name": "COCORASTII MISLII",
        "zip": "107165",
        "lat": "45.083296",
        "long": "25.925239"
      },
      {
        "name": "COCOSESTI",
        "zip": "107401",
        "lat": "45.004745",
        "long": "25.98657"
      },
      {
        "name": "COLCEAG",
        "zip": "107170",
        "lat": "44.943783",
        "long": "26.360335"
      },
      {
        "name": "COLTU DE JOS",
        "zip": "107382",
        "lat": "44.825328",
        "long": "25.910925"
      },
      {
        "name": "COMARNIC",
        "zip": "105700",
        "lat": "45.242777",
        "long": "25.634183"
      },
      {
        "name": "CONDURATU",
        "zip": "107037",
        "lat": "44.971984",
        "long": "26.432048"
      },
      {
        "name": "CORLATESTI",
        "zip": "107063",
        "lat": "44.913428",
        "long": "26.086054"
      },
      {
        "name": "CORNU DE JOS",
        "zip": "107180",
        "lat": "45.15094",
        "long": "25.706405"
      },
      {
        "name": "CORNU DE JOS",
        "zip": "107213",
        "lat": "44.843714",
        "long": "26.269532"
      },
      {
        "name": "CORNU DE SUS",
        "zip": "107176",
        "lat": "45.168186",
        "long": "25.696332"
      },
      {
        "name": "CORNU DE SUS",
        "zip": "107222",
        "lat": "44.840986",
        "long": "26.245239"
      },
      {
        "name": "COSERELE",
        "zip": "107291",
        "lat": "45.08705",
        "long": "26.250352"
      },
      {
        "name": "COSLEGI",
        "zip": "107622",
        "lat": "44.90146",
        "long": "26.158364"
      },
      {
        "name": "COSMINA DE JOS",
        "zip": "107186",
        "lat": "45.159743",
        "long": "25.901626"
      },
      {
        "name": "COSMINA DE SUS",
        "zip": "107187",
        "lat": "45.173405",
        "long": "25.897236"
      },
      {
        "name": "COSTENI",
        "zip": "107358",
        "lat": "45.298721",
        "long": "26.017849"
      },
      {
        "name": "COTOFENESTI",
        "zip": "107651",
        "lat": "45.13262",
        "long": "25.993136"
      },
      {
        "name": "CRANGURILE",
        "zip": "107038",
        "lat": "44.981626",
        "long": "26.485401"
      },
      {
        "name": "CRIVINA",
        "zip": "107276",
        "lat": "44.78395",
        "long": "26.049054"
      },
      {
        "name": "CUIB",
        "zip": "107287",
        "lat": "45.132475",
        "long": "26.077052"
      },
      {
        "name": "CURCUBEU",
        "zip": "107042",
        "lat": "44.762612",
        "long": "26.144047"
      },
      {
        "name": "CURMATURA",
        "zip": "107397",
        "lat": "45.153394",
        "long": "26.151867"
      },
      {
        "name": "DAMBU",
        "zip": "105201",
        "lat": "45.044976",
        "long": "25.888809"
      },
      {
        "name": "DARVARI",
        "zip": "107623",
        "lat": "44.918753",
        "long": "26.155998"
      },
      {
        "name": "DITESTI",
        "zip": "107246",
        "lat": "44.98235",
        "long": "25.732782"
      },
      {
        "name": "DOBROTA",
        "zip": "107292",
        "lat": "45.100222",
        "long": "26.283249"
      },
      {
        "name": "DOFTANA",
        "zip": "107603",
        "lat": "45.140582",
        "long": "25.778208"
      },
      {
        "name": "DRAGANEASA",
        "zip": "107476",
        "lat": "45.104675",
        "long": "25.681378"
      },
      {
        "name": "DRAGANESTI",
        "zip": "107210",
        "lat": "44.828008",
        "long": "26.287665"
      },
      {
        "name": "DRAGHICESTI",
        "zip": "107188",
        "lat": "45.165735",
        "long": "25.913283"
      },
      {
        "name": "DRAJNA DE JOS",
        "zip": "107193",
        "lat": "45.224471",
        "long": "26.057252"
      },
      {
        "name": "DRAJNA DE SUS",
        "zip": "107194",
        "lat": "45.2667",
        "long": "26.057932"
      },
      {
        "name": "DUMBRAVA",
        "zip": "107220",
        "lat": "44.874533",
        "long": "26.188565"
      },
      {
        "name": "DUMBRAVESTI",
        "zip": "107230",
        "lat": "45.090638",
        "long": "25.997315"
      },
      {
        "name": "EZENI",
        "zip": "107252",
        "lat": "44.931635",
        "long": "25.817109"
      },
      {
        "name": "FACAIENI",
        "zip": "107359",
        "lat": "45.292091",
        "long": "25.990215"
      },
      {
        "name": "FAGET",
        "zip": "107196",
        "lat": "45.24738",
        "long": "26.070715"
      },
      {
        "name": "FAGETU",
        "zip": "107307",
        "lat": "45.136673",
        "long": "26.020901"
      },
      {
        "name": "FANARI",
        "zip": "107266",
        "lat": "44.801217",
        "long": "26.191763"
      },
      {
        "name": "FANARI",
        "zip": "107277",
        "lat": "44.78813",
        "long": "26.086776"
      },
      {
        "name": "FANTANELE",
        "zip": "107240",
        "lat": "45.008259",
        "long": "26.377704"
      },
      {
        "name": "FEFELEI",
        "zip": "105801",
        "lat": "45.01236",
        "long": "26.440513"
      },
      {
        "name": "FILIPESTII DE PADURE",
        "zip": "107245",
        "lat": "44.998137",
        "long": "25.743133"
      },
      {
        "name": "FILIPESTII DE TARG",
        "zip": "107250",
        "lat": "44.978291",
        "long": "25.791551"
      },
      {
        "name": "FLORESTI",
        "zip": "107255",
        "lat": "45.027872",
        "long": "25.799913"
      },
      {
        "name": "FRASINET",
        "zip": "105403",
        "lat": "45.195646",
        "long": "25.676276"
      },
      {
        "name": "FULGA DE JOS",
        "zip": "107261",
        "lat": "44.88152",
        "long": "26.442579"
      },
      {
        "name": "FULGA DE SUS",
        "zip": "107262",
        "lat": "44.896584",
        "long": "26.445631"
      },
      {
        "name": "FUNDENI",
        "zip": "107308",
        "lat": "45.116849",
        "long": "26.023825"
      },
      {
        "name": "GAGENI",
        "zip": "107402",
        "lat": "45.018622",
        "long": "25.946645"
      },
      {
        "name": "GALMEIA",
        "zip": "107406",
        "lat": "45.032579",
        "long": "26.112121"
      },
      {
        "name": "GAVANEL",
        "zip": "107231",
        "lat": "45.080947",
        "long": "25.997683"
      },
      {
        "name": "GHEABA",
        "zip": "107361",
        "lat": "45.302813",
        "long": "26.003631"
      },
      {
        "name": "GHERGHITA",
        "zip": "107265",
        "lat": "44.799854",
        "long": "26.26992"
      },
      {
        "name": "GHIGHIU",
        "zip": "107056",
        "lat": "44.898149",
        "long": "26.078095"
      },
      {
        "name": "GHINOAICA",
        "zip": "107242",
        "lat": "45.04438",
        "long": "26.392544"
      },
      {
        "name": "GHIOCEL",
        "zip": "107411",
        "lat": "45.098171",
        "long": "26.170983"
      },
      {
        "name": "GHIOLDUM",
        "zip": "107383",
        "lat": "44.834879",
        "long": "25.879134"
      },
      {
        "name": "GHIOSESTI",
        "zip": "105701",
        "lat": "45.243613",
        "long": "25.6238"
      },
      {
        "name": "GLOD",
        "zip": "107336",
        "lat": "45.140576",
        "long": "26.448632"
      },
      {
        "name": "GOGA",
        "zip": "107499",
        "lat": "44.886526",
        "long": "26.141449"
      },
      {
        "name": "GOGEASCA",
        "zip": "107121",
        "lat": "45.240872",
        "long": "26.179277"
      },
      {
        "name": "GORGOTA",
        "zip": "107275",
        "lat": "44.78233",
        "long": "26.084295"
      },
      {
        "name": "GORNET",
        "zip": "107285",
        "lat": "45.118148",
        "long": "26.079781"
      },
      {
        "name": "GORNET-CRICOV",
        "zip": "107290",
        "lat": "45.07492",
        "long": "26.252772"
      },
      {
        "name": "GORUNA",
        "zip": "107166",
        "lat": "45.087485",
        "long": "25.935132"
      },
      {
        "name": "GRADISTEA",
        "zip": "107077",
        "lat": "44.886662",
        "long": "26.515826"
      },
      {
        "name": "GRESIA",
        "zip": "107538",
        "lat": "45.336437",
        "long": "26.15725"
      },
      {
        "name": "GROSANI",
        "zip": "106201",
        "lat": "45.248074",
        "long": "25.946532"
      },
      {
        "name": "GURA BELIEI",
        "zip": "105404",
        "lat": "45.210637",
        "long": "25.649459"
      },
      {
        "name": "GURA CRIVATULUI",
        "zip": "107384",
        "lat": "44.837748",
        "long": "25.818551"
      },
      {
        "name": "GURA VADULUI",
        "zip": "107300",
        "lat": "45.042084",
        "long": "26.437799"
      },
      {
        "name": "GURA VITIOAREI",
        "zip": "107305",
        "lat": "45.150006",
        "long": "26.031258"
      },
      {
        "name": "HABUD",
        "zip": "107553",
        "lat": "44.775832",
        "long": "25.925283"
      },
      {
        "name": "HARSA",
        "zip": "107407",
        "lat": "45.037428",
        "long": "26.160595"
      },
      {
        "name": "HATCARAU",
        "zip": "107214",
        "lat": "44.810041",
        "long": "26.322458"
      },
      {
        "name": "HOMORACIU",
        "zip": "107323",
        "lat": "45.269404",
        "long": "26.016336"
      },
      {
        "name": "IAZU",
        "zip": "107347",
        "lat": "45.083073",
        "long": "26.019928"
      },
      {
        "name": "INDEPENDENTA",
        "zip": "107267",
        "lat": "44.802957",
        "long": "26.222229"
      },
      {
        "name": "INOTESTI",
        "zip": "107171",
        "lat": "44.96152",
        "long": "26.357985"
      },
      {
        "name": "IORDACHEANU",
        "zip": "107310",
        "lat": "45.045977",
        "long": "26.238888"
      },
      {
        "name": "IRIMESTI",
        "zip": "105405",
        "lat": "45.153609",
        "long": "25.660746"
      },
      {
        "name": "IZESTI",
        "zip": "107046",
        "lat": "45.112674",
        "long": "26.145988"
      },
      {
        "name": "IZVOARELE",
        "zip": "107320",
        "lat": "45.281183",
        "long": "26.01062"
      },
      {
        "name": "IZVORU",
        "zip": "107481",
        "lat": "45.155149",
        "long": "25.629413"
      },
      {
        "name": "JERCALAI",
        "zip": "106304",
        "lat": "45.020319",
        "long": "26.222292"
      },
      {
        "name": "JUGURENI",
        "zip": "107330",
        "lat": "45.095791",
        "long": "26.437835"
      },
      {
        "name": "LACU TURCULUI",
        "zip": "107043",
        "lat": "44.762183",
        "long": "26.219066"
      },
      {
        "name": "LAPOS",
        "zip": "107335",
        "lat": "45.151975",
        "long": "26.419108"
      },
      {
        "name": "LAPOSEL",
        "zip": "107337",
        "lat": "45.147295",
        "long": "26.394418"
      },
      {
        "name": "LILIESTI",
        "zip": "105202",
        "lat": "45.034391",
        "long": "25.892868"
      },
      {
        "name": "LIPANESTI",
        "zip": "107340",
        "lat": "45.0541",
        "long": "26.020783"
      },
      {
        "name": "LIVADEA",
        "zip": "107652",
        "lat": "45.187855",
        "long": "25.924844"
      },
      {
        "name": "LOLOIASCA",
        "zip": "107616",
        "lat": "44.9689",
        "long": "26.292143"
      },
      {
        "name": "LOPATNITA",
        "zip": "107561",
        "lat": "45.185584",
        "long": "26.220208"
      },
      {
        "name": "LUNCA MARE",
        "zip": "107566",
        "lat": "45.199419",
        "long": "25.744671"
      },
      {
        "name": "LUNCA PRAHOVEI",
        "zip": "107352",
        "lat": "45.047166",
        "long": "25.769329"
      },
      {
        "name": "LUTU ROSU",
        "zip": "107066",
        "lat": "45.251227",
        "long": "25.818375"
      },
      {
        "name": "MAGULA",
        "zip": "107617",
        "lat": "44.928872",
        "long": "26.30393"
      },
      {
        "name": "MAGURA",
        "zip": "107562",
        "lat": "45.146464",
        "long": "26.197515"
      },
      {
        "name": "MAGURELE",
        "zip": "107345",
        "lat": "45.102249",
        "long": "26.037264"
      },
      {
        "name": "MAGURENI",
        "zip": "107350",
        "lat": "45.043486",
        "long": "25.75238"
      },
      {
        "name": "MALAESTII DE JOS",
        "zip": "107232",
        "lat": "45.104541",
        "long": "25.997094"
      },
      {
        "name": "MALAESTII DE SUS",
        "zip": "107233",
        "lat": "45.120501",
        "long": "26.003628"
      },
      {
        "name": "MALAIESTI",
        "zip": "107501",
        "lat": "44.869952",
        "long": "26.118628"
      },
      {
        "name": "MALAMUC",
        "zip": "107268",
        "lat": "44.795793",
        "long": "26.306638"
      },
      {
        "name": "MALU ROSU",
        "zip": "107127",
        "lat": "45.063743",
        "long": "26.330797"
      },
      {
        "name": "MALU VANAT",
        "zip": "107324",
        "lat": "45.255846",
        "long": "26.022201"
      },
      {
        "name": "MANASTIREA SUZANA",
        "zip": "107363",
        "lat": "45.394155",
        "long": "25.929131"
      },
      {
        "name": "MANECIU-PAMANTENI",
        "zip": "107362",
        "lat": "45.297125",
        "long": "25.999928"
      },
      {
        "name": "MANECIU-UNGURENI",
        "zip": "107365",
        "lat": "45.316067",
        "long": "25.992206"
      },
      {
        "name": "MANESTI",
        "zip": "107375",
        "lat": "44.866674",
        "long": "25.850751"
      },
      {
        "name": "MARGINEA PADURII",
        "zip": "107332",
        "lat": "45.102514",
        "long": "26.416749"
      },
      {
        "name": "MARGINENII DE JOS",
        "zip": "107253",
        "lat": "44.956861",
        "long": "25.758338"
      },
      {
        "name": "MARLOGEA",
        "zip": "107022",
        "lat": "45.127898",
        "long": "26.288006"
      },
      {
        "name": "MARUNTIS",
        "zip": "106305",
        "lat": "44.993699",
        "long": "26.276486"
      },
      {
        "name": "MATITA",
        "zip": "107398",
        "lat": "45.141898",
        "long": "26.163576"
      },
      {
        "name": "MEHEDINTA",
        "zip": "107412",
        "lat": "45.09523",
        "long": "26.187181"
      },
      {
        "name": "MELICESTI",
        "zip": "107604",
        "lat": "45.1619",
        "long": "25.811764"
      },
      {
        "name": "MERDEALA",
        "zip": "107442",
        "lat": "45.255562",
        "long": "26.14136"
      },
      {
        "name": "MERI",
        "zip": "107216",
        "lat": "44.835981",
        "long": "26.305235"
      },
      {
        "name": "MINIERI",
        "zip": "107247",
        "lat": "44.982587",
        "long": "25.759231"
      },
      {
        "name": "MIRESU MARE",
        "zip": "107517",
        "lat": "45.135002",
        "long": "26.376276"
      },
      {
        "name": "MIRESU MIC",
        "zip": "107518",
        "lat": "45.147812",
        "long": "26.367461"
      },
      {
        "name": "MIROSLAVESTI",
        "zip": "107486",
        "lat": "44.802849",
        "long": "26.085808"
      },
      {
        "name": "MISLEA",
        "zip": "107528",
        "lat": "45.095039",
        "long": "25.824189"
      },
      {
        "name": "MIZIL",
        "zip": "105800",
        "lat": "45.003051",
        "long": "26.443754"
      },
      {
        "name": "MOARA",
        "zip": "107487",
        "lat": "44.833205",
        "long": "26.067892"
      },
      {
        "name": "MOARA DOMNEASCA",
        "zip": "107502",
        "lat": "44.856907",
        "long": "26.149006"
      },
      {
        "name": "MOARA NOUA",
        "zip": "107064",
        "lat": "44.948124",
        "long": "26.102895"
      },
      {
        "name": "MOCESTI",
        "zip": "107311",
        "lat": "45.052134",
        "long": "26.241211"
      },
      {
        "name": "NEDELEA",
        "zip": "107027",
        "lat": "44.971914",
        "long": "25.816469"
      },
      {
        "name": "NEGOIESTI",
        "zip": "107086",
        "lat": "44.873193",
        "long": "25.980583"
      },
      {
        "name": "NEVESTEASCA",
        "zip": "107413",
        "lat": "45.088834",
        "long": "26.223315"
      },
      {
        "name": "NISIPOASA",
        "zip": "107408",
        "lat": "45.019624",
        "long": "26.161431"
      },
      {
        "name": "NISTORESTI",
        "zip": "105406",
        "lat": "45.202201",
        "long": "25.667926"
      },
      {
        "name": "NOVACESTI",
        "zip": "107259",
        "lat": "45.026338",
        "long": "25.775635"
      },
      {
        "name": "NUCET",
        "zip": "107151",
        "lat": "45.159139",
        "long": "26.287928"
      },
      {
        "name": "NUCET",
        "zip": "107288",
        "lat": "45.152737",
        "long": "26.097381"
      },
      {
        "name": "NUCSOARA DE JOS",
        "zip": "107443",
        "lat": "45.281358",
        "long": "26.105133"
      },
      {
        "name": "NUCSOARA DE SUS",
        "zip": "107444",
        "lat": "45.284655",
        "long": "26.11907"
      },
      {
        "name": "OCINA DE JOS",
        "zip": "107006",
        "lat": "45.180893",
        "long": "25.60729"
      },
      {
        "name": "OCINA DE SUS",
        "zip": "107007",
        "lat": "45.200602",
        "long": "25.598819"
      },
      {
        "name": "ODAILE",
        "zip": "107488",
        "lat": "44.822832",
        "long": "26.055067"
      },
      {
        "name": "OGRETIN",
        "zip": "107197",
        "lat": "45.260752",
        "long": "26.087575"
      },
      {
        "name": "OLARI",
        "zip": "107269",
        "lat": "44.785314",
        "long": "26.216651"
      },
      {
        "name": "OLARII VECHI",
        "zip": "107271",
        "lat": "44.791698",
        "long": "26.202454"
      },
      {
        "name": "OLOGENI",
        "zip": "107432",
        "lat": "44.733554",
        "long": "25.950331"
      },
      {
        "name": "OLTENI",
        "zip": "107597",
        "lat": "45.21855",
        "long": "26.035277"
      },
      {
        "name": "ORZOAIA DE JOS",
        "zip": "106306",
        "lat": "45.003717",
        "long": "26.228487"
      },
      {
        "name": "ORZOAIA DE SUS",
        "zip": "106307",
        "lat": "44.999254",
        "long": "26.229233"
      },
      {
        "name": "OSTROVU",
        "zip": "107016",
        "lat": "45.208961",
        "long": "25.897315"
      },
      {
        "name": "PACURETI",
        "zip": "107395",
        "lat": "45.143533",
        "long": "26.131833"
      },
      {
        "name": "PACURI",
        "zip": "107546",
        "lat": "45.193653",
        "long": "26.170727"
      },
      {
        "name": "PALANCA",
        "zip": "107503",
        "lat": "44.815941",
        "long": "26.198508"
      },
      {
        "name": "PANTAZI",
        "zip": "107624",
        "lat": "44.935126",
        "long": "26.138826"
      },
      {
        "name": "PAREPA-RUSANI",
        "zip": "107172",
        "lat": "44.905773",
        "long": "26.354777"
      },
      {
        "name": "PAULESTI",
        "zip": "107400",
        "lat": "45.001845",
        "long": "25.967907"
      },
      {
        "name": "PAULESTII NOI",
        "zip": "107403",
        "lat": "44.992562",
        "long": "25.979167"
      },
      {
        "name": "PERSUNARI",
        "zip": "107301",
        "lat": "45.056818",
        "long": "26.447845"
      },
      {
        "name": "PERSUNARI",
        "zip": "107386",
        "lat": "44.836148",
        "long": "25.887304"
      },
      {
        "name": "PIATRA",
        "zip": "107198",
        "lat": "45.211058",
        "long": "26.056424"
      },
      {
        "name": "PIATRA",
        "zip": "107387",
        "lat": "44.841048",
        "long": "25.941176"
      },
      {
        "name": "PIATRA",
        "zip": "107477",
        "lat": "45.110932",
        "long": "25.682521"
      },
      {
        "name": "PIATRA MICA",
        "zip": "107519",
        "lat": "45.164077",
        "long": "26.334019"
      },
      {
        "name": "PIETRICEAUA",
        "zip": "107102",
        "lat": "45.217226",
        "long": "25.80632"
      },
      {
        "name": "PIETRICICA",
        "zip": "107338",
        "lat": "45.164144",
        "long": "26.448996"
      },
      {
        "name": "PIETRISU",
        "zip": "107427",
        "lat": "45.119279",
        "long": "25.72455"
      },
      {
        "name": "PIETROSANI",
        "zip": "107489",
        "lat": "44.836399",
        "long": "26.10287"
      },
      {
        "name": "PIORESTI",
        "zip": "107433",
        "lat": "44.76207",
        "long": "26.019621"
      },
      {
        "name": "PISCULESTI",
        "zip": "107611",
        "lat": "44.830366",
        "long": "26.015955"
      },
      {
        "name": "PITIGOI",
        "zip": "107199",
        "lat": "45.219561",
        "long": "26.067633"
      },
      {
        "name": "PLAI",
        "zip": "107201",
        "lat": "45.218843",
        "long": "26.084875"
      },
      {
        "name": "PLAIETU",
        "zip": "107364",
        "lat": "45.346592",
        "long": "25.991358"
      },
      {
        "name": "PLAIU",
        "zip": "107482",
        "lat": "45.137417",
        "long": "25.621899"
      },
      {
        "name": "PLAIU",
        "zip": "107581",
        "lat": "45.21968",
        "long": "25.594534"
      },
      {
        "name": "PLAIU CAMPINEI",
        "zip": "107567",
        "lat": "45.186567",
        "long": "25.738512"
      },
      {
        "name": "PLAIU CORNULUI",
        "zip": "107568",
        "lat": "45.217959",
        "long": "25.683898"
      },
      {
        "name": "PLAVIA",
        "zip": "107312",
        "lat": "45.03209",
        "long": "26.240911"
      },
      {
        "name": "PLEASA",
        "zip": "107113",
        "lat": "45.00384",
        "long": "26.071442"
      },
      {
        "name": "PLOIESTI",
        "zip": "100001",
        "lat": "44.941747",
        "long": "26.02365"
      },
      {
        "name": "PLOIESTIORI",
        "zip": "107071",
        "lat": "44.980981",
        "long": "26.019612"
      },
      {
        "name": "PLOPENI",
        "zip": "105900",
        "lat": "45.049086",
        "long": "25.953226"
      },
      {
        "name": "PLOPENI",
        "zip": "107234",
        "lat": "45.065669",
        "long": "25.982568"
      },
      {
        "name": "PLOPU",
        "zip": "107405",
        "lat": "45.013359",
        "long": "26.142141"
      },
      {
        "name": "PODENII NOI",
        "zip": "107410",
        "lat": "45.110987",
        "long": "26.169319"
      },
      {
        "name": "PODENII VECHI",
        "zip": "107047",
        "lat": "45.087371",
        "long": "26.113019"
      },
      {
        "name": "PODGORIA",
        "zip": "107586",
        "lat": "45.108318",
        "long": "26.309589"
      },
      {
        "name": "PODU CHEII",
        "zip": "107103",
        "lat": "45.207907",
        "long": "25.750473"
      },
      {
        "name": "PODU CORBULUI",
        "zip": "105407",
        "lat": "45.215977",
        "long": "25.654701"
      },
      {
        "name": "PODU LUI GALBEN",
        "zip": "107414",
        "lat": "45.115566",
        "long": "26.15775"
      },
      {
        "name": "PODU LUNG",
        "zip": "105702",
        "lat": "45.225242",
        "long": "25.649642"
      },
      {
        "name": "PODU URSULUI",
        "zip": "107653",
        "lat": "45.17398",
        "long": "25.92252"
      },
      {
        "name": "PODU VADULUI",
        "zip": "105408",
        "lat": "45.150054",
        "long": "25.690927"
      },
      {
        "name": "PODU VALENI",
        "zip": "107434",
        "lat": "44.746574",
        "long": "25.978481"
      },
      {
        "name": "PODURILE",
        "zip": "107202",
        "lat": "45.276784",
        "long": "26.055885"
      },
      {
        "name": "POIANA",
        "zip": "105703",
        "lat": "45.239366",
        "long": "25.649805"
      },
      {
        "name": "POIANA CAMPINA",
        "zip": "107425",
        "lat": "45.129053",
        "long": "25.713026"
      },
      {
        "name": "POIANA COPACENI",
        "zip": "107309",
        "lat": "45.163991",
        "long": "26.069112"
      },
      {
        "name": "POIANA MARE",
        "zip": "107539",
        "lat": "45.323111",
        "long": "26.123207"
      },
      {
        "name": "POIANA MIERLEI",
        "zip": "107203",
        "lat": "45.266131",
        "long": "26.110246"
      },
      {
        "name": "POIANA TAPULUI",
        "zip": "105550",
        "lat": "45.384863",
        "long": "25.544084"
      },
      {
        "name": "POIANA TRESTIEI",
        "zip": "107189",
        "lat": "45.159834",
        "long": "25.871949"
      },
      {
        "name": "POIANA VARBILAU",
        "zip": "107654",
        "lat": "45.152179",
        "long": "25.989218"
      },
      {
        "name": "POIENARII APOSTOLI",
        "zip": "107278",
        "lat": "44.771962",
        "long": "26.053074"
      },
      {
        "name": "POIENARII BURCHII",
        "zip": "107430",
        "lat": "44.760758",
        "long": "26.003988"
      },
      {
        "name": "POIENARII VECHI",
        "zip": "107436",
        "lat": "44.752844",
        "long": "26.061995"
      },
      {
        "name": "POIENARII-RALI",
        "zip": "107437",
        "lat": "44.746902",
        "long": "26.046249"
      },
      {
        "name": "POIENILE",
        "zip": "107462",
        "lat": "45.174785",
        "long": "26.114235"
      },
      {
        "name": "POPESTI",
        "zip": "107087",
        "lat": "44.859835",
        "long": "25.994878"
      },
      {
        "name": "POPESTI",
        "zip": "107416",
        "lat": "45.110269",
        "long": "26.232208"
      },
      {
        "name": "POSADA",
        "zip": "105704",
        "lat": "45.286751",
        "long": "25.61791"
      },
      {
        "name": "POSESTII-PAMANTENI",
        "zip": "107446",
        "lat": "45.271017",
        "long": "26.147584"
      },
      {
        "name": "POSESTII-UNGURENI",
        "zip": "107447",
        "lat": "45.276746",
        "long": "26.141558"
      },
      {
        "name": "POTIGRAFU",
        "zip": "107280",
        "lat": "44.782986",
        "long": "26.099005"
      },
      {
        "name": "PRAJANI",
        "zip": "106202",
        "lat": "45.206028",
        "long": "25.950087"
      },
      {
        "name": "PREDEAL",
        "zip": "107463",
        "lat": "45.187965",
        "long": "26.100797"
      },
      {
        "name": "PREDESTI",
        "zip": "107612",
        "lat": "44.802556",
        "long": "25.994235"
      },
      {
        "name": "PRISEACA",
        "zip": "107293",
        "lat": "45.104426",
        "long": "26.246082"
      },
      {
        "name": "PROVITA DE JOS",
        "zip": "107475",
        "lat": "45.119895",
        "long": "25.669951"
      },
      {
        "name": "PROVITA DE SUS",
        "zip": "107480",
        "lat": "45.136568",
        "long": "25.636964"
      },
      {
        "name": "PUCHENII MARI",
        "zip": "107485",
        "lat": "44.824154",
        "long": "26.081646"
      },
      {
        "name": "PUCHENII MICI",
        "zip": "107491",
        "lat": "44.826925",
        "long": "26.056615"
      },
      {
        "name": "PUCHENII-MOSNENI",
        "zip": "107492",
        "lat": "44.811387",
        "long": "26.084984"
      },
      {
        "name": "PUSCASI",
        "zip": "107057",
        "lat": "44.850587",
        "long": "26.092184"
      },
      {
        "name": "RACHIERI",
        "zip": "107626",
        "lat": "44.960822",
        "long": "26.135455"
      },
      {
        "name": "RADILA",
        "zip": "107627",
        "lat": "44.92345",
        "long": "26.17254"
      },
      {
        "name": "RAFOV",
        "zip": "107495",
        "lat": "44.873425",
        "long": "26.13272"
      },
      {
        "name": "RAGMAN",
        "zip": "107428",
        "lat": "45.141018",
        "long": "25.695286"
      },
      {
        "name": "RAHOVA",
        "zip": "107417",
        "lat": "45.091246",
        "long": "26.203832"
      },
      {
        "name": "ROMANESTI",
        "zip": "107058",
        "lat": "44.858606",
        "long": "26.070913"
      },
      {
        "name": "ROTAREA",
        "zip": "107541",
        "lat": "45.312935",
        "long": "26.216986"
      },
      {
        "name": "ROTARI",
        "zip": "107128",
        "lat": "45.055229",
        "long": "26.294224"
      },
      {
        "name": "SALCIA",
        "zip": "107505",
        "lat": "45.182922",
        "long": "26.32542"
      },
      {
        "name": "SALCIILE",
        "zip": "107510",
        "lat": "44.81651",
        "long": "26.492457"
      },
      {
        "name": "SALCIOARA",
        "zip": "107418",
        "lat": "45.104037",
        "long": "26.187981"
      },
      {
        "name": "SANGERU",
        "zip": "107515",
        "lat": "45.130614",
        "long": "26.337037"
      },
      {
        "name": "SARARI",
        "zip": "107464",
        "lat": "45.197861",
        "long": "26.132789"
      },
      {
        "name": "SARATEL",
        "zip": "107466",
        "lat": "45.176324",
        "long": "26.097922"
      },
      {
        "name": "SARCA",
        "zip": "107529",
        "lat": "45.083518",
        "long": "25.865767"
      },
      {
        "name": "SATU DE SUS",
        "zip": "107388",
        "lat": "44.845401",
        "long": "25.895021"
      },
      {
        "name": "SATU NOU",
        "zip": "107039",
        "lat": "44.957562",
        "long": "26.530766"
      },
      {
        "name": "SATU NOU",
        "zip": "107341",
        "lat": "45.066274",
        "long": "26.041005"
      },
      {
        "name": "SATUCU",
        "zip": "107618",
        "lat": "44.954813",
        "long": "26.295846"
      },
      {
        "name": "SCHELA",
        "zip": "105203",
        "lat": "45.032738",
        "long": "25.83985"
      },
      {
        "name": "SCHIAU",
        "zip": "106308",
        "lat": "44.978611",
        "long": "26.233056"
      },
      {
        "name": "SCHIAU",
        "zip": "107628",
        "lat": "44.990033",
        "long": "26.18646"
      },
      {
        "name": "SCHIULESTI",
        "zip": "107326",
        "lat": "45.284705",
        "long": "25.954026"
      },
      {
        "name": "SCORTENI",
        "zip": "107525",
        "lat": "45.092912",
        "long": "25.849379"
      },
      {
        "name": "SCURTESTI",
        "zip": "107576",
        "lat": "45.245675",
        "long": "25.893846"
      },
      {
        "name": "SECARIA",
        "zip": "107530",
        "lat": "45.274389",
        "long": "25.684515"
      },
      {
        "name": "SECIU",
        "zip": "105301",
        "lat": "45.033033",
        "long": "26.056588"
      },
      {
        "name": "SECIURI",
        "zip": "107569",
        "lat": "45.231938",
        "long": "25.727349"
      },
      {
        "name": "SFACARU",
        "zip": "107419",
        "lat": "45.107851",
        "long": "26.166137"
      },
      {
        "name": "SFARLEANCA",
        "zip": "107236",
        "lat": "45.092584",
        "long": "26.009907"
      },
      {
        "name": "SICRITA",
        "zip": "107504",
        "lat": "44.83603",
        "long": "26.193766"
      },
      {
        "name": "SILISTEA",
        "zip": "107587",
        "lat": "45.106338",
        "long": "26.293962"
      },
      {
        "name": "SILISTEA DEALULUI",
        "zip": "107248",
        "lat": "45.015476",
        "long": "25.713669"
      },
      {
        "name": "SINAIA",
        "zip": "106100",
        "lat": "45.345661",
        "long": "25.547928"
      },
      {
        "name": "SIPOTU",
        "zip": "107342",
        "lat": "45.04076",
        "long": "26.017138"
      },
      {
        "name": "SIRNA",
        "zip": "107550",
        "lat": "44.801459",
        "long": "25.961918"
      },
      {
        "name": "SLANIC",
        "zip": "106200",
        "lat": "45.235778",
        "long": "25.939909"
      },
      {
        "name": "SLAVU",
        "zip": "107399",
        "lat": "45.159956",
        "long": "26.124372"
      },
      {
        "name": "SLON",
        "zip": "107141",
        "lat": "45.355213",
        "long": "26.041892"
      },
      {
        "name": "SOIMARI",
        "zip": "107560",
        "lat": "45.176007",
        "long": "26.211057"
      },
      {
        "name": "SOIMESTI",
        "zip": "107129",
        "lat": "45.044932",
        "long": "26.306388"
      },
      {
        "name": "SOTRILE",
        "zip": "107565",
        "lat": "45.211867",
        "long": "25.716937"
      },
      {
        "name": "STANCESTI",
        "zip": "107591",
        "lat": "44.855245",
        "long": "25.914489"
      },
      {
        "name": "STARCHIOJD",
        "zip": "107535",
        "lat": "45.322763",
        "long": "26.188097"
      },
      {
        "name": "STEFESTI",
        "zip": "107575",
        "lat": "45.233257",
        "long": "25.903631"
      },
      {
        "name": "STEJARU",
        "zip": "107088",
        "lat": "44.837792",
        "long": "25.960621"
      },
      {
        "name": "STOENESTI",
        "zip": "107028",
        "lat": "44.923147",
        "long": "25.857968"
      },
      {
        "name": "STRAOSTI",
        "zip": "107313",
        "lat": "45.04087",
        "long": "26.224002"
      },
      {
        "name": "STREJNICU",
        "zip": "107592",
        "lat": "44.917499",
        "long": "25.956299"
      },
      {
        "name": "STUBEIU",
        "zip": "107598",
        "lat": "45.21874",
        "long": "26.013096"
      },
      {
        "name": "SURANI",
        "zip": "107545",
        "lat": "45.195026",
        "long": "26.188042"
      },
      {
        "name": "SURDESTI",
        "zip": "105409",
        "lat": "45.186998",
        "long": "25.626511"
      },
      {
        "name": "TALEA",
        "zip": "107580",
        "lat": "45.225297",
        "long": "25.567432"
      },
      {
        "name": "TANTARENI",
        "zip": "107072",
        "lat": "44.968356",
        "long": "26.033276"
      },
      {
        "name": "TARCULESTI",
        "zip": "107294",
        "lat": "45.069489",
        "long": "26.251468"
      },
      {
        "name": "TARGSORU NOU",
        "zip": "107029",
        "lat": "44.916446",
        "long": "25.881441"
      },
      {
        "name": "TARGSORU VECHI",
        "zip": "107590",
        "lat": "44.879019",
        "long": "25.921825"
      },
      {
        "name": "TARICENI",
        "zip": "107554",
        "lat": "44.795977",
        "long": "25.970054"
      },
      {
        "name": "TARLESTI",
        "zip": "107448",
        "lat": "45.251961",
        "long": "26.196484"
      },
      {
        "name": "TARSORENI",
        "zip": "107577",
        "lat": "45.256814",
        "long": "25.883654"
      },
      {
        "name": "TATARAI",
        "zip": "107438",
        "lat": "44.737461",
        "long": "25.929854"
      },
      {
        "name": "TATARANI",
        "zip": "107059",
        "lat": "44.893058",
        "long": "26.034843"
      },
      {
        "name": "TATARU",
        "zip": "107585",
        "lat": "45.098578",
        "long": "26.347499"
      },
      {
        "name": "TEISANI",
        "zip": "107595",
        "lat": "45.237849",
        "long": "26.013162"
      },
      {
        "name": "TELEGA",
        "zip": "107600",
        "lat": "45.140056",
        "long": "25.788546"
      },
      {
        "name": "TESILA",
        "zip": "107645",
        "lat": "45.303312",
        "long": "25.722709"
      },
      {
        "name": "TINOSU",
        "zip": "107610",
        "lat": "44.816915",
        "long": "26.016569"
      },
      {
        "name": "TINTEA",
        "zip": "105250",
        "lat": "45.034618",
        "long": "25.910869"
      },
      {
        "name": "TIPARESTI",
        "zip": "107167",
        "lat": "45.083516",
        "long": "25.954337"
      },
      {
        "name": "TISA",
        "zip": "107521",
        "lat": "45.134137",
        "long": "26.324527"
      },
      {
        "name": "TOHANI",
        "zip": "107302",
        "lat": "45.064306",
        "long": "26.433487"
      },
      {
        "name": "TOMSANI",
        "zip": "107615",
        "lat": "44.939786",
        "long": "26.294402"
      },
      {
        "name": "TONTESTI",
        "zip": "107606",
        "lat": "45.126224",
        "long": "25.833014"
      },
      {
        "name": "TRAISTENI",
        "zip": "107641",
        "lat": "45.338393",
        "long": "25.726601"
      },
      {
        "name": "TRENU",
        "zip": "107152",
        "lat": "45.185498",
        "long": "26.269804"
      },
      {
        "name": "TRESTIENII DE JOS",
        "zip": "107223",
        "lat": "44.864372",
        "long": "26.232119"
      },
      {
        "name": "TRESTIENII DE SUS",
        "zip": "107224",
        "lat": "44.880657",
        "long": "26.220589"
      },
      {
        "name": "TRESTIOARA",
        "zip": "107657",
        "lat": "45.142474",
        "long": "25.945925"
      },
      {
        "name": "TUFANI",
        "zip": "107217",
        "lat": "44.798551",
        "long": "26.324943"
      },
      {
        "name": "TUFENI",
        "zip": "105204",
        "lat": "45.058434",
        "long": "25.835341"
      },
      {
        "name": "TULBUREA",
        "zip": "107467",
        "lat": "45.205558",
        "long": "26.114193"
      },
      {
        "name": "TULBUREA-VALENI",
        "zip": "107468",
        "lat": "45.199435",
        "long": "26.108871"
      },
      {
        "name": "UDRESTI",
        "zip": "107023",
        "lat": "45.115501",
        "long": "26.286048"
      },
      {
        "name": "ULMI",
        "zip": "106309",
        "lat": "44.954722",
        "long": "26.255278"
      },
      {
        "name": "UNGURENI",
        "zip": "107254",
        "lat": "44.943196",
        "long": "25.805573"
      },
      {
        "name": "UNGURENI",
        "zip": "107243",
        "lat": "45.033648",
        "long": "26.384712"
      },
      {
        "name": "UNGURENI",
        "zip": "107272",
        "lat": "44.797225",
        "long": "26.287261"
      },
      {
        "name": "URLATI",
        "zip": "106300",
        "lat": "44.991969",
        "long": "26.232683"
      },
      {
        "name": "URLETA",
        "zip": "107051",
        "lat": "45.086003",
        "long": "25.794693"
      },
      {
        "name": "VADU PARULUI",
        "zip": "107013",
        "lat": "44.930754",
        "long": "26.209632"
      },
      {
        "name": "VADU SAPAT",
        "zip": "107244",
        "lat": "45.039471",
        "long": "26.385538"
      },
      {
        "name": "VALCANESTI",
        "zip": "107655",
        "lat": "45.120544",
        "long": "25.933497"
      },
      {
        "name": "VALCELELE",
        "zip": "107173",
        "lat": "44.939682",
        "long": "26.375423"
      },
      {
        "name": "VALEA ANEI",
        "zip": "107542",
        "lat": "45.312057",
        "long": "26.196665"
      },
      {
        "name": "VALEA BOBULUI",
        "zip": "106310",
        "lat": "45.004955",
        "long": "26.232933"
      },
      {
        "name": "VALEA BORULUI",
        "zip": "107142",
        "lat": "45.305842",
        "long": "26.037602"
      },
      {
        "name": "VALEA BRADETULUI",
        "zip": "107143",
        "lat": "45.325155",
        "long": "26.034806"
      },
      {
        "name": "VALEA BRADULUI",
        "zip": "107483",
        "lat": "45.165012",
        "long": "25.61156"
      },
      {
        "name": "VALEA CALUGAREASCA",
        "zip": "107620",
        "lat": "44.962933",
        "long": "26.1491"
      },
      {
        "name": "VALEA CRANGULUI",
        "zip": "106311",
        "lat": "44.993855",
        "long": "26.259341"
      },
      {
        "name": "VALEA CRICOVULUI",
        "zip": "107024",
        "lat": "45.115599",
        "long": "26.248164"
      },
      {
        "name": "VALEA CUCULUI",
        "zip": "107314",
        "lat": "45.065304",
        "long": "26.226585"
      },
      {
        "name": "VALEA DULCE",
        "zip": "107421",
        "lat": "45.114281",
        "long": "26.207872"
      },
      {
        "name": "VALEA LARGA",
        "zip": "107629",
        "lat": "44.968575",
        "long": "26.19539"
      },
      {
        "name": "VALEA LESPEZII",
        "zip": "107144",
        "lat": "45.332813",
        "long": "26.041802"
      },
      {
        "name": "VALEA MANTEI",
        "zip": "107631",
        "lat": "44.976359",
        "long": "26.161551"
      },
      {
        "name": "VALEA MIEILOR",
        "zip": "106312",
        "lat": "44.97444",
        "long": "26.233651"
      },
      {
        "name": "VALEA NICOVANI",
        "zip": "107632",
        "lat": "44.959709",
        "long": "26.192312"
      },
      {
        "name": "VALEA NUCETULUI",
        "zip": "106313",
        "lat": "45.010134",
        "long": "26.259595"
      },
      {
        "name": "VALEA OPRII",
        "zip": "107177",
        "lat": "45.165658",
        "long": "25.713849"
      },
      {
        "name": "VALEA ORLEI",
        "zip": "107114",
        "lat": "44.978065",
        "long": "26.129336"
      },
      {
        "name": "VALEA PIETREI",
        "zip": "106314",
        "lat": "45.014599",
        "long": "26.230098"
      },
      {
        "name": "VALEA PLOPULUI",
        "zip": "107449",
        "lat": "45.293941",
        "long": "26.161319"
      },
      {
        "name": "VALEA POIENII",
        "zip": "107633",
        "lat": "44.969789",
        "long": "26.168414"
      },
      {
        "name": "VALEA POPII",
        "zip": "107634",
        "lat": "44.964151",
        "long": "26.129604"
      },
      {
        "name": "VALEA SCHEILOR",
        "zip": "107116",
        "lat": "45.070895",
        "long": "26.400568"
      },
      {
        "name": "VALEA SCREZII",
        "zip": "107451",
        "lat": "45.294194",
        "long": "26.182455"
      },
      {
        "name": "VALEA SEACA",
        "zip": "107296",
        "lat": "45.103351",
        "long": "26.266341"
      },
      {
        "name": "VALEA SEMAN",
        "zip": "106315",
        "lat": "45.01294",
        "long": "26.294274"
      },
      {
        "name": "VALEA STALPULUI",
        "zip": "107599",
        "lat": "45.213645",
        "long": "26.024161"
      },
      {
        "name": "VALEA STUPINII",
        "zip": "107452",
        "lat": "45.265023",
        "long": "26.1366"
      },
      {
        "name": "VALEA TARSEI",
        "zip": "105410",
        "lat": "45.177102",
        "long": "25.633463"
      },
      {
        "name": "VALEA TOCII",
        "zip": "107146",
        "lat": "45.318817",
        "long": "26.032954"
      },
      {
        "name": "VALEA UNGHIULUI",
        "zip": "107333",
        "lat": "45.122702",
        "long": "26.421887"
      },
      {
        "name": "VALEA URLOII",
        "zip": "106316",
        "lat": "45.00974",
        "long": "26.283609"
      },
      {
        "name": "VALEA URSOII",
        "zip": "107636",
        "lat": "44.958256",
        "long": "26.200756"
      },
      {
        "name": "VALENII DE MUNTE",
        "zip": "106400",
        "lat": "45.184782",
        "long": "26.038971"
      },
      {
        "name": "VARBILA",
        "zip": "107316",
        "lat": "45.045615",
        "long": "26.191872"
      },
      {
        "name": "VARBILAU",
        "zip": "107650",
        "lat": "45.182041",
        "long": "25.960228"
      },
      {
        "name": "VARFURILE",
        "zip": "107637",
        "lat": "44.988855",
        "long": "26.15392"
      },
      {
        "name": "VARNITA",
        "zip": "107556",
        "lat": "44.807177",
        "long": "25.944512"
      },
      {
        "name": "VISTIERU",
        "zip": "107571",
        "lat": "45.222735",
        "long": "25.701285"
      },
      {
        "name": "VITIOARA DE SUS",
        "zip": "107469",
        "lat": "45.172711",
        "long": "26.088174"
      },
      {
        "name": "ZAHANAUA",
        "zip": "107593",
        "lat": "44.875341",
        "long": "25.940058"
      },
      {
        "name": "ZALHANAUA",
        "zip": "107389",
        "lat": "44.901581",
        "long": "25.828827"
      },
      {
        "name": "ZAMBROAIA",
        "zip": "107471",
        "lat": "45.200819",
        "long": "26.124268"
      },
      {
        "name": "ZAMFIRA",
        "zip": "107343",
        "lat": "45.068288",
        "long": "26.008559"
      },
      {
        "name": "ZANOAGA",
        "zip": "107226",
        "lat": "44.866967",
        "long": "26.163751"
      },
      {
        "name": "ZMEURET",
        "zip": "107543",
        "lat": "45.330998",
        "long": "26.164833"
      }
    ],
    "SĂLAJ": [
      {
        "name": "ADALIN",
        "zip": "457131",
        "lat": "47.013027",
        "long": "23.43763"
      },
      {
        "name": "AGHIRES",
        "zip": "457246",
        "lat": "47.16164",
        "long": "23.017636"
      },
      {
        "name": "AGRIJ",
        "zip": "457005",
        "lat": "47.067116",
        "long": "23.101047"
      },
      {
        "name": "ALEUS",
        "zip": "457161",
        "lat": "47.146993",
        "long": "22.630961"
      },
      {
        "name": "ALMASU",
        "zip": "457010",
        "lat": "46.945452",
        "long": "23.132898"
      },
      {
        "name": "ALUNIS",
        "zip": "457036",
        "lat": "47.385209",
        "long": "23.276185"
      },
      {
        "name": "ARCHID",
        "zip": "457081",
        "lat": "47.345188",
        "long": "23.013529"
      },
      {
        "name": "BABENI",
        "zip": "457020",
        "lat": "47.301196",
        "long": "23.40357"
      },
      {
        "name": "BABIU",
        "zip": "457011",
        "lat": "46.946039",
        "long": "23.062866"
      },
      {
        "name": "BADACIN",
        "zip": "457266",
        "lat": "47.25595",
        "long": "22.854562"
      },
      {
        "name": "BADON",
        "zip": "457166",
        "lat": "47.250011",
        "long": "22.977968"
      },
      {
        "name": "BAICA",
        "zip": "457176",
        "lat": "47.076937",
        "long": "23.30186"
      },
      {
        "name": "BALAN",
        "zip": "457025",
        "lat": "47.154659",
        "long": "23.307559"
      },
      {
        "name": "BAN",
        "zip": "457031",
        "lat": "47.092715",
        "long": "22.804082"
      },
      {
        "name": "BANISOR",
        "zip": "457030",
        "lat": "47.105109",
        "long": "22.839093"
      },
      {
        "name": "BARSA",
        "zip": "457311",
        "lat": "47.325266",
        "long": "23.210448"
      },
      {
        "name": "BARSAU MARE",
        "zip": "457141",
        "lat": "47.271749",
        "long": "23.663308"
      },
      {
        "name": "BARSAUTA",
        "zip": "457191",
        "lat": "47.346383",
        "long": "23.694879"
      },
      {
        "name": "BENESAT",
        "zip": "457035",
        "lat": "47.412111",
        "long": "23.292136"
      },
      {
        "name": "BERCEA",
        "zip": "457306",
        "lat": "47.024829",
        "long": "23.186892"
      },
      {
        "name": "BEZDED",
        "zip": "457151",
        "lat": "47.156067",
        "long": "23.478245"
      },
      {
        "name": "BIC",
        "zip": "455301",
        "lat": "47.191652",
        "long": "22.82611"
      },
      {
        "name": "BILGHEZ",
        "zip": "457261",
        "lat": "47.229653",
        "long": "22.710641"
      },
      {
        "name": "BIUSA",
        "zip": "457037",
        "lat": "47.423246",
        "long": "23.245039"
      },
      {
        "name": "BIZUSA-BAI",
        "zip": "457192",
        "lat": "47.342738",
        "long": "23.603683"
      },
      {
        "name": "BOBOTA",
        "zip": "457040",
        "lat": "47.382306",
        "long": "22.76678"
      },
      {
        "name": "BOCSA",
        "zip": "457045",
        "lat": "47.297825",
        "long": "22.916674"
      },
      {
        "name": "BOCSITA",
        "zip": "457167",
        "lat": "47.30558",
        "long": "23.050356"
      },
      {
        "name": "BODIA",
        "zip": "457051",
        "lat": "47.059798",
        "long": "23.067242"
      },
      {
        "name": "BOGDANA",
        "zip": "457052",
        "lat": "47.021496",
        "long": "23.003929"
      },
      {
        "name": "BOGHIS",
        "zip": "457262",
        "lat": "47.157087",
        "long": "22.734568"
      },
      {
        "name": "BORLA",
        "zip": "457046",
        "lat": "47.280053",
        "long": "22.939696"
      },
      {
        "name": "BORZA",
        "zip": "457091",
        "lat": "47.219798",
        "long": "23.273483"
      },
      {
        "name": "BOZIES",
        "zip": "457263",
        "lat": "47.157104",
        "long": "22.715313"
      },
      {
        "name": "BOZNA",
        "zip": "457341",
        "lat": "47.083023",
        "long": "23.095507"
      },
      {
        "name": "BRAGLEZ",
        "zip": "457316",
        "lat": "47.217992",
        "long": "23.377281"
      },
      {
        "name": "BREBI",
        "zip": "457092",
        "lat": "47.207752",
        "long": "23.196897"
      },
      {
        "name": "BRUSTURI",
        "zip": "457093",
        "lat": "47.160246",
        "long": "23.225374"
      },
      {
        "name": "BUCIUMI",
        "zip": "457050",
        "lat": "47.044664",
        "long": "23.048578"
      },
      {
        "name": "BULGARI",
        "zip": "457296",
        "lat": "47.341627",
        "long": "23.134497"
      },
      {
        "name": "BUZAS",
        "zip": "457291",
        "lat": "47.306933",
        "long": "23.579124"
      },
      {
        "name": "CALACEA",
        "zip": "457152",
        "lat": "47.118389",
        "long": "23.447454"
      },
      {
        "name": "CAMAR",
        "zip": "457060",
        "lat": "47.298429",
        "long": "22.620302"
      },
      {
        "name": "CAMPIA",
        "zip": "457047",
        "lat": "47.314992",
        "long": "22.887893"
      },
      {
        "name": "CAPALNA",
        "zip": "457142",
        "lat": "47.252763",
        "long": "23.735039"
      },
      {
        "name": "CARASTELEC",
        "zip": "457065",
        "lat": "47.299896",
        "long": "22.69821"
      },
      {
        "name": "CEACA",
        "zip": "457361",
        "lat": "47.196813",
        "long": "23.559523"
      },
      {
        "name": "CEHEI",
        "zip": "455302",
        "lat": "47.25632",
        "long": "22.775067"
      },
      {
        "name": "CEHU SILVANIEI",
        "zip": "455100",
        "lat": "47.411184",
        "long": "23.182291"
      },
      {
        "name": "CERISA",
        "zip": "457162",
        "lat": "47.181476",
        "long": "22.566883"
      },
      {
        "name": "CERNUC",
        "zip": "457153",
        "lat": "47.135279",
        "long": "23.473651"
      },
      {
        "name": "CHECHIS",
        "zip": "457026",
        "lat": "47.174811",
        "long": "23.30996"
      },
      {
        "name": "CHENDREA",
        "zip": "457027",
        "lat": "47.122359",
        "long": "23.299044"
      },
      {
        "name": "CHENDREMAL",
        "zip": "457371",
        "lat": "47.011423",
        "long": "23.263035"
      },
      {
        "name": "CHEUD",
        "zip": "457256",
        "lat": "47.383745",
        "long": "23.316117"
      },
      {
        "name": "CHICHISA",
        "zip": "457281",
        "lat": "47.134133",
        "long": "23.193826"
      },
      {
        "name": "CHIESD",
        "zip": "457070",
        "lat": "47.382884",
        "long": "22.888775"
      },
      {
        "name": "CHILIOARA",
        "zip": "457082",
        "lat": "47.331448",
        "long": "23.031918"
      },
      {
        "name": "CHIZENI",
        "zip": "457143",
        "lat": "47.27661",
        "long": "23.639643"
      },
      {
        "name": "CIGLEAN",
        "zip": "457094",
        "lat": "47.223241",
        "long": "23.244555"
      },
      {
        "name": "CIOCMANI",
        "zip": "457021",
        "lat": "47.289204",
        "long": "23.351042"
      },
      {
        "name": "CIULA",
        "zip": "457216",
        "lat": "47.340068",
        "long": "23.414845"
      },
      {
        "name": "CIUMARNA",
        "zip": "457282",
        "lat": "47.124133",
        "long": "23.132467"
      },
      {
        "name": "CIURENI",
        "zip": "457362",
        "lat": "47.201604",
        "long": "23.539206"
      },
      {
        "name": "CIZER",
        "zip": "457075",
        "lat": "47.067317",
        "long": "22.86185"
      },
      {
        "name": "CLIT",
        "zip": "457022",
        "lat": "47.297052",
        "long": "23.429982"
      },
      {
        "name": "COLONIA SIGHETU SILVANIEI",
        "zip": "457071",
        "lat": "47.362699",
        "long": "22.913897"
      },
      {
        "name": "CORMENIS",
        "zip": "457226",
        "lat": "47.351994",
        "long": "23.516747"
      },
      {
        "name": "COSEIU",
        "zip": "457080",
        "lat": "47.31903",
        "long": "22.992999"
      },
      {
        "name": "COSNICIU DE JOS",
        "zip": "457211",
        "lat": "47.206351",
        "long": "22.615915"
      },
      {
        "name": "COSNICIU DE SUS",
        "zip": "457212",
        "lat": "47.19462",
        "long": "22.590612"
      },
      {
        "name": "COZLA",
        "zip": "457217",
        "lat": "47.350325",
        "long": "23.380561"
      },
      {
        "name": "CRASNA",
        "zip": "457085",
        "lat": "47.162923",
        "long": "22.86778"
      },
      {
        "name": "CREACA",
        "zip": "457090",
        "lat": "47.19682",
        "long": "23.234198"
      },
      {
        "name": "CRISENI",
        "zip": "457105",
        "lat": "47.232696",
        "long": "23.047091"
      },
      {
        "name": "CRISTELEC",
        "zip": "457236",
        "lat": "47.263751",
        "long": "22.72317"
      },
      {
        "name": "CRISTOLT",
        "zip": "457100",
        "lat": "47.208481",
        "long": "23.437469"
      },
      {
        "name": "CRISTOLTEL",
        "zip": "457317",
        "lat": "47.244381",
        "long": "23.404703"
      },
      {
        "name": "CRISTUR-CRISENI",
        "zip": "457106",
        "lat": "47.260363",
        "long": "23.095467"
      },
      {
        "name": "CUBLESU",
        "zip": "457111",
        "lat": "46.932598",
        "long": "23.317823"
      },
      {
        "name": "CUCEU",
        "zip": "455201",
        "lat": "47.26661",
        "long": "23.19483"
      },
      {
        "name": "CUCIULAT",
        "zip": "457218",
        "lat": "47.324007",
        "long": "23.421938"
      },
      {
        "name": "CUTIS",
        "zip": "457012",
        "lat": "46.951324",
        "long": "23.018035"
      },
      {
        "name": "CUZAPLAC",
        "zip": "457110",
        "lat": "46.966119",
        "long": "23.191582"
      },
      {
        "name": "DABACENI",
        "zip": "457193",
        "lat": "47.302951",
        "long": "23.601106"
      },
      {
        "name": "DEJA",
        "zip": "457297",
        "lat": "47.354816",
        "long": "23.181892"
      },
      {
        "name": "DELENI",
        "zip": "457121",
        "lat": "47.321107",
        "long": "23.090833"
      },
      {
        "name": "DERSIDA",
        "zip": "457041",
        "lat": "47.388102",
        "long": "22.801699"
      },
      {
        "name": "DIOSOD",
        "zip": "457168",
        "lat": "47.292376",
        "long": "23.020988"
      },
      {
        "name": "DOBA",
        "zip": "457122",
        "lat": "47.292794",
        "long": "23.091606"
      },
      {
        "name": "DOBRIN",
        "zip": "457120",
        "lat": "47.295353",
        "long": "23.13194"
      },
      {
        "name": "DOBROCINA",
        "zip": "457144",
        "lat": "47.263829",
        "long": "23.717056"
      },
      {
        "name": "DOH",
        "zip": "457237",
        "lat": "47.329776",
        "long": "22.718576"
      },
      {
        "name": "DOLHENI",
        "zip": "457194",
        "lat": "47.361475",
        "long": "23.656176"
      },
      {
        "name": "DOLU",
        "zip": "457372",
        "lat": "46.987205",
        "long": "23.326021"
      },
      {
        "name": "DOMNIN",
        "zip": "457312",
        "lat": "47.333797",
        "long": "23.1892"
      },
      {
        "name": "DRAGU",
        "zip": "457130",
        "lat": "47.03522",
        "long": "23.399205"
      },
      {
        "name": "DRIGHIU",
        "zip": "457163",
        "lat": "47.162854",
        "long": "22.649749"
      },
      {
        "name": "DUMUSLAU",
        "zip": "457066",
        "lat": "47.343739",
        "long": "22.675514"
      },
      {
        "name": "FABRICA",
        "zip": "457154",
        "lat": "47.200824",
        "long": "23.392881"
      },
      {
        "name": "FAGETU",
        "zip": "457271",
        "lat": "47.096203",
        "long": "22.58391"
      },
      {
        "name": "FALCUSA",
        "zip": "457276",
        "lat": "47.278911",
        "long": "23.780114"
      },
      {
        "name": "FANTANELE",
        "zip": "457132",
        "lat": "47.065122",
        "long": "23.413071"
      },
      {
        "name": "FANTANELE-RUS",
        "zip": "457292",
        "lat": "47.251961",
        "long": "23.558691"
      },
      {
        "name": "FETINDIA",
        "zip": "457247",
        "lat": "47.141365",
        "long": "23.015336"
      },
      {
        "name": "FILDU DE JOS",
        "zip": "457135",
        "lat": "46.91902",
        "long": "23.057995"
      },
      {
        "name": "FILDU DE MIJLOC",
        "zip": "457136",
        "lat": "46.923722",
        "long": "22.99674"
      },
      {
        "name": "FILDU DE SUS",
        "zip": "457137",
        "lat": "46.933187",
        "long": "22.963758"
      },
      {
        "name": "FIRMINIS",
        "zip": "457251",
        "lat": "47.245942",
        "long": "23.136502"
      },
      {
        "name": "FIZES",
        "zip": "457301",
        "lat": "47.094206",
        "long": "22.763082"
      },
      {
        "name": "FODORA",
        "zip": "457146",
        "lat": "47.264515",
        "long": "23.675779"
      },
      {
        "name": "FRANCENII DE PIATRA",
        "zip": "457147",
        "lat": "47.321346",
        "long": "23.674863"
      },
      {
        "name": "FUFEZ",
        "zip": "457164",
        "lat": "47.157518",
        "long": "22.540869"
      },
      {
        "name": "GALASENI",
        "zip": "457112",
        "lat": "46.893831",
        "long": "23.17785"
      },
      {
        "name": "GALGAU",
        "zip": "457140",
        "lat": "47.281829",
        "long": "23.701567"
      },
      {
        "name": "GALGAU ALMASULUI",
        "zip": "457029",
        "lat": "47.197644",
        "long": "23.327141"
      },
      {
        "name": "GALPAIA",
        "zip": "457028",
        "lat": "47.132008",
        "long": "23.248665"
      },
      {
        "name": "GARBOU",
        "zip": "457150",
        "lat": "47.160616",
        "long": "23.417544"
      },
      {
        "name": "GARCEIU",
        "zip": "457107",
        "lat": "47.256696",
        "long": "23.06425"
      },
      {
        "name": "GIURTELECU SIMLEULUI",
        "zip": "457238",
        "lat": "47.296797",
        "long": "22.795567"
      },
      {
        "name": "GLOD",
        "zip": "457148",
        "lat": "47.290379",
        "long": "23.652265"
      },
      {
        "name": "GOSTILA",
        "zip": "457277",
        "lat": "47.324493",
        "long": "23.803149"
      },
      {
        "name": "GURA VLADESEI",
        "zip": "457149",
        "lat": "47.265901",
        "long": "23.723807"
      },
      {
        "name": "GURUSLAU",
        "zip": "457169",
        "lat": "47.27888",
        "long": "22.979246"
      },
      {
        "name": "HALMASD",
        "zip": "457160",
        "lat": "47.157492",
        "long": "22.590791"
      },
      {
        "name": "HASMAS",
        "zip": "457293",
        "lat": "47.191549",
        "long": "23.607217"
      },
      {
        "name": "HERECLEAN",
        "zip": "457165",
        "lat": "47.246446",
        "long": "23.014755"
      },
      {
        "name": "HIDA",
        "zip": "457175",
        "lat": "47.061743",
        "long": "23.309436"
      },
      {
        "name": "HOROATU CEHULUI",
        "zip": "455101",
        "lat": "47.403816",
        "long": "23.243089"
      },
      {
        "name": "HOROATU CRASNEI",
        "zip": "457185",
        "lat": "47.125929",
        "long": "22.899034"
      },
      {
        "name": "HUREZ",
        "zip": "457186",
        "lat": "47.06551",
        "long": "22.914571"
      },
      {
        "name": "HUSENI",
        "zip": "457086",
        "lat": "47.183704",
        "long": "22.798499"
      },
      {
        "name": "HUSIA",
        "zip": "455202",
        "lat": "47.284433",
        "long": "23.294522"
      },
      {
        "name": "HUTA",
        "zip": "457053",
        "lat": "47.009301",
        "long": "22.948023"
      },
      {
        "name": "IAZ",
        "zip": "457272",
        "lat": "47.11929",
        "long": "22.688417"
      },
      {
        "name": "ILEANDA",
        "zip": "457190",
        "lat": "47.327253",
        "long": "23.615546"
      },
      {
        "name": "ILISUA",
        "zip": "457331",
        "lat": "47.29516",
        "long": "22.837101"
      },
      {
        "name": "INAU",
        "zip": "457313",
        "lat": "47.357294",
        "long": "23.267277"
      },
      {
        "name": "IP.",
        "zip": "457210",
        "lat": "47.229321",
        "long": "22.606204"
      },
      {
        "name": "JAC",
        "zip": "457096",
        "lat": "47.166263",
        "long": "23.197453"
      },
      {
        "name": "JEBUCU",
        "zip": "457013",
        "lat": "46.884196",
        "long": "23.105306"
      },
      {
        "name": "JIBOU",
        "zip": "455200",
        "lat": "47.260376",
        "long": "23.257888"
      },
      {
        "name": "LAZURI",
        "zip": "457346",
        "lat": "47.099136",
        "long": "22.751019"
      },
      {
        "name": "LEMNIU",
        "zip": "457219",
        "lat": "47.352438",
        "long": "23.485465"
      },
      {
        "name": "LESMIR",
        "zip": "457231",
        "lat": "47.256587",
        "long": "22.574737"
      },
      {
        "name": "LETCA",
        "zip": "457215",
        "lat": "47.334944",
        "long": "23.455413"
      },
      {
        "name": "LOMPIRT",
        "zip": "457332",
        "lat": "47.323021",
        "long": "22.845564"
      },
      {
        "name": "LOZNA",
        "zip": "457225",
        "lat": "47.321236",
        "long": "23.469784"
      },
      {
        "name": "LUMINISU",
        "zip": "457196",
        "lat": "47.361878",
        "long": "23.609354"
      },
      {
        "name": "LUPOAIA",
        "zip": "457097",
        "lat": "47.191099",
        "long": "23.251033"
      },
      {
        "name": "MAERISTE",
        "zip": "457235",
        "lat": "47.325511",
        "long": "22.793842"
      },
      {
        "name": "MAGURA",
        "zip": "457278",
        "lat": "47.315088",
        "long": "23.70559"
      },
      {
        "name": "MAL",
        "zip": "457302",
        "lat": "47.069795",
        "long": "22.814406"
      },
      {
        "name": "MALADIA",
        "zip": "457239",
        "lat": "47.298623",
        "long": "22.741859"
      },
      {
        "name": "MALENI",
        "zip": "457197",
        "lat": "47.358284",
        "long": "23.637035"
      },
      {
        "name": "MARCA",
        "zip": "457230",
        "lat": "47.214799",
        "long": "22.556155"
      },
      {
        "name": "MARCA-HUTA",
        "zip": "457232",
        "lat": "47.187905",
        "long": "22.500558"
      },
      {
        "name": "MARIN",
        "zip": "457087",
        "lat": "47.127535",
        "long": "22.810546"
      },
      {
        "name": "MESESENII DE JOS",
        "zip": "457245",
        "lat": "47.152982",
        "long": "22.947929"
      },
      {
        "name": "MESESENII DE SUS",
        "zip": "457248",
        "lat": "47.126721",
        "long": "22.984407"
      },
      {
        "name": "MESTEACANU",
        "zip": "457014",
        "lat": "46.965553",
        "long": "23.024041"
      },
      {
        "name": "MIERTA",
        "zip": "457113",
        "lat": "46.995914",
        "long": "23.180827"
      },
      {
        "name": "MILUANI",
        "zip": "457177",
        "lat": "47.014332",
        "long": "23.331522"
      },
      {
        "name": "MINEU",
        "zip": "457298",
        "lat": "47.345913",
        "long": "23.091966"
      },
      {
        "name": "MIRSID",
        "zip": "457250",
        "lat": "47.229788",
        "long": "23.119643"
      },
      {
        "name": "MOIAD",
        "zip": "457333",
        "lat": "47.340953",
        "long": "22.802008"
      },
      {
        "name": "MOIGRAD-POROLISSUM",
        "zip": "457252",
        "lat": "47.197017",
        "long": "23.143875"
      },
      {
        "name": "MOTIS",
        "zip": "455102",
        "lat": "47.42549",
        "long": "23.139109"
      },
      {
        "name": "MUNCEL",
        "zip": "457101",
        "lat": "47.224105",
        "long": "23.394516"
      },
      {
        "name": "NADIS",
        "zip": "455103",
        "lat": "47.377604",
        "long": "23.175369"
      },
      {
        "name": "NAIMON",
        "zip": "457123",
        "lat": "47.327439",
        "long": "23.117655"
      },
      {
        "name": "NAPRADEA",
        "zip": "457255",
        "lat": "47.364653",
        "long": "23.318505"
      },
      {
        "name": "NEGRENI",
        "zip": "457198",
        "lat": "47.342309",
        "long": "23.558892"
      },
      {
        "name": "NOTIG",
        "zip": "457299",
        "lat": "47.365177",
        "long": "23.216216"
      },
      {
        "name": "NUSFALAU",
        "zip": "457260",
        "lat": "47.199262",
        "long": "22.707423"
      },
      {
        "name": "PADURENI",
        "zip": "457061",
        "lat": "47.329125",
        "long": "22.624062"
      },
      {
        "name": "PADURIS",
        "zip": "457178",
        "lat": "47.097295",
        "long": "23.412791"
      },
      {
        "name": "PANIC",
        "zip": "457171",
        "lat": "47.205922",
        "long": "22.992781"
      },
      {
        "name": "PAUSA",
        "zip": "457283",
        "lat": "47.085523",
        "long": "23.148046"
      },
      {
        "name": "PECEIU",
        "zip": "457032",
        "lat": "47.12415",
        "long": "22.862375"
      },
      {
        "name": "PERICEI",
        "zip": "457265",
        "lat": "47.231402",
        "long": "22.86417"
      },
      {
        "name": "PERICEIU MIC",
        "zip": "457267",
        "lat": "47.240909",
        "long": "22.909332"
      },
      {
        "name": "PERII VADULUI",
        "zip": "457199",
        "lat": "47.352399",
        "long": "23.566613"
      },
      {
        "name": "PETRINDU",
        "zip": "457114",
        "lat": "46.919688",
        "long": "23.183067"
      },
      {
        "name": "PETRINZEL",
        "zip": "457016",
        "lat": "46.908775",
        "long": "23.144036"
      },
      {
        "name": "PIROSA",
        "zip": "457023",
        "lat": "47.317107",
        "long": "23.386292"
      },
      {
        "name": "PLESCA",
        "zip": "457076",
        "lat": "47.084423",
        "long": "22.891734"
      },
      {
        "name": "PLOPIS",
        "zip": "457270",
        "lat": "47.128212",
        "long": "22.654281"
      },
      {
        "name": "POARTA SALAJULUI",
        "zip": "457284",
        "lat": "47.08789",
        "long": "23.191213"
      },
      {
        "name": "PODISU",
        "zip": "457201",
        "lat": "47.319236",
        "long": "23.597469"
      },
      {
        "name": "POIANA BLENCHII",
        "zip": "457275",
        "lat": "47.306967",
        "long": "23.749221"
      },
      {
        "name": "POIANA MAGURA",
        "zip": "457334",
        "lat": "47.278804",
        "long": "22.808533"
      },
      {
        "name": "POIANA ONTII",
        "zip": "457102",
        "lat": "47.187542",
        "long": "23.47094"
      },
      {
        "name": "POIENITA",
        "zip": "457024",
        "lat": "47.310757",
        "long": "23.352553"
      },
      {
        "name": "POPENI",
        "zip": "457253",
        "lat": "47.250738",
        "long": "23.170613"
      },
      {
        "name": "POPTELEAC",
        "zip": "457156",
        "lat": "47.134595",
        "long": "23.414195"
      },
      {
        "name": "PORT",
        "zip": "457233",
        "lat": "47.229075",
        "long": "22.551977"
      },
      {
        "name": "PRELUCI",
        "zip": "457227",
        "lat": "47.310773",
        "long": "23.464342"
      },
      {
        "name": "PREOTEASA",
        "zip": "457347",
        "lat": "47.078713",
        "long": "22.731862"
      },
      {
        "name": "PRIA",
        "zip": "457077",
        "lat": "47.048782",
        "long": "22.890297"
      },
      {
        "name": "PRODANESTI",
        "zip": "457098",
        "lat": "47.219866",
        "long": "23.264762"
      },
      {
        "name": "PURCARET",
        "zip": "457221",
        "lat": "47.371948",
        "long": "23.437372"
      },
      {
        "name": "PUSTA",
        "zip": "455303",
        "lat": "47.245955",
        "long": "22.72374"
      },
      {
        "name": "RACAS",
        "zip": "457179",
        "lat": "47.104707",
        "long": "23.296043"
      },
      {
        "name": "RASTOCI",
        "zip": "457202",
        "lat": "47.359021",
        "long": "23.52751"
      },
      {
        "name": "RASTOLT",
        "zip": "457054",
        "lat": "47.030152",
        "long": "23.077081"
      },
      {
        "name": "RASTOLTU DESERT",
        "zip": "457006",
        "lat": "47.047727",
        "long": "23.137601"
      },
      {
        "name": "RATIN",
        "zip": "457088",
        "lat": "47.174158",
        "long": "22.833204"
      },
      {
        "name": "RATOVEI",
        "zip": "457348",
        "lat": "47.12917",
        "long": "22.766205"
      },
      {
        "name": "RECEA",
        "zip": "457356",
        "lat": "47.196049",
        "long": "22.946073"
      },
      {
        "name": "RECEA MICA",
        "zip": "457357",
        "lat": "47.18915",
        "long": "22.973223"
      },
      {
        "name": "ROGNA",
        "zip": "457203",
        "lat": "47.337236",
        "long": "23.592895"
      },
      {
        "name": "ROMANASI",
        "zip": "457280",
        "lat": "47.111719",
        "long": "23.183402"
      },
      {
        "name": "ROMITA",
        "zip": "457286",
        "lat": "47.144792",
        "long": "23.208687"
      },
      {
        "name": "RONA",
        "zip": "455203",
        "lat": "47.267917",
        "long": "23.288205"
      },
      {
        "name": "RUGINOASA",
        "zip": "457116",
        "lat": "46.933165",
        "long": "23.268882"
      },
      {
        "name": "RUS",
        "zip": "457290",
        "lat": "47.274055",
        "long": "23.594395"
      },
      {
        "name": "SAG",
        "zip": "457300",
        "lat": "47.078237",
        "long": "22.783149"
      },
      {
        "name": "SALAJENI",
        "zip": "457048",
        "lat": "47.320421",
        "long": "22.905396"
      },
      {
        "name": "SALATIG",
        "zip": "457295",
        "lat": "47.366023",
        "long": "23.139749"
      },
      {
        "name": "SAMSUD",
        "zip": "457325",
        "lat": "47.345799",
        "long": "22.953527"
      },
      {
        "name": "SANCRAIU ALMASULUI",
        "zip": "457373",
        "lat": "46.956089",
        "long": "23.348996"
      },
      {
        "name": "SANCRAIU SILVANIEI",
        "zip": "457124",
        "lat": "47.300364",
        "long": "23.135244"
      },
      {
        "name": "SANGEORGIU DE MESES",
        "zip": "457056",
        "lat": "47.0441",
        "long": "23.007468"
      },
      {
        "name": "SANMIHAIU ALMASULUI",
        "zip": "457305",
        "lat": "47.036311",
        "long": "23.269657"
      },
      {
        "name": "SANPETRU ALMASULUI",
        "zip": "457181",
        "lat": "47.08288",
        "long": "23.3387"
      },
      {
        "name": "SANTA MARIA",
        "zip": "457307",
        "lat": "47.040591",
        "long": "23.199967"
      },
      {
        "name": "SARBI",
        "zip": "457303",
        "lat": "47.066881",
        "long": "22.794404"
      },
      {
        "name": "SARMASAG",
        "zip": "457330",
        "lat": "47.345144",
        "long": "22.832005"
      },
      {
        "name": "SASA",
        "zip": "457204",
        "lat": "47.375628",
        "long": "23.639986"
      },
      {
        "name": "SEREDEIU",
        "zip": "457188",
        "lat": "47.110228",
        "long": "22.951667"
      },
      {
        "name": "SFARAS",
        "zip": "457017",
        "lat": "46.906029",
        "long": "23.096298"
      },
      {
        "name": "SICI",
        "zip": "457268",
        "lat": "47.257474",
        "long": "22.877709"
      },
      {
        "name": "SIGHETU SILVANIEI",
        "zip": "457072",
        "lat": "47.349571",
        "long": "22.876202"
      },
      {
        "name": "SIMISNA",
        "zip": "457294",
        "lat": "47.232024",
        "long": "23.623695"
      },
      {
        "name": "SIMLEU SILVANIEI",
        "zip": "455300",
        "lat": "47.230536",
        "long": "22.793305"
      },
      {
        "name": "SOIMUS",
        "zip": "457314",
        "lat": "47.299204",
        "long": "23.186296"
      },
      {
        "name": "SOIMUSENI",
        "zip": "457222",
        "lat": "47.337332",
        "long": "23.374065"
      },
      {
        "name": "SOLOMON",
        "zip": "457157",
        "lat": "47.173597",
        "long": "23.418111"
      },
      {
        "name": "SOLONA",
        "zip": "457318",
        "lat": "47.265244",
        "long": "23.403063"
      },
      {
        "name": "SOMES-GURUSLAU",
        "zip": "457257",
        "lat": "47.311443",
        "long": "23.297304"
      },
      {
        "name": "SOMES-ODORHEI",
        "zip": "457310",
        "lat": "47.323453",
        "long": "23.268131"
      },
      {
        "name": "STANA",
        "zip": "450002",
        "lat": "47.153346",
        "long": "23.135648"
      },
      {
        "name": "STANA",
        "zip": "457018",
        "lat": "46.886997",
        "long": "23.142113"
      },
      {
        "name": "STARCIU",
        "zip": "457187",
        "lat": "47.087473",
        "long": "22.919979"
      },
      {
        "name": "STOBORU",
        "zip": "457117",
        "lat": "46.937202",
        "long": "23.289038"
      },
      {
        "name": "STUPINI",
        "zip": "457182",
        "lat": "47.072355",
        "long": "23.382547"
      },
      {
        "name": "SUB CETATE",
        "zip": "457349",
        "lat": "47.106992",
        "long": "22.702533"
      },
      {
        "name": "SUMAL",
        "zip": "457234",
        "lat": "47.280661",
        "long": "22.565913"
      },
      {
        "name": "SURDUC",
        "zip": "457315",
        "lat": "47.256533",
        "long": "23.347762"
      },
      {
        "name": "SUTORU",
        "zip": "457374",
        "lat": "46.98714",
        "long": "23.250023"
      },
      {
        "name": "TAMASA",
        "zip": "457118",
        "lat": "46.94839",
        "long": "23.187339"
      },
      {
        "name": "TARMURE",
        "zip": "457336",
        "lat": "47.353679",
        "long": "22.759328"
      },
      {
        "name": "TAUDU",
        "zip": "457019",
        "lat": "46.983241",
        "long": "23.05052"
      },
      {
        "name": "TESTIOARA",
        "zip": "457319",
        "lat": "47.253881",
        "long": "23.425656"
      },
      {
        "name": "TETISU",
        "zip": "457138",
        "lat": "46.89754",
        "long": "23.045138"
      },
      {
        "name": "TIHAU",
        "zip": "457321",
        "lat": "47.227235",
        "long": "23.32964"
      },
      {
        "name": "TOPLITA",
        "zip": "457223",
        "lat": "47.358113",
        "long": "23.471166"
      },
      {
        "name": "TRANIS",
        "zip": "457258",
        "lat": "47.33317",
        "long": "23.306486"
      },
      {
        "name": "TRESTIA",
        "zip": "457183",
        "lat": "47.114135",
        "long": "23.334653"
      },
      {
        "name": "TREZNEA",
        "zip": "457340",
        "lat": "47.10562",
        "long": "23.10782"
      },
      {
        "name": "TURBUTA",
        "zip": "457322",
        "lat": "47.248026",
        "long": "23.312807"
      },
      {
        "name": "TUSA",
        "zip": "457304",
        "lat": "47.042916",
        "long": "22.776115"
      },
      {
        "name": "UGRUTIU",
        "zip": "457133",
        "lat": "47.006262",
        "long": "23.376361"
      },
      {
        "name": "UILEACU SIMLEULUI",
        "zip": "457241",
        "lat": "47.279316",
        "long": "22.750156"
      },
      {
        "name": "ULCIUG",
        "zip": "455104",
        "lat": "47.433759",
        "long": "23.193819"
      },
      {
        "name": "VADURELE",
        "zip": "457259",
        "lat": "47.332811",
        "long": "23.342132"
      },
      {
        "name": "VALCAU DE JOS",
        "zip": "457345",
        "lat": "47.129076",
        "long": "22.738231"
      },
      {
        "name": "VALCAU DE SUS",
        "zip": "457351",
        "lat": "47.114497",
        "long": "22.72988"
      },
      {
        "name": "VALEA CIURENILOR",
        "zip": "457363",
        "lat": "47.225166",
        "long": "23.522114"
      },
      {
        "name": "VALEA HRANEI",
        "zip": "457364",
        "lat": "47.224364",
        "long": "23.550383"
      },
      {
        "name": "VALEA LESULUI",
        "zip": "457228",
        "lat": "47.331794",
        "long": "23.479836"
      },
      {
        "name": "VALEA LOZNEI",
        "zip": "457229",
        "lat": "47.260661",
        "long": "23.493475"
      },
      {
        "name": "VALEA LUNGA",
        "zip": "457366",
        "lat": "47.166728",
        "long": "23.51409"
      },
      {
        "name": "VALEA POMILOR",
        "zip": "457326",
        "lat": "47.318886",
        "long": "22.953934"
      },
      {
        "name": "VALENI",
        "zip": "457103",
        "lat": "47.229103",
        "long": "23.446894"
      },
      {
        "name": "VALISOARA",
        "zip": "457224",
        "lat": "47.378496",
        "long": "23.401174"
      },
      {
        "name": "VAR",
        "zip": "455204",
        "lat": "47.235615",
        "long": "23.300059"
      },
      {
        "name": "VARSOLT",
        "zip": "457355",
        "lat": "47.206935",
        "long": "22.916396"
      },
      {
        "name": "VARTESCA",
        "zip": "457367",
        "lat": "47.174206",
        "long": "23.502417"
      },
      {
        "name": "VERVEGHIU",
        "zip": "457126",
        "lat": "47.313562",
        "long": "23.110271"
      },
      {
        "name": "VIILE JACULUI",
        "zip": "457099",
        "lat": "47.1638",
        "long": "23.156947"
      },
      {
        "name": "VOIVODENI",
        "zip": "457134",
        "lat": "47.055078",
        "long": "23.426279"
      },
      {
        "name": "ZALAU",
        "zip": "450006",
        "lat": "47.181942",
        "long": "23.056214"
      },
      {
        "name": "ZALHA",
        "zip": "457360",
        "lat": "47.194274",
        "long": "23.527993"
      },
      {
        "name": "ZALNOC",
        "zip": "457042",
        "lat": "47.364256",
        "long": "22.686339"
      },
      {
        "name": "ZAUAN",
        "zip": "457213",
        "lat": "47.225358",
        "long": "22.662165"
      },
      {
        "name": "ZAUAN-BAI",
        "zip": "457214",
        "lat": "47.247532",
        "long": "22.642975"
      },
      {
        "name": "ZIMBOR",
        "zip": "457370",
        "lat": "47.002485",
        "long": "23.263362"
      }
    ],
    "SATU-MARE": [
      {
        "name": "ACAS",
        "zip": "447005",
        "lat": "47.539057",
        "long": "22.784336"
      },
      {
        "name": "ACIUA",
        "zip": "447256",
        "lat": "47.681411",
        "long": "23.363901"
      },
      {
        "name": "ADRIAN",
        "zip": "447181",
        "lat": "47.903691",
        "long": "23.127155"
      },
      {
        "name": "ADY ENDRE",
        "zip": "447086",
        "lat": "47.581718",
        "long": "22.616572"
      },
      {
        "name": "AGRIS",
        "zip": "447066",
        "lat": "47.88075",
        "long": "23.003403"
      },
      {
        "name": "ALICENI",
        "zip": "447316",
        "lat": "47.964594",
        "long": "23.306587"
      },
      {
        "name": "ALIZA",
        "zip": "447321",
        "lat": "47.695423",
        "long": "22.731031"
      },
      {
        "name": "AMATI",
        "zip": "447231",
        "lat": "47.742297",
        "long": "22.918039"
      },
      {
        "name": "AMBUD",
        "zip": "447232",
        "lat": "47.77157",
        "long": "22.943715"
      },
      {
        "name": "ANDRID",
        "zip": "447010",
        "lat": "47.514325",
        "long": "22.338237"
      },
      {
        "name": "APA",
        "zip": "447015",
        "lat": "47.762728",
        "long": "23.199495"
      },
      {
        "name": "APATEU",
        "zip": "447116",
        "lat": "47.772895",
        "long": "22.994906"
      },
      {
        "name": "ARDUD",
        "zip": "447020",
        "lat": "47.639863",
        "long": "22.889335"
      },
      {
        "name": "ARDUD-VII",
        "zip": "447021",
        "lat": "47.646078",
        "long": "22.936173"
      },
      {
        "name": "ATEA",
        "zip": "447131",
        "lat": "47.870904",
        "long": "22.788663"
      },
      {
        "name": "BABA NOVAC",
        "zip": "447022",
        "lat": "47.649215",
        "long": "22.793039"
      },
      {
        "name": "BABASESTI",
        "zip": "447186",
        "lat": "47.77594",
        "long": "23.099214"
      },
      {
        "name": "BABESTI",
        "zip": "447146",
        "lat": "47.968928",
        "long": "23.079482"
      },
      {
        "name": "BABTA",
        "zip": "447061",
        "lat": "47.455348",
        "long": "22.938668"
      },
      {
        "name": "BARSAU DE JOS",
        "zip": "447036",
        "lat": "47.595183",
        "long": "23.263757"
      },
      {
        "name": "BARSAU DE SUS",
        "zip": "447037",
        "lat": "47.592329",
        "long": "23.221388"
      },
      {
        "name": "BATARCI",
        "zip": "447030",
        "lat": "48.035636",
        "long": "23.151096"
      },
      {
        "name": "BECHENI",
        "zip": "447281",
        "lat": "47.452434",
        "long": "22.448962"
      },
      {
        "name": "BELTIUG",
        "zip": "447040",
        "lat": "47.549227",
        "long": "22.842807"
      },
      {
        "name": "BERCU",
        "zip": "447171",
        "lat": "47.914795",
        "long": "22.888956"
      },
      {
        "name": "BERCU NOU",
        "zip": "447196",
        "lat": "47.933573",
        "long": "22.929362"
      },
      {
        "name": "BEREA",
        "zip": "447261",
        "lat": "47.669851",
        "long": "22.340812"
      },
      {
        "name": "BERINDAN",
        "zip": "447211",
        "lat": "47.784605",
        "long": "23.010176"
      },
      {
        "name": "BERVENI",
        "zip": "447050",
        "lat": "47.755972",
        "long": "22.472875"
      },
      {
        "name": "BICAU",
        "zip": "447257",
        "lat": "47.662356",
        "long": "23.284936"
      },
      {
        "name": "BIXAD",
        "zip": "447055",
        "lat": "47.919714",
        "long": "23.390534"
      },
      {
        "name": "BLAJA",
        "zip": "445301",
        "lat": "47.458922",
        "long": "22.555105"
      },
      {
        "name": "BOCICAU",
        "zip": "447311",
        "lat": "48.096964",
        "long": "23.155512"
      },
      {
        "name": "BOGDAND",
        "zip": "447060",
        "lat": "47.414681",
        "long": "22.939397"
      },
      {
        "name": "BOGHIS",
        "zip": "447126",
        "lat": "47.759585",
        "long": "22.673713"
      },
      {
        "name": "BOINESTI",
        "zip": "447056",
        "lat": "47.915674",
        "long": "23.351175"
      },
      {
        "name": "BOLDA",
        "zip": "447041",
        "lat": "47.532615",
        "long": "22.915558"
      },
      {
        "name": "BORLESTI",
        "zip": "447258",
        "lat": "47.680211",
        "long": "23.331114"
      },
      {
        "name": "BOTIZ",
        "zip": "447065",
        "lat": "47.829036",
        "long": "22.947668"
      },
      {
        "name": "CALINESTI-OAS",
        "zip": "447070",
        "lat": "47.908558",
        "long": "23.292436"
      },
      {
        "name": "CAMARZANA",
        "zip": "447075",
        "lat": "47.991041",
        "long": "23.304308"
      },
      {
        "name": "CAMIN",
        "zip": "447081",
        "lat": "47.728361",
        "long": "22.479874"
      },
      {
        "name": "CAPLENI",
        "zip": "447080",
        "lat": "47.709418",
        "long": "22.506368"
      },
      {
        "name": "CARASEU",
        "zip": "447117",
        "lat": "47.74126",
        "long": "23.097979"
      },
      {
        "name": "CAREI",
        "zip": "445100",
        "lat": "47.68153",
        "long": "22.468716"
      },
      {
        "name": "CAUAS",
        "zip": "447085",
        "lat": "47.569268",
        "long": "22.544159"
      },
      {
        "name": "CEAN",
        "zip": "447282",
        "lat": "47.444531",
        "long": "22.5206"
      },
      {
        "name": "CEHAL",
        "zip": "447095",
        "lat": "47.384324",
        "long": "22.594686"
      },
      {
        "name": "CEHALUT",
        "zip": "447096",
        "lat": "47.421002",
        "long": "22.569553"
      },
      {
        "name": "CERTEZE",
        "zip": "447100",
        "lat": "47.90257",
        "long": "23.46143"
      },
      {
        "name": "CHEGEA",
        "zip": "447276",
        "lat": "47.459334",
        "long": "22.679819"
      },
      {
        "name": "CHEREUSA",
        "zip": "447271",
        "lat": "47.491087",
        "long": "22.449766"
      },
      {
        "name": "CHILIA",
        "zip": "447161",
        "lat": "47.642053",
        "long": "23.076091"
      },
      {
        "name": "CHISAU",
        "zip": "447283",
        "lat": "47.460799",
        "long": "22.443022"
      },
      {
        "name": "CIDREAG",
        "zip": "447147",
        "lat": "47.986051",
        "long": "22.962082"
      },
      {
        "name": "CIG",
        "zip": "445302",
        "lat": "47.528865",
        "long": "22.637158"
      },
      {
        "name": "CIONCHESTI",
        "zip": "447361",
        "lat": "47.70104",
        "long": "22.91379"
      },
      {
        "name": "CIUMESTI",
        "zip": "447262",
        "lat": "47.66382",
        "long": "22.340688"
      },
      {
        "name": "CIUPERCENI",
        "zip": "447067",
        "lat": "47.866782",
        "long": "23.003464"
      },
      {
        "name": "COCA",
        "zip": "447071",
        "lat": "47.899127",
        "long": "23.265247"
      },
      {
        "name": "COMLAUSA",
        "zip": "447031",
        "lat": "48.05235",
        "long": "23.155807"
      },
      {
        "name": "COROD",
        "zip": "447118",
        "lat": "47.763101",
        "long": "23.012888"
      },
      {
        "name": "CORUND",
        "zip": "447062",
        "lat": "47.422185",
        "long": "22.869219"
      },
      {
        "name": "CRAIDOROLT",
        "zip": "447105",
        "lat": "47.61341",
        "long": "22.703934"
      },
      {
        "name": "CRISENI",
        "zip": "447106",
        "lat": "47.63931",
        "long": "22.680318"
      },
      {
        "name": "CRUCISOR",
        "zip": "447110",
        "lat": "47.693986",
        "long": "23.23001"
      },
      {
        "name": "CUCU",
        "zip": "447212",
        "lat": "47.786212",
        "long": "22.96614"
      },
      {
        "name": "CULCIU MARE",
        "zip": "447119",
        "lat": "47.755456",
        "long": "23.060411"
      },
      {
        "name": "CULCIU MIC",
        "zip": "447121",
        "lat": "47.764551",
        "long": "23.036836"
      },
      {
        "name": "CUTA",
        "zip": "447286",
        "lat": "47.538752",
        "long": "23.002703"
      },
      {
        "name": "DACIA",
        "zip": "447127",
        "lat": "47.733371",
        "long": "22.656703"
      },
      {
        "name": "DARA",
        "zip": "447132",
        "lat": "47.816362",
        "long": "22.752163"
      },
      {
        "name": "DECEBAL",
        "zip": "447356",
        "lat": "47.770173",
        "long": "22.761738"
      },
      {
        "name": "DINDESTI",
        "zip": "447011",
        "lat": "47.534336",
        "long": "22.379265"
      },
      {
        "name": "DINDESTIU MIC",
        "zip": "447241",
        "lat": "47.572991",
        "long": "22.352053"
      },
      {
        "name": "DOBA",
        "zip": "447125",
        "lat": "47.739359",
        "long": "22.71024"
      },
      {
        "name": "DOBOLT",
        "zip": "447148",
        "lat": "47.983578",
        "long": "23.038259"
      },
      {
        "name": "DOBRA",
        "zip": "447291",
        "lat": "47.494766",
        "long": "22.827622"
      },
      {
        "name": "DOMANESTI",
        "zip": "447201",
        "lat": "47.710708",
        "long": "22.589751"
      },
      {
        "name": "DOROLT",
        "zip": "447130",
        "lat": "47.843493",
        "long": "22.812596"
      },
      {
        "name": "DRAGUSENI",
        "zip": "447336",
        "lat": "47.905406",
        "long": "23.077798"
      },
      {
        "name": "DUMBRAVA",
        "zip": "447182",
        "lat": "47.844178",
        "long": "23.080603"
      },
      {
        "name": "ERIU-SANCRAI",
        "zip": "447107",
        "lat": "47.573847",
        "long": "22.669385"
      },
      {
        "name": "ETENI",
        "zip": "447213",
        "lat": "47.778575",
        "long": "23.04431"
      },
      {
        "name": "FOIENI",
        "zip": "447135",
        "lat": "47.697589",
        "long": "22.386438"
      },
      {
        "name": "GANAS",
        "zip": "447006",
        "lat": "47.519275",
        "long": "22.698007"
      },
      {
        "name": "GELU",
        "zip": "447322",
        "lat": "47.684033",
        "long": "22.783024"
      },
      {
        "name": "GERAUSA",
        "zip": "447023",
        "lat": "47.604633",
        "long": "22.93548"
      },
      {
        "name": "GHENCI",
        "zip": "447087",
        "lat": "47.630457",
        "long": "22.526717"
      },
      {
        "name": "GHERTA MARE",
        "zip": "447331",
        "lat": "47.968841",
        "long": "23.208532"
      },
      {
        "name": "GHERTA MICA",
        "zip": "447140",
        "lat": "47.937238",
        "long": "23.221694"
      },
      {
        "name": "GHILESTI",
        "zip": "447088",
        "lat": "47.540237",
        "long": "22.583247"
      },
      {
        "name": "GHILVACI",
        "zip": "447202",
        "lat": "47.67839",
        "long": "22.670816"
      },
      {
        "name": "GHIRISA",
        "zip": "447042",
        "lat": "47.595128",
        "long": "22.787965"
      },
      {
        "name": "GHIROLT",
        "zip": "447203",
        "lat": "47.608477",
        "long": "22.620884"
      },
      {
        "name": "GIOROCUTA",
        "zip": "447292",
        "lat": "47.432257",
        "long": "22.797694"
      },
      {
        "name": "GIUNGI",
        "zip": "447043",
        "lat": "47.57332",
        "long": "22.773488"
      },
      {
        "name": "GIURTELECU HODODULUI",
        "zip": "447156",
        "lat": "47.416176",
        "long": "23.091447"
      },
      {
        "name": "HALMEU",
        "zip": "447145",
        "lat": "47.980245",
        "long": "22.99642"
      },
      {
        "name": "HALMEU-VII",
        "zip": "447149",
        "lat": "48.01608",
        "long": "23.106774"
      },
      {
        "name": "HODISA",
        "zip": "447287",
        "lat": "47.575961",
        "long": "22.97587"
      },
      {
        "name": "HODOD",
        "zip": "447155",
        "lat": "47.402596",
        "long": "23.025018"
      },
      {
        "name": "HOMORODU DE JOS",
        "zip": "447162",
        "lat": "47.665496",
        "long": "23.08409"
      },
      {
        "name": "HOMORODU DE MIJLOC",
        "zip": "447163",
        "lat": "47.629147",
        "long": "23.063697"
      },
      {
        "name": "HOMORODU DE SUS",
        "zip": "447164",
        "lat": "47.616537",
        "long": "23.054657"
      },
      {
        "name": "HOREA",
        "zip": "447263",
        "lat": "47.683157",
        "long": "22.239343"
      },
      {
        "name": "HOTOAN",
        "zip": "447089",
        "lat": "47.556285",
        "long": "22.48863"
      },
      {
        "name": "HRIP",
        "zip": "447233",
        "lat": "47.720895",
        "long": "22.983585"
      },
      {
        "name": "HUREZU MARE",
        "zip": "447293",
        "lat": "47.465232",
        "long": "22.838377"
      },
      {
        "name": "HUTA-CERTEZE",
        "zip": "447101",
        "lat": "47.925811",
        "long": "23.488381"
      },
      {
        "name": "IANCULESTI",
        "zip": "445101",
        "lat": "47.631665",
        "long": "22.421577"
      },
      {
        "name": "IEGHERISTE",
        "zip": "447111",
        "lat": "47.657805",
        "long": "23.26272"
      },
      {
        "name": "IOJIB",
        "zip": "447187",
        "lat": "47.816172",
        "long": "23.156034"
      },
      {
        "name": "IRINA",
        "zip": "447012",
        "lat": "47.551706",
        "long": "22.402257"
      },
      {
        "name": "ISTRAU",
        "zip": "447204",
        "lat": "47.622905",
        "long": "22.645403"
      },
      {
        "name": "LAZURI",
        "zip": "447170",
        "lat": "47.85426",
        "long": "22.870836"
      },
      {
        "name": "LECHINTA",
        "zip": "447072",
        "lat": "47.923134",
        "long": "23.298232"
      },
      {
        "name": "LELEI",
        "zip": "447157",
        "lat": "47.375292",
        "long": "23.070641"
      },
      {
        "name": "LIPAU",
        "zip": "447122",
        "lat": "47.717497",
        "long": "23.132557"
      },
      {
        "name": "LIVADA",
        "zip": "447180",
        "lat": "47.863219",
        "long": "23.121164"
      },
      {
        "name": "LIVADA MICA",
        "zip": "447183",
        "lat": "47.844462",
        "long": "23.116224"
      },
      {
        "name": "LUCACENI",
        "zip": "447051",
        "lat": "47.742757",
        "long": "22.475958"
      },
      {
        "name": "LUNA",
        "zip": "445201",
        "lat": "47.849236",
        "long": "23.437676"
      },
      {
        "name": "LUNCA APEI",
        "zip": "447016",
        "lat": "47.741209",
        "long": "23.163073"
      },
      {
        "name": "MADARAS",
        "zip": "447024",
        "lat": "47.685029",
        "long": "22.852156"
      },
      {
        "name": "MARIUS",
        "zip": "447346",
        "lat": "47.665777",
        "long": "23.184556"
      },
      {
        "name": "MARNA NOUA",
        "zip": "447264",
        "lat": "47.658178",
        "long": "22.390107"
      },
      {
        "name": "MARTINESTI",
        "zip": "447214",
        "lat": "47.786481",
        "long": "22.940493"
      },
      {
        "name": "MEDIES-RATURI",
        "zip": "447188",
        "lat": "47.808159",
        "long": "23.20341"
      },
      {
        "name": "MEDIES-VII",
        "zip": "447189",
        "lat": "47.822597",
        "long": "23.239874"
      },
      {
        "name": "MEDIESU AURIT",
        "zip": "447185",
        "lat": "47.789585",
        "long": "23.136432"
      },
      {
        "name": "MEDISA",
        "zip": "447362",
        "lat": "47.60607",
        "long": "23.003531"
      },
      {
        "name": "MESTEACAN",
        "zip": "447151",
        "lat": "47.944443",
        "long": "23.020775"
      },
      {
        "name": "MICULA",
        "zip": "447195",
        "lat": "47.900252",
        "long": "22.950549"
      },
      {
        "name": "MICULA NOUA",
        "zip": "447197",
        "lat": "47.916793",
        "long": "22.929647"
      },
      {
        "name": "MIHAIENI",
        "zip": "447007",
        "lat": "47.562035",
        "long": "22.735108"
      },
      {
        "name": "MOFTINU MARE",
        "zip": "447206",
        "lat": "47.676062",
        "long": "22.657202"
      },
      {
        "name": "MOFTINU MIC",
        "zip": "447207",
        "lat": "47.685882",
        "long": "22.601063"
      },
      {
        "name": "MOISENI",
        "zip": "447102",
        "lat": "47.927984",
        "long": "23.468329"
      },
      {
        "name": "NADISU HODODULUI",
        "zip": "447158",
        "lat": "47.399795",
        "long": "22.999176"
      },
      {
        "name": "NECOPOI",
        "zip": "447166",
        "lat": "47.683239",
        "long": "23.065292"
      },
      {
        "name": "NEGRESTI-OAS",
        "zip": "445200",
        "lat": "47.872998",
        "long": "23.427014"
      },
      {
        "name": "NISIPENI",
        "zip": "447172",
        "lat": "47.902607",
        "long": "22.903424"
      },
      {
        "name": "NOROIENI",
        "zip": "447173",
        "lat": "47.885249",
        "long": "22.887389"
      },
      {
        "name": "OAR",
        "zip": "447357",
        "lat": "47.805693",
        "long": "22.730851"
      },
      {
        "name": "ODOREU",
        "zip": "447210",
        "lat": "47.796988",
        "long": "22.993673"
      },
      {
        "name": "ORASU NOU",
        "zip": "447220",
        "lat": "47.834089",
        "long": "23.291384"
      },
      {
        "name": "ORASU NOU-VII",
        "zip": "447221",
        "lat": "47.807975",
        "long": "23.269775"
      },
      {
        "name": "ORBAU",
        "zip": "447097",
        "lat": "47.410235",
        "long": "22.630122"
      },
      {
        "name": "PASUNEA MARE",
        "zip": "447073",
        "lat": "47.882747",
        "long": "23.232291"
      },
      {
        "name": "PAULESTI",
        "zip": "447230",
        "lat": "47.778745",
        "long": "22.906062"
      },
      {
        "name": "PAULIAN",
        "zip": "447128",
        "lat": "47.725735",
        "long": "22.676766"
      },
      {
        "name": "PELES",
        "zip": "447174",
        "lat": "47.884899",
        "long": "22.819978"
      },
      {
        "name": "PELISOR",
        "zip": "447176",
        "lat": "47.903915",
        "long": "22.854729"
      },
      {
        "name": "PETEA",
        "zip": "447133",
        "lat": "47.851618",
        "long": "22.786821"
      },
      {
        "name": "PETIN",
        "zip": "447234",
        "lat": "47.772453",
        "long": "22.967394"
      },
      {
        "name": "PETRESTI",
        "zip": "447240",
        "lat": "47.606864",
        "long": "22.367381"
      },
      {
        "name": "PIR",
        "zip": "447245",
        "lat": "47.459676",
        "long": "22.372753"
      },
      {
        "name": "PIRU NOU",
        "zip": "447246",
        "lat": "47.483844",
        "long": "22.391074"
      },
      {
        "name": "PISCARI",
        "zip": "447323",
        "lat": "47.652394",
        "long": "22.730198"
      },
      {
        "name": "PISCOLT",
        "zip": "447250",
        "lat": "47.580021",
        "long": "22.299598"
      },
      {
        "name": "POIANA CODRULUI",
        "zip": "447112",
        "lat": "47.626669",
        "long": "23.250565"
      },
      {
        "name": "POMI",
        "zip": "447255",
        "lat": "47.698304",
        "long": "23.305548"
      },
      {
        "name": "PORTITA",
        "zip": "447326",
        "lat": "47.568729",
        "long": "22.413434"
      },
      {
        "name": "PORUMBESTI",
        "zip": "447152",
        "lat": "47.983046",
        "long": "22.980764"
      },
      {
        "name": "POTAU",
        "zip": "447191",
        "lat": "47.756727",
        "long": "23.120901"
      },
      {
        "name": "PRILOG",
        "zip": "447222",
        "lat": "47.851047",
        "long": "23.319012"
      },
      {
        "name": "PRILOG-VII",
        "zip": "447223",
        "lat": "47.86003",
        "long": "23.278789"
      },
      {
        "name": "RACOVA",
        "zip": "447294",
        "lat": "47.462314",
        "long": "22.887078"
      },
      {
        "name": "RACSA",
        "zip": "447224",
        "lat": "47.820723",
        "long": "23.334507"
      },
      {
        "name": "RACSA-VII",
        "zip": "447226",
        "lat": "47.792325",
        "long": "23.303886"
      },
      {
        "name": "RADULESTI",
        "zip": "447091",
        "lat": "47.60032",
        "long": "22.563914"
      },
      {
        "name": "RATESTI",
        "zip": "447044",
        "lat": "47.584172",
        "long": "22.883838"
      },
      {
        "name": "RATIU",
        "zip": "445303",
        "lat": "47.439472",
        "long": "22.607415"
      },
      {
        "name": "REMETEA OASULUI",
        "zip": "447227",
        "lat": "47.876227",
        "long": "23.316913"
      },
      {
        "name": "RESIGHEA",
        "zip": "447251",
        "lat": "47.596794",
        "long": "22.295638"
      },
      {
        "name": "ROMANESTI",
        "zip": "447192",
        "lat": "47.790821",
        "long": "23.115431"
      },
      {
        "name": "ROSIORI",
        "zip": "447347",
        "lat": "47.712813",
        "long": "23.244189"
      },
      {
        "name": "RUSENI",
        "zip": "447236",
        "lat": "47.711863",
        "long": "22.946674"
      },
      {
        "name": "SACASENI",
        "zip": "447275",
        "lat": "47.479955",
        "long": "22.685637"
      },
      {
        "name": "SAI",
        "zip": "447348",
        "lat": "47.683087",
        "long": "23.120391"
      },
      {
        "name": "SANDRA",
        "zip": "447046",
        "lat": "47.558646",
        "long": "22.912966"
      },
      {
        "name": "SANISLAU",
        "zip": "447260",
        "lat": "47.636982",
        "long": "22.325098"
      },
      {
        "name": "SANMICLAUS",
        "zip": "447208",
        "lat": "47.638457",
        "long": "22.606784"
      },
      {
        "name": "SANTAU",
        "zip": "447270",
        "lat": "47.510341",
        "long": "22.510995"
      },
      {
        "name": "SARATURA",
        "zip": "447026",
        "lat": "47.625279",
        "long": "22.94277"
      },
      {
        "name": "SARAUAD",
        "zip": "445304",
        "lat": "47.479443",
        "long": "22.625592"
      },
      {
        "name": "SARVAZEL",
        "zip": "447247",
        "lat": "47.455968",
        "long": "22.417578"
      },
      {
        "name": "SATMAREL",
        "zip": "440001",
        "lat": "47.738144",
        "long": "22.794202"
      },
      {
        "name": "SATU MARE",
        "zip": "440004",
        "lat": "47.794582",
        "long": "22.879729"
      },
      {
        "name": "SATU MIC",
        "zip": "447108",
        "lat": "47.576249",
        "long": "22.702348"
      },
      {
        "name": "SAUCA",
        "zip": "447280",
        "lat": "47.470261",
        "long": "22.495323"
      },
      {
        "name": "SCARISOARA NOUA",
        "zip": "447252",
        "lat": "47.61604",
        "long": "22.229241"
      },
      {
        "name": "SECHERESA",
        "zip": "447296",
        "lat": "47.452578",
        "long": "22.742325"
      },
      {
        "name": "SER",
        "zip": "447063",
        "lat": "47.377156",
        "long": "22.968145"
      },
      {
        "name": "SILVAS",
        "zip": "447284",
        "lat": "47.474524",
        "long": "22.521396"
      },
      {
        "name": "SIRLAU",
        "zip": "447032",
        "lat": "48.058824",
        "long": "23.128612"
      },
      {
        "name": "SOCOND",
        "zip": "447285",
        "lat": "47.56225",
        "long": "22.949616"
      },
      {
        "name": "SOCONZEL",
        "zip": "447288",
        "lat": "47.517424",
        "long": "22.998232"
      },
      {
        "name": "SOLDUBA",
        "zip": "447167",
        "lat": "47.596676",
        "long": "23.040125"
      },
      {
        "name": "SOMESENI",
        "zip": "447017",
        "lat": "47.744089",
        "long": "23.20641"
      },
      {
        "name": "STANA",
        "zip": "447289",
        "lat": "47.507571",
        "long": "22.964234"
      },
      {
        "name": "SUDURAU",
        "zip": "447272",
        "lat": "47.531335",
        "long": "22.458161"
      },
      {
        "name": "SUPURU DE JOS",
        "zip": "447300",
        "lat": "47.465888",
        "long": "22.793992"
      },
      {
        "name": "SUPURU DE SUS",
        "zip": "447297",
        "lat": "47.433492",
        "long": "22.765846"
      },
      {
        "name": "TAMASENI",
        "zip": "447033",
        "lat": "48.015365",
        "long": "23.135428"
      },
      {
        "name": "TARNA MARE",
        "zip": "447310",
        "lat": "48.091388",
        "long": "23.199312"
      },
      {
        "name": "TARSOLT",
        "zip": "447315",
        "lat": "47.954283",
        "long": "23.348988"
      },
      {
        "name": "TASNAD",
        "zip": "445300",
        "lat": "47.478092",
        "long": "22.584855"
      },
      {
        "name": "TATARESTI",
        "zip": "447363",
        "lat": "47.682528",
        "long": "23.007716"
      },
      {
        "name": "TEGHEA",
        "zip": "447109",
        "lat": "47.586613",
        "long": "22.735784"
      },
      {
        "name": "TEREBESTI",
        "zip": "447320",
        "lat": "47.678948",
        "long": "22.720024"
      },
      {
        "name": "TIREAC",
        "zip": "447364",
        "lat": "47.693192",
        "long": "23.034805"
      },
      {
        "name": "TIREAM",
        "zip": "447325",
        "lat": "47.613785",
        "long": "22.472806"
      },
      {
        "name": "TRAIAN",
        "zip": "447129",
        "lat": "47.768355",
        "long": "22.696239"
      },
      {
        "name": "TRIP",
        "zip": "447057",
        "lat": "47.924502",
        "long": "23.376484"
      },
      {
        "name": "TUR",
        "zip": "445202",
        "lat": "47.882314",
        "long": "23.390446"
      },
      {
        "name": "TURT",
        "zip": "447330",
        "lat": "47.98981",
        "long": "23.200019"
      },
      {
        "name": "TURT-BAI",
        "zip": "447332",
        "lat": "48.023991",
        "long": "23.253726"
      },
      {
        "name": "TURULUNG",
        "zip": "447335",
        "lat": "47.932777",
        "long": "23.084348"
      },
      {
        "name": "TURULUNG-VII",
        "zip": "447337",
        "lat": "47.930849",
        "long": "23.148976"
      },
      {
        "name": "UNIMAT",
        "zip": "447008",
        "lat": "47.505018",
        "long": "22.745348"
      },
      {
        "name": "URZICENI",
        "zip": "447340",
        "lat": "47.734991",
        "long": "22.399924"
      },
      {
        "name": "URZICENI-PADURE",
        "zip": "447341",
        "lat": "47.74363",
        "long": "22.344082"
      },
      {
        "name": "VAGAS",
        "zip": "447313",
        "lat": "48.065073",
        "long": "23.259912"
      },
      {
        "name": "VALEA MORII",
        "zip": "445305",
        "lat": "47.4962",
        "long": "22.543226"
      },
      {
        "name": "VALEA SEACA",
        "zip": "447312",
        "lat": "48.080797",
        "long": "23.164886"
      },
      {
        "name": "VALEA VINULUI",
        "zip": "447345",
        "lat": "47.720006",
        "long": "23.188257"
      },
      {
        "name": "VAMA",
        "zip": "447350",
        "lat": "47.841606",
        "long": "23.388548"
      },
      {
        "name": "VANATORESTI",
        "zip": "447216",
        "lat": "47.831581",
        "long": "23.004368"
      },
      {
        "name": "VETIS",
        "zip": "447355",
        "lat": "47.800217",
        "long": "22.777895"
      },
      {
        "name": "VEZENDIU",
        "zip": "447327",
        "lat": "47.574732",
        "long": "22.432479"
      },
      {
        "name": "VIILE SATU MARE",
        "zip": "447360",
        "lat": "47.666287",
        "long": "22.952131"
      },
      {
        "name": "VIISOARA",
        "zip": "447266",
        "lat": "47.713255",
        "long": "22.299293"
      }
    ],
    "SIBIU": [
      {
        "name": "ACILIU",
        "zip": "557226",
        "lat": "45.83066",
        "long": "23.875602"
      },
      {
        "name": "AGARBICIU",
        "zip": "557026",
        "lat": "46.067983",
        "long": "24.191297"
      },
      {
        "name": "AGNITA",
        "zip": "555100",
        "lat": "45.974658",
        "long": "24.623372"
      },
      {
        "name": "ALAMOR",
        "zip": "557121",
        "lat": "45.928101",
        "long": "24.001038"
      },
      {
        "name": "ALBI",
        "zip": "557241",
        "lat": "45.935936",
        "long": "24.246666"
      },
      {
        "name": "ALMA",
        "zip": "557021",
        "lat": "46.213592",
        "long": "24.480366"
      },
      {
        "name": "ALMA VII",
        "zip": "557161",
        "lat": "46.047927",
        "long": "24.433117"
      },
      {
        "name": "ALTANA",
        "zip": "557005",
        "lat": "45.930245",
        "long": "24.462739"
      },
      {
        "name": "AMNAS",
        "zip": "557227",
        "lat": "45.845533",
        "long": "23.896993"
      },
      {
        "name": "APOLDU DE JOS",
        "zip": "557010",
        "lat": "45.879467",
        "long": "23.846273"
      },
      {
        "name": "APOLDU DE SUS",
        "zip": "557151",
        "lat": "45.850828",
        "long": "23.827962"
      },
      {
        "name": "APOS",
        "zip": "557036",
        "lat": "46.029813",
        "long": "24.553511"
      },
      {
        "name": "ARMENI",
        "zip": "557122",
        "lat": "45.965281",
        "long": "23.975216"
      },
      {
        "name": "ARPASU DE JOS",
        "zip": "557015",
        "lat": "45.779473",
        "long": "24.622127"
      },
      {
        "name": "ARPASU DE SUS",
        "zip": "557016",
        "lat": "45.733338",
        "long": "24.616659"
      },
      {
        "name": "ATEL",
        "zip": "557020",
        "lat": "46.157491",
        "long": "24.46788"
      },
      {
        "name": "AVRIG",
        "zip": "555200",
        "lat": "45.725297",
        "long": "24.379874"
      },
      {
        "name": "AXENTE SEVER",
        "zip": "557025",
        "lat": "46.093539",
        "long": "24.216143"
      },
      {
        "name": "BARGHIS",
        "zip": "557035",
        "lat": "45.98334",
        "long": "24.535446"
      },
      {
        "name": "BAZNA",
        "zip": "557030",
        "lat": "46.200651",
        "long": "24.283427"
      },
      {
        "name": "BENESTI",
        "zip": "557006",
        "lat": "45.954979",
        "long": "24.501215"
      },
      {
        "name": "BIERTAN",
        "zip": "557045",
        "lat": "46.136307",
        "long": "24.520958"
      },
      {
        "name": "BLAJEL",
        "zip": "557050",
        "lat": "46.20679",
        "long": "24.323707"
      },
      {
        "name": "BOARTA",
        "zip": "557246",
        "lat": "46.009227",
        "long": "24.197016"
      },
      {
        "name": "BOGATU ROMAN",
        "zip": "557176",
        "lat": "45.990981",
        "long": "23.93518"
      },
      {
        "name": "BOIAN",
        "zip": "557031",
        "lat": "46.201591",
        "long": "24.228621"
      },
      {
        "name": "BOITA",
        "zip": "555701",
        "lat": "45.634539",
        "long": "24.260369"
      },
      {
        "name": "BRADENI",
        "zip": "557060",
        "lat": "46.076773",
        "long": "24.827998"
      },
      {
        "name": "BRADU",
        "zip": "555201",
        "lat": "45.721032",
        "long": "24.328953"
      },
      {
        "name": "BRATEIU",
        "zip": "557055",
        "lat": "46.17264",
        "long": "24.424842"
      },
      {
        "name": "BROSTENI",
        "zip": "557177",
        "lat": "46.029979",
        "long": "23.955423"
      },
      {
        "name": "BRUIU",
        "zip": "557065",
        "lat": "45.874675",
        "long": "24.700858"
      },
      {
        "name": "BUIA",
        "zip": "557247",
        "lat": "45.97327",
        "long": "24.275525"
      },
      {
        "name": "BUNGARD",
        "zip": "557261",
        "lat": "45.775873",
        "long": "24.222832"
      },
      {
        "name": "BUZD",
        "zip": "557056",
        "lat": "46.138269",
        "long": "24.411382"
      },
      {
        "name": "CARTA",
        "zip": "557070",
        "lat": "45.789798",
        "long": "24.565354"
      },
      {
        "name": "CARTISOARA",
        "zip": "557075",
        "lat": "45.726337",
        "long": "24.57446"
      },
      {
        "name": "CASOLT",
        "zip": "557211",
        "lat": "45.77892",
        "long": "24.281174"
      },
      {
        "name": "CHESLER",
        "zip": "557146",
        "lat": "46.142324",
        "long": "24.186564"
      },
      {
        "name": "CHIRPAR",
        "zip": "557080",
        "lat": "45.894155",
        "long": "24.596707"
      },
      {
        "name": "CISNADIE",
        "zip": "555300",
        "lat": "45.716735",
        "long": "24.155738"
      },
      {
        "name": "CISNADIOARA",
        "zip": "555301",
        "lat": "45.704484",
        "long": "24.112873"
      },
      {
        "name": "COLONIA TALMACIU",
        "zip": "555702",
        "lat": "45.688274",
        "long": "24.25338"
      },
      {
        "name": "COLONIA TARNAVA",
        "zip": "557276",
        "lat": "46.135328",
        "long": "24.305726"
      },
      {
        "name": "COLUN",
        "zip": "557191",
        "lat": "45.779508",
        "long": "24.501007"
      },
      {
        "name": "COPSA MARE",
        "zip": "557046",
        "lat": "46.133748",
        "long": "24.550728"
      },
      {
        "name": "COPSA MICA",
        "zip": "555400",
        "lat": "46.115837",
        "long": "24.233658"
      },
      {
        "name": "CORNATEL",
        "zip": "557212",
        "lat": "45.800344",
        "long": "24.355334"
      },
      {
        "name": "COVES",
        "zip": "555101",
        "lat": "45.980546",
        "long": "24.572595"
      },
      {
        "name": "CRINT",
        "zip": "557228",
        "lat": "45.725163",
        "long": "23.802245"
      },
      {
        "name": "CRISTIAN",
        "zip": "557085",
        "lat": "45.783709",
        "long": "24.028291"
      },
      {
        "name": "CURCIU",
        "zip": "557091",
        "lat": "46.243646",
        "long": "24.405007"
      },
      {
        "name": "DAIA",
        "zip": "557213",
        "lat": "45.801242",
        "long": "24.285083"
      },
      {
        "name": "DARLOS",
        "zip": "557090",
        "lat": "46.189832",
        "long": "24.414225"
      },
      {
        "name": "DEALU FRUMOS",
        "zip": "557141",
        "lat": "45.983743",
        "long": "24.695956"
      },
      {
        "name": "DOBARCA",
        "zip": "557152",
        "lat": "45.850376",
        "long": "23.77287"
      },
      {
        "name": "DUMBRAVENI",
        "zip": "555500",
        "lat": "46.224324",
        "long": "24.575869"
      },
      {
        "name": "DUPUS",
        "zip": "557022",
        "lat": "46.151848",
        "long": "24.495257"
      },
      {
        "name": "ERNEA",
        "zip": "555501",
        "lat": "46.234232",
        "long": "24.530046"
      },
      {
        "name": "FANTANELE",
        "zip": "557229",
        "lat": "45.754942",
        "long": "23.926539"
      },
      {
        "name": "FLORESTI",
        "zip": "557116",
        "lat": "46.160675",
        "long": "24.66155"
      },
      {
        "name": "FOFELDEA",
        "zip": "557166",
        "lat": "45.834742",
        "long": "24.496092"
      },
      {
        "name": "GALES",
        "zip": "557231",
        "lat": "45.798596",
        "long": "23.863581"
      },
      {
        "name": "GHERDEAL",
        "zip": "557066",
        "lat": "45.859382",
        "long": "24.736484"
      },
      {
        "name": "GHIJASA DE JOS",
        "zip": "557167",
        "lat": "45.919938",
        "long": "24.391866"
      },
      {
        "name": "GHIJASA DE SUS",
        "zip": "557007",
        "lat": "45.977517",
        "long": "24.418454"
      },
      {
        "name": "GIACAS",
        "zip": "557023",
        "lat": "46.243341",
        "long": "24.477586"
      },
      {
        "name": "GLAMBOACA",
        "zip": "555202",
        "lat": "45.781289",
        "long": "24.462191"
      },
      {
        "name": "GURA RAULUI",
        "zip": "557095",
        "lat": "45.730119",
        "long": "23.984171"
      },
      {
        "name": "GUSU",
        "zip": "557131",
        "lat": "45.941692",
        "long": "23.901951"
      },
      {
        "name": "HAMBA",
        "zip": "557266",
        "lat": "45.863299",
        "long": "24.197206"
      },
      {
        "name": "HASAG",
        "zip": "557123",
        "lat": "45.977545",
        "long": "24.081576"
      },
      {
        "name": "HOGHILAG",
        "zip": "557100",
        "lat": "46.228408",
        "long": "24.616984"
      },
      {
        "name": "HOSMAN",
        "zip": "557168",
        "lat": "45.833706",
        "long": "24.427082"
      },
      {
        "name": "IACOBENI",
        "zip": "557105",
        "lat": "46.050984",
        "long": "24.716032"
      },
      {
        "name": "IGHISU NOU",
        "zip": "551001",
        "lat": "46.111209",
        "long": "24.3492"
      },
      {
        "name": "IGHISU VECHI",
        "zip": "557037",
        "lat": "45.988814",
        "long": "24.484832"
      },
      {
        "name": "ILIMBAV",
        "zip": "557136",
        "lat": "45.870698",
        "long": "24.524567"
      },
      {
        "name": "JINA",
        "zip": "557110",
        "lat": "45.785651",
        "long": "23.686863"
      },
      {
        "name": "LASLEA",
        "zip": "557115",
        "lat": "46.205574",
        "long": "24.655898"
      },
      {
        "name": "LAZARET",
        "zip": "555703",
        "lat": "45.561345",
        "long": "24.262506"
      },
      {
        "name": "LOAMNES",
        "zip": "557120",
        "lat": "45.944532",
        "long": "24.084783"
      },
      {
        "name": "LOTRIOARA",
        "zip": "555704",
        "lat": "45.573907",
        "long": "24.227642"
      },
      {
        "name": "LUDOS",
        "zip": "557130",
        "lat": "45.92644",
        "long": "23.900631"
      },
      {
        "name": "MAG",
        "zip": "557232",
        "lat": "45.819477",
        "long": "23.955607"
      },
      {
        "name": "MALANCRAV",
        "zip": "557117",
        "lat": "46.111153",
        "long": "24.648444"
      },
      {
        "name": "MANDRA",
        "zip": "557124",
        "lat": "45.926594",
        "long": "24.071611"
      },
      {
        "name": "MARPOD",
        "zip": "557135",
        "lat": "45.871427",
        "long": "24.496452"
      },
      {
        "name": "MARSA",
        "zip": "555250",
        "lat": "45.700023",
        "long": "24.370457"
      },
      {
        "name": "MEDIAS",
        "zip": "551002",
        "lat": "46.164911",
        "long": "24.351126"
      },
      {
        "name": "MERGHINDEAL",
        "zip": "557140",
        "lat": "45.965092",
        "long": "24.725928"
      },
      {
        "name": "METIS",
        "zip": "557156",
        "lat": "46.019586",
        "long": "24.405688"
      },
      {
        "name": "MICASASA",
        "zip": "557145",
        "lat": "46.087268",
        "long": "24.108936"
      },
      {
        "name": "MIERCUREA SIBIULUI",
        "zip": "557150",
        "lat": "45.888315",
        "long": "23.792793"
      },
      {
        "name": "MIGHINDOALA",
        "zip": "557248",
        "lat": "45.99995",
        "long": "24.276108"
      },
      {
        "name": "MIHAILENI",
        "zip": "557155",
        "lat": "45.990446",
        "long": "24.347944"
      },
      {
        "name": "MOARDAS",
        "zip": "557157",
        "lat": "46.008572",
        "long": "24.355328"
      },
      {
        "name": "MOHU",
        "zip": "557262",
        "lat": "45.742844",
        "long": "24.224724"
      },
      {
        "name": "MOSNA",
        "zip": "557160",
        "lat": "46.092433",
        "long": "24.395743"
      },
      {
        "name": "MOTIS",
        "zip": "557291",
        "lat": "46.060177",
        "long": "24.343184"
      },
      {
        "name": "MOVILE",
        "zip": "557106",
        "lat": "46.0225",
        "long": "24.791814"
      },
      {
        "name": "NEMSA",
        "zip": "557162",
        "lat": "46.08597",
        "long": "24.44448"
      },
      {
        "name": "NETUS",
        "zip": "557107",
        "lat": "46.058276",
        "long": "24.786915"
      },
      {
        "name": "NOCRICH",
        "zip": "557165",
        "lat": "45.896012",
        "long": "24.453995"
      },
      {
        "name": "NOISTAT",
        "zip": "557108",
        "lat": "46.052099",
        "long": "24.795098"
      },
      {
        "name": "NOU",
        "zip": "557214",
        "lat": "45.82994",
        "long": "24.283058"
      },
      {
        "name": "NOU ROMAN",
        "zip": "557017",
        "lat": "45.804152",
        "long": "24.577081"
      },
      {
        "name": "NOU SASESC",
        "zip": "557118",
        "lat": "46.110871",
        "long": "24.605369"
      },
      {
        "name": "NUCET",
        "zip": "557216",
        "lat": "45.795208",
        "long": "24.383712"
      },
      {
        "name": "OCNA SIBIULUI",
        "zip": "555600",
        "lat": "45.880428",
        "long": "24.057669"
      },
      {
        "name": "ORLAT",
        "zip": "557170",
        "lat": "45.756282",
        "long": "23.967135"
      },
      {
        "name": "PADURENI",
        "zip": "557242",
        "lat": "45.929033",
        "long": "24.219661"
      },
      {
        "name": "PALTIN",
        "zip": "555705",
        "lat": "45.544703",
        "long": "24.245169"
      },
      {
        "name": "PALTINIS",
        "zip": "550001",
        "lat": "45.653045",
        "long": "23.931982"
      },
      {
        "name": "PAUCA",
        "zip": "557175",
        "lat": "46.010272",
        "long": "23.889545"
      },
      {
        "name": "PAUCEA",
        "zip": "557051",
        "lat": "46.218456",
        "long": "24.358735"
      },
      {
        "name": "PELISOR",
        "zip": "557038",
        "lat": "46.046324",
        "long": "24.515239"
      },
      {
        "name": "PETIS",
        "zip": "557249",
        "lat": "46.016717",
        "long": "24.284724"
      },
      {
        "name": "POIANA SIBIULUI",
        "zip": "557180",
        "lat": "45.807553",
        "long": "23.730213"
      },
      {
        "name": "POIENITA",
        "zip": "557071",
        "lat": "45.816182",
        "long": "24.552572"
      },
      {
        "name": "POPLACA",
        "zip": "557185",
        "lat": "45.72908",
        "long": "24.050771"
      },
      {
        "name": "PORUMBACU DE JOS",
        "zip": "557190",
        "lat": "45.756132",
        "long": "24.45507"
      },
      {
        "name": "PORUMBACU DE SUS",
        "zip": "557192",
        "lat": "45.713775",
        "long": "24.473374"
      },
      {
        "name": "PRESACA",
        "zip": "557178",
        "lat": "45.974412",
        "long": "23.886754"
      },
      {
        "name": "PRISLOP",
        "zip": "557201",
        "lat": "45.690311",
        "long": "24.076953"
      },
      {
        "name": "PROD",
        "zip": "557101",
        "lat": "46.259595",
        "long": "24.650367"
      },
      {
        "name": "RACOVITA",
        "zip": "557195",
        "lat": "45.679415",
        "long": "24.344103"
      },
      {
        "name": "RASINARI",
        "zip": "557200",
        "lat": "45.709115",
        "long": "24.070794"
      },
      {
        "name": "RAU SADULUI",
        "zip": "557205",
        "lat": "45.624009",
        "long": "24.06132"
      },
      {
        "name": "RAVASEL",
        "zip": "557158",
        "lat": "46.009287",
        "long": "24.373522"
      },
      {
        "name": "RETIS",
        "zip": "557061",
        "lat": "46.043367",
        "long": "24.851198"
      },
      {
        "name": "RICHIS",
        "zip": "557047",
        "lat": "46.097903",
        "long": "24.480556"
      },
      {
        "name": "ROANDOLA",
        "zip": "557119",
        "lat": "46.162293",
        "long": "24.614711"
      },
      {
        "name": "ROD",
        "zip": "557281",
        "lat": "45.801547",
        "long": "23.781766"
      },
      {
        "name": "ROMANESTI",
        "zip": "557052",
        "lat": "46.247824",
        "long": "24.340792"
      },
      {
        "name": "ROSIA",
        "zip": "557210",
        "lat": "45.816962",
        "long": "24.314555"
      },
      {
        "name": "RUJA",
        "zip": "555102",
        "lat": "46.009706",
        "long": "24.651318"
      },
      {
        "name": "RUSCIORI",
        "zip": "557271",
        "lat": "45.814876",
        "long": "24.028022"
      },
      {
        "name": "RUSI",
        "zip": "557243",
        "lat": "45.961556",
        "long": "24.164246"
      },
      {
        "name": "SACADATE",
        "zip": "555203",
        "lat": "45.760814",
        "long": "24.388434"
      },
      {
        "name": "SACEL",
        "zip": "557233",
        "lat": "45.782393",
        "long": "23.939198"
      },
      {
        "name": "SADINCA",
        "zip": "557126",
        "lat": "45.982548",
        "long": "24.040824"
      },
      {
        "name": "SADU",
        "zip": "557220",
        "lat": "45.670509",
        "long": "24.182297"
      },
      {
        "name": "SALCAU",
        "zip": "557159",
        "lat": "45.971853",
        "long": "24.347814"
      },
      {
        "name": "SALISTE",
        "zip": "557225",
        "lat": "45.795522",
        "long": "23.887042"
      },
      {
        "name": "SANGATIN",
        "zip": "557011",
        "lat": "45.912095",
        "long": "23.853653"
      },
      {
        "name": "SARATA",
        "zip": "557193",
        "lat": "45.739876",
        "long": "24.504958"
      },
      {
        "name": "SAROS PE TARNAVE",
        "zip": "555502",
        "lat": "46.208051",
        "long": "24.544635"
      },
      {
        "name": "SASAUS",
        "zip": "557081",
        "lat": "45.849014",
        "long": "24.604484"
      },
      {
        "name": "SCOREIU",
        "zip": "557194",
        "lat": "45.760311",
        "long": "24.53139"
      },
      {
        "name": "SEBESU DE JOS",
        "zip": "557286",
        "lat": "45.650092",
        "long": "24.335064"
      },
      {
        "name": "SEBESU DE SUS",
        "zip": "557196",
        "lat": "45.653016",
        "long": "24.355329"
      },
      {
        "name": "SEICA MARE",
        "zip": "557245",
        "lat": "46.024693",
        "long": "24.156344"
      },
      {
        "name": "SEICA MICA",
        "zip": "557255",
        "lat": "46.054806",
        "long": "24.13026"
      },
      {
        "name": "SELIMBAR",
        "zip": "557260",
        "lat": "45.769437",
        "long": "24.190966"
      },
      {
        "name": "SIBIEL",
        "zip": "557234",
        "lat": "45.766122",
        "long": "23.908118"
      },
      {
        "name": "SIBIU",
        "zip": "550003",
        "lat": "45.797391",
        "long": "24.15192"
      },
      {
        "name": "SLIMNIC",
        "zip": "557240",
        "lat": "45.919057",
        "long": "24.15411"
      },
      {
        "name": "SMIG",
        "zip": "557024",
        "lat": "46.225252",
        "long": "24.445393"
      },
      {
        "name": "SOALA",
        "zip": "557027",
        "lat": "46.058688",
        "long": "24.26543"
      },
      {
        "name": "SOMARTIN",
        "zip": "557067",
        "lat": "45.85529",
        "long": "24.668929"
      },
      {
        "name": "SOROSTIN",
        "zip": "557256",
        "lat": "46.029242",
        "long": "24.061076"
      },
      {
        "name": "STEJARISU",
        "zip": "557109",
        "lat": "46.038487",
        "long": "24.676673"
      },
      {
        "name": "STENEA",
        "zip": "557251",
        "lat": "45.975742",
        "long": "24.23875"
      },
      {
        "name": "SURA MARE",
        "zip": "557265",
        "lat": "45.852574",
        "long": "24.169889"
      },
      {
        "name": "SURA MICA",
        "zip": "557270",
        "lat": "45.83206",
        "long": "24.0571"
      },
      {
        "name": "TALMACEL",
        "zip": "555706",
        "lat": "45.647479",
        "long": "24.243433"
      },
      {
        "name": "TALMACIU",
        "zip": "555700",
        "lat": "45.667512",
        "long": "24.261518"
      },
      {
        "name": "TAPU",
        "zip": "557147",
        "lat": "46.07383",
        "long": "24.093152"
      },
      {
        "name": "TARNAVA",
        "zip": "557275",
        "lat": "46.138601",
        "long": "24.294714"
      },
      {
        "name": "TELINE",
        "zip": "557062",
        "lat": "46.075373",
        "long": "24.904504"
      },
      {
        "name": "TICHINDEAL",
        "zip": "557169",
        "lat": "45.869071",
        "long": "24.388804"
      },
      {
        "name": "TILISCA",
        "zip": "557280",
        "lat": "45.798661",
        "long": "23.845601"
      },
      {
        "name": "TOPARCEA",
        "zip": "555601",
        "lat": "45.88555",
        "long": "23.9561"
      },
      {
        "name": "TURNU ROSU",
        "zip": "557285",
        "lat": "45.641525",
        "long": "24.299136"
      },
      {
        "name": "VALCHID",
        "zip": "557102",
        "lat": "46.169811",
        "long": "24.5831"
      },
      {
        "name": "VALE",
        "zip": "557236",
        "lat": "45.781759",
        "long": "23.895343"
      },
      {
        "name": "VALEA LUNGA",
        "zip": "557092",
        "lat": "46.189708",
        "long": "24.370639"
      },
      {
        "name": "VALEA VIILOR",
        "zip": "557290",
        "lat": "46.08183",
        "long": "24.278887"
      },
      {
        "name": "VALENI",
        "zip": "557148",
        "lat": "46.124865",
        "long": "24.13132"
      },
      {
        "name": "VARD",
        "zip": "557082",
        "lat": "45.946034",
        "long": "24.602298"
      },
      {
        "name": "VECERD",
        "zip": "557039",
        "lat": "45.98397",
        "long": "24.455309"
      },
      {
        "name": "VELT",
        "zip": "557032",
        "lat": "46.239268",
        "long": "24.281083"
      },
      {
        "name": "VESEUD",
        "zip": "557083",
        "lat": "45.929641",
        "long": "24.641285"
      },
      {
        "name": "VESEUD",
        "zip": "557244",
        "lat": "45.977636",
        "long": "24.192348"
      },
      {
        "name": "VESTEM",
        "zip": "557263",
        "lat": "45.717862",
        "long": "24.238826"
      },
      {
        "name": "VURPAR",
        "zip": "557295",
        "lat": "45.894987",
        "long": "24.341976"
      },
      {
        "name": "ZLAGNA",
        "zip": "557041",
        "lat": "46.032323",
        "long": "24.470342"
      }
    ],
    "SUCEAVA": [
      {
        "name": "ADANCATA",
        "zip": "727005",
        "lat": "47.735122",
        "long": "26.295103"
      },
      {
        "name": "ANTOCENI",
        "zip": "727236",
        "lat": "47.332721",
        "long": "26.47642"
      },
      {
        "name": "ARBORE",
        "zip": "727015",
        "lat": "47.731267",
        "long": "25.920002"
      },
      {
        "name": "ARGEL",
        "zip": "727386",
        "lat": "47.761358",
        "long": "25.470489"
      },
      {
        "name": "ARGESTRU",
        "zip": "725701",
        "lat": "47.382961",
        "long": "25.319749"
      },
      {
        "name": "ARGHIRA",
        "zip": "727446",
        "lat": "47.454121",
        "long": "26.472496"
      },
      {
        "name": "ARTARI",
        "zip": "727006",
        "lat": "47.763597",
        "long": "26.318336"
      },
      {
        "name": "BADEUTI",
        "zip": "727361",
        "lat": "47.802517",
        "long": "25.983768"
      },
      {
        "name": "BADRAGI",
        "zip": "727631",
        "lat": "47.876462",
        "long": "26.160194"
      },
      {
        "name": "BAHNA ARIN",
        "zip": "727447",
        "lat": "47.488575",
        "long": "26.441476"
      },
      {
        "name": "BAIA",
        "zip": "727020",
        "lat": "47.418317",
        "long": "26.219004"
      },
      {
        "name": "BAINET",
        "zip": "727391",
        "lat": "47.967374",
        "long": "25.944963"
      },
      {
        "name": "BAISESTI",
        "zip": "727141",
        "lat": "47.480238",
        "long": "26.111147"
      },
      {
        "name": "BALACEANA",
        "zip": "727126",
        "lat": "47.64338",
        "long": "26.047637"
      },
      {
        "name": "BALCAUTI",
        "zip": "727025",
        "lat": "47.892643",
        "long": "26.076976"
      },
      {
        "name": "BALINESTI",
        "zip": "727286",
        "lat": "47.904635",
        "long": "26.172407"
      },
      {
        "name": "BANCESTI",
        "zip": "727392",
        "lat": "47.956013",
        "long": "26.010816"
      },
      {
        "name": "BANESTI",
        "zip": "727231",
        "lat": "47.589462",
        "long": "26.523354"
      },
      {
        "name": "BARASTI",
        "zip": "727041",
        "lat": "47.363178",
        "long": "26.353832"
      },
      {
        "name": "BASARABI",
        "zip": "727448",
        "lat": "47.453704",
        "long": "26.439724"
      },
      {
        "name": "BENIA",
        "zip": "727381",
        "lat": "47.664587",
        "long": "25.266969"
      },
      {
        "name": "BERCHISESTI",
        "zip": "727216",
        "lat": "47.523057",
        "long": "26.032069"
      },
      {
        "name": "BERESTI",
        "zip": "727007",
        "lat": "47.782782",
        "long": "26.334714"
      },
      {
        "name": "BILCA",
        "zip": "727030",
        "lat": "47.918263",
        "long": "25.75457"
      },
      {
        "name": "BIVOLARIE",
        "zip": "727611",
        "lat": "47.914768",
        "long": "25.655628"
      },
      {
        "name": "BOBEICA",
        "zip": "727331",
        "lat": "47.728701",
        "long": "25.13678"
      },
      {
        "name": "BODNARENI",
        "zip": "727016",
        "lat": "47.758017",
        "long": "25.933432"
      },
      {
        "name": "BOGATA",
        "zip": "727021",
        "lat": "47.407894",
        "long": "26.186552"
      },
      {
        "name": "BOGDANESTI",
        "zip": "727035",
        "lat": "47.366711",
        "long": "26.273864"
      },
      {
        "name": "BOROAIA",
        "zip": "727040",
        "lat": "47.34904",
        "long": "26.338"
      },
      {
        "name": "BOSANCI",
        "zip": "727045",
        "lat": "47.586727",
        "long": "26.31745"
      },
      {
        "name": "BOTESTI",
        "zip": "727311",
        "lat": "47.51618",
        "long": "26.133805"
      },
      {
        "name": "BOTOS",
        "zip": "727121",
        "lat": "47.51752",
        "long": "25.221826"
      },
      {
        "name": "BOTOSANA",
        "zip": "727050",
        "lat": "47.687396",
        "long": "25.943422"
      },
      {
        "name": "BOTOSANITA MARE",
        "zip": "727106",
        "lat": "47.875336",
        "long": "26.106033"
      },
      {
        "name": "BOTOSANITA MICA",
        "zip": "727287",
        "lat": "47.885202",
        "long": "26.129572"
      },
      {
        "name": "BOTUS",
        "zip": "727266",
        "lat": "47.559883",
        "long": "25.341736"
      },
      {
        "name": "BOTUSEL",
        "zip": "727267",
        "lat": "47.578163",
        "long": "25.298186"
      },
      {
        "name": "BOURA",
        "zip": "727237",
        "lat": "47.410571",
        "long": "26.480782"
      },
      {
        "name": "BRADATEL",
        "zip": "727312",
        "lat": "47.499382",
        "long": "26.164504"
      },
      {
        "name": "BRAIESTI",
        "zip": "727142",
        "lat": "47.496728",
        "long": "26.071817"
      },
      {
        "name": "BRANISTEA",
        "zip": "727268",
        "lat": "47.58689",
        "long": "25.339968"
      },
      {
        "name": "BRASCA",
        "zip": "727127",
        "lat": "47.624515",
        "long": "26.059785"
      },
      {
        "name": "BREAZA",
        "zip": "727055",
        "lat": "47.612776",
        "long": "25.321647"
      },
      {
        "name": "BREAZA DE SUS",
        "zip": "727056",
        "lat": "47.649134",
        "long": "25.310617"
      },
      {
        "name": "BRODINA",
        "zip": "727060",
        "lat": "47.884934",
        "long": "25.428165"
      },
      {
        "name": "BRODINA",
        "zip": "727332",
        "lat": "47.779477",
        "long": "25.269136"
      },
      {
        "name": "BRODINA DE JOS",
        "zip": "727061",
        "lat": "47.820638",
        "long": "25.398048"
      },
      {
        "name": "BROSTENI",
        "zip": "727075",
        "lat": "47.239192",
        "long": "25.697919"
      },
      {
        "name": "BROSTENI",
        "zip": "727221",
        "lat": "47.304588",
        "long": "26.556246"
      },
      {
        "name": "BUCSOAIA",
        "zip": "727246",
        "lat": "47.540733",
        "long": "25.822747"
      },
      {
        "name": "BUDA",
        "zip": "727466",
        "lat": "47.369453",
        "long": "26.169955"
      },
      {
        "name": "BUDA",
        "zip": "727641",
        "lat": "47.838972",
        "long": "26.261167"
      },
      {
        "name": "BUDENI",
        "zip": "727171",
        "lat": "47.413839",
        "long": "26.659257"
      },
      {
        "name": "BULAI",
        "zip": "727371",
        "lat": "47.61551",
        "long": "26.221223"
      },
      {
        "name": "BUNESTI",
        "zip": "727090",
        "lat": "47.525188",
        "long": "26.281163"
      },
      {
        "name": "BURLA",
        "zip": "727616",
        "lat": "47.790331",
        "long": "25.926956"
      },
      {
        "name": "BURSUCENI",
        "zip": "727601",
        "lat": "47.650972",
        "long": "26.475303"
      },
      {
        "name": "CACICA",
        "zip": "727095",
        "lat": "47.63601",
        "long": "25.911803"
      },
      {
        "name": "CAJVANA",
        "zip": "727100",
        "lat": "47.701699",
        "long": "25.966924"
      },
      {
        "name": "CALAFINDESTI",
        "zip": "727105",
        "lat": "47.856223",
        "long": "26.125919"
      },
      {
        "name": "CALINESTI",
        "zip": "727107",
        "lat": "47.802462",
        "long": "26.153507"
      },
      {
        "name": "CALINESTI",
        "zip": "727156",
        "lat": "47.775819",
        "long": "26.135634"
      },
      {
        "name": "CALINESTI-VASILACHE",
        "zip": "727157",
        "lat": "47.79053",
        "long": "26.122023"
      },
      {
        "name": "CALUGARENI",
        "zip": "727008",
        "lat": "47.76471",
        "long": "26.287163"
      },
      {
        "name": "CAMARZANI",
        "zip": "727561",
        "lat": "47.384652",
        "long": "26.386483"
      },
      {
        "name": "CAMPULUNG MOLDOVENESC",
        "zip": "725100",
        "lat": "47.529776",
        "long": "25.559748"
      },
      {
        "name": "CAPU CAMPULUI",
        "zip": "727585",
        "lat": "47.50822",
        "long": "25.979593"
      },
      {
        "name": "CAPU CODRULUI",
        "zip": "727416",
        "lat": "47.531682",
        "long": "25.986385"
      },
      {
        "name": "CARLIBABA",
        "zip": "727110",
        "lat": "47.575834",
        "long": "25.126671"
      },
      {
        "name": "CARLIBABA NOUA",
        "zip": "727111",
        "lat": "47.570768",
        "long": "25.126943"
      },
      {
        "name": "CASOI",
        "zip": "727431",
        "lat": "47.300694",
        "long": "25.102512"
      },
      {
        "name": "CATRINARI",
        "zip": "727406",
        "lat": "47.187535",
        "long": "25.457511"
      },
      {
        "name": "CHILISENI",
        "zip": "727536",
        "lat": "47.56075",
        "long": "26.477815"
      },
      {
        "name": "CHIRIL",
        "zip": "727151",
        "lat": "47.392453",
        "long": "25.576198"
      },
      {
        "name": "CIOCANESTI",
        "zip": "727120",
        "lat": "47.481066",
        "long": "25.27912"
      },
      {
        "name": "CIOMARTAN",
        "zip": "727632",
        "lat": "47.872505",
        "long": "26.178978999999998"
      },
      {
        "name": "CIPRIAN PORUMBESCU",
        "zip": "727125",
        "lat": "47.571727",
        "long": "26.066267"
      },
      {
        "name": "CIUMARNA",
        "zip": "727596",
        "lat": "47.710218",
        "long": "25.611572"
      },
      {
        "name": "CIUMULESTI",
        "zip": "727562",
        "lat": "47.374137",
        "long": "26.392369"
      },
      {
        "name": "CLIMAUTI",
        "zip": "727393",
        "lat": "47.965859",
        "long": "25.927488"
      },
      {
        "name": "CLIT",
        "zip": "727017",
        "lat": "47.757567",
        "long": "25.849557"
      },
      {
        "name": "CODRU",
        "zip": "727101",
        "lat": "47.726171",
        "long": "26.016787"
      },
      {
        "name": "COJOCARENI",
        "zip": "727633",
        "lat": "47.85907",
        "long": "26.218213"
      },
      {
        "name": "COJOCI",
        "zip": "727152",
        "lat": "47.380746",
        "long": "25.580245"
      },
      {
        "name": "COLACU",
        "zip": "727269",
        "lat": "47.538301",
        "long": "25.372108"
      },
      {
        "name": "COMANESTI",
        "zip": "727135",
        "lat": "47.669493",
        "long": "25.987499"
      },
      {
        "name": "CORLATA",
        "zip": "727217",
        "lat": "47.544017",
        "long": "26.04174"
      },
      {
        "name": "CORNI",
        "zip": "727336",
        "lat": "47.473768",
        "long": "26.561258"
      },
      {
        "name": "CORNU LUNCII",
        "zip": "727140",
        "lat": "47.463518",
        "long": "26.152398"
      },
      {
        "name": "COROCAIESTI",
        "zip": "727602",
        "lat": "47.63831",
        "long": "26.487742"
      },
      {
        "name": "CORPACI",
        "zip": "727634",
        "lat": "47.865488",
        "long": "26.169199"
      },
      {
        "name": "COSNA",
        "zip": "727191",
        "lat": "47.370575",
        "long": "25.179346"
      },
      {
        "name": "COSTANA",
        "zip": "727531",
        "lat": "47.692645",
        "long": "26.119005"
      },
      {
        "name": "COSTILEVA",
        "zip": "727556",
        "lat": "47.880923",
        "long": "25.235336"
      },
      {
        "name": "COSTISA",
        "zip": "727251",
        "lat": "47.92176",
        "long": "25.907471"
      },
      {
        "name": "COTARGASI",
        "zip": "727076",
        "lat": "47.264493",
        "long": "25.760175"
      },
      {
        "name": "COTU BAII",
        "zip": "727563",
        "lat": "47.419304",
        "long": "26.281759"
      },
      {
        "name": "COTU DOBEI",
        "zip": "727232",
        "lat": "47.587372",
        "long": "26.473378"
      },
      {
        "name": "COVERCA",
        "zip": "727407",
        "lat": "47.231086",
        "long": "25.395294"
      },
      {
        "name": "COZANESTI",
        "zip": "727201",
        "lat": "47.343092",
        "long": "25.428707"
      },
      {
        "name": "CRUCEA",
        "zip": "727150",
        "lat": "47.350606",
        "long": "25.611277"
      },
      {
        "name": "CUMPARATURA",
        "zip": "727046",
        "lat": "47.570708",
        "long": "26.273899"
      },
      {
        "name": "CUNUNSCHI",
        "zip": "727062",
        "lat": "47.785692",
        "long": "25.348009"
      },
      {
        "name": "DANILA",
        "zip": "727158",
        "lat": "47.751941",
        "long": "26.101733"
      },
      {
        "name": "DARMANESTI",
        "zip": "727155",
        "lat": "47.734782",
        "long": "26.149274"
      },
      {
        "name": "DARMOXA",
        "zip": "727077",
        "lat": "47.185625",
        "long": "25.544607"
      },
      {
        "name": "DEALU",
        "zip": "727642",
        "lat": "47.830653",
        "long": "26.263778"
      },
      {
        "name": "DEALU FLORENI",
        "zip": "727192",
        "lat": "47.35967",
        "long": "25.227093"
      },
      {
        "name": "DEIA",
        "zip": "727261",
        "lat": "47.595118",
        "long": "25.619383"
      },
      {
        "name": "DELENI",
        "zip": "727426",
        "lat": "47.62946",
        "long": "25.974829"
      },
      {
        "name": "DELNITA",
        "zip": "727271",
        "lat": "47.537308",
        "long": "25.308876"
      },
      {
        "name": "DELUT",
        "zip": "727272",
        "lat": "47.558813",
        "long": "25.292164"
      },
      {
        "name": "DEMACUSA",
        "zip": "727387",
        "lat": "47.697166",
        "long": "25.504985"
      },
      {
        "name": "DOLHASCA",
        "zip": "727170",
        "lat": "47.426148",
        "long": "26.611131"
      },
      {
        "name": "DOLHESTII MARI",
        "zip": "727185",
        "lat": "47.450204",
        "long": "26.513262"
      },
      {
        "name": "DOLHESTII MICI",
        "zip": "727181",
        "lat": "47.436327",
        "long": "26.551784"
      },
      {
        "name": "DORNA CANDRENILOR",
        "zip": "727190",
        "lat": "47.355518000000004",
        "long": "25.257652"
      },
      {
        "name": "DORNA-ARINI",
        "zip": "727200",
        "lat": "47.338394",
        "long": "25.407643"
      },
      {
        "name": "DORNESTI",
        "zip": "727210",
        "lat": "47.871173",
        "long": "26.001095"
      },
      {
        "name": "DORNISOARA",
        "zip": "727432",
        "lat": "47.216275",
        "long": "25.08417"
      },
      {
        "name": "DOROTEIA",
        "zip": "727247",
        "lat": "47.500273",
        "long": "25.798033"
      },
      {
        "name": "DRAGOIASA",
        "zip": "727408",
        "lat": "47.1669",
        "long": "25.4332"
      },
      {
        "name": "DRAGOIESTI",
        "zip": "727215",
        "lat": "47.545625",
        "long": "26.084505"
      },
      {
        "name": "DRAGOMIRNA",
        "zip": "727366",
        "lat": "47.759477",
        "long": "26.226758"
      },
      {
        "name": "DRAGOSA",
        "zip": "727262",
        "lat": "47.648949",
        "long": "25.635761"
      },
      {
        "name": "DRAGUSENI",
        "zip": "727220",
        "lat": "47.297251",
        "long": "26.490228"
      },
      {
        "name": "DUBIUSCA",
        "zip": "727063",
        "lat": "47.79545",
        "long": "25.409701"
      },
      {
        "name": "DUMBRAVA",
        "zip": "727143",
        "lat": "47.4879",
        "long": "26.153721"
      },
      {
        "name": "DUMBRAVA",
        "zip": "727291",
        "lat": "47.800706",
        "long": "26.096208"
      },
      {
        "name": "DUMBRAVENI",
        "zip": "727225",
        "lat": "47.661",
        "long": "26.424569"
      },
      {
        "name": "DUMBRAVENI",
        "zip": "727467",
        "lat": "47.355473",
        "long": "26.187653"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "727564",
        "lat": "47.398455",
        "long": "26.345782"
      },
      {
        "name": "EHRESTE",
        "zip": "727064",
        "lat": "47.824208",
        "long": "25.344205"
      },
      {
        "name": "FALCAU",
        "zip": "727066",
        "lat": "47.910866",
        "long": "25.469081"
      },
      {
        "name": "FALTICENI",
        "zip": "725200",
        "lat": "47.459637",
        "long": "26.303942"
      },
      {
        "name": "FANTANA MARE",
        "zip": "727566",
        "lat": "47.414323",
        "long": "26.300154"
      },
      {
        "name": "FANTANELE",
        "zip": "727230",
        "lat": "47.578079",
        "long": "26.523553"
      },
      {
        "name": "FETESTI",
        "zip": "727009",
        "lat": "47.70631",
        "long": "26.339138"
      },
      {
        "name": "FLORINTA",
        "zip": "727526",
        "lat": "47.64601",
        "long": "26.128976"
      },
      {
        "name": "FORASTI",
        "zip": "727235",
        "lat": "47.349385",
        "long": "26.467031"
      },
      {
        "name": "FRASIN",
        "zip": "727078",
        "lat": "47.220541",
        "long": "25.737501"
      },
      {
        "name": "FRASIN",
        "zip": "727245",
        "lat": "47.540441",
        "long": "25.79357"
      },
      {
        "name": "FRATAUTII NOI",
        "zip": "727250",
        "lat": "47.929604",
        "long": "25.83996"
      },
      {
        "name": "FRATAUTII VECHI",
        "zip": "727255",
        "lat": "47.913201",
        "long": "25.871317"
      },
      {
        "name": "FRUMOASA",
        "zip": "727372",
        "lat": "47.596502",
        "long": "26.19183"
      },
      {
        "name": "FRUMOSU",
        "zip": "727260",
        "lat": "47.606808",
        "long": "25.647979"
      },
      {
        "name": "FUNDU MOLDOVEI",
        "zip": "727265",
        "lat": "47.52909",
        "long": "25.432556"
      },
      {
        "name": "GAINESTI",
        "zip": "727491",
        "lat": "47.419677",
        "long": "25.918088"
      },
      {
        "name": "GALANESTI",
        "zip": "727280",
        "lat": "47.911869",
        "long": "25.804268"
      },
      {
        "name": "GARA",
        "zip": "727362",
        "lat": "47.776747",
        "long": "26.026616"
      },
      {
        "name": "GARA LEU",
        "zip": "727222",
        "lat": "47.333264",
        "long": "26.522037"
      },
      {
        "name": "GEMENEA",
        "zip": "727506",
        "lat": "47.438031",
        "long": "25.701205"
      },
      {
        "name": "GHEORGHITENI",
        "zip": "727202",
        "lat": "47.361459",
        "long": "25.443001"
      },
      {
        "name": "GIULESTI",
        "zip": "727042",
        "lat": "47.348646",
        "long": "26.380004"
      },
      {
        "name": "GIURGESTI",
        "zip": "727621",
        "lat": "47.50381",
        "long": "26.42305"
      },
      {
        "name": "GLODU",
        "zip": "727409",
        "lat": "47.160961",
        "long": "25.476555"
      },
      {
        "name": "GRAMESTI",
        "zip": "727285",
        "lat": "47.912831",
        "long": "26.147997"
      },
      {
        "name": "GRANICESTI",
        "zip": "727290",
        "lat": "47.809397",
        "long": "26.05409"
      },
      {
        "name": "GRIGORESTI",
        "zip": "727486",
        "lat": "47.719072",
        "long": "26.383337"
      },
      {
        "name": "GROAPA VLADICHII",
        "zip": "727373",
        "lat": "47.54971",
        "long": "26.245744"
      },
      {
        "name": "GROPENI",
        "zip": "727026",
        "lat": "47.897618",
        "long": "26.100883"
      },
      {
        "name": "GULIA",
        "zip": "727172",
        "lat": "47.412032",
        "long": "26.608549"
      },
      {
        "name": "GURA HAITII",
        "zip": "727516",
        "lat": "47.197257",
        "long": "25.263759"
      },
      {
        "name": "GURA HUMORULUI",
        "zip": "725300",
        "lat": "47.553427",
        "long": "25.893272"
      },
      {
        "name": "GURA PUTNEI",
        "zip": "727456",
        "lat": "47.899508",
        "long": "25.595096"
      },
      {
        "name": "GURA SOLCII",
        "zip": "727292",
        "lat": "47.740931",
        "long": "26.05014"
      },
      {
        "name": "HALEASA",
        "zip": "727079",
        "lat": "47.234501",
        "long": "25.717275"
      },
      {
        "name": "HANCEA",
        "zip": "727603",
        "lat": "47.601822",
        "long": "26.453892"
      },
      {
        "name": "HANTESTI",
        "zip": "727011",
        "lat": "47.756592",
        "long": "26.36823"
      },
      {
        "name": "HARTOP",
        "zip": "727449",
        "lat": "47.490002",
        "long": "26.37226"
      },
      {
        "name": "HERLA",
        "zip": "727492",
        "lat": "47.442856",
        "long": "26.012537"
      },
      {
        "name": "HOLDA",
        "zip": "727081",
        "lat": "47.259333",
        "long": "25.680414"
      },
      {
        "name": "HOLDITA",
        "zip": "727082",
        "lat": "47.255147",
        "long": "25.698562"
      },
      {
        "name": "HORODNIC DE JOS",
        "zip": "727301",
        "lat": "47.860919",
        "long": "25.832425"
      },
      {
        "name": "HORODNIC DE SUS",
        "zip": "727305",
        "lat": "47.837126",
        "long": "25.824961"
      },
      {
        "name": "HORODNICENI",
        "zip": "727310",
        "lat": "47.528481",
        "long": "26.163405"
      },
      {
        "name": "HREATCA",
        "zip": "727622",
        "lat": "47.527228",
        "long": "26.354413"
      },
      {
        "name": "HUMORENI",
        "zip": "727136",
        "lat": "47.654869",
        "long": "25.987675"
      },
      {
        "name": "HURJUIENI",
        "zip": "727281",
        "lat": "47.913469",
        "long": "25.836852"
      },
      {
        "name": "HUSI",
        "zip": "727451",
        "lat": "47.447365",
        "long": "26.387555"
      },
      {
        "name": "IACOBENI",
        "zip": "727315",
        "lat": "47.417282",
        "long": "25.309969"
      },
      {
        "name": "IACOBESTI",
        "zip": "727293",
        "lat": "47.765506",
        "long": "26.085299"
      },
      {
        "name": "IASLOVAT",
        "zip": "727320",
        "lat": "47.758618",
        "long": "25.977421"
      },
      {
        "name": "IAZ",
        "zip": "727211",
        "lat": "47.907267",
        "long": "25.981239"
      },
      {
        "name": "IEDU",
        "zip": "727112",
        "lat": "47.620617",
        "long": "25.107918"
      },
      {
        "name": "IESLE",
        "zip": "727351",
        "lat": "47.318493",
        "long": "25.918756"
      },
      {
        "name": "ILISESTI",
        "zip": "727130",
        "lat": "47.608777",
        "long": "26.050612"
      },
      {
        "name": "IONEASA",
        "zip": "727567",
        "lat": "47.369379",
        "long": "26.438261"
      },
      {
        "name": "IPOTESTI",
        "zip": "727325",
        "lat": "47.621905",
        "long": "26.284714"
      },
      {
        "name": "IZVOARELE SUCEVEI",
        "zip": "727330",
        "lat": "47.762406",
        "long": "25.175232"
      },
      {
        "name": "JACOTA",
        "zip": "727623",
        "lat": "47.509836",
        "long": "26.389766"
      },
      {
        "name": "JAHALIA",
        "zip": "727468",
        "lat": "47.379926",
        "long": "26.239915"
      },
      {
        "name": "LAMASENI",
        "zip": "727461",
        "lat": "47.493312",
        "long": "26.227047"
      },
      {
        "name": "LEUCUSESTI",
        "zip": "727452",
        "lat": "47.427507",
        "long": "26.373067"
      },
      {
        "name": "LIPOVENI",
        "zip": "727367",
        "lat": "47.724587",
        "long": "26.22562"
      },
      {
        "name": "LISAURA",
        "zip": "727326",
        "lat": "47.638241",
        "long": "26.29758"
      },
      {
        "name": "LITENI",
        "zip": "727335",
        "lat": "47.52049",
        "long": "26.528299"
      },
      {
        "name": "LITENI",
        "zip": "727374",
        "lat": "47.570915",
        "long": "26.181812"
      },
      {
        "name": "LUCACESTI",
        "zip": "727218",
        "lat": "47.531616",
        "long": "26.106813"
      },
      {
        "name": "LUNCA",
        "zip": "727363",
        "lat": "47.768514",
        "long": "26.011672"
      },
      {
        "name": "LUNCA",
        "zip": "727636",
        "lat": "47.889438",
        "long": "26.223174"
      },
      {
        "name": "LUNCUSOARA",
        "zip": "727537",
        "lat": "47.596236",
        "long": "26.359469"
      },
      {
        "name": "LUNGENI",
        "zip": "727083",
        "lat": "47.233434",
        "long": "25.725844"
      },
      {
        "name": "LUPCINA",
        "zip": "727557",
        "lat": "47.831121",
        "long": "25.247443"
      },
      {
        "name": "MAGURA",
        "zip": "727558",
        "lat": "47.82187",
        "long": "25.235647"
      },
      {
        "name": "MAIDAN",
        "zip": "727096",
        "lat": "47.662461",
        "long": "25.823757"
      },
      {
        "name": "MALINI",
        "zip": "727350",
        "lat": "47.454256",
        "long": "26.085683"
      },
      {
        "name": "MANASTIOARA",
        "zip": "725501",
        "lat": "47.941344",
        "long": "26.032463"
      },
      {
        "name": "MANASTIOARA",
        "zip": "727538",
        "lat": "47.554303",
        "long": "26.397863"
      },
      {
        "name": "MANASTIREA HUMORULUI",
        "zip": "727355",
        "lat": "47.595428",
        "long": "25.857837"
      },
      {
        "name": "MANEUTI",
        "zip": "727256",
        "lat": "47.899824",
        "long": "25.927406"
      },
      {
        "name": "MANOLEA",
        "zip": "727238",
        "lat": "47.398691",
        "long": "26.475075"
      },
      {
        "name": "MARGINEA",
        "zip": "727345",
        "lat": "47.808957",
        "long": "25.821692"
      },
      {
        "name": "MARITEI",
        "zip": "727160",
        "lat": "47.747303",
        "long": "26.12995"
      },
      {
        "name": "MARITEIA MICA",
        "zip": "727159",
        "lat": "47.74947",
        "long": "26.113724"
      },
      {
        "name": "MAZANAESTI",
        "zip": "727219",
        "lat": "47.527954",
        "long": "26.084013"
      },
      {
        "name": "MERENI",
        "zip": "727476",
        "lat": "47.663839",
        "long": "26.322567"
      },
      {
        "name": "MERESTI",
        "zip": "727624",
        "lat": "47.549205",
        "long": "26.40808"
      },
      {
        "name": "MESTECANIS",
        "zip": "727316",
        "lat": "47.455792",
        "long": "25.335201"
      },
      {
        "name": "MESTECENI",
        "zip": "727568",
        "lat": "47.401096",
        "long": "26.419366"
      },
      {
        "name": "MIHAIESTI",
        "zip": "727313",
        "lat": "47.515631",
        "long": "26.217339"
      },
      {
        "name": "MIHOVENI",
        "zip": "727527",
        "lat": "47.67994",
        "long": "26.182202"
      },
      {
        "name": "MILISAUTI",
        "zip": "727360",
        "lat": "47.790632",
        "long": "25.994336"
      },
      {
        "name": "MIRONU",
        "zip": "727581",
        "lat": "47.487985",
        "long": "26.009519"
      },
      {
        "name": "MITOCASI",
        "zip": "727368",
        "lat": "47.728585",
        "long": "26.260866"
      },
      {
        "name": "MITOCU DRAGOMIRNEI",
        "zip": "727365",
        "lat": "47.723914",
        "long": "26.244383"
      },
      {
        "name": "MOARA CARP",
        "zip": "727376",
        "lat": "47.581797",
        "long": "26.230526"
      },
      {
        "name": "MOARA NICA",
        "zip": "727377",
        "lat": "47.60086",
        "long": "26.222615"
      },
      {
        "name": "MOISA",
        "zip": "727043",
        "lat": "47.332569",
        "long": "26.287026"
      },
      {
        "name": "MOLDOVA-SULITA",
        "zip": "727380",
        "lat": "47.693165",
        "long": "25.241723"
      },
      {
        "name": "MOLDOVITA",
        "zip": "727385",
        "lat": "47.688158",
        "long": "25.540065"
      },
      {
        "name": "MOLID",
        "zip": "727591",
        "lat": "47.567727",
        "long": "25.7314"
      },
      {
        "name": "MOVILENI",
        "zip": "727569",
        "lat": "47.400907",
        "long": "26.409141"
      },
      {
        "name": "MUSENITA",
        "zip": "727390",
        "lat": "47.962162",
        "long": "25.977159"
      },
      {
        "name": "NEAGRA",
        "zip": "727084",
        "lat": "47.233546",
        "long": "25.696017"
      },
      {
        "name": "NEAGRA SARULUI",
        "zip": "727517",
        "lat": "47.240528",
        "long": "25.331196"
      },
      {
        "name": "NEGOSTINA",
        "zip": "727027",
        "lat": "47.922815",
        "long": "26.082089"
      },
      {
        "name": "NEGRILEASA",
        "zip": "727507",
        "lat": "47.42348",
        "long": "25.816171"
      },
      {
        "name": "NICANI",
        "zip": "727637",
        "lat": "47.867053",
        "long": "26.227839"
      },
      {
        "name": "NIGOTESTI",
        "zip": "727571",
        "lat": "47.382929",
        "long": "26.43282"
      },
      {
        "name": "NISIPITU",
        "zip": "727559",
        "lat": "47.87288",
        "long": "25.327019"
      },
      {
        "name": "NOROCU",
        "zip": "727067",
        "lat": "47.901465",
        "long": "25.397655"
      },
      {
        "name": "OBCINA",
        "zip": "727273",
        "lat": "47.572302",
        "long": "25.273585"
      },
      {
        "name": "ONICENI",
        "zip": "727239",
        "lat": "47.324409",
        "long": "26.462166"
      },
      {
        "name": "ORTOAIA",
        "zip": "727203",
        "lat": "47.347971",
        "long": "25.436241"
      },
      {
        "name": "OSOI",
        "zip": "727626",
        "lat": "47.520579",
        "long": "26.460614"
      },
      {
        "name": "OSTRA",
        "zip": "727400",
        "lat": "47.396731",
        "long": "25.754622"
      },
      {
        "name": "PADURENI",
        "zip": "725502",
        "lat": "47.950131",
        "long": "26.105864"
      },
      {
        "name": "PAISENI",
        "zip": "727144",
        "lat": "47.429795",
        "long": "26.109712"
      },
      {
        "name": "PALTIN",
        "zip": "727068",
        "lat": "47.867189",
        "long": "25.344231"
      },
      {
        "name": "PALTINIS",
        "zip": "727411",
        "lat": "47.193594",
        "long": "25.428441"
      },
      {
        "name": "PALTINOASA",
        "zip": "727415",
        "lat": "47.550695",
        "long": "25.955084"
      },
      {
        "name": "PALTINU",
        "zip": "727597",
        "lat": "47.630403",
        "long": "25.545836"
      },
      {
        "name": "PANACI",
        "zip": "727405",
        "lat": "47.247018",
        "long": "25.382895"
      },
      {
        "name": "PARAIE",
        "zip": "727352",
        "lat": "47.462993",
        "long": "26.066085"
      },
      {
        "name": "PARAU NEGREI",
        "zip": "727057",
        "lat": "47.608456",
        "long": "25.350178"
      },
      {
        "name": "PARHAUTI",
        "zip": "727532",
        "lat": "47.710645",
        "long": "26.090204"
      },
      {
        "name": "PARTESTII DE JOS",
        "zip": "727425",
        "lat": "47.638871",
        "long": "25.944862"
      },
      {
        "name": "PARTESTII DE SUS",
        "zip": "727097",
        "lat": "47.646664",
        "long": "25.916676"
      },
      {
        "name": "PATRAUTI",
        "zip": "727420",
        "lat": "47.718935",
        "long": "26.191484"
      },
      {
        "name": "PETIA",
        "zip": "727091",
        "lat": "47.510128",
        "long": "26.319259"
      },
      {
        "name": "PIETROASA",
        "zip": "727086",
        "lat": "47.236616",
        "long": "25.741804"
      },
      {
        "name": "PILUGANI",
        "zip": "727433",
        "lat": "47.331626",
        "long": "25.168293"
      },
      {
        "name": "PLAI",
        "zip": "727274",
        "lat": "47.565253",
        "long": "25.364178"
      },
      {
        "name": "PLAIU SARULUI",
        "zip": "727518",
        "lat": "47.304372",
        "long": "25.379806"
      },
      {
        "name": "PLAVALARI",
        "zip": "727539",
        "lat": "47.568317",
        "long": "26.359247"
      },
      {
        "name": "PLESA",
        "zip": "727356",
        "lat": "47.630658",
        "long": "25.836502"
      },
      {
        "name": "PLESESTI",
        "zip": "727627",
        "lat": "47.522204",
        "long": "26.377922"
      },
      {
        "name": "PLOPENI",
        "zip": "727477",
        "lat": "47.658752",
        "long": "26.339906"
      },
      {
        "name": "PLUTONITA",
        "zip": "727248",
        "lat": "47.480808",
        "long": "25.791452"
      },
      {
        "name": "POCOLENI",
        "zip": "727462",
        "lat": "47.502038",
        "long": "26.266193"
      },
      {
        "name": "PODENI",
        "zip": "727092",
        "lat": "47.51503",
        "long": "26.279892"
      },
      {
        "name": "PODU COSNEI",
        "zip": "727193",
        "lat": "47.360846",
        "long": "25.201118"
      },
      {
        "name": "POIANA",
        "zip": "727173",
        "lat": "47.460443",
        "long": "26.574641"
      },
      {
        "name": "POIANA",
        "zip": "727643",
        "lat": "47.797048",
        "long": "26.275506"
      },
      {
        "name": "POIANA MARULUI",
        "zip": "727353",
        "lat": "47.411877",
        "long": "26.040774"
      },
      {
        "name": "POIANA MICULUI",
        "zip": "727357",
        "lat": "47.656789",
        "long": "25.769507"
      },
      {
        "name": "POIANA NEGRII",
        "zip": "727194",
        "lat": "47.313263",
        "long": "25.213785"
      },
      {
        "name": "POIANA STAMPEI",
        "zip": "727430",
        "lat": "47.310691",
        "long": "25.126943"
      },
      {
        "name": "POIENARI",
        "zip": "727174",
        "lat": "47.388166",
        "long": "26.600592"
      },
      {
        "name": "POIENI-SOLCA",
        "zip": "725601",
        "lat": "47.686256",
        "long": "25.893739"
      },
      {
        "name": "POIENI-SUCEAVA",
        "zip": "727541",
        "lat": "47.573952",
        "long": "26.462692"
      },
      {
        "name": "POJORATA",
        "zip": "727440",
        "lat": "47.524044",
        "long": "25.466678"
      },
      {
        "name": "PRALENI",
        "zip": "727434",
        "lat": "47.338033",
        "long": "25.184286"
      },
      {
        "name": "PRAXIA",
        "zip": "727572",
        "lat": "47.380844",
        "long": "26.317387"
      },
      {
        "name": "PRELIPCA",
        "zip": "727478",
        "lat": "47.610853",
        "long": "26.354136"
      },
      {
        "name": "PREUTESTI",
        "zip": "727445",
        "lat": "47.457601",
        "long": "26.414018"
      },
      {
        "name": "PRISACA DORNEI",
        "zip": "727592",
        "lat": "47.542254",
        "long": "25.656398"
      },
      {
        "name": "PROBOTA",
        "zip": "727176",
        "lat": "47.375868",
        "long": "26.624654"
      },
      {
        "name": "PUTNA",
        "zip": "727455",
        "lat": "47.870765",
        "long": "25.612478"
      },
      {
        "name": "RACOVA",
        "zip": "727542",
        "lat": "47.549424",
        "long": "26.449336"
      },
      {
        "name": "RADASENI",
        "zip": "727460",
        "lat": "47.468802",
        "long": "26.252713"
      },
      {
        "name": "RADAUTI",
        "zip": "725400",
        "lat": "47.846105",
        "long": "25.918182"
      },
      {
        "name": "RASCA",
        "zip": "727388",
        "lat": "47.7452",
        "long": "25.511538"
      },
      {
        "name": "RASCA",
        "zip": "727465",
        "lat": "47.356727",
        "long": "26.234337"
      },
      {
        "name": "RAUTENI",
        "zip": "727638",
        "lat": "47.846285",
        "long": "26.203029"
      },
      {
        "name": "REUSENI",
        "zip": "727543",
        "lat": "47.580725",
        "long": "26.365044"
      },
      {
        "name": "ROMANESTI",
        "zip": "727196",
        "lat": "47.372333",
        "long": "25.152849"
      },
      {
        "name": "ROMANESTI",
        "zip": "727294",
        "lat": "47.778659",
        "long": "26.079111"
      },
      {
        "name": "ROSCANI",
        "zip": "727337",
        "lat": "47.533452",
        "long": "26.549094"
      },
      {
        "name": "ROSIORI",
        "zip": "727241",
        "lat": "47.351145",
        "long": "26.4145"
      },
      {
        "name": "ROSU",
        "zip": "725702",
        "lat": "47.349493",
        "long": "25.313998"
      },
      {
        "name": "ROTOPANESTI",
        "zip": "727314",
        "lat": "47.507914",
        "long": "26.183335"
      },
      {
        "name": "ROTUNDA",
        "zip": "727338",
        "lat": "47.487452",
        "long": "26.524657"
      },
      {
        "name": "RUDESTI",
        "zip": "727288",
        "lat": "47.90357",
        "long": "26.110585"
      },
      {
        "name": "RUNCU",
        "zip": "727098",
        "lat": "47.673656",
        "long": "25.845438"
      },
      {
        "name": "RUSCA",
        "zip": "727204",
        "lat": "47.368401",
        "long": "25.455629"
      },
      {
        "name": "RUSI",
        "zip": "727242",
        "lat": "47.351997",
        "long": "26.43696"
      },
      {
        "name": "RUSII-MANASTIOARA",
        "zip": "727544",
        "lat": "47.591571",
        "long": "26.382115"
      },
      {
        "name": "SACUTA",
        "zip": "727044",
        "lat": "47.317881",
        "long": "26.293288"
      },
      {
        "name": "SADAU",
        "zip": "727069",
        "lat": "47.875666",
        "long": "25.401474"
      },
      {
        "name": "SADOVA",
        "zip": "727470",
        "lat": "47.542482",
        "long": "25.503796"
      },
      {
        "name": "SALAGENI",
        "zip": "727226",
        "lat": "47.677479",
        "long": "26.389516"
      },
      {
        "name": "SALCEA",
        "zip": "727475",
        "lat": "47.650542",
        "long": "26.373895"
      },
      {
        "name": "SARGHIESTI",
        "zip": "727533",
        "lat": "47.726402",
        "long": "26.084388"
      },
      {
        "name": "SARISOR",
        "zip": "727519",
        "lat": "47.259693",
        "long": "25.312746"
      },
      {
        "name": "SARISORU MARE",
        "zip": "727521",
        "lat": "47.271896",
        "long": "25.334078"
      },
      {
        "name": "SARU BUCOVINEI",
        "zip": "727522",
        "lat": "47.290541",
        "long": "25.343732"
      },
      {
        "name": "SARU DORNEI",
        "zip": "727515",
        "lat": "47.291511",
        "long": "25.370803"
      },
      {
        "name": "SASCA MARE",
        "zip": "727146",
        "lat": "47.433579",
        "long": "26.13852"
      },
      {
        "name": "SASCA MICA",
        "zip": "727147",
        "lat": "47.439269",
        "long": "26.178883"
      },
      {
        "name": "SASCA NOUA",
        "zip": "727148",
        "lat": "47.459146",
        "long": "26.193342"
      },
      {
        "name": "SATU MARE",
        "zip": "727153",
        "lat": "47.358097",
        "long": "25.610307"
      },
      {
        "name": "SATU MARE",
        "zip": "727480",
        "lat": "47.831367",
        "long": "26.002395"
      },
      {
        "name": "SCHEIA",
        "zip": "727525",
        "lat": "47.657647",
        "long": "26.228263"
      },
      {
        "name": "SECURICENI",
        "zip": "727546",
        "lat": "47.577151",
        "long": "26.346086"
      },
      {
        "name": "SERBANESTI",
        "zip": "727648",
        "lat": "47.813293",
        "long": "26.310649"
      },
      {
        "name": "SERBAUTI",
        "zip": "727108",
        "lat": "47.826845",
        "long": "26.140091"
      },
      {
        "name": "SES",
        "zip": "727093",
        "lat": "47.51136",
        "long": "26.27501"
      },
      {
        "name": "SESURI",
        "zip": "727113",
        "lat": "47.59697",
        "long": "24.963365"
      },
      {
        "name": "SFANTU ILIE",
        "zip": "727528",
        "lat": "47.636603",
        "long": "26.208373"
      },
      {
        "name": "SILISTEA",
        "zip": "727339",
        "lat": "47.522035",
        "long": "26.479246"
      },
      {
        "name": "SILISTEA NOUA",
        "zip": "727177",
        "lat": "47.450156",
        "long": "26.636367"
      },
      {
        "name": "SIMINICEA",
        "zip": "727485",
        "lat": "47.699897",
        "long": "26.401189"
      },
      {
        "name": "SINCA",
        "zip": "727149",
        "lat": "47.427575",
        "long": "26.158343"
      },
      {
        "name": "SIRET",
        "zip": "725500",
        "lat": "47.951766",
        "long": "26.069387"
      },
      {
        "name": "SLATINA",
        "zip": "727490",
        "lat": "47.446354",
        "long": "26.003282"
      },
      {
        "name": "SLATIOARA",
        "zip": "727469",
        "lat": "47.379194",
        "long": "26.117218"
      },
      {
        "name": "SLATIOARA",
        "zip": "727508",
        "lat": "47.463546",
        "long": "25.667624"
      },
      {
        "name": "SLOBOZIA",
        "zip": "727233",
        "lat": "47.568067",
        "long": "26.553729"
      },
      {
        "name": "SLOBOZIA",
        "zip": "727644",
        "lat": "47.794194",
        "long": "26.321424"
      },
      {
        "name": "SLOBOZIA SUCEVEI",
        "zip": "727296",
        "lat": "47.764277",
        "long": "26.046561"
      },
      {
        "name": "SMIDA UNGURENILOR",
        "zip": "727276",
        "lat": "47.522611",
        "long": "25.341776"
      },
      {
        "name": "SOLCA",
        "zip": "725600",
        "lat": "47.699949",
        "long": "25.837369"
      },
      {
        "name": "SOLDANESTI",
        "zip": "725201",
        "lat": "47.452052",
        "long": "26.32399"
      },
      {
        "name": "SOLONET",
        "zip": "727534",
        "lat": "47.686981",
        "long": "26.032067"
      },
      {
        "name": "SOLONETU NOU",
        "zip": "727099",
        "lat": "47.654362",
        "long": "25.851761"
      },
      {
        "name": "SPATARESTI",
        "zip": "727573",
        "lat": "47.427728",
        "long": "26.299804"
      },
      {
        "name": "STAMATE",
        "zip": "727234",
        "lat": "47.605981",
        "long": "26.516977"
      },
      {
        "name": "STANCA",
        "zip": "727646",
        "lat": "47.821399",
        "long": "26.270878"
      },
      {
        "name": "STANCUTA",
        "zip": "727647",
        "lat": "47.80976",
        "long": "26.274123"
      },
      {
        "name": "STIRBAT",
        "zip": "727547",
        "lat": "47.555416",
        "long": "26.492566"
      },
      {
        "name": "STRAJA",
        "zip": "727495",
        "lat": "47.918252",
        "long": "25.55275"
      },
      {
        "name": "STRAMTURA",
        "zip": "727593",
        "lat": "47.577415",
        "long": "25.687395"
      },
      {
        "name": "STROIESTI",
        "zip": "727500",
        "lat": "47.617071",
        "long": "26.129146"
      },
      {
        "name": "STULPICANI",
        "zip": "727505",
        "lat": "47.458515",
        "long": "25.765046"
      },
      {
        "name": "SUCEAVA",
        "zip": "720001",
        "lat": "47.647001",
        "long": "26.25226"
      },
      {
        "name": "SUCEVITA",
        "zip": "727510",
        "lat": "47.780478",
        "long": "25.720028"
      },
      {
        "name": "SUNATORI",
        "zip": "727206",
        "lat": "47.384371",
        "long": "25.485294"
      },
      {
        "name": "TARNA MARE",
        "zip": "725202",
        "lat": "47.472709",
        "long": "26.327634"
      },
      {
        "name": "TARNICIOARA",
        "zip": "727401",
        "lat": "47.411303",
        "long": "25.755527"
      },
      {
        "name": "TATARU",
        "zip": "727436",
        "lat": "47.336098",
        "long": "25.096387"
      },
      {
        "name": "TAUTESTI",
        "zip": "727639",
        "lat": "47.847302",
        "long": "26.2283"
      },
      {
        "name": "TESNA",
        "zip": "727197",
        "lat": "47.364974",
        "long": "25.118285"
      },
      {
        "name": "TESNA",
        "zip": "727437",
        "lat": "47.331981",
        "long": "25.129393"
      },
      {
        "name": "TIBAU",
        "zip": "727114",
        "lat": "47.592415",
        "long": "25.075091"
      },
      {
        "name": "TIBENI",
        "zip": "727481",
        "lat": "47.816183",
        "long": "26.024381"
      },
      {
        "name": "TISAUTI",
        "zip": "727327",
        "lat": "47.624708",
        "long": "26.311619"
      },
      {
        "name": "TODIRENI",
        "zip": "725703",
        "lat": "47.331918",
        "long": "25.394941"
      },
      {
        "name": "TODIRESTI",
        "zip": "727530",
        "lat": "47.703828",
        "long": "26.063142"
      },
      {
        "name": "TOLESTI",
        "zip": "727243",
        "lat": "47.382855",
        "long": "26.48461"
      },
      {
        "name": "TREI MOVILE",
        "zip": "727529",
        "lat": "47.631242",
        "long": "26.154909"
      },
      {
        "name": "UDESTI",
        "zip": "727535",
        "lat": "47.575565",
        "long": "26.412234"
      },
      {
        "name": "UIDESTI",
        "zip": "727244",
        "lat": "47.380085",
        "long": "26.463916"
      },
      {
        "name": "ULMA",
        "zip": "727555",
        "lat": "47.88975",
        "long": "25.289382"
      },
      {
        "name": "UNCESTI",
        "zip": "727094",
        "lat": "47.528126",
        "long": "26.323411"
      },
      {
        "name": "VADU MOLDOVEI",
        "zip": "727560",
        "lat": "47.37785",
        "long": "26.370652"
      },
      {
        "name": "VADU NEGRILESEI",
        "zip": "727509",
        "lat": "47.384945",
        "long": "25.841093"
      },
      {
        "name": "VALCELELE",
        "zip": "727501",
        "lat": "47.651245",
        "long": "26.095661"
      },
      {
        "name": "VALEA BANCULUI",
        "zip": "727198",
        "lat": "47.398515",
        "long": "25.191502"
      },
      {
        "name": "VALEA BOUREI",
        "zip": "727182",
        "lat": "47.425068",
        "long": "26.506439"
      },
      {
        "name": "VALEA GLODULUI",
        "zip": "727628",
        "lat": "47.509926",
        "long": "26.448572"
      },
      {
        "name": "VALEA MOLDOVEI",
        "zip": "727580",
        "lat": "47.473355",
        "long": "26.021183"
      },
      {
        "name": "VALEA POIENEI",
        "zip": "727178",
        "lat": "47.416626",
        "long": "26.571281"
      },
      {
        "name": "VALEA PUTNEI",
        "zip": "727441",
        "lat": "47.484978",
        "long": "25.375793"
      },
      {
        "name": "VALEA STANEI",
        "zip": "727116",
        "lat": "47.553139",
        "long": "25.16312"
      },
      {
        "name": "VALENI-STANISOARA",
        "zip": "727354",
        "lat": "47.367293",
        "long": "25.978852"
      },
      {
        "name": "VAMA",
        "zip": "727590",
        "lat": "47.571485",
        "long": "25.691263"
      },
      {
        "name": "VARATEC",
        "zip": "727479",
        "lat": "47.639875",
        "long": "26.403123"
      },
      {
        "name": "VARFU DEALULUI",
        "zip": "727428",
        "lat": "47.609794",
        "long": "25.940298"
      },
      {
        "name": "VARVATA",
        "zip": "727427",
        "lat": "47.612487",
        "long": "26.000151"
      },
      {
        "name": "VASCAUTI",
        "zip": "727394",
        "lat": "47.967516",
        "long": "26.023109"
      },
      {
        "name": "VATRA DORNEI",
        "zip": "725700",
        "lat": "47.347181",
        "long": "25.355615"
      },
      {
        "name": "VATRA MOLDOVITEI",
        "zip": "727595",
        "lat": "47.652499",
        "long": "25.573134"
      },
      {
        "name": "VERBIA",
        "zip": "727289",
        "lat": "47.885858",
        "long": "26.157616"
      },
      {
        "name": "VERCICANI",
        "zip": "727341",
        "lat": "47.526886",
        "long": "26.573414"
      },
      {
        "name": "VERESTI",
        "zip": "727600",
        "lat": "47.606965",
        "long": "26.439618"
      },
      {
        "name": "VICOVU DE JOS",
        "zip": "727605",
        "lat": "47.901119",
        "long": "25.726585"
      },
      {
        "name": "VICOVU DE SUS",
        "zip": "727610",
        "lat": "47.924353",
        "long": "25.671123"
      },
      {
        "name": "VICSANI",
        "zip": "727396",
        "lat": "47.9376",
        "long": "25.98157"
      },
      {
        "name": "VOIEVODEASA",
        "zip": "727511",
        "lat": "47.799533",
        "long": "25.74939"
      },
      {
        "name": "VOITINEL",
        "zip": "727282",
        "lat": "47.883655",
        "long": "25.75735"
      },
      {
        "name": "VOLOVAT",
        "zip": "727615",
        "lat": "47.807261",
        "long": "25.895584"
      },
      {
        "name": "VORNICENII MARI",
        "zip": "727378",
        "lat": "47.560077",
        "long": "26.123644"
      },
      {
        "name": "VORNICENII MICI",
        "zip": "727379",
        "lat": "47.565168",
        "long": "26.162147"
      },
      {
        "name": "VORONET",
        "zip": "725301",
        "lat": "47.531995",
        "long": "25.864426"
      },
      {
        "name": "VULTURESTI",
        "zip": "727620",
        "lat": "47.520457",
        "long": "26.410839"
      },
      {
        "name": "ZAHARESTI",
        "zip": "727502",
        "lat": "47.590973",
        "long": "26.15234"
      },
      {
        "name": "ZALOMESTRA",
        "zip": "727071",
        "lat": "47.852011",
        "long": "25.399423"
      },
      {
        "name": "ZAMOSTEA",
        "zip": "727630",
        "lat": "47.866186",
        "long": "26.203306"
      },
      {
        "name": "ZVORISTEA",
        "zip": "727640",
        "lat": "47.837106",
        "long": "26.291578"
      }
    ],
    "TELEORMAN": [
      {
        "name": "ALBENI",
        "zip": "147321",
        "lat": "44.39829",
        "long": "25.258936"
      },
      {
        "name": "ALBESTI",
        "zip": "147431",
        "lat": "44.068372",
        "long": "25.119396"
      },
      {
        "name": "ALEXANDRIA",
        "zip": "140001",
        "lat": "43.970224",
        "long": "25.328846"
      },
      {
        "name": "ANTONESTI",
        "zip": "147056",
        "lat": "44.116643",
        "long": "25.183194"
      },
      {
        "name": "BABAITA",
        "zip": "147010",
        "lat": "44.1615",
        "long": "25.38331"
      },
      {
        "name": "BACALESTI",
        "zip": "147066",
        "lat": "44.059968",
        "long": "24.81636"
      },
      {
        "name": "BACIU",
        "zip": "147016",
        "lat": "44.33139",
        "long": "25.443557"
      },
      {
        "name": "BADULEASA",
        "zip": "147286",
        "lat": "43.922605",
        "long": "24.983116"
      },
      {
        "name": "BALACI",
        "zip": "147005",
        "lat": "44.338924",
        "long": "24.924152"
      },
      {
        "name": "BALDOVINESTI",
        "zip": "147076",
        "lat": "44.33952",
        "long": "25.058879"
      },
      {
        "name": "BALTA SARATA",
        "zip": "147096",
        "lat": "44.013897",
        "long": "24.825371"
      },
      {
        "name": "BANEASA",
        "zip": "147301",
        "lat": "43.939751",
        "long": "24.949972"
      },
      {
        "name": "BANOV",
        "zip": "147271",
        "lat": "44.44492",
        "long": "25.340336"
      },
      {
        "name": "BARSESTII DE JOS",
        "zip": "147256",
        "lat": "44.016541",
        "long": "24.65398"
      },
      {
        "name": "BASCOVENI",
        "zip": "147151",
        "lat": "44.244435",
        "long": "25.359983"
      },
      {
        "name": "BECIU",
        "zip": "147257",
        "lat": "44.004292",
        "long": "24.66571"
      },
      {
        "name": "BEIU",
        "zip": "147376",
        "lat": "43.874098",
        "long": "25.455794"
      },
      {
        "name": "BELCIUG",
        "zip": "147226",
        "lat": "44.268177",
        "long": "25.118081"
      },
      {
        "name": "BEUCA",
        "zip": "147121",
        "lat": "44.251999",
        "long": "24.966369"
      },
      {
        "name": "BLEJESTI",
        "zip": "147015",
        "lat": "44.292468",
        "long": "25.47568"
      },
      {
        "name": "BOGDANA",
        "zip": "147020",
        "lat": "43.920566",
        "long": "25.095093"
      },
      {
        "name": "BOTOROAGA",
        "zip": "147025",
        "lat": "44.146983",
        "long": "25.546596"
      },
      {
        "name": "BRAGADIRU",
        "zip": "147030",
        "lat": "43.764569",
        "long": "25.512896"
      },
      {
        "name": "BRANCENI",
        "zip": "147035",
        "lat": "43.877896",
        "long": "25.397367"
      },
      {
        "name": "BRANCOVEANCA",
        "zip": "147258",
        "lat": "43.940212",
        "long": "24.692734"
      },
      {
        "name": "BRATASANI",
        "zip": "147411",
        "lat": "44.240834",
        "long": "25.25911"
      },
      {
        "name": "BRATCOVU",
        "zip": "147366",
        "lat": "44.157694",
        "long": "24.869305"
      },
      {
        "name": "BRATESTI",
        "zip": "147272",
        "lat": "44.432022",
        "long": "25.308824"
      },
      {
        "name": "BREBINA",
        "zip": "147316",
        "lat": "44.165829",
        "long": "24.97279"
      },
      {
        "name": "BROSTEANCA",
        "zip": "147021",
        "lat": "43.941051",
        "long": "25.074029"
      },
      {
        "name": "BUJORENI",
        "zip": "147040",
        "lat": "44.116646",
        "long": "25.648818"
      },
      {
        "name": "BUJORU",
        "zip": "147045",
        "lat": "43.710216",
        "long": "25.562556"
      },
      {
        "name": "BUJORU",
        "zip": "147061",
        "lat": "43.958587",
        "long": "24.850166"
      },
      {
        "name": "BURDENI",
        "zip": "147006",
        "lat": "44.370326",
        "long": "24.945686"
      },
      {
        "name": "BUTCULESTI",
        "zip": "147306",
        "lat": "44.217278",
        "long": "25.066039"
      },
      {
        "name": "BUTESTI",
        "zip": "147346",
        "lat": "44.390519",
        "long": "25.380259"
      },
      {
        "name": "BUZESCU",
        "zip": "147050",
        "lat": "44.010819",
        "long": "25.225469"
      },
      {
        "name": "CALINESTI",
        "zip": "147055",
        "lat": "44.087471",
        "long": "25.244817"
      },
      {
        "name": "CALMATUIU",
        "zip": "147060",
        "lat": "43.969495",
        "long": "24.865203"
      },
      {
        "name": "CALMATUIU DE SUS",
        "zip": "147065",
        "lat": "44.029114",
        "long": "24.813912"
      },
      {
        "name": "CALOMFIRESTI",
        "zip": "147281",
        "lat": "43.91686",
        "long": "25.357199"
      },
      {
        "name": "CALUGARU",
        "zip": "147026",
        "lat": "44.149681",
        "long": "25.494499"
      },
      {
        "name": "CARAVANETI",
        "zip": "147062",
        "lat": "43.955505",
        "long": "24.876247"
      },
      {
        "name": "CARLOMANU",
        "zip": "147287",
        "lat": "43.916465",
        "long": "24.959727"
      },
      {
        "name": "CATUNU",
        "zip": "147273",
        "lat": "44.423388",
        "long": "25.322843"
      },
      {
        "name": "CERNETU",
        "zip": "147201",
        "lat": "43.905436",
        "long": "25.455955"
      },
      {
        "name": "CERVENIA",
        "zip": "147070",
        "lat": "43.833134",
        "long": "25.459778"
      },
      {
        "name": "CETATEA",
        "zip": "147291",
        "lat": "44.132336",
        "long": "25.173577"
      },
      {
        "name": "CIOLANESTII DIN DEAL",
        "zip": "147077",
        "lat": "44.31057",
        "long": "25.086336"
      },
      {
        "name": "CIOLANESTII DIN VALE",
        "zip": "147078",
        "lat": "44.296225",
        "long": "25.103227"
      },
      {
        "name": "CIUPERCENI",
        "zip": "147080",
        "lat": "43.761099",
        "long": "24.927665"
      },
      {
        "name": "CIUPERCENI",
        "zip": "147091",
        "lat": "44.317603",
        "long": "25.378611"
      },
      {
        "name": "CIURARI",
        "zip": "147307",
        "lat": "44.254542",
        "long": "25.045691"
      },
      {
        "name": "CIURARI-DEAL",
        "zip": "147156",
        "lat": "44.43108",
        "long": "25.449179"
      },
      {
        "name": "CLANITA",
        "zip": "147011",
        "lat": "44.195774",
        "long": "25.373967"
      },
      {
        "name": "COMOARA",
        "zip": "147136",
        "lat": "44.113028",
        "long": "25.50767"
      },
      {
        "name": "CONTESTI",
        "zip": "147085",
        "lat": "43.79226",
        "long": "25.492066"
      },
      {
        "name": "COPACEANCA",
        "zip": "147057",
        "lat": "44.136648",
        "long": "25.218553"
      },
      {
        "name": "COSMESTI",
        "zip": "147090",
        "lat": "44.295279",
        "long": "25.393524"
      },
      {
        "name": "COSOAIA",
        "zip": "145301",
        "lat": "44.277922",
        "long": "25.625319"
      },
      {
        "name": "COSOTENI",
        "zip": "147432",
        "lat": "44.121052",
        "long": "25.025437"
      },
      {
        "name": "CRANGENI",
        "zip": "147095",
        "lat": "44.022763",
        "long": "24.799453"
      },
      {
        "name": "CRANGU",
        "zip": "147100",
        "lat": "43.846111",
        "long": "25.073499"
      },
      {
        "name": "CREVENICU",
        "zip": "147105",
        "lat": "44.244726",
        "long": "25.586686"
      },
      {
        "name": "CUCUETI",
        "zip": "147317",
        "lat": "44.184649",
        "long": "24.945566"
      },
      {
        "name": "DARVAS",
        "zip": "147041",
        "lat": "44.118628",
        "long": "25.639673"
      },
      {
        "name": "DEPARATI",
        "zip": "147412",
        "lat": "44.280569",
        "long": "25.215327"
      },
      {
        "name": "DIDESTI",
        "zip": "147110",
        "lat": "44.215473",
        "long": "24.888057"
      },
      {
        "name": "DOBRENI",
        "zip": "147401",
        "lat": "44.421457",
        "long": "25.127586"
      },
      {
        "name": "DOBROTESTI",
        "zip": "147115",
        "lat": "44.277424",
        "long": "24.886435"
      },
      {
        "name": "DOROBANTU",
        "zip": "147097",
        "lat": "43.991534",
        "long": "24.826943"
      },
      {
        "name": "DRACEA",
        "zip": "147101",
        "lat": "43.850274",
        "long": "25.048648"
      },
      {
        "name": "DRACESTI",
        "zip": "147322",
        "lat": "44.367895",
        "long": "25.244786"
      },
      {
        "name": "DRACSANI",
        "zip": "147122",
        "lat": "44.213261",
        "long": "24.993018"
      },
      {
        "name": "DRACSENEI",
        "zip": "147120",
        "lat": "44.225274",
        "long": "24.982479"
      },
      {
        "name": "DRAGANESTI DE VEDE",
        "zip": "147130",
        "lat": "44.129093",
        "long": "25.056663"
      },
      {
        "name": "DRAGANESTI-VLASCA",
        "zip": "147135",
        "lat": "44.101654",
        "long": "25.597677"
      },
      {
        "name": "DRAGHINESTI",
        "zip": "147157",
        "lat": "44.431302",
        "long": "25.42609"
      },
      {
        "name": "DUDU",
        "zip": "147259",
        "lat": "43.978397",
        "long": "24.676751"
      },
      {
        "name": "DULCEANCA",
        "zip": "147433",
        "lat": "44.090284",
        "long": "25.107017"
      },
      {
        "name": "DULCENI",
        "zip": "147416",
        "lat": "43.986261",
        "long": "25.045781"
      },
      {
        "name": "FANTANELE",
        "zip": "147371",
        "lat": "43.721035",
        "long": "25.292652"
      },
      {
        "name": "FLORICA",
        "zip": "147102",
        "lat": "43.890265",
        "long": "25.016995"
      },
      {
        "name": "FRASINET",
        "zip": "147012",
        "lat": "44.180384",
        "long": "25.382384"
      },
      {
        "name": "FRUMOASA",
        "zip": "147140",
        "lat": "43.790226",
        "long": "25.470324"
      },
      {
        "name": "FURCULESTI",
        "zip": "147145",
        "lat": "43.872015",
        "long": "25.142846"
      },
      {
        "name": "GALATENI",
        "zip": "147150",
        "lat": "44.227394",
        "long": "25.358863"
      },
      {
        "name": "GARAGAU",
        "zip": "147426",
        "lat": "44.232541",
        "long": "25.187825"
      },
      {
        "name": "GARDESTI",
        "zip": "147227",
        "lat": "44.262567",
        "long": "25.129303"
      },
      {
        "name": "GRADISTEANCA",
        "zip": "147152",
        "lat": "44.202147",
        "long": "25.373112"
      },
      {
        "name": "GRATIA",
        "zip": "147155",
        "lat": "44.438872",
        "long": "25.44798"
      },
      {
        "name": "GRESIA",
        "zip": "147367",
        "lat": "44.171257",
        "long": "24.918655"
      },
      {
        "name": "GURUIENI",
        "zip": "147191",
        "lat": "44.058455",
        "long": "25.396561"
      },
      {
        "name": "INSURATEI",
        "zip": "147111",
        "lat": "44.232812",
        "long": "24.88522"
      },
      {
        "name": "IONASCU",
        "zip": "147067",
        "lat": "44.043041",
        "long": "24.817174"
      },
      {
        "name": "ISLAZ",
        "zip": "147160",
        "lat": "43.727117",
        "long": "24.757049"
      },
      {
        "name": "IZVOARELE",
        "zip": "147165",
        "lat": "43.825754",
        "long": "25.395107"
      },
      {
        "name": "LACENI",
        "zip": "147236",
        "lat": "44.085125",
        "long": "25.332771"
      },
      {
        "name": "LADA",
        "zip": "147391",
        "lat": "44.319463",
        "long": "25.212114"
      },
      {
        "name": "LICURICIU",
        "zip": "147058",
        "lat": "44.097834",
        "long": "25.196435"
      },
      {
        "name": "LINIA COSTII",
        "zip": "147381",
        "lat": "44.277906",
        "long": "25.313203"
      },
      {
        "name": "LISA",
        "zip": "147170",
        "lat": "43.79212",
        "long": "25.144366"
      },
      {
        "name": "LITA",
        "zip": "147175",
        "lat": "43.795445",
        "long": "24.821573"
      },
      {
        "name": "LUDANEASCA",
        "zip": "147296",
        "lat": "44.003076",
        "long": "25.580112"
      },
      {
        "name": "LUNCA",
        "zip": "147180",
        "lat": "43.839387",
        "long": "24.769252"
      },
      {
        "name": "MAGURA",
        "zip": "147190",
        "lat": "44.022633",
        "long": "25.395245"
      },
      {
        "name": "MAGURA CU LILIAC",
        "zip": "147131",
        "lat": "44.128853",
        "long": "25.068195"
      },
      {
        "name": "MALDAENI",
        "zip": "147195",
        "lat": "44.126638",
        "long": "24.920558"
      },
      {
        "name": "MARITA",
        "zip": "147059",
        "lat": "44.116867",
        "long": "25.220983"
      },
      {
        "name": "MARZANESTI",
        "zip": "147200",
        "lat": "43.935596",
        "long": "25.466887"
      },
      {
        "name": "MAVRODIN",
        "zip": "147185",
        "lat": "44.036495",
        "long": "25.237253"
      },
      {
        "name": "MERENII DE JOS",
        "zip": "147206",
        "lat": "44.232137",
        "long": "25.643463"
      },
      {
        "name": "MERENII DE SUS",
        "zip": "147207",
        "lat": "44.228393",
        "long": "25.62103"
      },
      {
        "name": "MERI",
        "zip": "147434",
        "lat": "44.100744",
        "long": "25.055158"
      },
      {
        "name": "MERISANI",
        "zip": "147013",
        "lat": "44.116688",
        "long": "25.399805"
      },
      {
        "name": "MERISANI",
        "zip": "147116",
        "lat": "44.251899",
        "long": "24.875504"
      },
      {
        "name": "MOLDOVENI",
        "zip": "147161",
        "lat": "43.777718",
        "long": "24.728018"
      },
      {
        "name": "MOSTENI",
        "zip": "147146",
        "lat": "43.861365",
        "long": "25.141903"
      },
      {
        "name": "MOSTENI",
        "zip": "147210",
        "lat": "44.197874",
        "long": "25.508544"
      },
      {
        "name": "NANOV",
        "zip": "147215",
        "lat": "43.993428",
        "long": "25.284129"
      },
      {
        "name": "NASTURELU",
        "zip": "147220",
        "lat": "43.671382",
        "long": "25.464626"
      },
      {
        "name": "NAVODARI",
        "zip": "147331",
        "lat": "43.742076",
        "long": "25.094098"
      },
      {
        "name": "NECSESTI",
        "zip": "147225",
        "lat": "44.251806",
        "long": "25.149375"
      },
      {
        "name": "NEGRENI",
        "zip": "147392",
        "lat": "44.410784",
        "long": "25.193596"
      },
      {
        "name": "NEGRENII DE SUS",
        "zip": "147393",
        "lat": "44.419926",
        "long": "25.182711"
      },
      {
        "name": "NEGRENII-OSEBITI",
        "zip": "147394",
        "lat": "44.401917",
        "long": "25.197515"
      },
      {
        "name": "NEGRILESTI",
        "zip": "147323",
        "lat": "44.334015",
        "long": "25.251238"
      },
      {
        "name": "NENCIULESTI",
        "zip": "147186",
        "lat": "44.034949",
        "long": "25.200096"
      },
      {
        "name": "NICOLAE BALCESCU",
        "zip": "147063",
        "lat": "43.959715",
        "long": "24.832871"
      },
      {
        "name": "OBARTU",
        "zip": "147396",
        "lat": "44.319851",
        "long": "25.190816"
      },
      {
        "name": "ODOBEASCA",
        "zip": "147123",
        "lat": "44.196863",
        "long": "25.009253"
      },
      {
        "name": "OLTEANCA",
        "zip": "147336",
        "lat": "43.830028",
        "long": "24.795195"
      },
      {
        "name": "OLTENI",
        "zip": "147230",
        "lat": "44.177043",
        "long": "25.29168"
      },
      {
        "name": "ORBEASCA DE JOS",
        "zip": "147237",
        "lat": "44.121767",
        "long": "25.329516"
      },
      {
        "name": "ORBEASCA DE SUS",
        "zip": "147238",
        "lat": "44.137387",
        "long": "25.319661"
      },
      {
        "name": "PARU ROTUND",
        "zip": "147187",
        "lat": "44.042654",
        "long": "25.169625"
      },
      {
        "name": "PAULEASCA",
        "zip": "147141",
        "lat": "43.81296",
        "long": "25.456038"
      },
      {
        "name": "PERETU",
        "zip": "147240",
        "lat": "44.044903",
        "long": "25.090676"
      },
      {
        "name": "PERII BROSTENI",
        "zip": "147231",
        "lat": "44.206829",
        "long": "25.259751"
      },
      {
        "name": "PIATRA",
        "zip": "147245",
        "lat": "43.809993",
        "long": "25.166289"
      },
      {
        "name": "PIETROSANI",
        "zip": "147250",
        "lat": "43.713049",
        "long": "25.649358"
      },
      {
        "name": "PLEASOV",
        "zip": "147181",
        "lat": "43.849714",
        "long": "24.748862"
      },
      {
        "name": "PLOPI",
        "zip": "147124",
        "lat": "44.281318",
        "long": "24.98884"
      },
      {
        "name": "PLOPII-SLAVITESTI",
        "zip": "147255",
        "lat": "43.962874",
        "long": "24.683636"
      },
      {
        "name": "PLOSCA",
        "zip": "147265",
        "lat": "44.023663",
        "long": "25.14875"
      },
      {
        "name": "POENI",
        "zip": "147270",
        "lat": "44.399076",
        "long": "25.345554"
      },
      {
        "name": "POIANA",
        "zip": "147081",
        "lat": "43.741679",
        "long": "24.951224"
      },
      {
        "name": "POROSCHIA",
        "zip": "147280",
        "lat": "43.942451",
        "long": "25.355482"
      },
      {
        "name": "PREAJBA",
        "zip": "147274",
        "lat": "44.433907",
        "long": "25.359101"
      },
      {
        "name": "PRUNARU",
        "zip": "147042",
        "lat": "44.123601",
        "long": "25.679992"
      },
      {
        "name": "PRUNDU",
        "zip": "147182",
        "lat": "43.823943",
        "long": "24.691957"
      },
      {
        "name": "PURANI",
        "zip": "147441",
        "lat": "43.988817",
        "long": "25.434331"
      },
      {
        "name": "PURANI",
        "zip": "147347",
        "lat": "44.361247",
        "long": "25.425275"
      },
      {
        "name": "PURANII DE SUS",
        "zip": "147348",
        "lat": "44.370254",
        "long": "25.398449"
      },
      {
        "name": "PUTINEIU",
        "zip": "147285",
        "lat": "43.903535",
        "long": "24.966594"
      },
      {
        "name": "RADOIESTI-DEAL",
        "zip": "147292",
        "lat": "44.147858",
        "long": "25.141477"
      },
      {
        "name": "RADOIESTI-VALE",
        "zip": "147293",
        "lat": "44.142931",
        "long": "25.151604"
      },
      {
        "name": "RADULESTI",
        "zip": "147106",
        "lat": "44.243693",
        "long": "25.557358"
      },
      {
        "name": "RASMIRESTI",
        "zip": "147295",
        "lat": "43.996355",
        "long": "25.561221"
      },
      {
        "name": "ROSIORII DE VEDE",
        "zip": "145100",
        "lat": "44.112724",
        "long": "24.995359"
      },
      {
        "name": "ROTARESTI",
        "zip": "147382",
        "lat": "44.257567",
        "long": "25.327281"
      },
      {
        "name": "SACENI",
        "zip": "147305",
        "lat": "44.229928",
        "long": "25.064634"
      },
      {
        "name": "SAELELE",
        "zip": "147183",
        "lat": "43.855766",
        "long": "24.727893"
      },
      {
        "name": "SALCIA",
        "zip": "147300",
        "lat": "43.937342",
        "long": "24.923771"
      },
      {
        "name": "SARBENI",
        "zip": "147310",
        "lat": "44.471072",
        "long": "25.387322"
      },
      {
        "name": "SARBENII DE JOS",
        "zip": "147311",
        "lat": "44.463149",
        "long": "25.408783"
      },
      {
        "name": "SATU NOU",
        "zip": "147112",
        "lat": "44.221652",
        "long": "24.893076"
      },
      {
        "name": "SATUL VECHI",
        "zip": "147126",
        "lat": "44.193554",
        "long": "25.027795"
      },
      {
        "name": "SCHITU POIENARI",
        "zip": "147442",
        "lat": "43.988808",
        "long": "25.477695"
      },
      {
        "name": "SCRIOASTEA",
        "zip": "147315",
        "lat": "44.14544",
        "long": "24.953202"
      },
      {
        "name": "SCURTU MARE",
        "zip": "147320",
        "lat": "44.342467",
        "long": "25.270199"
      },
      {
        "name": "SCURTU-SLAVESTI",
        "zip": "147324",
        "lat": "44.347826",
        "long": "25.252113"
      },
      {
        "name": "SEACA",
        "zip": "147330",
        "lat": "43.756621",
        "long": "25.054269"
      },
      {
        "name": "SECARA",
        "zip": "147103",
        "lat": "43.843688",
        "long": "25.088926"
      },
      {
        "name": "SEGARCEA-DEAL",
        "zip": "147337",
        "lat": "43.825476",
        "long": "24.840201"
      },
      {
        "name": "SEGARCEA-VALE",
        "zip": "147335",
        "lat": "43.816805",
        "long": "24.806495"
      },
      {
        "name": "SERICU",
        "zip": "147017",
        "lat": "44.28552",
        "long": "25.438088"
      },
      {
        "name": "SFINTESTI",
        "zip": "147340",
        "lat": "44.190417",
        "long": "25.09938"
      },
      {
        "name": "SILISTEA",
        "zip": "147443",
        "lat": "43.994116",
        "long": "25.473699"
      },
      {
        "name": "SILISTEA",
        "zip": "147345",
        "lat": "44.372866",
        "long": "25.359147"
      },
      {
        "name": "SILISTEA GUMESTI",
        "zip": "147350",
        "lat": "44.380083",
        "long": "25.014803"
      },
      {
        "name": "SILISTEA MICA",
        "zip": "147349",
        "lat": "44.357427",
        "long": "25.311402"
      },
      {
        "name": "SLAVESTI",
        "zip": "147397",
        "lat": "44.341061",
        "long": "25.197684"
      },
      {
        "name": "SLOBOZIA MANDRA",
        "zip": "147355",
        "lat": "43.915762",
        "long": "24.699143"
      },
      {
        "name": "SMARDAN",
        "zip": "147261",
        "lat": "44.01734",
        "long": "24.665199"
      },
      {
        "name": "SMARDIOASA",
        "zip": "147360",
        "lat": "43.849516",
        "long": "25.435241"
      },
      {
        "name": "SOCETU",
        "zip": "147368",
        "lat": "44.198007",
        "long": "24.852133"
      },
      {
        "name": "SOIMU",
        "zip": "147361",
        "lat": "43.832579",
        "long": "25.44422"
      },
      {
        "name": "SPATAREI",
        "zip": "147147",
        "lat": "43.888233",
        "long": "25.136054"
      },
      {
        "name": "STEFENI",
        "zip": "147208",
        "lat": "44.225851",
        "long": "25.666968"
      },
      {
        "name": "STEJARU",
        "zip": "147098",
        "lat": "44.024906",
        "long": "24.780632"
      },
      {
        "name": "STEJARU",
        "zip": "147365",
        "lat": "44.184468",
        "long": "24.885804"
      },
      {
        "name": "STOROBANEASA",
        "zip": "147375",
        "lat": "43.884877",
        "long": "25.4544"
      },
      {
        "name": "SUHAIA",
        "zip": "147370",
        "lat": "43.739526",
        "long": "25.252915"
      },
      {
        "name": "TALPA POSTEI",
        "zip": "147383",
        "lat": "44.310131",
        "long": "25.288359"
      },
      {
        "name": "TALPA-BASCOVENI",
        "zip": "147384",
        "lat": "44.270672",
        "long": "25.323522"
      },
      {
        "name": "TALPA-OGRAZILE",
        "zip": "147386",
        "lat": "44.28726",
        "long": "25.293282"
      },
      {
        "name": "TARNAVA",
        "zip": "147027",
        "lat": "44.140708",
        "long": "25.56623"
      },
      {
        "name": "TATARASTII DE JOS",
        "zip": "147390",
        "lat": "44.375015",
        "long": "25.177209"
      },
      {
        "name": "TATARASTII DE SUS",
        "zip": "147400",
        "lat": "44.405308",
        "long": "25.120533"
      },
      {
        "name": "TAVARLAU",
        "zip": "147276",
        "lat": "44.454396",
        "long": "25.33685"
      },
      {
        "name": "TECUCI",
        "zip": "147007",
        "lat": "44.341786",
        "long": "24.859661"
      },
      {
        "name": "TELEORMANU",
        "zip": "147202",
        "lat": "43.961712",
        "long": "25.460756"
      },
      {
        "name": "TIGANESTI",
        "zip": "147420",
        "lat": "43.899115",
        "long": "25.381409"
      },
      {
        "name": "TRAIAN",
        "zip": "147405",
        "lat": "43.766514",
        "long": "25.003418"
      },
      {
        "name": "TRIVALEA-MOSTENI",
        "zip": "147410",
        "lat": "44.263492",
        "long": "25.241945"
      },
      {
        "name": "TROIANUL",
        "zip": "147415",
        "lat": "44.001432",
        "long": "25.021057"
      },
      {
        "name": "TUDOR VLADIMIRESCU",
        "zip": "147302",
        "lat": "43.947606",
        "long": "24.906158"
      },
      {
        "name": "TUNARI",
        "zip": "147028",
        "lat": "44.13743",
        "long": "25.590144"
      },
      {
        "name": "TURNU MAGURELE",
        "zip": "145200",
        "lat": "43.751831",
        "long": "24.869172"
      },
      {
        "name": "UDA-CLOCOCIOV",
        "zip": "147356",
        "lat": "43.887914",
        "long": "24.714367"
      },
      {
        "name": "UDA-PACIUREA",
        "zip": "147357",
        "lat": "43.879793",
        "long": "24.723788"
      },
      {
        "name": "UDENI",
        "zip": "147312",
        "lat": "44.463854",
        "long": "25.429637"
      },
      {
        "name": "UDUPU",
        "zip": "147402",
        "lat": "44.39657",
        "long": "25.144878"
      },
      {
        "name": "ULMENI",
        "zip": "147022",
        "lat": "43.902404",
        "long": "25.102993"
      },
      {
        "name": "URLUIU",
        "zip": "147023",
        "lat": "43.955488",
        "long": "25.054053"
      },
      {
        "name": "VACARESTI",
        "zip": "147132",
        "lat": "44.134478",
        "long": "25.02123"
      },
      {
        "name": "VACENI",
        "zip": "147137",
        "lat": "44.068113",
        "long": "25.53555"
      },
      {
        "name": "VALEA CIRESULUI",
        "zip": "147029",
        "lat": "44.167029",
        "long": "25.564509"
      },
      {
        "name": "VALEA PARULUI",
        "zip": "147203",
        "lat": "43.920199",
        "long": "25.465517"
      },
      {
        "name": "VALEA POSTEI",
        "zip": "147326",
        "lat": "44.325832",
        "long": "25.275374"
      },
      {
        "name": "VANATORI",
        "zip": "147171",
        "lat": "43.753035",
        "long": "25.153689"
      },
      {
        "name": "VARTOAPELE DE JOS",
        "zip": "147427",
        "lat": "44.176422",
        "long": "25.20027"
      },
      {
        "name": "VARTOAPELE DE SUS",
        "zip": "147428",
        "lat": "44.191199",
        "long": "25.199498"
      },
      {
        "name": "VATASI",
        "zip": "147277",
        "lat": "44.443094",
        "long": "25.356601"
      },
      {
        "name": "VATRA",
        "zip": "147417",
        "lat": "44.023324",
        "long": "25.00439"
      },
      {
        "name": "VEDEA",
        "zip": "147430",
        "lat": "44.091958",
        "long": "25.067229"
      },
      {
        "name": "VIDELE",
        "zip": "145300",
        "lat": "44.278693",
        "long": "25.526426"
      },
      {
        "name": "VIILE",
        "zip": "147318",
        "lat": "44.163735",
        "long": "24.929644"
      },
      {
        "name": "VIISOARA",
        "zip": "147435",
        "lat": "43.779846",
        "long": "25.175201"
      },
      {
        "name": "VITANESTI",
        "zip": "147440",
        "lat": "44.011564",
        "long": "25.418279"
      },
      {
        "name": "VOIEVODA",
        "zip": "147148",
        "lat": "43.841499",
        "long": "25.137508"
      },
      {
        "name": "ZAMBREASCA",
        "zip": "147445",
        "lat": "44.303499",
        "long": "24.998471"
      },
      {
        "name": "ZIMNICEA",
        "zip": "145400",
        "lat": "43.656765",
        "long": "25.365028"
      },
      {
        "name": "ZIMNICELE",
        "zip": "147221",
        "lat": "43.661264",
        "long": "25.412913"
      },
      {
        "name": "ZLATA",
        "zip": "147104",
        "lat": "43.875019",
        "long": "25.02355"
      }
    ],
    "TIMIȘ": [
      {
        "name": "ALBINA",
        "zip": "307286",
        "lat": "45.714799",
        "long": "21.375378"
      },
      {
        "name": "ALIOS",
        "zip": "307271",
        "lat": "46.037901",
        "long": "21.492912"
      },
      {
        "name": "ALTRINGEN",
        "zip": "307071",
        "lat": "45.98241",
        "long": "21.554949"
      },
      {
        "name": "BABSA",
        "zip": "307046",
        "lat": "45.808745",
        "long": "21.789263"
      },
      {
        "name": "BACOVA",
        "zip": "305101",
        "lat": "45.666019",
        "long": "21.552002"
      },
      {
        "name": "BALINT",
        "zip": "307005",
        "lat": "45.814506",
        "long": "21.85625"
      },
      {
        "name": "BALOSESTI",
        "zip": "307411",
        "lat": "45.782342",
        "long": "22.28962"
      },
      {
        "name": "BANLOC",
        "zip": "307010",
        "lat": "45.387789",
        "long": "21.134283"
      },
      {
        "name": "BARA",
        "zip": "307020",
        "lat": "45.894722",
        "long": "21.871944"
      },
      {
        "name": "BARATEAZ",
        "zip": "307366",
        "lat": "45.969848",
        "long": "21.091878"
      },
      {
        "name": "BARNA",
        "zip": "307025",
        "lat": "45.720713",
        "long": "22.057991"
      },
      {
        "name": "BATESTI",
        "zip": "305301",
        "lat": "45.84663",
        "long": "22.206347"
      },
      {
        "name": "BAZOS",
        "zip": "307341",
        "lat": "45.736927",
        "long": "21.496417"
      },
      {
        "name": "BAZOSU NOU",
        "zip": "307351",
        "lat": "45.750635",
        "long": "21.419691"
      },
      {
        "name": "BEBA VECHE",
        "zip": "307035",
        "lat": "46.131171",
        "long": "20.300387"
      },
      {
        "name": "BECICHERECU MIC",
        "zip": "307040",
        "lat": "45.82904",
        "long": "21.051423"
      },
      {
        "name": "BEGHEIU MIC",
        "zip": "305302",
        "lat": "45.834413",
        "long": "22.148131"
      },
      {
        "name": "BELINT",
        "zip": "307045",
        "lat": "45.749596",
        "long": "21.765946"
      },
      {
        "name": "BENCECU DE JOS",
        "zip": "307326",
        "lat": "45.904688",
        "long": "21.429536"
      },
      {
        "name": "BENCECU DE SUS",
        "zip": "307327",
        "lat": "45.883699",
        "long": "21.425603"
      },
      {
        "name": "BERECUTA",
        "zip": "307186",
        "lat": "45.412912",
        "long": "21.349603"
      },
      {
        "name": "BEREGSAU MARE",
        "zip": "307371",
        "lat": "45.759212",
        "long": "21.026662"
      },
      {
        "name": "BEREGSAU MIC",
        "zip": "307372",
        "lat": "45.751892",
        "long": "20.976897"
      },
      {
        "name": "BERINI",
        "zip": "307356",
        "lat": "45.582455",
        "long": "21.428885"
      },
      {
        "name": "BETHAUSEN",
        "zip": "307050",
        "lat": "45.836787",
        "long": "21.959382"
      },
      {
        "name": "BICHIGI",
        "zip": "305303",
        "lat": "45.856802",
        "long": "22.138591"
      },
      {
        "name": "BILED",
        "zip": "307060",
        "lat": "45.887784",
        "long": "20.959598"
      },
      {
        "name": "BIRDA",
        "zip": "307187",
        "lat": "45.429957",
        "long": "21.343594"
      },
      {
        "name": "BLAJOVA",
        "zip": "307296",
        "lat": "45.591598",
        "long": "21.481766"
      },
      {
        "name": "BOBDA",
        "zip": "307101",
        "lat": "45.734909",
        "long": "20.94257"
      },
      {
        "name": "BODO",
        "zip": "307006",
        "lat": "45.816158",
        "long": "21.885157"
      },
      {
        "name": "BOGDA",
        "zip": "307070",
        "lat": "45.978548",
        "long": "21.5781"
      },
      {
        "name": "BOLDUR",
        "zip": "307080",
        "lat": "45.694168",
        "long": "21.776658"
      },
      {
        "name": "BOTESTI",
        "zip": "307026",
        "lat": "45.702712",
        "long": "22.085202"
      },
      {
        "name": "BOTINESTI",
        "zip": "307027",
        "lat": "45.738541",
        "long": "22.090916"
      },
      {
        "name": "BRANESTI",
        "zip": "305304",
        "lat": "45.814073",
        "long": "22.250861"
      },
      {
        "name": "BREAZOVA",
        "zip": "307261",
        "lat": "45.836909",
        "long": "22.280572"
      },
      {
        "name": "BRESTEA",
        "zip": "307146",
        "lat": "45.352431",
        "long": "21.276093"
      },
      {
        "name": "BRESTOVAT",
        "zip": "307085",
        "lat": "45.873418",
        "long": "21.682006"
      },
      {
        "name": "BUCOVAT",
        "zip": "307156",
        "lat": "45.788429",
        "long": "22.152245"
      },
      {
        "name": "BUCOVAT",
        "zip": "307352",
        "lat": "45.75339",
        "long": "21.381411"
      },
      {
        "name": "BULGARUS",
        "zip": "307241",
        "lat": "45.919472",
        "long": "20.822188"
      },
      {
        "name": "BULZA",
        "zip": "307262",
        "lat": "45.9363",
        "long": "22.337722"
      },
      {
        "name": "BUNEA MARE",
        "zip": "305305",
        "lat": "45.91149",
        "long": "22.098447"
      },
      {
        "name": "BUNEA MICA",
        "zip": "305306",
        "lat": "45.925733",
        "long": "22.094381"
      },
      {
        "name": "BUTIN",
        "zip": "307188",
        "lat": "45.337297",
        "long": "21.379092"
      },
      {
        "name": "BUZAD",
        "zip": "307072",
        "lat": "45.941436",
        "long": "21.547986"
      },
      {
        "name": "BUZIAS",
        "zip": "305100",
        "lat": "45.64921",
        "long": "21.604246"
      },
      {
        "name": "CADAR",
        "zip": "307431",
        "lat": "45.535032",
        "long": "21.534571"
      },
      {
        "name": "CALACEA",
        "zip": "307306",
        "lat": "45.955569",
        "long": "21.145834"
      },
      {
        "name": "CAPAT",
        "zip": "307331",
        "lat": "45.687014",
        "long": "21.666097"
      },
      {
        "name": "CARANI",
        "zip": "307376",
        "lat": "45.910651",
        "long": "21.161438"
      },
      {
        "name": "CARPINIS",
        "zip": "307090",
        "lat": "45.787225",
        "long": "20.904173"
      },
      {
        "name": "CEBZA",
        "zip": "307111",
        "lat": "45.554132",
        "long": "21.064461"
      },
      {
        "name": "CENAD",
        "zip": "307095",
        "lat": "46.138348",
        "long": "20.585986"
      },
      {
        "name": "CENEI",
        "zip": "307100",
        "lat": "45.715836",
        "long": "20.903889"
      },
      {
        "name": "CERNA",
        "zip": "307246",
        "lat": "45.563144",
        "long": "21.406396"
      },
      {
        "name": "CERNETEAZ",
        "zip": "307211",
        "lat": "45.844295",
        "long": "21.26481"
      },
      {
        "name": "CHARLOTTENBURG",
        "zip": "307073",
        "lat": "45.97861",
        "long": "21.519507"
      },
      {
        "name": "CHECEA",
        "zip": "307102",
        "lat": "45.754353",
        "long": "20.834739"
      },
      {
        "name": "CHECHES",
        "zip": "307391",
        "lat": "45.896144",
        "long": "21.753342"
      },
      {
        "name": "CHEGLEVICI",
        "zip": "307151",
        "lat": "46.111353",
        "long": "20.449104"
      },
      {
        "name": "CHERESTUR",
        "zip": "307036",
        "lat": "46.124918",
        "long": "20.3825"
      },
      {
        "name": "CHEVERESU MARE",
        "zip": "307105",
        "lat": "45.666949",
        "long": "21.49083"
      },
      {
        "name": "CHISODA",
        "zip": "307221",
        "lat": "45.702848",
        "long": "21.211666"
      },
      {
        "name": "CHIZATAU",
        "zip": "307047",
        "lat": "45.75411",
        "long": "21.732249"
      },
      {
        "name": "CIACOVA",
        "zip": "307110",
        "lat": "45.508057",
        "long": "21.12862"
      },
      {
        "name": "CIRESU",
        "zip": "307131",
        "lat": "45.65074",
        "long": "22.033598"
      },
      {
        "name": "CIRESU MIC",
        "zip": "307132",
        "lat": "45.6755",
        "long": "22.036125"
      },
      {
        "name": "CLADOVA",
        "zip": "307051",
        "lat": "45.866256",
        "long": "21.970392"
      },
      {
        "name": "CLICIOVA",
        "zip": "307052",
        "lat": "45.794623",
        "long": "21.961818"
      },
      {
        "name": "CLOPODIA",
        "zip": "307231",
        "lat": "45.282449",
        "long": "21.465207"
      },
      {
        "name": "COLONIA BULGARA",
        "zip": "307152",
        "lat": "46.099743",
        "long": "20.413385"
      },
      {
        "name": "COLONIA FABRICII",
        "zip": "307412",
        "lat": "45.765527",
        "long": "22.31452"
      },
      {
        "name": "COLONIA MICA",
        "zip": "305307",
        "lat": "45.83585",
        "long": "22.189112"
      },
      {
        "name": "COMEAT",
        "zip": "307074",
        "lat": "45.960743",
        "long": "21.614732"
      },
      {
        "name": "COMLOSU MARE",
        "zip": "307120",
        "lat": "45.890553",
        "long": "20.627222"
      },
      {
        "name": "COMLOSU MIC",
        "zip": "307121",
        "lat": "45.851735",
        "long": "20.668561"
      },
      {
        "name": "CORNESTI",
        "zip": "307307",
        "lat": "45.912892",
        "long": "21.224985"
      },
      {
        "name": "COSARII",
        "zip": "307086",
        "lat": "45.927741",
        "long": "21.735311"
      },
      {
        "name": "COSAVA",
        "zip": "307136",
        "lat": "45.848337",
        "long": "22.31195"
      },
      {
        "name": "COSEVITA",
        "zip": "307263",
        "lat": "45.878703",
        "long": "22.38426"
      },
      {
        "name": "COSTEIU",
        "zip": "307125",
        "lat": "45.741119",
        "long": "21.849165"
      },
      {
        "name": "COSTEIU DE SUS",
        "zip": "307264",
        "lat": "45.90337",
        "long": "22.368406"
      },
      {
        "name": "COVACI",
        "zip": "307377",
        "lat": "45.834677",
        "long": "21.232018"
      },
      {
        "name": "CRAI NOU",
        "zip": "307226",
        "lat": "45.488221",
        "long": "21.0003"
      },
      {
        "name": "CRALOVAT",
        "zip": "307421",
        "lat": "45.827116",
        "long": "21.622178"
      },
      {
        "name": "CRICIOVA",
        "zip": "307130",
        "lat": "45.629116",
        "long": "22.07112"
      },
      {
        "name": "CRIVINA",
        "zip": "307291",
        "lat": "45.651491",
        "long": "22.120793"
      },
      {
        "name": "CRIVINA DE SUS",
        "zip": "307321",
        "lat": "45.842448",
        "long": "22.43522"
      },
      {
        "name": "CRIVOBARA",
        "zip": "307392",
        "lat": "45.909559",
        "long": "21.816665"
      },
      {
        "name": "CRUCENI",
        "zip": "307176",
        "lat": "45.473684",
        "long": "20.875785"
      },
      {
        "name": "CURTEA",
        "zip": "307135",
        "lat": "45.829704",
        "long": "22.307836"
      },
      {
        "name": "CUTINA",
        "zip": "307053",
        "lat": "45.827514",
        "long": "21.926962"
      },
      {
        "name": "DAROVA",
        "zip": "307140",
        "lat": "45.642003",
        "long": "21.773334"
      },
      {
        "name": "DEJAN",
        "zip": "307281",
        "lat": "45.28502",
        "long": "21.291257"
      },
      {
        "name": "DENTA",
        "zip": "307145",
        "lat": "45.353889",
        "long": "21.249162"
      },
      {
        "name": "DETA",
        "zip": "305200",
        "lat": "45.388897",
        "long": "21.224443"
      },
      {
        "name": "DINIAS",
        "zip": "307311",
        "lat": "45.651528",
        "long": "21.007429"
      },
      {
        "name": "DOBRESTI",
        "zip": "307021",
        "lat": "45.908688",
        "long": "21.94053"
      },
      {
        "name": "DOLAT",
        "zip": "307011",
        "lat": "45.430289",
        "long": "21.063218"
      },
      {
        "name": "DRAGOIESTI",
        "zip": "307332",
        "lat": "45.709405",
        "long": "21.665007"
      },
      {
        "name": "DRAGOMIRESTI",
        "zip": "307401",
        "lat": "45.544097",
        "long": "21.951984"
      },
      {
        "name": "DRAGSINA",
        "zip": "307106",
        "lat": "45.700462",
        "long": "21.432945"
      },
      {
        "name": "DRAGSINESTI",
        "zip": "307166",
        "lat": "45.768541",
        "long": "22.197433"
      },
      {
        "name": "DRINOVA",
        "zip": "307028",
        "lat": "45.685885",
        "long": "22.068822"
      },
      {
        "name": "DUBESTI",
        "zip": "307301",
        "lat": "45.92952",
        "long": "22.025096"
      },
      {
        "name": "DUBOZ",
        "zip": "307297",
        "lat": "45.545946",
        "long": "21.548003"
      },
      {
        "name": "DUDESTII NOI",
        "zip": "307041",
        "lat": "45.839818",
        "long": "21.100812"
      },
      {
        "name": "DUDESTII VECHI",
        "zip": "307150",
        "lat": "46.051643",
        "long": "20.484023"
      },
      {
        "name": "DUMBRAVA",
        "zip": "307155",
        "lat": "45.82537",
        "long": "22.116854"
      },
      {
        "name": "DUMBRAVITA",
        "zip": "307160",
        "lat": "45.800535",
        "long": "21.236434"
      },
      {
        "name": "FADIMAC",
        "zip": "307007",
        "lat": "45.847417",
        "long": "21.865558"
      },
      {
        "name": "FAGET",
        "zip": "305300",
        "lat": "45.855803",
        "long": "22.176887"
      },
      {
        "name": "FARASESTI",
        "zip": "307322",
        "lat": "45.797759",
        "long": "22.385704"
      },
      {
        "name": "FARDEA",
        "zip": "307165",
        "lat": "45.738545",
        "long": "22.16414"
      },
      {
        "name": "FERENDIA",
        "zip": "307232",
        "lat": "45.318527",
        "long": "21.494431"
      },
      {
        "name": "FIBIS",
        "zip": "307272",
        "lat": "45.972797",
        "long": "21.423552"
      },
      {
        "name": "FICATAR",
        "zip": "307333",
        "lat": "45.712624",
        "long": "21.69669"
      },
      {
        "name": "FOENI",
        "zip": "307175",
        "lat": "45.498612",
        "long": "20.87584"
      },
      {
        "name": "FOLEA",
        "zip": "307471",
        "lat": "45.498575",
        "long": "21.30004"
      },
      {
        "name": "GAD",
        "zip": "307112",
        "lat": "45.466563",
        "long": "20.987938"
      },
      {
        "name": "GAIU MIC",
        "zip": "307282",
        "lat": "45.295915",
        "long": "21.207635"
      },
      {
        "name": "GATAIA",
        "zip": "307185",
        "lat": "45.431111",
        "long": "21.43"
      },
      {
        "name": "GAVOJDIA",
        "zip": "307180",
        "lat": "45.616667",
        "long": "22.016667"
      },
      {
        "name": "GELU",
        "zip": "307456",
        "lat": "46.005042",
        "long": "21.057403"
      },
      {
        "name": "GHERMAN",
        "zip": "307233",
        "lat": "45.272054",
        "long": "21.358266"
      },
      {
        "name": "GHILAD",
        "zip": "307113",
        "lat": "45.468216",
        "long": "21.13812"
      },
      {
        "name": "GHIRODA",
        "zip": "307200",
        "lat": "45.768187",
        "long": "21.301683"
      },
      {
        "name": "GHIZELA",
        "zip": "307205",
        "lat": "45.821774",
        "long": "21.744108"
      },
      {
        "name": "GIARMATA",
        "zip": "307210",
        "lat": "45.83857",
        "long": "21.315555"
      },
      {
        "name": "GIARMATA-VII",
        "zip": "307201",
        "lat": "45.799599",
        "long": "21.300262"
      },
      {
        "name": "GIERA",
        "zip": "307215",
        "lat": "45.407226",
        "long": "20.992226"
      },
      {
        "name": "GIROC",
        "zip": "307220",
        "lat": "45.69418",
        "long": "21.235854"
      },
      {
        "name": "GIULVAZ",
        "zip": "307225",
        "lat": "45.54889",
        "long": "20.98445"
      },
      {
        "name": "GLADNA MONTANA",
        "zip": "307167",
        "lat": "45.745554",
        "long": "22.199953"
      },
      {
        "name": "GLADNA ROMANA",
        "zip": "307168",
        "lat": "45.750368",
        "long": "22.226486"
      },
      {
        "name": "GOTTLOB",
        "zip": "307251",
        "lat": "45.936004",
        "long": "20.711685"
      },
      {
        "name": "GRABAT",
        "zip": "307242",
        "lat": "45.878058",
        "long": "20.744914"
      },
      {
        "name": "GRANICERI",
        "zip": "307216",
        "lat": "45.441704",
        "long": "20.881747"
      },
      {
        "name": "GROSI",
        "zip": "307266",
        "lat": "45.915284",
        "long": "22.286044"
      },
      {
        "name": "GRUNI",
        "zip": "307048",
        "lat": "45.765066",
        "long": "21.812314"
      },
      {
        "name": "HAUZESTI",
        "zip": "307169",
        "lat": "45.716973",
        "long": "22.15849"
      },
      {
        "name": "HERENDESTI",
        "zip": "307461",
        "lat": "45.649028",
        "long": "21.852665"
      },
      {
        "name": "HERNEACOVA",
        "zip": "307342",
        "lat": "45.858086",
        "long": "21.515498"
      },
      {
        "name": "HEZERIS",
        "zip": "307126",
        "lat": "45.727369",
        "long": "21.925763"
      },
      {
        "name": "HISIAS",
        "zip": "307206",
        "lat": "45.841041",
        "long": "21.728672"
      },
      {
        "name": "HITIAS",
        "zip": "307334",
        "lat": "45.710629",
        "long": "21.598631"
      },
      {
        "name": "HODONI",
        "zip": "307367",
        "lat": "45.906642",
        "long": "21.085665"
      },
      {
        "name": "HODOS",
        "zip": "307087",
        "lat": "45.903927",
        "long": "21.651366"
      },
      {
        "name": "HODOS",
        "zip": "307141",
        "lat": "45.665407",
        "long": "21.798347"
      },
      {
        "name": "HOMOJDIA",
        "zip": "307137",
        "lat": "45.85607",
        "long": "22.357872"
      },
      {
        "name": "HONORICI",
        "zip": "307462",
        "lat": "45.615224",
        "long": "21.908932"
      },
      {
        "name": "IANOVA",
        "zip": "307353",
        "lat": "45.839557",
        "long": "21.419256"
      },
      {
        "name": "ICLODA",
        "zip": "307357",
        "lat": "45.642153",
        "long": "21.386893"
      },
      {
        "name": "ICTAR-BUDINT",
        "zip": "307422",
        "lat": "45.769254",
        "long": "21.674385"
      },
      {
        "name": "IECEA MARE",
        "zip": "307091",
        "lat": "45.850742",
        "long": "20.893096"
      },
      {
        "name": "IECEA MICA",
        "zip": "307092",
        "lat": "45.821466",
        "long": "20.923217"
      },
      {
        "name": "IERSNIC",
        "zip": "307302",
        "lat": "45.883596",
        "long": "22.003036"
      },
      {
        "name": "IGRIS",
        "zip": "307386",
        "lat": "46.112747",
        "long": "20.785706"
      },
      {
        "name": "IOHANISFELD",
        "zip": "307446",
        "lat": "45.566795",
        "long": "20.863447"
      },
      {
        "name": "IOSIF",
        "zip": "307247",
        "lat": "45.569386",
        "long": "21.278256"
      },
      {
        "name": "IOSIFALAU",
        "zip": "307423",
        "lat": "45.781682",
        "long": "21.679644"
      },
      {
        "name": "IVANDA",
        "zip": "307227",
        "lat": "45.565779",
        "long": "20.941722"
      },
      {
        "name": "IZVIN",
        "zip": "307343",
        "lat": "45.80054",
        "long": "21.46136"
      },
      {
        "name": "JABAR",
        "zip": "307081",
        "lat": "45.715423",
        "long": "21.800878"
      },
      {
        "name": "JAMU MARE",
        "zip": "307230",
        "lat": "45.255275",
        "long": "21.415477"
      },
      {
        "name": "JDIOARA",
        "zip": "307133",
        "lat": "45.621039",
        "long": "22.106989"
      },
      {
        "name": "JEBEL",
        "zip": "307235",
        "lat": "45.555555",
        "long": "21.213617"
      },
      {
        "name": "JENA",
        "zip": "307181",
        "lat": "45.600877",
        "long": "22.07377"
      },
      {
        "name": "JIMBOLIA",
        "zip": "305400",
        "lat": "45.791011",
        "long": "20.718041"
      },
      {
        "name": "JUPANESTI",
        "zip": "305308",
        "lat": "45.78743",
        "long": "22.26975"
      },
      {
        "name": "JUPANI",
        "zip": "307436",
        "lat": "45.80511",
        "long": "22.018806"
      },
      {
        "name": "JURESTI",
        "zip": "307029",
        "lat": "45.705622",
        "long": "22.067279"
      },
      {
        "name": "LAPUSNIC",
        "zip": "307022",
        "lat": "45.893615",
        "long": "21.922381"
      },
      {
        "name": "LATUNAS",
        "zip": "307234",
        "lat": "45.211698",
        "long": "21.479345"
      },
      {
        "name": "LENAUHEIM",
        "zip": "307240",
        "lat": "45.871941",
        "long": "20.79945"
      },
      {
        "name": "LEUCUSESTI",
        "zip": "307054",
        "lat": "45.835422",
        "long": "22.004799"
      },
      {
        "name": "LIEBLING",
        "zip": "307245",
        "lat": "45.5775",
        "long": "21.32167"
      },
      {
        "name": "LIVEZILE",
        "zip": "307012",
        "lat": "45.390259",
        "long": "21.057943"
      },
      {
        "name": "LOVRIN",
        "zip": "307250",
        "lat": "45.968055",
        "long": "20.770285"
      },
      {
        "name": "LUCARET",
        "zip": "307088",
        "lat": "45.837092",
        "long": "21.671888"
      },
      {
        "name": "LUGOJ",
        "zip": "305500",
        "lat": "45.686254",
        "long": "21.906316"
      },
      {
        "name": "LUGOJEL",
        "zip": "307182",
        "lat": "45.665538",
        "long": "21.961125"
      },
      {
        "name": "LUNCANII DE JOS",
        "zip": "307413",
        "lat": "45.719556",
        "long": "22.310327"
      },
      {
        "name": "LUNCANII DE SUS",
        "zip": "307414",
        "lat": "45.739037",
        "long": "22.308261"
      },
      {
        "name": "LUNGA",
        "zip": "307122",
        "lat": "45.883259",
        "long": "20.591802"
      },
      {
        "name": "MACEDONIA",
        "zip": "307114",
        "lat": "45.516247",
        "long": "21.057816"
      },
      {
        "name": "MAGURI",
        "zip": "305501",
        "lat": "45.661117",
        "long": "22.000776"
      },
      {
        "name": "MANASTIRE",
        "zip": "307189",
        "lat": "45.407694",
        "long": "21.332575"
      },
      {
        "name": "MANASTIUR",
        "zip": "307275",
        "lat": "45.832633",
        "long": "22.065299"
      },
      {
        "name": "MARGINA",
        "zip": "307260",
        "lat": "45.858321",
        "long": "22.265785"
      },
      {
        "name": "MASLOC",
        "zip": "307270",
        "lat": "45.998054",
        "long": "21.449721"
      },
      {
        "name": "MATNICU MIC",
        "zip": "307171",
        "lat": "45.763511",
        "long": "22.1766"
      },
      {
        "name": "MORAVITA",
        "zip": "307280",
        "lat": "45.256104",
        "long": "21.269472"
      },
      {
        "name": "MOSNITA NOUA",
        "zip": "307285",
        "lat": "45.718765",
        "long": "21.325857"
      },
      {
        "name": "MOSNITA VECHE",
        "zip": "307287",
        "lat": "45.734462",
        "long": "21.330255"
      },
      {
        "name": "MURANI",
        "zip": "307328",
        "lat": "45.923163",
        "long": "21.304292"
      },
      {
        "name": "NADAS",
        "zip": "307344",
        "lat": "45.903408",
        "long": "21.543095"
      },
      {
        "name": "NADRAG",
        "zip": "307290",
        "lat": "45.650001",
        "long": "22.183332"
      },
      {
        "name": "NEMESESTI",
        "zip": "307267",
        "lat": "45.887432",
        "long": "22.31577"
      },
      {
        "name": "NERAU",
        "zip": "307406",
        "lat": "45.969288",
        "long": "20.560701"
      },
      {
        "name": "NEVRINCEA",
        "zip": "307056",
        "lat": "45.789427",
        "long": "21.931329"
      },
      {
        "name": "NITCHIDORF",
        "zip": "307295",
        "lat": "45.58255",
        "long": "21.530003"
      },
      {
        "name": "OBAD",
        "zip": "307116",
        "lat": "45.540516",
        "long": "21.156962"
      },
      {
        "name": "OFSENITA",
        "zip": "307013",
        "lat": "45.415692",
        "long": "21.145781"
      },
      {
        "name": "OHABA LUNGA",
        "zip": "307300",
        "lat": "45.907043",
        "long": "21.983685"
      },
      {
        "name": "OHABA ROMANA",
        "zip": "307303",
        "lat": "45.950246",
        "long": "21.944028"
      },
      {
        "name": "OHABA-FORGACI",
        "zip": "307082",
        "lat": "45.718492",
        "long": "21.739887"
      },
      {
        "name": "OLOSAG",
        "zip": "307402",
        "lat": "45.603087",
        "long": "21.958833"
      },
      {
        "name": "OPATITA",
        "zip": "305201",
        "lat": "45.414235",
        "long": "21.269682"
      },
      {
        "name": "ORTISOARA",
        "zip": "307305",
        "lat": "45.963606",
        "long": "21.198335"
      },
      {
        "name": "OTELEC",
        "zip": "307447",
        "lat": "45.614783",
        "long": "20.849523"
      },
      {
        "name": "OTVESTI",
        "zip": "307358",
        "lat": "45.621846",
        "long": "21.436735"
      },
      {
        "name": "PADURANI",
        "zip": "307276",
        "lat": "45.878497",
        "long": "22.061365"
      },
      {
        "name": "PADURENI",
        "zip": "307236",
        "lat": "45.597484",
        "long": "21.217428"
      },
      {
        "name": "PADURENI",
        "zip": "307463",
        "lat": "45.578233",
        "long": "21.908156"
      },
      {
        "name": "PANIOVA",
        "zip": "307207",
        "lat": "45.844706",
        "long": "21.792899"
      },
      {
        "name": "PARTA",
        "zip": "307396",
        "lat": "45.628877",
        "long": "21.138773"
      },
      {
        "name": "PARTOS",
        "zip": "307014",
        "lat": "45.334457",
        "long": "21.126817"
      },
      {
        "name": "PARU",
        "zip": "307127",
        "lat": "45.776976",
        "long": "21.847591"
      },
      {
        "name": "PECIU NOU",
        "zip": "307310",
        "lat": "45.60568",
        "long": "21.058137"
      },
      {
        "name": "PERCOSOVA",
        "zip": "307191",
        "lat": "45.320287",
        "long": "21.34968"
      },
      {
        "name": "PERIAM",
        "zip": "307315",
        "lat": "46.042287",
        "long": "20.871121"
      },
      {
        "name": "PESAC",
        "zip": "307316",
        "lat": "45.9959",
        "long": "20.835218"
      },
      {
        "name": "PETROASA MARE",
        "zip": "307464",
        "lat": "45.61743",
        "long": "21.847311"
      },
      {
        "name": "PETROMAN",
        "zip": "307117",
        "lat": "45.541588",
        "long": "21.11405"
      },
      {
        "name": "PETROVASELO",
        "zip": "307346",
        "lat": "45.815103",
        "long": "21.581069"
      },
      {
        "name": "PIETROASA",
        "zip": "307320",
        "lat": "45.836467",
        "long": "22.394778"
      },
      {
        "name": "PINI",
        "zip": "307466",
        "lat": "45.633115",
        "long": "21.893629"
      },
      {
        "name": "PISCHIA",
        "zip": "307325",
        "lat": "45.904119",
        "long": "21.340359"
      },
      {
        "name": "POGANESTI",
        "zip": "307031",
        "lat": "45.72422",
        "long": "22.015664"
      },
      {
        "name": "POIENI",
        "zip": "307323",
        "lat": "45.798636",
        "long": "22.452561"
      },
      {
        "name": "PORDEANU",
        "zip": "307037",
        "lat": "46.148253",
        "long": "20.40054"
      },
      {
        "name": "POVARGINA",
        "zip": "305309",
        "lat": "45.8853",
        "long": "22.134664"
      },
      {
        "name": "PUSTINIS",
        "zip": "307448",
        "lat": "45.634192",
        "long": "20.857956"
      },
      {
        "name": "RACHITA",
        "zip": "307157",
        "lat": "45.838059",
        "long": "22.104323"
      },
      {
        "name": "RACOVITA",
        "zip": "307330",
        "lat": "45.699739",
        "long": "21.636334"
      },
      {
        "name": "RADMANESTI",
        "zip": "307023",
        "lat": "45.927149",
        "long": "21.904373"
      },
      {
        "name": "RAUTI",
        "zip": "307449",
        "lat": "45.673291",
        "long": "20.932765"
      },
      {
        "name": "RECAS",
        "zip": "307340",
        "lat": "45.801707",
        "long": "21.509292"
      },
      {
        "name": "REMETEA MARE",
        "zip": "307350",
        "lat": "45.779585",
        "long": "21.375415"
      },
      {
        "name": "REMETEA MICA",
        "zip": "307273",
        "lat": "45.966634",
        "long": "21.479603"
      },
      {
        "name": "REMETEA-LUNCA",
        "zip": "307277",
        "lat": "45.862589",
        "long": "22.044674"
      },
      {
        "name": "ROMANESTI",
        "zip": "307416",
        "lat": "45.810324",
        "long": "22.314608"
      },
      {
        "name": "ROVINITA MARE",
        "zip": "307147",
        "lat": "45.377087",
        "long": "21.295393"
      },
      {
        "name": "ROVINITA MICA",
        "zip": "307148",
        "lat": "45.349598",
        "long": "21.31122"
      },
      {
        "name": "RUDICICA",
        "zip": "307288",
        "lat": "45.708068",
        "long": "21.2729"
      },
      {
        "name": "RUDNA",
        "zip": "307228",
        "lat": "45.498384",
        "long": "21.00863"
      },
      {
        "name": "SACALAZ",
        "zip": "307370",
        "lat": "45.759704",
        "long": "21.110776"
      },
      {
        "name": "SACENI",
        "zip": "307437",
        "lat": "45.763247",
        "long": "22.061956"
      },
      {
        "name": "SACOSU MARE",
        "zip": "307142",
        "lat": "45.584425",
        "long": "21.729723"
      },
      {
        "name": "SACOSU TURCESC",
        "zip": "307355",
        "lat": "45.65195",
        "long": "21.428894"
      },
      {
        "name": "SAG",
        "zip": "307395",
        "lat": "45.648612",
        "long": "21.175561"
      },
      {
        "name": "SALBAGEL",
        "zip": "307183",
        "lat": "45.567684",
        "long": "22.039195"
      },
      {
        "name": "SALCIUA NOUA",
        "zip": "307329",
        "lat": "45.901734",
        "long": "21.502313"
      },
      {
        "name": "SANANDREI",
        "zip": "307375",
        "lat": "45.855091",
        "long": "21.167738"
      },
      {
        "name": "SANDRA",
        "zip": "307065",
        "lat": "45.925786",
        "long": "20.8939"
      },
      {
        "name": "SANGEORGE",
        "zip": "307192",
        "lat": "45.400125",
        "long": "21.319955"
      },
      {
        "name": "SANMARTINU MAGHIAR",
        "zip": "307451",
        "lat": "45.637168",
        "long": "20.912116"
      },
      {
        "name": "SANMARTINU SARBESC",
        "zip": "307312",
        "lat": "45.605571",
        "long": "20.957124"
      },
      {
        "name": "SANMIHAIU GERMAN",
        "zip": "307381",
        "lat": "45.710543",
        "long": "21.030306"
      },
      {
        "name": "SANMIHAIU ROMAN",
        "zip": "307380",
        "lat": "45.704454",
        "long": "21.088903"
      },
      {
        "name": "SANNICOLAU MARE",
        "zip": "305600",
        "lat": "46.071125",
        "long": "20.624115"
      },
      {
        "name": "SANOVITA",
        "zip": "307208",
        "lat": "45.799898",
        "long": "21.725233"
      },
      {
        "name": "SANPETRU MARE",
        "zip": "307385",
        "lat": "46.045742",
        "long": "20.817701"
      },
      {
        "name": "SANPETRU MIC",
        "zip": "307457",
        "lat": "46.028897",
        "long": "21.036149"
      },
      {
        "name": "SARAVALE",
        "zip": "307387",
        "lat": "46.068958",
        "long": "20.740211"
      },
      {
        "name": "SARAZANI",
        "zip": "307032",
        "lat": "45.737378",
        "long": "22.060963"
      },
      {
        "name": "SARBOVA",
        "zip": "307336",
        "lat": "45.699728",
        "long": "21.557633"
      },
      {
        "name": "SATCHINEZ",
        "zip": "307365",
        "lat": "45.937496",
        "long": "21.040569"
      },
      {
        "name": "SCULIA",
        "zip": "307193",
        "lat": "45.444293",
        "long": "21.432254"
      },
      {
        "name": "SECAS",
        "zip": "307390",
        "lat": "45.885",
        "long": "21.819167"
      },
      {
        "name": "SECEANI",
        "zip": "307308",
        "lat": "45.977104",
        "long": "21.317388"
      },
      {
        "name": "SEMLACU MARE",
        "zip": "307194",
        "lat": "45.362016",
        "long": "21.43931"
      },
      {
        "name": "SEMLACU MIC",
        "zip": "307196",
        "lat": "45.349056",
        "long": "21.411764"
      },
      {
        "name": "SILAGIU",
        "zip": "305102",
        "lat": "45.607953",
        "long": "21.610753"
      },
      {
        "name": "SINERSIG",
        "zip": "307083",
        "lat": "45.672922",
        "long": "21.721271"
      },
      {
        "name": "SINTAR",
        "zip": "307076",
        "lat": "45.974535",
        "long": "21.594776"
      },
      {
        "name": "SINTESTI",
        "zip": "307268",
        "lat": "45.87388",
        "long": "22.246734"
      },
      {
        "name": "SIPET",
        "zip": "307432",
        "lat": "45.506964",
        "long": "21.402496"
      },
      {
        "name": "SOCA",
        "zip": "307016",
        "lat": "45.371245",
        "long": "21.164253"
      },
      {
        "name": "SPATA",
        "zip": "307024",
        "lat": "45.931025",
        "long": "21.873194"
      },
      {
        "name": "STAMORA GERMANA",
        "zip": "307283",
        "lat": "45.282099",
        "long": "21.249059"
      },
      {
        "name": "STAMORA ROMANA",
        "zip": "307359",
        "lat": "45.60888",
        "long": "21.399531"
      },
      {
        "name": "STANCIOVA",
        "zip": "307347",
        "lat": "45.866175",
        "long": "21.570059"
      },
      {
        "name": "STIUCA",
        "zip": "307400",
        "lat": "45.573141",
        "long": "21.981304"
      },
      {
        "name": "SUDRIAS",
        "zip": "307438",
        "lat": "45.789523",
        "long": "22.028571"
      },
      {
        "name": "SURDUCU MIC",
        "zip": "307439",
        "lat": "45.767048",
        "long": "22.093079"
      },
      {
        "name": "SUSANI",
        "zip": "307441",
        "lat": "45.803183",
        "long": "21.996932"
      },
      {
        "name": "SUSTRA",
        "zip": "307424",
        "lat": "45.786158",
        "long": "21.583919"
      },
      {
        "name": "TAPIA",
        "zip": "305502",
        "lat": "45.67995",
        "long": "21.970392"
      },
      {
        "name": "TARGOVISTE",
        "zip": "307008",
        "lat": "45.815544",
        "long": "21.825483"
      },
      {
        "name": "TEMERESTI",
        "zip": "305310",
        "lat": "45.873279",
        "long": "22.214852"
      },
      {
        "name": "TEREMIA MARE",
        "zip": "307405",
        "lat": "45.935508",
        "long": "20.527012"
      },
      {
        "name": "TEREMIA MICA",
        "zip": "307407",
        "lat": "45.957732",
        "long": "20.498388"
      },
      {
        "name": "TES",
        "zip": "307089",
        "lat": "45.846206",
        "long": "21.658102"
      },
      {
        "name": "TIMISOARA",
        "zip": "300001",
        "lat": "45.753835",
        "long": "21.225747"
      },
      {
        "name": "TIPARI",
        "zip": "307128",
        "lat": "45.762763",
        "long": "21.851259"
      },
      {
        "name": "TOAGER",
        "zip": "307217",
        "lat": "45.412519",
        "long": "20.965108"
      },
      {
        "name": "TOMESTI",
        "zip": "307410",
        "lat": "45.786134",
        "long": "22.308238"
      },
      {
        "name": "TOMNATIC",
        "zip": "307255",
        "lat": "45.98857",
        "long": "20.661859"
      },
      {
        "name": "TOPLA",
        "zip": "307278",
        "lat": "45.897707",
        "long": "22.038396"
      },
      {
        "name": "TOPOLOVATU MARE",
        "zip": "307420",
        "lat": "45.773895",
        "long": "21.618885"
      },
      {
        "name": "TOPOLOVATU MIC",
        "zip": "307426",
        "lat": "45.759633",
        "long": "21.641965"
      },
      {
        "name": "TORMAC",
        "zip": "307430",
        "lat": "45.520834",
        "long": "21.493605"
      },
      {
        "name": "TRAIAN VUIA",
        "zip": "307435",
        "lat": "45.799731",
        "long": "22.067867"
      },
      {
        "name": "UIHEI",
        "zip": "307061",
        "lat": "45.911769",
        "long": "20.862128"
      },
      {
        "name": "UIVAR",
        "zip": "307445",
        "lat": "45.658059",
        "long": "20.905838"
      },
      {
        "name": "ULIUC",
        "zip": "307361",
        "lat": "45.677235",
        "long": "21.360754"
      },
      {
        "name": "UNIP",
        "zip": "307362",
        "lat": "45.656798",
        "long": "21.336993"
      },
      {
        "name": "URSENI",
        "zip": "307289",
        "lat": "45.693154",
        "long": "21.308506"
      },
      {
        "name": "UTVIN",
        "zip": "307382",
        "lat": "45.712976",
        "long": "21.13011"
      },
      {
        "name": "VALCANI",
        "zip": "307153",
        "lat": "46.0031",
        "long": "20.400129"
      },
      {
        "name": "VALEA LUNGA ROMANA",
        "zip": "307129",
        "lat": "45.754154",
        "long": "21.956153"
      },
      {
        "name": "VARIAS",
        "zip": "307455",
        "lat": "46.011798",
        "long": "20.961373"
      },
      {
        "name": "VICTOR VLAD DELAMARINA",
        "zip": "307460",
        "lat": "45.641242",
        "long": "21.896342"
      },
      {
        "name": "VISAG",
        "zip": "307467",
        "lat": "45.547571",
        "long": "21.815617"
      },
      {
        "name": "VIZEJDIA",
        "zip": "307252",
        "lat": "45.942854",
        "long": "20.652958"
      },
      {
        "name": "VIZMA",
        "zip": "307393",
        "lat": "45.925106",
        "long": "21.835386"
      },
      {
        "name": "VOITEG",
        "zip": "307470",
        "lat": "45.468891",
        "long": "21.239169"
      },
      {
        "name": "VUCOVA",
        "zip": "307107",
        "lat": "45.620531",
        "long": "21.511822"
      },
      {
        "name": "ZGRIBESTI",
        "zip": "307403",
        "lat": "45.52924",
        "long": "22.021782"
      },
      {
        "name": "ZOLT",
        "zip": "307172",
        "lat": "45.755915",
        "long": "22.255529"
      },
      {
        "name": "ZORANI",
        "zip": "307269",
        "lat": "45.871844",
        "long": "22.277521"
      }
    ],
    "TULCEA": [
      {
        "name": "AGIGHIOL",
        "zip": "827236",
        "lat": "45.032676",
        "long": "28.880102"
      },
      {
        "name": "ALBA",
        "zip": "827106",
        "lat": "45.06405",
        "long": "28.518586"
      },
      {
        "name": "ARDEALU",
        "zip": "827071",
        "lat": "44.973407",
        "long": "28.314527"
      },
      {
        "name": "ATMAGEA",
        "zip": "827056",
        "lat": "44.965485",
        "long": "28.4347"
      },
      {
        "name": "BABADAG",
        "zip": "825100",
        "lat": "44.892905",
        "long": "28.721104"
      },
      {
        "name": "BAIA",
        "zip": "827005",
        "lat": "44.723253",
        "long": "28.677849"
      },
      {
        "name": "BALABANCEA",
        "zip": "827091",
        "lat": "45.0694",
        "long": "28.406097"
      },
      {
        "name": "BALTENII DE JOS",
        "zip": "827131",
        "lat": "45.119911",
        "long": "29.056548"
      },
      {
        "name": "BALTENII DE SUS",
        "zip": "827132",
        "lat": "45.124961",
        "long": "29.001433"
      },
      {
        "name": "BEIDAUD",
        "zip": "827010",
        "lat": "44.712037",
        "long": "28.584766"
      },
      {
        "name": "BESTEPE",
        "zip": "827133",
        "lat": "45.092634",
        "long": "29.015554"
      },
      {
        "name": "C.A. ROSETTI",
        "zip": "827015",
        "lat": "45.293478",
        "long": "29.568245"
      },
      {
        "name": "CALFA",
        "zip": "827221",
        "lat": "44.826676",
        "long": "28.349967"
      },
      {
        "name": "CAMENA",
        "zip": "827006",
        "lat": "44.810396",
        "long": "28.607292"
      },
      {
        "name": "CAPRIOARA",
        "zip": "827092",
        "lat": "45.123246",
        "long": "28.404812"
      },
      {
        "name": "CARAORMAN",
        "zip": "827061",
        "lat": "45.07783",
        "long": "29.390516"
      },
      {
        "name": "CARCALIU",
        "zip": "827020",
        "lat": "45.18688",
        "long": "28.148696"
      },
      {
        "name": "CARDON",
        "zip": "827016",
        "lat": "45.237687",
        "long": "29.621685"
      },
      {
        "name": "CARJELARI",
        "zip": "827072",
        "lat": "44.962669",
        "long": "28.34115"
      },
      {
        "name": "CASIMCEA",
        "zip": "827025",
        "lat": "44.713988",
        "long": "28.379287"
      },
      {
        "name": "CASLITA",
        "zip": "827051",
        "lat": "45.351188",
        "long": "29.299306"
      },
      {
        "name": "CATALOI",
        "zip": "827076",
        "lat": "45.095078",
        "long": "28.731524"
      },
      {
        "name": "CAUGAGIA",
        "zip": "827007",
        "lat": "44.792043",
        "long": "28.66577"
      },
      {
        "name": "CEAMURLIA DE JOS",
        "zip": "827035",
        "lat": "44.738137",
        "long": "28.727416"
      },
      {
        "name": "CEAMURLIA DE SUS",
        "zip": "827008",
        "lat": "44.763712",
        "long": "28.60547"
      },
      {
        "name": "CEATALCHIOI",
        "zip": "827040",
        "lat": "45.288554",
        "long": "28.79366"
      },
      {
        "name": "CERBU",
        "zip": "827222",
        "lat": "44.8286",
        "long": "28.421515"
      },
      {
        "name": "CERNA",
        "zip": "827045",
        "lat": "45.079551",
        "long": "28.300177"
      },
      {
        "name": "CHILIA VECHE",
        "zip": "827050",
        "lat": "45.414166",
        "long": "29.289194"
      },
      {
        "name": "CISMEAUA NOUA",
        "zip": "827026",
        "lat": "44.800523",
        "long": "28.334956"
      },
      {
        "name": "CIUCUROVA",
        "zip": "827055",
        "lat": "44.912709",
        "long": "28.481472"
      },
      {
        "name": "CLOSCA",
        "zip": "827096",
        "lat": "45.009343",
        "long": "28.476579"
      },
      {
        "name": "COLINA",
        "zip": "827151",
        "lat": "45.025465",
        "long": "29.03192"
      },
      {
        "name": "CORUGEA",
        "zip": "827027",
        "lat": "44.735651",
        "long": "28.339544"
      },
      {
        "name": "CRISAN",
        "zip": "827060",
        "lat": "45.17355",
        "long": "29.389012"
      },
      {
        "name": "DAENI",
        "zip": "827065",
        "lat": "44.84445",
        "long": "28.127823"
      },
      {
        "name": "DOROBANTU",
        "zip": "827070",
        "lat": "44.959134",
        "long": "28.287207"
      },
      {
        "name": "DUNAVATU DE JOS",
        "zip": "827152",
        "lat": "44.982809",
        "long": "29.223392"
      },
      {
        "name": "DUNAVATU DE SUS",
        "zip": "827153",
        "lat": "45.014277",
        "long": "29.220511"
      },
      {
        "name": "ENISALA",
        "zip": "827191",
        "lat": "44.87857",
        "long": "28.818864"
      },
      {
        "name": "FAGARASU NOU",
        "zip": "827223",
        "lat": "44.859419",
        "long": "28.281288"
      },
      {
        "name": "FANTANA MARE",
        "zip": "827057",
        "lat": "44.861347",
        "long": "28.496562"
      },
      {
        "name": "FANTANA OILOR",
        "zip": "827073",
        "lat": "44.923312",
        "long": "28.25316"
      },
      {
        "name": "FLORESTI",
        "zip": "827097",
        "lat": "45.073191",
        "long": "28.449531"
      },
      {
        "name": "FRECATEI",
        "zip": "827075",
        "lat": "45.10707",
        "long": "28.659185"
      },
      {
        "name": "GARVAN",
        "zip": "827111",
        "lat": "45.352467",
        "long": "28.157236"
      },
      {
        "name": "GENERAL PRAPORGESCU",
        "zip": "827046",
        "lat": "45.014951",
        "long": "28.375317"
      },
      {
        "name": "GORGOVA",
        "zip": "827136",
        "lat": "45.179",
        "long": "29.167357"
      },
      {
        "name": "GRECI",
        "zip": "827080",
        "lat": "45.190103",
        "long": "28.232956"
      },
      {
        "name": "GRINDU",
        "zip": "827085",
        "lat": "45.405843",
        "long": "28.208658"
      },
      {
        "name": "HAIDAR",
        "zip": "827028",
        "lat": "44.774208",
        "long": "28.276092"
      },
      {
        "name": "HAMCEARCA",
        "zip": "827090",
        "lat": "45.116728",
        "long": "28.394079"
      },
      {
        "name": "HORIA",
        "zip": "827095",
        "lat": "45.026797",
        "long": "28.452234"
      },
      {
        "name": "I. C. BRATIANU",
        "zip": "827100",
        "lat": "45.40648",
        "long": "28.053324"
      },
      {
        "name": "IAZURILE",
        "zip": "827237",
        "lat": "45.020988",
        "long": "28.945601"
      },
      {
        "name": "ILGANII DE JOS",
        "zip": "827171",
        "lat": "45.156238",
        "long": "28.921851"
      },
      {
        "name": "ILGANII DE SUS",
        "zip": "827137",
        "lat": "45.194803",
        "long": "28.950961"
      },
      {
        "name": "ISACCEA",
        "zip": "825200",
        "lat": "45.272189",
        "long": "28.457146"
      },
      {
        "name": "IULIA",
        "zip": "827107",
        "lat": "45.015904",
        "long": "28.545746"
      },
      {
        "name": "IZVOARELE",
        "zip": "827105",
        "lat": "45.037993",
        "long": "28.536189"
      },
      {
        "name": "JIJILA",
        "zip": "827110",
        "lat": "45.305159",
        "long": "28.149357"
      },
      {
        "name": "JURILOVCA",
        "zip": "827115",
        "lat": "44.759284",
        "long": "28.874206"
      },
      {
        "name": "LASTUNI",
        "zip": "827146",
        "lat": "45.027181",
        "long": "28.696978"
      },
      {
        "name": "LETEA",
        "zip": "827017",
        "lat": "45.28407",
        "long": "29.524399"
      },
      {
        "name": "LUMINITA",
        "zip": "827224",
        "lat": "44.894721",
        "long": "28.330675"
      },
      {
        "name": "LUNCA",
        "zip": "827036",
        "lat": "44.73021",
        "long": "28.777198"
      },
      {
        "name": "LUNCAVITA",
        "zip": "827120",
        "lat": "45.286948",
        "long": "28.277047"
      },
      {
        "name": "MACIN",
        "zip": "825300",
        "lat": "45.247359",
        "long": "28.134154"
      },
      {
        "name": "MAGURELE",
        "zip": "827226",
        "lat": "44.902235",
        "long": "28.233019"
      },
      {
        "name": "MAHMUDIA",
        "zip": "827130",
        "lat": "45.086074",
        "long": "29.087599"
      },
      {
        "name": "MALCOCI",
        "zip": "827172",
        "lat": "45.138512",
        "long": "28.888244"
      },
      {
        "name": "MALIUC",
        "zip": "827135",
        "lat": "45.176596",
        "long": "29.111409"
      },
      {
        "name": "MESTERU",
        "zip": "827074",
        "lat": "44.926339",
        "long": "28.305005"
      },
      {
        "name": "MIHAI BRAVU",
        "zip": "827140",
        "lat": "44.948006",
        "long": "28.657023"
      },
      {
        "name": "MIHAIL KOGALNICEANU",
        "zip": "827145",
        "lat": "45.039322",
        "long": "28.736604"
      },
      {
        "name": "MILA 23",
        "zip": "827062",
        "lat": "45.228543",
        "long": "29.248702"
      },
      {
        "name": "MINA ALTAN TEPE",
        "zip": "827216",
        "lat": "44.788727",
        "long": "28.565729"
      },
      {
        "name": "MINERI",
        "zip": "827211",
        "lat": "45.163965",
        "long": "28.714638"
      },
      {
        "name": "MIRCEA VODA",
        "zip": "827047",
        "lat": "45.037113",
        "long": "28.355584"
      },
      {
        "name": "MURIGHIOL",
        "zip": "827150",
        "lat": "45.037137",
        "long": "29.16591"
      },
      {
        "name": "NALBANT",
        "zip": "827160",
        "lat": "45.047802",
        "long": "28.616172"
      },
      {
        "name": "NEATARNAREA",
        "zip": "827011",
        "lat": "44.745889",
        "long": "28.506687"
      },
      {
        "name": "NICOLAE BALCESCU",
        "zip": "827161",
        "lat": "44.995991",
        "long": "28.586647"
      },
      {
        "name": "NICULITEL",
        "zip": "827165",
        "lat": "45.183414",
        "long": "28.477478"
      },
      {
        "name": "NIFON",
        "zip": "827093",
        "lat": "45.154745",
        "long": "28.3716"
      },
      {
        "name": "NUFARU",
        "zip": "827170",
        "lat": "45.150478",
        "long": "28.920349"
      },
      {
        "name": "OSTROV",
        "zip": "827175",
        "lat": "44.919984",
        "long": "28.149281"
      },
      {
        "name": "OSTROVU TATARU",
        "zip": "827052",
        "lat": "45.385918",
        "long": "29.228015"
      },
      {
        "name": "PANDURU",
        "zip": "827009",
        "lat": "44.697146",
        "long": "28.638061"
      },
      {
        "name": "PARCHES",
        "zip": "827212",
        "lat": "45.214408",
        "long": "28.592122"
      },
      {
        "name": "PARDINA",
        "zip": "827180",
        "lat": "45.306432",
        "long": "28.956932"
      },
      {
        "name": "PARTIZANI",
        "zip": "827138",
        "lat": "45.191444",
        "long": "28.942084"
      },
      {
        "name": "PATLAGEANCA",
        "zip": "827041",
        "lat": "45.229177",
        "long": "28.745982"
      },
      {
        "name": "PECENEAGA",
        "zip": "827185",
        "lat": "45.008488",
        "long": "28.148723"
      },
      {
        "name": "PERIPRAVA",
        "zip": "827018",
        "lat": "45.401781",
        "long": "29.547184"
      },
      {
        "name": "PIATRA",
        "zip": "827176",
        "lat": "44.897807",
        "long": "28.142719"
      },
      {
        "name": "PLAURU",
        "zip": "827042",
        "lat": "45.323581",
        "long": "28.829367"
      },
      {
        "name": "PLOPUL",
        "zip": "827154",
        "lat": "45.022072",
        "long": "29.129365"
      },
      {
        "name": "POSTA",
        "zip": "827077",
        "lat": "45.117536",
        "long": "28.622027"
      },
      {
        "name": "RACHELU",
        "zip": "827121",
        "lat": "45.286674",
        "long": "28.323491"
      },
      {
        "name": "RAHMAN",
        "zip": "827029",
        "lat": "44.799195",
        "long": "28.272857"
      },
      {
        "name": "RANDUNICA",
        "zip": "827147",
        "lat": "45.000796",
        "long": "28.750907"
      },
      {
        "name": "RAZBOIENI",
        "zip": "827031",
        "lat": "44.765223",
        "long": "28.419727"
      },
      {
        "name": "REVARSAREA",
        "zip": "825201",
        "lat": "45.276361",
        "long": "28.387088"
      },
      {
        "name": "SABANGIA",
        "zip": "827192",
        "lat": "44.975193",
        "long": "28.883237"
      },
      {
        "name": "SALCENI",
        "zip": "827043",
        "lat": "45.274444",
        "long": "28.763086"
      },
      {
        "name": "SALCIOARA",
        "zip": "827116",
        "lat": "44.799375",
        "long": "28.888018"
      },
      {
        "name": "SAMBATA NOUA",
        "zip": "827227",
        "lat": "44.839372",
        "long": "28.40238"
      },
      {
        "name": "SARICHIOI",
        "zip": "827190",
        "lat": "44.944583",
        "long": "28.851823"
      },
      {
        "name": "SARIGHIOL DE DEAL",
        "zip": "827012",
        "lat": "44.699222",
        "long": "28.512953"
      },
      {
        "name": "SARINASUF",
        "zip": "827156",
        "lat": "45.010703",
        "long": "29.060545"
      },
      {
        "name": "SATU NOU",
        "zip": "827141",
        "lat": "44.956204",
        "long": "28.68408"
      },
      {
        "name": "SFANTU GHEORGHE",
        "zip": "827195",
        "lat": "44.896507",
        "long": "29.592905"
      },
      {
        "name": "SFISTOFCA",
        "zip": "827019",
        "lat": "45.298247",
        "long": "29.59575"
      },
      {
        "name": "SLAVA CERCHEZA",
        "zip": "827200",
        "lat": "44.901255",
        "long": "28.557107"
      },
      {
        "name": "SLAVA RUSA",
        "zip": "827201",
        "lat": "44.850295",
        "long": "28.605568"
      },
      {
        "name": "SMARDAN",
        "zip": "827205",
        "lat": "45.28462",
        "long": "28.005993"
      },
      {
        "name": "SOMOVA",
        "zip": "827210",
        "lat": "45.192038",
        "long": "28.658676"
      },
      {
        "name": "STANCA",
        "zip": "827032",
        "lat": "44.745473",
        "long": "28.290515"
      },
      {
        "name": "STEJARU",
        "zip": "827215",
        "lat": "44.770075",
        "long": "28.545627"
      },
      {
        "name": "SULINA",
        "zip": "825400",
        "lat": "45.155326",
        "long": "29.653673"
      },
      {
        "name": "TATANIR",
        "zip": "827053",
        "lat": "45.351131",
        "long": "29.033322"
      },
      {
        "name": "TELITA",
        "zip": "827078",
        "lat": "45.15545",
        "long": "28.567359"
      },
      {
        "name": "TICHILESTI",
        "zip": "825202",
        "lat": "45.263844",
        "long": "28.358605"
      },
      {
        "name": "TOPOLOG",
        "zip": "827220",
        "lat": "44.874463",
        "long": "28.374257"
      },
      {
        "name": "TRAIAN",
        "zip": "827048",
        "lat": "45.028903",
        "long": "28.234641"
      },
      {
        "name": "TRESTENIC",
        "zip": "827162",
        "lat": "45.078884",
        "long": "28.589886"
      },
      {
        "name": "TUDOR VLADIMIRESCU",
        "zip": "820001",
        "lat": "45.186746",
        "long": "28.799536"
      },
      {
        "name": "TULCEA",
        "zip": "820002",
        "lat": "45.177929",
        "long": "28.801892"
      },
      {
        "name": "TURCOAIA",
        "zip": "827230",
        "lat": "45.116097",
        "long": "28.190836"
      },
      {
        "name": "TURDA",
        "zip": "827142",
        "lat": "44.975581",
        "long": "28.623527"
      },
      {
        "name": "UZLINA",
        "zip": "827157",
        "lat": "45.075505",
        "long": "29.225067"
      },
      {
        "name": "VACARENI",
        "zip": "827125",
        "lat": "45.325651",
        "long": "28.194973"
      },
      {
        "name": "VALEA NUCARILOR",
        "zip": "827235",
        "lat": "45.043917",
        "long": "28.937361"
      },
      {
        "name": "VALEA TEILOR",
        "zip": "827108",
        "lat": "45.112011",
        "long": "28.487828"
      },
      {
        "name": "VASILE ALECSANDRI",
        "zip": "827217",
        "lat": "44.796088",
        "long": "28.503932"
      },
      {
        "name": "VICTORIA",
        "zip": "827173",
        "lat": "45.12933",
        "long": "28.966077"
      },
      {
        "name": "VISINA",
        "zip": "827117",
        "lat": "44.757874",
        "long": "28.840911"
      },
      {
        "name": "VISTERNA",
        "zip": "827193",
        "lat": "44.860945",
        "long": "28.769136"
      },
      {
        "name": "VULTURU",
        "zip": "827139",
        "lat": "45.174149",
        "long": "29.070068"
      },
      {
        "name": "ZEBIL",
        "zip": "827194",
        "lat": "44.946003",
        "long": "28.768731"
      }
    ],
    "VÂLCEA": [
      {
        "name": "AFANATA",
        "zip": "247166",
        "lat": "44.70465",
        "long": "23.97645"
      },
      {
        "name": "ALDESTI",
        "zip": "247231",
        "lat": "45.063529",
        "long": "24.431528"
      },
      {
        "name": "ALUNU",
        "zip": "247005",
        "lat": "45.021874",
        "long": "23.823606"
      },
      {
        "name": "AMARASTI",
        "zip": "247015",
        "lat": "44.766559",
        "long": "24.152024"
      },
      {
        "name": "ANDREIESTI",
        "zip": "247406",
        "lat": "45.218274",
        "long": "24.279063"
      },
      {
        "name": "ANINOASA",
        "zip": "247226",
        "lat": "44.793914",
        "long": "24.154307"
      },
      {
        "name": "ARANGHEL",
        "zip": "240001",
        "lat": "45.116035",
        "long": "24.327013"
      },
      {
        "name": "ARICIOAIA",
        "zip": "247681",
        "lat": "44.920521",
        "long": "24.221962"
      },
      {
        "name": "ARMASESTI",
        "zip": "247096",
        "lat": "45.01717",
        "long": "24.012287"
      },
      {
        "name": "ARSANCA",
        "zip": "247376",
        "lat": "45.009544",
        "long": "24.238532"
      },
      {
        "name": "AURESTI",
        "zip": "247451",
        "lat": "44.774413",
        "long": "24.266521"
      },
      {
        "name": "AVRAMESTI",
        "zip": "247591",
        "lat": "44.868155",
        "long": "24.161699"
      },
      {
        "name": "BABENI",
        "zip": "245100",
        "lat": "44.973188",
        "long": "24.236732"
      },
      {
        "name": "BABENI-OLTETU",
        "zip": "247156",
        "lat": "44.614038",
        "long": "23.97798"
      },
      {
        "name": "BABUESTI",
        "zip": "247126",
        "lat": "45.210855",
        "long": "24.411251"
      },
      {
        "name": "BADENI",
        "zip": "247131",
        "lat": "44.900816",
        "long": "24.427218"
      },
      {
        "name": "BAIASA",
        "zip": "247541",
        "lat": "44.930793",
        "long": "24.063432"
      },
      {
        "name": "BAIASU",
        "zip": "247481",
        "lat": "45.371798",
        "long": "24.394872"
      },
      {
        "name": "BAJENARI",
        "zip": "247542",
        "lat": "44.919527",
        "long": "24.080739"
      },
      {
        "name": "BALACIU",
        "zip": "247556",
        "lat": "44.931761",
        "long": "23.93409"
      },
      {
        "name": "BALCESTI",
        "zip": "245400",
        "lat": "44.617599",
        "long": "23.939781"
      },
      {
        "name": "BALOMIREASA",
        "zip": "247646",
        "lat": "44.91085",
        "long": "24.377512"
      },
      {
        "name": "BALOTA",
        "zip": "247531",
        "lat": "45.43514",
        "long": "24.294063"
      },
      {
        "name": "BALSOARA",
        "zip": "247361",
        "lat": "44.673421",
        "long": "24.123514"
      },
      {
        "name": "BALTATENI",
        "zip": "247706",
        "lat": "45.084871",
        "long": "24.067384"
      },
      {
        "name": "BALTENI",
        "zip": "247106",
        "lat": "45.017655",
        "long": "23.94909"
      },
      {
        "name": "BALUTOAIA",
        "zip": "247196",
        "lat": "45.047126",
        "long": "24.18792"
      },
      {
        "name": "BANESTI",
        "zip": "247416",
        "lat": "44.99586",
        "long": "24.390919"
      },
      {
        "name": "BANTESTI",
        "zip": "247362",
        "lat": "44.684174",
        "long": "24.073925"
      },
      {
        "name": "BARBARIGENI",
        "zip": "247543",
        "lat": "44.883116",
        "long": "24.062634"
      },
      {
        "name": "BARBATESTI",
        "zip": "247025",
        "lat": "45.168849",
        "long": "24.117835"
      },
      {
        "name": "BARBUCENI",
        "zip": "247526",
        "lat": "44.746387",
        "long": "24.244825"
      },
      {
        "name": "BARCANELE",
        "zip": "247461",
        "lat": "45.085804",
        "long": "24.134143"
      },
      {
        "name": "BARCANESTI",
        "zip": "247616",
        "lat": "44.804404",
        "long": "24.031022"
      },
      {
        "name": "BARLOGU",
        "zip": "247626",
        "lat": "45.106075",
        "long": "24.150201"
      },
      {
        "name": "BAROIU",
        "zip": "247696",
        "lat": "44.715725",
        "long": "23.921742"
      },
      {
        "name": "BARSESTI",
        "zip": "247057",
        "lat": "45.040603",
        "long": "24.350464"
      },
      {
        "name": "BARSESTI",
        "zip": "247377",
        "lat": "45.0559",
        "long": "24.250944"
      },
      {
        "name": "BARSOIU",
        "zip": "247647",
        "lat": "44.881844",
        "long": "24.342649"
      },
      {
        "name": "BARZA",
        "zip": "247056",
        "lat": "45.048658",
        "long": "24.371244"
      },
      {
        "name": "BARZESTI",
        "zip": "247026",
        "lat": "45.130454",
        "long": "24.113847"
      },
      {
        "name": "BATASANI",
        "zip": "247731",
        "lat": "44.684265",
        "long": "23.991581"
      },
      {
        "name": "BECSANI",
        "zip": "247167",
        "lat": "44.795305",
        "long": "24.001061"
      },
      {
        "name": "BENESTI",
        "zip": "245401",
        "lat": "44.656326",
        "long": "23.907814"
      },
      {
        "name": "BERBESTI",
        "zip": "247030",
        "lat": "44.988866",
        "long": "23.868635"
      },
      {
        "name": "BERBESTI",
        "zip": "247281",
        "lat": "44.513011",
        "long": "24.060533"
      },
      {
        "name": "BERCIOIU",
        "zip": "247058",
        "lat": "45.002978",
        "long": "24.317517"
      },
      {
        "name": "BERESTI",
        "zip": "247306",
        "lat": "44.936004",
        "long": "24.032791"
      },
      {
        "name": "BERISLAVESTI",
        "zip": "247040",
        "lat": "45.252125",
        "long": "24.418347"
      },
      {
        "name": "BISTRITA",
        "zip": "247116",
        "lat": "45.173302",
        "long": "24.046897"
      },
      {
        "name": "BLANOIU",
        "zip": "247532",
        "lat": "45.419956",
        "long": "24.330803"
      },
      {
        "name": "BLEJANI",
        "zip": "247592",
        "lat": "44.825997",
        "long": "24.203711"
      },
      {
        "name": "BLIDARI",
        "zip": "247232",
        "lat": "45.079075",
        "long": "24.458398"
      },
      {
        "name": "BOCSA",
        "zip": "247346",
        "lat": "44.755686",
        "long": "24.033675"
      },
      {
        "name": "BODESTI",
        "zip": "247006",
        "lat": "45.065304",
        "long": "23.807621"
      },
      {
        "name": "BODESTI",
        "zip": "247027",
        "lat": "45.140904",
        "long": "24.115002"
      },
      {
        "name": "BOGDANESTI",
        "zip": "247066",
        "lat": "45.175307",
        "long": "24.334605"
      },
      {
        "name": "BOGDANESTI",
        "zip": "247456",
        "lat": "45.033979",
        "long": "24.051931"
      },
      {
        "name": "BOGDANESTI",
        "zip": "247707",
        "lat": "45.137697",
        "long": "24.034938"
      },
      {
        "name": "BOISOARA",
        "zip": "247050",
        "lat": "45.442318",
        "long": "24.383665"
      },
      {
        "name": "BONCIU",
        "zip": "245101",
        "lat": "44.954894",
        "long": "24.226758"
      },
      {
        "name": "BONDOCI",
        "zip": "247107",
        "lat": "44.960145",
        "long": "23.995848"
      },
      {
        "name": "BOROSESTI",
        "zip": "247671",
        "lat": "44.659274",
        "long": "24.213467"
      },
      {
        "name": "BOTORANI",
        "zip": "247347",
        "lat": "44.745506",
        "long": "24.047307"
      },
      {
        "name": "BRADISOR",
        "zip": "247041",
        "lat": "45.271257",
        "long": "24.420646"
      },
      {
        "name": "BRADU-CLOCOTICI",
        "zip": "247533",
        "lat": "45.406549",
        "long": "24.329659"
      },
      {
        "name": "BRATIA DIN DEAL",
        "zip": "247206",
        "lat": "44.964822",
        "long": "24.300378"
      },
      {
        "name": "BRATIA DIN VALE",
        "zip": "247207",
        "lat": "44.956601",
        "long": "24.281523"
      },
      {
        "name": "BRATOVESTI",
        "zip": "247482",
        "lat": "45.412275",
        "long": "24.364576"
      },
      {
        "name": "BREZOI",
        "zip": "245500",
        "lat": "45.343274",
        "long": "24.24424"
      },
      {
        "name": "BROSTENI",
        "zip": "247307",
        "lat": "44.940641",
        "long": "24.002946"
      },
      {
        "name": "BUCIUMENI",
        "zip": "247151",
        "lat": "44.785678",
        "long": "24.291572"
      },
      {
        "name": "BUCSANI",
        "zip": "247271",
        "lat": "44.846813",
        "long": "24.231128"
      },
      {
        "name": "BUDA",
        "zip": "245901",
        "lat": "45.100387",
        "long": "24.302442"
      },
      {
        "name": "BUDELE",
        "zip": "247697",
        "lat": "44.832632",
        "long": "23.901112"
      },
      {
        "name": "BUDESTI",
        "zip": "247055",
        "lat": "45.064865",
        "long": "24.387448"
      },
      {
        "name": "BUDESTI",
        "zip": "247157",
        "lat": "44.602476",
        "long": "23.993302"
      },
      {
        "name": "BUDURASTI",
        "zip": "247627",
        "lat": "45.139207999999996",
        "long": "24.147628"
      },
      {
        "name": "BUJORENI",
        "zip": "247065",
        "lat": "45.145773",
        "long": "24.368334"
      },
      {
        "name": "BULAGEI",
        "zip": "247648",
        "lat": "44.919081",
        "long": "24.374202"
      },
      {
        "name": "BULETA",
        "zip": "247378",
        "lat": "45.039756",
        "long": "24.253547"
      },
      {
        "name": "BUMBUESTI",
        "zip": "247051",
        "lat": "45.431841",
        "long": "24.363039"
      },
      {
        "name": "BUNESTI",
        "zip": "247075",
        "lat": "45.116758",
        "long": "24.189612"
      },
      {
        "name": "BUNGETANI",
        "zip": "247158",
        "lat": "44.572555",
        "long": "24.007977"
      },
      {
        "name": "BURDALESTI",
        "zip": "247261",
        "lat": "44.739261",
        "long": "24.113895"
      },
      {
        "name": "BUTANU",
        "zip": "247756",
        "lat": "44.755576",
        "long": "23.85638"
      },
      {
        "name": "BUZDUGAN",
        "zip": "247462",
        "lat": "45.059617",
        "long": "24.145825"
      },
      {
        "name": "CACIULATA",
        "zip": "245601",
        "lat": "45.25952",
        "long": "24.324664"
      },
      {
        "name": "CAINENII MARI",
        "zip": "247086",
        "lat": "45.499366",
        "long": "24.298991"
      },
      {
        "name": "CAINENII MICI",
        "zip": "247087",
        "lat": "45.496853",
        "long": "24.307704"
      },
      {
        "name": "CALIGI",
        "zip": "247576",
        "lat": "45.218012",
        "long": "24.462411"
      },
      {
        "name": "CALIMANESTI",
        "zip": "245600",
        "lat": "45.239346",
        "long": "24.341693"
      },
      {
        "name": "CALINA",
        "zip": "247527",
        "lat": "44.702113",
        "long": "24.253984"
      },
      {
        "name": "CALINESTI",
        "zip": "245501",
        "lat": "45.369398",
        "long": "24.292742"
      },
      {
        "name": "CAPU DEALULUI",
        "zip": "245102",
        "lat": "44.986",
        "long": "24.242275"
      },
      {
        "name": "CARCADIESTI",
        "zip": "247326",
        "lat": "44.648575",
        "long": "24.137334"
      },
      {
        "name": "CARLOGANI",
        "zip": "245402",
        "lat": "44.68292",
        "long": "23.921826"
      },
      {
        "name": "CARSTANESTI",
        "zip": "247457",
        "lat": "45.040544",
        "long": "24.046404"
      },
      {
        "name": "CASA VECHE",
        "zip": "247441",
        "lat": "44.867642",
        "long": "24.316792"
      },
      {
        "name": "CATETU",
        "zip": "247168",
        "lat": "44.830262",
        "long": "23.956143"
      },
      {
        "name": "CAZANESTI",
        "zip": "240002",
        "lat": "45.058756",
        "long": "24.287782"
      },
      {
        "name": "CAZANESTI",
        "zip": "247216",
        "lat": "44.635357",
        "long": "23.892834"
      },
      {
        "name": "CAZANESTI",
        "zip": "247396",
        "lat": "45.037302",
        "long": "24.485283"
      },
      {
        "name": "CERETU",
        "zip": "247132",
        "lat": "44.888168",
        "long": "24.456797"
      },
      {
        "name": "CERMEGESTI",
        "zip": "247291",
        "lat": "44.858786",
        "long": "24.050969"
      },
      {
        "name": "CERMEGESTI",
        "zip": "247501",
        "lat": "44.867904",
        "long": "24.139"
      },
      {
        "name": "CERNA",
        "zip": "247726",
        "lat": "45.184056",
        "long": "23.848854"
      },
      {
        "name": "CERNELELE",
        "zip": "247463",
        "lat": "45.066878",
        "long": "24.155343"
      },
      {
        "name": "CERNISOARA",
        "zip": "247095",
        "lat": "45.044362",
        "long": "23.963235"
      },
      {
        "name": "CETATEAUA",
        "zip": "247672",
        "lat": "44.761994",
        "long": "24.191987"
      },
      {
        "name": "CHEIA",
        "zip": "245301",
        "lat": "45.184966",
        "long": "24.212654"
      },
      {
        "name": "CHERASTI",
        "zip": "247557",
        "lat": "44.857701",
        "long": "23.940881"
      },
      {
        "name": "CHICENI",
        "zip": "247708",
        "lat": "45.109529",
        "long": "24.052367"
      },
      {
        "name": "CHIRCULESTI",
        "zip": "245403",
        "lat": "44.673543",
        "long": "23.926602"
      },
      {
        "name": "CHIRICESTI",
        "zip": "247292",
        "lat": "44.864902",
        "long": "24.059229"
      },
      {
        "name": "CIOBOTI",
        "zip": "247442",
        "lat": "44.850183",
        "long": "24.290672"
      },
      {
        "name": "CIOCALTEI",
        "zip": "247544",
        "lat": "44.935888",
        "long": "24.071348"
      },
      {
        "name": "CIOCANARI",
        "zip": "247348",
        "lat": "44.735255",
        "long": "24.008962"
      },
      {
        "name": "CIOPONESTI",
        "zip": "247617",
        "lat": "44.799757",
        "long": "24.028167"
      },
      {
        "name": "CIORASTI",
        "zip": "247682",
        "lat": "44.957498",
        "long": "24.160376"
      },
      {
        "name": "CIORTESTI",
        "zip": "247757",
        "lat": "44.778871",
        "long": "23.818508"
      },
      {
        "name": "CIRESU",
        "zip": "247666",
        "lat": "45.063151",
        "long": "23.912082"
      },
      {
        "name": "CIRESUL",
        "zip": "247133",
        "lat": "44.862341",
        "long": "24.436291"
      },
      {
        "name": "CIUCHETI",
        "zip": "247596",
        "lat": "44.945362",
        "long": "23.825951"
      },
      {
        "name": "CIUMAGI",
        "zip": "247293",
        "lat": "44.864949",
        "long": "24.03828"
      },
      {
        "name": "CIUNGETU",
        "zip": "247336",
        "lat": "45.386765",
        "long": "23.951917"
      },
      {
        "name": "CIUTESTI",
        "zip": "247397",
        "lat": "45.047671",
        "long": "24.498135"
      },
      {
        "name": "COASTA",
        "zip": "247233",
        "lat": "45.141234",
        "long": "24.485637"
      },
      {
        "name": "COASTA",
        "zip": "247471",
        "lat": "45.132439",
        "long": "24.247082"
      },
      {
        "name": "COASTA CERBULUI",
        "zip": "247606",
        "lat": "45.135871",
        "long": "23.911045"
      },
      {
        "name": "COASTA MARE",
        "zip": "247076",
        "lat": "45.099977",
        "long": "24.234035"
      },
      {
        "name": "COCORU",
        "zip": "247208",
        "lat": "44.946194",
        "long": "24.297831"
      },
      {
        "name": "COLELIA",
        "zip": "247159",
        "lat": "44.62895",
        "long": "23.990848"
      },
      {
        "name": "COLTESTI",
        "zip": "247007",
        "lat": "44.982718",
        "long": "23.830109"
      },
      {
        "name": "COMANCA",
        "zip": "245302",
        "lat": "45.236232",
        "long": "24.224894"
      },
      {
        "name": "CONDOIESTI",
        "zip": "247686",
        "lat": "44.597981",
        "long": "24.242628"
      },
      {
        "name": "CONTEA",
        "zip": "247758",
        "lat": "44.701149",
        "long": "23.899483"
      },
      {
        "name": "COPACELU",
        "zip": "240003",
        "lat": "45.072047",
        "long": "24.31855"
      },
      {
        "name": "COPACENI",
        "zip": "247105",
        "lat": "44.996047",
        "long": "23.972581"
      },
      {
        "name": "COPACENI",
        "zip": "247534",
        "lat": "45.393859",
        "long": "24.314545"
      },
      {
        "name": "CORBII DIN VALE",
        "zip": "247417",
        "lat": "44.992191",
        "long": "24.463567"
      },
      {
        "name": "CORBU",
        "zip": "245502",
        "lat": "45.354947",
        "long": "24.264949"
      },
      {
        "name": "CORNET",
        "zip": "247727",
        "lat": "45.169666",
        "long": "23.879147"
      },
      {
        "name": "COSANI",
        "zip": "247197",
        "lat": "45.013253",
        "long": "24.188818"
      },
      {
        "name": "COSOTA",
        "zip": "245902",
        "lat": "45.086212",
        "long": "24.272535"
      },
      {
        "name": "COSTESTI",
        "zip": "247115",
        "lat": "45.147174",
        "long": "24.064057"
      },
      {
        "name": "CRANGU",
        "zip": "247593",
        "lat": "44.874057",
        "long": "24.158855"
      },
      {
        "name": "CREMENARI",
        "zip": "247209",
        "lat": "44.98079",
        "long": "24.314363"
      },
      {
        "name": "CRETENI",
        "zip": "247120",
        "lat": "44.686137",
        "long": "24.187365"
      },
      {
        "name": "CUCESTI",
        "zip": "247458",
        "lat": "45.022643",
        "long": "24.062511"
      },
      {
        "name": "CUCI",
        "zip": "247169",
        "lat": "44.817369",
        "long": "23.968236"
      },
      {
        "name": "CUCOIU",
        "zip": "247483",
        "lat": "45.405655",
        "long": "24.394742"
      },
      {
        "name": "CUCULESTI",
        "zip": "247618",
        "lat": "44.826178",
        "long": "24.038075"
      },
      {
        "name": "CUENI",
        "zip": "247546",
        "lat": "44.892822",
        "long": "24.072148"
      },
      {
        "name": "CURATURILE",
        "zip": "245201",
        "lat": "45.066326",
        "long": "24.177579"
      },
      {
        "name": "CURTEA",
        "zip": "247516",
        "lat": "44.962312",
        "long": "24.138059"
      },
      {
        "name": "DAESTI",
        "zip": "247125",
        "lat": "45.201074",
        "long": "24.386842"
      },
      {
        "name": "DAESTI",
        "zip": "247517",
        "lat": "44.962429",
        "long": "24.121191"
      },
      {
        "name": "DAMTENI",
        "zip": "247031",
        "lat": "45.003668",
        "long": "23.897641"
      },
      {
        "name": "DANCAI",
        "zip": "247171",
        "lat": "44.764563",
        "long": "23.965082"
      },
      {
        "name": "DANGESTI",
        "zip": "247042",
        "lat": "45.290489",
        "long": "24.42353"
      },
      {
        "name": "DEALU ALUNIS",
        "zip": "247032",
        "lat": "44.996652",
        "long": "23.889827"
      },
      {
        "name": "DEALU BISERICII",
        "zip": "247597",
        "lat": "44.915609",
        "long": "23.837566"
      },
      {
        "name": "DEALU CORNI",
        "zip": "247294",
        "lat": "44.904992",
        "long": "24.052883"
      },
      {
        "name": "DEALU GLAMEIA",
        "zip": "247759",
        "lat": "44.776486",
        "long": "23.801638"
      },
      {
        "name": "DEALU LAUNELE",
        "zip": "247134",
        "lat": "44.920173",
        "long": "24.46067"
      },
      {
        "name": "DEALU MALULUI",
        "zip": "240004",
        "lat": "45.133976",
        "long": "24.331532"
      },
      {
        "name": "DEALU MARE",
        "zip": "247211",
        "lat": "44.951409",
        "long": "24.302393"
      },
      {
        "name": "DEALU MARE",
        "zip": "247262",
        "lat": "44.707611",
        "long": "24.110099"
      },
      {
        "name": "DEALU MARE",
        "zip": "247272",
        "lat": "44.819364",
        "long": "24.24025"
      },
      {
        "name": "DEALU SCHEIULUI",
        "zip": "247136",
        "lat": "44.953758",
        "long": "24.457836"
      },
      {
        "name": "DEALU VALENI",
        "zip": "247761",
        "lat": "44.788541",
        "long": "23.799667"
      },
      {
        "name": "DEJOI",
        "zip": "247172",
        "lat": "44.823177",
        "long": "24.004079"
      },
      {
        "name": "DELENI",
        "zip": "247628",
        "lat": "45.160252",
        "long": "24.166822"
      },
      {
        "name": "DELURENI",
        "zip": "247273",
        "lat": "44.836509",
        "long": "24.23682"
      },
      {
        "name": "DELURENI",
        "zip": "247649",
        "lat": "44.890565",
        "long": "24.379328"
      },
      {
        "name": "DELURENI",
        "zip": "247732",
        "lat": "44.65465",
        "long": "24.005061"
      },
      {
        "name": "DEZROBITI",
        "zip": "247198",
        "lat": "45.02692",
        "long": "24.186563"
      },
      {
        "name": "DIACONESTI",
        "zip": "247251",
        "lat": "44.909675",
        "long": "23.788706"
      },
      {
        "name": "DIANU",
        "zip": "247667",
        "lat": "45.086145",
        "long": "23.943251"
      },
      {
        "name": "DICULESTI",
        "zip": "247161",
        "lat": "44.593506",
        "long": "23.98968"
      },
      {
        "name": "DIMULESTI",
        "zip": "247363",
        "lat": "44.667702",
        "long": "24.090361"
      },
      {
        "name": "DOBRESTI",
        "zip": "247137",
        "lat": "44.925403",
        "long": "24.439491"
      },
      {
        "name": "DOBRICEA",
        "zip": "247252",
        "lat": "44.900476",
        "long": "23.863958"
      },
      {
        "name": "DOBRICENI",
        "zip": "247629",
        "lat": "45.161804",
        "long": "24.14321"
      },
      {
        "name": "DOBRUSA",
        "zip": "247687",
        "lat": "44.62654",
        "long": "24.206607"
      },
      {
        "name": "DOSU RAULUI",
        "zip": "247418",
        "lat": "44.962459",
        "long": "24.394544"
      },
      {
        "name": "DOZESTI",
        "zip": "247173",
        "lat": "44.807315",
        "long": "23.960161"
      },
      {
        "name": "DRAGANESTI",
        "zip": "245503",
        "lat": "45.351942",
        "long": "24.30335"
      },
      {
        "name": "DRAGANESTI",
        "zip": "247234",
        "lat": "45.151971",
        "long": "24.476778"
      },
      {
        "name": "DRAGANU",
        "zip": "247733",
        "lat": "44.714517",
        "long": "24.001438"
      },
      {
        "name": "DRAGASANI",
        "zip": "245700",
        "lat": "44.658914",
        "long": "24.264264"
      },
      {
        "name": "DRAGIOIU",
        "zip": "247443",
        "lat": "44.89105",
        "long": "24.291798"
      },
      {
        "name": "DRAGOESTI",
        "zip": "247150",
        "lat": "44.818978",
        "long": "24.294523"
      },
      {
        "name": "DRAGULESTI",
        "zip": "247138",
        "lat": "44.944092",
        "long": "24.442337"
      },
      {
        "name": "DUMBRAVA",
        "zip": "247327",
        "lat": "44.636353",
        "long": "24.152885"
      },
      {
        "name": "DUMBRAVESTI",
        "zip": "247709",
        "lat": "45.079059",
        "long": "24.088267"
      },
      {
        "name": "FACAI",
        "zip": "245903",
        "lat": "45.081248",
        "long": "24.282964"
      },
      {
        "name": "FARTATESTI",
        "zip": "247165",
        "lat": "44.776472",
        "long": "23.989951"
      },
      {
        "name": "FAURESTI",
        "zip": "247155",
        "lat": "44.572726",
        "long": "24.019344"
      },
      {
        "name": "FAURESTI",
        "zip": "247762",
        "lat": "44.740405",
        "long": "23.874768"
      },
      {
        "name": "FEDELESOIU",
        "zip": "247127",
        "lat": "45.152411",
        "long": "24.391616"
      },
      {
        "name": "FETENI",
        "zip": "240299",
        "lat": "45.094486",
        "long": "24.423368"
      },
      {
        "name": "FIRESTI",
        "zip": "247077",
        "lat": "45.09617",
        "long": "24.211057"
      },
      {
        "name": "FIRIJBA",
        "zip": "247518",
        "lat": "44.987588",
        "long": "24.130239"
      },
      {
        "name": "FISCALIA",
        "zip": "247274",
        "lat": "44.810421",
        "long": "24.244885"
      },
      {
        "name": "FOLESTII DE JOS",
        "zip": "247711",
        "lat": "45.060985",
        "long": "24.078266"
      },
      {
        "name": "FOLESTII DE SUS",
        "zip": "247715",
        "lat": "45.094884",
        "long": "24.059709"
      },
      {
        "name": "FOTESTI",
        "zip": "247276",
        "lat": "44.840453",
        "long": "24.225704"
      },
      {
        "name": "FRANCESTI",
        "zip": "247195",
        "lat": "44.999699",
        "long": "24.190359"
      },
      {
        "name": "FRANCESTI-COASTA",
        "zip": "247407",
        "lat": "45.204867",
        "long": "24.295172"
      },
      {
        "name": "FRASINA",
        "zip": "247547",
        "lat": "44.915502",
        "long": "24.064666"
      },
      {
        "name": "FUMURENI",
        "zip": "247328",
        "lat": "44.611261",
        "long": "24.158417"
      },
      {
        "name": "FUNDATURA",
        "zip": "247741",
        "lat": "45.149559",
        "long": "24.310109"
      },
      {
        "name": "GAGENI",
        "zip": "247296",
        "lat": "44.843597",
        "long": "24.017794"
      },
      {
        "name": "GAINESTI",
        "zip": "247162",
        "lat": "44.576593",
        "long": "24.003564"
      },
      {
        "name": "GALICEA",
        "zip": "247205",
        "lat": "44.92589",
        "long": "24.279926"
      },
      {
        "name": "GALTOFANI",
        "zip": "247419",
        "lat": "45.001576",
        "long": "24.382077"
      },
      {
        "name": "GANESTI",
        "zip": "247763",
        "lat": "44.720548",
        "long": "23.893115"
      },
      {
        "name": "GANTULEI",
        "zip": "247329",
        "lat": "44.569566",
        "long": "24.219747"
      },
      {
        "name": "GARNICET",
        "zip": "247174",
        "lat": "44.809236",
        "long": "24.010152"
      },
      {
        "name": "GARNICETU",
        "zip": "247619",
        "lat": "44.836152",
        "long": "24.043389"
      },
      {
        "name": "GATEJESTI",
        "zip": "245202",
        "lat": "45.096179",
        "long": "24.200312"
      },
      {
        "name": "GAUJANI",
        "zip": "247052",
        "lat": "45.452976",
        "long": "24.376852"
      },
      {
        "name": "GAVANESTI",
        "zip": "247408",
        "lat": "45.209919",
        "long": "24.288346"
      },
      {
        "name": "GEAMANA",
        "zip": "247152",
        "lat": "44.802698",
        "long": "24.302955"
      },
      {
        "name": "GEAMANA",
        "zip": "247651",
        "lat": "44.931288",
        "long": "24.390623"
      },
      {
        "name": "GENUNENI",
        "zip": "247199",
        "lat": "45.036437",
        "long": "24.103565"
      },
      {
        "name": "GHINDARI",
        "zip": "247282",
        "lat": "44.556979",
        "long": "24.018923"
      },
      {
        "name": "GHIOBESTI",
        "zip": "247652",
        "lat": "44.912918",
        "long": "24.343232"
      },
      {
        "name": "GHIOROIU",
        "zip": "247215",
        "lat": "44.688951",
        "long": "23.838002"
      },
      {
        "name": "GIBESTI",
        "zip": "247236",
        "lat": "45.087593",
        "long": "24.493101"
      },
      {
        "name": "GINERICA",
        "zip": "247421",
        "lat": "45.002498",
        "long": "24.495598"
      },
      {
        "name": "GIULESTI",
        "zip": "247176",
        "lat": "44.737571",
        "long": "23.974898"
      },
      {
        "name": "GIULESTII DE SUS",
        "zip": "247177",
        "lat": "44.695085",
        "long": "23.9666"
      },
      {
        "name": "GIURGIUVENI",
        "zip": "247237",
        "lat": "45.121433",
        "long": "24.492163"
      },
      {
        "name": "GIUROIU",
        "zip": "247653",
        "lat": "44.918182",
        "long": "24.342691"
      },
      {
        "name": "GLAVILE",
        "zip": "247225",
        "lat": "44.815808",
        "long": "24.136622"
      },
      {
        "name": "GLODU",
        "zip": "247139",
        "lat": "44.896916",
        "long": "24.440746"
      },
      {
        "name": "GOLOTRENI",
        "zip": "245504",
        "lat": "45.342153",
        "long": "24.277158"
      },
      {
        "name": "GORANU",
        "zip": "240440",
        "lat": "45.105579",
        "long": "24.385885"
      },
      {
        "name": "GORUNESTI",
        "zip": "245404",
        "lat": "44.567108",
        "long": "23.960936"
      },
      {
        "name": "GORUNESTI",
        "zip": "247607",
        "lat": "45.098773",
        "long": "23.89244"
      },
      {
        "name": "GOVORA",
        "zip": "247379",
        "lat": "45.068197",
        "long": "24.230482"
      },
      {
        "name": "GRADISTEA",
        "zip": "247250",
        "lat": "44.879669",
        "long": "23.821919"
      },
      {
        "name": "GREBLESTI",
        "zip": "247088",
        "lat": "45.475137",
        "long": "24.311816"
      },
      {
        "name": "GRECI",
        "zip": "247341",
        "lat": "45.093514",
        "long": "23.847335"
      },
      {
        "name": "GROPENI",
        "zip": "247577",
        "lat": "45.178258",
        "long": "24.429577"
      },
      {
        "name": "GROSI",
        "zip": "247097",
        "lat": "44.996799",
        "long": "24.037945"
      },
      {
        "name": "GRUIERI",
        "zip": "247631",
        "lat": "45.160347",
        "long": "24.157111"
      },
      {
        "name": "GRUIU",
        "zip": "247632",
        "lat": "45.147659",
        "long": "24.171204"
      },
      {
        "name": "GRUIU LUPULUI",
        "zip": "247536",
        "lat": "45.428485",
        "long": "24.341042"
      },
      {
        "name": "GUGUIANCA",
        "zip": "247277",
        "lat": "44.863209",
        "long": "24.212266"
      },
      {
        "name": "GURA CRUCILOR",
        "zip": "247141",
        "lat": "44.910025",
        "long": "24.425045"
      },
      {
        "name": "GURA SUHASULUI",
        "zip": "245904",
        "lat": "45.085401",
        "long": "24.305579"
      },
      {
        "name": "GURA VAII",
        "zip": "247067",
        "lat": "45.187048",
        "long": "24.367841"
      },
      {
        "name": "GURGUIATA",
        "zip": "245303",
        "lat": "45.215433",
        "long": "24.189538"
      },
      {
        "name": "GURISOARA",
        "zip": "247381",
        "lat": "45.075142",
        "long": "24.214644"
      },
      {
        "name": "GUSOENI",
        "zip": "247260",
        "lat": "44.71612",
        "long": "24.122192"
      },
      {
        "name": "GUSOIANCA",
        "zip": "247263",
        "lat": "44.750267",
        "long": "24.107696"
      },
      {
        "name": "HERASTI",
        "zip": "247217",
        "lat": "44.660888",
        "long": "23.86783"
      },
      {
        "name": "HOREZU",
        "zip": "245800",
        "lat": "45.145649",
        "long": "23.99058"
      },
      {
        "name": "HOTARASA",
        "zip": "247108",
        "lat": "44.951063",
        "long": "24.013041"
      },
      {
        "name": "HOTARELE",
        "zip": "247409",
        "lat": "45.184062",
        "long": "24.341642"
      },
      {
        "name": "HOTAROAIA",
        "zip": "247558",
        "lat": "44.850932",
        "long": "23.919538"
      },
      {
        "name": "IACOVILE",
        "zip": "247364",
        "lat": "44.699755",
        "long": "24.082642"
      },
      {
        "name": "IFRIMESTI",
        "zip": "245801",
        "lat": "45.186734",
        "long": "23.978031"
      },
      {
        "name": "IGOIU",
        "zip": "247008",
        "lat": "45.048238",
        "long": "23.808347"
      },
      {
        "name": "ILACIU",
        "zip": "247009",
        "lat": "44.985711",
        "long": "23.815171"
      },
      {
        "name": "IONESTI",
        "zip": "247270",
        "lat": "44.867116",
        "long": "24.233309"
      },
      {
        "name": "IRIMESTI",
        "zip": "245405",
        "lat": "44.665155",
        "long": "23.948141"
      },
      {
        "name": "IZBASESTI",
        "zip": "247398",
        "lat": "45.039408",
        "long": "24.447509"
      },
      {
        "name": "IZVORASU",
        "zip": "247673",
        "lat": "44.770872",
        "long": "24.193274"
      },
      {
        "name": "IZVORU",
        "zip": "247121",
        "lat": "44.725555",
        "long": "24.174737"
      },
      {
        "name": "IZVORU RECE",
        "zip": "247654",
        "lat": "44.934115",
        "long": "24.408059"
      },
      {
        "name": "IZVORU RECE",
        "zip": "247728",
        "lat": "45.167236",
        "long": "23.900685"
      },
      {
        "name": "JAROSTEA",
        "zip": "247227",
        "lat": "44.78633",
        "long": "24.10409"
      },
      {
        "name": "JIBLEA NOUA",
        "zip": "245602",
        "lat": "45.222875",
        "long": "24.355369"
      },
      {
        "name": "JIBLEA VECHE",
        "zip": "245603",
        "lat": "45.243601",
        "long": "24.351629"
      },
      {
        "name": "LACUSTENI",
        "zip": "247764",
        "lat": "44.695105",
        "long": "23.89814"
      },
      {
        "name": "LACUSTENII DE JOS",
        "zip": "247766",
        "lat": "44.685894",
        "long": "23.889256"
      },
      {
        "name": "LACUSTENII DE SUS",
        "zip": "247767",
        "lat": "44.72909",
        "long": "23.891607"
      },
      {
        "name": "LADESTI",
        "zip": "247290",
        "lat": "44.875072",
        "long": "24.042194"
      },
      {
        "name": "LALOSU",
        "zip": "247280",
        "lat": "44.548287",
        "long": "24.028243"
      },
      {
        "name": "LAUNELE DE JOS",
        "zip": "247142",
        "lat": "44.876471",
        "long": "24.436773"
      },
      {
        "name": "LESPEZI",
        "zip": "240292",
        "lat": "45.121265",
        "long": "24.381981"
      },
      {
        "name": "LINIA",
        "zip": "247059",
        "lat": "45.072219",
        "long": "24.404439"
      },
      {
        "name": "LINIA",
        "zip": "247253",
        "lat": "44.890374",
        "long": "23.804329"
      },
      {
        "name": "LINIA DEALULUI",
        "zip": "247621",
        "lat": "44.788401",
        "long": "24.050009"
      },
      {
        "name": "LINIA HANULUI",
        "zip": "247422",
        "lat": "44.987482",
        "long": "24.423703"
      },
      {
        "name": "LINIA PE VALE",
        "zip": "247143",
        "lat": "44.907715",
        "long": "24.413661"
      },
      {
        "name": "LIVADIA",
        "zip": "245304",
        "lat": "45.203972",
        "long": "24.241305"
      },
      {
        "name": "LIVEZI",
        "zip": "247315",
        "lat": "44.833472",
        "long": "23.824167"
      },
      {
        "name": "LUNCA",
        "zip": "245905",
        "lat": "45.097333",
        "long": "24.268455"
      },
      {
        "name": "LUNCA",
        "zip": "247068",
        "lat": "45.168981",
        "long": "24.368016"
      },
      {
        "name": "LUNGESTI",
        "zip": "247325",
        "lat": "44.574512",
        "long": "24.193628"
      },
      {
        "name": "LUPOAIA",
        "zip": "247502",
        "lat": "44.877021",
        "long": "24.117623"
      },
      {
        "name": "LUPUIESTI",
        "zip": "247559",
        "lat": "44.88204",
        "long": "23.912358"
      },
      {
        "name": "MACIUCENI",
        "zip": "247349",
        "lat": "44.760007",
        "long": "24.019427"
      },
      {
        "name": "MADULARI",
        "zip": "247098",
        "lat": "45.053195",
        "long": "23.992607"
      },
      {
        "name": "MADULARI",
        "zip": "247360",
        "lat": "44.687155",
        "long": "24.095629"
      },
      {
        "name": "MAGURA",
        "zip": "247382",
        "lat": "45.005349",
        "long": "24.249667"
      },
      {
        "name": "MAGURENI",
        "zip": "247264",
        "lat": "44.700115",
        "long": "24.151902"
      },
      {
        "name": "MALAIA",
        "zip": "247335",
        "lat": "45.351923",
        "long": "24.044007"
      },
      {
        "name": "MALDARESTI",
        "zip": "247297",
        "lat": "44.894744",
        "long": "24.039773"
      },
      {
        "name": "MALDARESTI",
        "zip": "247351",
        "lat": "44.76635",
        "long": "24.018808"
      },
      {
        "name": "MALDARESTI",
        "zip": "247370",
        "lat": "45.121655",
        "long": "23.999027"
      },
      {
        "name": "MALDARESTII DE JOS",
        "zip": "247371",
        "lat": "45.10596",
        "long": "24.014784"
      },
      {
        "name": "MALU",
        "zip": "247656",
        "lat": "44.933248",
        "long": "24.351357"
      },
      {
        "name": "MALU ALB",
        "zip": "247069",
        "lat": "45.137539",
        "long": "24.379251"
      },
      {
        "name": "MALU VARTOP",
        "zip": "247071",
        "lat": "45.184751",
        "long": "24.352947"
      },
      {
        "name": "MAMU",
        "zip": "247366",
        "lat": "44.683923",
        "long": "24.119958"
      },
      {
        "name": "MANAILESTI",
        "zip": "247201",
        "lat": "45.024636",
        "long": "24.124513"
      },
      {
        "name": "MANEASA",
        "zip": "247698",
        "lat": "44.773793",
        "long": "23.919311"
      },
      {
        "name": "MANGURENI",
        "zip": "247424",
        "lat": "45.019209",
        "long": "24.452514"
      },
      {
        "name": "MANICEA",
        "zip": "247768",
        "lat": "44.748994",
        "long": "23.861273"
      },
      {
        "name": "MARCEA",
        "zip": "247278",
        "lat": "44.904972",
        "long": "24.233531"
      },
      {
        "name": "MARCUSU",
        "zip": "247163",
        "lat": "44.561805",
        "long": "24.014573"
      },
      {
        "name": "MARGINENI",
        "zip": "247734",
        "lat": "44.695038",
        "long": "24.006128"
      },
      {
        "name": "MARICESTI",
        "zip": "247178",
        "lat": "44.702506",
        "long": "23.962845"
      },
      {
        "name": "MARITA",
        "zip": "247729",
        "lat": "45.174925",
        "long": "23.868063"
      },
      {
        "name": "MATEESTI",
        "zip": "247340",
        "lat": "45.071422",
        "long": "23.847818"
      },
      {
        "name": "MAZARARU",
        "zip": "247423",
        "lat": "45.004295",
        "long": "24.40572"
      },
      {
        "name": "MAZILI",
        "zip": "247674",
        "lat": "44.662538",
        "long": "24.225696"
      },
      {
        "name": "MECEA",
        "zip": "247769",
        "lat": "44.768135",
        "long": "23.796924"
      },
      {
        "name": "MEIENI",
        "zip": "247519",
        "lat": "44.973631",
        "long": "24.107535"
      },
      {
        "name": "MERESESTI",
        "zip": "247016",
        "lat": "44.742548",
        "long": "24.153231"
      },
      {
        "name": "MIEREA",
        "zip": "247218",
        "lat": "44.718065",
        "long": "23.797253"
      },
      {
        "name": "MIHAESTI",
        "zip": "247375",
        "lat": "45.020363",
        "long": "24.241425"
      },
      {
        "name": "MIJATI",
        "zip": "247308",
        "lat": "44.927113",
        "long": "23.986598"
      },
      {
        "name": "MIJLOCU",
        "zip": "247598",
        "lat": "44.921701",
        "long": "23.837047"
      },
      {
        "name": "MILCOIU",
        "zip": "247395",
        "lat": "45.041638",
        "long": "24.468593"
      },
      {
        "name": "MILESTI",
        "zip": "247164",
        "lat": "44.580868",
        "long": "23.99441"
      },
      {
        "name": "MILOSTEA",
        "zip": "247608",
        "lat": "45.124973",
        "long": "23.835965"
      },
      {
        "name": "MIRESTI",
        "zip": "247712",
        "lat": "45.074786",
        "long": "24.047873"
      },
      {
        "name": "MITROFANI",
        "zip": "247676",
        "lat": "44.721963",
        "long": "24.214431"
      },
      {
        "name": "MLACENI",
        "zip": "247484",
        "lat": "45.384917",
        "long": "24.436365"
      },
      {
        "name": "MODOIA",
        "zip": "247099",
        "lat": "44.976463",
        "long": "24.057007"
      },
      {
        "name": "MOGESTI",
        "zip": "247609",
        "lat": "45.118151",
        "long": "23.874373"
      },
      {
        "name": "MOGOSESTI",
        "zip": "247633",
        "lat": "45.128053",
        "long": "24.153714"
      },
      {
        "name": "MOLOGESTI",
        "zip": "247283",
        "lat": "44.524887",
        "long": "24.049382"
      },
      {
        "name": "MOSOROASA",
        "zip": "245305",
        "lat": "45.156435",
        "long": "24.293909"
      },
      {
        "name": "MOSTENI",
        "zip": "247202",
        "lat": "45.03627",
        "long": "24.174685"
      },
      {
        "name": "MRENESTI",
        "zip": "247122",
        "lat": "44.711014",
        "long": "24.18248"
      },
      {
        "name": "MUEREASCA",
        "zip": "247405",
        "lat": "45.186782",
        "long": "24.31963"
      },
      {
        "name": "MUEREASCA DE SUS",
        "zip": "247411",
        "lat": "45.203207",
        "long": "24.292788"
      },
      {
        "name": "MUNTENI",
        "zip": "247383",
        "lat": "44.988813",
        "long": "24.268166"
      },
      {
        "name": "NEGHINESTI",
        "zip": "247634",
        "lat": "45.157987",
        "long": "24.17925"
      },
      {
        "name": "NEGRAIA",
        "zip": "247503",
        "lat": "44.907747",
        "long": "24.115026"
      },
      {
        "name": "NEGRENI",
        "zip": "247384",
        "lat": "45.028068",
        "long": "24.246682"
      },
      {
        "name": "NEGRULESTI",
        "zip": "247028",
        "lat": "45.131201",
        "long": "24.088656"
      },
      {
        "name": "NEMOIU",
        "zip": "247017",
        "lat": "44.747626",
        "long": "24.16301"
      },
      {
        "name": "NENCIULESTI",
        "zip": "247699",
        "lat": "44.814779",
        "long": "23.918697"
      },
      {
        "name": "NETESTI",
        "zip": "247657",
        "lat": "44.926732",
        "long": "24.352926"
      },
      {
        "name": "NICOLESTI",
        "zip": "247444",
        "lat": "44.886919",
        "long": "24.266377"
      },
      {
        "name": "NISIPI",
        "zip": "247179",
        "lat": "44.80392",
        "long": "24.007924"
      },
      {
        "name": "OBARSIA",
        "zip": "247101",
        "lat": "45.071011",
        "long": "23.987006"
      },
      {
        "name": "OBISLAVU",
        "zip": "247254",
        "lat": "44.899842",
        "long": "23.816913"
      },
      {
        "name": "OBOGENI",
        "zip": "247658",
        "lat": "44.941144",
        "long": "24.377625"
      },
      {
        "name": "OBROCESTI",
        "zip": "247668",
        "lat": "45.101777",
        "long": "23.930709"
      },
      {
        "name": "OCNITA",
        "zip": "245906",
        "lat": "45.088823",
        "long": "24.276611"
      },
      {
        "name": "OCRACU",
        "zip": "247011",
        "lat": "44.970874",
        "long": "23.816529"
      },
      {
        "name": "OLANESTI",
        "zip": "245306",
        "lat": "45.180234",
        "long": "24.256911"
      },
      {
        "name": "OLANU",
        "zip": "247440",
        "lat": "44.865208",
        "long": "24.288736"
      },
      {
        "name": "OLTEANCA",
        "zip": "247228",
        "lat": "44.797056",
        "long": "24.120693"
      },
      {
        "name": "OLTEANCA",
        "zip": "247298",
        "lat": "44.859493",
        "long": "24.096337"
      },
      {
        "name": "OLTENI",
        "zip": "247072",
        "lat": "45.145697",
        "long": "24.383404"
      },
      {
        "name": "OLTETANI",
        "zip": "247284",
        "lat": "44.4966",
        "long": "24.07638"
      },
      {
        "name": "OLTETU",
        "zip": "247771",
        "lat": "44.789365",
        "long": "23.868013"
      },
      {
        "name": "OPATESTI",
        "zip": "247238",
        "lat": "45.109783",
        "long": "24.473299"
      },
      {
        "name": "ORLESTI",
        "zip": "247450",
        "lat": "44.79567",
        "long": "24.229881"
      },
      {
        "name": "OSTROVENI",
        "zip": "247212",
        "lat": "44.929247",
        "long": "24.263202"
      },
      {
        "name": "OTESANI",
        "zip": "247455",
        "lat": "45.075654",
        "long": "24.0299"
      },
      {
        "name": "OTETELISU",
        "zip": "245406",
        "lat": "44.636652",
        "long": "23.960313"
      },
      {
        "name": "OVESELU",
        "zip": "247352",
        "lat": "44.751277",
        "long": "24.017943"
      },
      {
        "name": "PADINA",
        "zip": "247018",
        "lat": "44.771802",
        "long": "24.13003"
      },
      {
        "name": "PADURETU",
        "zip": "245103",
        "lat": "44.974212",
        "long": "24.17723"
      },
      {
        "name": "PALANGA",
        "zip": "247019",
        "lat": "44.783458",
        "long": "24.141119"
      },
      {
        "name": "PARAIENII DE JOS",
        "zip": "247317",
        "lat": "44.804595",
        "long": "23.829236"
      },
      {
        "name": "PARAIENII DE MIJLOC",
        "zip": "247318",
        "lat": "44.813627",
        "long": "23.828887"
      },
      {
        "name": "PARAIENII DE SUS",
        "zip": "247319",
        "lat": "44.824617",
        "long": "23.822857"
      },
      {
        "name": "PARAUSANI",
        "zip": "247316",
        "lat": "44.859861",
        "long": "23.842179"
      },
      {
        "name": "PASAREI",
        "zip": "247561",
        "lat": "44.875089",
        "long": "23.944051"
      },
      {
        "name": "PASCOAIA",
        "zip": "245505",
        "lat": "45.353206",
        "long": "24.154083"
      },
      {
        "name": "PASCULESTI",
        "zip": "247299",
        "lat": "44.856519",
        "long": "24.032783"
      },
      {
        "name": "PATESTI",
        "zip": "247586",
        "lat": "45.279165",
        "long": "24.391682"
      },
      {
        "name": "PAUSA",
        "zip": "245604",
        "lat": "45.262735",
        "long": "24.326416"
      },
      {
        "name": "PAUSESTI",
        "zip": "247460",
        "lat": "45.073569",
        "long": "24.134816"
      },
      {
        "name": "PAUSESTI-MAGLASI",
        "zip": "247470",
        "lat": "45.14084",
        "long": "24.245837"
      },
      {
        "name": "PAUSESTI-OTASAU",
        "zip": "247464",
        "lat": "45.07123",
        "long": "24.130375"
      },
      {
        "name": "PERISANI",
        "zip": "247480",
        "lat": "45.375851",
        "long": "24.40913"
      },
      {
        "name": "PERTESTI",
        "zip": "247562",
        "lat": "44.871651",
        "long": "23.886114"
      },
      {
        "name": "PESCEANA",
        "zip": "247500",
        "lat": "44.87999",
        "long": "24.136591"
      },
      {
        "name": "PIETRARI",
        "zip": "247472",
        "lat": "45.124116",
        "long": "24.266013"
      },
      {
        "name": "PIETRARI",
        "zip": "247510",
        "lat": "45.10161",
        "long": "24.123071"
      },
      {
        "name": "PIETRARII DE SUS",
        "zip": "247511",
        "lat": "45.116965",
        "long": "24.093359"
      },
      {
        "name": "PIETRENI",
        "zip": "247117",
        "lat": "45.183123",
        "long": "24.060753"
      },
      {
        "name": "PIETRISU",
        "zip": "245307",
        "lat": "45.220808",
        "long": "24.22622"
      },
      {
        "name": "PIETROASA",
        "zip": "247736",
        "lat": "44.639947",
        "long": "23.99518"
      },
      {
        "name": "PISCU MARE",
        "zip": "247636",
        "lat": "45.163521",
        "long": "24.172697"
      },
      {
        "name": "PISCU PIETREI",
        "zip": "247061",
        "lat": "45.037956",
        "long": "24.366222"
      },
      {
        "name": "PISCU SCOARTEI",
        "zip": "247548",
        "lat": "44.904462",
        "long": "24.081449"
      },
      {
        "name": "PLEASA",
        "zip": "247742",
        "lat": "45.148488",
        "long": "24.293565"
      },
      {
        "name": "PLESESTI",
        "zip": "247563",
        "lat": "44.883817",
        "long": "23.932088"
      },
      {
        "name": "PLESOIU",
        "zip": "247321",
        "lat": "44.848443",
        "long": "23.843129"
      },
      {
        "name": "PLESOIU",
        "zip": "247426",
        "lat": "44.961686",
        "long": "24.34935"
      },
      {
        "name": "PODENI",
        "zip": "247486",
        "lat": "45.396459",
        "long": "24.421215"
      },
      {
        "name": "POENARI",
        "zip": "240005",
        "lat": "45.099849",
        "long": "24.329503"
      },
      {
        "name": "POENITA",
        "zip": "247239",
        "lat": "45.15342",
        "long": "24.485109"
      },
      {
        "name": "POIANA",
        "zip": "247487",
        "lat": "45.342215",
        "long": "24.434641"
      },
      {
        "name": "POIENARI",
        "zip": "247219",
        "lat": "44.718256",
        "long": "23.807757"
      },
      {
        "name": "POJOGI-CERNA",
        "zip": "247669",
        "lat": "45.038499",
        "long": "23.933816"
      },
      {
        "name": "POPESTI",
        "zip": "247181",
        "lat": "44.752409",
        "long": "23.968152"
      },
      {
        "name": "POPESTI",
        "zip": "247241",
        "lat": "45.093663",
        "long": "24.472749"
      },
      {
        "name": "POPESTI",
        "zip": "247301",
        "lat": "44.870399",
        "long": "24.04011"
      },
      {
        "name": "POPESTI",
        "zip": "247353",
        "lat": "44.737989",
        "long": "24.01126"
      },
      {
        "name": "POPESTI",
        "zip": "247427",
        "lat": "44.985077",
        "long": "24.490025"
      },
      {
        "name": "POPESTI",
        "zip": "247515",
        "lat": "44.996422",
        "long": "24.084308"
      },
      {
        "name": "POPESTI",
        "zip": "247599",
        "lat": "44.936123",
        "long": "23.821652"
      },
      {
        "name": "POPESTI",
        "zip": "247637",
        "lat": "45.154053",
        "long": "24.172395"
      },
      {
        "name": "POPESTI",
        "zip": "247701",
        "lat": "44.793932",
        "long": "23.914255"
      },
      {
        "name": "PORTARESTI",
        "zip": "247286",
        "lat": "44.542402",
        "long": "24.04518"
      },
      {
        "name": "PRAJILA",
        "zip": "245203",
        "lat": "45.080211",
        "long": "24.180723"
      },
      {
        "name": "PREDESTI",
        "zip": "247428",
        "lat": "44.964774",
        "long": "24.370418"
      },
      {
        "name": "PREOTESTI",
        "zip": "245407",
        "lat": "44.541672",
        "long": "23.985097"
      },
      {
        "name": "PRIBA",
        "zip": "240006",
        "lat": "45.126933",
        "long": "24.338955"
      },
      {
        "name": "PRILOAGE",
        "zip": "247089",
        "lat": "45.453525",
        "long": "24.300641"
      },
      {
        "name": "PRIPOARA",
        "zip": "247412",
        "lat": "45.196835",
        "long": "24.288915"
      },
      {
        "name": "PRIPOARE",
        "zip": "247488",
        "lat": "45.360744",
        "long": "24.41002"
      },
      {
        "name": "PRIPORU",
        "zip": "247743",
        "lat": "45.125026",
        "long": "24.28502"
      },
      {
        "name": "PROCOPOAIA",
        "zip": "247452",
        "lat": "44.778583",
        "long": "24.234682"
      },
      {
        "name": "PRODANESTI",
        "zip": "247279",
        "lat": "44.892636",
        "long": "24.223274"
      },
      {
        "name": "PROIENI",
        "zip": "245506",
        "lat": "45.356154",
        "long": "24.276826"
      },
      {
        "name": "PRUNDENI",
        "zip": "247525",
        "lat": "44.737199",
        "long": "24.250222"
      },
      {
        "name": "RACOVITA",
        "zip": "247062",
        "lat": "45.079186",
        "long": "24.397862"
      },
      {
        "name": "RACOVITA",
        "zip": "247530",
        "lat": "45.410693",
        "long": "24.307588"
      },
      {
        "name": "RACU",
        "zip": "247677",
        "lat": "44.74309",
        "long": "24.204975"
      },
      {
        "name": "RADACINESTI",
        "zip": "247043",
        "lat": "45.28012",
        "long": "24.441773"
      },
      {
        "name": "RAMESTI",
        "zip": "245802",
        "lat": "45.170736",
        "long": "23.986754"
      },
      {
        "name": "RAMESTI",
        "zip": "247691",
        "lat": "44.574283",
        "long": "24.107451"
      },
      {
        "name": "RAMNICU VALCEA",
        "zip": "240011",
        "lat": "45.103167",
        "long": "24.364643"
      },
      {
        "name": "RAPA CARAMIZII",
        "zip": "247549",
        "lat": "44.931267",
        "long": "24.081834"
      },
      {
        "name": "RAPANESTI",
        "zip": "247078",
        "lat": "45.093544",
        "long": "24.239574"
      },
      {
        "name": "RATALESTI",
        "zip": "247564",
        "lat": "44.884465",
        "long": "23.899977"
      },
      {
        "name": "RAU VADULUI",
        "zip": "247091",
        "lat": "45.517488",
        "long": "24.279755"
      },
      {
        "name": "RAURENI",
        "zip": "240050",
        "lat": "45.055448",
        "long": "24.331249"
      },
      {
        "name": "ROBAIA",
        "zip": "247044",
        "lat": "45.244586",
        "long": "24.465108"
      },
      {
        "name": "ROBESTI",
        "zip": "247092",
        "lat": "45.45113",
        "long": "24.295895"
      },
      {
        "name": "ROESTI",
        "zip": "247504",
        "lat": "44.915761",
        "long": "24.130249"
      },
      {
        "name": "ROESTI",
        "zip": "247540",
        "lat": "44.909301",
        "long": "24.070418"
      },
      {
        "name": "ROMANESTI",
        "zip": "247566",
        "lat": "44.904389",
        "long": "23.928444"
      },
      {
        "name": "ROMANI",
        "zip": "245104",
        "lat": "44.97352",
        "long": "24.205031"
      },
      {
        "name": "ROMANII DE JOS",
        "zip": "245803",
        "lat": "45.164231",
        "long": "24.006902"
      },
      {
        "name": "ROMANII DE SUS",
        "zip": "245804",
        "lat": "45.180576",
        "long": "23.993479"
      },
      {
        "name": "ROSIA",
        "zip": "247012",
        "lat": "44.995352",
        "long": "23.819499"
      },
      {
        "name": "ROSIILE",
        "zip": "247555",
        "lat": "44.876509",
        "long": "23.92275"
      },
      {
        "name": "ROSIOARA",
        "zip": "247033",
        "lat": "45.019452",
        "long": "23.877785"
      },
      {
        "name": "ROSOVENI",
        "zip": "247372",
        "lat": "45.108983",
        "long": "24.032914"
      },
      {
        "name": "ROTARASTI",
        "zip": "247429",
        "lat": "44.994291",
        "long": "24.438061"
      },
      {
        "name": "RUDA",
        "zip": "247063",
        "lat": "45.030629",
        "long": "24.333063"
      },
      {
        "name": "RUGETU",
        "zip": "247386",
        "lat": "44.998903",
        "long": "24.242436"
      },
      {
        "name": "RUGETU",
        "zip": "247611",
        "lat": "45.141473",
        "long": "23.872748"
      },
      {
        "name": "RUNCU",
        "zip": "247575",
        "lat": "45.175339",
        "long": "24.443412"
      },
      {
        "name": "RUSANESTI",
        "zip": "247182",
        "lat": "44.715764",
        "long": "23.98008"
      },
      {
        "name": "SAIOCI",
        "zip": "247551",
        "lat": "44.9462",
        "long": "24.071327"
      },
      {
        "name": "SALATRUCEL",
        "zip": "247585",
        "lat": "45.24819",
        "long": "24.388893"
      },
      {
        "name": "SALISTEA",
        "zip": "240644",
        "lat": "45.118669",
        "long": "24.446358"
      },
      {
        "name": "SALISTEA",
        "zip": "247337",
        "lat": "45.35404",
        "long": "24.132435"
      },
      {
        "name": "SANBOTIN",
        "zip": "247128",
        "lat": "45.17728",
        "long": "24.378752"
      },
      {
        "name": "SARBI",
        "zip": "247692",
        "lat": "44.64967",
        "long": "24.086128"
      },
      {
        "name": "SARSANESTI",
        "zip": "247102",
        "lat": "45.075207",
        "long": "23.978309"
      },
      {
        "name": "SARULESTI",
        "zip": "247309",
        "lat": "44.913932",
        "long": "24.024932"
      },
      {
        "name": "SASCIOARA",
        "zip": "247772",
        "lat": "44.800697",
        "long": "23.870741"
      },
      {
        "name": "SATU POIENI",
        "zip": "245408",
        "lat": "44.620744",
        "long": "23.909837"
      },
      {
        "name": "SCAIOSI",
        "zip": "247453",
        "lat": "44.796396",
        "long": "24.257804"
      },
      {
        "name": "SCARISOARA",
        "zip": "247387",
        "lat": "45.069336",
        "long": "24.218978"
      },
      {
        "name": "SCAUENI",
        "zip": "247046",
        "lat": "45.264134",
        "long": "24.444957"
      },
      {
        "name": "SCHITU",
        "zip": "247431",
        "lat": "44.983783",
        "long": "24.48244"
      },
      {
        "name": "SCORUSU",
        "zip": "247311",
        "lat": "44.919336",
        "long": "24.013995"
      },
      {
        "name": "SCUNDU",
        "zip": "247590",
        "lat": "44.844044",
        "long": "24.182509"
      },
      {
        "name": "SEACA",
        "zip": "245605",
        "lat": "45.218779",
        "long": "24.349109"
      },
      {
        "name": "SEACA",
        "zip": "247587",
        "lat": "45.265551",
        "long": "24.407966"
      },
      {
        "name": "SECIU",
        "zip": "247183",
        "lat": "44.806057",
        "long": "23.975941"
      },
      {
        "name": "SERBANEASA",
        "zip": "247432",
        "lat": "44.981891",
        "long": "24.39371"
      },
      {
        "name": "SERBANESTI",
        "zip": "247312",
        "lat": "44.944039",
        "long": "23.992292"
      },
      {
        "name": "SERBANESTI",
        "zip": "247466",
        "lat": "45.059388",
        "long": "24.149629"
      },
      {
        "name": "SERBANESTI",
        "zip": "247588",
        "lat": "45.274184",
        "long": "24.366408"
      },
      {
        "name": "SERBANESTI",
        "zip": "247688",
        "lat": "44.587182",
        "long": "24.242234"
      },
      {
        "name": "SILEA",
        "zip": "247454",
        "lat": "44.76561",
        "long": "24.237927"
      },
      {
        "name": "SINESTI",
        "zip": "247595",
        "lat": "44.939125",
        "long": "23.840201"
      },
      {
        "name": "SIRINEASA",
        "zip": "247680",
        "lat": "44.942737",
        "long": "24.181072"
      },
      {
        "name": "SLATIOARA",
        "zip": "247605",
        "lat": "45.120712",
        "long": "23.889763"
      },
      {
        "name": "SLATIOARELE",
        "zip": "245907",
        "lat": "45.079824",
        "long": "24.259338"
      },
      {
        "name": "SLAVITESTI",
        "zip": "247683",
        "lat": "44.924182",
        "long": "24.218482"
      },
      {
        "name": "SNAMANA",
        "zip": "247578",
        "lat": "45.195608",
        "long": "24.454962"
      },
      {
        "name": "SOLICESTI",
        "zip": "247467",
        "lat": "45.085508",
        "long": "24.11599"
      },
      {
        "name": "SOTANI",
        "zip": "247186",
        "lat": "44.815974",
        "long": "24.015246"
      },
      {
        "name": "SPARLENI",
        "zip": "247266",
        "lat": "44.70389",
        "long": "24.138154"
      },
      {
        "name": "SPINU",
        "zip": "247489",
        "lat": "45.390813",
        "long": "24.403835"
      },
      {
        "name": "STANCULESTI",
        "zip": "247184",
        "lat": "44.783031",
        "long": "23.960916"
      },
      {
        "name": "STANESTI",
        "zip": "247615",
        "lat": "44.817554",
        "long": "24.042244"
      },
      {
        "name": "STANESTI",
        "zip": "247659",
        "lat": "44.899378",
        "long": "24.339801"
      },
      {
        "name": "STANESTI-LUNCA",
        "zip": "247331",
        "lat": "44.567741",
        "long": "24.208416"
      },
      {
        "name": "STANOMIRU",
        "zip": "247773",
        "lat": "44.744067",
        "long": "23.862027"
      },
      {
        "name": "STEFANESTI",
        "zip": "247354",
        "lat": "44.775484",
        "long": "24.020405"
      },
      {
        "name": "STEFANESTI",
        "zip": "247685",
        "lat": "44.609517",
        "long": "24.236761"
      },
      {
        "name": "STIRBESTI",
        "zip": "247221",
        "lat": "44.647724",
        "long": "23.876851"
      },
      {
        "name": "STOENESTI",
        "zip": "247047",
        "lat": "45.26422",
        "long": "24.432062"
      },
      {
        "name": "STOENESTI",
        "zip": "247625",
        "lat": "45.122535",
        "long": "24.162823"
      },
      {
        "name": "STOICANESTI",
        "zip": "247446",
        "lat": "44.879581",
        "long": "24.286313"
      },
      {
        "name": "STOICULESTI",
        "zip": "247693",
        "lat": "44.588245",
        "long": "24.116828"
      },
      {
        "name": "STOILESTI",
        "zip": "247645",
        "lat": "44.886697",
        "long": "24.338255"
      },
      {
        "name": "STOLNICENI",
        "zip": "240007",
        "lat": "45.039477",
        "long": "24.306404"
      },
      {
        "name": "STRACHINESTI",
        "zip": "247256",
        "lat": "44.904989",
        "long": "23.837666"
      },
      {
        "name": "STREMINOASA",
        "zip": "247123",
        "lat": "44.684825",
        "long": "24.178797"
      },
      {
        "name": "STROESTI",
        "zip": "247665",
        "lat": "45.085615",
        "long": "23.911106"
      },
      {
        "name": "STUPAREI",
        "zip": "247388",
        "lat": "45.017053",
        "long": "24.278577"
      },
      {
        "name": "SUB DEAL",
        "zip": "247459",
        "lat": "45.062814",
        "long": "24.010525"
      },
      {
        "name": "SUIESTI",
        "zip": "247622",
        "lat": "44.842596",
        "long": "24.047268"
      },
      {
        "name": "SURDOIU",
        "zip": "247491",
        "lat": "45.349911",
        "long": "24.412361"
      },
      {
        "name": "SURICARU",
        "zip": "247399",
        "lat": "45.038756",
        "long": "24.43401"
      },
      {
        "name": "SURPATELE",
        "zip": "247203",
        "lat": "45.047425",
        "long": "24.179627"
      },
      {
        "name": "SURPATI",
        "zip": "247579",
        "lat": "45.203148",
        "long": "24.483342"
      },
      {
        "name": "SUSANI",
        "zip": "247690",
        "lat": "44.608103",
        "long": "24.096931"
      },
      {
        "name": "SUSENI",
        "zip": "247638",
        "lat": "45.17121",
        "long": "24.136991"
      },
      {
        "name": "SUTA",
        "zip": "247413",
        "lat": "45.217947",
        "long": "24.266631"
      },
      {
        "name": "SUTESTI",
        "zip": "247670",
        "lat": "44.673017",
        "long": "24.203226"
      },
      {
        "name": "TANASESTI",
        "zip": "245805",
        "lat": "45.18278",
        "long": "23.96922"
      },
      {
        "name": "TANISLAVI",
        "zip": "247187",
        "lat": "44.772613",
        "long": "23.967271"
      },
      {
        "name": "TARGU GANGULESTI",
        "zip": "247034",
        "lat": "44.968539",
        "long": "23.863275"
      },
      {
        "name": "TATARANI",
        "zip": "245105",
        "lat": "44.981482",
        "long": "24.247643"
      },
      {
        "name": "TEICA",
        "zip": "245908",
        "lat": "45.098278",
        "long": "24.285149"
      },
      {
        "name": "TEIU",
        "zip": "247213",
        "lat": "44.903875",
        "long": "24.283155"
      },
      {
        "name": "TEIUL",
        "zip": "247021",
        "lat": "44.770262",
        "long": "24.120338"
      },
      {
        "name": "TEIUSU",
        "zip": "247079",
        "lat": "45.07901",
        "long": "24.236428"
      },
      {
        "name": "TELECHESTI",
        "zip": "247373",
        "lat": "45.085705",
        "long": "24.016247"
      },
      {
        "name": "TEPESTI",
        "zip": "247702",
        "lat": "44.79271",
        "long": "23.922973"
      },
      {
        "name": "TEPSENARI",
        "zip": "247401",
        "lat": "45.024823",
        "long": "24.484178"
      },
      {
        "name": "TETOIU",
        "zip": "247695",
        "lat": "44.754241",
        "long": "23.921131"
      },
      {
        "name": "TIGHINA",
        "zip": "247746",
        "lat": "44.573192",
        "long": "24.295566"
      },
      {
        "name": "TINA",
        "zip": "247322",
        "lat": "44.864276",
        "long": "23.82222"
      },
      {
        "name": "TISA",
        "zip": "245308",
        "lat": "45.204924",
        "long": "24.218142"
      },
      {
        "name": "TITESTI",
        "zip": "247492",
        "lat": "45.419712",
        "long": "24.393233"
      },
      {
        "name": "TITIRECI",
        "zip": "247081",
        "lat": "45.107967",
        "long": "24.197426"
      },
      {
        "name": "TOMSANI",
        "zip": "247705",
        "lat": "45.124663",
        "long": "24.046881"
      },
      {
        "name": "TROIAN",
        "zip": "240008",
        "lat": "45.078215",
        "long": "24.347154"
      },
      {
        "name": "TRUNDIN",
        "zip": "247744",
        "lat": "45.134759",
        "long": "24.319787"
      },
      {
        "name": "TUFANII",
        "zip": "247433",
        "lat": "44.979803",
        "long": "24.470392"
      },
      {
        "name": "TULEI-CAMPENI",
        "zip": "247242",
        "lat": "45.134968",
        "long": "24.481972"
      },
      {
        "name": "TURBUREA",
        "zip": "247257",
        "lat": "44.881304",
        "long": "23.850032"
      },
      {
        "name": "TURCESTI",
        "zip": "247342",
        "lat": "45.040132",
        "long": "23.865142"
      },
      {
        "name": "TUTULESTI",
        "zip": "247537",
        "lat": "45.39945",
        "long": "24.299546"
      },
      {
        "name": "TUTURU",
        "zip": "247258",
        "lat": "44.920082",
        "long": "23.777782"
      },
      {
        "name": "UDRESTI",
        "zip": "247144",
        "lat": "44.926603",
        "long": "24.464373"
      },
      {
        "name": "ULMETEL",
        "zip": "247473",
        "lat": "45.138361",
        "long": "24.235102"
      },
      {
        "name": "ULMETU",
        "zip": "247109",
        "lat": "45.005336",
        "long": "23.960616"
      },
      {
        "name": "URSANI",
        "zip": "245806",
        "lat": "45.171587",
        "long": "23.961918"
      },
      {
        "name": "URSI",
        "zip": "247521",
        "lat": "45.009005",
        "long": "24.069446"
      },
      {
        "name": "URSI",
        "zip": "247661",
        "lat": "44.913857",
        "long": "24.337128"
      },
      {
        "name": "URSOAIA",
        "zip": "247506",
        "lat": "44.856724",
        "long": "24.12959"
      },
      {
        "name": "URZICA",
        "zip": "247601",
        "lat": "44.913904",
        "long": "23.824812"
      },
      {
        "name": "USUREI",
        "zip": "247694",
        "lat": "44.63167",
        "long": "24.088853"
      },
      {
        "name": "VAIDEENI",
        "zip": "247725",
        "lat": "45.17034",
        "long": "23.931053"
      },
      {
        "name": "VALEA ALUNISULUI",
        "zip": "247684",
        "lat": "44.948221",
        "long": "24.145076"
      },
      {
        "name": "VALEA BABEI",
        "zip": "247581",
        "lat": "45.181283",
        "long": "24.498277"
      },
      {
        "name": "VALEA BALCEASCA",
        "zip": "247434",
        "lat": "44.980893",
        "long": "24.424956"
      },
      {
        "name": "VALEA CASELOR",
        "zip": "245701",
        "lat": "44.646811",
        "long": "24.229746"
      },
      {
        "name": "VALEA CASELOR",
        "zip": "247522",
        "lat": "44.946754",
        "long": "24.125539"
      },
      {
        "name": "VALEA CHEII",
        "zip": "247474",
        "lat": "45.157489",
        "long": "24.247122"
      },
      {
        "name": "VALEA GRADISTEI",
        "zip": "247259",
        "lat": "44.886104",
        "long": "23.791891"
      },
      {
        "name": "VALEA LUI STAN",
        "zip": "245507",
        "lat": "45.352885",
        "long": "24.193966"
      },
      {
        "name": "VALEA LUNGA",
        "zip": "247623",
        "lat": "44.810625",
        "long": "24.039843"
      },
      {
        "name": "VALEA MACESULUI",
        "zip": "247751",
        "lat": "45.395324",
        "long": "24.005855"
      },
      {
        "name": "VALEA MARE",
        "zip": "245106",
        "lat": "44.93783",
        "long": "24.238835"
      },
      {
        "name": "VALEA MARE",
        "zip": "247036",
        "lat": "45.016948",
        "long": "23.915409"
      },
      {
        "name": "VALEA MARE",
        "zip": "247730",
        "lat": "44.665051",
        "long": "23.99894"
      },
      {
        "name": "VALEA RAULUI",
        "zip": "247214",
        "lat": "44.938887",
        "long": "24.317055"
      },
      {
        "name": "VALEA SCHEIULUI",
        "zip": "247146",
        "lat": "44.943707",
        "long": "24.484286"
      },
      {
        "name": "VALEA URSULUI",
        "zip": "247188",
        "lat": "44.798268",
        "long": "23.97462"
      },
      {
        "name": "VALEA VALENI",
        "zip": "247774",
        "lat": "44.780229",
        "long": "23.83856"
      },
      {
        "name": "VALEA VIEI",
        "zip": "247436",
        "lat": "44.970902",
        "long": "24.362589"
      },
      {
        "name": "VALENI",
        "zip": "247468",
        "lat": "45.083451",
        "long": "24.116951"
      },
      {
        "name": "VALENI",
        "zip": "247776",
        "lat": "44.790196",
        "long": "23.832694"
      },
      {
        "name": "VARATECI",
        "zip": "247582",
        "lat": "45.156562",
        "long": "24.444601"
      },
      {
        "name": "VARATICA",
        "zip": "245508",
        "lat": "45.33709",
        "long": "24.278017"
      },
      {
        "name": "VARATICI",
        "zip": "247118",
        "lat": "45.157023",
        "long": "24.061906"
      },
      {
        "name": "VARLENI",
        "zip": "247624",
        "lat": "44.786687",
        "long": "24.025193"
      },
      {
        "name": "VATASESTI",
        "zip": "247243",
        "lat": "45.116371",
        "long": "24.461813"
      },
      {
        "name": "VERDEA",
        "zip": "247678",
        "lat": "44.6914",
        "long": "24.227934"
      },
      {
        "name": "VETELU",
        "zip": "247111",
        "lat": "44.974345",
        "long": "23.982978"
      },
      {
        "name": "VIISOARA",
        "zip": "247204",
        "lat": "44.994764",
        "long": "24.163209"
      },
      {
        "name": "VLADESTI",
        "zip": "247740",
        "lat": "45.120384",
        "long": "24.300596"
      },
      {
        "name": "VLADUCENI",
        "zip": "247476",
        "lat": "45.136619",
        "long": "24.260708"
      },
      {
        "name": "VLADULESTI",
        "zip": "247662",
        "lat": "44.915665",
        "long": "24.319638"
      },
      {
        "name": "VOICESTI",
        "zip": "247745",
        "lat": "44.605933",
        "long": "24.290357"
      },
      {
        "name": "VOICESTII DIN VALE",
        "zip": "247747",
        "lat": "44.608356",
        "long": "24.310096"
      },
      {
        "name": "VOICULEASA",
        "zip": "247229",
        "lat": "44.809196",
        "long": "24.103029"
      },
      {
        "name": "VOINEASA",
        "zip": "247750",
        "lat": "45.417975",
        "long": "23.960336"
      },
      {
        "name": "VOINESITA",
        "zip": "247752",
        "lat": "45.411437",
        "long": "23.965745"
      },
      {
        "name": "VULPUESTI",
        "zip": "247389",
        "lat": "45.062381",
        "long": "24.231402"
      },
      {
        "name": "ZARNENI",
        "zip": "245702",
        "lat": "44.629267",
        "long": "24.229508"
      },
      {
        "name": "ZARNESTI",
        "zip": "247313",
        "lat": "44.904085",
        "long": "24.024296"
      },
      {
        "name": "ZATRENI",
        "zip": "247755",
        "lat": "44.762449",
        "long": "23.85428"
      },
      {
        "name": "ZATRENII DE SUS",
        "zip": "247777",
        "lat": "44.767857",
        "long": "23.846554"
      },
      {
        "name": "ZAVIDENI",
        "zip": "247528",
        "lat": "44.753377",
        "long": "24.24334"
      },
      {
        "name": "ZAVOIENI",
        "zip": "247356",
        "lat": "44.770196",
        "long": "24.019174"
      },
      {
        "name": "ZGUBEA",
        "zip": "247567",
        "lat": "44.921298",
        "long": "23.908148"
      },
      {
        "name": "ZLATAREI",
        "zip": "245703",
        "lat": "44.630572",
        "long": "24.257878"
      },
      {
        "name": "ZMEURATU",
        "zip": "247639",
        "lat": "45.146233",
        "long": "24.190794"
      }
    ],
    "VASLUI": [
      {
        "name": "1 DECEMBRIE",
        "zip": "737026",
        "lat": "46.359791",
        "long": "27.809418"
      },
      {
        "name": "ALBESTI",
        "zip": "737005",
        "lat": "46.499291",
        "long": "27.863405"
      },
      {
        "name": "ALBESTI",
        "zip": "737176",
        "lat": "46.696126",
        "long": "27.552852"
      },
      {
        "name": "ALBINA",
        "zip": "737301",
        "lat": "46.657838",
        "long": "27.37184"
      },
      {
        "name": "ALBITA",
        "zip": "737221",
        "lat": "46.79784",
        "long": "28.143373"
      },
      {
        "name": "ALEXANDRU VLAHUTA",
        "zip": "737010",
        "lat": "46.426143",
        "long": "27.639676"
      },
      {
        "name": "ARMASENI",
        "zip": "737051",
        "lat": "46.845168",
        "long": "27.2517"
      },
      {
        "name": "ARMASENI",
        "zip": "737111",
        "lat": "46.806377",
        "long": "27.981217"
      },
      {
        "name": "ARMASOAIA",
        "zip": "737446",
        "lat": "46.682281",
        "long": "27.387349"
      },
      {
        "name": "ARSITA",
        "zip": "737076",
        "lat": "46.55993",
        "long": "27.624337"
      },
      {
        "name": "ARSURA",
        "zip": "737020",
        "lat": "46.812858",
        "long": "28.026877"
      },
      {
        "name": "AVERESTI",
        "zip": "737115",
        "lat": "46.786656",
        "long": "27.987313"
      },
      {
        "name": "AVRAMESTI",
        "zip": "737596",
        "lat": "46.550909",
        "long": "27.364031"
      },
      {
        "name": "BABUSA",
        "zip": "737052",
        "lat": "46.808719",
        "long": "27.227304"
      },
      {
        "name": "BABUTA",
        "zip": "737201",
        "lat": "46.60878",
        "long": "27.35511"
      },
      {
        "name": "BACANI",
        "zip": "737045",
        "lat": "46.32166",
        "long": "27.679219"
      },
      {
        "name": "BACAOANI",
        "zip": "737366",
        "lat": "46.580102",
        "long": "27.780267"
      },
      {
        "name": "BACESTI",
        "zip": "737050",
        "lat": "46.824678",
        "long": "27.247356"
      },
      {
        "name": "BADEANA",
        "zip": "737551",
        "lat": "46.163098",
        "long": "27.597196"
      },
      {
        "name": "BAHNARI",
        "zip": "730001",
        "lat": "46.640979",
        "long": "27.799089"
      },
      {
        "name": "BAILE DRANCENI",
        "zip": "737222",
        "lat": "46.814776",
        "long": "28.103476"
      },
      {
        "name": "BALESTI",
        "zip": "737177",
        "lat": "46.712365",
        "long": "27.528648"
      },
      {
        "name": "BALTATENI",
        "zip": "737046",
        "lat": "46.336952",
        "long": "27.695842"
      },
      {
        "name": "BALTATI",
        "zip": "737526",
        "lat": "46.699115",
        "long": "27.897828"
      },
      {
        "name": "BALTENI",
        "zip": "737060",
        "lat": "46.674939",
        "long": "27.623988"
      },
      {
        "name": "BALTENI-DEAL",
        "zip": "737061",
        "lat": "46.668348",
        "long": "27.612332"
      },
      {
        "name": "BANCA",
        "zip": "737025",
        "lat": "46.300593",
        "long": "27.813147"
      },
      {
        "name": "BANCESTI",
        "zip": "737597",
        "lat": "46.54016",
        "long": "27.44702"
      },
      {
        "name": "BARBOSI",
        "zip": "737286",
        "lat": "46.488556",
        "long": "27.970129"
      },
      {
        "name": "BARLAD",
        "zip": "731001",
        "lat": "46.227156",
        "long": "27.668883"
      },
      {
        "name": "BARLALESTI",
        "zip": "737241",
        "lat": "46.222151",
        "long": "27.916874"
      },
      {
        "name": "BARTALUS-MOCANI",
        "zip": "737426",
        "lat": "46.394798",
        "long": "27.455732"
      },
      {
        "name": "BARTALUS-RAZESI",
        "zip": "737427",
        "lat": "46.38124",
        "long": "27.461623"
      },
      {
        "name": "BARZESTI",
        "zip": "737496",
        "lat": "46.743567",
        "long": "27.562734"
      },
      {
        "name": "BEJENESTI",
        "zip": "737326",
        "lat": "46.651402",
        "long": "27.614829"
      },
      {
        "name": "BELCESTI",
        "zip": "737321",
        "lat": "46.153522",
        "long": "27.51616"
      },
      {
        "name": "BELZENI",
        "zip": "737202",
        "lat": "46.621388",
        "long": "27.306357"
      },
      {
        "name": "BENESTI",
        "zip": "737511",
        "lat": "46.695632",
        "long": "27.829789"
      },
      {
        "name": "BEREASA",
        "zip": "737161",
        "lat": "46.831344",
        "long": "27.657258"
      },
      {
        "name": "BEREZENI",
        "zip": "737065",
        "lat": "46.373515",
        "long": "28.152119"
      },
      {
        "name": "BLAGESTI",
        "zip": "737070",
        "lat": "46.136089",
        "long": "28.014615"
      },
      {
        "name": "BLESCA",
        "zip": "737302",
        "lat": "46.659131",
        "long": "27.397099"
      },
      {
        "name": "BOBESTI",
        "zip": "737231",
        "lat": "46.721874",
        "long": "28.002866"
      },
      {
        "name": "BOGDANA",
        "zip": "737075",
        "lat": "46.526676",
        "long": "27.632777"
      },
      {
        "name": "BOGDANA-VOLOSENI",
        "zip": "737486",
        "lat": "46.63757",
        "long": "28.120828"
      },
      {
        "name": "BOGDANESTI",
        "zip": "737085",
        "lat": "46.451086",
        "long": "27.724905"
      },
      {
        "name": "BOGDANESTI",
        "zip": "737246",
        "lat": "46.260068",
        "long": "28.116127"
      },
      {
        "name": "BOGDANITA",
        "zip": "737095",
        "lat": "46.459038",
        "long": "27.685518"
      },
      {
        "name": "BOGESTI",
        "zip": "737411",
        "lat": "46.341863",
        "long": "27.551336"
      },
      {
        "name": "BOLATI",
        "zip": "737456",
        "lat": "46.845893",
        "long": "27.596256"
      },
      {
        "name": "BORODESTI",
        "zip": "737552",
        "lat": "46.056965",
        "long": "27.584849"
      },
      {
        "name": "BOTESTI",
        "zip": "737105",
        "lat": "46.795891",
        "long": "27.888704"
      },
      {
        "name": "BOTOAIA",
        "zip": "737162",
        "lat": "46.826981",
        "long": "27.635671"
      },
      {
        "name": "BOTOI",
        "zip": "737203",
        "lat": "46.593753",
        "long": "27.381768"
      },
      {
        "name": "BOUSORI",
        "zip": "737476",
        "lat": "46.733347",
        "long": "27.825258"
      },
      {
        "name": "BOZIA",
        "zip": "737247",
        "lat": "46.340408",
        "long": "28.122119"
      },
      {
        "name": "BRADESTI",
        "zip": "737586",
        "lat": "46.161957",
        "long": "27.773124"
      },
      {
        "name": "BRAHASOAIA",
        "zip": "737497",
        "lat": "46.716833",
        "long": "27.603123"
      },
      {
        "name": "BRODOC",
        "zip": "730002",
        "lat": "46.650901",
        "long": "27.673872"
      },
      {
        "name": "BROSCOSESTI",
        "zip": "737341",
        "lat": "46.5669",
        "long": "28.221894"
      },
      {
        "name": "BROSTENI",
        "zip": "737303",
        "lat": "46.636565",
        "long": "27.493304"
      },
      {
        "name": "BUDA",
        "zip": "737011",
        "lat": "46.467541",
        "long": "27.605687"
      },
      {
        "name": "BUDA",
        "zip": "737086",
        "lat": "46.492057",
        "long": "27.714984"
      },
      {
        "name": "BUDA",
        "zip": "737391",
        "lat": "46.762313",
        "long": "27.421133"
      },
      {
        "name": "BUDESTI",
        "zip": "737156",
        "lat": "46.612587",
        "long": "27.954099"
      },
      {
        "name": "BUDU CANTEMIR",
        "zip": "737487",
        "lat": "46.61446",
        "long": "28.127236"
      },
      {
        "name": "BUHAIESTI",
        "zip": "737616",
        "lat": "46.779245",
        "long": "27.526506"
      },
      {
        "name": "BULBOACA",
        "zip": "737171",
        "lat": "46.550013",
        "long": "27.77869"
      },
      {
        "name": "BUMBATA",
        "zip": "737571",
        "lat": "46.485932",
        "long": "28.226564"
      },
      {
        "name": "BUNESTI",
        "zip": "737112",
        "lat": "46.830918",
        "long": "27.971556"
      },
      {
        "name": "BURSUCI",
        "zip": "737242",
        "lat": "46.221636",
        "long": "27.863468"
      },
      {
        "name": "BUSCATA",
        "zip": "737304",
        "lat": "46.634839",
        "long": "27.416568"
      },
      {
        "name": "BUTUCARIA",
        "zip": "737626",
        "lat": "46.797269",
        "long": "27.625145"
      },
      {
        "name": "CALIMANESTI",
        "zip": "737428",
        "lat": "46.497591",
        "long": "27.425497"
      },
      {
        "name": "CALUGARENI",
        "zip": "737498",
        "lat": "46.728522",
        "long": "27.576115"
      },
      {
        "name": "CANTALARESTI",
        "zip": "737499",
        "lat": "46.732946",
        "long": "27.620079"
      },
      {
        "name": "CAPOTESTI",
        "zip": "737396",
        "lat": "46.594127",
        "long": "28.09864"
      },
      {
        "name": "CAPUSNENI",
        "zip": "737336",
        "lat": "46.525829",
        "long": "27.683493"
      },
      {
        "name": "CARJA",
        "zip": "737371",
        "lat": "46.146504",
        "long": "28.107132"
      },
      {
        "name": "CARJOANI",
        "zip": "737412",
        "lat": "46.322401",
        "long": "27.535224"
      },
      {
        "name": "CARTIBASI",
        "zip": "737096",
        "lat": "46.456419",
        "long": "27.669291"
      },
      {
        "name": "CAZANESTI",
        "zip": "735201",
        "lat": "46.866198",
        "long": "27.501795"
      },
      {
        "name": "CEPESTI",
        "zip": "737097",
        "lat": "46.383659",
        "long": "27.682413"
      },
      {
        "name": "CETATUIA",
        "zip": "737429",
        "lat": "46.430041",
        "long": "27.43506"
      },
      {
        "name": "CHERSACOSU",
        "zip": "737488",
        "lat": "46.717963",
        "long": "28.13859"
      },
      {
        "name": "CHETRESTI",
        "zip": "737062",
        "lat": "46.682998",
        "long": "27.594124"
      },
      {
        "name": "CHETROSU",
        "zip": "737271",
        "lat": "46.568811",
        "long": "27.501037"
      },
      {
        "name": "CHILIENI",
        "zip": "737136",
        "lat": "46.305084",
        "long": "27.477908"
      },
      {
        "name": "CHIRCESTI",
        "zip": "737361",
        "lat": "46.846409",
        "long": "27.849273"
      },
      {
        "name": "CHITCANI",
        "zip": "737146",
        "lat": "46.452593",
        "long": "27.781884"
      },
      {
        "name": "CHITOC",
        "zip": "737337",
        "lat": "46.595447",
        "long": "27.674505"
      },
      {
        "name": "CIOATELE",
        "zip": "735202",
        "lat": "46.829138",
        "long": "27.429057"
      },
      {
        "name": "CIOCANI",
        "zip": "737406",
        "lat": "46.260437",
        "long": "27.559945"
      },
      {
        "name": "CIOFENI",
        "zip": "737627",
        "lat": "46.75781",
        "long": "27.633613"
      },
      {
        "name": "CIORTOLOM",
        "zip": "737553",
        "lat": "46.112284",
        "long": "27.575785"
      },
      {
        "name": "CIUPERCA",
        "zip": "737204",
        "lat": "46.610019",
        "long": "27.408732"
      },
      {
        "name": "CODAESTI",
        "zip": "737130",
        "lat": "46.87127",
        "long": "27.769136"
      },
      {
        "name": "CODRENI",
        "zip": "737466",
        "lat": "46.483079",
        "long": "27.902331"
      },
      {
        "name": "CONDREA",
        "zip": "737342",
        "lat": "46.542606",
        "long": "28.216299"
      },
      {
        "name": "COPACEANA",
        "zip": "737248",
        "lat": "46.355303",
        "long": "28.06317"
      },
      {
        "name": "CORBU",
        "zip": "737338",
        "lat": "46.581356",
        "long": "27.706283"
      },
      {
        "name": "CORNI-ALBESTI",
        "zip": "737006",
        "lat": "46.518075",
        "long": "27.871996"
      },
      {
        "name": "COROBANESTI",
        "zip": "737598",
        "lat": "46.515442",
        "long": "27.465803"
      },
      {
        "name": "CORODESTI",
        "zip": "737272",
        "lat": "46.528203",
        "long": "27.5138"
      },
      {
        "name": "COROIESTI",
        "zip": "737098",
        "lat": "46.439308",
        "long": "27.672431"
      },
      {
        "name": "COROIESTI",
        "zip": "737135",
        "lat": "46.244139",
        "long": "27.484174"
      },
      {
        "name": "COROIESTII DE SUS",
        "zip": "737137",
        "lat": "46.262904",
        "long": "27.490475"
      },
      {
        "name": "COROIU",
        "zip": "737554",
        "lat": "46.105122",
        "long": "27.544291"
      },
      {
        "name": "COSCA",
        "zip": "737306",
        "lat": "46.683949",
        "long": "27.474394"
      },
      {
        "name": "COSESTI",
        "zip": "737307",
        "lat": "46.674941",
        "long": "27.457497"
      },
      {
        "name": "COSTESTI",
        "zip": "737145",
        "lat": "46.497703",
        "long": "27.764495"
      },
      {
        "name": "COTIC",
        "zip": "737536",
        "lat": "46.872074",
        "long": "27.363216"
      },
      {
        "name": "COZMESTI",
        "zip": "737178",
        "lat": "46.733754",
        "long": "27.501644"
      },
      {
        "name": "CRACIUNESTI",
        "zip": "737457",
        "lat": "46.870762",
        "long": "27.53182"
      },
      {
        "name": "CRANG",
        "zip": "737407",
        "lat": "46.245568",
        "long": "27.610915"
      },
      {
        "name": "CRANGU NOU",
        "zip": "737408",
        "lat": "46.273127",
        "long": "27.566817"
      },
      {
        "name": "CRASNA",
        "zip": "737007",
        "lat": "46.509301",
        "long": "27.83225"
      },
      {
        "name": "CRASNASENI",
        "zip": "737527",
        "lat": "46.67087",
        "long": "27.957159"
      },
      {
        "name": "CRETESTI",
        "zip": "737155",
        "lat": "46.631865",
        "long": "27.961545"
      },
      {
        "name": "CRETESTII DE SUS",
        "zip": "737157",
        "lat": "46.639465",
        "long": "27.980227"
      },
      {
        "name": "CRISTESTI",
        "zip": "737431",
        "lat": "46.465862",
        "long": "27.452528"
      },
      {
        "name": "CRIVESTI",
        "zip": "737556",
        "lat": "46.090343",
        "long": "27.561265"
      },
      {
        "name": "CUJBA",
        "zip": "737516",
        "lat": "46.956961",
        "long": "27.665465"
      },
      {
        "name": "CURSESTI-DEAL",
        "zip": "737447",
        "lat": "46.713005",
        "long": "27.389344"
      },
      {
        "name": "CURSESTI-VALE",
        "zip": "737448",
        "lat": "46.723025",
        "long": "27.37447"
      },
      {
        "name": "CURTENI",
        "zip": "737381",
        "lat": "46.600049",
        "long": "27.934676"
      },
      {
        "name": "DANESTI",
        "zip": "737160",
        "lat": "46.847519",
        "long": "27.673109"
      },
      {
        "name": "DAVIDESTI",
        "zip": "737397",
        "lat": "46.60324",
        "long": "28.093823"
      },
      {
        "name": "DEALU MARE",
        "zip": "737636",
        "lat": "46.224492",
        "long": "27.721306"
      },
      {
        "name": "DEALU SECARII",
        "zip": "737416",
        "lat": "46.51976",
        "long": "27.566448"
      },
      {
        "name": "DELEA",
        "zip": "737628",
        "lat": "46.698294",
        "long": "27.698938"
      },
      {
        "name": "DELENI",
        "zip": "737170",
        "lat": "46.543136",
        "long": "27.743929"
      },
      {
        "name": "DELENI",
        "zip": "737287",
        "lat": "46.517131",
        "long": "27.988855"
      },
      {
        "name": "DELESTI",
        "zip": "737175",
        "lat": "46.71202",
        "long": "27.552014"
      },
      {
        "name": "DINGA",
        "zip": "737147",
        "lat": "46.495134",
        "long": "27.734598"
      },
      {
        "name": "DOAGELE",
        "zip": "737206",
        "lat": "46.668489",
        "long": "27.327776"
      },
      {
        "name": "DOBROSLOVESTI",
        "zip": "737629",
        "lat": "46.769053",
        "long": "27.60859"
      },
      {
        "name": "DOCANEASA",
        "zip": "737588",
        "lat": "46.111631",
        "long": "27.801159"
      },
      {
        "name": "DOCANI",
        "zip": "737587",
        "lat": "46.141207",
        "long": "27.75231"
      },
      {
        "name": "DODESTI",
        "zip": "737576",
        "lat": "46.352163",
        "long": "27.893985"
      },
      {
        "name": "DRAGESTI",
        "zip": "737537",
        "lat": "46.87113",
        "long": "27.39466"
      },
      {
        "name": "DRAGOMANESTI",
        "zip": "737273",
        "lat": "46.502073",
        "long": "27.528063"
      },
      {
        "name": "DRAGOMIRESTI",
        "zip": "737200",
        "lat": "46.632961",
        "long": "27.359445"
      },
      {
        "name": "DRANCENI",
        "zip": "737220",
        "lat": "46.801337",
        "long": "28.131657"
      },
      {
        "name": "DRAXENI",
        "zip": "737274",
        "lat": "46.582023",
        "long": "27.475863"
      },
      {
        "name": "DRAXENI",
        "zip": "737458",
        "lat": "46.871427",
        "long": "27.623376"
      },
      {
        "name": "DRUJESTI",
        "zip": "737047",
        "lat": "46.308313",
        "long": "27.675408"
      },
      {
        "name": "DUDA",
        "zip": "737232",
        "lat": "46.747616",
        "long": "28.044044"
      },
      {
        "name": "DUMASCA",
        "zip": "737517",
        "lat": "46.92431",
        "long": "27.710279"
      },
      {
        "name": "DUMBRAVENI",
        "zip": "737261",
        "lat": "46.763755",
        "long": "27.347138"
      },
      {
        "name": "DUMESTI",
        "zip": "737235",
        "lat": "46.847154",
        "long": "27.300611"
      },
      {
        "name": "DUMESTII VECHI",
        "zip": "737236",
        "lat": "46.832586",
        "long": "27.309084"
      },
      {
        "name": "EMIL RACOVITA",
        "zip": "737163",
        "lat": "46.871467",
        "long": "27.679369"
      },
      {
        "name": "EPURENI",
        "zip": "737233",
        "lat": "46.708333",
        "long": "28.038615"
      },
      {
        "name": "EPURENI",
        "zip": "737240",
        "lat": "46.246932",
        "long": "27.911231"
      },
      {
        "name": "FALCIU",
        "zip": "737245",
        "lat": "46.29493",
        "long": "28.142838"
      },
      {
        "name": "FANTANA BLANARULUI",
        "zip": "737077",
        "lat": "46.594373",
        "long": "27.598934"
      },
      {
        "name": "FANTANELE",
        "zip": "737432",
        "lat": "46.49611",
        "long": "27.449815"
      },
      {
        "name": "FASTACI",
        "zip": "737179",
        "lat": "46.730369",
        "long": "27.447335"
      },
      {
        "name": "FEDESTI",
        "zip": "737506",
        "lat": "46.306545",
        "long": "27.874821"
      },
      {
        "name": "FERESTI",
        "zip": "737566",
        "lat": "46.781792",
        "long": "27.700925"
      },
      {
        "name": "FLORENI",
        "zip": "737372",
        "lat": "46.236032",
        "long": "27.979772"
      },
      {
        "name": "FLORESTI",
        "zip": "737417",
        "lat": "46.551836",
        "long": "27.556335"
      },
      {
        "name": "FOCSA",
        "zip": "737343",
        "lat": "46.565152",
        "long": "28.193574"
      },
      {
        "name": "FOCSEASCA",
        "zip": "737518",
        "lat": "46.93331",
        "long": "27.632965"
      },
      {
        "name": "FRASINU",
        "zip": "737418",
        "lat": "46.615546",
        "long": "27.507181"
      },
      {
        "name": "FRUNTISENI",
        "zip": "737281",
        "lat": "46.206344",
        "long": "27.769041"
      },
      {
        "name": "FULGU",
        "zip": "737433",
        "lat": "46.497982",
        "long": "27.393281"
      },
      {
        "name": "FUNDATURA",
        "zip": "737021",
        "lat": "46.795585",
        "long": "28.029452"
      },
      {
        "name": "FUNDATURA",
        "zip": "737181",
        "lat": "46.685201",
        "long": "27.530816"
      },
      {
        "name": "FUNDATURA MARE",
        "zip": "737308",
        "lat": "46.704038",
        "long": "27.449266"
      },
      {
        "name": "FUNDATURA MICA",
        "zip": "737309",
        "lat": "46.702073",
        "long": "27.4384"
      },
      {
        "name": "FUNDU VAII",
        "zip": "737339",
        "lat": "46.546079",
        "long": "27.678403"
      },
      {
        "name": "FUNDU VAII",
        "zip": "737419",
        "lat": "46.571364",
        "long": "27.524051"
      },
      {
        "name": "GAGESTI",
        "zip": "737255",
        "lat": "46.330764",
        "long": "27.971689"
      },
      {
        "name": "GALTESTI",
        "zip": "737434",
        "lat": "46.43224",
        "long": "27.515263"
      },
      {
        "name": "GANESTI",
        "zip": "737106",
        "lat": "46.81305",
        "long": "27.922677"
      },
      {
        "name": "GARA BANCA",
        "zip": "737027",
        "lat": "46.339231",
        "long": "27.794197"
      },
      {
        "name": "GARA DOCANEASA",
        "zip": "737589",
        "lat": "46.113125",
        "long": "27.783418"
      },
      {
        "name": "GARA ROSIESTI",
        "zip": "737467",
        "lat": "46.432698",
        "long": "27.835107"
      },
      {
        "name": "GARA TALASMAN",
        "zip": "737591",
        "lat": "46.132613",
        "long": "27.842036"
      },
      {
        "name": "GARCENI",
        "zip": "737260",
        "lat": "46.755334",
        "long": "27.306064"
      },
      {
        "name": "GARDESTI",
        "zip": "737599",
        "lat": "46.550839",
        "long": "27.451499"
      },
      {
        "name": "GAVANU",
        "zip": "737078",
        "lat": "46.509383",
        "long": "27.611596"
      },
      {
        "name": "GHERGHELEU",
        "zip": "737131",
        "lat": "46.853413",
        "long": "27.716666"
      },
      {
        "name": "GHERGHESTI",
        "zip": "737270",
        "lat": "46.490828",
        "long": "27.533201"
      },
      {
        "name": "GHERMANESTI",
        "zip": "737028",
        "lat": "46.323745",
        "long": "27.83918"
      },
      {
        "name": "GHERMANESTI",
        "zip": "737223",
        "lat": "46.829558",
        "long": "28.079946"
      },
      {
        "name": "GHICANI",
        "zip": "737012",
        "lat": "46.38991",
        "long": "27.656147"
      },
      {
        "name": "GHIREASCA",
        "zip": "737351",
        "lat": "46.197767",
        "long": "27.89732"
      },
      {
        "name": "GIURCANI",
        "zip": "737256",
        "lat": "46.283011",
        "long": "27.981381"
      },
      {
        "name": "GIURGESTI",
        "zip": "737528",
        "lat": "46.735038",
        "long": "27.975654"
      },
      {
        "name": "GLODENI",
        "zip": "735203",
        "lat": "46.841996",
        "long": "27.520294"
      },
      {
        "name": "GRAJDENI",
        "zip": "737282",
        "lat": "46.189772",
        "long": "27.778319"
      },
      {
        "name": "GRIVITA",
        "zip": "737280",
        "lat": "46.161411",
        "long": "27.662575"
      },
      {
        "name": "GRUMEZOAIA",
        "zip": "737191",
        "lat": "46.557189",
        "long": "28.037897"
      },
      {
        "name": "GUGESTI",
        "zip": "737107",
        "lat": "46.76308",
        "long": "27.897952"
      },
      {
        "name": "GURA ALBESTI",
        "zip": "737008",
        "lat": "46.468974",
        "long": "27.838549"
      },
      {
        "name": "GURA IDRICI",
        "zip": "737468",
        "lat": "46.414167",
        "long": "27.883254"
      },
      {
        "name": "GURA VAII",
        "zip": "737489",
        "lat": "46.644186",
        "long": "28.159671"
      },
      {
        "name": "GUSITEI",
        "zip": "737192",
        "lat": "46.458941",
        "long": "28.027857"
      },
      {
        "name": "HALARESTI",
        "zip": "737296",
        "lat": "46.394797",
        "long": "27.556492"
      },
      {
        "name": "HALTA DODESTI",
        "zip": "737577",
        "lat": "46.375844",
        "long": "27.823032"
      },
      {
        "name": "HARSOVA",
        "zip": "737182",
        "lat": "46.671974",
        "long": "27.542328"
      },
      {
        "name": "HARSOVENI",
        "zip": "737311",
        "lat": "46.644708",
        "long": "27.508313"
      },
      {
        "name": "HOCENI",
        "zip": "737285",
        "lat": "46.539658",
        "long": "28.007459"
      },
      {
        "name": "HORDILA",
        "zip": "737449",
        "lat": "46.70681",
        "long": "27.433469"
      },
      {
        "name": "HORDILESTI",
        "zip": "737183",
        "lat": "46.744512",
        "long": "27.509058"
      },
      {
        "name": "HORGA",
        "zip": "737243",
        "lat": "46.278392",
        "long": "27.89172"
      },
      {
        "name": "HOROIATA",
        "zip": "737087",
        "lat": "46.356561",
        "long": "27.747234"
      },
      {
        "name": "HREASCA",
        "zip": "737138",
        "lat": "46.339762",
        "long": "27.501181"
      },
      {
        "name": "HUC",
        "zip": "737538",
        "lat": "46.828691",
        "long": "27.407022"
      },
      {
        "name": "HUPCA",
        "zip": "737088",
        "lat": "46.406369",
        "long": "27.713284"
      },
      {
        "name": "HURDUGI",
        "zip": "737193",
        "lat": "46.509378",
        "long": "28.056982"
      },
      {
        "name": "HUSI",
        "zip": "735100",
        "lat": "46.672077",
        "long": "28.062138"
      },
      {
        "name": "IANA",
        "zip": "737295",
        "lat": "46.380124",
        "long": "27.554606"
      },
      {
        "name": "IAZ",
        "zip": "737477",
        "lat": "46.819242",
        "long": "27.760109"
      },
      {
        "name": "IBANESTI",
        "zip": "737013",
        "lat": "46.394822",
        "long": "27.625475"
      },
      {
        "name": "IDRICI",
        "zip": "737469",
        "lat": "46.467019",
        "long": "27.900521"
      },
      {
        "name": "IEZER",
        "zip": "737436",
        "lat": "46.412037",
        "long": "27.52512"
      },
      {
        "name": "IEZEREL",
        "zip": "737312",
        "lat": "46.651679",
        "long": "27.423302"
      },
      {
        "name": "IGESTI",
        "zip": "737071",
        "lat": "46.150877",
        "long": "27.99348"
      },
      {
        "name": "IVANESTI",
        "zip": "737300",
        "lat": "46.644101",
        "long": "27.463527"
      },
      {
        "name": "IVANESTI",
        "zip": "737398",
        "lat": "46.562343",
        "long": "28.117147"
      },
      {
        "name": "IVESTI",
        "zip": "737320",
        "lat": "46.192451",
        "long": "27.537935"
      },
      {
        "name": "JIGALIA",
        "zip": "737507",
        "lat": "46.312324",
        "long": "27.922328"
      },
      {
        "name": "LACU BABEI",
        "zip": "737079",
        "lat": "46.585163",
        "long": "27.588922"
      },
      {
        "name": "LALESTI",
        "zip": "737437",
        "lat": "46.474701",
        "long": "27.426372"
      },
      {
        "name": "LATESTI",
        "zip": "737373",
        "lat": "46.183361",
        "long": "27.985777"
      },
      {
        "name": "LAZA",
        "zip": "737325",
        "lat": "46.645664",
        "long": "27.597613"
      },
      {
        "name": "LAZU",
        "zip": "737276",
        "lat": "46.578313",
        "long": "27.49364"
      },
      {
        "name": "LEOSTI",
        "zip": "737399",
        "lat": "46.612996",
        "long": "28.075089"
      },
      {
        "name": "LEOSTI",
        "zip": "737529",
        "lat": "46.661667",
        "long": "27.946376"
      },
      {
        "name": "LIPOVAT",
        "zip": "737335",
        "lat": "46.565389",
        "long": "27.714459"
      },
      {
        "name": "LUNCA",
        "zip": "737277",
        "lat": "46.454029",
        "long": "27.540665"
      },
      {
        "name": "LUNCA BANULUI",
        "zip": "737340",
        "lat": "46.596549",
        "long": "28.17086"
      },
      {
        "name": "LUNCA VECHE",
        "zip": "737344",
        "lat": "46.527873",
        "long": "28.17649"
      },
      {
        "name": "LUPESTI",
        "zip": "737352",
        "lat": "46.178606",
        "long": "27.881866"
      },
      {
        "name": "MACRESTI",
        "zip": "737459",
        "lat": "46.891965",
        "long": "27.536697"
      },
      {
        "name": "MACRESTI",
        "zip": "737631",
        "lat": "46.810647",
        "long": "27.593412"
      },
      {
        "name": "MALAIESTI",
        "zip": "737621",
        "lat": "46.460808",
        "long": "27.972275"
      },
      {
        "name": "MALUSTENI",
        "zip": "737350",
        "lat": "46.180691",
        "long": "27.919258"
      },
      {
        "name": "MANASTIREA",
        "zip": "737184",
        "lat": "46.688057",
        "long": "27.542006"
      },
      {
        "name": "MANASTIREA",
        "zip": "737353",
        "lat": "46.178865",
        "long": "27.956392"
      },
      {
        "name": "MANJESTI",
        "zip": "737367",
        "lat": "46.598159",
        "long": "27.816417"
      },
      {
        "name": "MANTU",
        "zip": "737531",
        "lat": "46.734217",
        "long": "27.929085"
      },
      {
        "name": "MANZATESTI",
        "zip": "737354",
        "lat": "46.155695",
        "long": "27.886901"
      },
      {
        "name": "MANZATI",
        "zip": "737014",
        "lat": "46.44251",
        "long": "27.592672"
      },
      {
        "name": "MARASENI",
        "zip": "737501",
        "lat": "46.697796",
        "long": "27.666893"
      },
      {
        "name": "MARASESTI",
        "zip": "737601",
        "lat": "46.524468",
        "long": "27.414183"
      },
      {
        "name": "MASCUREI",
        "zip": "737413",
        "lat": "46.339366",
        "long": "27.523229"
      },
      {
        "name": "MICLESTI",
        "zip": "737029",
        "lat": "46.325147",
        "long": "27.899154"
      },
      {
        "name": "MICLESTI",
        "zip": "737360",
        "lat": "46.822418",
        "long": "27.839985"
      },
      {
        "name": "MIHAIL KOGALNICEANU",
        "zip": "737022",
        "lat": "46.794914",
        "long": "28.069799"
      },
      {
        "name": "MIRCESTI",
        "zip": "737519",
        "lat": "46.900596",
        "long": "27.672117"
      },
      {
        "name": "MIRENI",
        "zip": "737139",
        "lat": "46.315621",
        "long": "27.490068"
      },
      {
        "name": "MITOC",
        "zip": "737031",
        "lat": "46.382005",
        "long": "27.781535"
      },
      {
        "name": "MOARA DOMNEASCA",
        "zip": "737567",
        "lat": "46.714481",
        "long": "27.758903"
      },
      {
        "name": "MOARA GRECILOR",
        "zip": "730003",
        "lat": "46.672077",
        "long": "27.745414"
      },
      {
        "name": "MORARENI",
        "zip": "737016",
        "lat": "46.507697",
        "long": "27.588782"
      },
      {
        "name": "MORENI",
        "zip": "737172",
        "lat": "46.51312",
        "long": "27.741637"
      },
      {
        "name": "MOVILENI",
        "zip": "737141",
        "lat": "46.270201",
        "long": "27.514076"
      },
      {
        "name": "MUNTENESTI",
        "zip": "737502",
        "lat": "46.758315",
        "long": "27.531649"
      },
      {
        "name": "MUNTENII DE JOS",
        "zip": "737365",
        "lat": "46.606879",
        "long": "27.768422"
      },
      {
        "name": "MUNTENII DE SUS",
        "zip": "737512",
        "lat": "46.689676",
        "long": "27.777632"
      },
      {
        "name": "MURGENI",
        "zip": "737370",
        "lat": "46.203517",
        "long": "28.023877"
      },
      {
        "name": "MUSATA",
        "zip": "737066",
        "lat": "46.432389",
        "long": "28.102639"
      },
      {
        "name": "NEGRESTI",
        "zip": "735200",
        "lat": "46.834714",
        "long": "27.45908"
      },
      {
        "name": "OBARSENI",
        "zip": "737592",
        "lat": "46.184305",
        "long": "27.844552"
      },
      {
        "name": "OBARSENI",
        "zip": "737602",
        "lat": "46.573615",
        "long": "27.450391"
      },
      {
        "name": "OBARSENII LINGURARI",
        "zip": "737603",
        "lat": "46.594866",
        "long": "27.437205"
      },
      {
        "name": "ODAIA BOGDANA",
        "zip": "737249",
        "lat": "46.288688",
        "long": "28.079024"
      },
      {
        "name": "ODAIA BURSUCANI",
        "zip": "737283",
        "lat": "46.152012",
        "long": "27.708821"
      },
      {
        "name": "OLTENESTI",
        "zip": "737380",
        "lat": "46.584026",
        "long": "27.902946"
      },
      {
        "name": "OPRISITA",
        "zip": "737421",
        "lat": "46.611179",
        "long": "27.571857"
      },
      {
        "name": "ORGOIESTI",
        "zip": "737089",
        "lat": "46.490091",
        "long": "27.697023"
      },
      {
        "name": "OSESTI",
        "zip": "737390",
        "lat": "46.758988",
        "long": "27.484681"
      },
      {
        "name": "OTELENI",
        "zip": "737288",
        "lat": "46.54031",
        "long": "27.981539"
      },
      {
        "name": "OTETOAIA",
        "zip": "737346",
        "lat": "46.581487",
        "long": "28.176813"
      },
      {
        "name": "PACURARESTI",
        "zip": "737142",
        "lat": "46.282859",
        "long": "27.484806"
      },
      {
        "name": "PADURENI",
        "zip": "737392",
        "lat": "46.785593",
        "long": "27.440814"
      },
      {
        "name": "PADURENI",
        "zip": "737395",
        "lat": "46.621922",
        "long": "28.082581"
      },
      {
        "name": "PAHNA",
        "zip": "737382",
        "lat": "46.55553",
        "long": "27.870274"
      },
      {
        "name": "PAHNESTI",
        "zip": "737023",
        "lat": "46.778777",
        "long": "28.041812"
      },
      {
        "name": "PALTINIS",
        "zip": "737053",
        "lat": "46.788606",
        "long": "27.24375"
      },
      {
        "name": "PARPANITA",
        "zip": "735204",
        "lat": "46.832219",
        "long": "27.488579"
      },
      {
        "name": "PARVESTI",
        "zip": "737148",
        "lat": "46.47556",
        "long": "27.742491"
      },
      {
        "name": "PEICANI",
        "zip": "737257",
        "lat": "46.305649",
        "long": "27.988178"
      },
      {
        "name": "PERIENI",
        "zip": "737405",
        "lat": "46.304436",
        "long": "27.609954"
      },
      {
        "name": "PLOPENI",
        "zip": "737081",
        "lat": "46.577546",
        "long": "27.600859"
      },
      {
        "name": "PLOPI",
        "zip": "737113",
        "lat": "46.770271",
        "long": "27.990286"
      },
      {
        "name": "PLOPOASA",
        "zip": "737539",
        "lat": "46.81401",
        "long": "27.37377"
      },
      {
        "name": "PLOTONESTI",
        "zip": "737194",
        "lat": "46.555931",
        "long": "28.075974"
      },
      {
        "name": "POCHIDIA",
        "zip": "737557",
        "lat": "46.043179",
        "long": "27.587463"
      },
      {
        "name": "PODENI",
        "zip": "737617",
        "lat": "46.800554",
        "long": "27.565336"
      },
      {
        "name": "PODU OPRII",
        "zip": "737114",
        "lat": "46.832493",
        "long": "27.946744"
      },
      {
        "name": "PODU PIETRIS",
        "zip": "737409",
        "lat": "46.236592",
        "long": "27.540587"
      },
      {
        "name": "POGANA",
        "zip": "737410",
        "lat": "46.315545",
        "long": "27.572793"
      },
      {
        "name": "POGANESTI",
        "zip": "737491",
        "lat": "46.693294",
        "long": "28.16577"
      },
      {
        "name": "POGONESTI",
        "zip": "737322",
        "lat": "46.152294",
        "long": "27.532255"
      },
      {
        "name": "POIANA",
        "zip": "735205",
        "lat": "46.805536",
        "long": "27.487601"
      },
      {
        "name": "POIANA LUI ALEXA",
        "zip": "737327",
        "lat": "46.618829",
        "long": "27.617458"
      },
      {
        "name": "POIANA PIETREI",
        "zip": "737207",
        "lat": "46.64607",
        "long": "27.349689"
      },
      {
        "name": "POIENESTI",
        "zip": "737415",
        "lat": "46.60912",
        "long": "27.541143"
      },
      {
        "name": "POIENESTI-DEAL",
        "zip": "737422",
        "lat": "46.579394",
        "long": "27.543031"
      },
      {
        "name": "POLOCIN",
        "zip": "737323",
        "lat": "46.136612",
        "long": "27.531524"
      },
      {
        "name": "POPENI",
        "zip": "737258",
        "lat": "46.354402",
        "long": "27.976613"
      },
      {
        "name": "POPENI",
        "zip": "737637",
        "lat": "46.246672",
        "long": "27.805202"
      },
      {
        "name": "POPESTI",
        "zip": "737208",
        "lat": "46.590424",
        "long": "27.403664"
      },
      {
        "name": "POPESTI",
        "zip": "737362",
        "lat": "46.797492",
        "long": "27.837362"
      },
      {
        "name": "PORTARI",
        "zip": "737632",
        "lat": "46.738563",
        "long": "27.700156"
      },
      {
        "name": "POSTA ELAN",
        "zip": "737622",
        "lat": "46.414292",
        "long": "27.996383"
      },
      {
        "name": "PRIBESTI",
        "zip": "737132",
        "lat": "46.910009",
        "long": "27.796594"
      },
      {
        "name": "PROTOPOPESTI",
        "zip": "737521",
        "lat": "46.965382",
        "long": "27.639746"
      },
      {
        "name": "PUIESTI",
        "zip": "737425",
        "lat": "46.423164",
        "long": "27.499506"
      },
      {
        "name": "PUNGESTI",
        "zip": "737445",
        "lat": "46.708281",
        "long": "27.337363"
      },
      {
        "name": "PUNTISENI",
        "zip": "737149",
        "lat": "46.478546",
        "long": "27.762812"
      },
      {
        "name": "PUSCASI",
        "zip": "737328",
        "lat": "46.621537",
        "long": "27.645033"
      },
      {
        "name": "PUTU OLARULUI",
        "zip": "737017",
        "lat": "46.374914",
        "long": "27.647697"
      },
      {
        "name": "RACOVA",
        "zip": "737262",
        "lat": "46.744475",
        "long": "27.247307"
      },
      {
        "name": "RACOVITA",
        "zip": "737263",
        "lat": "46.758245",
        "long": "27.259557"
      },
      {
        "name": "RADAESTI",
        "zip": "737099",
        "lat": "46.405724",
        "long": "27.681051"
      },
      {
        "name": "RADENI",
        "zip": "737209",
        "lat": "46.589332",
        "long": "27.373836"
      },
      {
        "name": "RADESTI",
        "zip": "737151",
        "lat": "46.47866",
        "long": "27.791143"
      },
      {
        "name": "RADUCANI",
        "zip": "737347",
        "lat": "46.573868",
        "long": "28.221361"
      },
      {
        "name": "RADUIESTI",
        "zip": "737186",
        "lat": "46.696583",
        "long": "27.583992"
      },
      {
        "name": "RAFAILA",
        "zip": "737541",
        "lat": "46.800638",
        "long": "27.362361"
      },
      {
        "name": "RAIU",
        "zip": "737374",
        "lat": "46.239897",
        "long": "28.017811"
      },
      {
        "name": "RANCENI",
        "zip": "737067",
        "lat": "46.403955",
        "long": "28.105434"
      },
      {
        "name": "RANZESTI",
        "zip": "737251",
        "lat": "46.221011",
        "long": "28.094684"
      },
      {
        "name": "RAPSA",
        "zip": "737451",
        "lat": "46.711662",
        "long": "27.415177"
      },
      {
        "name": "RASCANI",
        "zip": "737164",
        "lat": "46.856055",
        "long": "27.63307"
      },
      {
        "name": "RASCANI",
        "zip": "737508",
        "lat": "46.318054",
        "long": "27.903418"
      },
      {
        "name": "RASESTI",
        "zip": "737224",
        "lat": "46.773071",
        "long": "28.140603"
      },
      {
        "name": "RASNITA",
        "zip": "737329",
        "lat": "46.660507",
        "long": "27.573707"
      },
      {
        "name": "RATESU CUZEI",
        "zip": "737461",
        "lat": "46.837551",
        "long": "27.56423"
      },
      {
        "name": "REBRICEA",
        "zip": "737455",
        "lat": "46.86597",
        "long": "27.560144"
      },
      {
        "name": "RECEA",
        "zip": "737297",
        "lat": "46.437971",
        "long": "27.541443"
      },
      {
        "name": "REDIU",
        "zip": "730004",
        "lat": "46.633739",
        "long": "27.694387"
      },
      {
        "name": "REDIU",
        "zip": "737289",
        "lat": "46.544763",
        "long": "27.932754"
      },
      {
        "name": "REDIU",
        "zip": "737471",
        "lat": "46.474092",
        "long": "27.874135"
      },
      {
        "name": "REDIU GALIAN",
        "zip": "737133",
        "lat": "46.886484",
        "long": "27.732015"
      },
      {
        "name": "ROSIESTI",
        "zip": "737465",
        "lat": "46.439616",
        "long": "27.902417"
      },
      {
        "name": "ROSIORI",
        "zip": "737116",
        "lat": "46.795521",
        "long": "27.976742"
      },
      {
        "name": "ROTARI",
        "zip": "737438",
        "lat": "46.416647",
        "long": "27.461947"
      },
      {
        "name": "RUGARIA",
        "zip": "737604",
        "lat": "46.603846",
        "long": "27.464727"
      },
      {
        "name": "RUSCA",
        "zip": "737401",
        "lat": "46.643687",
        "long": "28.064076"
      },
      {
        "name": "RUSI",
        "zip": "737439",
        "lat": "46.459902",
        "long": "27.508145"
      },
      {
        "name": "SALCENI",
        "zip": "737559",
        "lat": "46.06499",
        "long": "27.569073"
      },
      {
        "name": "SALCIOARA",
        "zip": "737033",
        "lat": "46.34492",
        "long": "27.773923"
      },
      {
        "name": "SARATENI",
        "zip": "737376",
        "lat": "46.193898",
        "long": "27.960555"
      },
      {
        "name": "SARATU",
        "zip": "737492",
        "lat": "46.624418",
        "long": "28.239911"
      },
      {
        "name": "SARBI",
        "zip": "737034",
        "lat": "46.393053",
        "long": "27.807382"
      },
      {
        "name": "SASOVA",
        "zip": "737462",
        "lat": "46.882279",
        "long": "27.580638"
      },
      {
        "name": "SATU NOU",
        "zip": "737032",
        "lat": "46.29754",
        "long": "27.796597"
      },
      {
        "name": "SATU NOU",
        "zip": "737068",
        "lat": "46.358063",
        "long": "28.149997"
      },
      {
        "name": "SATU NOU",
        "zip": "737158",
        "lat": "46.656384",
        "long": "27.977191"
      },
      {
        "name": "SATU NOU",
        "zip": "737478",
        "lat": "46.784076",
        "long": "27.800446"
      },
      {
        "name": "SATU NOU",
        "zip": "737513",
        "lat": "46.69563",
        "long": "27.750105"
      },
      {
        "name": "SATU NOU",
        "zip": "737558",
        "lat": "46.044025",
        "long": "27.596429"
      },
      {
        "name": "SAUCA",
        "zip": "737331",
        "lat": "46.651298",
        "long": "27.603196"
      },
      {
        "name": "SCHINENI",
        "zip": "737377",
        "lat": "46.203512",
        "long": "27.952903"
      },
      {
        "name": "SCHINETEA",
        "zip": "737237",
        "lat": "46.862311",
        "long": "27.260429"
      },
      {
        "name": "SCHITU",
        "zip": "737101",
        "lat": "46.506363",
        "long": "27.672049"
      },
      {
        "name": "SECUIA",
        "zip": "737368",
        "lat": "46.5643",
        "long": "27.801609"
      },
      {
        "name": "SEMENEA",
        "zip": "737211",
        "lat": "46.607031",
        "long": "27.370631"
      },
      {
        "name": "SERBOTESTI",
        "zip": "737479",
        "lat": "46.809623",
        "long": "27.77763"
      },
      {
        "name": "SILISTEA",
        "zip": "737298",
        "lat": "46.426849",
        "long": "27.548092"
      },
      {
        "name": "SILISTEA",
        "zip": "737452",
        "lat": "46.6915",
        "long": "27.36988"
      },
      {
        "name": "SILISTEA",
        "zip": "737542",
        "lat": "46.840311",
        "long": "27.403705"
      },
      {
        "name": "SIMILA",
        "zip": "737638",
        "lat": "46.262842",
        "long": "27.701179"
      },
      {
        "name": "SIMILISOARA",
        "zip": "737082",
        "lat": "46.518552",
        "long": "27.608931"
      },
      {
        "name": "SIPENI",
        "zip": "737072",
        "lat": "46.136943",
        "long": "27.982754"
      },
      {
        "name": "SISCANI",
        "zip": "737291",
        "lat": "46.58431",
        "long": "27.992936"
      },
      {
        "name": "SLOBOZIA",
        "zip": "737264",
        "lat": "46.752231",
        "long": "27.229969"
      },
      {
        "name": "SOCI",
        "zip": "737278",
        "lat": "46.492745",
        "long": "27.555488"
      },
      {
        "name": "SOFIENI",
        "zip": "737522",
        "lat": "46.953548",
        "long": "27.646817"
      },
      {
        "name": "SOFRONESTI",
        "zip": "737543",
        "lat": "46.880362",
        "long": "27.376759"
      },
      {
        "name": "SOLESTI",
        "zip": "737475",
        "lat": "46.76546",
        "long": "27.787278"
      },
      {
        "name": "SOPARLENI",
        "zip": "737226",
        "lat": "46.760423",
        "long": "28.117477"
      },
      {
        "name": "STANCASENI",
        "zip": "737606",
        "lat": "46.521425",
        "long": "27.474678"
      },
      {
        "name": "STANILESTI",
        "zip": "737485",
        "lat": "46.620876",
        "long": "28.173633"
      },
      {
        "name": "STEFAN CEL MARE",
        "zip": "737495",
        "lat": "46.71753",
        "long": "27.631075"
      },
      {
        "name": "STEJARU",
        "zip": "737453",
        "lat": "46.68964",
        "long": "27.319369"
      },
      {
        "name": "STIOBORANI",
        "zip": "737481",
        "lat": "46.746363",
        "long": "27.857647"
      },
      {
        "name": "STOISESTI",
        "zip": "737036",
        "lat": "46.342239",
        "long": "27.854045"
      },
      {
        "name": "STRAMTURA-MITOC",
        "zip": "737037",
        "lat": "46.361236",
        "long": "27.785287"
      },
      {
        "name": "STROIESTI",
        "zip": "737532",
        "lat": "46.724635",
        "long": "27.975833"
      },
      {
        "name": "STUHULET",
        "zip": "737069",
        "lat": "46.415164",
        "long": "28.067895"
      },
      {
        "name": "SUCEVENI",
        "zip": "737083",
        "lat": "46.53688",
        "long": "27.648541"
      },
      {
        "name": "SULETEA",
        "zip": "737505",
        "lat": "46.288691",
        "long": "27.913335"
      },
      {
        "name": "SUSENI",
        "zip": "737048",
        "lat": "46.354261",
        "long": "27.663432"
      },
      {
        "name": "TABALAIESTI",
        "zip": "737117",
        "lat": "46.763174",
        "long": "27.981899"
      },
      {
        "name": "TACUTA",
        "zip": "737515",
        "lat": "46.920019",
        "long": "27.687932"
      },
      {
        "name": "TALPIGENI",
        "zip": "737108",
        "lat": "46.833254",
        "long": "27.890064"
      },
      {
        "name": "TANACU",
        "zip": "737510",
        "lat": "46.678794",
        "long": "27.819067"
      },
      {
        "name": "TARZII",
        "zip": "737383",
        "lat": "46.568979",
        "long": "27.862336"
      },
      {
        "name": "TATARANI",
        "zip": "737166",
        "lat": "46.804663",
        "long": "27.675809"
      },
      {
        "name": "TATARANI",
        "zip": "737525",
        "lat": "46.694221",
        "long": "27.964425"
      },
      {
        "name": "TATOMIRESTI",
        "zip": "737463",
        "lat": "46.901287",
        "long": "27.534337"
      },
      {
        "name": "TEISORU",
        "zip": "737332",
        "lat": "46.60477",
        "long": "27.586395"
      },
      {
        "name": "TELEJNA",
        "zip": "737633",
        "lat": "46.782894",
        "long": "27.646206"
      },
      {
        "name": "TIBANESTII BUHLII",
        "zip": "737054",
        "lat": "46.862407",
        "long": "27.244543"
      },
      {
        "name": "TIFU",
        "zip": "737038",
        "lat": "46.334575",
        "long": "27.890853"
      },
      {
        "name": "TODIRENI",
        "zip": "737402",
        "lat": "46.518313",
        "long": "28.127468"
      },
      {
        "name": "TODIRESTI",
        "zip": "737535",
        "lat": "46.842424",
        "long": "27.376068"
      },
      {
        "name": "TOMESTI",
        "zip": "737414",
        "lat": "46.355505",
        "long": "27.583259"
      },
      {
        "name": "TOMSA",
        "zip": "737292",
        "lat": "46.568084",
        "long": "27.995544"
      },
      {
        "name": "TOPORASTI",
        "zip": "737454",
        "lat": "46.692987",
        "long": "27.411799"
      },
      {
        "name": "TRESTIANA",
        "zip": "737284",
        "lat": "46.19075",
        "long": "27.672996"
      },
      {
        "name": "TROHAN",
        "zip": "737266",
        "lat": "46.733077",
        "long": "27.287176"
      },
      {
        "name": "TUFESTII DE JOS",
        "zip": "737464",
        "lat": "46.881174",
        "long": "27.619329"
      },
      {
        "name": "TULESTI",
        "zip": "737212",
        "lat": "46.603143",
        "long": "27.332381"
      },
      {
        "name": "TUNSESTI",
        "zip": "737102",
        "lat": "46.482057",
        "long": "27.659069"
      },
      {
        "name": "TUPILATI",
        "zip": "737259",
        "lat": "46.391066",
        "long": "27.980219"
      },
      {
        "name": "TUTCANI",
        "zip": "737356",
        "lat": "46.16362",
        "long": "27.951003"
      },
      {
        "name": "TUTOVA",
        "zip": "737550",
        "lat": "46.119987",
        "long": "27.561466"
      },
      {
        "name": "ULEA",
        "zip": "737091",
        "lat": "46.421226",
        "long": "27.735052"
      },
      {
        "name": "UNCESTI",
        "zip": "737634",
        "lat": "46.799443",
        "long": "27.597502"
      },
      {
        "name": "UNTESTI",
        "zip": "737092",
        "lat": "46.397237",
        "long": "27.7321"
      },
      {
        "name": "URDESTI",
        "zip": "737578",
        "lat": "46.348334",
        "long": "27.940849"
      },
      {
        "name": "URICARI",
        "zip": "737607",
        "lat": "46.573396",
        "long": "27.364664"
      },
      {
        "name": "URLATI",
        "zip": "737196",
        "lat": "46.565426",
        "long": "28.053963"
      },
      {
        "name": "URSOAIA",
        "zip": "737313",
        "lat": "46.650414",
        "long": "27.404243"
      },
      {
        "name": "VADURILE",
        "zip": "737299",
        "lat": "46.373188",
        "long": "27.545444"
      },
      {
        "name": "VALCELE",
        "zip": "737393",
        "lat": "46.747472",
        "long": "27.445141"
      },
      {
        "name": "VALEA GRECULUI",
        "zip": "737234",
        "lat": "46.719849",
        "long": "28.101227"
      },
      {
        "name": "VALEA LUI BOSIE",
        "zip": "737534",
        "lat": "46.71007",
        "long": "27.973558"
      },
      {
        "name": "VALEA LUI DARIE",
        "zip": "737472",
        "lat": "46.449259",
        "long": "27.94296"
      },
      {
        "name": "VALEA LUNGA",
        "zip": "737593",
        "lat": "46.151661",
        "long": "27.831501"
      },
      {
        "name": "VALEA LUPULUI",
        "zip": "737279",
        "lat": "46.481927",
        "long": "27.547845"
      },
      {
        "name": "VALEA MARE",
        "zip": "735206",
        "lat": "46.813984",
        "long": "27.459538"
      },
      {
        "name": "VALEA MARE",
        "zip": "737238",
        "lat": "46.83367",
        "long": "27.328433"
      },
      {
        "name": "VALEA MARE",
        "zip": "737314",
        "lat": "46.663815",
        "long": "27.488814"
      },
      {
        "name": "VALEA OANEI",
        "zip": "737316",
        "lat": "46.669615",
        "long": "27.429524"
      },
      {
        "name": "VALEA POPII",
        "zip": "737544",
        "lat": "46.862579",
        "long": "27.411762"
      },
      {
        "name": "VALEA SEACA",
        "zip": "737533",
        "lat": "46.750871",
        "long": "27.975516"
      },
      {
        "name": "VALEA SILISTEI",
        "zip": "737482",
        "lat": "46.745289",
        "long": "27.831181"
      },
      {
        "name": "VALEA TARGULUI",
        "zip": "737333",
        "lat": "46.654198",
        "long": "27.65242"
      },
      {
        "name": "VALENI",
        "zip": "737403",
        "lat": "46.592561",
        "long": "28.068791"
      },
      {
        "name": "VALENI",
        "zip": "737565",
        "lat": "46.743992",
        "long": "27.763448"
      },
      {
        "name": "VALENI",
        "zip": "737579",
        "lat": "46.384545",
        "long": "27.845006"
      },
      {
        "name": "VASLUI",
        "zip": "730006",
        "lat": "46.638344",
        "long": "27.731868"
      },
      {
        "name": "VERDES",
        "zip": "737084",
        "lat": "46.551211",
        "long": "27.615812"
      },
      {
        "name": "VETRISOAIA",
        "zip": "737570",
        "lat": "46.429122",
        "long": "28.209674"
      },
      {
        "name": "VIISOARA",
        "zip": "730005",
        "lat": "46.64011",
        "long": "27.757086"
      },
      {
        "name": "VIISOARA",
        "zip": "737546",
        "lat": "46.83145",
        "long": "27.361997"
      },
      {
        "name": "VIISOARA",
        "zip": "737575",
        "lat": "46.37946",
        "long": "27.896399"
      },
      {
        "name": "VILTOTESTI",
        "zip": "737581",
        "lat": "46.380357",
        "long": "27.876698"
      },
      {
        "name": "VINDEREI",
        "zip": "737585",
        "lat": "46.150718",
        "long": "27.815353"
      },
      {
        "name": "VINETESTI",
        "zip": "737384",
        "lat": "46.631696",
        "long": "27.900154"
      },
      {
        "name": "VISINARI",
        "zip": "737093",
        "lat": "46.465774",
        "long": "27.703003"
      },
      {
        "name": "VIZURENI",
        "zip": "737561",
        "lat": "46.083738",
        "long": "27.591764"
      },
      {
        "name": "VLADESTI",
        "zip": "737094",
        "lat": "46.453045",
        "long": "27.708809"
      },
      {
        "name": "VLADIA",
        "zip": "737213",
        "lat": "46.636926",
        "long": "27.314501"
      },
      {
        "name": "VOINESTI",
        "zip": "737595",
        "lat": "46.561184",
        "long": "27.428372"
      },
      {
        "name": "VOINESTI",
        "zip": "737618",
        "lat": "46.819769",
        "long": "27.511376"
      },
      {
        "name": "VOVRIESTI",
        "zip": "737056",
        "lat": "46.868228",
        "long": "27.207552"
      },
      {
        "name": "VULPASENI",
        "zip": "737049",
        "lat": "46.362267",
        "long": "27.674494"
      },
      {
        "name": "VULTURESTI",
        "zip": "737615",
        "lat": "46.81036",
        "long": "27.526958"
      },
      {
        "name": "VUTCANI",
        "zip": "737620",
        "lat": "46.463066",
        "long": "27.951751"
      },
      {
        "name": "ZAPODENI",
        "zip": "737625",
        "lat": "46.745242",
        "long": "27.662332"
      },
      {
        "name": "ZGURA",
        "zip": "737386",
        "lat": "46.568473",
        "long": "27.939719"
      },
      {
        "name": "ZIZINCA",
        "zip": "737173",
        "lat": "46.548802",
        "long": "27.767447"
      },
      {
        "name": "ZORLENI",
        "zip": "737635",
        "lat": "46.265927",
        "long": "27.721607"
      }
    ],
    "VRANCEA": [
      {
        "name": "ADJUD",
        "zip": "625100",
        "lat": "46.100512",
        "long": "27.181047"
      },
      {
        "name": "ADJUDU VECHI",
        "zip": "625101",
        "lat": "46.13487",
        "long": "27.188763"
      },
      {
        "name": "ALEXANDRU VLAHUTA",
        "zip": "627106",
        "lat": "45.542294",
        "long": "27.107083"
      },
      {
        "name": "ANDREIASU DE JOS",
        "zip": "627005",
        "lat": "45.754757",
        "long": "26.833159"
      },
      {
        "name": "ANDREIASU DE SUS",
        "zip": "627006",
        "lat": "45.73699",
        "long": "26.834163"
      },
      {
        "name": "ANGHELESTI",
        "zip": "627296",
        "lat": "46.080307",
        "long": "27.059784"
      },
      {
        "name": "ARGEA",
        "zip": "627176",
        "lat": "46.043254",
        "long": "27.261261"
      },
      {
        "name": "ARMENI",
        "zip": "627316",
        "lat": "45.600645",
        "long": "27.193975"
      },
      {
        "name": "ARSITA",
        "zip": "627007",
        "lat": "45.741408",
        "long": "26.833744"
      },
      {
        "name": "ARVA",
        "zip": "627051",
        "lat": "45.768185",
        "long": "26.985941"
      },
      {
        "name": "BAHNELE",
        "zip": "627426",
        "lat": "45.632702",
        "long": "26.733363"
      },
      {
        "name": "BALANESTI",
        "zip": "627161",
        "lat": "45.607023",
        "long": "26.960155"
      },
      {
        "name": "BALESTI",
        "zip": "627015",
        "lat": "45.440345",
        "long": "27.23308"
      },
      {
        "name": "BALTA RATEI",
        "zip": "627396",
        "lat": "45.763061",
        "long": "27.269947"
      },
      {
        "name": "BARSESTI",
        "zip": "627020",
        "lat": "45.911857",
        "long": "26.739789"
      },
      {
        "name": "BATCARI",
        "zip": "627231",
        "lat": "45.826563",
        "long": "26.709983"
      },
      {
        "name": "BATINESTI",
        "zip": "627376",
        "lat": "45.833694",
        "long": "27.155764"
      },
      {
        "name": "BECIU",
        "zip": "627406",
        "lat": "45.737701",
        "long": "27.048462"
      },
      {
        "name": "BELCIUGELE",
        "zip": "627191",
        "lat": "45.509142",
        "long": "27.485875"
      },
      {
        "name": "BICESTII DE JOS",
        "zip": "627111",
        "lat": "45.543335",
        "long": "26.932423"
      },
      {
        "name": "BICESTII DE SUS",
        "zip": "627112",
        "lat": "45.56284",
        "long": "26.925983"
      },
      {
        "name": "BICHESTI",
        "zip": "627026",
        "lat": "46.185211",
        "long": "27.410499"
      },
      {
        "name": "BILIESTI",
        "zip": "627331",
        "lat": "45.71784",
        "long": "27.343456"
      },
      {
        "name": "BIZIGHESTI",
        "zip": "627141",
        "lat": "45.818807",
        "long": "27.210578"
      },
      {
        "name": "BLIDARI",
        "zip": "627066",
        "lat": "45.662989",
        "long": "27.056433"
      },
      {
        "name": "BLIDARI",
        "zip": "627113",
        "lat": "45.564562",
        "long": "26.914137"
      },
      {
        "name": "BODESTI",
        "zip": "627446",
        "lat": "45.891347",
        "long": "26.724873"
      },
      {
        "name": "BOGHESTI",
        "zip": "627025",
        "lat": "46.158868",
        "long": "27.409557"
      },
      {
        "name": "BOGHESTII DE SUS",
        "zip": "627027",
        "lat": "46.169697",
        "long": "27.404367"
      },
      {
        "name": "BOGZA",
        "zip": "627301",
        "lat": "45.508018",
        "long": "27.193845"
      },
      {
        "name": "BOLOTESTI",
        "zip": "627035",
        "lat": "45.839707",
        "long": "27.074497"
      },
      {
        "name": "BONTESTI",
        "zip": "627067",
        "lat": "45.678918",
        "long": "27.052042"
      },
      {
        "name": "BORDEASCA NOUA",
        "zip": "627351",
        "lat": "45.539846",
        "long": "27.289617"
      },
      {
        "name": "BORDEASCA VECHE",
        "zip": "627352",
        "lat": "45.54095",
        "long": "27.312241"
      },
      {
        "name": "BORDESTI",
        "zip": "627045",
        "lat": "45.555194",
        "long": "27.043373"
      },
      {
        "name": "BORDESTII DE JOS",
        "zip": "627046",
        "lat": "45.539103",
        "long": "27.038701"
      },
      {
        "name": "BOTARLAU",
        "zip": "627456",
        "lat": "45.631967",
        "long": "27.386834"
      },
      {
        "name": "BRADACESTI",
        "zip": "627226",
        "lat": "45.701545",
        "long": "26.677174"
      },
      {
        "name": "BRADETU",
        "zip": "627232",
        "lat": "45.80133",
        "long": "26.62159"
      },
      {
        "name": "BROSTENI",
        "zip": "627050",
        "lat": "45.760868",
        "long": "27.037455"
      },
      {
        "name": "BUDA",
        "zip": "627091",
        "lat": "46.131787",
        "long": "27.302788"
      },
      {
        "name": "BUDESTI",
        "zip": "627101",
        "lat": "45.62779",
        "long": "27.056692"
      },
      {
        "name": "BURCA",
        "zip": "627416",
        "lat": "45.909292",
        "long": "26.951156"
      },
      {
        "name": "BURCIOAIA",
        "zip": "625102",
        "lat": "46.070936",
        "long": "27.230059"
      },
      {
        "name": "CAIATA",
        "zip": "627302",
        "lat": "45.523709",
        "long": "27.152142"
      },
      {
        "name": "CALIENII NOI",
        "zip": "627216",
        "lat": "45.590446",
        "long": "27.490521"
      },
      {
        "name": "CALIENII VECHI",
        "zip": "627217",
        "lat": "45.59947",
        "long": "27.50943"
      },
      {
        "name": "CALIMANEASA",
        "zip": "627336",
        "lat": "46.113677",
        "long": "27.410306"
      },
      {
        "name": "CALIMANESTI",
        "zip": "625201",
        "lat": "45.961489",
        "long": "27.216041"
      },
      {
        "name": "CAMPINEANCA",
        "zip": "627055",
        "lat": "45.711659",
        "long": "27.12832"
      },
      {
        "name": "CAMPURI",
        "zip": "627060",
        "lat": "46.014834",
        "long": "26.787076"
      },
      {
        "name": "CANDESTI",
        "zip": "627107",
        "lat": "45.538849",
        "long": "27.075645"
      },
      {
        "name": "CARLIGELE",
        "zip": "627065",
        "lat": "45.675158",
        "long": "27.078764"
      },
      {
        "name": "CARSOCHESTI-CORABITA",
        "zip": "627241",
        "lat": "45.734455",
        "long": "26.74693"
      },
      {
        "name": "CATAUTI",
        "zip": "627071",
        "lat": "45.54044",
        "long": "26.846584"
      },
      {
        "name": "CEARDAC",
        "zip": "627151",
        "lat": "45.669668",
        "long": "27.166112"
      },
      {
        "name": "CERBU",
        "zip": "627186",
        "lat": "45.593513",
        "long": "26.713197"
      },
      {
        "name": "CHIOJDENI",
        "zip": "627070",
        "lat": "45.563297",
        "long": "26.865095"
      },
      {
        "name": "CHIRICANI",
        "zip": "627227",
        "lat": "45.693627",
        "long": "26.710573"
      },
      {
        "name": "CHITCANI",
        "zip": "627028",
        "lat": "46.141813",
        "long": "27.414795"
      },
      {
        "name": "CIOLANESTI",
        "zip": "627136",
        "lat": "45.95778",
        "long": "27.061354"
      },
      {
        "name": "CIORANI",
        "zip": "627276",
        "lat": "45.988439",
        "long": "27.214999"
      },
      {
        "name": "CIORASTI",
        "zip": "627080",
        "lat": "45.431254",
        "long": "27.312598"
      },
      {
        "name": "CIUSLEA",
        "zip": "627142",
        "lat": "45.78559",
        "long": "27.310564"
      },
      {
        "name": "CLIPICESTI",
        "zip": "627377",
        "lat": "45.892702",
        "long": "27.025881"
      },
      {
        "name": "COCOSARI",
        "zip": "627162",
        "lat": "45.612092",
        "long": "26.966246"
      },
      {
        "name": "CODRESTI",
        "zip": "627081",
        "lat": "45.421775",
        "long": "27.271592"
      },
      {
        "name": "COLACU",
        "zip": "627391",
        "lat": "45.889734",
        "long": "26.829078"
      },
      {
        "name": "COPACESTI",
        "zip": "627297",
        "lat": "46.090879",
        "long": "27.120354"
      },
      {
        "name": "CORBITA",
        "zip": "627090",
        "lat": "46.151661",
        "long": "27.305455"
      },
      {
        "name": "CORNETU",
        "zip": "627306",
        "lat": "45.500631",
        "long": "27.049656"
      },
      {
        "name": "COROTENI",
        "zip": "627307",
        "lat": "45.484515",
        "long": "27.03304"
      },
      {
        "name": "COSTISA",
        "zip": "627177",
        "lat": "46.176181",
        "long": "27.209192"
      },
      {
        "name": "COSTISA",
        "zip": "627337",
        "lat": "46.094028",
        "long": "27.424857"
      },
      {
        "name": "COSTISA DE SUS",
        "zip": "627338",
        "lat": "46.099878",
        "long": "27.414356"
      },
      {
        "name": "COTESTI",
        "zip": "627100",
        "lat": "45.646356",
        "long": "27.063849"
      },
      {
        "name": "COVRAG",
        "zip": "627339",
        "lat": "46.084947",
        "long": "27.334807"
      },
      {
        "name": "COZA",
        "zip": "627366",
        "lat": "45.89595",
        "long": "26.659277"
      },
      {
        "name": "CRUCEA DE JOS",
        "zip": "625401",
        "lat": "45.896357",
        "long": "27.101528"
      },
      {
        "name": "CRUCEA DE SUS",
        "zip": "625402",
        "lat": "45.917473",
        "long": "27.083304"
      },
      {
        "name": "DALHAUTI",
        "zip": "627068",
        "lat": "45.693703",
        "long": "27.045517"
      },
      {
        "name": "DEALU CUCULUI",
        "zip": "627266",
        "lat": "45.672299",
        "long": "26.995397"
      },
      {
        "name": "DEALU LUNG",
        "zip": "627163",
        "lat": "45.621128",
        "long": "26.947249"
      },
      {
        "name": "DEALU SARII",
        "zip": "627187",
        "lat": "45.572368",
        "long": "26.758323"
      },
      {
        "name": "DIOCHETI-REDIU",
        "zip": "627211",
        "lat": "45.930988",
        "long": "27.138637"
      },
      {
        "name": "DOAGA",
        "zip": "627143",
        "lat": "45.830254",
        "long": "27.293199"
      },
      {
        "name": "DOMNESTI-SAT",
        "zip": "627277",
        "lat": "46.024971",
        "long": "27.214191"
      },
      {
        "name": "DOMNESTI-TARG",
        "zip": "627278",
        "lat": "46.02729",
        "long": "27.195018"
      },
      {
        "name": "DRAGOSLOVENI",
        "zip": "627108",
        "lat": "45.561697",
        "long": "27.077036"
      },
      {
        "name": "DRAGOSLOVENI",
        "zip": "627321",
        "lat": "46.000347",
        "long": "26.666278"
      },
      {
        "name": "DUMBRAVA",
        "zip": "625403",
        "lat": "45.909926",
        "long": "27.112238"
      },
      {
        "name": "DUMBRAVA",
        "zip": "627267",
        "lat": "45.657899",
        "long": "27.007701"
      },
      {
        "name": "DUMBRAVENI",
        "zip": "627105",
        "lat": "45.551934",
        "long": "27.107308"
      },
      {
        "name": "DUMITRESTI",
        "zip": "627110",
        "lat": "45.556359",
        "long": "26.922597"
      },
      {
        "name": "DUMITRESTII DE SUS",
        "zip": "627114",
        "lat": "45.557632",
        "long": "26.894456"
      },
      {
        "name": "DUMITRESTII-FATA",
        "zip": "627116",
        "lat": "45.593674",
        "long": "26.93358"
      },
      {
        "name": "DUPA MAGURA",
        "zip": "627427",
        "lat": "45.628258",
        "long": "26.738011"
      },
      {
        "name": "FAGETU",
        "zip": "627233",
        "lat": "45.820086",
        "long": "26.699922"
      },
      {
        "name": "FARAOANELE",
        "zip": "627407",
        "lat": "45.711097",
        "long": "27.043484"
      },
      {
        "name": "FARCAS",
        "zip": "627286",
        "lat": "45.802932",
        "long": "26.827813"
      },
      {
        "name": "FAUREI",
        "zip": "627144",
        "lat": "45.786795",
        "long": "27.198848"
      },
      {
        "name": "FELDIOARA",
        "zip": "627341",
        "lat": "46.098739",
        "long": "27.350928"
      },
      {
        "name": "FETESTI",
        "zip": "627061",
        "lat": "46.037998",
        "long": "26.755057"
      },
      {
        "name": "FETIG",
        "zip": "627008",
        "lat": "45.738675",
        "long": "26.785295"
      },
      {
        "name": "FITIONESTI",
        "zip": "627135",
        "lat": "45.98574",
        "long": "27.057505"
      },
      {
        "name": "FOCSANI",
        "zip": "620003",
        "lat": "45.697274",
        "long": "27.185692"
      },
      {
        "name": "FRECATEI",
        "zip": "627212",
        "lat": "45.963223",
        "long": "27.089718"
      },
      {
        "name": "GAGESTI",
        "zip": "627036",
        "lat": "45.855983",
        "long": "27.055396000000002"
      },
      {
        "name": "GALBENI",
        "zip": "627342",
        "lat": "46.108927",
        "long": "27.37666"
      },
      {
        "name": "GALOIESTI",
        "zip": "627117",
        "lat": "45.5519",
        "long": "26.956316"
      },
      {
        "name": "GAROAFA",
        "zip": "627140",
        "lat": "45.783501",
        "long": "27.211538"
      },
      {
        "name": "GHEBARI",
        "zip": "627242",
        "lat": "45.779732",
        "long": "26.785802"
      },
      {
        "name": "GHIMICESTI",
        "zip": "627137",
        "lat": "45.966962",
        "long": "27.077687"
      },
      {
        "name": "GOGOIU",
        "zip": "627281",
        "lat": "45.999299",
        "long": "26.841624"
      },
      {
        "name": "GOLESTI",
        "zip": "627150",
        "lat": "45.662452",
        "long": "27.165723"
      },
      {
        "name": "GOLESTII DE SUS",
        "zip": "627102",
        "lat": "45.641157",
        "long": "27.103429"
      },
      {
        "name": "GOLOGANU",
        "zip": "627206",
        "lat": "45.609837",
        "long": "27.26422"
      },
      {
        "name": "GRESU",
        "zip": "627367",
        "lat": "45.949298",
        "long": "26.496466"
      },
      {
        "name": "GROAPA TUFEI",
        "zip": "627164",
        "lat": "45.603071",
        "long": "27.002327"
      },
      {
        "name": "GUGESTI",
        "zip": "627155",
        "lat": "45.567018",
        "long": "27.128654"
      },
      {
        "name": "GURA CALITEI",
        "zip": "627160",
        "lat": "45.581597",
        "long": "27.023881"
      },
      {
        "name": "GURA VAII",
        "zip": "627062",
        "lat": "46.051701",
        "long": "26.737683"
      },
      {
        "name": "HANGULESTI",
        "zip": "627457",
        "lat": "45.592661",
        "long": "27.407402"
      },
      {
        "name": "HARET",
        "zip": "625202",
        "lat": "45.919478",
        "long": "27.208169"
      },
      {
        "name": "HAULISCA",
        "zip": "627368",
        "lat": "45.88053",
        "long": "26.681901"
      },
      {
        "name": "HOLBANESTI",
        "zip": "627138",
        "lat": "45.966521",
        "long": "27.069225"
      },
      {
        "name": "HOMOCEA",
        "zip": "627175",
        "lat": "46.137506",
        "long": "27.241185"
      },
      {
        "name": "HOTARU",
        "zip": "627009",
        "lat": "45.727417",
        "long": "26.85218"
      },
      {
        "name": "IGESTI",
        "zip": "627378",
        "lat": "45.819992",
        "long": "27.181843"
      },
      {
        "name": "IRESTI",
        "zip": "627417",
        "lat": "45.930607",
        "long": "26.942008"
      },
      {
        "name": "IUGANI",
        "zip": "627029",
        "lat": "46.149754",
        "long": "27.434465"
      },
      {
        "name": "IVANCESTI",
        "zip": "627037",
        "lat": "45.807154",
        "long": "27.139635"
      },
      {
        "name": "IZVOARELE",
        "zip": "627092",
        "lat": "46.156461",
        "long": "27.342882"
      },
      {
        "name": "JARISTEA",
        "zip": "627180",
        "lat": "45.795004",
        "long": "27.060725"
      },
      {
        "name": "JGHEABURI",
        "zip": "627287",
        "lat": "45.814499",
        "long": "26.829974"
      },
      {
        "name": "JILISTE",
        "zip": "627317",
        "lat": "45.599706",
        "long": "27.241567"
      },
      {
        "name": "JITIA",
        "zip": "627185",
        "lat": "45.586022",
        "long": "26.747234"
      },
      {
        "name": "JITIA DE JOS",
        "zip": "627188",
        "lat": "45.568707",
        "long": "26.78193"
      },
      {
        "name": "JORASTI",
        "zip": "627397",
        "lat": "45.71449",
        "long": "27.262784"
      },
      {
        "name": "LACU LUI BABAN",
        "zip": "627166",
        "lat": "45.602433",
        "long": "26.974152"
      },
      {
        "name": "LAMOTESTI",
        "zip": "627207",
        "lat": "45.658514",
        "long": "27.25113"
      },
      {
        "name": "LARGASENI",
        "zip": "627093",
        "lat": "46.195821",
        "long": "27.293274"
      },
      {
        "name": "LASTUNI",
        "zip": "627118",
        "lat": "45.598873",
        "long": "26.89258"
      },
      {
        "name": "LEPSA",
        "zip": "627369",
        "lat": "45.950831",
        "long": "26.57582"
      },
      {
        "name": "LESPEZI",
        "zip": "627178",
        "lat": "46.160275",
        "long": "27.24065"
      },
      {
        "name": "LIESTI",
        "zip": "627308",
        "lat": "45.497105",
        "long": "27.049823"
      },
      {
        "name": "LIVADA",
        "zip": "627201",
        "lat": "45.774491",
        "long": "26.922229"
      },
      {
        "name": "LIVEZILE",
        "zip": "627436",
        "lat": "45.954386",
        "long": "26.832433"
      },
      {
        "name": "LOJNITA",
        "zip": "627072",
        "lat": "45.568775",
        "long": "26.840222"
      },
      {
        "name": "LUNCILE",
        "zip": "627073",
        "lat": "45.560366",
        "long": "26.814208"
      },
      {
        "name": "LUPOAIA",
        "zip": "627119",
        "lat": "45.542812",
        "long": "26.911155"
      },
      {
        "name": "MAGURA",
        "zip": "627189",
        "lat": "45.601656",
        "long": "26.743675"
      },
      {
        "name": "MAHRIU",
        "zip": "627268",
        "lat": "45.672276",
        "long": "26.965657"
      },
      {
        "name": "MAICANESTI",
        "zip": "627190",
        "lat": "45.501799",
        "long": "27.494542"
      },
      {
        "name": "MALURI",
        "zip": "627458",
        "lat": "45.56124",
        "long": "27.440661"
      },
      {
        "name": "MANASTIOARA",
        "zip": "627139",
        "lat": "45.95619",
        "long": "27.082764"
      },
      {
        "name": "MANDRESTI-MOLDOVA",
        "zip": "620001",
        "lat": "45.68858",
        "long": "27.255987"
      },
      {
        "name": "MANDRESTI-MUNTENI",
        "zip": "620002",
        "lat": "45.682595",
        "long": "27.242749"
      },
      {
        "name": "MARACINI",
        "zip": "627074",
        "lat": "45.580553",
        "long": "26.846186"
      },
      {
        "name": "MARASESTI",
        "zip": "625200",
        "lat": "45.874081",
        "long": "27.218417"
      },
      {
        "name": "MARASTI",
        "zip": "627282",
        "lat": "46.013175",
        "long": "26.845107"
      },
      {
        "name": "MARTINESTI",
        "zip": "627353",
        "lat": "45.502415",
        "long": "27.304869"
      },
      {
        "name": "MATACINA",
        "zip": "627392",
        "lat": "45.883065",
        "long": "26.808162"
      },
      {
        "name": "MERA",
        "zip": "627200",
        "lat": "45.765242",
        "long": "26.934424"
      },
      {
        "name": "MESTEACANU",
        "zip": "627437",
        "lat": "45.937937",
        "long": "26.832586"
      },
      {
        "name": "MIHALCENI",
        "zip": "627082",
        "lat": "45.443662",
        "long": "27.303796"
      },
      {
        "name": "MILCOVEL",
        "zip": "627202",
        "lat": "45.790519",
        "long": "26.918258"
      },
      {
        "name": "MILCOVUL",
        "zip": "627205",
        "lat": "45.645709",
        "long": "27.259781"
      },
      {
        "name": "MIRCESTII NOI",
        "zip": "627398",
        "lat": "45.750705",
        "long": "27.272962"
      },
      {
        "name": "MIRCESTII VECHI",
        "zip": "627399",
        "lat": "45.743981",
        "long": "27.282413"
      },
      {
        "name": "MODRUZENI",
        "zip": "625203",
        "lat": "45.905339",
        "long": "27.232953"
      },
      {
        "name": "MORARESTI",
        "zip": "627243",
        "lat": "45.734086",
        "long": "26.756649"
      },
      {
        "name": "MOTNAU",
        "zip": "627121",
        "lat": "45.584013",
        "long": "26.878367"
      },
      {
        "name": "MOVILITA",
        "zip": "627210",
        "lat": "45.957294",
        "long": "27.103278"
      },
      {
        "name": "MUNCEI",
        "zip": "627447",
        "lat": "45.855357",
        "long": "26.683804"
      },
      {
        "name": "MUNCELU",
        "zip": "627326",
        "lat": "45.951397",
        "long": "27.034476"
      },
      {
        "name": "NANESTI",
        "zip": "627215",
        "lat": "45.543686",
        "long": "27.499771"
      },
      {
        "name": "NANESTI",
        "zip": "627343",
        "lat": "46.099188",
        "long": "27.375362"
      },
      {
        "name": "NARUJA",
        "zip": "627220",
        "lat": "45.827619",
        "long": "26.776885"
      },
      {
        "name": "NECULELE",
        "zip": "627428",
        "lat": "45.627933",
        "long": "26.712044"
      },
      {
        "name": "NEGRILESTI",
        "zip": "627021",
        "lat": "45.937625",
        "long": "26.706023"
      },
      {
        "name": "NEICU",
        "zip": "625404",
        "lat": "45.916837",
        "long": "27.075221"
      },
      {
        "name": "NEREJU",
        "zip": "627225",
        "lat": "45.716401",
        "long": "26.717534"
      },
      {
        "name": "NEREJU MIC",
        "zip": "627228",
        "lat": "45.706758",
        "long": "26.695207"
      },
      {
        "name": "NISTORESTI",
        "zip": "627230",
        "lat": "45.830158",
        "long": "26.718479"
      },
      {
        "name": "OBREJITA",
        "zip": "627356",
        "lat": "45.501178",
        "long": "27.076932"
      },
      {
        "name": "OCHESESTI",
        "zip": "627094",
        "lat": "46.150207",
        "long": "27.319313"
      },
      {
        "name": "ODOBASCA",
        "zip": "627269",
        "lat": "45.657646",
        "long": "26.979702"
      },
      {
        "name": "ODOBESTI",
        "zip": "625300",
        "lat": "45.760235",
        "long": "27.065135"
      },
      {
        "name": "OLARENI",
        "zip": "627309",
        "lat": "45.485094",
        "long": "27.007019"
      },
      {
        "name": "OLESESTI",
        "zip": "627379",
        "lat": "45.847808",
        "long": "27.100971"
      },
      {
        "name": "OLTENI",
        "zip": "627408",
        "lat": "45.73369",
        "long": "27.098376"
      },
      {
        "name": "OREAVU",
        "zip": "627156",
        "lat": "45.588906",
        "long": "27.150515"
      },
      {
        "name": "PADURENI",
        "zip": "625204",
        "lat": "45.934921",
        "long": "27.224389"
      },
      {
        "name": "PADURENI",
        "zip": "627181",
        "lat": "45.793467",
        "long": "27.035035"
      },
      {
        "name": "PADURENI",
        "zip": "627357",
        "lat": "45.524587",
        "long": "27.060584"
      },
      {
        "name": "PALTIN",
        "zip": "627240",
        "lat": "45.777393000000004",
        "long": "26.719335"
      },
      {
        "name": "PANCIU",
        "zip": "625400",
        "lat": "45.907091",
        "long": "27.089899"
      },
      {
        "name": "PATRASCANI",
        "zip": "627381",
        "lat": "45.825277",
        "long": "27.177928"
      },
      {
        "name": "PAULESTI",
        "zip": "627371",
        "lat": "45.891435",
        "long": "26.68932"
      },
      {
        "name": "PAUNESTI",
        "zip": "627260",
        "lat": "46.032254",
        "long": "27.113352"
      },
      {
        "name": "PAVALARI",
        "zip": "627244",
        "lat": "45.739692",
        "long": "26.688501"
      },
      {
        "name": "PETREANU",
        "zip": "627271",
        "lat": "45.690543",
        "long": "26.936031"
      },
      {
        "name": "PETRESTI",
        "zip": "627401",
        "lat": "45.729891",
        "long": "27.226651"
      },
      {
        "name": "PIETROASA",
        "zip": "627056",
        "lat": "45.712174",
        "long": "27.119513"
      },
      {
        "name": "PIETROASA",
        "zip": "627038",
        "lat": "45.864666",
        "long": "27.040744"
      },
      {
        "name": "PIETROASA",
        "zip": "627358",
        "lat": "45.523084",
        "long": "27.039125"
      },
      {
        "name": "PIETROASA",
        "zip": "627409",
        "lat": "45.700196",
        "long": "27.042646"
      },
      {
        "name": "PISCU RADULUI",
        "zip": "627438",
        "lat": "45.962121",
        "long": "26.807134"
      },
      {
        "name": "PISCU REGHIULUI",
        "zip": "627288",
        "lat": "45.796203",
        "long": "26.811173"
      },
      {
        "name": "PITULUSA",
        "zip": "627052",
        "lat": "45.767566",
        "long": "27.01424"
      },
      {
        "name": "PLACINTENI",
        "zip": "627031",
        "lat": "46.15222",
        "long": "27.37224"
      },
      {
        "name": "PLESESTI",
        "zip": "627032",
        "lat": "46.153455",
        "long": "27.452575"
      },
      {
        "name": "PLOPU",
        "zip": "627167",
        "lat": "45.628391",
        "long": "26.961438"
      },
      {
        "name": "PLOSCUTENI",
        "zip": "627179",
        "lat": "46.078585",
        "long": "27.270323"
      },
      {
        "name": "PLOSTINA",
        "zip": "627448",
        "lat": "45.850359",
        "long": "26.656139"
      },
      {
        "name": "PODU LACULUI",
        "zip": "627272",
        "lat": "45.643523",
        "long": "26.989784"
      },
      {
        "name": "PODU NARUJEI",
        "zip": "627221",
        "lat": "45.818684",
        "long": "26.754148"
      },
      {
        "name": "PODU SCHIOPULUI",
        "zip": "627234",
        "lat": "45.808819",
        "long": "26.64843"
      },
      {
        "name": "PODU STOICA",
        "zip": "627222",
        "lat": "45.821964",
        "long": "26.787528"
      },
      {
        "name": "PODURI",
        "zip": "627393",
        "lat": "45.88092",
        "long": "26.822695"
      },
      {
        "name": "PODURILE",
        "zip": "627076",
        "lat": "45.556934",
        "long": "26.862834"
      },
      {
        "name": "POENILE",
        "zip": "627168",
        "lat": "45.623218",
        "long": "26.982866"
      },
      {
        "name": "POIANA",
        "zip": "627449",
        "lat": "45.874802",
        "long": "26.759048"
      },
      {
        "name": "POIANA CRISTEI",
        "zip": "627265",
        "lat": "45.654732",
        "long": "26.998312"
      },
      {
        "name": "POIANA STOICHII",
        "zip": "627429",
        "lat": "45.660381",
        "long": "26.750919"
      },
      {
        "name": "POIENITA",
        "zip": "627122",
        "lat": "45.584654",
        "long": "26.913296"
      },
      {
        "name": "POPESTI",
        "zip": "627386",
        "lat": "45.590983",
        "long": "27.099076"
      },
      {
        "name": "PRAHUDA",
        "zip": "627246",
        "lat": "45.787771",
        "long": "26.770024"
      },
      {
        "name": "PRECISTANU",
        "zip": "627146",
        "lat": "45.771501",
        "long": "27.210675"
      },
      {
        "name": "PRISACA",
        "zip": "627394",
        "lat": "45.863443",
        "long": "26.781037"
      },
      {
        "name": "PRISECANI",
        "zip": "627033",
        "lat": "46.180727",
        "long": "27.425476"
      },
      {
        "name": "PUFESTI",
        "zip": "627275",
        "lat": "45.999859",
        "long": "27.208725"
      },
      {
        "name": "PUTNA",
        "zip": "627039",
        "lat": "45.824895",
        "long": "27.097554"
      },
      {
        "name": "RACHITASU",
        "zip": "627011",
        "lat": "45.73267",
        "long": "26.808738"
      },
      {
        "name": "RACHITOSU",
        "zip": "627147",
        "lat": "45.791613",
        "long": "27.260641"
      },
      {
        "name": "RACOASA",
        "zip": "627280",
        "lat": "45.992213",
        "long": "26.879391"
      },
      {
        "name": "RADACINESTI",
        "zip": "627096",
        "lat": "46.184552",
        "long": "27.295982"
      },
      {
        "name": "RADULESTI",
        "zip": "627402",
        "lat": "45.743136",
        "long": "27.313457"
      },
      {
        "name": "RAIUTI",
        "zip": "627289",
        "lat": "45.821497",
        "long": "26.838367"
      },
      {
        "name": "RAMNICEANCA",
        "zip": "627411",
        "lat": "45.729133",
        "long": "27.06006"
      },
      {
        "name": "RAMNICENI",
        "zip": "627192",
        "lat": "45.512042",
        "long": "27.444138"
      },
      {
        "name": "RASCA",
        "zip": "627169",
        "lat": "45.640454",
        "long": "26.93357"
      },
      {
        "name": "RASTOACA",
        "zip": "627208",
        "lat": "45.659414",
        "long": "27.286595"
      },
      {
        "name": "REBEGARI",
        "zip": "627223",
        "lat": "45.824637",
        "long": "26.741787"
      },
      {
        "name": "REGHIU",
        "zip": "627285",
        "lat": "45.793079",
        "long": "26.865154"
      },
      {
        "name": "REPEDEA",
        "zip": "627327",
        "lat": "45.921439",
        "long": "27.034073"
      },
      {
        "name": "ROMANESTI",
        "zip": "627236",
        "lat": "45.816468",
        "long": "26.684623"
      },
      {
        "name": "ROSCARI",
        "zip": "627123",
        "lat": "45.572273",
        "long": "26.913721"
      },
      {
        "name": "ROSIOARA",
        "zip": "627203",
        "lat": "45.769755",
        "long": "26.960243"
      },
      {
        "name": "ROTILESTII MARI",
        "zip": "627063",
        "lat": "46.036772",
        "long": "26.752159"
      },
      {
        "name": "ROTILESTII MICI",
        "zip": "627064",
        "lat": "46.035432",
        "long": "26.741623"
      },
      {
        "name": "RUCARENI",
        "zip": "627322",
        "lat": "45.993863",
        "long": "26.654948"
      },
      {
        "name": "RUGET",
        "zip": "627418",
        "lat": "45.901821",
        "long": "26.860093"
      },
      {
        "name": "RUGINESTI",
        "zip": "627295",
        "lat": "46.074307",
        "long": "27.133952"
      },
      {
        "name": "SAHASTRU",
        "zip": "627229",
        "lat": "45.727208",
        "long": "26.687138"
      },
      {
        "name": "SALCIA NOUA",
        "zip": "627083",
        "lat": "45.456839",
        "long": "27.340751"
      },
      {
        "name": "SALCIA VECHE",
        "zip": "627084",
        "lat": "45.457343",
        "long": "27.307734"
      },
      {
        "name": "SARBI",
        "zip": "627382",
        "lat": "45.869684",
        "long": "27.065269"
      },
      {
        "name": "SATU NOU",
        "zip": "625405",
        "lat": "45.889478",
        "long": "27.098239"
      },
      {
        "name": "SATU NOU",
        "zip": "627086",
        "lat": "45.429109",
        "long": "27.329696"
      },
      {
        "name": "SCAFARI",
        "zip": "627419",
        "lat": "45.904841",
        "long": "26.88853"
      },
      {
        "name": "SCANTEIA",
        "zip": "627182",
        "lat": "45.822718",
        "long": "27.026119"
      },
      {
        "name": "SECIU",
        "zip": "627077",
        "lat": "45.536863",
        "long": "26.835289"
      },
      {
        "name": "SERBANESTI",
        "zip": "627097",
        "lat": "46.164756",
        "long": "27.300871"
      },
      {
        "name": "SERBESTI",
        "zip": "627421",
        "lat": "45.920117",
        "long": "26.973616"
      },
      {
        "name": "SIHLEA",
        "zip": "627300",
        "lat": "45.49858",
        "long": "27.128146"
      },
      {
        "name": "SIMINOC",
        "zip": "627124",
        "lat": "45.598807",
        "long": "26.866019"
      },
      {
        "name": "SINDRILARI",
        "zip": "627291",
        "lat": "45.791233",
        "long": "26.880188"
      },
      {
        "name": "SIRETU",
        "zip": "625205",
        "lat": "45.885302",
        "long": "27.237532"
      },
      {
        "name": "SISCANI",
        "zip": "625103",
        "lat": "46.152304",
        "long": "27.170393"
      },
      {
        "name": "SLIMNIC",
        "zip": "627359",
        "lat": "45.508111",
        "long": "27.051326"
      },
      {
        "name": "SLOBOZIA BOTESTI",
        "zip": "627193",
        "lat": "45.515012",
        "long": "27.419657"
      },
      {
        "name": "SLOBOZIA BRADULUI",
        "zip": "627305",
        "lat": "45.490756",
        "long": "27.056836"
      },
      {
        "name": "SLOBOZIA CIORASTI",
        "zip": "627315",
        "lat": "45.617119",
        "long": "27.203791"
      },
      {
        "name": "SOTARCARI",
        "zip": "627171",
        "lat": "45.608329",
        "long": "26.98226"
      },
      {
        "name": "SPATAREASA",
        "zip": "627087",
        "lat": "45.426791",
        "long": "27.296217"
      },
      {
        "name": "SPINESTI",
        "zip": "627451",
        "lat": "45.892011",
        "long": "26.706059"
      },
      {
        "name": "SPULBER",
        "zip": "627247",
        "lat": "45.74935",
        "long": "26.752095"
      },
      {
        "name": "STRAJESCU",
        "zip": "627148",
        "lat": "45.81777",
        "long": "27.287794"
      },
      {
        "name": "STRAOANE",
        "zip": "627325",
        "lat": "45.934924",
        "long": "27.045978"
      },
      {
        "name": "STUPINA",
        "zip": "627194",
        "lat": "45.460019",
        "long": "27.439712"
      },
      {
        "name": "SURAIA",
        "zip": "627330",
        "lat": "45.681949",
        "long": "27.383692"
      },
      {
        "name": "TABUCESTI",
        "zip": "627034",
        "lat": "46.170836",
        "long": "27.441522"
      },
      {
        "name": "TAMBOESTI",
        "zip": "627355",
        "lat": "45.517861",
        "long": "27.049328"
      },
      {
        "name": "TANASARI",
        "zip": "627431",
        "lat": "45.612751",
        "long": "26.726168"
      },
      {
        "name": "TANASOAIA",
        "zip": "627335",
        "lat": "46.103786",
        "long": "27.388916"
      },
      {
        "name": "TARATU",
        "zip": "627273",
        "lat": "45.702754",
        "long": "26.888748"
      },
      {
        "name": "TATARANU",
        "zip": "627350",
        "lat": "45.514007",
        "long": "27.322885"
      },
      {
        "name": "TATARU",
        "zip": "627196",
        "lat": "45.500613",
        "long": "27.476925"
      },
      {
        "name": "TEPA",
        "zip": "627251",
        "lat": "45.781238",
        "long": "26.690126"
      },
      {
        "name": "TERCHESTI",
        "zip": "627387",
        "lat": "45.584327",
        "long": "27.052048"
      },
      {
        "name": "TICHIRIS",
        "zip": "627422",
        "lat": "45.90094",
        "long": "26.876546"
      },
      {
        "name": "TIFESTI",
        "zip": "627375",
        "lat": "45.858628",
        "long": "27.083812"
      },
      {
        "name": "TINOASA",
        "zip": "627126",
        "lat": "45.614056",
        "long": "26.892839"
      },
      {
        "name": "TIPAU",
        "zip": "627252",
        "lat": "45.751392",
        "long": "26.723364"
      },
      {
        "name": "TISITA",
        "zip": "625206",
        "lat": "45.845297",
        "long": "27.210543"
      },
      {
        "name": "TITILA",
        "zip": "627012",
        "lat": "45.726241",
        "long": "26.835933"
      },
      {
        "name": "TOJANII DE JOS",
        "zip": "627248",
        "lat": "45.741428",
        "long": "26.733174"
      },
      {
        "name": "TOJANII DE SUS",
        "zip": "627249",
        "lat": "45.760637",
        "long": "26.745625"
      },
      {
        "name": "TOPESTI",
        "zip": "627022",
        "lat": "45.905451",
        "long": "26.751805"
      },
      {
        "name": "TRESTIA",
        "zip": "627127",
        "lat": "45.60952",
        "long": "26.857981"
      },
      {
        "name": "TRESTIENI",
        "zip": "627361",
        "lat": "45.515545",
        "long": "27.022714"
      },
      {
        "name": "TROTUSANU",
        "zip": "627213",
        "lat": "45.981749",
        "long": "27.094959"
      },
      {
        "name": "TULBUREA",
        "zip": "627078",
        "lat": "45.564088",
        "long": "26.836426"
      },
      {
        "name": "TULNICI",
        "zip": "627365",
        "lat": "45.918666",
        "long": "26.673586"
      },
      {
        "name": "TUTU",
        "zip": "627098",
        "lat": "46.174605",
        "long": "27.272532"
      },
      {
        "name": "UNGURENI",
        "zip": "627237",
        "lat": "45.813468",
        "long": "26.674224"
      },
      {
        "name": "UNIREA",
        "zip": "625301",
        "lat": "45.740202",
        "long": "27.107413"
      },
      {
        "name": "URECHESTI",
        "zip": "627385",
        "lat": "45.601807",
        "long": "27.071409"
      },
      {
        "name": "URSOAIA",
        "zip": "627292",
        "lat": "45.781771",
        "long": "26.808772"
      },
      {
        "name": "VADU ROSCA",
        "zip": "627459",
        "lat": "45.63851",
        "long": "27.454361"
      },
      {
        "name": "VAJAITOAREA",
        "zip": "627354",
        "lat": "45.47973",
        "long": "27.306591"
      },
      {
        "name": "VALCANI",
        "zip": "627253",
        "lat": "45.768971",
        "long": "26.782304"
      },
      {
        "name": "VALCELE",
        "zip": "627057",
        "lat": "45.696925",
        "long": "27.156572"
      },
      {
        "name": "VALCELELE",
        "zip": "627099",
        "lat": "46.161775",
        "long": "27.336226"
      },
      {
        "name": "VALEA BECIULUI",
        "zip": "627311",
        "lat": "45.49061",
        "long": "27.042472"
      },
      {
        "name": "VALEA COTESTI",
        "zip": "627103",
        "lat": "45.634464",
        "long": "27.075811"
      },
      {
        "name": "VALEA MICA",
        "zip": "627128",
        "lat": "45.600214",
        "long": "26.918874"
      },
      {
        "name": "VALEA MILCOVULUI",
        "zip": "627293",
        "lat": "45.783468",
        "long": "26.855194"
      },
      {
        "name": "VALEA NEAGRA",
        "zip": "627238",
        "lat": "45.811775",
        "long": "26.636905"
      },
      {
        "name": "VALEA SARII",
        "zip": "627390",
        "lat": "45.877355",
        "long": "26.798697"
      },
      {
        "name": "VALENI",
        "zip": "627214",
        "lat": "45.95707",
        "long": "27.095145"
      },
      {
        "name": "VALENI",
        "zip": "627298",
        "lat": "46.070616",
        "long": "27.156096"
      },
      {
        "name": "VALENI",
        "zip": "627328",
        "lat": "45.911874",
        "long": "27.057538"
      },
      {
        "name": "VANATORI",
        "zip": "627395",
        "lat": "45.722948",
        "long": "27.255383"
      },
      {
        "name": "VARNITA",
        "zip": "627283",
        "lat": "45.975023",
        "long": "26.959804"
      },
      {
        "name": "VARSATURA",
        "zip": "627183",
        "lat": "45.786741",
        "long": "27.041746"
      },
      {
        "name": "VARTESCOIU",
        "zip": "627405",
        "lat": "45.729786",
        "long": "27.081949"
      },
      {
        "name": "VERDEA",
        "zip": "627284",
        "lat": "46.012108",
        "long": "26.893821"
      },
      {
        "name": "VETRESTI-HERASTRAU",
        "zip": "627239",
        "lat": "45.811605",
        "long": "26.657835"
      },
      {
        "name": "VIDRA",
        "zip": "627415",
        "lat": "45.908869",
        "long": "26.89537"
      },
      {
        "name": "VIISOARA",
        "zip": "627261",
        "lat": "46.051602",
        "long": "27.095932"
      },
      {
        "name": "VIISOARA",
        "zip": "627423",
        "lat": "45.9232",
        "long": "26.829514"
      },
      {
        "name": "VINTILEASCA",
        "zip": "627425",
        "lat": "45.613918",
        "long": "26.709468"
      },
      {
        "name": "VITANESTI",
        "zip": "627383",
        "lat": "45.882905",
        "long": "27.041972"
      },
      {
        "name": "VITANESTII DE SUB MAGURA",
        "zip": "627041",
        "lat": "45.874136",
        "long": "27.026791"
      },
      {
        "name": "VIZANTEA MANASTIREASCA",
        "zip": "627439",
        "lat": "45.987653",
        "long": "26.774146000000002"
      },
      {
        "name": "VIZANTEA RAZASEASCA",
        "zip": "627441",
        "lat": "45.973979",
        "long": "26.807756"
      },
      {
        "name": "VLADNICU DE JOS",
        "zip": "627344",
        "lat": "46.096162",
        "long": "27.36153"
      },
      {
        "name": "VLADNICU DE SUS",
        "zip": "627346",
        "lat": "46.113962",
        "long": "27.353991"
      },
      {
        "name": "VOETIN",
        "zip": "627303",
        "lat": "45.443457",
        "long": "27.144906"
      },
      {
        "name": "VOLOSCANI",
        "zip": "627424",
        "lat": "45.924886",
        "long": "26.922911"
      },
      {
        "name": "VRANCIOAIA",
        "zip": "627445",
        "lat": "45.864832",
        "long": "26.729603"
      },
      {
        "name": "VULCANEASA",
        "zip": "627204",
        "lat": "45.773881",
        "long": "26.909809"
      },
      {
        "name": "VULTURU",
        "zip": "627455",
        "lat": "45.620511",
        "long": "27.421973"
      }
    ]
  }